import { ref as Br, readonly as pC, computed as Ye, unref as jt, watch as On, shallowRef as pi, createElementBlock as Qe, openBlock as ke, defineComponent as ir, normalizeClass as Un, toDisplayString as cn, inject as Xa, createElementVNode as Ft, withModifiers as $f, createBlock as Mt, createCommentVNode as Bt, resolveDynamicComponent as Sn, normalizeStyle as Ln, withCtx as Xt, useTemplateRef as ja, createVNode as Sr, createTextVNode as bn, Transition as zd, withDirectives as zi, Fragment as Mn, renderList as ii, vShow as yf, nextTick as sc, onMounted as P0, toValue as Dn, getCurrentScope as dC, onScopeDispose as hC, shallowReadonly as lu, getCurrentInstance as l2, isRef as Vd, hasInjectionContext as mC, reactive as Gd, watchEffect as gC, toRaw as LD, provide as Pa, renderSlot as Bn, h as vC, useAttrs as R0, mergeProps as $i, mergeModels as eo, useModel as bc, vModelText as xs, createSlots as yC, toHandlers as ND, resolveComponent as FD, toRefs as MD, vModelCheckbox as BD, setBlockTracking as qy, withKeys as Dy, normalizeProps as I0, guardReactiveProps as UD, vModelSelect as HD, onBeforeMount as bC, useCssVars as zD, onUnmounted as VD, Teleport as GD, defineCustomElement as Gp } from "vue";
var $y;
(function(e) {
  e.None = "none", e.Declared = "declared", e.InheritedFromService = "inheritedFromService";
})($y || ($y = {}));
var Ly;
(function(e) {
  e.Unspecified = "unspecified", e.Simple = "simple", e.Matrix = "matrix", e.Label = "label", e.Form = "form", e.CommaDelimited = "commaDelimited", e.SpaceDelimited = "spaceDelimited", e.PipeDelimited = "pipeDelimited", e.DeepObject = "deepObject", e.TabDelimited = "tabDelimited";
})(Ly || (Ly = {}));
var Ny;
(function(e) {
  e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Information = 2] = "Information", e[e.Hint = 3] = "Hint";
})(Ny || (Ny = {}));
var Ri;
(function(e) {
  e.Article = "article", e.HttpService = "http_service", e.HttpServer = "http_server", e.HttpOperation = "http_operation", e.HttpCallback = "http_callback", e.HttpWebhook = "http_webhook", e.Model = "model", e.Generic = "generic", e.Unknown = "unknown", e.TableOfContents = "table_of_contents", e.SpectralRuleset = "spectral_ruleset", e.Styleguide = "styleguide", e.Image = "image", e.StoplightResolutions = "stoplight_resolutions", e.StoplightOverride = "stoplight_override";
})(Ri || (Ri = {}));
var Fy;
(function(e) {
  e.Json = "json", e.Markdown = "markdown", e.Yaml = "yaml", e.Javascript = "javascript", e.Apng = "apng", e.Avif = "avif", e.Bmp = "bmp", e.Gif = "gif", e.Jpeg = "jpeg", e.Png = "png", e.Svg = "svg", e.Webp = "webp";
})(Fy || (Fy = {}));
const Wp = globalThis || void 0 || self;
var xC = typeof Wp == "object" && Wp && Wp.Object === Object && Wp, WD = typeof self == "object" && self && self.Object === Object && self, $a = xC || WD || Function("return this")(), uc = $a.Symbol, _C = Object.prototype, KD = _C.hasOwnProperty, ZD = _C.toString, Wc = uc ? uc.toStringTag : void 0;
function YD(e) {
  var t = KD.call(e, Wc), n = e[Wc];
  try {
    e[Wc] = void 0;
    var r = !0;
  } catch {
  }
  var i = ZD.call(e);
  return r && (t ? e[Wc] = n : delete e[Wc]), i;
}
var JD = Object.prototype, QD = JD.toString;
function XD(e) {
  return QD.call(e);
}
var e$ = "[object Null]", t$ = "[object Undefined]", My = uc ? uc.toStringTag : void 0;
function xc(e) {
  return e == null ? e === void 0 ? t$ : e$ : My && My in Object(e) ? YD(e) : XD(e);
}
function Lf(e) {
  return e != null && typeof e == "object";
}
var r$ = "[object Symbol]";
function j0(e) {
  return typeof e == "symbol" || Lf(e) && xc(e) == r$;
}
function wC(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Nf = Array.isArray, By = uc ? uc.prototype : void 0, Uy = By ? By.toString : void 0;
function SC(e) {
  if (typeof e == "string")
    return e;
  if (Nf(e))
    return wC(e, SC) + "";
  if (j0(e))
    return Uy ? Uy.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var n$ = /\s/;
function i$(e) {
  for (var t = e.length; t-- && n$.test(e.charAt(t)); )
    ;
  return t;
}
var a$ = /^\s+/;
function o$(e) {
  return e && e.slice(0, i$(e) + 1).replace(a$, "");
}
function ta(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Hy = NaN, s$ = /^[-+]0x[0-9a-f]+$/i, u$ = /^0b[01]+$/i, c$ = /^0o[0-7]+$/i, l$ = parseInt;
function f$(e) {
  if (typeof e == "number")
    return e;
  if (j0(e))
    return Hy;
  if (ta(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ta(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = o$(e);
  var n = u$.test(e);
  return n || c$.test(e) ? l$(e.slice(2), n ? 2 : 8) : s$.test(e) ? Hy : +e;
}
var zy = 1 / 0, p$ = 17976931348623157e292;
function d$(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = f$(e), e === zy || e === -zy) {
    var t = e < 0 ? -1 : 1;
    return t * p$;
  }
  return e === e ? e : 0;
}
function Vy(e) {
  var t = d$(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function CC(e) {
  return e;
}
var h$ = "[object AsyncFunction]", m$ = "[object Function]", g$ = "[object GeneratorFunction]", v$ = "[object Proxy]";
function kC(e) {
  if (!ta(e))
    return !1;
  var t = xc(e);
  return t == m$ || t == g$ || t == h$ || t == v$;
}
var bh = $a["__core-js_shared__"], Gy = (function() {
  var e = /[^.]+$/.exec(bh && bh.keys && bh.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function y$(e) {
  return !!Gy && Gy in e;
}
var b$ = Function.prototype, x$ = b$.toString;
function Cu(e) {
  if (e != null) {
    try {
      return x$.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var _$ = /[\\^$.*+?()[\]{}|]/g, w$ = /^\[object .+?Constructor\]$/, S$ = Function.prototype, C$ = Object.prototype, k$ = S$.toString, A$ = C$.hasOwnProperty, E$ = RegExp(
  "^" + k$.call(A$).replace(_$, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function O$(e) {
  if (!ta(e) || y$(e))
    return !1;
  var t = kC(e) ? E$ : w$;
  return t.test(Cu(e));
}
function T$(e, t) {
  return e?.[t];
}
function ku(e, t) {
  var n = T$(e, t);
  return O$(n) ? n : void 0;
}
var bf = ku($a, "WeakMap"), Wd = bf && new bf(), AC = Wd ? function(e, t) {
  return Wd.set(e, t), e;
} : CC, Wy = Object.create, f2 = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!ta(t))
      return {};
    if (Wy)
      return Wy(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
})();
function xf(e) {
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
      case 5:
        return new e(t[0], t[1], t[2], t[3], t[4]);
      case 6:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
      case 7:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
    }
    var n = f2(e.prototype), r = e.apply(n, t);
    return ta(r) ? r : n;
  };
}
var P$ = 1;
function R$(e, t, n) {
  var r = t & P$, i = xf(e);
  function a() {
    var o = this && this !== $a && this instanceof a ? i : e;
    return o.apply(r ? n : this, arguments);
  }
  return a;
}
function EC(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var I$ = Math.max;
function OC(e, t, n, r) {
  for (var i = -1, a = e.length, o = n.length, c = -1, u = t.length, s = I$(a - o, 0), l = Array(u + s), d = !r; ++c < u; )
    l[c] = t[c];
  for (; ++i < o; )
    (d || i < a) && (l[n[i]] = e[i]);
  for (; s--; )
    l[c++] = e[i++];
  return l;
}
var j$ = Math.max;
function TC(e, t, n, r) {
  for (var i = -1, a = e.length, o = -1, c = n.length, u = -1, s = t.length, l = j$(a - c, 0), d = Array(l + s), f = !r; ++i < l; )
    d[i] = e[i];
  for (var p = i; ++u < s; )
    d[p + u] = t[u];
  for (; ++o < c; )
    (f || i < a) && (d[p + n[o]] = e[i++]);
  return d;
}
function q$(e, t) {
  for (var n = e.length, r = 0; n--; )
    e[n] === t && ++r;
  return r;
}
function p2() {
}
var D$ = 4294967295;
function cc(e) {
  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = D$, this.__views__ = [];
}
cc.prototype = f2(p2.prototype);
cc.prototype.constructor = cc;
function $$() {
}
var PC = Wd ? function(e) {
  return Wd.get(e);
} : $$, Ky = {}, L$ = Object.prototype, N$ = L$.hasOwnProperty;
function F$(e) {
  for (var t = e.name + "", n = Ky[t], r = N$.call(Ky, t) ? n.length : 0; r--; ) {
    var i = n[r], a = i.func;
    if (a == null || a == e)
      return i.name;
  }
  return t;
}
function lc(e, t) {
  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
lc.prototype = f2(p2.prototype);
lc.prototype.constructor = lc;
function RC(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
function M$(e) {
  if (e instanceof cc)
    return e.clone();
  var t = new lc(e.__wrapped__, e.__chain__);
  return t.__actions__ = RC(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
var B$ = Object.prototype, U$ = B$.hasOwnProperty;
function Kd(e) {
  if (Lf(e) && !Nf(e) && !(e instanceof cc)) {
    if (e instanceof lc)
      return e;
    if (U$.call(e, "__wrapped__"))
      return M$(e);
  }
  return new lc(e);
}
Kd.prototype = p2.prototype;
Kd.prototype.constructor = Kd;
function H$(e) {
  var t = F$(e), n = Kd[t];
  if (typeof n != "function" || !(t in cc.prototype))
    return !1;
  if (e === n)
    return !0;
  var r = PC(n);
  return !!r && e === r[0];
}
var z$ = 800, V$ = 16, G$ = Date.now;
function IC(e) {
  var t = 0, n = 0;
  return function() {
    var r = G$(), i = V$ - (r - n);
    if (n = r, i > 0) {
      if (++t >= z$)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var jC = IC(AC), W$ = /\{\n\/\* \[wrapped with (.+)\] \*/, K$ = /,? & /;
function Z$(e) {
  var t = e.match(W$);
  return t ? t[1].split(K$) : [];
}
var Y$ = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function J$(e, t) {
  var n = t.length;
  if (!n)
    return e;
  var r = n - 1;
  return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Y$, `{
/* [wrapped with ` + t + `] */
`);
}
function Q$(e) {
  return function() {
    return e;
  };
}
var Zy = (function() {
  try {
    var e = ku(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), X$ = Zy ? function(e, t) {
  return Zy(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Q$(t),
    writable: !0
  });
} : CC, eL = IC(X$);
function tL(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function rL(e, t, n, r) {
  for (var i = e.length, a = n + -1; ++a < i; )
    if (t(e[a], a, e))
      return a;
  return -1;
}
function nL(e) {
  return e !== e;
}
function iL(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
function aL(e, t, n) {
  return t === t ? iL(e, t, n) : rL(e, nL, n);
}
function oL(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && aL(e, t, 0) > -1;
}
var sL = 1, uL = 2, cL = 8, lL = 16, fL = 32, pL = 64, dL = 128, hL = 256, mL = 512, gL = [
  ["ary", dL],
  ["bind", sL],
  ["bindKey", uL],
  ["curry", cL],
  ["curryRight", lL],
  ["flip", mL],
  ["partial", fL],
  ["partialRight", pL],
  ["rearg", hL]
];
function vL(e, t) {
  return tL(gL, function(n) {
    var r = "_." + n[0];
    t & n[1] && !oL(e, r) && e.push(r);
  }), e.sort();
}
function qC(e, t, n) {
  var r = t + "";
  return eL(e, J$(r, vL(Z$(r), n)));
}
var yL = 4, bL = 8, Yy = 32, Jy = 64;
function DC(e, t, n, r, i, a, o, c, u, s) {
  var l = t & bL, d = l ? o : void 0, f = l ? void 0 : o, p = l ? a : void 0, g = l ? void 0 : a;
  t |= l ? Yy : Jy, t &= ~(l ? Jy : Yy), t & yL || (t &= -4);
  var b = [
    e,
    t,
    i,
    p,
    d,
    g,
    f,
    c,
    u,
    s
  ], w = n.apply(void 0, b);
  return H$(e) && jC(w, b), w.placeholder = r, qC(w, e, t);
}
function $C(e) {
  var t = e;
  return t.placeholder;
}
var xL = 9007199254740991, _L = /^(?:0|[1-9]\d*)$/;
function LC(e, t) {
  var n = typeof e;
  return t = t ?? xL, !!t && (n == "number" || n != "symbol" && _L.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var wL = Math.min;
function SL(e, t) {
  for (var n = e.length, r = wL(t.length, n), i = RC(e); r--; ) {
    var a = t[r];
    e[r] = LC(a, n) ? i[a] : void 0;
  }
  return e;
}
var Qy = "__lodash_placeholder__";
function Zd(e, t) {
  for (var n = -1, r = e.length, i = 0, a = []; ++n < r; ) {
    var o = e[n];
    (o === t || o === Qy) && (e[n] = Qy, a[i++] = n);
  }
  return a;
}
var CL = 1, kL = 2, AL = 8, EL = 16, OL = 128, TL = 512;
function d2(e, t, n, r, i, a, o, c, u, s) {
  var l = t & OL, d = t & CL, f = t & kL, p = t & (AL | EL), g = t & TL, b = f ? void 0 : xf(e);
  function w() {
    for (var y = arguments.length, v = Array(y), _ = y; _--; )
      v[_] = arguments[_];
    if (p)
      var E = $C(w), O = q$(v, E);
    if (r && (v = OC(v, r, i, p)), a && (v = TC(v, a, o, p)), y -= O, p && y < s) {
      var M = Zd(v, E);
      return DC(
        e,
        t,
        d2,
        w.placeholder,
        n,
        v,
        M,
        c,
        u,
        s - y
      );
    }
    var L = d ? n : this, Z = f ? L[e] : e;
    return y = v.length, c ? v = SL(v, c) : g && y > 1 && v.reverse(), l && u < y && (v.length = u), this && this !== $a && this instanceof w && (Z = b || xf(Z)), Z.apply(L, v);
  }
  return w;
}
function PL(e, t, n) {
  var r = xf(e);
  function i() {
    for (var a = arguments.length, o = Array(a), c = a, u = $C(i); c--; )
      o[c] = arguments[c];
    var s = a < 3 && o[0] !== u && o[a - 1] !== u ? [] : Zd(o, u);
    if (a -= s.length, a < n)
      return DC(
        e,
        t,
        d2,
        i.placeholder,
        void 0,
        o,
        s,
        void 0,
        void 0,
        n - a
      );
    var l = this && this !== $a && this instanceof i ? r : e;
    return EC(l, this, o);
  }
  return i;
}
var RL = 1;
function IL(e, t, n, r) {
  var i = t & RL, a = xf(e);
  function o() {
    for (var c = -1, u = arguments.length, s = -1, l = r.length, d = Array(l + u), f = this && this !== $a && this instanceof o ? a : e; ++s < l; )
      d[s] = r[s];
    for (; u--; )
      d[s++] = arguments[++c];
    return EC(f, i ? n : this, d);
  }
  return o;
}
var Xy = "__lodash_placeholder__", xh = 1, jL = 2, qL = 4, eb = 8, Kc = 128, tb = 256, DL = Math.min;
function $L(e, t) {
  var n = e[1], r = t[1], i = n | r, a = i < (xh | jL | Kc), o = r == Kc && n == eb || r == Kc && n == tb && e[7].length <= t[8] || r == (Kc | tb) && t[7].length <= t[8] && n == eb;
  if (!(a || o))
    return e;
  r & xh && (e[2] = t[2], i |= n & xh ? 0 : qL);
  var c = t[3];
  if (c) {
    var u = e[3];
    e[3] = u ? OC(u, c, t[4]) : c, e[4] = u ? Zd(e[3], Xy) : t[4];
  }
  return c = t[5], c && (u = e[5], e[5] = u ? TC(u, c, t[6]) : c, e[6] = u ? Zd(e[5], Xy) : t[6]), c = t[7], c && (e[7] = c), r & Kc && (e[8] = e[8] == null ? t[8] : DL(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = i, e;
}
var LL = "Expected a function", rb = 1, NL = 2, nb = 8, ib = 16, ab = 32, FL = 64, ob = Math.max;
function ML(e, t, n, r, i, a, o, c) {
  var u = t & NL;
  if (!u && typeof e != "function")
    throw new TypeError(LL);
  var s = r ? r.length : 0;
  if (s || (t &= -97, r = i = void 0), o = o === void 0 ? o : ob(Vy(o), 0), c = c === void 0 ? c : Vy(c), s -= i ? i.length : 0, t & FL) {
    var l = r, d = i;
    r = i = void 0;
  }
  var f = u ? void 0 : PC(e), p = [
    e,
    t,
    n,
    r,
    i,
    l,
    d,
    a,
    o,
    c
  ];
  if (f && $L(p, f), e = p[0], t = p[1], n = p[2], r = p[3], i = p[4], c = p[9] = p[9] === void 0 ? u ? 0 : e.length : ob(p[9] - s, 0), !c && t & (nb | ib) && (t &= -25), !t || t == rb)
    var g = R$(e, t, n);
  else t == nb || t == ib ? g = PL(e, t, c) : (t == ab || t == (rb | ab)) && !i.length ? g = IL(e, t, n, r) : g = d2.apply(void 0, p);
  var b = f ? AC : jC;
  return qC(b(g, p), e, t);
}
function BL(e, t) {
  return e === t || e !== e && t !== t;
}
var UL = 9007199254740991;
function NC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= UL;
}
function HL(e) {
  return e != null && NC(e.length) && !kC(e);
}
var zL = Object.prototype;
function VL(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || zL;
  return e === n;
}
function GL(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var WL = "[object Arguments]";
function sb(e) {
  return Lf(e) && xc(e) == WL;
}
var FC = Object.prototype, KL = FC.hasOwnProperty, ZL = FC.propertyIsEnumerable, YL = sb(/* @__PURE__ */ (function() {
  return arguments;
})()) ? sb : function(e) {
  return Lf(e) && KL.call(e, "callee") && !ZL.call(e, "callee");
}, Qa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function h2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function q0(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      var i = !1;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
function JL() {
  return !1;
}
var MC = typeof exports == "object" && exports && !exports.nodeType && exports, ub = MC && typeof module == "object" && module && !module.nodeType && module, QL = ub && ub.exports === MC, cb = QL ? $a.Buffer : void 0, XL = cb ? cb.isBuffer : void 0, eN = XL || JL, tN = "[object Arguments]", rN = "[object Array]", nN = "[object Boolean]", iN = "[object Date]", aN = "[object Error]", oN = "[object Function]", sN = "[object Map]", uN = "[object Number]", cN = "[object Object]", lN = "[object RegExp]", fN = "[object Set]", pN = "[object String]", dN = "[object WeakMap]", hN = "[object ArrayBuffer]", mN = "[object DataView]", gN = "[object Float32Array]", vN = "[object Float64Array]", yN = "[object Int8Array]", bN = "[object Int16Array]", xN = "[object Int32Array]", _N = "[object Uint8Array]", wN = "[object Uint8ClampedArray]", SN = "[object Uint16Array]", CN = "[object Uint32Array]", Kn = {};
Kn[gN] = Kn[vN] = Kn[yN] = Kn[bN] = Kn[xN] = Kn[_N] = Kn[wN] = Kn[SN] = Kn[CN] = !0;
Kn[tN] = Kn[rN] = Kn[hN] = Kn[nN] = Kn[mN] = Kn[iN] = Kn[aN] = Kn[oN] = Kn[sN] = Kn[uN] = Kn[cN] = Kn[lN] = Kn[fN] = Kn[pN] = Kn[dN] = !1;
function kN(e) {
  return Lf(e) && NC(e.length) && !!Kn[xc(e)];
}
function AN(e) {
  return function(t) {
    return e(t);
  };
}
var BC = typeof exports == "object" && exports && !exports.nodeType && exports, cf = BC && typeof module == "object" && module && !module.nodeType && module, EN = cf && cf.exports === BC, _h = EN && xC.process, lb = (function() {
  try {
    var e = cf && cf.require && cf.require("util").types;
    return e || _h && _h.binding && _h.binding("util");
  } catch {
  }
})(), fb = lb && lb.isTypedArray, ON = fb ? AN(fb) : kN, TN = Object.prototype, PN = TN.hasOwnProperty;
function RN(e, t) {
  var n = Nf(e), r = !n && YL(e), i = !n && !r && eN(e), a = !n && !r && !i && ON(e), o = n || r || i || a, c = o ? GL(e.length, String) : [], u = c.length;
  for (var s in e)
    PN.call(e, s) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    LC(s, u))) && c.push(s);
  return c;
}
function IN(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var jN = IN(Object.keys, Object), qN = Object.prototype, DN = qN.hasOwnProperty;
function $N(e) {
  if (!VL(e))
    return jN(e);
  var t = [];
  for (var n in Object(e))
    DN.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function UC(e) {
  return HL(e) ? RN(e) : $N(e);
}
var LN = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, NN = /^\w*$/;
function FN(e, t) {
  if (Nf(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || j0(e) ? !0 : NN.test(e) || !LN.test(e) || t != null && e in Object(t);
}
var _f = ku(Object, "create");
function MN() {
  this.__data__ = _f ? _f(null) : {}, this.size = 0;
}
function BN(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var UN = "__lodash_hash_undefined__", HN = Object.prototype, zN = HN.hasOwnProperty;
function VN(e) {
  var t = this.__data__;
  if (_f) {
    var n = t[e];
    return n === UN ? void 0 : n;
  }
  return zN.call(t, e) ? t[e] : void 0;
}
var GN = Object.prototype, WN = GN.hasOwnProperty;
function KN(e) {
  var t = this.__data__;
  return _f ? t[e] !== void 0 : WN.call(t, e);
}
var ZN = "__lodash_hash_undefined__";
function YN(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = _f && t === void 0 ? ZN : t, this;
}
function xu(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xu.prototype.clear = MN;
xu.prototype.delete = BN;
xu.prototype.get = VN;
xu.prototype.has = KN;
xu.prototype.set = YN;
function JN() {
  this.__data__ = [], this.size = 0;
}
function D0(e, t) {
  for (var n = e.length; n--; )
    if (BL(e[n][0], t))
      return n;
  return -1;
}
var QN = Array.prototype, XN = QN.splice;
function eF(e) {
  var t = this.__data__, n = D0(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : XN.call(t, n, 1), --this.size, !0;
}
function tF(e) {
  var t = this.__data__, n = D0(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function rF(e) {
  return D0(this.__data__, e) > -1;
}
function nF(e, t) {
  var n = this.__data__, r = D0(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function _c(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
_c.prototype.clear = JN;
_c.prototype.delete = eF;
_c.prototype.get = tF;
_c.prototype.has = rF;
_c.prototype.set = nF;
var Yd = ku($a, "Map");
function iF() {
  this.size = 0, this.__data__ = {
    hash: new xu(),
    map: new (Yd || _c)(),
    string: new xu()
  };
}
function aF(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function $0(e, t) {
  var n = e.__data__;
  return aF(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function oF(e) {
  var t = $0(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function sF(e) {
  return $0(this, e).get(e);
}
function uF(e) {
  return $0(this, e).has(e);
}
function cF(e, t) {
  var n = $0(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Au(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Au.prototype.clear = iF;
Au.prototype.delete = oF;
Au.prototype.get = sF;
Au.prototype.has = uF;
Au.prototype.set = cF;
var lF = "Expected a function";
function m2(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(lF);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, r);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (m2.Cache || Au)(), n;
}
m2.Cache = Au;
var fF = 500;
function pF(e) {
  var t = m2(e, function(r) {
    return n.size === fF && n.clear(), r;
  }), n = t.cache;
  return t;
}
var dF = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hF = /\\(\\)?/g, mF = pF(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(dF, function(n, r, i, a) {
    t.push(i ? a.replace(hF, "$1") : r || n);
  }), t;
});
function gF(e) {
  return e == null ? "" : SC(e);
}
function vF(e, t) {
  return Nf(e) ? e : FN(e, t) ? [e] : mF(gF(e));
}
function yF(e) {
  if (typeof e == "string" || j0(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function bF(e, t) {
  t = vF(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[yF(t[n++])];
  return n && n == r ? e : void 0;
}
function xF(e, t, n) {
  var r = e == null ? void 0 : bF(e, t);
  return r === void 0 ? n : r;
}
var E6 = ku($a, "DataView"), O6 = ku($a, "Promise"), T6 = ku($a, "Set"), pb = "[object Map]", _F = "[object Object]", db = "[object Promise]", hb = "[object Set]", mb = "[object WeakMap]", gb = "[object DataView]", wF = Cu(E6), SF = Cu(Yd), CF = Cu(O6), kF = Cu(T6), AF = Cu(bf), fu = xc;
(E6 && fu(new E6(new ArrayBuffer(1))) != gb || Yd && fu(new Yd()) != pb || O6 && fu(O6.resolve()) != db || T6 && fu(new T6()) != hb || bf && fu(new bf()) != mb) && (fu = function(e) {
  var t = xc(e), n = t == _F ? e.constructor : void 0, r = n ? Cu(n) : "";
  if (r)
    switch (r) {
      case wF:
        return gb;
      case SF:
        return pb;
      case CF:
        return db;
      case kF:
        return hb;
      case AF:
        return mb;
    }
  return t;
});
function EF(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var OF = 8;
function g2(e, t, n) {
  t = n ? void 0 : t;
  var r = ML(e, OF, void 0, void 0, void 0, void 0, void 0, t);
  return r.placeholder = g2.placeholder, r;
}
g2.placeholder = {};
function TF(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function PF(e, t) {
  return wC(t, function(n) {
    return [n, e[n]];
  });
}
function RF(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = [r, r];
  }), n;
}
var IF = "[object Map]", jF = "[object Set]";
function qF(e) {
  return function(t) {
    var n = fu(t);
    return n == IF ? EF(t) : n == jF ? RF(t) : PF(t, e(t));
  };
}
var DF = qF(UC);
function v2(e) {
  return ta(e) && "id" in e;
}
function $F(e) {
  return v2(e) && "name" in e && "version" in e;
}
function Jd(e) {
  return v2(e) && "method" in e && "path" in e;
}
function Qd(e) {
  return v2(e) && "method" in e && "name" in e;
}
g2((e, t) => e.toUpperCase() === t.toUpperCase());
function Xd(e) {
  return e.replace(/\/|{|}|\s/g, "-").replace(/-{2,}/, "-").replace(/^-/, "").replace(/-$/, "");
}
const LF = (...e) => e.reverse().reduce((t, n) => ({ ...t, ...n }), {});
function wh(e, t, n) {
  const r = {}, i = [], a = e.tags.map((u) => u.toLowerCase()), o = e.children.filter((u) => u.type === t);
  for (const u of o)
    if (u.tags.length > 0)
      for (let s = 0; s < u.tags.length; s++) {
        const l = u.tags[s], d = s === 0 ? u.uri : u.uri.split("/").toSpliced(2, 0, Xd(l).toLowerCase()).join("/"), f = l.toLowerCase();
        if (r[f])
          r[f].items.push({ ...u, uri: d }), r[f].initiallyExpanded = r[f].initiallyExpanded ? !0 : d === n;
        else {
          const p = a.findIndex((b) => b === f), g = e.tags[p];
          r[f] = {
            title: g || l,
            items: [{ ...u, uri: d }],
            initiallyExpanded: d === n
          };
        }
      }
    else
      i.push(u);
  return { groups: Object.entries(r).sort(([u], [s]) => {
    const l = u.toLowerCase(), d = s.toLowerCase(), f = a.findIndex((g) => g === l), p = a.findIndex((g) => g === d);
    return f < 0 && p < 0 ? 0 : f < 0 ? 1 : p < 0 ? -1 : f - p;
  }).map(([, u]) => u), ungrouped: i };
}
const NF = {
  hideSchemas: !1,
  hideInternal: !1,
  hideDeprecated: !1,
  currentPath: ""
}, FF = (e, t = {}) => {
  const n = LF(t, NF), r = [];
  if (r.push({
    id: "/",
    slug: "/",
    title: "Overview",
    type: "overview",
    meta: ""
  }), e.children.some((s) => s.type === Ri.HttpOperation)) {
    const { groups: s, ungrouped: l } = wh(
      e,
      Ri.HttpOperation,
      n.currentPath
    );
    r.push({
      title: "Endpoints",
      items: [],
      hideTitle: n.hideSchemas,
      initiallyExpanded: !0
      // Endpoints are always expanded by default
    }), Sh({
      groups: s,
      ungrouped: l,
      tree: r.at(-1).items,
      itemsType: Ri.HttpOperation,
      hideInternal: n.hideInternal,
      hideDeprecated: n.hideDeprecated
    });
  }
  const a = e.children.some((s) => s.type === Ri.HttpWebhook), { groups: o, ungrouped: c } = wh(
    e,
    Ri.HttpWebhook,
    n.currentPath
  );
  a && (r.push({
    title: "Webhooks",
    items: [],
    initiallyExpanded: o.some((s) => s.initiallyExpanded) || c.some((s) => s.uri === n.currentPath)
  }), Sh({
    groups: o,
    ungrouped: c,
    tree: r.at(-1).items,
    itemsType: Ri.HttpWebhook,
    hideInternal: n.hideInternal,
    hideDeprecated: n.hideDeprecated
  }));
  let u = e.children.filter((s) => s.type === Ri.Model);
  if (n.hideInternal && (u = u.filter((s) => !P6(s))), !n.hideSchemas && u.length) {
    const { groups: s, ungrouped: l } = wh(e, Ri.Model, n.currentPath);
    r.push({
      title: "Schemas",
      items: [],
      initiallyExpanded: s.some((d) => d.initiallyExpanded) || l.some((d) => d.uri === n.currentPath)
    }), Sh({
      groups: s,
      ungrouped: l,
      tree: r.at(-1).items,
      itemsType: Ri.Model,
      hideInternal: n.hideInternal
    });
  }
  return r;
}, P6 = (e) => {
  const t = e.data;
  return Jd(t) || Qd(t) ? !!t.internal : $F(t) ? !1 : !!t["x-internal"];
}, Kp = (e) => {
  const t = e.data;
  return Jd(t) || Qd(t) ? t.deprecated ?? !1 : !1;
}, Sh = ({
  groups: e,
  ungrouped: t,
  tree: n,
  itemsType: r,
  hideInternal: i,
  hideDeprecated: a
}) => {
  t.forEach((o) => {
    i && P6(o) || a && Kp(o) || n.push({
      id: o.uri,
      slug: o.uri,
      title: o.name,
      type: o.type,
      meta: Jd(o.data) || Qd(o.data) ? o.data.method : "",
      ...Kp(o) ? { deprecated: !0 } : {}
    });
  }), e.forEach((o) => {
    const c = o.items.flatMap((u) => i && P6(u) || a && Kp(u) ? [] : {
      id: u.uri,
      slug: u.uri,
      title: u.name,
      type: u.type,
      meta: Jd(u.data) || Qd(u.data) ? u.data.method : "",
      ...Kp(u) ? { deprecated: !0 } : {}
    });
    c.length && n.push({
      title: o.title,
      items: c,
      itemsType: r,
      initiallyExpanded: o.initiallyExpanded
    });
  });
};
var of = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var MF = of.exports, vb;
function Xn() {
  return vb || (vb = 1, (function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", c = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", s = 500, l = "__lodash_placeholder__", d = 1, f = 2, p = 4, g = 1, b = 2, w = 1, y = 2, v = 4, _ = 8, E = 16, O = 32, M = 64, L = 128, Z = 256, Q = 512, ae = 30, re = "...", X = 800, de = 16, Ce = 1, J = 2, ne = 3, De = 1 / 0, je = 9007199254740991, Me = 17976931348623157e292, qe = NaN, Ve = 4294967295, xe = Ve - 1, ve = Ve >>> 1, Ae = [
        ["ary", L],
        ["bind", w],
        ["bindKey", y],
        ["curry", _],
        ["curryRight", E],
        ["flip", Q],
        ["partial", O],
        ["partialRight", M],
        ["rearg", Z]
      ], Ue = "[object Arguments]", qt = "[object Array]", Ze = "[object AsyncFunction]", At = "[object Boolean]", He = "[object Date]", Dt = "[object DOMException]", Fe = "[object Error]", Xe = "[object Function]", ze = "[object GeneratorFunction]", Rt = "[object Map]", Yt = "[object Number]", ye = "[object Null]", W = "[object Object]", Y = "[object Promise]", ie = "[object Proxy]", Te = "[object RegExp]", $ = "[object Set]", _e = "[object String]", Le = "[object Symbol]", et = "[object Undefined]", Ge = "[object WeakMap]", $t = "[object WeakSet]", Be = "[object ArrayBuffer]", P = "[object DataView]", N = "[object Float32Array]", F = "[object Float64Array]", T = "[object Int8Array]", C = "[object Int16Array]", S = "[object Int32Array]", h = "[object Uint8Array]", k = "[object Uint8ClampedArray]", R = "[object Uint16Array]", j = "[object Uint32Array]", A = /\b__p \+= '';/g, I = /\b(__p \+=) '' \+/g, z = /(__e\(.*?\)|\b__t\)) \+\n'';/g, H = /&(?:amp|lt|gt|quot|#39);/g, K = /[&<>"']/g, U = RegExp(H.source), D = RegExp(K.source), B = /<%-([\s\S]+?)%>/g, ee = /<%([\s\S]+?)%>/g, V = /<%=([\s\S]+?)%>/g, te = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ue = /^\w*$/, ge = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pe = /[\\^$.*+?()[\]{}|]/g, se = RegExp(pe.source), ce = /^\s+/, Oe = /\s/, fe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, be = /\{\n\/\* \[wrapped with (.+)\] \*/, me = /,? & /, Ie = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, le = /[()=,{}\[\]\/\s]/, he = /\\(\\)?/g, we = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Re = /\w*$/, Pe = /^[-+]0x[0-9a-f]+$/i, $e = /^0b[01]+$/i, We = /^\[object .+?Constructor\]$/, yt = /^0o[0-7]+$/i, dt = /^(?:0|[1-9]\d*)$/, bt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ft = /($^)/, xt = /['\n\r\u2028\u2029\\]/g, pt = "\\ud800-\\udfff", _t = "\\u0300-\\u036f", ht = "\\ufe20-\\ufe2f", gt = "\\u20d0-\\u20ff", Je = _t + ht + gt, mt = "\\u2700-\\u27bf", nt = "a-z\\xdf-\\xf6\\xf8-\\xff", Et = "\\xac\\xb1\\xd7\\xf7", ut = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ot = "\\u2000-\\u206f", ct = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", St = "A-Z\\xc0-\\xd6\\xd8-\\xde", it = "\\ufe0e\\ufe0f", Ct = Et + ut + Ot + ct, tt = "['’]", Tt = "[" + pt + "]", at = "[" + Ct + "]", wt = "[" + Je + "]", ot = "\\d+", Pt = "[" + mt + "]", st = "[" + nt + "]", kt = "[^" + pt + Ct + ot + mt + nt + St + "]", rt = "\\ud83c[\\udffb-\\udfff]", Lt = "(?:" + wt + "|" + rt + ")", It = "[^" + pt + "]", Gt = "(?:\\ud83c[\\udde6-\\uddff]){2}", qr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Jr = "[" + St + "]", Ur = "\\u200d", Xr = "(?:" + st + "|" + kt + ")", Gr = "(?:" + Jr + "|" + kt + ")", en = "(?:" + tt + "(?:d|ll|m|re|s|t|ve))?", Hr = "(?:" + tt + "(?:D|LL|M|RE|S|T|VE))?", tn = Lt + "?", zr = "[" + it + "]?", rn = "(?:" + Ur + "(?:" + [It, Gt, qr].join("|") + ")" + zr + tn + ")*", Wr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", nn = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Vr = zr + tn + rn, an = "(?:" + [Pt, Gt, qr].join("|") + ")" + Vr, Kr = "(?:" + [It + wt + "?", wt, Gt, qr, Tt].join("|") + ")", on = RegExp(tt, "g"), Zr = RegExp(wt, "g"), Qr = RegExp(rt + "(?=" + rt + ")|" + Kr + Vr, "g"), Yr = RegExp([
        Jr + "?" + st + "+" + en + "(?=" + [at, Jr, "$"].join("|") + ")",
        Gr + "+" + Hr + "(?=" + [at, Jr + Xr, "$"].join("|") + ")",
        Jr + "?" + Xr + "+" + en,
        Jr + "+" + Hr,
        nn,
        Wr,
        ot,
        an
      ].join("|"), "g"), Dr = RegExp("[" + Ur + pt + Je + it + "]"), cr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, $r = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], lr = -1, Wt = {};
      Wt[N] = Wt[F] = Wt[T] = Wt[C] = Wt[S] = Wt[h] = Wt[k] = Wt[R] = Wt[j] = !0, Wt[Ue] = Wt[qt] = Wt[Be] = Wt[At] = Wt[P] = Wt[He] = Wt[Fe] = Wt[Xe] = Wt[Rt] = Wt[Yt] = Wt[W] = Wt[Te] = Wt[$] = Wt[_e] = Wt[Ge] = !1;
      var Ut = {};
      Ut[Ue] = Ut[qt] = Ut[Be] = Ut[P] = Ut[At] = Ut[He] = Ut[N] = Ut[F] = Ut[T] = Ut[C] = Ut[S] = Ut[Rt] = Ut[Yt] = Ut[W] = Ut[Te] = Ut[$] = Ut[_e] = Ut[Le] = Ut[h] = Ut[k] = Ut[R] = Ut[j] = !0, Ut[Fe] = Ut[Xe] = Ut[Ge] = !1;
      var Lr = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, fr = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Nr = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, pr = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Fr = parseFloat, dr = parseInt, Tr = typeof Qa == "object" && Qa && Qa.Object === Object && Qa, hr = typeof self == "object" && self && self.Object === Object && self, er = Tr || hr || Function("return this")(), rr = t && !t.nodeType && t, wr = rr && !0 && e && !e.nodeType && e, ar = wr && wr.exports === rr, Ar = ar && Tr.process, Kt = (function() {
        try {
          var lt = wr && wr.require && wr.require("util").types;
          return lt || Ar && Ar.binding && Ar.binding("util");
        } catch {
        }
      })(), Pr = Kt && Kt.isArrayBuffer, or = Kt && Kt.isDate, Rr = Kt && Kt.isMap, sr = Kt && Kt.isRegExp, Ir = Kt && Kt.isSet, ur = Kt && Kt.isTypedArray;
      function mr(lt, Ht, Nt) {
        switch (Nt.length) {
          case 0:
            return lt.call(Ht);
          case 1:
            return lt.call(Ht, Nt[0]);
          case 2:
            return lt.call(Ht, Nt[0], Nt[1]);
          case 3:
            return lt.call(Ht, Nt[0], Nt[1], Nt[2]);
        }
        return lt.apply(Ht, Nt);
      }
      function gr(lt, Ht, Nt, fn) {
        for (var xn = -1, $n = lt == null ? 0 : lt.length; ++xn < $n; ) {
          var si = lt[xn];
          Ht(fn, si, Nt(si), lt);
        }
        return fn;
      }
      function _r(lt, Ht) {
        for (var Nt = -1, fn = lt == null ? 0 : lt.length; ++Nt < fn && Ht(lt[Nt], Nt, lt) !== !1; )
          ;
        return lt;
      }
      function vr(lt, Ht) {
        for (var Nt = lt == null ? 0 : lt.length; Nt-- && Ht(lt[Nt], Nt, lt) !== !1; )
          ;
        return lt;
      }
      function jr(lt, Ht) {
        for (var Nt = -1, fn = lt == null ? 0 : lt.length; ++Nt < fn; )
          if (!Ht(lt[Nt], Nt, lt))
            return !1;
        return !0;
      }
      function Jt(lt, Ht) {
        for (var Nt = -1, fn = lt == null ? 0 : lt.length, xn = 0, $n = []; ++Nt < fn; ) {
          var si = lt[Nt];
          Ht(si, Nt, lt) && ($n[xn++] = si);
        }
        return $n;
      }
      function kr(lt, Ht) {
        var Nt = lt == null ? 0 : lt.length;
        return !!Nt && An(lt, Ht, 0) > -1;
      }
      function nr(lt, Ht, Nt) {
        for (var fn = -1, xn = lt == null ? 0 : lt.length; ++fn < xn; )
          if (Nt(Ht, lt[fn]))
            return !0;
        return !1;
      }
      function Zt(lt, Ht) {
        for (var Nt = -1, fn = lt == null ? 0 : lt.length, xn = Array(fn); ++Nt < fn; )
          xn[Nt] = Ht(lt[Nt], Nt, lt);
        return xn;
      }
      function Qt(lt, Ht) {
        for (var Nt = -1, fn = Ht.length, xn = lt.length; ++Nt < fn; )
          lt[xn + Nt] = Ht[Nt];
        return lt;
      }
      function Er(lt, Ht, Nt, fn) {
        var xn = -1, $n = lt == null ? 0 : lt.length;
        for (fn && $n && (Nt = lt[++xn]); ++xn < $n; )
          Nt = Ht(Nt, lt[xn], xn, lt);
        return Nt;
      }
      function yr(lt, Ht, Nt, fn) {
        var xn = lt == null ? 0 : lt.length;
        for (fn && xn && (Nt = lt[--xn]); xn--; )
          Nt = Ht(Nt, lt[xn], xn, lt);
        return Nt;
      }
      function Or(lt, Ht) {
        for (var Nt = -1, fn = lt == null ? 0 : lt.length; ++Nt < fn; )
          if (Ht(lt[Nt], Nt, lt))
            return !0;
        return !1;
      }
      var br = b1("length");
      function Mr(lt) {
        return lt.split("");
      }
      function xr(lt) {
        return lt.match(Ie) || [];
      }
      function ln(lt, Ht, Nt) {
        var fn;
        return Nt(lt, function(xn, $n, si) {
          if (Ht(xn, $n, si))
            return fn = $n, !1;
        }), fn;
      }
      function un(lt, Ht, Nt, fn) {
        for (var xn = lt.length, $n = Nt + (fn ? 1 : -1); fn ? $n-- : ++$n < xn; )
          if (Ht(lt[$n], $n, lt))
            return $n;
        return -1;
      }
      function An(lt, Ht, Nt) {
        return Ht === Ht ? ST(lt, Ht, Nt) : un(lt, Lg, Nt);
      }
      function pT(lt, Ht, Nt, fn) {
        for (var xn = Nt - 1, $n = lt.length; ++xn < $n; )
          if (fn(lt[xn], Ht))
            return xn;
        return -1;
      }
      function Lg(lt) {
        return lt !== lt;
      }
      function Ng(lt, Ht) {
        var Nt = lt == null ? 0 : lt.length;
        return Nt ? _1(lt, Ht) / Nt : qe;
      }
      function b1(lt) {
        return function(Ht) {
          return Ht == null ? n : Ht[lt];
        };
      }
      function x1(lt) {
        return function(Ht) {
          return lt == null ? n : lt[Ht];
        };
      }
      function Fg(lt, Ht, Nt, fn, xn) {
        return xn(lt, function($n, si, Hn) {
          Nt = fn ? (fn = !1, $n) : Ht(Nt, $n, si, Hn);
        }), Nt;
      }
      function dT(lt, Ht) {
        var Nt = lt.length;
        for (lt.sort(Ht); Nt--; )
          lt[Nt] = lt[Nt].value;
        return lt;
      }
      function _1(lt, Ht) {
        for (var Nt, fn = -1, xn = lt.length; ++fn < xn; ) {
          var $n = Ht(lt[fn]);
          $n !== n && (Nt = Nt === n ? $n : Nt + $n);
        }
        return Nt;
      }
      function w1(lt, Ht) {
        for (var Nt = -1, fn = Array(lt); ++Nt < lt; )
          fn[Nt] = Ht(Nt);
        return fn;
      }
      function hT(lt, Ht) {
        return Zt(Ht, function(Nt) {
          return [Nt, lt[Nt]];
        });
      }
      function Mg(lt) {
        return lt && lt.slice(0, zg(lt) + 1).replace(ce, "");
      }
      function ia(lt) {
        return function(Ht) {
          return lt(Ht);
        };
      }
      function S1(lt, Ht) {
        return Zt(Ht, function(Nt) {
          return lt[Nt];
        });
      }
      function Ic(lt, Ht) {
        return lt.has(Ht);
      }
      function Bg(lt, Ht) {
        for (var Nt = -1, fn = lt.length; ++Nt < fn && An(Ht, lt[Nt], 0) > -1; )
          ;
        return Nt;
      }
      function Ug(lt, Ht) {
        for (var Nt = lt.length; Nt-- && An(Ht, lt[Nt], 0) > -1; )
          ;
        return Nt;
      }
      function mT(lt, Ht) {
        for (var Nt = lt.length, fn = 0; Nt--; )
          lt[Nt] === Ht && ++fn;
        return fn;
      }
      var gT = x1(Lr), vT = x1(fr);
      function yT(lt) {
        return "\\" + pr[lt];
      }
      function bT(lt, Ht) {
        return lt == null ? n : lt[Ht];
      }
      function ju(lt) {
        return Dr.test(lt);
      }
      function xT(lt) {
        return cr.test(lt);
      }
      function _T(lt) {
        for (var Ht, Nt = []; !(Ht = lt.next()).done; )
          Nt.push(Ht.value);
        return Nt;
      }
      function C1(lt) {
        var Ht = -1, Nt = Array(lt.size);
        return lt.forEach(function(fn, xn) {
          Nt[++Ht] = [xn, fn];
        }), Nt;
      }
      function Hg(lt, Ht) {
        return function(Nt) {
          return lt(Ht(Nt));
        };
      }
      function cs(lt, Ht) {
        for (var Nt = -1, fn = lt.length, xn = 0, $n = []; ++Nt < fn; ) {
          var si = lt[Nt];
          (si === Ht || si === l) && (lt[Nt] = l, $n[xn++] = Nt);
        }
        return $n;
      }
      function cp(lt) {
        var Ht = -1, Nt = Array(lt.size);
        return lt.forEach(function(fn) {
          Nt[++Ht] = fn;
        }), Nt;
      }
      function wT(lt) {
        var Ht = -1, Nt = Array(lt.size);
        return lt.forEach(function(fn) {
          Nt[++Ht] = [fn, fn];
        }), Nt;
      }
      function ST(lt, Ht, Nt) {
        for (var fn = Nt - 1, xn = lt.length; ++fn < xn; )
          if (lt[fn] === Ht)
            return fn;
        return -1;
      }
      function CT(lt, Ht, Nt) {
        for (var fn = Nt + 1; fn--; )
          if (lt[fn] === Ht)
            return fn;
        return fn;
      }
      function qu(lt) {
        return ju(lt) ? AT(lt) : br(lt);
      }
      function La(lt) {
        return ju(lt) ? ET(lt) : Mr(lt);
      }
      function zg(lt) {
        for (var Ht = lt.length; Ht-- && Oe.test(lt.charAt(Ht)); )
          ;
        return Ht;
      }
      var kT = x1(Nr);
      function AT(lt) {
        for (var Ht = Qr.lastIndex = 0; Qr.test(lt); )
          ++Ht;
        return Ht;
      }
      function ET(lt) {
        return lt.match(Qr) || [];
      }
      function OT(lt) {
        return lt.match(Yr) || [];
      }
      var TT = (function lt(Ht) {
        Ht = Ht == null ? er : Du.defaults(er.Object(), Ht, Du.pick(er, $r));
        var Nt = Ht.Array, fn = Ht.Date, xn = Ht.Error, $n = Ht.Function, si = Ht.Math, Hn = Ht.Object, k1 = Ht.RegExp, PT = Ht.String, va = Ht.TypeError, lp = Nt.prototype, RT = $n.prototype, $u = Hn.prototype, fp = Ht["__core-js_shared__"], pp = RT.toString, Fn = $u.hasOwnProperty, IT = 0, Vg = (function() {
          var m = /[^.]+$/.exec(fp && fp.keys && fp.keys.IE_PROTO || "");
          return m ? "Symbol(src)_1." + m : "";
        })(), dp = $u.toString, jT = pp.call(Hn), qT = er._, DT = k1(
          "^" + pp.call(Fn).replace(pe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), hp = ar ? Ht.Buffer : n, ls = Ht.Symbol, mp = Ht.Uint8Array, Gg = hp ? hp.allocUnsafe : n, gp = Hg(Hn.getPrototypeOf, Hn), Wg = Hn.create, Kg = $u.propertyIsEnumerable, vp = lp.splice, Zg = ls ? ls.isConcatSpreadable : n, jc = ls ? ls.iterator : n, Rs = ls ? ls.toStringTag : n, yp = (function() {
          try {
            var m = $s(Hn, "defineProperty");
            return m({}, "", {}), m;
          } catch {
          }
        })(), $T = Ht.clearTimeout !== er.clearTimeout && Ht.clearTimeout, LT = fn && fn.now !== er.Date.now && fn.now, NT = Ht.setTimeout !== er.setTimeout && Ht.setTimeout, bp = si.ceil, xp = si.floor, A1 = Hn.getOwnPropertySymbols, FT = hp ? hp.isBuffer : n, Yg = Ht.isFinite, MT = lp.join, BT = Hg(Hn.keys, Hn), ui = si.max, Ei = si.min, UT = fn.now, HT = Ht.parseInt, Jg = si.random, zT = lp.reverse, E1 = $s(Ht, "DataView"), qc = $s(Ht, "Map"), O1 = $s(Ht, "Promise"), Lu = $s(Ht, "Set"), Dc = $s(Ht, "WeakMap"), $c = $s(Hn, "create"), _p = Dc && new Dc(), Nu = {}, VT = Ls(E1), GT = Ls(qc), WT = Ls(O1), KT = Ls(Lu), ZT = Ls(Dc), wp = ls ? ls.prototype : n, Lc = wp ? wp.valueOf : n, Qg = wp ? wp.toString : n;
        function Se(m) {
          if (Qn(m) && !_n(m) && !(m instanceof In)) {
            if (m instanceof ya)
              return m;
            if (Fn.call(m, "__wrapped__"))
              return Xv(m);
          }
          return new ya(m);
        }
        var Fu = /* @__PURE__ */ (function() {
          function m() {
          }
          return function(x) {
            if (!Yn(x))
              return {};
            if (Wg)
              return Wg(x);
            m.prototype = x;
            var q = new m();
            return m.prototype = n, q;
          };
        })();
        function Sp() {
        }
        function ya(m, x) {
          this.__wrapped__ = m, this.__actions__ = [], this.__chain__ = !!x, this.__index__ = 0, this.__values__ = n;
        }
        Se.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: B,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: ee,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: V,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: Se
          }
        }, Se.prototype = Sp.prototype, Se.prototype.constructor = Se, ya.prototype = Fu(Sp.prototype), ya.prototype.constructor = ya;
        function In(m) {
          this.__wrapped__ = m, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ve, this.__views__ = [];
        }
        function YT() {
          var m = new In(this.__wrapped__);
          return m.__actions__ = Ki(this.__actions__), m.__dir__ = this.__dir__, m.__filtered__ = this.__filtered__, m.__iteratees__ = Ki(this.__iteratees__), m.__takeCount__ = this.__takeCount__, m.__views__ = Ki(this.__views__), m;
        }
        function JT() {
          if (this.__filtered__) {
            var m = new In(this);
            m.__dir__ = -1, m.__filtered__ = !0;
          } else
            m = this.clone(), m.__dir__ *= -1;
          return m;
        }
        function QT() {
          var m = this.__wrapped__.value(), x = this.__dir__, q = _n(m), G = x < 0, oe = q ? m.length : 0, Ee = lR(0, oe, this.__views__), Ne = Ee.start, Ke = Ee.end, vt = Ke - Ne, zt = G ? Ke : Ne - 1, Vt = this.__iteratees__, tr = Vt.length, sn = 0, dn = Ei(vt, this.__takeCount__);
          if (!q || !G && oe == vt && dn == vt)
            return wv(m, this.__actions__);
          var vn = [];
          e:
            for (; vt-- && sn < dn; ) {
              zt += x;
              for (var En = -1, yn = m[zt]; ++En < tr; ) {
                var Rn = Vt[En], jn = Rn.iteratee, sa = Rn.type, Mi = jn(yn);
                if (sa == J)
                  yn = Mi;
                else if (!Mi) {
                  if (sa == Ce)
                    continue e;
                  break e;
                }
              }
              vn[sn++] = yn;
            }
          return vn;
        }
        In.prototype = Fu(Sp.prototype), In.prototype.constructor = In;
        function Is(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.clear(); ++x < q; ) {
            var G = m[x];
            this.set(G[0], G[1]);
          }
        }
        function XT() {
          this.__data__ = $c ? $c(null) : {}, this.size = 0;
        }
        function eP(m) {
          var x = this.has(m) && delete this.__data__[m];
          return this.size -= x ? 1 : 0, x;
        }
        function tP(m) {
          var x = this.__data__;
          if ($c) {
            var q = x[m];
            return q === u ? n : q;
          }
          return Fn.call(x, m) ? x[m] : n;
        }
        function rP(m) {
          var x = this.__data__;
          return $c ? x[m] !== n : Fn.call(x, m);
        }
        function nP(m, x) {
          var q = this.__data__;
          return this.size += this.has(m) ? 0 : 1, q[m] = $c && x === n ? u : x, this;
        }
        Is.prototype.clear = XT, Is.prototype.delete = eP, Is.prototype.get = tP, Is.prototype.has = rP, Is.prototype.set = nP;
        function Oo(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.clear(); ++x < q; ) {
            var G = m[x];
            this.set(G[0], G[1]);
          }
        }
        function iP() {
          this.__data__ = [], this.size = 0;
        }
        function aP(m) {
          var x = this.__data__, q = Cp(x, m);
          if (q < 0)
            return !1;
          var G = x.length - 1;
          return q == G ? x.pop() : vp.call(x, q, 1), --this.size, !0;
        }
        function oP(m) {
          var x = this.__data__, q = Cp(x, m);
          return q < 0 ? n : x[q][1];
        }
        function sP(m) {
          return Cp(this.__data__, m) > -1;
        }
        function uP(m, x) {
          var q = this.__data__, G = Cp(q, m);
          return G < 0 ? (++this.size, q.push([m, x])) : q[G][1] = x, this;
        }
        Oo.prototype.clear = iP, Oo.prototype.delete = aP, Oo.prototype.get = oP, Oo.prototype.has = sP, Oo.prototype.set = uP;
        function To(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.clear(); ++x < q; ) {
            var G = m[x];
            this.set(G[0], G[1]);
          }
        }
        function cP() {
          this.size = 0, this.__data__ = {
            hash: new Is(),
            map: new (qc || Oo)(),
            string: new Is()
          };
        }
        function lP(m) {
          var x = $p(this, m).delete(m);
          return this.size -= x ? 1 : 0, x;
        }
        function fP(m) {
          return $p(this, m).get(m);
        }
        function pP(m) {
          return $p(this, m).has(m);
        }
        function dP(m, x) {
          var q = $p(this, m), G = q.size;
          return q.set(m, x), this.size += q.size == G ? 0 : 1, this;
        }
        To.prototype.clear = cP, To.prototype.delete = lP, To.prototype.get = fP, To.prototype.has = pP, To.prototype.set = dP;
        function js(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.__data__ = new To(); ++x < q; )
            this.add(m[x]);
        }
        function hP(m) {
          return this.__data__.set(m, u), this;
        }
        function mP(m) {
          return this.__data__.has(m);
        }
        js.prototype.add = js.prototype.push = hP, js.prototype.has = mP;
        function Na(m) {
          var x = this.__data__ = new Oo(m);
          this.size = x.size;
        }
        function gP() {
          this.__data__ = new Oo(), this.size = 0;
        }
        function vP(m) {
          var x = this.__data__, q = x.delete(m);
          return this.size = x.size, q;
        }
        function yP(m) {
          return this.__data__.get(m);
        }
        function bP(m) {
          return this.__data__.has(m);
        }
        function xP(m, x) {
          var q = this.__data__;
          if (q instanceof Oo) {
            var G = q.__data__;
            if (!qc || G.length < i - 1)
              return G.push([m, x]), this.size = ++q.size, this;
            q = this.__data__ = new To(G);
          }
          return q.set(m, x), this.size = q.size, this;
        }
        Na.prototype.clear = gP, Na.prototype.delete = vP, Na.prototype.get = yP, Na.prototype.has = bP, Na.prototype.set = xP;
        function Xg(m, x) {
          var q = _n(m), G = !q && Ns(m), oe = !q && !G && ms(m), Ee = !q && !G && !oe && Hu(m), Ne = q || G || oe || Ee, Ke = Ne ? w1(m.length, PT) : [], vt = Ke.length;
          for (var zt in m)
            (x || Fn.call(m, zt)) && !(Ne && // Safari 9 has enumerable `arguments.length` in strict mode.
            (zt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            oe && (zt == "offset" || zt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            Ee && (zt == "buffer" || zt == "byteLength" || zt == "byteOffset") || // Skip index properties.
            jo(zt, vt))) && Ke.push(zt);
          return Ke;
        }
        function ev(m) {
          var x = m.length;
          return x ? m[F1(0, x - 1)] : n;
        }
        function _P(m, x) {
          return Lp(Ki(m), qs(x, 0, m.length));
        }
        function wP(m) {
          return Lp(Ki(m));
        }
        function T1(m, x, q) {
          (q !== n && !Fa(m[x], q) || q === n && !(x in m)) && Po(m, x, q);
        }
        function Nc(m, x, q) {
          var G = m[x];
          (!(Fn.call(m, x) && Fa(G, q)) || q === n && !(x in m)) && Po(m, x, q);
        }
        function Cp(m, x) {
          for (var q = m.length; q--; )
            if (Fa(m[q][0], x))
              return q;
          return -1;
        }
        function SP(m, x, q, G) {
          return fs(m, function(oe, Ee, Ne) {
            x(G, oe, q(oe), Ne);
          }), G;
        }
        function tv(m, x) {
          return m && oo(x, hi(x), m);
        }
        function CP(m, x) {
          return m && oo(x, Yi(x), m);
        }
        function Po(m, x, q) {
          x == "__proto__" && yp ? yp(m, x, {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          }) : m[x] = q;
        }
        function P1(m, x) {
          for (var q = -1, G = x.length, oe = Nt(G), Ee = m == null; ++q < G; )
            oe[q] = Ee ? n : lh(m, x[q]);
          return oe;
        }
        function qs(m, x, q) {
          return m === m && (q !== n && (m = m <= q ? m : q), x !== n && (m = m >= x ? m : x)), m;
        }
        function ba(m, x, q, G, oe, Ee) {
          var Ne, Ke = x & d, vt = x & f, zt = x & p;
          if (q && (Ne = oe ? q(m, G, oe, Ee) : q(m)), Ne !== n)
            return Ne;
          if (!Yn(m))
            return m;
          var Vt = _n(m);
          if (Vt) {
            if (Ne = pR(m), !Ke)
              return Ki(m, Ne);
          } else {
            var tr = Oi(m), sn = tr == Xe || tr == ze;
            if (ms(m))
              return kv(m, Ke);
            if (tr == W || tr == Ue || sn && !oe) {
              if (Ne = vt || sn ? {} : zv(m), !Ke)
                return vt ? tR(m, CP(Ne, m)) : eR(m, tv(Ne, m));
            } else {
              if (!Ut[tr])
                return oe ? m : {};
              Ne = dR(m, tr, Ke);
            }
          }
          Ee || (Ee = new Na());
          var dn = Ee.get(m);
          if (dn)
            return dn;
          Ee.set(m, Ne), by(m) ? m.forEach(function(yn) {
            Ne.add(ba(yn, x, q, yn, m, Ee));
          }) : vy(m) && m.forEach(function(yn, Rn) {
            Ne.set(Rn, ba(yn, x, q, Rn, m, Ee));
          });
          var vn = zt ? vt ? Y1 : Z1 : vt ? Yi : hi, En = Vt ? n : vn(m);
          return _r(En || m, function(yn, Rn) {
            En && (Rn = yn, yn = m[Rn]), Nc(Ne, Rn, ba(yn, x, q, Rn, m, Ee));
          }), Ne;
        }
        function kP(m) {
          var x = hi(m);
          return function(q) {
            return rv(q, m, x);
          };
        }
        function rv(m, x, q) {
          var G = q.length;
          if (m == null)
            return !G;
          for (m = Hn(m); G--; ) {
            var oe = q[G], Ee = x[oe], Ne = m[oe];
            if (Ne === n && !(oe in m) || !Ee(Ne))
              return !1;
          }
          return !0;
        }
        function nv(m, x, q) {
          if (typeof m != "function")
            throw new va(o);
          return Vc(function() {
            m.apply(n, q);
          }, x);
        }
        function Fc(m, x, q, G) {
          var oe = -1, Ee = kr, Ne = !0, Ke = m.length, vt = [], zt = x.length;
          if (!Ke)
            return vt;
          q && (x = Zt(x, ia(q))), G ? (Ee = nr, Ne = !1) : x.length >= i && (Ee = Ic, Ne = !1, x = new js(x));
          e:
            for (; ++oe < Ke; ) {
              var Vt = m[oe], tr = q == null ? Vt : q(Vt);
              if (Vt = G || Vt !== 0 ? Vt : 0, Ne && tr === tr) {
                for (var sn = zt; sn--; )
                  if (x[sn] === tr)
                    continue e;
                vt.push(Vt);
              } else Ee(x, tr, G) || vt.push(Vt);
            }
          return vt;
        }
        var fs = Pv(ao), iv = Pv(I1, !0);
        function AP(m, x) {
          var q = !0;
          return fs(m, function(G, oe, Ee) {
            return q = !!x(G, oe, Ee), q;
          }), q;
        }
        function kp(m, x, q) {
          for (var G = -1, oe = m.length; ++G < oe; ) {
            var Ee = m[G], Ne = x(Ee);
            if (Ne != null && (Ke === n ? Ne === Ne && !oa(Ne) : q(Ne, Ke)))
              var Ke = Ne, vt = Ee;
          }
          return vt;
        }
        function EP(m, x, q, G) {
          var oe = m.length;
          for (q = Cn(q), q < 0 && (q = -q > oe ? 0 : oe + q), G = G === n || G > oe ? oe : Cn(G), G < 0 && (G += oe), G = q > G ? 0 : _y(G); q < G; )
            m[q++] = x;
          return m;
        }
        function av(m, x) {
          var q = [];
          return fs(m, function(G, oe, Ee) {
            x(G, oe, Ee) && q.push(G);
          }), q;
        }
        function ki(m, x, q, G, oe) {
          var Ee = -1, Ne = m.length;
          for (q || (q = mR), oe || (oe = []); ++Ee < Ne; ) {
            var Ke = m[Ee];
            x > 0 && q(Ke) ? x > 1 ? ki(Ke, x - 1, q, G, oe) : Qt(oe, Ke) : G || (oe[oe.length] = Ke);
          }
          return oe;
        }
        var R1 = Rv(), ov = Rv(!0);
        function ao(m, x) {
          return m && R1(m, x, hi);
        }
        function I1(m, x) {
          return m && ov(m, x, hi);
        }
        function Ap(m, x) {
          return Jt(x, function(q) {
            return qo(m[q]);
          });
        }
        function Ds(m, x) {
          x = ds(x, m);
          for (var q = 0, G = x.length; m != null && q < G; )
            m = m[so(x[q++])];
          return q && q == G ? m : n;
        }
        function sv(m, x, q) {
          var G = x(m);
          return _n(m) ? G : Qt(G, q(m));
        }
        function Ni(m) {
          return m == null ? m === n ? et : ye : Rs && Rs in Hn(m) ? cR(m) : wR(m);
        }
        function j1(m, x) {
          return m > x;
        }
        function OP(m, x) {
          return m != null && Fn.call(m, x);
        }
        function TP(m, x) {
          return m != null && x in Hn(m);
        }
        function PP(m, x, q) {
          return m >= Ei(x, q) && m < ui(x, q);
        }
        function q1(m, x, q) {
          for (var G = q ? nr : kr, oe = m[0].length, Ee = m.length, Ne = Ee, Ke = Nt(Ee), vt = 1 / 0, zt = []; Ne--; ) {
            var Vt = m[Ne];
            Ne && x && (Vt = Zt(Vt, ia(x))), vt = Ei(Vt.length, vt), Ke[Ne] = !q && (x || oe >= 120 && Vt.length >= 120) ? new js(Ne && Vt) : n;
          }
          Vt = m[0];
          var tr = -1, sn = Ke[0];
          e:
            for (; ++tr < oe && zt.length < vt; ) {
              var dn = Vt[tr], vn = x ? x(dn) : dn;
              if (dn = q || dn !== 0 ? dn : 0, !(sn ? Ic(sn, vn) : G(zt, vn, q))) {
                for (Ne = Ee; --Ne; ) {
                  var En = Ke[Ne];
                  if (!(En ? Ic(En, vn) : G(m[Ne], vn, q)))
                    continue e;
                }
                sn && sn.push(vn), zt.push(dn);
              }
            }
          return zt;
        }
        function RP(m, x, q, G) {
          return ao(m, function(oe, Ee, Ne) {
            x(G, q(oe), Ee, Ne);
          }), G;
        }
        function Mc(m, x, q) {
          x = ds(x, m), m = Kv(m, x);
          var G = m == null ? m : m[so(_a(x))];
          return G == null ? n : mr(G, m, q);
        }
        function uv(m) {
          return Qn(m) && Ni(m) == Ue;
        }
        function IP(m) {
          return Qn(m) && Ni(m) == Be;
        }
        function jP(m) {
          return Qn(m) && Ni(m) == He;
        }
        function Bc(m, x, q, G, oe) {
          return m === x ? !0 : m == null || x == null || !Qn(m) && !Qn(x) ? m !== m && x !== x : qP(m, x, q, G, Bc, oe);
        }
        function qP(m, x, q, G, oe, Ee) {
          var Ne = _n(m), Ke = _n(x), vt = Ne ? qt : Oi(m), zt = Ke ? qt : Oi(x);
          vt = vt == Ue ? W : vt, zt = zt == Ue ? W : zt;
          var Vt = vt == W, tr = zt == W, sn = vt == zt;
          if (sn && ms(m)) {
            if (!ms(x))
              return !1;
            Ne = !0, Vt = !1;
          }
          if (sn && !Vt)
            return Ee || (Ee = new Na()), Ne || Hu(m) ? Bv(m, x, q, G, oe, Ee) : sR(m, x, vt, q, G, oe, Ee);
          if (!(q & g)) {
            var dn = Vt && Fn.call(m, "__wrapped__"), vn = tr && Fn.call(x, "__wrapped__");
            if (dn || vn) {
              var En = dn ? m.value() : m, yn = vn ? x.value() : x;
              return Ee || (Ee = new Na()), oe(En, yn, q, G, Ee);
            }
          }
          return sn ? (Ee || (Ee = new Na()), uR(m, x, q, G, oe, Ee)) : !1;
        }
        function DP(m) {
          return Qn(m) && Oi(m) == Rt;
        }
        function D1(m, x, q, G) {
          var oe = q.length, Ee = oe, Ne = !G;
          if (m == null)
            return !Ee;
          for (m = Hn(m); oe--; ) {
            var Ke = q[oe];
            if (Ne && Ke[2] ? Ke[1] !== m[Ke[0]] : !(Ke[0] in m))
              return !1;
          }
          for (; ++oe < Ee; ) {
            Ke = q[oe];
            var vt = Ke[0], zt = m[vt], Vt = Ke[1];
            if (Ne && Ke[2]) {
              if (zt === n && !(vt in m))
                return !1;
            } else {
              var tr = new Na();
              if (G)
                var sn = G(zt, Vt, vt, m, x, tr);
              if (!(sn === n ? Bc(Vt, zt, g | b, G, tr) : sn))
                return !1;
            }
          }
          return !0;
        }
        function cv(m) {
          if (!Yn(m) || vR(m))
            return !1;
          var x = qo(m) ? DT : We;
          return x.test(Ls(m));
        }
        function $P(m) {
          return Qn(m) && Ni(m) == Te;
        }
        function LP(m) {
          return Qn(m) && Oi(m) == $;
        }
        function NP(m) {
          return Qn(m) && Hp(m.length) && !!Wt[Ni(m)];
        }
        function lv(m) {
          return typeof m == "function" ? m : m == null ? Ji : typeof m == "object" ? _n(m) ? dv(m[0], m[1]) : pv(m) : Iy(m);
        }
        function $1(m) {
          if (!zc(m))
            return BT(m);
          var x = [];
          for (var q in Hn(m))
            Fn.call(m, q) && q != "constructor" && x.push(q);
          return x;
        }
        function FP(m) {
          if (!Yn(m))
            return _R(m);
          var x = zc(m), q = [];
          for (var G in m)
            G == "constructor" && (x || !Fn.call(m, G)) || q.push(G);
          return q;
        }
        function L1(m, x) {
          return m < x;
        }
        function fv(m, x) {
          var q = -1, G = Zi(m) ? Nt(m.length) : [];
          return fs(m, function(oe, Ee, Ne) {
            G[++q] = x(oe, Ee, Ne);
          }), G;
        }
        function pv(m) {
          var x = Q1(m);
          return x.length == 1 && x[0][2] ? Gv(x[0][0], x[0][1]) : function(q) {
            return q === m || D1(q, m, x);
          };
        }
        function dv(m, x) {
          return eh(m) && Vv(x) ? Gv(so(m), x) : function(q) {
            var G = lh(q, m);
            return G === n && G === x ? fh(q, m) : Bc(x, G, g | b);
          };
        }
        function Ep(m, x, q, G, oe) {
          m !== x && R1(x, function(Ee, Ne) {
            if (oe || (oe = new Na()), Yn(Ee))
              MP(m, x, Ne, q, Ep, G, oe);
            else {
              var Ke = G ? G(rh(m, Ne), Ee, Ne + "", m, x, oe) : n;
              Ke === n && (Ke = Ee), T1(m, Ne, Ke);
            }
          }, Yi);
        }
        function MP(m, x, q, G, oe, Ee, Ne) {
          var Ke = rh(m, q), vt = rh(x, q), zt = Ne.get(vt);
          if (zt) {
            T1(m, q, zt);
            return;
          }
          var Vt = Ee ? Ee(Ke, vt, q + "", m, x, Ne) : n, tr = Vt === n;
          if (tr) {
            var sn = _n(vt), dn = !sn && ms(vt), vn = !sn && !dn && Hu(vt);
            Vt = vt, sn || dn || vn ? _n(Ke) ? Vt = Ke : ti(Ke) ? Vt = Ki(Ke) : dn ? (tr = !1, Vt = kv(vt, !0)) : vn ? (tr = !1, Vt = Av(vt, !0)) : Vt = [] : Gc(vt) || Ns(vt) ? (Vt = Ke, Ns(Ke) ? Vt = wy(Ke) : (!Yn(Ke) || qo(Ke)) && (Vt = zv(vt))) : tr = !1;
          }
          tr && (Ne.set(vt, Vt), oe(Vt, vt, G, Ee, Ne), Ne.delete(vt)), T1(m, q, Vt);
        }
        function hv(m, x) {
          var q = m.length;
          if (q)
            return x += x < 0 ? q : 0, jo(x, q) ? m[x] : n;
        }
        function mv(m, x, q) {
          x.length ? x = Zt(x, function(Ee) {
            return _n(Ee) ? function(Ne) {
              return Ds(Ne, Ee.length === 1 ? Ee[0] : Ee);
            } : Ee;
          }) : x = [Ji];
          var G = -1;
          x = Zt(x, ia(mn()));
          var oe = fv(m, function(Ee, Ne, Ke) {
            var vt = Zt(x, function(zt) {
              return zt(Ee);
            });
            return { criteria: vt, index: ++G, value: Ee };
          });
          return dT(oe, function(Ee, Ne) {
            return XP(Ee, Ne, q);
          });
        }
        function BP(m, x) {
          return gv(m, x, function(q, G) {
            return fh(m, G);
          });
        }
        function gv(m, x, q) {
          for (var G = -1, oe = x.length, Ee = {}; ++G < oe; ) {
            var Ne = x[G], Ke = Ds(m, Ne);
            q(Ke, Ne) && Uc(Ee, ds(Ne, m), Ke);
          }
          return Ee;
        }
        function UP(m) {
          return function(x) {
            return Ds(x, m);
          };
        }
        function N1(m, x, q, G) {
          var oe = G ? pT : An, Ee = -1, Ne = x.length, Ke = m;
          for (m === x && (x = Ki(x)), q && (Ke = Zt(m, ia(q))); ++Ee < Ne; )
            for (var vt = 0, zt = x[Ee], Vt = q ? q(zt) : zt; (vt = oe(Ke, Vt, vt, G)) > -1; )
              Ke !== m && vp.call(Ke, vt, 1), vp.call(m, vt, 1);
          return m;
        }
        function vv(m, x) {
          for (var q = m ? x.length : 0, G = q - 1; q--; ) {
            var oe = x[q];
            if (q == G || oe !== Ee) {
              var Ee = oe;
              jo(oe) ? vp.call(m, oe, 1) : U1(m, oe);
            }
          }
          return m;
        }
        function F1(m, x) {
          return m + xp(Jg() * (x - m + 1));
        }
        function HP(m, x, q, G) {
          for (var oe = -1, Ee = ui(bp((x - m) / (q || 1)), 0), Ne = Nt(Ee); Ee--; )
            Ne[G ? Ee : ++oe] = m, m += q;
          return Ne;
        }
        function M1(m, x) {
          var q = "";
          if (!m || x < 1 || x > je)
            return q;
          do
            x % 2 && (q += m), x = xp(x / 2), x && (m += m);
          while (x);
          return q;
        }
        function Tn(m, x) {
          return nh(Wv(m, x, Ji), m + "");
        }
        function zP(m) {
          return ev(zu(m));
        }
        function VP(m, x) {
          var q = zu(m);
          return Lp(q, qs(x, 0, q.length));
        }
        function Uc(m, x, q, G) {
          if (!Yn(m))
            return m;
          x = ds(x, m);
          for (var oe = -1, Ee = x.length, Ne = Ee - 1, Ke = m; Ke != null && ++oe < Ee; ) {
            var vt = so(x[oe]), zt = q;
            if (vt === "__proto__" || vt === "constructor" || vt === "prototype")
              return m;
            if (oe != Ne) {
              var Vt = Ke[vt];
              zt = G ? G(Vt, vt, Ke) : n, zt === n && (zt = Yn(Vt) ? Vt : jo(x[oe + 1]) ? [] : {});
            }
            Nc(Ke, vt, zt), Ke = Ke[vt];
          }
          return m;
        }
        var yv = _p ? function(m, x) {
          return _p.set(m, x), m;
        } : Ji, GP = yp ? function(m, x) {
          return yp(m, "toString", {
            configurable: !0,
            enumerable: !1,
            value: dh(x),
            writable: !0
          });
        } : Ji;
        function WP(m) {
          return Lp(zu(m));
        }
        function xa(m, x, q) {
          var G = -1, oe = m.length;
          x < 0 && (x = -x > oe ? 0 : oe + x), q = q > oe ? oe : q, q < 0 && (q += oe), oe = x > q ? 0 : q - x >>> 0, x >>>= 0;
          for (var Ee = Nt(oe); ++G < oe; )
            Ee[G] = m[G + x];
          return Ee;
        }
        function KP(m, x) {
          var q;
          return fs(m, function(G, oe, Ee) {
            return q = x(G, oe, Ee), !q;
          }), !!q;
        }
        function Op(m, x, q) {
          var G = 0, oe = m == null ? G : m.length;
          if (typeof x == "number" && x === x && oe <= ve) {
            for (; G < oe; ) {
              var Ee = G + oe >>> 1, Ne = m[Ee];
              Ne !== null && !oa(Ne) && (q ? Ne <= x : Ne < x) ? G = Ee + 1 : oe = Ee;
            }
            return oe;
          }
          return B1(m, x, Ji, q);
        }
        function B1(m, x, q, G) {
          var oe = 0, Ee = m == null ? 0 : m.length;
          if (Ee === 0)
            return 0;
          x = q(x);
          for (var Ne = x !== x, Ke = x === null, vt = oa(x), zt = x === n; oe < Ee; ) {
            var Vt = xp((oe + Ee) / 2), tr = q(m[Vt]), sn = tr !== n, dn = tr === null, vn = tr === tr, En = oa(tr);
            if (Ne)
              var yn = G || vn;
            else zt ? yn = vn && (G || sn) : Ke ? yn = vn && sn && (G || !dn) : vt ? yn = vn && sn && !dn && (G || !En) : dn || En ? yn = !1 : yn = G ? tr <= x : tr < x;
            yn ? oe = Vt + 1 : Ee = Vt;
          }
          return Ei(Ee, xe);
        }
        function bv(m, x) {
          for (var q = -1, G = m.length, oe = 0, Ee = []; ++q < G; ) {
            var Ne = m[q], Ke = x ? x(Ne) : Ne;
            if (!q || !Fa(Ke, vt)) {
              var vt = Ke;
              Ee[oe++] = Ne === 0 ? 0 : Ne;
            }
          }
          return Ee;
        }
        function xv(m) {
          return typeof m == "number" ? m : oa(m) ? qe : +m;
        }
        function aa(m) {
          if (typeof m == "string")
            return m;
          if (_n(m))
            return Zt(m, aa) + "";
          if (oa(m))
            return Qg ? Qg.call(m) : "";
          var x = m + "";
          return x == "0" && 1 / m == -De ? "-0" : x;
        }
        function ps(m, x, q) {
          var G = -1, oe = kr, Ee = m.length, Ne = !0, Ke = [], vt = Ke;
          if (q)
            Ne = !1, oe = nr;
          else if (Ee >= i) {
            var zt = x ? null : aR(m);
            if (zt)
              return cp(zt);
            Ne = !1, oe = Ic, vt = new js();
          } else
            vt = x ? [] : Ke;
          e:
            for (; ++G < Ee; ) {
              var Vt = m[G], tr = x ? x(Vt) : Vt;
              if (Vt = q || Vt !== 0 ? Vt : 0, Ne && tr === tr) {
                for (var sn = vt.length; sn--; )
                  if (vt[sn] === tr)
                    continue e;
                x && vt.push(tr), Ke.push(Vt);
              } else oe(vt, tr, q) || (vt !== Ke && vt.push(tr), Ke.push(Vt));
            }
          return Ke;
        }
        function U1(m, x) {
          return x = ds(x, m), m = Kv(m, x), m == null || delete m[so(_a(x))];
        }
        function _v(m, x, q, G) {
          return Uc(m, x, q(Ds(m, x)), G);
        }
        function Tp(m, x, q, G) {
          for (var oe = m.length, Ee = G ? oe : -1; (G ? Ee-- : ++Ee < oe) && x(m[Ee], Ee, m); )
            ;
          return q ? xa(m, G ? 0 : Ee, G ? Ee + 1 : oe) : xa(m, G ? Ee + 1 : 0, G ? oe : Ee);
        }
        function wv(m, x) {
          var q = m;
          return q instanceof In && (q = q.value()), Er(x, function(G, oe) {
            return oe.func.apply(oe.thisArg, Qt([G], oe.args));
          }, q);
        }
        function H1(m, x, q) {
          var G = m.length;
          if (G < 2)
            return G ? ps(m[0]) : [];
          for (var oe = -1, Ee = Nt(G); ++oe < G; )
            for (var Ne = m[oe], Ke = -1; ++Ke < G; )
              Ke != oe && (Ee[oe] = Fc(Ee[oe] || Ne, m[Ke], x, q));
          return ps(ki(Ee, 1), x, q);
        }
        function Sv(m, x, q) {
          for (var G = -1, oe = m.length, Ee = x.length, Ne = {}; ++G < oe; ) {
            var Ke = G < Ee ? x[G] : n;
            q(Ne, m[G], Ke);
          }
          return Ne;
        }
        function z1(m) {
          return ti(m) ? m : [];
        }
        function V1(m) {
          return typeof m == "function" ? m : Ji;
        }
        function ds(m, x) {
          return _n(m) ? m : eh(m, x) ? [m] : Qv(Nn(m));
        }
        var ZP = Tn;
        function hs(m, x, q) {
          var G = m.length;
          return q = q === n ? G : q, !x && q >= G ? m : xa(m, x, q);
        }
        var Cv = $T || function(m) {
          return er.clearTimeout(m);
        };
        function kv(m, x) {
          if (x)
            return m.slice();
          var q = m.length, G = Gg ? Gg(q) : new m.constructor(q);
          return m.copy(G), G;
        }
        function G1(m) {
          var x = new m.constructor(m.byteLength);
          return new mp(x).set(new mp(m)), x;
        }
        function YP(m, x) {
          var q = x ? G1(m.buffer) : m.buffer;
          return new m.constructor(q, m.byteOffset, m.byteLength);
        }
        function JP(m) {
          var x = new m.constructor(m.source, Re.exec(m));
          return x.lastIndex = m.lastIndex, x;
        }
        function QP(m) {
          return Lc ? Hn(Lc.call(m)) : {};
        }
        function Av(m, x) {
          var q = x ? G1(m.buffer) : m.buffer;
          return new m.constructor(q, m.byteOffset, m.length);
        }
        function Ev(m, x) {
          if (m !== x) {
            var q = m !== n, G = m === null, oe = m === m, Ee = oa(m), Ne = x !== n, Ke = x === null, vt = x === x, zt = oa(x);
            if (!Ke && !zt && !Ee && m > x || Ee && Ne && vt && !Ke && !zt || G && Ne && vt || !q && vt || !oe)
              return 1;
            if (!G && !Ee && !zt && m < x || zt && q && oe && !G && !Ee || Ke && q && oe || !Ne && oe || !vt)
              return -1;
          }
          return 0;
        }
        function XP(m, x, q) {
          for (var G = -1, oe = m.criteria, Ee = x.criteria, Ne = oe.length, Ke = q.length; ++G < Ne; ) {
            var vt = Ev(oe[G], Ee[G]);
            if (vt) {
              if (G >= Ke)
                return vt;
              var zt = q[G];
              return vt * (zt == "desc" ? -1 : 1);
            }
          }
          return m.index - x.index;
        }
        function Ov(m, x, q, G) {
          for (var oe = -1, Ee = m.length, Ne = q.length, Ke = -1, vt = x.length, zt = ui(Ee - Ne, 0), Vt = Nt(vt + zt), tr = !G; ++Ke < vt; )
            Vt[Ke] = x[Ke];
          for (; ++oe < Ne; )
            (tr || oe < Ee) && (Vt[q[oe]] = m[oe]);
          for (; zt--; )
            Vt[Ke++] = m[oe++];
          return Vt;
        }
        function Tv(m, x, q, G) {
          for (var oe = -1, Ee = m.length, Ne = -1, Ke = q.length, vt = -1, zt = x.length, Vt = ui(Ee - Ke, 0), tr = Nt(Vt + zt), sn = !G; ++oe < Vt; )
            tr[oe] = m[oe];
          for (var dn = oe; ++vt < zt; )
            tr[dn + vt] = x[vt];
          for (; ++Ne < Ke; )
            (sn || oe < Ee) && (tr[dn + q[Ne]] = m[oe++]);
          return tr;
        }
        function Ki(m, x) {
          var q = -1, G = m.length;
          for (x || (x = Nt(G)); ++q < G; )
            x[q] = m[q];
          return x;
        }
        function oo(m, x, q, G) {
          var oe = !q;
          q || (q = {});
          for (var Ee = -1, Ne = x.length; ++Ee < Ne; ) {
            var Ke = x[Ee], vt = G ? G(q[Ke], m[Ke], Ke, q, m) : n;
            vt === n && (vt = m[Ke]), oe ? Po(q, Ke, vt) : Nc(q, Ke, vt);
          }
          return q;
        }
        function eR(m, x) {
          return oo(m, X1(m), x);
        }
        function tR(m, x) {
          return oo(m, Uv(m), x);
        }
        function Pp(m, x) {
          return function(q, G) {
            var oe = _n(q) ? gr : SP, Ee = x ? x() : {};
            return oe(q, m, mn(G, 2), Ee);
          };
        }
        function Mu(m) {
          return Tn(function(x, q) {
            var G = -1, oe = q.length, Ee = oe > 1 ? q[oe - 1] : n, Ne = oe > 2 ? q[2] : n;
            for (Ee = m.length > 3 && typeof Ee == "function" ? (oe--, Ee) : n, Ne && Fi(q[0], q[1], Ne) && (Ee = oe < 3 ? n : Ee, oe = 1), x = Hn(x); ++G < oe; ) {
              var Ke = q[G];
              Ke && m(x, Ke, G, Ee);
            }
            return x;
          });
        }
        function Pv(m, x) {
          return function(q, G) {
            if (q == null)
              return q;
            if (!Zi(q))
              return m(q, G);
            for (var oe = q.length, Ee = x ? oe : -1, Ne = Hn(q); (x ? Ee-- : ++Ee < oe) && G(Ne[Ee], Ee, Ne) !== !1; )
              ;
            return q;
          };
        }
        function Rv(m) {
          return function(x, q, G) {
            for (var oe = -1, Ee = Hn(x), Ne = G(x), Ke = Ne.length; Ke--; ) {
              var vt = Ne[m ? Ke : ++oe];
              if (q(Ee[vt], vt, Ee) === !1)
                break;
            }
            return x;
          };
        }
        function rR(m, x, q) {
          var G = x & w, oe = Hc(m);
          function Ee() {
            var Ne = this && this !== er && this instanceof Ee ? oe : m;
            return Ne.apply(G ? q : this, arguments);
          }
          return Ee;
        }
        function Iv(m) {
          return function(x) {
            x = Nn(x);
            var q = ju(x) ? La(x) : n, G = q ? q[0] : x.charAt(0), oe = q ? hs(q, 1).join("") : x.slice(1);
            return G[m]() + oe;
          };
        }
        function Bu(m) {
          return function(x) {
            return Er(Py(Ty(x).replace(on, "")), m, "");
          };
        }
        function Hc(m) {
          return function() {
            var x = arguments;
            switch (x.length) {
              case 0:
                return new m();
              case 1:
                return new m(x[0]);
              case 2:
                return new m(x[0], x[1]);
              case 3:
                return new m(x[0], x[1], x[2]);
              case 4:
                return new m(x[0], x[1], x[2], x[3]);
              case 5:
                return new m(x[0], x[1], x[2], x[3], x[4]);
              case 6:
                return new m(x[0], x[1], x[2], x[3], x[4], x[5]);
              case 7:
                return new m(x[0], x[1], x[2], x[3], x[4], x[5], x[6]);
            }
            var q = Fu(m.prototype), G = m.apply(q, x);
            return Yn(G) ? G : q;
          };
        }
        function nR(m, x, q) {
          var G = Hc(m);
          function oe() {
            for (var Ee = arguments.length, Ne = Nt(Ee), Ke = Ee, vt = Uu(oe); Ke--; )
              Ne[Ke] = arguments[Ke];
            var zt = Ee < 3 && Ne[0] !== vt && Ne[Ee - 1] !== vt ? [] : cs(Ne, vt);
            if (Ee -= zt.length, Ee < q)
              return Lv(
                m,
                x,
                Rp,
                oe.placeholder,
                n,
                Ne,
                zt,
                n,
                n,
                q - Ee
              );
            var Vt = this && this !== er && this instanceof oe ? G : m;
            return mr(Vt, this, Ne);
          }
          return oe;
        }
        function jv(m) {
          return function(x, q, G) {
            var oe = Hn(x);
            if (!Zi(x)) {
              var Ee = mn(q, 3);
              x = hi(x), q = function(Ke) {
                return Ee(oe[Ke], Ke, oe);
              };
            }
            var Ne = m(x, q, G);
            return Ne > -1 ? oe[Ee ? x[Ne] : Ne] : n;
          };
        }
        function qv(m) {
          return Io(function(x) {
            var q = x.length, G = q, oe = ya.prototype.thru;
            for (m && x.reverse(); G--; ) {
              var Ee = x[G];
              if (typeof Ee != "function")
                throw new va(o);
              if (oe && !Ne && Dp(Ee) == "wrapper")
                var Ne = new ya([], !0);
            }
            for (G = Ne ? G : q; ++G < q; ) {
              Ee = x[G];
              var Ke = Dp(Ee), vt = Ke == "wrapper" ? J1(Ee) : n;
              vt && th(vt[0]) && vt[1] == (L | _ | O | Z) && !vt[4].length && vt[9] == 1 ? Ne = Ne[Dp(vt[0])].apply(Ne, vt[3]) : Ne = Ee.length == 1 && th(Ee) ? Ne[Ke]() : Ne.thru(Ee);
            }
            return function() {
              var zt = arguments, Vt = zt[0];
              if (Ne && zt.length == 1 && _n(Vt))
                return Ne.plant(Vt).value();
              for (var tr = 0, sn = q ? x[tr].apply(this, zt) : Vt; ++tr < q; )
                sn = x[tr].call(this, sn);
              return sn;
            };
          });
        }
        function Rp(m, x, q, G, oe, Ee, Ne, Ke, vt, zt) {
          var Vt = x & L, tr = x & w, sn = x & y, dn = x & (_ | E), vn = x & Q, En = sn ? n : Hc(m);
          function yn() {
            for (var Rn = arguments.length, jn = Nt(Rn), sa = Rn; sa--; )
              jn[sa] = arguments[sa];
            if (dn)
              var Mi = Uu(yn), ua = mT(jn, Mi);
            if (G && (jn = Ov(jn, G, oe, dn)), Ee && (jn = Tv(jn, Ee, Ne, dn)), Rn -= ua, dn && Rn < zt) {
              var ri = cs(jn, Mi);
              return Lv(
                m,
                x,
                Rp,
                yn.placeholder,
                q,
                jn,
                ri,
                Ke,
                vt,
                zt - Rn
              );
            }
            var Ma = tr ? q : this, $o = sn ? Ma[m] : m;
            return Rn = jn.length, Ke ? jn = SR(jn, Ke) : vn && Rn > 1 && jn.reverse(), Vt && vt < Rn && (jn.length = vt), this && this !== er && this instanceof yn && ($o = En || Hc($o)), $o.apply(Ma, jn);
          }
          return yn;
        }
        function Dv(m, x) {
          return function(q, G) {
            return RP(q, m, x(G), {});
          };
        }
        function Ip(m, x) {
          return function(q, G) {
            var oe;
            if (q === n && G === n)
              return x;
            if (q !== n && (oe = q), G !== n) {
              if (oe === n)
                return G;
              typeof q == "string" || typeof G == "string" ? (q = aa(q), G = aa(G)) : (q = xv(q), G = xv(G)), oe = m(q, G);
            }
            return oe;
          };
        }
        function W1(m) {
          return Io(function(x) {
            return x = Zt(x, ia(mn())), Tn(function(q) {
              var G = this;
              return m(x, function(oe) {
                return mr(oe, G, q);
              });
            });
          });
        }
        function jp(m, x) {
          x = x === n ? " " : aa(x);
          var q = x.length;
          if (q < 2)
            return q ? M1(x, m) : x;
          var G = M1(x, bp(m / qu(x)));
          return ju(x) ? hs(La(G), 0, m).join("") : G.slice(0, m);
        }
        function iR(m, x, q, G) {
          var oe = x & w, Ee = Hc(m);
          function Ne() {
            for (var Ke = -1, vt = arguments.length, zt = -1, Vt = G.length, tr = Nt(Vt + vt), sn = this && this !== er && this instanceof Ne ? Ee : m; ++zt < Vt; )
              tr[zt] = G[zt];
            for (; vt--; )
              tr[zt++] = arguments[++Ke];
            return mr(sn, oe ? q : this, tr);
          }
          return Ne;
        }
        function $v(m) {
          return function(x, q, G) {
            return G && typeof G != "number" && Fi(x, q, G) && (q = G = n), x = Do(x), q === n ? (q = x, x = 0) : q = Do(q), G = G === n ? x < q ? 1 : -1 : Do(G), HP(x, q, G, m);
          };
        }
        function qp(m) {
          return function(x, q) {
            return typeof x == "string" && typeof q == "string" || (x = wa(x), q = wa(q)), m(x, q);
          };
        }
        function Lv(m, x, q, G, oe, Ee, Ne, Ke, vt, zt) {
          var Vt = x & _, tr = Vt ? Ne : n, sn = Vt ? n : Ne, dn = Vt ? Ee : n, vn = Vt ? n : Ee;
          x |= Vt ? O : M, x &= ~(Vt ? M : O), x & v || (x &= -4);
          var En = [
            m,
            x,
            oe,
            dn,
            tr,
            vn,
            sn,
            Ke,
            vt,
            zt
          ], yn = q.apply(n, En);
          return th(m) && Zv(yn, En), yn.placeholder = G, Yv(yn, m, x);
        }
        function K1(m) {
          var x = si[m];
          return function(q, G) {
            if (q = wa(q), G = G == null ? 0 : Ei(Cn(G), 292), G && Yg(q)) {
              var oe = (Nn(q) + "e").split("e"), Ee = x(oe[0] + "e" + (+oe[1] + G));
              return oe = (Nn(Ee) + "e").split("e"), +(oe[0] + "e" + (+oe[1] - G));
            }
            return x(q);
          };
        }
        var aR = Lu && 1 / cp(new Lu([, -0]))[1] == De ? function(m) {
          return new Lu(m);
        } : gh;
        function Nv(m) {
          return function(x) {
            var q = Oi(x);
            return q == Rt ? C1(x) : q == $ ? wT(x) : hT(x, m(x));
          };
        }
        function Ro(m, x, q, G, oe, Ee, Ne, Ke) {
          var vt = x & y;
          if (!vt && typeof m != "function")
            throw new va(o);
          var zt = G ? G.length : 0;
          if (zt || (x &= -97, G = oe = n), Ne = Ne === n ? Ne : ui(Cn(Ne), 0), Ke = Ke === n ? Ke : Cn(Ke), zt -= oe ? oe.length : 0, x & M) {
            var Vt = G, tr = oe;
            G = oe = n;
          }
          var sn = vt ? n : J1(m), dn = [
            m,
            x,
            q,
            G,
            oe,
            Vt,
            tr,
            Ee,
            Ne,
            Ke
          ];
          if (sn && xR(dn, sn), m = dn[0], x = dn[1], q = dn[2], G = dn[3], oe = dn[4], Ke = dn[9] = dn[9] === n ? vt ? 0 : m.length : ui(dn[9] - zt, 0), !Ke && x & (_ | E) && (x &= -25), !x || x == w)
            var vn = rR(m, x, q);
          else x == _ || x == E ? vn = nR(m, x, Ke) : (x == O || x == (w | O)) && !oe.length ? vn = iR(m, x, q, G) : vn = Rp.apply(n, dn);
          var En = sn ? yv : Zv;
          return Yv(En(vn, dn), m, x);
        }
        function Fv(m, x, q, G) {
          return m === n || Fa(m, $u[q]) && !Fn.call(G, q) ? x : m;
        }
        function Mv(m, x, q, G, oe, Ee) {
          return Yn(m) && Yn(x) && (Ee.set(x, m), Ep(m, x, n, Mv, Ee), Ee.delete(x)), m;
        }
        function oR(m) {
          return Gc(m) ? n : m;
        }
        function Bv(m, x, q, G, oe, Ee) {
          var Ne = q & g, Ke = m.length, vt = x.length;
          if (Ke != vt && !(Ne && vt > Ke))
            return !1;
          var zt = Ee.get(m), Vt = Ee.get(x);
          if (zt && Vt)
            return zt == x && Vt == m;
          var tr = -1, sn = !0, dn = q & b ? new js() : n;
          for (Ee.set(m, x), Ee.set(x, m); ++tr < Ke; ) {
            var vn = m[tr], En = x[tr];
            if (G)
              var yn = Ne ? G(En, vn, tr, x, m, Ee) : G(vn, En, tr, m, x, Ee);
            if (yn !== n) {
              if (yn)
                continue;
              sn = !1;
              break;
            }
            if (dn) {
              if (!Or(x, function(Rn, jn) {
                if (!Ic(dn, jn) && (vn === Rn || oe(vn, Rn, q, G, Ee)))
                  return dn.push(jn);
              })) {
                sn = !1;
                break;
              }
            } else if (!(vn === En || oe(vn, En, q, G, Ee))) {
              sn = !1;
              break;
            }
          }
          return Ee.delete(m), Ee.delete(x), sn;
        }
        function sR(m, x, q, G, oe, Ee, Ne) {
          switch (q) {
            case P:
              if (m.byteLength != x.byteLength || m.byteOffset != x.byteOffset)
                return !1;
              m = m.buffer, x = x.buffer;
            case Be:
              return !(m.byteLength != x.byteLength || !Ee(new mp(m), new mp(x)));
            case At:
            case He:
            case Yt:
              return Fa(+m, +x);
            case Fe:
              return m.name == x.name && m.message == x.message;
            case Te:
            case _e:
              return m == x + "";
            case Rt:
              var Ke = C1;
            case $:
              var vt = G & g;
              if (Ke || (Ke = cp), m.size != x.size && !vt)
                return !1;
              var zt = Ne.get(m);
              if (zt)
                return zt == x;
              G |= b, Ne.set(m, x);
              var Vt = Bv(Ke(m), Ke(x), G, oe, Ee, Ne);
              return Ne.delete(m), Vt;
            case Le:
              if (Lc)
                return Lc.call(m) == Lc.call(x);
          }
          return !1;
        }
        function uR(m, x, q, G, oe, Ee) {
          var Ne = q & g, Ke = Z1(m), vt = Ke.length, zt = Z1(x), Vt = zt.length;
          if (vt != Vt && !Ne)
            return !1;
          for (var tr = vt; tr--; ) {
            var sn = Ke[tr];
            if (!(Ne ? sn in x : Fn.call(x, sn)))
              return !1;
          }
          var dn = Ee.get(m), vn = Ee.get(x);
          if (dn && vn)
            return dn == x && vn == m;
          var En = !0;
          Ee.set(m, x), Ee.set(x, m);
          for (var yn = Ne; ++tr < vt; ) {
            sn = Ke[tr];
            var Rn = m[sn], jn = x[sn];
            if (G)
              var sa = Ne ? G(jn, Rn, sn, x, m, Ee) : G(Rn, jn, sn, m, x, Ee);
            if (!(sa === n ? Rn === jn || oe(Rn, jn, q, G, Ee) : sa)) {
              En = !1;
              break;
            }
            yn || (yn = sn == "constructor");
          }
          if (En && !yn) {
            var Mi = m.constructor, ua = x.constructor;
            Mi != ua && "constructor" in m && "constructor" in x && !(typeof Mi == "function" && Mi instanceof Mi && typeof ua == "function" && ua instanceof ua) && (En = !1);
          }
          return Ee.delete(m), Ee.delete(x), En;
        }
        function Io(m) {
          return nh(Wv(m, n, ry), m + "");
        }
        function Z1(m) {
          return sv(m, hi, X1);
        }
        function Y1(m) {
          return sv(m, Yi, Uv);
        }
        var J1 = _p ? function(m) {
          return _p.get(m);
        } : gh;
        function Dp(m) {
          for (var x = m.name + "", q = Nu[x], G = Fn.call(Nu, x) ? q.length : 0; G--; ) {
            var oe = q[G], Ee = oe.func;
            if (Ee == null || Ee == m)
              return oe.name;
          }
          return x;
        }
        function Uu(m) {
          var x = Fn.call(Se, "placeholder") ? Se : m;
          return x.placeholder;
        }
        function mn() {
          var m = Se.iteratee || hh;
          return m = m === hh ? lv : m, arguments.length ? m(arguments[0], arguments[1]) : m;
        }
        function $p(m, x) {
          var q = m.__data__;
          return gR(x) ? q[typeof x == "string" ? "string" : "hash"] : q.map;
        }
        function Q1(m) {
          for (var x = hi(m), q = x.length; q--; ) {
            var G = x[q], oe = m[G];
            x[q] = [G, oe, Vv(oe)];
          }
          return x;
        }
        function $s(m, x) {
          var q = bT(m, x);
          return cv(q) ? q : n;
        }
        function cR(m) {
          var x = Fn.call(m, Rs), q = m[Rs];
          try {
            m[Rs] = n;
            var G = !0;
          } catch {
          }
          var oe = dp.call(m);
          return G && (x ? m[Rs] = q : delete m[Rs]), oe;
        }
        var X1 = A1 ? function(m) {
          return m == null ? [] : (m = Hn(m), Jt(A1(m), function(x) {
            return Kg.call(m, x);
          }));
        } : vh, Uv = A1 ? function(m) {
          for (var x = []; m; )
            Qt(x, X1(m)), m = gp(m);
          return x;
        } : vh, Oi = Ni;
        (E1 && Oi(new E1(new ArrayBuffer(1))) != P || qc && Oi(new qc()) != Rt || O1 && Oi(O1.resolve()) != Y || Lu && Oi(new Lu()) != $ || Dc && Oi(new Dc()) != Ge) && (Oi = function(m) {
          var x = Ni(m), q = x == W ? m.constructor : n, G = q ? Ls(q) : "";
          if (G)
            switch (G) {
              case VT:
                return P;
              case GT:
                return Rt;
              case WT:
                return Y;
              case KT:
                return $;
              case ZT:
                return Ge;
            }
          return x;
        });
        function lR(m, x, q) {
          for (var G = -1, oe = q.length; ++G < oe; ) {
            var Ee = q[G], Ne = Ee.size;
            switch (Ee.type) {
              case "drop":
                m += Ne;
                break;
              case "dropRight":
                x -= Ne;
                break;
              case "take":
                x = Ei(x, m + Ne);
                break;
              case "takeRight":
                m = ui(m, x - Ne);
                break;
            }
          }
          return { start: m, end: x };
        }
        function fR(m) {
          var x = m.match(be);
          return x ? x[1].split(me) : [];
        }
        function Hv(m, x, q) {
          x = ds(x, m);
          for (var G = -1, oe = x.length, Ee = !1; ++G < oe; ) {
            var Ne = so(x[G]);
            if (!(Ee = m != null && q(m, Ne)))
              break;
            m = m[Ne];
          }
          return Ee || ++G != oe ? Ee : (oe = m == null ? 0 : m.length, !!oe && Hp(oe) && jo(Ne, oe) && (_n(m) || Ns(m)));
        }
        function pR(m) {
          var x = m.length, q = new m.constructor(x);
          return x && typeof m[0] == "string" && Fn.call(m, "index") && (q.index = m.index, q.input = m.input), q;
        }
        function zv(m) {
          return typeof m.constructor == "function" && !zc(m) ? Fu(gp(m)) : {};
        }
        function dR(m, x, q) {
          var G = m.constructor;
          switch (x) {
            case Be:
              return G1(m);
            case At:
            case He:
              return new G(+m);
            case P:
              return YP(m, q);
            case N:
            case F:
            case T:
            case C:
            case S:
            case h:
            case k:
            case R:
            case j:
              return Av(m, q);
            case Rt:
              return new G();
            case Yt:
            case _e:
              return new G(m);
            case Te:
              return JP(m);
            case $:
              return new G();
            case Le:
              return QP(m);
          }
        }
        function hR(m, x) {
          var q = x.length;
          if (!q)
            return m;
          var G = q - 1;
          return x[G] = (q > 1 ? "& " : "") + x[G], x = x.join(q > 2 ? ", " : " "), m.replace(fe, `{
/* [wrapped with ` + x + `] */
`);
        }
        function mR(m) {
          return _n(m) || Ns(m) || !!(Zg && m && m[Zg]);
        }
        function jo(m, x) {
          var q = typeof m;
          return x = x ?? je, !!x && (q == "number" || q != "symbol" && dt.test(m)) && m > -1 && m % 1 == 0 && m < x;
        }
        function Fi(m, x, q) {
          if (!Yn(q))
            return !1;
          var G = typeof x;
          return (G == "number" ? Zi(q) && jo(x, q.length) : G == "string" && x in q) ? Fa(q[x], m) : !1;
        }
        function eh(m, x) {
          if (_n(m))
            return !1;
          var q = typeof m;
          return q == "number" || q == "symbol" || q == "boolean" || m == null || oa(m) ? !0 : ue.test(m) || !te.test(m) || x != null && m in Hn(x);
        }
        function gR(m) {
          var x = typeof m;
          return x == "string" || x == "number" || x == "symbol" || x == "boolean" ? m !== "__proto__" : m === null;
        }
        function th(m) {
          var x = Dp(m), q = Se[x];
          if (typeof q != "function" || !(x in In.prototype))
            return !1;
          if (m === q)
            return !0;
          var G = J1(q);
          return !!G && m === G[0];
        }
        function vR(m) {
          return !!Vg && Vg in m;
        }
        var yR = fp ? qo : yh;
        function zc(m) {
          var x = m && m.constructor, q = typeof x == "function" && x.prototype || $u;
          return m === q;
        }
        function Vv(m) {
          return m === m && !Yn(m);
        }
        function Gv(m, x) {
          return function(q) {
            return q == null ? !1 : q[m] === x && (x !== n || m in Hn(q));
          };
        }
        function bR(m) {
          var x = Bp(m, function(G) {
            return q.size === s && q.clear(), G;
          }), q = x.cache;
          return x;
        }
        function xR(m, x) {
          var q = m[1], G = x[1], oe = q | G, Ee = oe < (w | y | L), Ne = G == L && q == _ || G == L && q == Z && m[7].length <= x[8] || G == (L | Z) && x[7].length <= x[8] && q == _;
          if (!(Ee || Ne))
            return m;
          G & w && (m[2] = x[2], oe |= q & w ? 0 : v);
          var Ke = x[3];
          if (Ke) {
            var vt = m[3];
            m[3] = vt ? Ov(vt, Ke, x[4]) : Ke, m[4] = vt ? cs(m[3], l) : x[4];
          }
          return Ke = x[5], Ke && (vt = m[5], m[5] = vt ? Tv(vt, Ke, x[6]) : Ke, m[6] = vt ? cs(m[5], l) : x[6]), Ke = x[7], Ke && (m[7] = Ke), G & L && (m[8] = m[8] == null ? x[8] : Ei(m[8], x[8])), m[9] == null && (m[9] = x[9]), m[0] = x[0], m[1] = oe, m;
        }
        function _R(m) {
          var x = [];
          if (m != null)
            for (var q in Hn(m))
              x.push(q);
          return x;
        }
        function wR(m) {
          return dp.call(m);
        }
        function Wv(m, x, q) {
          return x = ui(x === n ? m.length - 1 : x, 0), function() {
            for (var G = arguments, oe = -1, Ee = ui(G.length - x, 0), Ne = Nt(Ee); ++oe < Ee; )
              Ne[oe] = G[x + oe];
            oe = -1;
            for (var Ke = Nt(x + 1); ++oe < x; )
              Ke[oe] = G[oe];
            return Ke[x] = q(Ne), mr(m, this, Ke);
          };
        }
        function Kv(m, x) {
          return x.length < 2 ? m : Ds(m, xa(x, 0, -1));
        }
        function SR(m, x) {
          for (var q = m.length, G = Ei(x.length, q), oe = Ki(m); G--; ) {
            var Ee = x[G];
            m[G] = jo(Ee, q) ? oe[Ee] : n;
          }
          return m;
        }
        function rh(m, x) {
          if (!(x === "constructor" && typeof m[x] == "function") && x != "__proto__")
            return m[x];
        }
        var Zv = Jv(yv), Vc = NT || function(m, x) {
          return er.setTimeout(m, x);
        }, nh = Jv(GP);
        function Yv(m, x, q) {
          var G = x + "";
          return nh(m, hR(G, CR(fR(G), q)));
        }
        function Jv(m) {
          var x = 0, q = 0;
          return function() {
            var G = UT(), oe = de - (G - q);
            if (q = G, oe > 0) {
              if (++x >= X)
                return arguments[0];
            } else
              x = 0;
            return m.apply(n, arguments);
          };
        }
        function Lp(m, x) {
          var q = -1, G = m.length, oe = G - 1;
          for (x = x === n ? G : x; ++q < x; ) {
            var Ee = F1(q, oe), Ne = m[Ee];
            m[Ee] = m[q], m[q] = Ne;
          }
          return m.length = x, m;
        }
        var Qv = bR(function(m) {
          var x = [];
          return m.charCodeAt(0) === 46 && x.push(""), m.replace(ge, function(q, G, oe, Ee) {
            x.push(oe ? Ee.replace(he, "$1") : G || q);
          }), x;
        });
        function so(m) {
          if (typeof m == "string" || oa(m))
            return m;
          var x = m + "";
          return x == "0" && 1 / m == -De ? "-0" : x;
        }
        function Ls(m) {
          if (m != null) {
            try {
              return pp.call(m);
            } catch {
            }
            try {
              return m + "";
            } catch {
            }
          }
          return "";
        }
        function CR(m, x) {
          return _r(Ae, function(q) {
            var G = "_." + q[0];
            x & q[1] && !kr(m, G) && m.push(G);
          }), m.sort();
        }
        function Xv(m) {
          if (m instanceof In)
            return m.clone();
          var x = new ya(m.__wrapped__, m.__chain__);
          return x.__actions__ = Ki(m.__actions__), x.__index__ = m.__index__, x.__values__ = m.__values__, x;
        }
        function kR(m, x, q) {
          (q ? Fi(m, x, q) : x === n) ? x = 1 : x = ui(Cn(x), 0);
          var G = m == null ? 0 : m.length;
          if (!G || x < 1)
            return [];
          for (var oe = 0, Ee = 0, Ne = Nt(bp(G / x)); oe < G; )
            Ne[Ee++] = xa(m, oe, oe += x);
          return Ne;
        }
        function AR(m) {
          for (var x = -1, q = m == null ? 0 : m.length, G = 0, oe = []; ++x < q; ) {
            var Ee = m[x];
            Ee && (oe[G++] = Ee);
          }
          return oe;
        }
        function ER() {
          var m = arguments.length;
          if (!m)
            return [];
          for (var x = Nt(m - 1), q = arguments[0], G = m; G--; )
            x[G - 1] = arguments[G];
          return Qt(_n(q) ? Ki(q) : [q], ki(x, 1));
        }
        var OR = Tn(function(m, x) {
          return ti(m) ? Fc(m, ki(x, 1, ti, !0)) : [];
        }), TR = Tn(function(m, x) {
          var q = _a(x);
          return ti(q) && (q = n), ti(m) ? Fc(m, ki(x, 1, ti, !0), mn(q, 2)) : [];
        }), PR = Tn(function(m, x) {
          var q = _a(x);
          return ti(q) && (q = n), ti(m) ? Fc(m, ki(x, 1, ti, !0), n, q) : [];
        });
        function RR(m, x, q) {
          var G = m == null ? 0 : m.length;
          return G ? (x = q || x === n ? 1 : Cn(x), xa(m, x < 0 ? 0 : x, G)) : [];
        }
        function IR(m, x, q) {
          var G = m == null ? 0 : m.length;
          return G ? (x = q || x === n ? 1 : Cn(x), x = G - x, xa(m, 0, x < 0 ? 0 : x)) : [];
        }
        function jR(m, x) {
          return m && m.length ? Tp(m, mn(x, 3), !0, !0) : [];
        }
        function qR(m, x) {
          return m && m.length ? Tp(m, mn(x, 3), !0) : [];
        }
        function DR(m, x, q, G) {
          var oe = m == null ? 0 : m.length;
          return oe ? (q && typeof q != "number" && Fi(m, x, q) && (q = 0, G = oe), EP(m, x, q, G)) : [];
        }
        function ey(m, x, q) {
          var G = m == null ? 0 : m.length;
          if (!G)
            return -1;
          var oe = q == null ? 0 : Cn(q);
          return oe < 0 && (oe = ui(G + oe, 0)), un(m, mn(x, 3), oe);
        }
        function ty(m, x, q) {
          var G = m == null ? 0 : m.length;
          if (!G)
            return -1;
          var oe = G - 1;
          return q !== n && (oe = Cn(q), oe = q < 0 ? ui(G + oe, 0) : Ei(oe, G - 1)), un(m, mn(x, 3), oe, !0);
        }
        function ry(m) {
          var x = m == null ? 0 : m.length;
          return x ? ki(m, 1) : [];
        }
        function $R(m) {
          var x = m == null ? 0 : m.length;
          return x ? ki(m, De) : [];
        }
        function LR(m, x) {
          var q = m == null ? 0 : m.length;
          return q ? (x = x === n ? 1 : Cn(x), ki(m, x)) : [];
        }
        function NR(m) {
          for (var x = -1, q = m == null ? 0 : m.length, G = {}; ++x < q; ) {
            var oe = m[x];
            G[oe[0]] = oe[1];
          }
          return G;
        }
        function ny(m) {
          return m && m.length ? m[0] : n;
        }
        function FR(m, x, q) {
          var G = m == null ? 0 : m.length;
          if (!G)
            return -1;
          var oe = q == null ? 0 : Cn(q);
          return oe < 0 && (oe = ui(G + oe, 0)), An(m, x, oe);
        }
        function MR(m) {
          var x = m == null ? 0 : m.length;
          return x ? xa(m, 0, -1) : [];
        }
        var BR = Tn(function(m) {
          var x = Zt(m, z1);
          return x.length && x[0] === m[0] ? q1(x) : [];
        }), UR = Tn(function(m) {
          var x = _a(m), q = Zt(m, z1);
          return x === _a(q) ? x = n : q.pop(), q.length && q[0] === m[0] ? q1(q, mn(x, 2)) : [];
        }), HR = Tn(function(m) {
          var x = _a(m), q = Zt(m, z1);
          return x = typeof x == "function" ? x : n, x && q.pop(), q.length && q[0] === m[0] ? q1(q, n, x) : [];
        });
        function zR(m, x) {
          return m == null ? "" : MT.call(m, x);
        }
        function _a(m) {
          var x = m == null ? 0 : m.length;
          return x ? m[x - 1] : n;
        }
        function VR(m, x, q) {
          var G = m == null ? 0 : m.length;
          if (!G)
            return -1;
          var oe = G;
          return q !== n && (oe = Cn(q), oe = oe < 0 ? ui(G + oe, 0) : Ei(oe, G - 1)), x === x ? CT(m, x, oe) : un(m, Lg, oe, !0);
        }
        function GR(m, x) {
          return m && m.length ? hv(m, Cn(x)) : n;
        }
        var WR = Tn(iy);
        function iy(m, x) {
          return m && m.length && x && x.length ? N1(m, x) : m;
        }
        function KR(m, x, q) {
          return m && m.length && x && x.length ? N1(m, x, mn(q, 2)) : m;
        }
        function ZR(m, x, q) {
          return m && m.length && x && x.length ? N1(m, x, n, q) : m;
        }
        var YR = Io(function(m, x) {
          var q = m == null ? 0 : m.length, G = P1(m, x);
          return vv(m, Zt(x, function(oe) {
            return jo(oe, q) ? +oe : oe;
          }).sort(Ev)), G;
        });
        function JR(m, x) {
          var q = [];
          if (!(m && m.length))
            return q;
          var G = -1, oe = [], Ee = m.length;
          for (x = mn(x, 3); ++G < Ee; ) {
            var Ne = m[G];
            x(Ne, G, m) && (q.push(Ne), oe.push(G));
          }
          return vv(m, oe), q;
        }
        function ih(m) {
          return m == null ? m : zT.call(m);
        }
        function QR(m, x, q) {
          var G = m == null ? 0 : m.length;
          return G ? (q && typeof q != "number" && Fi(m, x, q) ? (x = 0, q = G) : (x = x == null ? 0 : Cn(x), q = q === n ? G : Cn(q)), xa(m, x, q)) : [];
        }
        function XR(m, x) {
          return Op(m, x);
        }
        function eI(m, x, q) {
          return B1(m, x, mn(q, 2));
        }
        function tI(m, x) {
          var q = m == null ? 0 : m.length;
          if (q) {
            var G = Op(m, x);
            if (G < q && Fa(m[G], x))
              return G;
          }
          return -1;
        }
        function rI(m, x) {
          return Op(m, x, !0);
        }
        function nI(m, x, q) {
          return B1(m, x, mn(q, 2), !0);
        }
        function iI(m, x) {
          var q = m == null ? 0 : m.length;
          if (q) {
            var G = Op(m, x, !0) - 1;
            if (Fa(m[G], x))
              return G;
          }
          return -1;
        }
        function aI(m) {
          return m && m.length ? bv(m) : [];
        }
        function oI(m, x) {
          return m && m.length ? bv(m, mn(x, 2)) : [];
        }
        function sI(m) {
          var x = m == null ? 0 : m.length;
          return x ? xa(m, 1, x) : [];
        }
        function uI(m, x, q) {
          return m && m.length ? (x = q || x === n ? 1 : Cn(x), xa(m, 0, x < 0 ? 0 : x)) : [];
        }
        function cI(m, x, q) {
          var G = m == null ? 0 : m.length;
          return G ? (x = q || x === n ? 1 : Cn(x), x = G - x, xa(m, x < 0 ? 0 : x, G)) : [];
        }
        function lI(m, x) {
          return m && m.length ? Tp(m, mn(x, 3), !1, !0) : [];
        }
        function fI(m, x) {
          return m && m.length ? Tp(m, mn(x, 3)) : [];
        }
        var pI = Tn(function(m) {
          return ps(ki(m, 1, ti, !0));
        }), dI = Tn(function(m) {
          var x = _a(m);
          return ti(x) && (x = n), ps(ki(m, 1, ti, !0), mn(x, 2));
        }), hI = Tn(function(m) {
          var x = _a(m);
          return x = typeof x == "function" ? x : n, ps(ki(m, 1, ti, !0), n, x);
        });
        function mI(m) {
          return m && m.length ? ps(m) : [];
        }
        function gI(m, x) {
          return m && m.length ? ps(m, mn(x, 2)) : [];
        }
        function vI(m, x) {
          return x = typeof x == "function" ? x : n, m && m.length ? ps(m, n, x) : [];
        }
        function ah(m) {
          if (!(m && m.length))
            return [];
          var x = 0;
          return m = Jt(m, function(q) {
            if (ti(q))
              return x = ui(q.length, x), !0;
          }), w1(x, function(q) {
            return Zt(m, b1(q));
          });
        }
        function ay(m, x) {
          if (!(m && m.length))
            return [];
          var q = ah(m);
          return x == null ? q : Zt(q, function(G) {
            return mr(x, n, G);
          });
        }
        var yI = Tn(function(m, x) {
          return ti(m) ? Fc(m, x) : [];
        }), bI = Tn(function(m) {
          return H1(Jt(m, ti));
        }), xI = Tn(function(m) {
          var x = _a(m);
          return ti(x) && (x = n), H1(Jt(m, ti), mn(x, 2));
        }), _I = Tn(function(m) {
          var x = _a(m);
          return x = typeof x == "function" ? x : n, H1(Jt(m, ti), n, x);
        }), wI = Tn(ah);
        function SI(m, x) {
          return Sv(m || [], x || [], Nc);
        }
        function CI(m, x) {
          return Sv(m || [], x || [], Uc);
        }
        var kI = Tn(function(m) {
          var x = m.length, q = x > 1 ? m[x - 1] : n;
          return q = typeof q == "function" ? (m.pop(), q) : n, ay(m, q);
        });
        function oy(m) {
          var x = Se(m);
          return x.__chain__ = !0, x;
        }
        function AI(m, x) {
          return x(m), m;
        }
        function Np(m, x) {
          return x(m);
        }
        var EI = Io(function(m) {
          var x = m.length, q = x ? m[0] : 0, G = this.__wrapped__, oe = function(Ee) {
            return P1(Ee, m);
          };
          return x > 1 || this.__actions__.length || !(G instanceof In) || !jo(q) ? this.thru(oe) : (G = G.slice(q, +q + (x ? 1 : 0)), G.__actions__.push({
            func: Np,
            args: [oe],
            thisArg: n
          }), new ya(G, this.__chain__).thru(function(Ee) {
            return x && !Ee.length && Ee.push(n), Ee;
          }));
        });
        function OI() {
          return oy(this);
        }
        function TI() {
          return new ya(this.value(), this.__chain__);
        }
        function PI() {
          this.__values__ === n && (this.__values__ = xy(this.value()));
          var m = this.__index__ >= this.__values__.length, x = m ? n : this.__values__[this.__index__++];
          return { done: m, value: x };
        }
        function RI() {
          return this;
        }
        function II(m) {
          for (var x, q = this; q instanceof Sp; ) {
            var G = Xv(q);
            G.__index__ = 0, G.__values__ = n, x ? oe.__wrapped__ = G : x = G;
            var oe = G;
            q = q.__wrapped__;
          }
          return oe.__wrapped__ = m, x;
        }
        function jI() {
          var m = this.__wrapped__;
          if (m instanceof In) {
            var x = m;
            return this.__actions__.length && (x = new In(this)), x = x.reverse(), x.__actions__.push({
              func: Np,
              args: [ih],
              thisArg: n
            }), new ya(x, this.__chain__);
          }
          return this.thru(ih);
        }
        function qI() {
          return wv(this.__wrapped__, this.__actions__);
        }
        var DI = Pp(function(m, x, q) {
          Fn.call(m, q) ? ++m[q] : Po(m, q, 1);
        });
        function $I(m, x, q) {
          var G = _n(m) ? jr : AP;
          return q && Fi(m, x, q) && (x = n), G(m, mn(x, 3));
        }
        function LI(m, x) {
          var q = _n(m) ? Jt : av;
          return q(m, mn(x, 3));
        }
        var NI = jv(ey), FI = jv(ty);
        function MI(m, x) {
          return ki(Fp(m, x), 1);
        }
        function BI(m, x) {
          return ki(Fp(m, x), De);
        }
        function UI(m, x, q) {
          return q = q === n ? 1 : Cn(q), ki(Fp(m, x), q);
        }
        function sy(m, x) {
          var q = _n(m) ? _r : fs;
          return q(m, mn(x, 3));
        }
        function uy(m, x) {
          var q = _n(m) ? vr : iv;
          return q(m, mn(x, 3));
        }
        var HI = Pp(function(m, x, q) {
          Fn.call(m, q) ? m[q].push(x) : Po(m, q, [x]);
        });
        function zI(m, x, q, G) {
          m = Zi(m) ? m : zu(m), q = q && !G ? Cn(q) : 0;
          var oe = m.length;
          return q < 0 && (q = ui(oe + q, 0)), zp(m) ? q <= oe && m.indexOf(x, q) > -1 : !!oe && An(m, x, q) > -1;
        }
        var VI = Tn(function(m, x, q) {
          var G = -1, oe = typeof x == "function", Ee = Zi(m) ? Nt(m.length) : [];
          return fs(m, function(Ne) {
            Ee[++G] = oe ? mr(x, Ne, q) : Mc(Ne, x, q);
          }), Ee;
        }), GI = Pp(function(m, x, q) {
          Po(m, q, x);
        });
        function Fp(m, x) {
          var q = _n(m) ? Zt : fv;
          return q(m, mn(x, 3));
        }
        function WI(m, x, q, G) {
          return m == null ? [] : (_n(x) || (x = x == null ? [] : [x]), q = G ? n : q, _n(q) || (q = q == null ? [] : [q]), mv(m, x, q));
        }
        var KI = Pp(function(m, x, q) {
          m[q ? 0 : 1].push(x);
        }, function() {
          return [[], []];
        });
        function ZI(m, x, q) {
          var G = _n(m) ? Er : Fg, oe = arguments.length < 3;
          return G(m, mn(x, 4), q, oe, fs);
        }
        function YI(m, x, q) {
          var G = _n(m) ? yr : Fg, oe = arguments.length < 3;
          return G(m, mn(x, 4), q, oe, iv);
        }
        function JI(m, x) {
          var q = _n(m) ? Jt : av;
          return q(m, Up(mn(x, 3)));
        }
        function QI(m) {
          var x = _n(m) ? ev : zP;
          return x(m);
        }
        function XI(m, x, q) {
          (q ? Fi(m, x, q) : x === n) ? x = 1 : x = Cn(x);
          var G = _n(m) ? _P : VP;
          return G(m, x);
        }
        function ej(m) {
          var x = _n(m) ? wP : WP;
          return x(m);
        }
        function tj(m) {
          if (m == null)
            return 0;
          if (Zi(m))
            return zp(m) ? qu(m) : m.length;
          var x = Oi(m);
          return x == Rt || x == $ ? m.size : $1(m).length;
        }
        function rj(m, x, q) {
          var G = _n(m) ? Or : KP;
          return q && Fi(m, x, q) && (x = n), G(m, mn(x, 3));
        }
        var nj = Tn(function(m, x) {
          if (m == null)
            return [];
          var q = x.length;
          return q > 1 && Fi(m, x[0], x[1]) ? x = [] : q > 2 && Fi(x[0], x[1], x[2]) && (x = [x[0]]), mv(m, ki(x, 1), []);
        }), Mp = LT || function() {
          return er.Date.now();
        };
        function ij(m, x) {
          if (typeof x != "function")
            throw new va(o);
          return m = Cn(m), function() {
            if (--m < 1)
              return x.apply(this, arguments);
          };
        }
        function cy(m, x, q) {
          return x = q ? n : x, x = m && x == null ? m.length : x, Ro(m, L, n, n, n, n, x);
        }
        function ly(m, x) {
          var q;
          if (typeof x != "function")
            throw new va(o);
          return m = Cn(m), function() {
            return --m > 0 && (q = x.apply(this, arguments)), m <= 1 && (x = n), q;
          };
        }
        var oh = Tn(function(m, x, q) {
          var G = w;
          if (q.length) {
            var oe = cs(q, Uu(oh));
            G |= O;
          }
          return Ro(m, G, x, q, oe);
        }), fy = Tn(function(m, x, q) {
          var G = w | y;
          if (q.length) {
            var oe = cs(q, Uu(fy));
            G |= O;
          }
          return Ro(x, G, m, q, oe);
        });
        function py(m, x, q) {
          x = q ? n : x;
          var G = Ro(m, _, n, n, n, n, n, x);
          return G.placeholder = py.placeholder, G;
        }
        function dy(m, x, q) {
          x = q ? n : x;
          var G = Ro(m, E, n, n, n, n, n, x);
          return G.placeholder = dy.placeholder, G;
        }
        function hy(m, x, q) {
          var G, oe, Ee, Ne, Ke, vt, zt = 0, Vt = !1, tr = !1, sn = !0;
          if (typeof m != "function")
            throw new va(o);
          x = wa(x) || 0, Yn(q) && (Vt = !!q.leading, tr = "maxWait" in q, Ee = tr ? ui(wa(q.maxWait) || 0, x) : Ee, sn = "trailing" in q ? !!q.trailing : sn);
          function dn(ri) {
            var Ma = G, $o = oe;
            return G = oe = n, zt = ri, Ne = m.apply($o, Ma), Ne;
          }
          function vn(ri) {
            return zt = ri, Ke = Vc(Rn, x), Vt ? dn(ri) : Ne;
          }
          function En(ri) {
            var Ma = ri - vt, $o = ri - zt, jy = x - Ma;
            return tr ? Ei(jy, Ee - $o) : jy;
          }
          function yn(ri) {
            var Ma = ri - vt, $o = ri - zt;
            return vt === n || Ma >= x || Ma < 0 || tr && $o >= Ee;
          }
          function Rn() {
            var ri = Mp();
            if (yn(ri))
              return jn(ri);
            Ke = Vc(Rn, En(ri));
          }
          function jn(ri) {
            return Ke = n, sn && G ? dn(ri) : (G = oe = n, Ne);
          }
          function sa() {
            Ke !== n && Cv(Ke), zt = 0, G = vt = oe = Ke = n;
          }
          function Mi() {
            return Ke === n ? Ne : jn(Mp());
          }
          function ua() {
            var ri = Mp(), Ma = yn(ri);
            if (G = arguments, oe = this, vt = ri, Ma) {
              if (Ke === n)
                return vn(vt);
              if (tr)
                return Cv(Ke), Ke = Vc(Rn, x), dn(vt);
            }
            return Ke === n && (Ke = Vc(Rn, x)), Ne;
          }
          return ua.cancel = sa, ua.flush = Mi, ua;
        }
        var aj = Tn(function(m, x) {
          return nv(m, 1, x);
        }), oj = Tn(function(m, x, q) {
          return nv(m, wa(x) || 0, q);
        });
        function sj(m) {
          return Ro(m, Q);
        }
        function Bp(m, x) {
          if (typeof m != "function" || x != null && typeof x != "function")
            throw new va(o);
          var q = function() {
            var G = arguments, oe = x ? x.apply(this, G) : G[0], Ee = q.cache;
            if (Ee.has(oe))
              return Ee.get(oe);
            var Ne = m.apply(this, G);
            return q.cache = Ee.set(oe, Ne) || Ee, Ne;
          };
          return q.cache = new (Bp.Cache || To)(), q;
        }
        Bp.Cache = To;
        function Up(m) {
          if (typeof m != "function")
            throw new va(o);
          return function() {
            var x = arguments;
            switch (x.length) {
              case 0:
                return !m.call(this);
              case 1:
                return !m.call(this, x[0]);
              case 2:
                return !m.call(this, x[0], x[1]);
              case 3:
                return !m.call(this, x[0], x[1], x[2]);
            }
            return !m.apply(this, x);
          };
        }
        function uj(m) {
          return ly(2, m);
        }
        var cj = ZP(function(m, x) {
          x = x.length == 1 && _n(x[0]) ? Zt(x[0], ia(mn())) : Zt(ki(x, 1), ia(mn()));
          var q = x.length;
          return Tn(function(G) {
            for (var oe = -1, Ee = Ei(G.length, q); ++oe < Ee; )
              G[oe] = x[oe].call(this, G[oe]);
            return mr(m, this, G);
          });
        }), sh = Tn(function(m, x) {
          var q = cs(x, Uu(sh));
          return Ro(m, O, n, x, q);
        }), my = Tn(function(m, x) {
          var q = cs(x, Uu(my));
          return Ro(m, M, n, x, q);
        }), lj = Io(function(m, x) {
          return Ro(m, Z, n, n, n, x);
        });
        function fj(m, x) {
          if (typeof m != "function")
            throw new va(o);
          return x = x === n ? x : Cn(x), Tn(m, x);
        }
        function pj(m, x) {
          if (typeof m != "function")
            throw new va(o);
          return x = x == null ? 0 : ui(Cn(x), 0), Tn(function(q) {
            var G = q[x], oe = hs(q, 0, x);
            return G && Qt(oe, G), mr(m, this, oe);
          });
        }
        function dj(m, x, q) {
          var G = !0, oe = !0;
          if (typeof m != "function")
            throw new va(o);
          return Yn(q) && (G = "leading" in q ? !!q.leading : G, oe = "trailing" in q ? !!q.trailing : oe), hy(m, x, {
            leading: G,
            maxWait: x,
            trailing: oe
          });
        }
        function hj(m) {
          return cy(m, 1);
        }
        function mj(m, x) {
          return sh(V1(x), m);
        }
        function gj() {
          if (!arguments.length)
            return [];
          var m = arguments[0];
          return _n(m) ? m : [m];
        }
        function vj(m) {
          return ba(m, p);
        }
        function yj(m, x) {
          return x = typeof x == "function" ? x : n, ba(m, p, x);
        }
        function bj(m) {
          return ba(m, d | p);
        }
        function xj(m, x) {
          return x = typeof x == "function" ? x : n, ba(m, d | p, x);
        }
        function _j(m, x) {
          return x == null || rv(m, x, hi(x));
        }
        function Fa(m, x) {
          return m === x || m !== m && x !== x;
        }
        var wj = qp(j1), Sj = qp(function(m, x) {
          return m >= x;
        }), Ns = uv(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? uv : function(m) {
          return Qn(m) && Fn.call(m, "callee") && !Kg.call(m, "callee");
        }, _n = Nt.isArray, Cj = Pr ? ia(Pr) : IP;
        function Zi(m) {
          return m != null && Hp(m.length) && !qo(m);
        }
        function ti(m) {
          return Qn(m) && Zi(m);
        }
        function kj(m) {
          return m === !0 || m === !1 || Qn(m) && Ni(m) == At;
        }
        var ms = FT || yh, Aj = or ? ia(or) : jP;
        function Ej(m) {
          return Qn(m) && m.nodeType === 1 && !Gc(m);
        }
        function Oj(m) {
          if (m == null)
            return !0;
          if (Zi(m) && (_n(m) || typeof m == "string" || typeof m.splice == "function" || ms(m) || Hu(m) || Ns(m)))
            return !m.length;
          var x = Oi(m);
          if (x == Rt || x == $)
            return !m.size;
          if (zc(m))
            return !$1(m).length;
          for (var q in m)
            if (Fn.call(m, q))
              return !1;
          return !0;
        }
        function Tj(m, x) {
          return Bc(m, x);
        }
        function Pj(m, x, q) {
          q = typeof q == "function" ? q : n;
          var G = q ? q(m, x) : n;
          return G === n ? Bc(m, x, n, q) : !!G;
        }
        function uh(m) {
          if (!Qn(m))
            return !1;
          var x = Ni(m);
          return x == Fe || x == Dt || typeof m.message == "string" && typeof m.name == "string" && !Gc(m);
        }
        function Rj(m) {
          return typeof m == "number" && Yg(m);
        }
        function qo(m) {
          if (!Yn(m))
            return !1;
          var x = Ni(m);
          return x == Xe || x == ze || x == Ze || x == ie;
        }
        function gy(m) {
          return typeof m == "number" && m == Cn(m);
        }
        function Hp(m) {
          return typeof m == "number" && m > -1 && m % 1 == 0 && m <= je;
        }
        function Yn(m) {
          var x = typeof m;
          return m != null && (x == "object" || x == "function");
        }
        function Qn(m) {
          return m != null && typeof m == "object";
        }
        var vy = Rr ? ia(Rr) : DP;
        function Ij(m, x) {
          return m === x || D1(m, x, Q1(x));
        }
        function jj(m, x, q) {
          return q = typeof q == "function" ? q : n, D1(m, x, Q1(x), q);
        }
        function qj(m) {
          return yy(m) && m != +m;
        }
        function Dj(m) {
          if (yR(m))
            throw new xn(a);
          return cv(m);
        }
        function $j(m) {
          return m === null;
        }
        function Lj(m) {
          return m == null;
        }
        function yy(m) {
          return typeof m == "number" || Qn(m) && Ni(m) == Yt;
        }
        function Gc(m) {
          if (!Qn(m) || Ni(m) != W)
            return !1;
          var x = gp(m);
          if (x === null)
            return !0;
          var q = Fn.call(x, "constructor") && x.constructor;
          return typeof q == "function" && q instanceof q && pp.call(q) == jT;
        }
        var ch = sr ? ia(sr) : $P;
        function Nj(m) {
          return gy(m) && m >= -je && m <= je;
        }
        var by = Ir ? ia(Ir) : LP;
        function zp(m) {
          return typeof m == "string" || !_n(m) && Qn(m) && Ni(m) == _e;
        }
        function oa(m) {
          return typeof m == "symbol" || Qn(m) && Ni(m) == Le;
        }
        var Hu = ur ? ia(ur) : NP;
        function Fj(m) {
          return m === n;
        }
        function Mj(m) {
          return Qn(m) && Oi(m) == Ge;
        }
        function Bj(m) {
          return Qn(m) && Ni(m) == $t;
        }
        var Uj = qp(L1), Hj = qp(function(m, x) {
          return m <= x;
        });
        function xy(m) {
          if (!m)
            return [];
          if (Zi(m))
            return zp(m) ? La(m) : Ki(m);
          if (jc && m[jc])
            return _T(m[jc]());
          var x = Oi(m), q = x == Rt ? C1 : x == $ ? cp : zu;
          return q(m);
        }
        function Do(m) {
          if (!m)
            return m === 0 ? m : 0;
          if (m = wa(m), m === De || m === -De) {
            var x = m < 0 ? -1 : 1;
            return x * Me;
          }
          return m === m ? m : 0;
        }
        function Cn(m) {
          var x = Do(m), q = x % 1;
          return x === x ? q ? x - q : x : 0;
        }
        function _y(m) {
          return m ? qs(Cn(m), 0, Ve) : 0;
        }
        function wa(m) {
          if (typeof m == "number")
            return m;
          if (oa(m))
            return qe;
          if (Yn(m)) {
            var x = typeof m.valueOf == "function" ? m.valueOf() : m;
            m = Yn(x) ? x + "" : x;
          }
          if (typeof m != "string")
            return m === 0 ? m : +m;
          m = Mg(m);
          var q = $e.test(m);
          return q || yt.test(m) ? dr(m.slice(2), q ? 2 : 8) : Pe.test(m) ? qe : +m;
        }
        function wy(m) {
          return oo(m, Yi(m));
        }
        function zj(m) {
          return m ? qs(Cn(m), -je, je) : m === 0 ? m : 0;
        }
        function Nn(m) {
          return m == null ? "" : aa(m);
        }
        var Vj = Mu(function(m, x) {
          if (zc(x) || Zi(x)) {
            oo(x, hi(x), m);
            return;
          }
          for (var q in x)
            Fn.call(x, q) && Nc(m, q, x[q]);
        }), Sy = Mu(function(m, x) {
          oo(x, Yi(x), m);
        }), Vp = Mu(function(m, x, q, G) {
          oo(x, Yi(x), m, G);
        }), Gj = Mu(function(m, x, q, G) {
          oo(x, hi(x), m, G);
        }), Wj = Io(P1);
        function Kj(m, x) {
          var q = Fu(m);
          return x == null ? q : tv(q, x);
        }
        var Zj = Tn(function(m, x) {
          m = Hn(m);
          var q = -1, G = x.length, oe = G > 2 ? x[2] : n;
          for (oe && Fi(x[0], x[1], oe) && (G = 1); ++q < G; )
            for (var Ee = x[q], Ne = Yi(Ee), Ke = -1, vt = Ne.length; ++Ke < vt; ) {
              var zt = Ne[Ke], Vt = m[zt];
              (Vt === n || Fa(Vt, $u[zt]) && !Fn.call(m, zt)) && (m[zt] = Ee[zt]);
            }
          return m;
        }), Yj = Tn(function(m) {
          return m.push(n, Mv), mr(Cy, n, m);
        });
        function Jj(m, x) {
          return ln(m, mn(x, 3), ao);
        }
        function Qj(m, x) {
          return ln(m, mn(x, 3), I1);
        }
        function Xj(m, x) {
          return m == null ? m : R1(m, mn(x, 3), Yi);
        }
        function eq(m, x) {
          return m == null ? m : ov(m, mn(x, 3), Yi);
        }
        function tq(m, x) {
          return m && ao(m, mn(x, 3));
        }
        function rq(m, x) {
          return m && I1(m, mn(x, 3));
        }
        function nq(m) {
          return m == null ? [] : Ap(m, hi(m));
        }
        function iq(m) {
          return m == null ? [] : Ap(m, Yi(m));
        }
        function lh(m, x, q) {
          var G = m == null ? n : Ds(m, x);
          return G === n ? q : G;
        }
        function aq(m, x) {
          return m != null && Hv(m, x, OP);
        }
        function fh(m, x) {
          return m != null && Hv(m, x, TP);
        }
        var oq = Dv(function(m, x, q) {
          x != null && typeof x.toString != "function" && (x = dp.call(x)), m[x] = q;
        }, dh(Ji)), sq = Dv(function(m, x, q) {
          x != null && typeof x.toString != "function" && (x = dp.call(x)), Fn.call(m, x) ? m[x].push(q) : m[x] = [q];
        }, mn), uq = Tn(Mc);
        function hi(m) {
          return Zi(m) ? Xg(m) : $1(m);
        }
        function Yi(m) {
          return Zi(m) ? Xg(m, !0) : FP(m);
        }
        function cq(m, x) {
          var q = {};
          return x = mn(x, 3), ao(m, function(G, oe, Ee) {
            Po(q, x(G, oe, Ee), G);
          }), q;
        }
        function lq(m, x) {
          var q = {};
          return x = mn(x, 3), ao(m, function(G, oe, Ee) {
            Po(q, oe, x(G, oe, Ee));
          }), q;
        }
        var fq = Mu(function(m, x, q) {
          Ep(m, x, q);
        }), Cy = Mu(function(m, x, q, G) {
          Ep(m, x, q, G);
        }), pq = Io(function(m, x) {
          var q = {};
          if (m == null)
            return q;
          var G = !1;
          x = Zt(x, function(Ee) {
            return Ee = ds(Ee, m), G || (G = Ee.length > 1), Ee;
          }), oo(m, Y1(m), q), G && (q = ba(q, d | f | p, oR));
          for (var oe = x.length; oe--; )
            U1(q, x[oe]);
          return q;
        });
        function dq(m, x) {
          return ky(m, Up(mn(x)));
        }
        var hq = Io(function(m, x) {
          return m == null ? {} : BP(m, x);
        });
        function ky(m, x) {
          if (m == null)
            return {};
          var q = Zt(Y1(m), function(G) {
            return [G];
          });
          return x = mn(x), gv(m, q, function(G, oe) {
            return x(G, oe[0]);
          });
        }
        function mq(m, x, q) {
          x = ds(x, m);
          var G = -1, oe = x.length;
          for (oe || (oe = 1, m = n); ++G < oe; ) {
            var Ee = m == null ? n : m[so(x[G])];
            Ee === n && (G = oe, Ee = q), m = qo(Ee) ? Ee.call(m) : Ee;
          }
          return m;
        }
        function gq(m, x, q) {
          return m == null ? m : Uc(m, x, q);
        }
        function vq(m, x, q, G) {
          return G = typeof G == "function" ? G : n, m == null ? m : Uc(m, x, q, G);
        }
        var Ay = Nv(hi), Ey = Nv(Yi);
        function yq(m, x, q) {
          var G = _n(m), oe = G || ms(m) || Hu(m);
          if (x = mn(x, 4), q == null) {
            var Ee = m && m.constructor;
            oe ? q = G ? new Ee() : [] : Yn(m) ? q = qo(Ee) ? Fu(gp(m)) : {} : q = {};
          }
          return (oe ? _r : ao)(m, function(Ne, Ke, vt) {
            return x(q, Ne, Ke, vt);
          }), q;
        }
        function bq(m, x) {
          return m == null ? !0 : U1(m, x);
        }
        function xq(m, x, q) {
          return m == null ? m : _v(m, x, V1(q));
        }
        function _q(m, x, q, G) {
          return G = typeof G == "function" ? G : n, m == null ? m : _v(m, x, V1(q), G);
        }
        function zu(m) {
          return m == null ? [] : S1(m, hi(m));
        }
        function wq(m) {
          return m == null ? [] : S1(m, Yi(m));
        }
        function Sq(m, x, q) {
          return q === n && (q = x, x = n), q !== n && (q = wa(q), q = q === q ? q : 0), x !== n && (x = wa(x), x = x === x ? x : 0), qs(wa(m), x, q);
        }
        function Cq(m, x, q) {
          return x = Do(x), q === n ? (q = x, x = 0) : q = Do(q), m = wa(m), PP(m, x, q);
        }
        function kq(m, x, q) {
          if (q && typeof q != "boolean" && Fi(m, x, q) && (x = q = n), q === n && (typeof x == "boolean" ? (q = x, x = n) : typeof m == "boolean" && (q = m, m = n)), m === n && x === n ? (m = 0, x = 1) : (m = Do(m), x === n ? (x = m, m = 0) : x = Do(x)), m > x) {
            var G = m;
            m = x, x = G;
          }
          if (q || m % 1 || x % 1) {
            var oe = Jg();
            return Ei(m + oe * (x - m + Fr("1e-" + ((oe + "").length - 1))), x);
          }
          return F1(m, x);
        }
        var Aq = Bu(function(m, x, q) {
          return x = x.toLowerCase(), m + (q ? Oy(x) : x);
        });
        function Oy(m) {
          return ph(Nn(m).toLowerCase());
        }
        function Ty(m) {
          return m = Nn(m), m && m.replace(bt, gT).replace(Zr, "");
        }
        function Eq(m, x, q) {
          m = Nn(m), x = aa(x);
          var G = m.length;
          q = q === n ? G : qs(Cn(q), 0, G);
          var oe = q;
          return q -= x.length, q >= 0 && m.slice(q, oe) == x;
        }
        function Oq(m) {
          return m = Nn(m), m && D.test(m) ? m.replace(K, vT) : m;
        }
        function Tq(m) {
          return m = Nn(m), m && se.test(m) ? m.replace(pe, "\\$&") : m;
        }
        var Pq = Bu(function(m, x, q) {
          return m + (q ? "-" : "") + x.toLowerCase();
        }), Rq = Bu(function(m, x, q) {
          return m + (q ? " " : "") + x.toLowerCase();
        }), Iq = Iv("toLowerCase");
        function jq(m, x, q) {
          m = Nn(m), x = Cn(x);
          var G = x ? qu(m) : 0;
          if (!x || G >= x)
            return m;
          var oe = (x - G) / 2;
          return jp(xp(oe), q) + m + jp(bp(oe), q);
        }
        function qq(m, x, q) {
          m = Nn(m), x = Cn(x);
          var G = x ? qu(m) : 0;
          return x && G < x ? m + jp(x - G, q) : m;
        }
        function Dq(m, x, q) {
          m = Nn(m), x = Cn(x);
          var G = x ? qu(m) : 0;
          return x && G < x ? jp(x - G, q) + m : m;
        }
        function $q(m, x, q) {
          return q || x == null ? x = 0 : x && (x = +x), HT(Nn(m).replace(ce, ""), x || 0);
        }
        function Lq(m, x, q) {
          return (q ? Fi(m, x, q) : x === n) ? x = 1 : x = Cn(x), M1(Nn(m), x);
        }
        function Nq() {
          var m = arguments, x = Nn(m[0]);
          return m.length < 3 ? x : x.replace(m[1], m[2]);
        }
        var Fq = Bu(function(m, x, q) {
          return m + (q ? "_" : "") + x.toLowerCase();
        });
        function Mq(m, x, q) {
          return q && typeof q != "number" && Fi(m, x, q) && (x = q = n), q = q === n ? Ve : q >>> 0, q ? (m = Nn(m), m && (typeof x == "string" || x != null && !ch(x)) && (x = aa(x), !x && ju(m)) ? hs(La(m), 0, q) : m.split(x, q)) : [];
        }
        var Bq = Bu(function(m, x, q) {
          return m + (q ? " " : "") + ph(x);
        });
        function Uq(m, x, q) {
          return m = Nn(m), q = q == null ? 0 : qs(Cn(q), 0, m.length), x = aa(x), m.slice(q, q + x.length) == x;
        }
        function Hq(m, x, q) {
          var G = Se.templateSettings;
          q && Fi(m, x, q) && (x = n), m = Nn(m), x = Vp({}, x, G, Fv);
          var oe = Vp({}, x.imports, G.imports, Fv), Ee = hi(oe), Ne = S1(oe, Ee), Ke, vt, zt = 0, Vt = x.interpolate || ft, tr = "__p += '", sn = k1(
            (x.escape || ft).source + "|" + Vt.source + "|" + (Vt === V ? we : ft).source + "|" + (x.evaluate || ft).source + "|$",
            "g"
          ), dn = "//# sourceURL=" + (Fn.call(x, "sourceURL") ? (x.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++lr + "]") + `
`;
          m.replace(sn, function(yn, Rn, jn, sa, Mi, ua) {
            return jn || (jn = sa), tr += m.slice(zt, ua).replace(xt, yT), Rn && (Ke = !0, tr += `' +
__e(` + Rn + `) +
'`), Mi && (vt = !0, tr += `';
` + Mi + `;
__p += '`), jn && (tr += `' +
((__t = (` + jn + `)) == null ? '' : __t) +
'`), zt = ua + yn.length, yn;
          }), tr += `';
`;
          var vn = Fn.call(x, "variable") && x.variable;
          if (!vn)
            tr = `with (obj) {
` + tr + `
}
`;
          else if (le.test(vn))
            throw new xn(c);
          tr = (vt ? tr.replace(A, "") : tr).replace(I, "$1").replace(z, "$1;"), tr = "function(" + (vn || "obj") + `) {
` + (vn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Ke ? ", __e = _.escape" : "") + (vt ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + tr + `return __p
}`;
          var En = Ry(function() {
            return $n(Ee, dn + "return " + tr).apply(n, Ne);
          });
          if (En.source = tr, uh(En))
            throw En;
          return En;
        }
        function zq(m) {
          return Nn(m).toLowerCase();
        }
        function Vq(m) {
          return Nn(m).toUpperCase();
        }
        function Gq(m, x, q) {
          if (m = Nn(m), m && (q || x === n))
            return Mg(m);
          if (!m || !(x = aa(x)))
            return m;
          var G = La(m), oe = La(x), Ee = Bg(G, oe), Ne = Ug(G, oe) + 1;
          return hs(G, Ee, Ne).join("");
        }
        function Wq(m, x, q) {
          if (m = Nn(m), m && (q || x === n))
            return m.slice(0, zg(m) + 1);
          if (!m || !(x = aa(x)))
            return m;
          var G = La(m), oe = Ug(G, La(x)) + 1;
          return hs(G, 0, oe).join("");
        }
        function Kq(m, x, q) {
          if (m = Nn(m), m && (q || x === n))
            return m.replace(ce, "");
          if (!m || !(x = aa(x)))
            return m;
          var G = La(m), oe = Bg(G, La(x));
          return hs(G, oe).join("");
        }
        function Zq(m, x) {
          var q = ae, G = re;
          if (Yn(x)) {
            var oe = "separator" in x ? x.separator : oe;
            q = "length" in x ? Cn(x.length) : q, G = "omission" in x ? aa(x.omission) : G;
          }
          m = Nn(m);
          var Ee = m.length;
          if (ju(m)) {
            var Ne = La(m);
            Ee = Ne.length;
          }
          if (q >= Ee)
            return m;
          var Ke = q - qu(G);
          if (Ke < 1)
            return G;
          var vt = Ne ? hs(Ne, 0, Ke).join("") : m.slice(0, Ke);
          if (oe === n)
            return vt + G;
          if (Ne && (Ke += vt.length - Ke), ch(oe)) {
            if (m.slice(Ke).search(oe)) {
              var zt, Vt = vt;
              for (oe.global || (oe = k1(oe.source, Nn(Re.exec(oe)) + "g")), oe.lastIndex = 0; zt = oe.exec(Vt); )
                var tr = zt.index;
              vt = vt.slice(0, tr === n ? Ke : tr);
            }
          } else if (m.indexOf(aa(oe), Ke) != Ke) {
            var sn = vt.lastIndexOf(oe);
            sn > -1 && (vt = vt.slice(0, sn));
          }
          return vt + G;
        }
        function Yq(m) {
          return m = Nn(m), m && U.test(m) ? m.replace(H, kT) : m;
        }
        var Jq = Bu(function(m, x, q) {
          return m + (q ? " " : "") + x.toUpperCase();
        }), ph = Iv("toUpperCase");
        function Py(m, x, q) {
          return m = Nn(m), x = q ? n : x, x === n ? xT(m) ? OT(m) : xr(m) : m.match(x) || [];
        }
        var Ry = Tn(function(m, x) {
          try {
            return mr(m, n, x);
          } catch (q) {
            return uh(q) ? q : new xn(q);
          }
        }), Qq = Io(function(m, x) {
          return _r(x, function(q) {
            q = so(q), Po(m, q, oh(m[q], m));
          }), m;
        });
        function Xq(m) {
          var x = m == null ? 0 : m.length, q = mn();
          return m = x ? Zt(m, function(G) {
            if (typeof G[1] != "function")
              throw new va(o);
            return [q(G[0]), G[1]];
          }) : [], Tn(function(G) {
            for (var oe = -1; ++oe < x; ) {
              var Ee = m[oe];
              if (mr(Ee[0], this, G))
                return mr(Ee[1], this, G);
            }
          });
        }
        function eD(m) {
          return kP(ba(m, d));
        }
        function dh(m) {
          return function() {
            return m;
          };
        }
        function tD(m, x) {
          return m == null || m !== m ? x : m;
        }
        var rD = qv(), nD = qv(!0);
        function Ji(m) {
          return m;
        }
        function hh(m) {
          return lv(typeof m == "function" ? m : ba(m, d));
        }
        function iD(m) {
          return pv(ba(m, d));
        }
        function aD(m, x) {
          return dv(m, ba(x, d));
        }
        var oD = Tn(function(m, x) {
          return function(q) {
            return Mc(q, m, x);
          };
        }), sD = Tn(function(m, x) {
          return function(q) {
            return Mc(m, q, x);
          };
        });
        function mh(m, x, q) {
          var G = hi(x), oe = Ap(x, G);
          q == null && !(Yn(x) && (oe.length || !G.length)) && (q = x, x = m, m = this, oe = Ap(x, hi(x)));
          var Ee = !(Yn(q) && "chain" in q) || !!q.chain, Ne = qo(m);
          return _r(oe, function(Ke) {
            var vt = x[Ke];
            m[Ke] = vt, Ne && (m.prototype[Ke] = function() {
              var zt = this.__chain__;
              if (Ee || zt) {
                var Vt = m(this.__wrapped__), tr = Vt.__actions__ = Ki(this.__actions__);
                return tr.push({ func: vt, args: arguments, thisArg: m }), Vt.__chain__ = zt, Vt;
              }
              return vt.apply(m, Qt([this.value()], arguments));
            });
          }), m;
        }
        function uD() {
          return er._ === this && (er._ = qT), this;
        }
        function gh() {
        }
        function cD(m) {
          return m = Cn(m), Tn(function(x) {
            return hv(x, m);
          });
        }
        var lD = W1(Zt), fD = W1(jr), pD = W1(Or);
        function Iy(m) {
          return eh(m) ? b1(so(m)) : UP(m);
        }
        function dD(m) {
          return function(x) {
            return m == null ? n : Ds(m, x);
          };
        }
        var hD = $v(), mD = $v(!0);
        function vh() {
          return [];
        }
        function yh() {
          return !1;
        }
        function gD() {
          return {};
        }
        function vD() {
          return "";
        }
        function yD() {
          return !0;
        }
        function bD(m, x) {
          if (m = Cn(m), m < 1 || m > je)
            return [];
          var q = Ve, G = Ei(m, Ve);
          x = mn(x), m -= Ve;
          for (var oe = w1(G, x); ++q < m; )
            x(q);
          return oe;
        }
        function xD(m) {
          return _n(m) ? Zt(m, so) : oa(m) ? [m] : Ki(Qv(Nn(m)));
        }
        function _D(m) {
          var x = ++IT;
          return Nn(m) + x;
        }
        var wD = Ip(function(m, x) {
          return m + x;
        }, 0), SD = K1("ceil"), CD = Ip(function(m, x) {
          return m / x;
        }, 1), kD = K1("floor");
        function AD(m) {
          return m && m.length ? kp(m, Ji, j1) : n;
        }
        function ED(m, x) {
          return m && m.length ? kp(m, mn(x, 2), j1) : n;
        }
        function OD(m) {
          return Ng(m, Ji);
        }
        function TD(m, x) {
          return Ng(m, mn(x, 2));
        }
        function PD(m) {
          return m && m.length ? kp(m, Ji, L1) : n;
        }
        function RD(m, x) {
          return m && m.length ? kp(m, mn(x, 2), L1) : n;
        }
        var ID = Ip(function(m, x) {
          return m * x;
        }, 1), jD = K1("round"), qD = Ip(function(m, x) {
          return m - x;
        }, 0);
        function DD(m) {
          return m && m.length ? _1(m, Ji) : 0;
        }
        function $D(m, x) {
          return m && m.length ? _1(m, mn(x, 2)) : 0;
        }
        return Se.after = ij, Se.ary = cy, Se.assign = Vj, Se.assignIn = Sy, Se.assignInWith = Vp, Se.assignWith = Gj, Se.at = Wj, Se.before = ly, Se.bind = oh, Se.bindAll = Qq, Se.bindKey = fy, Se.castArray = gj, Se.chain = oy, Se.chunk = kR, Se.compact = AR, Se.concat = ER, Se.cond = Xq, Se.conforms = eD, Se.constant = dh, Se.countBy = DI, Se.create = Kj, Se.curry = py, Se.curryRight = dy, Se.debounce = hy, Se.defaults = Zj, Se.defaultsDeep = Yj, Se.defer = aj, Se.delay = oj, Se.difference = OR, Se.differenceBy = TR, Se.differenceWith = PR, Se.drop = RR, Se.dropRight = IR, Se.dropRightWhile = jR, Se.dropWhile = qR, Se.fill = DR, Se.filter = LI, Se.flatMap = MI, Se.flatMapDeep = BI, Se.flatMapDepth = UI, Se.flatten = ry, Se.flattenDeep = $R, Se.flattenDepth = LR, Se.flip = sj, Se.flow = rD, Se.flowRight = nD, Se.fromPairs = NR, Se.functions = nq, Se.functionsIn = iq, Se.groupBy = HI, Se.initial = MR, Se.intersection = BR, Se.intersectionBy = UR, Se.intersectionWith = HR, Se.invert = oq, Se.invertBy = sq, Se.invokeMap = VI, Se.iteratee = hh, Se.keyBy = GI, Se.keys = hi, Se.keysIn = Yi, Se.map = Fp, Se.mapKeys = cq, Se.mapValues = lq, Se.matches = iD, Se.matchesProperty = aD, Se.memoize = Bp, Se.merge = fq, Se.mergeWith = Cy, Se.method = oD, Se.methodOf = sD, Se.mixin = mh, Se.negate = Up, Se.nthArg = cD, Se.omit = pq, Se.omitBy = dq, Se.once = uj, Se.orderBy = WI, Se.over = lD, Se.overArgs = cj, Se.overEvery = fD, Se.overSome = pD, Se.partial = sh, Se.partialRight = my, Se.partition = KI, Se.pick = hq, Se.pickBy = ky, Se.property = Iy, Se.propertyOf = dD, Se.pull = WR, Se.pullAll = iy, Se.pullAllBy = KR, Se.pullAllWith = ZR, Se.pullAt = YR, Se.range = hD, Se.rangeRight = mD, Se.rearg = lj, Se.reject = JI, Se.remove = JR, Se.rest = fj, Se.reverse = ih, Se.sampleSize = XI, Se.set = gq, Se.setWith = vq, Se.shuffle = ej, Se.slice = QR, Se.sortBy = nj, Se.sortedUniq = aI, Se.sortedUniqBy = oI, Se.split = Mq, Se.spread = pj, Se.tail = sI, Se.take = uI, Se.takeRight = cI, Se.takeRightWhile = lI, Se.takeWhile = fI, Se.tap = AI, Se.throttle = dj, Se.thru = Np, Se.toArray = xy, Se.toPairs = Ay, Se.toPairsIn = Ey, Se.toPath = xD, Se.toPlainObject = wy, Se.transform = yq, Se.unary = hj, Se.union = pI, Se.unionBy = dI, Se.unionWith = hI, Se.uniq = mI, Se.uniqBy = gI, Se.uniqWith = vI, Se.unset = bq, Se.unzip = ah, Se.unzipWith = ay, Se.update = xq, Se.updateWith = _q, Se.values = zu, Se.valuesIn = wq, Se.without = yI, Se.words = Py, Se.wrap = mj, Se.xor = bI, Se.xorBy = xI, Se.xorWith = _I, Se.zip = wI, Se.zipObject = SI, Se.zipObjectDeep = CI, Se.zipWith = kI, Se.entries = Ay, Se.entriesIn = Ey, Se.extend = Sy, Se.extendWith = Vp, mh(Se, Se), Se.add = wD, Se.attempt = Ry, Se.camelCase = Aq, Se.capitalize = Oy, Se.ceil = SD, Se.clamp = Sq, Se.clone = vj, Se.cloneDeep = bj, Se.cloneDeepWith = xj, Se.cloneWith = yj, Se.conformsTo = _j, Se.deburr = Ty, Se.defaultTo = tD, Se.divide = CD, Se.endsWith = Eq, Se.eq = Fa, Se.escape = Oq, Se.escapeRegExp = Tq, Se.every = $I, Se.find = NI, Se.findIndex = ey, Se.findKey = Jj, Se.findLast = FI, Se.findLastIndex = ty, Se.findLastKey = Qj, Se.floor = kD, Se.forEach = sy, Se.forEachRight = uy, Se.forIn = Xj, Se.forInRight = eq, Se.forOwn = tq, Se.forOwnRight = rq, Se.get = lh, Se.gt = wj, Se.gte = Sj, Se.has = aq, Se.hasIn = fh, Se.head = ny, Se.identity = Ji, Se.includes = zI, Se.indexOf = FR, Se.inRange = Cq, Se.invoke = uq, Se.isArguments = Ns, Se.isArray = _n, Se.isArrayBuffer = Cj, Se.isArrayLike = Zi, Se.isArrayLikeObject = ti, Se.isBoolean = kj, Se.isBuffer = ms, Se.isDate = Aj, Se.isElement = Ej, Se.isEmpty = Oj, Se.isEqual = Tj, Se.isEqualWith = Pj, Se.isError = uh, Se.isFinite = Rj, Se.isFunction = qo, Se.isInteger = gy, Se.isLength = Hp, Se.isMap = vy, Se.isMatch = Ij, Se.isMatchWith = jj, Se.isNaN = qj, Se.isNative = Dj, Se.isNil = Lj, Se.isNull = $j, Se.isNumber = yy, Se.isObject = Yn, Se.isObjectLike = Qn, Se.isPlainObject = Gc, Se.isRegExp = ch, Se.isSafeInteger = Nj, Se.isSet = by, Se.isString = zp, Se.isSymbol = oa, Se.isTypedArray = Hu, Se.isUndefined = Fj, Se.isWeakMap = Mj, Se.isWeakSet = Bj, Se.join = zR, Se.kebabCase = Pq, Se.last = _a, Se.lastIndexOf = VR, Se.lowerCase = Rq, Se.lowerFirst = Iq, Se.lt = Uj, Se.lte = Hj, Se.max = AD, Se.maxBy = ED, Se.mean = OD, Se.meanBy = TD, Se.min = PD, Se.minBy = RD, Se.stubArray = vh, Se.stubFalse = yh, Se.stubObject = gD, Se.stubString = vD, Se.stubTrue = yD, Se.multiply = ID, Se.nth = GR, Se.noConflict = uD, Se.noop = gh, Se.now = Mp, Se.pad = jq, Se.padEnd = qq, Se.padStart = Dq, Se.parseInt = $q, Se.random = kq, Se.reduce = ZI, Se.reduceRight = YI, Se.repeat = Lq, Se.replace = Nq, Se.result = mq, Se.round = jD, Se.runInContext = lt, Se.sample = QI, Se.size = tj, Se.snakeCase = Fq, Se.some = rj, Se.sortedIndex = XR, Se.sortedIndexBy = eI, Se.sortedIndexOf = tI, Se.sortedLastIndex = rI, Se.sortedLastIndexBy = nI, Se.sortedLastIndexOf = iI, Se.startCase = Bq, Se.startsWith = Uq, Se.subtract = qD, Se.sum = DD, Se.sumBy = $D, Se.template = Hq, Se.times = bD, Se.toFinite = Do, Se.toInteger = Cn, Se.toLength = _y, Se.toLower = zq, Se.toNumber = wa, Se.toSafeInteger = zj, Se.toString = Nn, Se.toUpper = Vq, Se.trim = Gq, Se.trimEnd = Wq, Se.trimStart = Kq, Se.truncate = Zq, Se.unescape = Yq, Se.uniqueId = _D, Se.upperCase = Jq, Se.upperFirst = ph, Se.each = sy, Se.eachRight = uy, Se.first = ny, mh(Se, (function() {
          var m = {};
          return ao(Se, function(x, q) {
            Fn.call(Se.prototype, q) || (m[q] = x);
          }), m;
        })(), { chain: !1 }), Se.VERSION = r, _r(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(m) {
          Se[m].placeholder = Se;
        }), _r(["drop", "take"], function(m, x) {
          In.prototype[m] = function(q) {
            q = q === n ? 1 : ui(Cn(q), 0);
            var G = this.__filtered__ && !x ? new In(this) : this.clone();
            return G.__filtered__ ? G.__takeCount__ = Ei(q, G.__takeCount__) : G.__views__.push({
              size: Ei(q, Ve),
              type: m + (G.__dir__ < 0 ? "Right" : "")
            }), G;
          }, In.prototype[m + "Right"] = function(q) {
            return this.reverse()[m](q).reverse();
          };
        }), _r(["filter", "map", "takeWhile"], function(m, x) {
          var q = x + 1, G = q == Ce || q == ne;
          In.prototype[m] = function(oe) {
            var Ee = this.clone();
            return Ee.__iteratees__.push({
              iteratee: mn(oe, 3),
              type: q
            }), Ee.__filtered__ = Ee.__filtered__ || G, Ee;
          };
        }), _r(["head", "last"], function(m, x) {
          var q = "take" + (x ? "Right" : "");
          In.prototype[m] = function() {
            return this[q](1).value()[0];
          };
        }), _r(["initial", "tail"], function(m, x) {
          var q = "drop" + (x ? "" : "Right");
          In.prototype[m] = function() {
            return this.__filtered__ ? new In(this) : this[q](1);
          };
        }), In.prototype.compact = function() {
          return this.filter(Ji);
        }, In.prototype.find = function(m) {
          return this.filter(m).head();
        }, In.prototype.findLast = function(m) {
          return this.reverse().find(m);
        }, In.prototype.invokeMap = Tn(function(m, x) {
          return typeof m == "function" ? new In(this) : this.map(function(q) {
            return Mc(q, m, x);
          });
        }), In.prototype.reject = function(m) {
          return this.filter(Up(mn(m)));
        }, In.prototype.slice = function(m, x) {
          m = Cn(m);
          var q = this;
          return q.__filtered__ && (m > 0 || x < 0) ? new In(q) : (m < 0 ? q = q.takeRight(-m) : m && (q = q.drop(m)), x !== n && (x = Cn(x), q = x < 0 ? q.dropRight(-x) : q.take(x - m)), q);
        }, In.prototype.takeRightWhile = function(m) {
          return this.reverse().takeWhile(m).reverse();
        }, In.prototype.toArray = function() {
          return this.take(Ve);
        }, ao(In.prototype, function(m, x) {
          var q = /^(?:filter|find|map|reject)|While$/.test(x), G = /^(?:head|last)$/.test(x), oe = Se[G ? "take" + (x == "last" ? "Right" : "") : x], Ee = G || /^find/.test(x);
          oe && (Se.prototype[x] = function() {
            var Ne = this.__wrapped__, Ke = G ? [1] : arguments, vt = Ne instanceof In, zt = Ke[0], Vt = vt || _n(Ne), tr = function(Rn) {
              var jn = oe.apply(Se, Qt([Rn], Ke));
              return G && sn ? jn[0] : jn;
            };
            Vt && q && typeof zt == "function" && zt.length != 1 && (vt = Vt = !1);
            var sn = this.__chain__, dn = !!this.__actions__.length, vn = Ee && !sn, En = vt && !dn;
            if (!Ee && Vt) {
              Ne = En ? Ne : new In(this);
              var yn = m.apply(Ne, Ke);
              return yn.__actions__.push({ func: Np, args: [tr], thisArg: n }), new ya(yn, sn);
            }
            return vn && En ? m.apply(this, Ke) : (yn = this.thru(tr), vn ? G ? yn.value()[0] : yn.value() : yn);
          });
        }), _r(["pop", "push", "shift", "sort", "splice", "unshift"], function(m) {
          var x = lp[m], q = /^(?:push|sort|unshift)$/.test(m) ? "tap" : "thru", G = /^(?:pop|shift)$/.test(m);
          Se.prototype[m] = function() {
            var oe = arguments;
            if (G && !this.__chain__) {
              var Ee = this.value();
              return x.apply(_n(Ee) ? Ee : [], oe);
            }
            return this[q](function(Ne) {
              return x.apply(_n(Ne) ? Ne : [], oe);
            });
          };
        }), ao(In.prototype, function(m, x) {
          var q = Se[x];
          if (q) {
            var G = q.name + "";
            Fn.call(Nu, G) || (Nu[G] = []), Nu[G].push({ name: x, func: q });
          }
        }), Nu[Rp(n, y).name] = [{
          name: "wrapper",
          func: n
        }], In.prototype.clone = YT, In.prototype.reverse = JT, In.prototype.value = QT, Se.prototype.at = EI, Se.prototype.chain = OI, Se.prototype.commit = TI, Se.prototype.next = PI, Se.prototype.plant = II, Se.prototype.reverse = jI, Se.prototype.toJSON = Se.prototype.valueOf = Se.prototype.value = qI, Se.prototype.first = Se.prototype.head, jc && (Se.prototype[jc] = RI), Se;
      }), Du = TT();
      wr ? ((wr.exports = Du)._ = Du, rr._ = Du) : er._ = Du;
    }).call(MF);
  })(of, of.exports)), of.exports;
}
var mi = Xn();
function HC(e) {
  let t = "";
  return e.absolute && (e.protocol === "file" ? (e.drive && (t += e.drive), t += "/") : (t += e.protocol + "://", e.origin && (t += e.origin + "/"))), (t += e.path.join("/")) === "" && (t = "."), t;
}
function wf(e, t, n, r) {
  this.message = e, this.expected = t, this.found = n, this.location = r, this.name = "SyntaxError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, wf);
}
(function(e, t) {
  function n() {
    this.constructor = e;
  }
  n.prototype = t.prototype, e.prototype = new n();
})(wf, Error), wf.buildMessage = function(e, t) {
  var n = { literal: function(o) {
    return '"' + i(o.text) + '"';
  }, class: function(o) {
    var c, u = "";
    for (c = 0; c < o.parts.length; c++) u += o.parts[c] instanceof Array ? a(o.parts[c][0]) + "-" + a(o.parts[c][1]) : a(o.parts[c]);
    return "[" + (o.inverted ? "^" : "") + u + "]";
  }, any: function(o) {
    return "any character";
  }, end: function(o) {
    return "end of input";
  }, other: function(o) {
    return o.description;
  } };
  function r(o) {
    return o.charCodeAt(0).toString(16).toUpperCase();
  }
  function i(o) {
    return o.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(c) {
      return "\\x0" + r(c);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(c) {
      return "\\x" + r(c);
    });
  }
  function a(o) {
    return o.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(c) {
      return "\\x0" + r(c);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(c) {
      return "\\x" + r(c);
    });
  }
  return "Expected " + (function(o) {
    var c, u, s, l = new Array(o.length);
    for (c = 0; c < o.length; c++) l[c] = (s = o[c], n[s.type](s));
    if (l.sort(), l.length > 0) {
      for (c = 1, u = 1; c < l.length; c++) l[c - 1] !== l[c] && (l[u] = l[c], u++);
      l.length = u;
    }
    switch (l.length) {
      case 1:
        return l[0];
      case 2:
        return l[0] + " or " + l[1];
      default:
        return l.slice(0, -1).join(", ") + ", or " + l[l.length - 1];
    }
  })(e) + " but " + (function(o) {
    return o ? '"' + i(o) + '"' : "end of input";
  })(t) + " found.";
};
var BF = function(e, t) {
  t = t !== void 0 ? t : {};
  var n, r, i, a, o = {}, c = { Path: Y }, u = Y, s = function(Be, P, N, F) {
    return { protocol: Be, origin: P, absolute: !0, ...N, ...F };
  }, l = function(Be, P, N) {
    return { protocol: Be, origin: P, absolute: !0, ...N, path: [] };
  }, d = "http://", f = ze("http://", !0), p = function(Be) {
    return "http";
  }, g = "https://", b = ze("https://", !0), w = function(Be) {
    return "https";
  }, y = "", v = function() {
    return null;
  }, _ = function(Be, P, N) {
    return { protocol: Be, origin: null, absolute: !0, ...P, ...N };
  }, E = "file://", O = ze("file://", !0), M = "file:", L = ze("file:", !0), Z = function(Be) {
    return "file";
  }, Q = function(Be, P) {
    return { protocol: "file", origin: null, absolute: !0, ...Be, ...P };
  }, ae = /^[A-Za-z]/, re = Rt([["A", "Z"], ["a", "z"]], !1, !1), X = ":", de = ze(":", !1), Ce = function(Be) {
    return { drive: Be.toLowerCase() + ":" };
  }, J = function() {
    return { drive: null };
  }, ne = function() {
    return { drive: null };
  }, De = function(Be) {
    return { protocol: null, origin: null, absolute: !1, drive: null, ...Be };
  }, je = function(Be) {
    return { path: Be };
  }, Me = function(Be, P) {
    return [Be, ...P];
  }, qe = function(Be) {
    return [Be];
  }, Ve = ".", xe = ze(".", !1), ve = "/", Ae = ze("/", !1), Ue = "\\", qt = ze("\\", !1), Ze = /^[^\/\\]/, At = Rt(["/", "\\"], !0, !1), He = 0, Dt = [{ line: 1, column: 1 }], Fe = 0, Xe = [];
  if ("startRule" in t) {
    if (!(t.startRule in c)) throw new Error(`Can't start parsing from rule "` + t.startRule + '".');
    u = c[t.startRule];
  }
  function ze(Be, P) {
    return { type: "literal", text: Be, ignoreCase: P };
  }
  function Rt(Be, P, N) {
    return { type: "class", parts: Be, inverted: P, ignoreCase: N };
  }
  function Yt(Be) {
    var P, N = Dt[Be];
    if (N) return N;
    for (P = Be - 1; !Dt[P]; ) P--;
    for (N = { line: (N = Dt[P]).line, column: N.column }; P < Be; ) e.charCodeAt(P) === 10 ? (N.line++, N.column = 1) : N.column++, P++;
    return Dt[Be] = N, N;
  }
  function ye(Be, P) {
    var N = Yt(Be), F = Yt(P);
    return { start: { offset: Be, line: N.line, column: N.column }, end: { offset: P, line: F.line, column: F.column } };
  }
  function W(Be) {
    He < Fe || (He > Fe && (Fe = He, Xe = []), Xe.push(Be));
  }
  function Y() {
    var Be;
    return (Be = (function() {
      var P, N, F, T, C;
      return P = He, (N = ie()) !== o && (F = Te()) !== o && (T = _e()) !== o && (C = Le()) !== o ? (N = s(N, F, T, C), P = N) : (He = P, P = o), P === o && (P = He, (N = ie()) !== o && (F = Te()) !== o && (T = (function() {
        var S;
        return (S = y) !== o && (S = ne()), S;
      })()) !== o ? (N = l(N, F, T), P = N) : (He = P, P = o)), P;
    })()) === o && (Be = (function() {
      var P, N, F, T;
      return P = He, (N = (function() {
        var C;
        return e.substr(He, 7).toLowerCase() === E ? (C = e.substr(He, 7), He += 7) : (C = o, W(O)), C === o && (e.substr(He, 5).toLowerCase() === M ? (C = e.substr(He, 5), He += 5) : (C = o, W(L))), C !== o && (C = Z()), C;
      })()) !== o && (F = $()) !== o && (T = Le()) !== o ? (N = _(N, F, T), P = N) : (He = P, P = o), P;
    })()) === o && (Be = (function() {
      var P, N, F;
      return P = He, (N = $()) !== o && (F = Le()) !== o ? (N = Q(N, F), P = N) : (He = P, P = o), P;
    })()) === o && (Be = (function() {
      var P, N, F;
      return P = He, (N = (function() {
        var T;
        return (T = (function() {
          var C, S, h;
          return C = He, e.charCodeAt(He) === 46 ? (S = Ve, He++) : (S = o, W(xe)), S !== o && (h = Ge()) !== o ? C = S = [S, h] : (He = C, C = o), C;
        })()) === o && (T = y), T;
      })()) !== o && (F = Le()) !== o ? (N = De(F), P = N) : (He = P, P = o), P;
    })()), Be;
  }
  function ie() {
    var Be, P;
    return e.substr(He, 7).toLowerCase() === d ? (P = e.substr(He, 7), He += 7) : (P = o, W(f)), P !== o && (P = p()), (Be = P) === o && (Be = (function() {
      var N;
      return e.substr(He, 8).toLowerCase() === g ? (N = e.substr(He, 8), He += 8) : (N = o, W(b)), N !== o && (N = w()), N;
    })()), Be;
  }
  function Te() {
    var Be, P, N;
    if (Be = He, P = [], (N = $t()) !== o) for (; N !== o; ) P.push(N), N = $t();
    else P = o;
    return (Be = P !== o ? e.substring(Be, He) : P) === o && (Be = He, (P = y) !== o && (P = v()), Be = P), Be;
  }
  function $() {
    var Be;
    return (Be = (function() {
      var P, N, F, T;
      return P = He, (N = Ge()) === o && (N = null), N !== o ? (ae.test(e.charAt(He)) ? (F = e.charAt(He), He++) : (F = o, W(re)), F !== o ? (e.charCodeAt(He) === 58 ? (T = X, He++) : (T = o, W(de)), T !== o && Ge() !== o ? (N = Ce(F), P = N) : (He = P, P = o)) : (He = P, P = o)) : (He = P, P = o), P;
    })()) === o && (Be = _e()), Be;
  }
  function _e() {
    var Be;
    return (Be = Ge()) !== o && (Be = J()), Be;
  }
  function Le() {
    var Be;
    return (Be = (function P() {
      var N, F, T;
      return N = He, (F = et()) !== o && Ge() !== o && (T = P()) !== o ? (F = Me(F, T), N = F) : (He = N, N = o), N === o && (N = He, (F = et()) !== o && (F = qe(F)), N = F), N;
    })()) !== o && (Be = je(Be)), Be;
  }
  function et() {
    var Be, P, N;
    if (Be = He, P = [], (N = $t()) !== o) for (; N !== o; ) P.push(N), N = $t();
    else P = o;
    return (Be = P !== o ? e.substring(Be, He) : P) === o && (Be = y), Be;
  }
  function Ge() {
    var Be;
    return e.charCodeAt(He) === 47 ? (Be = ve, He++) : (Be = o, W(Ae)), Be === o && (e.charCodeAt(He) === 92 ? (Be = Ue, He++) : (Be = o, W(qt))), Be;
  }
  function $t() {
    var Be;
    return Ze.test(e.charAt(He)) ? (Be = e.charAt(He), He++) : (Be = o, W(At)), Be;
  }
  if ((n = u()) !== o && He === e.length) return n;
  throw n !== o && He < e.length && W({ type: "end" }), r = Xe, i = Fe < e.length ? e.charAt(Fe) : null, a = Fe < e.length ? ye(Fe, Fe + 1) : ye(Fe, Fe), new wf(wf.buildMessage(r, i), r, i, a);
};
function y2(e) {
  if (typeof e != "string") throw new Error(`@stoplight/path: Cannot parse ${e} because it is not a string`);
  return BF(e, {});
}
function R6(e) {
  let t = e.path;
  t = t.filter((r) => r !== "" && r !== ".");
  const n = [];
  for (const r of t) r === ".." && n.length && n[n.length - 1] !== ".." ? n.pop() : r === ".." && e.absolute || n.push(r);
  return e.path = n, e;
}
const UF = (e) => {
  const t = R6(y2(e));
  return t.path.pop(), HC(R6(t));
};
function HF(e) {
  return y2(e).absolute;
}
const zF = (...e) => {
  if (e.length === 0) return ".";
  const t = e.map(y2), n = Object.assign({}, t[0]);
  for (let r = 1; r < t.length; r++) {
    const i = t[r];
    if (i.absolute) throw new Error('Cannot join an absolute path "' + e[r] + '" in the middle of other paths.');
    for (const a of i.path) n.path.push(a);
  }
  return HC(R6(n));
};
function zC(e, t) {
  t === void 0 && (t = !1);
  var n = e.length, r = 0, i = "", a = 0, o = 16, c = 0, u = 0, s = 0, l = 0, d = 0;
  function f(_, E) {
    for (var O = 0, M = 0; O < _; ) {
      var L = e.charCodeAt(r);
      if (L >= 48 && L <= 57)
        M = M * 16 + L - 48;
      else if (L >= 65 && L <= 70)
        M = M * 16 + L - 65 + 10;
      else if (L >= 97 && L <= 102)
        M = M * 16 + L - 97 + 10;
      else
        break;
      r++, O++;
    }
    return O < _ && (M = -1), M;
  }
  function p(_) {
    r = _, i = "", a = 0, o = 16, d = 0;
  }
  function g() {
    var _ = r;
    if (e.charCodeAt(r) === 48)
      r++;
    else
      for (r++; r < e.length && Vu(e.charCodeAt(r)); )
        r++;
    if (r < e.length && e.charCodeAt(r) === 46)
      if (r++, r < e.length && Vu(e.charCodeAt(r)))
        for (r++; r < e.length && Vu(e.charCodeAt(r)); )
          r++;
      else
        return d = 3, e.substring(_, r);
    var E = r;
    if (r < e.length && (e.charCodeAt(r) === 69 || e.charCodeAt(r) === 101))
      if (r++, (r < e.length && e.charCodeAt(r) === 43 || e.charCodeAt(r) === 45) && r++, r < e.length && Vu(e.charCodeAt(r))) {
        for (r++; r < e.length && Vu(e.charCodeAt(r)); )
          r++;
        E = r;
      } else
        d = 3;
    return e.substring(_, E);
  }
  function b() {
    for (var _ = "", E = r; ; ) {
      if (r >= n) {
        _ += e.substring(E, r), d = 2;
        break;
      }
      var O = e.charCodeAt(r);
      if (O === 34) {
        _ += e.substring(E, r), r++;
        break;
      }
      if (O === 92) {
        if (_ += e.substring(E, r), r++, r >= n) {
          d = 2;
          break;
        }
        var M = e.charCodeAt(r++);
        switch (M) {
          case 34:
            _ += '"';
            break;
          case 92:
            _ += "\\";
            break;
          case 47:
            _ += "/";
            break;
          case 98:
            _ += "\b";
            break;
          case 102:
            _ += "\f";
            break;
          case 110:
            _ += `
`;
            break;
          case 114:
            _ += "\r";
            break;
          case 116:
            _ += "	";
            break;
          case 117:
            var L = f(4);
            L >= 0 ? _ += String.fromCharCode(L) : d = 4;
            break;
          default:
            d = 5;
        }
        E = r;
        continue;
      }
      if (O >= 0 && O <= 31)
        if (Zc(O)) {
          _ += e.substring(E, r), d = 2;
          break;
        } else
          d = 6;
      r++;
    }
    return _;
  }
  function w() {
    if (i = "", d = 0, a = r, u = c, l = s, r >= n)
      return a = n, o = 17;
    var _ = e.charCodeAt(r);
    if (Ch(_)) {
      do
        r++, i += String.fromCharCode(_), _ = e.charCodeAt(r);
      while (Ch(_));
      return o = 15;
    }
    if (Zc(_))
      return r++, i += String.fromCharCode(_), _ === 13 && e.charCodeAt(r) === 10 && (r++, i += `
`), c++, s = r, o = 14;
    switch (_) {
      // tokens: []{}:,
      case 123:
        return r++, o = 1;
      case 125:
        return r++, o = 2;
      case 91:
        return r++, o = 3;
      case 93:
        return r++, o = 4;
      case 58:
        return r++, o = 6;
      case 44:
        return r++, o = 5;
      // strings
      case 34:
        return r++, i = b(), o = 10;
      // comments
      case 47:
        var E = r - 1;
        if (e.charCodeAt(r + 1) === 47) {
          for (r += 2; r < n && !Zc(e.charCodeAt(r)); )
            r++;
          return i = e.substring(E, r), o = 12;
        }
        if (e.charCodeAt(r + 1) === 42) {
          r += 2;
          for (var O = n - 1, M = !1; r < O; ) {
            var L = e.charCodeAt(r);
            if (L === 42 && e.charCodeAt(r + 1) === 47) {
              r += 2, M = !0;
              break;
            }
            r++, Zc(L) && (L === 13 && e.charCodeAt(r) === 10 && r++, c++, s = r);
          }
          return M || (r++, d = 1), i = e.substring(E, r), o = 13;
        }
        return i += String.fromCharCode(_), r++, o = 16;
      // numbers
      case 45:
        if (i += String.fromCharCode(_), r++, r === n || !Vu(e.charCodeAt(r)))
          return o = 16;
      // found a minus, followed by a number so
      // we fall through to proceed with scanning
      // numbers
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
        return i += g(), o = 11;
      // literals and unknown symbols
      default:
        for (; r < n && y(_); )
          r++, _ = e.charCodeAt(r);
        if (a !== r) {
          switch (i = e.substring(a, r), i) {
            case "true":
              return o = 8;
            case "false":
              return o = 9;
            case "null":
              return o = 7;
          }
          return o = 16;
        }
        return i += String.fromCharCode(_), r++, o = 16;
    }
  }
  function y(_) {
    if (Ch(_) || Zc(_))
      return !1;
    switch (_) {
      case 125:
      case 93:
      case 123:
      case 91:
      case 34:
      case 58:
      case 44:
      case 47:
        return !1;
    }
    return !0;
  }
  function v() {
    var _;
    do
      _ = w();
    while (_ >= 12 && _ <= 15);
    return _;
  }
  return {
    setPosition: p,
    getPosition: function() {
      return r;
    },
    scan: t ? v : w,
    getToken: function() {
      return o;
    },
    getTokenValue: function() {
      return i;
    },
    getTokenOffset: function() {
      return a;
    },
    getTokenLength: function() {
      return r - a;
    },
    getTokenStartLine: function() {
      return u;
    },
    getTokenStartCharacter: function() {
      return a - l;
    },
    getTokenError: function() {
      return d;
    }
  };
}
function Ch(e) {
  return e === 32 || e === 9 || e === 11 || e === 12 || e === 160 || e === 5760 || e >= 8192 && e <= 8203 || e === 8239 || e === 8287 || e === 12288 || e === 65279;
}
function Zc(e) {
  return e === 10 || e === 13 || e === 8232 || e === 8233;
}
function Vu(e) {
  return e >= 48 && e <= 57;
}
var I6;
(function(e) {
  e.DEFAULT = {
    allowTrailingComma: !1
  };
})(I6 || (I6 = {}));
function VC(e) {
  if (!e.parent || !e.parent.children)
    return [];
  var t = VC(e.parent);
  if (e.parent.type === "property") {
    var n = e.parent.children[0].value;
    t.push(n);
  } else if (e.parent.type === "array") {
    var r = e.parent.children.indexOf(e);
    r !== -1 && t.push(r);
  }
  return t;
}
function VF(e, t, n) {
  return n === void 0 && (n = !1), t >= e.offset && t < e.offset + e.length || n && t === e.offset + e.length;
}
function GC(e, t, n) {
  if (n === void 0 && (n = !1), VF(e, t, n)) {
    var r = e.children;
    if (Array.isArray(r))
      for (var i = 0; i < r.length && r[i].offset <= t; i++) {
        var a = GC(r[i], t, n);
        if (a)
          return a;
      }
    return e;
  }
}
function GF(e, t, n) {
  n === void 0 && (n = I6.DEFAULT);
  var r = zC(e, !1);
  function i(Q) {
    return Q ? function() {
      return Q(r.getTokenOffset(), r.getTokenLength(), r.getTokenStartLine(), r.getTokenStartCharacter());
    } : function() {
      return !0;
    };
  }
  function a(Q) {
    return Q ? function(ae) {
      return Q(ae, r.getTokenOffset(), r.getTokenLength(), r.getTokenStartLine(), r.getTokenStartCharacter());
    } : function() {
      return !0;
    };
  }
  var o = i(t.onObjectBegin), c = a(t.onObjectProperty), u = i(t.onObjectEnd), s = i(t.onArrayBegin), l = i(t.onArrayEnd), d = a(t.onLiteralValue), f = a(t.onSeparator), p = i(t.onComment), g = a(t.onError), b = n && n.disallowComments, w = n && n.allowTrailingComma;
  function y() {
    for (; ; ) {
      var Q = r.scan();
      switch (r.getTokenError()) {
        case 4:
          v(
            14
            /* InvalidUnicode */
          );
          break;
        case 5:
          v(
            15
            /* InvalidEscapeCharacter */
          );
          break;
        case 3:
          v(
            13
            /* UnexpectedEndOfNumber */
          );
          break;
        case 1:
          b || v(
            11
            /* UnexpectedEndOfComment */
          );
          break;
        case 2:
          v(
            12
            /* UnexpectedEndOfString */
          );
          break;
        case 6:
          v(
            16
            /* InvalidCharacter */
          );
          break;
      }
      switch (Q) {
        case 12:
        case 13:
          b ? v(
            10
            /* InvalidCommentToken */
          ) : p();
          break;
        case 16:
          v(
            1
            /* InvalidSymbol */
          );
          break;
        case 15:
        case 14:
          break;
        default:
          return Q;
      }
    }
  }
  function v(Q, ae, re) {
    if (ae === void 0 && (ae = []), re === void 0 && (re = []), g(Q), ae.length + re.length > 0)
      for (var X = r.getToken(); X !== 17; ) {
        if (ae.indexOf(X) !== -1) {
          y();
          break;
        } else if (re.indexOf(X) !== -1)
          break;
        X = y();
      }
  }
  function _(Q) {
    var ae = r.getTokenValue();
    return Q ? d(ae) : c(ae), y(), !0;
  }
  function E() {
    switch (r.getToken()) {
      case 11:
        var Q = 0;
        try {
          Q = JSON.parse(r.getTokenValue()), typeof Q != "number" && (v(
            2
            /* InvalidNumberFormat */
          ), Q = 0);
        } catch {
          v(
            2
            /* InvalidNumberFormat */
          );
        }
        d(Q);
        break;
      case 7:
        d(null);
        break;
      case 8:
        d(!0);
        break;
      case 9:
        d(!1);
        break;
      default:
        return !1;
    }
    return y(), !0;
  }
  function O() {
    return r.getToken() !== 10 ? (v(3, [], [
      2,
      5
      /* CommaToken */
    ]), !1) : (_(!1), r.getToken() === 6 ? (f(":"), y(), Z() || v(4, [], [
      2,
      5
      /* CommaToken */
    ])) : v(5, [], [
      2,
      5
      /* CommaToken */
    ]), !0);
  }
  function M() {
    o(), y();
    for (var Q = !1; r.getToken() !== 2 && r.getToken() !== 17; ) {
      if (r.getToken() === 5) {
        if (Q || v(4, [], []), f(","), y(), r.getToken() === 2 && w)
          break;
      } else Q && v(6, [], []);
      O() || v(4, [], [
        2,
        5
        /* CommaToken */
      ]), Q = !0;
    }
    return u(), r.getToken() !== 2 ? v(7, [
      2
      /* CloseBraceToken */
    ], []) : y(), !0;
  }
  function L() {
    s(), y();
    for (var Q = !1; r.getToken() !== 4 && r.getToken() !== 17; ) {
      if (r.getToken() === 5) {
        if (Q || v(4, [], []), f(","), y(), r.getToken() === 4 && w)
          break;
      } else Q && v(6, [], []);
      Z() || v(4, [], [
        4,
        5
        /* CommaToken */
      ]), Q = !0;
    }
    return l(), r.getToken() !== 4 ? v(8, [
      4
      /* CloseBracketToken */
    ], []) : y(), !0;
  }
  function Z() {
    switch (r.getToken()) {
      case 3:
        return L();
      case 1:
        return M();
      case 10:
        return _(!0);
      default:
        return E();
    }
  }
  return y(), r.getToken() === 17 ? n.allowEmptyContent ? !0 : (v(4, [], []), !1) : Z() ? (r.getToken() !== 17 && v(9, [], []), !0) : (v(4, [], []), !1);
}
var WF = zC, KF = GC, ZF = VC, YF = GF;
function JF(e) {
  switch (e) {
    case 1:
      return "InvalidSymbol";
    case 2:
      return "InvalidNumberFormat";
    case 3:
      return "PropertyNameExpected";
    case 4:
      return "ValueExpected";
    case 5:
      return "ColonExpected";
    case 6:
      return "CommaExpected";
    case 7:
      return "CloseBraceExpected";
    case 8:
      return "CloseBracketExpected";
    case 9:
      return "EndOfFileExpected";
    case 10:
      return "InvalidCommentToken";
    case 11:
      return "UnexpectedEndOfComment";
    case 12:
      return "UnexpectedEndOfString";
    case 13:
      return "UnexpectedEndOfNumber";
    case 14:
      return "InvalidUnicode";
    case 15:
      return "InvalidEscapeCharacter";
    case 16:
      return "InvalidCharacter";
  }
  return "<unknown ParseErrorCode>";
}
function QF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var WC = { exports: {} }, ai = WC.exports = {}, mo, go;
function j6() {
  throw new Error("setTimeout has not been defined");
}
function q6() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? mo = setTimeout : mo = j6;
  } catch {
    mo = j6;
  }
  try {
    typeof clearTimeout == "function" ? go = clearTimeout : go = q6;
  } catch {
    go = q6;
  }
})();
function KC(e) {
  if (mo === setTimeout)
    return setTimeout(e, 0);
  if ((mo === j6 || !mo) && setTimeout)
    return mo = setTimeout, setTimeout(e, 0);
  try {
    return mo(e, 0);
  } catch {
    try {
      return mo.call(null, e, 0);
    } catch {
      return mo.call(this, e, 0);
    }
  }
}
function XF(e) {
  if (go === clearTimeout)
    return clearTimeout(e);
  if ((go === q6 || !go) && clearTimeout)
    return go = clearTimeout, clearTimeout(e);
  try {
    return go(e);
  } catch {
    try {
      return go.call(null, e);
    } catch {
      return go.call(this, e);
    }
  }
}
var ts = [], tc = !1, mu, Nd = -1;
function eM() {
  !tc || !mu || (tc = !1, mu.length ? ts = mu.concat(ts) : Nd = -1, ts.length && ZC());
}
function ZC() {
  if (!tc) {
    var e = KC(eM);
    tc = !0;
    for (var t = ts.length; t; ) {
      for (mu = ts, ts = []; ++Nd < t; )
        mu && mu[Nd].run();
      Nd = -1, t = ts.length;
    }
    mu = null, tc = !1, XF(e);
  }
}
ai.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  ts.push(new YC(e, t)), ts.length === 1 && !tc && KC(ZC);
};
function YC(e, t) {
  this.fun = e, this.array = t;
}
YC.prototype.run = function() {
  this.fun.apply(null, this.array);
};
ai.title = "browser";
ai.browser = !0;
ai.env = {};
ai.argv = [];
ai.version = "";
ai.versions = {};
function as() {
}
ai.on = as;
ai.addListener = as;
ai.once = as;
ai.off = as;
ai.removeListener = as;
ai.removeAllListeners = as;
ai.emit = as;
ai.prependListener = as;
ai.prependOnceListener = as;
ai.listeners = function(e) {
  return [];
};
ai.binding = function(e) {
  throw new Error("process.binding is not supported");
};
ai.cwd = function() {
  return "/";
};
ai.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
ai.umask = function() {
  return 0;
};
var tM = WC.exports;
const gn = /* @__PURE__ */ QF(tM), rM = Math.floor(Date.now() / 36e5), JC = `__object_order_${rM}__`, Ai = Symbol.for(JC), nM = {
  defineProperty(e, t, n) {
    return !Object.prototype.hasOwnProperty.call(e, t) && Ai in e ? e[Ai].push(t) : "value" in n && t === Ai && n.value.lastIndexOf(Ai) === -1 && n.value.push(Ai), Reflect.defineProperty(e, t, n);
  },
  deleteProperty(e, t) {
    const n = Object.prototype.hasOwnProperty.call(e, t), r = Reflect.deleteProperty(e, t);
    if (r && n && Ai in e) {
      const i = e[Ai].indexOf(t);
      i !== -1 && e[Ai].splice(i, 1);
    }
    return r;
  },
  ownKeys(e) {
    return Ai in e ? e[Ai] : Reflect.ownKeys(e);
  },
  set(e, t, n) {
    const r = Object.prototype.hasOwnProperty.call(e, t), i = Reflect.set(e, t, n);
    return i && !r && Ai in e && e[Ai].push(t), i;
  }
};
function iM(e, t = Reflect.ownKeys(e)) {
  cM(e);
  const n = new Proxy(e, nM);
  return aM(n, t), n;
}
function aM(e, t) {
  return Ai in e ? (e[Ai].length = 0, e[Ai].push(...t), !0) : Reflect.defineProperty(e, Ai, {
    configurable: !0,
    value: t
  });
}
function oM(e) {
  return e[Ai];
}
function D6(e) {
  return e !== null && typeof e == "object";
}
function sM(e) {
  if (!D6(e)) return !1;
  if (e[Symbol.toStringTag] !== void 0) {
    const t = Object.getPrototypeOf(e);
    return t === null || t === Object.prototype;
  }
  return uM(e) === "Object";
}
function uM(e) {
  const t = e[Symbol.toStringTag];
  if (typeof t == "string")
    return t;
  const n = Reflect.apply(Object.prototype.toString, e, []);
  return n.slice(8, n.length - 1);
}
function cM(e, t) {
  if (lM() && !sM(e))
    throw new TypeError(t);
}
function lM() {
  return typeof gn > "u" || !D6(gn) || !D6(gn.env) ? !1 : gn.env.NODE_ENV === "development" || gn.env.NODE_ENV === "test";
}
var yb;
(function(e) {
  e.None = "none", e.Declared = "declared", e.InheritedFromService = "inheritedFromService";
})(yb || (yb = {}));
var bb;
(function(e) {
  e.Unspecified = "unspecified", e.Simple = "simple", e.Matrix = "matrix", e.Label = "label", e.Form = "form", e.CommaDelimited = "commaDelimited", e.SpaceDelimited = "spaceDelimited", e.PipeDelimited = "pipeDelimited", e.DeepObject = "deepObject", e.TabDelimited = "tabDelimited";
})(bb || (bb = {}));
var e0;
(function(e) {
  e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Information = 2] = "Information", e[e.Hint = 3] = "Hint";
})(e0 || (e0 = {}));
var xb;
(function(e) {
  e.Article = "article", e.HttpService = "http_service", e.HttpServer = "http_server", e.HttpOperation = "http_operation", e.HttpCallback = "http_callback", e.Model = "model", e.Generic = "generic", e.Unknown = "unknown", e.TableOfContents = "table_of_contents", e.SpectralRuleset = "spectral_ruleset", e.Styleguide = "styleguide", e.Image = "image", e.StoplightResolutions = "stoplight_resolutions", e.StoplightOverride = "stoplight_override";
})(xb || (xb = {}));
var _b;
(function(e) {
  e.Json = "json", e.Markdown = "markdown", e.Yaml = "yaml", e.Javascript = "javascript", e.Apng = "apng", e.Avif = "avif", e.Bmp = "bmp", e.Gif = "gif", e.Jpeg = "jpeg", e.Png = "png", e.Svg = "svg", e.Webp = "webp";
})(_b || (_b = {}));
var kh, wb;
function fM() {
  if (wb) return kh;
  wb = 1, kh = p;
  var e = "";
  const t = /[\x00-\x1f\x22\x5c]/, n = /[\x00-\x1f\x22\x5c]/g, r = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000b",
    "\\f",
    "\\r",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\"
  ];
  function i(g) {
    return r[g.charCodeAt(0)];
  }
  function a(g) {
    if (g.length < 5e3 && !t.test(g))
      return g;
    if (g.length > 100)
      return g.replace(n, i);
    for (var b = "", w = 0, y = 0; y < g.length; y++) {
      const v = g.charCodeAt(y);
      (v === 34 || v === 92 || v < 32) && (w === y ? b += r[v] : b += `${g.slice(w, y)}${r[v]}`, w = y + 1);
    }
    return w === 0 ? b = g : w !== y && (b += g.slice(w)), b;
  }
  function o(g, b, w, y, v) {
    var _, E, O;
    const M = e;
    var L = b[g];
    switch (typeof L == "object" && L !== null && typeof L.toJSON == "function" && (L = L.toJSON(g)), L = y.call(b, g, L), typeof L) {
      case "object":
        if (L === null)
          return "null";
        for (_ = 0; _ < w.length; _++)
          if (w[_] === L)
            return '"[Circular]"';
        if (Array.isArray(L)) {
          if (L.length === 0)
            return "[]";
          for (w.push(L), E = "[", e += v, E += `
${e}`, O = `,
${e}`, _ = 0; _ < L.length - 1; _++) {
            const re = o(_, L, w, y, v);
            E += re !== void 0 ? re : "null", E += O;
          }
          const ae = o(_, L, w, y, v);
          return E += ae !== void 0 ? ae : "null", e !== "" && (E += `
${M}`), E += "]", w.pop(), e = M, E;
        }
        var Z = f(Object.keys(L));
        if (Z.length === 0)
          return "{}";
        w.push(L), E = "{", e += v, E += `
${e}`, O = `,
${e}`;
        var Q = "";
        for (_ = 0; _ < Z.length; _++) {
          g = Z[_];
          const ae = o(g, L, w, y, v);
          ae !== void 0 && (E += `${Q}"${a(g)}": ${ae}`, Q = O);
        }
        return Q !== "" ? E += `
${M}` : E = "{", E += "}", w.pop(), e = M, E;
      case "string":
        return `"${a(L)}"`;
      case "number":
        return isFinite(L) ? String(L) : "null";
      case "boolean":
        return L === !0 ? "true" : "false";
    }
  }
  function c(g, b, w, y, v) {
    var _, E, O;
    const M = e;
    switch (typeof b == "object" && b !== null && typeof b.toJSON == "function" && (b = b.toJSON(g)), typeof b) {
      case "object":
        if (b === null)
          return "null";
        for (_ = 0; _ < w.length; _++)
          if (w[_] === b)
            return '"[Circular]"';
        if (Array.isArray(b)) {
          if (b.length === 0)
            return "[]";
          for (w.push(b), E = "[", e += v, E += `
${e}`, O = `,
${e}`, _ = 0; _ < b.length - 1; _++) {
            const Q = c(_, b[_], w, y, v);
            E += Q !== void 0 ? Q : "null", E += O;
          }
          const Z = c(_, b[_], w, y, v);
          return E += Z !== void 0 ? Z : "null", e !== "" && (E += `
${M}`), E += "]", w.pop(), e = M, E;
        }
        if (y.length === 0)
          return "{}";
        w.push(b), E = "{", e += v, E += `
${e}`, O = `,
${e}`;
        var L = "";
        for (_ = 0; _ < y.length; _++)
          if (typeof y[_] == "string" || typeof y[_] == "number") {
            g = y[_];
            const Z = c(g, b[g], w, y, v);
            Z !== void 0 && (E += `${L}"${a(g)}": ${Z}`, L = O);
          }
        return L !== "" ? E += `
${M}` : E = "{", E += "}", w.pop(), e = M, E;
      case "string":
        return `"${a(b)}"`;
      case "number":
        return isFinite(b) ? String(b) : "null";
      case "boolean":
        return b === !0 ? "true" : "false";
    }
  }
  function u(g, b, w, y) {
    var v, _, E;
    const O = e;
    switch (typeof b) {
      case "object":
        if (b === null)
          return "null";
        if (typeof b.toJSON == "function") {
          if (b = b.toJSON(g), typeof b != "object")
            return u(g, b, w, y);
          if (b === null)
            return "null";
        }
        for (v = 0; v < w.length; v++)
          if (w[v] === b)
            return '"[Circular]"';
        if (Array.isArray(b)) {
          if (b.length === 0)
            return "[]";
          for (w.push(b), _ = "[", e += y, _ += `
${e}`, E = `,
${e}`, v = 0; v < b.length - 1; v++) {
            const Q = u(v, b[v], w, y);
            _ += Q !== void 0 ? Q : "null", _ += E;
          }
          const Z = u(v, b[v], w, y);
          return _ += Z !== void 0 ? Z : "null", e !== "" && (_ += `
${O}`), _ += "]", w.pop(), e = O, _;
        }
        var M = f(Object.keys(b));
        if (M.length === 0)
          return "{}";
        w.push(b), _ = "{", e += y, _ += `
${e}`, E = `,
${e}`;
        var L = "";
        for (v = 0; v < M.length; v++) {
          g = M[v];
          const Z = u(g, b[g], w, y);
          Z !== void 0 && (_ += `${L}"${a(g)}": ${Z}`, L = E);
        }
        return L !== "" ? _ += `
${O}` : _ = "{", _ += "}", w.pop(), e = O, _;
      case "string":
        return `"${a(b)}"`;
      case "number":
        return isFinite(b) ? String(b) : "null";
      case "boolean":
        return b === !0 ? "true" : "false";
    }
  }
  function s(g, b, w, y) {
    var v, _;
    switch (typeof b == "object" && b !== null && typeof b.toJSON == "function" && (b = b.toJSON(g)), typeof b) {
      case "object":
        if (b === null)
          return "null";
        for (v = 0; v < w.length; v++)
          if (w[v] === b)
            return '"[Circular]"';
        if (Array.isArray(b)) {
          if (b.length === 0)
            return "[]";
          for (w.push(b), _ = "[", v = 0; v < b.length - 1; v++) {
            const M = s(v, b[v], w, y);
            _ += M !== void 0 ? M : "null", _ += ",";
          }
          const O = s(v, b[v], w, y);
          return _ += O !== void 0 ? O : "null", _ += "]", w.pop(), _;
        }
        if (y.length === 0)
          return "{}";
        w.push(b), _ = "{";
        var E = "";
        for (v = 0; v < y.length; v++)
          if (typeof y[v] == "string" || typeof y[v] == "number") {
            g = y[v];
            const O = s(g, b[g], w, y);
            O !== void 0 && (_ += `${E}"${a(g)}":${O}`, E = ",");
          }
        return _ += "}", w.pop(), _;
      case "string":
        return `"${a(b)}"`;
      case "number":
        return isFinite(b) ? String(b) : "null";
      case "boolean":
        return b === !0 ? "true" : "false";
    }
  }
  function l(g, b, w, y) {
    var v, _, E = b[g];
    switch (typeof E == "object" && E !== null && typeof E.toJSON == "function" && (E = E.toJSON(g)), E = y.call(b, g, E), typeof E) {
      case "object":
        if (E === null)
          return "null";
        for (v = 0; v < w.length; v++)
          if (w[v] === E)
            return '"[Circular]"';
        if (Array.isArray(E)) {
          if (E.length === 0)
            return "[]";
          for (w.push(E), _ = "[", v = 0; v < E.length - 1; v++) {
            const Z = l(v, E, w, y);
            _ += Z !== void 0 ? Z : "null", _ += ",";
          }
          const L = l(v, E, w, y);
          return _ += L !== void 0 ? L : "null", _ += "]", w.pop(), _;
        }
        var O = f(Object.keys(E));
        if (O.length === 0)
          return "{}";
        w.push(E), _ = "{";
        var M = "";
        for (v = 0; v < O.length; v++) {
          g = O[v];
          const L = l(g, E, w, y);
          L !== void 0 && (_ += `${M}"${a(g)}":${L}`, M = ",");
        }
        return _ += "}", w.pop(), _;
      case "string":
        return `"${a(E)}"`;
      case "number":
        return isFinite(E) ? String(E) : "null";
      case "boolean":
        return E === !0 ? "true" : "false";
    }
  }
  function d(g, b, w) {
    var y, v;
    switch (typeof b) {
      case "object":
        if (b === null)
          return "null";
        if (typeof b.toJSON == "function") {
          if (b = b.toJSON(g), typeof b != "object")
            return d(g, b, w);
          if (b === null)
            return "null";
        }
        for (y = 0; y < w.length; y++)
          if (w[y] === b)
            return '"[Circular]"';
        if (Array.isArray(b)) {
          if (b.length === 0)
            return "[]";
          for (w.push(b), v = "[", y = 0; y < b.length - 1; y++) {
            const M = d(y, b[y], w);
            v += M !== void 0 ? M : "null", v += ",";
          }
          const O = d(y, b[y], w);
          return v += O !== void 0 ? O : "null", v += "]", w.pop(), v;
        }
        var _ = f(Object.keys(b));
        if (_.length === 0)
          return "{}";
        w.push(b);
        var E = "";
        for (v = "{", y = 0; y < _.length; y++) {
          g = _[y];
          const O = d(g, b[g], w);
          O !== void 0 && (v += `${E}"${a(g)}":${O}`, E = ",");
        }
        return v += "}", w.pop(), v;
      case "string":
        return `"${a(b)}"`;
      case "number":
        return isFinite(b) ? String(b) : "null";
      case "boolean":
        return b === !0 ? "true" : "false";
    }
  }
  function f(g) {
    for (var b = 1; b < g.length; b++) {
      const y = g[b];
      for (var w = b; w !== 0 && g[w - 1] > y; )
        g[w] = g[w - 1], w--;
      g[w] = y;
    }
    return g;
  }
  function p(g, b, w) {
    var y, v = "";
    if (e = "", arguments.length > 1) {
      if (typeof w == "number")
        for (y = 0; y < w; y += 1)
          v += " ";
      else typeof w == "string" && (v = w);
      if (v !== "") {
        if (b != null) {
          if (typeof b == "function")
            return o("", { "": g }, [], b, v);
          if (Array.isArray(b))
            return c("", g, [], b, v);
        }
        return u("", g, [], v);
      }
      if (typeof b == "function")
        return l("", { "": g }, [], b);
      if (Array.isArray(b))
        return s("", g, [], b);
    }
    return d("", g, []);
  }
  return kh;
}
var Ah, Sb;
function pM() {
  if (Sb) return Ah;
  Sb = 1;
  const e = fM();
  return Ah = e, e.default = e, Ah;
}
var dM = pM();
const hM = /* @__PURE__ */ h2(dM);
function _u(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype || typeof e.constructor == "function" && Function.toString.call(Object) === Function.toString.call(e.constructor);
}
function mM(e, t, n) {
  if (!_u(e) && !Array.isArray(e) || !(t in e)) throw new ReferenceError(`Could not resolve '${n}'`);
}
function $6(e) {
  if (typeof e.$ref != "string") throw new TypeError("$ref should be a string");
}
const t0 = (e) => _u(e) && "$ref" in e, QC = (e) => t0(e) && typeof e.$ref == "string", L0 = (e) => e.length > 0 && (e === "#" || /^#\S*$/.test(e)), ks = (e, t, n) => {
  const r = e.toString();
  let i = "", a = r, o = 0, c = a.indexOf(t);
  for (; c > -1; ) i += r.substring(o, o + c) + n, a = a.substring(c + t.length, a.length), o += c + t.length, c = a.indexOf(t);
  return a.length > 0 && (i += r.substring(r.length - a.length, r.length)), i;
}, lf = (e) => typeof e == "number" ? e : ks(ks(e, "~", "~0"), "/", "~1"), gM = /[^a-zA–Z0–9_.!~*'()\/\-\u{D800}-\u{DFFF}]/gu;
function XC(e) {
  return e.replace(gM, encodeURIComponent);
}
const ek = (e) => {
  const t = lf(e);
  return typeof t == "number" ? t : XC(t);
}, r0 = (e) => vM(e), vM = (e) => {
  if (e && typeof e != "object") throw new TypeError("Invalid type: path must be an array of segments.");
  return e.length === 0 ? "#" : `#/${e.map(ek).join("/")}`;
};
function yM(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}
const bM = /%[0-9a-f]+/gi, L6 = (e) => {
  let t;
  try {
    t = decodeURIComponent(e);
  } catch {
    t = e.replace(bM, yM);
  }
  return ks(ks(t, "~1", "/"), "~0", "~");
}, Ia = (e) => xM(e), xM = (e) => {
  if (typeof e != "string") throw new TypeError("Invalid type: JSON Pointers are represented as strings.");
  if (e.length === 0 || e[0] !== "#") throw new URIError("Invalid JSON Pointer syntax; URI fragment identifiers must begin with a hash.");
  if (e.length === 1) return [];
  if (e[1] !== "/") throw new URIError("Invalid JSON Pointer syntax.");
  return ((t) => {
    const n = t.length, r = [];
    let i = -1;
    for (; ++i < n; ) r.push(L6(t[i]));
    return r;
  })(e.substring(2).split("/"));
}, tk = (e, t, n) => {
  const r = { value: e, path: n };
  t.onEnter && t.onEnter(r);
  for (const i of Object.keys(e)) {
    const a = e[i];
    t.onProperty && t.onProperty({ parent: e, parentPath: n, property: i, propertyValue: a }), typeof a == "object" && a !== null && tk(a, t, n.concat(i));
  }
  t.onLeave && t.onLeave(r);
}, b2 = (e, t) => {
  typeof e == "object" && e !== null && tk(e, typeof t == "function" ? { onProperty: t } : t, []);
};
function rk(e, t, n) {
  b2(e, { onProperty({ property: r, propertyValue: i, parent: a }) {
    r === "$ref" && typeof i == "string" && i.startsWith(t) && (a.$ref = `${n}${i.slice(t.length)}`);
  } });
}
const nk = (e) => e.length > 0 && e[0] !== "#", x2 = (e) => {
  if (typeof e != "string" || e.length === 0 || !nk(e)) return null;
  const t = e.indexOf("#");
  return t === -1 ? e : e.slice(0, t);
};
function ik(e, t) {
  return _u(t) && _u(e) && ("summary" in e || "description" in e) ? Object.assign(Object.assign(Object.assign({}, t), "description" in e ? { description: e.description } : null), "summary" in e ? { summary: e.summary } : null) : t;
}
function* ak(e, t, n) {
  t0(e.value) && ($6(e.value), yield [-1, e.value]);
  for (const [r, i] of t.entries()) mM(e.value, i, n), e.value = e.value[i], t0(e.value) && ($6(e.value), yield [r, e.value]);
}
function ok(e, t) {
  return sk(e, t).value;
}
function sk(e, t) {
  return (function n(r, i, a, o) {
    if (x2(i) !== null) throw new ReferenceError("Cannot resolve external references");
    const c = Ia(i);
    let u = [...c];
    i === "#" && t0(r) && ($6(r), c.unshift(...Ia(r.$ref)));
    const s = { value: r };
    for (const [l, d] of ak(s, c, i)) {
      if (a.includes(d)) return { source: null, location: o ?? u, value: a[a.length - 1] };
      a.push(d);
      const f = n(r, d.$ref, a, u);
      s.value = f.value, (u = f.location).push(...c.slice(l + 1));
    }
    return { source: null, location: u, value: a.length > 0 ? ik(a[a.length - 1], s.value) : s.value };
  })(e, t, []);
}
const _M = "#/__bundled__", wM = "#/__errors__", SM = ({ document: e, path: t, bundleRoot: n = "#/__bundled__", errorsRoot: r = "#/__errors__", cloneDocument: i = !0, keyProvider: a }, o) => {
  if (t === n || t === r) throw new Error("Roots do not make any sense");
  const c = i ? mi.cloneDeep(e) : e;
  return CM(c, Ia(n), Ia(r), t, a)(t, { [t]: !0 }, o);
}, CM = (e, t, n, r, i) => {
  const a = /* @__PURE__ */ new Set(), o = (c, u, s, l = {}, d = {}, f = {}) => {
    const p = Ia(c), g = mi.get(e, p);
    b2(s || g, { onEnter: ({ value: w }) => {
      if (QC(w) && L0(w.$ref)) {
        const y = w.$ref;
        if (f[y]) return;
        if (y === c && (l[y] = "#"), l[y]) return void (w.$ref = l[y]);
        let v, _, E, O, M;
        try {
          let L;
          v = Ia(y), i && (L = i({ document: e, path: v })), L || (L = (({ document: Q, path: ae }) => ae.length === 0 ? "root" : Array.isArray(mi.get(Q, ae.slice(0, -1))) ? `${ae[ae.length - 2]}_${ae[ae.length - 1]}` : String(ae[ae.length - 1]))({ document: e, path: v })), E = L;
          let Z = 1;
          for (; a.has(E); ) if (E = `${L}_${++Z}`, Z > 20) throw new Error(`Keys ${L}_2 through ${L}_20 already taken.`);
          a.add(E), _ = [...t, E], O = r0(_);
        } catch (L) {
          f[y] = L instanceof Error ? L.message : String(L);
        }
        if (!v || !_ || !O) return;
        if (typeof e == "object" && e !== null && !(M = mi.get(e, v))) try {
          M = ok(Object(e), y);
        } catch {
        }
        M !== void 0 && (l[y] = O, w.$ref = O, mi.has(d, _) || (Array.isArray(M) ? mi.set(d, _, new Array(M.length).fill(null)) : typeof M == "object" && mi.setWith(d, _, {}, Object), mi.set(d, _, M), y === "#" ? (function(L, Z, Q, ae) {
          const re = Q.map((Ce) => `[${JSON.stringify(Ce)}]`).join(""), X = JSON.parse(JSON.stringify(mi.omit(Object(L), re))), de = {};
          mi.set(Z, ae, X), mi.set(X, Q, de), rk(X, "#", r0(ae)), de.$ref = "#";
        })(e, d, Ia(r), _) : u[y] || (u[y] = !0, o(c, u, M, l, d, f), u[y] = !1)));
      }
    } });
    const b = mi.get(d, t);
    return b && Object.keys(b).length && mi.set(g, t, b), (Object.keys(f).length || mi.has(e, n)) && mi.set(g, n, mi.has(e, n) ? mi.get(e, n) : f), g;
  };
  return o;
}, _2 = (e) => ks(ks(e, "~1", "/"), "~0", "~"), kM = (e, t) => {
  const n = /* @__PURE__ */ new WeakMap();
  return (function r(i, a) {
    let o;
    if (t && (i = t(i)), _u(i) || Array.isArray(i)) {
      const c = n.get(i);
      return c ? { $ref: c } : (n.set(i, r0(a)), Array.isArray(i) ? o = i.map((u, s) => r(u, [...a, String(s)])) : (o = {}, Object.keys(i).forEach((u) => {
        o[u] = r(i[u], [...a, u]);
      })), n.delete(i), o);
    }
    return i;
  })(e, []);
}, AM = (e) => ks(ks(e, "~", "~0"), "//", "/~1"), uk = (e) => {
  if (typeof e != "string" || e.length === 0) return null;
  const t = e.indexOf("#");
  return t === -1 ? null : e.slice(t);
}, EM = (e) => {
  const t = WF(e, !0);
  if (t.scan(), t.getToken() !== 1 || (t.scan(), t.getToken() === 2)) return;
  if (t.getToken() !== 10) throw new SyntaxError("Unexpected character");
  const n = t.getTokenValue();
  if (t.scan(), t.getToken() !== 6) throw new SyntaxError("Colon expected");
  switch (t.scan(), t.getToken()) {
    case 10:
      return [n, t.getTokenValue()];
    case 11:
      return [n, Number(t.getTokenValue())];
    case 8:
      return [n, !0];
    case 9:
      return [n, !1];
    case 7:
      return [n, null];
    case 16:
      throw new SyntaxError("Unexpected character");
    case 17:
      throw new SyntaxError("Unexpected end of file");
    default:
      return;
  }
}, OM = ({ lineMap: e, ast: t }, n) => {
  const r = e[n.line], i = e[n.line + 1];
  if (r === void 0) return;
  const a = KF(t, i === void 0 ? r + n.character : Math.min(i, r + n.character), !0);
  if (a === void 0) return;
  const o = ZF(a);
  return o.length !== 0 ? o : void 0;
};
function TM(e) {
  return _2(e.split("/").pop() || "");
}
const PM = ({ ast: e }, t, n = !1) => {
  const r = (function(i, a, o) {
    e: for (const c of a) {
      const u = Number.isInteger(Number(c)) ? Number(c) : c;
      if (typeof u == "string" || typeof u == "number" && i.type !== "array") {
        if (i.type !== "object" || !Array.isArray(i.children)) return o ? i : void 0;
        for (const s of i.children) if (Array.isArray(s.children) && s.children[0].value === String(u) && s.children.length === 2) {
          i = s.children[1];
          continue e;
        }
        return o ? i : void 0;
      }
      if (i.type !== "array" || u < 0 || !Array.isArray(i.children) || u >= i.children.length) return o ? i : void 0;
      i = i.children[u];
    }
    return i;
  })(e, t, n);
  if (r !== void 0 && r.range !== void 0) return { range: r.range };
}, RM = (e, t = { disallowComments: !0 }) => {
  const n = [], { ast: r, data: i, lineMap: a } = ck(e, n, t);
  return { data: i, diagnostics: n, ast: r, lineMap: a };
};
function ck(e, t = [], n) {
  const r = jM(e);
  let i = { type: "array", offset: -1, length: -1, children: [], parent: void 0 }, a = null, o = [];
  const c = /* @__PURE__ */ new WeakMap(), u = [];
  function s(w) {
    i.type === "property" && (i.length = w - i.offset, i = i.parent);
  }
  function l(w, y, v) {
    return { start: { line: w, character: y }, end: { line: w, character: y + v } };
  }
  function d(w) {
    return i.children.push(w), w;
  }
  function f(w) {
    Array.isArray(o) ? o.push(w) : a !== null && (o[a] = w);
  }
  function p(w) {
    f(w), u.push(o), o = w, a = null;
  }
  function g() {
    o = u.pop();
  }
  YF(e, { onObjectBegin: (w, y, v, _) => {
    i = d({ type: "object", offset: w, length: -1, parent: i, children: [], range: l(v, _, y) }), n.ignoreDuplicateKeys === !1 && c.set(i, []), p((function(E) {
      return E ? iM({}) : {};
    })(n.preserveKeyOrder === !0));
  }, onObjectProperty: (w, y, v, _, E) => {
    if ((i = d({ type: "property", offset: y, length: -1, parent: i, children: [] })).children.push({ type: "string", value: w, offset: y, length: v, parent: i }), n.ignoreDuplicateKeys === !1) {
      const O = c.get(i.parent);
      O && (O.length !== 0 && O.includes(w) ? t.push({ range: l(_, E, v), message: "DuplicateKey", severity: e0.Error, path: lk(i), code: 20 }) : O.push(w));
    }
    n.preserveKeyOrder === !0 && (function(O, M) {
      if (!(M in O)) return;
      const L = oM(O), Z = L.indexOf(M);
      Z !== -1 && (L.splice(Z, 1), L.push(M));
    })(o, w), a = w;
  }, onObjectEnd: (w, y, v, _) => {
    n.ignoreDuplicateKeys === !1 && c.delete(i), i.length = w + y - i.offset, i.range && (i.range.end.line = v, i.range.end.character = _ + y), i = i.parent, s(w + y), g();
  }, onArrayBegin: (w, y, v, _) => {
    i = d({ type: "array", offset: w, length: -1, parent: i, children: [], range: l(v, _, y) }), p([]);
  }, onArrayEnd: (w, y, v, _) => {
    i.length = w + y - i.offset, i.range && (i.range.end.line = v, i.range.end.character = _ + y), i = i.parent, s(w + y), g();
  }, onLiteralValue: (w, y, v, _, E) => {
    d({ type: IM(w), offset: y, length: v, parent: i, value: w, range: l(_, E, v) }), s(y + v), f(w);
  }, onSeparator: (w, y) => {
    i.type === "property" && (w === ":" ? i.colonOffset = y : w === "," && s(y));
  }, onError: (w, y, v, _, E) => {
    t.push({ range: l(_, E, v), message: JF(w), severity: e0.Error, code: w });
  } }, n);
  const b = i.children[0];
  return b && delete b.parent, { ast: b, data: o[0], lineMap: r };
}
function IM(e) {
  switch (typeof e) {
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    default:
      return "null";
  }
}
const jM = (e) => {
  const t = [0];
  let n = 0;
  for (; n < e.length; n++) e[n] === `
` && t.push(n + 1);
  return t.push(n + 1), t;
};
function lk(e, t = []) {
  return e.type === "property" && t.unshift(e.children[0].value), e.parent !== void 0 ? (e.parent.type === "array" && e.parent.parent !== void 0 && t.unshift(e.parent.children.indexOf(e)), lk(e.parent, t)) : t;
}
const qM = (e, t, n) => {
  if (!e || !Object.hasOwnProperty.call(e, t) || t === n) return e;
  const r = {};
  for (const [i, a] of Object.entries(e)) i === t ? r[n] = a : i in r || (r[i] = a);
  return r;
};
function Zp(e) {
  return _u(e) || Array.isArray(e);
}
function DM(e, t, n) {
  if (n.length <= 1 || t.length <= 1) throw Error("Source/target path must not be empty and point at root");
  if (t.indexOf(n) === 0) throw Error("Target path cannot be contained within source");
  const r = Ia(t);
  let i = e;
  for (const c of r) {
    if (!Zp(i)) return;
    i = i[c];
  }
  if (!Zp(i)) return;
  const a = Ia(n);
  let o = e;
  for (const [c, u] of a.entries()) {
    if (!Zp(o) || u in o) return;
    const s = c === a.length - 1 ? i : {};
    o[u] = s, o = s;
  }
  delete e[r[0]], (function c(u, s, l) {
    for (const d of Object.keys(u)) {
      const f = u[d];
      if (d !== "$ref") Zp(f) && c(f, s, l);
      else {
        if (typeof f != "string" || !L0(f)) continue;
        f.indexOf(s) === 0 && (u[d] = f.replace(s, l));
      }
    }
  })(e, t, n);
}
async function fk(e, t, n, r, i) {
  let a = (function(d, f) {
    const p = x2(f);
    return p === null ? d : HF(p) ? p : zF(UF(d), p);
  })(t, n);
  const o = uk(n) || "#", c = await e[a], u = Ia(o);
  let s = [...u];
  const l = { value: c };
  for (const [d, f] of ak(l, u, o)) {
    if (r.includes(f)) return { source: t, location: i ?? s, value: r[r.length - 1] };
    r.push(f);
    const p = await fk(e, a, f.$ref, r, s);
    ({ source: a, location: s } = p), l.value = p.value, s.push(...u.slice(d + 1));
  }
  return { source: a, location: s, value: r.length > 0 ? ik(r[r.length - 1], l.value) : l.value };
}
async function $M(e, t, n) {
  return (await pk(e, t, n)).value;
}
function pk(e, t, n) {
  return fk(e, t, n, []);
}
const LM = (e, t) => {
  if (typeof e != "string") return e;
  try {
    const n = NM(e);
    return typeof n == "string" ? n : JSON.parse(e, t);
  } catch {
    return;
  }
}, NM = (e) => {
  const t = Number(e);
  return Number.isFinite(t) ? String(t) === e ? t : e : NaN;
}, dk = (e, t, n) => {
  if (typeof e == "string") return e;
  try {
    return JSON.stringify(e, t, n);
  } catch {
    return hM(e, t, n);
  }
}, FM = (e, t) => {
  if (e instanceof Array) {
    if (t instanceof Array) {
      if (t.length > e.length) return !1;
      for (const n in t) {
        if (!t.hasOwnProperty(n)) continue;
        const r = parseInt(e[n]), i = parseInt(t[n]);
        if (isNaN(r) && isNaN(i)) {
          if (e[n] !== t[n]) return !1;
        } else if (r !== i) return !1;
      }
    }
  } else {
    if (typeof e != "string") return !1;
    if (typeof t == "string") return e.startsWith(t);
  }
  return !0;
}, MM = (e, t, n) => {
  const r = dk(e, t, n);
  if (r === void 0) throw new Error("The value could not be stringified");
  return r;
};
function BM(e) {
  return e.replace(/^(\/|#\/)/, "").split("/").map(_2).map(UM).join(".");
}
function UM(e) {
  return e.includes(".") ? `["${e.replace(/"/g, '\\"')}"]` : e;
}
const N6 = Symbol.for(JC), HM = { ownKeys: (e) => N6 in e ? e[N6] : Reflect.ownKeys(e) }, zM = (e) => new Proxy(e, HM);
function VM(e, t) {
  if (typeof e == "string" && typeof t == "string") return mi.trimStart(e, t);
  if (!(e && Array.isArray(e) && e.length && t && Array.isArray(t) && t.length)) return e;
  let n = 0;
  for (const r in e) if (e.hasOwnProperty(r)) {
    if (e[r] !== t[r]) break;
    n++;
  }
  return e.slice(n);
}
const GM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BUNDLE_ROOT: _M,
  ERRORS_ROOT: wM,
  KEYS: N6,
  bundleTarget: SM,
  decodePointer: L6,
  decodePointerFragment: _2,
  decodePointerUriFragment: L6,
  decycle: kM,
  encodePointer: AM,
  encodePointerFragment: lf,
  encodePointerUriFragment: ek,
  encodeUriPointer: XC,
  extractPointerFromRef: uk,
  extractSourceFromRef: x2,
  getFirstPrimitiveProperty: EM,
  getJsonPathForPosition: OM,
  getLastPathSegment: TM,
  getLocationForJsonPath: PM,
  hasRef: QC,
  isExternalRef: nk,
  isLocalRef: L0,
  isPlainObject: _u,
  parseTree: ck,
  parseWithPointers: RM,
  pathToPointer: r0,
  pointerToPath: Ia,
  remapRefs: rk,
  renameObjectKey: qM,
  reparentBundleTarget: DM,
  resolveExternalRef: $M,
  resolveExternalRefWithLocation: pk,
  resolveInlineRef: ok,
  resolveInlineRefWithLocation: sk,
  safeParse: LM,
  safeStringify: dk,
  startsWith: FM,
  stringify: MM,
  toPropertyPath: BM,
  trapAccess: zM,
  traverse: b2,
  trimStart: VM
}, Symbol.toStringTag, { value: "Module" }));
var Eh = {}, F6 = function(e, t) {
  return F6 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, F6(e, t);
};
function hk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  F6(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var n0 = function() {
  return n0 = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, n0.apply(this, arguments);
};
function mk(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function gk(e, t, n, r) {
  var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
  else for (var c = e.length - 1; c >= 0; c--) (o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
  return i > 3 && a && Object.defineProperty(t, n, a), a;
}
function vk(e, t) {
  return function(n, r) {
    t(n, r, e);
  };
}
function yk(e, t, n, r, i, a) {
  function o(y) {
    if (y !== void 0 && typeof y != "function") throw new TypeError("Function expected");
    return y;
  }
  for (var c = r.kind, u = c === "getter" ? "get" : c === "setter" ? "set" : "value", s = !t && e ? r.static ? e : e.prototype : null, l = t || (s ? Object.getOwnPropertyDescriptor(s, r.name) : {}), d, f = !1, p = n.length - 1; p >= 0; p--) {
    var g = {};
    for (var b in r) g[b] = b === "access" ? {} : r[b];
    for (var b in r.access) g.access[b] = r.access[b];
    g.addInitializer = function(y) {
      if (f) throw new TypeError("Cannot add initializers after decoration has completed");
      a.push(o(y || null));
    };
    var w = (0, n[p])(c === "accessor" ? { get: l.get, set: l.set } : l[u], g);
    if (c === "accessor") {
      if (w === void 0) continue;
      if (w === null || typeof w != "object") throw new TypeError("Object expected");
      (d = o(w.get)) && (l.get = d), (d = o(w.set)) && (l.set = d), (d = o(w.init)) && i.unshift(d);
    } else (d = o(w)) && (c === "field" ? i.unshift(d) : l[u] = d);
  }
  s && Object.defineProperty(s, r.name, l), f = !0;
}
function bk(e, t, n) {
  for (var r = arguments.length > 2, i = 0; i < t.length; i++)
    n = r ? t[i].call(e, n) : t[i].call(e);
  return r ? n : void 0;
}
function xk(e) {
  return typeof e == "symbol" ? e : "".concat(e);
}
function _k(e, t, n) {
  return typeof t == "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", { configurable: !0, value: n ? "".concat(n, " ", t) : t });
}
function wk(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function Sk(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function c(l) {
      try {
        s(r.next(l));
      } catch (d) {
        o(d);
      }
    }
    function u(l) {
      try {
        s(r.throw(l));
      } catch (d) {
        o(d);
      }
    }
    function s(l) {
      l.done ? a(l.value) : i(l.value).then(c, u);
    }
    s((r = r.apply(e, t || [])).next());
  });
}
function Ck(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = c(0), o.throw = c(1), o.return = c(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function c(s) {
    return function(l) {
      return u([s, l]);
    };
  }
  function u(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (n = 0)), n; ) try {
      if (r = 1, i && (a = s[0] & 2 ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
      switch (i = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
        case 0:
        case 1:
          a = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = s;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(s);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      r = a = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var N0 = Object.create ? (function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
}) : (function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
});
function kk(e, t) {
  for (var n in e) n !== "default" && !Object.prototype.hasOwnProperty.call(t, n) && N0(t, e, n);
}
function i0(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function w2(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) a.push(i.value);
  } catch (c) {
    o = { error: c };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function Ak() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(w2(arguments[t]));
  return e;
}
function Ek() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var a = arguments[t], o = 0, c = a.length; o < c; o++, i++)
      r[i] = a[o];
  return r;
}
function Ok(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function fc(e) {
  return this instanceof fc ? (this.v = e, this) : new fc(e);
}
function Tk(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, a = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), c("next"), c("throw"), c("return", o), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(p) {
    return function(g) {
      return Promise.resolve(g).then(p, d);
    };
  }
  function c(p, g) {
    r[p] && (i[p] = function(b) {
      return new Promise(function(w, y) {
        a.push([p, b, w, y]) > 1 || u(p, b);
      });
    }, g && (i[p] = g(i[p])));
  }
  function u(p, g) {
    try {
      s(r[p](g));
    } catch (b) {
      f(a[0][3], b);
    }
  }
  function s(p) {
    p.value instanceof fc ? Promise.resolve(p.value.v).then(l, d) : f(a[0][2], p);
  }
  function l(p) {
    u("next", p);
  }
  function d(p) {
    u("throw", p);
  }
  function f(p, g) {
    p(g), a.shift(), a.length && u(a[0][0], a[0][1]);
  }
}
function Pk(e) {
  var t, n;
  return t = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function r(i, a) {
    t[i] = e[i] ? function(o) {
      return (n = !n) ? { value: fc(e[i](o)), done: !1 } : a ? a(o) : o;
    } : a;
  }
}
function Rk(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof i0 == "function" ? i0(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(a) {
    n[a] = e[a] && function(o) {
      return new Promise(function(c, u) {
        o = e[a](o), i(c, u, o.done, o.value);
      });
    };
  }
  function i(a, o, c, u) {
    Promise.resolve(u).then(function(s) {
      a({ value: s, done: c });
    }, o);
  }
}
function Ik(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var WM = Object.create ? (function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
}) : function(e, t) {
  e.default = t;
}, M6 = function(e) {
  return M6 = Object.getOwnPropertyNames || function(t) {
    var n = [];
    for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[n.length] = r);
    return n;
  }, M6(e);
};
function jk(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n = M6(e), r = 0; r < n.length; r++) n[r] !== "default" && N0(t, e, n[r]);
  return WM(t, e), t;
}
function qk(e) {
  return e && e.__esModule ? e : { default: e };
}
function Dk(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function $k(e, t, n, r, i) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function Lk(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
function Nk(e, t, n) {
  if (t != null) {
    if (typeof t != "object" && typeof t != "function") throw new TypeError("Object expected.");
    var r, i;
    if (n) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r = t[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r = t[Symbol.dispose], n && (i = r);
    }
    if (typeof r != "function") throw new TypeError("Object not disposable.");
    i && (r = function() {
      try {
        i.call(this);
      } catch (a) {
        return Promise.reject(a);
      }
    }), e.stack.push({ value: t, dispose: r, async: n });
  } else n && e.stack.push({ async: !0 });
  return t;
}
var KM = typeof SuppressedError == "function" ? SuppressedError : function(e, t, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = e, r.suppressed = t, r;
};
function Fk(e) {
  function t(a) {
    e.error = e.hasError ? new KM(a, e.error, "An error was suppressed during disposal.") : a, e.hasError = !0;
  }
  var n, r = 0;
  function i() {
    for (; n = e.stack.pop(); )
      try {
        if (!n.async && r === 1) return r = 0, e.stack.push(n), Promise.resolve().then(i);
        if (n.dispose) {
          var a = n.dispose.call(n.value);
          if (n.async) return r |= 2, Promise.resolve(a).then(i, function(o) {
            return t(o), i();
          });
        } else r |= 1;
      } catch (o) {
        t(o);
      }
    if (r === 1) return e.hasError ? Promise.reject(e.error) : Promise.resolve();
    if (e.hasError) throw e.error;
  }
  return i();
}
function Mk(e, t) {
  return typeof e == "string" && /^\.\.?\//.test(e) ? e.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(n, r, i, a, o) {
    return r ? t ? ".jsx" : ".js" : i && (!a || !o) ? n : i + a + "." + o.toLowerCase() + "js";
  }) : e;
}
const ZM = {
  __extends: hk,
  __assign: n0,
  __rest: mk,
  __decorate: gk,
  __param: vk,
  __esDecorate: yk,
  __runInitializers: bk,
  __propKey: xk,
  __setFunctionName: _k,
  __metadata: wk,
  __awaiter: Sk,
  __generator: Ck,
  __createBinding: N0,
  __exportStar: kk,
  __values: i0,
  __read: w2,
  __spread: Ak,
  __spreadArrays: Ek,
  __spreadArray: Ok,
  __await: fc,
  __asyncGenerator: Tk,
  __asyncDelegator: Pk,
  __asyncValues: Rk,
  __makeTemplateObject: Ik,
  __importStar: jk,
  __importDefault: qk,
  __classPrivateFieldGet: Dk,
  __classPrivateFieldSet: $k,
  __classPrivateFieldIn: Lk,
  __addDisposableResource: Nk,
  __disposeResources: Fk,
  __rewriteRelativeImportExtension: Mk
}, YM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: Nk,
  get __assign() {
    return n0;
  },
  __asyncDelegator: Pk,
  __asyncGenerator: Tk,
  __asyncValues: Rk,
  __await: fc,
  __awaiter: Sk,
  __classPrivateFieldGet: Dk,
  __classPrivateFieldIn: Lk,
  __classPrivateFieldSet: $k,
  __createBinding: N0,
  __decorate: gk,
  __disposeResources: Fk,
  __esDecorate: yk,
  __exportStar: kk,
  __extends: hk,
  __generator: Ck,
  __importDefault: qk,
  __importStar: jk,
  __makeTemplateObject: Ik,
  __metadata: wk,
  __param: vk,
  __propKey: xk,
  __read: w2,
  __rest: mk,
  __rewriteRelativeImportExtension: Mk,
  __runInitializers: bk,
  __setFunctionName: _k,
  __spread: Ak,
  __spreadArray: Ok,
  __spreadArrays: Ek,
  __values: i0,
  default: ZM
}, Symbol.toStringTag, { value: "Module" })), F0 = /* @__PURE__ */ q0(YM);
var Ba = {};
const Zn = /* @__PURE__ */ q0(GM);
var Ua = {}, Cb;
function Jn() {
  if (Cb) return Ua;
  Cb = 1, Object.defineProperty(Ua, "__esModule", { value: !0 }), Ua.isSerializablePrimitive = Ua.isString = Ua.isBoolean = Ua.isNonNullable = void 0;
  function e(i) {
    return i != null;
  }
  Ua.isNonNullable = e;
  function t(i) {
    return typeof i == "boolean";
  }
  Ua.isBoolean = t;
  function n(i) {
    return typeof i == "string";
  }
  Ua.isString = n;
  function r(i) {
    return t(i) || n(i) || typeof i == "number" || i === null;
  }
  return Ua.isSerializablePrimitive = r, Ua;
}
var Ha = {}, kb;
function Si() {
  if (kb) return Ha;
  kb = 1, Object.defineProperty(Ha, "__esModule", { value: !0 }), Ha.extractId = Ha.collectExplicitProperties = Ha.isEqual = Ha.entries = void 0;
  const e = Zn, t = Xn();
  function n(o) {
    return (0, e.isPlainObject)(o) ? Object.entries(o) : [];
  }
  Ha.entries = n;
  function r(o, c) {
    return (0, t.isEqualWith)(o, c, (u, s, l) => {
      if (l === "id")
        return !0;
    });
  }
  Ha.isEqual = r;
  function i(o) {
    return (0, e.isPlainObject)(o) ? Object.keys(o).filter((c) => c !== "x-stoplight") : [];
  }
  Ha.collectExplicitProperties = i;
  function a(o) {
    if ((0, e.isPlainObject)(o) && (0, e.isPlainObject)(o["x-stoplight"]) && typeof o["x-stoplight"].id == "string")
      return o["x-stoplight"].id;
  }
  return Ha.extractId = a, Ha;
}
var Fs = {}, Oh = {}, Th = {}, Ab;
function wc() {
  return Ab || (Ab = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.HttpOperationSecurityDeclarationTypes = void 0, (function(t) {
      t.None = "none", t.Declared = "declared", t.InheritedFromService = "inheritedFromService";
    })(e.HttpOperationSecurityDeclarationTypes || (e.HttpOperationSecurityDeclarationTypes = {})), e.HttpParamStyles = void 0, (function(t) {
      t.Unspecified = "unspecified", t.Simple = "simple", t.Matrix = "matrix", t.Label = "label", t.Form = "form", t.CommaDelimited = "commaDelimited", t.SpaceDelimited = "spaceDelimited", t.PipeDelimited = "pipeDelimited", t.DeepObject = "deepObject", t.TabDelimited = "tabDelimited";
    })(e.HttpParamStyles || (e.HttpParamStyles = {})), e.DiagnosticSeverity = void 0, (function(t) {
      t[t.Error = 0] = "Error", t[t.Warning = 1] = "Warning", t[t.Information = 2] = "Information", t[t.Hint = 3] = "Hint";
    })(e.DiagnosticSeverity || (e.DiagnosticSeverity = {})), e.NodeType = void 0, (function(t) {
      t.Article = "article", t.HttpService = "http_service", t.HttpServer = "http_server", t.HttpOperation = "http_operation", t.HttpCallback = "http_callback", t.Model = "model", t.Generic = "generic", t.Unknown = "unknown", t.TableOfContents = "table_of_contents", t.SpectralRuleset = "spectral_ruleset", t.Styleguide = "styleguide", t.Image = "image", t.StoplightResolutions = "stoplight_resolutions", t.StoplightOverride = "stoplight_override";
    })(e.NodeType || (e.NodeType = {})), e.NodeFormat = void 0, (function(t) {
      t.Json = "json", t.Markdown = "markdown", t.Yaml = "yaml", t.Javascript = "javascript", t.Apng = "apng", t.Avif = "avif", t.Bmp = "bmp", t.Gif = "gif", t.Jpeg = "jpeg", t.Png = "png", t.Svg = "svg", t.Webp = "webp";
    })(e.NodeFormat || (e.NodeFormat = {}));
  })(Th)), Th;
}
var Eb;
function Vi() {
  return Eb || (Eb = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isReferenceObject = e.isValidOas3ParamStyle = e.isValidOas3ParameterObject = e.isValidOas2ParameterObject = e.isValidParameterObject = e.hasXLogo = void 0;
    const t = Zn, n = /* @__PURE__ */ wc();
    function r(f) {
      return (0, t.isPlainObject)(f["x-logo"]);
    }
    e.hasXLogo = r;
    const i = ["query", "header", "path", "cookie"], a = ["query", "header", "path", "body", "formData"], o = Object.values(n.HttpParamStyles).filter((f) => ![n.HttpParamStyles.CommaDelimited, n.HttpParamStyles.TabDelimited].includes(f)), c = (f) => (0, t.isPlainObject)(f) && typeof f.name == "string" && typeof f.in == "string";
    e.isValidParameterObject = c;
    const u = (f) => (0, e.isValidParameterObject)(f) && a.includes(f.in);
    e.isValidOas2ParameterObject = u;
    const s = (f) => (0, e.isValidParameterObject)(f) && i.includes(f.in);
    e.isValidOas3ParameterObject = s;
    const l = (f) => o.includes(f);
    e.isValidOas3ParamStyle = l;
    function d(f) {
      return (0, t.hasRef)(f);
    }
    e.isReferenceObject = d;
  })(Oh)), Oh;
}
var Ph = {}, Ob;
function Ff() {
  return Ob || (Ob = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.OasVersion = void 0, (function(t) {
      t[t.OAS2 = 2] = "OAS2", t[t.OAS3 = 3] = "OAS3";
    })(e.OasVersion || (e.OasVersion = {}));
  })(Ph)), Ph;
}
var Tb;
function Ps() {
  if (Tb) return Fs;
  Tb = 1, Object.defineProperty(Fs, "__esModule", { value: !0 }), Fs.getExtensions = Fs.createOasParamsIterator = void 0;
  const e = /* @__PURE__ */ Si(), t = /* @__PURE__ */ Vi(), n = /* @__PURE__ */ Ff(), r = ["x-internal"], i = (c) => `${c.name}-${c.in}`;
  function a(c) {
    return function* (u, s) {
      var l;
      const d = /* @__PURE__ */ new Set(), { parentId: f, context: p } = this, g = Array.isArray(s.parameters) ? s.parameters : [], b = Array.isArray(u.parameters) ? u.parameters : [], w = [...g, ...b];
      for (let y = 0; y < w.length; y++) {
        this.context = y < g.length ? "operation" : "path", this.parentId = this.ids[this.context];
        const v = (l = this.maybeResolveLocalRef(w[y])) !== null && l !== void 0 ? l : w[y];
        if ((0, t.isReferenceObject)(v)) {
          yield w[y], this.context = p, this.parentId = f;
          continue;
        }
        if (!(c === n.OasVersion.OAS2 ? t.isValidOas2ParameterObject : t.isValidOas3ParameterObject)(v)) {
          this.context = p, this.parentId = f;
          continue;
        }
        const _ = i(v);
        if (d.has(_)) {
          this.context = p, this.parentId = f;
          continue;
        }
        d.add(_), yield v;
      }
      this.context = p, this.parentId = f;
    };
  }
  Fs.createOasParamsIterator = a;
  function o(c) {
    return Object.fromEntries((0, e.entries)(c).filter(([u]) => u.startsWith("x-") && !r.includes(u)));
  }
  return Fs.getExtensions = o, Fs;
}
var Yc = {}, Pb;
function S2() {
  if (Pb) return Yc;
  Pb = 1, Object.defineProperty(Yc, "__esModule", { value: !0 }), Yc.toExternalDocs = void 0;
  function e(i) {
    if (!i || typeof i != "object")
      return {};
    const a = n(i);
    if (a === void 0)
      return {};
    const o = r(i);
    return {
      externalDocs: {
        url: a,
        ...o ? { description: o } : {}
      }
    };
  }
  Yc.toExternalDocs = e;
  const t = /^\s*$/;
  function n(i) {
    const a = i?.url;
    if (!(!a || typeof a != "string" || t.test(a)))
      return a;
  }
  function r(i) {
    const a = i.description;
    if (!(!a || typeof a != "string" || t.test(a)))
      return a;
  }
  return Yc;
}
var Ms = {}, Bs = {}, Jc = {}, Rb;
function JM() {
  if (Rb) return Jc;
  Rb = 1, Object.defineProperty(Jc, "__esModule", { value: !0 }), Jc.idGenerators = void 0;
  const e = /* @__PURE__ */ Jn();
  function t(i) {
    return i.join("-");
  }
  function n(i) {
    return i.slice().sort((a, o) => a.localeCompare(o));
  }
  function r(i) {
    return i.replace(/({)[^}]+(?=})/g, "$1");
  }
  return Jc.idGenerators = {
    tag: (i) => t(["tag", i.name]),
    schema: (i) => t(["schema", i.parentId, i.key]),
    schemaProperty: (i) => t(["schema_property", i.parentId, String(i.key)]),
    example: (i) => t(["example", i.parentId, i.keyOrName]),
    httpPath: (i) => t(["http_path", i.parentId, r(i.path)]),
    httpWebhookName: (i) => t(["http_webhook_name", i.parentId, r(i.name)]),
    httpOperation: (i) => t(["http_operation", i.parentId, i.method, r(i.path)]),
    httpWebhookOperation: (i) => t(["http_webhook_operation", i.parentId, i.method, r(i.name)]),
    httpCallbackOperation: (i) => t(["http_callback", i.parentId, i.key, i.method, i.path]),
    httpPathParam: (i) => t(["http_path_param", i.parentId, i.keyOrName]),
    httpQuery: (i) => t(["http_query", i.parentId, i.keyOrName]),
    httpCookie: (i) => t(["http_cookie", i.parentId, i.keyOrName]),
    httpHeader: (i) => t(["http_header", i.parentId, i.componentType, i.keyOrName]),
    httpRequestBody: (i) => {
      const a = [
        "http_request_body",
        i.parentId,
        ...Array.isArray(i.consumes) ? n(i.consumes) : []
      ];
      return (0, e.isNonNullable)(i.key) && a.push(i.key), t(a);
    },
    httpMedia: (i) => t(["http_media", i.parentId, i.mediaType]),
    httpSecurity: (i) => {
      var a, o, c;
      return t([
        "http_security",
        i.parentId,
        i.kind,
        i.keyOrName,
        ...i.kind === "requirement" ? [String((a = i.index) !== null && a !== void 0 ? a : ""), (c = (o = i.scopeKeys) === null || o === void 0 ? void 0 : o.join("|")) !== null && c !== void 0 ? c : ""] : []
      ]);
    },
    httpServer: (i) => t(["http_server", i.parentId, i.url]),
    httpResponse: (i) => t([
      "http_response",
      i.parentId,
      i.codeOrKey,
      ...Array.isArray(i.produces) ? n(i.produces) : []
    ])
  }, Jc;
}
var Ib;
function Ci() {
  if (Ib) return Bs;
  Ib = 1, Object.defineProperty(Bs, "__esModule", { value: !0 }), Bs.withContext = Bs.createContext = void 0;
  const e = Zn, t = /* @__PURE__ */ JM();
  function n(a) {
    const o = (c) => (this.parentId = a(c), this.parentId);
    for (const [c, u] of Object.entries(t.idGenerators))
      o[c] = (s) => o(u(Object.assign({ parentId: this.parentId }, s)));
    return o;
  }
  function r(a, o, c) {
    let u = "service", s;
    return {
      document: a,
      get context() {
        return u;
      },
      set context(l) {
        u = l, l !== "operation" && (this.parentId = this.ids[l]);
      },
      maybeResolveLocalRef(l) {
        if ((0, e.hasRef)(l) && (0, e.isLocalRef)(l.$ref))
          try {
            return o.call(this, l);
          } catch {
            return;
          } finally {
            this.parentId = this.ids[u];
          }
        return l;
      },
      get generateId() {
        return s ?? (s = n.call(this, c));
      },
      ids: {
        service: "",
        path: "",
        operation: "",
        webhookName: "",
        webhook: ""
      },
      references: {},
      parentId: ""
    };
  }
  Bs.createContext = r;
  function i(a) {
    return function(...o) {
      const { context: c, parentId: u } = this, s = a.apply(this, o);
      return this.context = c, this.parentId = u, s;
    };
  }
  return Bs.withContext = i, Bs;
}
var jb;
function Bk() {
  if (jb) return Ms;
  jb = 1, Object.defineProperty(Ms, "__esModule", { value: !0 }), Ms.translateToTags = Ms.translateTagDefinition = void 0;
  const e = Zn, t = Xn(), n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Ps(), a = /* @__PURE__ */ S2(), o = (0, n.withContext)(function(s) {
    if (s === null || !(0, r.isSerializablePrimitive)(s))
      return;
    const l = String(s);
    return {
      id: this.generateId.tag({ name: l }),
      name: l
    };
  }), c = function(s, ...l) {
    if (!(0, e.isPlainObject)(s))
      return;
    const d = o.call(this, s.name, ...l);
    if (!d)
      return;
    const f = (0, i.getExtensions)(s);
    return {
      ...d,
      ...(0, t.pickBy)({
        description: s.description
      }, r.isString),
      ...(0, a.toExternalDocs)(s.externalDocs),
      ...f
    };
  };
  Ms.translateTagDefinition = c;
  const u = function(s) {
    return Array.isArray(s) ? s.map(o, this).filter(r.isNonNullable) : [];
  };
  return Ms.translateToTags = u, Ms;
}
var Rh = {}, Ih = {}, jh = {}, qb;
function ga() {
  return qb || (qb = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.syncReferenceObject = e.bundleResolveRef = e.resolveRef = e.getComponentName = e.setSharedKey = e.getSharedKey = e.inferContext = void 0;
    const t = Zn;
    function n(f) {
      return f.length < 2 || f[0] !== "paths" ? "service" : f.length === 2 || f[3] === "parameters" || f[3] === "servers" ? "path" : "operation";
    }
    e.inferContext = n;
    const r = /* @__PURE__ */ new WeakMap();
    function i(f, p) {
      var g;
      return (g = r.get(f)) !== null && g !== void 0 ? g : p;
    }
    e.getSharedKey = i;
    function a(f, p) {
      return typeof f == "object" && f !== null ? r.set(f, p) : !1;
    }
    e.setSharedKey = a;
    const o = /#\/components\/(?<section>[A-Za-z0-9_-]+)\//;
    function c(f, p) {
      var g;
      const w = l(f, p).match(o);
      return (g = w?.groups) === null || g === void 0 ? void 0 : g.section;
    }
    e.getComponentName = c;
    const u = function(f) {
      const { value: p, location: g } = (0, t.resolveInlineRefWithLocation)(this.document, f.$ref), b = n(g);
      return b !== null && this.context !== b && (this.context = b), typeof p == "object" && p !== null && b === "service" && r.set(p, g[0] === "components" ? g[2] : g[1]), p;
    };
    e.resolveRef = u;
    const s = function(f) {
      return e.resolveRef.call(this, f), d(f, this.references);
    };
    e.bundleResolveRef = s;
    function l(f, p) {
      const g = /* @__PURE__ */ new Set();
      let b = p;
      for (; b in f; ) {
        if (g.has(b))
          return b;
        g.add(b);
        const w = f[b];
        if (b = w.value, w.resolved)
          return b;
      }
      return b;
    }
    function d(f, p) {
      const { $ref: g } = f;
      return Object.defineProperty({ ...f }, "$ref", {
        enumerable: !0,
        get() {
          return l(p, g);
        },
        set(b) {
          p[g] = { value: b, resolved: !0 };
        }
      });
    }
    e.syncReferenceObject = d;
  })(jh)), jh;
}
var Yp = {}, Jp = {}, Db;
function QM() {
  if (Db) return Jp;
  Db = 1, Object.defineProperty(Jp, "__esModule", { value: !0 });
  const e = (t) => (n) => {
    t in n && (n.examples = [n[t]], delete n[t]);
  };
  return Jp.default = {
    "x-example": e("x-example"),
    example: e("example")
  }, Jp;
}
var Qp = {}, $b;
function XM() {
  if ($b) return Qp;
  $b = 1, Object.defineProperty(Qp, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ Si(), t = {
    MIN_INT_32: 0 - 2 ** 31,
    MAX_INT_32: 2 ** 31 - 1,
    MIN_INT_64: Number.MIN_SAFE_INTEGER,
    MAX_INT_64: Number.MAX_SAFE_INTEGER,
    MIN_FLOAT: 0 - 2 ** 128,
    MAX_FLOAT: 2 ** 128 - 1,
    MIN_DOUBLE: 0 - Number.MAX_VALUE,
    MAX_DOUBLE: Number.MAX_VALUE
  }, n = (p, g) => (b) => {
    const w = (0, e.collectExplicitProperties)(b);
    b["x-stoplight"] = { ...b["x-stoplight"], explicitProperties: w }, b.minimum = Math.max(l(b.minimum, p), p), b.maximum = Math.min(l(b.maximum, g), g);
  }, r = n(t.MIN_INT_32, t.MAX_INT_32), i = n(t.MIN_INT_64, t.MAX_INT_64), a = n(t.MIN_FLOAT, t.MAX_FLOAT), o = n(t.MIN_DOUBLE, t.MAX_DOUBLE), c = (p) => {
    const g = (0, e.collectExplicitProperties)(p);
    p["x-stoplight"] = { ...p["x-stoplight"], explicitProperties: g }, p.pattern = "^[\\w\\d+\\/=]*$";
  }, u = (p) => {
    p.contentEncoding = "base64", delete p.format;
  }, s = (p) => {
    p.contentMediaType = "application/octet-stream", delete p.format;
  };
  function l(p, g) {
    const b = Number(p);
    return Number.isNaN(b) ? g : b;
  }
  const d = {
    int32: r,
    int64: i,
    float: a,
    double: o,
    byte: c,
    base64: u,
    binary: s
  }, f = (p) => {
    typeof p.format == "string" && p.format in d && d[p.format](p);
  };
  return Qp.default = { format: f }, Qp;
}
var Xp = {}, Lb;
function eB() {
  if (Lb) return Xp;
  Lb = 1, Object.defineProperty(Xp, "__esModule", { value: !0 });
  const e = (t) => {
    if (!("id" in t))
      return;
    const { id: n } = t;
    delete t.id, typeof n == "string" && (t.$id = n);
  };
  return Xp.default = { id: e }, Xp;
}
var ed = {}, Nb;
function tB() {
  if (Nb) return ed;
  Nb = 1, Object.defineProperty(ed, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ Si(), t = [
    "string",
    "number",
    "integer",
    "boolean",
    "object",
    "array",
    "null"
  ];
  function n(i) {
    return t.includes(i);
  }
  const r = (i) => (a) => {
    if (!(typeof a.type != "string" || !n(a.type) || !(i in a))) {
      if (a[i] === !0)
        a.type = [a.type, "null"], Array.isArray(a.enum) && (a.enum = [...a.enum, null]);
      else if (i === "nullable") {
        const o = (0, e.collectExplicitProperties)(a);
        a["x-stoplight"] = { ...a["x-stoplight"], explicitProperties: o };
      }
      delete a[i];
    }
  };
  return ed.default = {
    "x-nullable": r("x-nullable"),
    nullable: r("nullable")
  }, ed;
}
var td = {}, Fb;
function rB() {
  if (Fb) return td;
  Fb = 1, Object.defineProperty(td, "__esModule", { value: !0 });
  function e(t, n) {
    return (r) => {
      if (!(t in r))
        return;
      const { [t]: i } = r;
      typeof i != "number" && (i !== !0 || typeof r[n] != "number" ? delete r[t] : (r[t] = r[n], delete r[n]));
    };
  }
  return td.default = {
    exclusiveMinimum: e("exclusiveMinimum", "minimum"),
    exclusiveMaximum: e("exclusiveMaximum", "maximum")
  }, td;
}
var Mb;
function nB() {
  if (Mb) return Yp;
  Mb = 1, Object.defineProperty(Yp, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ QM(), t = /* @__PURE__ */ XM(), n = /* @__PURE__ */ eB(), r = /* @__PURE__ */ tB(), i = /* @__PURE__ */ rB();
  return Yp.default = {
    ...e.default,
    ...n.default,
    ...t.default,
    ...r.default,
    ...i.default
  }, Yp;
}
var Bb;
function Eu() {
  return Bb || (Bb = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.convertSchema = e.translateSchemaObjectFromPair = e.translateSchemaObject = void 0;
    const t = Zn, n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Si(), i = /* @__PURE__ */ Vi(), a = /* @__PURE__ */ ga(), o = /* @__PURE__ */ nB(), c = Object.keys(o.default), u = /* @__PURE__ */ new WeakMap();
    e.translateSchemaObject = (0, n.withContext)(function(f) {
      const p = this.maybeResolveLocalRef(f);
      if ((0, i.isReferenceObject)(p))
        return p;
      const g = this.context === "service" ? (0, a.getSharedKey)(Object(p), "") : "";
      return e.translateSchemaObjectFromPair.call(this, [g, f]);
    }), e.translateSchemaObjectFromPair = (0, n.withContext)(function([f, p]) {
      var g, b;
      const w = this.maybeResolveLocalRef(p);
      if (!(0, t.isPlainObject)(w)) {
        if (!(0, i.isReferenceObject)(p))
          return {};
        const _ = s(this.document, p, this.references), E = (g = (0, r.extractId)(_)) !== null && g !== void 0 ? g : this.generateId.schema({ key: f ?? "" });
        return _["x-stoplight"] = {
          ...(0, t.isPlainObject)(_["x-stoplight"]) && _["x-stoplight"],
          id: E
        }, _;
      }
      if ((0, i.isReferenceObject)(w))
        return w;
      let y = u.get(w);
      if (y)
        return y;
      y = s(this.document, w, this.references);
      const v = (b = (0, r.extractId)(y)) !== null && b !== void 0 ? b : this.generateId.schema({ key: f ?? "" });
      return y["x-stoplight"] = {
        ...(0, t.isPlainObject)(y["x-stoplight"]) && y["x-stoplight"],
        id: v
      }, u.set(w, y), y;
    });
    function s(f, p, g = {}) {
      const b = (0, t.isPlainObject)(p) ? p : {};
      if ("jsonSchemaDialect" in f && typeof f.jsonSchemaDialect == "string")
        return {
          $schema: f.jsonSchemaDialect,
          ...b
        };
      const w = l(b, {
        structs: ["allOf", "anyOf", "oneOf", "not", "items", "additionalProperties", "additionalItems"],
        references: g
      });
      return w.$schema = "http://json-schema.org/draft-07/schema#", w;
    }
    e.convertSchema = s;
    function l(f, p) {
      if ((0, i.isReferenceObject)(f))
        return (0, a.syncReferenceObject)(f, p.references);
      let g = u.get(f);
      if (g)
        return g;
      const b = { ...f };
      u.set(f, b);
      for (const w of p.structs)
        if (Array.isArray(b[w])) {
          b[w] = b[w].slice();
          for (let y = 0; y < b[w].length; y++)
            typeof b[w][y] == "object" && b[w][y] !== null ? b[w][y] = l(b[w][y], p) : (b[w].splice(y, 1), y--);
        } else b[w] !== null && typeof b[w] == "object" && (b[w] = l(b[w], p));
      "properties" in b && (0, t.isPlainObject)(b.properties) && d(b, p);
      for (const w of c)
        w in b && o.default[w](b);
      return b;
    }
    function d(f, p) {
      const g = { ...f.properties };
      f.properties = g;
      for (const b of Object.keys(g)) {
        const w = g[b];
        (0, t.isPlainObject)(w) && (g[b] = l(w, p));
      }
    }
  })(Ih)), Ih;
}
var Qc = {}, Ub;
function iB() {
  if (Ub) return Qc;
  Ub = 1, Object.defineProperty(Qc, "__esModule", { value: !0 }), Qc.translateToSecurityDeclarationType = void 0;
  const e = /* @__PURE__ */ wc();
  function t({ security: n }) {
    let r = e.HttpOperationSecurityDeclarationTypes.InheritedFromService;
    return Array.isArray(n) && (r = n.length === 0 ? e.HttpOperationSecurityDeclarationTypes.None : e.HttpOperationSecurityDeclarationTypes.Declared), r;
  }
  return Qc.translateToSecurityDeclarationType = t, Qc;
}
var Xc = {}, Hb;
function Uk() {
  if (Hb) return Xc;
  Hb = 1, Object.defineProperty(Xc, "__esModule", { value: !0 }), Xc.translateLogo = void 0;
  const e = Xn();
  function t({ "x-logo": n, contact: r }) {
    return {
      altText: "logo",
      href: r?.url,
      ...(0, e.pickBy)(n, (i, a) => typeof i == "string" && ["altText", "href", "backgroundColor", "url"].includes(a))
    };
  }
  return Xc.translateLogo = t, Xc;
}
var zb;
function C2() {
  return zb || (zb = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateLogo = e.translateToSecurityDeclarationType = e.translateSchemaObject = e.convertSchema = void 0;
    var t = /* @__PURE__ */ Eu();
    Object.defineProperty(e, "convertSchema", { enumerable: !0, get: function() {
      return t.convertSchema;
    } }), Object.defineProperty(e, "translateSchemaObject", { enumerable: !0, get: function() {
      return t.translateSchemaObject;
    } });
    var n = /* @__PURE__ */ iB();
    Object.defineProperty(e, "translateToSecurityDeclarationType", { enumerable: !0, get: function() {
      return n.translateToSecurityDeclarationType;
    } });
    var r = /* @__PURE__ */ Uk();
    Object.defineProperty(e, "translateLogo", { enumerable: !0, get: function() {
      return r.translateLogo;
    } });
  })(Rh)), Rh;
}
var Vb;
function k2() {
  if (Vb) return Ba;
  Vb = 1, Object.defineProperty(Ba, "__esModule", { value: !0 }), Ba.transformOasEndpointOperation = Ba.transformOasEndpointOperations = Ba.WEBHOOK_CONFIG = Ba.OPERATION_CONFIG = void 0;
  const e = Zn, t = Xn(), n = /* @__PURE__ */ Jn(), r = /* @__PURE__ */ Si(), i = /* @__PURE__ */ Ps(), a = /* @__PURE__ */ S2(), o = /* @__PURE__ */ Bk(), c = /* @__PURE__ */ C2(), u = ["get", "post", "put", "delete", "options", "head", "patch", "trace"];
  Ba.OPERATION_CONFIG = {
    type: "operation",
    documentProp: "paths",
    nameProp: "path"
  }, Ba.WEBHOOK_CONFIG = {
    type: "webhook",
    documentProp: "webhooks",
    nameProp: "name"
  };
  function s(d, f, p, g = u, b) {
    return ((0, e.isPlainObject)(d[p.documentProp]) ? Object.entries(d[p.documentProp]) : []).flatMap(([y, v]) => {
      if (!(0, e.isPlainObject)(v))
        return [];
      let _ = Object.keys(v);
      return g !== null && (_ = _.filter((E) => g.includes(E))), _.map((E) => f({
        document: d,
        name: y,
        method: E,
        config: p,
        ctx: b
      }));
    });
  }
  Ba.transformOasEndpointOperations = s;
  const l = function({ type: d, documentProp: f, nameProp: p }, g, b, w) {
    var y, v, _, E, O, M;
    const L = this.maybeResolveLocalRef((v = (y = this.document) === null || y === void 0 ? void 0 : y[f]) === null || v === void 0 ? void 0 : v[g]);
    if (typeof L != "object" || L === null)
      throw new Error(`Could not find ${[f, g].join("/")} in the provided spec.`);
    const Z = this.maybeResolveLocalRef(L[b]);
    if (!Z)
      throw new Error(`Could not find ${[f, g, b].join("/")} in the provided spec.`);
    const Q = this.ids.service = String((_ = this.document["x-stoplight"]) === null || _ === void 0 ? void 0 : _.id);
    d === "operation" ? this.ids.path = this.generateId.httpPath({ parentId: Q, path: g }) : this.ids.webhookName = this.generateId.httpWebhookName({ parentId: Q, name: g });
    let ae;
    return this.context === "callback" ? ae = this.ids.operation = (E = (0, r.extractId)(Z)) !== null && E !== void 0 ? E : this.generateId.httpCallbackOperation({
      parentId: Q,
      method: b,
      path: g,
      key: w ?? ""
    }) : d === "operation" ? ae = this.ids.operation = (O = (0, r.extractId)(Z)) !== null && O !== void 0 ? O : this.generateId.httpOperation({ parentId: Q, method: b, path: g }) : ae = this.ids.webhook = (M = (0, r.extractId)(Z)) !== null && M !== void 0 ? M : this.generateId.httpWebhookOperation({ parentId: Q, method: b, name: g }), this.parentId = ae, this.context = d, {
      id: ae,
      method: b,
      [p]: g,
      tags: o.translateToTags.call(this, Z.tags),
      extensions: (0, i.getExtensions)(Z),
      ...(0, t.pickBy)({
        deprecated: Z.deprecated,
        internal: Z["x-internal"]
      }, n.isBoolean),
      ...(0, t.pickBy)({
        iid: Z.operationId,
        description: Z.description,
        summary: Z.summary
      }, n.isString),
      securityDeclarationType: (0, c.translateToSecurityDeclarationType)(Z),
      ...(0, a.toExternalDocs)(Z.externalDocs)
    };
  };
  return Ba.transformOasEndpointOperation = l, Ba;
}
var Gb;
function M0() {
  return Gb || (Gb = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.OasVersion = e.convertToJsonSchema = e.defaultRefResolver = void 0, F0.__exportStar(/* @__PURE__ */ k2(), e);
    var n = /* @__PURE__ */ ga();
    Object.defineProperty(e, "defaultRefResolver", { enumerable: !0, get: function() {
      return n.resolveRef;
    } });
    var r = /* @__PURE__ */ C2();
    Object.defineProperty(e, "convertToJsonSchema", { enumerable: !0, get: function() {
      return r.convertSchema;
    } });
    var i = /* @__PURE__ */ Ff();
    Object.defineProperty(e, "OasVersion", { enumerable: !0, get: function() {
      return i.OasVersion;
    } });
  })(Eh)), Eh;
}
var Wb = /* @__PURE__ */ M0(), qh = {}, Dh = {}, el = {}, Us = {}, $h = { exports: {} }, Kb;
function aB() {
  return Kb || (Kb = 1, (function(e) {
    var t = (function() {
      var n, r = [], i = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"], a = "1a", o = !1, c, u, s, l, d, f, p, g = "chongo <Landon Curt Noll> /\\../\\", b = 52, w = {
        32: { offset: 0 },
        64: { offset: [0, 0, 0, 0] },
        128: { offset: [0, 0, 0, 0, 0, 0, 0, 0] },
        256: { offset: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
        512: { offset: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
        1024: { offset: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
      };
      for (n = 0; n < 256; n++)
        r[n] = (n >> 4 & 15).toString(16) + (n & 15).toString(16);
      function y(P, N) {
        var F = "0123456789abcdefghijklmnopqrstuvwxyz", T = [0], C, S, h, k = "";
        for (S = 0; S < P.length; S += 2) {
          for (C = parseInt(P.substr(S, 2), 16), h = 0; h < T.length; h++)
            C += T[h] << 8, T[h] = C % N, C = C / N | 0;
          for (; C > 0; )
            T.push(C % N), C = C / N | 0;
        }
        for (S = T.length - 1; S >= 0; --S)
          k += F[T[S]];
        return k;
      }
      function v(P, N) {
        return {
          bits: N,
          value: P,
          dec: function() {
            return y(P, 10);
          },
          hex: function() {
            return P;
          },
          str: function() {
            return y(P, 36);
          }
        };
      }
      function _(P, N) {
        return {
          bits: N,
          value: P,
          dec: function() {
            return P.toString();
          },
          hex: function() {
            return r[P >>> 24] + r[P >>> 16 & 255] + r[P >>> 8 & 255] + r[P & 255];
          },
          str: function() {
            return P.toString(36);
          }
        };
      }
      function E(P, N) {
        return {
          bits: N,
          value: P,
          dec: function() {
            return P.toString();
          },
          hex: function() {
            return ("0000000000000000" + P.toString(16)).substr(-13);
          },
          str: function() {
            return P.toString(36);
          }
        };
      }
      function O(P, N) {
        var F = typeof P == "object" ? JSON.stringify(P) : P;
        switch (N || b) {
          case 32:
            return c(F);
          case 64:
            return s(F);
          case 128:
            return l(F);
          case 256:
            return d(F);
          case 512:
            return f(F);
          case 1024:
            return p(F);
          default:
            return u(F);
        }
      }
      function M(P) {
        if (P === 52 || w[P])
          b = P;
        else
          throw new Error("Supported FNV keyspacs: 32, 52, 64, 128, 256, 512, and 1024 bit");
      }
      function L(P) {
        if (P === "1a")
          a = P, c = o ? xe : qe, u = o ? qt : Ae, s = o ? Dt : At, l = o ? Rt : Xe, d = o ? Y : ye, f = o ? _e : Te, p = o ? $t : et;
        else if (P === "1")
          a = P, c = o ? ve : Ve, u = o ? Ze : Ue, s = o ? Fe : He, l = o ? Yt : ze, d = o ? ie : W, f = o ? Le : $, p = o ? Be : Ge;
        else
          throw new Error("Supported FNV versions: 1, 1a");
      }
      function Z(P) {
        P ? (o = !0, c = a == "1a" ? xe : ve, u = a == "1a" ? qt : Ze, s = a == "1a" ? Dt : Fe, l = a == "1a" ? Rt : Yt, d = a == "1a" ? Y : ie, f = a == "1a" ? _e : Le, p = a == "1a" ? $t : Be) : (o = !1, c = a == "1a" ? qe : Ve, u = a == "1a" ? Ae : Ue, s = a == "1a" ? At : He, l = a == "1a" ? Xe : ze, d = a == "1a" ? ye : W, f = a == "1a" ? Te : $, p = a == "1a" ? et : Ge);
      }
      function Q(P) {
        var N = a, F, T;
        P = P || P === 0 ? P : g, P === g && L("1");
        for (var C in w) {
          for (w[C].offset = [], T = 0; T < C / 16; T++)
            w[C].offset[T] = 0;
          for (F = O(P, parseInt(C, 10)).hex(), T = 0; T < C / 16; T++)
            w[C].offset[T] = parseInt(F.substr(T * 4, 4), 16);
        }
        L(N);
      }
      function ae(P) {
        var N, F = P.length - 3, T = 0, C = 40389, S = 0, h = 33052;
        for (N = 0; N < F; )
          C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535, C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535, C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535, C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535;
        for (; N < F + 3; )
          C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535;
        return (h << 16 >>> 0) + C;
      }
      function re(P) {
        var N, F = P.length - 3, T = 0, C = 40389, S = 0, h = 33052;
        for (N = 0; N < F; )
          C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535, C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535, C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535, C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535;
        for (; N < F + 3; )
          C ^= P.charCodeAt(N++), T = C * 403, S = h * 403, S += C << 8, h = S + (T >>> 16) & 65535, C = T & 65535;
        return r[h >>> 8 & 255] + r[h & 255] + r[C >>> 8 & 255] + r[C & 255];
      }
      function X(P) {
        var N, F = P.length - 3, T = 0, C = 8997, S = 0, h = 33826, k = 0, R = 40164, j = 0, A = 52210;
        for (N = 0; N < F; )
          C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535;
        for (; N < F + 3; )
          C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535;
        return (A & 15) * 281474976710656 + R * 4294967296 + h * 65536 + (C ^ A >> 4);
      }
      function de(P) {
        var N, F = P.length - 3, T = 0, C = 8997, S = 0, h = 33826, k = 0, R = 40164, j = 0, A = 52210;
        for (N = 0; N < F; )
          C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535;
        for (; N < F + 3; )
          C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535;
        return i[A & 15] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255] + r[C >> 8 ^ A >> 12] + r[(C ^ A >> 4) & 255];
      }
      function Ce(P) {
        var N, F = P.length - 3, T = 0, C = 8997, S = 0, h = 33826, k = 0, R = 40164, j = 0, A = 52210;
        for (N = 0; N < F; )
          C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535, C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535;
        for (; N < F + 3; )
          C ^= P.charCodeAt(N++), T = C * 435, S = h * 435, k = R * 435, j = A * 435, k += C << 8, j += h << 8, S += T >>> 16, C = T & 65535, k += S >>> 16, h = S & 65535, A = j + (k >>> 16) & 65535, R = k & 65535;
        return r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255] + r[C >> 8] + r[C & 255];
      }
      function J(P) {
        var N, F, T = P.length, C = 0, S = 40389, h = 0, k = 33052;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? S ^= N : N < 2048 ? (S ^= N >> 6 | 192, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), S ^= N >> 18 | 240, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N >> 12 & 63 | 128, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N >> 6 & 63 | 128, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N & 63 | 128) : (S ^= N >> 12 | 224, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N >> 6 & 63 | 128, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N & 63 | 128), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535;
        return (k << 16 >>> 0) + S;
      }
      function ne(P) {
        var N, F, T = P.length, C = 0, S = 40389, h = 0, k = 33052;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? S ^= N : N < 2048 ? (S ^= N >> 6 | 192, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), S ^= N >> 18 | 240, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N >> 12 & 63 | 128, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N >> 6 & 63 | 128, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N & 63 | 128) : (S ^= N >> 12 | 224, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N >> 6 & 63 | 128, C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= N & 63 | 128), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535;
        return r[k >>> 8 & 255] + r[k & 255] + r[S >>> 8 & 255] + r[S & 255];
      }
      function De(P) {
        var N, F, T = P.length, C = 0, S = 8997, h = 0, k = 33826, R = 0, j = 40164, A = 0, I = 52210;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? S ^= N : N < 2048 ? (S ^= N >> 6 | 192, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), S ^= N >> 18 | 240, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 12 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 6 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128) : (S ^= N >> 12 | 224, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 6 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        return (I & 15) * 281474976710656 + j * 4294967296 + k * 65536 + (S ^ I >> 4);
      }
      function je(P) {
        var N, F, T = P.length, C = 0, S = 8997, h = 0, k = 33826, R = 0, j = 40164, A = 0, I = 52210;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? S ^= N : N < 2048 ? (S ^= N >> 6 | 192, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), S ^= N >> 18 | 240, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 12 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 6 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128) : (S ^= N >> 12 | 224, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 6 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        return i[I & 15] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8 ^ I >> 12] + r[(S ^ I >> 4) & 255];
      }
      function Me(P) {
        var N, F, T = P.length, C = 0, S = 8997, h = 0, k = 33826, R = 0, j = 40164, A = 0, I = 52210;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? S ^= N : N < 2048 ? (S ^= N >> 6 | 192, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), S ^= N >> 18 | 240, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 12 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 6 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128) : (S ^= N >> 12 | 224, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N >> 6 & 63 | 128, C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= N & 63 | 128), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        return r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255];
      }
      function qe(P) {
        var N, F = P.length - 3, T = w[32].offset, C = 0, S = T[1] | 0, h = 0, k = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535;
        return _((k << 16 >>> 0) + S, 32);
      }
      function Ve(P) {
        var N, F = P.length - 3, T = w[32].offset, C = 0, S = T[1] | 0, h = 0, k = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++), C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 403, h = k * 403, h += S << 8, k = h + (C >>> 16) & 65535, S = C & 65535, S ^= P.charCodeAt(N++);
        return _((k << 16 >>> 0) + S, 32);
      }
      function xe(P) {
        var N, F, T = P.length, C = w[32].offset, S = 0, h = C[1] | 0, k = 0, R = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N >> 12 & 63 | 128, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N >> 6 & 63 | 128, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N >> 6 & 63 | 128, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N & 63 | 128), S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535;
        return _((R << 16 >>> 0) + h, 32);
      }
      function ve(P) {
        var N, F, T = P.length, C = w[32].offset, S = 0, h = C[1] | 0, k = 0, R = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N >> 12 & 63 | 128, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N >> 6 & 63 | 128, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N >> 6 & 63 | 128, S = h * 403, k = R * 403, k += h << 8, R = k + (S >>> 16) & 65535, h = S & 65535, h ^= N & 63 | 128);
        return _((R << 16 >>> 0) + h, 32);
      }
      c = qe;
      function Ae(P) {
        var N, F = P.length - 3, T = w[64].offset, C = 0, S = T[3] | 0, h = 0, k = T[2] | 0, R = 0, j = T[1] | 0, A = 0, I = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        return E((I & 15) * 281474976710656 + j * 4294967296 + k * 65536 + (S ^ I >> 4), 52);
      }
      function Ue(P) {
        var N, F = P.length - 3, T = w[64].offset, C = 0, S = T[3] | 0, h = 0, k = T[2] | 0, R = 0, j = T[1] | 0, A = 0, I = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++);
        return E((I & 15) * 281474976710656 + j * 4294967296 + k * 65536 + (S ^ I >> 4), 52);
      }
      function qt(P) {
        var N, F, T = P.length, C = w[64].offset, S = 0, h = C[3] | 0, k = 0, R = C[2] | 0, j = 0, A = C[1] | 0, I = 0, z = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 12 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128), S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535;
        return E((z & 15) * 281474976710656 + A * 4294967296 + R * 65536 + (h ^ z >> 4), 52);
      }
      function Ze(P) {
        var N, F, T = P.length, C = w[64].offset, S = 0, h = C[3] | 0, k = 0, R = C[2] | 0, j = 0, A = C[1] | 0, I = 0, z = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 12 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128);
        return E((z & 15) * 281474976710656 + A * 4294967296 + R * 65536 + (h ^ z >> 4), 52);
      }
      u = Ae;
      function At(P) {
        var N, F = P.length - 3, T = w[64].offset, C = 0, S = T[3] | 0, h = 0, k = T[2] | 0, R = 0, j = T[1] | 0, A = 0, I = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535;
        return v(r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 64);
      }
      function He(P) {
        var N, F = P.length - 3, T = w[64].offset, C = 0, S = T[3] | 0, h = 0, k = T[2] | 0, R = 0, j = T[1] | 0, A = 0, I = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++), C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 435, h = k * 435, R = j * 435, A = I * 435, R += S << 8, A += k << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, I = A + (R >>> 16) & 65535, j = R & 65535, S ^= P.charCodeAt(N++);
        return v(r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 64);
      }
      function Dt(P) {
        var N, F, T = P.length, C = w[64].offset, S = 0, h = C[3] | 0, k = 0, R = C[2] | 0, j = 0, A = C[1] | 0, I = 0, z = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 12 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128), S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535;
        return v(r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 64);
      }
      function Fe(P) {
        var N, F, T = P.length, C = w[64].offset, S = 0, h = C[3] | 0, k = 0, R = C[2] | 0, j = 0, A = C[1] | 0, I = 0, z = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 12 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N >> 6 & 63 | 128, S = h * 435, k = R * 435, j = A * 435, I = z * 435, j += h << 8, I += R << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, z = I + (j >>> 16) & 65535, A = j & 65535, h ^= N & 63 | 128);
        return v(r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 64);
      }
      s = At;
      function Xe(P) {
        var N, F = P.length - 3, T = w[128].offset, C = 0, S = T[7] | 0, h = 0, k = T[6] | 0, R = 0, j = T[5] | 0, A = 0, I = T[4] | 0, z = 0, H = T[3] | 0, K = 0, U = T[2] | 0, D = 0, B = T[1] | 0, ee = 0, V = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535;
        return v(r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 128);
      }
      function ze(P) {
        var N, F = P.length - 3, T = w[128].offset, C = 0, S = T[7] | 0, h = 0, k = T[6] | 0, R = 0, j = T[5] | 0, A = 0, I = T[4] | 0, z = 0, H = T[3] | 0, K = 0, U = T[2] | 0, D = 0, B = T[1] | 0, ee = 0, V = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++), C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 315, h = k * 315, R = j * 315, A = I * 315, z = H * 315, K = U * 315, D = B * 315, ee = V * 315, K += S << 8, D += k << 8, ee += j << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, V = ee + (D >>> 16) & 65535, B = D & 65535, S ^= P.charCodeAt(N++);
        return v(r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 128);
      }
      function Rt(P) {
        var N, F, T = P.length, C = w[128].offset, S = 0, h = C[7] | 0, k = 0, R = C[6] | 0, j = 0, A = C[5] | 0, I = 0, z = C[4] | 0, H = 0, K = C[3] | 0, U = 0, D = C[2] | 0, B = 0, ee = C[1] | 0, V = 0, te = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N >> 12 & 63 | 128, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N >> 6 & 63 | 128, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N >> 6 & 63 | 128, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N & 63 | 128), S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535;
        return v(r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 128);
      }
      function Yt(P) {
        var N, F, T = P.length, C = w[128].offset, S = 0, h = C[7] | 0, k = 0, R = C[6] | 0, j = 0, A = C[5] | 0, I = 0, z = C[4] | 0, H = 0, K = C[3] | 0, U = 0, D = C[2] | 0, B = 0, ee = C[1] | 0, V = 0, te = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N >> 12 & 63 | 128, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N >> 6 & 63 | 128, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N >> 6 & 63 | 128, S = h * 315, k = R * 315, j = A * 315, I = z * 315, H = K * 315, U = D * 315, B = ee * 315, V = te * 315, U += h << 8, B += R << 8, V += A << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, te = V + (B >>> 16) & 65535, ee = B & 65535, h ^= N & 63 | 128);
        return v(r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 128);
      }
      l = Xe;
      function ye(P) {
        var N, F = P.length - 3, T = w[256].offset, C = 0, S = T[15] | 0, h = 0, k = T[14] | 0, R = 0, j = T[13] | 0, A = 0, I = T[12] | 0, z = 0, H = T[11] | 0, K = 0, U = T[10] | 0, D = 0, B = T[9] | 0, ee = 0, V = T[8] | 0, te = 0, ue = T[7] | 0, ge = 0, pe = T[6] | 0, se = 0, ce = T[5] | 0, Oe = 0, fe = T[4] | 0, be = 0, me = T[3] | 0, Ie = 0, le = T[2] | 0, he = 0, we = T[1] | 0, Re = 0, Pe = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535;
        return v(r[Pe >> 8] + r[Pe & 255] + r[we >> 8] + r[we & 255] + r[le >> 8] + r[le & 255] + r[me >> 8] + r[me & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 256);
      }
      function W(P) {
        var N, F = P.length - 3, T = w[256].offset, C = 0, S = T[15] | 0, h = 0, k = T[14] | 0, R = 0, j = T[13] | 0, A = 0, I = T[12] | 0, z = 0, H = T[11] | 0, K = 0, U = T[10] | 0, D = 0, B = T[9] | 0, ee = 0, V = T[8] | 0, te = 0, ue = T[7] | 0, ge = 0, pe = T[6] | 0, se = 0, ce = T[5] | 0, Oe = 0, fe = T[4] | 0, be = 0, me = T[3] | 0, Ie = 0, le = T[2] | 0, he = 0, we = T[1] | 0, Re = 0, Pe = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++), C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 355, h = k * 355, R = j * 355, A = I * 355, z = H * 355, K = U * 355, D = B * 355, ee = V * 355, te = ue * 355, ge = pe * 355, se = ce * 355, Oe = fe * 355, be = me * 355, Ie = le * 355, he = we * 355, Re = Pe * 355, se += S << 8, Oe += k << 8, be += j << 8, Ie += I << 8, he += H << 8, Re += U << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Pe = Re + (he >>> 16) & 65535, we = he & 65535, S ^= P.charCodeAt(N++);
        return v(r[Pe >> 8] + r[Pe & 255] + r[we >> 8] + r[we & 255] + r[le >> 8] + r[le & 255] + r[me >> 8] + r[me & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 256);
      }
      function Y(P) {
        var N, F, T = P.length, C = w[256].offset, S = 0, h = C[15] | 0, k = 0, R = C[14] | 0, j = 0, A = C[13] | 0, I = 0, z = C[12] | 0, H = 0, K = C[11] | 0, U = 0, D = C[10] | 0, B = 0, ee = C[9] | 0, V = 0, te = C[8] | 0, ue = 0, ge = C[7] | 0, pe = 0, se = C[6] | 0, ce = 0, Oe = C[5] | 0, fe = 0, be = C[4] | 0, me = 0, Ie = C[3] | 0, le = 0, he = C[2] | 0, we = 0, Re = C[1] | 0, Pe = 0, $e = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N >> 12 & 63 | 128, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N >> 6 & 63 | 128, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N >> 6 & 63 | 128, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N & 63 | 128), S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535;
        return v(r[$e >> 8] + r[$e & 255] + r[Re >> 8] + r[Re & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[Oe >> 8] + r[Oe & 255] + r[se >> 8] + r[se & 255] + r[ge >> 8] + r[ge & 255] + r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 256);
      }
      function ie(P) {
        var N, F, T = P.length, C = w[256].offset, S = 0, h = C[15] | 0, k = 0, R = C[14] | 0, j = 0, A = C[13] | 0, I = 0, z = C[12] | 0, H = 0, K = C[11] | 0, U = 0, D = C[10] | 0, B = 0, ee = C[9] | 0, V = 0, te = C[8] | 0, ue = 0, ge = C[7] | 0, pe = 0, se = C[6] | 0, ce = 0, Oe = C[5] | 0, fe = 0, be = C[4] | 0, me = 0, Ie = C[3] | 0, le = 0, he = C[2] | 0, we = 0, Re = C[1] | 0, Pe = 0, $e = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N >> 12 & 63 | 128, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N >> 6 & 63 | 128, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N >> 6 & 63 | 128, S = h * 355, k = R * 355, j = A * 355, I = z * 355, H = K * 355, U = D * 355, B = ee * 355, V = te * 355, ue = ge * 355, pe = se * 355, ce = Oe * 355, fe = be * 355, me = Ie * 355, le = he * 355, we = Re * 355, Pe = $e * 355, ce += h << 8, fe += R << 8, me += A << 8, le += z << 8, we += K << 8, Pe += D << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, $e = Pe + (we >>> 16) & 65535, Re = we & 65535, h ^= N & 63 | 128);
        return v(r[$e >> 8] + r[$e & 255] + r[Re >> 8] + r[Re & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[Oe >> 8] + r[Oe & 255] + r[se >> 8] + r[se & 255] + r[ge >> 8] + r[ge & 255] + r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 256);
      }
      d = ye;
      function Te(P) {
        var N, F = P.length - 3, T = w[512].offset, C = 0, S = T[31] | 0, h = 0, k = T[30] | 0, R = 0, j = T[29] | 0, A = 0, I = T[28] | 0, z = 0, H = T[27] | 0, K = 0, U = T[26] | 0, D = 0, B = T[25] | 0, ee = 0, V = T[24] | 0, te = 0, ue = T[23] | 0, ge = 0, pe = T[22] | 0, se = 0, ce = T[21] | 0, Oe = 0, fe = T[20] | 0, be = 0, me = T[19] | 0, Ie = 0, le = T[18] | 0, he = 0, we = T[17] | 0, Re = 0, Pe = T[16] | 0, $e = 0, We = T[15] | 0, yt = 0, dt = T[14] | 0, bt = 0, ft = T[13] | 0, xt = 0, pt = T[12] | 0, _t = 0, ht = T[11] | 0, gt = 0, Je = T[10] | 0, mt = 0, nt = T[9] | 0, Et = 0, ut = T[8] | 0, Ot = 0, ct = T[7] | 0, St = 0, it = T[6] | 0, Ct = 0, tt = T[5] | 0, Tt = 0, at = T[4] | 0, wt = 0, ot = T[3] | 0, Pt = 0, st = T[2] | 0, kt = 0, rt = T[1] | 0, Lt = 0, It = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535;
        return v(r[It >> 8] + r[It & 255] + r[rt >> 8] + r[rt & 255] + r[st >> 8] + r[st & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[tt >> 8] + r[tt & 255] + r[it >> 8] + r[it & 255] + r[ct >> 8] + r[ct & 255] + r[ut >> 8] + r[ut & 255] + r[nt >> 8] + r[nt & 255] + r[Je >> 8] + r[Je & 255] + r[ht >> 8] + r[ht & 255] + r[pt >> 8] + r[pt & 255] + r[ft >> 8] + r[ft & 255] + r[dt >> 8] + r[dt & 255] + r[We >> 8] + r[We & 255] + r[Pe >> 8] + r[Pe & 255] + r[we >> 8] + r[we & 255] + r[le >> 8] + r[le & 255] + r[me >> 8] + r[me & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 512);
      }
      function $(P) {
        var N, F = P.length - 3, T = w[512].offset, C = 0, S = T[31] | 0, h = 0, k = T[30] | 0, R = 0, j = T[29] | 0, A = 0, I = T[28] | 0, z = 0, H = T[27] | 0, K = 0, U = T[26] | 0, D = 0, B = T[25] | 0, ee = 0, V = T[24] | 0, te = 0, ue = T[23] | 0, ge = 0, pe = T[22] | 0, se = 0, ce = T[21] | 0, Oe = 0, fe = T[20] | 0, be = 0, me = T[19] | 0, Ie = 0, le = T[18] | 0, he = 0, we = T[17] | 0, Re = 0, Pe = T[16] | 0, $e = 0, We = T[15] | 0, yt = 0, dt = T[14] | 0, bt = 0, ft = T[13] | 0, xt = 0, pt = T[12] | 0, _t = 0, ht = T[11] | 0, gt = 0, Je = T[10] | 0, mt = 0, nt = T[9] | 0, Et = 0, ut = T[8] | 0, Ot = 0, ct = T[7] | 0, St = 0, it = T[6] | 0, Ct = 0, tt = T[5] | 0, Tt = 0, at = T[4] | 0, wt = 0, ot = T[3] | 0, Pt = 0, st = T[2] | 0, kt = 0, rt = T[1] | 0, Lt = 0, It = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++), C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 343, h = k * 343, R = j * 343, A = I * 343, z = H * 343, K = U * 343, D = B * 343, ee = V * 343, te = ue * 343, ge = pe * 343, se = ce * 343, Oe = fe * 343, be = me * 343, Ie = le * 343, he = we * 343, Re = Pe * 343, $e = We * 343, yt = dt * 343, bt = ft * 343, xt = pt * 343, _t = ht * 343, gt = Je * 343, mt = nt * 343, Et = ut * 343, Ot = ct * 343, St = it * 343, Ct = tt * 343, Tt = at * 343, wt = ot * 343, Pt = st * 343, kt = rt * 343, Lt = It * 343, gt += S << 8, mt += k << 8, Et += j << 8, Ot += I << 8, St += H << 8, Ct += U << 8, Tt += B << 8, wt += V << 8, Pt += ue << 8, kt += pe << 8, Lt += ce << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, It = Lt + (kt >>> 16) & 65535, rt = kt & 65535, S ^= P.charCodeAt(N++);
        return v(r[It >> 8] + r[It & 255] + r[rt >> 8] + r[rt & 255] + r[st >> 8] + r[st & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[tt >> 8] + r[tt & 255] + r[it >> 8] + r[it & 255] + r[ct >> 8] + r[ct & 255] + r[ut >> 8] + r[ut & 255] + r[nt >> 8] + r[nt & 255] + r[Je >> 8] + r[Je & 255] + r[ht >> 8] + r[ht & 255] + r[pt >> 8] + r[pt & 255] + r[ft >> 8] + r[ft & 255] + r[dt >> 8] + r[dt & 255] + r[We >> 8] + r[We & 255] + r[Pe >> 8] + r[Pe & 255] + r[we >> 8] + r[we & 255] + r[le >> 8] + r[le & 255] + r[me >> 8] + r[me & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 512);
      }
      function _e(P) {
        var N, F, T = P.length, C = w[512].offset, S = 0, h = C[31] | 0, k = 0, R = C[30] | 0, j = 0, A = C[29] | 0, I = 0, z = C[28] | 0, H = 0, K = C[27] | 0, U = 0, D = C[26] | 0, B = 0, ee = C[25] | 0, V = 0, te = C[24] | 0, ue = 0, ge = C[23] | 0, pe = 0, se = C[22] | 0, ce = 0, Oe = C[21] | 0, fe = 0, be = C[20] | 0, me = 0, Ie = C[19] | 0, le = 0, he = C[18] | 0, we = 0, Re = C[17] | 0, Pe = 0, $e = C[16] | 0, We = 0, yt = C[15] | 0, dt = 0, bt = C[14] | 0, ft = 0, xt = C[13] | 0, pt = 0, _t = C[12] | 0, ht = 0, gt = C[11] | 0, Je = 0, mt = C[10] | 0, nt = 0, Et = C[9] | 0, ut = 0, Ot = C[8] | 0, ct = 0, St = C[7] | 0, it = 0, Ct = C[6] | 0, tt = 0, Tt = C[5] | 0, at = 0, wt = C[4] | 0, ot = 0, Pt = C[3] | 0, st = 0, kt = C[2] | 0, rt = 0, Lt = C[1] | 0, It = 0, Gt = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N >> 12 & 63 | 128, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N >> 6 & 63 | 128, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N >> 6 & 63 | 128, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N & 63 | 128), S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535;
        return v(r[Gt >> 8] + r[Gt & 255] + r[Lt >> 8] + r[Lt & 255] + r[kt >> 8] + r[kt & 255] + r[Pt >> 8] + r[Pt & 255] + r[wt >> 8] + r[wt & 255] + r[Tt >> 8] + r[Tt & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Ot >> 8] + r[Ot & 255] + r[Et >> 8] + r[Et & 255] + r[mt >> 8] + r[mt & 255] + r[gt >> 8] + r[gt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[$e >> 8] + r[$e & 255] + r[Re >> 8] + r[Re & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[Oe >> 8] + r[Oe & 255] + r[se >> 8] + r[se & 255] + r[ge >> 8] + r[ge & 255] + r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 512);
      }
      function Le(P) {
        var N, F, T = P.length, C = w[512].offset, S = 0, h = C[31] | 0, k = 0, R = C[30] | 0, j = 0, A = C[29] | 0, I = 0, z = C[28] | 0, H = 0, K = C[27] | 0, U = 0, D = C[26] | 0, B = 0, ee = C[25] | 0, V = 0, te = C[24] | 0, ue = 0, ge = C[23] | 0, pe = 0, se = C[22] | 0, ce = 0, Oe = C[21] | 0, fe = 0, be = C[20] | 0, me = 0, Ie = C[19] | 0, le = 0, he = C[18] | 0, we = 0, Re = C[17] | 0, Pe = 0, $e = C[16] | 0, We = 0, yt = C[15] | 0, dt = 0, bt = C[14] | 0, ft = 0, xt = C[13] | 0, pt = 0, _t = C[12] | 0, ht = 0, gt = C[11] | 0, Je = 0, mt = C[10] | 0, nt = 0, Et = C[9] | 0, ut = 0, Ot = C[8] | 0, ct = 0, St = C[7] | 0, it = 0, Ct = C[6] | 0, tt = 0, Tt = C[5] | 0, at = 0, wt = C[4] | 0, ot = 0, Pt = C[3] | 0, st = 0, kt = C[2] | 0, rt = 0, Lt = C[1] | 0, It = 0, Gt = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N >> 12 & 63 | 128, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N >> 6 & 63 | 128, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N >> 6 & 63 | 128, S = h * 343, k = R * 343, j = A * 343, I = z * 343, H = K * 343, U = D * 343, B = ee * 343, V = te * 343, ue = ge * 343, pe = se * 343, ce = Oe * 343, fe = be * 343, me = Ie * 343, le = he * 343, we = Re * 343, Pe = $e * 343, We = yt * 343, dt = bt * 343, ft = xt * 343, pt = _t * 343, ht = gt * 343, Je = mt * 343, nt = Et * 343, ut = Ot * 343, ct = St * 343, it = Ct * 343, tt = Tt * 343, at = wt * 343, ot = Pt * 343, st = kt * 343, rt = Lt * 343, It = Gt * 343, Je += h << 8, nt += R << 8, ut += A << 8, ct += z << 8, it += K << 8, tt += D << 8, at += ee << 8, ot += te << 8, st += ge << 8, rt += se << 8, It += Oe << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, Gt = It + (rt >>> 16) & 65535, Lt = rt & 65535, h ^= N & 63 | 128);
        return v(r[Gt >> 8] + r[Gt & 255] + r[Lt >> 8] + r[Lt & 255] + r[kt >> 8] + r[kt & 255] + r[Pt >> 8] + r[Pt & 255] + r[wt >> 8] + r[wt & 255] + r[Tt >> 8] + r[Tt & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Ot >> 8] + r[Ot & 255] + r[Et >> 8] + r[Et & 255] + r[mt >> 8] + r[mt & 255] + r[gt >> 8] + r[gt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[$e >> 8] + r[$e & 255] + r[Re >> 8] + r[Re & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[Oe >> 8] + r[Oe & 255] + r[se >> 8] + r[se & 255] + r[ge >> 8] + r[ge & 255] + r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 512);
      }
      f = Te;
      function et(P) {
        var N, F = P.length - 3, T = w[1024].offset, C = 0, S = T[63] | 0, h = 0, k = T[62] | 0, R = 0, j = T[61] | 0, A = 0, I = T[60] | 0, z = 0, H = T[59] | 0, K = 0, U = T[58] | 0, D = 0, B = T[57] | 0, ee = 0, V = T[56] | 0, te = 0, ue = T[55] | 0, ge = 0, pe = T[54] | 0, se = 0, ce = T[53] | 0, Oe = 0, fe = T[52] | 0, be = 0, me = T[51] | 0, Ie = 0, le = T[50] | 0, he = 0, we = T[49] | 0, Re = 0, Pe = T[48] | 0, $e = 0, We = T[47] | 0, yt = 0, dt = T[46] | 0, bt = 0, ft = T[45] | 0, xt = 0, pt = T[44] | 0, _t = 0, ht = T[43] | 0, gt = 0, Je = T[42] | 0, mt = 0, nt = T[41] | 0, Et = 0, ut = T[40] | 0, Ot = 0, ct = T[39] | 0, St = 0, it = T[38] | 0, Ct = 0, tt = T[37] | 0, Tt = 0, at = T[36] | 0, wt = 0, ot = T[35] | 0, Pt = 0, st = T[34] | 0, kt = 0, rt = T[33] | 0, Lt = 0, It = T[32] | 0, Gt = 0, qr = T[31] | 0, Jr = 0, Ur = T[30] | 0, Xr = 0, Gr = T[29] | 0, en = 0, Hr = T[28] | 0, tn = 0, zr = T[27] | 0, rn = 0, Wr = T[26] | 0, nn = 0, Vr = T[25] | 0, an = 0, Kr = T[24] | 0, on = 0, Zr = T[23] | 0, Qr = 0, Yr = T[22] | 0, Dr = 0, cr = T[21] | 0, $r = 0, lr = T[20] | 0, Wt = 0, Ut = T[19] | 0, Lr = 0, fr = T[18] | 0, Nr = 0, pr = T[17] | 0, Fr = 0, dr = T[16] | 0, Tr = 0, hr = T[15] | 0, er = 0, rr = T[14] | 0, wr = 0, ar = T[13] | 0, Ar = 0, Kt = T[12] | 0, Pr = 0, or = T[11] | 0, Rr = 0, sr = T[10] | 0, Ir = 0, ur = T[9] | 0, mr = 0, gr = T[8] | 0, _r = 0, vr = T[7] | 0, jr = 0, Jt = T[6] | 0, kr = 0, nr = T[5] | 0, Zt = 0, Qt = T[4] | 0, Er = 0, yr = T[3] | 0, Or = 0, br = T[2] | 0, Mr = 0, xr = T[1] | 0, ln = 0, un = T[0] | 0;
        for (N = 0; N < F; )
          S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535;
        for (; N < F + 3; )
          S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535;
        return v(r[un >> 8] + r[un & 255] + r[xr >> 8] + r[xr & 255] + r[br >> 8] + r[br & 255] + r[yr >> 8] + r[yr & 255] + r[Qt >> 8] + r[Qt & 255] + r[nr >> 8] + r[nr & 255] + r[Jt >> 8] + r[Jt & 255] + r[vr >> 8] + r[vr & 255] + r[gr >> 8] + r[gr & 255] + r[ur >> 8] + r[ur & 255] + r[sr >> 8] + r[sr & 255] + r[or >> 8] + r[or & 255] + r[Kt >> 8] + r[Kt & 255] + r[ar >> 8] + r[ar & 255] + r[rr >> 8] + r[rr & 255] + r[hr >> 8] + r[hr & 255] + r[dr >> 8] + r[dr & 255] + r[pr >> 8] + r[pr & 255] + r[fr >> 8] + r[fr & 255] + r[Ut >> 8] + r[Ut & 255] + r[lr >> 8] + r[lr & 255] + r[cr >> 8] + r[cr & 255] + r[Yr >> 8] + r[Yr & 255] + r[Zr >> 8] + r[Zr & 255] + r[Kr >> 8] + r[Kr & 255] + r[Vr >> 8] + r[Vr & 255] + r[Wr >> 8] + r[Wr & 255] + r[zr >> 8] + r[zr & 255] + r[Hr >> 8] + r[Hr & 255] + r[Gr >> 8] + r[Gr & 255] + r[Ur >> 8] + r[Ur & 255] + r[qr >> 8] + r[qr & 255] + r[It >> 8] + r[It & 255] + r[rt >> 8] + r[rt & 255] + r[st >> 8] + r[st & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[tt >> 8] + r[tt & 255] + r[it >> 8] + r[it & 255] + r[ct >> 8] + r[ct & 255] + r[ut >> 8] + r[ut & 255] + r[nt >> 8] + r[nt & 255] + r[Je >> 8] + r[Je & 255] + r[ht >> 8] + r[ht & 255] + r[pt >> 8] + r[pt & 255] + r[ft >> 8] + r[ft & 255] + r[dt >> 8] + r[dt & 255] + r[We >> 8] + r[We & 255] + r[Pe >> 8] + r[Pe & 255] + r[we >> 8] + r[we & 255] + r[le >> 8] + r[le & 255] + r[me >> 8] + r[me & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 1024);
      }
      function Ge(P) {
        var N, F = P.length - 3, T = w[1024].offset, C = 0, S = T[63] | 0, h = 0, k = T[62] | 0, R = 0, j = T[61] | 0, A = 0, I = T[60] | 0, z = 0, H = T[59] | 0, K = 0, U = T[58] | 0, D = 0, B = T[57] | 0, ee = 0, V = T[56] | 0, te = 0, ue = T[55] | 0, ge = 0, pe = T[54] | 0, se = 0, ce = T[53] | 0, Oe = 0, fe = T[52] | 0, be = 0, me = T[51] | 0, Ie = 0, le = T[50] | 0, he = 0, we = T[49] | 0, Re = 0, Pe = T[48] | 0, $e = 0, We = T[47] | 0, yt = 0, dt = T[46] | 0, bt = 0, ft = T[45] | 0, xt = 0, pt = T[44] | 0, _t = 0, ht = T[43] | 0, gt = 0, Je = T[42] | 0, mt = 0, nt = T[41] | 0, Et = 0, ut = T[40] | 0, Ot = 0, ct = T[39] | 0, St = 0, it = T[38] | 0, Ct = 0, tt = T[37] | 0, Tt = 0, at = T[36] | 0, wt = 0, ot = T[35] | 0, Pt = 0, st = T[34] | 0, kt = 0, rt = T[33] | 0, Lt = 0, It = T[32] | 0, Gt = 0, qr = T[31] | 0, Jr = 0, Ur = T[30] | 0, Xr = 0, Gr = T[29] | 0, en = 0, Hr = T[28] | 0, tn = 0, zr = T[27] | 0, rn = 0, Wr = T[26] | 0, nn = 0, Vr = T[25] | 0, an = 0, Kr = T[24] | 0, on = 0, Zr = T[23] | 0, Qr = 0, Yr = T[22] | 0, Dr = 0, cr = T[21] | 0, $r = 0, lr = T[20] | 0, Wt = 0, Ut = T[19] | 0, Lr = 0, fr = T[18] | 0, Nr = 0, pr = T[17] | 0, Fr = 0, dr = T[16] | 0, Tr = 0, hr = T[15] | 0, er = 0, rr = T[14] | 0, wr = 0, ar = T[13] | 0, Ar = 0, Kt = T[12] | 0, Pr = 0, or = T[11] | 0, Rr = 0, sr = T[10] | 0, Ir = 0, ur = T[9] | 0, mr = 0, gr = T[8] | 0, _r = 0, vr = T[7] | 0, jr = 0, Jt = T[6] | 0, kr = 0, nr = T[5] | 0, Zt = 0, Qt = T[4] | 0, Er = 0, yr = T[3] | 0, Or = 0, br = T[2] | 0, Mr = 0, xr = T[1] | 0, ln = 0, un = T[0] | 0;
        for (N = 0; N < F; )
          C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++), C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++);
        for (; N < F + 3; )
          C = S * 397, h = k * 397, R = j * 397, A = I * 397, z = H * 397, K = U * 397, D = B * 397, ee = V * 397, te = ue * 397, ge = pe * 397, se = ce * 397, Oe = fe * 397, be = me * 397, Ie = le * 397, he = we * 397, Re = Pe * 397, $e = We * 397, yt = dt * 397, bt = ft * 397, xt = pt * 397, _t = ht * 397, gt = Je * 397, mt = nt * 397, Et = ut * 397, Ot = ct * 397, St = it * 397, Ct = tt * 397, Tt = at * 397, wt = ot * 397, Pt = st * 397, kt = rt * 397, Lt = It * 397, Gt = qr * 397, Jr = Ur * 397, Xr = Gr * 397, en = Hr * 397, tn = zr * 397, rn = Wr * 397, nn = Vr * 397, an = Kr * 397, on = Zr * 397, Qr = Yr * 397, Dr = cr * 397, $r = lr * 397, Wt = Ut * 397, Lr = fr * 397, Nr = pr * 397, Fr = dr * 397, Tr = hr * 397, er = rr * 397, wr = ar * 397, Ar = Kt * 397, Pr = or * 397, Rr = sr * 397, Ir = ur * 397, mr = gr * 397, _r = vr * 397, jr = Jt * 397, kr = nr * 397, Zt = Qt * 397, Er = yr * 397, Or = br * 397, Mr = xr * 397, ln = un * 397, Dr += S << 8, $r += k << 8, Wt += j << 8, Lr += I << 8, Nr += H << 8, Fr += U << 8, Tr += B << 8, er += V << 8, wr += ue << 8, Ar += pe << 8, Pr += ce << 8, Rr += fe << 8, Ir += me << 8, mr += le << 8, _r += we << 8, jr += Pe << 8, kr += We << 8, Zt += dt << 8, Er += ft << 8, Or += pt << 8, Mr += ht << 8, ln += Je << 8, h += C >>> 16, S = C & 65535, R += h >>> 16, k = h & 65535, A += R >>> 16, j = R & 65535, z += A >>> 16, I = A & 65535, K += z >>> 16, H = z & 65535, D += K >>> 16, U = K & 65535, ee += D >>> 16, B = D & 65535, te += ee >>> 16, V = ee & 65535, ge += te >>> 16, ue = te & 65535, se += ge >>> 16, pe = ge & 65535, Oe += se >>> 16, ce = se & 65535, be += Oe >>> 16, fe = Oe & 65535, Ie += be >>> 16, me = be & 65535, he += Ie >>> 16, le = Ie & 65535, Re += he >>> 16, we = he & 65535, $e += Re >>> 16, Pe = Re & 65535, yt += $e >>> 16, We = $e & 65535, bt += yt >>> 16, dt = yt & 65535, xt += bt >>> 16, ft = bt & 65535, _t += xt >>> 16, pt = xt & 65535, gt += _t >>> 16, ht = _t & 65535, mt += gt >>> 16, Je = gt & 65535, Et += mt >>> 16, nt = mt & 65535, Ot += Et >>> 16, ut = Et & 65535, St += Ot >>> 16, ct = Ot & 65535, Ct += St >>> 16, it = St & 65535, Tt += Ct >>> 16, tt = Ct & 65535, wt += Tt >>> 16, at = Tt & 65535, Pt += wt >>> 16, ot = wt & 65535, kt += Pt >>> 16, st = Pt & 65535, Lt += kt >>> 16, rt = kt & 65535, Gt += Lt >>> 16, It = Lt & 65535, Jr += Gt >>> 16, qr = Gt & 65535, Xr += Jr >>> 16, Ur = Jr & 65535, en += Xr >>> 16, Gr = Xr & 65535, tn += en >>> 16, Hr = en & 65535, rn += tn >>> 16, zr = tn & 65535, nn += rn >>> 16, Wr = rn & 65535, an += nn >>> 16, Vr = nn & 65535, on += an >>> 16, Kr = an & 65535, Qr += on >>> 16, Zr = on & 65535, Dr += Qr >>> 16, Yr = Qr & 65535, $r += Dr >>> 16, cr = Dr & 65535, Wt += $r >>> 16, lr = $r & 65535, Lr += Wt >>> 16, Ut = Wt & 65535, Nr += Lr >>> 16, fr = Lr & 65535, Fr += Nr >>> 16, pr = Nr & 65535, Tr += Fr >>> 16, dr = Fr & 65535, er += Tr >>> 16, hr = Tr & 65535, wr += er >>> 16, rr = er & 65535, Ar += wr >>> 16, ar = wr & 65535, Pr += Ar >>> 16, Kt = Ar & 65535, Rr += Pr >>> 16, or = Pr & 65535, Ir += Rr >>> 16, sr = Rr & 65535, mr += Ir >>> 16, ur = Ir & 65535, _r += mr >>> 16, gr = mr & 65535, jr += _r >>> 16, vr = _r & 65535, kr += jr >>> 16, Jt = jr & 65535, Zt += kr >>> 16, nr = kr & 65535, Er += Zt >>> 16, Qt = Zt & 65535, Or += Er >>> 16, yr = Er & 65535, Mr += Or >>> 16, br = Or & 65535, un = ln + (Mr >>> 16) & 65535, xr = Mr & 65535, S ^= P.charCodeAt(N++);
        return v(r[un >> 8] + r[un & 255] + r[xr >> 8] + r[xr & 255] + r[br >> 8] + r[br & 255] + r[yr >> 8] + r[yr & 255] + r[Qt >> 8] + r[Qt & 255] + r[nr >> 8] + r[nr & 255] + r[Jt >> 8] + r[Jt & 255] + r[vr >> 8] + r[vr & 255] + r[gr >> 8] + r[gr & 255] + r[ur >> 8] + r[ur & 255] + r[sr >> 8] + r[sr & 255] + r[or >> 8] + r[or & 255] + r[Kt >> 8] + r[Kt & 255] + r[ar >> 8] + r[ar & 255] + r[rr >> 8] + r[rr & 255] + r[hr >> 8] + r[hr & 255] + r[dr >> 8] + r[dr & 255] + r[pr >> 8] + r[pr & 255] + r[fr >> 8] + r[fr & 255] + r[Ut >> 8] + r[Ut & 255] + r[lr >> 8] + r[lr & 255] + r[cr >> 8] + r[cr & 255] + r[Yr >> 8] + r[Yr & 255] + r[Zr >> 8] + r[Zr & 255] + r[Kr >> 8] + r[Kr & 255] + r[Vr >> 8] + r[Vr & 255] + r[Wr >> 8] + r[Wr & 255] + r[zr >> 8] + r[zr & 255] + r[Hr >> 8] + r[Hr & 255] + r[Gr >> 8] + r[Gr & 255] + r[Ur >> 8] + r[Ur & 255] + r[qr >> 8] + r[qr & 255] + r[It >> 8] + r[It & 255] + r[rt >> 8] + r[rt & 255] + r[st >> 8] + r[st & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[tt >> 8] + r[tt & 255] + r[it >> 8] + r[it & 255] + r[ct >> 8] + r[ct & 255] + r[ut >> 8] + r[ut & 255] + r[nt >> 8] + r[nt & 255] + r[Je >> 8] + r[Je & 255] + r[ht >> 8] + r[ht & 255] + r[pt >> 8] + r[pt & 255] + r[ft >> 8] + r[ft & 255] + r[dt >> 8] + r[dt & 255] + r[We >> 8] + r[We & 255] + r[Pe >> 8] + r[Pe & 255] + r[we >> 8] + r[we & 255] + r[le >> 8] + r[le & 255] + r[me >> 8] + r[me & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[I >> 8] + r[I & 255] + r[j >> 8] + r[j & 255] + r[k >> 8] + r[k & 255] + r[S >> 8] + r[S & 255], 1024);
      }
      function $t(P) {
        var N, F, T = P.length, C = w[1024].offset, S = 0, h = C[63] | 0, k = 0, R = C[62] | 0, j = 0, A = C[61] | 0, I = 0, z = C[60] | 0, H = 0, K = C[59] | 0, U = 0, D = C[58] | 0, B = 0, ee = C[57] | 0, V = 0, te = C[56] | 0, ue = 0, ge = C[55] | 0, pe = 0, se = C[54] | 0, ce = 0, Oe = C[53] | 0, fe = 0, be = C[52] | 0, me = 0, Ie = C[51] | 0, le = 0, he = C[50] | 0, we = 0, Re = C[49] | 0, Pe = 0, $e = C[48] | 0, We = 0, yt = C[47] | 0, dt = 0, bt = C[46] | 0, ft = 0, xt = C[45] | 0, pt = 0, _t = C[44] | 0, ht = 0, gt = C[43] | 0, Je = 0, mt = C[42] | 0, nt = 0, Et = C[41] | 0, ut = 0, Ot = C[40] | 0, ct = 0, St = C[39] | 0, it = 0, Ct = C[38] | 0, tt = 0, Tt = C[37] | 0, at = 0, wt = C[36] | 0, ot = 0, Pt = C[35] | 0, st = 0, kt = C[34] | 0, rt = 0, Lt = C[33] | 0, It = 0, Gt = C[32] | 0, qr = 0, Jr = C[31] | 0, Ur = 0, Xr = C[30] | 0, Gr = 0, en = C[29] | 0, Hr = 0, tn = C[28] | 0, zr = 0, rn = C[27] | 0, Wr = 0, nn = C[26] | 0, Vr = 0, an = C[25] | 0, Kr = 0, on = C[24] | 0, Zr = 0, Qr = C[23] | 0, Yr = 0, Dr = C[22] | 0, cr = 0, $r = C[21] | 0, lr = 0, Wt = C[20] | 0, Ut = 0, Lr = C[19] | 0, fr = 0, Nr = C[18] | 0, pr = 0, Fr = C[17] | 0, dr = 0, Tr = C[16] | 0, hr = 0, er = C[15] | 0, rr = 0, wr = C[14] | 0, ar = 0, Ar = C[13] | 0, Kt = 0, Pr = C[12] | 0, or = 0, Rr = C[11] | 0, sr = 0, Ir = C[10] | 0, ur = 0, mr = C[9] | 0, gr = 0, _r = C[8] | 0, vr = 0, jr = C[7] | 0, Jt = 0, kr = C[6] | 0, nr = 0, Zt = C[5] | 0, Qt = 0, Er = C[4] | 0, yr = 0, Or = C[3] | 0, br = 0, Mr = C[2] | 0, xr = 0, ln = C[1] | 0, un = 0, An = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N >> 12 & 63 | 128, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N >> 6 & 63 | 128, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N >> 6 & 63 | 128, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N & 63 | 128), S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535;
        return v(r[An >> 8] + r[An & 255] + r[ln >> 8] + r[ln & 255] + r[Mr >> 8] + r[Mr & 255] + r[Or >> 8] + r[Or & 255] + r[Er >> 8] + r[Er & 255] + r[Zt >> 8] + r[Zt & 255] + r[kr >> 8] + r[kr & 255] + r[jr >> 8] + r[jr & 255] + r[_r >> 8] + r[_r & 255] + r[mr >> 8] + r[mr & 255] + r[Ir >> 8] + r[Ir & 255] + r[Rr >> 8] + r[Rr & 255] + r[Pr >> 8] + r[Pr & 255] + r[Ar >> 8] + r[Ar & 255] + r[wr >> 8] + r[wr & 255] + r[er >> 8] + r[er & 255] + r[Tr >> 8] + r[Tr & 255] + r[Fr >> 8] + r[Fr & 255] + r[Nr >> 8] + r[Nr & 255] + r[Lr >> 8] + r[Lr & 255] + r[Wt >> 8] + r[Wt & 255] + r[$r >> 8] + r[$r & 255] + r[Dr >> 8] + r[Dr & 255] + r[Qr >> 8] + r[Qr & 255] + r[on >> 8] + r[on & 255] + r[an >> 8] + r[an & 255] + r[nn >> 8] + r[nn & 255] + r[rn >> 8] + r[rn & 255] + r[tn >> 8] + r[tn & 255] + r[en >> 8] + r[en & 255] + r[Xr >> 8] + r[Xr & 255] + r[Jr >> 8] + r[Jr & 255] + r[Gt >> 8] + r[Gt & 255] + r[Lt >> 8] + r[Lt & 255] + r[kt >> 8] + r[kt & 255] + r[Pt >> 8] + r[Pt & 255] + r[wt >> 8] + r[wt & 255] + r[Tt >> 8] + r[Tt & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Ot >> 8] + r[Ot & 255] + r[Et >> 8] + r[Et & 255] + r[mt >> 8] + r[mt & 255] + r[gt >> 8] + r[gt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[$e >> 8] + r[$e & 255] + r[Re >> 8] + r[Re & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[Oe >> 8] + r[Oe & 255] + r[se >> 8] + r[se & 255] + r[ge >> 8] + r[ge & 255] + r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 1024);
      }
      function Be(P) {
        var N, F, T = P.length, C = w[1024].offset, S = 0, h = C[63] | 0, k = 0, R = C[62] | 0, j = 0, A = C[61] | 0, I = 0, z = C[60] | 0, H = 0, K = C[59] | 0, U = 0, D = C[58] | 0, B = 0, ee = C[57] | 0, V = 0, te = C[56] | 0, ue = 0, ge = C[55] | 0, pe = 0, se = C[54] | 0, ce = 0, Oe = C[53] | 0, fe = 0, be = C[52] | 0, me = 0, Ie = C[51] | 0, le = 0, he = C[50] | 0, we = 0, Re = C[49] | 0, Pe = 0, $e = C[48] | 0, We = 0, yt = C[47] | 0, dt = 0, bt = C[46] | 0, ft = 0, xt = C[45] | 0, pt = 0, _t = C[44] | 0, ht = 0, gt = C[43] | 0, Je = 0, mt = C[42] | 0, nt = 0, Et = C[41] | 0, ut = 0, Ot = C[40] | 0, ct = 0, St = C[39] | 0, it = 0, Ct = C[38] | 0, tt = 0, Tt = C[37] | 0, at = 0, wt = C[36] | 0, ot = 0, Pt = C[35] | 0, st = 0, kt = C[34] | 0, rt = 0, Lt = C[33] | 0, It = 0, Gt = C[32] | 0, qr = 0, Jr = C[31] | 0, Ur = 0, Xr = C[30] | 0, Gr = 0, en = C[29] | 0, Hr = 0, tn = C[28] | 0, zr = 0, rn = C[27] | 0, Wr = 0, nn = C[26] | 0, Vr = 0, an = C[25] | 0, Kr = 0, on = C[24] | 0, Zr = 0, Qr = C[23] | 0, Yr = 0, Dr = C[22] | 0, cr = 0, $r = C[21] | 0, lr = 0, Wt = C[20] | 0, Ut = 0, Lr = C[19] | 0, fr = 0, Nr = C[18] | 0, pr = 0, Fr = C[17] | 0, dr = 0, Tr = C[16] | 0, hr = 0, er = C[15] | 0, rr = 0, wr = C[14] | 0, ar = 0, Ar = C[13] | 0, Kt = 0, Pr = C[12] | 0, or = 0, Rr = C[11] | 0, sr = 0, Ir = C[10] | 0, ur = 0, mr = C[9] | 0, gr = 0, _r = C[8] | 0, vr = 0, jr = C[7] | 0, Jt = 0, kr = C[6] | 0, nr = 0, Zt = C[5] | 0, Qt = 0, Er = C[4] | 0, yr = 0, Or = C[3] | 0, br = 0, Mr = C[2] | 0, xr = 0, ln = C[1] | 0, un = 0, An = C[0] | 0;
        for (F = 0; F < T; F++)
          N = P.charCodeAt(F), S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, N < 128 ? h ^= N : N < 2048 ? (h ^= N >> 6 | 192, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N & 63 | 128) : (N & 64512) == 55296 && F + 1 < T && (P.charCodeAt(F + 1) & 64512) == 56320 ? (N = 65536 + ((N & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= N >> 18 | 240, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N >> 12 & 63 | 128, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N >> 6 & 63 | 128, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N & 63 | 128) : (h ^= N >> 12 | 224, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N >> 6 & 63 | 128, S = h * 397, k = R * 397, j = A * 397, I = z * 397, H = K * 397, U = D * 397, B = ee * 397, V = te * 397, ue = ge * 397, pe = se * 397, ce = Oe * 397, fe = be * 397, me = Ie * 397, le = he * 397, we = Re * 397, Pe = $e * 397, We = yt * 397, dt = bt * 397, ft = xt * 397, pt = _t * 397, ht = gt * 397, Je = mt * 397, nt = Et * 397, ut = Ot * 397, ct = St * 397, it = Ct * 397, tt = Tt * 397, at = wt * 397, ot = Pt * 397, st = kt * 397, rt = Lt * 397, It = Gt * 397, qr = Jr * 397, Ur = Xr * 397, Gr = en * 397, Hr = tn * 397, zr = rn * 397, Wr = nn * 397, Vr = an * 397, Kr = on * 397, Zr = Qr * 397, Yr = Dr * 397, cr = $r * 397, lr = Wt * 397, Ut = Lr * 397, fr = Nr * 397, pr = Fr * 397, dr = Tr * 397, hr = er * 397, rr = wr * 397, ar = Ar * 397, Kt = Pr * 397, or = Rr * 397, sr = Ir * 397, ur = mr * 397, gr = _r * 397, vr = jr * 397, Jt = kr * 397, nr = Zt * 397, Qt = Er * 397, yr = Or * 397, br = Mr * 397, xr = ln * 397, un = An * 397, cr += h << 8, lr += R << 8, Ut += A << 8, fr += z << 8, pr += K << 8, dr += D << 8, hr += ee << 8, rr += te << 8, ar += ge << 8, Kt += se << 8, or += Oe << 8, sr += be << 8, ur += Ie << 8, gr += he << 8, vr += Re << 8, Jt += $e << 8, nr += yt << 8, Qt += bt << 8, yr += xt << 8, br += _t << 8, xr += gt << 8, un += mt << 8, k += S >>> 16, h = S & 65535, j += k >>> 16, R = k & 65535, I += j >>> 16, A = j & 65535, H += I >>> 16, z = I & 65535, U += H >>> 16, K = H & 65535, B += U >>> 16, D = U & 65535, V += B >>> 16, ee = B & 65535, ue += V >>> 16, te = V & 65535, pe += ue >>> 16, ge = ue & 65535, ce += pe >>> 16, se = pe & 65535, fe += ce >>> 16, Oe = ce & 65535, me += fe >>> 16, be = fe & 65535, le += me >>> 16, Ie = me & 65535, we += le >>> 16, he = le & 65535, Pe += we >>> 16, Re = we & 65535, We += Pe >>> 16, $e = Pe & 65535, dt += We >>> 16, yt = We & 65535, ft += dt >>> 16, bt = dt & 65535, pt += ft >>> 16, xt = ft & 65535, ht += pt >>> 16, _t = pt & 65535, Je += ht >>> 16, gt = ht & 65535, nt += Je >>> 16, mt = Je & 65535, ut += nt >>> 16, Et = nt & 65535, ct += ut >>> 16, Ot = ut & 65535, it += ct >>> 16, St = ct & 65535, tt += it >>> 16, Ct = it & 65535, at += tt >>> 16, Tt = tt & 65535, ot += at >>> 16, wt = at & 65535, st += ot >>> 16, Pt = ot & 65535, rt += st >>> 16, kt = st & 65535, It += rt >>> 16, Lt = rt & 65535, qr += It >>> 16, Gt = It & 65535, Ur += qr >>> 16, Jr = qr & 65535, Gr += Ur >>> 16, Xr = Ur & 65535, Hr += Gr >>> 16, en = Gr & 65535, zr += Hr >>> 16, tn = Hr & 65535, Wr += zr >>> 16, rn = zr & 65535, Vr += Wr >>> 16, nn = Wr & 65535, Kr += Vr >>> 16, an = Vr & 65535, Zr += Kr >>> 16, on = Kr & 65535, Yr += Zr >>> 16, Qr = Zr & 65535, cr += Yr >>> 16, Dr = Yr & 65535, lr += cr >>> 16, $r = cr & 65535, Ut += lr >>> 16, Wt = lr & 65535, fr += Ut >>> 16, Lr = Ut & 65535, pr += fr >>> 16, Nr = fr & 65535, dr += pr >>> 16, Fr = pr & 65535, hr += dr >>> 16, Tr = dr & 65535, rr += hr >>> 16, er = hr & 65535, ar += rr >>> 16, wr = rr & 65535, Kt += ar >>> 16, Ar = ar & 65535, or += Kt >>> 16, Pr = Kt & 65535, sr += or >>> 16, Rr = or & 65535, ur += sr >>> 16, Ir = sr & 65535, gr += ur >>> 16, mr = ur & 65535, vr += gr >>> 16, _r = gr & 65535, Jt += vr >>> 16, jr = vr & 65535, nr += Jt >>> 16, kr = Jt & 65535, Qt += nr >>> 16, Zt = nr & 65535, yr += Qt >>> 16, Er = Qt & 65535, br += yr >>> 16, Or = yr & 65535, xr += br >>> 16, Mr = br & 65535, An = un + (xr >>> 16) & 65535, ln = xr & 65535, h ^= N & 63 | 128);
        return v(r[An >> 8] + r[An & 255] + r[ln >> 8] + r[ln & 255] + r[Mr >> 8] + r[Mr & 255] + r[Or >> 8] + r[Or & 255] + r[Er >> 8] + r[Er & 255] + r[Zt >> 8] + r[Zt & 255] + r[kr >> 8] + r[kr & 255] + r[jr >> 8] + r[jr & 255] + r[_r >> 8] + r[_r & 255] + r[mr >> 8] + r[mr & 255] + r[Ir >> 8] + r[Ir & 255] + r[Rr >> 8] + r[Rr & 255] + r[Pr >> 8] + r[Pr & 255] + r[Ar >> 8] + r[Ar & 255] + r[wr >> 8] + r[wr & 255] + r[er >> 8] + r[er & 255] + r[Tr >> 8] + r[Tr & 255] + r[Fr >> 8] + r[Fr & 255] + r[Nr >> 8] + r[Nr & 255] + r[Lr >> 8] + r[Lr & 255] + r[Wt >> 8] + r[Wt & 255] + r[$r >> 8] + r[$r & 255] + r[Dr >> 8] + r[Dr & 255] + r[Qr >> 8] + r[Qr & 255] + r[on >> 8] + r[on & 255] + r[an >> 8] + r[an & 255] + r[nn >> 8] + r[nn & 255] + r[rn >> 8] + r[rn & 255] + r[tn >> 8] + r[tn & 255] + r[en >> 8] + r[en & 255] + r[Xr >> 8] + r[Xr & 255] + r[Jr >> 8] + r[Jr & 255] + r[Gt >> 8] + r[Gt & 255] + r[Lt >> 8] + r[Lt & 255] + r[kt >> 8] + r[kt & 255] + r[Pt >> 8] + r[Pt & 255] + r[wt >> 8] + r[wt & 255] + r[Tt >> 8] + r[Tt & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Ot >> 8] + r[Ot & 255] + r[Et >> 8] + r[Et & 255] + r[mt >> 8] + r[mt & 255] + r[gt >> 8] + r[gt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[$e >> 8] + r[$e & 255] + r[Re >> 8] + r[Re & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[Oe >> 8] + r[Oe & 255] + r[se >> 8] + r[se & 255] + r[ge >> 8] + r[ge & 255] + r[te >> 8] + r[te & 255] + r[ee >> 8] + r[ee & 255] + r[D >> 8] + r[D & 255] + r[K >> 8] + r[K & 255] + r[z >> 8] + r[z & 255] + r[A >> 8] + r[A & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 1024);
      }
      return p = et, L("1a"), Z(!1), Q(), {
        hash: O,
        setKeyspace: M,
        version: L,
        useUTF8: Z,
        seed: Q,
        fast1a32: ae,
        fast1a32hex: re,
        fast1a52: X,
        fast1a52hex: de,
        fast1a64: Ce,
        fast1a32utf: J,
        fast1a32hexutf: ne,
        fast1a52utf: De,
        fast1a52hexutf: je,
        fast1a64utf: Me
      };
    })();
    e.exports = t;
  })($h)), $h.exports;
}
var Zb;
function oB() {
  if (Zb) return Us;
  Zb = 1, Object.defineProperty(Us, "__esModule", { value: !0 }), Us.hash = Us.setSkipHashing = void 0;
  const e = aB();
  let t = !1;
  const n = (i) => {
    t = i;
  };
  Us.setSkipHashing = n;
  const r = (i, a = t) => a ? i : e.fast1a52hex(i);
  return Us.hash = r, Us;
}
var Yb;
function Mf() {
  if (Yb) return el;
  Yb = 1, Object.defineProperty(el, "__esModule", { value: !0 }), el.createContext = void 0;
  const e = /* @__PURE__ */ Ci(), t = /* @__PURE__ */ oB(), n = /* @__PURE__ */ ga();
  function r(i, a = n.resolveRef) {
    return (0, e.createContext)(i, a, t.hash);
  }
  return el.createContext = r, el;
}
var tl = {}, ca = {}, ci = {}, Jb;
function Sc() {
  if (Jb) return ci;
  Jb = 1, Object.defineProperty(ci, "__esModule", { value: !0 }), ci.isFormDataParam = ci.isBodyParam = ci.isHeaderParam = ci.isPathParam = ci.isQueryParam = ci.isValidScheme = ci.isResponseObject = ci.isSecurityScheme = void 0;
  const e = Zn, t = /* @__PURE__ */ Vi();
  function n(l) {
    return (0, e.isPlainObject)(l) && typeof l.type == "string";
  }
  ci.isSecurityScheme = n;
  const r = (l) => (0, e.isPlainObject)(l) && ("description" in l || "schema" in l || "headers" in l || "examples" in l);
  ci.isResponseObject = r;
  function i(l) {
    return typeof l == "string" && ["http", "https", "ws", "wss"].includes(l);
  }
  ci.isValidScheme = i;
  function a(l) {
    return (0, t.isValidOas2ParameterObject)(l) && l.in === "query";
  }
  ci.isQueryParam = a;
  function o(l) {
    return (0, t.isValidOas2ParameterObject)(l) && l.in === "path";
  }
  ci.isPathParam = o;
  function c(l) {
    return (0, t.isValidOas2ParameterObject)(l) && l.in === "header";
  }
  ci.isHeaderParam = c;
  function u(l) {
    return (0, t.isValidOas2ParameterObject)(l) && l.in === "body";
  }
  ci.isBodyParam = u;
  function s(l) {
    return (0, t.isValidOas2ParameterObject)(l) && l.in === "formData";
  }
  return ci.isFormDataParam = s, ci;
}
var Qb;
function B0() {
  if (Qb) return ca;
  Qb = 1, Object.defineProperty(ca, "__esModule", { value: !0 }), ca.getExamplesFromSchema = ca.normalizeProducesOrConsumes = ca.getConsumes = ca.getProduces = ca.getSecurities = void 0;
  const e = Zn, t = Xn(), n = /* @__PURE__ */ Jn(), r = /* @__PURE__ */ Sc();
  function i(f, p) {
    if (!(0, n.isNonNullable)(f.securityDefinitions) || (0, t.isEmpty)(f.securityDefinitions))
      return [];
    const g = p || f.security, b = c(g, f.securityDefinitions);
    return d(g) && b.push([]), b;
  }
  ca.getSecurities = i;
  function a(f, p) {
    return s("produces", f, p);
  }
  ca.getProduces = a;
  function o(f, p) {
    return s("consumes", f, p);
  }
  ca.getConsumes = o;
  function c(f, p) {
    return !Array.isArray(f) || !p ? [] : f.map((g) => (0, e.isPlainObject)(g) ? Object.keys(g).map((b) => {
      const w = p[b];
      if ((0, r.isSecurityScheme)(w)) {
        const y = { ...w, key: b }, v = g[b], _ = Array.isArray(v) ? v : [];
        return y.type === "oauth2" && _.length && (y.scopes = (0, t.pickBy)(y.scopes, (E, O) => _.includes(O))), y;
      }
      return null;
    }).filter(n.isNonNullable) : []).filter((g) => !(0, t.isEmpty)(g));
  }
  function u(f) {
    return Array.isArray(f) ? f.flat().filter(n.isString) : [];
  }
  ca.normalizeProducesOrConsumes = u;
  function s(f, p, g) {
    return u(g?.[f] || p?.[f]);
  }
  function l(f) {
    return (0, e.isPlainObject)(f) ? {
      ...(0, e.isPlainObject)(f["x-examples"]) && { ...f["x-examples"] },
      ..."example" in f && { default: f.example }
    } : {};
  }
  ca.getExamplesFromSchema = l;
  function d(f) {
    return Array.isArray(f) && f.length > 1 && f.some((p) => (0, t.isEmpty)(p));
  }
  return ca;
}
var Lh = {}, rl = {}, Xb;
function Bf() {
  if (Xb) return rl;
  Xb = 1, Object.defineProperty(rl, "__esModule", { value: !0 }), rl.translateToDefaultExample = void 0;
  const e = /* @__PURE__ */ Ci();
  return rl.translateToDefaultExample = (0, e.withContext)(function(t, n) {
    const r = this.maybeResolveLocalRef(n);
    return {
      id: this.generateId.example({ keyOrName: t }),
      value: r,
      key: t
    };
  }), rl;
}
var e8;
function A2() {
  return e8 || (e8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSharedParameters = e.translateToPathParameter = e.translateToQueryParameter = e.translateFromFormDataParameters = e.translateToBodyParameter = e.translateToHeaderParams = e.translateToHeaderParam = void 0;
    const t = Zn, n = /* @__PURE__ */ wc(), r = Xn(), i = /* @__PURE__ */ Ci(), a = /* @__PURE__ */ Jn(), o = /* @__PURE__ */ Vi(), c = /* @__PURE__ */ ga(), u = /* @__PURE__ */ Bf(), s = /* @__PURE__ */ Eu(), l = /* @__PURE__ */ Si(), d = /* @__PURE__ */ B0(), f = /* @__PURE__ */ Sc(), p = ["application/x-www-form-urlencoded", "multipart/form-data"];
    function g(_) {
      if (_.type !== "array")
        return { style: n.HttpParamStyles.Unspecified };
      switch (_.collectionFormat) {
        case "csv":
          return { style: n.HttpParamStyles.CommaDelimited };
        case "ssv":
          return { style: n.HttpParamStyles.SpaceDelimited };
        case "tsv":
          return { style: n.HttpParamStyles.TabDelimited };
        case "pipes":
          return { style: n.HttpParamStyles.PipeDelimited };
        case "multi":
          return { style: n.HttpParamStyles.Form, explode: !0 };
        default:
          return { style: n.HttpParamStyles.CommaDelimited };
      }
    }
    e.translateToHeaderParam = (0, i.withContext)(function(_) {
      const E = _.name, O = (0, c.getSharedKey)(_, E);
      return {
        id: this.generateId.httpHeader({ keyOrName: O, componentType: "parameter" }),
        name: E,
        style: n.HttpParamStyles.Simple,
        ...v.call(this, _),
        ...(0, r.pickBy)({
          required: _.required
        }, a.isBoolean)
      };
    });
    const b = function([_, E]) {
      if ((0, o.isReferenceObject)(E))
        return E.name = _, E;
      if (!(0, t.isPlainObject)(E))
        return;
      const O = { name: _, in: "header", ...E };
      if ((0, f.isHeaderParam)(O))
        return e.translateToHeaderParam.call(this, O);
    }, w = function(_) {
      return (0, l.entries)(_).map(b, this).filter(a.isNonNullable);
    };
    e.translateToHeaderParams = w, e.translateToBodyParameter = (0, i.withContext)(function(_, E) {
      const O = this.generateId.httpRequestBody({}), M = (0, l.entries)(_["x-examples"] || (0, d.getExamplesFromSchema)(_.schema)).map(([Z, Q]) => u.translateToDefaultExample.call(this, Z, Q)), L = E.filter((Z) => !p.includes(Z));
      return {
        id: O,
        contents: L.map((0, i.withContext)((Z) => ({
          id: this.generateId.httpMedia({ mediaType: Z }),
          mediaType: Z,
          examples: M,
          ...(0, r.pickBy)({
            schema: (0, t.isPlainObject)(_.schema) ? s.translateSchemaObject.call(this, _.schema) : void 0
          }, a.isNonNullable)
        })), this),
        ...(0, r.pickBy)({
          required: _.required
        }, a.isBoolean),
        ...(0, r.pickBy)({
          description: _.description
        }, a.isString),
        ...(0, r.pickBy)({
          name: _.name
        }, a.isString)
      };
    }), e.translateFromFormDataParameters = (0, i.withContext)(function(_, E) {
      const O = E.filter((L) => p.includes(L)), M = {
        id: this.generateId.httpRequestBody({ consumes: O }),
        contents: O.map((0, i.withContext)((L) => ({
          id: this.generateId.httpMedia({ mediaType: L }),
          mediaType: L,
          ...(0, r.pickBy)({
            schema: _.length > 0 ? s.translateSchemaObject.call(this, { type: "object", properties: {} }) : void 0
          }, a.isNonNullable)
        })), this)
      };
      return _.reduce((L, Z) => {
        var Q, ae, re;
        const { schema: X = {}, description: de } = v.call(this, Z);
        delete X.$schema, delete X["x-stoplight"];
        for (const Ce of L.contents) {
          typeof de == "string" && de.length > 0 && (X.description = de), Ce.schema.properties[Z.name] = X, Z.required && ((Q = (re = Ce.schema).required) !== null && Q !== void 0 ? Q : re.required = []).push(Z.name);
          const J = y(Z);
          J && ((ae = Ce.encodings) !== null && ae !== void 0 ? ae : Ce.encodings = []).push(J);
        }
        return L;
      }, M);
    });
    function y(_) {
      switch (_.collectionFormat) {
        case "csv":
          return {
            property: _.name,
            style: n.HttpParamStyles.CommaDelimited,
            explode: !1
          };
        case "pipes":
          return {
            property: _.name,
            style: n.HttpParamStyles.PipeDelimited,
            explode: !1
          };
        case "multi":
          return {
            property: _.name,
            style: n.HttpParamStyles.Form,
            explode: !0
          };
        case "ssv":
          return {
            property: _.name,
            style: n.HttpParamStyles.SpaceDelimited,
            explode: !1
          };
      }
      return null;
    }
    e.translateToQueryParameter = (0, i.withContext)(function(_) {
      const E = _.name, O = (0, c.getSharedKey)(_, E);
      return {
        id: this.generateId.httpQuery({ keyOrName: O }),
        name: E,
        ...g(_),
        ...v.call(this, _),
        ...(0, r.pickBy)({
          allowEmptyValue: _.allowEmptyValue,
          required: _.required
        }, a.isBoolean)
      };
    }), e.translateToPathParameter = (0, i.withContext)(function(_) {
      const E = _.name, O = (0, c.getSharedKey)(_, E);
      return {
        id: this.generateId.httpPathParam({ keyOrName: O }),
        name: E,
        style: n.HttpParamStyles.Simple,
        ...v.call(this, _),
        ...(0, r.pickBy)({
          required: _.required
        }, a.isBoolean)
      };
    });
    const v = function(_) {
      const E = (0, r.pick)(_, "type", "format", "default", "enum", "exclusiveMaximum", "exclusiveMinimum", "maxItems", "maxLength", "maximum", "minItems", "minimum", "minLength", "title", "items", "pattern", "uniqueItems", "multipleOf");
      return "allowEmptyValue" in _ && _.allowEmptyValue === !1 && (E.minLength = 1), {
        ...(0, r.pickBy)({
          schema: Object.keys(E).length > 0 ? s.translateSchemaObject.call(this, E) : void 0
        }, a.isNonNullable),
        ...(0, r.pickBy)({
          deprecated: _["x-deprecated"]
        }, a.isBoolean),
        ...(0, r.pickBy)({
          description: _.description
        }, a.isString)
      };
    };
    e.translateToSharedParameters = (0, i.withContext)(function(_) {
      const E = {
        header: [],
        query: [],
        cookie: [],
        path: [],
        unknownParameters: []
      };
      for (const [O, M] of (0, l.entries)(_.parameters))
        (0, c.setSharedKey)(M, O), !(!(0, o.isValidOas2ParameterObject)(M) || M.in === "formData" || M.in === "body") && (this.references[`#/parameters/${O}`] = {
          resolved: !0,
          value: `#/components/${M.in}/${E[M.in].length}`
        }, (0, f.isQueryParam)(M) ? E.query.push({
          key: O,
          ...e.translateToQueryParameter.call(this, M)
        }) : (0, f.isPathParam)(M) ? E.path.push({
          key: O,
          ...e.translateToPathParameter.call(this, M)
        }) : (0, f.isHeaderParam)(M) && E.header.push({
          key: O,
          ...e.translateToHeaderParam.call(this, M)
        }));
      return E;
    });
  })(Lh)), Lh;
}
var t8;
function sB() {
  if (t8) return tl;
  t8 = 1, Object.defineProperty(tl, "__esModule", { value: !0 }), tl.translateToRequest = void 0;
  const e = Xn(), t = /* @__PURE__ */ Jn(), n = /* @__PURE__ */ M0(), r = /* @__PURE__ */ Ps(), i = /* @__PURE__ */ Vi(), a = /* @__PURE__ */ ga(), o = /* @__PURE__ */ B0(), c = /* @__PURE__ */ Sc(), u = /* @__PURE__ */ A2(), s = (0, r.createOasParamsIterator)(n.OasVersion.OAS2), l = function(d, f) {
    var p;
    const g = (0, o.getConsumes)(this.document, f), b = s.call(this, d, f), w = {
      headers: [],
      query: [],
      cookie: [],
      path: [],
      unknown: []
    };
    let y;
    const v = [];
    for (const E of b) {
      if ((0, i.isReferenceObject)(E)) {
        const O = (p = (0, a.getComponentName)(this.references, E.$ref)) !== null && p !== void 0 ? p : "", M = w[O === "header" ? "headers" : O || "unknown"];
        Array.isArray(M) && M.push((0, a.syncReferenceObject)(E, this.references));
        continue;
      }
      (0, c.isQueryParam)(E) ? w.query.push(u.translateToQueryParameter.call(this, E)) : (0, c.isPathParam)(E) ? w.path.push(u.translateToPathParameter.call(this, E)) : (0, c.isHeaderParam)(E) ? w.headers.push(u.translateToHeaderParam.call(this, E)) : (0, c.isBodyParam)(E) ? y = u.translateToBodyParameter.call(this, E, g) : (0, c.isFormDataParam)(E) && v.push(E);
    }
    let _;
    return y ? _ = y : v.length && (_ = u.translateFromFormDataParameters.call(this, v, g)), w.unknown && !w.unknown.length && delete w.unknown, {
      ...w,
      ...(0, e.pickBy)({
        body: _
      }, t.isNonNullable)
    };
  };
  return tl.translateToRequest = l, tl;
}
var Nh = {}, r8;
function Hk() {
  return r8 || (r8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSharedResponses = e.translateToResponses = e.translateToResponse = void 0;
    const t = Zn, n = Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Jn(), a = /* @__PURE__ */ Vi(), o = /* @__PURE__ */ ga(), c = /* @__PURE__ */ Bf(), u = /* @__PURE__ */ Eu(), s = /* @__PURE__ */ Si(), l = /* @__PURE__ */ B0(), d = /* @__PURE__ */ Sc(), f = /* @__PURE__ */ A2();
    e.translateToResponse = (0, r.withContext)(function(b, w, y) {
      var v;
      const _ = (v = this.maybeResolveLocalRef(y)) !== null && v !== void 0 ? v : y;
      if ((0, a.isReferenceObject)(_))
        return _.code = w, _;
      if (!(0, d.isResponseObject)(_))
        return;
      const E = this.context === "service" ? (0, o.getSharedKey)(_, w) : w, O = this.generateId.httpResponse({ codeOrKey: E, produces: b }), M = f.translateToHeaderParams.call(this, _.headers), L = (0, s.entries)(_.examples || (0, l.getExamplesFromSchema)(_.schema)).map(([re, X]) => c.translateToDefaultExample.call(this, re, X)), Z = b.map((0, r.withContext)((re) => ({
        id: this.generateId.httpMedia({ mediaType: re }),
        mediaType: re,
        examples: L.filter((X) => X.key === re),
        ...(0, n.pickBy)({
          schema: (0, t.isPlainObject)(_.schema) ? u.translateSchemaObject.call(this, _.schema) : void 0
        }, i.isNonNullable)
      })), this).filter(({ schema: re, examples: X }) => !!re || X.length > 0), Q = {
        id: O,
        code: w,
        description: _.description,
        headers: M,
        contents: Z
      }, ae = L.filter((re) => !b.includes(re.key));
      return ae.length > 0 && (Q.contents.length === 0 && (Q.contents[0] = {
        id: this.generateId.httpMedia({ mediaType: "" }),
        mediaType: "",
        schema: {},
        examples: []
      }), Q.contents[0].examples.push(...ae)), Q;
    });
    const p = function(b) {
      const w = (0, l.getProduces)(this.document, b);
      return (0, s.entries)(b.responses).map(([y, v]) => e.translateToResponse.call(this, w, y, v)).filter(i.isNonNullable);
    };
    e.translateToResponses = p;
    const g = function(b) {
      const w = {
        responses: []
      };
      for (const [y, v] of (0, s.entries)(b.responses))
        (0, o.setSharedKey)(v, y), w.responses.push({
          key: y,
          ...e.translateToResponse.call(this, ["application/x-stoplight-placeholder"], y, v)
        });
      return w;
    };
    e.translateToSharedResponses = g;
  })(Nh)), Nh;
}
var Fh = {}, n8;
function zk() {
  return n8 || (n8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSecurities = e.translateToSingleSecurity = e.translateToOauth2SecurityScheme = e.translateToApiKeySecurityScheme = e.translateToBasicSecurityScheme = e.translateToFlows = void 0;
    const t = Zn, n = Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Jn(), a = /* @__PURE__ */ Ps(), o = /* @__PURE__ */ B0(), c = /* @__PURE__ */ Sc(), u = function(f) {
      const p = {}, g = (0, t.isPlainObject)(f.scopes) ? (0, n.pickBy)(f.scopes, i.isString) : {}, b = "authorizationUrl" in f && typeof f.authorizationUrl == "string" ? f.authorizationUrl : "", w = "tokenUrl" in f && typeof f.tokenUrl == "string" ? f.tokenUrl : "";
      return f.flow === "implicit" ? p.implicit = {
        authorizationUrl: b,
        scopes: g
      } : f.flow === "password" ? p.password = {
        tokenUrl: w,
        scopes: g
      } : f.flow === "application" ? p.clientCredentials = {
        tokenUrl: w,
        scopes: g
      } : f.flow === "accessCode" && (p.authorizationCode = {
        authorizationUrl: b,
        tokenUrl: w,
        scopes: g
      }), p;
    };
    e.translateToFlows = u, e.translateToBasicSecurityScheme = (0, r.withContext)(function(f, p, g) {
      const b = f.key;
      return {
        id: this.generateId.httpSecurity({
          keyOrName: b,
          kind: p,
          ...p === "requirement" ? {
            index: g
          } : {}
        }),
        type: "http",
        scheme: "basic",
        key: b,
        ...(0, n.pickBy)({
          description: f.description
        }, i.isString),
        extensions: (0, a.getExtensions)(f)
      };
    });
    const s = ["query", "header"];
    e.translateToApiKeySecurityScheme = (0, r.withContext)(function(f, p, g) {
      if ("in" in f && f.in && s.includes(f.in)) {
        const b = f.key;
        return {
          id: this.generateId.httpSecurity({
            keyOrName: b,
            kind: p,
            ...p === "requirement" ? {
              index: g
            } : {}
          }),
          type: "apiKey",
          in: f.in,
          name: (0, i.isString)(f.name) ? f.name : "",
          key: b,
          ...(0, n.pickBy)({
            description: f.description
          }, i.isString),
          extensions: (0, a.getExtensions)(f)
        };
      }
    });
    const l = ["implicit", "password", "application", "accessCode"];
    e.translateToOauth2SecurityScheme = (0, r.withContext)(function(f, p, g) {
      if (!f.flow || !l.includes(f.flow))
        return;
      const b = f.key;
      return {
        id: this.generateId.httpSecurity({
          keyOrName: b,
          kind: p,
          ...p === "requirement" ? {
            index: g
          } : {}
        }),
        type: "oauth2",
        flows: e.translateToFlows.call(this, f),
        key: b,
        ...(0, n.pickBy)({
          description: f.description
        }, i.isString),
        extensions: (0, a.getExtensions)(f)
      };
    });
    const d = function(f, p, g) {
      if ((0, c.isSecurityScheme)(p))
        switch (p.type) {
          case "basic":
            return e.translateToBasicSecurityScheme.call(this, p, f, g);
          case "apiKey":
            return e.translateToApiKeySecurityScheme.call(this, p, f, g);
          case "oauth2":
            return e.translateToOauth2SecurityScheme.call(this, p, f, g);
        }
    };
    e.translateToSingleSecurity = d, e.translateToSecurities = (0, r.withContext)(function(f, p) {
      return this.context = "service", (0, o.getSecurities)(this.document, f).map((b) => b.map(e.translateToSingleSecurity.bind(this, p)).filter(i.isNonNullable));
    });
  })(Fh)), Fh;
}
var Mh = {}, i8;
function Vk() {
  return i8 || (i8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToServer = e.translateToServers = void 0;
    const t = Xn(), n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Sc();
    e.translateToServers = (0, n.withContext)(function(a) {
      let o;
      if (Array.isArray(a.schemes))
        o = a.schemes, this.context = "operation";
      else if (Array.isArray(this.document.schemes))
        o = this.document.schemes, this.context = "service";
      else
        return [];
      return o.map(e.translateToServer, this).filter(r.isNonNullable);
    }), e.translateToServer = (0, n.withContext)(function(a) {
      var o;
      const { host: c } = this.document;
      if (typeof c != "string" || c.length === 0 || !(0, r.isString)(a) || !(0, i.isValidScheme)(a))
        return;
      const u = typeof this.document.basePath == "string" && this.document.basePath.length > 0 ? this.document.basePath : null, s = new URL("https://localhost");
      s.protocol = `${a}:`, s.host = c, u !== null && (s.pathname = u);
      const l = s.toString().replace(/\/$/, "");
      return {
        id: this.generateId.httpServer({ url: l }),
        url: l,
        ...(0, t.pickBy)({
          name: (o = this.document.info) === null || o === void 0 ? void 0 : o.title
        }, r.isString)
      };
    });
  })(Mh)), Mh;
}
var a8;
function Gk() {
  return a8 || (a8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas2Operation = e.transformOas2Operations = void 0;
    const t = /* @__PURE__ */ Mf(), n = /* @__PURE__ */ k2(), r = /* @__PURE__ */ sB(), i = /* @__PURE__ */ Hk(), a = /* @__PURE__ */ zk(), o = /* @__PURE__ */ Vk();
    function c(s, l) {
      return (0, n.transformOasEndpointOperations)(s, e.transformOas2Operation, n.OPERATION_CONFIG, void 0, l);
    }
    e.transformOas2Operations = c;
    const u = ({ document: s, name: l, method: d, config: f, ctx: p = (0, t.createContext)(s) }) => {
      const g = n.transformOasEndpointOperation.call(p, f, l, d), b = p.maybeResolveLocalRef(p.document[f.documentProp][l]), w = p.maybeResolveLocalRef(b[d]);
      return {
        ...g,
        responses: i.translateToResponses.call(p, w),
        servers: o.translateToServers.call(p, w),
        request: r.translateToRequest.call(p, b, w),
        security: a.translateToSecurities.call(p, w.security, "requirement")
      };
    };
    e.transformOas2Operation = u;
  })(Dh)), Dh;
}
var Bh = {}, nl = {}, o8;
function Wk() {
  if (o8) return nl;
  o8 = 1, Object.defineProperty(nl, "__esModule", { value: !0 }), nl.transformOasService = void 0;
  const e = Zn, t = Xn(), n = /* @__PURE__ */ Jn(), r = /* @__PURE__ */ Ps(), i = /* @__PURE__ */ S2(), a = /* @__PURE__ */ Vi(), o = /* @__PURE__ */ Bk(), c = /* @__PURE__ */ Uk(), u = function() {
    var s, l, d, f, p, g, b, w;
    const y = this.document, v = String((s = y["x-stoplight"]) === null || s === void 0 ? void 0 : s.id);
    this.ids.service = v, this.parentId = v;
    const _ = {
      id: v,
      version: (d = (l = y.info) === null || l === void 0 ? void 0 : l.version) !== null && d !== void 0 ? d : "",
      name: (p = (f = y.info) === null || f === void 0 ? void 0 : f.title) !== null && p !== void 0 ? p : "no-title",
      ...(0, t.pickBy)({
        description: (g = y.info) === null || g === void 0 ? void 0 : g.description,
        termsOfService: (b = y.info) === null || b === void 0 ? void 0 : b.termsOfService
      }, n.isString),
      ...(0, t.pickBy)({
        contact: (w = y.info) === null || w === void 0 ? void 0 : w.contact
      }, e.isPlainObject),
      ...(0, t.pickBy)({
        internal: y["x-internal"]
      }, n.isBoolean),
      ...(0, i.toExternalDocs)(y.externalDocs),
      extensions: (0, r.getExtensions)(y),
      infoExtensions: (0, r.getExtensions)(y.info)
    };
    (0, e.isPlainObject)(y.info) && (0, a.hasXLogo)(y.info) && (_.logo = (0, c.translateLogo)(y.info));
    const E = Array.isArray(y.tags) ? y.tags.map(o.translateTagDefinition, this).filter(n.isNonNullable) : [];
    return E.length > 0 && (_.tags = E), _;
  };
  return nl.transformOasService = u, nl;
}
var il = {}, s8;
function Kk() {
  if (s8) return il;
  s8 = 1, Object.defineProperty(il, "__esModule", { value: !0 }), il.translateToComponents = void 0;
  const e = Zn, t = /* @__PURE__ */ Jn(), n = /* @__PURE__ */ Si(), r = /* @__PURE__ */ Vi(), i = /* @__PURE__ */ ga(), a = /* @__PURE__ */ Ff();
  function o(u, s) {
    const l = u === "#/components" ? this.document.components : this.document;
    return (d, f) => {
      const p = s[d];
      if (p === void 0 || !(0, e.isPlainObject)(l))
        return [];
      const g = [], b = (0, n.entries)(l[d]);
      for (let w = 0; w < b.length; w++) {
        const y = b[w], [v, _] = y;
        if ((0, i.setSharedKey)(_, v), (0, r.isReferenceObject)(_)) {
          this.references[`${u}/${d}/${v}`] = {
            resolved: !0,
            value: `#/components/${f}/${g.length}`
          };
          const O = {
            ..._,
            key: v
          };
          g.push((0, i.syncReferenceObject)(O, this.references));
          continue;
        }
        const E = p.call(this, b[w], w, b);
        (0, t.isNonNullable)(E) && (this.references[`${u}/${d}/${v}`] = {
          resolved: !0,
          value: `#/components/${f}/${g.length}`
        }, E.key = v, g.push(E));
      }
      return g;
    };
  }
  const c = function(u, s) {
    const l = u === a.OasVersion.OAS3 ? "#/components" : "#", d = o.call(this, l, s);
    return {
      responses: d("responses", "responses"),
      schemas: d(u === a.OasVersion.OAS3 ? "schemas" : "definitions", "schemas"),
      requestBodies: d("requestBodies", "requestBodies"),
      examples: d("examples", "examples"),
      securitySchemes: d(u === a.OasVersion.OAS3 ? "securitySchemes" : "securityDefinitions", "securitySchemes")
    };
  };
  return il.translateToComponents = c, il;
}
var u8;
function uB() {
  return u8 || (u8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas2Service = e.bundleOas2Service = void 0;
    const t = Zn, n = Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Jn(), a = /* @__PURE__ */ Mf(), o = /* @__PURE__ */ Vi(), c = /* @__PURE__ */ ga(), u = /* @__PURE__ */ Wk(), s = /* @__PURE__ */ Kk(), l = /* @__PURE__ */ Eu(), d = /* @__PURE__ */ Ff(), f = /* @__PURE__ */ Si(), p = /* @__PURE__ */ Gk(), g = /* @__PURE__ */ A2(), b = /* @__PURE__ */ Hk(), w = /* @__PURE__ */ zk(), y = /* @__PURE__ */ Vk(), v = function(M) {
      const L = c.resolveRef.call(this, M);
      return M.$ref.startsWith("#/responses/") || (0, o.isValidOas2ParameterObject)(L) && (L.in === "formData" || L.in === "body") ? L : (0, c.syncReferenceObject)(M, this.references);
    }, _ = ({ document: M }) => {
      const L = (0, a.createContext)(M, v), { document: Z } = L, { securitySchemes: Q, ...ae } = (0, e.transformOas2Service)({ document: Z, ctx: L }), re = {
        ...s.translateToComponents.call(L, d.OasVersion.OAS2, {
          definitions: l.translateSchemaObjectFromPair,
          securityDefinitions: O
        }),
        ...b.translateToSharedResponses.call(L, Z),
        ...g.translateToSharedParameters.call(L, Z),
        callbacks: []
      }, X = (0, p.transformOas2Operations)(Z, L);
      return {
        ...ae,
        operations: X,
        webhooks: [],
        components: re
      };
    };
    e.bundleOas2Service = _;
    const E = ({ document: M, ctx: L = (0, a.createContext)(M) }) => {
      var Z;
      const Q = u.transformOasService.call(L);
      !((Z = M.info) === null || Z === void 0) && Z.license && (Q.license = {
        ...M.info.license,
        name: M.info.license.name || ""
      });
      const re = (Array.isArray(M.schemes) ? M.schemes.filter(i.isString) : []).map(y.translateToServer, L).filter(i.isNonNullable);
      re.length && (Q.servers = re);
      const X = (0, f.entries)(M.securityDefinitions).map(O, L).filter(i.isNonNullable);
      X.length && (Q.securitySchemes = X);
      const de = Array.isArray(M.security) ? M.security.map((Ce) => (0, t.isPlainObject)(Ce) ? Object.keys(Ce).map((J) => {
        const ne = X.find((De) => De.key === J);
        if (ne?.type === "oauth2") {
          const De = {};
          for (const je in ne.flows) {
            const Me = ne.flows[je];
            De[je] = {
              ...Me,
              scopes: (0, n.pickBy)(Me.scopes, (qe, Ve) => {
                const xe = Ce[J];
                if (xe)
                  return xe.includes(Ve);
              })
            };
          }
          return {
            ...ne,
            flows: De
          };
        }
        return ne;
      }).filter(i.isNonNullable) : null).filter(i.isNonNullable) : [];
      return de.length && (Q.security = de), Q;
    };
    e.transformOas2Service = E;
    const O = (0, r.withContext)(function([M, L], Z) {
      if ((0, t.isPlainObject)(L))
        return w.translateToSingleSecurity.call(this, "scheme", { ...L, key: M }, Z, []);
    });
  })(Bh)), Bh;
}
var c8;
function cB() {
  return c8 || (c8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = F0;
    t.__exportStar(/* @__PURE__ */ Gk(), e), t.__exportStar(/* @__PURE__ */ uB(), e);
  })(qh)), qh;
}
var l8 = /* @__PURE__ */ cB(), Uh = {}, Hh = {}, al = {}, f8;
function Zk() {
  if (f8) return al;
  f8 = 1, Object.defineProperty(al, "__esModule", { value: !0 }), al.translateToCallbacks = void 0;
  const e = /* @__PURE__ */ Mf(), t = /* @__PURE__ */ Vi(), n = /* @__PURE__ */ k2(), r = /* @__PURE__ */ Si(), i = /* @__PURE__ */ T2(), a = function(o) {
    const c = (0, r.entries)(o);
    if (c.length)
      return c.reduce((u, [s, l]) => {
        (0, t.isReferenceObject)(l) && u.push({ key: s, ...l });
        for (const [d, f] of (0, r.entries)(l))
          for (const [p, g] of (0, r.entries)(f)) {
            const b = {
              openapi: "3",
              info: { title: "", version: "1" },
              paths: { [d]: { [p]: g } }
            }, w = (0, e.createContext)(b);
            w.context = "callback", Object.assign(w.ids, this.ids), w.ids.operation = this.generateId.httpCallbackOperation({
              parentId: this.ids.service,
              method: p,
              path: d,
              key: s
            }), u.push({
              ...(0, i.transformOas3Operation)({
                document: b,
                method: p,
                name: d,
                key: s,
                config: n.OPERATION_CONFIG,
                ctx: w
              }),
              key: s
            });
          }
        return u;
      }, []);
  };
  return al.translateToCallbacks = a, al;
}
var zh = {}, Vh = {}, p8;
function Ou() {
  return p8 || (p8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isRequestBodyObject = e.isOAuthFlowObject = e.isResponseObject = e.isServerVariableObject = e.isServerObject = e.isHeaderObject = e.isBaseParameterObject = e.isSecurityScheme = void 0;
    const t = Zn, n = (l) => (0, t.isPlainObject)(l) && typeof l.type == "string";
    e.isSecurityScheme = n;
    const r = (l) => (0, t.isPlainObject)(l) && ("description" in l || "required" in l || "content" in l || "style" in l || "examples" in l || "example" in l || "schema" in l || "name" in l);
    e.isBaseParameterObject = r;
    const i = (l) => (0, e.isBaseParameterObject)(l);
    e.isHeaderObject = i;
    const a = (l) => (0, t.isPlainObject)(l) && typeof l.url == "string";
    e.isServerObject = a;
    const o = (l) => {
      if (!(0, t.isPlainObject)(l))
        return !1;
      const d = typeof l.default;
      return d === "string" || d === "boolean" || d === "number";
    };
    e.isServerVariableObject = o;
    const c = (l) => (0, t.isPlainObject)(l) && ("description" in l || "headers" in l || "content" in l || "links" in l);
    e.isResponseObject = c;
    const u = (l) => (0, t.isPlainObject)(l) && (0, t.isPlainObject)(l.scopes);
    e.isOAuthFlowObject = u;
    const s = (l) => (0, t.isPlainObject)(l) && (0, t.isPlainObject)(l.content);
    e.isRequestBodyObject = s;
  })(Vh)), Vh;
}
var ol = {}, sl = {}, d8;
function U0() {
  if (d8) return sl;
  d8 = 1, Object.defineProperty(sl, "__esModule", { value: !0 }), sl.translateToExample = void 0;
  const e = Zn, t = Xn(), n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Vi(), a = /* @__PURE__ */ ga();
  return sl.translateToExample = (0, n.withContext)(function([o, c]) {
    var u;
    const s = (u = this.maybeResolveLocalRef(c)) !== null && u !== void 0 ? u : c;
    if (!(0, e.isPlainObject)(s))
      return;
    if ((0, i.isReferenceObject)(s))
      return s.key = o, s;
    const l = this.context === "service" ? (0, a.getSharedKey)(s, o) : o;
    return {
      id: this.generateId.example({ keyOrName: l }),
      key: o,
      ...typeof s.externalValue == "string" ? { externalValue: s.externalValue } : { value: s.value },
      ...(0, t.pickBy)({
        summary: s.summary,
        description: s.description
      }, r.isString)
    };
  }), sl;
}
var ul = {}, h8;
function E2() {
  if (h8) return ul;
  h8 = 1, Object.defineProperty(ul, "__esModule", { value: !0 }), ul.translateHeaderObject = void 0;
  const e = Zn, t = /* @__PURE__ */ wc(), n = Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Jn(), a = /* @__PURE__ */ Vi(), o = /* @__PURE__ */ C2(), c = /* @__PURE__ */ Bf(), u = /* @__PURE__ */ Si(), s = /* @__PURE__ */ Ou(), l = /* @__PURE__ */ U0();
  return ul.translateHeaderObject = (0, r.withContext)(function([d, f]) {
    var p;
    const g = (p = this.maybeResolveLocalRef(f)) !== null && p !== void 0 ? p : f;
    if ((0, a.isReferenceObject)(g))
      return g.name = d, g;
    if (!(0, e.isPlainObject)(g))
      return;
    const b = this.generateId.httpHeader({ keyOrName: d, componentType: "header" });
    if (!(0, s.isHeaderObject)(g))
      return {
        id: b,
        encodings: [],
        examples: [],
        name: d,
        style: t.HttpParamStyles.Simple
      };
    const { content: w } = g, y = (0, e.isPlainObject)(w) ? Object.values(w)[0] : null, v = {
      id: b,
      name: d,
      style: t.HttpParamStyles.Simple,
      ...(0, n.pickBy)({
        schema: (0, e.isPlainObject)(g.schema) ? o.translateSchemaObject.call(this, g.schema) : null,
        content: g.content
      }, i.isNonNullable),
      ...(0, n.pickBy)({
        description: g.description
      }, i.isString),
      ...(0, n.pickBy)({
        allowEmptyValue: g.allowEmptyValue,
        allowReserved: g.allowReserved,
        explode: g.explode,
        required: g.required,
        deprecated: g.deprecated
      }, i.isBoolean)
    }, _ = [], E = [];
    return (0, e.isPlainObject)(y) && (_.push(...(0, u.entries)(y.examples).map(l.translateToExample, this).filter(i.isNonNullable)), (0, e.isPlainObject)(y.encoding) && E.push(...Object.values(y.encoding)), "example" in y && _.push(c.translateToDefaultExample.call(this, "__default_content", y.example))), _.push(...(0, u.entries)(g.examples).map(l.translateToExample, this).filter(i.isNonNullable)), "example" in g && _.push(c.translateToDefaultExample.call(this, "__default", g.example)), {
      ...v,
      encodings: E,
      examples: _
    };
  }), ul;
}
var m8;
function Yk() {
  if (m8) return ol;
  m8 = 1, Object.defineProperty(ol, "__esModule", { value: !0 }), ol.translateMediaTypeObject = void 0;
  const e = Zn, t = /* @__PURE__ */ wc(), n = Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Jn(), a = /* @__PURE__ */ Bf(), o = /* @__PURE__ */ Eu(), c = /* @__PURE__ */ Si(), u = /* @__PURE__ */ U0(), s = /* @__PURE__ */ E2(), l = [
    t.HttpParamStyles.Form,
    t.HttpParamStyles.SpaceDelimited,
    t.HttpParamStyles.PipeDelimited,
    t.HttpParamStyles.DeepObject
  ];
  function d(g) {
    return typeof g.style == "string" && l.includes(g.style);
  }
  const f = (0, r.withContext)(function([g, b]) {
    if ((0, e.isPlainObject)(b) && d(b))
      return {
        property: g,
        style: b.style,
        headers: (0, c.entries)(b.headers).map(s.translateHeaderObject, this).filter(i.isNonNullable),
        ...(0, n.pickBy)({
          allowReserved: b.allowReserved,
          explode: b.explode
        }, i.isBoolean),
        ...(0, n.pickBy)({
          mediaType: b.contentType
        }, i.isString)
      };
  }), p = (0, r.withContext)(function(g) {
    if ((0, e.isPlainObject)(g))
      return o.translateSchemaObject.call(this, g);
  });
  return ol.translateMediaTypeObject = (0, r.withContext)(function([g, b]) {
    var w;
    if (!(0, e.isPlainObject)(b))
      return;
    const y = this.generateId.httpMedia({ mediaType: g }), { schema: v, encoding: _, examples: E } = b, O = p.call(this, v), M = "example" in b ? b.example : (w = O?.examples) === null || w === void 0 ? void 0 : w[0];
    return {
      id: y,
      mediaType: g,
      examples: [
        M !== void 0 ? a.translateToDefaultExample.call(this, "default", M) : void 0,
        ...(0, c.entries)(E).map(u.translateToExample, this)
      ].filter(i.isNonNullable),
      encodings: (0, c.entries)(_).map(f, this).filter(i.isNonNullable),
      ...(0, n.pickBy)({
        schema: O
      }, i.isNonNullable)
    };
  }), ol;
}
var g8;
function O2() {
  return g8 || (g8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToRequest = e.translateParameterObject = e.translateRequestBody = e.translateToSharedRequestBody = void 0;
    const t = Zn, n = /* @__PURE__ */ wc(), r = Xn(), i = /* @__PURE__ */ Ci(), a = /* @__PURE__ */ Jn(), o = /* @__PURE__ */ M0(), c = /* @__PURE__ */ Ps(), u = /* @__PURE__ */ Vi(), s = /* @__PURE__ */ ga(), l = /* @__PURE__ */ Bf(), d = /* @__PURE__ */ Eu(), f = /* @__PURE__ */ Si(), p = /* @__PURE__ */ Ou(), g = /* @__PURE__ */ Yk(), b = /* @__PURE__ */ U0();
    e.translateToSharedRequestBody = (0, i.withContext)(function([v, _]) {
      const E = this.maybeResolveLocalRef(_);
      return (0, u.isReferenceObject)(E) ? (E.key = v, E) : e.translateRequestBody.call(this, v, E);
    }), e.translateRequestBody = (0, i.withContext)(function(v, _) {
      var E;
      const O = (E = this.maybeResolveLocalRef(_)) !== null && E !== void 0 ? E : _;
      return (0, u.isReferenceObject)(O) ? O : (0, p.isRequestBodyObject)(O) ? {
        id: this.generateId.httpRequestBody({
          key: this.context === "service" ? (0, s.getSharedKey)(O, v) : v
        }),
        contents: (0, f.entries)(O.content).map(g.translateMediaTypeObject, this).filter(a.isNonNullable),
        ...(0, r.pickBy)({
          required: O.required
        }, a.isBoolean),
        ...(0, r.pickBy)({
          description: O.description
        }, a.isString)
      } : void 0;
    });
    const w = (0, i.withContext)(function(v) {
      if ((0, t.isPlainObject)(v.schema))
        return d.translateSchemaObject.call(this, {
          ...v.schema,
          ..."example" in v ? { example: v.example } : null
        });
    });
    e.translateParameterObject = (0, i.withContext)(function(v) {
      this.context === "path" && (this.context = "operation", this.parentId = this.ids.operation);
      const _ = v.in === "path" ? "pathParam" : v.in, E = v.name, O = (0, s.getSharedKey)(v, E), M = this.generateId[`http${_[0].toUpperCase()}${_.slice(1)}`]({ keyOrName: O, componentType: "parameter" }), L = w.call(this, v), Z = (0, f.entries)(v.examples).map(b.translateToExample, this).filter(a.isNonNullable), Q = Z.some((ae) => !(0, u.isReferenceObject)(ae) && ae.key.includes("default"));
      return {
        id: M,
        name: E,
        style: (0, u.isValidOas3ParamStyle)(v.style) ? v.style : v.in === "query" || v.in === "cookie" ? n.HttpParamStyles.Form : n.HttpParamStyles.Simple,
        examples: [
          !Q && v.example !== void 0 ? l.translateToDefaultExample.call(this, "default", v.example) : void 0,
          ...Z
        ].filter(a.isNonNullable),
        ...(0, r.pickBy)({
          description: v.description
        }, a.isString),
        ...(0, r.pickBy)({
          deprecated: v.deprecated,
          required: v.required,
          explode: v.explode,
          allowEmptyValue: v.allowEmptyValue,
          allowReserved: v.allowReserved
        }, a.isBoolean),
        ...(0, r.pickBy)({
          schema: L,
          content: v.content
        }, t.isPlainObject),
        explicitProperties: (0, f.collectExplicitProperties)(v)
      };
    });
    const y = (0, c.createOasParamsIterator)(o.OasVersion.OAS3);
    e.translateToRequest = (0, i.withContext)(function(v, _) {
      var E;
      const O = {
        header: [],
        query: [],
        cookie: [],
        path: [],
        unknown: []
      };
      for (const L of y.call(this, v, _)) {
        let Z;
        (0, u.isReferenceObject)(L) ? Z = (E = (0, s.getComponentName)(this.references, L.$ref)) !== null && E !== void 0 ? E : "" : Z = L.in, ["parameters", "unknownParameters"].includes(Z) && (Z = "unknown");
        const Q = O[Z || "unknown"];
        Array.isArray(Q) && ((0, u.isReferenceObject)(L) ? Q.push((0, s.syncReferenceObject)(L, this.references)) : Q.push(e.translateParameterObject.call(this, L)));
      }
      const M = {
        ...(0, r.pickBy)({
          body: e.translateRequestBody.call(this, void 0, _?.requestBody)
        }, a.isNonNullable),
        headers: O.header,
        query: O.query,
        cookie: O.cookie,
        path: O.path,
        unknown: O.unknown
      };
      return M.unknown && !M.unknown.length && delete M.unknown, M;
    });
  })(zh)), zh;
}
var Gh = {}, v8;
function Jk() {
  return v8 || (v8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToResponses = e.translateToResponse = void 0;
    const t = Xn(), n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Vi(), a = /* @__PURE__ */ ga(), o = /* @__PURE__ */ Si(), c = /* @__PURE__ */ Ou(), u = /* @__PURE__ */ Yk(), s = /* @__PURE__ */ E2();
    e.translateToResponse = (0, n.withContext)(function([d, f]) {
      var p;
      const g = (p = this.maybeResolveLocalRef(f)) !== null && p !== void 0 ? p : f;
      if ((0, i.isReferenceObject)(g))
        return g.code = d, g;
      if (!(0, c.isResponseObject)(g))
        return;
      const b = this.context === "service" ? (0, a.getSharedKey)(g, d) : d;
      return {
        id: this.generateId.httpResponse({ codeOrKey: b }),
        code: d,
        headers: (0, o.entries)(g.headers).map(s.translateHeaderObject, this).filter(r.isNonNullable),
        contents: (0, o.entries)(g.content).map(u.translateMediaTypeObject, this).filter(r.isNonNullable),
        ...(0, t.pickBy)({
          description: g.description
        }, r.isString)
      };
    });
    const l = function(d) {
      return (0, o.entries)(d).map(e.translateToResponse, this).filter(r.isNonNullable);
    };
    e.translateToResponses = l;
  })(Gh)), Gh;
}
var Wh = {}, Hs = {}, y8;
function lB() {
  if (y8) return Hs;
  y8 = 1, Object.defineProperty(Hs, "__esModule", { value: !0 }), Hs.getScopeKeys = Hs.getSecurities = void 0;
  const e = Zn, t = Xn(), n = /* @__PURE__ */ Jn(), r = /* @__PURE__ */ Ps(), i = /* @__PURE__ */ Si(), a = /* @__PURE__ */ Ou();
  function o(u, s) {
    var l;
    const d = (l = u.components) === null || l === void 0 ? void 0 : l.securitySchemes;
    return (0, e.isPlainObject)(d) ? (Array.isArray(s) ? s : u.security || []).map((f) => (0, i.entries)(f).map(([p, g]) => {
      const b = d[p];
      if (!(0, a.isSecurityScheme)(b))
        return;
      if (b.type === "oauth2")
        return [
          p,
          {
            ...b,
            flows: Object.fromEntries((0, i.entries)(b.flows).map(([y, v]) => [
              y,
              {
                ...v,
                scopes: (0, t.pickBy)(v?.scopes, (_, E) => g?.includes(E))
              }
            ])),
            extensions: (0, r.getExtensions)(b)
          }
        ];
      const w = g?.length ? { "x-scopes": g } : {};
      return [
        p,
        {
          ...b,
          ...w,
          extensions: (0, r.getExtensions)({ ...b, ...w })
        }
      ];
    }).filter(n.isNonNullable)) : [];
  }
  Hs.getSecurities = o;
  function c(u) {
    if (!u.flows)
      return;
    const s = [];
    function l(d, f) {
      var p;
      for (const g of Object.keys((p = f?.scopes) !== null && p !== void 0 ? p : {}))
        s.push(`${d}::${g}`);
    }
    return l("implicit", u.flows.implicit), l("password", u.flows.password), l("clientCredentials", u.flows.clientCredentials), l("authorizationCode", u.flows.authorizationCode), s;
  }
  return Hs.getScopeKeys = c, Hs;
}
var b8;
function Qk() {
  return b8 || (b8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSingleSecurity = e.translateToSecurities = void 0;
    const t = Zn, n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Ps(), a = /* @__PURE__ */ lB(), o = /* @__PURE__ */ Ou(), c = function(s, l) {
      return this.context = "service", (0, a.getSecurities)(this.document, s).map((f) => f.map(e.translateToSingleSecurity.bind(this, l)).filter(r.isNonNullable));
    };
    e.translateToSecurities = c, e.translateToSingleSecurity = (0, n.withContext)(function(s, [l, d], f) {
      var p, g;
      const b = {
        id: this.generateId.httpSecurity({
          keyOrName: l,
          kind: s,
          ...s === "requirement" ? {
            index: f,
            scopeKeys: (0, a.getScopeKeys)(d)
          } : {}
        }),
        key: l,
        extensions: (0, i.getExtensions)(d)
      };
      if (d.description && (b.description = d.description), d.type === "apiKey")
        return {
          ...b,
          type: "apiKey",
          name: d.name,
          in: d.in
        };
      if (d.type === "http")
        return ((p = d.scheme) === null || p === void 0 ? void 0 : p.toLowerCase()) === "bearer" ? {
          ...b,
          type: "http",
          scheme: "bearer",
          bearerFormat: d.bearerFormat
        } : {
          ...b,
          type: "http",
          scheme: (g = d.scheme) === null || g === void 0 ? void 0 : g.toLowerCase()
        };
      if (d.type === "oauth2")
        return {
          ...b,
          type: "oauth2",
          flows: u(d.flows)
        };
      if (d.type === "openIdConnect")
        return {
          ...b,
          type: "openIdConnect",
          openIdConnectUrl: d.openIdConnectUrl
        };
      if (d.type === "mutualTLS")
        return {
          ...b,
          type: "mutualTLS"
        };
    });
    function u(s) {
      const l = {};
      return (0, t.isPlainObject)(s) && ((0, o.isOAuthFlowObject)(s.password) && typeof s.password.tokenUrl == "string" && (l.password = {
        ...typeof s.password.refreshUrl == "string" && { refreshUrl: s.password.refreshUrl },
        tokenUrl: s.password.tokenUrl,
        scopes: s.password.scopes
      }), (0, o.isOAuthFlowObject)(s.implicit) && typeof s.implicit.authorizationUrl == "string" && (l.implicit = {
        ...typeof s.implicit.refreshUrl == "string" && { refreshUrl: s.implicit.refreshUrl },
        authorizationUrl: s.implicit.authorizationUrl,
        scopes: s.implicit.scopes
      }), (0, o.isOAuthFlowObject)(s.authorizationCode) && typeof s.authorizationCode.authorizationUrl == "string" && typeof s.authorizationCode.tokenUrl == "string" && (l.authorizationCode = {
        ...typeof s.authorizationCode.refreshUrl == "string" && { refreshUrl: s.authorizationCode.refreshUrl },
        authorizationUrl: s.authorizationCode.authorizationUrl,
        scopes: s.authorizationCode.scopes,
        tokenUrl: s.authorizationCode.tokenUrl
      }), (0, o.isOAuthFlowObject)(s.clientCredentials) && typeof s.clientCredentials.tokenUrl == "string" && (l.clientCredentials = {
        ...typeof s.clientCredentials.refreshUrl == "string" && { refreshUrl: s.clientCredentials.refreshUrl },
        scopes: s.clientCredentials.scopes,
        tokenUrl: s.clientCredentials.tokenUrl
      })), l;
    }
  })(Wh)), Wh;
}
var Kh = {}, x8;
function Xk() {
  return x8 || (x8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateServerVariables = e.translateToServer = e.translateToServers = void 0;
    const t = Xn(), n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Si(), a = /* @__PURE__ */ Ou();
    e.translateToServers = (0, n.withContext)(function(u, s) {
      let l;
      if (Array.isArray(s.servers))
        l = s.servers;
      else if (Array.isArray(u.servers))
        l = u.servers, this.context = "path";
      else if (Array.isArray(this.document.servers))
        l = this.document.servers, this.context = "service";
      else
        return [];
      return l.map(e.translateToServer, this).filter(r.isNonNullable);
    }), e.translateToServer = (0, n.withContext)(function(u) {
      var s;
      if (!(0, a.isServerObject)(u))
        return;
      const l = e.translateServerVariables.call(this, u.variables);
      return {
        id: this.generateId.httpServer({ url: u.url }),
        url: u.url,
        ...(0, t.pickBy)({
          name: (s = this.document.info) === null || s === void 0 ? void 0 : s.title,
          description: u.description
        }, r.isString),
        ...(0, t.pickBy)({
          variables: l
        }, r.isNonNullable)
      };
    });
    const o = (u) => {
      const s = (0, i.entries)(u).map(c).filter(r.isNonNullable);
      return s.length > 0 ? Object.fromEntries(s) : void 0;
    };
    e.translateServerVariables = o;
    const c = function([u, s]) {
      if ((0, a.isServerVariableObject)(s))
        return [
          u,
          {
            default: String(s.default),
            ...(0, t.pickBy)({
              description: s.description
            }, r.isString),
            ...(0, t.pickBy)({
              enum: Array.isArray(s.enum) ? s.enum.map(String) : void 0
            }, r.isNonNullable)
          }
        ];
    };
  })(Kh)), Kh;
}
var _8;
function T2() {
  return _8 || (_8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas3Operation = e.transformOas3WebhookOperations = e.transformOas3Operations = void 0;
    const t = Xn(), n = /* @__PURE__ */ Jn(), r = /* @__PURE__ */ M0(), i = /* @__PURE__ */ Mf(), a = /* @__PURE__ */ Zk(), o = /* @__PURE__ */ O2(), c = /* @__PURE__ */ Jk(), u = /* @__PURE__ */ Qk(), s = /* @__PURE__ */ Xk();
    function l(p, g) {
      return (0, r.transformOasEndpointOperations)(p, e.transformOas3Operation, r.OPERATION_CONFIG, void 0, g);
    }
    e.transformOas3Operations = l;
    function d(p, g) {
      return (0, r.transformOasEndpointOperations)(p, e.transformOas3Operation, r.WEBHOOK_CONFIG, void 0, g);
    }
    e.transformOas3WebhookOperations = d;
    const f = ({ document: p, name: g, method: b, config: w, key: y, ctx: v = (0, i.createContext)(p) }) => {
      const _ = r.transformOasEndpointOperation.call(v, w, g, b, y), E = v.maybeResolveLocalRef(v.document[w.documentProp][g]), O = v.maybeResolveLocalRef(E[b]);
      return {
        ..._,
        responses: c.translateToResponses.call(v, O.responses),
        request: o.translateToRequest.call(v, E, O),
        security: u.translateToSecurities.call(v, O.security, "requirement"),
        servers: s.translateToServers.call(v, E, O),
        ...(0, t.pickBy)({
          callbacks: a.translateToCallbacks.call(v, O.callbacks)
        }, n.isNonNullable)
      };
    };
    e.transformOas3Operation = f;
  })(Hh)), Hh;
}
var Zh = {}, cl = {}, w8;
function fB() {
  if (w8) return cl;
  w8 = 1, Object.defineProperty(cl, "__esModule", { value: !0 }), cl.translateToSharedParameters = void 0;
  const e = Zn, t = /* @__PURE__ */ Ci(), n = /* @__PURE__ */ Jn(), r = /* @__PURE__ */ Vi(), i = /* @__PURE__ */ ga(), a = /* @__PURE__ */ Si(), o = /* @__PURE__ */ E2(), c = /* @__PURE__ */ O2();
  return cl.translateToSharedParameters = (0, t.withContext)(function(u) {
    const s = {
      header: [],
      query: [],
      cookie: [],
      path: [],
      unknownParameters: []
    };
    if (!(0, e.isPlainObject)(u))
      return s;
    for (const [d, f] of (0, a.entries)(u.headers)) {
      (0, i.setSharedKey)(f, d), this.references[`#/components/headers/${d}`] = {
        resolved: !0,
        value: `#/components/header/${s.header.length}`
      };
      const p = o.translateHeaderObject.call(this, [d, f]);
      (0, n.isNonNullable)(p) && s.header.push({
        ...p,
        key: d
      });
    }
    const l = [];
    for (const [d, f] of (0, a.entries)(u.parameters)) {
      if ((0, i.setSharedKey)(f, d), (0, r.isReferenceObject)(f)) {
        (0, e.isLocalRef)(f.$ref) ? this.references[`#/components/parameters/${d}`] = {
          resolved: !1,
          value: f.$ref
        } : (this.references[`#/components/parameters/${d}`] = {
          resolved: !0,
          value: `#/components/unknownParameters/${s.unknownParameters.length}`
        }, s.unknownParameters.push({
          ...f,
          key: d
        })), l.push((0, i.syncReferenceObject)({
          ...f,
          key: d
        }, this.references));
        continue;
      }
      if (!(0, r.isValidOas3ParameterObject)(f))
        continue;
      const p = c.translateParameterObject.call(this, f);
      this.references[`#/components/parameters/${d}`] = {
        resolved: !0,
        value: `#/components/${f.in}/${s[f.in].length}`
      }, s[f.in].push({
        ...p,
        key: d
      });
    }
    for (const d of l) {
      const f = (0, i.getComponentName)(this.references, d.$ref);
      f && f !== "unknownParameters" && f in s && s[f].push(d);
    }
    return s;
  }), cl;
}
var S8;
function pB() {
  return S8 || (S8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas3Service = e.bundleOas3Service = void 0;
    const t = Zn, n = Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Jn(), a = /* @__PURE__ */ Mf(), o = /* @__PURE__ */ ga(), c = /* @__PURE__ */ Wk(), u = /* @__PURE__ */ Kk(), s = /* @__PURE__ */ Eu(), l = /* @__PURE__ */ Ff(), d = /* @__PURE__ */ Si(), f = /* @__PURE__ */ Ou(), p = /* @__PURE__ */ T2(), g = /* @__PURE__ */ Zk(), b = /* @__PURE__ */ U0(), w = /* @__PURE__ */ fB(), y = /* @__PURE__ */ O2(), v = /* @__PURE__ */ Jk(), _ = /* @__PURE__ */ Qk(), E = /* @__PURE__ */ Xk(), O = ({ document: Z }) => {
      var Q;
      const ae = (0, a.createContext)(Z, o.bundleResolveRef), { document: re } = ae, { securitySchemes: X, ...de } = (0, e.transformOas3Service)({ document: re, ctx: ae }), Ce = {
        ...u.translateToComponents.call(ae, l.OasVersion.OAS3, {
          responses: v.translateToResponse,
          requestBodies: y.translateToSharedRequestBody,
          examples: b.translateToExample,
          schemas: s.translateSchemaObjectFromPair,
          securitySchemes: L
        }),
        callbacks: (Q = g.translateToCallbacks.call(ae, re.components ? re.components.callbacks : [])) !== null && Q !== void 0 ? Q : [],
        ...w.translateToSharedParameters.call(ae, re.components)
      }, J = (0, p.transformOas3Operations)(re, ae), ne = (0, p.transformOas3WebhookOperations)(re, ae);
      return {
        ...de,
        operations: J,
        webhooks: ne,
        components: Ce
      };
    };
    e.bundleOas3Service = O;
    const M = ({ document: Z, ctx: Q = (0, a.createContext)(Z) }) => {
      var ae, re, X;
      const { document: de } = Q, Ce = c.transformOasService.call(Q);
      if (typeof ((ae = de.info) === null || ae === void 0 ? void 0 : ae.summary) == "string" && (Ce.summary = de.info.summary), !((re = de.info) === null || re === void 0) && re.license) {
        const { name: je, identifier: Me, ...qe } = de.info.license;
        Ce.license = {
          ...qe,
          name: typeof je == "string" ? je : "",
          ...typeof Me == "string" && { identifier: Me }
        };
      }
      const J = Array.isArray(de.servers) ? de.servers.map(E.translateToServer, Q).filter(i.isNonNullable) : [];
      J.length && (Ce.servers = J);
      const ne = (0, d.entries)((X = de.components) === null || X === void 0 ? void 0 : X.securitySchemes).map(L, Q).filter(i.isNonNullable);
      ne.length && (Ce.securitySchemes = ne);
      const De = (Array.isArray(de.security) ? de.security : []).map((je) => (0, t.isPlainObject)(je) ? Object.keys(je).map((Me) => {
        const qe = ne.find((Ve) => Ve.key === Me);
        if (qe?.type === "oauth2") {
          const Ve = {};
          for (const xe in qe.flows) {
            const ve = qe.flows[xe];
            Ve[xe] = {
              ...ve,
              scopes: (0, n.pickBy)(ve.scopes, (Ae, Ue) => {
                const qt = je[Me];
                return qt ? qt.includes(Ue) : !1;
              })
            };
          }
          return {
            ...qe,
            flows: Ve
          };
        }
        return qe;
      }).filter(i.isNonNullable) : null).filter(i.isNonNullable);
      return De.length && (Ce.security = De), Ce;
    };
    e.transformOas3Service = M;
    const L = (0, r.withContext)(function([Z, Q], ae) {
      if ((0, f.isSecurityScheme)(Q))
        return _.translateToSingleSecurity.call(this, "scheme", [Z, Q], ae, []);
    });
  })(Zh)), Zh;
}
var C8;
function dB() {
  return C8 || (C8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = F0;
    t.__exportStar(/* @__PURE__ */ T2(), e), t.__exportStar(/* @__PURE__ */ pB(), e);
  })(Uh)), Uh;
}
var rd = /* @__PURE__ */ dB(), bi = /* @__PURE__ */ ((e) => (e.Paths = "paths", e.Path = "path", e.Operation = "operation", e.Webhooks = "webhooks", e.Webhook = "webhook", e.Components = "components", e.Models = "models", e.Model = "model", e))(bi || {}), ff = /* @__PURE__ */ ((e) => (e.OAS2 = "OAS 2.0", e.OAS3 = "OAS 3.0", e.OAS31 = "OAS 3.1", e.ASYNC = "ASYNC", e))(ff || {});
const hB = [
  {
    match: "paths",
    type: bi.Paths,
    children: [
      {
        notMatch: "^x-",
        type: bi.Path,
        children: [
          {
            match: "get|post|put|delete|options|head|patch|trace",
            type: bi.Operation
          }
        ]
      }
    ]
  },
  {
    match: "definitions",
    type: bi.Models,
    children: [
      {
        notMatch: "^x-",
        type: bi.Model
      }
    ]
  }
], k8 = [
  {
    match: "paths",
    type: bi.Paths,
    children: [
      {
        notMatch: "^x-",
        type: bi.Path,
        children: [
          {
            match: "get|post|put|delete|options|head|patch|trace",
            type: bi.Operation
          }
        ]
      }
    ]
  },
  {
    match: "webhooks",
    type: bi.Webhooks,
    children: [
      {
        notMatch: "^x-",
        type: bi.Webhook,
        children: [
          {
            match: "get|post|put|delete|options|head|patch|trace",
            type: bi.Webhook
          }
        ]
      }
    ]
  },
  {
    match: "components",
    type: bi.Components,
    children: [
      {
        match: "schemas",
        type: bi.Models,
        children: [
          {
            notMatch: "^x-",
            type: bi.Model
          }
        ]
      }
    ]
  }
], mB = (e) => ta(e) && "swagger" in e && Number.parseInt(String(e.swagger)) === 2, gB = (e) => ta(e) && "openapi" in e && Number.parseFloat(String(e.openapi)) >= 3, vB = (e) => ta(e) && "openapi" in e && Number.parseFloat(String(e.openapi)) === 3.1, yB = /((definitions|components)\/?(schemas)?)\//;
function bB(e) {
  if (vB(e))
    return Yh(
      { ...e, jsonSchemaDialect: "http://json-schema.org/draft-07/schema#" },
      k8,
      rd.transformOas3Service,
      rd.transformOas3Operation,
      ff.OAS31
    );
  if (gB(e))
    return Yh(
      e,
      k8,
      rd.transformOas3Service,
      rd.transformOas3Operation,
      ff.OAS3
    );
  if (mB(e))
    return Yh(
      e,
      hB,
      l8.transformOas2Service,
      l8.transformOas2Operation,
      ff.OAS2
    );
}
function Yh(e, t, n, r, i) {
  const a = n({ document: e });
  return {
    type: Ri.HttpService,
    uri: "/",
    name: a.name,
    data: a,
    tags: a.tags?.map((c) => c.name) || [],
    children: eA(e, e, t, r),
    specVersion: i
  };
}
function eA(e, t, n, r, i = "") {
  const a = [];
  if (!ta(t)) return a;
  for (const o of Object.keys(t)) {
    const c = lf(o), u = xB(c, n);
    if (u) {
      const s = `${i}/${c}`, l = Ia(`#${s}`);
      if (u.type === bi.Operation && l.length === 3) {
        const d = String(l[1]), f = String(l[2]), p = r({
          document: e,
          name: d,
          method: f,
          config: Wb.OPERATION_CONFIG
        });
        let g;
        const b = String(lf(d));
        p.iid ? g = `/operations/${p.iid}` : g = s.replace(b, Xd(d)), a.push({
          type: Ri.HttpOperation,
          uri: g,
          data: p,
          name: p.summary || p.iid || p.path,
          tags: p.tags?.map((w) => w.name) || []
        });
      } else if (u.type === bi.Webhook && l.length === 3) {
        const d = String(l[1]), f = String(l[2]), p = r({
          document: e,
          name: d,
          method: f,
          config: Wb.WEBHOOK_CONFIG
        });
        let g;
        const b = String(lf(d));
        p.iid ? g = `/webhooks/${p.iid}` : g = s.replace(b, Xd(d)), a.push({
          type: Ri.HttpWebhook,
          uri: g,
          data: p,
          name: p.summary || p.name,
          tags: p.tags?.map((w) => w.name) || []
        });
      } else if (u.type === bi.Model) {
        const d = xF(e, l), f = s.replace(yB, "schemas/");
        a.push({
          type: Ri.Model,
          uri: f,
          data: d,
          name: d.title || TF(s.split("/")) || "",
          tags: d["x-tags"] || []
        });
      }
      u.children && a.push(...eA(e, t[o], u.children, r, s));
    }
  }
  return a;
}
function xB(e, t) {
  if (typeof e != "number")
    for (const n of t) {
      const r = e.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
      if (n.match?.match(r) || n.notMatch !== void 0 && !n.notMatch.match(r))
        return n;
    }
}
var Jh = {}, nd = {}, ll = {}, Qh = {}, za = {}, Xh = {}, A8;
function H0() {
  return A8 || (A8 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t;
    (function(u) {
      u[u.SCALAR = 0] = "SCALAR", u[u.MAPPING = 1] = "MAPPING", u[u.MAP = 2] = "MAP", u[u.SEQ = 3] = "SEQ", u[u.ANCHOR_REF = 4] = "ANCHOR_REF", u[u.INCLUDE_REF = 5] = "INCLUDE_REF";
    })(t = e.Kind || (e.Kind = {}));
    function n(u, s) {
      var l = s ? s.endPosition : u.endPosition + 1, d = {
        key: u,
        value: s,
        startPosition: u.startPosition,
        endPosition: l,
        kind: t.MAPPING,
        parent: null,
        errors: []
      };
      return d;
    }
    e.newMapping = n;
    function r(u, s, l, d) {
      return {
        errors: [],
        referencesAnchor: u,
        value: d,
        startPosition: s,
        endPosition: l,
        kind: t.ANCHOR_REF,
        parent: null
      };
    }
    e.newAnchorRef = r;
    function i(u = "") {
      const s = {
        errors: [],
        startPosition: -1,
        endPosition: -1,
        value: "" + u,
        kind: t.SCALAR,
        parent: null,
        doubleQuoted: !1,
        rawValue: "" + u
      };
      return typeof u != "string" && (s.valueObject = u), s;
    }
    e.newScalar = i;
    function a() {
      return {
        errors: [],
        startPosition: -1,
        endPosition: -1,
        items: [],
        kind: t.SEQ,
        parent: null
      };
    }
    e.newItems = a;
    function o() {
      return a();
    }
    e.newSeq = o;
    function c(u) {
      return {
        errors: [],
        startPosition: -1,
        endPosition: -1,
        mappings: u || [],
        kind: t.MAP,
        parent: null
      };
    }
    e.newMap = c;
  })(Xh)), Xh;
}
var Lo = {}, E8;
function Cc() {
  if (E8) return Lo;
  E8 = 1, Object.defineProperty(Lo, "__esModule", { value: !0 });
  function e(o) {
    return typeof o > "u" || o === null;
  }
  Lo.isNothing = e;
  function t(o) {
    return typeof o == "object" && o !== null;
  }
  Lo.isObject = t;
  function n(o) {
    return Array.isArray(o) ? o : e(o) ? [] : [o];
  }
  Lo.toArray = n;
  function r(o, c) {
    var u, s, l, d;
    if (c)
      for (d = Object.keys(c), u = 0, s = d.length; u < s; u += 1)
        l = d[u], o[l] = c[l];
    return o;
  }
  Lo.extend = r;
  function i(o, c) {
    var u = "", s;
    for (s = 0; s < c; s += 1)
      u += o;
    return u;
  }
  Lo.repeat = i;
  function a(o) {
    return o === 0 && Number.NEGATIVE_INFINITY === 1 / o;
  }
  return Lo.isNegativeZero = a, Lo;
}
var e5, O8;
function Uf() {
  if (O8) return e5;
  O8 = 1;
  class e {
    constructor(n, r = null, i = !1) {
      this.name = "YAMLException", this.reason = n, this.mark = r, this.message = this.toString(!1), this.isWarning = i;
    }
    static isInstance(n) {
      if (n != null && n.getClassIdentifier && typeof n.getClassIdentifier == "function") {
        for (let r of n.getClassIdentifier())
          if (r == e.CLASS_IDENTIFIER)
            return !0;
      }
      return !1;
    }
    getClassIdentifier() {
      var n = [];
      return n.concat(e.CLASS_IDENTIFIER);
    }
    toString(n = !1) {
      var r;
      return r = "JS-YAML: " + (this.reason || "(unknown reason)"), !n && this.mark && (r += " " + this.mark.toString()), r;
    }
  }
  return e.CLASS_IDENTIFIER = "yaml-ast-parser.YAMLException", e5 = e, e5;
}
var t5, T8;
function _B() {
  if (T8) return t5;
  T8 = 1;
  const e = Cc();
  class t {
    constructor(r, i, a, o, c) {
      this.name = r, this.buffer = i, this.position = a, this.line = o, this.column = c;
    }
    getSnippet(r = 0, i = 75) {
      var a, o, c, u, s;
      if (!this.buffer)
        return null;
      for (r = r || 4, i = i || 75, a = "", o = this.position; o > 0 && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(o - 1)) === -1; )
        if (o -= 1, this.position - o > i / 2 - 1) {
          a = " ... ", o += 5;
          break;
        }
      for (c = "", u = this.position; u < this.buffer.length && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(u)) === -1; )
        if (u += 1, u - this.position > i / 2 - 1) {
          c = " ... ", u -= 5;
          break;
        }
      return s = this.buffer.slice(o, u), e.repeat(" ", r) + a + s + c + `
` + e.repeat(" ", r + this.position - o + a.length) + "^";
    }
    toString(r = !0) {
      var i, a = "";
      return this.name && (a += 'in "' + this.name + '" '), a += "at line " + (this.line + 1) + ", column " + (this.column + 1), r || (i = this.getSnippet(), i && (a += `:
` + i)), a;
    }
  }
  return t5 = t, t5;
}
var id = {}, ad = {}, P8;
function Li() {
  if (P8) return ad;
  P8 = 1, Object.defineProperty(ad, "__esModule", { value: !0 });
  const e = Uf();
  var t = [
    "kind",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "defaultStyle",
    "styleAliases"
  ], n = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function r(a) {
    var o = {};
    return a !== null && Object.keys(a).forEach(function(c) {
      a[c].forEach(function(u) {
        o[String(u)] = c;
      });
    }), o;
  }
  class i {
    constructor(o, c) {
      if (c = c || {}, Object.keys(c).forEach(function(u) {
        if (t.indexOf(u) === -1)
          throw new e('Unknown option "' + u + '" is met in definition of "' + o + '" YAML type.');
      }), this.tag = o, this.kind = c.kind || null, this.resolve = c.resolve || function() {
        return !0;
      }, this.construct = c.construct || function(u) {
        return u;
      }, this.instanceOf = c.instanceOf || null, this.predicate = c.predicate || null, this.represent = c.represent || null, this.defaultStyle = c.defaultStyle || null, this.styleAliases = r(c.styleAliases || null), n.indexOf(this.kind) === -1)
        throw new e('Unknown kind "' + this.kind + '" is specified for "' + o + '" YAML type.');
    }
  }
  return ad.Type = i, ad;
}
var R8;
function Hf() {
  if (R8) return id;
  R8 = 1, Object.defineProperty(id, "__esModule", { value: !0 });
  const e = Cc(), t = Uf(), n = Li();
  function r(o, c, u) {
    var s = [];
    return o.include.forEach(function(l) {
      u = r(l, c, u);
    }), o[c].forEach(function(l) {
      u.forEach(function(d, f) {
        d.tag === l.tag && s.push(f);
      }), u.push(l);
    }), u.filter(function(l, d) {
      return s.indexOf(d) === -1;
    });
  }
  function i() {
    var o = {}, c, u;
    function s(l) {
      o[l.tag] = l;
    }
    for (c = 0, u = arguments.length; c < u; c += 1)
      arguments[c].forEach(s);
    return o;
  }
  class a {
    constructor(c) {
      this.include = c.include || [], this.implicit = c.implicit || [], this.explicit = c.explicit || [], this.implicit.forEach(function(u) {
        if (u.loadKind && u.loadKind !== "scalar")
          throw new t("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
      }), this.compiledImplicit = r(this, "implicit", []), this.compiledExplicit = r(this, "explicit", []), this.compiledTypeMap = i(this.compiledImplicit, this.compiledExplicit);
    }
  }
  return id.Schema = a, a.DEFAULT = null, a.create = function() {
    var c, u;
    switch (arguments.length) {
      case 1:
        c = a.DEFAULT, u = arguments[0];
        break;
      case 2:
        c = arguments[0], u = arguments[1];
        break;
      default:
        throw new t("Wrong number of arguments for Schema.create function");
    }
    if (c = e.toArray(c), u = e.toArray(u), !c.every(function(s) {
      return s instanceof a;
    }))
      throw new t("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
    if (!u.every(function(s) {
      return s instanceof n.Type;
    }))
      throw new t("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    return new a({
      include: c,
      explicit: u
    });
  }, id;
}
var r5, I8;
function wB() {
  if (I8) return r5;
  I8 = 1;
  const e = Li();
  return r5 = new e.Type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(t) {
      return t !== null ? t : "";
    }
  }), r5;
}
var n5, j8;
function SB() {
  if (j8) return n5;
  j8 = 1;
  const e = Li();
  return n5 = new e.Type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(t) {
      return t !== null ? t : [];
    }
  }), n5;
}
var i5, q8;
function CB() {
  if (q8) return i5;
  q8 = 1;
  const e = Li();
  return i5 = new e.Type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(t) {
      return t !== null ? t : {};
    }
  }), i5;
}
var a5, D8;
function kB() {
  if (D8) return a5;
  D8 = 1;
  const e = Hf();
  return a5 = new e.Schema({
    explicit: [
      wB(),
      SB(),
      CB()
    ]
  }), a5;
}
var o5, $8;
function AB() {
  if ($8) return o5;
  $8 = 1;
  const e = Li();
  function t(i) {
    if (i === null)
      return !0;
    var a = i.length;
    return a === 1 && i === "~" || a === 4 && (i === "null" || i === "Null" || i === "NULL");
  }
  function n() {
    return null;
  }
  function r(i) {
    return i === null;
  }
  return o5 = new e.Type("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      }
    },
    defaultStyle: "lowercase"
  }), o5;
}
var s5, L8;
function EB() {
  if (L8) return s5;
  L8 = 1;
  const e = Li();
  function t(i) {
    if (i === null)
      return !1;
    var a = i.length;
    return a === 4 && (i === "true" || i === "True" || i === "TRUE") || a === 5 && (i === "false" || i === "False" || i === "FALSE");
  }
  function n(i) {
    return i === "true" || i === "True" || i === "TRUE";
  }
  function r(i) {
    return Object.prototype.toString.call(i) === "[object Boolean]";
  }
  return s5 = new e.Type("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      lowercase: function(i) {
        return i ? "true" : "false";
      },
      uppercase: function(i) {
        return i ? "TRUE" : "FALSE";
      },
      camelcase: function(i) {
        return i ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  }), s5;
}
var u5, N8;
function OB() {
  if (N8) return u5;
  N8 = 1;
  const e = Cc(), t = Li();
  function n(u) {
    return 48 <= u && u <= 57 || 65 <= u && u <= 70 || 97 <= u && u <= 102;
  }
  function r(u) {
    return 48 <= u && u <= 55;
  }
  function i(u) {
    return 48 <= u && u <= 57;
  }
  function a(u) {
    if (u === null)
      return !1;
    var s = u.length, l = 0, d = !1, f;
    if (!s)
      return !1;
    if (f = u[l], (f === "-" || f === "+") && (f = u[++l]), f === "0") {
      if (l + 1 === s)
        return !0;
      if (f = u[++l], f === "b") {
        for (l++; l < s; l++)
          if (f = u[l], f !== "_") {
            if (f !== "0" && f !== "1")
              return !1;
            d = !0;
          }
        return d;
      }
      if (f === "x") {
        for (l++; l < s; l++)
          if (f = u[l], f !== "_") {
            if (!n(u.charCodeAt(l)))
              return !1;
            d = !0;
          }
        return d;
      }
      for (; l < s; l++)
        if (f = u[l], f !== "_") {
          if (!r(u.charCodeAt(l))) {
            d = !1;
            break;
          }
          d = !0;
        }
      if (d)
        return d;
    }
    for (; l < s; l++)
      if (f = u[l], f !== "_") {
        if (f === ":")
          break;
        if (!i(u.charCodeAt(l)))
          return !1;
        d = !0;
      }
    return d ? f !== ":" ? !0 : /^(:[0-5]?[0-9])+$/.test(u.slice(l)) : !1;
  }
  function o(u) {
    var s = u, l = 1, d, f, p = [];
    return s.indexOf("_") !== -1 && (s = s.replace(/_/g, "")), d = s[0], (d === "-" || d === "+") && (d === "-" && (l = -1), s = s.slice(1), d = s[0]), s === "0" ? 0 : d === "0" ? s[1] === "b" ? l * parseInt(s.slice(2), 2) : s[1] === "x" ? l * parseInt(s, 16) : l * parseInt(s, 8) : s.indexOf(":") !== -1 ? (s.split(":").forEach(function(g) {
      p.unshift(parseInt(g, 10));
    }), s = 0, f = 1, p.forEach(function(g) {
      s += g * f, f *= 60;
    }), l * s) : l * parseInt(s, 10);
  }
  function c(u) {
    const s = Object.prototype.toString.call(u);
    return s === "[object Number]" && u % 1 === 0 && !e.isNegativeZero(u) || s === "[object BigInt]";
  }
  return u5 = new t.Type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: a,
    construct: o,
    predicate: c,
    represent: {
      binary: function(u) {
        return "0b" + u.toString(2);
      },
      octal: function(u) {
        return "0" + u.toString(8);
      },
      decimal: function(u) {
        return u.toString(10);
      },
      hexadecimal: function(u) {
        return "0x" + u.toString(16).toUpperCase();
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }), u5;
}
var c5, F8;
function TB() {
  if (F8) return c5;
  F8 = 1;
  const e = Cc(), t = Li();
  var n = new RegExp("^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
  function r(c) {
    return !(c === null || !n.test(c));
  }
  function i(c) {
    var u, s, l, d;
    return u = c.replace(/_/g, "").toLowerCase(), s = u[0] === "-" ? -1 : 1, d = [], 0 <= "+-".indexOf(u[0]) && (u = u.slice(1)), u === ".inf" ? s === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : u === ".nan" ? NaN : 0 <= u.indexOf(":") ? (u.split(":").forEach(function(f) {
      d.unshift(parseFloat(f, 10));
    }), u = 0, l = 1, d.forEach(function(f) {
      u += f * l, l *= 60;
    }), s * u) : s * parseFloat(u, 10);
  }
  function a(c, u) {
    if (isNaN(c))
      switch (u) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    else if (Number.POSITIVE_INFINITY === c)
      switch (u) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    else if (Number.NEGATIVE_INFINITY === c)
      switch (u) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    else if (e.isNegativeZero(c))
      return "-0.0";
    return c.toString(10);
  }
  function o(c) {
    return Object.prototype.toString.call(c) === "[object Number]" && (c % 1 !== 0 || e.isNegativeZero(c));
  }
  return c5 = new t.Type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: r,
    construct: i,
    predicate: o,
    represent: a,
    defaultStyle: "lowercase"
  }), c5;
}
var l5, M8;
function PB() {
  if (M8) return l5;
  M8 = 1;
  const e = Hf();
  return l5 = new e.Schema({
    include: [
      kB()
    ],
    implicit: [
      AB(),
      EB(),
      OB(),
      TB()
    ]
  }), l5;
}
var f5, B8;
function RB() {
  if (B8) return f5;
  B8 = 1;
  const e = Hf();
  return f5 = new e.Schema({
    include: [
      PB()
    ]
  }), f5;
}
var p5, U8;
function IB() {
  if (U8) return p5;
  U8 = 1;
  const e = Li();
  var t = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?)?$");
  function n(a) {
    if (a === null)
      return !1;
    var o;
    return o = t.exec(a), o !== null;
  }
  function r(a) {
    var o, c, u, s, l, d, f, p = 0, g = null, b, w, y;
    if (o = t.exec(a), o === null)
      throw new Error("Date resolve error");
    if (c = +o[1], u = +o[2] - 1, s = +o[3], !o[4])
      return new Date(Date.UTC(c, u, s));
    if (l = +o[4], d = +o[5], f = +o[6], o[7]) {
      for (p = o[7].slice(0, 3); p.length < 3; )
        p = p + "0";
      p = +p;
    }
    return o[9] && (b = +o[10], w = +(o[11] || 0), g = (b * 60 + w) * 6e4, o[9] === "-" && (g = -g)), y = new Date(Date.UTC(c, u, s, l, d, f, p)), g && y.setTime(y.getTime() - g), y;
  }
  function i(a) {
    return a.toISOString();
  }
  return p5 = new e.Type("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: n,
    construct: r,
    instanceOf: Date,
    represent: i
  }), p5;
}
var d5, H8;
function jB() {
  if (H8) return d5;
  H8 = 1;
  const e = Li();
  function t(n) {
    return n === "<<" || n === null;
  }
  return d5 = new e.Type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: t
  }), d5;
}
var h5 = {}, fl = {}, z8;
function qB() {
  if (z8) return fl;
  z8 = 1, fl.byteLength = c, fl.toByteArray = s, fl.fromByteArray = f;
  for (var e = [], t = [], n = typeof Uint8Array < "u" ? Uint8Array : Array, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, a = r.length; i < a; ++i)
    e[i] = r[i], t[r.charCodeAt(i)] = i;
  t[45] = 62, t[95] = 63;
  function o(p) {
    var g = p.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var b = p.indexOf("=");
    b === -1 && (b = g);
    var w = b === g ? 0 : 4 - b % 4;
    return [b, w];
  }
  function c(p) {
    var g = o(p), b = g[0], w = g[1];
    return (b + w) * 3 / 4 - w;
  }
  function u(p, g, b) {
    return (g + b) * 3 / 4 - b;
  }
  function s(p) {
    var g, b = o(p), w = b[0], y = b[1], v = new n(u(p, w, y)), _ = 0, E = y > 0 ? w - 4 : w, O;
    for (O = 0; O < E; O += 4)
      g = t[p.charCodeAt(O)] << 18 | t[p.charCodeAt(O + 1)] << 12 | t[p.charCodeAt(O + 2)] << 6 | t[p.charCodeAt(O + 3)], v[_++] = g >> 16 & 255, v[_++] = g >> 8 & 255, v[_++] = g & 255;
    return y === 2 && (g = t[p.charCodeAt(O)] << 2 | t[p.charCodeAt(O + 1)] >> 4, v[_++] = g & 255), y === 1 && (g = t[p.charCodeAt(O)] << 10 | t[p.charCodeAt(O + 1)] << 4 | t[p.charCodeAt(O + 2)] >> 2, v[_++] = g >> 8 & 255, v[_++] = g & 255), v;
  }
  function l(p) {
    return e[p >> 18 & 63] + e[p >> 12 & 63] + e[p >> 6 & 63] + e[p & 63];
  }
  function d(p, g, b) {
    for (var w, y = [], v = g; v < b; v += 3)
      w = (p[v] << 16 & 16711680) + (p[v + 1] << 8 & 65280) + (p[v + 2] & 255), y.push(l(w));
    return y.join("");
  }
  function f(p) {
    for (var g, b = p.length, w = b % 3, y = [], v = 16383, _ = 0, E = b - w; _ < E; _ += v)
      y.push(d(p, _, _ + v > E ? E : _ + v));
    return w === 1 ? (g = p[b - 1], y.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : w === 2 && (g = (p[b - 2] << 8) + p[b - 1], y.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), y.join("");
  }
  return fl;
}
var od = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var V8;
function DB() {
  return V8 || (V8 = 1, od.read = function(e, t, n, r, i) {
    var a, o, c = i * 8 - r - 1, u = (1 << c) - 1, s = u >> 1, l = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
    for (d += f, a = p & (1 << -l) - 1, p >>= -l, l += c; l > 0; a = a * 256 + e[t + d], d += f, l -= 8)
      ;
    for (o = a & (1 << -l) - 1, a >>= -l, l += r; l > 0; o = o * 256 + e[t + d], d += f, l -= 8)
      ;
    if (a === 0)
      a = 1 - s;
    else {
      if (a === u)
        return o ? NaN : (p ? -1 : 1) * (1 / 0);
      o = o + Math.pow(2, r), a = a - s;
    }
    return (p ? -1 : 1) * o * Math.pow(2, a - r);
  }, od.write = function(e, t, n, r, i, a) {
    var o, c, u, s = a * 8 - i - 1, l = (1 << s) - 1, d = l >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : a - 1, g = r ? 1 : -1, b = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (c = isNaN(t) ? 1 : 0, o = l) : (o = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), o + d >= 1 ? t += f / u : t += f * Math.pow(2, 1 - d), t * u >= 2 && (o++, u /= 2), o + d >= l ? (c = 0, o = l) : o + d >= 1 ? (c = (t * u - 1) * Math.pow(2, i), o = o + d) : (c = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + p] = c & 255, p += g, c /= 256, i -= 8)
      ;
    for (o = o << i | c, s += i; s > 0; e[n + p] = o & 255, p += g, o /= 256, s -= 8)
      ;
    e[n + p - g] |= b * 128;
  }), od;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var G8;
function P2() {
  return G8 || (G8 = 1, (function(e) {
    var t = qB(), n = DB(), r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = c, e.SlowBuffer = v, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, c.TYPED_ARRAY_SUPPORT = a(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function a() {
      try {
        var ye = new Uint8Array(1), W = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(W, Uint8Array.prototype), Object.setPrototypeOf(ye, W), ye.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(c.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(c.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.byteOffset;
      }
    });
    function o(ye) {
      if (ye > i)
        throw new RangeError('The value "' + ye + '" is invalid for option "size"');
      var W = new Uint8Array(ye);
      return Object.setPrototypeOf(W, c.prototype), W;
    }
    function c(ye, W, Y) {
      if (typeof ye == "number") {
        if (typeof W == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return d(ye);
      }
      return u(ye, W, Y);
    }
    c.poolSize = 8192;
    function u(ye, W, Y) {
      if (typeof ye == "string")
        return f(ye, W);
      if (ArrayBuffer.isView(ye))
        return g(ye);
      if (ye == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ye
        );
      if (ze(ye, ArrayBuffer) || ye && ze(ye.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ze(ye, SharedArrayBuffer) || ye && ze(ye.buffer, SharedArrayBuffer)))
        return b(ye, W, Y);
      if (typeof ye == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var ie = ye.valueOf && ye.valueOf();
      if (ie != null && ie !== ye)
        return c.from(ie, W, Y);
      var Te = w(ye);
      if (Te) return Te;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ye[Symbol.toPrimitive] == "function")
        return c.from(
          ye[Symbol.toPrimitive]("string"),
          W,
          Y
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ye
      );
    }
    c.from = function(ye, W, Y) {
      return u(ye, W, Y);
    }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
    function s(ye) {
      if (typeof ye != "number")
        throw new TypeError('"size" argument must be of type number');
      if (ye < 0)
        throw new RangeError('The value "' + ye + '" is invalid for option "size"');
    }
    function l(ye, W, Y) {
      return s(ye), ye <= 0 ? o(ye) : W !== void 0 ? typeof Y == "string" ? o(ye).fill(W, Y) : o(ye).fill(W) : o(ye);
    }
    c.alloc = function(ye, W, Y) {
      return l(ye, W, Y);
    };
    function d(ye) {
      return s(ye), o(ye < 0 ? 0 : y(ye) | 0);
    }
    c.allocUnsafe = function(ye) {
      return d(ye);
    }, c.allocUnsafeSlow = function(ye) {
      return d(ye);
    };
    function f(ye, W) {
      if ((typeof W != "string" || W === "") && (W = "utf8"), !c.isEncoding(W))
        throw new TypeError("Unknown encoding: " + W);
      var Y = _(ye, W) | 0, ie = o(Y), Te = ie.write(ye, W);
      return Te !== Y && (ie = ie.slice(0, Te)), ie;
    }
    function p(ye) {
      for (var W = ye.length < 0 ? 0 : y(ye.length) | 0, Y = o(W), ie = 0; ie < W; ie += 1)
        Y[ie] = ye[ie] & 255;
      return Y;
    }
    function g(ye) {
      if (ze(ye, Uint8Array)) {
        var W = new Uint8Array(ye);
        return b(W.buffer, W.byteOffset, W.byteLength);
      }
      return p(ye);
    }
    function b(ye, W, Y) {
      if (W < 0 || ye.byteLength < W)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (ye.byteLength < W + (Y || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var ie;
      return W === void 0 && Y === void 0 ? ie = new Uint8Array(ye) : Y === void 0 ? ie = new Uint8Array(ye, W) : ie = new Uint8Array(ye, W, Y), Object.setPrototypeOf(ie, c.prototype), ie;
    }
    function w(ye) {
      if (c.isBuffer(ye)) {
        var W = y(ye.length) | 0, Y = o(W);
        return Y.length === 0 || ye.copy(Y, 0, 0, W), Y;
      }
      if (ye.length !== void 0)
        return typeof ye.length != "number" || Rt(ye.length) ? o(0) : p(ye);
      if (ye.type === "Buffer" && Array.isArray(ye.data))
        return p(ye.data);
    }
    function y(ye) {
      if (ye >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return ye | 0;
    }
    function v(ye) {
      return +ye != ye && (ye = 0), c.alloc(+ye);
    }
    c.isBuffer = function(W) {
      return W != null && W._isBuffer === !0 && W !== c.prototype;
    }, c.compare = function(W, Y) {
      if (ze(W, Uint8Array) && (W = c.from(W, W.offset, W.byteLength)), ze(Y, Uint8Array) && (Y = c.from(Y, Y.offset, Y.byteLength)), !c.isBuffer(W) || !c.isBuffer(Y))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (W === Y) return 0;
      for (var ie = W.length, Te = Y.length, $ = 0, _e = Math.min(ie, Te); $ < _e; ++$)
        if (W[$] !== Y[$]) {
          ie = W[$], Te = Y[$];
          break;
        }
      return ie < Te ? -1 : Te < ie ? 1 : 0;
    }, c.isEncoding = function(W) {
      switch (String(W).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, c.concat = function(W, Y) {
      if (!Array.isArray(W))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (W.length === 0)
        return c.alloc(0);
      var ie;
      if (Y === void 0)
        for (Y = 0, ie = 0; ie < W.length; ++ie)
          Y += W[ie].length;
      var Te = c.allocUnsafe(Y), $ = 0;
      for (ie = 0; ie < W.length; ++ie) {
        var _e = W[ie];
        if (ze(_e, Uint8Array))
          $ + _e.length > Te.length ? c.from(_e).copy(Te, $) : Uint8Array.prototype.set.call(
            Te,
            _e,
            $
          );
        else if (c.isBuffer(_e))
          _e.copy(Te, $);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        $ += _e.length;
      }
      return Te;
    };
    function _(ye, W) {
      if (c.isBuffer(ye))
        return ye.length;
      if (ArrayBuffer.isView(ye) || ze(ye, ArrayBuffer))
        return ye.byteLength;
      if (typeof ye != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ye
        );
      var Y = ye.length, ie = arguments.length > 2 && arguments[2] === !0;
      if (!ie && Y === 0) return 0;
      for (var Te = !1; ; )
        switch (W) {
          case "ascii":
          case "latin1":
          case "binary":
            return Y;
          case "utf8":
          case "utf-8":
            return At(ye).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Y * 2;
          case "hex":
            return Y >>> 1;
          case "base64":
            return Fe(ye).length;
          default:
            if (Te)
              return ie ? -1 : At(ye).length;
            W = ("" + W).toLowerCase(), Te = !0;
        }
    }
    c.byteLength = _;
    function E(ye, W, Y) {
      var ie = !1;
      if ((W === void 0 || W < 0) && (W = 0), W > this.length || ((Y === void 0 || Y > this.length) && (Y = this.length), Y <= 0) || (Y >>>= 0, W >>>= 0, Y <= W))
        return "";
      for (ye || (ye = "utf8"); ; )
        switch (ye) {
          case "hex":
            return Me(this, W, Y);
          case "utf8":
          case "utf-8":
            return Ce(this, W, Y);
          case "ascii":
            return De(this, W, Y);
          case "latin1":
          case "binary":
            return je(this, W, Y);
          case "base64":
            return de(this, W, Y);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return qe(this, W, Y);
          default:
            if (ie) throw new TypeError("Unknown encoding: " + ye);
            ye = (ye + "").toLowerCase(), ie = !0;
        }
    }
    c.prototype._isBuffer = !0;
    function O(ye, W, Y) {
      var ie = ye[W];
      ye[W] = ye[Y], ye[Y] = ie;
    }
    c.prototype.swap16 = function() {
      var W = this.length;
      if (W % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var Y = 0; Y < W; Y += 2)
        O(this, Y, Y + 1);
      return this;
    }, c.prototype.swap32 = function() {
      var W = this.length;
      if (W % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var Y = 0; Y < W; Y += 4)
        O(this, Y, Y + 3), O(this, Y + 1, Y + 2);
      return this;
    }, c.prototype.swap64 = function() {
      var W = this.length;
      if (W % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var Y = 0; Y < W; Y += 8)
        O(this, Y, Y + 7), O(this, Y + 1, Y + 6), O(this, Y + 2, Y + 5), O(this, Y + 3, Y + 4);
      return this;
    }, c.prototype.toString = function() {
      var W = this.length;
      return W === 0 ? "" : arguments.length === 0 ? Ce(this, 0, W) : E.apply(this, arguments);
    }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(W) {
      if (!c.isBuffer(W)) throw new TypeError("Argument must be a Buffer");
      return this === W ? !0 : c.compare(this, W) === 0;
    }, c.prototype.inspect = function() {
      var W = "", Y = e.INSPECT_MAX_BYTES;
      return W = this.toString("hex", 0, Y).replace(/(.{2})/g, "$1 ").trim(), this.length > Y && (W += " ... "), "<Buffer " + W + ">";
    }, r && (c.prototype[r] = c.prototype.inspect), c.prototype.compare = function(W, Y, ie, Te, $) {
      if (ze(W, Uint8Array) && (W = c.from(W, W.offset, W.byteLength)), !c.isBuffer(W))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof W
        );
      if (Y === void 0 && (Y = 0), ie === void 0 && (ie = W ? W.length : 0), Te === void 0 && (Te = 0), $ === void 0 && ($ = this.length), Y < 0 || ie > W.length || Te < 0 || $ > this.length)
        throw new RangeError("out of range index");
      if (Te >= $ && Y >= ie)
        return 0;
      if (Te >= $)
        return -1;
      if (Y >= ie)
        return 1;
      if (Y >>>= 0, ie >>>= 0, Te >>>= 0, $ >>>= 0, this === W) return 0;
      for (var _e = $ - Te, Le = ie - Y, et = Math.min(_e, Le), Ge = this.slice(Te, $), $t = W.slice(Y, ie), Be = 0; Be < et; ++Be)
        if (Ge[Be] !== $t[Be]) {
          _e = Ge[Be], Le = $t[Be];
          break;
        }
      return _e < Le ? -1 : Le < _e ? 1 : 0;
    };
    function M(ye, W, Y, ie, Te) {
      if (ye.length === 0) return -1;
      if (typeof Y == "string" ? (ie = Y, Y = 0) : Y > 2147483647 ? Y = 2147483647 : Y < -2147483648 && (Y = -2147483648), Y = +Y, Rt(Y) && (Y = Te ? 0 : ye.length - 1), Y < 0 && (Y = ye.length + Y), Y >= ye.length) {
        if (Te) return -1;
        Y = ye.length - 1;
      } else if (Y < 0)
        if (Te) Y = 0;
        else return -1;
      if (typeof W == "string" && (W = c.from(W, ie)), c.isBuffer(W))
        return W.length === 0 ? -1 : L(ye, W, Y, ie, Te);
      if (typeof W == "number")
        return W = W & 255, typeof Uint8Array.prototype.indexOf == "function" ? Te ? Uint8Array.prototype.indexOf.call(ye, W, Y) : Uint8Array.prototype.lastIndexOf.call(ye, W, Y) : L(ye, [W], Y, ie, Te);
      throw new TypeError("val must be string, number or Buffer");
    }
    function L(ye, W, Y, ie, Te) {
      var $ = 1, _e = ye.length, Le = W.length;
      if (ie !== void 0 && (ie = String(ie).toLowerCase(), ie === "ucs2" || ie === "ucs-2" || ie === "utf16le" || ie === "utf-16le")) {
        if (ye.length < 2 || W.length < 2)
          return -1;
        $ = 2, _e /= 2, Le /= 2, Y /= 2;
      }
      function et(N, F) {
        return $ === 1 ? N[F] : N.readUInt16BE(F * $);
      }
      var Ge;
      if (Te) {
        var $t = -1;
        for (Ge = Y; Ge < _e; Ge++)
          if (et(ye, Ge) === et(W, $t === -1 ? 0 : Ge - $t)) {
            if ($t === -1 && ($t = Ge), Ge - $t + 1 === Le) return $t * $;
          } else
            $t !== -1 && (Ge -= Ge - $t), $t = -1;
      } else
        for (Y + Le > _e && (Y = _e - Le), Ge = Y; Ge >= 0; Ge--) {
          for (var Be = !0, P = 0; P < Le; P++)
            if (et(ye, Ge + P) !== et(W, P)) {
              Be = !1;
              break;
            }
          if (Be) return Ge;
        }
      return -1;
    }
    c.prototype.includes = function(W, Y, ie) {
      return this.indexOf(W, Y, ie) !== -1;
    }, c.prototype.indexOf = function(W, Y, ie) {
      return M(this, W, Y, ie, !0);
    }, c.prototype.lastIndexOf = function(W, Y, ie) {
      return M(this, W, Y, ie, !1);
    };
    function Z(ye, W, Y, ie) {
      Y = Number(Y) || 0;
      var Te = ye.length - Y;
      ie ? (ie = Number(ie), ie > Te && (ie = Te)) : ie = Te;
      var $ = W.length;
      ie > $ / 2 && (ie = $ / 2);
      for (var _e = 0; _e < ie; ++_e) {
        var Le = parseInt(W.substr(_e * 2, 2), 16);
        if (Rt(Le)) return _e;
        ye[Y + _e] = Le;
      }
      return _e;
    }
    function Q(ye, W, Y, ie) {
      return Xe(At(W, ye.length - Y), ye, Y, ie);
    }
    function ae(ye, W, Y, ie) {
      return Xe(He(W), ye, Y, ie);
    }
    function re(ye, W, Y, ie) {
      return Xe(Fe(W), ye, Y, ie);
    }
    function X(ye, W, Y, ie) {
      return Xe(Dt(W, ye.length - Y), ye, Y, ie);
    }
    c.prototype.write = function(W, Y, ie, Te) {
      if (Y === void 0)
        Te = "utf8", ie = this.length, Y = 0;
      else if (ie === void 0 && typeof Y == "string")
        Te = Y, ie = this.length, Y = 0;
      else if (isFinite(Y))
        Y = Y >>> 0, isFinite(ie) ? (ie = ie >>> 0, Te === void 0 && (Te = "utf8")) : (Te = ie, ie = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var $ = this.length - Y;
      if ((ie === void 0 || ie > $) && (ie = $), W.length > 0 && (ie < 0 || Y < 0) || Y > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      Te || (Te = "utf8");
      for (var _e = !1; ; )
        switch (Te) {
          case "hex":
            return Z(this, W, Y, ie);
          case "utf8":
          case "utf-8":
            return Q(this, W, Y, ie);
          case "ascii":
          case "latin1":
          case "binary":
            return ae(this, W, Y, ie);
          case "base64":
            return re(this, W, Y, ie);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return X(this, W, Y, ie);
          default:
            if (_e) throw new TypeError("Unknown encoding: " + Te);
            Te = ("" + Te).toLowerCase(), _e = !0;
        }
    }, c.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function de(ye, W, Y) {
      return W === 0 && Y === ye.length ? t.fromByteArray(ye) : t.fromByteArray(ye.slice(W, Y));
    }
    function Ce(ye, W, Y) {
      Y = Math.min(ye.length, Y);
      for (var ie = [], Te = W; Te < Y; ) {
        var $ = ye[Te], _e = null, Le = $ > 239 ? 4 : $ > 223 ? 3 : $ > 191 ? 2 : 1;
        if (Te + Le <= Y) {
          var et, Ge, $t, Be;
          switch (Le) {
            case 1:
              $ < 128 && (_e = $);
              break;
            case 2:
              et = ye[Te + 1], (et & 192) === 128 && (Be = ($ & 31) << 6 | et & 63, Be > 127 && (_e = Be));
              break;
            case 3:
              et = ye[Te + 1], Ge = ye[Te + 2], (et & 192) === 128 && (Ge & 192) === 128 && (Be = ($ & 15) << 12 | (et & 63) << 6 | Ge & 63, Be > 2047 && (Be < 55296 || Be > 57343) && (_e = Be));
              break;
            case 4:
              et = ye[Te + 1], Ge = ye[Te + 2], $t = ye[Te + 3], (et & 192) === 128 && (Ge & 192) === 128 && ($t & 192) === 128 && (Be = ($ & 15) << 18 | (et & 63) << 12 | (Ge & 63) << 6 | $t & 63, Be > 65535 && Be < 1114112 && (_e = Be));
          }
        }
        _e === null ? (_e = 65533, Le = 1) : _e > 65535 && (_e -= 65536, ie.push(_e >>> 10 & 1023 | 55296), _e = 56320 | _e & 1023), ie.push(_e), Te += Le;
      }
      return ne(ie);
    }
    var J = 4096;
    function ne(ye) {
      var W = ye.length;
      if (W <= J)
        return String.fromCharCode.apply(String, ye);
      for (var Y = "", ie = 0; ie < W; )
        Y += String.fromCharCode.apply(
          String,
          ye.slice(ie, ie += J)
        );
      return Y;
    }
    function De(ye, W, Y) {
      var ie = "";
      Y = Math.min(ye.length, Y);
      for (var Te = W; Te < Y; ++Te)
        ie += String.fromCharCode(ye[Te] & 127);
      return ie;
    }
    function je(ye, W, Y) {
      var ie = "";
      Y = Math.min(ye.length, Y);
      for (var Te = W; Te < Y; ++Te)
        ie += String.fromCharCode(ye[Te]);
      return ie;
    }
    function Me(ye, W, Y) {
      var ie = ye.length;
      (!W || W < 0) && (W = 0), (!Y || Y < 0 || Y > ie) && (Y = ie);
      for (var Te = "", $ = W; $ < Y; ++$)
        Te += Yt[ye[$]];
      return Te;
    }
    function qe(ye, W, Y) {
      for (var ie = ye.slice(W, Y), Te = "", $ = 0; $ < ie.length - 1; $ += 2)
        Te += String.fromCharCode(ie[$] + ie[$ + 1] * 256);
      return Te;
    }
    c.prototype.slice = function(W, Y) {
      var ie = this.length;
      W = ~~W, Y = Y === void 0 ? ie : ~~Y, W < 0 ? (W += ie, W < 0 && (W = 0)) : W > ie && (W = ie), Y < 0 ? (Y += ie, Y < 0 && (Y = 0)) : Y > ie && (Y = ie), Y < W && (Y = W);
      var Te = this.subarray(W, Y);
      return Object.setPrototypeOf(Te, c.prototype), Te;
    };
    function Ve(ye, W, Y) {
      if (ye % 1 !== 0 || ye < 0) throw new RangeError("offset is not uint");
      if (ye + W > Y) throw new RangeError("Trying to access beyond buffer length");
    }
    c.prototype.readUintLE = c.prototype.readUIntLE = function(W, Y, ie) {
      W = W >>> 0, Y = Y >>> 0, ie || Ve(W, Y, this.length);
      for (var Te = this[W], $ = 1, _e = 0; ++_e < Y && ($ *= 256); )
        Te += this[W + _e] * $;
      return Te;
    }, c.prototype.readUintBE = c.prototype.readUIntBE = function(W, Y, ie) {
      W = W >>> 0, Y = Y >>> 0, ie || Ve(W, Y, this.length);
      for (var Te = this[W + --Y], $ = 1; Y > 0 && ($ *= 256); )
        Te += this[W + --Y] * $;
      return Te;
    }, c.prototype.readUint8 = c.prototype.readUInt8 = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 1, this.length), this[W];
    }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 2, this.length), this[W] | this[W + 1] << 8;
    }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 2, this.length), this[W] << 8 | this[W + 1];
    }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 4, this.length), (this[W] | this[W + 1] << 8 | this[W + 2] << 16) + this[W + 3] * 16777216;
    }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 4, this.length), this[W] * 16777216 + (this[W + 1] << 16 | this[W + 2] << 8 | this[W + 3]);
    }, c.prototype.readIntLE = function(W, Y, ie) {
      W = W >>> 0, Y = Y >>> 0, ie || Ve(W, Y, this.length);
      for (var Te = this[W], $ = 1, _e = 0; ++_e < Y && ($ *= 256); )
        Te += this[W + _e] * $;
      return $ *= 128, Te >= $ && (Te -= Math.pow(2, 8 * Y)), Te;
    }, c.prototype.readIntBE = function(W, Y, ie) {
      W = W >>> 0, Y = Y >>> 0, ie || Ve(W, Y, this.length);
      for (var Te = Y, $ = 1, _e = this[W + --Te]; Te > 0 && ($ *= 256); )
        _e += this[W + --Te] * $;
      return $ *= 128, _e >= $ && (_e -= Math.pow(2, 8 * Y)), _e;
    }, c.prototype.readInt8 = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 1, this.length), this[W] & 128 ? (255 - this[W] + 1) * -1 : this[W];
    }, c.prototype.readInt16LE = function(W, Y) {
      W = W >>> 0, Y || Ve(W, 2, this.length);
      var ie = this[W] | this[W + 1] << 8;
      return ie & 32768 ? ie | 4294901760 : ie;
    }, c.prototype.readInt16BE = function(W, Y) {
      W = W >>> 0, Y || Ve(W, 2, this.length);
      var ie = this[W + 1] | this[W] << 8;
      return ie & 32768 ? ie | 4294901760 : ie;
    }, c.prototype.readInt32LE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 4, this.length), this[W] | this[W + 1] << 8 | this[W + 2] << 16 | this[W + 3] << 24;
    }, c.prototype.readInt32BE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 4, this.length), this[W] << 24 | this[W + 1] << 16 | this[W + 2] << 8 | this[W + 3];
    }, c.prototype.readFloatLE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 4, this.length), n.read(this, W, !0, 23, 4);
    }, c.prototype.readFloatBE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 4, this.length), n.read(this, W, !1, 23, 4);
    }, c.prototype.readDoubleLE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 8, this.length), n.read(this, W, !0, 52, 8);
    }, c.prototype.readDoubleBE = function(W, Y) {
      return W = W >>> 0, Y || Ve(W, 8, this.length), n.read(this, W, !1, 52, 8);
    };
    function xe(ye, W, Y, ie, Te, $) {
      if (!c.isBuffer(ye)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (W > Te || W < $) throw new RangeError('"value" argument is out of bounds');
      if (Y + ie > ye.length) throw new RangeError("Index out of range");
    }
    c.prototype.writeUintLE = c.prototype.writeUIntLE = function(W, Y, ie, Te) {
      if (W = +W, Y = Y >>> 0, ie = ie >>> 0, !Te) {
        var $ = Math.pow(2, 8 * ie) - 1;
        xe(this, W, Y, ie, $, 0);
      }
      var _e = 1, Le = 0;
      for (this[Y] = W & 255; ++Le < ie && (_e *= 256); )
        this[Y + Le] = W / _e & 255;
      return Y + ie;
    }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(W, Y, ie, Te) {
      if (W = +W, Y = Y >>> 0, ie = ie >>> 0, !Te) {
        var $ = Math.pow(2, 8 * ie) - 1;
        xe(this, W, Y, ie, $, 0);
      }
      var _e = ie - 1, Le = 1;
      for (this[Y + _e] = W & 255; --_e >= 0 && (Le *= 256); )
        this[Y + _e] = W / Le & 255;
      return Y + ie;
    }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 1, 255, 0), this[Y] = W & 255, Y + 1;
    }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 2, 65535, 0), this[Y] = W & 255, this[Y + 1] = W >>> 8, Y + 2;
    }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 2, 65535, 0), this[Y] = W >>> 8, this[Y + 1] = W & 255, Y + 2;
    }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 4, 4294967295, 0), this[Y + 3] = W >>> 24, this[Y + 2] = W >>> 16, this[Y + 1] = W >>> 8, this[Y] = W & 255, Y + 4;
    }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 4, 4294967295, 0), this[Y] = W >>> 24, this[Y + 1] = W >>> 16, this[Y + 2] = W >>> 8, this[Y + 3] = W & 255, Y + 4;
    }, c.prototype.writeIntLE = function(W, Y, ie, Te) {
      if (W = +W, Y = Y >>> 0, !Te) {
        var $ = Math.pow(2, 8 * ie - 1);
        xe(this, W, Y, ie, $ - 1, -$);
      }
      var _e = 0, Le = 1, et = 0;
      for (this[Y] = W & 255; ++_e < ie && (Le *= 256); )
        W < 0 && et === 0 && this[Y + _e - 1] !== 0 && (et = 1), this[Y + _e] = (W / Le >> 0) - et & 255;
      return Y + ie;
    }, c.prototype.writeIntBE = function(W, Y, ie, Te) {
      if (W = +W, Y = Y >>> 0, !Te) {
        var $ = Math.pow(2, 8 * ie - 1);
        xe(this, W, Y, ie, $ - 1, -$);
      }
      var _e = ie - 1, Le = 1, et = 0;
      for (this[Y + _e] = W & 255; --_e >= 0 && (Le *= 256); )
        W < 0 && et === 0 && this[Y + _e + 1] !== 0 && (et = 1), this[Y + _e] = (W / Le >> 0) - et & 255;
      return Y + ie;
    }, c.prototype.writeInt8 = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 1, 127, -128), W < 0 && (W = 255 + W + 1), this[Y] = W & 255, Y + 1;
    }, c.prototype.writeInt16LE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 2, 32767, -32768), this[Y] = W & 255, this[Y + 1] = W >>> 8, Y + 2;
    }, c.prototype.writeInt16BE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 2, 32767, -32768), this[Y] = W >>> 8, this[Y + 1] = W & 255, Y + 2;
    }, c.prototype.writeInt32LE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 4, 2147483647, -2147483648), this[Y] = W & 255, this[Y + 1] = W >>> 8, this[Y + 2] = W >>> 16, this[Y + 3] = W >>> 24, Y + 4;
    }, c.prototype.writeInt32BE = function(W, Y, ie) {
      return W = +W, Y = Y >>> 0, ie || xe(this, W, Y, 4, 2147483647, -2147483648), W < 0 && (W = 4294967295 + W + 1), this[Y] = W >>> 24, this[Y + 1] = W >>> 16, this[Y + 2] = W >>> 8, this[Y + 3] = W & 255, Y + 4;
    };
    function ve(ye, W, Y, ie, Te, $) {
      if (Y + ie > ye.length) throw new RangeError("Index out of range");
      if (Y < 0) throw new RangeError("Index out of range");
    }
    function Ae(ye, W, Y, ie, Te) {
      return W = +W, Y = Y >>> 0, Te || ve(ye, W, Y, 4), n.write(ye, W, Y, ie, 23, 4), Y + 4;
    }
    c.prototype.writeFloatLE = function(W, Y, ie) {
      return Ae(this, W, Y, !0, ie);
    }, c.prototype.writeFloatBE = function(W, Y, ie) {
      return Ae(this, W, Y, !1, ie);
    };
    function Ue(ye, W, Y, ie, Te) {
      return W = +W, Y = Y >>> 0, Te || ve(ye, W, Y, 8), n.write(ye, W, Y, ie, 52, 8), Y + 8;
    }
    c.prototype.writeDoubleLE = function(W, Y, ie) {
      return Ue(this, W, Y, !0, ie);
    }, c.prototype.writeDoubleBE = function(W, Y, ie) {
      return Ue(this, W, Y, !1, ie);
    }, c.prototype.copy = function(W, Y, ie, Te) {
      if (!c.isBuffer(W)) throw new TypeError("argument should be a Buffer");
      if (ie || (ie = 0), !Te && Te !== 0 && (Te = this.length), Y >= W.length && (Y = W.length), Y || (Y = 0), Te > 0 && Te < ie && (Te = ie), Te === ie || W.length === 0 || this.length === 0) return 0;
      if (Y < 0)
        throw new RangeError("targetStart out of bounds");
      if (ie < 0 || ie >= this.length) throw new RangeError("Index out of range");
      if (Te < 0) throw new RangeError("sourceEnd out of bounds");
      Te > this.length && (Te = this.length), W.length - Y < Te - ie && (Te = W.length - Y + ie);
      var $ = Te - ie;
      return this === W && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Y, ie, Te) : Uint8Array.prototype.set.call(
        W,
        this.subarray(ie, Te),
        Y
      ), $;
    }, c.prototype.fill = function(W, Y, ie, Te) {
      if (typeof W == "string") {
        if (typeof Y == "string" ? (Te = Y, Y = 0, ie = this.length) : typeof ie == "string" && (Te = ie, ie = this.length), Te !== void 0 && typeof Te != "string")
          throw new TypeError("encoding must be a string");
        if (typeof Te == "string" && !c.isEncoding(Te))
          throw new TypeError("Unknown encoding: " + Te);
        if (W.length === 1) {
          var $ = W.charCodeAt(0);
          (Te === "utf8" && $ < 128 || Te === "latin1") && (W = $);
        }
      } else typeof W == "number" ? W = W & 255 : typeof W == "boolean" && (W = Number(W));
      if (Y < 0 || this.length < Y || this.length < ie)
        throw new RangeError("Out of range index");
      if (ie <= Y)
        return this;
      Y = Y >>> 0, ie = ie === void 0 ? this.length : ie >>> 0, W || (W = 0);
      var _e;
      if (typeof W == "number")
        for (_e = Y; _e < ie; ++_e)
          this[_e] = W;
      else {
        var Le = c.isBuffer(W) ? W : c.from(W, Te), et = Le.length;
        if (et === 0)
          throw new TypeError('The value "' + W + '" is invalid for argument "value"');
        for (_e = 0; _e < ie - Y; ++_e)
          this[_e + Y] = Le[_e % et];
      }
      return this;
    };
    var qt = /[^+/0-9A-Za-z-_]/g;
    function Ze(ye) {
      if (ye = ye.split("=")[0], ye = ye.trim().replace(qt, ""), ye.length < 2) return "";
      for (; ye.length % 4 !== 0; )
        ye = ye + "=";
      return ye;
    }
    function At(ye, W) {
      W = W || 1 / 0;
      for (var Y, ie = ye.length, Te = null, $ = [], _e = 0; _e < ie; ++_e) {
        if (Y = ye.charCodeAt(_e), Y > 55295 && Y < 57344) {
          if (!Te) {
            if (Y > 56319) {
              (W -= 3) > -1 && $.push(239, 191, 189);
              continue;
            } else if (_e + 1 === ie) {
              (W -= 3) > -1 && $.push(239, 191, 189);
              continue;
            }
            Te = Y;
            continue;
          }
          if (Y < 56320) {
            (W -= 3) > -1 && $.push(239, 191, 189), Te = Y;
            continue;
          }
          Y = (Te - 55296 << 10 | Y - 56320) + 65536;
        } else Te && (W -= 3) > -1 && $.push(239, 191, 189);
        if (Te = null, Y < 128) {
          if ((W -= 1) < 0) break;
          $.push(Y);
        } else if (Y < 2048) {
          if ((W -= 2) < 0) break;
          $.push(
            Y >> 6 | 192,
            Y & 63 | 128
          );
        } else if (Y < 65536) {
          if ((W -= 3) < 0) break;
          $.push(
            Y >> 12 | 224,
            Y >> 6 & 63 | 128,
            Y & 63 | 128
          );
        } else if (Y < 1114112) {
          if ((W -= 4) < 0) break;
          $.push(
            Y >> 18 | 240,
            Y >> 12 & 63 | 128,
            Y >> 6 & 63 | 128,
            Y & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return $;
    }
    function He(ye) {
      for (var W = [], Y = 0; Y < ye.length; ++Y)
        W.push(ye.charCodeAt(Y) & 255);
      return W;
    }
    function Dt(ye, W) {
      for (var Y, ie, Te, $ = [], _e = 0; _e < ye.length && !((W -= 2) < 0); ++_e)
        Y = ye.charCodeAt(_e), ie = Y >> 8, Te = Y % 256, $.push(Te), $.push(ie);
      return $;
    }
    function Fe(ye) {
      return t.toByteArray(Ze(ye));
    }
    function Xe(ye, W, Y, ie) {
      for (var Te = 0; Te < ie && !(Te + Y >= W.length || Te >= ye.length); ++Te)
        W[Te + Y] = ye[Te];
      return Te;
    }
    function ze(ye, W) {
      return ye instanceof W || ye != null && ye.constructor != null && ye.constructor.name != null && ye.constructor.name === W.name;
    }
    function Rt(ye) {
      return ye !== ye;
    }
    var Yt = (function() {
      for (var ye = "0123456789abcdef", W = new Array(256), Y = 0; Y < 16; ++Y)
        for (var ie = Y * 16, Te = 0; Te < 16; ++Te)
          W[ie + Te] = ye[Y] + ye[Te];
      return W;
    })();
  })(h5)), h5;
}
var m5, W8;
function $B() {
  if (W8) return m5;
  W8 = 1;
  var e = P2().Buffer;
  const t = Li();
  var n = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function r(c) {
    if (c === null)
      return !1;
    var u, s, l = 0, d = c.length, f = n;
    for (s = 0; s < d; s++)
      if (u = f.indexOf(c.charAt(s)), !(u > 64)) {
        if (u < 0)
          return !1;
        l += 6;
      }
    return l % 8 === 0;
  }
  function i(c) {
    var u, s, l = c.replace(/[\r\n=]/g, ""), d = l.length, f = n, p = 0, g = [];
    for (u = 0; u < d; u++)
      u % 4 === 0 && u && (g.push(p >> 16 & 255), g.push(p >> 8 & 255), g.push(p & 255)), p = p << 6 | f.indexOf(l.charAt(u));
    return s = d % 4 * 6, s === 0 ? (g.push(p >> 16 & 255), g.push(p >> 8 & 255), g.push(p & 255)) : s === 18 ? (g.push(p >> 10 & 255), g.push(p >> 2 & 255)) : s === 12 && g.push(p >> 4 & 255), e ? new e(g) : g;
  }
  function a(c) {
    var u = "", s = 0, l, d, f = c.length, p = n;
    for (l = 0; l < f; l++)
      l % 3 === 0 && l && (u += p[s >> 18 & 63], u += p[s >> 12 & 63], u += p[s >> 6 & 63], u += p[s & 63]), s = (s << 8) + c[l];
    return d = f % 3, d === 0 ? (u += p[s >> 18 & 63], u += p[s >> 12 & 63], u += p[s >> 6 & 63], u += p[s & 63]) : d === 2 ? (u += p[s >> 10 & 63], u += p[s >> 4 & 63], u += p[s << 2 & 63], u += p[64]) : d === 1 && (u += p[s >> 2 & 63], u += p[s << 4 & 63], u += p[64], u += p[64]), u;
  }
  function o(c) {
    return e && e.isBuffer(c);
  }
  return m5 = new t.Type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: r,
    construct: i,
    predicate: o,
    represent: a
  }), m5;
}
var g5, K8;
function LB() {
  if (K8) return g5;
  K8 = 1;
  const e = Li();
  var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  function r(a) {
    if (a === null)
      return !0;
    var o = [], c, u, s, l, d, f = a;
    for (c = 0, u = f.length; c < u; c += 1) {
      if (s = f[c], d = !1, n.call(s) !== "[object Object]")
        return !1;
      for (l in s)
        if (t.call(s, l))
          if (!d)
            d = !0;
          else
            return !1;
      if (!d)
        return !1;
      if (o.indexOf(l) === -1)
        o.push(l);
      else
        return !1;
    }
    return !0;
  }
  function i(a) {
    return a !== null ? a : [];
  }
  return g5 = new e.Type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: r,
    construct: i
  }), g5;
}
var v5, Z8;
function NB() {
  if (Z8) return v5;
  Z8 = 1;
  const e = Li(), t = H0();
  var n = Object.prototype.toString;
  function r(a) {
    if (a === null)
      return !0;
    if (a.kind != t.Kind.SEQ)
      return !1;
    var o, c, u, s = a.items;
    for (o = 0, c = s.length; o < c; o += 1)
      if (u = s[o], n.call(u) !== "[object Object]" || !Array.isArray(u.mappings) || u.mappings.length !== 1)
        return !1;
    return !0;
  }
  function i(a) {
    if (a === null || !Array.isArray(a.items))
      return [];
    let o, c, u, s = a.items;
    for (u = t.newItems(), u.parent = a.parent, u.startPosition = a.startPosition, u.endPosition = a.endPosition, o = 0, c = s.length; o < c; o += 1) {
      let d = s[o].mappings[0], f = t.newItems();
      f.parent = u, f.startPosition = d.key.startPosition, f.endPosition = d.value.startPosition, d.key.parent = f, d.value.parent = f, f.items = [d.key, d.value], u.items.push(f);
    }
    return u;
  }
  return v5 = new e.Type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: r,
    construct: i
  }), v5;
}
var y5, Y8;
function FB() {
  if (Y8) return y5;
  Y8 = 1;
  const e = Li(), t = H0();
  function n(i) {
    return i === null ? !0 : i.kind == t.Kind.MAP;
  }
  function r(i) {
    return i !== null ? i : {};
  }
  return y5 = new e.Type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: n,
    construct: r
  }), y5;
}
var b5, J8;
function R2() {
  if (J8) return b5;
  J8 = 1;
  const e = Hf();
  var t = new e.Schema({
    include: [
      RB()
    ],
    implicit: [
      IB(),
      jB()
    ],
    explicit: [
      $B(),
      LB(),
      NB(),
      FB()
    ]
  });
  return b5 = t, b5;
}
var x5, Q8;
function MB() {
  if (Q8) return x5;
  Q8 = 1;
  const e = Li();
  function t() {
    return !0;
  }
  function n() {
  }
  function r() {
    return "";
  }
  function i(a) {
    return typeof a > "u";
  }
  return x5 = new e.Type("tag:yaml.org,2002:js/undefined", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: i,
    represent: r
  }), x5;
}
var _5, X8;
function BB() {
  if (X8) return _5;
  X8 = 1;
  const e = Li();
  function t(a) {
    if (a === null || a.length === 0)
      return !1;
    var o = a, c = /\/([gim]*)$/.exec(a), u = "";
    if (o[0] === "/") {
      if (c && (u = c[1]), u.length > 3 || o[o.length - u.length - 1] !== "/")
        return !1;
      o = o.slice(1, o.length - u.length - 1);
    }
    try {
      var s = new RegExp(o, u);
      return !0;
    } catch {
      return !1;
    }
  }
  function n(a) {
    var o = a, c = /\/([gim]*)$/.exec(a), u = "";
    return o[0] === "/" && (c && (u = c[1]), o = o.slice(1, o.length - u.length - 1)), new RegExp(o, u);
  }
  function r(a) {
    var o = "/" + a.source + "/";
    return a.global && (o += "g"), a.multiline && (o += "m"), a.ignoreCase && (o += "i"), o;
  }
  function i(a) {
    return Object.prototype.toString.call(a) === "[object RegExp]";
  }
  return _5 = new e.Type("tag:yaml.org,2002:js/regexp", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: i,
    represent: r
  }), _5;
}
var w5, e4;
function tA() {
  if (e4) return w5;
  e4 = 1;
  const e = Hf();
  var t = new e.Schema({
    include: [
      R2()
    ],
    explicit: [
      MB(),
      BB()
    ]
  });
  return e.Schema.DEFAULT = t, w5 = t, w5;
}
var t4;
function UB() {
  if (t4) return za;
  t4 = 1, Object.defineProperty(za, "__esModule", { value: !0 });
  const e = H0(), t = Cc(), n = Uf(), r = _B(), i = R2(), a = tA();
  var o = Object.prototype.hasOwnProperty, c = 1, u = 2, s = 3, l = 4, d = 1, f = 2, p = 3, g = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, b = /[\x85\u2028\u2029]/, w = /[,\[\]\{\}]/, y = /^(?:!|!!|![a-z\-]+!)$/i, v = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
  function _(P) {
    return P === 10 || P === 13;
  }
  function E(P) {
    return P === 9 || P === 32;
  }
  function O(P) {
    return P === 9 || P === 32 || P === 10 || P === 13;
  }
  function M(P) {
    return P === 44 || P === 91 || P === 93 || P === 123 || P === 125;
  }
  function L(P) {
    var N;
    return 48 <= P && P <= 57 ? P - 48 : (N = P | 32, 97 <= N && N <= 102 ? N - 97 + 10 : -1);
  }
  function Z(P) {
    return P === 120 ? 2 : P === 117 ? 4 : P === 85 ? 8 : 0;
  }
  function Q(P) {
    return 48 <= P && P <= 57 ? P - 48 : -1;
  }
  function ae(P) {
    return P === 48 ? "\0" : P === 97 ? "\x07" : P === 98 ? "\b" : P === 116 || P === 9 ? "	" : P === 110 ? `
` : P === 118 ? "\v" : P === 102 ? "\f" : P === 114 ? "\r" : P === 101 ? "\x1B" : P === 32 ? " " : P === 34 ? '"' : P === 47 ? "/" : P === 92 ? "\\" : P === 78 ? "" : P === 95 ? " " : P === 76 ? "\u2028" : P === 80 ? "\u2029" : "";
  }
  function re(P) {
    return P <= 65535 ? String.fromCharCode(P) : String.fromCharCode((P - 65536 >> 10) + 55296, (P - 65536 & 1023) + 56320);
  }
  for (var X = new Array(256), de = new Array(256), Ce = new Array(256), J = new Array(256), ne = 0; ne < 256; ne++)
    J[ne] = de[ne] = ae(ne), X[ne] = de[ne] ? 1 : 0, Ce[ne] = 1, X[ne] || (J[ne] = "\\" + String.fromCharCode(ne));
  class De {
    constructor(N, F) {
      this.errorMap = {}, this.errors = [], this.lines = [], this.input = N, this.filename = F.filename || null, this.schema = F.schema || a, this.onWarning = F.onWarning || null, this.legacy = F.legacy || !1, this.allowAnyEscape = F.allowAnyEscape || !1, this.ignoreDuplicateKeys = F.ignoreDuplicateKeys || !1, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = N.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.documents = [];
    }
  }
  function je(P, N, F = !1) {
    return new n(N, new r(P.filename, P.input, P.position, P.line, P.position - P.lineStart), F);
  }
  function Me(P, N, F, T = !1, C = !1) {
    var S = qt(P, N);
    if (S) {
      var h = F + N;
      if (!P.errorMap[h]) {
        var k = new r(P.filename, P.input, N, S.line, N - S.start);
        C && (k.toLineEnd = !0);
        var R = new n(F, k, T);
        P.errors.push(R);
      }
    }
  }
  function qe(P, N) {
    var F = je(P, N), T = F.message + F.mark.position;
    if (!P.errorMap[T]) {
      P.errors.push(F), P.errorMap[T] = 1;
      for (var C = P.position; ; ) {
        if (P.position >= P.input.length - 1)
          return;
        var S = P.input.charAt(P.position);
        if (S == `
`) {
          P.position--, P.position == C && (P.position += 1);
          return;
        }
        if (S == "\r") {
          P.position--, P.position == C && (P.position += 1);
          return;
        }
        P.position++;
      }
    }
  }
  function Ve(P, N) {
    var F = je(P, N);
    P.onWarning && P.onWarning.call(null, F);
  }
  var xe = {
    YAML: function(N, F, T) {
      var C, S, h;
      N.version !== null && qe(N, "duplication of %YAML directive"), T.length !== 1 && qe(N, "YAML directive accepts exactly one argument"), C = /^([0-9]+)\.([0-9]+)$/.exec(T[0]), C === null && qe(N, "ill-formed argument of the YAML directive"), S = parseInt(C[1], 10), h = parseInt(C[2], 10), S !== 1 && qe(N, "found incompatible YAML document (version 1.2 is required)"), N.version = T[0], N.checkLineBreaks = h < 2, h !== 2 && qe(N, "found incompatible YAML document (version 1.2 is required)");
    },
    TAG: function(N, F, T) {
      var C, S;
      T.length !== 2 && qe(N, "TAG directive accepts exactly two arguments"), C = T[0], S = T[1], y.test(C) || qe(N, "ill-formed tag handle (first argument) of the TAG directive"), o.call(N.tagMap, C) && qe(N, 'there is a previously declared suffix for "' + C + '" tag handle'), v.test(S) || qe(N, "ill-formed tag prefix (second argument) of the TAG directive"), N.tagMap[C] = S;
    }
  };
  function ve(P, N, F, T) {
    var C, S, h, k, R = P.result;
    if (R.startPosition == -1 && (R.startPosition = N), N <= F) {
      if (k = P.input.slice(N, F), T)
        for (C = 0, S = k.length; C < S; C += 1)
          h = k.charCodeAt(C), h === 9 || 32 <= h && h <= 1114111 || qe(P, "expected valid JSON character");
      else g.test(k) && qe(P, "the stream contains non-printable characters");
      R.value += k, R.endPosition = F;
    }
  }
  function Ae(P, N, F, T, C) {
    if (T != null) {
      N === null && (N = {
        startPosition: T.startPosition,
        endPosition: C.endPosition,
        parent: null,
        errors: [],
        mappings: [],
        kind: e.Kind.MAP
      });
      var S = e.newMapping(T, C);
      return S.parent = N, T.parent = S, C != null && (C.parent = S), !P.ignoreDuplicateKeys && N.mappings.forEach((h) => {
        h.key && h.key.value === (S.key && S.key.value) && (Me(P, S.key.startPosition, "duplicate key"), Me(P, h.key.startPosition, "duplicate key"));
      }), N.mappings.push(S), N.endPosition = C ? C.endPosition : T.endPosition + 1, N;
    }
  }
  function Ue(P) {
    var N;
    N = P.input.charCodeAt(P.position), N === 10 ? P.position++ : N === 13 ? (P.position++, P.input.charCodeAt(P.position) === 10 && P.position++) : qe(P, "a line break is expected"), P.line += 1, P.lineStart = P.position, P.lines.push({
      start: P.lineStart,
      line: P.line
    });
  }
  function qt(P, N) {
    for (var F, T = 0; T < P.lines.length && !(P.lines[T].start > N); T++)
      F = P.lines[T];
    return F || {
      start: 0,
      line: 0
    };
  }
  function Ze(P) {
    var N = 0, F = P.position;
    do
      N = P.input.charCodeAt(++P.position);
    while (N !== 0 && !_(N));
    P.comments.push({
      startPosition: F,
      endPosition: P.position,
      value: P.input.slice(F + 1, P.position)
    });
  }
  function At(P, N, F) {
    for (var T = 0, C = P.input.charCodeAt(P.position); C !== 0; ) {
      for (; E(C); )
        C === 9 && P.errors.push(je(P, "Using tabs can lead to unpredictable results", !0)), C = P.input.charCodeAt(++P.position);
      if (N && C === 35 && (Ze(P), C = P.input.charCodeAt(P.position)), _(C))
        for (Ue(P), C = P.input.charCodeAt(P.position), T++, P.lineIndent = 0; C === 32; )
          P.lineIndent++, C = P.input.charCodeAt(++P.position);
      else
        break;
    }
    return F !== -1 && T !== 0 && P.lineIndent < F && Ve(P, "deficient indentation"), T;
  }
  function He(P) {
    var N = P.position, F;
    return F = P.input.charCodeAt(N), !!((F === 45 || F === 46) && P.input.charCodeAt(N + 1) === F && P.input.charCodeAt(N + 2) === F && (N += 3, F = P.input.charCodeAt(N), F === 0 || O(F)));
  }
  function Dt(P, N, F) {
    F === 1 ? N.value += " " : F > 1 && (N.value += t.repeat(`
`, F - 1));
  }
  function Fe(P, N, F) {
    var T, C, S, h, k, R, j, A, I = P.kind, z = P.result, H, K = e.newScalar();
    if (K.plainScalar = !0, P.result = K, H = P.input.charCodeAt(P.position), O(H) || M(H) || H === 35 || H === 38 || H === 42 || H === 33 || H === 124 || H === 62 || H === 39 || H === 34 || H === 37 || H === 64 || H === 96 || (H === 63 || H === 45) && (C = P.input.charCodeAt(P.position + 1), O(C) || F && M(C)))
      return !1;
    for (P.kind = "scalar", S = h = P.position, k = !1; H !== 0; ) {
      if (H === 58) {
        if (C = P.input.charCodeAt(P.position + 1), O(C) || F && M(C))
          break;
      } else if (H === 35) {
        if (T = P.input.charCodeAt(P.position - 1), O(T))
          break;
      } else {
        if (P.position === P.lineStart && He(P) || F && M(H))
          break;
        if (_(H))
          if (R = P.line, j = P.lineStart, A = P.lineIndent, At(P, !1, -1), P.lineIndent >= N) {
            k = !0, H = P.input.charCodeAt(P.position);
            continue;
          } else {
            P.position = h, P.line = R, P.lineStart = j, P.lineIndent = A;
            break;
          }
      }
      if (k && (ve(P, S, h, !1), Dt(P, K, P.line - R), S = h = P.position, k = !1), E(H) || (h = P.position + 1), H = P.input.charCodeAt(++P.position), P.position >= P.input.length)
        return !1;
    }
    return ve(P, S, h, !1), P.result.startPosition != -1 ? (K.rawValue = P.input.substring(K.startPosition, K.endPosition), !0) : (P.kind = I, P.result = z, !1);
  }
  function Xe(P, N) {
    var F, T, C;
    if (F = P.input.charCodeAt(P.position), F !== 39)
      return !1;
    var S = e.newScalar();
    for (S.singleQuoted = !0, P.kind = "scalar", P.result = S, S.startPosition = P.position, P.position++, T = C = P.position; (F = P.input.charCodeAt(P.position)) !== 0; )
      if (F === 39)
        if (ve(P, T, P.position, !0), F = P.input.charCodeAt(++P.position), S.endPosition = P.position, F === 39)
          T = C = P.position, P.position++;
        else
          return !0;
      else _(F) ? (ve(P, T, C, !0), Dt(P, S, At(P, !1, N)), T = C = P.position) : P.position === P.lineStart && He(P) ? qe(P, "unexpected end of the document within a single quoted scalar") : (P.position++, C = P.position, S.endPosition = P.position);
    qe(P, "unexpected end of the stream within a single quoted scalar");
  }
  function ze(P, N) {
    var F, T, C, S, h, k;
    if (k = P.input.charCodeAt(P.position), k !== 34)
      return !1;
    P.kind = "scalar";
    var R = e.newScalar();
    for (R.doubleQuoted = !0, P.result = R, R.startPosition = P.position, P.position++, F = T = P.position; (k = P.input.charCodeAt(P.position)) !== 0; ) {
      if (k === 34)
        return ve(P, F, P.position, !0), P.position++, R.endPosition = P.position, R.rawValue = P.input.substring(R.startPosition, R.endPosition), !0;
      if (k === 92) {
        if (ve(P, F, P.position, !0), k = P.input.charCodeAt(++P.position), _(k))
          At(P, !1, N);
        else if (k < 256 && (P.allowAnyEscape ? Ce[k] : X[k]))
          R.value += P.allowAnyEscape ? J[k] : de[k], P.position++;
        else if ((h = Z(k)) > 0) {
          for (C = h, S = 0; C > 0; C--)
            k = P.input.charCodeAt(++P.position), (h = L(k)) >= 0 ? S = (S << 4) + h : qe(P, "expected hexadecimal character");
          R.value += re(S), P.position++;
        } else
          qe(P, "unknown escape sequence");
        F = T = P.position;
      } else _(k) ? (ve(P, F, T, !0), Dt(P, R, At(P, !1, N)), F = T = P.position) : P.position === P.lineStart && He(P) ? qe(P, "unexpected end of the document within a double quoted scalar") : (P.position++, T = P.position);
    }
    qe(P, "unexpected end of the stream within a double quoted scalar");
  }
  function Rt(P, N) {
    var F = !0, T, C = P.tag, S, h = P.anchor, k, R, j, A, I, z, H, K, U;
    if (U = P.input.charCodeAt(P.position), U === 91)
      R = 93, I = !1, S = e.newItems(), S.startPosition = P.position;
    else if (U === 123)
      R = 125, I = !0, S = e.newMap(), S.startPosition = P.position;
    else
      return !1;
    for (P.anchor !== null && (S.anchorId = P.anchor, P.anchorMap[P.anchor] = S), U = P.input.charCodeAt(++P.position); U !== 0; ) {
      if (At(P, !0, N), U = P.input.charCodeAt(P.position), U === R)
        return P.position++, P.tag = C, P.anchor = h, P.kind = I ? "mapping" : "sequence", P.result = S, S.endPosition = P.position, !0;
      if (!F) {
        var D = P.position;
        qe(P, "missed comma between flow collection entries"), P.position = D + 1;
      }
      if (H = z = K = null, j = A = !1, U === 63 && (k = P.input.charCodeAt(P.position + 1), O(k) && (j = A = !0, P.position++, At(P, !0, N))), T = P.line, $(P, N, c, !1, !0), H = P.tag, z = P.result, At(P, !0, N), U = P.input.charCodeAt(P.position), (A || P.line === T) && U === 58 && (j = !0, U = P.input.charCodeAt(++P.position), At(P, !0, N), $(P, N, c, !1, !0), K = P.result), I)
        Ae(P, S, H, z, K);
      else if (j) {
        var B = Ae(P, null, H, z, K);
        B.parent = S, S.items.push(B);
      } else
        z && (z.parent = S), S.items.push(z);
      S.endPosition = P.position + 1, At(P, !0, N), U = P.input.charCodeAt(P.position), U === 44 ? (F = !0, U = P.input.charCodeAt(++P.position)) : F = !1;
    }
    qe(P, "unexpected end of the stream within a flow collection");
  }
  function Yt(P, N) {
    var F, T, C = d, S = !1, h = N, k = 0, R = !1, j, A;
    if (A = P.input.charCodeAt(P.position), A === 124)
      T = !1;
    else if (A === 62)
      T = !0;
    else
      return !1;
    var I = e.newScalar();
    for (P.kind = "scalar", P.result = I, I.startPosition = P.position; A !== 0; )
      if (A = P.input.charCodeAt(++P.position), A === 43 || A === 45)
        d === C ? C = A === 43 ? p : f : qe(P, "repeat of a chomping mode identifier");
      else if ((j = Q(A)) >= 0)
        j === 0 ? qe(P, "bad explicit indentation width of a block scalar; it cannot be less than one") : S ? qe(P, "repeat of an indentation width identifier") : (h = N + j - 1, S = !0);
      else
        break;
    if (E(A)) {
      do
        A = P.input.charCodeAt(++P.position);
      while (E(A));
      A === 35 && (Ze(P), A = P.input.charCodeAt(P.position));
    }
    for (; A !== 0; ) {
      for (Ue(P), P.lineIndent = 0, A = P.input.charCodeAt(P.position); (!S || P.lineIndent < h) && A === 32; )
        P.lineIndent++, A = P.input.charCodeAt(++P.position);
      if (!S && P.lineIndent > h && (h = P.lineIndent), _(A)) {
        k++;
        continue;
      }
      if (P.lineIndent < h) {
        C === p ? I.value += t.repeat(`
`, k) : C === d && S && (I.value += `
`);
        break;
      }
      for (T ? E(A) ? (R = !0, I.value += t.repeat(`
`, k + 1)) : R ? (R = !1, I.value += t.repeat(`
`, k + 1)) : k === 0 ? S && (I.value += " ") : I.value += t.repeat(`
`, k) : S && (I.value += t.repeat(`
`, k + 1)), S = !0, k = 0, F = P.position; !_(A) && A !== 0; )
        A = P.input.charCodeAt(++P.position);
      ve(P, F, P.position, !1);
    }
    I.endPosition = P.position;
    for (var z = P.position - 1; ; ) {
      var H = P.input[z];
      if (H == "\r" || H == `
` || H != " " && H != "	")
        break;
      z--;
    }
    return I.endPosition = z, I.rawValue = P.input.substring(I.startPosition, I.endPosition), !0;
  }
  function ye(P, N) {
    var F, T = P.tag, C = P.anchor, S = e.newItems(), h, k = !1, R;
    for (P.anchor !== null && (S.anchorId = P.anchor, P.anchorMap[P.anchor] = S), S.startPosition = P.position, R = P.input.charCodeAt(P.position); R !== 0 && !(R !== 45 || (h = P.input.charCodeAt(P.position + 1), !O(h))); ) {
      if (k = !0, P.position++, At(P, !0, -1) && P.lineIndent <= N) {
        S.items.push(null), R = P.input.charCodeAt(P.position);
        continue;
      }
      if (F = P.line, $(P, N, s, !1, !0), P.result && (P.result.parent = S, S.items.push(P.result)), At(P, !0, -1), R = P.input.charCodeAt(P.position), (P.line === F || P.lineIndent > N) && R !== 0)
        qe(P, "bad indentation of a sequence entry");
      else if (P.lineIndent < N)
        break;
    }
    return S.endPosition = P.position, k ? (P.tag = T, P.anchor = C, P.kind = "sequence", P.result = S, S.endPosition = P.position, !0) : !1;
  }
  function W(P, N, F) {
    var T, C, S, h = P.tag, k = P.anchor, R = e.newMap(), j = null, A = null, I = null, z = !1, H = !1, K;
    for (R.startPosition = P.position, P.anchor !== null && (R.anchorId = P.anchor, P.anchorMap[P.anchor] = R), K = P.input.charCodeAt(P.position); K !== 0; ) {
      if (T = P.input.charCodeAt(P.position + 1), S = P.line, (K === 63 || K === 58) && O(T))
        K === 63 ? (z && (Ae(P, R, j, A, null), j = A = I = null), H = !0, z = !0, C = !0) : z ? (z = !1, C = !0) : qe(P, "incomplete explicit mapping pair; a key node is missed"), P.position += 1, K = T;
      else if ($(P, F, u, !1, !0))
        if (P.line === S) {
          for (K = P.input.charCodeAt(P.position); E(K); )
            K = P.input.charCodeAt(++P.position);
          if (K === 58)
            K = P.input.charCodeAt(++P.position), O(K) || qe(P, "a whitespace character is expected after the key-value separator within a block mapping"), z && (Ae(P, R, j, A, null), j = A = I = null), H = !0, z = !1, C = !1, j = P.tag, A = P.result;
          else {
            if (P.position == P.lineStart && He(P))
              break;
            if (H)
              qe(P, "can not read an implicit mapping pair; a colon is missed");
            else
              return P.tag = h, P.anchor = k, !0;
          }
        } else if (H) {
          for (qe(P, "can not read a block mapping entry; a multiline key may not be an implicit key"); P.position > 0; )
            if (K = P.input.charCodeAt(--P.position), _(K)) {
              P.position++;
              break;
            }
        } else
          return P.tag = h, P.anchor = k, !0;
      else
        break;
      if ((P.line === S || P.lineIndent > N) && ($(P, N, l, !0, C) && (z ? A = P.result : I = P.result), z || (Ae(P, R, j, A, I), j = A = I = null), At(P, !0, -1), K = P.input.charCodeAt(P.position)), P.lineIndent > N && K !== 0)
        qe(P, "bad indentation of a mapping entry");
      else if (P.lineIndent < N)
        break;
    }
    return z && Ae(P, R, j, A, null), H && (P.tag = h, P.anchor = k, P.kind = "mapping", P.result = R), H;
  }
  function Y(P) {
    var N, F = !1, T = !1, C, S, h;
    if (h = P.input.charCodeAt(P.position), h !== 33)
      return !1;
    if (P.tag !== null && qe(P, "duplication of a tag property"), h = P.input.charCodeAt(++P.position), h === 60 ? (F = !0, h = P.input.charCodeAt(++P.position)) : h === 33 ? (T = !0, C = "!!", h = P.input.charCodeAt(++P.position)) : C = "!", N = P.position, F) {
      do
        h = P.input.charCodeAt(++P.position);
      while (h !== 0 && h !== 62);
      P.position < P.length ? (S = P.input.slice(N, P.position), h = P.input.charCodeAt(++P.position)) : qe(P, "unexpected end of the stream within a verbatim tag");
    } else {
      for (; h !== 0 && !O(h); )
        h === 33 && (T ? qe(P, "tag suffix cannot contain exclamation marks") : (C = P.input.slice(N - 1, P.position + 1), y.test(C) || qe(P, "named tag handle cannot contain such characters"), T = !0, N = P.position + 1)), h = P.input.charCodeAt(++P.position);
      S = P.input.slice(N, P.position), w.test(S) && qe(P, "tag suffix cannot contain flow indicator characters");
    }
    return S && !v.test(S) && qe(P, "tag name cannot contain such characters: " + S), F ? P.tag = S : o.call(P.tagMap, C) ? P.tag = P.tagMap[C] + S : C === "!" ? P.tag = "!" + S : C === "!!" ? P.tag = "tag:yaml.org,2002:" + S : qe(P, 'undeclared tag handle "' + C + '"'), !0;
  }
  function ie(P) {
    var N, F;
    if (F = P.input.charCodeAt(P.position), F !== 38)
      return !1;
    for (P.anchor !== null && qe(P, "duplication of an anchor property"), F = P.input.charCodeAt(++P.position), N = P.position; F !== 0 && !O(F) && !M(F); )
      F = P.input.charCodeAt(++P.position);
    return P.position === N && qe(P, "name of an anchor node must contain at least one character"), P.anchor = P.input.slice(N, P.position), !0;
  }
  function Te(P) {
    var N, F;
    P.length, P.input;
    var T;
    if (T = P.input.charCodeAt(P.position), T !== 42)
      return !1;
    for (T = P.input.charCodeAt(++P.position), N = P.position; T !== 0 && !O(T) && !M(T); )
      T = P.input.charCodeAt(++P.position);
    return P.position <= N && (qe(P, "name of an alias node must contain at least one character"), P.position = N + 1), F = P.input.slice(N, P.position), P.anchorMap.hasOwnProperty(F) || (qe(P, 'unidentified alias "' + F + '"'), P.position <= N && (P.position = N + 1)), P.result = e.newAnchorRef(F, N, P.position, P.anchorMap[F]), At(P, !0, -1), !0;
  }
  function $(P, N, F, T, C) {
    var S, h, k, R = 1, j = !1, A = !1, I, z, H, K, U;
    P.tag = null, P.anchor = null, P.kind = null, P.result = null, S = h = k = l === F || s === F, T && At(P, !0, -1) && (j = !0, P.lineIndent > N ? R = 1 : P.lineIndent === N ? R = 0 : P.lineIndent < N && (R = -1));
    let D = P.position;
    if (P.position - P.lineStart, R === 1)
      for (; Y(P) || ie(P); )
        At(P, !0, -1) ? (j = !0, k = S, P.lineIndent > N ? R = 1 : P.lineIndent === N ? R = 0 : P.lineIndent < N && (R = -1)) : k = !1;
    if (k && (k = j || C), (R === 1 || l === F) && (c === F || u === F ? K = N : K = N + 1, U = P.position - P.lineStart, R === 1 ? k && (ye(P, U) || W(P, U, K)) || Rt(P, K) ? A = !0 : (h && Yt(P, K) || Xe(P, K) || ze(P, K) ? A = !0 : Te(P) ? (A = !0, (P.tag !== null || P.anchor !== null) && qe(P, "alias node should not have any properties")) : Fe(P, K, c === F) && (A = !0, P.tag === null && (P.tag = "?")), P.anchor !== null && (P.anchorMap[P.anchor] = P.result, P.result.anchorId = P.anchor)) : R === 0 && (A = k && ye(P, U))), P.tag !== null && P.tag !== "!")
      if (P.tag == "!include")
        P.result || (P.result = e.newScalar(), P.result.startPosition = P.position, P.result.endPosition = P.position, qe(P, "!include without value")), P.result.kind = e.Kind.INCLUDE_REF;
      else if (P.tag === "?")
        for (I = 0, z = P.implicitTypes.length; I < z; I += 1) {
          H = P.implicitTypes[I];
          var B = P.result.value;
          if (H.resolve(B)) {
            P.result.valueObject = H.construct(P.result.value), P.tag = H.tag, P.anchor !== null && (P.result.anchorId = P.anchor, P.anchorMap[P.anchor] = P.result);
            break;
          }
        }
      else o.call(P.typeMap, P.tag) ? (H = P.typeMap[P.tag], P.result !== null && H.kind !== P.kind && qe(P, "unacceptable node kind for !<" + P.tag + '> tag; it should be "' + H.kind + '", not "' + P.kind + '"'), H.resolve(P.result) ? (P.result = H.construct(P.result), P.anchor !== null && (P.result.anchorId = P.anchor, P.anchorMap[P.anchor] = P.result)) : qe(P, "cannot resolve a node with !<" + P.tag + "> explicit tag")) : Me(P, D, "unknown tag <" + P.tag + ">", !1, !0);
    return P.tag !== null || P.anchor !== null || A;
  }
  function _e(P) {
    var N = P.position, F, T, C, S = !1, h;
    for (P.version = null, P.checkLineBreaks = P.legacy, P.tagMap = {}, P.anchorMap = {}, P.comments = []; (h = P.input.charCodeAt(P.position)) !== 0 && (At(P, !0, -1), h = P.input.charCodeAt(P.position), !(P.lineIndent > 0 || h !== 37)); ) {
      for (S = !0, h = P.input.charCodeAt(++P.position), F = P.position; h !== 0 && !O(h); )
        h = P.input.charCodeAt(++P.position);
      for (T = P.input.slice(F, P.position), C = [], T.length < 1 && qe(P, "directive name must not be less than one character in length"); h !== 0; ) {
        for (; E(h); )
          h = P.input.charCodeAt(++P.position);
        if (h === 35) {
          Ze(P), h = P.input.charCodeAt(P.position);
          break;
        }
        if (_(h))
          break;
        for (F = P.position; h !== 0 && !O(h); )
          h = P.input.charCodeAt(++P.position);
        C.push(P.input.slice(F, P.position));
      }
      h !== 0 && Ue(P), o.call(xe, T) ? xe[T](P, T, C) : (Ve(P, 'unknown document directive "' + T + '"'), P.position++);
    }
    if (At(P, !0, -1), P.lineIndent === 0 && P.input.charCodeAt(P.position) === 45 && P.input.charCodeAt(P.position + 1) === 45 && P.input.charCodeAt(P.position + 2) === 45 ? (P.position += 3, At(P, !0, -1)) : S && qe(P, "directives end mark is expected"), $(P, P.lineIndent - 1, l, !1, !0), At(P, !0, -1), P.checkLineBreaks && b.test(P.input.slice(N, P.position)) && Ve(P, "non-ASCII line breaks are interpreted as content"), P.result.comments = P.comments, P.documents.push(P.result), P.position === P.lineStart && He(P)) {
      P.input.charCodeAt(P.position) === 46 && (P.position += 3, At(P, !0, -1));
      return;
    }
    if (P.position < P.length - 1)
      qe(P, "end of the stream or a document separator is expected");
    else
      return;
  }
  function Le(P, N) {
    P = String(P), N = N || {};
    let F = P.length;
    F !== 0 && (P.charCodeAt(F - 1) !== 10 && P.charCodeAt(F - 1) !== 13 && (P += `
`), P.charCodeAt(0) === 65279 && (P = P.slice(1)));
    var T = new De(P, N);
    for (T.input += "\0"; T.input.charCodeAt(T.position) === 32; )
      T.lineIndent += 1, T.position += 1;
    for (; T.position < T.length - 1; ) {
      var C = T.position;
      if (_e(T), T.position <= C)
        for (; T.position < T.length - 1; T.position++) {
          var S = T.input.charAt(T.position);
          if (S == `
`)
            break;
        }
    }
    let h = T.documents, k = h.length;
    k > 0 && (h[k - 1].endPosition = F);
    for (let R of h)
      R.errors = T.errors, R.startPosition > R.endPosition && (R.startPosition = R.endPosition);
    return h;
  }
  function et(P, N, F = {}) {
    var T = Le(P, F), C, S;
    for (C = 0, S = T.length; C < S; C += 1)
      N(T[C]);
  }
  za.loadAll = et;
  function Ge(P, N = {}) {
    var F = Le(P, N);
    if (F.length !== 0) {
      if (F.length === 1)
        return F[0];
      var T = new n("expected a single document in the stream, but found more");
      return T.mark = new r("", "", 0, 0, 0), T.mark.position = F[0].endPosition, F[0].errors.push(T), F[0];
    }
  }
  za.load = Ge;
  function $t(P, N, F = {}) {
    et(P, N, t.extend({ schema: i }, F));
  }
  za.safeLoadAll = $t;
  function Be(P, N = {}) {
    return Ge(P, t.extend({ schema: i }, N));
  }
  return za.safeLoad = Be, za.loadAll = et, za.load = Ge, za.safeLoadAll = $t, za.safeLoad = Be, za;
}
var pl = {}, r4;
function HB() {
  if (r4) return pl;
  r4 = 1, Object.defineProperty(pl, "__esModule", { value: !0 });
  var e = Cc(), t = Uf(), n = tA(), r = R2(), i = Object.prototype.toString, a = Object.prototype.hasOwnProperty, o = 9, c = 10, u = 13, s = 32, l = 33, d = 34, f = 35, p = 37, g = 38, b = 39, w = 42, y = 44, v = 45, _ = 58, E = 61, O = 62, M = 63, L = 64, Z = 91, Q = 93, ae = 96, re = 123, X = 124, de = 125, Ce = {};
  Ce[0] = "\\0", Ce[7] = "\\a", Ce[8] = "\\b", Ce[9] = "\\t", Ce[10] = "\\n", Ce[11] = "\\v", Ce[12] = "\\f", Ce[13] = "\\r", Ce[27] = "\\e", Ce[34] = '\\"', Ce[92] = "\\\\", Ce[133] = "\\N", Ce[160] = "\\_", Ce[8232] = "\\L", Ce[8233] = "\\P";
  var J = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ];
  function ne(h, k) {
    var R, j, A, I, z, H, K;
    if (k === null)
      return {};
    for (R = {}, j = Object.keys(k), A = 0, I = j.length; A < I; A += 1)
      z = j[A], H = String(k[z]), z.slice(0, 2) === "!!" && (z = "tag:yaml.org,2002:" + z.slice(2)), K = h.compiledTypeMap.fallback[z], K && a.call(K.styleAliases, H) && (H = K.styleAliases[H]), R[z] = H;
    return R;
  }
  function De(h) {
    var k, R, j;
    if (k = h.toString(16).toUpperCase(), h <= 255)
      R = "x", j = 2;
    else if (h <= 65535)
      R = "u", j = 4;
    else if (h <= 4294967295)
      R = "U", j = 8;
    else
      throw new t("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + R + e.repeat("0", j - k.length) + k;
  }
  function je(h) {
    this.schema = h.schema || n, this.indent = Math.max(1, h.indent || 2), this.noArrayIndent = h.noArrayIndent || !1, this.skipInvalid = h.skipInvalid || !1, this.flowLevel = e.isNothing(h.flowLevel) ? -1 : h.flowLevel, this.styleMap = ne(this.schema, h.styles || null), this.sortKeys = h.sortKeys || !1, this.lineWidth = h.lineWidth || 80, this.noRefs = h.noRefs || !1, this.noCompatMode = h.noCompatMode || !1, this.condenseFlow = h.condenseFlow || !1, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.comments = h.comments || {}, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
  }
  function Me(h, k) {
    for (var R = e.repeat(" ", k), j = 0, A = -1, I = "", z, H = h.length; j < H; )
      A = h.indexOf(`
`, j), A === -1 ? (z = h.slice(j), j = H) : (z = h.slice(j, A + 1), j = A + 1), z.length && z !== `
` && (I += R), I += z;
    return I;
  }
  function qe(h, k) {
    return `
` + e.repeat(" ", h.indent * k);
  }
  function Ve(h, k) {
    var R, j, A;
    for (R = 0, j = h.implicitTypes.length; R < j; R += 1)
      if (A = h.implicitTypes[R], A.resolve(k))
        return !0;
    return !1;
  }
  function xe(h) {
    return h === s || h === o;
  }
  function ve(h) {
    return 32 <= h && h <= 126 || 161 <= h && h <= 55295 && h !== 8232 && h !== 8233 || 57344 <= h && h <= 65533 && h !== 65279 || 65536 <= h && h <= 1114111;
  }
  function Ae(h) {
    return ve(h) && !xe(h) && h !== 65279 && h !== u && h !== c;
  }
  function Ue(h, k) {
    return ve(h) && h !== 65279 && h !== y && h !== Z && h !== Q && h !== re && h !== de && h !== _ && (h !== f || k && Ae(k));
  }
  function qt(h) {
    return ve(h) && h !== 65279 && !xe(h) && h !== v && h !== M && h !== _ && h !== y && h !== Z && h !== Q && h !== re && h !== de && h !== f && h !== g && h !== w && h !== l && h !== X && h !== E && h !== O && h !== b && h !== d && h !== p && h !== L && h !== ae;
  }
  function Ze(h) {
    var k = /^\n* /;
    return k.test(h);
  }
  var At = 1, He = 2, Dt = 3, Fe = 4, Xe = 5;
  function ze(h, k, R, j, A) {
    var I, z, H, K = !1, U = !1, D = j !== -1, B = -1, ee = qt(h.charCodeAt(0)) && !xe(h.charCodeAt(h.length - 1));
    if (k)
      for (I = 0; I < h.length; I++) {
        if (z = h.charCodeAt(I), !ve(z))
          return Xe;
        H = I > 0 ? h.charCodeAt(I - 1) : null, ee = ee && Ue(z, H);
      }
    else {
      for (I = 0; I < h.length; I++) {
        if (z = h.charCodeAt(I), z === c)
          K = !0, D && (U = U || I - B - 1 > j && h[B + 1] !== " ", B = I);
        else if (!ve(z))
          return Xe;
        H = I > 0 ? h.charCodeAt(I - 1) : null, ee = ee && Ue(z, H);
      }
      U = U || D && I - B - 1 > j && h[B + 1] !== " ";
    }
    return !K && !U ? ee && !A(h) ? At : He : R > 9 && Ze(h) ? Xe : U ? Fe : Dt;
  }
  function Rt(h, k, R, j, A) {
    var I = (function() {
      if (k.length === 0)
        return "''";
      if (!h.noCompatMode && J.indexOf(k) !== -1)
        return "'" + k + "'";
      var z = h.indent * Math.max(1, R), H = h.lineWidth === -1 ? -1 : Math.max(Math.min(h.lineWidth, 40), h.lineWidth - z), K = j || h.flowLevel > -1 && R >= h.flowLevel;
      function U(D) {
        return Ve(h, D);
      }
      switch (ze(k, K, h.indent, H, U)) {
        case At:
          return k;
        case He:
          return "'" + k.replace(/'/g, "''") + "'";
        case Dt:
          return "|" + Yt(k, h.indent) + ye(Me(k, z));
        case Fe:
          return ">" + Yt(k, h.indent) + ye(Me(W(k, H), z));
        case Xe:
          return '"' + ie(k) + '"';
        default:
          throw new t("impossible error: invalid scalar style");
      }
    })();
    if (!j) {
      let H = new S(h, A).write(R, "before-eol");
      H !== "" && (I += " " + H);
    }
    h.dump = I;
  }
  function Yt(h, k) {
    var R = Ze(h) ? String(k) : "", j = h[h.length - 1] === `
`, A = j && (h[h.length - 2] === `
` || h === `
`), I = A ? "+" : j ? "" : "-";
    return R + I + `
`;
  }
  function ye(h) {
    return h[h.length - 1] === `
` ? h.slice(0, -1) : h;
  }
  function W(h, k) {
    for (var R = /(\n+)([^\n]*)/g, j = (function() {
      var U = h.indexOf(`
`);
      return U = U !== -1 ? U : h.length, R.lastIndex = U, Y(h.slice(0, U), k);
    })(), A = h[0] === `
` || h[0] === " ", I, z; z = R.exec(h); ) {
      var H = z[1], K = z[2];
      I = K[0] === " ", j += H + (!A && !I && K !== "" ? `
` : "") + Y(K, k), A = I;
    }
    return j;
  }
  function Y(h, k) {
    if (h === "" || h[0] === " ")
      return h;
    for (var R = / [^ ]/g, j, A = 0, I, z = 0, H = 0, K = ""; j = R.exec(h); )
      H = j.index, H - A > k && (I = z > A ? z : H, K += `
` + h.slice(A, I), A = I + 1), z = H;
    return K += `
`, h.length - A > k && z > A ? K += h.slice(A, z) + `
` + h.slice(z + 1) : K += h.slice(A), K.slice(1);
  }
  function ie(h) {
    for (var k = "", R, j, A, I = 0; I < h.length; I++) {
      if (R = h.charCodeAt(I), R >= 55296 && R <= 56319 && (j = h.charCodeAt(I + 1), j >= 56320 && j <= 57343)) {
        k += De((R - 55296) * 1024 + j - 56320 + 65536), I++;
        continue;
      }
      A = Ce[R], k += !A && ve(R) ? h[I] : A || De(R);
    }
    return k;
  }
  function Te(h, k, R, j) {
    var A = "", I = h.tag, z, H;
    for (z = 0, H = R.length; z < H; z += 1)
      Ge(h, k, R[z], !1, !1, !1, j) && (z !== 0 && (A += "," + (h.condenseFlow ? "" : " ")), A += h.dump);
    h.tag = I, h.dump = "[" + A + "]";
  }
  function $(h, k, R, j, A) {
    var I = "", z = h.tag, H, K, U = new S(h, A);
    for (I += U.write(k, "before-eol"), I += U.write(k, "leading"), H = 0, K = R.length; H < K; H += 1)
      I += U.writeAt(String(H), k, "before"), Ge(h, k + 1, R[H], !0, !0, !1, `${A}/${H}`) && ((!j || H !== 0) && (I += qe(h, k)), h.dump && c === h.dump.charCodeAt(0) ? I += "-" : I += "- ", I += h.dump), I += U.writeAt(String(H), k, "after");
    h.tag = z, h.dump = I || "[]", h.dump += U.write(k, "trailing");
  }
  function _e(h, k, R, j) {
    var A = "", I = h.tag, z = Object.keys(R), H, K, U, D, B;
    for (H = 0, K = z.length; H < K; H += 1)
      B = "", H !== 0 && (B += ", "), h.condenseFlow && (B += '"'), U = z[H], D = R[U], Ge(h, k, U, !1, !1, !1, j) && (h.dump.length > 1024 && (B += "? "), B += h.dump + (h.condenseFlow ? '"' : "") + ":" + (h.condenseFlow ? "" : " "), Ge(h, k, D, !1, !1, !1, j) && (B += h.dump, A += B));
    h.tag = I, h.dump = "{" + A + "}";
  }
  function Le(h, k, R, j, A) {
    var I = "", z = h.tag, H = Object.keys(R), K, U, D, B, ee, V;
    if (h.sortKeys === !0)
      H.sort();
    else if (typeof h.sortKeys == "function")
      H.sort(h.sortKeys);
    else if (h.sortKeys)
      throw new t("sortKeys must be a boolean or a function");
    var te = new S(h, A);
    for (I += te.write(k, "before-eol"), I += te.write(k, "leading"), K = 0, U = H.length; K < U; K += 1)
      V = "", (!j || K !== 0) && (V += qe(h, k)), D = H[K], B = R[D], I += te.writeAt(D, k, "before"), Ge(h, k + 1, D, !0, !0, !0, A) && (ee = h.tag !== null && h.tag !== "?" || h.dump && h.dump.length > 1024, ee && (h.dump && c === h.dump.charCodeAt(0) ? V += "?" : V += "? "), V += h.dump, ee && (V += qe(h, k)), Ge(h, k + 1, B, !0, ee, !1, `${A}/${C(D)}`) && (h.dump && c === h.dump.charCodeAt(0) ? V += ":" : V += ": ", V += h.dump, I += V, I += te.writeAt(k, D, "after")));
    h.tag = z, h.dump = I || "{}", h.dump += te.write(k, "trailing");
  }
  function et(h, k, R) {
    var j, A, I, z, H, K;
    for (A = R ? h.explicitTypes : h.implicitTypes, I = 0, z = A.length; I < z; I += 1)
      if (H = A[I], (H.instanceOf || H.predicate) && (!H.instanceOf || typeof k == "object" && k instanceof H.instanceOf) && (!H.predicate || H.predicate(k))) {
        if (h.tag = R ? H.tag : "?", H.represent) {
          if (K = h.styleMap[H.tag] || H.defaultStyle, i.call(H.represent) === "[object Function]")
            j = H.represent(k, K);
          else if (a.call(H.represent, K))
            j = H.represent[K](k, K);
          else
            throw new t("!<" + H.tag + '> tag resolver accepts not "' + K + '" style');
          h.dump = j;
        }
        return !0;
      }
    return !1;
  }
  function Ge(h, k, R, j, A, I, z) {
    h.tag = null, h.dump = R, et(h, R, !1) || et(h, R, !0);
    var H = i.call(h.dump);
    j && (j = h.flowLevel < 0 || h.flowLevel > k), (h.tag !== null && h.tag !== "?" || h.indent !== 2 && k > 0) && (A = !1);
    var K = H === "[object Object]" || H === "[object Array]", U, D;
    if (K && (U = h.duplicates.indexOf(R), D = U !== -1), (h.tag !== null && h.tag !== "?" || D || h.indent !== 2 && k > 0) && (A = !1), D && h.usedDuplicates[U])
      h.dump = "*ref_" + U;
    else {
      if (K && D && !h.usedDuplicates[U] && (h.usedDuplicates[U] = !0), H === "[object Object]")
        j && Object.keys(h.dump).length !== 0 ? (Le(h, k, h.dump, A, z), D && (h.dump = "&ref_" + U + h.dump)) : (_e(h, k, h.dump, z), D && (h.dump = "&ref_" + U + " " + h.dump));
      else if (H === "[object Array]") {
        var B = h.noArrayIndent && k > 0 ? k - 1 : k;
        j && h.dump.length !== 0 ? ($(h, B, h.dump, A, z), D && (h.dump = "&ref_" + U + h.dump)) : (Te(h, B, h.dump, z), D && (h.dump = "&ref_" + U + " " + h.dump));
      } else if (H === "[object String]")
        h.tag !== "?" && Rt(h, h.dump, k, I, z);
      else {
        if (h.skipInvalid)
          return !1;
        throw new t("unacceptable kind of an object to dump " + H);
      }
      h.tag !== null && h.tag !== "?" && (h.dump = "!<" + h.tag + "> " + h.dump);
    }
    return !0;
  }
  function $t(h, k) {
    var R = [], j = [], A, I;
    for (Be(h, R, j), A = 0, I = j.length; A < I; A += 1)
      k.duplicates.push(R[j[A]]);
    k.usedDuplicates = new Array(I);
  }
  function Be(h, k, R) {
    var j, A, I;
    if (h !== null && typeof h == "object")
      if (A = k.indexOf(h), A !== -1)
        R.indexOf(A) === -1 && R.push(A);
      else if (k.push(h), Array.isArray(h))
        for (A = 0, I = h.length; A < I; A += 1)
          Be(h[A], k, R);
      else
        for (j = Object.keys(h), A = 0, I = j.length; A < I; A += 1)
          Be(h[j[A]], k, R);
  }
  function P(h, k) {
    k = k || {};
    var R = new je(k);
    return k.noRefs || $t(h, R), Ge(R, 0, h, !0, !0, !1, "#") ? R.dump + `
` : "";
  }
  pl.dump = P;
  function N(h, k) {
    return P(h, e.extend({ schema: r }, k));
  }
  pl.safeDump = N;
  const F = /~/g, T = /\//g;
  function C(h) {
    return h.replace(F, "~0").replace(T, "~1");
  }
  function S(h, k) {
    if (this.state = h, this.comments = {
      "before-eol": /* @__PURE__ */ new Set(),
      leading: /* @__PURE__ */ new Set(),
      trailing: /* @__PURE__ */ new Set(),
      before: /* @__PURE__ */ new Map(),
      after: /* @__PURE__ */ new Map()
    }, this.written = /* @__PURE__ */ new WeakSet(), h.comments !== null && k in h.comments)
      for (let R of h.comments[k])
        switch (R.placement) {
          case "before-eol":
          case "leading":
          case "trailing":
            this.comments[R.placement].add(R);
            break;
          case "between":
            let j = this.comments.before.get(R.between[1]);
            j ? j.add(R) : this.comments.before.set(R.between[1], /* @__PURE__ */ new Set([R]));
            let A = this.comments.after.get(R.between[0]);
            A ? A.add(R) : this.comments.after.set(R.between[0], /* @__PURE__ */ new Set([R]));
            break;
        }
  }
  return S.prototype.write = function(h, k) {
    let R = "";
    for (let j of this.comments[k])
      R += this._write(j, h);
    return R;
  }, S.prototype.writeAt = function(h, k, R) {
    let j = "", A = this.comments[R].get(h);
    if (A)
      for (let I of A)
        j += this._write(I, k);
    return j;
  }, S.prototype._write = function(h, k) {
    if (this.written.has(h))
      return "";
    this.written.add(h);
    let R = "#" + h.value;
    return h.placement === "before-eol" ? R : k === 0 && h.placement === "leading" ? R + `
` : qe(this.state, k) + R;
  }, pl;
}
var S5 = {}, n4;
function zB() {
  return n4 || (n4 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    function t(u) {
      if (["true", "True", "TRUE"].lastIndexOf(u) >= 0)
        return !0;
      if (["false", "False", "FALSE"].lastIndexOf(u) >= 0)
        return !1;
      throw `Invalid boolean "${u}"`;
    }
    e.parseYamlBoolean = t;
    function n(u) {
      return u.lastIndexOf("0o", 0) === 0 ? parseInt(u.substring(2), 8) : parseInt(u);
    }
    function r(u) {
      const s = n(u);
      if (Number.isNaN(s))
        throw `Invalid integer "${u}"`;
      return s;
    }
    e.parseYamlInteger = r;
    function i(u) {
      const s = r(u);
      return s > Number.MAX_SAFE_INTEGER && u.lastIndexOf("0o", 0) === -1 ? BigInt(u) : s;
    }
    e.parseYamlBigInteger = i;
    function a(u) {
      if ([".nan", ".NaN", ".NAN"].lastIndexOf(u) >= 0)
        return NaN;
      const l = /^([-+])?(?:\.inf|\.Inf|\.INF)$/.exec(u);
      if (l)
        return l[1] === "-" ? -1 / 0 : 1 / 0;
      const d = parseFloat(u);
      if (!isNaN(d))
        return d;
      throw `Invalid float "${u}"`;
    }
    e.parseYamlFloat = a;
    var o;
    (function(u) {
      u[u.null = 0] = "null", u[u.bool = 1] = "bool", u[u.int = 2] = "int", u[u.float = 3] = "float", u[u.string = 4] = "string";
    })(o = e.ScalarType || (e.ScalarType = {}));
    function c(u) {
      if (u === void 0)
        return o.null;
      if (u.doubleQuoted || !u.plainScalar || u.singleQuoted)
        return o.string;
      const s = u.value;
      if (["null", "Null", "NULL", "~", ""].indexOf(s) >= 0 || s == null)
        return o.null;
      if (["true", "True", "TRUE", "false", "False", "FALSE"].indexOf(s) >= 0)
        return o.bool;
      const l = /^[-+]?[0-9]+$/, d = /^0o[0-7]+$/, f = /^0x[0-9a-fA-F]+$/;
      if (l.test(s) || d.test(s) || f.test(s))
        return o.int;
      const p = /^[-+]?(\.[0-9]+|[0-9]+(\.[0-9]*)?)([eE][-+]?[0-9]+)?$/, g = /^[-+]?(\.inf|\.Inf|\.INF)$/;
      return p.test(s) || g.test(s) || [".nan", ".NaN", ".NAN"].indexOf(s) >= 0 ? o.float : o.string;
    }
    e.determineScalarType = c;
  })(S5)), S5;
}
var i4;
function I2() {
  return i4 || (i4 = 1, (function(e) {
    function t(i) {
      for (var a in i) e.hasOwnProperty(a) || (e[a] = i[a]);
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var n = UB();
    e.load = n.load, e.loadAll = n.loadAll, e.safeLoad = n.safeLoad, e.safeLoadAll = n.safeLoadAll;
    var r = HB();
    e.dump = r.dump, e.safeDump = r.safeDump, e.YAMLException = Uf(), t(H0()), t(zB());
  })(Qh)), Qh;
}
var a4;
function kc() {
  if (a4) return ll;
  a4 = 1, Object.defineProperty(ll, "__esModule", { value: !0 });
  const e = I2();
  return ll.Kind = e.Kind, ll.ScalarType = e.ScalarType, ll;
}
var sd = {}, o4;
function zf() {
  return o4 || (o4 = 1, Object.defineProperty(sd, "__esModule", { value: !0 }), sd.isObject = (e) => e !== null && typeof e == "object"), sd;
}
var s4;
function j2() {
  if (s4) return nd;
  s4 = 1, Object.defineProperty(nd, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ kc(), t = /* @__PURE__ */ zf();
  function n(r) {
    const i = [];
    let a = r;
    for (; r; ) {
      switch (r.kind) {
        case e.Kind.SCALAR:
          i.unshift(r.value);
          break;
        case e.Kind.MAPPING:
          a !== r.key && (i.length > 0 && t.isObject(r.value) && r.value.value === i[0] ? i[0] = r.key.value : i.unshift(r.key.value));
          break;
        case e.Kind.SEQ:
          if (a) {
            const o = r.items.indexOf(a);
            a.kind === e.Kind.SCALAR ? i[0] = o : o !== -1 && i.unshift(o);
          }
          break;
      }
      a = r, r = r.parent;
    }
    return i;
  }
  return nd.buildJsonPath = n, nd;
}
var C5 = {}, u4;
function rA() {
  return u4 || (u4 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = /* @__PURE__ */ kc(), n = /* @__PURE__ */ zf();
    e.dereferenceAnchor = (i, a) => {
      if (!n.isObject(i))
        return i;
      if (i.kind === t.Kind.ANCHOR_REF && i.referencesAnchor === a)
        return null;
      switch (i.kind) {
        case t.Kind.MAP:
          return Object.assign({}, i, { mappings: i.mappings.map((o) => e.dereferenceAnchor(o, a)) });
        case t.Kind.SEQ:
          return Object.assign({}, i, { items: i.items.map((o) => e.dereferenceAnchor(o, a)) });
        case t.Kind.MAPPING:
          return Object.assign({}, i, { value: e.dereferenceAnchor(i.value, a) });
        case t.Kind.SCALAR:
          return i;
        case t.Kind.ANCHOR_REF:
          return n.isObject(i.value) && r(i) ? null : i;
        default:
          return i;
      }
    };
    const r = (i) => {
      const { referencesAnchor: a } = i;
      let o = i;
      for (; o = o.parent; )
        if ("anchorId" in o && o.anchorId === a)
          return !0;
      return !1;
    };
  })(C5)), C5;
}
var ud = {}, c4;
function VB() {
  if (c4) return ud;
  c4 = 1, Object.defineProperty(ud, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ j2(), t = /* @__PURE__ */ kc(), n = /* @__PURE__ */ zf();
  ud.getJsonPathForPosition = ({ ast: o, lineMap: c }, { line: u, character: s }) => {
    if (u >= c.length || s >= c[u])
      return;
    const l = u === 0 ? 0 : c[u - 1] + 1, d = a(o, Math.min(c[u] - 1, l + s), u, c);
    if (!n.isObject(d))
      return;
    const f = e.buildJsonPath(d);
    if (f.length !== 0)
      return f;
  };
  function* r(o) {
    switch (o.kind) {
      case t.Kind.MAP:
        if (o.mappings.length !== 0)
          for (const c of o.mappings)
            n.isObject(c) && (yield c);
        break;
      case t.Kind.MAPPING:
        n.isObject(o.key) && (yield o.key), n.isObject(o.value) && (yield o.value);
        break;
      case t.Kind.SEQ:
        if (o.items.length !== 0)
          for (const c of o.items)
            n.isObject(c) && (yield c);
        break;
      case t.Kind.SCALAR:
        yield o;
        break;
    }
  }
  function i(o, c, u) {
    const s = u[c - 1] + 1, l = u[c];
    switch (o.kind) {
      case t.Kind.MAPPING:
        return o.key;
      case t.Kind.MAP:
        if (o.mappings.length !== 0) {
          for (const d of o.mappings)
            if (d.startPosition > s && d.startPosition <= l)
              return i(d, c, u);
        }
        break;
      case t.Kind.SEQ:
        if (o.items.length !== 0) {
          for (const d of o.items)
            if (d !== null && d.startPosition > s && d.startPosition <= l)
              return i(d, c, u);
        }
        break;
    }
    return o;
  }
  function a(o, c, u, s) {
    for (const l of r(o))
      if (l.startPosition <= c && c <= l.endPosition)
        return l.kind === t.Kind.SCALAR ? l : a(l, c, u, s);
    if (s[u - 1] === s[u] - 1)
      return o;
    if (o.startPosition < s[u - 1] && c <= o.endPosition) {
      if (o.kind !== t.Kind.MAPPING)
        return i(o, u, s);
      if (o.value && o.key.endPosition < c)
        return i(o.value, u, s);
    }
    return o;
  }
  return ud;
}
var cd = {}, k5 = {}, l4;
function q2() {
  return l4 || (l4 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.lineForPosition = (t, n, r = 0, i) => {
      if (t === 0 || n.length === 0 || t < n[0])
        return 0;
      typeof i > "u" && (i = n.length);
      const a = Math.floor((i - r) / 2) + r;
      if (t >= n[a] && !n[a + 1])
        return a + 1;
      const o = n[Math.min(a + 1, n.length)];
      return t === n[a] - 1 ? a : t >= n[a] && t <= o ? t === o ? a + 2 : a + 1 : t > n[a] ? e.lineForPosition(t, n, a + 1, i) : e.lineForPosition(t, n, r, a - 1);
    };
  })(k5)), k5;
}
var f4;
function GB() {
  if (f4) return cd;
  f4 = 1, Object.defineProperty(cd, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ q2(), t = /* @__PURE__ */ kc(), n = /* @__PURE__ */ zf();
  cd.getLocationForJsonPath = ({ ast: s, lineMap: l, metadata: d }, f, p = !1) => {
    const g = a(s, f, { closest: p, mergeKeys: d !== void 0 && d.mergeKeys === !0 });
    if (g !== void 0)
      return u(l, {
        start: r(g, l.length > 0 ? l[0] : 0),
        end: i(g)
      });
  };
  function r(s, l) {
    if (s.parent && s.parent.kind === t.Kind.MAPPING) {
      if (s.parent.value === null)
        return s.parent.endPosition;
      if (s.kind !== t.Kind.SCALAR)
        return s.parent.key.endPosition + 1;
    }
    return s.parent === null && l - s.startPosition === 0 ? 0 : s.startPosition;
  }
  function i(s) {
    switch (s.kind) {
      case t.Kind.SEQ:
        const { items: l } = s;
        if (l.length !== 0) {
          const d = l[l.length - 1];
          if (d !== null)
            return i(d);
        }
        break;
      case t.Kind.MAPPING:
        if (s.value !== null)
          return i(s.value);
        break;
      case t.Kind.MAP:
        if (s.value !== null && s.mappings.length !== 0)
          return i(s.mappings[s.mappings.length - 1]);
        break;
      case t.Kind.SCALAR:
        if (s.parent !== null && s.parent.kind === t.Kind.MAPPING && s.parent.value === null)
          return s.parent.endPosition;
        break;
    }
    return s.endPosition;
  }
  function a(s, l, { closest: d, mergeKeys: f }) {
    e: for (const p of l) {
      if (!n.isObject(s))
        return d ? s : void 0;
      switch (s.kind) {
        case t.Kind.MAP:
          const g = o(s.mappings, f);
          for (let b = g.length - 1; b >= 0; b--) {
            const w = g[b];
            if (w.key.value === p) {
              w.value === null ? s = w.key : s = w.value;
              continue e;
            }
          }
          return d ? s : void 0;
        case t.Kind.SEQ:
          for (let b = 0; b < s.items.length; b++)
            if (b === Number(p)) {
              const w = s.items[b];
              if (w === null)
                break;
              s = w;
              continue e;
            }
          return d ? s : void 0;
        default:
          return d ? s : void 0;
      }
    }
    return s;
  }
  function o(s, l) {
    return l ? s.reduce((d, f) => (n.isObject(f) && (f.key.value === "<<" ? d.push(...c(f.value)) : d.push(f)), d), []) : s;
  }
  function c(s) {
    if (!n.isObject(s))
      return [];
    switch (s.kind) {
      case t.Kind.SEQ:
        return s.items.reduceRight((l, d) => (l.push(...c(d)), l), []);
      case t.Kind.MAP:
        return s.mappings;
      case t.Kind.ANCHOR_REF:
        return c(s.value);
      default:
        return [];
    }
  }
  const u = (s, { start: l = 0, end: d = 0 }) => {
    const f = e.lineForPosition(l, s), p = e.lineForPosition(d, s);
    return {
      range: {
        start: {
          line: f,
          character: l - (f === 0 ? 0 : s[f - 1])
        },
        end: {
          line: p,
          character: d - (p === 0 ? 0 : s[p - 1])
        }
      }
    };
  };
  return cd;
}
var ld = {}, fd = {}, uo = {}, p4;
function nA() {
  if (p4) return uo;
  p4 = 1, Object.defineProperty(uo, "__esModule", { value: !0 });
  const t = `__object_order_${Math.floor(Date.now() / 36e5)}__`, n = Symbol.for(t), r = String(n), i = {
    defineProperty(v, _, E) {
      return !Object.prototype.hasOwnProperty.call(v, _) && n in v ? v[n].push(_) : "value" in E && _ === n && E.value.lastIndexOf(n) === -1 && E.value.push(n), Reflect.defineProperty(v, _, E);
    },
    deleteProperty(v, _) {
      const E = Object.prototype.hasOwnProperty.call(v, _), O = Reflect.deleteProperty(v, _);
      if (O && E && n in v) {
        const M = v[n].indexOf(_);
        M !== -1 && v[n].splice(M, 1);
      }
      return O;
    },
    ownKeys(v) {
      return n in v ? v[n] : Reflect.ownKeys(v);
    },
    set(v, _, E) {
      const O = Object.prototype.hasOwnProperty.call(v, _), M = Reflect.set(v, _, E);
      return M && !O && n in v && v[n].push(_), M;
    }
  };
  function a(v, _ = Reflect.ownKeys(v)) {
    w(v);
    const E = new Proxy(v, i);
    return o(E, _), E;
  }
  function o(v, _) {
    return n in v ? (v[n].length = 0, v[n].push(..._), !0) : Reflect.defineProperty(v, n, {
      configurable: !0,
      value: _
    });
  }
  function c(v) {
    return v[n];
  }
  function u(v) {
    const _ = v.slice();
    for (let E = 0; E < _.length; E += 1) {
      const O = _[E];
      p(O) && (_[E] = Array.isArray(O) ? u(O) : s(O, !0));
    }
    return _;
  }
  function s(v, _) {
    w(v, "Invalid target provided");
    const E = { ...v };
    if (n in v && Object.defineProperty(E, r, {
      enumerable: !0,
      value: v[n].filter((O) => O !== n)
    }), _)
      for (const O of Object.keys(v)) {
        if (O === r) continue;
        const M = v[O];
        p(M) && (E[O] = Array.isArray(M) ? u(M) : s(M, !0));
      }
    return E;
  }
  function l(v) {
    for (let _ = 0; _ < v.length; _ += 1) {
      const E = v[_];
      p(E) && (v[_] = Array.isArray(E) ? l(E) : d(E, !0));
    }
    return v;
  }
  function d(v, _) {
    w(v, "Invalid target provided");
    const E = a(
      v,
      r in v ? v[r] : Reflect.ownKeys(v)
    );
    if (delete E[r], _)
      for (const O of Object.keys(v)) {
        const M = v[O];
        p(M) && (v[O] = Array.isArray(M) ? l(M) : d(M, !0));
      }
    return E;
  }
  function f(v) {
    return n in v;
  }
  function p(v) {
    return v !== null && typeof v == "object";
  }
  function g(v) {
    if (!p(v)) return !1;
    if (v[Symbol.toStringTag] !== void 0) {
      const _ = Object.getPrototypeOf(v);
      return _ === null || _ === Object.prototype;
    }
    return b(v) === "Object";
  }
  function b(v) {
    const _ = v[Symbol.toStringTag];
    if (typeof _ == "string")
      return _;
    const E = Reflect.apply(Object.prototype.toString, v, []);
    return E.slice(8, E.length - 1);
  }
  function w(v, _) {
    if (y() && !g(v))
      throw new TypeError(_);
  }
  function y() {
    return typeof gn > "u" || !p(gn) || !p(gn.env) ? !1 : gn.env.NODE_ENV === "development" || gn.env.NODE_ENV === "test";
  }
  return uo.ORDER_KEY_ID = t, uo.default = a, uo.deserialize = d, uo.getOrder = c, uo.isOrderedObject = f, uo.serialize = s, uo.setOrder = o, uo;
}
var A5 = {}, d4;
function WB() {
  return d4 || (d4 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.HttpOperationSecurityDeclarationTypes = void 0, (function(t) {
      t.None = "none", t.Declared = "declared", t.InheritedFromService = "inheritedFromService";
    })(e.HttpOperationSecurityDeclarationTypes || (e.HttpOperationSecurityDeclarationTypes = {})), e.HttpParamStyles = void 0, (function(t) {
      t.Unspecified = "unspecified", t.Simple = "simple", t.Matrix = "matrix", t.Label = "label", t.Form = "form", t.CommaDelimited = "commaDelimited", t.SpaceDelimited = "spaceDelimited", t.PipeDelimited = "pipeDelimited", t.DeepObject = "deepObject", t.TabDelimited = "tabDelimited";
    })(e.HttpParamStyles || (e.HttpParamStyles = {})), e.DiagnosticSeverity = void 0, (function(t) {
      t[t.Error = 0] = "Error", t[t.Warning = 1] = "Warning", t[t.Information = 2] = "Information", t[t.Hint = 3] = "Hint";
    })(e.DiagnosticSeverity || (e.DiagnosticSeverity = {})), e.NodeType = void 0, (function(t) {
      t.Article = "article", t.HttpService = "http_service", t.HttpServer = "http_server", t.HttpOperation = "http_operation", t.HttpCallback = "http_callback", t.HttpWebhook = "http_webhook", t.Model = "model", t.Generic = "generic", t.Unknown = "unknown", t.TableOfContents = "table_of_contents", t.SpectralRuleset = "spectral_ruleset", t.Styleguide = "styleguide", t.Image = "image", t.StoplightResolutions = "stoplight_resolutions", t.StoplightOverride = "stoplight_override";
    })(e.NodeType || (e.NodeType = {})), e.NodeFormat = void 0, (function(t) {
      t.Json = "json", t.Markdown = "markdown", t.Yaml = "yaml", t.Javascript = "javascript", t.Apng = "apng", t.Avif = "avif", t.Bmp = "bmp", t.Gif = "gif", t.Jpeg = "jpeg", t.Png = "png", t.Svg = "svg", t.Webp = "webp";
    })(e.NodeFormat || (e.NodeFormat = {}));
  })(A5)), A5;
}
var h4;
function iA() {
  if (h4) return fd;
  h4 = 1, Object.defineProperty(fd, "__esModule", { value: !0 });
  const e = nA(), t = /* @__PURE__ */ WB(), n = I2(), r = /* @__PURE__ */ j2(), i = /* @__PURE__ */ rA(), a = /* @__PURE__ */ q2(), o = /* @__PURE__ */ kc(), c = /* @__PURE__ */ zf();
  fd.parseWithPointers = (re, X) => {
    const de = p(re), Ce = n.load(re, Object.assign({}, X, { ignoreDuplicateKeys: !0 })), J = {
      ast: Ce,
      lineMap: de,
      data: void 0,
      diagnostics: [],
      metadata: X,
      comments: {}
    };
    if (!Ce)
      return J;
    const ne = ae(X), De = new Q(J.comments, Q.mapComments(ne.attachComments && Ce.comments ? Ce.comments : [], de), Ce, de, "#"), je = {
      lineMap: de,
      diagnostics: J.diagnostics
    };
    return J.data = d(je, Ce, De, ne), Ce.errors && J.diagnostics.push(...b(Ce.errors, de)), J.diagnostics.length > 0 && J.diagnostics.sort((Me, qe) => Me.range.start.line - qe.range.start.line), Array.isArray(J.ast.errors) && (J.ast.errors.length = 0), J;
  };
  const u = /~/g, s = /\//g;
  function l(re) {
    return re.replace(u, "~0").replace(s, "~1");
  }
  const d = (re, X, de, Ce) => {
    if (X)
      switch (X.kind) {
        case o.Kind.MAP: {
          const J = de.enter(X), { lineMap: ne, diagnostics: De } = re, { preserveKeyOrder: je, ignoreDuplicateKeys: Me, json: qe, mergeKeys: Ve } = Ce, xe = y(je), ve = [], Ae = Ve, Ue = !qe, qt = !Me;
          for (const Ze of X.mappings) {
            if (!O(Ze, ne, De, Ue))
              continue;
            const At = String(f(Ze.key)), He = J.enter(Ze, l(At));
            if ((Ue || qt) && (!Ae || At !== "<<"))
              if (ve.includes(At)) {
                if (Ue)
                  throw new Error("Duplicate YAML mapping key encountered");
                qt && De.push(L(Ze.key, ne, "duplicate key"));
              } else
                ve.push(At);
            if (Ae && At === "<<") {
              const Dt = w(d(re, Ze.value, He, Ce), je);
              Object.assign(xe, Dt);
            } else
              xe[At] = d(re, Ze.value, He, Ce), je && E(xe, At);
            He.attachComments();
          }
          return J.attachComments(), xe;
        }
        case o.Kind.SEQ: {
          const J = de.enter(X), ne = X.items.map((De, je) => {
            if (De !== null) {
              const Me = J.enter(De, je), qe = d(re, De, Me, Ce);
              return Me.attachComments(), qe;
            } else
              return null;
          });
          return J.attachComments(), ne;
        }
        case o.Kind.SCALAR: {
          const J = f(X);
          return !Ce.bigInt && typeof J == "bigint" ? Number(J) : J;
        }
        case o.Kind.ANCHOR_REF:
          return c.isObject(X.value) && (X.value = i.dereferenceAnchor(X.value, X.referencesAnchor)), d(re, X.value, de, Ce);
        default:
          return null;
      }
    return X;
  };
  function f(re) {
    switch (n.determineScalarType(re)) {
      case o.ScalarType.null:
        return null;
      case o.ScalarType.string:
        return String(re.value);
      case o.ScalarType.bool:
        return n.parseYamlBoolean(re.value);
      case o.ScalarType.int:
        return n.parseYamlBigInteger(re.value);
      case o.ScalarType.float:
        return n.parseYamlFloat(re.value);
    }
  }
  const p = (re) => {
    const X = [];
    let de = 0;
    for (; de < re.length; de++)
      re[de] === `
` && X.push(de + 1);
    return X.push(de + 1), X;
  };
  function g(re, X) {
    return X === 0 ? Math.max(0, re[0] - 1) : Math.max(0, re[X] - re[X - 1] - 1);
  }
  const b = (re, X) => {
    const de = [];
    let Ce = -1, J = 0;
    for (const ne of re) {
      const De = {
        code: ne.name,
        message: ne.reason,
        severity: ne.isWarning ? t.DiagnosticSeverity.Warning : t.DiagnosticSeverity.Error,
        range: {
          start: {
            line: ne.mark.line,
            character: ne.mark.column
          },
          end: {
            line: ne.mark.line,
            character: ne.mark.toLineEnd ? g(X, ne.mark.line) : ne.mark.column
          }
        }
      };
      ne.reason === "missed comma between flow collection entries" ? Ce = Ce === -1 ? J : Ce : Ce !== -1 && (de[Ce].range.end = De.range.end, de[Ce].message = "invalid mixed usage of block and flow styles", de.length = Ce + 1, J = de.length, Ce = -1), de.push(De), J++;
    }
    return de;
  }, w = (re, X) => Array.isArray(re) ? re.reduceRight(X ? (Ce, J) => {
    const ne = Object.keys(J);
    Object.assign(Ce, J);
    for (let De = ne.length - 1; De >= 0; De--)
      _(Ce, ne[De]);
    return Ce;
  } : (Ce, J) => Object.assign(Ce, J), y(X)) : typeof re != "object" || re === null ? null : Object(re);
  function y(re) {
    return re ? e.default({}) : {};
  }
  function v(re, X) {
    if (!(X in re))
      return;
    const de = e.getOrder(re), Ce = de.indexOf(X);
    Ce !== -1 && de.splice(Ce, 1);
  }
  function _(re, X) {
    v(re, X), e.getOrder(re).unshift(X);
  }
  function E(re, X) {
    v(re, X), e.getOrder(re).push(X);
  }
  function O(re, X, de, Ce) {
    if (re.key.kind !== o.Kind.SCALAR)
      return Ce || de.push(M(re.key, X, "mapping key must be a string scalar", Ce)), !1;
    if (!Ce) {
      const J = typeof f(re.key);
      J !== "string" && de.push(M(re.key, X, `mapping key must be a string scalar rather than ${re.key.valueObject === null ? "null" : J}`, Ce));
    }
    return !0;
  }
  function M(re, X, de, Ce) {
    const J = L(re, X, de);
    return J.code = "YAMLIncompatibleValue", J.severity = Ce ? t.DiagnosticSeverity.Hint : t.DiagnosticSeverity.Warning, J;
  }
  function L(re, X, de) {
    return {
      code: "YAMLException",
      message: de,
      severity: t.DiagnosticSeverity.Error,
      path: r.buildJsonPath(re),
      range: Z(X, re.startPosition, re.endPosition)
    };
  }
  function Z(re, X, de) {
    const Ce = a.lineForPosition(X, re), J = a.lineForPosition(de, re);
    return {
      start: {
        line: Ce,
        character: Ce === 0 ? X : X - re[Ce - 1]
      },
      end: {
        line: J,
        character: J === 0 ? de : de - re[J - 1]
      }
    };
  }
  class Q {
    constructor(X, de, Ce, J, ne) {
      if (this.attachedComments = X, this.node = Ce, this.lineMap = J, this.pointer = ne, de.length === 0)
        this.comments = [];
      else {
        const De = this.getStartPosition(Ce), je = this.getEndPosition(Ce), Me = a.lineForPosition(De, this.lineMap), qe = a.lineForPosition(je, this.lineMap), Ve = [];
        for (let xe = de.length - 1; xe >= 0; xe--) {
          const ve = de[xe];
          ve.range.start.line >= Me && ve.range.end.line <= qe && (Ve.push(ve), de.splice(xe, 1));
        }
        this.comments = Ve;
      }
    }
    getStartPosition(X) {
      return X.parent === null ? 0 : X.kind === o.Kind.MAPPING ? X.key.startPosition : X.startPosition;
    }
    getEndPosition(X) {
      switch (X.kind) {
        case o.Kind.MAPPING:
          return X.value === null ? X.endPosition : this.getEndPosition(X.value);
        case o.Kind.MAP:
          return X.mappings.length === 0 ? X.endPosition : X.mappings[X.mappings.length - 1].endPosition;
        case o.Kind.SEQ: {
          if (X.items.length === 0)
            return X.endPosition;
          const de = X.items[X.items.length - 1];
          return de === null ? X.endPosition : de.endPosition;
        }
        default:
          return X.endPosition;
      }
    }
    static mapComments(X, de) {
      return X.map((Ce) => ({
        value: Ce.value,
        range: Z(de, Ce.startPosition, Ce.endPosition),
        startPosition: Ce.startPosition,
        endPosition: Ce.endPosition
      }));
    }
    enter(X, de) {
      return new Q(this.attachedComments, this.comments, X, this.lineMap, de === void 0 ? this.pointer : `${this.pointer}/${de}`);
    }
    static isLeading(X, de) {
      switch (X.kind) {
        case o.Kind.MAP:
          return X.mappings.length === 0 || X.mappings[0].startPosition > de;
        case o.Kind.SEQ: {
          if (X.items.length === 0)
            return !0;
          const Ce = X.items[0];
          return Ce === null || Ce.startPosition > de;
        }
        case o.Kind.MAPPING:
          return X.value === null || X.value.startPosition > de;
        default:
          return !1;
      }
    }
    static isTrailing(X, de) {
      switch (X.kind) {
        case o.Kind.MAP:
          return X.mappings.length > 0 && de > X.mappings[X.mappings.length - 1].endPosition;
        case o.Kind.SEQ:
          if (X.items.length === 0)
            return !1;
          const Ce = X.items[X.items.length - 1];
          return Ce !== null && de > Ce.endPosition;
        case o.Kind.MAPPING:
          return X.value !== null && de > X.value.endPosition;
        default:
          return !1;
      }
    }
    static findBetween(X, de, Ce) {
      switch (X.kind) {
        case o.Kind.MAP: {
          let J;
          for (const ne of X.mappings)
            if (de > ne.startPosition)
              J = ne.key.value;
            else if (J !== void 0 && ne.startPosition > Ce)
              return [J, ne.key.value];
          return null;
        }
        case o.Kind.SEQ: {
          let J;
          for (let ne = 0; ne < X.items.length; ne++) {
            const De = X.items[ne];
            if (De !== null) {
              if (de > De.startPosition)
                J = String(ne);
              else if (J !== void 0 && De.startPosition > Ce)
                return [J, String(ne)];
            }
          }
          return null;
        }
        default:
          return null;
      }
    }
    isBeforeEOL(X) {
      return this.node.kind === o.Kind.SCALAR || this.node.kind === o.Kind.MAPPING && X.range.end.line === a.lineForPosition(this.node.key.endPosition, this.lineMap);
    }
    attachComments() {
      if (this.comments.length === 0)
        return;
      const X = this.attachedComments[this.pointer] = this.attachedComments[this.pointer] || [];
      for (const de of this.comments)
        if (this.isBeforeEOL(de))
          X.push({
            value: de.value,
            placement: "before-eol"
          });
        else if (Q.isLeading(this.node, de.startPosition))
          X.push({
            value: de.value,
            placement: "leading"
          });
        else if (Q.isTrailing(this.node, de.endPosition))
          X.push({
            value: de.value,
            placement: "trailing"
          });
        else {
          const Ce = Q.findBetween(this.node, de.startPosition, de.endPosition);
          Ce !== null ? X.push({
            value: de.value,
            placement: "between",
            between: Ce
          }) : X.push({
            value: de.value,
            placement: "trailing"
          });
        }
    }
  }
  function ae(re) {
    return re === void 0 ? {
      attachComments: !1,
      preserveKeyOrder: !1,
      bigInt: !1,
      mergeKeys: !1,
      json: !0,
      ignoreDuplicateKeys: !1
    } : Object.assign({}, re, { attachComments: re.attachComments === !0, preserveKeyOrder: re.preserveKeyOrder === !0, bigInt: re.bigInt === !0, mergeKeys: re.mergeKeys === !0, json: re.json !== !1, ignoreDuplicateKeys: re.ignoreDuplicateKeys !== !1 });
  }
  return fd;
}
var m4;
function KB() {
  if (m4) return ld;
  m4 = 1, Object.defineProperty(ld, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ iA();
  return ld.parse = (t) => e.parseWithPointers(t).data, ld;
}
var pd = {}, g4;
function ZB() {
  if (g4) return pd;
  g4 = 1, Object.defineProperty(pd, "__esModule", { value: !0 });
  const e = I2();
  return pd.safeStringify = (t, n) => typeof t == "string" ? t : e.safeDump(t, n), pd;
}
var E5 = {}, v4;
function YB() {
  return v4 || (v4 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = nA();
    e.KEYS = Symbol.for(t.ORDER_KEY_ID);
    const n = {
      ownKeys(r) {
        return e.KEYS in r ? r[e.KEYS] : Reflect.ownKeys(r);
      }
    };
    e.trapAccess = (r) => new Proxy(r, n);
  })(E5)), E5;
}
var y4;
function JB() {
  return y4 || (y4 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = F0;
    t.__exportStar(/* @__PURE__ */ j2(), e), t.__exportStar(/* @__PURE__ */ rA(), e), t.__exportStar(/* @__PURE__ */ VB(), e), t.__exportStar(/* @__PURE__ */ GB(), e), t.__exportStar(/* @__PURE__ */ q2(), e);
    var n = /* @__PURE__ */ KB();
    e.parse = n.parse;
    var r = /* @__PURE__ */ iA();
    e.parseWithPointers = r.parseWithPointers, t.__exportStar(/* @__PURE__ */ ZB(), e), t.__exportStar(/* @__PURE__ */ kc(), e), t.__exportStar(/* @__PURE__ */ YB(), e);
  })(Jh)), Jh;
}
var QB = /* @__PURE__ */ JB(), aA = {}, z0 = {};
z0.byteLength = tU;
z0.toByteArray = nU;
z0.fromByteArray = oU;
var yo = [], Ta = [], XB = typeof Uint8Array < "u" ? Uint8Array : Array, O5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Gu = 0, eU = O5.length; Gu < eU; ++Gu)
  yo[Gu] = O5[Gu], Ta[O5.charCodeAt(Gu)] = Gu;
Ta[45] = 62;
Ta[95] = 63;
function oA(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function tU(e) {
  var t = oA(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function rU(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function nU(e) {
  var t, n = oA(e), r = n[0], i = n[1], a = new XB(rU(e, r, i)), o = 0, c = i > 0 ? r - 4 : r, u;
  for (u = 0; u < c; u += 4)
    t = Ta[e.charCodeAt(u)] << 18 | Ta[e.charCodeAt(u + 1)] << 12 | Ta[e.charCodeAt(u + 2)] << 6 | Ta[e.charCodeAt(u + 3)], a[o++] = t >> 16 & 255, a[o++] = t >> 8 & 255, a[o++] = t & 255;
  return i === 2 && (t = Ta[e.charCodeAt(u)] << 2 | Ta[e.charCodeAt(u + 1)] >> 4, a[o++] = t & 255), i === 1 && (t = Ta[e.charCodeAt(u)] << 10 | Ta[e.charCodeAt(u + 1)] << 4 | Ta[e.charCodeAt(u + 2)] >> 2, a[o++] = t >> 8 & 255, a[o++] = t & 255), a;
}
function iU(e) {
  return yo[e >> 18 & 63] + yo[e >> 12 & 63] + yo[e >> 6 & 63] + yo[e & 63];
}
function aU(e, t, n) {
  for (var r, i = [], a = t; a < n; a += 3)
    r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (e[a + 2] & 255), i.push(iU(r));
  return i.join("");
}
function oU(e) {
  for (var t, n = e.length, r = n % 3, i = [], a = 16383, o = 0, c = n - r; o < c; o += a)
    i.push(aU(e, o, o + a > c ? c : o + a));
  return r === 1 ? (t = e[n - 1], i.push(
    yo[t >> 2] + yo[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i.push(
    yo[t >> 10] + yo[t >> 4 & 63] + yo[t << 2 & 63] + "="
  )), i.join("");
}
var D2 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
D2.read = function(e, t, n, r, i) {
  var a, o, c = i * 8 - r - 1, u = (1 << c) - 1, s = u >> 1, l = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
  for (d += f, a = p & (1 << -l) - 1, p >>= -l, l += c; l > 0; a = a * 256 + e[t + d], d += f, l -= 8)
    ;
  for (o = a & (1 << -l) - 1, a >>= -l, l += r; l > 0; o = o * 256 + e[t + d], d += f, l -= 8)
    ;
  if (a === 0)
    a = 1 - s;
  else {
    if (a === u)
      return o ? NaN : (p ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), a = a - s;
  }
  return (p ? -1 : 1) * o * Math.pow(2, a - r);
};
D2.write = function(e, t, n, r, i, a) {
  var o, c, u, s = a * 8 - i - 1, l = (1 << s) - 1, d = l >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : a - 1, g = r ? 1 : -1, b = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (c = isNaN(t) ? 1 : 0, o = l) : (o = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), o + d >= 1 ? t += f / u : t += f * Math.pow(2, 1 - d), t * u >= 2 && (o++, u /= 2), o + d >= l ? (c = 0, o = l) : o + d >= 1 ? (c = (t * u - 1) * Math.pow(2, i), o = o + d) : (c = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + p] = c & 255, p += g, c /= 256, i -= 8)
    ;
  for (o = o << i | c, s += i; s > 0; e[n + p] = o & 255, p += g, o /= 256, s -= 8)
    ;
  e[n + p - g] |= b * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = z0, n = D2, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = l, e.SlowBuffer = O, e.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  e.kMaxLength = i;
  const { Uint8Array: a, ArrayBuffer: o, SharedArrayBuffer: c } = globalThis;
  l.TYPED_ARRAY_SUPPORT = u(), !l.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function u() {
    try {
      const F = new a(1), T = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(T, a.prototype), Object.setPrototypeOf(F, T), F.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(l.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (l.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(l.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (l.isBuffer(this))
        return this.byteOffset;
    }
  });
  function s(F) {
    if (F > i)
      throw new RangeError('The value "' + F + '" is invalid for option "size"');
    const T = new a(F);
    return Object.setPrototypeOf(T, l.prototype), T;
  }
  function l(F, T, C) {
    if (typeof F == "number") {
      if (typeof T == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return g(F);
    }
    return d(F, T, C);
  }
  l.poolSize = 8192;
  function d(F, T, C) {
    if (typeof F == "string")
      return b(F, T);
    if (o.isView(F))
      return y(F);
    if (F == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof F
      );
    if (Ge(F, o) || F && Ge(F.buffer, o) || typeof c < "u" && (Ge(F, c) || F && Ge(F.buffer, c)))
      return v(F, T, C);
    if (typeof F == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const S = F.valueOf && F.valueOf();
    if (S != null && S !== F)
      return l.from(S, T, C);
    const h = _(F);
    if (h) return h;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof F[Symbol.toPrimitive] == "function")
      return l.from(F[Symbol.toPrimitive]("string"), T, C);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof F
    );
  }
  l.from = function(F, T, C) {
    return d(F, T, C);
  }, Object.setPrototypeOf(l.prototype, a.prototype), Object.setPrototypeOf(l, a);
  function f(F) {
    if (typeof F != "number")
      throw new TypeError('"size" argument must be of type number');
    if (F < 0)
      throw new RangeError('The value "' + F + '" is invalid for option "size"');
  }
  function p(F, T, C) {
    return f(F), F <= 0 ? s(F) : T !== void 0 ? typeof C == "string" ? s(F).fill(T, C) : s(F).fill(T) : s(F);
  }
  l.alloc = function(F, T, C) {
    return p(F, T, C);
  };
  function g(F) {
    return f(F), s(F < 0 ? 0 : E(F) | 0);
  }
  l.allocUnsafe = function(F) {
    return g(F);
  }, l.allocUnsafeSlow = function(F) {
    return g(F);
  };
  function b(F, T) {
    if ((typeof T != "string" || T === "") && (T = "utf8"), !l.isEncoding(T))
      throw new TypeError("Unknown encoding: " + T);
    const C = M(F, T) | 0;
    let S = s(C);
    const h = S.write(F, T);
    return h !== C && (S = S.slice(0, h)), S;
  }
  function w(F) {
    const T = F.length < 0 ? 0 : E(F.length) | 0, C = s(T);
    for (let S = 0; S < T; S += 1)
      C[S] = F[S] & 255;
    return C;
  }
  function y(F) {
    if (Ge(F, a)) {
      const T = new a(F);
      return v(T.buffer, T.byteOffset, T.byteLength);
    }
    return w(F);
  }
  function v(F, T, C) {
    if (T < 0 || F.byteLength < T)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (F.byteLength < T + (C || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let S;
    return T === void 0 && C === void 0 ? S = new a(F) : C === void 0 ? S = new a(F, T) : S = new a(F, T, C), Object.setPrototypeOf(S, l.prototype), S;
  }
  function _(F) {
    if (l.isBuffer(F)) {
      const T = E(F.length) | 0, C = s(T);
      return C.length === 0 || F.copy(C, 0, 0, T), C;
    }
    if (F.length !== void 0)
      return typeof F.length != "number" || $t(F.length) ? s(0) : w(F);
    if (F.type === "Buffer" && Array.isArray(F.data))
      return w(F.data);
  }
  function E(F) {
    if (F >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return F | 0;
  }
  function O(F) {
    return +F != F && (F = 0), l.alloc(+F);
  }
  l.isBuffer = function(T) {
    return T != null && T._isBuffer === !0 && T !== l.prototype;
  }, l.compare = function(T, C) {
    if (Ge(T, a) && (T = l.from(T, T.offset, T.byteLength)), Ge(C, a) && (C = l.from(C, C.offset, C.byteLength)), !l.isBuffer(T) || !l.isBuffer(C))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (T === C) return 0;
    let S = T.length, h = C.length;
    for (let k = 0, R = Math.min(S, h); k < R; ++k)
      if (T[k] !== C[k]) {
        S = T[k], h = C[k];
        break;
      }
    return S < h ? -1 : h < S ? 1 : 0;
  }, l.isEncoding = function(T) {
    switch (String(T).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, l.concat = function(T, C) {
    if (!Array.isArray(T))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (T.length === 0)
      return l.alloc(0);
    let S;
    if (C === void 0)
      for (C = 0, S = 0; S < T.length; ++S)
        C += T[S].length;
    const h = l.allocUnsafe(C);
    let k = 0;
    for (S = 0; S < T.length; ++S) {
      let R = T[S];
      if (Ge(R, a))
        k + R.length > h.length ? (l.isBuffer(R) || (R = l.from(R)), R.copy(h, k)) : a.prototype.set.call(
          h,
          R,
          k
        );
      else if (l.isBuffer(R))
        R.copy(h, k);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      k += R.length;
    }
    return h;
  };
  function M(F, T) {
    if (l.isBuffer(F))
      return F.length;
    if (o.isView(F) || Ge(F, o))
      return F.byteLength;
    if (typeof F != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof F
      );
    const C = F.length, S = arguments.length > 2 && arguments[2] === !0;
    if (!S && C === 0) return 0;
    let h = !1;
    for (; ; )
      switch (T) {
        case "ascii":
        case "latin1":
        case "binary":
          return C;
        case "utf8":
        case "utf-8":
          return Te(F).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return C * 2;
        case "hex":
          return C >>> 1;
        case "base64":
          return Le(F).length;
        default:
          if (h)
            return S ? -1 : Te(F).length;
          T = ("" + T).toLowerCase(), h = !0;
      }
  }
  l.byteLength = M;
  function L(F, T, C) {
    let S = !1;
    if ((T === void 0 || T < 0) && (T = 0), T > this.length || ((C === void 0 || C > this.length) && (C = this.length), C <= 0) || (C >>>= 0, T >>>= 0, C <= T))
      return "";
    for (F || (F = "utf8"); ; )
      switch (F) {
        case "hex":
          return xe(this, T, C);
        case "utf8":
        case "utf-8":
          return De(this, T, C);
        case "ascii":
          return qe(this, T, C);
        case "latin1":
        case "binary":
          return Ve(this, T, C);
        case "base64":
          return ne(this, T, C);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ve(this, T, C);
        default:
          if (S) throw new TypeError("Unknown encoding: " + F);
          F = (F + "").toLowerCase(), S = !0;
      }
  }
  l.prototype._isBuffer = !0;
  function Z(F, T, C) {
    const S = F[T];
    F[T] = F[C], F[C] = S;
  }
  l.prototype.swap16 = function() {
    const T = this.length;
    if (T % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let C = 0; C < T; C += 2)
      Z(this, C, C + 1);
    return this;
  }, l.prototype.swap32 = function() {
    const T = this.length;
    if (T % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let C = 0; C < T; C += 4)
      Z(this, C, C + 3), Z(this, C + 1, C + 2);
    return this;
  }, l.prototype.swap64 = function() {
    const T = this.length;
    if (T % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let C = 0; C < T; C += 8)
      Z(this, C, C + 7), Z(this, C + 1, C + 6), Z(this, C + 2, C + 5), Z(this, C + 3, C + 4);
    return this;
  }, l.prototype.toString = function() {
    const T = this.length;
    return T === 0 ? "" : arguments.length === 0 ? De(this, 0, T) : L.apply(this, arguments);
  }, l.prototype.toLocaleString = l.prototype.toString, l.prototype.equals = function(T) {
    if (!l.isBuffer(T)) throw new TypeError("Argument must be a Buffer");
    return this === T ? !0 : l.compare(this, T) === 0;
  }, l.prototype.inspect = function() {
    let T = "";
    const C = e.INSPECT_MAX_BYTES;
    return T = this.toString("hex", 0, C).replace(/(.{2})/g, "$1 ").trim(), this.length > C && (T += " ... "), "<Buffer " + T + ">";
  }, r && (l.prototype[r] = l.prototype.inspect), l.prototype.compare = function(T, C, S, h, k) {
    if (Ge(T, a) && (T = l.from(T, T.offset, T.byteLength)), !l.isBuffer(T))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof T
      );
    if (C === void 0 && (C = 0), S === void 0 && (S = T ? T.length : 0), h === void 0 && (h = 0), k === void 0 && (k = this.length), C < 0 || S > T.length || h < 0 || k > this.length)
      throw new RangeError("out of range index");
    if (h >= k && C >= S)
      return 0;
    if (h >= k)
      return -1;
    if (C >= S)
      return 1;
    if (C >>>= 0, S >>>= 0, h >>>= 0, k >>>= 0, this === T) return 0;
    let R = k - h, j = S - C;
    const A = Math.min(R, j), I = this.slice(h, k), z = T.slice(C, S);
    for (let H = 0; H < A; ++H)
      if (I[H] !== z[H]) {
        R = I[H], j = z[H];
        break;
      }
    return R < j ? -1 : j < R ? 1 : 0;
  };
  function Q(F, T, C, S, h) {
    if (F.length === 0) return -1;
    if (typeof C == "string" ? (S = C, C = 0) : C > 2147483647 ? C = 2147483647 : C < -2147483648 && (C = -2147483648), C = +C, $t(C) && (C = h ? 0 : F.length - 1), C < 0 && (C = F.length + C), C >= F.length) {
      if (h) return -1;
      C = F.length - 1;
    } else if (C < 0)
      if (h) C = 0;
      else return -1;
    if (typeof T == "string" && (T = l.from(T, S)), l.isBuffer(T))
      return T.length === 0 ? -1 : ae(F, T, C, S, h);
    if (typeof T == "number")
      return T = T & 255, typeof a.prototype.indexOf == "function" ? h ? a.prototype.indexOf.call(F, T, C) : a.prototype.lastIndexOf.call(F, T, C) : ae(F, [T], C, S, h);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ae(F, T, C, S, h) {
    let k = 1, R = F.length, j = T.length;
    if (S !== void 0 && (S = String(S).toLowerCase(), S === "ucs2" || S === "ucs-2" || S === "utf16le" || S === "utf-16le")) {
      if (F.length < 2 || T.length < 2)
        return -1;
      k = 2, R /= 2, j /= 2, C /= 2;
    }
    function A(z, H) {
      return k === 1 ? z[H] : z.readUInt16BE(H * k);
    }
    let I;
    if (h) {
      let z = -1;
      for (I = C; I < R; I++)
        if (A(F, I) === A(T, z === -1 ? 0 : I - z)) {
          if (z === -1 && (z = I), I - z + 1 === j) return z * k;
        } else
          z !== -1 && (I -= I - z), z = -1;
    } else
      for (C + j > R && (C = R - j), I = C; I >= 0; I--) {
        let z = !0;
        for (let H = 0; H < j; H++)
          if (A(F, I + H) !== A(T, H)) {
            z = !1;
            break;
          }
        if (z) return I;
      }
    return -1;
  }
  l.prototype.includes = function(T, C, S) {
    return this.indexOf(T, C, S) !== -1;
  }, l.prototype.indexOf = function(T, C, S) {
    return Q(this, T, C, S, !0);
  }, l.prototype.lastIndexOf = function(T, C, S) {
    return Q(this, T, C, S, !1);
  };
  function re(F, T, C, S) {
    C = Number(C) || 0;
    const h = F.length - C;
    S ? (S = Number(S), S > h && (S = h)) : S = h;
    const k = T.length;
    S > k / 2 && (S = k / 2);
    let R;
    for (R = 0; R < S; ++R) {
      const j = parseInt(T.substr(R * 2, 2), 16);
      if ($t(j)) return R;
      F[C + R] = j;
    }
    return R;
  }
  function X(F, T, C, S) {
    return et(Te(T, F.length - C), F, C, S);
  }
  function de(F, T, C, S) {
    return et($(T), F, C, S);
  }
  function Ce(F, T, C, S) {
    return et(Le(T), F, C, S);
  }
  function J(F, T, C, S) {
    return et(_e(T, F.length - C), F, C, S);
  }
  l.prototype.write = function(T, C, S, h) {
    if (C === void 0)
      h = "utf8", S = this.length, C = 0;
    else if (S === void 0 && typeof C == "string")
      h = C, S = this.length, C = 0;
    else if (isFinite(C))
      C = C >>> 0, isFinite(S) ? (S = S >>> 0, h === void 0 && (h = "utf8")) : (h = S, S = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const k = this.length - C;
    if ((S === void 0 || S > k) && (S = k), T.length > 0 && (S < 0 || C < 0) || C > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    h || (h = "utf8");
    let R = !1;
    for (; ; )
      switch (h) {
        case "hex":
          return re(this, T, C, S);
        case "utf8":
        case "utf-8":
          return X(this, T, C, S);
        case "ascii":
        case "latin1":
        case "binary":
          return de(this, T, C, S);
        case "base64":
          return Ce(this, T, C, S);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return J(this, T, C, S);
        default:
          if (R) throw new TypeError("Unknown encoding: " + h);
          h = ("" + h).toLowerCase(), R = !0;
      }
  }, l.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ne(F, T, C) {
    return T === 0 && C === F.length ? t.fromByteArray(F) : t.fromByteArray(F.slice(T, C));
  }
  function De(F, T, C) {
    C = Math.min(F.length, C);
    const S = [];
    let h = T;
    for (; h < C; ) {
      const k = F[h];
      let R = null, j = k > 239 ? 4 : k > 223 ? 3 : k > 191 ? 2 : 1;
      if (h + j <= C) {
        let A, I, z, H;
        switch (j) {
          case 1:
            k < 128 && (R = k);
            break;
          case 2:
            A = F[h + 1], (A & 192) === 128 && (H = (k & 31) << 6 | A & 63, H > 127 && (R = H));
            break;
          case 3:
            A = F[h + 1], I = F[h + 2], (A & 192) === 128 && (I & 192) === 128 && (H = (k & 15) << 12 | (A & 63) << 6 | I & 63, H > 2047 && (H < 55296 || H > 57343) && (R = H));
            break;
          case 4:
            A = F[h + 1], I = F[h + 2], z = F[h + 3], (A & 192) === 128 && (I & 192) === 128 && (z & 192) === 128 && (H = (k & 15) << 18 | (A & 63) << 12 | (I & 63) << 6 | z & 63, H > 65535 && H < 1114112 && (R = H));
        }
      }
      R === null ? (R = 65533, j = 1) : R > 65535 && (R -= 65536, S.push(R >>> 10 & 1023 | 55296), R = 56320 | R & 1023), S.push(R), h += j;
    }
    return Me(S);
  }
  const je = 4096;
  function Me(F) {
    const T = F.length;
    if (T <= je)
      return String.fromCharCode.apply(String, F);
    let C = "", S = 0;
    for (; S < T; )
      C += String.fromCharCode.apply(
        String,
        F.slice(S, S += je)
      );
    return C;
  }
  function qe(F, T, C) {
    let S = "";
    C = Math.min(F.length, C);
    for (let h = T; h < C; ++h)
      S += String.fromCharCode(F[h] & 127);
    return S;
  }
  function Ve(F, T, C) {
    let S = "";
    C = Math.min(F.length, C);
    for (let h = T; h < C; ++h)
      S += String.fromCharCode(F[h]);
    return S;
  }
  function xe(F, T, C) {
    const S = F.length;
    (!T || T < 0) && (T = 0), (!C || C < 0 || C > S) && (C = S);
    let h = "";
    for (let k = T; k < C; ++k)
      h += Be[F[k]];
    return h;
  }
  function ve(F, T, C) {
    const S = F.slice(T, C);
    let h = "";
    for (let k = 0; k < S.length - 1; k += 2)
      h += String.fromCharCode(S[k] + S[k + 1] * 256);
    return h;
  }
  l.prototype.slice = function(T, C) {
    const S = this.length;
    T = ~~T, C = C === void 0 ? S : ~~C, T < 0 ? (T += S, T < 0 && (T = 0)) : T > S && (T = S), C < 0 ? (C += S, C < 0 && (C = 0)) : C > S && (C = S), C < T && (C = T);
    const h = this.subarray(T, C);
    return Object.setPrototypeOf(h, l.prototype), h;
  };
  function Ae(F, T, C) {
    if (F % 1 !== 0 || F < 0) throw new RangeError("offset is not uint");
    if (F + T > C) throw new RangeError("Trying to access beyond buffer length");
  }
  l.prototype.readUintLE = l.prototype.readUIntLE = function(T, C, S) {
    T = T >>> 0, C = C >>> 0, S || Ae(T, C, this.length);
    let h = this[T], k = 1, R = 0;
    for (; ++R < C && (k *= 256); )
      h += this[T + R] * k;
    return h;
  }, l.prototype.readUintBE = l.prototype.readUIntBE = function(T, C, S) {
    T = T >>> 0, C = C >>> 0, S || Ae(T, C, this.length);
    let h = this[T + --C], k = 1;
    for (; C > 0 && (k *= 256); )
      h += this[T + --C] * k;
    return h;
  }, l.prototype.readUint8 = l.prototype.readUInt8 = function(T, C) {
    return T = T >>> 0, C || Ae(T, 1, this.length), this[T];
  }, l.prototype.readUint16LE = l.prototype.readUInt16LE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 2, this.length), this[T] | this[T + 1] << 8;
  }, l.prototype.readUint16BE = l.prototype.readUInt16BE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 2, this.length), this[T] << 8 | this[T + 1];
  }, l.prototype.readUint32LE = l.prototype.readUInt32LE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 4, this.length), (this[T] | this[T + 1] << 8 | this[T + 2] << 16) + this[T + 3] * 16777216;
  }, l.prototype.readUint32BE = l.prototype.readUInt32BE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 4, this.length), this[T] * 16777216 + (this[T + 1] << 16 | this[T + 2] << 8 | this[T + 3]);
  }, l.prototype.readBigUInt64LE = P(function(T) {
    T = T >>> 0, ye(T, "offset");
    const C = this[T], S = this[T + 7];
    (C === void 0 || S === void 0) && W(T, this.length - 8);
    const h = C + this[++T] * 2 ** 8 + this[++T] * 2 ** 16 + this[++T] * 2 ** 24, k = this[++T] + this[++T] * 2 ** 8 + this[++T] * 2 ** 16 + S * 2 ** 24;
    return BigInt(h) + (BigInt(k) << BigInt(32));
  }), l.prototype.readBigUInt64BE = P(function(T) {
    T = T >>> 0, ye(T, "offset");
    const C = this[T], S = this[T + 7];
    (C === void 0 || S === void 0) && W(T, this.length - 8);
    const h = C * 2 ** 24 + this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + this[++T], k = this[++T] * 2 ** 24 + this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + S;
    return (BigInt(h) << BigInt(32)) + BigInt(k);
  }), l.prototype.readIntLE = function(T, C, S) {
    T = T >>> 0, C = C >>> 0, S || Ae(T, C, this.length);
    let h = this[T], k = 1, R = 0;
    for (; ++R < C && (k *= 256); )
      h += this[T + R] * k;
    return k *= 128, h >= k && (h -= Math.pow(2, 8 * C)), h;
  }, l.prototype.readIntBE = function(T, C, S) {
    T = T >>> 0, C = C >>> 0, S || Ae(T, C, this.length);
    let h = C, k = 1, R = this[T + --h];
    for (; h > 0 && (k *= 256); )
      R += this[T + --h] * k;
    return k *= 128, R >= k && (R -= Math.pow(2, 8 * C)), R;
  }, l.prototype.readInt8 = function(T, C) {
    return T = T >>> 0, C || Ae(T, 1, this.length), this[T] & 128 ? (255 - this[T] + 1) * -1 : this[T];
  }, l.prototype.readInt16LE = function(T, C) {
    T = T >>> 0, C || Ae(T, 2, this.length);
    const S = this[T] | this[T + 1] << 8;
    return S & 32768 ? S | 4294901760 : S;
  }, l.prototype.readInt16BE = function(T, C) {
    T = T >>> 0, C || Ae(T, 2, this.length);
    const S = this[T + 1] | this[T] << 8;
    return S & 32768 ? S | 4294901760 : S;
  }, l.prototype.readInt32LE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 4, this.length), this[T] | this[T + 1] << 8 | this[T + 2] << 16 | this[T + 3] << 24;
  }, l.prototype.readInt32BE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 4, this.length), this[T] << 24 | this[T + 1] << 16 | this[T + 2] << 8 | this[T + 3];
  }, l.prototype.readBigInt64LE = P(function(T) {
    T = T >>> 0, ye(T, "offset");
    const C = this[T], S = this[T + 7];
    (C === void 0 || S === void 0) && W(T, this.length - 8);
    const h = this[T + 4] + this[T + 5] * 2 ** 8 + this[T + 6] * 2 ** 16 + (S << 24);
    return (BigInt(h) << BigInt(32)) + BigInt(C + this[++T] * 2 ** 8 + this[++T] * 2 ** 16 + this[++T] * 2 ** 24);
  }), l.prototype.readBigInt64BE = P(function(T) {
    T = T >>> 0, ye(T, "offset");
    const C = this[T], S = this[T + 7];
    (C === void 0 || S === void 0) && W(T, this.length - 8);
    const h = (C << 24) + // Overflow
    this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + this[++T];
    return (BigInt(h) << BigInt(32)) + BigInt(this[++T] * 2 ** 24 + this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + S);
  }), l.prototype.readFloatLE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 4, this.length), n.read(this, T, !0, 23, 4);
  }, l.prototype.readFloatBE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 4, this.length), n.read(this, T, !1, 23, 4);
  }, l.prototype.readDoubleLE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 8, this.length), n.read(this, T, !0, 52, 8);
  }, l.prototype.readDoubleBE = function(T, C) {
    return T = T >>> 0, C || Ae(T, 8, this.length), n.read(this, T, !1, 52, 8);
  };
  function Ue(F, T, C, S, h, k) {
    if (!l.isBuffer(F)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (T > h || T < k) throw new RangeError('"value" argument is out of bounds');
    if (C + S > F.length) throw new RangeError("Index out of range");
  }
  l.prototype.writeUintLE = l.prototype.writeUIntLE = function(T, C, S, h) {
    if (T = +T, C = C >>> 0, S = S >>> 0, !h) {
      const j = Math.pow(2, 8 * S) - 1;
      Ue(this, T, C, S, j, 0);
    }
    let k = 1, R = 0;
    for (this[C] = T & 255; ++R < S && (k *= 256); )
      this[C + R] = T / k & 255;
    return C + S;
  }, l.prototype.writeUintBE = l.prototype.writeUIntBE = function(T, C, S, h) {
    if (T = +T, C = C >>> 0, S = S >>> 0, !h) {
      const j = Math.pow(2, 8 * S) - 1;
      Ue(this, T, C, S, j, 0);
    }
    let k = S - 1, R = 1;
    for (this[C + k] = T & 255; --k >= 0 && (R *= 256); )
      this[C + k] = T / R & 255;
    return C + S;
  }, l.prototype.writeUint8 = l.prototype.writeUInt8 = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 1, 255, 0), this[C] = T & 255, C + 1;
  }, l.prototype.writeUint16LE = l.prototype.writeUInt16LE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 2, 65535, 0), this[C] = T & 255, this[C + 1] = T >>> 8, C + 2;
  }, l.prototype.writeUint16BE = l.prototype.writeUInt16BE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 2, 65535, 0), this[C] = T >>> 8, this[C + 1] = T & 255, C + 2;
  }, l.prototype.writeUint32LE = l.prototype.writeUInt32LE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 4, 4294967295, 0), this[C + 3] = T >>> 24, this[C + 2] = T >>> 16, this[C + 1] = T >>> 8, this[C] = T & 255, C + 4;
  }, l.prototype.writeUint32BE = l.prototype.writeUInt32BE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 4, 4294967295, 0), this[C] = T >>> 24, this[C + 1] = T >>> 16, this[C + 2] = T >>> 8, this[C + 3] = T & 255, C + 4;
  };
  function qt(F, T, C, S, h) {
    Yt(T, S, h, F, C, 7);
    let k = Number(T & BigInt(4294967295));
    F[C++] = k, k = k >> 8, F[C++] = k, k = k >> 8, F[C++] = k, k = k >> 8, F[C++] = k;
    let R = Number(T >> BigInt(32) & BigInt(4294967295));
    return F[C++] = R, R = R >> 8, F[C++] = R, R = R >> 8, F[C++] = R, R = R >> 8, F[C++] = R, C;
  }
  function Ze(F, T, C, S, h) {
    Yt(T, S, h, F, C, 7);
    let k = Number(T & BigInt(4294967295));
    F[C + 7] = k, k = k >> 8, F[C + 6] = k, k = k >> 8, F[C + 5] = k, k = k >> 8, F[C + 4] = k;
    let R = Number(T >> BigInt(32) & BigInt(4294967295));
    return F[C + 3] = R, R = R >> 8, F[C + 2] = R, R = R >> 8, F[C + 1] = R, R = R >> 8, F[C] = R, C + 8;
  }
  l.prototype.writeBigUInt64LE = P(function(T, C = 0) {
    return qt(this, T, C, BigInt(0), BigInt("0xffffffffffffffff"));
  }), l.prototype.writeBigUInt64BE = P(function(T, C = 0) {
    return Ze(this, T, C, BigInt(0), BigInt("0xffffffffffffffff"));
  }), l.prototype.writeIntLE = function(T, C, S, h) {
    if (T = +T, C = C >>> 0, !h) {
      const A = Math.pow(2, 8 * S - 1);
      Ue(this, T, C, S, A - 1, -A);
    }
    let k = 0, R = 1, j = 0;
    for (this[C] = T & 255; ++k < S && (R *= 256); )
      T < 0 && j === 0 && this[C + k - 1] !== 0 && (j = 1), this[C + k] = (T / R >> 0) - j & 255;
    return C + S;
  }, l.prototype.writeIntBE = function(T, C, S, h) {
    if (T = +T, C = C >>> 0, !h) {
      const A = Math.pow(2, 8 * S - 1);
      Ue(this, T, C, S, A - 1, -A);
    }
    let k = S - 1, R = 1, j = 0;
    for (this[C + k] = T & 255; --k >= 0 && (R *= 256); )
      T < 0 && j === 0 && this[C + k + 1] !== 0 && (j = 1), this[C + k] = (T / R >> 0) - j & 255;
    return C + S;
  }, l.prototype.writeInt8 = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 1, 127, -128), T < 0 && (T = 255 + T + 1), this[C] = T & 255, C + 1;
  }, l.prototype.writeInt16LE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 2, 32767, -32768), this[C] = T & 255, this[C + 1] = T >>> 8, C + 2;
  }, l.prototype.writeInt16BE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 2, 32767, -32768), this[C] = T >>> 8, this[C + 1] = T & 255, C + 2;
  }, l.prototype.writeInt32LE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 4, 2147483647, -2147483648), this[C] = T & 255, this[C + 1] = T >>> 8, this[C + 2] = T >>> 16, this[C + 3] = T >>> 24, C + 4;
  }, l.prototype.writeInt32BE = function(T, C, S) {
    return T = +T, C = C >>> 0, S || Ue(this, T, C, 4, 2147483647, -2147483648), T < 0 && (T = 4294967295 + T + 1), this[C] = T >>> 24, this[C + 1] = T >>> 16, this[C + 2] = T >>> 8, this[C + 3] = T & 255, C + 4;
  }, l.prototype.writeBigInt64LE = P(function(T, C = 0) {
    return qt(this, T, C, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), l.prototype.writeBigInt64BE = P(function(T, C = 0) {
    return Ze(this, T, C, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function At(F, T, C, S, h, k) {
    if (C + S > F.length) throw new RangeError("Index out of range");
    if (C < 0) throw new RangeError("Index out of range");
  }
  function He(F, T, C, S, h) {
    return T = +T, C = C >>> 0, h || At(F, T, C, 4), n.write(F, T, C, S, 23, 4), C + 4;
  }
  l.prototype.writeFloatLE = function(T, C, S) {
    return He(this, T, C, !0, S);
  }, l.prototype.writeFloatBE = function(T, C, S) {
    return He(this, T, C, !1, S);
  };
  function Dt(F, T, C, S, h) {
    return T = +T, C = C >>> 0, h || At(F, T, C, 8), n.write(F, T, C, S, 52, 8), C + 8;
  }
  l.prototype.writeDoubleLE = function(T, C, S) {
    return Dt(this, T, C, !0, S);
  }, l.prototype.writeDoubleBE = function(T, C, S) {
    return Dt(this, T, C, !1, S);
  }, l.prototype.copy = function(T, C, S, h) {
    if (!l.isBuffer(T)) throw new TypeError("argument should be a Buffer");
    if (S || (S = 0), !h && h !== 0 && (h = this.length), C >= T.length && (C = T.length), C || (C = 0), h > 0 && h < S && (h = S), h === S || T.length === 0 || this.length === 0) return 0;
    if (C < 0)
      throw new RangeError("targetStart out of bounds");
    if (S < 0 || S >= this.length) throw new RangeError("Index out of range");
    if (h < 0) throw new RangeError("sourceEnd out of bounds");
    h > this.length && (h = this.length), T.length - C < h - S && (h = T.length - C + S);
    const k = h - S;
    return this === T && typeof a.prototype.copyWithin == "function" ? this.copyWithin(C, S, h) : a.prototype.set.call(
      T,
      this.subarray(S, h),
      C
    ), k;
  }, l.prototype.fill = function(T, C, S, h) {
    if (typeof T == "string") {
      if (typeof C == "string" ? (h = C, C = 0, S = this.length) : typeof S == "string" && (h = S, S = this.length), h !== void 0 && typeof h != "string")
        throw new TypeError("encoding must be a string");
      if (typeof h == "string" && !l.isEncoding(h))
        throw new TypeError("Unknown encoding: " + h);
      if (T.length === 1) {
        const R = T.charCodeAt(0);
        (h === "utf8" && R < 128 || h === "latin1") && (T = R);
      }
    } else typeof T == "number" ? T = T & 255 : typeof T == "boolean" && (T = Number(T));
    if (C < 0 || this.length < C || this.length < S)
      throw new RangeError("Out of range index");
    if (S <= C)
      return this;
    C = C >>> 0, S = S === void 0 ? this.length : S >>> 0, T || (T = 0);
    let k;
    if (typeof T == "number")
      for (k = C; k < S; ++k)
        this[k] = T;
    else {
      const R = l.isBuffer(T) ? T : l.from(T, h), j = R.length;
      if (j === 0)
        throw new TypeError('The value "' + T + '" is invalid for argument "value"');
      for (k = 0; k < S - C; ++k)
        this[k + C] = R[k % j];
    }
    return this;
  };
  const Fe = {};
  function Xe(F, T, C) {
    Fe[F] = class extends C {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: T.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${F}]`, this.stack, delete this.name;
      }
      get code() {
        return F;
      }
      set code(h) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: h,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${F}]: ${this.message}`;
      }
    };
  }
  Xe(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(F) {
      return F ? `${F} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Xe(
    "ERR_INVALID_ARG_TYPE",
    function(F, T) {
      return `The "${F}" argument must be of type number. Received type ${typeof T}`;
    },
    TypeError
  ), Xe(
    "ERR_OUT_OF_RANGE",
    function(F, T, C) {
      let S = `The value of "${F}" is out of range.`, h = C;
      return Number.isInteger(C) && Math.abs(C) > 2 ** 32 ? h = ze(String(C)) : typeof C == "bigint" && (h = String(C), (C > BigInt(2) ** BigInt(32) || C < -(BigInt(2) ** BigInt(32))) && (h = ze(h)), h += "n"), S += ` It must be ${T}. Received ${h}`, S;
    },
    RangeError
  );
  function ze(F) {
    let T = "", C = F.length;
    const S = F[0] === "-" ? 1 : 0;
    for (; C >= S + 4; C -= 3)
      T = `_${F.slice(C - 3, C)}${T}`;
    return `${F.slice(0, C)}${T}`;
  }
  function Rt(F, T, C) {
    ye(T, "offset"), (F[T] === void 0 || F[T + C] === void 0) && W(T, F.length - (C + 1));
  }
  function Yt(F, T, C, S, h, k) {
    if (F > C || F < T) {
      const R = typeof T == "bigint" ? "n" : "";
      let j;
      throw T === 0 || T === BigInt(0) ? j = `>= 0${R} and < 2${R} ** ${(k + 1) * 8}${R}` : j = `>= -(2${R} ** ${(k + 1) * 8 - 1}${R}) and < 2 ** ${(k + 1) * 8 - 1}${R}`, new Fe.ERR_OUT_OF_RANGE("value", j, F);
    }
    Rt(S, h, k);
  }
  function ye(F, T) {
    if (typeof F != "number")
      throw new Fe.ERR_INVALID_ARG_TYPE(T, "number", F);
  }
  function W(F, T, C) {
    throw Math.floor(F) !== F ? (ye(F, C), new Fe.ERR_OUT_OF_RANGE("offset", "an integer", F)) : T < 0 ? new Fe.ERR_BUFFER_OUT_OF_BOUNDS() : new Fe.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${T}`,
      F
    );
  }
  const Y = /[^+/0-9A-Za-z-_]/g;
  function ie(F) {
    if (F = F.split("=")[0], F = F.trim().replace(Y, ""), F.length < 2) return "";
    for (; F.length % 4 !== 0; )
      F = F + "=";
    return F;
  }
  function Te(F, T) {
    T = T || 1 / 0;
    let C;
    const S = F.length;
    let h = null;
    const k = [];
    for (let R = 0; R < S; ++R) {
      if (C = F.charCodeAt(R), C > 55295 && C < 57344) {
        if (!h) {
          if (C > 56319) {
            (T -= 3) > -1 && k.push(239, 191, 189);
            continue;
          } else if (R + 1 === S) {
            (T -= 3) > -1 && k.push(239, 191, 189);
            continue;
          }
          h = C;
          continue;
        }
        if (C < 56320) {
          (T -= 3) > -1 && k.push(239, 191, 189), h = C;
          continue;
        }
        C = (h - 55296 << 10 | C - 56320) + 65536;
      } else h && (T -= 3) > -1 && k.push(239, 191, 189);
      if (h = null, C < 128) {
        if ((T -= 1) < 0) break;
        k.push(C);
      } else if (C < 2048) {
        if ((T -= 2) < 0) break;
        k.push(
          C >> 6 | 192,
          C & 63 | 128
        );
      } else if (C < 65536) {
        if ((T -= 3) < 0) break;
        k.push(
          C >> 12 | 224,
          C >> 6 & 63 | 128,
          C & 63 | 128
        );
      } else if (C < 1114112) {
        if ((T -= 4) < 0) break;
        k.push(
          C >> 18 | 240,
          C >> 12 & 63 | 128,
          C >> 6 & 63 | 128,
          C & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return k;
  }
  function $(F) {
    const T = [];
    for (let C = 0; C < F.length; ++C)
      T.push(F.charCodeAt(C) & 255);
    return T;
  }
  function _e(F, T) {
    let C, S, h;
    const k = [];
    for (let R = 0; R < F.length && !((T -= 2) < 0); ++R)
      C = F.charCodeAt(R), S = C >> 8, h = C % 256, k.push(h), k.push(S);
    return k;
  }
  function Le(F) {
    return t.toByteArray(ie(F));
  }
  function et(F, T, C, S) {
    let h;
    for (h = 0; h < S && !(h + C >= T.length || h >= F.length); ++h)
      T[h + C] = F[h];
    return h;
  }
  function Ge(F, T) {
    return F instanceof T || F != null && F.constructor != null && F.constructor.name != null && F.constructor.name === T.name;
  }
  function $t(F) {
    return F !== F;
  }
  const Be = (function() {
    const F = "0123456789abcdef", T = new Array(256);
    for (let C = 0; C < 16; ++C) {
      const S = C * 16;
      for (let h = 0; h < 16; ++h)
        T[S + h] = F[C] + F[h];
    }
    return T;
  })();
  function P(F) {
    return typeof BigInt > "u" ? N : F;
  }
  function N() {
    throw new Error("BigInt not supported");
  }
})(aA);
const qn = aA.Buffer;
var Va = {}, Sa = {}, co = {}, Ga = {}, zn = {}, Wu = {}, T5, b4;
function As() {
  if (b4) return T5;
  b4 = 1;
  function e(i) {
    if (typeof i != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
  }
  function t(i, a) {
    for (var o = "", c = 0, u = -1, s = 0, l, d = 0; d <= i.length; ++d) {
      if (d < i.length)
        l = i.charCodeAt(d);
      else {
        if (l === 47)
          break;
        l = 47;
      }
      if (l === 47) {
        if (!(u === d - 1 || s === 1)) if (u !== d - 1 && s === 2) {
          if (o.length < 2 || c !== 2 || o.charCodeAt(o.length - 1) !== 46 || o.charCodeAt(o.length - 2) !== 46) {
            if (o.length > 2) {
              var f = o.lastIndexOf("/");
              if (f !== o.length - 1) {
                f === -1 ? (o = "", c = 0) : (o = o.slice(0, f), c = o.length - 1 - o.lastIndexOf("/")), u = d, s = 0;
                continue;
              }
            } else if (o.length === 2 || o.length === 1) {
              o = "", c = 0, u = d, s = 0;
              continue;
            }
          }
          a && (o.length > 0 ? o += "/.." : o = "..", c = 2);
        } else
          o.length > 0 ? o += "/" + i.slice(u + 1, d) : o = i.slice(u + 1, d), c = d - u - 1;
        u = d, s = 0;
      } else l === 46 && s !== -1 ? ++s : s = -1;
    }
    return o;
  }
  function n(i, a) {
    var o = a.dir || a.root, c = a.base || (a.name || "") + (a.ext || "");
    return o ? o === a.root ? o + c : o + i + c : c;
  }
  var r = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var a = "", o = !1, c, u = arguments.length - 1; u >= -1 && !o; u--) {
        var s;
        u >= 0 ? s = arguments[u] : (c === void 0 && (c = gn.cwd()), s = c), e(s), s.length !== 0 && (a = s + "/" + a, o = s.charCodeAt(0) === 47);
      }
      return a = t(a, !o), o ? a.length > 0 ? "/" + a : "/" : a.length > 0 ? a : ".";
    },
    normalize: function(a) {
      if (e(a), a.length === 0) return ".";
      var o = a.charCodeAt(0) === 47, c = a.charCodeAt(a.length - 1) === 47;
      return a = t(a, !o), a.length === 0 && !o && (a = "."), a.length > 0 && c && (a += "/"), o ? "/" + a : a;
    },
    isAbsolute: function(a) {
      return e(a), a.length > 0 && a.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var a, o = 0; o < arguments.length; ++o) {
        var c = arguments[o];
        e(c), c.length > 0 && (a === void 0 ? a = c : a += "/" + c);
      }
      return a === void 0 ? "." : r.normalize(a);
    },
    relative: function(a, o) {
      if (e(a), e(o), a === o || (a = r.resolve(a), o = r.resolve(o), a === o)) return "";
      for (var c = 1; c < a.length && a.charCodeAt(c) === 47; ++c)
        ;
      for (var u = a.length, s = u - c, l = 1; l < o.length && o.charCodeAt(l) === 47; ++l)
        ;
      for (var d = o.length, f = d - l, p = s < f ? s : f, g = -1, b = 0; b <= p; ++b) {
        if (b === p) {
          if (f > p) {
            if (o.charCodeAt(l + b) === 47)
              return o.slice(l + b + 1);
            if (b === 0)
              return o.slice(l + b);
          } else s > p && (a.charCodeAt(c + b) === 47 ? g = b : b === 0 && (g = 0));
          break;
        }
        var w = a.charCodeAt(c + b), y = o.charCodeAt(l + b);
        if (w !== y)
          break;
        w === 47 && (g = b);
      }
      var v = "";
      for (b = c + g + 1; b <= u; ++b)
        (b === u || a.charCodeAt(b) === 47) && (v.length === 0 ? v += ".." : v += "/..");
      return v.length > 0 ? v + o.slice(l + g) : (l += g, o.charCodeAt(l) === 47 && ++l, o.slice(l));
    },
    _makeLong: function(a) {
      return a;
    },
    dirname: function(a) {
      if (e(a), a.length === 0) return ".";
      for (var o = a.charCodeAt(0), c = o === 47, u = -1, s = !0, l = a.length - 1; l >= 1; --l)
        if (o = a.charCodeAt(l), o === 47) {
          if (!s) {
            u = l;
            break;
          }
        } else
          s = !1;
      return u === -1 ? c ? "/" : "." : c && u === 1 ? "//" : a.slice(0, u);
    },
    basename: function(a, o) {
      if (o !== void 0 && typeof o != "string") throw new TypeError('"ext" argument must be a string');
      e(a);
      var c = 0, u = -1, s = !0, l;
      if (o !== void 0 && o.length > 0 && o.length <= a.length) {
        if (o.length === a.length && o === a) return "";
        var d = o.length - 1, f = -1;
        for (l = a.length - 1; l >= 0; --l) {
          var p = a.charCodeAt(l);
          if (p === 47) {
            if (!s) {
              c = l + 1;
              break;
            }
          } else
            f === -1 && (s = !1, f = l + 1), d >= 0 && (p === o.charCodeAt(d) ? --d === -1 && (u = l) : (d = -1, u = f));
        }
        return c === u ? u = f : u === -1 && (u = a.length), a.slice(c, u);
      } else {
        for (l = a.length - 1; l >= 0; --l)
          if (a.charCodeAt(l) === 47) {
            if (!s) {
              c = l + 1;
              break;
            }
          } else u === -1 && (s = !1, u = l + 1);
        return u === -1 ? "" : a.slice(c, u);
      }
    },
    extname: function(a) {
      e(a);
      for (var o = -1, c = 0, u = -1, s = !0, l = 0, d = a.length - 1; d >= 0; --d) {
        var f = a.charCodeAt(d);
        if (f === 47) {
          if (!s) {
            c = d + 1;
            break;
          }
          continue;
        }
        u === -1 && (s = !1, u = d + 1), f === 46 ? o === -1 ? o = d : l !== 1 && (l = 1) : o !== -1 && (l = -1);
      }
      return o === -1 || u === -1 || // We saw a non-dot character immediately before the dot
      l === 0 || // The (right-most) trimmed path component is exactly '..'
      l === 1 && o === u - 1 && o === c + 1 ? "" : a.slice(o, u);
    },
    format: function(a) {
      if (a === null || typeof a != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof a);
      return n("/", a);
    },
    parse: function(a) {
      e(a);
      var o = { root: "", dir: "", base: "", ext: "", name: "" };
      if (a.length === 0) return o;
      var c = a.charCodeAt(0), u = c === 47, s;
      u ? (o.root = "/", s = 1) : s = 0;
      for (var l = -1, d = 0, f = -1, p = !0, g = a.length - 1, b = 0; g >= s; --g) {
        if (c = a.charCodeAt(g), c === 47) {
          if (!p) {
            d = g + 1;
            break;
          }
          continue;
        }
        f === -1 && (p = !1, f = g + 1), c === 46 ? l === -1 ? l = g : b !== 1 && (b = 1) : l !== -1 && (b = -1);
      }
      return l === -1 || f === -1 || // We saw a non-dot character immediately before the dot
      b === 0 || // The (right-most) trimmed path component is exactly '..'
      b === 1 && l === f - 1 && l === d + 1 ? f !== -1 && (d === 0 && u ? o.base = o.name = a.slice(1, f) : o.base = o.name = a.slice(d, f)) : (d === 0 && u ? (o.name = a.slice(1, l), o.base = a.slice(1, f)) : (o.name = a.slice(d, l), o.base = a.slice(d, f)), o.ext = a.slice(l, f)), d > 0 ? o.dir = a.slice(0, d - 1) : u && (o.dir = "/"), o;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return r.posix = r, T5 = r, T5;
}
var x4;
function sA() {
  if (x4) return Wu;
  x4 = 1;
  var e = Wu && Wu.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Wu, "__esModule", { value: !0 }), Wu.default = n;
  const t = e(As());
  function n(r) {
    return r.startsWith("\\\\?\\") ? r : r.split(t.default?.win32?.sep).join(t.default?.posix?.sep ?? "/");
  }
  return Wu;
}
var dl = {}, _4;
function sU() {
  if (_4) return dl;
  _4 = 1, Object.defineProperty(dl, "__esModule", { value: !0 }), dl.isWindows = void 0;
  const e = /^win/.test(globalThis.process ? globalThis.process.platform : ""), t = () => e;
  return dl.isWindows = t, dl;
}
var w4;
function qa() {
  if (w4) return zn;
  w4 = 1;
  var e = zn && zn.__createBinding || (Object.create ? (function(J, ne, De, je) {
    je === void 0 && (je = De);
    var Me = Object.getOwnPropertyDescriptor(ne, De);
    (!Me || ("get" in Me ? !ne.__esModule : Me.writable || Me.configurable)) && (Me = { enumerable: !0, get: function() {
      return ne[De];
    } }), Object.defineProperty(J, je, Me);
  }) : (function(J, ne, De, je) {
    je === void 0 && (je = De), J[je] = ne[De];
  })), t = zn && zn.__setModuleDefault || (Object.create ? (function(J, ne) {
    Object.defineProperty(J, "default", { enumerable: !0, value: ne });
  }) : function(J, ne) {
    J.default = ne;
  }), n = zn && zn.__importStar || /* @__PURE__ */ (function() {
    var J = function(ne) {
      return J = Object.getOwnPropertyNames || function(De) {
        var je = [];
        for (var Me in De) Object.prototype.hasOwnProperty.call(De, Me) && (je[je.length] = Me);
        return je;
      }, J(ne);
    };
    return function(ne) {
      if (ne && ne.__esModule) return ne;
      var De = {};
      if (ne != null) for (var je = J(ne), Me = 0; Me < je.length; Me++) je[Me] !== "default" && e(De, ne, je[Me]);
      return t(De, ne), De;
    };
  })(), r = zn && zn.__importDefault || function(J) {
    return J && J.__esModule ? J : { default: J };
  };
  Object.defineProperty(zn, "__esModule", { value: !0 }), zn.parse = void 0, zn.resolve = b, zn.cwd = w, zn.getProtocol = y, zn.getExtension = v, zn.stripQuery = _, zn.getHash = E, zn.stripHash = O, zn.isHttp = M, zn.isUnsafeUrl = L, zn.isFileSystemPath = ae, zn.fromFileSystemPath = re, zn.toFileSystemPath = X, zn.safePointerToPath = de, zn.relative = Ce;
  const i = r(sA()), a = n(As()), o = /\//g, c = /^(\w{2,}):\/\//i, u = /~1/g, s = /~0/g, l = As(), d = sU(), f = [
    [/\?/g, "%3F"],
    [/#/g, "%23"]
  ], p = [/%23/g, "#", /%24/g, "$", /%26/g, "&", /%2C/g, ",", /%40/g, "@"], g = (J) => new URL(J);
  zn.parse = g;
  function b(J, ne) {
    const De = new URL((0, i.default)(J), "https://aaa.nonexistanturl.com"), je = new URL((0, i.default)(ne), De), Me = ne.match(/(\s*)$/)?.[1] || "";
    if (je.hostname === "aaa.nonexistanturl.com") {
      const { pathname: qe, search: Ve, hash: xe } = je;
      return qe + Ve + xe + Me;
    }
    return je.toString() + Me;
  }
  function w() {
    if (typeof window < "u" && window.location && window.location.href) {
      const J = window.location.href;
      if (!J || !J.startsWith("http"))
        try {
          return new URL(J), J;
        } catch {
          return "/";
        }
      return J;
    }
    if (typeof gn < "u" && gn.cwd) {
      const J = gn.cwd(), ne = J.slice(-1);
      return ne === "/" || ne === "\\" ? J : J + "/";
    }
    return "/";
  }
  function y(J) {
    const ne = c.exec(J || "");
    if (ne)
      return ne[1].toLowerCase();
  }
  function v(J) {
    const ne = J.lastIndexOf(".");
    return ne >= 0 ? _(J.substr(ne).toLowerCase()) : "";
  }
  function _(J) {
    const ne = J.indexOf("?");
    return ne >= 0 && (J = J.substr(0, ne)), J;
  }
  function E(J) {
    if (!J)
      return "#";
    const ne = J.indexOf("#");
    return ne >= 0 ? J.substring(ne) : "#";
  }
  function O(J) {
    if (!J)
      return "";
    const ne = J.indexOf("#");
    return ne >= 0 && (J = J.substring(0, ne)), J;
  }
  function M(J) {
    const ne = y(J);
    return ne === "http" || ne === "https" ? !0 : ne === void 0 ? typeof window < "u" : !1;
  }
  function L(J) {
    if (!J || typeof J != "string")
      return !0;
    const ne = J.trim().toLowerCase();
    if (!ne || ne.startsWith("javascript:") || ne.startsWith("vbscript:") || ne.startsWith("data:") || ne.startsWith("file:"))
      return !0;
    if (typeof window < "u" && window.location && window.location.href)
      return !1;
    const De = [
      // Localhost variations
      "localhost",
      "127.0.0.1",
      "::1",
      // Private IP ranges (RFC 1918)
      "10.",
      "172.16.",
      "172.17.",
      "172.18.",
      "172.19.",
      "172.20.",
      "172.21.",
      "172.22.",
      "172.23.",
      "172.24.",
      "172.25.",
      "172.26.",
      "172.27.",
      "172.28.",
      "172.29.",
      "172.30.",
      "172.31.",
      "192.168.",
      // Link-local addresses
      "169.254.",
      // Internal domains
      ".local",
      ".internal",
      ".intranet",
      ".corp",
      ".home",
      ".lan"
    ];
    try {
      const je = new URL(ne.startsWith("//") ? "http:" + ne : ne), Me = je.hostname.toLowerCase();
      for (const Ve of De)
        if (Me === Ve || Me.startsWith(Ve) || Me.endsWith(Ve))
          return !0;
      if (Z(Me))
        return !0;
      const qe = je.port;
      if (qe && Q(parseInt(qe)))
        return !0;
    } catch {
      if (ne.startsWith("/") && !ne.startsWith("//"))
        return !1;
      for (const Me of De)
        if (ne.includes(Me))
          return !0;
    }
    return !1;
  }
  function Z(J) {
    const ne = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, De = J.match(ne);
    if (!De)
      return !1;
    const [, je, Me, qe, Ve] = De.map(Number);
    return je > 255 || Me > 255 || qe > 255 || Ve > 255 ? !1 : je === 10 || je === 127 || je === 172 && Me >= 16 && Me <= 31 || je === 192 && Me === 168 || je === 169 && Me === 254;
  }
  function Q(J) {
    return [
      22,
      // SSH
      23,
      // Telnet
      25,
      // SMTP
      53,
      // DNS
      135,
      // RPC
      139,
      // NetBIOS
      445,
      // SMB
      993,
      // IMAPS
      995,
      // POP3S
      1433,
      // SQL Server
      1521,
      // Oracle
      3306,
      // MySQL
      3389,
      // RDP
      5432,
      // PostgreSQL
      5900,
      // VNC
      6379,
      // Redis
      8080,
      // Common internal web
      8443,
      // Common internal HTTPS
      9200,
      // Elasticsearch
      27017
      // MongoDB
    ].includes(J);
  }
  function ae(J) {
    if (typeof window < "u" || typeof gn < "u" && gn.browser)
      return !1;
    const ne = y(J);
    return ne === void 0 || ne === "file";
  }
  function re(J) {
    if ((0, d.isWindows)()) {
      const ne = w(), De = J.toUpperCase(), Me = (0, i.default)(ne).toUpperCase(), qe = De.includes(Me), Ve = De.includes(Me), xe = a.win32?.isAbsolute(J) || J.startsWith("http://") || J.startsWith("https://") || J.startsWith("file://");
      !(qe || Ve || xe) && !ne.startsWith("http") && (J = (0, l.join)(ne, J)), J = (0, i.default)(J);
    }
    J = encodeURI(J);
    for (const ne of f)
      J = J.replace(ne[0], ne[1]);
    return J;
  }
  function X(J, ne) {
    J = decodeURI(J);
    for (let je = 0; je < p.length; je += 2)
      J = J.replace(p[je], p[je + 1]);
    let De = J.substr(0, 7).toLowerCase() === "file://";
    return De && (J = J[7] === "/" ? J.substr(8) : J.substr(7), (0, d.isWindows)() && J[1] === "/" && (J = J[0] + ":" + J.substr(1)), ne ? J = "file:///" + J : (De = !1, J = (0, d.isWindows)() ? J : "/" + J)), (0, d.isWindows)() && !De && (J = J.replace(o, "\\"), J.substr(1, 2) === ":\\" && (J = J[0].toUpperCase() + J.substr(1))), J;
  }
  function de(J) {
    return J.length <= 1 || J[0] !== "#" || J[1] !== "/" ? [] : J.slice(2).split("/").map((ne) => decodeURIComponent(ne).replace(u, "/").replace(s, "~"));
  }
  function Ce(J, ne) {
    if (!ae(J) || !ae(ne))
      return b(J, ne);
    const De = a.default.dirname(O(J)), je = O(ne);
    return a.default.relative(De, je) + E(ne);
  }
  return zn;
}
var Wn = {}, S4;
function no() {
  if (S4) return Wn;
  S4 = 1, Object.defineProperty(Wn, "__esModule", { value: !0 }), Wn.InvalidPointerError = Wn.TimeoutError = Wn.MissingPointerError = Wn.UnmatchedResolverError = Wn.ResolverError = Wn.UnmatchedParserError = Wn.ParserError = Wn.JSONParserErrorGroup = Wn.JSONParserError = void 0, Wn.toJSON = i, Wn.getDeepKeys = a, Wn.isHandledError = b, Wn.normalizeError = w;
  const e = qa(), t = ["function", "symbol", "undefined"], n = ["constructor", "prototype", "__proto__"], r = Object.getPrototypeOf({});
  function i() {
    const y = {}, v = this;
    for (const _ of a(v))
      if (typeof _ == "string") {
        const E = v[_], O = typeof E;
        t.includes(O) || (y[_] = E);
      }
    return y;
  }
  function a(y, v = []) {
    let _ = [];
    for (; y && y !== r; )
      _ = _.concat(Object.getOwnPropertyNames(y), Object.getOwnPropertySymbols(y)), y = Object.getPrototypeOf(y);
    const E = new Set(_);
    for (const O of v.concat(n))
      E.delete(O);
    return E;
  }
  class o extends Error {
    name;
    message;
    source;
    path;
    code;
    constructor(v, _) {
      super(), this.code = "EUNKNOWN", this.name = "JSONParserError", this.message = v, this.source = _, this.path = null;
    }
    toJSON = i.bind(this);
    get footprint() {
      return `${this.path}+${this.source}+${this.code}+${this.message}`;
    }
  }
  Wn.JSONParserError = o;
  class c extends Error {
    files;
    constructor(v) {
      super(), this.files = v, this.name = "JSONParserErrorGroup", this.message = `${this.errors.length} error${this.errors.length > 1 ? "s" : ""} occurred while reading '${(0, e.toFileSystemPath)(v.$refs._root$Ref.path)}'`;
    }
    toJSON = i.bind(this);
    static getParserErrors(v) {
      const _ = [];
      for (const E of Object.values(v.$refs._$refs))
        E.errors && _.push(...E.errors);
      return _;
    }
    get errors() {
      return c.getParserErrors(this.files);
    }
  }
  Wn.JSONParserErrorGroup = c;
  class u extends o {
    code = "EPARSER";
    name = "ParserError";
    constructor(v, _) {
      super(`Error parsing ${_}: ${v}`, _);
    }
  }
  Wn.ParserError = u;
  class s extends o {
    code = "EUNMATCHEDPARSER";
    name = "UnmatchedParserError";
    constructor(v) {
      super(`Could not find parser for "${v}"`, v);
    }
  }
  Wn.UnmatchedParserError = s;
  class l extends o {
    code = "ERESOLVER";
    name = "ResolverError";
    ioErrorCode;
    constructor(v, _) {
      super(v.message || `Error reading file "${_}"`, _), "code" in v && (this.ioErrorCode = String(v.code));
    }
  }
  Wn.ResolverError = l;
  class d extends o {
    code = "EUNMATCHEDRESOLVER";
    name = "UnmatchedResolverError";
    constructor(v) {
      super(`Could not find resolver for "${v}"`, v);
    }
  }
  Wn.UnmatchedResolverError = d;
  class f extends o {
    code = "EMISSINGPOINTER";
    name = "MissingPointerError";
    targetToken;
    targetRef;
    targetFound;
    parentPath;
    constructor(v, _, E, O, M) {
      super(`Missing $ref pointer "${(0, e.getHash)(_)}". Token "${v}" does not exist.`, (0, e.stripHash)(_)), this.targetToken = v, this.targetRef = E, this.targetFound = O, this.parentPath = M;
    }
  }
  Wn.MissingPointerError = f;
  class p extends o {
    code = "ETIMEOUT";
    name = "TimeoutError";
    constructor(v) {
      super(`Dereferencing timeout reached: ${v}ms`);
    }
  }
  Wn.TimeoutError = p;
  class g extends o {
    code = "EUNMATCHEDRESOLVER";
    name = "InvalidPointerError";
    constructor(v, _) {
      super(`Invalid $ref pointer "${v}". Pointers must begin with "#/"`, (0, e.stripHash)(_));
    }
  }
  Wn.InvalidPointerError = g;
  function b(y) {
    return y instanceof o || y instanceof c;
  }
  function w(y) {
    return y.path === null && (y.path = []), y;
  }
  return Wn;
}
var C4;
function V0() {
  return C4 || (C4 = 1, (function(e) {
    var t = Ga && Ga.__createBinding || (Object.create ? (function(v, _, E, O) {
      O === void 0 && (O = E);
      var M = Object.getOwnPropertyDescriptor(_, E);
      (!M || ("get" in M ? !_.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
        return _[E];
      } }), Object.defineProperty(v, O, M);
    }) : (function(v, _, E, O) {
      O === void 0 && (O = E), v[O] = _[E];
    })), n = Ga && Ga.__setModuleDefault || (Object.create ? (function(v, _) {
      Object.defineProperty(v, "default", { enumerable: !0, value: _ });
    }) : function(v, _) {
      v.default = _;
    }), r = Ga && Ga.__importStar || /* @__PURE__ */ (function() {
      var v = function(_) {
        return v = Object.getOwnPropertyNames || function(E) {
          var O = [];
          for (var M in E) Object.prototype.hasOwnProperty.call(E, M) && (O[O.length] = M);
          return O;
        }, v(_);
      };
      return function(_) {
        if (_ && _.__esModule) return _;
        var E = {};
        if (_ != null) for (var O = v(_), M = 0; M < O.length; M++) O[M] !== "default" && t(E, _, O[M]);
        return n(E, _), E;
      };
    })(), i = Ga && Ga.__importDefault || function(v) {
      return v && v.__esModule ? v : { default: v };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.nullSymbol = void 0;
    const a = i(Vf()), o = r(qa()), c = no();
    e.nullSymbol = Symbol("null");
    const u = /\//g, s = /~/g, l = /~1/g, d = /~0/g, f = (v) => {
      try {
        return decodeURIComponent(v);
      } catch {
        return v;
      }
    };
    class p {
      /**
       * The {@link $Ref} object that contains this {@link Pointer} object.
       */
      $ref;
      /**
       * The file path or URL, containing the JSON pointer in the hash.
       * This path is relative to the path of the main JSON schema file.
       */
      path;
      /**
       * The original path or URL, used for error messages.
       */
      originalPath;
      /**
       * The value of the JSON pointer.
       * Can be any JSON type, not just objects. Unknown file types are represented as Buffers (byte arrays).
       */
      value;
      /**
       * Indicates whether the pointer references itself.
       */
      circular;
      /**
       * The number of indirect references that were traversed to resolve the value.
       * Resolving a single pointer may require resolving multiple $Refs.
       */
      indirections;
      constructor(_, E, O) {
        this.$ref = _, this.path = E, this.originalPath = O || E, this.value = void 0, this.circular = !1, this.indirections = 0;
      }
      /**
       * Resolves the value of a nested property within the given object.
       *
       * @param obj - The object that will be crawled
       * @param options
       * @param pathFromRoot - the path of place that initiated resolving
       *
       * @returns
       * Returns a JSON pointer whose {@link Pointer#value} is the resolved value.
       * If resolving this value required resolving other JSON references, then
       * the {@link Pointer#$ref} and {@link Pointer#path} will reflect the resolution path
       * of the resolved value.
       */
      resolve(_, E, O) {
        const M = p.parse(this.path, this.originalPath), L = [];
        this.value = w(_);
        for (let Z = 0; Z < M.length; Z++) {
          g(this, E, O) && (this.path = p.join(this.path, M.slice(Z)));
          const Q = M[Z];
          if (this.value[Q] === void 0 || this.value[Q] === null && Z === M.length - 1) {
            let ae = !1;
            for (let J = M.length - 1; J > Z; J--) {
              const ne = M.slice(Z, J + 1).join("/");
              if (this.value[ne] !== void 0) {
                this.value = this.value[ne], Z = J, ae = !0;
                break;
              }
            }
            if (ae)
              continue;
            if (Q in this.value && this.value[Q] === null) {
              this.value = e.nullSymbol;
              continue;
            }
            this.value = null;
            const re = this.$ref.path || "", X = this.path.replace(re, ""), de = p.join("", L), Ce = O?.replace(re, "");
            throw new c.MissingPointerError(Q, decodeURI(this.originalPath), X, de, Ce);
          } else
            this.value = this.value[Q];
          L.push(Q);
        }
        return (!this.value || this.value.$ref && o.resolve(this.path, this.value.$ref) !== O) && g(this, E, O), this;
      }
      /**
       * Sets the value of a nested property within the given object.
       *
       * @param obj - The object that will be crawled
       * @param value - the value to assign
       * @param options
       *
       * @returns
       * Returns the modified object, or an entirely new object if the entire object is overwritten.
       */
      set(_, E, O) {
        const M = p.parse(this.path);
        let L;
        if (M.length === 0)
          return this.value = E, E;
        this.value = w(_);
        for (let Z = 0; Z < M.length - 1; Z++)
          g(this, O), L = M[Z], this.value && this.value[L] !== void 0 ? this.value = this.value[L] : this.value = b(this, L, {});
        return g(this, O), L = M[M.length - 1], b(this, L, E), _;
      }
      /**
       * Parses a JSON pointer (or a path containing a JSON pointer in the hash)
       * and returns an array of the pointer's tokens.
       * (e.g. "schema.json#/definitions/person/name" => ["definitions", "person", "name"])
       *
       * The pointer is parsed according to RFC 6901
       * {@link https://tools.ietf.org/html/rfc6901#section-3}
       *
       * @param path
       * @param [originalPath]
       * @returns
       */
      static parse(_, E) {
        const O = o.getHash(_).substring(1);
        if (!O)
          return [];
        const M = O.split("/");
        for (let L = 0; L < M.length; L++)
          M[L] = f(M[L].replace(l, "/").replace(d, "~"));
        if (M[0] !== "")
          throw new c.InvalidPointerError(O, E === void 0 ? _ : E);
        return M.slice(1);
      }
      /**
       * Creates a JSON pointer path, by joining one or more tokens to a base path.
       *
       * @param base - The base path (e.g. "schema.json#/definitions/person")
       * @param tokens - The token(s) to append (e.g. ["name", "first"])
       * @returns
       */
      static join(_, E) {
        _.indexOf("#") === -1 && (_ += "#"), E = Array.isArray(E) ? E : [E];
        for (let O = 0; O < E.length; O++) {
          const M = E[O];
          _ += "/" + encodeURIComponent(M.replace(s, "~0").replace(u, "~1"));
        }
        return _;
      }
    }
    function g(v, _, E) {
      if (a.default.isAllowed$Ref(v.value, _)) {
        const O = o.resolve(v.path, v.value.$ref);
        if (O === v.path && !y(E))
          v.circular = !0;
        else {
          const M = v.$ref.$refs._resolve(O, v.path, _);
          return M === null ? !1 : (v.indirections += M.indirections + 1, a.default.isExtended$Ref(v.value) ? (v.value = a.default.dereference(v.value, M.value), !1) : (v.$ref = M.$ref, v.path = M.path, v.value = M.value, !0));
        }
      }
    }
    e.default = p;
    function b(v, _, E) {
      if (v.value && typeof v.value == "object")
        _ === "-" && Array.isArray(v.value) ? v.value.push(E) : v.value[_] = E;
      else
        throw new c.JSONParserError(`Error assigning $ref pointer "${v.path}". 
Cannot set "${_}" of a non-object.`);
      return E;
    }
    function w(v) {
      if ((0, c.isHandledError)(v))
        throw v;
      return v;
    }
    function y(v) {
      return typeof v == "string" && p.parse(v).length == 0;
    }
  })(Ga)), Ga;
}
var k4;
function Vf() {
  if (k4) return co;
  k4 = 1;
  var e = co && co.__createBinding || (Object.create ? (function(c, u, s, l) {
    l === void 0 && (l = s);
    var d = Object.getOwnPropertyDescriptor(u, s);
    (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return u[s];
    } }), Object.defineProperty(c, l, d);
  }) : (function(c, u, s, l) {
    l === void 0 && (l = s), c[l] = u[s];
  })), t = co && co.__setModuleDefault || (Object.create ? (function(c, u) {
    Object.defineProperty(c, "default", { enumerable: !0, value: u });
  }) : function(c, u) {
    c.default = u;
  }), n = co && co.__importStar || /* @__PURE__ */ (function() {
    var c = function(u) {
      return c = Object.getOwnPropertyNames || function(s) {
        var l = [];
        for (var d in s) Object.prototype.hasOwnProperty.call(s, d) && (l[l.length] = d);
        return l;
      }, c(u);
    };
    return function(u) {
      if (u && u.__esModule) return u;
      var s = {};
      if (u != null) for (var l = c(u), d = 0; d < l.length; d++) l[d] !== "default" && e(s, u, l[d]);
      return t(s, u), s;
    };
  })();
  Object.defineProperty(co, "__esModule", { value: !0 });
  const r = n(V0()), i = no(), a = qa();
  class o {
    /**
     * The file path or URL of the referenced file.
     * This path is relative to the path of the main JSON schema file.
     *
     * This path does NOT contain document fragments (JSON pointers). It always references an ENTIRE file.
     * Use methods such as {@link $Ref#get}, {@link $Ref#resolve}, and {@link $Ref#exists} to get
     * specific JSON pointers within the file.
     *
     * @type {string}
     */
    path;
    /**
     * The resolved value of the JSON reference.
     * Can be any JSON type, not just objects. Unknown file types are represented as Buffers (byte arrays).
     *
     * @type {?*}
     */
    value;
    /**
     * The {@link $Refs} object that contains this {@link $Ref} object.
     *
     * @type {$Refs}
     */
    $refs;
    /**
     * Indicates the type of {@link $Ref#path} (e.g. "file", "http", etc.)
     */
    pathType;
    /**
     * List of all errors. Undefined if no errors.
     */
    errors = [];
    constructor(u) {
      this.$refs = u;
    }
    /**
     * Pushes an error to errors array.
     *
     * @param err - The error to be pushed
     * @returns
     */
    addError(u) {
      this.errors === void 0 && (this.errors = []);
      const s = this.errors.map(({ footprint: l }) => l);
      "errors" in u && Array.isArray(u.errors) ? this.errors.push(...u.errors.map(i.normalizeError).filter(({ footprint: l }) => !s.includes(l))) : (!("footprint" in u) || !s.includes(u.footprint)) && this.errors.push((0, i.normalizeError)(u));
    }
    /**
     * Determines whether the given JSON reference exists within this {@link $Ref#value}.
     *
     * @param path - The full path being resolved, optionally with a JSON pointer in the hash
     * @param options
     * @returns
     */
    exists(u, s) {
      try {
        return this.resolve(u, s), !0;
      } catch {
        return !1;
      }
    }
    /**
     * Resolves the given JSON reference within this {@link $Ref#value} and returns the resolved value.
     *
     * @param path - The full path being resolved, optionally with a JSON pointer in the hash
     * @param options
     * @returns - Returns the resolved value
     */
    get(u, s) {
      return this.resolve(u, s)?.value;
    }
    /**
     * Resolves the given JSON reference within this {@link $Ref#value}.
     *
     * @param path - The full path being resolved, optionally with a JSON pointer in the hash
     * @param options
     * @param friendlyPath - The original user-specified path (used for error messages)
     * @param pathFromRoot - The path of `obj` from the schema root
     * @returns
     */
    resolve(u, s, l, d) {
      const f = new r.default(this, u, l);
      try {
        const p = f.resolve(this.value, s, d);
        return p.value === r.nullSymbol && (p.value = null), p;
      } catch (p) {
        if (!s || !s.continueOnError || !(0, i.isHandledError)(p))
          throw p;
        return p.path === null && (p.path = (0, a.safePointerToPath)((0, a.getHash)(d))), p instanceof i.InvalidPointerError && (p.source = decodeURI((0, a.stripHash)(d))), this.addError(p), null;
      }
    }
    /**
     * Sets the value of a nested property within this {@link $Ref#value}.
     * If the property, or any of its parents don't exist, they will be created.
     *
     * @param path - The full path of the property to set, optionally with a JSON pointer in the hash
     * @param value - The value to assign
     */
    set(u, s) {
      const l = new r.default(this, u);
      this.value = l.set(this.value, s), this.value === r.nullSymbol && (this.value = null);
    }
    /**
     * Determines whether the given value is a JSON reference.
     *
     * @param value - The value to inspect
     * @returns
     */
    static is$Ref(u) {
      return !!u && typeof u == "object" && u !== null && "$ref" in u && typeof u.$ref == "string" && u.$ref.length > 0;
    }
    /**
     * Determines whether the given value is an external JSON reference.
     *
     * @param value - The value to inspect
     * @returns
     */
    static isExternal$Ref(u) {
      return o.is$Ref(u) && u.$ref[0] !== "#";
    }
    /**
     * Determines whether the given value is a JSON reference, and whether it is allowed by the options.
     * For example, if it references an external file, then options.resolve.external must be true.
     *
     * @param value - The value to inspect
     * @param options
     * @returns
     */
    static isAllowed$Ref(u, s) {
      if (this.is$Ref(u)) {
        if (u.$ref.substring(0, 2) === "#/" || u.$ref === "#")
          return !0;
        if (u.$ref[0] !== "#" && (!s || s.resolve?.external))
          return !0;
      }
    }
    /**
     * Determines whether the given value is a JSON reference that "extends" its resolved value.
     * That is, it has extra properties (in addition to "$ref"), so rather than simply pointing to
     * an existing value, this $ref actually creates a NEW value that is a shallow copy of the resolved
     * value, plus the extra properties.
     *
     * @example: {
       person: {
         properties: {
           firstName: { type: string }
           lastName: { type: string }
         }
       }
       employee: {
         properties: {
           $ref: #/person/properties
           salary: { type: number }
         }
       }
     }
     *  In this example, "employee" is an extended $ref, since it extends "person" with an additional
     *  property (salary).  The result is a NEW value that looks like this:
     *
     *  {
     *    properties: {
     *      firstName: { type: string }
     *      lastName: { type: string }
     *      salary: { type: number }
     *    }
     *  }
     *
     * @param value - The value to inspect
     * @returns
     */
    static isExtended$Ref(u) {
      return o.is$Ref(u) && Object.keys(u).length > 1;
    }
    /**
     * Returns the resolved value of a JSON Reference.
     * If necessary, the resolved value is merged with the JSON Reference to create a new object
     *
     * @example: {
    person: {
      properties: {
        firstName: { type: string }
        lastName: { type: string }
      }
    }
    employee: {
      properties: {
        $ref: #/person/properties
        salary: { type: number }
      }
    }
    } When "person" and "employee" are merged, you end up with the following object:
     *
     *  {
     *    properties: {
     *      firstName: { type: string }
     *      lastName: { type: string }
     *      salary: { type: number }
     *    }
     *  }
     *
     * @param $ref - The JSON reference object (the one with the "$ref" property)
     * @param resolvedValue - The resolved value, which can be any type
     * @returns - Returns the dereferenced value
     */
    static dereference(u, s) {
      if (s && typeof s == "object" && o.isExtended$Ref(u)) {
        const l = {};
        for (const d of Object.keys(u))
          d !== "$ref" && (l[d] = u[d]);
        for (const d of Object.keys(s))
          d in l || (l[d] = s[d]);
        return l;
      } else
        return s;
    }
  }
  return co.default = o, co;
}
var A4;
function uU() {
  if (A4) return Sa;
  A4 = 1;
  var e = Sa && Sa.__createBinding || (Object.create ? (function(s, l, d, f) {
    f === void 0 && (f = d);
    var p = Object.getOwnPropertyDescriptor(l, d);
    (!p || ("get" in p ? !l.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return l[d];
    } }), Object.defineProperty(s, f, p);
  }) : (function(s, l, d, f) {
    f === void 0 && (f = d), s[f] = l[d];
  })), t = Sa && Sa.__setModuleDefault || (Object.create ? (function(s, l) {
    Object.defineProperty(s, "default", { enumerable: !0, value: l });
  }) : function(s, l) {
    s.default = l;
  }), n = Sa && Sa.__importStar || /* @__PURE__ */ (function() {
    var s = function(l) {
      return s = Object.getOwnPropertyNames || function(d) {
        var f = [];
        for (var p in d) Object.prototype.hasOwnProperty.call(d, p) && (f[f.length] = p);
        return f;
      }, s(l);
    };
    return function(l) {
      if (l && l.__esModule) return l;
      var d = {};
      if (l != null) for (var f = s(l), p = 0; p < f.length; p++) f[p] !== "default" && e(d, l, f[p]);
      return t(d, l), d;
    };
  })(), r = Sa && Sa.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(Sa, "__esModule", { value: !0 });
  const i = r(Vf()), a = n(qa()), o = r(sA());
  class c {
    /**
     * This property is true if the schema contains any circular references. You may want to check this property before serializing the dereferenced schema as JSON, since JSON.stringify() does not support circular references by default.
     *
     * See https://apidevtools.com/json-schema-ref-parser/docs/refs.html#circular
     */
    circular;
    /**
     * Returns the paths/URLs of all the files in your schema (including the main schema file).
     *
     * See https://apidevtools.com/json-schema-ref-parser/docs/refs.html#pathstypes
     *
     * @param types (optional) Optionally only return certain types of paths ("file", "http", etc.)
     */
    paths(...l) {
      return u(this._$refs, l.flat()).map((f) => (0, o.default)(f.decoded));
    }
    /**
     * Returns a map of paths/URLs and their correspond values.
     *
     * See https://apidevtools.com/json-schema-ref-parser/docs/refs.html#valuestypes
     *
     * @param types (optional) Optionally only return values from certain locations ("file", "http", etc.)
     */
    values(...l) {
      const d = this._$refs;
      return u(d, l.flat()).reduce((p, g) => (p[(0, o.default)(g.decoded)] = d[g.encoded].value, p), {});
    }
    /**
     * Returns `true` if the given path exists in the schema; otherwise, returns `false`
     *
     * See https://apidevtools.com/json-schema-ref-parser/docs/refs.html#existsref
     *
     * @param $ref The JSON Reference path, optionally with a JSON Pointer in the hash
     */
    /**
     * Determines whether the given JSON reference exists.
     *
     * @param path - The path being resolved, optionally with a JSON pointer in the hash
     * @param [options]
     * @returns
     */
    exists(l, d) {
      try {
        return this._resolve(l, "", d), !0;
      } catch {
        return !1;
      }
    }
    /**
     * Resolves the given JSON reference and returns the resolved value.
     *
     * @param path - The path being resolved, with a JSON pointer in the hash
     * @param [options]
     * @returns - Returns the resolved value
     */
    get(l, d) {
      return this._resolve(l, "", d).value;
    }
    /**
     * Sets the value at the given path in the schema. If the property, or any of its parents, don't exist, they will be created.
     *
     * @param path The JSON Reference path, optionally with a JSON Pointer in the hash
     * @param value The value to assign. Can be anything (object, string, number, etc.)
     */
    set(l, d) {
      const f = a.resolve(this._root$Ref.path, l), p = a.stripHash(f), g = this._$refs[p];
      if (!g)
        throw new Error(`Error resolving $ref pointer "${l}". 
"${p}" not found.`);
      g.set(f, d);
    }
    /**
     * Returns the specified {@link $Ref} object, or undefined.
     *
     * @param path - The path being resolved, optionally with a JSON pointer in the hash
     * @returns
     * @protected
     */
    _get$Ref(l) {
      l = a.resolve(this._root$Ref.path, l);
      const d = a.stripHash(l);
      return this._$refs[d];
    }
    /**
     * Creates a new {@link $Ref} object and adds it to this {@link $Refs} object.
     *
     * @param path  - The file path or URL of the referenced file
     */
    _add(l) {
      const d = a.stripHash(l), f = new i.default(this);
      return f.path = d, this._$refs[d] = f, this._root$Ref = this._root$Ref || f, f;
    }
    /**
     * Resolves the given JSON reference.
     *
     * @param path - The path being resolved, optionally with a JSON pointer in the hash
     * @param pathFromRoot - The path of `obj` from the schema root
     * @param [options]
     * @returns
     * @protected
     */
    _resolve(l, d, f) {
      const p = a.resolve(this._root$Ref.path, l), g = a.stripHash(p), b = this._$refs[g];
      if (!b)
        throw new Error(`Error resolving $ref pointer "${l}". 
"${g}" not found.`);
      return b.resolve(p, f, l, d);
    }
    /**
     * A map of paths/urls to {@link $Ref} objects
     *
     * @type {object}
     * @protected
     */
    _$refs = {};
    /**
     * The {@link $Ref} object that is the root of the JSON schema.
     *
     * @type {$Ref}
     * @protected
     */
    _root$Ref;
    constructor() {
      this.circular = !1, this._$refs = {}, this._root$Ref = null;
    }
    /**
     * Returns the paths of all the files/URLs that are referenced by the JSON schema,
     * including the schema itself.
     *
     * @param [types] - Only return paths of the given types ("file", "http", etc.)
     * @returns
     */
    /**
     * Returns the map of JSON references and their resolved values.
     *
     * @param [types] - Only return references of the given types ("file", "http", etc.)
     * @returns
     */
    /**
     * Returns a POJO (plain old JavaScript object) for serialization as JSON.
     *
     * @returns {object}
     */
    toJSON = this.values;
  }
  Sa.default = c;
  function u(s, l) {
    let d = Object.keys(s);
    return l = Array.isArray(l[0]) ? l[0] : Array.prototype.slice.call(l), l.length > 0 && l[0] && (d = d.filter((f) => l.includes(s[f].pathType))), d.map((f) => ({
      encoded: f,
      decoded: s[f].pathType === "file" ? a.toFileSystemPath(f, !0) : f
    }));
  }
  return Sa;
}
var lo = {}, zs = {}, E4;
function cU() {
  if (E4) return zs;
  E4 = 1, Object.defineProperty(zs, "__esModule", { value: !0 }), zs.all = e, zs.filter = t, zs.sort = n, zs.run = r;
  function e(a) {
    return Object.keys(a || {}).filter((o) => typeof a[o] == "object").map((o) => (a[o].name = o, a[o]));
  }
  function t(a, o, c) {
    return a.filter((u) => !!i(u, o, c));
  }
  function n(a) {
    for (const o of a)
      o.order = o.order || Number.MAX_SAFE_INTEGER;
    return a.sort((o, c) => o.order - c.order);
  }
  async function r(a, o, c, u) {
    let s, l, d = 0;
    return new Promise((f, p) => {
      g();
      function g() {
        if (s = a[d++], !s)
          return p(l);
        try {
          const v = i(s, o, c, b, u);
          if (v && typeof v.then == "function")
            v.then(w, y);
          else if (v !== void 0)
            w(v);
          else if (d === a.length)
            throw new Error("No promise has been returned or callback has been called.");
        } catch (v) {
          y(v);
        }
      }
      function b(v, _) {
        v ? y(v) : w(_);
      }
      function w(v) {
        f({
          plugin: s,
          result: v
        });
      }
      function y(v) {
        l = {
          plugin: s,
          error: v
        }, g();
      }
    });
  }
  function i(a, o, c, u, s) {
    const l = a[o];
    if (typeof l == "function")
      return l.apply(a, [c, u, s]);
    if (!u) {
      if (l instanceof RegExp)
        return l.test(c.url);
      if (typeof l == "string")
        return l === c.extension;
      if (Array.isArray(l))
        return l.indexOf(c.extension) !== -1;
    }
    return l;
  }
  return zs;
}
var O4;
function uA() {
  if (O4) return lo;
  O4 = 1;
  var e = lo && lo.__createBinding || (Object.create ? (function(l, d, f, p) {
    p === void 0 && (p = f);
    var g = Object.getOwnPropertyDescriptor(d, f);
    (!g || ("get" in g ? !d.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return d[f];
    } }), Object.defineProperty(l, p, g);
  }) : (function(l, d, f, p) {
    p === void 0 && (p = f), l[p] = d[f];
  })), t = lo && lo.__setModuleDefault || (Object.create ? (function(l, d) {
    Object.defineProperty(l, "default", { enumerable: !0, value: d });
  }) : function(l, d) {
    l.default = d;
  }), n = lo && lo.__importStar || /* @__PURE__ */ (function() {
    var l = function(d) {
      return l = Object.getOwnPropertyNames || function(f) {
        var p = [];
        for (var g in f) Object.prototype.hasOwnProperty.call(f, g) && (p[p.length] = g);
        return p;
      }, l(d);
    };
    return function(d) {
      if (d && d.__esModule) return d;
      var f = {};
      if (d != null) for (var p = l(d), g = 0; g < p.length; g++) p[g] !== "default" && e(f, d, p[g]);
      return t(f, d), f;
    };
  })();
  Object.defineProperty(lo, "__esModule", { value: !0 });
  const r = n(qa()), i = n(cU()), a = no();
  async function o(l, d, f) {
    const p = l.indexOf("#");
    let g = "";
    p >= 0 && (g = l.substring(p), l = l.substring(0, p));
    const b = d._add(l), w = {
      url: l,
      hash: g,
      extension: r.getExtension(l)
    };
    try {
      const y = await c(w, f, d);
      b.pathType = y.plugin.name, w.data = y.result;
      const v = await u(w, f, d);
      return b.value = v.result, v.result;
    } catch (y) {
      throw (0, a.isHandledError)(y) && (b.value = y), y;
    }
  }
  async function c(l, d, f) {
    let p = i.all(d.resolve);
    p = i.filter(p, "canRead", l), i.sort(p);
    try {
      return await i.run(p, "read", l, f);
    } catch (g) {
      throw !g && d.continueOnError ? new a.UnmatchedResolverError(l.url) : !g || !("error" in g) ? new SyntaxError(`Unable to resolve $ref pointer "${l.url}"`) : g.error instanceof a.ResolverError ? g.error : new a.ResolverError(g, l.url);
    }
  }
  async function u(l, d, f) {
    const p = i.all(d.parse), g = i.filter(p, "canParse", l), b = g.length > 0 ? g : p;
    i.sort(b);
    try {
      const w = await i.run(b, "parse", l, f);
      if (!w.plugin.allowEmpty && s(w.result))
        throw new SyntaxError(`Error parsing "${l.url}" as ${w.plugin.name}. 
Parsed value is empty`);
      return w;
    } catch (w) {
      throw !w && d.continueOnError ? new a.UnmatchedParserError(l.url) : w && w.message && w.message.startsWith("Error parsing") ? w : !w || !("error" in w) ? new SyntaxError(`Unable to parse ${l.url}`) : w.error instanceof a.ParserError ? w.error : new a.ParserError(w.error.message, l.url);
    }
  }
  function s(l) {
    return l === void 0 || typeof l == "object" && Object.keys(l).length === 0 || typeof l == "string" && l.trim().length === 0 || qn.isBuffer(l) && l.length === 0;
  }
  return lo.default = o, lo;
}
var hl = {}, ml = {}, dd = {}, T4;
function lU() {
  if (T4) return dd;
  T4 = 1, Object.defineProperty(dd, "__esModule", { value: !0 });
  const e = no();
  return dd.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 100,
    /**
     * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
     */
    allowEmpty: !0,
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that match will be tried, in order, until one successfully parses the file.
     * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
     * every parser will be tried.
     */
    canParse: ".json",
    /**
     * Allow JSON files with byte order marks (BOM)
     */
    allowBOM: !0,
    /**
     * Parses the given file as JSON
     */
    async parse(t) {
      let n = t.data;
      if (qn.isBuffer(n) && (n = n.toString()), typeof n == "string") {
        if (n.trim().length === 0)
          return;
        try {
          return JSON.parse(n);
        } catch (r) {
          if (this.allowBOM)
            try {
              const i = n.indexOf("{");
              return n = n.slice(i), JSON.parse(n);
            } catch (i) {
              throw new e.ParserError(i.message, t.url);
            }
          throw new e.ParserError(r.message, t.url);
        }
      } else
        return n;
    }
  }, dd;
}
var Ku = {}, Ti = {}, hd = {}, gs = {}, P4;
function Gf() {
  if (P4) return gs;
  P4 = 1;
  function e(o) {
    return typeof o > "u" || o === null;
  }
  function t(o) {
    return typeof o == "object" && o !== null;
  }
  function n(o) {
    return Array.isArray(o) ? o : e(o) ? [] : [o];
  }
  function r(o, c) {
    var u, s, l, d;
    if (c)
      for (d = Object.keys(c), u = 0, s = d.length; u < s; u += 1)
        l = d[u], o[l] = c[l];
    return o;
  }
  function i(o, c) {
    var u = "", s;
    for (s = 0; s < c; s += 1)
      u += o;
    return u;
  }
  function a(o) {
    return o === 0 && Number.NEGATIVE_INFINITY === 1 / o;
  }
  return gs.isNothing = e, gs.isObject = t, gs.toArray = n, gs.repeat = i, gs.isNegativeZero = a, gs.extend = r, gs;
}
var P5, R4;
function Wf() {
  if (R4) return P5;
  R4 = 1;
  function e(n, r) {
    var i = "", a = n.reason || "(unknown reason)";
    return n.mark ? (n.mark.name && (i += 'in "' + n.mark.name + '" '), i += "(" + (n.mark.line + 1) + ":" + (n.mark.column + 1) + ")", !r && n.mark.snippet && (i += `

` + n.mark.snippet), a + " " + i) : a;
  }
  function t(n, r) {
    Error.call(this), this.name = "YAMLException", this.reason = n, this.mark = r, this.message = e(this, !1), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
  }
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t.prototype.toString = function(r) {
    return this.name + ": " + e(this, r);
  }, P5 = t, P5;
}
var R5, I4;
function fU() {
  if (I4) return R5;
  I4 = 1;
  var e = Gf();
  function t(i, a, o, c, u) {
    var s = "", l = "", d = Math.floor(u / 2) - 1;
    return c - a > d && (s = " ... ", a = c - d + s.length), o - c > d && (l = " ...", o = c + d - l.length), {
      str: s + i.slice(a, o).replace(/\t/g, "→") + l,
      pos: c - a + s.length
      // relative position
    };
  }
  function n(i, a) {
    return e.repeat(" ", a - i.length) + i;
  }
  function r(i, a) {
    if (a = Object.create(a || null), !i.buffer) return null;
    a.maxLength || (a.maxLength = 79), typeof a.indent != "number" && (a.indent = 1), typeof a.linesBefore != "number" && (a.linesBefore = 3), typeof a.linesAfter != "number" && (a.linesAfter = 2);
    for (var o = /\r?\n|\r|\0/g, c = [0], u = [], s, l = -1; s = o.exec(i.buffer); )
      u.push(s.index), c.push(s.index + s[0].length), i.position <= s.index && l < 0 && (l = c.length - 2);
    l < 0 && (l = c.length - 1);
    var d = "", f, p, g = Math.min(i.line + a.linesAfter, u.length).toString().length, b = a.maxLength - (a.indent + g + 3);
    for (f = 1; f <= a.linesBefore && !(l - f < 0); f++)
      p = t(
        i.buffer,
        c[l - f],
        u[l - f],
        i.position - (c[l] - c[l - f]),
        b
      ), d = e.repeat(" ", a.indent) + n((i.line - f + 1).toString(), g) + " | " + p.str + `
` + d;
    for (p = t(i.buffer, c[l], u[l], i.position, b), d += e.repeat(" ", a.indent) + n((i.line + 1).toString(), g) + " | " + p.str + `
`, d += e.repeat("-", a.indent + g + 3 + p.pos) + `^
`, f = 1; f <= a.linesAfter && !(l + f >= u.length); f++)
      p = t(
        i.buffer,
        c[l + f],
        u[l + f],
        i.position - (c[l] - c[l + f]),
        b
      ), d += e.repeat(" ", a.indent) + n((i.line + f + 1).toString(), g) + " | " + p.str + `
`;
    return d.replace(/\n$/, "");
  }
  return R5 = r, R5;
}
var I5, j4;
function Gi() {
  if (j4) return I5;
  j4 = 1;
  var e = Wf(), t = [
    "kind",
    "multi",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "representName",
    "defaultStyle",
    "styleAliases"
  ], n = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function r(a) {
    var o = {};
    return a !== null && Object.keys(a).forEach(function(c) {
      a[c].forEach(function(u) {
        o[String(u)] = c;
      });
    }), o;
  }
  function i(a, o) {
    if (o = o || {}, Object.keys(o).forEach(function(c) {
      if (t.indexOf(c) === -1)
        throw new e('Unknown option "' + c + '" is met in definition of "' + a + '" YAML type.');
    }), this.options = o, this.tag = a, this.kind = o.kind || null, this.resolve = o.resolve || function() {
      return !0;
    }, this.construct = o.construct || function(c) {
      return c;
    }, this.instanceOf = o.instanceOf || null, this.predicate = o.predicate || null, this.represent = o.represent || null, this.representName = o.representName || null, this.defaultStyle = o.defaultStyle || null, this.multi = o.multi || !1, this.styleAliases = r(o.styleAliases || null), n.indexOf(this.kind) === -1)
      throw new e('Unknown kind "' + this.kind + '" is specified for "' + a + '" YAML type.');
  }
  return I5 = i, I5;
}
var j5, q4;
function cA() {
  if (q4) return j5;
  q4 = 1;
  var e = Wf(), t = Gi();
  function n(a, o) {
    var c = [];
    return a[o].forEach(function(u) {
      var s = c.length;
      c.forEach(function(l, d) {
        l.tag === u.tag && l.kind === u.kind && l.multi === u.multi && (s = d);
      }), c[s] = u;
    }), c;
  }
  function r() {
    var a = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {},
      multi: {
        scalar: [],
        sequence: [],
        mapping: [],
        fallback: []
      }
    }, o, c;
    function u(s) {
      s.multi ? (a.multi[s.kind].push(s), a.multi.fallback.push(s)) : a[s.kind][s.tag] = a.fallback[s.tag] = s;
    }
    for (o = 0, c = arguments.length; o < c; o += 1)
      arguments[o].forEach(u);
    return a;
  }
  function i(a) {
    return this.extend(a);
  }
  return i.prototype.extend = function(o) {
    var c = [], u = [];
    if (o instanceof t)
      u.push(o);
    else if (Array.isArray(o))
      u = u.concat(o);
    else if (o && (Array.isArray(o.implicit) || Array.isArray(o.explicit)))
      o.implicit && (c = c.concat(o.implicit)), o.explicit && (u = u.concat(o.explicit));
    else
      throw new e("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    c.forEach(function(l) {
      if (!(l instanceof t))
        throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
      if (l.loadKind && l.loadKind !== "scalar")
        throw new e("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
      if (l.multi)
        throw new e("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
    }), u.forEach(function(l) {
      if (!(l instanceof t))
        throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    });
    var s = Object.create(i.prototype);
    return s.implicit = (this.implicit || []).concat(c), s.explicit = (this.explicit || []).concat(u), s.compiledImplicit = n(s, "implicit"), s.compiledExplicit = n(s, "explicit"), s.compiledTypeMap = r(s.compiledImplicit, s.compiledExplicit), s;
  }, j5 = i, j5;
}
var q5, D4;
function lA() {
  if (D4) return q5;
  D4 = 1;
  var e = Gi();
  return q5 = new e("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(t) {
      return t !== null ? t : "";
    }
  }), q5;
}
var D5, $4;
function fA() {
  if ($4) return D5;
  $4 = 1;
  var e = Gi();
  return D5 = new e("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(t) {
      return t !== null ? t : [];
    }
  }), D5;
}
var $5, L4;
function pA() {
  if (L4) return $5;
  L4 = 1;
  var e = Gi();
  return $5 = new e("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(t) {
      return t !== null ? t : {};
    }
  }), $5;
}
var L5, N4;
function dA() {
  if (N4) return L5;
  N4 = 1;
  var e = cA();
  return L5 = new e({
    explicit: [
      lA(),
      fA(),
      pA()
    ]
  }), L5;
}
var N5, F4;
function hA() {
  if (F4) return N5;
  F4 = 1;
  var e = Gi();
  function t(i) {
    if (i === null) return !0;
    var a = i.length;
    return a === 1 && i === "~" || a === 4 && (i === "null" || i === "Null" || i === "NULL");
  }
  function n() {
    return null;
  }
  function r(i) {
    return i === null;
  }
  return N5 = new e("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      },
      empty: function() {
        return "";
      }
    },
    defaultStyle: "lowercase"
  }), N5;
}
var F5, M4;
function mA() {
  if (M4) return F5;
  M4 = 1;
  var e = Gi();
  function t(i) {
    if (i === null) return !1;
    var a = i.length;
    return a === 4 && (i === "true" || i === "True" || i === "TRUE") || a === 5 && (i === "false" || i === "False" || i === "FALSE");
  }
  function n(i) {
    return i === "true" || i === "True" || i === "TRUE";
  }
  function r(i) {
    return Object.prototype.toString.call(i) === "[object Boolean]";
  }
  return F5 = new e("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      lowercase: function(i) {
        return i ? "true" : "false";
      },
      uppercase: function(i) {
        return i ? "TRUE" : "FALSE";
      },
      camelcase: function(i) {
        return i ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  }), F5;
}
var M5, B4;
function gA() {
  if (B4) return M5;
  B4 = 1;
  var e = Gf(), t = Gi();
  function n(u) {
    return 48 <= u && u <= 57 || 65 <= u && u <= 70 || 97 <= u && u <= 102;
  }
  function r(u) {
    return 48 <= u && u <= 55;
  }
  function i(u) {
    return 48 <= u && u <= 57;
  }
  function a(u) {
    if (u === null) return !1;
    var s = u.length, l = 0, d = !1, f;
    if (!s) return !1;
    if (f = u[l], (f === "-" || f === "+") && (f = u[++l]), f === "0") {
      if (l + 1 === s) return !0;
      if (f = u[++l], f === "b") {
        for (l++; l < s; l++)
          if (f = u[l], f !== "_") {
            if (f !== "0" && f !== "1") return !1;
            d = !0;
          }
        return d && f !== "_";
      }
      if (f === "x") {
        for (l++; l < s; l++)
          if (f = u[l], f !== "_") {
            if (!n(u.charCodeAt(l))) return !1;
            d = !0;
          }
        return d && f !== "_";
      }
      if (f === "o") {
        for (l++; l < s; l++)
          if (f = u[l], f !== "_") {
            if (!r(u.charCodeAt(l))) return !1;
            d = !0;
          }
        return d && f !== "_";
      }
    }
    if (f === "_") return !1;
    for (; l < s; l++)
      if (f = u[l], f !== "_") {
        if (!i(u.charCodeAt(l)))
          return !1;
        d = !0;
      }
    return !(!d || f === "_");
  }
  function o(u) {
    var s = u, l = 1, d;
    if (s.indexOf("_") !== -1 && (s = s.replace(/_/g, "")), d = s[0], (d === "-" || d === "+") && (d === "-" && (l = -1), s = s.slice(1), d = s[0]), s === "0") return 0;
    if (d === "0") {
      if (s[1] === "b") return l * parseInt(s.slice(2), 2);
      if (s[1] === "x") return l * parseInt(s.slice(2), 16);
      if (s[1] === "o") return l * parseInt(s.slice(2), 8);
    }
    return l * parseInt(s, 10);
  }
  function c(u) {
    return Object.prototype.toString.call(u) === "[object Number]" && u % 1 === 0 && !e.isNegativeZero(u);
  }
  return M5 = new t("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: a,
    construct: o,
    predicate: c,
    represent: {
      binary: function(u) {
        return u >= 0 ? "0b" + u.toString(2) : "-0b" + u.toString(2).slice(1);
      },
      octal: function(u) {
        return u >= 0 ? "0o" + u.toString(8) : "-0o" + u.toString(8).slice(1);
      },
      decimal: function(u) {
        return u.toString(10);
      },
      /* eslint-disable max-len */
      hexadecimal: function(u) {
        return u >= 0 ? "0x" + u.toString(16).toUpperCase() : "-0x" + u.toString(16).toUpperCase().slice(1);
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }), M5;
}
var B5, U4;
function vA() {
  if (U4) return B5;
  U4 = 1;
  var e = Gf(), t = Gi(), n = new RegExp(
    // 2.5e4, 2.5 and integers
    "^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"
  );
  function r(u) {
    return !(u === null || !n.test(u) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    u[u.length - 1] === "_");
  }
  function i(u) {
    var s, l;
    return s = u.replace(/_/g, "").toLowerCase(), l = s[0] === "-" ? -1 : 1, "+-".indexOf(s[0]) >= 0 && (s = s.slice(1)), s === ".inf" ? l === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : s === ".nan" ? NaN : l * parseFloat(s, 10);
  }
  var a = /^[-+]?[0-9]+e/;
  function o(u, s) {
    var l;
    if (isNaN(u))
      switch (s) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    else if (Number.POSITIVE_INFINITY === u)
      switch (s) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    else if (Number.NEGATIVE_INFINITY === u)
      switch (s) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    else if (e.isNegativeZero(u))
      return "-0.0";
    return l = u.toString(10), a.test(l) ? l.replace("e", ".e") : l;
  }
  function c(u) {
    return Object.prototype.toString.call(u) === "[object Number]" && (u % 1 !== 0 || e.isNegativeZero(u));
  }
  return B5 = new t("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: r,
    construct: i,
    predicate: c,
    represent: o,
    defaultStyle: "lowercase"
  }), B5;
}
var U5, H4;
function yA() {
  return H4 || (H4 = 1, U5 = dA().extend({
    implicit: [
      hA(),
      mA(),
      gA(),
      vA()
    ]
  })), U5;
}
var H5, z4;
function bA() {
  return z4 || (z4 = 1, H5 = yA()), H5;
}
var z5, V4;
function xA() {
  if (V4) return z5;
  V4 = 1;
  var e = Gi(), t = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"
  ), n = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"
  );
  function r(o) {
    return o === null ? !1 : t.exec(o) !== null || n.exec(o) !== null;
  }
  function i(o) {
    var c, u, s, l, d, f, p, g = 0, b = null, w, y, v;
    if (c = t.exec(o), c === null && (c = n.exec(o)), c === null) throw new Error("Date resolve error");
    if (u = +c[1], s = +c[2] - 1, l = +c[3], !c[4])
      return new Date(Date.UTC(u, s, l));
    if (d = +c[4], f = +c[5], p = +c[6], c[7]) {
      for (g = c[7].slice(0, 3); g.length < 3; )
        g += "0";
      g = +g;
    }
    return c[9] && (w = +c[10], y = +(c[11] || 0), b = (w * 60 + y) * 6e4, c[9] === "-" && (b = -b)), v = new Date(Date.UTC(u, s, l, d, f, p, g)), b && v.setTime(v.getTime() - b), v;
  }
  function a(o) {
    return o.toISOString();
  }
  return z5 = new e("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: r,
    construct: i,
    instanceOf: Date,
    represent: a
  }), z5;
}
var V5, G4;
function _A() {
  if (G4) return V5;
  G4 = 1;
  var e = Gi();
  function t(n) {
    return n === "<<" || n === null;
  }
  return V5 = new e("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: t
  }), V5;
}
var G5, W4;
function wA() {
  if (W4) return G5;
  W4 = 1;
  var e = Gi(), t = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function n(o) {
    if (o === null) return !1;
    var c, u, s = 0, l = o.length, d = t;
    for (u = 0; u < l; u++)
      if (c = d.indexOf(o.charAt(u)), !(c > 64)) {
        if (c < 0) return !1;
        s += 6;
      }
    return s % 8 === 0;
  }
  function r(o) {
    var c, u, s = o.replace(/[\r\n=]/g, ""), l = s.length, d = t, f = 0, p = [];
    for (c = 0; c < l; c++)
      c % 4 === 0 && c && (p.push(f >> 16 & 255), p.push(f >> 8 & 255), p.push(f & 255)), f = f << 6 | d.indexOf(s.charAt(c));
    return u = l % 4 * 6, u === 0 ? (p.push(f >> 16 & 255), p.push(f >> 8 & 255), p.push(f & 255)) : u === 18 ? (p.push(f >> 10 & 255), p.push(f >> 2 & 255)) : u === 12 && p.push(f >> 4 & 255), new Uint8Array(p);
  }
  function i(o) {
    var c = "", u = 0, s, l, d = o.length, f = t;
    for (s = 0; s < d; s++)
      s % 3 === 0 && s && (c += f[u >> 18 & 63], c += f[u >> 12 & 63], c += f[u >> 6 & 63], c += f[u & 63]), u = (u << 8) + o[s];
    return l = d % 3, l === 0 ? (c += f[u >> 18 & 63], c += f[u >> 12 & 63], c += f[u >> 6 & 63], c += f[u & 63]) : l === 2 ? (c += f[u >> 10 & 63], c += f[u >> 4 & 63], c += f[u << 2 & 63], c += f[64]) : l === 1 && (c += f[u >> 2 & 63], c += f[u << 4 & 63], c += f[64], c += f[64]), c;
  }
  function a(o) {
    return Object.prototype.toString.call(o) === "[object Uint8Array]";
  }
  return G5 = new e("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: n,
    construct: r,
    predicate: a,
    represent: i
  }), G5;
}
var W5, K4;
function SA() {
  if (K4) return W5;
  K4 = 1;
  var e = Gi(), t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  function r(a) {
    if (a === null) return !0;
    var o = [], c, u, s, l, d, f = a;
    for (c = 0, u = f.length; c < u; c += 1) {
      if (s = f[c], d = !1, n.call(s) !== "[object Object]") return !1;
      for (l in s)
        if (t.call(s, l))
          if (!d) d = !0;
          else return !1;
      if (!d) return !1;
      if (o.indexOf(l) === -1) o.push(l);
      else return !1;
    }
    return !0;
  }
  function i(a) {
    return a !== null ? a : [];
  }
  return W5 = new e("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: r,
    construct: i
  }), W5;
}
var K5, Z4;
function CA() {
  if (Z4) return K5;
  Z4 = 1;
  var e = Gi(), t = Object.prototype.toString;
  function n(i) {
    if (i === null) return !0;
    var a, o, c, u, s, l = i;
    for (s = new Array(l.length), a = 0, o = l.length; a < o; a += 1) {
      if (c = l[a], t.call(c) !== "[object Object]" || (u = Object.keys(c), u.length !== 1)) return !1;
      s[a] = [u[0], c[u[0]]];
    }
    return !0;
  }
  function r(i) {
    if (i === null) return [];
    var a, o, c, u, s, l = i;
    for (s = new Array(l.length), a = 0, o = l.length; a < o; a += 1)
      c = l[a], u = Object.keys(c), s[a] = [u[0], c[u[0]]];
    return s;
  }
  return K5 = new e("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: n,
    construct: r
  }), K5;
}
var Z5, Y4;
function kA() {
  if (Y4) return Z5;
  Y4 = 1;
  var e = Gi(), t = Object.prototype.hasOwnProperty;
  function n(i) {
    if (i === null) return !0;
    var a, o = i;
    for (a in o)
      if (t.call(o, a) && o[a] !== null)
        return !1;
    return !0;
  }
  function r(i) {
    return i !== null ? i : {};
  }
  return Z5 = new e("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: n,
    construct: r
  }), Z5;
}
var Y5, J4;
function $2() {
  return J4 || (J4 = 1, Y5 = bA().extend({
    implicit: [
      xA(),
      _A()
    ],
    explicit: [
      wA(),
      SA(),
      CA(),
      kA()
    ]
  })), Y5;
}
var Q4;
function pU() {
  if (Q4) return hd;
  Q4 = 1;
  var e = Gf(), t = Wf(), n = fU(), r = $2(), i = Object.prototype.hasOwnProperty, a = 1, o = 2, c = 3, u = 4, s = 1, l = 2, d = 3, f = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, p = /[\x85\u2028\u2029]/, g = /[,\[\]\{\}]/, b = /^(?:!|!!|![a-z\-]+!)$/i, w = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
  function y($) {
    return Object.prototype.toString.call($);
  }
  function v($) {
    return $ === 10 || $ === 13;
  }
  function _($) {
    return $ === 9 || $ === 32;
  }
  function E($) {
    return $ === 9 || $ === 32 || $ === 10 || $ === 13;
  }
  function O($) {
    return $ === 44 || $ === 91 || $ === 93 || $ === 123 || $ === 125;
  }
  function M($) {
    var _e;
    return 48 <= $ && $ <= 57 ? $ - 48 : (_e = $ | 32, 97 <= _e && _e <= 102 ? _e - 97 + 10 : -1);
  }
  function L($) {
    return $ === 120 ? 2 : $ === 117 ? 4 : $ === 85 ? 8 : 0;
  }
  function Z($) {
    return 48 <= $ && $ <= 57 ? $ - 48 : -1;
  }
  function Q($) {
    return $ === 48 ? "\0" : $ === 97 ? "\x07" : $ === 98 ? "\b" : $ === 116 || $ === 9 ? "	" : $ === 110 ? `
` : $ === 118 ? "\v" : $ === 102 ? "\f" : $ === 114 ? "\r" : $ === 101 ? "\x1B" : $ === 32 ? " " : $ === 34 ? '"' : $ === 47 ? "/" : $ === 92 ? "\\" : $ === 78 ? "" : $ === 95 ? " " : $ === 76 ? "\u2028" : $ === 80 ? "\u2029" : "";
  }
  function ae($) {
    return $ <= 65535 ? String.fromCharCode($) : String.fromCharCode(
      ($ - 65536 >> 10) + 55296,
      ($ - 65536 & 1023) + 56320
    );
  }
  for (var re = new Array(256), X = new Array(256), de = 0; de < 256; de++)
    re[de] = Q(de) ? 1 : 0, X[de] = Q(de);
  function Ce($, _e) {
    this.input = $, this.filename = _e.filename || null, this.schema = _e.schema || r, this.onWarning = _e.onWarning || null, this.legacy = _e.legacy || !1, this.json = _e.json || !1, this.listener = _e.listener || null, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = $.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.firstTabInLine = -1, this.documents = [];
  }
  function J($, _e) {
    var Le = {
      name: $.filename,
      buffer: $.input.slice(0, -1),
      // omit trailing \0
      position: $.position,
      line: $.line,
      column: $.position - $.lineStart
    };
    return Le.snippet = n(Le), new t(_e, Le);
  }
  function ne($, _e) {
    throw J($, _e);
  }
  function De($, _e) {
    $.onWarning && $.onWarning.call(null, J($, _e));
  }
  var je = {
    YAML: function(_e, Le, et) {
      var Ge, $t, Be;
      _e.version !== null && ne(_e, "duplication of %YAML directive"), et.length !== 1 && ne(_e, "YAML directive accepts exactly one argument"), Ge = /^([0-9]+)\.([0-9]+)$/.exec(et[0]), Ge === null && ne(_e, "ill-formed argument of the YAML directive"), $t = parseInt(Ge[1], 10), Be = parseInt(Ge[2], 10), $t !== 1 && ne(_e, "unacceptable YAML version of the document"), _e.version = et[0], _e.checkLineBreaks = Be < 2, Be !== 1 && Be !== 2 && De(_e, "unsupported YAML version of the document");
    },
    TAG: function(_e, Le, et) {
      var Ge, $t;
      et.length !== 2 && ne(_e, "TAG directive accepts exactly two arguments"), Ge = et[0], $t = et[1], b.test(Ge) || ne(_e, "ill-formed tag handle (first argument) of the TAG directive"), i.call(_e.tagMap, Ge) && ne(_e, 'there is a previously declared suffix for "' + Ge + '" tag handle'), w.test($t) || ne(_e, "ill-formed tag prefix (second argument) of the TAG directive");
      try {
        $t = decodeURIComponent($t);
      } catch {
        ne(_e, "tag prefix is malformed: " + $t);
      }
      _e.tagMap[Ge] = $t;
    }
  };
  function Me($, _e, Le, et) {
    var Ge, $t, Be, P;
    if (_e < Le) {
      if (P = $.input.slice(_e, Le), et)
        for (Ge = 0, $t = P.length; Ge < $t; Ge += 1)
          Be = P.charCodeAt(Ge), Be === 9 || 32 <= Be && Be <= 1114111 || ne($, "expected valid JSON character");
      else f.test(P) && ne($, "the stream contains non-printable characters");
      $.result += P;
    }
  }
  function qe($, _e, Le, et) {
    var Ge, $t, Be, P;
    for (e.isObject(Le) || ne($, "cannot merge mappings; the provided source object is unacceptable"), Ge = Object.keys(Le), Be = 0, P = Ge.length; Be < P; Be += 1)
      $t = Ge[Be], i.call(_e, $t) || (_e[$t] = Le[$t], et[$t] = !0);
  }
  function Ve($, _e, Le, et, Ge, $t, Be, P, N) {
    var F, T;
    if (Array.isArray(Ge))
      for (Ge = Array.prototype.slice.call(Ge), F = 0, T = Ge.length; F < T; F += 1)
        Array.isArray(Ge[F]) && ne($, "nested arrays are not supported inside keys"), typeof Ge == "object" && y(Ge[F]) === "[object Object]" && (Ge[F] = "[object Object]");
    if (typeof Ge == "object" && y(Ge) === "[object Object]" && (Ge = "[object Object]"), Ge = String(Ge), _e === null && (_e = {}), et === "tag:yaml.org,2002:merge")
      if (Array.isArray($t))
        for (F = 0, T = $t.length; F < T; F += 1)
          qe($, _e, $t[F], Le);
      else
        qe($, _e, $t, Le);
    else
      !$.json && !i.call(Le, Ge) && i.call(_e, Ge) && ($.line = Be || $.line, $.lineStart = P || $.lineStart, $.position = N || $.position, ne($, "duplicated mapping key")), Ge === "__proto__" ? Object.defineProperty(_e, Ge, {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        value: $t
      }) : _e[Ge] = $t, delete Le[Ge];
    return _e;
  }
  function xe($) {
    var _e;
    _e = $.input.charCodeAt($.position), _e === 10 ? $.position++ : _e === 13 ? ($.position++, $.input.charCodeAt($.position) === 10 && $.position++) : ne($, "a line break is expected"), $.line += 1, $.lineStart = $.position, $.firstTabInLine = -1;
  }
  function ve($, _e, Le) {
    for (var et = 0, Ge = $.input.charCodeAt($.position); Ge !== 0; ) {
      for (; _(Ge); )
        Ge === 9 && $.firstTabInLine === -1 && ($.firstTabInLine = $.position), Ge = $.input.charCodeAt(++$.position);
      if (_e && Ge === 35)
        do
          Ge = $.input.charCodeAt(++$.position);
        while (Ge !== 10 && Ge !== 13 && Ge !== 0);
      if (v(Ge))
        for (xe($), Ge = $.input.charCodeAt($.position), et++, $.lineIndent = 0; Ge === 32; )
          $.lineIndent++, Ge = $.input.charCodeAt(++$.position);
      else
        break;
    }
    return Le !== -1 && et !== 0 && $.lineIndent < Le && De($, "deficient indentation"), et;
  }
  function Ae($) {
    var _e = $.position, Le;
    return Le = $.input.charCodeAt(_e), !!((Le === 45 || Le === 46) && Le === $.input.charCodeAt(_e + 1) && Le === $.input.charCodeAt(_e + 2) && (_e += 3, Le = $.input.charCodeAt(_e), Le === 0 || E(Le)));
  }
  function Ue($, _e) {
    _e === 1 ? $.result += " " : _e > 1 && ($.result += e.repeat(`
`, _e - 1));
  }
  function qt($, _e, Le) {
    var et, Ge, $t, Be, P, N, F, T, C = $.kind, S = $.result, h;
    if (h = $.input.charCodeAt($.position), E(h) || O(h) || h === 35 || h === 38 || h === 42 || h === 33 || h === 124 || h === 62 || h === 39 || h === 34 || h === 37 || h === 64 || h === 96 || (h === 63 || h === 45) && (Ge = $.input.charCodeAt($.position + 1), E(Ge) || Le && O(Ge)))
      return !1;
    for ($.kind = "scalar", $.result = "", $t = Be = $.position, P = !1; h !== 0; ) {
      if (h === 58) {
        if (Ge = $.input.charCodeAt($.position + 1), E(Ge) || Le && O(Ge))
          break;
      } else if (h === 35) {
        if (et = $.input.charCodeAt($.position - 1), E(et))
          break;
      } else {
        if ($.position === $.lineStart && Ae($) || Le && O(h))
          break;
        if (v(h))
          if (N = $.line, F = $.lineStart, T = $.lineIndent, ve($, !1, -1), $.lineIndent >= _e) {
            P = !0, h = $.input.charCodeAt($.position);
            continue;
          } else {
            $.position = Be, $.line = N, $.lineStart = F, $.lineIndent = T;
            break;
          }
      }
      P && (Me($, $t, Be, !1), Ue($, $.line - N), $t = Be = $.position, P = !1), _(h) || (Be = $.position + 1), h = $.input.charCodeAt(++$.position);
    }
    return Me($, $t, Be, !1), $.result ? !0 : ($.kind = C, $.result = S, !1);
  }
  function Ze($, _e) {
    var Le, et, Ge;
    if (Le = $.input.charCodeAt($.position), Le !== 39)
      return !1;
    for ($.kind = "scalar", $.result = "", $.position++, et = Ge = $.position; (Le = $.input.charCodeAt($.position)) !== 0; )
      if (Le === 39)
        if (Me($, et, $.position, !0), Le = $.input.charCodeAt(++$.position), Le === 39)
          et = $.position, $.position++, Ge = $.position;
        else
          return !0;
      else v(Le) ? (Me($, et, Ge, !0), Ue($, ve($, !1, _e)), et = Ge = $.position) : $.position === $.lineStart && Ae($) ? ne($, "unexpected end of the document within a single quoted scalar") : ($.position++, Ge = $.position);
    ne($, "unexpected end of the stream within a single quoted scalar");
  }
  function At($, _e) {
    var Le, et, Ge, $t, Be, P;
    if (P = $.input.charCodeAt($.position), P !== 34)
      return !1;
    for ($.kind = "scalar", $.result = "", $.position++, Le = et = $.position; (P = $.input.charCodeAt($.position)) !== 0; ) {
      if (P === 34)
        return Me($, Le, $.position, !0), $.position++, !0;
      if (P === 92) {
        if (Me($, Le, $.position, !0), P = $.input.charCodeAt(++$.position), v(P))
          ve($, !1, _e);
        else if (P < 256 && re[P])
          $.result += X[P], $.position++;
        else if ((Be = L(P)) > 0) {
          for (Ge = Be, $t = 0; Ge > 0; Ge--)
            P = $.input.charCodeAt(++$.position), (Be = M(P)) >= 0 ? $t = ($t << 4) + Be : ne($, "expected hexadecimal character");
          $.result += ae($t), $.position++;
        } else
          ne($, "unknown escape sequence");
        Le = et = $.position;
      } else v(P) ? (Me($, Le, et, !0), Ue($, ve($, !1, _e)), Le = et = $.position) : $.position === $.lineStart && Ae($) ? ne($, "unexpected end of the document within a double quoted scalar") : ($.position++, et = $.position);
    }
    ne($, "unexpected end of the stream within a double quoted scalar");
  }
  function He($, _e) {
    var Le = !0, et, Ge, $t, Be = $.tag, P, N = $.anchor, F, T, C, S, h, k = /* @__PURE__ */ Object.create(null), R, j, A, I;
    if (I = $.input.charCodeAt($.position), I === 91)
      T = 93, h = !1, P = [];
    else if (I === 123)
      T = 125, h = !0, P = {};
    else
      return !1;
    for ($.anchor !== null && ($.anchorMap[$.anchor] = P), I = $.input.charCodeAt(++$.position); I !== 0; ) {
      if (ve($, !0, _e), I = $.input.charCodeAt($.position), I === T)
        return $.position++, $.tag = Be, $.anchor = N, $.kind = h ? "mapping" : "sequence", $.result = P, !0;
      Le ? I === 44 && ne($, "expected the node content, but found ','") : ne($, "missed comma between flow collection entries"), j = R = A = null, C = S = !1, I === 63 && (F = $.input.charCodeAt($.position + 1), E(F) && (C = S = !0, $.position++, ve($, !0, _e))), et = $.line, Ge = $.lineStart, $t = $.position, ye($, _e, a, !1, !0), j = $.tag, R = $.result, ve($, !0, _e), I = $.input.charCodeAt($.position), (S || $.line === et) && I === 58 && (C = !0, I = $.input.charCodeAt(++$.position), ve($, !0, _e), ye($, _e, a, !1, !0), A = $.result), h ? Ve($, P, k, j, R, A, et, Ge, $t) : C ? P.push(Ve($, null, k, j, R, A, et, Ge, $t)) : P.push(R), ve($, !0, _e), I = $.input.charCodeAt($.position), I === 44 ? (Le = !0, I = $.input.charCodeAt(++$.position)) : Le = !1;
    }
    ne($, "unexpected end of the stream within a flow collection");
  }
  function Dt($, _e) {
    var Le, et, Ge = s, $t = !1, Be = !1, P = _e, N = 0, F = !1, T, C;
    if (C = $.input.charCodeAt($.position), C === 124)
      et = !1;
    else if (C === 62)
      et = !0;
    else
      return !1;
    for ($.kind = "scalar", $.result = ""; C !== 0; )
      if (C = $.input.charCodeAt(++$.position), C === 43 || C === 45)
        s === Ge ? Ge = C === 43 ? d : l : ne($, "repeat of a chomping mode identifier");
      else if ((T = Z(C)) >= 0)
        T === 0 ? ne($, "bad explicit indentation width of a block scalar; it cannot be less than one") : Be ? ne($, "repeat of an indentation width identifier") : (P = _e + T - 1, Be = !0);
      else
        break;
    if (_(C)) {
      do
        C = $.input.charCodeAt(++$.position);
      while (_(C));
      if (C === 35)
        do
          C = $.input.charCodeAt(++$.position);
        while (!v(C) && C !== 0);
    }
    for (; C !== 0; ) {
      for (xe($), $.lineIndent = 0, C = $.input.charCodeAt($.position); (!Be || $.lineIndent < P) && C === 32; )
        $.lineIndent++, C = $.input.charCodeAt(++$.position);
      if (!Be && $.lineIndent > P && (P = $.lineIndent), v(C)) {
        N++;
        continue;
      }
      if ($.lineIndent < P) {
        Ge === d ? $.result += e.repeat(`
`, $t ? 1 + N : N) : Ge === s && $t && ($.result += `
`);
        break;
      }
      for (et ? _(C) ? (F = !0, $.result += e.repeat(`
`, $t ? 1 + N : N)) : F ? (F = !1, $.result += e.repeat(`
`, N + 1)) : N === 0 ? $t && ($.result += " ") : $.result += e.repeat(`
`, N) : $.result += e.repeat(`
`, $t ? 1 + N : N), $t = !0, Be = !0, N = 0, Le = $.position; !v(C) && C !== 0; )
        C = $.input.charCodeAt(++$.position);
      Me($, Le, $.position, !1);
    }
    return !0;
  }
  function Fe($, _e) {
    var Le, et = $.tag, Ge = $.anchor, $t = [], Be, P = !1, N;
    if ($.firstTabInLine !== -1) return !1;
    for ($.anchor !== null && ($.anchorMap[$.anchor] = $t), N = $.input.charCodeAt($.position); N !== 0 && ($.firstTabInLine !== -1 && ($.position = $.firstTabInLine, ne($, "tab characters must not be used in indentation")), !(N !== 45 || (Be = $.input.charCodeAt($.position + 1), !E(Be)))); ) {
      if (P = !0, $.position++, ve($, !0, -1) && $.lineIndent <= _e) {
        $t.push(null), N = $.input.charCodeAt($.position);
        continue;
      }
      if (Le = $.line, ye($, _e, c, !1, !0), $t.push($.result), ve($, !0, -1), N = $.input.charCodeAt($.position), ($.line === Le || $.lineIndent > _e) && N !== 0)
        ne($, "bad indentation of a sequence entry");
      else if ($.lineIndent < _e)
        break;
    }
    return P ? ($.tag = et, $.anchor = Ge, $.kind = "sequence", $.result = $t, !0) : !1;
  }
  function Xe($, _e, Le) {
    var et, Ge, $t, Be, P, N, F = $.tag, T = $.anchor, C = {}, S = /* @__PURE__ */ Object.create(null), h = null, k = null, R = null, j = !1, A = !1, I;
    if ($.firstTabInLine !== -1) return !1;
    for ($.anchor !== null && ($.anchorMap[$.anchor] = C), I = $.input.charCodeAt($.position); I !== 0; ) {
      if (!j && $.firstTabInLine !== -1 && ($.position = $.firstTabInLine, ne($, "tab characters must not be used in indentation")), et = $.input.charCodeAt($.position + 1), $t = $.line, (I === 63 || I === 58) && E(et))
        I === 63 ? (j && (Ve($, C, S, h, k, null, Be, P, N), h = k = R = null), A = !0, j = !0, Ge = !0) : j ? (j = !1, Ge = !0) : ne($, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), $.position += 1, I = et;
      else {
        if (Be = $.line, P = $.lineStart, N = $.position, !ye($, Le, o, !1, !0))
          break;
        if ($.line === $t) {
          for (I = $.input.charCodeAt($.position); _(I); )
            I = $.input.charCodeAt(++$.position);
          if (I === 58)
            I = $.input.charCodeAt(++$.position), E(I) || ne($, "a whitespace character is expected after the key-value separator within a block mapping"), j && (Ve($, C, S, h, k, null, Be, P, N), h = k = R = null), A = !0, j = !1, Ge = !1, h = $.tag, k = $.result;
          else if (A)
            ne($, "can not read an implicit mapping pair; a colon is missed");
          else
            return $.tag = F, $.anchor = T, !0;
        } else if (A)
          ne($, "can not read a block mapping entry; a multiline key may not be an implicit key");
        else
          return $.tag = F, $.anchor = T, !0;
      }
      if (($.line === $t || $.lineIndent > _e) && (j && (Be = $.line, P = $.lineStart, N = $.position), ye($, _e, u, !0, Ge) && (j ? k = $.result : R = $.result), j || (Ve($, C, S, h, k, R, Be, P, N), h = k = R = null), ve($, !0, -1), I = $.input.charCodeAt($.position)), ($.line === $t || $.lineIndent > _e) && I !== 0)
        ne($, "bad indentation of a mapping entry");
      else if ($.lineIndent < _e)
        break;
    }
    return j && Ve($, C, S, h, k, null, Be, P, N), A && ($.tag = F, $.anchor = T, $.kind = "mapping", $.result = C), A;
  }
  function ze($) {
    var _e, Le = !1, et = !1, Ge, $t, Be;
    if (Be = $.input.charCodeAt($.position), Be !== 33) return !1;
    if ($.tag !== null && ne($, "duplication of a tag property"), Be = $.input.charCodeAt(++$.position), Be === 60 ? (Le = !0, Be = $.input.charCodeAt(++$.position)) : Be === 33 ? (et = !0, Ge = "!!", Be = $.input.charCodeAt(++$.position)) : Ge = "!", _e = $.position, Le) {
      do
        Be = $.input.charCodeAt(++$.position);
      while (Be !== 0 && Be !== 62);
      $.position < $.length ? ($t = $.input.slice(_e, $.position), Be = $.input.charCodeAt(++$.position)) : ne($, "unexpected end of the stream within a verbatim tag");
    } else {
      for (; Be !== 0 && !E(Be); )
        Be === 33 && (et ? ne($, "tag suffix cannot contain exclamation marks") : (Ge = $.input.slice(_e - 1, $.position + 1), b.test(Ge) || ne($, "named tag handle cannot contain such characters"), et = !0, _e = $.position + 1)), Be = $.input.charCodeAt(++$.position);
      $t = $.input.slice(_e, $.position), g.test($t) && ne($, "tag suffix cannot contain flow indicator characters");
    }
    $t && !w.test($t) && ne($, "tag name cannot contain such characters: " + $t);
    try {
      $t = decodeURIComponent($t);
    } catch {
      ne($, "tag name is malformed: " + $t);
    }
    return Le ? $.tag = $t : i.call($.tagMap, Ge) ? $.tag = $.tagMap[Ge] + $t : Ge === "!" ? $.tag = "!" + $t : Ge === "!!" ? $.tag = "tag:yaml.org,2002:" + $t : ne($, 'undeclared tag handle "' + Ge + '"'), !0;
  }
  function Rt($) {
    var _e, Le;
    if (Le = $.input.charCodeAt($.position), Le !== 38) return !1;
    for ($.anchor !== null && ne($, "duplication of an anchor property"), Le = $.input.charCodeAt(++$.position), _e = $.position; Le !== 0 && !E(Le) && !O(Le); )
      Le = $.input.charCodeAt(++$.position);
    return $.position === _e && ne($, "name of an anchor node must contain at least one character"), $.anchor = $.input.slice(_e, $.position), !0;
  }
  function Yt($) {
    var _e, Le, et;
    if (et = $.input.charCodeAt($.position), et !== 42) return !1;
    for (et = $.input.charCodeAt(++$.position), _e = $.position; et !== 0 && !E(et) && !O(et); )
      et = $.input.charCodeAt(++$.position);
    return $.position === _e && ne($, "name of an alias node must contain at least one character"), Le = $.input.slice(_e, $.position), i.call($.anchorMap, Le) || ne($, 'unidentified alias "' + Le + '"'), $.result = $.anchorMap[Le], ve($, !0, -1), !0;
  }
  function ye($, _e, Le, et, Ge) {
    var $t, Be, P, N = 1, F = !1, T = !1, C, S, h, k, R, j;
    if ($.listener !== null && $.listener("open", $), $.tag = null, $.anchor = null, $.kind = null, $.result = null, $t = Be = P = u === Le || c === Le, et && ve($, !0, -1) && (F = !0, $.lineIndent > _e ? N = 1 : $.lineIndent === _e ? N = 0 : $.lineIndent < _e && (N = -1)), N === 1)
      for (; ze($) || Rt($); )
        ve($, !0, -1) ? (F = !0, P = $t, $.lineIndent > _e ? N = 1 : $.lineIndent === _e ? N = 0 : $.lineIndent < _e && (N = -1)) : P = !1;
    if (P && (P = F || Ge), (N === 1 || u === Le) && (a === Le || o === Le ? R = _e : R = _e + 1, j = $.position - $.lineStart, N === 1 ? P && (Fe($, j) || Xe($, j, R)) || He($, R) ? T = !0 : (Be && Dt($, R) || Ze($, R) || At($, R) ? T = !0 : Yt($) ? (T = !0, ($.tag !== null || $.anchor !== null) && ne($, "alias node should not have any properties")) : qt($, R, a === Le) && (T = !0, $.tag === null && ($.tag = "?")), $.anchor !== null && ($.anchorMap[$.anchor] = $.result)) : N === 0 && (T = P && Fe($, j))), $.tag === null)
      $.anchor !== null && ($.anchorMap[$.anchor] = $.result);
    else if ($.tag === "?") {
      for ($.result !== null && $.kind !== "scalar" && ne($, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + $.kind + '"'), C = 0, S = $.implicitTypes.length; C < S; C += 1)
        if (k = $.implicitTypes[C], k.resolve($.result)) {
          $.result = k.construct($.result), $.tag = k.tag, $.anchor !== null && ($.anchorMap[$.anchor] = $.result);
          break;
        }
    } else if ($.tag !== "!") {
      if (i.call($.typeMap[$.kind || "fallback"], $.tag))
        k = $.typeMap[$.kind || "fallback"][$.tag];
      else
        for (k = null, h = $.typeMap.multi[$.kind || "fallback"], C = 0, S = h.length; C < S; C += 1)
          if ($.tag.slice(0, h[C].tag.length) === h[C].tag) {
            k = h[C];
            break;
          }
      k || ne($, "unknown tag !<" + $.tag + ">"), $.result !== null && k.kind !== $.kind && ne($, "unacceptable node kind for !<" + $.tag + '> tag; it should be "' + k.kind + '", not "' + $.kind + '"'), k.resolve($.result, $.tag) ? ($.result = k.construct($.result, $.tag), $.anchor !== null && ($.anchorMap[$.anchor] = $.result)) : ne($, "cannot resolve a node with !<" + $.tag + "> explicit tag");
    }
    return $.listener !== null && $.listener("close", $), $.tag !== null || $.anchor !== null || T;
  }
  function W($) {
    var _e = $.position, Le, et, Ge, $t = !1, Be;
    for ($.version = null, $.checkLineBreaks = $.legacy, $.tagMap = /* @__PURE__ */ Object.create(null), $.anchorMap = /* @__PURE__ */ Object.create(null); (Be = $.input.charCodeAt($.position)) !== 0 && (ve($, !0, -1), Be = $.input.charCodeAt($.position), !($.lineIndent > 0 || Be !== 37)); ) {
      for ($t = !0, Be = $.input.charCodeAt(++$.position), Le = $.position; Be !== 0 && !E(Be); )
        Be = $.input.charCodeAt(++$.position);
      for (et = $.input.slice(Le, $.position), Ge = [], et.length < 1 && ne($, "directive name must not be less than one character in length"); Be !== 0; ) {
        for (; _(Be); )
          Be = $.input.charCodeAt(++$.position);
        if (Be === 35) {
          do
            Be = $.input.charCodeAt(++$.position);
          while (Be !== 0 && !v(Be));
          break;
        }
        if (v(Be)) break;
        for (Le = $.position; Be !== 0 && !E(Be); )
          Be = $.input.charCodeAt(++$.position);
        Ge.push($.input.slice(Le, $.position));
      }
      Be !== 0 && xe($), i.call(je, et) ? je[et]($, et, Ge) : De($, 'unknown document directive "' + et + '"');
    }
    if (ve($, !0, -1), $.lineIndent === 0 && $.input.charCodeAt($.position) === 45 && $.input.charCodeAt($.position + 1) === 45 && $.input.charCodeAt($.position + 2) === 45 ? ($.position += 3, ve($, !0, -1)) : $t && ne($, "directives end mark is expected"), ye($, $.lineIndent - 1, u, !1, !0), ve($, !0, -1), $.checkLineBreaks && p.test($.input.slice(_e, $.position)) && De($, "non-ASCII line breaks are interpreted as content"), $.documents.push($.result), $.position === $.lineStart && Ae($)) {
      $.input.charCodeAt($.position) === 46 && ($.position += 3, ve($, !0, -1));
      return;
    }
    if ($.position < $.length - 1)
      ne($, "end of the stream or a document separator is expected");
    else
      return;
  }
  function Y($, _e) {
    $ = String($), _e = _e || {}, $.length !== 0 && ($.charCodeAt($.length - 1) !== 10 && $.charCodeAt($.length - 1) !== 13 && ($ += `
`), $.charCodeAt(0) === 65279 && ($ = $.slice(1)));
    var Le = new Ce($, _e), et = $.indexOf("\0");
    for (et !== -1 && (Le.position = et, ne(Le, "null byte is not allowed in input")), Le.input += "\0"; Le.input.charCodeAt(Le.position) === 32; )
      Le.lineIndent += 1, Le.position += 1;
    for (; Le.position < Le.length - 1; )
      W(Le);
    return Le.documents;
  }
  function ie($, _e, Le) {
    _e !== null && typeof _e == "object" && typeof Le > "u" && (Le = _e, _e = null);
    var et = Y($, Le);
    if (typeof _e != "function")
      return et;
    for (var Ge = 0, $t = et.length; Ge < $t; Ge += 1)
      _e(et[Ge]);
  }
  function Te($, _e) {
    var Le = Y($, _e);
    if (Le.length !== 0) {
      if (Le.length === 1)
        return Le[0];
      throw new t("expected a single document in the stream, but found more");
    }
  }
  return hd.loadAll = ie, hd.load = Te, hd;
}
var J5 = {}, X4;
function dU() {
  if (X4) return J5;
  X4 = 1;
  var e = Gf(), t = Wf(), n = $2(), r = Object.prototype.toString, i = Object.prototype.hasOwnProperty, a = 65279, o = 9, c = 10, u = 13, s = 32, l = 33, d = 34, f = 35, p = 37, g = 38, b = 39, w = 42, y = 44, v = 45, _ = 58, E = 61, O = 62, M = 63, L = 64, Z = 91, Q = 93, ae = 96, re = 123, X = 124, de = 125, Ce = {};
  Ce[0] = "\\0", Ce[7] = "\\a", Ce[8] = "\\b", Ce[9] = "\\t", Ce[10] = "\\n", Ce[11] = "\\v", Ce[12] = "\\f", Ce[13] = "\\r", Ce[27] = "\\e", Ce[34] = '\\"', Ce[92] = "\\\\", Ce[133] = "\\N", Ce[160] = "\\_", Ce[8232] = "\\L", Ce[8233] = "\\P";
  var J = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ], ne = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
  function De(h, k) {
    var R, j, A, I, z, H, K;
    if (k === null) return {};
    for (R = {}, j = Object.keys(k), A = 0, I = j.length; A < I; A += 1)
      z = j[A], H = String(k[z]), z.slice(0, 2) === "!!" && (z = "tag:yaml.org,2002:" + z.slice(2)), K = h.compiledTypeMap.fallback[z], K && i.call(K.styleAliases, H) && (H = K.styleAliases[H]), R[z] = H;
    return R;
  }
  function je(h) {
    var k, R, j;
    if (k = h.toString(16).toUpperCase(), h <= 255)
      R = "x", j = 2;
    else if (h <= 65535)
      R = "u", j = 4;
    else if (h <= 4294967295)
      R = "U", j = 8;
    else
      throw new t("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + R + e.repeat("0", j - k.length) + k;
  }
  var Me = 1, qe = 2;
  function Ve(h) {
    this.schema = h.schema || n, this.indent = Math.max(1, h.indent || 2), this.noArrayIndent = h.noArrayIndent || !1, this.skipInvalid = h.skipInvalid || !1, this.flowLevel = e.isNothing(h.flowLevel) ? -1 : h.flowLevel, this.styleMap = De(this.schema, h.styles || null), this.sortKeys = h.sortKeys || !1, this.lineWidth = h.lineWidth || 80, this.noRefs = h.noRefs || !1, this.noCompatMode = h.noCompatMode || !1, this.condenseFlow = h.condenseFlow || !1, this.quotingType = h.quotingType === '"' ? qe : Me, this.forceQuotes = h.forceQuotes || !1, this.replacer = typeof h.replacer == "function" ? h.replacer : null, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
  }
  function xe(h, k) {
    for (var R = e.repeat(" ", k), j = 0, A = -1, I = "", z, H = h.length; j < H; )
      A = h.indexOf(`
`, j), A === -1 ? (z = h.slice(j), j = H) : (z = h.slice(j, A + 1), j = A + 1), z.length && z !== `
` && (I += R), I += z;
    return I;
  }
  function ve(h, k) {
    return `
` + e.repeat(" ", h.indent * k);
  }
  function Ae(h, k) {
    var R, j, A;
    for (R = 0, j = h.implicitTypes.length; R < j; R += 1)
      if (A = h.implicitTypes[R], A.resolve(k))
        return !0;
    return !1;
  }
  function Ue(h) {
    return h === s || h === o;
  }
  function qt(h) {
    return 32 <= h && h <= 126 || 161 <= h && h <= 55295 && h !== 8232 && h !== 8233 || 57344 <= h && h <= 65533 && h !== a || 65536 <= h && h <= 1114111;
  }
  function Ze(h) {
    return qt(h) && h !== a && h !== u && h !== c;
  }
  function At(h, k, R) {
    var j = Ze(h), A = j && !Ue(h);
    return (
      // ns-plain-safe
      (R ? (
        // c = flow-in
        j
      ) : j && h !== y && h !== Z && h !== Q && h !== re && h !== de) && h !== f && !(k === _ && !A) || Ze(k) && !Ue(k) && h === f || k === _ && A
    );
  }
  function He(h) {
    return qt(h) && h !== a && !Ue(h) && h !== v && h !== M && h !== _ && h !== y && h !== Z && h !== Q && h !== re && h !== de && h !== f && h !== g && h !== w && h !== l && h !== X && h !== E && h !== O && h !== b && h !== d && h !== p && h !== L && h !== ae;
  }
  function Dt(h) {
    return !Ue(h) && h !== _;
  }
  function Fe(h, k) {
    var R = h.charCodeAt(k), j;
    return R >= 55296 && R <= 56319 && k + 1 < h.length && (j = h.charCodeAt(k + 1), j >= 56320 && j <= 57343) ? (R - 55296) * 1024 + j - 56320 + 65536 : R;
  }
  function Xe(h) {
    var k = /^\n* /;
    return k.test(h);
  }
  var ze = 1, Rt = 2, Yt = 3, ye = 4, W = 5;
  function Y(h, k, R, j, A, I, z, H) {
    var K, U = 0, D = null, B = !1, ee = !1, V = j !== -1, te = -1, ue = He(Fe(h, 0)) && Dt(Fe(h, h.length - 1));
    if (k || z)
      for (K = 0; K < h.length; U >= 65536 ? K += 2 : K++) {
        if (U = Fe(h, K), !qt(U))
          return W;
        ue = ue && At(U, D, H), D = U;
      }
    else {
      for (K = 0; K < h.length; U >= 65536 ? K += 2 : K++) {
        if (U = Fe(h, K), U === c)
          B = !0, V && (ee = ee || // Foldable line = too long, and not more-indented.
          K - te - 1 > j && h[te + 1] !== " ", te = K);
        else if (!qt(U))
          return W;
        ue = ue && At(U, D, H), D = U;
      }
      ee = ee || V && K - te - 1 > j && h[te + 1] !== " ";
    }
    return !B && !ee ? ue && !z && !A(h) ? ze : I === qe ? W : Rt : R > 9 && Xe(h) ? W : z ? I === qe ? W : Rt : ee ? ye : Yt;
  }
  function ie(h, k, R, j, A) {
    h.dump = (function() {
      if (k.length === 0)
        return h.quotingType === qe ? '""' : "''";
      if (!h.noCompatMode && (J.indexOf(k) !== -1 || ne.test(k)))
        return h.quotingType === qe ? '"' + k + '"' : "'" + k + "'";
      var I = h.indent * Math.max(1, R), z = h.lineWidth === -1 ? -1 : Math.max(Math.min(h.lineWidth, 40), h.lineWidth - I), H = j || h.flowLevel > -1 && R >= h.flowLevel;
      function K(U) {
        return Ae(h, U);
      }
      switch (Y(
        k,
        H,
        h.indent,
        z,
        K,
        h.quotingType,
        h.forceQuotes && !j,
        A
      )) {
        case ze:
          return k;
        case Rt:
          return "'" + k.replace(/'/g, "''") + "'";
        case Yt:
          return "|" + Te(k, h.indent) + $(xe(k, I));
        case ye:
          return ">" + Te(k, h.indent) + $(xe(_e(k, z), I));
        case W:
          return '"' + et(k) + '"';
        default:
          throw new t("impossible error: invalid scalar style");
      }
    })();
  }
  function Te(h, k) {
    var R = Xe(h) ? String(k) : "", j = h[h.length - 1] === `
`, A = j && (h[h.length - 2] === `
` || h === `
`), I = A ? "+" : j ? "" : "-";
    return R + I + `
`;
  }
  function $(h) {
    return h[h.length - 1] === `
` ? h.slice(0, -1) : h;
  }
  function _e(h, k) {
    for (var R = /(\n+)([^\n]*)/g, j = (function() {
      var U = h.indexOf(`
`);
      return U = U !== -1 ? U : h.length, R.lastIndex = U, Le(h.slice(0, U), k);
    })(), A = h[0] === `
` || h[0] === " ", I, z; z = R.exec(h); ) {
      var H = z[1], K = z[2];
      I = K[0] === " ", j += H + (!A && !I && K !== "" ? `
` : "") + Le(K, k), A = I;
    }
    return j;
  }
  function Le(h, k) {
    if (h === "" || h[0] === " ") return h;
    for (var R = / [^ ]/g, j, A = 0, I, z = 0, H = 0, K = ""; j = R.exec(h); )
      H = j.index, H - A > k && (I = z > A ? z : H, K += `
` + h.slice(A, I), A = I + 1), z = H;
    return K += `
`, h.length - A > k && z > A ? K += h.slice(A, z) + `
` + h.slice(z + 1) : K += h.slice(A), K.slice(1);
  }
  function et(h) {
    for (var k = "", R = 0, j, A = 0; A < h.length; R >= 65536 ? A += 2 : A++)
      R = Fe(h, A), j = Ce[R], !j && qt(R) ? (k += h[A], R >= 65536 && (k += h[A + 1])) : k += j || je(R);
    return k;
  }
  function Ge(h, k, R) {
    var j = "", A = h.tag, I, z, H;
    for (I = 0, z = R.length; I < z; I += 1)
      H = R[I], h.replacer && (H = h.replacer.call(R, String(I), H)), (F(h, k, H, !1, !1) || typeof H > "u" && F(h, k, null, !1, !1)) && (j !== "" && (j += "," + (h.condenseFlow ? "" : " ")), j += h.dump);
    h.tag = A, h.dump = "[" + j + "]";
  }
  function $t(h, k, R, j) {
    var A = "", I = h.tag, z, H, K;
    for (z = 0, H = R.length; z < H; z += 1)
      K = R[z], h.replacer && (K = h.replacer.call(R, String(z), K)), (F(h, k + 1, K, !0, !0, !1, !0) || typeof K > "u" && F(h, k + 1, null, !0, !0, !1, !0)) && ((!j || A !== "") && (A += ve(h, k)), h.dump && c === h.dump.charCodeAt(0) ? A += "-" : A += "- ", A += h.dump);
    h.tag = I, h.dump = A || "[]";
  }
  function Be(h, k, R) {
    var j = "", A = h.tag, I = Object.keys(R), z, H, K, U, D;
    for (z = 0, H = I.length; z < H; z += 1)
      D = "", j !== "" && (D += ", "), h.condenseFlow && (D += '"'), K = I[z], U = R[K], h.replacer && (U = h.replacer.call(R, K, U)), F(h, k, K, !1, !1) && (h.dump.length > 1024 && (D += "? "), D += h.dump + (h.condenseFlow ? '"' : "") + ":" + (h.condenseFlow ? "" : " "), F(h, k, U, !1, !1) && (D += h.dump, j += D));
    h.tag = A, h.dump = "{" + j + "}";
  }
  function P(h, k, R, j) {
    var A = "", I = h.tag, z = Object.keys(R), H, K, U, D, B, ee;
    if (h.sortKeys === !0)
      z.sort();
    else if (typeof h.sortKeys == "function")
      z.sort(h.sortKeys);
    else if (h.sortKeys)
      throw new t("sortKeys must be a boolean or a function");
    for (H = 0, K = z.length; H < K; H += 1)
      ee = "", (!j || A !== "") && (ee += ve(h, k)), U = z[H], D = R[U], h.replacer && (D = h.replacer.call(R, U, D)), F(h, k + 1, U, !0, !0, !0) && (B = h.tag !== null && h.tag !== "?" || h.dump && h.dump.length > 1024, B && (h.dump && c === h.dump.charCodeAt(0) ? ee += "?" : ee += "? "), ee += h.dump, B && (ee += ve(h, k)), F(h, k + 1, D, !0, B) && (h.dump && c === h.dump.charCodeAt(0) ? ee += ":" : ee += ": ", ee += h.dump, A += ee));
    h.tag = I, h.dump = A || "{}";
  }
  function N(h, k, R) {
    var j, A, I, z, H, K;
    for (A = R ? h.explicitTypes : h.implicitTypes, I = 0, z = A.length; I < z; I += 1)
      if (H = A[I], (H.instanceOf || H.predicate) && (!H.instanceOf || typeof k == "object" && k instanceof H.instanceOf) && (!H.predicate || H.predicate(k))) {
        if (R ? H.multi && H.representName ? h.tag = H.representName(k) : h.tag = H.tag : h.tag = "?", H.represent) {
          if (K = h.styleMap[H.tag] || H.defaultStyle, r.call(H.represent) === "[object Function]")
            j = H.represent(k, K);
          else if (i.call(H.represent, K))
            j = H.represent[K](k, K);
          else
            throw new t("!<" + H.tag + '> tag resolver accepts not "' + K + '" style');
          h.dump = j;
        }
        return !0;
      }
    return !1;
  }
  function F(h, k, R, j, A, I, z) {
    h.tag = null, h.dump = R, N(h, R, !1) || N(h, R, !0);
    var H = r.call(h.dump), K = j, U;
    j && (j = h.flowLevel < 0 || h.flowLevel > k);
    var D = H === "[object Object]" || H === "[object Array]", B, ee;
    if (D && (B = h.duplicates.indexOf(R), ee = B !== -1), (h.tag !== null && h.tag !== "?" || ee || h.indent !== 2 && k > 0) && (A = !1), ee && h.usedDuplicates[B])
      h.dump = "*ref_" + B;
    else {
      if (D && ee && !h.usedDuplicates[B] && (h.usedDuplicates[B] = !0), H === "[object Object]")
        j && Object.keys(h.dump).length !== 0 ? (P(h, k, h.dump, A), ee && (h.dump = "&ref_" + B + h.dump)) : (Be(h, k, h.dump), ee && (h.dump = "&ref_" + B + " " + h.dump));
      else if (H === "[object Array]")
        j && h.dump.length !== 0 ? (h.noArrayIndent && !z && k > 0 ? $t(h, k - 1, h.dump, A) : $t(h, k, h.dump, A), ee && (h.dump = "&ref_" + B + h.dump)) : (Ge(h, k, h.dump), ee && (h.dump = "&ref_" + B + " " + h.dump));
      else if (H === "[object String]")
        h.tag !== "?" && ie(h, h.dump, k, I, K);
      else {
        if (H === "[object Undefined]")
          return !1;
        if (h.skipInvalid) return !1;
        throw new t("unacceptable kind of an object to dump " + H);
      }
      h.tag !== null && h.tag !== "?" && (U = encodeURI(
        h.tag[0] === "!" ? h.tag.slice(1) : h.tag
      ).replace(/!/g, "%21"), h.tag[0] === "!" ? U = "!" + U : U.slice(0, 18) === "tag:yaml.org,2002:" ? U = "!!" + U.slice(18) : U = "!<" + U + ">", h.dump = U + " " + h.dump);
    }
    return !0;
  }
  function T(h, k) {
    var R = [], j = [], A, I;
    for (C(h, R, j), A = 0, I = j.length; A < I; A += 1)
      k.duplicates.push(R[j[A]]);
    k.usedDuplicates = new Array(I);
  }
  function C(h, k, R) {
    var j, A, I;
    if (h !== null && typeof h == "object")
      if (A = k.indexOf(h), A !== -1)
        R.indexOf(A) === -1 && R.push(A);
      else if (k.push(h), Array.isArray(h))
        for (A = 0, I = h.length; A < I; A += 1)
          C(h[A], k, R);
      else
        for (j = Object.keys(h), A = 0, I = j.length; A < I; A += 1)
          C(h[j[A]], k, R);
  }
  function S(h, k) {
    k = k || {};
    var R = new Ve(k);
    R.noRefs || T(h, R);
    var j = h;
    return R.replacer && (j = R.replacer.call({ "": j }, "", j)), F(R, 0, j, !0, !0) ? R.dump + `
` : "";
  }
  return J5.dump = S, J5;
}
var ex;
function tx() {
  if (ex) return Ti;
  ex = 1;
  var e = pU(), t = dU();
  function n(r, i) {
    return function() {
      throw new Error("Function yaml." + r + " is removed in js-yaml 4. Use yaml." + i + " instead, which is now safe by default.");
    };
  }
  return Ti.Type = Gi(), Ti.Schema = cA(), Ti.FAILSAFE_SCHEMA = dA(), Ti.JSON_SCHEMA = yA(), Ti.CORE_SCHEMA = bA(), Ti.DEFAULT_SCHEMA = $2(), Ti.load = e.load, Ti.loadAll = e.loadAll, Ti.dump = t.dump, Ti.YAMLException = Wf(), Ti.types = {
    binary: wA(),
    float: vA(),
    map: pA(),
    null: hA(),
    pairs: CA(),
    set: kA(),
    timestamp: xA(),
    bool: mA(),
    int: gA(),
    merge: _A(),
    omap: SA(),
    seq: fA(),
    str: lA()
  }, Ti.safeLoad = n("safeLoad", "load"), Ti.safeLoadAll = n("safeLoadAll", "loadAll"), Ti.safeDump = n("safeDump", "dump"), Ti;
}
var rx;
function hU() {
  if (rx) return Ku;
  rx = 1;
  var e = Ku && Ku.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ku, "__esModule", { value: !0 });
  const t = no(), n = e(tx()), r = tx();
  return Ku.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 200,
    /**
     * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
     */
    allowEmpty: !0,
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that match will be tried, in order, until one successfully parses the file.
     * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
     * every parser will be tried.
     */
    canParse: [".yaml", ".yml", ".json"],
    // JSON is valid YAML
    /**
     * Parses the given file as YAML
     *
     * @param file           - An object containing information about the referenced file
     * @param file.url       - The full URL of the referenced file
     * @param file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
     * @param file.data      - The file contents. This will be whatever data type was returned by the resolver
     * @returns
     */
    async parse(i) {
      let a = i.data;
      if (qn.isBuffer(a) && (a = a.toString()), typeof a == "string")
        try {
          return n.default.load(a, { schema: r.JSON_SCHEMA });
        } catch (o) {
          throw new t.ParserError(o?.message || "Parser Error", i.url);
        }
      else
        return a;
    }
  }, Ku;
}
var md = {}, nx;
function mU() {
  if (nx) return md;
  nx = 1, Object.defineProperty(md, "__esModule", { value: !0 });
  const e = no(), t = /\.(txt|htm|html|md|xml|js|min|map|css|scss|less|svg)$/i;
  return md.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 300,
    /**
     * Whether to allow "empty" files (zero bytes).
     */
    allowEmpty: !0,
    /**
     * The encoding that the text is expected to be in.
     */
    encoding: "utf8",
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that return true will be tried, in order, until one successfully parses the file.
     * Parsers that return false will be skipped, UNLESS all parsers returned false, in which case
     * every parser will be tried.
     */
    canParse(n) {
      return (typeof n.data == "string" || qn.isBuffer(n.data)) && t.test(n.url);
    },
    /**
     * Parses the given file as text
     */
    parse(n) {
      if (typeof n.data == "string")
        return n.data;
      if (qn.isBuffer(n.data))
        return n.data.toString(this.encoding);
      throw new e.ParserError("data is not text", n.url);
    }
  }, md;
}
var gd = {}, ix;
function gU() {
  if (ix) return gd;
  ix = 1, Object.defineProperty(gd, "__esModule", { value: !0 });
  const e = /\.(jpeg|jpg|gif|png|bmp|ico)$/i;
  return gd.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 400,
    /**
     * Whether to allow "empty" files (zero bytes).
     */
    allowEmpty: !0,
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that return true will be tried, in order, until one successfully parses the file.
     * Parsers that return false will be skipped, UNLESS all parsers returned false, in which case
     * every parser will be tried.
     */
    canParse(t) {
      return qn.isBuffer(t.data) && e.test(t.url);
    },
    /**
     * Parses the given data as a Buffer (byte array).
     */
    parse(t) {
      return qn.isBuffer(t.data) ? t.data : qn.from(t.data);
    }
  }, gd;
}
var Ca = {};
const vU = {}, yU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vU
}, Symbol.toStringTag, { value: "Module" })), ni = /* @__PURE__ */ q0(yU);
var ax;
function bU() {
  if (ax) return Ca;
  ax = 1;
  var e = Ca && Ca.__createBinding || (Object.create ? (function(c, u, s, l) {
    l === void 0 && (l = s);
    var d = Object.getOwnPropertyDescriptor(u, s);
    (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return u[s];
    } }), Object.defineProperty(c, l, d);
  }) : (function(c, u, s, l) {
    l === void 0 && (l = s), c[l] = u[s];
  })), t = Ca && Ca.__setModuleDefault || (Object.create ? (function(c, u) {
    Object.defineProperty(c, "default", { enumerable: !0, value: u });
  }) : function(c, u) {
    c.default = u;
  }), n = Ca && Ca.__importStar || /* @__PURE__ */ (function() {
    var c = function(u) {
      return c = Object.getOwnPropertyNames || function(s) {
        var l = [];
        for (var d in s) Object.prototype.hasOwnProperty.call(s, d) && (l[l.length] = d);
        return l;
      }, c(u);
    };
    return function(u) {
      if (u && u.__esModule) return u;
      var s = {};
      if (u != null) for (var l = c(u), d = 0; d < l.length; d++) l[d] !== "default" && e(s, u, l[d]);
      return t(s, u), s;
    };
  })(), r = Ca && Ca.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(Ca, "__esModule", { value: !0 });
  const i = r(ni), a = n(qa()), o = no();
  return Ca.default = {
    /**
     * The order that this resolver will run, in relation to other resolvers.
     */
    order: 100,
    /**
     * Determines whether this resolver can read a given file reference.
     * Resolvers that return true will be tried, in order, until one successfully resolves the file.
     * Resolvers that return false will not be given a chance to resolve the file.
     */
    canRead(c) {
      return a.isFileSystemPath(c.url);
    },
    /**
     * Reads the given file and returns its raw contents as a Buffer.
     */
    async read(c) {
      let u;
      try {
        u = a.toFileSystemPath(c.url);
      } catch (s) {
        const l = s;
        throw l.message = `Malformed URI: ${c.url}: ${l.message}`, new o.ResolverError(l, c.url);
      }
      (u.endsWith("/") || u.endsWith("\\")) && (u = u.slice(0, -1));
      try {
        return await i.default.promises.readFile(u);
      } catch (s) {
        const l = s;
        throw l.message = `Error opening file ${u}: ${l.message}`, new o.ResolverError(l, u);
      }
    }
  }, Ca;
}
var fo = {}, ox;
function xU() {
  if (ox) return fo;
  ox = 1;
  var e = fo && fo.__createBinding || (Object.create ? (function(c, u, s, l) {
    l === void 0 && (l = s);
    var d = Object.getOwnPropertyDescriptor(u, s);
    (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return u[s];
    } }), Object.defineProperty(c, l, d);
  }) : (function(c, u, s, l) {
    l === void 0 && (l = s), c[l] = u[s];
  })), t = fo && fo.__setModuleDefault || (Object.create ? (function(c, u) {
    Object.defineProperty(c, "default", { enumerable: !0, value: u });
  }) : function(c, u) {
    c.default = u;
  }), n = fo && fo.__importStar || /* @__PURE__ */ (function() {
    var c = function(u) {
      return c = Object.getOwnPropertyNames || function(s) {
        var l = [];
        for (var d in s) Object.prototype.hasOwnProperty.call(s, d) && (l[l.length] = d);
        return l;
      }, c(u);
    };
    return function(u) {
      if (u && u.__esModule) return u;
      var s = {};
      if (u != null) for (var l = c(u), d = 0; d < l.length; d++) l[d] !== "default" && e(s, u, l[d]);
      return t(s, u), s;
    };
  })();
  Object.defineProperty(fo, "__esModule", { value: !0 });
  const r = n(qa()), i = no();
  fo.default = {
    /**
     * The order that this resolver will run, in relation to other resolvers.
     */
    order: 200,
    /**
     * HTTP headers to send when downloading files.
     *
     * @example:
     * {
     *   "User-Agent": "JSON Schema $Ref Parser",
     *   Accept: "application/json"
     * }
     */
    headers: null,
    /**
     * HTTP request timeout (in milliseconds).
     */
    timeout: 6e4,
    // 60 seconds
    /**
     * The maximum number of HTTP redirects to follow.
     * To disable automatic following of redirects, set this to zero.
     */
    redirects: 5,
    /**
     * The `withCredentials` option of XMLHttpRequest.
     * Set this to `true` if you're downloading files from a CORS-enabled server that requires authentication
     */
    withCredentials: !1,
    /**
     * Set this to `false` if you want to allow unsafe URLs (e.g., `127.0.0.1`, localhost, and other internal URLs).
     */
    safeUrlResolver: !0,
    /**
     * Determines whether this resolver can read a given file reference.
     * Resolvers that return true will be tried in order, until one successfully resolves the file.
     * Resolvers that return false will not be given a chance to resolve the file.
     */
    canRead(c) {
      return r.isHttp(c.url) && (!this.safeUrlResolver || !r.isUnsafeUrl(c.url));
    },
    /**
     * Reads the given URL and returns its raw contents as a Buffer.
     */
    read(c) {
      const u = r.parse(c.url);
      return typeof window < "u" && !u.protocol && (u.protocol = r.parse(location.href).protocol), a(u, this);
    }
  };
  async function a(c, u, s) {
    c = r.parse(c);
    const l = s || [];
    l.push(c.href);
    try {
      const d = await o(c, u);
      if (d.status >= 400) {
        const f = new Error(`HTTP ERROR ${d.status}`);
        throw f.status = d.status, f;
      } else if (d.status >= 300)
        if (!Number.isNaN(u.redirects) && l.length > u.redirects) {
          const f = new Error(`Error downloading ${l[0]}. 
Too many redirects: 
  ${l.join(` 
  `)}`);
          throw f.status = d.status, new i.ResolverError(f);
        } else if (!("location" in d.headers) || !d.headers.location) {
          const f = new Error(`HTTP ${d.status} redirect with no location header`);
          throw f.status = d.status, f;
        } else {
          const f = r.resolve(c.href, d.headers.location);
          return a(f, u, l);
        }
      else {
        if (d.body) {
          const f = await d.arrayBuffer();
          return qn.from(f);
        }
        return qn.alloc(0);
      }
    } catch (d) {
      const f = d;
      throw f.message = `Error downloading ${c.href}: ${f.message}`, new i.ResolverError(f, c.href);
    }
  }
  async function o(c, u) {
    let s, l;
    u.timeout && (s = new AbortController(), l = setTimeout(() => s.abort(), u.timeout));
    const d = await fetch(c, {
      method: "GET",
      headers: u.headers || {},
      credentials: u.withCredentials ? "include" : "same-origin",
      signal: s ? s.signal : null
    });
    return l && clearTimeout(l), d;
  }
  return fo;
}
var sx;
function AA() {
  return sx || (sx = 1, (function(e) {
    var t = ml && ml.__importDefault || function(f) {
      return f && f.__esModule ? f : { default: f };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getNewOptions = e.getJsonSchemaRefParserDefaultOptions = void 0;
    const n = t(lU()), r = t(hU()), i = t(mU()), a = t(gU()), o = t(bU()), c = t(xU()), u = () => ({
      /**
       * Determines how different types of files will be parsed.
       *
       * You can add additional parsers of your own, replace an existing one with
       * your own implementation, or disable any parser by setting it to false.
       */
      parse: {
        json: { ...n.default },
        yaml: { ...r.default },
        text: { ...i.default },
        binary: { ...a.default }
      },
      /**
       * Determines how JSON References will be resolved.
       *
       * You can add additional resolvers of your own, replace an existing one with
       * your own implementation, or disable any resolver by setting it to false.
       */
      resolve: {
        file: { ...o.default },
        http: { ...c.default },
        /**
         * Determines whether external $ref pointers will be resolved.
         * If this option is disabled, then none of above resolvers will be called.
         * Instead, external $ref pointers will simply be ignored.
         *
         * @type {boolean}
         */
        external: !0
      },
      /**
       * By default, JSON Schema $Ref Parser throws the first error it encounters. Setting `continueOnError` to `true`
       * causes it to keep processing as much as possible and then throw a single error that contains all errors
       * that were encountered.
       */
      continueOnError: !1,
      /**
       * Determines the types of JSON references that are allowed.
       */
      dereference: {
        /**
         * Dereference circular (recursive) JSON references?
         * If false, then a {@link ReferenceError} will be thrown if a circular reference is found.
         * If "ignore", then circular references will not be dereferenced.
         *
         * @type {boolean|string}
         */
        circular: !0,
        /**
         * A function, called for each path, which can return true to stop this path and all
         * subpaths from being dereferenced further. This is useful in schemas where some
         * subpaths contain literal $ref keys that should not be dereferenced.
         *
         * @type {function}
         */
        excludedPathMatcher: () => !1,
        referenceResolution: "relative"
      },
      mutateInputSchema: !0
    });
    e.getJsonSchemaRefParserDefaultOptions = u;
    const s = (f) => {
      const p = (0, e.getJsonSchemaRefParserDefaultOptions)();
      return f && l(p, f), p;
    };
    e.getNewOptions = s;
    function l(f, p) {
      if (d(p)) {
        const g = Object.keys(p).filter((b) => !["__proto__", "constructor", "prototype"].includes(b));
        for (let b = 0; b < g.length; b++) {
          const w = g[b], y = p[w], v = f[w];
          d(y) ? f[w] = l(v || {}, y) : y !== void 0 && (f[w] = y);
        }
      }
      return f;
    }
    function d(f) {
      return f && typeof f == "object" && !Array.isArray(f) && !(f instanceof RegExp) && !(f instanceof Date);
    }
  })(ml)), ml;
}
var ux;
function _U() {
  if (ux) return hl;
  ux = 1, Object.defineProperty(hl, "__esModule", { value: !0 }), hl.normalizeArgs = t;
  const e = AA();
  function t(n) {
    let r, i, a, o;
    const c = Array.prototype.slice.call(n);
    typeof c[c.length - 1] == "function" && (o = c.pop()), typeof c[0] == "string" ? (r = c[0], typeof c[2] == "object" ? (i = c[1], a = c[2]) : (i = void 0, a = c[1])) : (r = "", i = c[0], a = c[1]);
    try {
      a = (0, e.getNewOptions)(a);
    } catch (u) {
      console.error(`JSON Schema Ref Parser: Error normalizing options: ${u}`);
    }
    return !a.mutateInputSchema && typeof i == "object" && (i = JSON.parse(JSON.stringify(i))), {
      path: r,
      schema: i,
      options: a,
      callback: o
    };
  }
  return hl.default = t, hl;
}
var ka = {}, cx;
function wU() {
  if (cx) return ka;
  cx = 1;
  var e = ka && ka.__createBinding || (Object.create ? (function(f, p, g, b) {
    b === void 0 && (b = g);
    var w = Object.getOwnPropertyDescriptor(p, g);
    (!w || ("get" in w ? !p.__esModule : w.writable || w.configurable)) && (w = { enumerable: !0, get: function() {
      return p[g];
    } }), Object.defineProperty(f, b, w);
  }) : (function(f, p, g, b) {
    b === void 0 && (b = g), f[b] = p[g];
  })), t = ka && ka.__setModuleDefault || (Object.create ? (function(f, p) {
    Object.defineProperty(f, "default", { enumerable: !0, value: p });
  }) : function(f, p) {
    f.default = p;
  }), n = ka && ka.__importStar || /* @__PURE__ */ (function() {
    var f = function(p) {
      return f = Object.getOwnPropertyNames || function(g) {
        var b = [];
        for (var w in g) Object.prototype.hasOwnProperty.call(g, w) && (b[b.length] = w);
        return b;
      }, f(p);
    };
    return function(p) {
      if (p && p.__esModule) return p;
      var g = {};
      if (p != null) for (var b = f(p), w = 0; w < b.length; w++) b[w] !== "default" && e(g, p, b[w]);
      return t(g, p), g;
    };
  })(), r = ka && ka.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(ka, "__esModule", { value: !0 });
  const i = r(Vf()), a = r(V0()), o = r(uA()), c = n(qa()), u = no();
  function s(f, p) {
    if (!p.resolve?.external)
      return Promise.resolve();
    try {
      const g = l(f.schema, f.$refs._root$Ref.path + "#", f.$refs, p);
      return Promise.all(g);
    } catch (g) {
      return Promise.reject(g);
    }
  }
  function l(f, p, g, b, w, y) {
    w ||= /* @__PURE__ */ new Set();
    let v = [];
    if (f && typeof f == "object" && !ArrayBuffer.isView(f) && !w.has(f)) {
      w.add(f), i.default.isExternal$Ref(f) && v.push(d(f, p, g, b));
      const _ = Object.keys(f);
      for (const E of _) {
        const O = a.default.join(p, E), M = f[E];
        v = v.concat(l(M, O, g, b, w));
      }
    }
    return v;
  }
  async function d(f, p, g, b) {
    const w = b.dereference?.externalReferenceResolution === "root", y = c.resolve(w ? c.cwd() : p, f.$ref), v = c.stripHash(y), _ = g._$refs[v];
    if (_)
      return Promise.resolve(_.value);
    try {
      const E = await (0, o.default)(y, g, b), O = l(E, v + "#", g, b, /* @__PURE__ */ new Set(), !0);
      return Promise.all(O);
    } catch (E) {
      if (!b?.continueOnError || !(0, u.isHandledError)(E))
        throw E;
      return g._$refs[v] && (E.source = decodeURI(c.stripHash(p)), E.path = c.safePointerToPath(c.getHash(p))), [];
    }
  }
  return ka.default = s, ka;
}
var Aa = {}, lx;
function SU() {
  if (lx) return Aa;
  lx = 1;
  var e = Aa && Aa.__createBinding || (Object.create ? (function(p, g, b, w) {
    w === void 0 && (w = b);
    var y = Object.getOwnPropertyDescriptor(g, b);
    (!y || ("get" in y ? !g.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return g[b];
    } }), Object.defineProperty(p, w, y);
  }) : (function(p, g, b, w) {
    w === void 0 && (w = b), p[w] = g[b];
  })), t = Aa && Aa.__setModuleDefault || (Object.create ? (function(p, g) {
    Object.defineProperty(p, "default", { enumerable: !0, value: g });
  }) : function(p, g) {
    p.default = g;
  }), n = Aa && Aa.__importStar || /* @__PURE__ */ (function() {
    var p = function(g) {
      return p = Object.getOwnPropertyNames || function(b) {
        var w = [];
        for (var y in b) Object.prototype.hasOwnProperty.call(b, y) && (w[w.length] = y);
        return w;
      }, p(g);
    };
    return function(g) {
      if (g && g.__esModule) return g;
      var b = {};
      if (g != null) for (var w = p(g), y = 0; y < w.length; y++) w[y] !== "default" && e(b, g, w[y]);
      return t(b, g), b;
    };
  })(), r = Aa && Aa.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(Aa, "__esModule", { value: !0 });
  const i = r(Vf()), a = r(V0()), o = n(qa());
  function c(p, g) {
    const b = [];
    u(p, "schema", p.$refs._root$Ref.path + "#", "#", 0, b, p.$refs, g), l(b);
  }
  function u(p, g, b, w, y, v, _, E) {
    const O = g === null ? p : p[g];
    if (O && typeof O == "object" && !ArrayBuffer.isView(O))
      if (i.default.isAllowed$Ref(O))
        s(p, g, b, w, y, v, _, E);
      else {
        const M = Object.keys(O).sort((L, Z) => L === "definitions" || L === "$defs" ? -1 : Z === "definitions" || Z === "$defs" ? 1 : L.length - Z.length);
        for (const L of M) {
          const Z = a.default.join(b, L), Q = a.default.join(w, L), ae = O[L];
          i.default.isAllowed$Ref(ae) ? s(O, L, b, Q, y, v, _, E) : u(O, L, Z, Q, y, v, _, E);
        }
      }
  }
  function s(p, g, b, w, y, v, _, E) {
    const O = g === null ? p : p[g], M = o.resolve(b, O.$ref), L = _._resolve(M, w, E);
    if (L === null)
      return;
    const Q = a.default.parse(w).length, ae = o.stripHash(L.path), re = o.getHash(L.path), X = ae !== _._root$Ref.path, de = i.default.isExtended$Ref(O);
    y += L.indirections;
    const Ce = d(v, p, g);
    if (Ce)
      if (Q < Ce.depth || y < Ce.indirections)
        f(v, Ce);
      else
        return;
    v.push({
      $ref: O,
      // The JSON Reference (e.g. {$ref: string})
      parent: p,
      // The object that contains this $ref pointer
      key: g,
      // The key in `parent` that is the $ref pointer
      pathFromRoot: w,
      // The path to the $ref pointer, from the JSON Schema root
      depth: Q,
      // How far from the JSON Schema root is this $ref pointer?
      file: ae,
      // The file that the $ref pointer resolves to
      hash: re,
      // The hash within `file` that the $ref pointer resolves to
      value: L.value,
      // The resolved value of the $ref pointer
      circular: L.circular,
      // Is this $ref pointer DIRECTLY circular? (i.e. it references itself)
      extended: de,
      // Does this $ref extend its resolved value? (i.e. it has extra properties, in addition to "$ref")
      external: X,
      // Does this $ref pointer point to a file other than the main JSON Schema file?
      indirections: y
      // The number of indirect references that were traversed to resolve the value
    }), (!Ce || X) && u(L.value, null, L.path, w, y + 1, v, _, E);
  }
  function l(p) {
    p.sort((y, v) => {
      if (y.file !== v.file)
        return y.file < v.file ? -1 : 1;
      if (y.hash !== v.hash)
        return y.hash < v.hash ? -1 : 1;
      if (y.circular !== v.circular)
        return y.circular ? -1 : 1;
      if (y.extended !== v.extended)
        return y.extended ? 1 : -1;
      if (y.indirections !== v.indirections)
        return y.indirections - v.indirections;
      if (y.depth !== v.depth)
        return y.depth - v.depth;
      {
        const _ = Math.max(y.pathFromRoot.lastIndexOf("/definitions"), y.pathFromRoot.lastIndexOf("/$defs")), E = Math.max(v.pathFromRoot.lastIndexOf("/definitions"), v.pathFromRoot.lastIndexOf("/$defs"));
        return _ !== E ? E - _ : y.pathFromRoot.length - v.pathFromRoot.length;
      }
    });
    let g, b, w;
    for (const y of p)
      y.external ? y.file === g && y.hash === b ? y.$ref.$ref = w : y.file === g && y.hash.indexOf(b + "/") === 0 ? y.$ref.$ref = a.default.join(w, a.default.parse(y.hash.replace(b, "#"))) : (g = y.file, b = y.hash, w = y.pathFromRoot, y.$ref = y.parent[y.key] = i.default.dereference(y.$ref, y.value), y.circular && (y.$ref.$ref = y.pathFromRoot)) : y.$ref.$ref = y.hash;
  }
  function d(p, g, b) {
    for (const w of p)
      if (w && w.parent === g && w.key === b)
        return w;
  }
  function f(p, g) {
    const b = p.indexOf(g);
    p.splice(b, 1);
  }
  return Aa.default = c, Aa;
}
var Ea = {}, fx;
function CU() {
  if (fx) return Ea;
  fx = 1;
  var e = Ea && Ea.__createBinding || (Object.create ? (function(p, g, b, w) {
    w === void 0 && (w = b);
    var y = Object.getOwnPropertyDescriptor(g, b);
    (!y || ("get" in y ? !g.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return g[b];
    } }), Object.defineProperty(p, w, y);
  }) : (function(p, g, b, w) {
    w === void 0 && (w = b), p[w] = g[b];
  })), t = Ea && Ea.__setModuleDefault || (Object.create ? (function(p, g) {
    Object.defineProperty(p, "default", { enumerable: !0, value: g });
  }) : function(p, g) {
    p.default = g;
  }), n = Ea && Ea.__importStar || /* @__PURE__ */ (function() {
    var p = function(g) {
      return p = Object.getOwnPropertyNames || function(b) {
        var w = [];
        for (var y in b) Object.prototype.hasOwnProperty.call(b, y) && (w[w.length] = y);
        return w;
      }, p(g);
    };
    return function(g) {
      if (g && g.__esModule) return g;
      var b = {};
      if (g != null) for (var w = p(g), y = 0; y < w.length; y++) w[y] !== "default" && e(b, g, w[y]);
      return t(b, g), b;
    };
  })(), r = Ea && Ea.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(Ea, "__esModule", { value: !0 });
  const i = r(Vf()), a = r(V0()), o = n(qa()), c = no();
  Ea.default = u;
  function u(p, g) {
    const b = Date.now(), w = s(p.schema, p.$refs._root$Ref.path, "#", /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Map(), p.$refs, g, b);
    p.$refs.circular = w.circular, p.schema = w.value;
  }
  function s(p, g, b, w, y, v, _, E, O) {
    let M;
    const L = {
      value: p,
      circular: !1
    };
    d(O, E);
    const Z = E.dereference || {}, Q = Z.excludedPathMatcher || (() => !1);
    if ((Z?.circular === "ignore" || !y.has(p)) && p && typeof p == "object" && !ArrayBuffer.isView(p) && !Q(b)) {
      if (w.add(p), y.add(p), i.default.isAllowed$Ref(p, E))
        M = l(p, g, b, w, y, v, _, E, O), L.circular = M.circular, L.value = M.value;
      else
        for (const ae of Object.keys(p)) {
          d(O, E);
          const re = a.default.join(g, ae), X = a.default.join(b, ae);
          if (Q(X))
            continue;
          const de = p[ae];
          let Ce = !1;
          if (i.default.isAllowed$Ref(de, E)) {
            if (M = l(de, re, X, w, y, v, _, E, O), Ce = M.circular, p[ae] !== M.value) {
              const J = /* @__PURE__ */ new Map();
              Z?.preservedProperties && typeof p[ae] == "object" && !Array.isArray(p[ae]) && Z?.preservedProperties.forEach((ne) => {
                ne in p[ae] && J.set(ne, p[ae][ne]);
              }), p[ae] = M.value, Z?.preservedProperties && J.size && typeof p[ae] == "object" && !Array.isArray(p[ae]) && J.forEach((ne, De) => {
                p[ae][De] = ne;
              }), Z?.onDereference?.(de.$ref, p[ae], p, ae);
            }
          } else
            w.has(de) ? Ce = f(re, _, E) : (M = s(de, re, X, w, y, v, _, E, O), Ce = M.circular, p[ae] !== M.value && (p[ae] = M.value));
          L.circular = L.circular || Ce;
        }
      w.delete(p);
    }
    return L;
  }
  function l(p, g, b, w, y, v, _, E, O) {
    const L = i.default.isExternal$Ref(p) && E?.dereference?.externalReferenceResolution === "root", Z = o.resolve(L ? o.cwd() : g, p.$ref), Q = v.get(Z);
    if (Q) {
      if (!Q.circular) {
        const J = Object.keys(p);
        if (J.length > 1) {
          const ne = {};
          for (const De of J)
            De !== "$ref" && !(De in Q.value) && (ne[De] = p[De]);
          return {
            circular: Q.circular,
            value: Object.assign({}, Q.value, ne)
          };
        }
        return Q;
      }
      if (typeof Q.value == "object" && "$ref" in Q.value && "$ref" in p) {
        if (Q.value.$ref === p.$ref)
          return Q;
      } else
        return Q;
    }
    const ae = _._resolve(Z, g, E);
    if (ae === null)
      return {
        circular: !1,
        value: null
      };
    const re = ae.circular;
    let X = re || w.has(ae.value);
    X && f(g, _, E);
    let de = i.default.dereference(p, ae.value);
    if (!X) {
      const J = s(de, ae.path, b, w, y, v, _, E, O);
      X = J.circular, de = J.value;
    }
    X && !re && E.dereference?.circular === "ignore" && (de = p), re && (de.$ref = b);
    const Ce = {
      circular: X,
      value: de
    };
    return Object.keys(p).length === 1 && v.set(Z, Ce), Ce;
  }
  function d(p, g) {
    if (g && g.timeoutMs && Date.now() - p > g.timeoutMs)
      throw new c.TimeoutError(g.timeoutMs);
  }
  function f(p, g, b) {
    if (g.circular = !0, b?.dereference?.onCircular?.(p), !b.dereference.circular)
      throw new ReferenceError(`Circular $ref pointer found at ${p}`);
    return !0;
  }
  return Ea;
}
var Zu = {}, vd = {}, px;
function kU() {
  if (px) return vd;
  px = 1, Object.defineProperty(vd, "__esModule", { value: !0 });
  function e() {
    return typeof gn == "object" && typeof gn.nextTick == "function" ? gn.nextTick : typeof setImmediate == "function" ? setImmediate : function(n) {
      setTimeout(n, 0);
    };
  }
  return vd.default = e(), vd;
}
var dx;
function AU() {
  if (dx) return Zu;
  dx = 1;
  var e = Zu && Zu.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Zu, "__esModule", { value: !0 }), Zu.default = n;
  const t = e(kU());
  function n(r, i) {
    if (r) {
      i.then(function(a) {
        (0, t.default)(function() {
          r(null, a);
        });
      }, function(a) {
        (0, t.default)(function() {
          r(a);
        });
      });
      return;
    } else
      return i;
  }
  return Zu;
}
var hx;
function EU() {
  return hx || (hx = 1, (function(e) {
    var t = Va && Va.__createBinding || (Object.create ? (function(v, _, E, O) {
      O === void 0 && (O = E);
      var M = Object.getOwnPropertyDescriptor(_, E);
      (!M || ("get" in M ? !_.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
        return _[E];
      } }), Object.defineProperty(v, O, M);
    }) : (function(v, _, E, O) {
      O === void 0 && (O = E), v[O] = _[E];
    })), n = Va && Va.__setModuleDefault || (Object.create ? (function(v, _) {
      Object.defineProperty(v, "default", { enumerable: !0, value: _ });
    }) : function(v, _) {
      v.default = _;
    }), r = Va && Va.__importStar || /* @__PURE__ */ (function() {
      var v = function(_) {
        return v = Object.getOwnPropertyNames || function(E) {
          var O = [];
          for (var M in E) Object.prototype.hasOwnProperty.call(E, M) && (O[O.length] = M);
          return O;
        }, v(_);
      };
      return function(_) {
        if (_ && _.__esModule) return _;
        var E = {};
        if (_ != null) for (var O = v(_), M = 0; M < O.length; M++) O[M] !== "default" && t(E, _, O[M]);
        return n(E, _), E;
      };
    })(), i = Va && Va.__importDefault || function(v) {
      return v && v.__esModule ? v : { default: v };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isUnsafeUrl = e.$Refs = e.getJsonSchemaRefParserDefaultOptions = e.jsonSchemaParserNormalizeArgs = e.dereferenceInternal = e.JSONParserErrorGroup = e.isHandledError = e.UnmatchedParserError = e.ParserError = e.ResolverError = e.MissingPointerError = e.InvalidPointerError = e.JSONParserError = e.UnmatchedResolverError = e.dereference = e.bundle = e.resolve = e.parse = e.$RefParser = void 0;
    const a = i(uU());
    e.$Refs = a.default;
    const o = i(uA()), c = i(_U());
    e.jsonSchemaParserNormalizeArgs = c.default;
    const u = i(wU()), s = i(SU()), l = i(CU());
    e.dereferenceInternal = l.default;
    const d = r(qa()), f = no();
    Object.defineProperty(e, "JSONParserError", { enumerable: !0, get: function() {
      return f.JSONParserError;
    } }), Object.defineProperty(e, "InvalidPointerError", { enumerable: !0, get: function() {
      return f.InvalidPointerError;
    } }), Object.defineProperty(e, "MissingPointerError", { enumerable: !0, get: function() {
      return f.MissingPointerError;
    } }), Object.defineProperty(e, "ResolverError", { enumerable: !0, get: function() {
      return f.ResolverError;
    } }), Object.defineProperty(e, "ParserError", { enumerable: !0, get: function() {
      return f.ParserError;
    } }), Object.defineProperty(e, "UnmatchedParserError", { enumerable: !0, get: function() {
      return f.UnmatchedParserError;
    } }), Object.defineProperty(e, "UnmatchedResolverError", { enumerable: !0, get: function() {
      return f.UnmatchedResolverError;
    } }), Object.defineProperty(e, "isHandledError", { enumerable: !0, get: function() {
      return f.isHandledError;
    } }), Object.defineProperty(e, "JSONParserErrorGroup", { enumerable: !0, get: function() {
      return f.JSONParserErrorGroup;
    } });
    const p = i(AU()), g = AA();
    Object.defineProperty(e, "getJsonSchemaRefParserDefaultOptions", { enumerable: !0, get: function() {
      return g.getJsonSchemaRefParserDefaultOptions;
    } });
    const b = qa();
    Object.defineProperty(e, "isUnsafeUrl", { enumerable: !0, get: function() {
      return b.isUnsafeUrl;
    } });
    class w {
      /**
       * The parsed (and possibly dereferenced) JSON schema object
       *
       * @type {object}
       * @readonly
       */
      schema = null;
      /**
       * The resolved JSON references
       *
       * @type {$Refs}
       * @readonly
       */
      $refs = new a.default();
      async parse() {
        const _ = (0, c.default)(arguments);
        let E;
        if (!_.path && !_.schema) {
          const M = new Error(`Expected a file path, URL, or object. Got ${_.path || _.schema}`);
          return (0, p.default)(_.callback, Promise.reject(M));
        }
        this.schema = null, this.$refs = new a.default();
        let O = "http";
        if (d.isFileSystemPath(_.path))
          _.path = d.fromFileSystemPath(_.path), O = "file";
        else if (!_.path && _.schema && "$id" in _.schema && _.schema.$id) {
          const M = d.parse(_.schema.$id), L = M.protocol === "https:" ? 443 : 80;
          _.path = `${M.protocol}//${M.hostname}:${L}`;
        }
        if (_.path = d.resolve(d.cwd(), _.path), _.schema && typeof _.schema == "object") {
          const M = this.$refs._add(_.path);
          M.value = _.schema, M.pathType = O, E = Promise.resolve(_.schema);
        } else
          E = (0, o.default)(_.path, this.$refs, _.options);
        try {
          const M = await E;
          if (M !== null && typeof M == "object" && !qn.isBuffer(M))
            return this.schema = M, (0, p.default)(_.callback, Promise.resolve(this.schema));
          if (_.options.continueOnError)
            return this.schema = null, (0, p.default)(_.callback, Promise.resolve(this.schema));
          throw new SyntaxError(`"${this.$refs._root$Ref.path || M}" is not a valid JSON Schema`);
        } catch (M) {
          return !_.options.continueOnError || !(0, f.isHandledError)(M) ? (0, p.default)(_.callback, Promise.reject(M)) : (this.$refs._$refs[d.stripHash(_.path)] && this.$refs._$refs[d.stripHash(_.path)].addError(M), (0, p.default)(_.callback, Promise.resolve(null)));
        }
      }
      static parse() {
        const _ = new w();
        return _.parse.apply(_, arguments);
      }
      async resolve() {
        const _ = (0, c.default)(arguments);
        try {
          return await this.parse(_.path, _.schema, _.options), await (0, u.default)(this, _.options), y(this), (0, p.default)(_.callback, Promise.resolve(this.$refs));
        } catch (E) {
          return (0, p.default)(_.callback, Promise.reject(E));
        }
      }
      static resolve() {
        const _ = new w();
        return _.resolve.apply(_, arguments);
      }
      static bundle() {
        const _ = new w();
        return _.bundle.apply(_, arguments);
      }
      async bundle() {
        const _ = (0, c.default)(arguments);
        try {
          return await this.resolve(_.path, _.schema, _.options), (0, s.default)(this, _.options), y(this), (0, p.default)(_.callback, Promise.resolve(this.schema));
        } catch (E) {
          return (0, p.default)(_.callback, Promise.reject(E));
        }
      }
      static dereference() {
        const _ = new w();
        return _.dereference.apply(_, arguments);
      }
      async dereference() {
        const _ = (0, c.default)(arguments);
        try {
          return await this.resolve(_.path, _.schema, _.options), (0, l.default)(this, _.options), y(this), (0, p.default)(_.callback, Promise.resolve(this.schema));
        } catch (E) {
          return (0, p.default)(_.callback, Promise.reject(E));
        }
      }
    }
    e.$RefParser = w, e.default = w;
    function y(v) {
      if (f.JSONParserErrorGroup.getParserErrors(v).length > 0)
        throw new f.JSONParserErrorGroup(v);
    }
    e.parse = w.parse, e.resolve = w.resolve, e.bundle = w.bundle, e.dereference = w.dereference;
  })(Va)), Va;
}
var OU = EU();
const mx = /* @__PURE__ */ h2(OU), { parse: TU, stringify: PU } = JSON, { keys: RU } = Object, Sf = String, EA = "string", gx = {}, a0 = "object", OA = (e, t) => t, IU = (e) => e instanceof Sf ? Sf(e) : e, jU = (e, t) => typeof t === EA ? new Sf(t) : t, TA = (e, t, n, r) => {
  const i = [];
  for (let a = RU(n), { length: o } = a, c = 0; c < o; c++) {
    const u = a[c], s = n[u];
    if (s instanceof Sf) {
      const l = e[s];
      typeof l === a0 && !t.has(l) ? (t.add(l), n[u] = gx, i.push({ k: u, a: [e, t, l, r] })) : n[u] = r.call(n, u, l);
    } else n[u] !== gx && (n[u] = r.call(n, u, s));
  }
  for (let { length: a } = i, o = 0; o < a; o++) {
    const { k: c, a: u } = i[o];
    n[c] = r.call(n, c, TA.apply(null, u));
  }
  return n;
}, vx = (e, t, n) => {
  const r = Sf(t.push(n) - 1);
  return e.set(n, r), r;
}, o0 = (e, t) => {
  const n = TU(e, jU).map(IU), r = n[0], i = OA, a = typeof r === a0 && r ? TA(n, /* @__PURE__ */ new Set(), r, i) : r;
  return i.call({ "": a }, "", a);
}, Fd = (e, t, n) => {
  const r = t && typeof t === a0 ? (l, d) => l === "" || -1 < t.indexOf(l) ? d : void 0 : t || OA, i = /* @__PURE__ */ new Map(), a = [], o = [];
  let c = +vx(i, a, r.call({ "": e }, "", e)), u = !c;
  for (; c < a.length; )
    u = !0, o[c] = PU(a[c++], s, n);
  return "[" + o.join(",") + "]";
  function s(l, d) {
    if (u)
      return u = !u, d;
    const f = r.call(this, l, d);
    switch (typeof f) {
      case a0:
        if (f === null) return f;
      case EA:
        return i.get(f) || vx(i, a, f);
    }
    return f;
  }
}, qU = [
  "maximum",
  "minimum",
  "maxLength",
  "minLength",
  "exclusiveMaximum",
  "exclusiveMinimum",
  "multipleOf",
  "maxItems",
  "minItems"
], PA = ["small", "large"], DU = ["neutral", "primary"];
var pc = /* @__PURE__ */ ((e) => (e.ResponseCodeSelectMenu = "response-code-select-menu", e.ContentTypeSelectMenu = "content-type-select-menu", e))(pc || {});
const L2 = [
  "top",
  "right",
  "bottom",
  "left",
  "top-start",
  "top-end",
  "right-start",
  "right-end",
  "bottom-start",
  "bottom-end",
  "left-start",
  "left-end"
], $U = ["2xx", "4xx"], LU = ["small", "large"], NU = ["bash", "python", "node", "java", "javascript", "go", "ruby", "swift", "csharp", "c++", "php", "c", "r", "json"];
var _s = /* @__PURE__ */ ((e) => (e.SEND = "send", e.RECEIVE = "receive", e.REQUEST = "request", e.REPLY = "reply", e))(_s || {});
const Ii = {
  ...Ri,
  HttpOperationTag: "http_operation_tag",
  AsyncMessage: "async_message",
  AsyncOperation: "async_operation"
}, yx = ({
  type: e,
  isAsyncAPIv2: t
}) => e === _s.RECEIVE ? t ? "PUB" : "RECEIVE" : e === _s.REPLY ? "REPLY" : e === _s.REQUEST ? "REQUEST" : t ? "SUB" : "SEND", RA = (e) => ({
  type: Ii.AsyncMessage,
  uri: `/message-${e.id()}`,
  name: e.id() || "",
  data: {
    description: e.description(),
    summary: e.summary(),
    correlationId: e.correlationId()?.location(),
    title: e.title(),
    messageId: e.id(),
    ...e.hasPayload() ? {
      payload: es(e.payload())
    } : null
  }
}), bx = (e) => e.isSend() ? e.reply() !== void 0 ? _s.REQUEST : _s.SEND : e.isReceive() && e.reply() !== void 0 ? _s.REPLY : _s.RECEIVE, es = (e) => {
  if (!e)
    return {};
  const t = {
    ...e.description() ? { description: e.description() } : null,
    ...e.examples() ? { examples: e.examples() } : null,
    ...e.format() ? { format: e.format() } : null,
    ...e.pattern() ? { pattern: e.pattern() } : null,
    ...e.title() ? { title: e.title() } : null,
    ...e.required() ? { required: e.required() } : null,
    ...e.type() ? { type: e.type() } : null,
    ...e.additionalProperties !== void 0 ? { additionalProperties: e.additionalProperties() } : null,
    ...e.enum() ? { enum: e.enum() } : null,
    ...e.isCircular() ? { isCircular: e.isCircular() } : null,
    ...e.const() ? { const: e.const() } : null,
    ...e.default() !== void 0 ? { default: e.default() } : null
  }, n = e.properties();
  n && (t.properties = {}, Object.keys(n).forEach((c) => {
    t.properties[c] = es(n[c]);
  }));
  const r = e.items();
  if (r)
    if (Array.isArray(r)) {
      t.items = [];
      for (let c = 0; c < r.length; c++)
        t.push(es(r[c]));
    } else
      t.items = es(r);
  const i = e.allOf();
  if (i) {
    t.allOf = [];
    for (let c = 0; c < i.length; c++)
      t.allOf.push(es(i[c]));
  }
  const a = e.anyOf();
  if (a) {
    t.anyOf = [];
    for (let c = 0; c < a.length; c++)
      t.anyOf.push(es(a[c]));
  }
  const o = e.oneOf();
  if (o) {
    t.oneOf = [];
    for (let c = 0; c < o.length; c++)
      t.oneOf.push(es(o[c]));
  }
  return t;
}, FU = (e, t) => {
  const n = e.info(), r = e.version(), a = r.localeCompare("2.6.0", void 0, { numeric: !0 }) === 0, o = [], c = {
    type: Ii.HttpService,
    name: n.title(),
    // @ts-ignore version of async is not yet in SpecVersion enum
    specVersion: ff.ASYNC + " " + r,
    uri: "/",
    tags: [],
    children: [],
    data: {
      id: "undefined",
      version: n.version(),
      name: n.title(),
      description: n.description(),
      ...n.hasExternalDocs() ? {
        externalDocs: {
          url: n.externalDocs()?.url(),
          description: n.externalDocs()?.description() || "External Docs"
        }
      } : null,
      ...n.hasContact() ? {
        contact: {
          name: n.contact()?.name(),
          email: n.contact()?.email(),
          url: n.contact()?.url()
        }
      } : null,
      ...n.hasLicense() ? {
        license: {
          name: n.license()?.name(),
          url: n.license()?.url()
        }
      } : null
    }
  };
  n && o.push(
    { id: "/", slug: "/", title: "Overview", type: "overview", meta: "" }
  );
  const u = [], s = e.securitySchemes();
  s && s.length && (s.forEach((g) => {
    u.push({
      id: g.id(),
      key: g.id(),
      //@ts-ignore converting string to enum
      in: g.in(),
      name: g.name() || g.id(),
      //@ts-ignore converting string to enum
      type: g.type(),
      description: g.description() || g.openIdConnectUrl()
    });
  }), c.data.securitySchemes = u);
  const l = e.allServers();
  if (l && l.length) {
    c.data.servers = [];
    const g = {
      items: []
    };
    l.forEach((b) => {
      c.data.servers?.push({ id: b.id(), url: b.url(), name: b.id(), description: b.description() }), g.items.push({
        id: `/operation-${b.id()}`,
        slug: `/operation-${b.id()}`,
        title: b.id() || "",
        type: "http_operation",
        meta: ""
      });
    });
  }
  const d = e.allOperations();
  if (d && d.length) {
    const g = {
      title: "Operations",
      items: [],
      hideTitle: !1,
      initiallyExpanded: !0
    };
    d.forEach((b) => {
      !g.initiallyExpanded && `/operation-${b.id()}` === t.currentPath && (g.initiallyExpanded = !0), g.items.push({
        id: `/operation-${b.id()}`,
        slug: `/operation-${b.id()}`,
        title: b.id() || "",
        type: "http_operation",
        meta: yx({ type: bx(b), isAsyncAPIv2: a })
      }), c.children.push({
        type: "async_operation",
        uri: `/operation-${b.id()}`,
        name: b.id() || "",
        data: {
          operation: b,
          method: yx({ type: bx(b), isAsyncAPIv2: a })
        }
      });
    }), o.push(g);
  }
  const f = e.allMessages();
  if (f && f.length) {
    const g = {
      title: "Messages",
      items: [],
      hideTitle: !1,
      initiallyExpanded: !0
    };
    f.forEach((b) => {
      !g.initiallyExpanded && `/message-${b.id()}` === t.currentPath && (g.initiallyExpanded = !0), g.items.push({
        id: `/message-${b.id()}`,
        slug: `/message-${b.id()}`,
        title: b.id() || "",
        type: Ii.Model,
        meta: ""
      }), c.children.push(RA(b));
    }), o.push(g);
  }
  const p = e.components().schemas().all();
  if (p && p.length && !t.hideSchemas) {
    const g = {
      title: "Schemas",
      items: [],
      hideTitle: !1,
      initiallyExpanded: !1
    };
    p.forEach((b) => {
      !g.initiallyExpanded && `/schema-${b.id()}` === t.currentPath && (g.initiallyExpanded = !0), g.items.push({
        id: `/schema-${b.id()}`,
        slug: `/schema-${b.id()}`,
        title: b.id() || "",
        type: Ii.Model,
        meta: ""
      }), c.children.push({
        type: Ii.Model,
        uri: `/schema-${b.id()}`,
        name: b.id() || "",
        data: es(b)
      });
    }), o.push(g);
  }
  return { toc: o, document: c };
}, s0 = () => typeof window > "u" || typeof document > "u" || !window || !document;
function xx(e) {
  return e.replace(/\/$/, "");
}
const IA = (e) => {
  let t = "";
  return Array.isArray(e) ? e.forEach((n, r) => {
    t += typeof n == "object" ? JSON.stringify(n) : n + `${r < e.length - 1 ? ", " : ""}`;
  }) : typeof e == "object" && (t = JSON.stringify(e)), t || e;
}, jA = (e) => {
  try {
    return typeof e == "string" ? JSON.parse(e) : e;
  } catch {
    return e;
  }
}, u0 = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_/]+/g, "-").toLowerCase(), Qi = (e, ...t) => {
  e && console.log(...t);
};
let yd = null, Yu = "", _x = "";
const MU = () => {
  const e = Br(), t = Br(), n = Br();
  function r(f) {
    if (typeof f == "object" && f !== null) return f;
    if (typeof f == "string")
      if (f.startsWith("{"))
        try {
          return JSON.parse(f);
        } catch (p) {
          console.error("@kong/spec-renderer: in parseJSSON:", p);
        }
      else
        try {
          return QB.parse(f);
        } catch (p) {
          console.error("@kong/spec-renderer: in parseYaml:", p);
        }
  }
  const i = (f) => {
    const p = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Set(), b = (v, _) => _.reduce((E, O) => E?.[O] ?? null, v), w = (v, _ = "") => (Object.keys(v).forEach((E) => {
      try {
        if (!p.has(v[E]) && !g.has(v[E])) {
          if (typeof v[E] == "object" && v[E] !== null)
            g.add(v[E]), v[E] = w(v[E], _ + "/" + E);
          else if (v[E] && L0(v[E])) {
            const O = b(f, v[E].replace("#/", "").split("/"));
            O && typeof O == "object" && (O.title = O.title || v[E].split("/").pop()), p.add(v[E]);
          }
        }
      } catch (O) {
        console.warn("@kong/spec-renderer: Issue in titleResolve:", O);
      }
    }), v);
    return w(f);
  }, a = async (f, p = {}) => {
    if (!yd) {
      const w = await import("./index-BlS37cX_.js").then((v) => v.i), y = await import("./index-C-ooRPWj.js");
      yd = new w.default(), yd.registerSchemaParser(y.default());
    }
    let g = f;
    if (p.specUrl && !f) {
      try {
        g = await (await fetch(p.specUrl)).text();
      } catch (w) {
        console.error(`@kong/spec-renderer: error fetching async document from ${p.specUrl}`, w);
        return;
      }
      Qi(p.traceParsing, "async document fetched");
    }
    Yu || s(g);
    let b = null;
    try {
      const {
        document: w
        /*, diagnostics*/
      } = await yd.parse(g);
      if (!w) {
        Qi(p.traceParsing, "async document undefined after parsing");
        return;
      }
      b = w;
    } catch (w) {
      console.error("@kong/spec-renderer: error parsing async document", w);
      return;
    }
    Qi(p.traceParsing, "async document parsed");
    try {
      const { toc: w, document: y } = FU(b, {
        hideSchemas: p?.hideSchemas,
        hideInternal: p?.hideInternal,
        hideDeprecated: p?.hideDeprecated,
        currentPath: p?.currentPath
      });
      Qi(p.traceParsing, "async document transformed"), n.value = w, e.value = y;
      return;
    } catch (w) {
      console.error("@kong/spec-renderer: error transforming async document", w);
      return;
    }
  }, o = async (f, p = {}) => {
    p.specUrl && !f ? (t.value = await mx.bundle(p.specUrl, {
      resolve: {
        file: !1,
        external: !0,
        http: {
          timeout: 2e3,
          withCredentials: p.withCredentials
        }
      },
      dereference: {
        circular: !0
      },
      continueOnError: !0
    }), Qi(p.traceParsing, "fetched and external referenced bundled")) : (t.value = r(f), Qi(p.traceParsing, "parsed from string")), _x = t.value?.info?.title;
  }, c = async (f, p = {}) => {
    if (await s(f, p.specUrl), (!t.value || p.enforceResetBeforeParsing) && await o(f, p), !t.value) {
      console.error("@kong/spec-renderer: empty jsonDocument initial processing");
      return;
    }
    Qi(p.traceParsing, "json document available"), t.value = i(t.value), Qi(p.traceParsing, "title resolved");
    try {
      const b = await mx.dereference(t.value, {
        continueOnError: !0,
        dereference: {
          circular: !0
        },
        external: !1,
        resolve: {
          file: !1,
          // http references resolved during bundle call above
          http: !1
        }
      });
      t.value = b;
    } catch (b) {
      console.error("@kong/spec-renderer: error dereferencing:", b);
    }
    Qi(p.traceParsing, "dereferenced");
    try {
      e.value = bB(t.value);
    } catch (b) {
      console.error("@kong/spec-renderer: error in transformOasToServiceNode:", b);
    }
    const g = () => {
      if (t.value?.components?.securitySchemes) {
        for (const [b, w] of Object.entries(t.value.components.securitySchemes))
          for (const [y, v] of Object.entries(w.flows || {}))
            if (v.scopes) {
              const _ = e.value?.data?.securitySchemes?.find((E) => E.key === b);
              _?.flows?.[y]?.scopes && (_.flows[y].scopes = v.scopes);
              for (const E of e.value?.data?.security || []) {
                const O = E.find((M) => M.key === b);
                O?.flows?.[y]?.scopes && (O.flows[y].scopes = v.scopes);
              }
              for (const E of (e.value?.children || []).filter((O) => O.type === "http_operation"))
                if (E.data.security)
                  for (const O of E.data.security) {
                    const M = O.find((L) => L.key === b);
                    M?.flows?.[y]?.scopes && (M.flows[y].scopes = v.scopes);
                  }
            }
      }
    };
    try {
      g();
    } catch (b) {
      console.error("@kong/spec-renderer: error in fixSecurityScopes:", b);
    }
    Qi(p.traceParsing, "transformed");
    try {
      e.value && (n.value = FF(e.value, {
        hideSchemas: p?.hideSchemas,
        hideInternal: p?.hideInternal,
        hideDeprecated: p?.hideDeprecated,
        currentPath: p?.currentPath
      }));
    } catch (b) {
      console.error("@kong/spec-renderer: error in computeAPITree:", b);
    }
    if (p.webComponentSafe)
      try {
        e.value = Fd(e.value), n.value = Fd(n.value), validationResults.value = Fd(validationResults.value);
      } catch (b) {
        console.error("@kong/spec-renderer: error in stringifying for web-component:", b);
      }
    Qi(p.traceParsing, "APITree computed");
  }, u = async (f, p = {}) => {
    if (await o(f, p), !t.value) {
      console.error("@kong/spec-renderer: empty jsonDocument initial processing");
      return;
    }
    Qi(p.traceParsing, "json document available"), t.value?.asyncapi ? (Qi(p.traceParsing, "asyncapi spec detected"), await a(f, p)) : (Qi(p.traceParsing, "openapi spec detected"), await c(f, p));
  }, s = async (f, p) => {
    if (Yu = f ?? "", !f && p)
      try {
        const g = await fetch(p);
        if (!g.ok)
          throw new Error(`HTTP error! status: ${g.status}`);
        Yu = await g.text();
      } catch (g) {
        console.error("@kong/spec-renderer: error in fetching spec file:", g);
      }
  }, l = async () => {
    if (!(s0() || !Yu))
      try {
        const f = d(Yu), p = window.location.pathname.replace(/[^a-zA-Z0-9]/g, ""), b = `${u0(_x || p || "spec-file")}.${f}`, w = new Blob([Yu], { type: f === "json" ? "application/json" : "text/yaml" }), y = window.URL.createObjectURL(w), v = document.createElement("a");
        v.href = y, v.setAttribute("download", b), document.body.appendChild(v), v.click(), document.body.removeChild(v), window.URL.revokeObjectURL(y);
      } catch (f) {
        console.error("@kong/spec-renderer: error in downloading spec file:", f);
      }
  }, d = (f) => f.startsWith("{") || f.startsWith("[") ? "json" : "yaml";
  return {
    parseSpecDocument: u,
    parseOpenApiSpecDocument: c,
    parseAsyncApiSpecDocument: a,
    downloadSpecFile: l,
    parsedDocument: e,
    tableOfContents: n
  };
};
let _i = class extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
};
function BU(e) {
  return N2(e);
}
function N2(e) {
  return Array.isArray(e) ? UU(e) : e instanceof RegExp ? e : typeof e == "object" ? HU(e) : e;
}
function UU(e) {
  let t = [];
  for (let n = 0, r = e.length; n < r; n++)
    t[n] = N2(e[n]);
  return t;
}
function HU(e) {
  let t = {};
  for (let n in e)
    t[n] = N2(e[n]);
  return t;
}
function qA(e, ...t) {
  return t.forEach((n) => {
    for (let r in n)
      e[r] = n[r];
  }), e;
}
function DA(e) {
  const t = ~e.lastIndexOf("/") || ~e.lastIndexOf("\\");
  return t === 0 ? e : ~t === e.length - 1 ? DA(e.substring(0, e.length - 1)) : e.substr(~t + 1);
}
var Q5 = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g, bd = class {
  static hasCaptures(e) {
    return e === null ? !1 : (Q5.lastIndex = 0, Q5.test(e));
  }
  static replaceCaptures(e, t, n) {
    return e.replace(Q5, (r, i, a, o) => {
      let c = n[parseInt(i || a, 10)];
      if (c) {
        let u = t.substring(c.start, c.end);
        for (; u[0] === "."; )
          u = u.substring(1);
        switch (o) {
          case "downcase":
            return u.toLowerCase();
          case "upcase":
            return u.toUpperCase();
          default:
            return u;
        }
      } else
        return r;
    });
  }
};
function $A(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function LA(e, t) {
  if (e === null && t === null)
    return 0;
  if (!e)
    return -1;
  if (!t)
    return 1;
  let n = e.length, r = t.length;
  if (n === r) {
    for (let i = 0; i < n; i++) {
      let a = $A(e[i], t[i]);
      if (a !== 0)
        return a;
    }
    return 0;
  }
  return n - r;
}
function wx(e) {
  return !!(/^#[0-9a-f]{6}$/i.test(e) || /^#[0-9a-f]{8}$/i.test(e) || /^#[0-9a-f]{3}$/i.test(e) || /^#[0-9a-f]{4}$/i.test(e));
}
function NA(e) {
  return e.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var FA = class {
  constructor(e) {
    this.fn = e;
  }
  cache = /* @__PURE__ */ new Map();
  get(e) {
    if (this.cache.has(e))
      return this.cache.get(e);
    const t = this.fn(e);
    return this.cache.set(e, t), t;
  }
}, c0 = class {
  constructor(e, t, n) {
    this._colorMap = e, this._defaults = t, this._root = n;
  }
  static createFromRawTheme(e, t) {
    return this.createFromParsedTheme(GU(e), t);
  }
  static createFromParsedTheme(e, t) {
    return KU(e, t);
  }
  _cachedMatchRoot = new FA(
    (e) => this._root.match(e)
  );
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  getDefaults() {
    return this._defaults;
  }
  match(e) {
    if (e === null)
      return this._defaults;
    const t = e.scopeName, r = this._cachedMatchRoot.get(t).find(
      (i) => zU(e.parent, i.parentScopes)
    );
    return r ? new MA(
      r.fontStyle,
      r.foreground,
      r.background
    ) : null;
  }
}, X5 = class Md {
  constructor(t, n) {
    this.parent = t, this.scopeName = n;
  }
  static push(t, n) {
    for (const r of n)
      t = new Md(t, r);
    return t;
  }
  static from(...t) {
    let n = null;
    for (let r = 0; r < t.length; r++)
      n = new Md(n, t[r]);
    return n;
  }
  push(t) {
    return new Md(this, t);
  }
  getSegments() {
    let t = this;
    const n = [];
    for (; t; )
      n.push(t.scopeName), t = t.parent;
    return n.reverse(), n;
  }
  toString() {
    return this.getSegments().join(" ");
  }
  extends(t) {
    return this === t ? !0 : this.parent === null ? !1 : this.parent.extends(t);
  }
  getExtensionIfDefined(t) {
    const n = [];
    let r = this;
    for (; r && r !== t; )
      n.push(r.scopeName), r = r.parent;
    return r === t ? n.reverse() : void 0;
  }
};
function zU(e, t) {
  if (t.length === 0)
    return !0;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = !1;
    if (r === ">") {
      if (n === t.length - 1)
        return !1;
      r = t[++n], i = !0;
    }
    for (; e && !VU(e.scopeName, r); ) {
      if (i)
        return !1;
      e = e.parent;
    }
    if (!e)
      return !1;
    e = e.parent;
  }
  return !0;
}
function VU(e, t) {
  return t === e || e.startsWith(t) && e[t.length] === ".";
}
var MA = class {
  constructor(e, t, n) {
    this.fontStyle = e, this.foregroundId = t, this.backgroundId = n;
  }
};
function GU(e) {
  if (!e)
    return [];
  if (!e.settings || !Array.isArray(e.settings))
    return [];
  let t = e.settings, n = [], r = 0;
  for (let i = 0, a = t.length; i < a; i++) {
    let o = t[i];
    if (!o.settings)
      continue;
    let c;
    if (typeof o.scope == "string") {
      let d = o.scope;
      d = d.replace(/^[,]+/, ""), d = d.replace(/[,]+$/, ""), c = d.split(",");
    } else Array.isArray(o.scope) ? c = o.scope : c = [""];
    let u = -1;
    if (typeof o.settings.fontStyle == "string") {
      u = 0;
      let d = o.settings.fontStyle.split(" ");
      for (let f = 0, p = d.length; f < p; f++)
        switch (d[f]) {
          case "italic":
            u = u | 1;
            break;
          case "bold":
            u = u | 2;
            break;
          case "underline":
            u = u | 4;
            break;
          case "strikethrough":
            u = u | 8;
            break;
        }
    }
    let s = null;
    typeof o.settings.foreground == "string" && wx(o.settings.foreground) && (s = o.settings.foreground);
    let l = null;
    typeof o.settings.background == "string" && wx(o.settings.background) && (l = o.settings.background);
    for (let d = 0, f = c.length; d < f; d++) {
      let g = c[d].trim().split(" "), b = g[g.length - 1], w = null;
      g.length > 1 && (w = g.slice(0, g.length - 1), w.reverse()), n[r++] = new WU(
        b,
        w,
        i,
        u,
        s,
        l
      );
    }
  }
  return n;
}
var WU = class {
  constructor(e, t, n, r, i, a) {
    this.scope = e, this.parentScopes = t, this.index = n, this.fontStyle = r, this.foreground = i, this.background = a;
  }
}, ji = /* @__PURE__ */ ((e) => (e[e.NotSet = -1] = "NotSet", e[e.None = 0] = "None", e[e.Italic = 1] = "Italic", e[e.Bold = 2] = "Bold", e[e.Underline = 4] = "Underline", e[e.Strikethrough = 8] = "Strikethrough", e))(ji || {});
function KU(e, t) {
  e.sort((u, s) => {
    let l = $A(u.scope, s.scope);
    return l !== 0 || (l = LA(u.parentScopes, s.parentScopes), l !== 0) ? l : u.index - s.index;
  });
  let n = 0, r = "#000000", i = "#ffffff";
  for (; e.length >= 1 && e[0].scope === ""; ) {
    let u = e.shift();
    u.fontStyle !== -1 && (n = u.fontStyle), u.foreground !== null && (r = u.foreground), u.background !== null && (i = u.background);
  }
  let a = new ZU(t), o = new MA(n, a.getId(r), a.getId(i)), c = new JU(new B6(0, null, -1, 0, 0), []);
  for (let u = 0, s = e.length; u < s; u++) {
    let l = e[u];
    c.insert(0, l.scope, l.parentScopes, l.fontStyle, a.getId(l.foreground), a.getId(l.background));
  }
  return new c0(a, o, c);
}
var ZU = class {
  _isFrozen;
  _lastColorId;
  _id2color;
  _color2id;
  constructor(e) {
    if (this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ Object.create(null), Array.isArray(e)) {
      this._isFrozen = !0;
      for (let t = 0, n = e.length; t < n; t++)
        this._color2id[e[t]] = t, this._id2color[t] = e[t];
    } else
      this._isFrozen = !1;
  }
  getId(e) {
    if (e === null)
      return 0;
    e = e.toUpperCase();
    let t = this._color2id[e];
    if (t)
      return t;
    if (this._isFrozen)
      throw new Error(`Missing color in color map - ${e}`);
    return t = ++this._lastColorId, this._color2id[e] = t, this._id2color[t] = e, t;
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}, YU = Object.freeze([]), B6 = class BA {
  scopeDepth;
  parentScopes;
  fontStyle;
  foreground;
  background;
  constructor(t, n, r, i, a) {
    this.scopeDepth = t, this.parentScopes = n || YU, this.fontStyle = r, this.foreground = i, this.background = a;
  }
  clone() {
    return new BA(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
  }
  static cloneArr(t) {
    let n = [];
    for (let r = 0, i = t.length; r < i; r++)
      n[r] = t[r].clone();
    return n;
  }
  acceptOverwrite(t, n, r, i) {
    this.scopeDepth > t ? console.log("how did this happen?") : this.scopeDepth = t, n !== -1 && (this.fontStyle = n), r !== 0 && (this.foreground = r), i !== 0 && (this.background = i);
  }
}, JU = class U6 {
  constructor(t, n = [], r = {}) {
    this._mainRule = t, this._children = r, this._rulesWithParentScopes = n;
  }
  _rulesWithParentScopes;
  static _cmpBySpecificity(t, n) {
    if (t.scopeDepth !== n.scopeDepth)
      return n.scopeDepth - t.scopeDepth;
    let r = 0, i = 0;
    for (; t.parentScopes[r] === ">" && r++, n.parentScopes[i] === ">" && i++, !(r >= t.parentScopes.length || i >= n.parentScopes.length); ) {
      const a = n.parentScopes[i].length - t.parentScopes[r].length;
      if (a !== 0)
        return a;
      r++, i++;
    }
    return n.parentScopes.length - t.parentScopes.length;
  }
  match(t) {
    if (t !== "") {
      let r = t.indexOf("."), i, a;
      if (r === -1 ? (i = t, a = "") : (i = t.substring(0, r), a = t.substring(r + 1)), this._children.hasOwnProperty(i))
        return this._children[i].match(a);
    }
    const n = this._rulesWithParentScopes.concat(this._mainRule);
    return n.sort(U6._cmpBySpecificity), n;
  }
  insert(t, n, r, i, a, o) {
    if (n === "") {
      this._doInsertHere(t, r, i, a, o);
      return;
    }
    let c = n.indexOf("."), u, s;
    c === -1 ? (u = n, s = "") : (u = n.substring(0, c), s = n.substring(c + 1));
    let l;
    this._children.hasOwnProperty(u) ? l = this._children[u] : (l = new U6(this._mainRule.clone(), B6.cloneArr(this._rulesWithParentScopes)), this._children[u] = l), l.insert(t + 1, s, r, i, a, o);
  }
  _doInsertHere(t, n, r, i, a) {
    if (n === null) {
      this._mainRule.acceptOverwrite(t, r, i, a);
      return;
    }
    for (let o = 0, c = this._rulesWithParentScopes.length; o < c; o++) {
      let u = this._rulesWithParentScopes[o];
      if (LA(u.parentScopes, n) === 0) {
        u.acceptOverwrite(t, r, i, a);
        return;
      }
    }
    r === -1 && (r = this._mainRule.fontStyle), i === 0 && (i = this._mainRule.foreground), a === 0 && (a = this._mainRule.background), this._rulesWithParentScopes.push(new B6(t, n, r, i, a));
  }
}, dc = class Oa {
  static toBinaryStr(t) {
    return t.toString(2).padStart(32, "0");
  }
  static print(t) {
    const n = Oa.getLanguageId(t), r = Oa.getTokenType(t), i = Oa.getFontStyle(t), a = Oa.getForeground(t), o = Oa.getBackground(t);
    console.log({
      languageId: n,
      tokenType: r,
      fontStyle: i,
      foreground: a,
      background: o
    });
  }
  static getLanguageId(t) {
    return (t & 255) >>> 0;
  }
  static getTokenType(t) {
    return (t & 768) >>> 8;
  }
  static containsBalancedBrackets(t) {
    return (t & 1024) !== 0;
  }
  static getFontStyle(t) {
    return (t & 30720) >>> 11;
  }
  static getForeground(t) {
    return (t & 16744448) >>> 15;
  }
  static getBackground(t) {
    return (t & 4278190080) >>> 24;
  }
  /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */
  static set(t, n, r, i, a, o, c) {
    let u = Oa.getLanguageId(t), s = Oa.getTokenType(t), l = Oa.containsBalancedBrackets(t) ? 1 : 0, d = Oa.getFontStyle(t), f = Oa.getForeground(t), p = Oa.getBackground(t);
    return n !== 0 && (u = n), r !== 8 && (s = r), i !== null && (l = i ? 1 : 0), a !== -1 && (d = a), o !== 0 && (f = o), c !== 0 && (p = c), (u << 0 | s << 8 | l << 10 | d << 11 | f << 15 | p << 24) >>> 0;
  }
};
function l0(e, t) {
  const n = [], r = QU(e);
  let i = r.next();
  for (; i !== null; ) {
    let u = 0;
    if (i.length === 2 && i.charAt(1) === ":") {
      switch (i.charAt(0)) {
        case "R":
          u = 1;
          break;
        case "L":
          u = -1;
          break;
        default:
          console.log(`Unknown priority ${i} in scope selector`);
      }
      i = r.next();
    }
    let s = o();
    if (n.push({ matcher: s, priority: u }), i !== ",")
      break;
    i = r.next();
  }
  return n;
  function a() {
    if (i === "-") {
      i = r.next();
      const u = a();
      return (s) => !!u && !u(s);
    }
    if (i === "(") {
      i = r.next();
      const u = c();
      return i === ")" && (i = r.next()), u;
    }
    if (Sx(i)) {
      const u = [];
      do
        u.push(i), i = r.next();
      while (Sx(i));
      return (s) => t(u, s);
    }
    return null;
  }
  function o() {
    const u = [];
    let s = a();
    for (; s; )
      u.push(s), s = a();
    return (l) => u.every((d) => d(l));
  }
  function c() {
    const u = [];
    let s = o();
    for (; s && (u.push(s), i === "|" || i === ","); ) {
      do
        i = r.next();
      while (i === "|" || i === ",");
      s = o();
    }
    return (l) => u.some((d) => d(l));
  }
}
function Sx(e) {
  return !!e && !!e.match(/[\w\.:]+/);
}
function QU(e) {
  let t = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g, n = t.exec(e);
  return {
    next: () => {
      if (!n)
        return null;
      const r = n[0];
      return n = t.exec(e), r;
    }
  };
}
function UA(e) {
  typeof e.dispose == "function" && e.dispose();
}
var Cf = class {
  constructor(e) {
    this.scopeName = e;
  }
  toKey() {
    return this.scopeName;
  }
}, XU = class {
  constructor(e, t) {
    this.scopeName = e, this.ruleName = t;
  }
  toKey() {
    return `${this.scopeName}#${this.ruleName}`;
  }
}, eH = class {
  _references = [];
  _seenReferenceKeys = /* @__PURE__ */ new Set();
  get references() {
    return this._references;
  }
  visitedRule = /* @__PURE__ */ new Set();
  add(e) {
    const t = e.toKey();
    this._seenReferenceKeys.has(t) || (this._seenReferenceKeys.add(t), this._references.push(e));
  }
}, tH = class {
  constructor(e, t) {
    this.repo = e, this.initialScopeName = t, this.seenFullScopeRequests.add(this.initialScopeName), this.Q = [new Cf(this.initialScopeName)];
  }
  seenFullScopeRequests = /* @__PURE__ */ new Set();
  seenPartialScopeRequests = /* @__PURE__ */ new Set();
  Q;
  processQueue() {
    const e = this.Q;
    this.Q = [];
    const t = new eH();
    for (const n of e)
      rH(n, this.initialScopeName, this.repo, t);
    for (const n of t.references)
      if (n instanceof Cf) {
        if (this.seenFullScopeRequests.has(n.scopeName))
          continue;
        this.seenFullScopeRequests.add(n.scopeName), this.Q.push(n);
      } else {
        if (this.seenFullScopeRequests.has(n.scopeName) || this.seenPartialScopeRequests.has(n.toKey()))
          continue;
        this.seenPartialScopeRequests.add(n.toKey()), this.Q.push(n);
      }
  }
};
function rH(e, t, n, r) {
  const i = n.lookup(e.scopeName);
  if (!i) {
    if (e.scopeName === t)
      throw new Error(`No grammar provided for <${t}>`);
    return;
  }
  const a = n.lookup(t);
  e instanceof Cf ? Bd({ baseGrammar: a, selfGrammar: i }, r) : H6(
    e.ruleName,
    { baseGrammar: a, selfGrammar: i, repository: i.repository },
    r
  );
  const o = n.injections(e.scopeName);
  if (o)
    for (const c of o)
      r.add(new Cf(c));
}
function H6(e, t, n) {
  if (t.repository && t.repository[e]) {
    const r = t.repository[e];
    f0([r], t, n);
  }
}
function Bd(e, t) {
  e.selfGrammar.patterns && Array.isArray(e.selfGrammar.patterns) && f0(
    e.selfGrammar.patterns,
    { ...e, repository: e.selfGrammar.repository },
    t
  ), e.selfGrammar.injections && f0(
    Object.values(e.selfGrammar.injections),
    { ...e, repository: e.selfGrammar.repository },
    t
  );
}
function f0(e, t, n) {
  for (const r of e) {
    if (n.visitedRule.has(r))
      continue;
    n.visitedRule.add(r);
    const i = r.repository ? qA({}, t.repository, r.repository) : t.repository;
    Array.isArray(r.patterns) && f0(r.patterns, { ...t, repository: i }, n);
    const a = r.include;
    if (!a)
      continue;
    const o = HA(a);
    switch (o.kind) {
      case 0:
        Bd({ ...t, selfGrammar: t.baseGrammar }, n);
        break;
      case 1:
        Bd(t, n);
        break;
      case 2:
        H6(o.ruleName, { ...t, repository: i }, n);
        break;
      case 3:
      case 4:
        const c = o.scopeName === t.selfGrammar.scopeName ? t.selfGrammar : o.scopeName === t.baseGrammar.scopeName ? t.baseGrammar : void 0;
        if (c) {
          const u = { baseGrammar: t.baseGrammar, selfGrammar: c, repository: i };
          o.kind === 4 ? H6(o.ruleName, u, n) : Bd(u, n);
        } else
          o.kind === 4 ? n.add(new XU(o.scopeName, o.ruleName)) : n.add(new Cf(o.scopeName));
        break;
    }
  }
}
var nH = class {
  kind = 0;
}, iH = class {
  kind = 1;
}, aH = class {
  constructor(e) {
    this.ruleName = e;
  }
  kind = 2;
}, oH = class {
  constructor(e) {
    this.scopeName = e;
  }
  kind = 3;
}, sH = class {
  constructor(e, t) {
    this.scopeName = e, this.ruleName = t;
  }
  kind = 4;
};
function HA(e) {
  if (e === "$base")
    return new nH();
  if (e === "$self")
    return new iH();
  const t = e.indexOf("#");
  if (t === -1)
    return new oH(e);
  if (t === 0)
    return new aH(e.substring(1));
  {
    const n = e.substring(0, t), r = e.substring(t + 1);
    return new sH(n, r);
  }
}
var uH = /\\(\d+)/, Cx = /\\(\d+)/g, cH = -1, zA = -2;
var Kf = class {
  $location;
  id;
  _nameIsCapturing;
  _name;
  _contentNameIsCapturing;
  _contentName;
  constructor(e, t, n, r) {
    this.$location = e, this.id = t, this._name = n || null, this._nameIsCapturing = bd.hasCaptures(this._name), this._contentName = r || null, this._contentNameIsCapturing = bd.hasCaptures(this._contentName);
  }
  get debugName() {
    const e = this.$location ? `${DA(this.$location.filename)}:${this.$location.line}` : "unknown";
    return `${this.constructor.name}#${this.id} @ ${e}`;
  }
  getName(e, t) {
    return !this._nameIsCapturing || this._name === null || e === null || t === null ? this._name : bd.replaceCaptures(this._name, e, t);
  }
  getContentName(e, t) {
    return !this._contentNameIsCapturing || this._contentName === null ? this._contentName : bd.replaceCaptures(this._contentName, e, t);
  }
}, lH = class extends Kf {
  retokenizeCapturedWithRuleId;
  constructor(e, t, n, r, i) {
    super(e, t, n, r), this.retokenizeCapturedWithRuleId = i;
  }
  dispose() {
  }
  collectPatterns(e, t) {
    throw new Error("Not supported!");
  }
  compile(e, t) {
    throw new Error("Not supported!");
  }
  compileAG(e, t, n, r) {
    throw new Error("Not supported!");
  }
}, fH = class extends Kf {
  _match;
  captures;
  _cachedCompiledPatterns;
  constructor(e, t, n, r, i) {
    super(e, t, n, null), this._match = new kf(r, this.id), this.captures = i, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugMatchRegExp() {
    return `${this._match.source}`;
  }
  collectPatterns(e, t) {
    t.push(this._match);
  }
  compile(e, t) {
    return this._getCachedCompiledPatterns(e).compile(e);
  }
  compileAG(e, t, n, r) {
    return this._getCachedCompiledPatterns(e).compileAG(e, n, r);
  }
  _getCachedCompiledPatterns(e) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new Af(), this.collectPatterns(e, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, kx = class extends Kf {
  hasMissingPatterns;
  patterns;
  _cachedCompiledPatterns;
  constructor(e, t, n, r, i) {
    super(e, t, n, r), this.patterns = i.patterns, this.hasMissingPatterns = i.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  collectPatterns(e, t) {
    for (const n of this.patterns)
      e.getRule(n).collectPatterns(e, t);
  }
  compile(e, t) {
    return this._getCachedCompiledPatterns(e).compile(e);
  }
  compileAG(e, t, n, r) {
    return this._getCachedCompiledPatterns(e).compileAG(e, n, r);
  }
  _getCachedCompiledPatterns(e) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new Af(), this.collectPatterns(e, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, z6 = class extends Kf {
  _begin;
  beginCaptures;
  _end;
  endHasBackReferences;
  endCaptures;
  applyEndPatternLast;
  hasMissingPatterns;
  patterns;
  _cachedCompiledPatterns;
  constructor(e, t, n, r, i, a, o, c, u, s) {
    super(e, t, n, r), this._begin = new kf(i, this.id), this.beginCaptures = a, this._end = new kf(o || "￿", -1), this.endHasBackReferences = this._end.hasBackReferences, this.endCaptures = c, this.applyEndPatternLast = u || !1, this.patterns = s.patterns, this.hasMissingPatterns = s.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugEndRegExp() {
    return `${this._end.source}`;
  }
  getEndWithResolvedBackReferences(e, t) {
    return this._end.resolveBackReferences(e, t);
  }
  collectPatterns(e, t) {
    t.push(this._begin);
  }
  compile(e, t) {
    return this._getCachedCompiledPatterns(e, t).compile(e);
  }
  compileAG(e, t, n, r) {
    return this._getCachedCompiledPatterns(e, t).compileAG(e, n, r);
  }
  _getCachedCompiledPatterns(e, t) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new Af();
      for (const n of this.patterns)
        e.getRule(n).collectPatterns(e, this._cachedCompiledPatterns);
      this.applyEndPatternLast ? this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end) : this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
    }
    return this._end.hasBackReferences && (this.applyEndPatternLast ? this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, t) : this._cachedCompiledPatterns.setSource(0, t)), this._cachedCompiledPatterns;
  }
}, p0 = class extends Kf {
  _begin;
  beginCaptures;
  whileCaptures;
  _while;
  whileHasBackReferences;
  hasMissingPatterns;
  patterns;
  _cachedCompiledPatterns;
  _cachedCompiledWhilePatterns;
  constructor(e, t, n, r, i, a, o, c, u) {
    super(e, t, n, r), this._begin = new kf(i, this.id), this.beginCaptures = a, this.whileCaptures = c, this._while = new kf(o, zA), this.whileHasBackReferences = this._while.hasBackReferences, this.patterns = u.patterns, this.hasMissingPatterns = u.hasMissingPatterns, this._cachedCompiledPatterns = null, this._cachedCompiledWhilePatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null), this._cachedCompiledWhilePatterns && (this._cachedCompiledWhilePatterns.dispose(), this._cachedCompiledWhilePatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugWhileRegExp() {
    return `${this._while.source}`;
  }
  getWhileWithResolvedBackReferences(e, t) {
    return this._while.resolveBackReferences(e, t);
  }
  collectPatterns(e, t) {
    t.push(this._begin);
  }
  compile(e, t) {
    return this._getCachedCompiledPatterns(e).compile(e);
  }
  compileAG(e, t, n, r) {
    return this._getCachedCompiledPatterns(e).compileAG(e, n, r);
  }
  _getCachedCompiledPatterns(e) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new Af();
      for (const t of this.patterns)
        e.getRule(t).collectPatterns(e, this._cachedCompiledPatterns);
    }
    return this._cachedCompiledPatterns;
  }
  compileWhile(e, t) {
    return this._getCachedCompiledWhilePatterns(e, t).compile(e);
  }
  compileWhileAG(e, t, n, r) {
    return this._getCachedCompiledWhilePatterns(e, t).compileAG(e, n, r);
  }
  _getCachedCompiledWhilePatterns(e, t) {
    return this._cachedCompiledWhilePatterns || (this._cachedCompiledWhilePatterns = new Af(), this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while)), this._while.hasBackReferences && this._cachedCompiledWhilePatterns.setSource(0, t || "￿"), this._cachedCompiledWhilePatterns;
  }
}, VA = class Pi {
  static createCaptureRule(t, n, r, i, a) {
    return t.registerRule((o) => new lH(n, o, r, i, a));
  }
  static getCompiledRuleId(t, n, r) {
    return t.id || n.registerRule((i) => {
      if (t.id = i, t.match)
        return new fH(
          t.$vscodeTextmateLocation,
          t.id,
          t.name,
          t.match,
          Pi._compileCaptures(t.captures, n, r)
        );
      if (typeof t.begin > "u") {
        t.repository && (r = qA({}, r, t.repository));
        let a = t.patterns;
        return typeof a > "u" && t.include && (a = [{ include: t.include }]), new kx(
          t.$vscodeTextmateLocation,
          t.id,
          t.name,
          t.contentName,
          Pi._compilePatterns(a, n, r)
        );
      }
      return t.while ? new p0(
        t.$vscodeTextmateLocation,
        t.id,
        t.name,
        t.contentName,
        t.begin,
        Pi._compileCaptures(t.beginCaptures || t.captures, n, r),
        t.while,
        Pi._compileCaptures(t.whileCaptures || t.captures, n, r),
        Pi._compilePatterns(t.patterns, n, r)
      ) : new z6(
        t.$vscodeTextmateLocation,
        t.id,
        t.name,
        t.contentName,
        t.begin,
        Pi._compileCaptures(t.beginCaptures || t.captures, n, r),
        t.end,
        Pi._compileCaptures(t.endCaptures || t.captures, n, r),
        t.applyEndPatternLast,
        Pi._compilePatterns(t.patterns, n, r)
      );
    }), t.id;
  }
  static _compileCaptures(t, n, r) {
    let i = [];
    if (t) {
      let a = 0;
      for (const o in t) {
        if (o === "$vscodeTextmateLocation")
          continue;
        const c = parseInt(o, 10);
        c > a && (a = c);
      }
      for (let o = 0; o <= a; o++)
        i[o] = null;
      for (const o in t) {
        if (o === "$vscodeTextmateLocation")
          continue;
        const c = parseInt(o, 10);
        let u = 0;
        t[o].patterns && (u = Pi.getCompiledRuleId(t[o], n, r)), i[c] = Pi.createCaptureRule(n, t[o].$vscodeTextmateLocation, t[o].name, t[o].contentName, u);
      }
    }
    return i;
  }
  static _compilePatterns(t, n, r) {
    let i = [];
    if (t)
      for (let a = 0, o = t.length; a < o; a++) {
        const c = t[a];
        let u = -1;
        if (c.include) {
          const s = HA(c.include);
          switch (s.kind) {
            case 0:
            case 1:
              u = Pi.getCompiledRuleId(r[c.include], n, r);
              break;
            case 2:
              let l = r[s.ruleName];
              l && (u = Pi.getCompiledRuleId(l, n, r));
              break;
            case 3:
            case 4:
              const d = s.scopeName, f = s.kind === 4 ? s.ruleName : null, p = n.getExternalGrammar(d, r);
              if (p)
                if (f) {
                  let g = p.repository[f];
                  g && (u = Pi.getCompiledRuleId(g, n, p.repository));
                } else
                  u = Pi.getCompiledRuleId(p.repository.$self, n, p.repository);
              break;
          }
        } else
          u = Pi.getCompiledRuleId(c, n, r);
        if (u !== -1) {
          const s = n.getRule(u);
          let l = !1;
          if ((s instanceof kx || s instanceof z6 || s instanceof p0) && s.hasMissingPatterns && s.patterns.length === 0 && (l = !0), l)
            continue;
          i.push(u);
        }
      }
    return {
      patterns: i,
      hasMissingPatterns: (t ? t.length : 0) !== i.length
    };
  }
}, kf = class GA {
  source;
  ruleId;
  hasAnchor;
  hasBackReferences;
  _anchorCache;
  constructor(t, n) {
    if (t && typeof t == "string") {
      const r = t.length;
      let i = 0, a = [], o = !1;
      for (let c = 0; c < r; c++)
        if (t.charAt(c) === "\\" && c + 1 < r) {
          const s = t.charAt(c + 1);
          s === "z" ? (a.push(t.substring(i, c)), a.push("$(?!\\n)(?<!\\n)"), i = c + 2) : (s === "A" || s === "G") && (o = !0), c++;
        }
      this.hasAnchor = o, i === 0 ? this.source = t : (a.push(t.substring(i, r)), this.source = a.join(""));
    } else
      this.hasAnchor = !1, this.source = t;
    this.hasAnchor ? this._anchorCache = this._buildAnchorCache() : this._anchorCache = null, this.ruleId = n, typeof this.source == "string" ? this.hasBackReferences = uH.test(this.source) : this.hasBackReferences = !1;
  }
  clone() {
    return new GA(this.source, this.ruleId);
  }
  setSource(t) {
    this.source !== t && (this.source = t, this.hasAnchor && (this._anchorCache = this._buildAnchorCache()));
  }
  resolveBackReferences(t, n) {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let r = n.map((i) => t.substring(i.start, i.end));
    return Cx.lastIndex = 0, this.source.replace(Cx, (i, a) => NA(r[parseInt(a, 10)] || ""));
  }
  _buildAnchorCache() {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let t = [], n = [], r = [], i = [], a, o, c, u;
    for (a = 0, o = this.source.length; a < o; a++)
      c = this.source.charAt(a), t[a] = c, n[a] = c, r[a] = c, i[a] = c, c === "\\" && a + 1 < o && (u = this.source.charAt(a + 1), u === "A" ? (t[a + 1] = "￿", n[a + 1] = "￿", r[a + 1] = "A", i[a + 1] = "A") : u === "G" ? (t[a + 1] = "￿", n[a + 1] = "G", r[a + 1] = "￿", i[a + 1] = "G") : (t[a + 1] = u, n[a + 1] = u, r[a + 1] = u, i[a + 1] = u), a++);
    return {
      A0_G0: t.join(""),
      A0_G1: n.join(""),
      A1_G0: r.join(""),
      A1_G1: i.join("")
    };
  }
  resolveAnchors(t, n) {
    return !this.hasAnchor || !this._anchorCache || typeof this.source != "string" ? this.source : t ? n ? this._anchorCache.A1_G1 : this._anchorCache.A1_G0 : n ? this._anchorCache.A0_G1 : this._anchorCache.A0_G0;
  }
}, Af = class {
  _items;
  _hasAnchors;
  _cached;
  _anchorCache;
  constructor() {
    this._items = [], this._hasAnchors = !1, this._cached = null, this._anchorCache = {
      A0_G0: null,
      A0_G1: null,
      A1_G0: null,
      A1_G1: null
    };
  }
  dispose() {
    this._disposeCaches();
  }
  _disposeCaches() {
    this._cached && (this._cached.dispose(), this._cached = null), this._anchorCache.A0_G0 && (this._anchorCache.A0_G0.dispose(), this._anchorCache.A0_G0 = null), this._anchorCache.A0_G1 && (this._anchorCache.A0_G1.dispose(), this._anchorCache.A0_G1 = null), this._anchorCache.A1_G0 && (this._anchorCache.A1_G0.dispose(), this._anchorCache.A1_G0 = null), this._anchorCache.A1_G1 && (this._anchorCache.A1_G1.dispose(), this._anchorCache.A1_G1 = null);
  }
  push(e) {
    this._items.push(e), this._hasAnchors = this._hasAnchors || e.hasAnchor;
  }
  unshift(e) {
    this._items.unshift(e), this._hasAnchors = this._hasAnchors || e.hasAnchor;
  }
  length() {
    return this._items.length;
  }
  setSource(e, t) {
    this._items[e].source !== t && (this._disposeCaches(), this._items[e].setSource(t));
  }
  compile(e) {
    if (!this._cached) {
      let t = this._items.map((n) => n.source);
      this._cached = new Ax(e, t, this._items.map((n) => n.ruleId));
    }
    return this._cached;
  }
  compileAG(e, t, n) {
    return this._hasAnchors ? t ? n ? (this._anchorCache.A1_G1 || (this._anchorCache.A1_G1 = this._resolveAnchors(e, t, n)), this._anchorCache.A1_G1) : (this._anchorCache.A1_G0 || (this._anchorCache.A1_G0 = this._resolveAnchors(e, t, n)), this._anchorCache.A1_G0) : n ? (this._anchorCache.A0_G1 || (this._anchorCache.A0_G1 = this._resolveAnchors(e, t, n)), this._anchorCache.A0_G1) : (this._anchorCache.A0_G0 || (this._anchorCache.A0_G0 = this._resolveAnchors(e, t, n)), this._anchorCache.A0_G0) : this.compile(e);
  }
  _resolveAnchors(e, t, n) {
    let r = this._items.map((i) => i.resolveAnchors(t, n));
    return new Ax(e, r, this._items.map((i) => i.ruleId));
  }
}, Ax = class {
  constructor(e, t, n) {
    this.regExps = t, this.rules = n, this.scanner = e.createOnigScanner(t);
  }
  scanner;
  dispose() {
    typeof this.scanner.dispose == "function" && this.scanner.dispose();
  }
  toString() {
    const e = [];
    for (let t = 0, n = this.rules.length; t < n; t++)
      e.push("   - " + this.rules[t] + ": " + this.regExps[t]);
    return e.join(`
`);
  }
  findNextMatchSync(e, t, n) {
    const r = this.scanner.findNextMatchSync(e, t, n);
    return r ? {
      ruleId: this.rules[r.index],
      captureIndices: r.captureIndices
    } : null;
  }
}, em = class {
  constructor(e, t) {
    this.languageId = e, this.tokenType = t;
  }
}, pH = class V6 {
  _defaultAttributes;
  _embeddedLanguagesMatcher;
  constructor(t, n) {
    this._defaultAttributes = new em(
      t,
      8
      /* NotSet */
    ), this._embeddedLanguagesMatcher = new dH(Object.entries(n || {}));
  }
  getDefaultAttributes() {
    return this._defaultAttributes;
  }
  getBasicScopeAttributes(t) {
    return t === null ? V6._NULL_SCOPE_METADATA : this._getBasicScopeAttributes.get(t);
  }
  static _NULL_SCOPE_METADATA = new em(0, 0);
  _getBasicScopeAttributes = new FA((t) => {
    const n = this._scopeToLanguage(t), r = this._toStandardTokenType(t);
    return new em(n, r);
  });
  /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */
  _scopeToLanguage(t) {
    return this._embeddedLanguagesMatcher.match(t) || 0;
  }
  _toStandardTokenType(t) {
    const n = t.match(V6.STANDARD_TOKEN_TYPE_REGEXP);
    if (!n)
      return 8;
    switch (n[1]) {
      case "comment":
        return 1;
      case "string":
        return 2;
      case "regex":
        return 3;
      case "meta.embedded":
        return 0;
    }
    throw new Error("Unexpected match for standard token type!");
  }
  static STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex|meta\.embedded)\b/;
}, dH = class {
  values;
  scopesRegExp;
  constructor(e) {
    if (e.length === 0)
      this.values = null, this.scopesRegExp = null;
    else {
      this.values = new Map(e);
      const t = e.map(
        ([n, r]) => NA(n)
      );
      t.sort(), t.reverse(), this.scopesRegExp = new RegExp(
        `^((${t.join(")|(")}))($|\\.)`,
        ""
      );
    }
  }
  match(e) {
    if (!this.scopesRegExp)
      return;
    const t = e.match(this.scopesRegExp);
    if (t)
      return this.values.get(t[1]);
  }
};
typeof gn < "u" && gn.env.VSCODE_TEXTMATE_DEBUG;
var Ex = class {
  constructor(e, t) {
    this.stack = e, this.stoppedEarly = t;
  }
};
function WA(e, t, n, r, i, a, o, c) {
  const u = t.content.length;
  let s = !1, l = -1;
  if (o) {
    const p = hH(
      e,
      t,
      n,
      r,
      i,
      a
    );
    i = p.stack, r = p.linePos, n = p.isFirstLine, l = p.anchorPosition;
  }
  const d = Date.now();
  for (; !s; ) {
    if (c !== 0 && Date.now() - d > c)
      return new Ex(i, !0);
    f();
  }
  return new Ex(i, !1);
  function f() {
    const p = mH(
      e,
      t,
      n,
      r,
      i,
      l
    );
    if (!p) {
      a.produce(i, u), s = !0;
      return;
    }
    const g = p.captureIndices, b = p.matchedRuleId, w = g && g.length > 0 ? g[0].end > r : !1;
    if (b === cH) {
      const y = i.getRule(e);
      a.produce(i, g[0].start), i = i.withContentNameScopesList(i.nameScopesList), sf(
        e,
        t,
        n,
        i,
        a,
        y.endCaptures,
        g
      ), a.produce(i, g[0].end);
      const v = i;
      if (i = i.parent, l = v.getAnchorPos(), !w && v.getEnterPos() === r) {
        i = v, a.produce(i, u), s = !0;
        return;
      }
    } else {
      const y = e.getRule(b);
      a.produce(i, g[0].start);
      const v = i, _ = y.getName(t.content, g), E = i.contentNameScopesList.pushAttributed(
        _,
        e
      );
      if (i = i.push(
        b,
        r,
        l,
        g[0].end === u,
        null,
        E,
        E
      ), y instanceof z6) {
        const O = y;
        sf(
          e,
          t,
          n,
          i,
          a,
          O.beginCaptures,
          g
        ), a.produce(i, g[0].end), l = g[0].end;
        const M = O.getContentName(
          t.content,
          g
        ), L = E.pushAttributed(
          M,
          e
        );
        if (i = i.withContentNameScopesList(L), O.endHasBackReferences && (i = i.withEndRule(
          O.getEndWithResolvedBackReferences(
            t.content,
            g
          )
        )), !w && v.hasSameRuleAs(i)) {
          i = i.pop(), a.produce(i, u), s = !0;
          return;
        }
      } else if (y instanceof p0) {
        const O = y;
        sf(
          e,
          t,
          n,
          i,
          a,
          O.beginCaptures,
          g
        ), a.produce(i, g[0].end), l = g[0].end;
        const M = O.getContentName(
          t.content,
          g
        ), L = E.pushAttributed(
          M,
          e
        );
        if (i = i.withContentNameScopesList(L), O.whileHasBackReferences && (i = i.withEndRule(
          O.getWhileWithResolvedBackReferences(
            t.content,
            g
          )
        )), !w && v.hasSameRuleAs(i)) {
          i = i.pop(), a.produce(i, u), s = !0;
          return;
        }
      } else if (sf(
        e,
        t,
        n,
        i,
        a,
        y.captures,
        g
      ), a.produce(i, g[0].end), i = i.pop(), !w) {
        i = i.safePop(), a.produce(i, u), s = !0;
        return;
      }
    }
    g[0].end > r && (r = g[0].end, n = !1);
  }
}
function hH(e, t, n, r, i, a) {
  let o = i.beginRuleCapturedEOL ? 0 : -1;
  const c = [];
  for (let u = i; u; u = u.pop()) {
    const s = u.getRule(e);
    s instanceof p0 && c.push({
      rule: s,
      stack: u
    });
  }
  for (let u = c.pop(); u; u = c.pop()) {
    const { ruleScanner: s, findOptions: l } = yH(u.rule, e, u.stack.endRule, n, r === o), d = s.findNextMatchSync(t, r, l);
    if (d) {
      if (d.ruleId !== zA) {
        i = u.stack.pop();
        break;
      }
      d.captureIndices && d.captureIndices.length && (a.produce(u.stack, d.captureIndices[0].start), sf(e, t, n, u.stack, a, u.rule.whileCaptures, d.captureIndices), a.produce(u.stack, d.captureIndices[0].end), o = d.captureIndices[0].end, d.captureIndices[0].end > r && (r = d.captureIndices[0].end, n = !1));
    } else {
      i = u.stack.pop();
      break;
    }
  }
  return { stack: i, linePos: r, anchorPosition: o, isFirstLine: n };
}
function mH(e, t, n, r, i, a) {
  const o = gH(e, t, n, r, i, a), c = e.getInjections();
  if (c.length === 0)
    return o;
  const u = vH(c, e, t, n, r, i, a);
  if (!u)
    return o;
  if (!o)
    return u;
  const s = o.captureIndices[0].start, l = u.captureIndices[0].start;
  return l < s || u.priorityMatch && l === s ? u : o;
}
function gH(e, t, n, r, i, a) {
  const o = i.getRule(e), { ruleScanner: c, findOptions: u } = KA(o, e, i.endRule, n, r === a), s = c.findNextMatchSync(t, r, u);
  return s ? {
    captureIndices: s.captureIndices,
    matchedRuleId: s.ruleId
  } : null;
}
function vH(e, t, n, r, i, a, o) {
  let c = Number.MAX_VALUE, u = null, s, l = 0;
  const d = a.contentNameScopesList.getScopeNames();
  for (let f = 0, p = e.length; f < p; f++) {
    const g = e[f];
    if (!g.matcher(d))
      continue;
    const b = t.getRule(g.ruleId), { ruleScanner: w, findOptions: y } = KA(b, t, null, r, i === o), v = w.findNextMatchSync(n, i, y);
    if (!v)
      continue;
    const _ = v.captureIndices[0].start;
    if (!(_ >= c) && (c = _, u = v.captureIndices, s = v.ruleId, l = g.priority, c === i))
      break;
  }
  return u ? {
    priorityMatch: l === -1,
    captureIndices: u,
    matchedRuleId: s
  } : null;
}
function KA(e, t, n, r, i) {
  return {
    ruleScanner: e.compileAG(t, n, r, i),
    findOptions: 0
    /* None */
  };
}
function yH(e, t, n, r, i) {
  return {
    ruleScanner: e.compileWhileAG(t, n, r, i),
    findOptions: 0
    /* None */
  };
}
function sf(e, t, n, r, i, a, o) {
  if (a.length === 0)
    return;
  const c = t.content, u = Math.min(a.length, o.length), s = [], l = o[0].end;
  for (let d = 0; d < u; d++) {
    const f = a[d];
    if (f === null)
      continue;
    const p = o[d];
    if (p.length === 0)
      continue;
    if (p.start > l)
      break;
    for (; s.length > 0 && s[s.length - 1].endPos <= p.start; )
      i.produceFromScopes(s[s.length - 1].scopes, s[s.length - 1].endPos), s.pop();
    if (s.length > 0 ? i.produceFromScopes(s[s.length - 1].scopes, p.start) : i.produce(r, p.start), f.retokenizeCapturedWithRuleId) {
      const b = f.getName(c, o), w = r.contentNameScopesList.pushAttributed(b, e), y = f.getContentName(c, o), v = w.pushAttributed(y, e), _ = r.push(f.retokenizeCapturedWithRuleId, p.start, -1, !1, null, w, v), E = e.createOnigString(c.substring(0, p.end));
      WA(
        e,
        E,
        n && p.start === 0,
        p.start,
        _,
        i,
        !1,
        /* no time limit */
        0
      ), UA(E);
      continue;
    }
    const g = f.getName(c, o);
    if (g !== null) {
      const w = (s.length > 0 ? s[s.length - 1].scopes : r.contentNameScopesList).pushAttributed(g, e);
      s.push(new bH(w, p.end));
    }
  }
  for (; s.length > 0; )
    i.produceFromScopes(s[s.length - 1].scopes, s[s.length - 1].endPos), s.pop();
}
var bH = class {
  scopes;
  endPos;
  constructor(e, t) {
    this.scopes = e, this.endPos = t;
  }
};
function xH(e, t, n, r, i, a, o, c) {
  return new wH(
    e,
    t,
    n,
    r,
    i,
    a,
    o,
    c
  );
}
function Ox(e, t, n, r, i) {
  const a = l0(t, d0), o = VA.getCompiledRuleId(n, r, i.repository);
  for (const c of a)
    e.push({
      debugSelector: t,
      matcher: c.matcher,
      ruleId: o,
      grammar: i,
      priority: c.priority
    });
}
function d0(e, t) {
  if (t.length < e.length)
    return !1;
  let n = 0;
  return e.every((r) => {
    for (let i = n; i < t.length; i++)
      if (_H(t[i], r))
        return n = i + 1, !0;
    return !1;
  });
}
function _H(e, t) {
  if (!e)
    return !1;
  if (e === t)
    return !0;
  const n = t.length;
  return e.length > n && e.substr(0, n) === t && e[n] === ".";
}
var wH = class {
  constructor(e, t, n, r, i, a, o, c) {
    if (this._rootScopeName = e, this.balancedBracketSelectors = a, this._onigLib = c, this._basicScopeAttributesProvider = new pH(
      n,
      r
    ), this._rootId = -1, this._lastRuleId = 0, this._ruleId2desc = [null], this._includedGrammars = {}, this._grammarRepository = o, this._grammar = Tx(t, null), this._injections = null, this._tokenTypeMatchers = [], i)
      for (const u of Object.keys(i)) {
        const s = l0(u, d0);
        for (const l of s)
          this._tokenTypeMatchers.push({
            matcher: l.matcher,
            type: i[u]
          });
      }
  }
  _rootId;
  _lastRuleId;
  _ruleId2desc;
  _includedGrammars;
  _grammarRepository;
  _grammar;
  _injections;
  _basicScopeAttributesProvider;
  _tokenTypeMatchers;
  get themeProvider() {
    return this._grammarRepository;
  }
  dispose() {
    for (const e of this._ruleId2desc)
      e && e.dispose();
  }
  createOnigScanner(e) {
    return this._onigLib.createOnigScanner(e);
  }
  createOnigString(e) {
    return this._onigLib.createOnigString(e);
  }
  getMetadataForScope(e) {
    return this._basicScopeAttributesProvider.getBasicScopeAttributes(e);
  }
  _collectInjections() {
    const e = {
      lookup: (i) => i === this._rootScopeName ? this._grammar : this.getExternalGrammar(i),
      injections: (i) => this._grammarRepository.injections(i)
    }, t = [], n = this._rootScopeName, r = e.lookup(n);
    if (r) {
      const i = r.injections;
      if (i)
        for (let o in i)
          Ox(
            t,
            o,
            i[o],
            this,
            r
          );
      const a = this._grammarRepository.injections(n);
      a && a.forEach((o) => {
        const c = this.getExternalGrammar(o);
        if (c) {
          const u = c.injectionSelector;
          u && Ox(
            t,
            u,
            c,
            this,
            c
          );
        }
      });
    }
    return t.sort((i, a) => i.priority - a.priority), t;
  }
  getInjections() {
    return this._injections === null && (this._injections = this._collectInjections()), this._injections;
  }
  registerRule(e) {
    const t = ++this._lastRuleId, n = e(t);
    return this._ruleId2desc[t] = n, n;
  }
  getRule(e) {
    return this._ruleId2desc[e];
  }
  getExternalGrammar(e, t) {
    if (this._includedGrammars[e])
      return this._includedGrammars[e];
    if (this._grammarRepository) {
      const n = this._grammarRepository.lookup(e);
      if (n)
        return this._includedGrammars[e] = Tx(
          n,
          t && t.$base
        ), this._includedGrammars[e];
    }
  }
  tokenizeLine(e, t, n = 0) {
    const r = this._tokenize(e, t, !1, n);
    return {
      tokens: r.lineTokens.getResult(r.ruleStack, r.lineLength),
      ruleStack: r.ruleStack,
      stoppedEarly: r.stoppedEarly
    };
  }
  tokenizeLine2(e, t, n = 0) {
    const r = this._tokenize(e, t, !0, n);
    return {
      tokens: r.lineTokens.getBinaryResult(r.ruleStack, r.lineLength),
      ruleStack: r.ruleStack,
      stoppedEarly: r.stoppedEarly
    };
  }
  _tokenize(e, t, n, r) {
    this._rootId === -1 && (this._rootId = VA.getCompiledRuleId(
      this._grammar.repository.$self,
      this,
      this._grammar.repository
    ), this.getInjections());
    let i;
    if (!t || t === G6.NULL) {
      i = !0;
      const s = this._basicScopeAttributesProvider.getDefaultAttributes(), l = this.themeProvider.getDefaults(), d = dc.set(
        0,
        s.languageId,
        s.tokenType,
        null,
        l.fontStyle,
        l.foregroundId,
        l.backgroundId
      ), f = this.getRule(this._rootId).getName(
        null,
        null
      );
      let p;
      f ? p = pf.createRootAndLookUpScopeName(
        f,
        d,
        this
      ) : p = pf.createRoot(
        "unknown",
        d
      ), t = new G6(
        null,
        this._rootId,
        -1,
        -1,
        !1,
        null,
        p,
        p
      );
    } else
      i = !1, t.reset();
    e = e + `
`;
    const a = this.createOnigString(e), o = a.content.length, c = new CH(
      n,
      e,
      this._tokenTypeMatchers,
      this.balancedBracketSelectors
    ), u = WA(
      this,
      a,
      i,
      0,
      t,
      c,
      !0,
      r
    );
    return UA(a), {
      lineLength: o,
      lineTokens: c,
      ruleStack: u.stack,
      stoppedEarly: u.stoppedEarly
    };
  }
};
function Tx(e, t) {
  return e = BU(e), e.repository = e.repository || {}, e.repository.$self = {
    $vscodeTextmateLocation: e.$vscodeTextmateLocation,
    patterns: e.patterns,
    name: e.scopeName
  }, e.repository.$base = t || e.repository.$self, e;
}
var pf = class po {
  /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(t, n, r) {
    this.parent = t, this.scopePath = n, this.tokenAttributes = r;
  }
  static fromExtension(t, n) {
    let r = t, i = t?.scopePath ?? null;
    for (const a of n)
      i = X5.push(i, a.scopeNames), r = new po(r, i, a.encodedTokenAttributes);
    return r;
  }
  static createRoot(t, n) {
    return new po(null, new X5(null, t), n);
  }
  static createRootAndLookUpScopeName(t, n, r) {
    const i = r.getMetadataForScope(t), a = new X5(null, t), o = r.themeProvider.themeMatch(a), c = po.mergeAttributes(
      n,
      i,
      o
    );
    return new po(null, a, c);
  }
  get scopeName() {
    return this.scopePath.scopeName;
  }
  toString() {
    return this.getScopeNames().join(" ");
  }
  equals(t) {
    return po.equals(this, t);
  }
  static equals(t, n) {
    do {
      if (t === n || !t && !n)
        return !0;
      if (!t || !n || t.scopeName !== n.scopeName || t.tokenAttributes !== n.tokenAttributes)
        return !1;
      t = t.parent, n = n.parent;
    } while (!0);
  }
  static mergeAttributes(t, n, r) {
    let i = -1, a = 0, o = 0;
    return r !== null && (i = r.fontStyle, a = r.foregroundId, o = r.backgroundId), dc.set(
      t,
      n.languageId,
      n.tokenType,
      null,
      i,
      a,
      o
    );
  }
  pushAttributed(t, n) {
    if (t === null)
      return this;
    if (t.indexOf(" ") === -1)
      return po._pushAttributed(this, t, n);
    const r = t.split(/ /g);
    let i = this;
    for (const a of r)
      i = po._pushAttributed(i, a, n);
    return i;
  }
  static _pushAttributed(t, n, r) {
    const i = r.getMetadataForScope(n), a = t.scopePath.push(n), o = r.themeProvider.themeMatch(a), c = po.mergeAttributes(
      t.tokenAttributes,
      i,
      o
    );
    return new po(t, a, c);
  }
  getScopeNames() {
    return this.scopePath.getSegments();
  }
  getExtensionIfDefined(t) {
    const n = [];
    let r = this;
    for (; r && r !== t; )
      n.push({
        encodedTokenAttributes: r.tokenAttributes,
        scopeNames: r.scopePath.getExtensionIfDefined(r.parent?.scopePath ?? null)
      }), r = r.parent;
    return r === t ? n.reverse() : void 0;
  }
}, G6 = class pu {
  /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(t, n, r, i, a, o, c, u) {
    this.parent = t, this.ruleId = n, this.beginRuleCapturedEOL = a, this.endRule = o, this.nameScopesList = c, this.contentNameScopesList = u, this.depth = this.parent ? this.parent.depth + 1 : 1, this._enterPos = r, this._anchorPos = i;
  }
  _stackElementBrand = void 0;
  // TODO remove me
  static NULL = new pu(
    null,
    0,
    0,
    0,
    !1,
    null,
    null,
    null
  );
  /**
   * The position on the current line where this state was pushed.
   * This is relevant only while tokenizing a line, to detect endless loops.
   * Its value is meaningless across lines.
   */
  _enterPos;
  /**
   * The captured anchor position when this stack element was pushed.
   * This is relevant only while tokenizing a line, to restore the anchor position when popping.
   * Its value is meaningless across lines.
   */
  _anchorPos;
  /**
   * The depth of the stack.
   */
  depth;
  equals(t) {
    return t === null ? !1 : pu._equals(this, t);
  }
  static _equals(t, n) {
    return t === n ? !0 : this._structuralEquals(t, n) ? pf.equals(t.contentNameScopesList, n.contentNameScopesList) : !1;
  }
  /**
   * A structural equals check. Does not take into account `scopes`.
   */
  static _structuralEquals(t, n) {
    do {
      if (t === n || !t && !n)
        return !0;
      if (!t || !n || t.depth !== n.depth || t.ruleId !== n.ruleId || t.endRule !== n.endRule)
        return !1;
      t = t.parent, n = n.parent;
    } while (!0);
  }
  clone() {
    return this;
  }
  static _reset(t) {
    for (; t; )
      t._enterPos = -1, t._anchorPos = -1, t = t.parent;
  }
  reset() {
    pu._reset(this);
  }
  pop() {
    return this.parent;
  }
  safePop() {
    return this.parent ? this.parent : this;
  }
  push(t, n, r, i, a, o, c) {
    return new pu(
      this,
      t,
      n,
      r,
      i,
      a,
      o,
      c
    );
  }
  getEnterPos() {
    return this._enterPos;
  }
  getAnchorPos() {
    return this._anchorPos;
  }
  getRule(t) {
    return t.getRule(this.ruleId);
  }
  toString() {
    const t = [];
    return this._writeString(t, 0), "[" + t.join(",") + "]";
  }
  _writeString(t, n) {
    return this.parent && (n = this.parent._writeString(t, n)), t[n++] = `(${this.ruleId}, ${this.nameScopesList?.toString()}, ${this.contentNameScopesList?.toString()})`, n;
  }
  withContentNameScopesList(t) {
    return this.contentNameScopesList === t ? this : this.parent.push(
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      this.endRule,
      this.nameScopesList,
      t
    );
  }
  withEndRule(t) {
    return this.endRule === t ? this : new pu(
      this.parent,
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      t,
      this.nameScopesList,
      this.contentNameScopesList
    );
  }
  // Used to warn of endless loops
  hasSameRuleAs(t) {
    let n = this;
    for (; n && n._enterPos === t._enterPos; ) {
      if (n.ruleId === t.ruleId)
        return !0;
      n = n.parent;
    }
    return !1;
  }
  toStateStackFrame() {
    return {
      ruleId: this.ruleId,
      beginRuleCapturedEOL: this.beginRuleCapturedEOL,
      endRule: this.endRule,
      nameScopesList: this.nameScopesList?.getExtensionIfDefined(this.parent?.nameScopesList ?? null) ?? [],
      contentNameScopesList: this.contentNameScopesList?.getExtensionIfDefined(this.nameScopesList) ?? []
    };
  }
  static pushFrame(t, n) {
    const r = pf.fromExtension(t?.nameScopesList ?? null, n.nameScopesList);
    return new pu(
      t,
      n.ruleId,
      n.enterPos ?? -1,
      n.anchorPos ?? -1,
      n.beginRuleCapturedEOL,
      n.endRule,
      r,
      pf.fromExtension(r, n.contentNameScopesList)
    );
  }
}, SH = class {
  balancedBracketScopes;
  unbalancedBracketScopes;
  allowAny = !1;
  constructor(e, t) {
    this.balancedBracketScopes = e.flatMap(
      (n) => n === "*" ? (this.allowAny = !0, []) : l0(n, d0).map((r) => r.matcher)
    ), this.unbalancedBracketScopes = t.flatMap(
      (n) => l0(n, d0).map((r) => r.matcher)
    );
  }
  get matchesAlways() {
    return this.allowAny && this.unbalancedBracketScopes.length === 0;
  }
  get matchesNever() {
    return this.balancedBracketScopes.length === 0 && !this.allowAny;
  }
  match(e) {
    for (const t of this.unbalancedBracketScopes)
      if (t(e))
        return !1;
    for (const t of this.balancedBracketScopes)
      if (t(e))
        return !0;
    return this.allowAny;
  }
}, CH = class {
  constructor(e, t, n, r) {
    this.balancedBracketSelectors = r, this._emitBinaryTokens = e, this._tokenTypeOverrides = n, this._lineText = null, this._tokens = [], this._binaryTokens = [], this._lastTokenEndIndex = 0;
  }
  _emitBinaryTokens;
  /**
   * defined only if `false`.
   */
  _lineText;
  /**
   * used only if `_emitBinaryTokens` is false.
   */
  _tokens;
  /**
   * used only if `_emitBinaryTokens` is true.
   */
  _binaryTokens;
  _lastTokenEndIndex;
  _tokenTypeOverrides;
  produce(e, t) {
    this.produceFromScopes(e.contentNameScopesList, t);
  }
  produceFromScopes(e, t) {
    if (this._lastTokenEndIndex >= t)
      return;
    if (this._emitBinaryTokens) {
      let r = e?.tokenAttributes ?? 0, i = !1;
      if (this.balancedBracketSelectors?.matchesAlways && (i = !0), this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
        const a = e?.getScopeNames() ?? [];
        for (const o of this._tokenTypeOverrides)
          o.matcher(a) && (r = dc.set(
            r,
            0,
            o.type,
            null,
            -1,
            0,
            0
          ));
        this.balancedBracketSelectors && (i = this.balancedBracketSelectors.match(a));
      }
      if (i && (r = dc.set(
        r,
        0,
        8,
        i,
        -1,
        0,
        0
      )), this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === r) {
        this._lastTokenEndIndex = t;
        return;
      }
      this._binaryTokens.push(this._lastTokenEndIndex), this._binaryTokens.push(r), this._lastTokenEndIndex = t;
      return;
    }
    const n = e?.getScopeNames() ?? [];
    this._tokens.push({
      startIndex: this._lastTokenEndIndex,
      endIndex: t,
      // value: lineText.substring(lastTokenEndIndex, endIndex),
      scopes: n
    }), this._lastTokenEndIndex = t;
  }
  getResult(e, t) {
    return this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === t - 1 && this._tokens.pop(), this._tokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(e, t), this._tokens[this._tokens.length - 1].startIndex = 0), this._tokens;
  }
  getBinaryResult(e, t) {
    this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === t - 1 && (this._binaryTokens.pop(), this._binaryTokens.pop()), this._binaryTokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(e, t), this._binaryTokens[this._binaryTokens.length - 2] = 0);
    const n = new Uint32Array(this._binaryTokens.length);
    for (let r = 0, i = this._binaryTokens.length; r < i; r++)
      n[r] = this._binaryTokens[r];
    return n;
  }
}, kH = class {
  constructor(e, t) {
    this._onigLib = t, this._theme = e;
  }
  _grammars = /* @__PURE__ */ new Map();
  _rawGrammars = /* @__PURE__ */ new Map();
  _injectionGrammars = /* @__PURE__ */ new Map();
  _theme;
  dispose() {
    for (const e of this._grammars.values())
      e.dispose();
  }
  setTheme(e) {
    this._theme = e;
  }
  getColorMap() {
    return this._theme.getColorMap();
  }
  /**
   * Add `grammar` to registry and return a list of referenced scope names
   */
  addGrammar(e, t) {
    this._rawGrammars.set(e.scopeName, e), t && this._injectionGrammars.set(e.scopeName, t);
  }
  /**
   * Lookup a raw grammar.
   */
  lookup(e) {
    return this._rawGrammars.get(e);
  }
  /**
   * Returns the injections for the given grammar
   */
  injections(e) {
    return this._injectionGrammars.get(e);
  }
  /**
   * Get the default theme settings
   */
  getDefaults() {
    return this._theme.getDefaults();
  }
  /**
   * Match a scope in the theme.
   */
  themeMatch(e) {
    return this._theme.match(e);
  }
  /**
   * Lookup a grammar.
   */
  grammarForScopeName(e, t, n, r, i) {
    if (!this._grammars.has(e)) {
      let a = this._rawGrammars.get(e);
      if (!a)
        return null;
      this._grammars.set(e, xH(
        e,
        a,
        t,
        n,
        r,
        i,
        this,
        this._onigLib
      ));
    }
    return this._grammars.get(e);
  }
}, AH = class {
  _options;
  _syncRegistry;
  _ensureGrammarCache;
  constructor(t) {
    this._options = t, this._syncRegistry = new kH(
      c0.createFromRawTheme(t.theme, t.colorMap),
      t.onigLib
    ), this._ensureGrammarCache = /* @__PURE__ */ new Map();
  }
  dispose() {
    this._syncRegistry.dispose();
  }
  /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */
  setTheme(t, n) {
    this._syncRegistry.setTheme(c0.createFromRawTheme(t, n));
  }
  /**
   * Returns a lookup array for color ids.
   */
  getColorMap() {
    return this._syncRegistry.getColorMap();
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithEmbeddedLanguages(t, n, r) {
    return this.loadGrammarWithConfiguration(t, n, { embeddedLanguages: r });
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithConfiguration(t, n, r) {
    return this._loadGrammar(
      t,
      n,
      r.embeddedLanguages,
      r.tokenTypes,
      new SH(
        r.balancedBracketSelectors || [],
        r.unbalancedBracketSelectors || []
      )
    );
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */
  loadGrammar(t) {
    return this._loadGrammar(t, 0, null, null, null);
  }
  _loadGrammar(t, n, r, i, a) {
    const o = new tH(this._syncRegistry, t);
    for (; o.Q.length > 0; )
      o.Q.map((c) => this._loadSingleGrammar(c.scopeName)), o.processQueue();
    return this._grammarForScopeName(
      t,
      n,
      r,
      i,
      a
    );
  }
  _loadSingleGrammar(t) {
    this._ensureGrammarCache.has(t) || (this._doLoadSingleGrammar(t), this._ensureGrammarCache.set(t, !0));
  }
  _doLoadSingleGrammar(t) {
    const n = this._options.loadGrammar(t);
    if (n) {
      const r = typeof this._options.getInjections == "function" ? this._options.getInjections(t) : void 0;
      this._syncRegistry.addGrammar(n, r);
    }
  }
  /**
   * Adds a rawGrammar.
   */
  addGrammar(t, n = [], r = 0, i = null) {
    return this._syncRegistry.addGrammar(t, n), this._grammarForScopeName(t.scopeName, r, i);
  }
  /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */
  _grammarForScopeName(t, n = 0, r = null, i = null, a = null) {
    return this._syncRegistry.grammarForScopeName(
      t,
      n,
      r,
      i,
      a
    );
  }
}, W6 = G6.NULL;
const EH = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
];
class Zf {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Zf.prototype.normal = {};
Zf.prototype.property = {};
Zf.prototype.space = void 0;
function ZA(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new Zf(n, r, t);
}
function K6(e) {
  return e.toLowerCase();
}
class na {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
na.prototype.attribute = "";
na.prototype.booleanish = !1;
na.prototype.boolean = !1;
na.prototype.commaOrSpaceSeparated = !1;
na.prototype.commaSeparated = !1;
na.prototype.defined = !1;
na.prototype.mustUseProperty = !1;
na.prototype.number = !1;
na.prototype.overloadedBoolean = !1;
na.prototype.property = "";
na.prototype.spaceSeparated = !1;
na.prototype.space = void 0;
let OH = 0;
const wn = Tu(), oi = Tu(), YA = Tu(), Cr = Tu(), Vn = Tu(), rc = Tu(), pa = Tu();
function Tu() {
  return 2 ** ++OH;
}
const Z6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: wn,
  booleanish: oi,
  commaOrSpaceSeparated: pa,
  commaSeparated: rc,
  number: Cr,
  overloadedBoolean: YA,
  spaceSeparated: Vn
}, Symbol.toStringTag, { value: "Module" })), tm = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Z6)
);
class F2 extends na {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), Px(this, "space", i), typeof r == "number")
      for (; ++a < tm.length; ) {
        const o = tm[a];
        Px(this, tm[a], (r & Z6[o]) === Z6[o]);
      }
  }
}
F2.prototype.defined = !0;
function Px(e, t, n) {
  n && (e[t] = n);
}
function Ac(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new F2(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[K6(r)] = r, n[K6(a.attribute)] = r;
  }
  return new Zf(t, n, e.space);
}
const JA = Ac({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: oi,
    ariaAutoComplete: null,
    ariaBusy: oi,
    ariaChecked: oi,
    ariaColCount: Cr,
    ariaColIndex: Cr,
    ariaColSpan: Cr,
    ariaControls: Vn,
    ariaCurrent: null,
    ariaDescribedBy: Vn,
    ariaDetails: null,
    ariaDisabled: oi,
    ariaDropEffect: Vn,
    ariaErrorMessage: null,
    ariaExpanded: oi,
    ariaFlowTo: Vn,
    ariaGrabbed: oi,
    ariaHasPopup: null,
    ariaHidden: oi,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Vn,
    ariaLevel: Cr,
    ariaLive: null,
    ariaModal: oi,
    ariaMultiLine: oi,
    ariaMultiSelectable: oi,
    ariaOrientation: null,
    ariaOwns: Vn,
    ariaPlaceholder: null,
    ariaPosInSet: Cr,
    ariaPressed: oi,
    ariaReadOnly: oi,
    ariaRelevant: null,
    ariaRequired: oi,
    ariaRoleDescription: Vn,
    ariaRowCount: Cr,
    ariaRowIndex: Cr,
    ariaRowSpan: Cr,
    ariaSelected: oi,
    ariaSetSize: Cr,
    ariaSort: null,
    ariaValueMax: Cr,
    ariaValueMin: Cr,
    ariaValueNow: Cr,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function QA(e, t) {
  return t in e ? e[t] : t;
}
function XA(e, t) {
  return QA(e, t.toLowerCase());
}
const TH = Ac({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: rc,
    acceptCharset: Vn,
    accessKey: Vn,
    action: null,
    allow: null,
    allowFullScreen: wn,
    allowPaymentRequest: wn,
    allowUserMedia: wn,
    alt: null,
    as: null,
    async: wn,
    autoCapitalize: null,
    autoComplete: Vn,
    autoFocus: wn,
    autoPlay: wn,
    blocking: Vn,
    capture: null,
    charSet: null,
    checked: wn,
    cite: null,
    className: Vn,
    cols: Cr,
    colSpan: null,
    content: null,
    contentEditable: oi,
    controls: wn,
    controlsList: Vn,
    coords: Cr | rc,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: wn,
    defer: wn,
    dir: null,
    dirName: null,
    disabled: wn,
    download: YA,
    draggable: oi,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: wn,
    formTarget: null,
    headers: Vn,
    height: Cr,
    hidden: wn,
    high: Cr,
    href: null,
    hrefLang: null,
    htmlFor: Vn,
    httpEquiv: Vn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: wn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: wn,
    itemId: null,
    itemProp: Vn,
    itemRef: Vn,
    itemScope: wn,
    itemType: Vn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: wn,
    low: Cr,
    manifest: null,
    max: null,
    maxLength: Cr,
    media: null,
    method: null,
    min: null,
    minLength: Cr,
    multiple: wn,
    muted: wn,
    name: null,
    nonce: null,
    noModule: wn,
    noValidate: wn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: wn,
    optimum: Cr,
    pattern: null,
    ping: Vn,
    placeholder: null,
    playsInline: wn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: wn,
    referrerPolicy: null,
    rel: Vn,
    required: wn,
    reversed: wn,
    rows: Cr,
    rowSpan: Cr,
    sandbox: Vn,
    scope: null,
    scoped: wn,
    seamless: wn,
    selected: wn,
    shadowRootClonable: wn,
    shadowRootDelegatesFocus: wn,
    shadowRootMode: null,
    shape: null,
    size: Cr,
    sizes: null,
    slot: null,
    span: Cr,
    spellCheck: oi,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Cr,
    step: null,
    style: null,
    tabIndex: Cr,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: wn,
    useMap: null,
    value: oi,
    width: Cr,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Vn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Cr,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Cr,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: wn,
    // Lists. Use CSS to reduce space between items instead
    declare: wn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Cr,
    // `<img>` and `<object>`
    leftMargin: Cr,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Cr,
    // `<body>`
    marginWidth: Cr,
    // `<body>`
    noResize: wn,
    // `<frame>`
    noHref: wn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: wn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: wn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Cr,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: oi,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Cr,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Cr,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: wn,
    disableRemotePlayback: wn,
    prefix: null,
    property: null,
    results: Cr,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: XA
}), PH = Ac({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: pa,
    accentHeight: Cr,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Cr,
    amplitude: Cr,
    arabicForm: null,
    ascent: Cr,
    attributeName: null,
    attributeType: null,
    azimuth: Cr,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Cr,
    by: null,
    calcMode: null,
    capHeight: Cr,
    className: Vn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Cr,
    diffuseConstant: Cr,
    direction: null,
    display: null,
    dur: null,
    divisor: Cr,
    dominantBaseline: null,
    download: wn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Cr,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Cr,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Cr,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: rc,
    g2: rc,
    glyphName: rc,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Cr,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Cr,
    horizOriginX: Cr,
    horizOriginY: Cr,
    id: null,
    ideographic: Cr,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Cr,
    k: Cr,
    k1: Cr,
    k2: Cr,
    k3: Cr,
    k4: Cr,
    kernelMatrix: pa,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Cr,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Cr,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Cr,
    overlineThickness: Cr,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Cr,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Vn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Cr,
    pointsAtY: Cr,
    pointsAtZ: Cr,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: pa,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: pa,
    rev: pa,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: pa,
    requiredFeatures: pa,
    requiredFonts: pa,
    requiredFormats: pa,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Cr,
    specularExponent: Cr,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Cr,
    strikethroughThickness: Cr,
    string: null,
    stroke: null,
    strokeDashArray: pa,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Cr,
    strokeOpacity: Cr,
    strokeWidth: null,
    style: null,
    surfaceScale: Cr,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: pa,
    tabIndex: Cr,
    tableValues: null,
    target: null,
    targetX: Cr,
    targetY: Cr,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: pa,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Cr,
    underlineThickness: Cr,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Cr,
    values: null,
    vAlphabetic: Cr,
    vMathematical: Cr,
    vectorEffect: null,
    vHanging: Cr,
    vIdeographic: Cr,
    version: null,
    vertAdvY: Cr,
    vertOriginX: Cr,
    vertOriginY: Cr,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Cr,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: QA
}), eE = Ac({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), tE = Ac({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: XA
}), rE = Ac({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), RH = /[A-Z]/g, Rx = /-[a-z]/g, IH = /^data[-\w.:]+$/i;
function jH(e, t) {
  const n = K6(t);
  let r = t, i = na;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && IH.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(Rx, DH);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!Rx.test(a)) {
        let o = a.replace(RH, qH);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = F2;
  }
  return new i(r, t);
}
function qH(e) {
  return "-" + e.toLowerCase();
}
function DH(e) {
  return e.charAt(1).toUpperCase();
}
const $H = ZA([JA, TH, eE, tE, rE], "html"), nE = ZA([JA, PH, eE, tE, rE], "svg"), Ix = {}.hasOwnProperty;
function LH(e, t) {
  const n = t || {};
  function r(i, ...a) {
    let o = r.invalid;
    const c = r.handlers;
    if (i && Ix.call(i, e)) {
      const u = String(i[e]);
      o = Ix.call(c, u) ? c[u] : r.unknown;
    }
    if (o)
      return o.call(this, i, ...a);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const NH = /["&'<>`]/g, FH = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, MH = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), BH = /[|\\{}()[\]^$+*?.]/g, jx = /* @__PURE__ */ new WeakMap();
function UH(e, t) {
  if (e = e.replace(
    t.subset ? HH(t.subset) : NH,
    r
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(FH, n).replace(MH, r);
  function n(i, a, o) {
    return t.format(
      (i.charCodeAt(0) - 55296) * 1024 + i.charCodeAt(1) - 56320 + 65536,
      o.charCodeAt(a + 2),
      t
    );
  }
  function r(i, a, o) {
    return t.format(
      i.charCodeAt(0),
      o.charCodeAt(a + 1),
      t
    );
  }
}
function HH(e) {
  let t = jx.get(e);
  return t || (t = zH(e), jx.set(e, t)), t;
}
function zH(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(BH, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
const VH = /[\dA-Fa-f]/;
function GH(e, t, n) {
  const r = "&#x" + e.toString(16).toUpperCase();
  return n && t && !VH.test(String.fromCharCode(t)) ? r : r + ";";
}
const WH = /\d/;
function KH(e, t, n) {
  const r = "&#" + String(e);
  return n && t && !WH.test(String.fromCharCode(t)) ? r : r + ";";
}
const ZH = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], rm = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, YH = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], iE = {}.hasOwnProperty, Y6 = {};
let xd;
for (xd in rm)
  iE.call(rm, xd) && (Y6[rm[xd]] = xd);
const JH = /[^\dA-Za-z]/;
function QH(e, t, n, r) {
  const i = String.fromCharCode(e);
  if (iE.call(Y6, i)) {
    const a = Y6[i], o = "&" + a;
    return n && ZH.includes(a) && !YH.includes(a) && (!r || t && t !== 61 && JH.test(String.fromCharCode(t))) ? o : o + ";";
  }
  return "";
}
function XH(e, t, n) {
  let r = GH(e, t, n.omitOptionalSemicolons), i;
  if ((n.useNamedReferences || n.useShortestReferences) && (i = QH(
    e,
    t,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !i) && n.useShortestReferences) {
    const a = KH(e, t, n.omitOptionalSemicolons);
    a.length < r.length && (r = a);
  }
  return i && (!n.useShortestReferences || i.length < r.length) ? i : r;
}
function nc(e, t) {
  return UH(e, Object.assign({ format: XH }, t));
}
const ez = /^>|^->|<!--|-->|--!>|<!-$/g, tz = [">"], rz = ["<", ">"];
function nz(e, t, n, r) {
  return r.settings.bogusComments ? "<?" + nc(
    e.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: tz
    })
  ) + ">" : "<!--" + e.value.replace(ez, i) + "-->";
  function i(a) {
    return nc(
      a,
      Object.assign({}, r.settings.characterReferences, {
        subset: rz
      })
    );
  }
}
function iz(e, t, n, r) {
  return "<!" + (r.settings.upperDoctype ? "DOCTYPE" : "doctype") + (r.settings.tightDoctype ? "" : " ") + "html>";
}
function qx(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function az(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
function oz(e) {
  return e.join(" ").trim();
}
const sz = /[ \t\n\f\r]/g;
function M2(e) {
  return typeof e == "object" ? e.type === "text" ? Dx(e.value) : !1 : Dx(e);
}
function Dx(e) {
  return e.replace(sz, "") === "";
}
const di = oE(1), aE = oE(-1), uz = [];
function oE(e) {
  return t;
  function t(n, r, i) {
    const a = n ? n.children : uz;
    let o = (r || 0) + e, c = a[o];
    if (!i)
      for (; c && M2(c); )
        o += e, c = a[o];
    return c;
  }
}
const cz = {}.hasOwnProperty;
function sE(e) {
  return t;
  function t(n, r, i) {
    return cz.call(e, n.tagName) && e[n.tagName](n, r, i);
  }
}
const B2 = sE({
  body: fz,
  caption: nm,
  colgroup: nm,
  dd: mz,
  dt: hz,
  head: nm,
  html: lz,
  li: dz,
  optgroup: gz,
  option: vz,
  p: pz,
  rp: $x,
  rt: $x,
  tbody: bz,
  td: Lx,
  tfoot: xz,
  th: Lx,
  thead: yz,
  tr: _z
});
function nm(e, t, n) {
  const r = di(n, t, !0);
  return !r || r.type !== "comment" && !(r.type === "text" && M2(r.value.charAt(0)));
}
function lz(e, t, n) {
  const r = di(n, t);
  return !r || r.type !== "comment";
}
function fz(e, t, n) {
  const r = di(n, t);
  return !r || r.type !== "comment";
}
function pz(e, t, n) {
  const r = di(n, t);
  return r ? r.type === "element" && (r.tagName === "address" || r.tagName === "article" || r.tagName === "aside" || r.tagName === "blockquote" || r.tagName === "details" || r.tagName === "div" || r.tagName === "dl" || r.tagName === "fieldset" || r.tagName === "figcaption" || r.tagName === "figure" || r.tagName === "footer" || r.tagName === "form" || r.tagName === "h1" || r.tagName === "h2" || r.tagName === "h3" || r.tagName === "h4" || r.tagName === "h5" || r.tagName === "h6" || r.tagName === "header" || r.tagName === "hgroup" || r.tagName === "hr" || r.tagName === "main" || r.tagName === "menu" || r.tagName === "nav" || r.tagName === "ol" || r.tagName === "p" || r.tagName === "pre" || r.tagName === "section" || r.tagName === "table" || r.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function dz(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && r.tagName === "li";
}
function hz(e, t, n) {
  const r = di(n, t);
  return !!(r && r.type === "element" && (r.tagName === "dt" || r.tagName === "dd"));
}
function mz(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function $x(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && (r.tagName === "rp" || r.tagName === "rt");
}
function gz(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && r.tagName === "optgroup";
}
function vz(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && (r.tagName === "option" || r.tagName === "optgroup");
}
function yz(e, t, n) {
  const r = di(n, t);
  return !!(r && r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot"));
}
function bz(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function xz(e, t, n) {
  return !di(n, t);
}
function _z(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && r.tagName === "tr";
}
function Lx(e, t, n) {
  const r = di(n, t);
  return !r || r.type === "element" && (r.tagName === "td" || r.tagName === "th");
}
const wz = sE({
  body: kz,
  colgroup: Az,
  head: Cz,
  html: Sz,
  tbody: Ez
});
function Sz(e) {
  const t = di(e, -1);
  return !t || t.type !== "comment";
}
function Cz(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e.children)
    if (r.type === "element" && (r.tagName === "base" || r.tagName === "title")) {
      if (t.has(r.tagName)) return !1;
      t.add(r.tagName);
    }
  const n = e.children[0];
  return !n || n.type === "element";
}
function kz(e) {
  const t = di(e, -1, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && M2(t.value.charAt(0))) && !(t.type === "element" && (t.tagName === "meta" || t.tagName === "link" || t.tagName === "script" || t.tagName === "style" || t.tagName === "template"));
}
function Az(e, t, n) {
  const r = aE(n, t), i = di(e, -1, !0);
  return n && r && r.type === "element" && r.tagName === "colgroup" && B2(r, n.children.indexOf(r), n) ? !1 : !!(i && i.type === "element" && i.tagName === "col");
}
function Ez(e, t, n) {
  const r = aE(n, t), i = di(e, -1);
  return n && r && r.type === "element" && (r.tagName === "thead" || r.tagName === "tbody") && B2(r, n.children.indexOf(r), n) ? !1 : !!(i && i.type === "element" && i.tagName === "tr");
}
const _d = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function Oz(e, t, n, r) {
  const i = r.schema, a = i.space === "svg" ? !1 : r.settings.omitOptionalTags;
  let o = i.space === "svg" ? r.settings.closeEmptyElements : r.settings.voids.includes(e.tagName.toLowerCase());
  const c = [];
  let u;
  i.space === "html" && e.tagName === "svg" && (r.schema = nE);
  const s = Tz(r, e.properties), l = r.all(
    i.space === "html" && e.tagName === "template" ? e.content : e
  );
  return r.schema = i, l && (o = !1), (s || !a || !wz(e, t, n)) && (c.push("<", e.tagName, s ? " " + s : ""), o && (i.space === "svg" || r.settings.closeSelfClosing) && (u = s.charAt(s.length - 1), (!r.settings.tightSelfClosing || u === "/" || u && u !== '"' && u !== "'") && c.push(" "), c.push("/")), c.push(">")), c.push(l), !o && (!a || !B2(e, t, n)) && c.push("</" + e.tagName + ">"), c.join("");
}
function Tz(e, t) {
  const n = [];
  let r = -1, i;
  if (t) {
    for (i in t)
      if (t[i] !== null && t[i] !== void 0) {
        const a = Pz(e, i, t[i]);
        a && n.push(a);
      }
  }
  for (; ++r < n.length; ) {
    const a = e.settings.tightAttributes ? n[r].charAt(n[r].length - 1) : void 0;
    r !== n.length - 1 && a !== '"' && a !== "'" && (n[r] += " ");
  }
  return n.join("");
}
function Pz(e, t, n) {
  const r = jH(e.schema, t), i = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, a = e.settings.allowDangerousCharacters ? 0 : 1;
  let o = e.quote, c;
  if (r.overloadedBoolean && (n === r.attribute || n === "") ? n = !0 : (r.boolean || r.overloadedBoolean) && (typeof n != "string" || n === r.attribute || n === "") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const u = nc(
    r.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: _d.name[i][a]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (r.commaSeparated ? az : oz)(n, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(n), e.settings.collapseEmptyAttributes && !n) ? u : (e.settings.preferUnquoted && (c = nc(
    n,
    Object.assign({}, e.settings.characterReferences, {
      attribute: !0,
      subset: _d.unquoted[i][a]
    })
  )), c !== n && (e.settings.quoteSmart && qx(n, o) > qx(n, e.alternative) && (o = e.alternative), c = o + nc(
    n,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (o === "'" ? _d.single : _d.double)[i][a],
      attribute: !0
    })
  ) + o), u + (c && "=" + c));
}
const Rz = ["<", "&"];
function uE(e, t, n, r) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? e.value : nc(
    e.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: Rz
    })
  );
}
function Iz(e, t, n, r) {
  return r.settings.allowDangerousHtml ? e.value : uE(e, t, n, r);
}
function jz(e, t, n, r) {
  return r.all(e);
}
const qz = LH("type", {
  invalid: Dz,
  unknown: $z,
  handlers: { comment: nz, doctype: iz, element: Oz, raw: Iz, root: jz, text: uE }
});
function Dz(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function $z(e) {
  const t = (
    /** @type {Nodes} */
    e
  );
  throw new Error("Cannot compile unknown node `" + t.type + "`");
}
const Lz = {}, Nz = {}, Fz = [];
function Mz(e, t) {
  const n = t || Lz, r = n.quote || '"', i = r === '"' ? "'" : '"';
  if (r !== '"' && r !== "'")
    throw new Error("Invalid quote `" + r + "`, expected `'` or `\"`");
  return {
    one: Bz,
    all: Uz,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || EH,
      characterReferences: n.characterReferences || Nz,
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? nE : $H,
    quote: r,
    alternative: i
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function Bz(e, t, n) {
  return qz(e, t, n, this);
}
function Uz(e) {
  const t = [], n = e && e.children || Fz;
  let r = -1;
  for (; ++r < n.length; )
    t[r] = this.one(n[r], r, e);
  return t.join("");
}
function h0(e, t) {
  const n = typeof e == "string" ? {} : { ...e.colorReplacements }, r = typeof e == "string" ? e : e.name;
  for (const [i, a] of Object.entries(t?.colorReplacements || {}))
    typeof a == "string" ? n[i] = a : i === r && Object.assign(n, a);
  return n;
}
function Cs(e, t) {
  return e && (t?.[e?.toLowerCase()] || e);
}
function Hz(e) {
  return Array.isArray(e) ? e : [e];
}
async function cE(e) {
  return Promise.resolve(typeof e == "function" ? e() : e).then((t) => t.default || t);
}
function U2(e) {
  return !e || ["plaintext", "txt", "text", "plain"].includes(e);
}
function zz(e) {
  return e === "ansi" || U2(e);
}
function H2(e) {
  return e === "none";
}
function Vz(e) {
  return H2(e);
}
function lE(e, t) {
  if (!t)
    return e;
  e.properties ||= {}, e.properties.class ||= [], typeof e.properties.class == "string" && (e.properties.class = e.properties.class.split(/\s+/g)), Array.isArray(e.properties.class) || (e.properties.class = []);
  const n = Array.isArray(t) ? t : t.split(/\s+/g);
  for (const r of n)
    r && !e.properties.class.includes(r) && e.properties.class.push(r);
  return e;
}
function G0(e, t = !1) {
  const n = e.split(/(\r?\n)/g);
  let r = 0;
  const i = [];
  for (let a = 0; a < n.length; a += 2) {
    const o = t ? n[a] + (n[a + 1] || "") : n[a];
    i.push([o, r]), r += n[a].length, r += n[a + 1]?.length || 0;
  }
  return i;
}
function Gz(e) {
  const t = G0(e, !0).map(([i]) => i);
  function n(i) {
    if (i === e.length)
      return {
        line: t.length - 1,
        character: t[t.length - 1].length
      };
    let a = i, o = 0;
    for (const c of t) {
      if (a < c.length)
        break;
      a -= c.length, o++;
    }
    return { line: o, character: a };
  }
  function r(i, a) {
    let o = 0;
    for (let c = 0; c < i; c++)
      o += t[c].length;
    return o += a, o;
  }
  return {
    lines: t,
    indexToPos: n,
    posToIndex: r
  };
}
const z2 = "light-dark()", Wz = ["color", "background-color"];
function Kz(e, t) {
  let n = 0;
  const r = [];
  for (const i of t)
    i > n && r.push({
      ...e,
      content: e.content.slice(n, i),
      offset: e.offset + n
    }), n = i;
  return n < e.content.length && r.push({
    ...e,
    content: e.content.slice(n),
    offset: e.offset + n
  }), r;
}
function Zz(e, t) {
  const n = Array.from(t instanceof Set ? t : new Set(t)).sort((r, i) => r - i);
  return n.length ? e.map((r) => r.flatMap((i) => {
    const a = n.filter((o) => i.offset < o && o < i.offset + i.content.length).map((o) => o - i.offset).sort((o, c) => o - c);
    return a.length ? Kz(i, a) : i;
  })) : e;
}
function Yz(e, t, n, r, i = "css-vars") {
  const a = {
    content: e.content,
    explanation: e.explanation,
    offset: e.offset
  }, o = t.map((l) => m0(e.variants[l])), c = new Set(o.flatMap((l) => Object.keys(l))), u = {}, s = (l, d) => {
    const f = d === "color" ? "" : d === "background-color" ? "-bg" : `-${d}`;
    return n + t[l] + (d === "color" ? "" : f);
  };
  return o.forEach((l, d) => {
    for (const f of c) {
      const p = l[f] || "inherit";
      if (d === 0 && r && Wz.includes(f))
        if (r === z2 && o.length > 1) {
          const g = t.findIndex((v) => v === "light"), b = t.findIndex((v) => v === "dark");
          if (g === -1 || b === -1)
            throw new _i('When using `defaultColor: "light-dark()"`, you must provide both `light` and `dark` themes');
          const w = o[g][f] || "inherit", y = o[b][f] || "inherit";
          u[f] = `light-dark(${w}, ${y})`, i === "css-vars" && (u[s(d, f)] = p);
        } else
          u[f] = p;
      else
        i === "css-vars" && (u[s(d, f)] = p);
    }
  }), a.htmlStyle = u, a;
}
function m0(e) {
  const t = {};
  if (e.color && (t.color = e.color), e.bgColor && (t["background-color"] = e.bgColor), e.fontStyle) {
    e.fontStyle & ji.Italic && (t["font-style"] = "italic"), e.fontStyle & ji.Bold && (t["font-weight"] = "bold");
    const n = [];
    e.fontStyle & ji.Underline && n.push("underline"), e.fontStyle & ji.Strikethrough && n.push("line-through"), n.length && (t["text-decoration"] = n.join(" "));
  }
  return t;
}
function J6(e) {
  return typeof e == "string" ? e : Object.entries(e).map(([t, n]) => `${t}:${n}`).join(";");
}
const fE = /* @__PURE__ */ new WeakMap();
function W0(e, t) {
  fE.set(e, t);
}
function Ef(e) {
  return fE.get(e);
}
class Ec {
  /**
   * Theme to Stack mapping
   */
  _stacks = {};
  lang;
  get themes() {
    return Object.keys(this._stacks);
  }
  get theme() {
    return this.themes[0];
  }
  get _stack() {
    return this._stacks[this.theme];
  }
  /**
   * Static method to create a initial grammar state.
   */
  static initial(t, n) {
    return new Ec(
      Object.fromEntries(Hz(n).map((r) => [r, W6])),
      t
    );
  }
  constructor(...t) {
    if (t.length === 2) {
      const [n, r] = t;
      this.lang = r, this._stacks = n;
    } else {
      const [n, r, i] = t;
      this.lang = r, this._stacks = { [i]: n };
    }
  }
  /**
   * Get the internal stack object.
   * @internal
   */
  getInternalStack(t = this.theme) {
    return this._stacks[t];
  }
  getScopes(t = this.theme) {
    return Jz(this._stacks[t]);
  }
  toJSON() {
    return {
      lang: this.lang,
      theme: this.theme,
      themes: this.themes,
      scopes: this.getScopes()
    };
  }
}
function Jz(e) {
  const t = [], n = /* @__PURE__ */ new Set();
  function r(i) {
    if (n.has(i))
      return;
    n.add(i);
    const a = i?.nameScopesList?.scopeName;
    a && t.push(a), i.parent && r(i.parent);
  }
  return r(e), t;
}
function Qz(e, t) {
  if (!(e instanceof Ec))
    throw new _i("Invalid grammar state");
  return e.getInternalStack(t);
}
function Xz() {
  const e = /* @__PURE__ */ new WeakMap();
  function t(n) {
    if (!e.has(n.meta)) {
      let r = function(o) {
        if (typeof o == "number") {
          if (o < 0 || o > n.source.length)
            throw new _i(`Invalid decoration offset: ${o}. Code length: ${n.source.length}`);
          return {
            ...i.indexToPos(o),
            offset: o
          };
        } else {
          const c = i.lines[o.line];
          if (c === void 0)
            throw new _i(`Invalid decoration position ${JSON.stringify(o)}. Lines length: ${i.lines.length}`);
          let u = o.character;
          if (u < 0 && (u = c.length + u), u < 0 || u > c.length)
            throw new _i(`Invalid decoration position ${JSON.stringify(o)}. Line ${o.line} length: ${c.length}`);
          return {
            ...o,
            character: u,
            offset: i.posToIndex(o.line, u)
          };
        }
      };
      const i = Gz(n.source), a = (n.options.decorations || []).map((o) => ({
        ...o,
        start: r(o.start),
        end: r(o.end)
      }));
      eV(a), e.set(n.meta, {
        decorations: a,
        converter: i,
        source: n.source
      });
    }
    return e.get(n.meta);
  }
  return {
    name: "shiki:decorations",
    tokens(n) {
      if (!this.options.decorations?.length)
        return;
      const i = t(this).decorations.flatMap((o) => [o.start.offset, o.end.offset]);
      return Zz(n, i);
    },
    code(n) {
      if (!this.options.decorations?.length)
        return;
      const r = t(this), i = Array.from(n.children).filter((l) => l.type === "element" && l.tagName === "span");
      if (i.length !== r.converter.lines.length)
        throw new _i(`Number of lines in code element (${i.length}) does not match the number of lines in the source (${r.converter.lines.length}). Failed to apply decorations.`);
      function a(l, d, f, p) {
        const g = i[l];
        let b = "", w = -1, y = -1;
        if (d === 0 && (w = 0), f === 0 && (y = 0), f === Number.POSITIVE_INFINITY && (y = g.children.length), w === -1 || y === -1)
          for (let _ = 0; _ < g.children.length; _++)
            b += pE(g.children[_]), w === -1 && b.length === d && (w = _ + 1), y === -1 && b.length === f && (y = _ + 1);
        if (w === -1)
          throw new _i(`Failed to find start index for decoration ${JSON.stringify(p.start)}`);
        if (y === -1)
          throw new _i(`Failed to find end index for decoration ${JSON.stringify(p.end)}`);
        const v = g.children.slice(w, y);
        if (!p.alwaysWrap && v.length === g.children.length)
          c(g, p, "line");
        else if (!p.alwaysWrap && v.length === 1 && v[0].type === "element")
          c(v[0], p, "token");
        else {
          const _ = {
            type: "element",
            tagName: "span",
            properties: {},
            children: v
          };
          c(_, p, "wrapper"), g.children.splice(w, v.length, _);
        }
      }
      function o(l, d) {
        i[l] = c(i[l], d, "line");
      }
      function c(l, d, f) {
        const p = d.properties || {}, g = d.transform || ((b) => b);
        return l.tagName = d.tagName || "span", l.properties = {
          ...l.properties,
          ...p,
          class: l.properties.class
        }, d.properties?.class && lE(l, d.properties.class), l = g(l, f) || l, l;
      }
      const u = [], s = r.decorations.sort((l, d) => d.start.offset - l.start.offset || l.end.offset - d.end.offset);
      for (const l of s) {
        const { start: d, end: f } = l;
        if (d.line === f.line)
          a(d.line, d.character, f.character, l);
        else if (d.line < f.line) {
          a(d.line, d.character, Number.POSITIVE_INFINITY, l);
          for (let p = d.line + 1; p < f.line; p++)
            u.unshift(() => o(p, l));
          a(f.line, 0, f.character, l);
        }
      }
      u.forEach((l) => l());
    }
  };
}
function eV(e) {
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (n.start.offset > n.end.offset)
      throw new _i(`Invalid decoration range: ${JSON.stringify(n.start)} - ${JSON.stringify(n.end)}`);
    for (let r = t + 1; r < e.length; r++) {
      const i = e[r], a = n.start.offset <= i.start.offset && i.start.offset < n.end.offset, o = n.start.offset < i.end.offset && i.end.offset <= n.end.offset, c = i.start.offset <= n.start.offset && n.start.offset < i.end.offset, u = i.start.offset < n.end.offset && n.end.offset <= i.end.offset;
      if (a || o || c || u) {
        if (a && o || c && u || c && n.start.offset === n.end.offset || o && i.start.offset === i.end.offset)
          continue;
        throw new _i(`Decorations ${JSON.stringify(n.start)} and ${JSON.stringify(i.start)} intersect.`);
      }
    }
  }
}
function pE(e) {
  return e.type === "text" ? e.value : e.type === "element" ? e.children.map(pE).join("") : "";
}
const tV = [
  /* @__PURE__ */ Xz()
];
function g0(e) {
  return [
    ...e.transformers || [],
    ...tV
  ];
}
var gu = [
  "black",
  "red",
  "green",
  "yellow",
  "blue",
  "magenta",
  "cyan",
  "white",
  "brightBlack",
  "brightRed",
  "brightGreen",
  "brightYellow",
  "brightBlue",
  "brightMagenta",
  "brightCyan",
  "brightWhite"
], im = {
  1: "bold",
  2: "dim",
  3: "italic",
  4: "underline",
  7: "reverse",
  8: "hidden",
  9: "strikethrough"
};
function rV(e, t) {
  const n = e.indexOf("\x1B", t);
  if (n !== -1 && e[n + 1] === "[") {
    const r = e.indexOf("m", n);
    if (r !== -1)
      return {
        sequence: e.substring(n + 2, r).split(";"),
        startPosition: n,
        position: r + 1
      };
  }
  return {
    position: e.length
  };
}
function Nx(e) {
  const t = e.shift();
  if (t === "2") {
    const n = e.splice(0, 3).map((r) => Number.parseInt(r));
    return n.length !== 3 || n.some((r) => Number.isNaN(r)) ? void 0 : {
      type: "rgb",
      rgb: n
    };
  } else if (t === "5") {
    const n = e.shift();
    if (n)
      return { type: "table", index: Number(n) };
  }
}
function nV(e) {
  const t = [];
  for (; e.length > 0; ) {
    const n = e.shift();
    if (!n)
      continue;
    const r = Number.parseInt(n);
    if (!Number.isNaN(r))
      if (r === 0)
        t.push({ type: "resetAll" });
      else if (r <= 9)
        im[r] && t.push({
          type: "setDecoration",
          value: im[r]
        });
      else if (r <= 29) {
        const i = im[r - 20];
        i && (t.push({
          type: "resetDecoration",
          value: i
        }), i === "dim" && t.push({
          type: "resetDecoration",
          value: "bold"
        }));
      } else if (r <= 37)
        t.push({
          type: "setForegroundColor",
          value: { type: "named", name: gu[r - 30] }
        });
      else if (r === 38) {
        const i = Nx(e);
        i && t.push({
          type: "setForegroundColor",
          value: i
        });
      } else if (r === 39)
        t.push({
          type: "resetForegroundColor"
        });
      else if (r <= 47)
        t.push({
          type: "setBackgroundColor",
          value: { type: "named", name: gu[r - 40] }
        });
      else if (r === 48) {
        const i = Nx(e);
        i && t.push({
          type: "setBackgroundColor",
          value: i
        });
      } else r === 49 ? t.push({
        type: "resetBackgroundColor"
      }) : r === 53 ? t.push({
        type: "setDecoration",
        value: "overline"
      }) : r === 55 ? t.push({
        type: "resetDecoration",
        value: "overline"
      }) : r >= 90 && r <= 97 ? t.push({
        type: "setForegroundColor",
        value: { type: "named", name: gu[r - 90 + 8] }
      }) : r >= 100 && r <= 107 && t.push({
        type: "setBackgroundColor",
        value: { type: "named", name: gu[r - 100 + 8] }
      });
  }
  return t;
}
function iV() {
  let e = null, t = null, n = /* @__PURE__ */ new Set();
  return {
    parse(r) {
      const i = [];
      let a = 0;
      do {
        const o = rV(r, a), c = o.sequence ? r.substring(a, o.startPosition) : r.substring(a);
        if (c.length > 0 && i.push({
          value: c,
          foreground: e,
          background: t,
          decorations: new Set(n)
        }), o.sequence) {
          const u = nV(o.sequence);
          for (const s of u)
            s.type === "resetAll" ? (e = null, t = null, n.clear()) : s.type === "resetForegroundColor" ? e = null : s.type === "resetBackgroundColor" ? t = null : s.type === "resetDecoration" && n.delete(s.value);
          for (const s of u)
            s.type === "setForegroundColor" ? e = s.value : s.type === "setBackgroundColor" ? t = s.value : s.type === "setDecoration" && n.add(s.value);
        }
        a = o.position;
      } while (a < r.length);
      return i;
    }
  };
}
var aV = {
  black: "#000000",
  red: "#bb0000",
  green: "#00bb00",
  yellow: "#bbbb00",
  blue: "#0000bb",
  magenta: "#ff00ff",
  cyan: "#00bbbb",
  white: "#eeeeee",
  brightBlack: "#555555",
  brightRed: "#ff5555",
  brightGreen: "#00ff00",
  brightYellow: "#ffff55",
  brightBlue: "#5555ff",
  brightMagenta: "#ff55ff",
  brightCyan: "#55ffff",
  brightWhite: "#ffffff"
};
function oV(e = aV) {
  function t(c) {
    return e[c];
  }
  function n(c) {
    return `#${c.map((u) => Math.max(0, Math.min(u, 255)).toString(16).padStart(2, "0")).join("")}`;
  }
  let r;
  function i() {
    if (r)
      return r;
    r = [];
    for (let s = 0; s < gu.length; s++)
      r.push(t(gu[s]));
    let c = [0, 95, 135, 175, 215, 255];
    for (let s = 0; s < 6; s++)
      for (let l = 0; l < 6; l++)
        for (let d = 0; d < 6; d++)
          r.push(n([c[s], c[l], c[d]]));
    let u = 8;
    for (let s = 0; s < 24; s++, u += 10)
      r.push(n([u, u, u]));
    return r;
  }
  function a(c) {
    return i()[c];
  }
  function o(c) {
    switch (c.type) {
      case "named":
        return t(c.name);
      case "rgb":
        return n(c.rgb);
      case "table":
        return a(c.index);
    }
  }
  return {
    value: o
  };
}
function sV(e, t, n) {
  const r = h0(e, n), i = G0(t), a = oV(
    Object.fromEntries(
      gu.map((c) => [
        c,
        e.colors?.[`terminal.ansi${c[0].toUpperCase()}${c.substring(1)}`]
      ])
    )
  ), o = iV();
  return i.map(
    (c) => o.parse(c[0]).map((u) => {
      let s, l;
      u.decorations.has("reverse") ? (s = u.background ? a.value(u.background) : e.bg, l = u.foreground ? a.value(u.foreground) : e.fg) : (s = u.foreground ? a.value(u.foreground) : e.fg, l = u.background ? a.value(u.background) : void 0), s = Cs(s, r), l = Cs(l, r), u.decorations.has("dim") && (s = uV(s));
      let d = ji.None;
      return u.decorations.has("bold") && (d |= ji.Bold), u.decorations.has("italic") && (d |= ji.Italic), u.decorations.has("underline") && (d |= ji.Underline), u.decorations.has("strikethrough") && (d |= ji.Strikethrough), {
        content: u.value,
        offset: c[1],
        // TODO: more accurate offset? might need to fork ansi-sequence-parser
        color: s,
        bgColor: l,
        fontStyle: d
      };
    })
  );
}
function uV(e) {
  const t = e.match(/#([0-9a-f]{3})([0-9a-f]{3})?([0-9a-f]{2})?/);
  if (t)
    if (t[3]) {
      const r = Math.round(Number.parseInt(t[3], 16) / 2).toString(16).padStart(2, "0");
      return `#${t[1]}${t[2]}${r}`;
    } else return t[2] ? `#${t[1]}${t[2]}80` : `#${Array.from(t[1]).map((r) => `${r}${r}`).join("")}80`;
  const n = e.match(/var\((--[\w-]+-ansi-[\w-]+)\)/);
  return n ? `var(${n[1]}-dim)` : e;
}
function V2(e, t, n = {}) {
  const {
    lang: r = "text",
    theme: i = e.getLoadedThemes()[0]
  } = n;
  if (U2(r) || H2(i))
    return G0(t).map((u) => [{ content: u[0], offset: u[1] }]);
  const { theme: a, colorMap: o } = e.setTheme(i);
  if (r === "ansi")
    return sV(a, t, n);
  const c = e.getLanguage(r);
  if (n.grammarState) {
    if (n.grammarState.lang !== c.name)
      throw new _i(`Grammar state language "${n.grammarState.lang}" does not match highlight language "${c.name}"`);
    if (!n.grammarState.themes.includes(a.name))
      throw new _i(`Grammar state themes "${n.grammarState.themes}" do not contain highlight theme "${a.name}"`);
  }
  return lV(t, c, a, o, n);
}
function cV(...e) {
  if (e.length === 2)
    return Ef(e[1]);
  const [t, n, r = {}] = e, {
    lang: i = "text",
    theme: a = t.getLoadedThemes()[0]
  } = r;
  if (U2(i) || H2(a))
    throw new _i("Plain language does not have grammar state");
  if (i === "ansi")
    throw new _i("ANSI language does not have grammar state");
  const { theme: o, colorMap: c } = t.setTheme(a), u = t.getLanguage(i);
  return new Ec(
    v0(n, u, o, c, r).stateStack,
    u.name,
    o.name
  );
}
function lV(e, t, n, r, i) {
  const a = v0(e, t, n, r, i), o = new Ec(
    v0(e, t, n, r, i).stateStack,
    t.name,
    n.name
  );
  return W0(a.tokens, o), a.tokens;
}
function v0(e, t, n, r, i) {
  const a = h0(n, i), {
    tokenizeMaxLineLength: o = 0,
    tokenizeTimeLimit: c = 500
  } = i, u = G0(e);
  let s = i.grammarState ? Qz(i.grammarState, n.name) ?? W6 : i.grammarContextCode != null ? v0(
    i.grammarContextCode,
    t,
    n,
    r,
    {
      ...i,
      grammarState: void 0,
      grammarContextCode: void 0
    }
  ).stateStack : W6, l = [];
  const d = [];
  for (let f = 0, p = u.length; f < p; f++) {
    const [g, b] = u[f];
    if (g === "") {
      l = [], d.push([]);
      continue;
    }
    if (o > 0 && g.length >= o) {
      l = [], d.push([{
        content: g,
        offset: b,
        color: "",
        fontStyle: 0
      }]);
      continue;
    }
    let w, y, v;
    i.includeExplanation && (w = t.tokenizeLine(g, s, c), y = w.tokens, v = 0);
    const _ = t.tokenizeLine2(g, s, c), E = _.tokens.length / 2;
    for (let O = 0; O < E; O++) {
      const M = _.tokens[2 * O], L = O + 1 < E ? _.tokens[2 * O + 2] : g.length;
      if (M === L)
        continue;
      const Z = _.tokens[2 * O + 1], Q = Cs(
        r[dc.getForeground(Z)],
        a
      ), ae = dc.getFontStyle(Z), re = {
        content: g.substring(M, L),
        offset: b + M,
        color: Q,
        fontStyle: ae
      };
      if (i.includeExplanation) {
        const X = [];
        if (i.includeExplanation !== "scopeName")
          for (const Ce of n.settings) {
            let J;
            switch (typeof Ce.scope) {
              case "string":
                J = Ce.scope.split(/,/).map((ne) => ne.trim());
                break;
              case "object":
                J = Ce.scope;
                break;
              default:
                continue;
            }
            X.push({
              settings: Ce,
              selectors: J.map((ne) => ne.split(/ /))
            });
          }
        re.explanation = [];
        let de = 0;
        for (; M + de < L; ) {
          const Ce = y[v], J = g.substring(
            Ce.startIndex,
            Ce.endIndex
          );
          de += J.length, re.explanation.push({
            content: J,
            scopes: i.includeExplanation === "scopeName" ? fV(
              Ce.scopes
            ) : pV(
              X,
              Ce.scopes
            )
          }), v += 1;
        }
      }
      l.push(re);
    }
    d.push(l), l = [], s = _.ruleStack;
  }
  return {
    tokens: d,
    stateStack: s
  };
}
function fV(e) {
  return e.map((t) => ({ scopeName: t }));
}
function pV(e, t) {
  const n = [];
  for (let r = 0, i = t.length; r < i; r++) {
    const a = t[r];
    n[r] = {
      scopeName: a,
      themeMatches: hV(e, a, t.slice(0, r))
    };
  }
  return n;
}
function Fx(e, t) {
  return e === t || t.substring(0, e.length) === e && t[e.length] === ".";
}
function dV(e, t, n) {
  if (!Fx(e[e.length - 1], t))
    return !1;
  let r = e.length - 2, i = n.length - 1;
  for (; r >= 0 && i >= 0; )
    Fx(e[r], n[i]) && (r -= 1), i -= 1;
  return r === -1;
}
function hV(e, t, n) {
  const r = [];
  for (const { selectors: i, settings: a } of e)
    for (const o of i)
      if (dV(o, t, n)) {
        r.push(a);
        break;
      }
  return r;
}
function dE(e, t, n) {
  const r = Object.entries(n.themes).filter((u) => u[1]).map((u) => ({ color: u[0], theme: u[1] })), i = r.map((u) => {
    const s = V2(e, t, {
      ...n,
      theme: u.theme
    }), l = Ef(s), d = typeof u.theme == "string" ? u.theme : u.theme.name;
    return {
      tokens: s,
      state: l,
      theme: d
    };
  }), a = mV(
    ...i.map((u) => u.tokens)
  ), o = a[0].map(
    (u, s) => u.map((l, d) => {
      const f = {
        content: l.content,
        variants: {},
        offset: l.offset
      };
      return "includeExplanation" in n && n.includeExplanation && (f.explanation = l.explanation), a.forEach((p, g) => {
        const {
          content: b,
          explanation: w,
          offset: y,
          ...v
        } = p[s][d];
        f.variants[r[g].color] = v;
      }), f;
    })
  ), c = i[0].state ? new Ec(
    Object.fromEntries(i.map((u) => [u.theme, u.state?.getInternalStack(u.theme)])),
    i[0].state.lang
  ) : void 0;
  return c && W0(o, c), o;
}
function mV(...e) {
  const t = e.map(() => []), n = e.length;
  for (let r = 0; r < e[0].length; r++) {
    const i = e.map((u) => u[r]), a = t.map(() => []);
    t.forEach((u, s) => u.push(a[s]));
    const o = i.map(() => 0), c = i.map((u) => u[0]);
    for (; c.every((u) => u); ) {
      const u = Math.min(...c.map((s) => s.content.length));
      for (let s = 0; s < n; s++) {
        const l = c[s];
        l.content.length === u ? (a[s].push(l), o[s] += 1, c[s] = i[s][o[s]]) : (a[s].push({
          ...l,
          content: l.content.slice(0, u)
        }), c[s] = {
          ...l,
          content: l.content.slice(u),
          offset: l.offset + u
        });
      }
    }
  }
  return t;
}
function y0(e, t, n) {
  let r, i, a, o, c, u;
  if ("themes" in n) {
    const {
      defaultColor: s = "light",
      cssVariablePrefix: l = "--shiki-",
      colorsRendering: d = "css-vars"
    } = n, f = Object.entries(n.themes).filter((y) => y[1]).map((y) => ({ color: y[0], theme: y[1] })).sort((y, v) => y.color === s ? -1 : v.color === s ? 1 : 0);
    if (f.length === 0)
      throw new _i("`themes` option must not be empty");
    const p = dE(
      e,
      t,
      n
    );
    if (u = Ef(p), s && z2 !== s && !f.find((y) => y.color === s))
      throw new _i(`\`themes\` option must contain the defaultColor key \`${s}\``);
    const g = f.map((y) => e.getTheme(y.theme)), b = f.map((y) => y.color);
    a = p.map((y) => y.map((v) => Yz(v, b, l, s, d))), u && W0(a, u);
    const w = f.map((y) => h0(y.theme, n));
    i = Mx(f, g, w, l, s, "fg", d), r = Mx(f, g, w, l, s, "bg", d), o = `shiki-themes ${g.map((y) => y.name).join(" ")}`, c = s ? void 0 : [i, r].join(";");
  } else if ("theme" in n) {
    const s = h0(n.theme, n);
    a = V2(
      e,
      t,
      n
    );
    const l = e.getTheme(n.theme);
    r = Cs(l.bg, s), i = Cs(l.fg, s), o = l.name, u = Ef(a);
  } else
    throw new _i("Invalid options, either `theme` or `themes` must be provided");
  return {
    tokens: a,
    fg: i,
    bg: r,
    themeName: o,
    rootStyle: c,
    grammarState: u
  };
}
function Mx(e, t, n, r, i, a, o) {
  return e.map((c, u) => {
    const s = Cs(t[u][a], n[u]) || "inherit", l = `${r + c.color}${a === "bg" ? "-bg" : ""}:${s}`;
    if (u === 0 && i) {
      if (i === z2 && e.length > 1) {
        const d = e.findIndex((b) => b.color === "light"), f = e.findIndex((b) => b.color === "dark");
        if (d === -1 || f === -1)
          throw new _i('When using `defaultColor: "light-dark()"`, you must provide both `light` and `dark` themes');
        const p = Cs(t[d][a], n[d]) || "inherit", g = Cs(t[f][a], n[f]) || "inherit";
        return `light-dark(${p}, ${g});${l}`;
      }
      return s;
    }
    return o === "css-vars" ? l : null;
  }).filter((c) => !!c).join(";");
}
function b0(e, t, n, r = {
  meta: {},
  options: n,
  codeToHast: (i, a) => b0(e, i, a),
  codeToTokens: (i, a) => y0(e, i, a)
}) {
  let i = t;
  for (const g of g0(n))
    i = g.preprocess?.call(r, i, n) || i;
  let {
    tokens: a,
    fg: o,
    bg: c,
    themeName: u,
    rootStyle: s,
    grammarState: l
  } = y0(e, i, n);
  const {
    mergeWhitespaces: d = !0,
    mergeSameStyleTokens: f = !1
  } = n;
  d === !0 ? a = vV(a) : d === "never" && (a = yV(a)), f && (a = bV(a));
  const p = {
    ...r,
    get source() {
      return i;
    }
  };
  for (const g of g0(n))
    a = g.tokens?.call(p, a) || a;
  return gV(
    a,
    {
      ...n,
      fg: o,
      bg: c,
      themeName: u,
      rootStyle: s
    },
    p,
    l
  );
}
function gV(e, t, n, r = Ef(e)) {
  const i = g0(t), a = [], o = {
    type: "root",
    children: []
  }, {
    structure: c = "classic",
    tabindex: u = "0"
  } = t;
  let s = {
    type: "element",
    tagName: "pre",
    properties: {
      class: `shiki ${t.themeName || ""}`,
      style: t.rootStyle || `background-color:${t.bg};color:${t.fg}`,
      ...u !== !1 && u != null ? {
        tabindex: u.toString()
      } : {},
      ...Object.fromEntries(
        Array.from(
          Object.entries(t.meta || {})
        ).filter(([g]) => !g.startsWith("_"))
      )
    },
    children: []
  }, l = {
    type: "element",
    tagName: "code",
    properties: {},
    children: a
  };
  const d = [], f = {
    ...n,
    structure: c,
    addClassToHast: lE,
    get source() {
      return n.source;
    },
    get tokens() {
      return e;
    },
    get options() {
      return t;
    },
    get root() {
      return o;
    },
    get pre() {
      return s;
    },
    get code() {
      return l;
    },
    get lines() {
      return d;
    }
  };
  if (e.forEach((g, b) => {
    b && (c === "inline" ? o.children.push({ type: "element", tagName: "br", properties: {}, children: [] }) : c === "classic" && a.push({ type: "text", value: `
` }));
    let w = {
      type: "element",
      tagName: "span",
      properties: { class: "line" },
      children: []
    }, y = 0;
    for (const v of g) {
      let _ = {
        type: "element",
        tagName: "span",
        properties: {
          ...v.htmlAttrs
        },
        children: [{ type: "text", value: v.content }]
      };
      const E = J6(v.htmlStyle || m0(v));
      E && (_.properties.style = E);
      for (const O of i)
        _ = O?.span?.call(f, _, b + 1, y, w, v) || _;
      c === "inline" ? o.children.push(_) : c === "classic" && w.children.push(_), y += v.content.length;
    }
    if (c === "classic") {
      for (const v of i)
        w = v?.line?.call(f, w, b + 1) || w;
      d.push(w), a.push(w);
    }
  }), c === "classic") {
    for (const g of i)
      l = g?.code?.call(f, l) || l;
    s.children.push(l);
    for (const g of i)
      s = g?.pre?.call(f, s) || s;
    o.children.push(s);
  }
  let p = o;
  for (const g of i)
    p = g?.root?.call(f, p) || p;
  return r && W0(p, r), p;
}
function vV(e) {
  return e.map((t) => {
    const n = [];
    let r = "", i = 0;
    return t.forEach((a, o) => {
      const u = !(a.fontStyle && (a.fontStyle & ji.Underline || a.fontStyle & ji.Strikethrough));
      u && a.content.match(/^\s+$/) && t[o + 1] ? (i || (i = a.offset), r += a.content) : r ? (u ? n.push({
        ...a,
        offset: i,
        content: r + a.content
      }) : n.push(
        {
          content: r,
          offset: i
        },
        a
      ), i = 0, r = "") : n.push(a);
    }), n;
  });
}
function yV(e) {
  return e.map((t) => t.flatMap((n) => {
    if (n.content.match(/^\s+$/))
      return n;
    const r = n.content.match(/^(\s*)(.*?)(\s*)$/);
    if (!r)
      return n;
    const [, i, a, o] = r;
    if (!i && !o)
      return n;
    const c = [{
      ...n,
      offset: n.offset + i.length,
      content: a
    }];
    return i && c.unshift({
      content: i,
      offset: n.offset
    }), o && c.push({
      content: o,
      offset: n.offset + i.length + a.length
    }), c;
  }));
}
function bV(e) {
  return e.map((t) => {
    const n = [];
    for (const r of t) {
      if (n.length === 0) {
        n.push({ ...r });
        continue;
      }
      const i = n[n.length - 1], a = J6(i.htmlStyle || m0(i)), o = J6(r.htmlStyle || m0(r)), c = i.fontStyle && (i.fontStyle & ji.Underline || i.fontStyle & ji.Strikethrough), u = r.fontStyle && (r.fontStyle & ji.Underline || r.fontStyle & ji.Strikethrough);
      !c && !u && a === o ? i.content += r.content : n.push({ ...r });
    }
    return n;
  });
}
const xV = Mz;
function _V(e, t, n) {
  const r = {
    meta: {},
    options: n,
    codeToHast: (a, o) => b0(e, a, o),
    codeToTokens: (a, o) => y0(e, a, o)
  };
  let i = xV(b0(e, t, n, r));
  for (const a of g0(n))
    i = a.postprocess?.call(r, i, n) || i;
  return i;
}
const Bx = { light: "#333333", dark: "#bbbbbb" }, Ux = { light: "#fffffe", dark: "#1e1e1e" }, Hx = "__shiki_resolved";
function G2(e) {
  if (e?.[Hx])
    return e;
  const t = {
    ...e
  };
  t.tokenColors && !t.settings && (t.settings = t.tokenColors, delete t.tokenColors), t.type ||= "dark", t.colorReplacements = { ...t.colorReplacements }, t.settings ||= [];
  let { bg: n, fg: r } = t;
  if (!n || !r) {
    const c = t.settings ? t.settings.find((u) => !u.name && !u.scope) : void 0;
    c?.settings?.foreground && (r = c.settings.foreground), c?.settings?.background && (n = c.settings.background), !r && t?.colors?.["editor.foreground"] && (r = t.colors["editor.foreground"]), !n && t?.colors?.["editor.background"] && (n = t.colors["editor.background"]), r || (r = t.type === "light" ? Bx.light : Bx.dark), n || (n = t.type === "light" ? Ux.light : Ux.dark), t.fg = r, t.bg = n;
  }
  t.settings[0] && t.settings[0].settings && !t.settings[0].scope || t.settings.unshift({
    settings: {
      foreground: t.fg,
      background: t.bg
    }
  });
  let i = 0;
  const a = /* @__PURE__ */ new Map();
  function o(c) {
    if (a.has(c))
      return a.get(c);
    i += 1;
    const u = `#${i.toString(16).padStart(8, "0").toLowerCase()}`;
    return t.colorReplacements?.[`#${u}`] ? o(c) : (a.set(c, u), u);
  }
  t.settings = t.settings.map((c) => {
    const u = c.settings?.foreground && !c.settings.foreground.startsWith("#"), s = c.settings?.background && !c.settings.background.startsWith("#");
    if (!u && !s)
      return c;
    const l = {
      ...c,
      settings: {
        ...c.settings
      }
    };
    if (u) {
      const d = o(c.settings.foreground);
      t.colorReplacements[d] = c.settings.foreground, l.settings.foreground = d;
    }
    if (s) {
      const d = o(c.settings.background);
      t.colorReplacements[d] = c.settings.background, l.settings.background = d;
    }
    return l;
  });
  for (const c of Object.keys(t.colors || {}))
    if ((c === "editor.foreground" || c === "editor.background" || c.startsWith("terminal.ansi")) && !t.colors[c]?.startsWith("#")) {
      const u = o(t.colors[c]);
      t.colorReplacements[u] = t.colors[c], t.colors[c] = u;
    }
  return Object.defineProperty(t, Hx, {
    enumerable: !1,
    writable: !1,
    value: !0
  }), t;
}
async function hE(e) {
  return Array.from(new Set((await Promise.all(
    e.filter((t) => !zz(t)).map(async (t) => await cE(t).then((n) => Array.isArray(n) ? n : [n]))
  )).flat()));
}
async function mE(e) {
  return (await Promise.all(
    e.map(
      async (n) => Vz(n) ? null : G2(await cE(n))
    )
  )).filter((n) => !!n);
}
let wV = 3;
function SV(e, t = 3) {
  t > wV || console.trace(`[SHIKI DEPRECATE]: ${e}`);
}
let ec = class extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
};
class CV extends AH {
  constructor(t, n, r, i = {}) {
    super(t), this._resolver = t, this._themes = n, this._langs = r, this._alias = i, this._themes.map((a) => this.loadTheme(a)), this.loadLanguages(this._langs);
  }
  _resolvedThemes = /* @__PURE__ */ new Map();
  _resolvedGrammars = /* @__PURE__ */ new Map();
  _langMap = /* @__PURE__ */ new Map();
  _langGraph = /* @__PURE__ */ new Map();
  _textmateThemeCache = /* @__PURE__ */ new WeakMap();
  _loadedThemesCache = null;
  _loadedLanguagesCache = null;
  getTheme(t) {
    return typeof t == "string" ? this._resolvedThemes.get(t) : this.loadTheme(t);
  }
  loadTheme(t) {
    const n = G2(t);
    return n.name && (this._resolvedThemes.set(n.name, n), this._loadedThemesCache = null), n;
  }
  getLoadedThemes() {
    return this._loadedThemesCache || (this._loadedThemesCache = [...this._resolvedThemes.keys()]), this._loadedThemesCache;
  }
  // Override and re-implement this method to cache the textmate themes as `TextMateTheme.createFromRawTheme`
  // is expensive. Themes can switch often especially for dual-theme support.
  //
  // The parent class also accepts `colorMap` as the second parameter, but since we don't use that,
  // we omit here so it's easier to cache the themes.
  setTheme(t) {
    let n = this._textmateThemeCache.get(t);
    n || (n = c0.createFromRawTheme(t), this._textmateThemeCache.set(t, n)), this._syncRegistry.setTheme(n);
  }
  getGrammar(t) {
    if (this._alias[t]) {
      const n = /* @__PURE__ */ new Set([t]);
      for (; this._alias[t]; ) {
        if (t = this._alias[t], n.has(t))
          throw new ec(`Circular alias \`${Array.from(n).join(" -> ")} -> ${t}\``);
        n.add(t);
      }
    }
    return this._resolvedGrammars.get(t);
  }
  loadLanguage(t) {
    if (this.getGrammar(t.name))
      return;
    const n = new Set(
      [...this._langMap.values()].filter((a) => a.embeddedLangsLazy?.includes(t.name))
    );
    this._resolver.addLanguage(t);
    const r = {
      balancedBracketSelectors: t.balancedBracketSelectors || ["*"],
      unbalancedBracketSelectors: t.unbalancedBracketSelectors || []
    };
    this._syncRegistry._rawGrammars.set(t.scopeName, t);
    const i = this.loadGrammarWithConfiguration(t.scopeName, 1, r);
    if (i.name = t.name, this._resolvedGrammars.set(t.name, i), t.aliases && t.aliases.forEach((a) => {
      this._alias[a] = t.name;
    }), this._loadedLanguagesCache = null, n.size)
      for (const a of n)
        this._resolvedGrammars.delete(a.name), this._loadedLanguagesCache = null, this._syncRegistry?._injectionGrammars?.delete(a.scopeName), this._syncRegistry?._grammars?.delete(a.scopeName), this.loadLanguage(this._langMap.get(a.name));
  }
  dispose() {
    super.dispose(), this._resolvedThemes.clear(), this._resolvedGrammars.clear(), this._langMap.clear(), this._langGraph.clear(), this._loadedThemesCache = null;
  }
  loadLanguages(t) {
    for (const i of t)
      this.resolveEmbeddedLanguages(i);
    const n = Array.from(this._langGraph.entries()), r = n.filter(([i, a]) => !a);
    if (r.length) {
      const i = n.filter(([a, o]) => o && o.embeddedLangs?.some((c) => r.map(([u]) => u).includes(c))).filter((a) => !r.includes(a));
      throw new ec(`Missing languages ${r.map(([a]) => `\`${a}\``).join(", ")}, required by ${i.map(([a]) => `\`${a}\``).join(", ")}`);
    }
    for (const [i, a] of n)
      this._resolver.addLanguage(a);
    for (const [i, a] of n)
      this.loadLanguage(a);
  }
  getLoadedLanguages() {
    return this._loadedLanguagesCache || (this._loadedLanguagesCache = [
      .../* @__PURE__ */ new Set([...this._resolvedGrammars.keys(), ...Object.keys(this._alias)])
    ]), this._loadedLanguagesCache;
  }
  resolveEmbeddedLanguages(t) {
    if (this._langMap.set(t.name, t), this._langGraph.set(t.name, t), t.embeddedLangs)
      for (const n of t.embeddedLangs)
        this._langGraph.set(n, this._langMap.get(n));
  }
}
class kV {
  _langs = /* @__PURE__ */ new Map();
  _scopeToLang = /* @__PURE__ */ new Map();
  _injections = /* @__PURE__ */ new Map();
  _onigLib;
  constructor(t, n) {
    this._onigLib = {
      createOnigScanner: (r) => t.createScanner(r),
      createOnigString: (r) => t.createString(r)
    }, n.forEach((r) => this.addLanguage(r));
  }
  get onigLib() {
    return this._onigLib;
  }
  getLangRegistration(t) {
    return this._langs.get(t);
  }
  loadGrammar(t) {
    return this._scopeToLang.get(t);
  }
  addLanguage(t) {
    this._langs.set(t.name, t), t.aliases && t.aliases.forEach((n) => {
      this._langs.set(n, t);
    }), this._scopeToLang.set(t.scopeName, t), t.injectTo && t.injectTo.forEach((n) => {
      this._injections.get(n) || this._injections.set(n, []), this._injections.get(n).push(t.scopeName);
    });
  }
  getInjections(t) {
    const n = t.split(".");
    let r = [];
    for (let i = 1; i <= n.length; i++) {
      const a = n.slice(0, i).join(".");
      r = [...r, ...this._injections.get(a) || []];
    }
    return r;
  }
}
let gl = 0;
function AV(e) {
  gl += 1, e.warnings !== !1 && gl >= 10 && gl % 10 === 0 && console.warn(`[Shiki] ${gl} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
  let t = !1;
  if (!e.engine)
    throw new ec("`engine` option is required for synchronous mode");
  const n = (e.langs || []).flat(1), r = (e.themes || []).flat(1).map(G2), i = new kV(e.engine, n), a = new CV(i, r, n, e.langAlias);
  let o;
  function c(v) {
    w();
    const _ = a.getGrammar(typeof v == "string" ? v : v.name);
    if (!_)
      throw new ec(`Language \`${v}\` not found, you may need to load it first`);
    return _;
  }
  function u(v) {
    if (v === "none")
      return { bg: "", fg: "", name: "none", settings: [], type: "dark" };
    w();
    const _ = a.getTheme(v);
    if (!_)
      throw new ec(`Theme \`${v}\` not found, you may need to load it first`);
    return _;
  }
  function s(v) {
    w();
    const _ = u(v);
    o !== v && (a.setTheme(_), o = v);
    const E = a.getColorMap();
    return {
      theme: _,
      colorMap: E
    };
  }
  function l() {
    return w(), a.getLoadedThemes();
  }
  function d() {
    return w(), a.getLoadedLanguages();
  }
  function f(...v) {
    w(), a.loadLanguages(v.flat(1));
  }
  async function p(...v) {
    return f(await hE(v));
  }
  function g(...v) {
    w();
    for (const _ of v.flat(1))
      a.loadTheme(_);
  }
  async function b(...v) {
    return w(), g(await mE(v));
  }
  function w() {
    if (t)
      throw new ec("Shiki instance has been disposed");
  }
  function y() {
    t || (t = !0, a.dispose(), gl -= 1);
  }
  return {
    setTheme: s,
    getTheme: u,
    getLanguage: c,
    getLoadedThemes: l,
    getLoadedLanguages: d,
    loadLanguage: p,
    loadLanguageSync: f,
    loadTheme: b,
    loadThemeSync: g,
    dispose: y,
    [Symbol.dispose]: y
  };
}
async function EV(e) {
  e.engine || SV("`engine` option is required. Use `createOnigurumaEngine` or `createJavaScriptRegexEngine` to create an engine.");
  const [
    t,
    n,
    r
  ] = await Promise.all([
    mE(e.themes || []),
    hE(e.langs || []),
    e.engine
  ]);
  return AV({
    ...e,
    themes: t,
    langs: n,
    engine: r
  });
}
async function OV(e) {
  const t = await EV(e);
  return {
    getLastGrammarState: (...n) => cV(t, ...n),
    codeToTokensBase: (n, r) => V2(t, n, r),
    codeToTokensWithThemes: (n, r) => dE(t, n, r),
    codeToTokens: (n, r) => y0(t, n, r),
    codeToHast: (n, r) => b0(t, n, r),
    codeToHtml: (n, r) => _V(t, n, r),
    getBundledLanguages: () => ({}),
    getBundledThemes: () => ({}),
    ...t,
    getInternalContext: () => t
  };
}
class W2 extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
}
function TV() {
  return 2147483648;
}
function PV() {
  return typeof performance < "u" ? performance.now() : Date.now();
}
const RV = (e, t) => e + (t - e % t) % t;
async function IV(e) {
  let t, n;
  const r = {};
  function i(p) {
    n = p, r.HEAPU8 = new Uint8Array(p), r.HEAPU32 = new Uint32Array(p);
  }
  function a(p, g, b) {
    r.HEAPU8.copyWithin(p, g, g + b);
  }
  function o(p) {
    try {
      return t.grow(p - n.byteLength + 65535 >>> 16), i(t.buffer), 1;
    } catch {
    }
  }
  function c(p) {
    const g = r.HEAPU8.length;
    p = p >>> 0;
    const b = TV();
    if (p > b)
      return !1;
    for (let w = 1; w <= 4; w *= 2) {
      let y = g * (1 + 0.2 / w);
      y = Math.min(y, p + 100663296);
      const v = Math.min(b, RV(Math.max(p, y), 65536));
      if (o(v))
        return !0;
    }
    return !1;
  }
  const u = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
  function s(p, g, b = 1024) {
    const w = g + b;
    let y = g;
    for (; p[y] && !(y >= w); ) ++y;
    if (y - g > 16 && p.buffer && u)
      return u.decode(p.subarray(g, y));
    let v = "";
    for (; g < y; ) {
      let _ = p[g++];
      if (!(_ & 128)) {
        v += String.fromCharCode(_);
        continue;
      }
      const E = p[g++] & 63;
      if ((_ & 224) === 192) {
        v += String.fromCharCode((_ & 31) << 6 | E);
        continue;
      }
      const O = p[g++] & 63;
      if ((_ & 240) === 224 ? _ = (_ & 15) << 12 | E << 6 | O : _ = (_ & 7) << 18 | E << 12 | O << 6 | p[g++] & 63, _ < 65536)
        v += String.fromCharCode(_);
      else {
        const M = _ - 65536;
        v += String.fromCharCode(55296 | M >> 10, 56320 | M & 1023);
      }
    }
    return v;
  }
  function l(p, g) {
    return p ? s(r.HEAPU8, p, g) : "";
  }
  const d = {
    emscripten_get_now: PV,
    emscripten_memcpy_big: a,
    emscripten_resize_heap: c,
    fd_write: () => 0
  };
  async function f() {
    const g = await e({
      env: d,
      wasi_snapshot_preview1: d
    });
    t = g.memory, i(t.buffer), Object.assign(r, g), r.UTF8ToString = l;
  }
  return await f(), r;
}
var jV = Object.defineProperty, qV = (e, t, n) => t in e ? jV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fi = (e, t, n) => qV(e, typeof t != "symbol" ? t + "" : t, n);
let yi = null;
function DV(e) {
  throw new W2(e.UTF8ToString(e.getLastOnigError()));
}
class K0 {
  constructor(t) {
    fi(this, "utf16Length"), fi(this, "utf8Length"), fi(this, "utf16Value"), fi(this, "utf8Value"), fi(this, "utf16OffsetToUtf8"), fi(this, "utf8OffsetToUtf16");
    const n = t.length, r = K0._utf8ByteLength(t), i = r !== n, a = i ? new Uint32Array(n + 1) : null;
    i && (a[n] = r);
    const o = i ? new Uint32Array(r + 1) : null;
    i && (o[r] = n);
    const c = new Uint8Array(r);
    let u = 0;
    for (let s = 0; s < n; s++) {
      const l = t.charCodeAt(s);
      let d = l, f = !1;
      if (l >= 55296 && l <= 56319 && s + 1 < n) {
        const p = t.charCodeAt(s + 1);
        p >= 56320 && p <= 57343 && (d = (l - 55296 << 10) + 65536 | p - 56320, f = !0);
      }
      i && (a[s] = u, f && (a[s + 1] = u), d <= 127 ? o[u + 0] = s : d <= 2047 ? (o[u + 0] = s, o[u + 1] = s) : d <= 65535 ? (o[u + 0] = s, o[u + 1] = s, o[u + 2] = s) : (o[u + 0] = s, o[u + 1] = s, o[u + 2] = s, o[u + 3] = s)), d <= 127 ? c[u++] = d : d <= 2047 ? (c[u++] = 192 | (d & 1984) >>> 6, c[u++] = 128 | (d & 63) >>> 0) : d <= 65535 ? (c[u++] = 224 | (d & 61440) >>> 12, c[u++] = 128 | (d & 4032) >>> 6, c[u++] = 128 | (d & 63) >>> 0) : (c[u++] = 240 | (d & 1835008) >>> 18, c[u++] = 128 | (d & 258048) >>> 12, c[u++] = 128 | (d & 4032) >>> 6, c[u++] = 128 | (d & 63) >>> 0), f && s++;
    }
    this.utf16Length = n, this.utf8Length = r, this.utf16Value = t, this.utf8Value = c, this.utf16OffsetToUtf8 = a, this.utf8OffsetToUtf16 = o;
  }
  static _utf8ByteLength(t) {
    let n = 0;
    for (let r = 0, i = t.length; r < i; r++) {
      const a = t.charCodeAt(r);
      let o = a, c = !1;
      if (a >= 55296 && a <= 56319 && r + 1 < i) {
        const u = t.charCodeAt(r + 1);
        u >= 56320 && u <= 57343 && (o = (a - 55296 << 10) + 65536 | u - 56320, c = !0);
      }
      o <= 127 ? n += 1 : o <= 2047 ? n += 2 : o <= 65535 ? n += 3 : n += 4, c && r++;
    }
    return n;
  }
  createString(t) {
    const n = t.omalloc(this.utf8Length);
    return t.HEAPU8.set(this.utf8Value, n), n;
  }
}
const Z0 = class ho {
  constructor(t) {
    if (fi(this, "id", ++ho.LAST_ID), fi(this, "_onigBinding"), fi(this, "content"), fi(this, "utf16Length"), fi(this, "utf8Length"), fi(this, "utf16OffsetToUtf8"), fi(this, "utf8OffsetToUtf16"), fi(this, "ptr"), !yi)
      throw new W2("Must invoke loadWasm first.");
    this._onigBinding = yi, this.content = t;
    const n = new K0(t);
    this.utf16Length = n.utf16Length, this.utf8Length = n.utf8Length, this.utf16OffsetToUtf8 = n.utf16OffsetToUtf8, this.utf8OffsetToUtf16 = n.utf8OffsetToUtf16, this.utf8Length < 1e4 && !ho._sharedPtrInUse ? (ho._sharedPtr || (ho._sharedPtr = yi.omalloc(1e4)), ho._sharedPtrInUse = !0, yi.HEAPU8.set(n.utf8Value, ho._sharedPtr), this.ptr = ho._sharedPtr) : this.ptr = n.createString(yi);
  }
  convertUtf8OffsetToUtf16(t) {
    return this.utf8OffsetToUtf16 ? t < 0 ? 0 : t > this.utf8Length ? this.utf16Length : this.utf8OffsetToUtf16[t] : t;
  }
  convertUtf16OffsetToUtf8(t) {
    return this.utf16OffsetToUtf8 ? t < 0 ? 0 : t > this.utf16Length ? this.utf8Length : this.utf16OffsetToUtf8[t] : t;
  }
  dispose() {
    this.ptr === ho._sharedPtr ? ho._sharedPtrInUse = !1 : this._onigBinding.ofree(this.ptr);
  }
};
fi(Z0, "LAST_ID", 0);
fi(Z0, "_sharedPtr", 0);
fi(Z0, "_sharedPtrInUse", !1);
let gE = Z0;
class $V {
  constructor(t) {
    if (fi(this, "_onigBinding"), fi(this, "_ptr"), !yi)
      throw new W2("Must invoke loadWasm first.");
    const n = [], r = [];
    for (let c = 0, u = t.length; c < u; c++) {
      const s = new K0(t[c]);
      n[c] = s.createString(yi), r[c] = s.utf8Length;
    }
    const i = yi.omalloc(4 * t.length);
    yi.HEAPU32.set(n, i / 4);
    const a = yi.omalloc(4 * t.length);
    yi.HEAPU32.set(r, a / 4);
    const o = yi.createOnigScanner(i, a, t.length);
    for (let c = 0, u = t.length; c < u; c++)
      yi.ofree(n[c]);
    yi.ofree(a), yi.ofree(i), o === 0 && DV(yi), this._onigBinding = yi, this._ptr = o;
  }
  dispose() {
    this._onigBinding.freeOnigScanner(this._ptr);
  }
  findNextMatchSync(t, n, r) {
    let i = 0;
    if (typeof r == "number" && (i = r), typeof t == "string") {
      t = new gE(t);
      const a = this._findNextMatchSync(t, n, !1, i);
      return t.dispose(), a;
    }
    return this._findNextMatchSync(t, n, !1, i);
  }
  _findNextMatchSync(t, n, r, i) {
    const a = this._onigBinding, o = a.findNextOnigScannerMatch(this._ptr, t.id, t.ptr, t.utf8Length, t.convertUtf16OffsetToUtf8(n), i);
    if (o === 0)
      return null;
    const c = a.HEAPU32;
    let u = o / 4;
    const s = c[u++], l = c[u++], d = [];
    for (let f = 0; f < l; f++) {
      const p = t.convertUtf8OffsetToUtf16(c[u++]), g = t.convertUtf8OffsetToUtf16(c[u++]);
      d[f] = {
        start: p,
        end: g,
        length: g - p
      };
    }
    return {
      index: s,
      captureIndices: d
    };
  }
}
function LV(e) {
  return typeof e.instantiator == "function";
}
function NV(e) {
  return typeof e.default == "function";
}
function FV(e) {
  return typeof e.data < "u";
}
function MV(e) {
  return typeof Response < "u" && e instanceof Response;
}
function BV(e) {
  return typeof ArrayBuffer < "u" && (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) || typeof qn < "u" && qn.isBuffer?.(e) || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer || typeof Uint32Array < "u" && e instanceof Uint32Array;
}
let wd;
function UV(e) {
  if (wd)
    return wd;
  async function t() {
    yi = await IV(async (n) => {
      let r = e;
      return r = await r, typeof r == "function" && (r = await r(n)), typeof r == "function" && (r = await r(n)), LV(r) ? r = await r.instantiator(n) : NV(r) ? r = await r.default(n) : (FV(r) && (r = r.data), MV(r) ? typeof WebAssembly.instantiateStreaming == "function" ? r = await HV(r)(n) : r = await zV(r)(n) : BV(r) ? r = await am(r)(n) : r instanceof WebAssembly.Module ? r = await am(r)(n) : "default" in r && r.default instanceof WebAssembly.Module && (r = await am(r.default)(n))), "instance" in r && (r = r.instance), "exports" in r && (r = r.exports), r;
    });
  }
  return wd = t(), wd;
}
function am(e) {
  return (t) => WebAssembly.instantiate(e, t);
}
function HV(e) {
  return (t) => WebAssembly.instantiateStreaming(e, t);
}
function zV(e) {
  return async (t) => {
    const n = await e.arrayBuffer();
    return WebAssembly.instantiate(n, t);
  };
}
async function VV(e) {
  return e && await UV(e), {
    createScanner(t) {
      return new $V(t.map((n) => typeof n == "string" ? n : n.source));
    },
    createString(t) {
      return new gE(t);
    }
  };
}
const om = Br();
function GV() {
  const e = async () => {
    om.value || (om.value = await OV({
      themes: [
        import("./catppuccin-latte-DDI4I_Rd.js"),
        import("./catppuccin-mocha-CwrFPXRy.js")
      ],
      langs: [
        import("./java-DY6VlHhP.js"),
        import("./javascript-Dp1Jmi5H.js"),
        import("./json-DxJze_jm.js"),
        import("./python-BFNSHbwJ.js"),
        import("./go-ChxJuLYK.js"),
        import("./ruby-DoFFhp0W.js"),
        import("./fish-B6QqlqeT.js"),
        import("./csharp-DmxfTLWR.js")
      ],
      // Important: If running in SSR, the host application must have a `shiki/onig.wasm` file available at the root of the assets. If in new Konnect Dev Portal, this is already handled.
      engine: VV(() => import.meta.server ? import(
        /* @vite-ignore */
        "shiki/onig.wasm"
      ) : import("./wasm-DQxwEHae.js"))
    }));
  };
  return {
    highlighter: pC(om),
    createHighlighter: e
  };
}
const Xu = [
  {
    label: "Shell",
    httpSnippetLanguage: "shell",
    highlightLanguage: "fish"
    // libraries: [
    //   {
    //     label: 'cURL',
    //     httpSnippetLibrary: 'curl',
    //   },
    //   {
    //     label: 'Wget',
    //     httpSnippetLibrary: 'wget',
    //   },
    // ],
  },
  {
    label: "JSON (body)",
    httpSnippetLanguage: "json",
    highlightLanguage: "json"
  },
  {
    label: "Python",
    httpSnippetLanguage: "python",
    highlightLanguage: "python"
    // libraries: [
    //   {
    //     label: 'Python 3',
    //     httpSnippetLibrary: 'python3',
    //   },
    //   {
    //     label: 'Requests',
    //     httpSnippetLibrary: 'requests',
    //   },
    // ],
  },
  {
    label: "Node",
    httpSnippetLanguage: "node",
    highlightLanguage: "javascript"
    // libraries: [
    //   {
    //     label: 'Native',
    //     httpSnippetLibrary: 'native',
    //   },
    //   {
    //     label: 'Request',
    //     httpSnippetLibrary: 'request',
    //   },
    //   {
    //     label: 'Unirest',
    //     httpSnippetLibrary: 'unirest',
    //   },
    //   {
    //     label: 'Fetch',
    //     httpSnippetLibrary: 'fetch',
    //   },
    //   {
    //     label: 'Axios',
    //     httpSnippetLibrary: 'axios',
    //   },
    // ],
  },
  {
    label: "JavaScript",
    httpSnippetLanguage: "javascript",
    highlightLanguage: "javascript"
    // libraries: [
    //   {
    //     label: 'Fetch',
    //     httpSnippetLibrary: 'fetch',
    //   },
    //   {
    //     label: 'XMLHttpRequest',
    //     httpSnippetLibrary: 'xhr',
    //   },
    //   {
    //     label: 'Axios',
    //     httpSnippetLibrary: 'axios',
    //   },
    // ],
  },
  {
    label: "Go",
    httpSnippetLanguage: "go",
    highlightLanguage: "go"
  },
  {
    label: "Java",
    httpSnippetLanguage: "java",
    highlightLanguage: "java"
    // libraries: [
    //   {
    //     label: 'AsyncHttp',
    //     httpSnippetLibrary: 'asynchttp',
    //   },
    //   {
    //     label: 'NetHttp',
    //     httpSnippetLibrary: 'nethttp',
    //   },
    //   {
    //     label: 'OkHttp',
    //     httpSnippetLibrary: 'okhttp',
    //   },
    //   {
    //     label: 'Unirest',
    //     httpSnippetLibrary: 'unirest',
    //   },
    // ],
  },
  {
    label: "C#",
    httpSnippetLanguage: "csharp",
    highlightLanguage: "csharp"
  },
  {
    label: "Ruby",
    httpSnippetLanguage: "ruby",
    highlightLanguage: "ruby"
  }
], vE = 6, ns = 2, zx = 2, WV = 20, Vx = 1200, hc = 1;
/*!
 * allof-merge v0.6.6
 * Copyright (C) 2012-2024 Damir Yusipov
 * Date: Sat, 17 Feb 2024 19:27:36 GMT
 */
function Of(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
function KV(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
const ZV = (e = {}, t, n, r) => {
  const i = `/${t}`, a = typeof e["/**"] == "function" ? e["/**"]({ key: t, path: n, value: r }) : e["/**"], o = typeof e["/*"] == "function" ? e["/*"]({ key: t, path: n, value: r }) : e["/*"];
  let c = {};
  if (i in e) c = e[i];
  else if (!a && !o) return;
  return c = typeof c == "function" ? c({ key: t, path: n, value: r }) : c, o && (c = Object.assign(Object.assign({}, o), c)), a ? Object.assign(Object.assign({ "/**": e["/**"] }, a), c) : c;
}, yE = (e) => {
  const t = {}, n = e.reduce(((r, i) => (Object.keys(i).forEach(((a) => r.add(a))), r)), /* @__PURE__ */ new Set());
  for (const r of n.keys()) {
    const i = e.filter(((a) => r in a));
    if (i.length !== 1) {
      if (r.charAt(0) !== "/") throw new Error(`Cannot merge rules. Duplicate key: ${r}. Rules should not have same Rule key`);
      t[r] = (a, o) => {
        const c = i.map(((u) => typeof u[r] == "function" ? u[r](a, o) : u[r]));
        return yE(c);
      };
    } else t[r] = i[0][r];
  }
  return t;
}, is = (e) => typeof e == "object" && e !== null, sm = (e) => Array.isArray(e), YV = (e, t, n = {}) => {
  var r, i;
  t = sm(t) ? t : [t];
  const a = sm(n.rules) ? yE(n.rules) : n.rules, o = [{ data: e, state: n.state, path: [], keys: [], keyIndex: -1, rules: a }];
  for (; o.length > 0; ) {
    const c = o[o.length - 1];
    if (c.keyIndex >= c.keys.length) {
      for (; !((r = c.hooks) === null || r === void 0) && r.length; ) c.hooks.pop()();
      o.pop();
      continue;
    }
    const u = c.keys[c.keyIndex++], [s, l, d] = o.length > 1 ? [c.data[u], [...c.path, u], ZV(c.rules, u, [...c.path, u], c.data[u])] : [c.data, c.path, a];
    let f = { value: s, path: l, key: u, state: c.state, rules: d };
    const p = [];
    for (const g of t) {
      if (!g || typeof g != "function") continue;
      const b = (i = g(f)) !== null && i !== void 0 ? i : {}, { terminate: w, done: y, exitHook: v } = b, _ = KV(b, ["terminate", "done", "exitHook"]);
      if (w) return;
      if (v && p.push(v), f = Object.assign(Object.assign({}, f), _), y) {
        f = null;
        break;
      }
    }
    if (f && is(f.value)) {
      const g = sm(f.value) ? [...f.value.keys()] : Object.keys(f.value);
      o.push({ hooks: p, state: f.state, data: f.value, path: l, keys: g, keyIndex: 0, rules: f.rules });
    } else for (; p.length; ) p.pop()();
  }
}, JV = () => {
  const e = /* @__PURE__ */ new WeakMap();
  let t;
  return [({ value: n }) => {
    t = n;
  }, ({ value: n, path: r, key: i, state: a }) => {
    if (i = r.length ? i : "#", is(t) && is(n)) {
      if (e.has(t)) return a.node[i] = e.get(t), { done: !0 };
      const o = Array.isArray(n) ? [] : {};
      a.node[i] = o, e.set(t, o);
    } else a.node[i] = n;
    return { value: n, state: Object.assign(Object.assign({}, a), { node: a.node[i] }) };
  }];
};
class bE extends Map {
  add(t, n) {
    const r = this.get(t);
    return r ? r.push(n) : this.set(t, [n]), this;
  }
}
const QV = (e, t) => {
  const n = {};
  for (const r of t) r in e && (n[r] = e[r], delete e[r]);
  return n;
}, xE = (e, t) => {
  if (Array.isArray(e) && Array.isArray(t)) return [...e, ...t];
  if (is(e) && is(t)) {
    const n = Object.assign({}, e);
    for (const r of Object.keys(t)) n[r] = xE(n[r], t[r]);
    return n;
  }
  return t;
}, Q6 = (e) => e && e.$ref && typeof e.$ref == "string", Gx = (e) => e && e.anyOf && Array.isArray(e.anyOf), Wx = (e) => e && e.oneOf && Array.isArray(e.oneOf), _E = (e, t = "") => {
  const [n = t, r] = e.split("#"), i = r && r !== "/" ? r : "";
  return { filePath: n, pointer: i, normalized: XV(n, i), jsonPath: SE(i) };
}, XV = (e, t) => e ? `${e}${t ? "#" + t : ""}` : t ? `#${t}` : "#", wE = (e, t, n = [t]) => {
  if (!is(e)) return;
  let r = e;
  const i = SE(t);
  for (const a of i) if (Array.isArray(r) && r.length > +a) r = r[+a];
  else if (is(r) && a in r) r = r[a];
  else {
    if (!Q6(r)) return;
    {
      const o = _E(r.$ref);
      r = o.filePath || n.includes(o.pointer) ? void 0 : wE(e, o.pointer, [...n, o.pointer]);
    }
  }
  return r;
}, x0 = { slash: /\//g, tilde: /~/g, escapedSlash: /~1/g, escapedTilde: /~0/g }, SE = (e) => e.split("/").map(((t) => decodeURIComponent(t.replace(x0.escapedSlash, "/").replace(x0.escapedTilde, "~")))).slice(1), K2 = (e) => e.length ? "/" + e.map(((t) => encodeURIComponent(String(t).replace(x0.tilde, "~0").replace(x0.slash, "~1")))).join("/") : "", eG = (e, t) => JSON.stringify(e) == JSON.stringify(t), tG = (e) => {
  let t = 1;
  for (; e * t % 1 != 0; ) t *= 10;
  return t;
};
function rG(e) {
  const t = e.reduce(((n, r) => Math.max(n, tG(r))), 0);
  return e.reduce(((n, r) => Math.round(n * t * r * t / CE(n * t, r * t)) / t));
}
function CE(e, t) {
  return t === 0 ? e : CE(t, e % t);
}
const kE = (e) => {
  if (e.length === 0) return [[]];
  const t = e[0], n = e.slice(1), r = kE(n), i = [];
  for (const a of t) for (const o of r) i.push([a, ...o]);
  return i;
}, nG = (e) => {
  const t = [];
  for (const n of e) {
    if (!("properties" in n)) continue;
    const r = new Set(Object.keys(n.properties)), i = new bE();
    for (const o of r.values()) for (const c of e) if (!(c == n || c.properties && o in c.properties)) if ("patternProperties" in c && c.patternProperties) for (const u of Object.keys(c.patternProperties)) new RegExp(u).test(o) || r.delete(o);
    else "additionalProperties" in c && (c.additionalProperties === !1 ? r.delete(o) : typeof c.additionalProperties == "object" && i.add(o, c.additionalProperties));
    if (!r.size) continue;
    const a = {};
    for (const o of r.values()) i.has(o) ? a[o] = { allOf: [n.properties[o], ...i.get(o)] } : a[o] = n.properties[o];
    t.push(a);
  }
  return t;
}, iG = (e) => {
  const t = [];
  for (const n of e) {
    if (!("patternProperties" in n)) continue;
    const r = new Set(Object.keys(n.patternProperties));
    for (const a of e) if (a != n && "additionalProperties" in a && !a.additionalProperties) for (const o of r.values()) a.patternProperties && o in a.patternProperties || r.delete(o);
    if (!r.size) continue;
    const i = {};
    for (const a of r.values()) i[a] = n.patternProperties[a];
    t.push(i);
  }
  return t;
}, Kx = (e) => {
  const t = {}, n = Z2(e);
  for (const [r, i] of Object.entries(n)) i.includes(!1) ? t[r] = !1 : t[r] = i.length > 1 ? { allOf: i } : i[0];
  return t;
}, aG = (e, t) => !!e.reduce(((n, r) => n && r === !0), !0) || Yf(e, t), oG = () => "Could not merge values, they are probably incompatible", sG = (e) => `Merge rule not found for key: ${e}`, Z2 = (e) => {
  const t = {};
  for (const n of e) for (const r of Object.keys(n)) Array.isArray(t[r]) ? t[r].push(n[r]) : t[r] = [n[r]];
  return t;
}, Yf = (e, t) => {
  if (e.includes(!1)) return !1;
  const n = {}, r = Z2(e);
  "properties" in r && (r.properties = nG(e)), "patternProperties" in r && (r.patternProperties = iG(e));
  for (let [i, a] of Object.entries(r)) {
    if (!a.length) continue;
    const o = t.mergeRules;
    let c = `/${i}` in o ? o[`/${i}`] : o["/?"];
    c = c && !("$" in c) && "/" in c ? c["/"] : c, c = typeof c == "function" ? c() : c;
    const u = c && "$" in c ? c.$ : void 0;
    if (!u) throw new Error(sG(i));
    const s = a.length > 1 ? u(a, Object.assign(Object.assign({}, t), { allOfItems: e })) : a[0];
    s === void 0 ? t.mergeError(a) : n[i] = s;
  }
  return Object.keys(n).length ? n : void 0;
}, vo = (e) => e[e.length - 1], du = (e) => e.reduce(((t, n) => t || n), !1), vl = (e) => Math.min(...e), yl = (e) => Math.max(...e), uG = (e) => e.length > 1 ? e.reduce(((t, n) => `${t}(?=${n})`), "") : e[0], AE = ([e, ...t]) => t.reduce(((n, r) => n.filter(((i) => r.includes(i)))), e), cG = ([e, ...t]) => t.find(((n) => !eG(n, e))) ? void 0 : e, Ra = ([e, ...t]) => t.reduce(((n, r) => xE(n, r)), e), df = (e) => kE(e).map(((t) => ({ allOf: t }))), lG = (e) => ({ anyOf: e }), fG = (e) => rG(e), pG = (e, t) => {
  const n = e.map(((i) => i.map(((a) => JSON.stringify(a))))), r = AE(n).map(((i) => JSON.parse(i))).sort();
  return r.length || t.mergeError(e), r;
}, dG = (e, t) => {
  const n = e.map(((i) => Array.isArray(i) ? i : [i])), r = AE(n);
  return r.length === 1 ? r[0] : r.length ? r : void 0;
}, EE = (e) => {
  const t = /* @__PURE__ */ new Set();
  for (const n of e) for (const r of n) t.add(r);
  return Array.from(t).sort();
}, hG = (e, t) => {
  const n = {}, r = Z2(e);
  for (const [i, a] of Object.entries(r))
    if (a.reduce(((o, c) => o && Array.isArray(c)), !0)) n[i] = EE(a);
    else {
      const o = a.map(((c) => Array.isArray(c) ? { required: c } : c));
      n[i] = o.length > 1 ? { allOf: o } : o[0];
    }
  return n;
}, OE = (e, t) => {
  if (!e.reduce(((u, s) => Array.isArray(s) || u), !1)) return Yf(e, t);
  const n = [];
  let r = 1 / 0, i = 0;
  const a = new bE();
  for (const u of t.allOfItems) "additionalItems" in u && u.additionalItems && "items" in u && Array.isArray(u.items) && a.add(u.items.length, u.additionalItems), "items" in u && (n.push(u.items), Array.isArray(u.items) && (i = Math.max(i, u.items.length), "additionalItems" in u && u.additionalItems === !1 && (r = Math.min(r, u.items.length))));
  const o = Math.min(i, r), c = [...Array(o)].map((() => ({ allOf: [] })));
  for (const u of n) if (Array.isArray(u)) for (let s = 0; s < o; s++) {
    const l = [];
    for (let d = 0; d <= s; d++) a.has(d) && l.push(...a.get(d));
    s < u.length ? c[s].allOf.push(l.length ? Object.assign(Object.assign({}, u[s]), { allOf: l }) : u[s]) : c[s].allOf.push(!l.length || { allOf: l });
  }
  else c.forEach((({ allOf: s }) => s.push(u)));
  return c;
}, mG = (e, t) => {
  const n = [], r = [];
  for (const i of t.allOfItems) "items" in i && !Array.isArray(i.items) && r.push(i.items), "additionalItems" in i && "items" in i && Array.isArray(i.items) && n.push(i.additionalItems);
  return r.length && n.forEach(((i) => i.allOf = r)), Yf(n, t);
}, vi = (e = "draft-06", t = {}) => Object.assign(Object.assign(Object.assign(Object.assign({ "/maximum": { $: vl }, "/exclusiveMaximum": { $: du }, "/minimum": { $: yl }, "/exclusiveMinimum": { $: du }, "/maxLength": { $: vl }, "/minLength": { $: yl }, "/maxItems": { $: vl }, "/minItems": { $: yl }, "/uniqueItems": { $: du }, "/maxProperties": { $: vl }, "/minProperties": { $: yl }, "/required": { $: EE }, "/multipleOf": { $: fG }, "/enum": { $: pG }, "/type": { $: dG }, "/allOf": { "/*": () => vi(e, t), $: df }, "/not": { $: lG }, "/oneOf": { "/*": () => vi(e, t), $: df, sibling: ["definitions", "$defs", "$id", "$schema"] }, "/anyOf": { "/*": () => vi(e, t), $: df, sibling: ["definitions", "$defs", "$id", "$schema"] }, "/properties": { "/*": () => vi(e, t), $: Kx }, "/items": () => Object.assign(Object.assign({}, vi(e, t)), { $: OE, "/*": ({ key: n }) => typeof n == "number" ? vi(e, t) : {} }), "/additionalProperties": () => Object.assign(Object.assign({}, vi(e, t)), { $: aG }), "/additionalItems": () => Object.assign(Object.assign({}, vi(e, t)), { $: mG }), "/patternProperties": { "/*": () => vi(e, t), $: Kx }, "/pattern": { $: uG }, "/readOnly": { $: du }, "/writeOnly": { $: du }, "/example": { $: Ra }, "/examples": { $: Ra }, "/deprecated": { $: du } }, e !== "draft-04" ? { "/propertyNames": () => vi(e, t), "/contains": () => vi(e, t), "/dependencies": { "/*": () => vi(e, t), $: hG }, "/const": { $: cG }, "/exclusiveMaximum": { $: vl }, "/exclusiveMinimum": { $: yl }, "/$defs": { "/*": () => vi(e, t), $: Ra } } : {}), { "/definitions": { "/*": () => vi(e, t), $: Ra }, "/xml": { $: Ra }, "/externalDocs": { $: vo }, "/description": { $: vo }, "/title": { $: vo }, "/format": { $: vo }, "/default": { $: vo }, "/?": { $: vo } }), t), { $: Yf }), hf = (e) => vi(e, { "/discriminator": { $: Ra }, "/oneOf": { "/*": () => hf(e), $: df, sibling: ["discriminator"] }, "/anyOf": { "/*": () => hf(e), $: df, sibling: ["discriminator"] } }), Y0 = (e) => e === "3.0.x" ? Object.assign(Object.assign({}, hf("draft-04")), { "/items": ({ key: t }) => Object.assign(Object.assign({}, hf("draft-04")), { $: OE }) }) : hf("draft-06"), vu = (e) => ({ "/*": { "/schema": Y0(e) } }), Zx = (e) => ({ "/content": { "/*": { "/schema": Y0(e), "/encoding": { "/headers": vu(e) } } } }), Yx = (e) => ({ "/*": { "/headers": vu(e), "/content": { "/*": { "/schema": Y0(e), "/encoding": { "/headers": vu(e) } } } } }), gG = (e = "3.0.x") => ({ "/paths": { "/*": { "/*": { "/parameters": vu(e), "/requestBody": Zx(e), "/responses": Yx(e) }, "/parameters": vu(e) } }, "/components": { "/schemas": { "/*": Y0(e) }, "/responses": Yx(e), "/parameters": vu(e), "/requestBodies": { "/*": Zx(e) }, "/headers": vu(e) } }), hu = vi("draft-06", { "/args": () => hu, "/nullable": { $: du }, "/specifiedByURL": { $: vo }, "/values": { $: Ra, "/*": { $: Ra, "/description": { $: vo }, "/deprecated": { $: vo, "/reason": { $: vo } } } }, "/interfaces": { $: Ra, "/*": { $: Ra } }, "/directives": { $: Ra, "/*": () => Object.assign(Object.assign({}, hu), { "/meta": { $: Ra } }) } }), vG = { "/queries": { "/*": () => hu }, "/mutations": { "/*": () => hu }, "/subscriptions": { "/*": () => hu }, "/components": { "/*": { "/*": hu }, "/directives": { "/*": { "/args": () => hu } } } }, Sd = (e, t, n) => {
  const r = n.sibling || [], i = e, a = t, o = i[a], c = Of(i, [typeof a == "symbol" ? a : a + ""]), u = QV(c, r);
  return Object.keys(c).length ? Object.assign({ [t]: o.map(((s) => ({ allOf: [c, s] }))) }, u) : e;
}, TE = (e, t, n, r) => {
  const i = [], a = K2(t), o = [], c = { pointer: a, data: "", refs: [] };
  for (const s of e) if (Q6(s) && !o.includes(s.$ref)) {
    c.data === "" && (c.data = JSON.stringify(e));
    const { $ref: l } = s, d = Of(s, ["$ref"]), { filePath: f, normalized: p, pointer: g } = _E(l), b = r.find(((y) => y.refs.includes(s.$ref) && y.data === c.data && g !== y.pointer));
    if (b) return { allOfItems: [{ $ref: "#" + b.pointer }], brokenRefs: o };
    c.refs.push(p);
    const w = f ? void 0 : wE(n, g);
    w === void 0 ? (o.push(p), i.push(s)) : i.push(w), Object.keys(d).length && i.push(d);
  } else i.push(s);
  c.refs.length && r.push(c);
  const u = PE(i);
  return u.find(((s) => Q6(s) && !o.includes(s.$ref))) ? TE(u, t, n, r) : { allOfItems: u, brokenRefs: o };
}, PE = (e) => {
  const t = [];
  for (const n of e) if (is(n)) if (n.allOf && Array.isArray(n.allOf)) {
    const { allOf: r } = n, i = Of(n, ["allOf"]), a = Object.keys(i).length ? [...r, i] : r;
    t.push(...PE(a));
  } else t.push(n);
  return t;
}, yG = (e) => {
  if (typeof e != "object" || !e) return vi();
  if ("openapi" in e && typeof e.openapi == "string" && /3.+/.test(e.openapi)) {
    const t = e.openapi.startsWith("3.1") ? "3.1.x" : "3.0.x";
    return gG(t);
  }
  return "graphapi" in e && typeof e.graphapi == "string" ? vG : vi();
}, bG = (e, t) => {
  var n;
  const r = (n = t?.rules) !== null && n !== void 0 ? n : yG(e);
  return ((i, a = [], o = {}) => {
    var c;
    a = Array.isArray(a) ? a : [a];
    const u = { "#": void 0 }, s = Object.assign({ state: Object.assign(Object.assign({}, (c = o.state) !== null && c !== void 0 ? c : {}), { root: u, node: u }) }, o.rules ? { rules: o.rules } : {}), [l, d] = JV();
    return YV(i, [l, ...a, d], s), u["#"];
  })(e, xG(t), { rules: r });
}, xG = (e) => {
  const t = /* @__PURE__ */ new Map();
  let n = e?.source;
  const r = [];
  return ({ value: i, key: a, path: o, rules: c, state: u }) => {
    o.length || e?.source || (n = i);
    const s = (y) => {
      var v;
      const _ = _G(o);
      _ ? t.set(..._) : (v = e?.onMergeError) === null || v === void 0 || v.call(e, oG(), o, y);
    }, l = () => {
      const { node: y } = u, v = K2(o);
      if (t.has(v)) {
        const _ = t.get(v), E = y[a];
        Array.isArray(E) && (E.length < 2 && s(i?.allOf || []), E.splice(_, 1));
      }
    };
    if (!is(i) || Array.isArray(i)) return { exitHook: l };
    if (!((y) => !!y && y["/allOf"] && "$" in y["/allOf"])(c)) return { exitHook: l };
    const { allOf: d } = i, f = Of(i, ["allOf"]), p = [];
    if (Array.isArray(d) && p.push(...d), p.length) Object.keys(f).length && p.push(f);
    else {
      const { $ref: y } = f, v = Of(f, ["$ref"]);
      if (e?.mergeRefSibling && y && Object.keys(v).length > 0) p.push({ $ref: y }, v);
      else if (e?.mergeCombinarySibling) {
        if (Gx(f) && c["/anyOf"]) return { value: Sd(f, "anyOf", c["/anyOf"]), exitHook: l };
        if (Wx(f) && c["/oneOf"]) return { value: Sd(f, "oneOf", c["/oneOf"]), exitHook: l };
      }
    }
    if (!p.length) return { value: f, exitHook: l };
    const { allOfItems: g, brokenRefs: b } = TE(p, o, n, r);
    if (b.length) return b.forEach(((y) => {
      var v;
      return (v = e?.onRefResolveError) === null || v === void 0 ? void 0 : v.call(e, "Cannot resolve $ref", o, y);
    })), { value: { allOf: g }, exitHook: l };
    if (g.length < 2) return { value: g.length ? g[0] : {}, exitHook: l };
    const w = Yf(g, { allOfItems: g, mergeRules: c, mergeError: s });
    return e?.mergeCombinarySibling && Gx(w) ? { value: Sd(w, "anyOf", c["/anyOf"]), exitHook: l } : e?.mergeCombinarySibling && Wx(w) ? { value: Sd(w, "oneOf", c["/oneOf"]), exitHook: l } : { value: w, exitHook: l };
  };
}, _G = (e) => {
  for (let t = e.length - 2; t >= 0; t--) if (e[t] === "anyOf" || e[t] === "oneOf") {
    const n = e.slice(0, t + 1);
    return [K2(n), e[t + 1]];
  }
};
function rs(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const wG = (e) => {
  const t = /* @__PURE__ */ new Set(), n = JSON.stringify(e, (i, a) => {
    if (typeof a == "object" && a !== null) {
      if (t.has(a))
        return;
      t.add(a);
    }
    return a;
  });
  return JSON.parse(n);
}, X6 = (e) => {
  if (Array.isArray(e?.allOf) && e.allOf.length > 0) {
    try {
      JSON.stringify(e);
    } catch {
      let t = {};
      for (const n of e.allOf)
        t = { ...X6, ...wG(n) };
      return {
        ...t,
        ...e.title ? { title: e.title } : {}
      };
    }
    return {
      ...bG(e, { mergeCombinarySibling: !0 }),
      ...e.title ? { title: e.title } : {}
    };
  } else
    return e;
}, Y2 = (e) => Array.isArray(e) ? e.includes("array") ? "array" : e.includes("object") ? "object" : e[0] : e, Oc = (e) => {
  if (!rs(e)) return {};
  if (Y2(e.type) === "array" && e.items && rs(e.items)) {
    const n = { ...e };
    return delete n.items, {
      ...n,
      ...X6(e.items),
      type: e.type,
      itemType: e.items.type
    };
  }
  return X6(e);
}, SG = (e, t) => t ?? `Variant ${e + 1}`;
function um(e, t) {
  if (!e) return {};
  const n = {};
  return Object.keys(e).forEach((r) => {
    const i = e[r];
    if (!rs(i)) return {};
    if (t(i))
      return {};
    n[r] = J2(i, t);
  }), n;
}
function J2(e, t = RE) {
  const n = JSON.parse(JSON.stringify(e));
  if (e.properties) {
    const r = um(e.properties, t);
    n.properties = r;
  }
  if (rs(e.items)) {
    const r = J2(e.items, t);
    n.items = r;
  }
  if (e.oneOf?.length) {
    const r = [];
    e.oneOf.forEach((i) => {
      if (!rs(i) || t(i)) return;
      const a = um(i.properties, t);
      r.push({ ...i, properties: a });
    }), n.oneOf = r;
  }
  if (e.anyOf?.length) {
    const r = [];
    e.anyOf.forEach((i) => {
      if (!rs(i) || t(i)) return;
      const a = um(i.properties, t);
      r.push({ ...i, properties: a });
    }), n.anyOf = r;
  }
  return n;
}
function RE(e) {
  return !!e.readOnly;
}
const mf = (e, t) => {
  if (!e)
    return "";
  let n = e.example;
  if (n !== void 0 || e.schema?.examples && (n = e.schema?.examples[0], n !== void 0) || e.schema?.example && (n = e.schema?.example, n !== void 0) || e.examples && (n = e.examples[0], n !== void 0))
    return n;
  if (e.enum)
    return e.enum[0];
  if (e.default !== null && e.default !== void 0)
    return typeof e.default == "object" ? JSON.stringify(e.default) : e.default;
  if (e.schema?.default !== null && e.schema?.default !== void 0)
    return typeof e.schema.default == "object" ? JSON.stringify(e.schema.default) : e.schema.default;
  switch (Y2(e.type)) {
    case "boolean":
      return !1;
    case "integer":
      return 0;
    case "number":
      return 0;
    case "string":
      return t;
    case "object":
      return "{}";
    case "array":
      return "[]";
  }
  return "";
}, J0 = ({ objData: e, parentKey: t = "", nestedLevel: n = 0, filteringOptions: r }) => {
  const i = /* @__PURE__ */ new WeakMap(), a = ({ objData: c, parentKey: u = "", nestedLevel: s = 0, filteringOptions: l }) => {
    if (typeof c > "u")
      return null;
    let d = {};
    if (c.allOf && Array.isArray(c.allOf)) {
      if (l.excludeReadonly) {
        for (let f = 0; f < c.allOf.length; f++)
          if (c.allOf[f].readOnly === !0)
            return null;
      }
      for (let f = 0; f < c.allOf.length; f++)
        d = {
          ...d,
          ...o({
            objData: c.allOf[f],
            parentKey: `allOf-${f}`,
            nestedLevel: s,
            filteringOptions: l
          })
        };
      return d;
    }
    return Array.isArray(c.anyOf) && typeof c.anyOf[0] == "object" ? o({ objData: c.anyOf[0] || {}, parentKey: u, nestedLevel: s + 1, filteringOptions: l }) : Array.isArray(c.oneOf) && typeof c.oneOf[0] == "object" ? o({ objData: c.oneOf[0] || {}, parentKey: u, nestedLevel: s + 1, filteringOptions: l }) : null;
  }, o = ({ objData: c, parentKey: u = "", nestedLevel: s = 0, filteringOptions: l }) => {
    let d = {};
    if (typeof c > "u")
      return d;
    if (c.example)
      return c.example;
    if (Array.isArray(c.examples) && c.examples.length > 0 && c.examples[0])
      return c.examples[0];
    if (l.excludeNotRequired && !c.required)
      return d;
    if (s >= vE)
      return d[u] = mf(c, u), d;
    const f = i.get(c);
    if (f)
      return f.seenSample;
    d = a({ objData: c, parentKey: u, nestedLevel: s, filteringOptions: l }) ?? {};
    for (const p of Object.keys(c.properties || {})) {
      if (l.excludeNotRequired && (!Array.isArray(c.required) || !c.required.includes(p)))
        continue;
      const g = Oc(c.properties[p]);
      if (l.excludeReadonly && g.readOnly)
        continue;
      const b = Y2(g.type);
      if (b === "array" || b === "object" || g.allOf) {
        if (b === "array") {
          const w = g.itemType === "object" ? o({
            objData: g || {},
            parentKey: p,
            nestedLevel: s + 1,
            filteringOptions: l
          }) : a({
            objData: g,
            parentKey: p,
            nestedLevel: s + 1,
            filteringOptions: l
          }) ?? mf(g, p);
          d[p] = Array.isArray(w) ? w : [w];
        } else if (b === "object" || g.allOf) {
          const w = o({ objData: g || {}, parentKey: p, nestedLevel: s + 1, filteringOptions: l });
          w !== null && (d[p] = w);
        }
      } else
        d[p] = a({
          objData: g,
          parentKey: p,
          nestedLevel: s + 1,
          filteringOptions: l
        }) ?? mf(g, p);
    }
    return i.set(c, { sampleObj: d, parentKey: u }), d;
  };
  return o({ objData: e, parentKey: t, nestedLevel: n, filteringOptions: r });
}, CG = (e, t = {}) => {
  const {
    sorted: n,
    ignorenull: r,
    ignoreEmptyArray: i,
    useDot: a,
    skipIndex: o,
    skipBracket: c,
    whitespace: u = "+"
  } = t, s = (w) => String(w).replace(/[^ !'()~*]/gu, encodeURIComponent).replace(/ /g, u).replace(/[!'()~*]/g, (y) => `%${y.charCodeAt().toString(16).slice(-2).toUpperCase()}`), l = (w, y = Object.keys(w)) => n ? y.sort() : y, d = (w) => w.filter((y) => y).join("&"), f = (w, y) => d(l(y).map((v) => b(a ? `${w}.${v}` : `${w}[${v}]`, y[v]))), p = (w, y, v = c ? "" : "[]") => y.length ? d(y.map((_, E) => b(o ? w + v : w + "[" + E + "]", _))) : i ? null : s(w + v), g = (w, y) => d(
    Array.from(y).map((v) => b(w, v))
  ), b = (w, y, v = typeof y, _ = null) => (y === _ ? _ = r ? _ : s(w) + "=" + _ : /string|number|boolean/.test(v) ? _ = s(w) + "=" + s(y) : Array.isArray(y) ? _ = p(w, y) : y instanceof Set ? _ = g(w, y) : v === "object" && (_ = f(w, y)), _);
  return e && d(l(e).map((w) => b(w, e[w])));
}, kG = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.responses?.forEach((n) => {
    (n.contents || []).forEach((r) => {
      t.add(r.mediaType);
    });
  }), [...t].join(", ");
}, IE = (e) => {
  const t = [], n = kG(e);
  return n && t.push({
    name: "Accept",
    value: n
  }), t.push({
    name: "Content-Type",
    value: e.request?.body?.contents?.[0]?.mediaType ?? e.responses?.[0]?.contents?.[0]?.mediaType ?? "application/json"
  }), t;
}, Q2 = (e) => {
  const t = {};
  return e ? (Object.keys(e).forEach((n) => {
    t[e[n]?.name || n] = mf(e[n], n);
  }), t) : {};
}, X2 = (e, t) => {
  if (!e.path)
    return "";
  if (!e.request?.path)
    return e.path.replaceAll("{", "").replaceAll("}", "");
  const n = t || Q2(e.request?.path) || {};
  let r = e.path;
  return Object.keys(n).forEach((i) => {
    const a = n[i];
    r = r.replaceAll(`{${i}}`, a);
  }), r.replaceAll("{", "").replaceAll("}", "");
}, eg = (e, t) => {
  const n = t || Q2(e.request?.query) || {}, r = new URLSearchParams();
  return Object.keys(n).forEach((i) => {
    (e.request?.query?.find((o) => o.name === i)?.required || n[i] !== "") && r.append(i, n[i]);
  }), r.toString();
}, tg = ({ data: e, fieldValues: t, excludeHeaderList: n }) => {
  const r = t || {}, i = [];
  return e.request?.headers?.forEach((a) => {
    if (n?.includes(a.name))
      return;
    const o = a.name, c = r[o] ?? mf(a, o);
    c && i.push({
      name: o,
      value: String(c)
    });
  }), i;
}, gf = (e, t = { excludeReadonly: !0, excludeNotRequired: !1 }, n = 0) => {
  if (!e.length || !e[0])
    return "";
  if (n !== void 0 && Array.isArray(e[0].examples) && // @ts-ignore value is valid property of example
  e[0].examples[n]?.value) {
    const r = jA(e[0].examples[n].value);
    return JSON.stringify(r, null, ns);
  }
  return JSON.stringify(
    J0({
      objData: Oc(e[0].schema),
      filteringOptions: t
    }),
    null,
    ns
  );
}, jE = (e, t) => {
  let n = "";
  for (const r of Object.keys(e || {}))
    r.toLowerCase() === "content-type" && (n = e[r]);
  return !t || t.isBinary ? { body: null, contentType: n } : t.content && n === "application/x-www-form-urlencoded" ? { body: CG(jA(t.content)), contentType: n } : { body: t.content, contentType: n };
}, AG = (e) => e.startsWith("2") ? "2xx" : "4xx";
function qE(e) {
  const t = (c) => c.replace("/", "-"), n = Ye(() => jt(e)), r = Ye(() => n.value.map((c) => ({ value: c.mediaType, label: c.mediaType, key: t(c.mediaType) })) ?? []), i = Br(r.value[0]?.value ?? ""), a = Ye(() => r.value.length < 2 ? n.value : n.value.filter((c) => c.mediaType === i.value) ?? []), o = Ye(() => [{
    name: pc.ContentTypeSelectMenu,
    value: i.value,
    optionList: r.value
  }]);
  return {
    contentTypeList: r,
    activeContentType: i,
    activeResponseContentList: a,
    contentSelectComponentList: o
  };
}
function DE(e) {
  const t = Ye(() => e.value?.map((l) => ({ value: l.code, label: l.code, key: AG(l.code) })) ?? []), n = Br(t.value[0]?.value), r = Ye(() => e.value?.find((l) => l.code === n.value)), i = Ye(() => r.value?.description ?? ""), a = Ye(() => r.value?.contents ?? []), { activeContentType: o, activeResponseContentList: c, contentTypeList: u } = qE(a), s = Ye(() => {
    const l = [{
      name: pc.ResponseCodeSelectMenu,
      value: n.value,
      optionList: t.value
    }];
    return u.value.length > 0 && l.push({
      name: pc.ContentTypeSelectMenu,
      value: o.value,
      optionList: u.value
    }), l;
  });
  return On(t, (l) => {
    n.value = l[0]?.value, o.value = u.value[0]?.value;
  }), On(n, () => {
    o.value = u.value[0]?.value;
  }), {
    responseCodeList: t,
    activeResponseCode: n,
    activeResponse: r,
    activeResponseDescription: i,
    activeContentType: o,
    contentTypeList: u,
    activeResponseContentList: c,
    responseSelectComponentList: s
  };
}
function EG(e) {
  const t = Br(e.value[0]?.key ?? ""), n = Ye(() => e.value.map((d) => ({ value: d.key, label: d.key, key: d.method })) ?? []), r = Ye(() => e.value.find((d) => d.key === t.value)), i = Ye(() => r.value?.request?.body?.contents ? gf(
    r.value.request.body.contents,
    { excludeReadonly: !0, excludeNotRequired: !1 },
    0
  ) : ""), a = Ye(() => r.value?.responses ?? []), {
    activeResponseDescription: o,
    activeResponseCode: c,
    activeContentType: u,
    activeResponseContentList: s,
    responseSelectComponentList: l
  } = DE(a);
  return On(n, (d) => {
    t.value = d[0]?.value ?? "";
  }), {
    activeCallbackKey: t,
    callbackKeyList: n,
    activeCallback: r,
    activeCallbackRequestSample: i,
    activeCallbackResponseDescription: o,
    activeCallbackResponseCode: c,
    activeCallbackContentType: u,
    activeCallbackResponseContentList: s,
    activeCallbackResponseSelectComponentList: l
  };
}
const No = Br([]), Cd = pi("");
function OG() {
  const e = (o, c) => {
    if (!c)
      return "";
    let u = c.origUrl || c.url;
    if (c.variables)
      for (const s of Object.keys(c.variables))
        u = u.replace(`{${s}}`, c.variables[s].extensions?.value || c.variables[s].default);
    return xx(u);
  }, t = (o) => {
    const c = o.map((u, s) => ({
      ...u,
      origUrl: u.url,
      url: e(s, u)
    }));
    No.value = c, Cd.value = e(0, c[0]);
  }, n = (o) => {
    const c = xx(o);
    No.value.push({
      id: No.value.length.toString(),
      url: c
    }), Cd.value = c;
  }, r = (o) => {
    No.value = No.value.filter((c) => c.url !== o);
  }, i = (o, c, u) => {
    const s = No.value.findIndex((d) => d.id === o);
    if (s === -1)
      return;
    const l = No.value[s];
    !l || !l.variables || !l.variables[c] || (l.variables[c].extensions || (l.variables[c].extensions = {}), l.variables[c].extensions.value = u, l.url = e(s, l), Cd.value = l.url);
  }, a = Ye(() => No.value?.map((o) => o.url) ?? []);
  return {
    serverList: No,
    selectedServerUrl: Cd,
    serverUrlList: a,
    initialize: t,
    addServerUrl: n,
    removeServerUrl: r,
    setServerVariable: i
  };
}
const TG = Br("browser");
function PG() {
  return {
    selectedTryItMethodKey: TG
  };
}
const Jx = {};
function RG(e) {
  let t = Jx[e];
  if (t)
    return t;
  t = Jx[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    t.push(r);
  }
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    t[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  }
  return t;
}
function mc(e, t) {
  typeof t != "string" && (t = mc.defaultChars);
  const n = RG(t);
  return e.replace(/(%[a-f0-9]{2})+/gi, function(r) {
    let i = "";
    for (let a = 0, o = r.length; a < o; a += 3) {
      const c = parseInt(r.slice(a + 1, a + 3), 16);
      if (c < 128) {
        i += n[c];
        continue;
      }
      if ((c & 224) === 192 && a + 3 < o) {
        const u = parseInt(r.slice(a + 4, a + 6), 16);
        if ((u & 192) === 128) {
          const s = c << 6 & 1984 | u & 63;
          s < 128 ? i += "��" : i += String.fromCharCode(s), a += 3;
          continue;
        }
      }
      if ((c & 240) === 224 && a + 6 < o) {
        const u = parseInt(r.slice(a + 4, a + 6), 16), s = parseInt(r.slice(a + 7, a + 9), 16);
        if ((u & 192) === 128 && (s & 192) === 128) {
          const l = c << 12 & 61440 | u << 6 & 4032 | s & 63;
          l < 2048 || l >= 55296 && l <= 57343 ? i += "���" : i += String.fromCharCode(l), a += 6;
          continue;
        }
      }
      if ((c & 248) === 240 && a + 9 < o) {
        const u = parseInt(r.slice(a + 4, a + 6), 16), s = parseInt(r.slice(a + 7, a + 9), 16), l = parseInt(r.slice(a + 10, a + 12), 16);
        if ((u & 192) === 128 && (s & 192) === 128 && (l & 192) === 128) {
          let d = c << 18 & 1835008 | u << 12 & 258048 | s << 6 & 4032 | l & 63;
          d < 65536 || d > 1114111 ? i += "����" : (d -= 65536, i += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), a += 9;
          continue;
        }
      }
      i += "�";
    }
    return i;
  });
}
mc.defaultChars = ";/?:@&=+$,#";
mc.componentChars = "";
const Qx = {};
function IG(e) {
  let t = Qx[e];
  if (t)
    return t;
  t = Qx[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(r) ? t.push(r) : t.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < e.length; n++)
    t[e.charCodeAt(n)] = e[n];
  return t;
}
function Jf(e, t, n) {
  typeof t != "string" && (n = t, t = Jf.defaultChars), typeof n > "u" && (n = !0);
  const r = IG(t);
  let i = "";
  for (let a = 0, o = e.length; a < o; a++) {
    const c = e.charCodeAt(a);
    if (n && c === 37 && a + 2 < o && /^[0-9a-f]{2}$/i.test(e.slice(a + 1, a + 3))) {
      i += e.slice(a, a + 3), a += 2;
      continue;
    }
    if (c < 128) {
      i += r[c];
      continue;
    }
    if (c >= 55296 && c <= 57343) {
      if (c >= 55296 && c <= 56319 && a + 1 < o) {
        const u = e.charCodeAt(a + 1);
        if (u >= 56320 && u <= 57343) {
          i += encodeURIComponent(e[a] + e[a + 1]), a++;
          continue;
        }
      }
      i += "%EF%BF%BD";
      continue;
    }
    i += encodeURIComponent(e[a]);
  }
  return i;
}
Jf.defaultChars = ";/?:@&=+$,-_.!~*'()#";
Jf.componentChars = "-_.!~*'()";
function rg(e) {
  let t = "";
  return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
}
function _0() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const jG = /^([a-z0-9.+-]+:)/i, qG = /:[0-9]*$/, DG = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, $G = ["<", ">", '"', "`", " ", "\r", `
`, "	"], LG = ["{", "}", "|", "\\", "^", "`"].concat($G), NG = ["'"].concat(LG), Xx = ["%", "/", "?", ";", "#"].concat(NG), e7 = ["/", "?", "#"], FG = 255, t7 = /^[+a-z0-9A-Z_-]{0,63}$/, MG = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, r7 = {
  javascript: !0,
  "javascript:": !0
}, n7 = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function ng(e, t) {
  if (e && e instanceof _0) return e;
  const n = new _0();
  return n.parse(e, t), n;
}
_0.prototype.parse = function(e, t) {
  let n, r, i, a = e;
  if (a = a.trim(), !t && e.split("#").length === 1) {
    const s = DG.exec(a);
    if (s)
      return this.pathname = s[1], s[2] && (this.search = s[2]), this;
  }
  let o = jG.exec(a);
  if (o && (o = o[0], n = o.toLowerCase(), this.protocol = o, a = a.substr(o.length)), (t || o || a.match(/^\/\/[^@\/]+@[^@\/]+/)) && (i = a.substr(0, 2) === "//", i && !(o && r7[o]) && (a = a.substr(2), this.slashes = !0)), !r7[o] && (i || o && !n7[o])) {
    let s = -1;
    for (let g = 0; g < e7.length; g++)
      r = a.indexOf(e7[g]), r !== -1 && (s === -1 || r < s) && (s = r);
    let l, d;
    s === -1 ? d = a.lastIndexOf("@") : d = a.lastIndexOf("@", s), d !== -1 && (l = a.slice(0, d), a = a.slice(d + 1), this.auth = l), s = -1;
    for (let g = 0; g < Xx.length; g++)
      r = a.indexOf(Xx[g]), r !== -1 && (s === -1 || r < s) && (s = r);
    s === -1 && (s = a.length), a[s - 1] === ":" && s--;
    const f = a.slice(0, s);
    a = a.slice(s), this.parseHost(f), this.hostname = this.hostname || "";
    const p = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!p) {
      const g = this.hostname.split(/\./);
      for (let b = 0, w = g.length; b < w; b++) {
        const y = g[b];
        if (y && !y.match(t7)) {
          let v = "";
          for (let _ = 0, E = y.length; _ < E; _++)
            y.charCodeAt(_) > 127 ? v += "x" : v += y[_];
          if (!v.match(t7)) {
            const _ = g.slice(0, b), E = g.slice(b + 1), O = y.match(MG);
            O && (_.push(O[1]), E.unshift(O[2])), E.length && (a = E.join(".") + a), this.hostname = _.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > FG && (this.hostname = ""), p && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const c = a.indexOf("#");
  c !== -1 && (this.hash = a.substr(c), a = a.slice(0, c));
  const u = a.indexOf("?");
  return u !== -1 && (this.search = a.substr(u), a = a.slice(0, u)), a && (this.pathname = a), n7[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
_0.prototype.parseHost = function(e) {
  let t = qG.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
const BG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: mc,
  encode: Jf,
  format: rg,
  parse: ng
}, Symbol.toStringTag, { value: "Module" })), $E = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, LE = /[\0-\x1F\x7F-\x9F]/, UG = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, ig = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, NE = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, FE = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, HG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: $E,
  Cc: LE,
  Cf: UG,
  P: ig,
  S: NE,
  Z: FE
}, Symbol.toStringTag, { value: "Module" })), zG = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), VG = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var cm;
const GG = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), WG = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (cm = String.fromCodePoint) !== null && cm !== void 0 ? cm : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function KG(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = GG.get(e)) !== null && t !== void 0 ? t : e;
}
var wi;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(wi || (wi = {}));
const ZG = 32;
var ws;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(ws || (ws = {}));
function e2(e) {
  return e >= wi.ZERO && e <= wi.NINE;
}
function YG(e) {
  return e >= wi.UPPER_A && e <= wi.UPPER_F || e >= wi.LOWER_A && e <= wi.LOWER_F;
}
function JG(e) {
  return e >= wi.UPPER_A && e <= wi.UPPER_Z || e >= wi.LOWER_A && e <= wi.LOWER_Z || e2(e);
}
function QG(e) {
  return e === wi.EQUALS || JG(e);
}
var gi;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(gi || (gi = {}));
var bs;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(bs || (bs = {}));
class XG {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = gi.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = bs.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = gi.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case gi.EntityStart:
        return t.charCodeAt(n) === wi.NUM ? (this.state = gi.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = gi.NamedEntity, this.stateNamedEntity(t, n));
      case gi.NumericStart:
        return this.stateNumericStart(t, n);
      case gi.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case gi.NumericHex:
        return this.stateNumericHex(t, n);
      case gi.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | ZG) === wi.LOWER_X ? (this.state = gi.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = gi.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, i) {
    if (n !== r) {
      const a = r - n;
      this.result = this.result * Math.pow(i, a) + parseInt(t.substr(n, a), i), this.consumed += a;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (e2(i) || YG(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (e2(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === wi.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === bs.Strict)
      return 0;
    return this.emitCodePoint(KG(this.result), this.consumed), this.errors && (t !== wi.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], a = (i & ws.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const o = t.charCodeAt(n);
      if (this.treeIndex = eW(r, i, this.treeIndex + Math.max(1, a), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === bs.Attribute && // We shouldn't have consumed any characters after the entity,
        (a === 0 || // And there should be no invalid characters.
        QG(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], a = (i & ws.VALUE_LENGTH) >> 14, a !== 0) {
        if (o === wi.SEMI)
          return this.emitNamedEntityData(this.treeIndex, a, this.consumed + this.excess);
        this.decodeMode !== bs.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, i = (r[n] & ws.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[t] & ~ws.VALUE_LENGTH : i[t + 1], r), n === 3 && this.emitCodePoint(i[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case gi.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== bs.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case gi.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case gi.NumericHex:
        return this.emitNumericEntity(0, 3);
      case gi.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case gi.EntityStart:
        return 0;
    }
  }
}
function ME(e) {
  let t = "";
  const n = new XG(e, (r) => t += WG(r));
  return function(i, a) {
    let o = 0, c = 0;
    for (; (c = i.indexOf("&", c)) >= 0; ) {
      t += i.slice(o, c), n.startEntity(a);
      const s = n.write(
        i,
        // Skip the "&"
        c + 1
      );
      if (s < 0) {
        o = c + n.end();
        break;
      }
      o = c + s, c = s === 0 ? o + 1 : o;
    }
    const u = t + i.slice(o);
    return t = "", u;
  };
}
function eW(e, t, n, r) {
  const i = (t & ws.BRANCH_LENGTH) >> 7, a = t & ws.JUMP_TABLE;
  if (i === 0)
    return a !== 0 && r === a ? n : -1;
  if (a) {
    const u = r - a;
    return u < 0 || u >= i ? -1 : e[n + u] - 1;
  }
  let o = n, c = o + i - 1;
  for (; o <= c; ) {
    const u = o + c >>> 1, s = e[u];
    if (s < r)
      o = u + 1;
    else if (s > r)
      c = u - 1;
    else
      return e[u + i];
  }
  return -1;
}
const tW = ME(zG);
ME(VG);
function BE(e, t = bs.Legacy) {
  return tW(e, t);
}
function rW(e) {
  return Object.prototype.toString.call(e);
}
function ag(e) {
  return rW(e) === "[object String]";
}
const nW = Object.prototype.hasOwnProperty;
function iW(e, t) {
  return nW.call(e, t);
}
function Q0(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(r) {
        e[r] = n[r];
      });
    }
  }), e;
}
function UE(e, t, n) {
  return [].concat(e.slice(0, t), n, e.slice(t + 1));
}
function og(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function w0(e) {
  if (e > 65535) {
    e -= 65536;
    const t = 55296 + (e >> 10), n = 56320 + (e & 1023);
    return String.fromCharCode(t, n);
  }
  return String.fromCharCode(e);
}
const HE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, aW = /&([a-z#][a-z0-9]{1,31});/gi, oW = new RegExp(HE.source + "|" + aW.source, "gi"), sW = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function uW(e, t) {
  if (t.charCodeAt(0) === 35 && sW.test(t)) {
    const r = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
    return og(r) ? w0(r) : e;
  }
  const n = BE(e);
  return n !== e ? n : e;
}
function cW(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(HE, "$1");
}
function gc(e) {
  return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(oW, function(t, n, r) {
    return n || uW(t, r);
  });
}
const lW = /[&<>"]/, fW = /[&<>"]/g, pW = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function dW(e) {
  return pW[e];
}
function Es(e) {
  return lW.test(e) ? e.replace(fW, dW) : e;
}
const hW = /[.?*+^$[\]\\(){}|-]/g;
function mW(e) {
  return e.replace(hW, "\\$&");
}
function Gn(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function Tf(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Pf(e) {
  return ig.test(e) || NE.test(e);
}
function Rf(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function X0(e) {
  return e = e.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
}
const gW = { mdurl: BG, ucmicro: HG }, vW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: UE,
  assign: Q0,
  escapeHtml: Es,
  escapeRE: mW,
  fromCodePoint: w0,
  has: iW,
  isMdAsciiPunct: Rf,
  isPunctChar: Pf,
  isSpace: Gn,
  isString: ag,
  isValidEntityCode: og,
  isWhiteSpace: Tf,
  lib: gW,
  normalizeReference: X0,
  unescapeAll: gc,
  unescapeMd: cW
}, Symbol.toStringTag, { value: "Module" }));
function yW(e, t, n) {
  let r, i, a, o;
  const c = e.posMax, u = e.pos;
  for (e.pos = t + 1, r = 1; e.pos < c; ) {
    if (a = e.src.charCodeAt(e.pos), a === 93 && (r--, r === 0)) {
      i = !0;
      break;
    }
    if (o = e.pos, e.md.inline.skipToken(e), a === 91) {
      if (o === e.pos - 1)
        r++;
      else if (n)
        return e.pos = u, -1;
    }
  }
  let s = -1;
  return i && (s = e.pos), e.pos = u, s;
}
function bW(e, t, n) {
  let r, i = t;
  const a = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (e.charCodeAt(i) === 60) {
    for (i++; i < n; ) {
      if (r = e.charCodeAt(i), r === 10 || r === 60)
        return a;
      if (r === 62)
        return a.pos = i + 1, a.str = gc(e.slice(t + 1, i)), a.ok = !0, a;
      if (r === 92 && i + 1 < n) {
        i += 2;
        continue;
      }
      i++;
    }
    return a;
  }
  let o = 0;
  for (; i < n && (r = e.charCodeAt(i), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && i + 1 < n) {
      if (e.charCodeAt(i + 1) === 32)
        break;
      i += 2;
      continue;
    }
    if (r === 40 && (o++, o > 32))
      return a;
    if (r === 41) {
      if (o === 0)
        break;
      o--;
    }
    i++;
  }
  return t === i || o !== 0 || (a.str = gc(e.slice(t, i)), a.pos = i, a.ok = !0), a;
}
function xW(e, t, n, r) {
  let i, a = t;
  const o = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (r)
    o.str = r.str, o.marker = r.marker;
  else {
    if (a >= n)
      return o;
    let c = e.charCodeAt(a);
    if (c !== 34 && c !== 39 && c !== 40)
      return o;
    t++, a++, c === 40 && (c = 41), o.marker = c;
  }
  for (; a < n; ) {
    if (i = e.charCodeAt(a), i === o.marker)
      return o.pos = a + 1, o.str += gc(e.slice(t, a)), o.ok = !0, o;
    if (i === 40 && o.marker === 41)
      return o;
    i === 92 && a + 1 < n && a++, a++;
  }
  return o.can_continue = !0, o.str += gc(e.slice(t, a)), o;
}
const _W = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: bW,
  parseLinkLabel: yW,
  parseLinkTitle: xW
}, Symbol.toStringTag, { value: "Module" })), ko = {};
ko.code_inline = function(e, t, n, r, i) {
  const a = e[t];
  return "<code" + i.renderAttrs(a) + ">" + Es(a.content) + "</code>";
};
ko.code_block = function(e, t, n, r, i) {
  const a = e[t];
  return "<pre" + i.renderAttrs(a) + "><code>" + Es(e[t].content) + `</code></pre>
`;
};
ko.fence = function(e, t, n, r, i) {
  const a = e[t], o = a.info ? gc(a.info).trim() : "";
  let c = "", u = "";
  if (o) {
    const l = o.split(/(\s+)/g);
    c = l[0], u = l.slice(2).join("");
  }
  let s;
  if (n.highlight ? s = n.highlight(a.content, c, u) || Es(a.content) : s = Es(a.content), s.indexOf("<pre") === 0)
    return s + `
`;
  if (o) {
    const l = a.attrIndex("class"), d = a.attrs ? a.attrs.slice() : [];
    l < 0 ? d.push(["class", n.langPrefix + c]) : (d[l] = d[l].slice(), d[l][1] += " " + n.langPrefix + c);
    const f = {
      attrs: d
    };
    return `<pre><code${i.renderAttrs(f)}>${s}</code></pre>
`;
  }
  return `<pre><code${i.renderAttrs(a)}>${s}</code></pre>
`;
};
ko.image = function(e, t, n, r, i) {
  const a = e[t];
  return a.attrs[a.attrIndex("alt")][1] = i.renderInlineAsText(a.children, n, r), i.renderToken(e, t, n);
};
ko.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
ko.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
ko.text = function(e, t) {
  return Es(e[t].content);
};
ko.html_block = function(e, t) {
  return e[t].content;
};
ko.html_inline = function(e, t) {
  return e[t].content;
};
function Tc() {
  this.rules = Q0({}, ko);
}
Tc.prototype.renderAttrs = function(t) {
  let n, r, i;
  if (!t.attrs)
    return "";
  for (i = "", n = 0, r = t.attrs.length; n < r; n++)
    i += " " + Es(t.attrs[n][0]) + '="' + Es(t.attrs[n][1]) + '"';
  return i;
};
Tc.prototype.renderToken = function(t, n, r) {
  const i = t[n];
  let a = "";
  if (i.hidden)
    return "";
  i.block && i.nesting !== -1 && n && t[n - 1].hidden && (a += `
`), a += (i.nesting === -1 ? "</" : "<") + i.tag, a += this.renderAttrs(i), i.nesting === 0 && r.xhtmlOut && (a += " /");
  let o = !1;
  if (i.block && (o = !0, i.nesting === 1 && n + 1 < t.length)) {
    const c = t[n + 1];
    (c.type === "inline" || c.hidden || c.nesting === -1 && c.tag === i.tag) && (o = !1);
  }
  return a += o ? `>
` : ">", a;
};
Tc.prototype.renderInline = function(e, t, n) {
  let r = "";
  const i = this.rules;
  for (let a = 0, o = e.length; a < o; a++) {
    const c = e[a].type;
    typeof i[c] < "u" ? r += i[c](e, a, t, n, this) : r += this.renderToken(e, a, t);
  }
  return r;
};
Tc.prototype.renderInlineAsText = function(e, t, n) {
  let r = "";
  for (let i = 0, a = e.length; i < a; i++)
    switch (e[i].type) {
      case "text":
        r += e[i].content;
        break;
      case "image":
        r += this.renderInlineAsText(e[i].children, t, n);
        break;
      case "html_inline":
      case "html_block":
        r += e[i].content;
        break;
      case "softbreak":
      case "hardbreak":
        r += `
`;
        break;
    }
  return r;
};
Tc.prototype.render = function(e, t, n) {
  let r = "";
  const i = this.rules;
  for (let a = 0, o = e.length; a < o; a++) {
    const c = e[a].type;
    c === "inline" ? r += this.renderInline(e[a].children, t, n) : typeof i[c] < "u" ? r += i[c](e, a, t, n, this) : r += this.renderToken(e, a, t, n);
  }
  return r;
};
function ra() {
  this.__rules__ = [], this.__cache__ = null;
}
ra.prototype.__find__ = function(e) {
  for (let t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
ra.prototype.__compile__ = function() {
  const e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      t.indexOf(r) < 0 && t.push(r);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || e.__cache__[n].push(r.fn));
    });
  });
};
ra.prototype.at = function(e, t, n) {
  const r = this.__find__(e), i = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[r].fn = t, this.__rules__[r].alt = i.alt || [], this.__cache__ = null;
};
ra.prototype.before = function(e, t, n, r) {
  const i = this.__find__(e), a = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: a.alt || []
  }), this.__cache__ = null;
};
ra.prototype.after = function(e, t, n, r) {
  const i = this.__find__(e), a = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: a.alt || []
  }), this.__cache__ = null;
};
ra.prototype.push = function(e, t, n) {
  const r = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: r.alt || []
  }), this.__cache__ = null;
};
ra.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !0, n.push(r);
  }, this), this.__cache__ = null, n;
};
ra.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(e, t);
};
ra.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !1, n.push(r);
  }, this), this.__cache__ = null, n;
};
ra.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function io(e, t, n) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
io.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const n = this.attrs;
  for (let r = 0, i = n.length; r < i; r++)
    if (n[r][0] === t)
      return r;
  return -1;
};
io.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
io.prototype.attrSet = function(t, n) {
  const r = this.attrIndex(t), i = [t, n];
  r < 0 ? this.attrPush(i) : this.attrs[r] = i;
};
io.prototype.attrGet = function(t) {
  const n = this.attrIndex(t);
  let r = null;
  return n >= 0 && (r = this.attrs[n][1]), r;
};
io.prototype.attrJoin = function(t, n) {
  const r = this.attrIndex(t);
  r < 0 ? this.attrPush([t, n]) : this.attrs[r][1] = this.attrs[r][1] + " " + n;
};
function zE(e, t, n) {
  this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
}
zE.prototype.Token = io;
const wW = /\r\n?|\n/g, SW = /\0/g;
function CW(e) {
  let t;
  t = e.src.replace(wW, `
`), t = t.replace(SW, "�"), e.src = t;
}
function kW(e) {
  let t;
  e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function AW(e) {
  const t = e.tokens;
  for (let n = 0, r = t.length; n < r; n++) {
    const i = t[n];
    i.type === "inline" && e.md.inline.parse(i.content, e.md, e.env, i.children);
  }
}
function EW(e) {
  return /^<a[>\s]/i.test(e);
}
function OW(e) {
  return /^<\/a\s*>/i.test(e);
}
function TW(e) {
  const t = e.tokens;
  if (e.md.options.linkify)
    for (let n = 0, r = t.length; n < r; n++) {
      if (t[n].type !== "inline" || !e.md.linkify.pretest(t[n].content))
        continue;
      let i = t[n].children, a = 0;
      for (let o = i.length - 1; o >= 0; o--) {
        const c = i[o];
        if (c.type === "link_close") {
          for (o--; i[o].level !== c.level && i[o].type !== "link_open"; )
            o--;
          continue;
        }
        if (c.type === "html_inline" && (EW(c.content) && a > 0 && a--, OW(c.content) && a++), !(a > 0) && c.type === "text" && e.md.linkify.test(c.content)) {
          const u = c.content;
          let s = e.md.linkify.match(u);
          const l = [];
          let d = c.level, f = 0;
          s.length > 0 && s[0].index === 0 && o > 0 && i[o - 1].type === "text_special" && (s = s.slice(1));
          for (let p = 0; p < s.length; p++) {
            const g = s[p].url, b = e.md.normalizeLink(g);
            if (!e.md.validateLink(b))
              continue;
            let w = s[p].text;
            s[p].schema ? s[p].schema === "mailto:" && !/^mailto:/i.test(w) ? w = e.md.normalizeLinkText("mailto:" + w).replace(/^mailto:/, "") : w = e.md.normalizeLinkText(w) : w = e.md.normalizeLinkText("http://" + w).replace(/^http:\/\//, "");
            const y = s[p].index;
            if (y > f) {
              const O = new e.Token("text", "", 0);
              O.content = u.slice(f, y), O.level = d, l.push(O);
            }
            const v = new e.Token("link_open", "a", 1);
            v.attrs = [["href", b]], v.level = d++, v.markup = "linkify", v.info = "auto", l.push(v);
            const _ = new e.Token("text", "", 0);
            _.content = w, _.level = d, l.push(_);
            const E = new e.Token("link_close", "a", -1);
            E.level = --d, E.markup = "linkify", E.info = "auto", l.push(E), f = s[p].lastIndex;
          }
          if (f < u.length) {
            const p = new e.Token("text", "", 0);
            p.content = u.slice(f), p.level = d, l.push(p);
          }
          t[n].children = i = UE(i, o, l);
        }
      }
    }
}
const VE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, PW = /\((c|tm|r)\)/i, RW = /\((c|tm|r)\)/ig, IW = {
  c: "©",
  r: "®",
  tm: "™"
};
function jW(e, t) {
  return IW[t.toLowerCase()];
}
function qW(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && (r.content = r.content.replace(RW, jW)), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function DW(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && VE.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function $W(e) {
  let t;
  if (e.md.options.typographer)
    for (t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type === "inline" && (PW.test(e.tokens[t].content) && qW(e.tokens[t].children), VE.test(e.tokens[t].content) && DW(e.tokens[t].children));
}
const LW = /['"]/, i7 = /['"]/g, a7 = "’";
function kd(e, t, n) {
  return e.slice(0, t) + n + e.slice(t + 1);
}
function NW(e, t) {
  let n;
  const r = [];
  for (let i = 0; i < e.length; i++) {
    const a = e[i], o = e[i].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= o); n--)
      ;
    if (r.length = n + 1, a.type !== "text")
      continue;
    let c = a.content, u = 0, s = c.length;
    e:
      for (; u < s; ) {
        i7.lastIndex = u;
        const l = i7.exec(c);
        if (!l)
          break;
        let d = !0, f = !0;
        u = l.index + 1;
        const p = l[0] === "'";
        let g = 32;
        if (l.index - 1 >= 0)
          g = c.charCodeAt(l.index - 1);
        else
          for (n = i - 1; n >= 0 && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n--)
            if (e[n].content) {
              g = e[n].content.charCodeAt(e[n].content.length - 1);
              break;
            }
        let b = 32;
        if (u < s)
          b = c.charCodeAt(u);
        else
          for (n = i + 1; n < e.length && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n++)
            if (e[n].content) {
              b = e[n].content.charCodeAt(0);
              break;
            }
        const w = Rf(g) || Pf(String.fromCharCode(g)), y = Rf(b) || Pf(String.fromCharCode(b)), v = Tf(g), _ = Tf(b);
        if (_ ? d = !1 : y && (v || w || (d = !1)), v ? f = !1 : w && (_ || y || (f = !1)), b === 34 && l[0] === '"' && g >= 48 && g <= 57 && (f = d = !1), d && f && (d = w, f = y), !d && !f) {
          p && (a.content = kd(a.content, l.index, a7));
          continue;
        }
        if (f)
          for (n = r.length - 1; n >= 0; n--) {
            let E = r[n];
            if (r[n].level < o)
              break;
            if (E.single === p && r[n].level === o) {
              E = r[n];
              let O, M;
              p ? (O = t.md.options.quotes[2], M = t.md.options.quotes[3]) : (O = t.md.options.quotes[0], M = t.md.options.quotes[1]), a.content = kd(a.content, l.index, M), e[E.token].content = kd(
                e[E.token].content,
                E.pos,
                O
              ), u += M.length - 1, E.token === i && (u += O.length - 1), c = a.content, s = c.length, r.length = n;
              continue e;
            }
          }
        d ? r.push({
          token: i,
          pos: l.index,
          single: p,
          level: o
        }) : f && p && (a.content = kd(a.content, l.index, a7));
      }
  }
}
function FW(e) {
  if (e.md.options.typographer)
    for (let t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type !== "inline" || !LW.test(e.tokens[t].content) || NW(e.tokens[t].children, e);
}
function MW(e) {
  let t, n;
  const r = e.tokens, i = r.length;
  for (let a = 0; a < i; a++) {
    if (r[a].type !== "inline") continue;
    const o = r[a].children, c = o.length;
    for (t = 0; t < c; t++)
      o[t].type === "text_special" && (o[t].type = "text");
    for (t = n = 0; t < c; t++)
      o[t].type === "text" && t + 1 < c && o[t + 1].type === "text" ? o[t + 1].content = o[t].content + o[t + 1].content : (t !== n && (o[n] = o[t]), n++);
    t !== n && (o.length = n);
  }
}
const lm = [
  ["normalize", CW],
  ["block", kW],
  ["inline", AW],
  ["linkify", TW],
  ["replacements", $W],
  ["smartquotes", FW],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", MW]
];
function sg() {
  this.ruler = new ra();
  for (let e = 0; e < lm.length; e++)
    this.ruler.push(lm[e][0], lm[e][1]);
}
sg.prototype.process = function(e) {
  const t = this.ruler.getRules("");
  for (let n = 0, r = t.length; n < r; n++)
    t[n](e);
};
sg.prototype.State = zE;
function Ao(e, t, n, r) {
  this.src = e, this.md = t, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const i = this.src;
  for (let a = 0, o = 0, c = 0, u = 0, s = i.length, l = !1; o < s; o++) {
    const d = i.charCodeAt(o);
    if (!l)
      if (Gn(d)) {
        c++, d === 9 ? u += 4 - u % 4 : u++;
        continue;
      } else
        l = !0;
    (d === 10 || o === s - 1) && (d !== 10 && o++, this.bMarks.push(a), this.eMarks.push(o), this.tShift.push(c), this.sCount.push(u), this.bsCount.push(0), l = !1, c = 0, u = 0, a = o + 1);
  }
  this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
Ao.prototype.push = function(e, t, n) {
  const r = new io(e, t, n);
  return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
};
Ao.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
Ao.prototype.skipEmptyLines = function(t) {
  for (let n = this.lineMax; t < n && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
Ao.prototype.skipSpaces = function(t) {
  for (let n = this.src.length; t < n; t++) {
    const r = this.src.charCodeAt(t);
    if (!Gn(r))
      break;
  }
  return t;
};
Ao.prototype.skipSpacesBack = function(t, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (!Gn(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
Ao.prototype.skipChars = function(t, n) {
  for (let r = this.src.length; t < r && this.src.charCodeAt(t) === n; t++)
    ;
  return t;
};
Ao.prototype.skipCharsBack = function(t, n, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (n !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
Ao.prototype.getLines = function(t, n, r, i) {
  if (t >= n)
    return "";
  const a = new Array(n - t);
  for (let o = 0, c = t; c < n; c++, o++) {
    let u = 0;
    const s = this.bMarks[c];
    let l = s, d;
    for (c + 1 < n || i ? d = this.eMarks[c] + 1 : d = this.eMarks[c]; l < d && u < r; ) {
      const f = this.src.charCodeAt(l);
      if (Gn(f))
        f === 9 ? u += 4 - (u + this.bsCount[c]) % 4 : u++;
      else if (l - s < this.tShift[c])
        u++;
      else
        break;
      l++;
    }
    u > r ? a[o] = new Array(u - r + 1).join(" ") + this.src.slice(l, d) : a[o] = this.src.slice(l, d);
  }
  return a.join("");
};
Ao.prototype.Token = io;
const BW = 65536;
function fm(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  return e.src.slice(n, r);
}
function o7(e) {
  const t = [], n = e.length;
  let r = 0, i = e.charCodeAt(r), a = !1, o = 0, c = "";
  for (; r < n; )
    i === 124 && (a ? (c += e.substring(o, r - 1), o = r) : (t.push(c + e.substring(o, r)), c = "", o = r + 1)), a = i === 92, r++, i = e.charCodeAt(r);
  return t.push(c + e.substring(o)), t;
}
function UW(e, t, n, r) {
  if (t + 2 > n)
    return !1;
  let i = t + 1;
  if (e.sCount[i] < e.blkIndent || e.sCount[i] - e.blkIndent >= 4)
    return !1;
  let a = e.bMarks[i] + e.tShift[i];
  if (a >= e.eMarks[i])
    return !1;
  const o = e.src.charCodeAt(a++);
  if (o !== 124 && o !== 45 && o !== 58 || a >= e.eMarks[i])
    return !1;
  const c = e.src.charCodeAt(a++);
  if (c !== 124 && c !== 45 && c !== 58 && !Gn(c) || o === 45 && Gn(c))
    return !1;
  for (; a < e.eMarks[i]; ) {
    const E = e.src.charCodeAt(a);
    if (E !== 124 && E !== 45 && E !== 58 && !Gn(E))
      return !1;
    a++;
  }
  let u = fm(e, t + 1), s = u.split("|");
  const l = [];
  for (let E = 0; E < s.length; E++) {
    const O = s[E].trim();
    if (!O) {
      if (E === 0 || E === s.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(O))
      return !1;
    O.charCodeAt(O.length - 1) === 58 ? l.push(O.charCodeAt(0) === 58 ? "center" : "right") : O.charCodeAt(0) === 58 ? l.push("left") : l.push("");
  }
  if (u = fm(e, t).trim(), u.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4)
    return !1;
  s = o7(u), s.length && s[0] === "" && s.shift(), s.length && s[s.length - 1] === "" && s.pop();
  const d = s.length;
  if (d === 0 || d !== l.length)
    return !1;
  if (r)
    return !0;
  const f = e.parentType;
  e.parentType = "table";
  const p = e.md.block.ruler.getRules("blockquote"), g = e.push("table_open", "table", 1), b = [t, 0];
  g.map = b;
  const w = e.push("thead_open", "thead", 1);
  w.map = [t, t + 1];
  const y = e.push("tr_open", "tr", 1);
  y.map = [t, t + 1];
  for (let E = 0; E < s.length; E++) {
    const O = e.push("th_open", "th", 1);
    l[E] && (O.attrs = [["style", "text-align:" + l[E]]]);
    const M = e.push("inline", "", 0);
    M.content = s[E].trim(), M.children = [], e.push("th_close", "th", -1);
  }
  e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
  let v, _ = 0;
  for (i = t + 2; i < n && !(e.sCount[i] < e.blkIndent); i++) {
    let E = !1;
    for (let M = 0, L = p.length; M < L; M++)
      if (p[M](e, i, n, !0)) {
        E = !0;
        break;
      }
    if (E || (u = fm(e, i).trim(), !u) || e.sCount[i] - e.blkIndent >= 4 || (s = o7(u), s.length && s[0] === "" && s.shift(), s.length && s[s.length - 1] === "" && s.pop(), _ += d - s.length, _ > BW))
      break;
    if (i === t + 2) {
      const M = e.push("tbody_open", "tbody", 1);
      M.map = v = [t + 2, 0];
    }
    const O = e.push("tr_open", "tr", 1);
    O.map = [i, i + 1];
    for (let M = 0; M < d; M++) {
      const L = e.push("td_open", "td", 1);
      l[M] && (L.attrs = [["style", "text-align:" + l[M]]]);
      const Z = e.push("inline", "", 0);
      Z.content = s[M] ? s[M].trim() : "", Z.children = [], e.push("td_close", "td", -1);
    }
    e.push("tr_close", "tr", -1);
  }
  return v && (e.push("tbody_close", "tbody", -1), v[1] = i), e.push("table_close", "table", -1), b[1] = i, e.parentType = f, e.line = i, !0;
}
function HW(e, t, n) {
  if (e.sCount[t] - e.blkIndent < 4)
    return !1;
  let r = t + 1, i = r;
  for (; r < n; ) {
    if (e.isEmpty(r)) {
      r++;
      continue;
    }
    if (e.sCount[r] - e.blkIndent >= 4) {
      r++, i = r;
      continue;
    }
    break;
  }
  e.line = i;
  const a = e.push("code_block", "code", 0);
  return a.content = e.getLines(t, i, 4 + e.blkIndent, !1) + `
`, a.map = [t, e.line], !0;
}
function zW(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || i + 3 > a)
    return !1;
  const o = e.src.charCodeAt(i);
  if (o !== 126 && o !== 96)
    return !1;
  let c = i;
  i = e.skipChars(i, o);
  let u = i - c;
  if (u < 3)
    return !1;
  const s = e.src.slice(c, i), l = e.src.slice(i, a);
  if (o === 96 && l.indexOf(String.fromCharCode(o)) >= 0)
    return !1;
  if (r)
    return !0;
  let d = t, f = !1;
  for (; d++, !(d >= n || (i = c = e.bMarks[d] + e.tShift[d], a = e.eMarks[d], i < a && e.sCount[d] < e.blkIndent)); )
    if (e.src.charCodeAt(i) === o && !(e.sCount[d] - e.blkIndent >= 4) && (i = e.skipChars(i, o), !(i - c < u) && (i = e.skipSpaces(i), !(i < a)))) {
      f = !0;
      break;
    }
  u = e.sCount[t], e.line = d + (f ? 1 : 0);
  const p = e.push("fence", "code", 0);
  return p.info = l, p.content = e.getLines(t + 1, d, u, !0), p.markup = s, p.map = [t, e.line], !0;
}
function VW(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  const o = e.lineMax;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 62)
    return !1;
  if (r)
    return !0;
  const c = [], u = [], s = [], l = [], d = e.md.block.ruler.getRules("blockquote"), f = e.parentType;
  e.parentType = "blockquote";
  let p = !1, g;
  for (g = t; g < n; g++) {
    const _ = e.sCount[g] < e.blkIndent;
    if (i = e.bMarks[g] + e.tShift[g], a = e.eMarks[g], i >= a)
      break;
    if (e.src.charCodeAt(i++) === 62 && !_) {
      let O = e.sCount[g] + 1, M, L;
      e.src.charCodeAt(i) === 32 ? (i++, O++, L = !1, M = !0) : e.src.charCodeAt(i) === 9 ? (M = !0, (e.bsCount[g] + O) % 4 === 3 ? (i++, O++, L = !1) : L = !0) : M = !1;
      let Z = O;
      for (c.push(e.bMarks[g]), e.bMarks[g] = i; i < a; ) {
        const Q = e.src.charCodeAt(i);
        if (Gn(Q))
          Q === 9 ? Z += 4 - (Z + e.bsCount[g] + (L ? 1 : 0)) % 4 : Z++;
        else
          break;
        i++;
      }
      p = i >= a, u.push(e.bsCount[g]), e.bsCount[g] = e.sCount[g] + 1 + (M ? 1 : 0), s.push(e.sCount[g]), e.sCount[g] = Z - O, l.push(e.tShift[g]), e.tShift[g] = i - e.bMarks[g];
      continue;
    }
    if (p)
      break;
    let E = !1;
    for (let O = 0, M = d.length; O < M; O++)
      if (d[O](e, g, n, !0)) {
        E = !0;
        break;
      }
    if (E) {
      e.lineMax = g, e.blkIndent !== 0 && (c.push(e.bMarks[g]), u.push(e.bsCount[g]), l.push(e.tShift[g]), s.push(e.sCount[g]), e.sCount[g] -= e.blkIndent);
      break;
    }
    c.push(e.bMarks[g]), u.push(e.bsCount[g]), l.push(e.tShift[g]), s.push(e.sCount[g]), e.sCount[g] = -1;
  }
  const b = e.blkIndent;
  e.blkIndent = 0;
  const w = e.push("blockquote_open", "blockquote", 1);
  w.markup = ">";
  const y = [t, 0];
  w.map = y, e.md.block.tokenize(e, t, g);
  const v = e.push("blockquote_close", "blockquote", -1);
  v.markup = ">", e.lineMax = o, e.parentType = f, y[1] = e.line;
  for (let _ = 0; _ < l.length; _++)
    e.bMarks[_ + t] = c[_], e.tShift[_ + t] = l[_], e.sCount[_ + t] = s[_], e.bsCount[_ + t] = u[_];
  return e.blkIndent = b, !0;
}
function GW(e, t, n, r) {
  const i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let a = e.bMarks[t] + e.tShift[t];
  const o = e.src.charCodeAt(a++);
  if (o !== 42 && o !== 45 && o !== 95)
    return !1;
  let c = 1;
  for (; a < i; ) {
    const s = e.src.charCodeAt(a++);
    if (s !== o && !Gn(s))
      return !1;
    s === o && c++;
  }
  if (c < 3)
    return !1;
  if (r)
    return !0;
  e.line = t + 1;
  const u = e.push("hr", "hr", 0);
  return u.map = [t, e.line], u.markup = Array(c + 1).join(String.fromCharCode(o)), !0;
}
function s7(e, t) {
  const n = e.eMarks[t];
  let r = e.bMarks[t] + e.tShift[t];
  const i = e.src.charCodeAt(r++);
  if (i !== 42 && i !== 45 && i !== 43)
    return -1;
  if (r < n) {
    const a = e.src.charCodeAt(r);
    if (!Gn(a))
      return -1;
  }
  return r;
}
function u7(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  let i = n;
  if (i + 1 >= r)
    return -1;
  let a = e.src.charCodeAt(i++);
  if (a < 48 || a > 57)
    return -1;
  for (; ; ) {
    if (i >= r)
      return -1;
    if (a = e.src.charCodeAt(i++), a >= 48 && a <= 57) {
      if (i - n >= 10)
        return -1;
      continue;
    }
    if (a === 41 || a === 46)
      break;
    return -1;
  }
  return i < r && (a = e.src.charCodeAt(i), !Gn(a)) ? -1 : i;
}
function WW(e, t) {
  const n = e.level + 2;
  for (let r = t + 2, i = e.tokens.length - 2; r < i; r++)
    e.tokens[r].level === n && e.tokens[r].type === "paragraph_open" && (e.tokens[r + 2].hidden = !0, e.tokens[r].hidden = !0, r += 2);
}
function KW(e, t, n, r) {
  let i, a, o, c, u = t, s = !0;
  if (e.sCount[u] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[u] - e.listIndent >= 4 && e.sCount[u] < e.blkIndent)
    return !1;
  let l = !1;
  r && e.parentType === "paragraph" && e.sCount[u] >= e.blkIndent && (l = !0);
  let d, f, p;
  if ((p = u7(e, u)) >= 0) {
    if (d = !0, o = e.bMarks[u] + e.tShift[u], f = Number(e.src.slice(o, p - 1)), l && f !== 1) return !1;
  } else if ((p = s7(e, u)) >= 0)
    d = !1;
  else
    return !1;
  if (l && e.skipSpaces(p) >= e.eMarks[u])
    return !1;
  if (r)
    return !0;
  const g = e.src.charCodeAt(p - 1), b = e.tokens.length;
  d ? (c = e.push("ordered_list_open", "ol", 1), f !== 1 && (c.attrs = [["start", f]])) : c = e.push("bullet_list_open", "ul", 1);
  const w = [u, 0];
  c.map = w, c.markup = String.fromCharCode(g);
  let y = !1;
  const v = e.md.block.ruler.getRules("list"), _ = e.parentType;
  for (e.parentType = "list"; u < n; ) {
    a = p, i = e.eMarks[u];
    const E = e.sCount[u] + p - (e.bMarks[u] + e.tShift[u]);
    let O = E;
    for (; a < i; ) {
      const J = e.src.charCodeAt(a);
      if (J === 9)
        O += 4 - (O + e.bsCount[u]) % 4;
      else if (J === 32)
        O++;
      else
        break;
      a++;
    }
    const M = a;
    let L;
    M >= i ? L = 1 : L = O - E, L > 4 && (L = 1);
    const Z = E + L;
    c = e.push("list_item_open", "li", 1), c.markup = String.fromCharCode(g);
    const Q = [u, 0];
    c.map = Q, d && (c.info = e.src.slice(o, p - 1));
    const ae = e.tight, re = e.tShift[u], X = e.sCount[u], de = e.listIndent;
    if (e.listIndent = e.blkIndent, e.blkIndent = Z, e.tight = !0, e.tShift[u] = M - e.bMarks[u], e.sCount[u] = O, M >= i && e.isEmpty(u + 1) ? e.line = Math.min(e.line + 2, n) : e.md.block.tokenize(e, u, n, !0), (!e.tight || y) && (s = !1), y = e.line - u > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = de, e.tShift[u] = re, e.sCount[u] = X, e.tight = ae, c = e.push("list_item_close", "li", -1), c.markup = String.fromCharCode(g), u = e.line, Q[1] = u, u >= n || e.sCount[u] < e.blkIndent || e.sCount[u] - e.blkIndent >= 4)
      break;
    let Ce = !1;
    for (let J = 0, ne = v.length; J < ne; J++)
      if (v[J](e, u, n, !0)) {
        Ce = !0;
        break;
      }
    if (Ce)
      break;
    if (d) {
      if (p = u7(e, u), p < 0)
        break;
      o = e.bMarks[u] + e.tShift[u];
    } else if (p = s7(e, u), p < 0)
      break;
    if (g !== e.src.charCodeAt(p - 1))
      break;
  }
  return d ? c = e.push("ordered_list_close", "ol", -1) : c = e.push("bullet_list_close", "ul", -1), c.markup = String.fromCharCode(g), w[1] = u, e.line = u, e.parentType = _, s && WW(e, b), !0;
}
function ZW(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t], o = t + 1;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 91)
    return !1;
  function c(v) {
    const _ = e.lineMax;
    if (v >= _ || e.isEmpty(v))
      return null;
    let E = !1;
    if (e.sCount[v] - e.blkIndent > 3 && (E = !0), e.sCount[v] < 0 && (E = !0), !E) {
      const L = e.md.block.ruler.getRules("reference"), Z = e.parentType;
      e.parentType = "reference";
      let Q = !1;
      for (let ae = 0, re = L.length; ae < re; ae++)
        if (L[ae](e, v, _, !0)) {
          Q = !0;
          break;
        }
      if (e.parentType = Z, Q)
        return null;
    }
    const O = e.bMarks[v] + e.tShift[v], M = e.eMarks[v];
    return e.src.slice(O, M + 1);
  }
  let u = e.src.slice(i, a + 1);
  a = u.length;
  let s = -1;
  for (i = 1; i < a; i++) {
    const v = u.charCodeAt(i);
    if (v === 91)
      return !1;
    if (v === 93) {
      s = i;
      break;
    } else if (v === 10) {
      const _ = c(o);
      _ !== null && (u += _, a = u.length, o++);
    } else if (v === 92 && (i++, i < a && u.charCodeAt(i) === 10)) {
      const _ = c(o);
      _ !== null && (u += _, a = u.length, o++);
    }
  }
  if (s < 0 || u.charCodeAt(s + 1) !== 58)
    return !1;
  for (i = s + 2; i < a; i++) {
    const v = u.charCodeAt(i);
    if (v === 10) {
      const _ = c(o);
      _ !== null && (u += _, a = u.length, o++);
    } else if (!Gn(v)) break;
  }
  const l = e.md.helpers.parseLinkDestination(u, i, a);
  if (!l.ok)
    return !1;
  const d = e.md.normalizeLink(l.str);
  if (!e.md.validateLink(d))
    return !1;
  i = l.pos;
  const f = i, p = o, g = i;
  for (; i < a; i++) {
    const v = u.charCodeAt(i);
    if (v === 10) {
      const _ = c(o);
      _ !== null && (u += _, a = u.length, o++);
    } else if (!Gn(v)) break;
  }
  let b = e.md.helpers.parseLinkTitle(u, i, a);
  for (; b.can_continue; ) {
    const v = c(o);
    if (v === null) break;
    u += v, i = a, a = u.length, o++, b = e.md.helpers.parseLinkTitle(u, i, a, b);
  }
  let w;
  for (i < a && g !== i && b.ok ? (w = b.str, i = b.pos) : (w = "", i = f, o = p); i < a; ) {
    const v = u.charCodeAt(i);
    if (!Gn(v))
      break;
    i++;
  }
  if (i < a && u.charCodeAt(i) !== 10 && w)
    for (w = "", i = f, o = p; i < a; ) {
      const v = u.charCodeAt(i);
      if (!Gn(v))
        break;
      i++;
    }
  if (i < a && u.charCodeAt(i) !== 10)
    return !1;
  const y = X0(u.slice(1, s));
  return y ? (r || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[y] > "u" && (e.env.references[y] = { title: w, href: d }), e.line = o), !0) : !1;
}
const YW = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], JW = "[a-zA-Z_:][a-zA-Z0-9:._-]*", QW = "[^\"'=<>`\\x00-\\x20]+", XW = "'[^']*'", eK = '"[^"]*"', tK = "(?:" + QW + "|" + XW + "|" + eK + ")", rK = "(?:\\s+" + JW + "(?:\\s*=\\s*" + tK + ")?)", GE = "<[A-Za-z][A-Za-z0-9\\-]*" + rK + "*\\s*\\/?>", WE = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", nK = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", iK = "<[?][\\s\\S]*?[?]>", aK = "<![A-Za-z][^>]*>", oK = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", sK = new RegExp("^(?:" + GE + "|" + WE + "|" + nK + "|" + iK + "|" + aK + "|" + oK + ")"), uK = new RegExp("^(?:" + GE + "|" + WE + ")"), Ju = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + YW.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(uK.source + "\\s*$"), /^$/, !1]
];
function cK(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(i) !== 60)
    return !1;
  let o = e.src.slice(i, a), c = 0;
  for (; c < Ju.length && !Ju[c][0].test(o); c++)
    ;
  if (c === Ju.length)
    return !1;
  if (r)
    return Ju[c][2];
  let u = t + 1;
  if (!Ju[c][1].test(o)) {
    for (; u < n && !(e.sCount[u] < e.blkIndent); u++)
      if (i = e.bMarks[u] + e.tShift[u], a = e.eMarks[u], o = e.src.slice(i, a), Ju[c][1].test(o)) {
        o.length !== 0 && u++;
        break;
      }
  }
  e.line = u;
  const s = e.push("html_block", "", 0);
  return s.map = [t, u], s.content = e.getLines(t, u, e.blkIndent, !0), !0;
}
function lK(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let o = e.src.charCodeAt(i);
  if (o !== 35 || i >= a)
    return !1;
  let c = 1;
  for (o = e.src.charCodeAt(++i); o === 35 && i < a && c <= 6; )
    c++, o = e.src.charCodeAt(++i);
  if (c > 6 || i < a && !Gn(o))
    return !1;
  if (r)
    return !0;
  a = e.skipSpacesBack(a, i);
  const u = e.skipCharsBack(a, 35, i);
  u > i && Gn(e.src.charCodeAt(u - 1)) && (a = u), e.line = t + 1;
  const s = e.push("heading_open", "h" + String(c), 1);
  s.markup = "########".slice(0, c), s.map = [t, e.line];
  const l = e.push("inline", "", 0);
  l.content = e.src.slice(i, a).trim(), l.map = [t, e.line], l.children = [];
  const d = e.push("heading_close", "h" + String(c), -1);
  return d.markup = "########".slice(0, c), !0;
}
function fK(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  const i = e.parentType;
  e.parentType = "paragraph";
  let a = 0, o, c = t + 1;
  for (; c < n && !e.isEmpty(c); c++) {
    if (e.sCount[c] - e.blkIndent > 3)
      continue;
    if (e.sCount[c] >= e.blkIndent) {
      let p = e.bMarks[c] + e.tShift[c];
      const g = e.eMarks[c];
      if (p < g && (o = e.src.charCodeAt(p), (o === 45 || o === 61) && (p = e.skipChars(p, o), p = e.skipSpaces(p), p >= g))) {
        a = o === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[c] < 0)
      continue;
    let f = !1;
    for (let p = 0, g = r.length; p < g; p++)
      if (r[p](e, c, n, !0)) {
        f = !0;
        break;
      }
    if (f)
      break;
  }
  if (!a)
    return !1;
  const u = e.getLines(t, c, e.blkIndent, !1).trim();
  e.line = c + 1;
  const s = e.push("heading_open", "h" + String(a), 1);
  s.markup = String.fromCharCode(o), s.map = [t, e.line];
  const l = e.push("inline", "", 0);
  l.content = u, l.map = [t, e.line - 1], l.children = [];
  const d = e.push("heading_close", "h" + String(a), -1);
  return d.markup = String.fromCharCode(o), e.parentType = i, !0;
}
function pK(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph"), i = e.parentType;
  let a = t + 1;
  for (e.parentType = "paragraph"; a < n && !e.isEmpty(a); a++) {
    if (e.sCount[a] - e.blkIndent > 3 || e.sCount[a] < 0)
      continue;
    let s = !1;
    for (let l = 0, d = r.length; l < d; l++)
      if (r[l](e, a, n, !0)) {
        s = !0;
        break;
      }
    if (s)
      break;
  }
  const o = e.getLines(t, a, e.blkIndent, !1).trim();
  e.line = a;
  const c = e.push("paragraph_open", "p", 1);
  c.map = [t, e.line];
  const u = e.push("inline", "", 0);
  return u.content = o, u.map = [t, e.line], u.children = [], e.push("paragraph_close", "p", -1), e.parentType = i, !0;
}
const Ad = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", UW, ["paragraph", "reference"]],
  ["code", HW],
  ["fence", zW, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", VW, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", GW, ["paragraph", "reference", "blockquote", "list"]],
  ["list", KW, ["paragraph", "reference", "blockquote"]],
  ["reference", ZW],
  ["html_block", cK, ["paragraph", "reference", "blockquote"]],
  ["heading", lK, ["paragraph", "reference", "blockquote"]],
  ["lheading", fK],
  ["paragraph", pK]
];
function e1() {
  this.ruler = new ra();
  for (let e = 0; e < Ad.length; e++)
    this.ruler.push(Ad[e][0], Ad[e][1], { alt: (Ad[e][2] || []).slice() });
}
e1.prototype.tokenize = function(e, t, n) {
  const r = this.ruler.getRules(""), i = r.length, a = e.md.options.maxNesting;
  let o = t, c = !1;
  for (; o < n && (e.line = o = e.skipEmptyLines(o), !(o >= n || e.sCount[o] < e.blkIndent)); ) {
    if (e.level >= a) {
      e.line = n;
      break;
    }
    const u = e.line;
    let s = !1;
    for (let l = 0; l < i; l++)
      if (s = r[l](e, o, n, !1), s) {
        if (u >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!s) throw new Error("none of the block rules matched");
    e.tight = !c, e.isEmpty(e.line - 1) && (c = !0), o = e.line, o < n && e.isEmpty(o) && (c = !0, o++, e.line = o);
  }
};
e1.prototype.parse = function(e, t, n, r) {
  if (!e)
    return;
  const i = new this.State(e, t, n, r);
  this.tokenize(i, i.line, i.lineMax);
};
e1.prototype.State = Ao;
function Qf(e, t, n, r) {
  this.src = e, this.env = n, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
Qf.prototype.pushPending = function() {
  const e = new io("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
Qf.prototype.push = function(e, t, n) {
  this.pending && this.pushPending();
  const r = new io(e, t, n);
  let i = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], i = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(i), r;
};
Qf.prototype.scanDelims = function(e, t) {
  const n = this.posMax, r = this.src.charCodeAt(e), i = e > 0 ? this.src.charCodeAt(e - 1) : 32;
  let a = e;
  for (; a < n && this.src.charCodeAt(a) === r; )
    a++;
  const o = a - e, c = a < n ? this.src.charCodeAt(a) : 32, u = Rf(i) || Pf(String.fromCharCode(i)), s = Rf(c) || Pf(String.fromCharCode(c)), l = Tf(i), d = Tf(c), f = !d && (!s || l || u), p = !l && (!u || d || s);
  return { can_open: f && (t || !p || u), can_close: p && (t || !f || s), length: o };
};
Qf.prototype.Token = io;
function dK(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function hK(e, t) {
  let n = e.pos;
  for (; n < e.posMax && !dK(e.src.charCodeAt(n)); )
    n++;
  return n === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
}
const mK = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function gK(e, t) {
  if (!e.md.options.linkify || e.linkLevel > 0) return !1;
  const n = e.pos, r = e.posMax;
  if (n + 3 > r || e.src.charCodeAt(n) !== 58 || e.src.charCodeAt(n + 1) !== 47 || e.src.charCodeAt(n + 2) !== 47) return !1;
  const i = e.pending.match(mK);
  if (!i) return !1;
  const a = i[1], o = e.md.linkify.matchAtStart(e.src.slice(n - a.length));
  if (!o) return !1;
  let c = o.url;
  if (c.length <= a.length) return !1;
  c = c.replace(/\*+$/, "");
  const u = e.md.normalizeLink(c);
  if (!e.md.validateLink(u)) return !1;
  if (!t) {
    e.pending = e.pending.slice(0, -a.length);
    const s = e.push("link_open", "a", 1);
    s.attrs = [["href", u]], s.markup = "linkify", s.info = "auto";
    const l = e.push("text", "", 0);
    l.content = e.md.normalizeLinkText(c);
    const d = e.push("link_close", "a", -1);
    d.markup = "linkify", d.info = "auto";
  }
  return e.pos += c.length - a.length, !0;
}
function vK(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 10)
    return !1;
  const r = e.pending.length - 1, i = e.posMax;
  if (!t)
    if (r >= 0 && e.pending.charCodeAt(r) === 32)
      if (r >= 1 && e.pending.charCodeAt(r - 1) === 32) {
        let a = r - 1;
        for (; a >= 1 && e.pending.charCodeAt(a - 1) === 32; ) a--;
        e.pending = e.pending.slice(0, a), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (n++; n < i && Gn(e.src.charCodeAt(n)); )
    n++;
  return e.pos = n, !0;
}
const ug = [];
for (let e = 0; e < 256; e++)
  ug.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  ug[e.charCodeAt(0)] = 1;
});
function yK(e, t) {
  let n = e.pos;
  const r = e.posMax;
  if (e.src.charCodeAt(n) !== 92 || (n++, n >= r)) return !1;
  let i = e.src.charCodeAt(n);
  if (i === 10) {
    for (t || e.push("hardbreak", "br", 0), n++; n < r && (i = e.src.charCodeAt(n), !!Gn(i)); )
      n++;
    return e.pos = n, !0;
  }
  let a = e.src[n];
  if (i >= 55296 && i <= 56319 && n + 1 < r) {
    const c = e.src.charCodeAt(n + 1);
    c >= 56320 && c <= 57343 && (a += e.src[n + 1], n++);
  }
  const o = "\\" + a;
  if (!t) {
    const c = e.push("text_special", "", 0);
    i < 256 && ug[i] !== 0 ? c.content = a : c.content = o, c.markup = o, c.info = "escape";
  }
  return e.pos = n + 1, !0;
}
function bK(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 96)
    return !1;
  const i = n;
  n++;
  const a = e.posMax;
  for (; n < a && e.src.charCodeAt(n) === 96; )
    n++;
  const o = e.src.slice(i, n), c = o.length;
  if (e.backticksScanned && (e.backticks[c] || 0) <= i)
    return t || (e.pending += o), e.pos += c, !0;
  let u = n, s;
  for (; (s = e.src.indexOf("`", u)) !== -1; ) {
    for (u = s + 1; u < a && e.src.charCodeAt(u) === 96; )
      u++;
    const l = u - s;
    if (l === c) {
      if (!t) {
        const d = e.push("code_inline", "code", 0);
        d.markup = o, d.content = e.src.slice(n, s).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return e.pos = u, !0;
    }
    e.backticks[l] = s;
  }
  return e.backticksScanned = !0, t || (e.pending += o), e.pos += c, !0;
}
function xK(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 126)
    return !1;
  const i = e.scanDelims(e.pos, !0);
  let a = i.length;
  const o = String.fromCharCode(r);
  if (a < 2)
    return !1;
  let c;
  a % 2 && (c = e.push("text", "", 0), c.content = o, a--);
  for (let u = 0; u < a; u += 2)
    c = e.push("text", "", 0), c.content = o + o, e.delimiters.push({
      marker: r,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: i.can_open,
      close: i.can_close
    });
  return e.pos += i.length, !0;
}
function c7(e, t) {
  let n;
  const r = [], i = t.length;
  for (let a = 0; a < i; a++) {
    const o = t[a];
    if (o.marker !== 126 || o.end === -1)
      continue;
    const c = t[o.end];
    n = e.tokens[o.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = e.tokens[c.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", e.tokens[c.token - 1].type === "text" && e.tokens[c.token - 1].content === "~" && r.push(c.token - 1);
  }
  for (; r.length; ) {
    const a = r.pop();
    let o = a + 1;
    for (; o < e.tokens.length && e.tokens[o].type === "s_close"; )
      o++;
    o--, a !== o && (n = e.tokens[o], e.tokens[o] = e.tokens[a], e.tokens[a] = n);
  }
}
function _K(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  c7(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && c7(e, t[r].delimiters);
}
const KE = {
  tokenize: xK,
  postProcess: _K
};
function wK(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 95 && r !== 42)
    return !1;
  const i = e.scanDelims(e.pos, r === 42);
  for (let a = 0; a < i.length; a++) {
    const o = e.push("text", "", 0);
    o.content = String.fromCharCode(r), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: r,
      // Total length of these series of delimiters.
      //
      length: i.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: i.can_open,
      close: i.can_close
    });
  }
  return e.pos += i.length, !0;
}
function l7(e, t) {
  const n = t.length;
  for (let r = n - 1; r >= 0; r--) {
    const i = t[r];
    if (i.marker !== 95 && i.marker !== 42 || i.end === -1)
      continue;
    const a = t[i.end], o = r > 0 && t[r - 1].end === i.end + 1 && // check that first two markers match and adjacent
    t[r - 1].marker === i.marker && t[r - 1].token === i.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[i.end + 1].token === a.token + 1, c = String.fromCharCode(i.marker), u = e.tokens[i.token];
    u.type = o ? "strong_open" : "em_open", u.tag = o ? "strong" : "em", u.nesting = 1, u.markup = o ? c + c : c, u.content = "";
    const s = e.tokens[a.token];
    s.type = o ? "strong_close" : "em_close", s.tag = o ? "strong" : "em", s.nesting = -1, s.markup = o ? c + c : c, s.content = "", o && (e.tokens[t[r - 1].token].content = "", e.tokens[t[i.end + 1].token].content = "", r--);
  }
}
function SK(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  l7(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && l7(e, t[r].delimiters);
}
const ZE = {
  tokenize: wK,
  postProcess: SK
};
function CK(e, t) {
  let n, r, i, a, o = "", c = "", u = e.pos, s = !0;
  if (e.src.charCodeAt(e.pos) !== 91)
    return !1;
  const l = e.pos, d = e.posMax, f = e.pos + 1, p = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (p < 0)
    return !1;
  let g = p + 1;
  if (g < d && e.src.charCodeAt(g) === 40) {
    for (s = !1, g++; g < d && (n = e.src.charCodeAt(g), !(!Gn(n) && n !== 10)); g++)
      ;
    if (g >= d)
      return !1;
    if (u = g, i = e.md.helpers.parseLinkDestination(e.src, g, e.posMax), i.ok) {
      for (o = e.md.normalizeLink(i.str), e.md.validateLink(o) ? g = i.pos : o = "", u = g; g < d && (n = e.src.charCodeAt(g), !(!Gn(n) && n !== 10)); g++)
        ;
      if (i = e.md.helpers.parseLinkTitle(e.src, g, e.posMax), g < d && u !== g && i.ok)
        for (c = i.str, g = i.pos; g < d && (n = e.src.charCodeAt(g), !(!Gn(n) && n !== 10)); g++)
          ;
    }
    (g >= d || e.src.charCodeAt(g) !== 41) && (s = !0), g++;
  }
  if (s) {
    if (typeof e.env.references > "u")
      return !1;
    if (g < d && e.src.charCodeAt(g) === 91 ? (u = g + 1, g = e.md.helpers.parseLinkLabel(e, g), g >= 0 ? r = e.src.slice(u, g++) : g = p + 1) : g = p + 1, r || (r = e.src.slice(f, p)), a = e.env.references[X0(r)], !a)
      return e.pos = l, !1;
    o = a.href, c = a.title;
  }
  if (!t) {
    e.pos = f, e.posMax = p;
    const b = e.push("link_open", "a", 1), w = [["href", o]];
    b.attrs = w, c && w.push(["title", c]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
  }
  return e.pos = g, e.posMax = d, !0;
}
function kK(e, t) {
  let n, r, i, a, o, c, u, s, l = "";
  const d = e.pos, f = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91)
    return !1;
  const p = e.pos + 2, g = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (g < 0)
    return !1;
  if (a = g + 1, a < f && e.src.charCodeAt(a) === 40) {
    for (a++; a < f && (n = e.src.charCodeAt(a), !(!Gn(n) && n !== 10)); a++)
      ;
    if (a >= f)
      return !1;
    for (s = a, c = e.md.helpers.parseLinkDestination(e.src, a, e.posMax), c.ok && (l = e.md.normalizeLink(c.str), e.md.validateLink(l) ? a = c.pos : l = ""), s = a; a < f && (n = e.src.charCodeAt(a), !(!Gn(n) && n !== 10)); a++)
      ;
    if (c = e.md.helpers.parseLinkTitle(e.src, a, e.posMax), a < f && s !== a && c.ok)
      for (u = c.str, a = c.pos; a < f && (n = e.src.charCodeAt(a), !(!Gn(n) && n !== 10)); a++)
        ;
    else
      u = "";
    if (a >= f || e.src.charCodeAt(a) !== 41)
      return e.pos = d, !1;
    a++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (a < f && e.src.charCodeAt(a) === 91 ? (s = a + 1, a = e.md.helpers.parseLinkLabel(e, a), a >= 0 ? i = e.src.slice(s, a++) : a = g + 1) : a = g + 1, i || (i = e.src.slice(p, g)), o = e.env.references[X0(i)], !o)
      return e.pos = d, !1;
    l = o.href, u = o.title;
  }
  if (!t) {
    r = e.src.slice(p, g);
    const b = [];
    e.md.inline.parse(
      r,
      e.md,
      e.env,
      b
    );
    const w = e.push("image", "img", 0), y = [["src", l], ["alt", ""]];
    w.attrs = y, w.children = b, w.content = r, u && y.push(["title", u]);
  }
  return e.pos = a, e.posMax = f, !0;
}
const AK = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, EK = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function OK(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 60)
    return !1;
  const r = e.pos, i = e.posMax;
  for (; ; ) {
    if (++n >= i) return !1;
    const o = e.src.charCodeAt(n);
    if (o === 60) return !1;
    if (o === 62) break;
  }
  const a = e.src.slice(r + 1, n);
  if (EK.test(a)) {
    const o = e.md.normalizeLink(a);
    if (!e.md.validateLink(o))
      return !1;
    if (!t) {
      const c = e.push("link_open", "a", 1);
      c.attrs = [["href", o]], c.markup = "autolink", c.info = "auto";
      const u = e.push("text", "", 0);
      u.content = e.md.normalizeLinkText(a);
      const s = e.push("link_close", "a", -1);
      s.markup = "autolink", s.info = "auto";
    }
    return e.pos += a.length + 2, !0;
  }
  if (AK.test(a)) {
    const o = e.md.normalizeLink("mailto:" + a);
    if (!e.md.validateLink(o))
      return !1;
    if (!t) {
      const c = e.push("link_open", "a", 1);
      c.attrs = [["href", o]], c.markup = "autolink", c.info = "auto";
      const u = e.push("text", "", 0);
      u.content = e.md.normalizeLinkText(a);
      const s = e.push("link_close", "a", -1);
      s.markup = "autolink", s.info = "auto";
    }
    return e.pos += a.length + 2, !0;
  }
  return !1;
}
function TK(e) {
  return /^<a[>\s]/i.test(e);
}
function PK(e) {
  return /^<\/a\s*>/i.test(e);
}
function RK(e) {
  const t = e | 32;
  return t >= 97 && t <= 122;
}
function IK(e, t) {
  if (!e.md.options.html)
    return !1;
  const n = e.posMax, r = e.pos;
  if (e.src.charCodeAt(r) !== 60 || r + 2 >= n)
    return !1;
  const i = e.src.charCodeAt(r + 1);
  if (i !== 33 && i !== 63 && i !== 47 && !RK(i))
    return !1;
  const a = e.src.slice(r).match(sK);
  if (!a)
    return !1;
  if (!t) {
    const o = e.push("html_inline", "", 0);
    o.content = a[0], TK(o.content) && e.linkLevel++, PK(o.content) && e.linkLevel--;
  }
  return e.pos += a[0].length, !0;
}
const jK = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, qK = /^&([a-z][a-z0-9]{1,31});/i;
function DK(e, t) {
  const n = e.pos, r = e.posMax;
  if (e.src.charCodeAt(n) !== 38 || n + 1 >= r) return !1;
  if (e.src.charCodeAt(n + 1) === 35) {
    const a = e.src.slice(n).match(jK);
    if (a) {
      if (!t) {
        const o = a[1][0].toLowerCase() === "x" ? parseInt(a[1].slice(1), 16) : parseInt(a[1], 10), c = e.push("text_special", "", 0);
        c.content = og(o) ? w0(o) : w0(65533), c.markup = a[0], c.info = "entity";
      }
      return e.pos += a[0].length, !0;
    }
  } else {
    const a = e.src.slice(n).match(qK);
    if (a) {
      const o = BE(a[0]);
      if (o !== a[0]) {
        if (!t) {
          const c = e.push("text_special", "", 0);
          c.content = o, c.markup = a[0], c.info = "entity";
        }
        return e.pos += a[0].length, !0;
      }
    }
  }
  return !1;
}
function f7(e) {
  const t = {}, n = e.length;
  if (!n) return;
  let r = 0, i = -2;
  const a = [];
  for (let o = 0; o < n; o++) {
    const c = e[o];
    if (a.push(0), (e[r].marker !== c.marker || i !== c.token - 1) && (r = o), i = c.token, c.length = c.length || 0, !c.close) continue;
    t.hasOwnProperty(c.marker) || (t[c.marker] = [-1, -1, -1, -1, -1, -1]);
    const u = t[c.marker][(c.open ? 3 : 0) + c.length % 3];
    let s = r - a[r] - 1, l = s;
    for (; s > u; s -= a[s] + 1) {
      const d = e[s];
      if (d.marker === c.marker && d.open && d.end < 0) {
        let f = !1;
        if ((d.close || c.open) && (d.length + c.length) % 3 === 0 && (d.length % 3 !== 0 || c.length % 3 !== 0) && (f = !0), !f) {
          const p = s > 0 && !e[s - 1].open ? a[s - 1] + 1 : 0;
          a[o] = o - s + p, a[s] = p, c.open = !1, d.end = o, d.close = !1, l = -1, i = -2;
          break;
        }
      }
    }
    l !== -1 && (t[c.marker][(c.open ? 3 : 0) + (c.length || 0) % 3] = l);
  }
}
function $K(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  f7(e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && f7(t[r].delimiters);
}
function LK(e) {
  let t, n, r = 0;
  const i = e.tokens, a = e.tokens.length;
  for (t = n = 0; t < a; t++)
    i[t].nesting < 0 && r--, i[t].level = r, i[t].nesting > 0 && r++, i[t].type === "text" && t + 1 < a && i[t + 1].type === "text" ? i[t + 1].content = i[t].content + i[t + 1].content : (t !== n && (i[n] = i[t]), n++);
  t !== n && (i.length = n);
}
const pm = [
  ["text", hK],
  ["linkify", gK],
  ["newline", vK],
  ["escape", yK],
  ["backticks", bK],
  ["strikethrough", KE.tokenize],
  ["emphasis", ZE.tokenize],
  ["link", CK],
  ["image", kK],
  ["autolink", OK],
  ["html_inline", IK],
  ["entity", DK]
], dm = [
  ["balance_pairs", $K],
  ["strikethrough", KE.postProcess],
  ["emphasis", ZE.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", LK]
];
function Xf() {
  this.ruler = new ra();
  for (let e = 0; e < pm.length; e++)
    this.ruler.push(pm[e][0], pm[e][1]);
  this.ruler2 = new ra();
  for (let e = 0; e < dm.length; e++)
    this.ruler2.push(dm[e][0], dm[e][1]);
}
Xf.prototype.skipToken = function(e) {
  const t = e.pos, n = this.ruler.getRules(""), r = n.length, i = e.md.options.maxNesting, a = e.cache;
  if (typeof a[t] < "u") {
    e.pos = a[t];
    return;
  }
  let o = !1;
  if (e.level < i) {
    for (let c = 0; c < r; c++)
      if (e.level++, o = n[c](e, !0), e.level--, o) {
        if (t >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  o || e.pos++, a[t] = e.pos;
};
Xf.prototype.tokenize = function(e) {
  const t = this.ruler.getRules(""), n = t.length, r = e.posMax, i = e.md.options.maxNesting;
  for (; e.pos < r; ) {
    const a = e.pos;
    let o = !1;
    if (e.level < i) {
      for (let c = 0; c < n; c++)
        if (o = t[c](e, !1), o) {
          if (a >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (o) {
      if (e.pos >= r)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
Xf.prototype.parse = function(e, t, n, r) {
  const i = new this.State(e, t, n, r);
  this.tokenize(i);
  const a = this.ruler2.getRules(""), o = a.length;
  for (let c = 0; c < o; c++)
    a[c](i);
};
Xf.prototype.State = Qf;
function NK(e) {
  const t = {};
  e = e || {}, t.src_Any = $E.source, t.src_Cc = LE.source, t.src_Z = FE.source, t.src_P = ig.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
  const n = "[><｜]";
  return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
}
function t2(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    n && Object.keys(n).forEach(function(r) {
      e[r] = n[r];
    });
  }), e;
}
function t1(e) {
  return Object.prototype.toString.call(e);
}
function FK(e) {
  return t1(e) === "[object String]";
}
function MK(e) {
  return t1(e) === "[object Object]";
}
function BK(e) {
  return t1(e) === "[object RegExp]";
}
function p7(e) {
  return t1(e) === "[object Function]";
}
function UK(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const YE = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function HK(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t || YE.hasOwnProperty(n);
  }, !1);
}
const zK = {
  "http:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(r) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : r.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
    }
  }
}, VK = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", GK = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function WK(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function KK(e) {
  return function(t, n) {
    const r = t.slice(n);
    return e.test(r) ? r.match(e)[0].length : 0;
  };
}
function d7() {
  return function(e, t) {
    t.normalize(e);
  };
}
function S0(e) {
  const t = e.re = NK(e.__opts__), n = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || n.push(VK), n.push(t.src_xn), t.src_tlds = n.join("|");
  function r(c) {
    return c.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), "i");
  const i = [];
  e.__compiled__ = {};
  function a(c, u) {
    throw new Error('(LinkifyIt) Invalid schema "' + c + '": ' + u);
  }
  Object.keys(e.__schemas__).forEach(function(c) {
    const u = e.__schemas__[c];
    if (u === null)
      return;
    const s = { validate: null, link: null };
    if (e.__compiled__[c] = s, MK(u)) {
      BK(u.validate) ? s.validate = KK(u.validate) : p7(u.validate) ? s.validate = u.validate : a(c, u), p7(u.normalize) ? s.normalize = u.normalize : u.normalize ? a(c, u) : s.normalize = d7();
      return;
    }
    if (FK(u)) {
      i.push(c);
      return;
    }
    a(c, u);
  }), i.forEach(function(c) {
    e.__compiled__[e.__schemas__[c]] && (e.__compiled__[c].validate = e.__compiled__[e.__schemas__[c]].validate, e.__compiled__[c].normalize = e.__compiled__[e.__schemas__[c]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: d7() };
  const o = Object.keys(e.__compiled__).filter(function(c) {
    return c.length > 0 && e.__compiled__[c];
  }).map(UK).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + o + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + o + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), WK(e);
}
function ZK(e, t) {
  const n = e.__index__, r = e.__last_index__, i = e.__text_cache__.slice(n, r);
  this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = r + t, this.raw = i, this.text = i, this.url = i;
}
function r2(e, t) {
  const n = new ZK(e, t);
  return e.__compiled__[n.schema].normalize(n, e), n;
}
function ha(e, t) {
  if (!(this instanceof ha))
    return new ha(e, t);
  t || HK(e) && (t = e, e = {}), this.__opts__ = t2({}, YE, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = t2({}, zK, e), this.__compiled__ = {}, this.__tlds__ = GK, this.__tlds_replaced__ = !1, this.re = {}, S0(this);
}
ha.prototype.add = function(t, n) {
  return this.__schemas__[t] = n, S0(this), this;
};
ha.prototype.set = function(t) {
  return this.__opts__ = t2(this.__opts__, t), this;
};
ha.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  let n, r, i, a, o, c, u, s, l;
  if (this.re.schema_test.test(t)) {
    for (u = this.re.schema_search, u.lastIndex = 0; (n = u.exec(t)) !== null; )
      if (a = this.testSchemaAt(t, n[2], u.lastIndex), a) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + a;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (s = t.search(this.re.host_fuzzy_test), s >= 0 && (this.__index__ < 0 || s < this.__index__) && (r = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (o = r.index + r[1].length, (this.__index__ < 0 || o < this.__index__) && (this.__schema__ = "", this.__index__ = o, this.__last_index__ = r.index + r[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (l = t.indexOf("@"), l >= 0 && (i = t.match(this.re.email_fuzzy)) !== null && (o = i.index + i[1].length, c = i.index + i[0].length, (this.__index__ < 0 || o < this.__index__ || o === this.__index__ && c > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = o, this.__last_index__ = c))), this.__index__ >= 0;
};
ha.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
ha.prototype.testSchemaAt = function(t, n, r) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(t, r, this) : 0;
};
ha.prototype.match = function(t) {
  const n = [];
  let r = 0;
  this.__index__ >= 0 && this.__text_cache__ === t && (n.push(r2(this, r)), r = this.__last_index__);
  let i = r ? t.slice(r) : t;
  for (; this.test(i); )
    n.push(r2(this, r)), i = i.slice(this.__last_index__), r += this.__last_index__;
  return n.length ? n : null;
};
ha.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
  const n = this.re.schema_at_start.exec(t);
  if (!n) return null;
  const r = this.testSchemaAt(t, n[2], n[0].length);
  return r ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + r, r2(this, 0)) : null;
};
ha.prototype.tlds = function(t, n) {
  return t = Array.isArray(t) ? t : [t], n ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(r, i, a) {
    return r !== a[i - 1];
  }).reverse(), S0(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, S0(this), this);
};
ha.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
ha.prototype.onCompile = function() {
};
const ic = 2147483647, bo = 36, cg = 1, If = 26, YK = 38, JK = 700, JE = 72, QE = 128, XE = "-", QK = /^xn--/, XK = /[^\0-\x7F]/, eZ = /[\x2E\u3002\uFF0E\uFF61]/g, tZ = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, hm = bo - cg, xo = Math.floor, mm = String.fromCharCode;
function ys(e) {
  throw new RangeError(tZ[e]);
}
function rZ(e, t) {
  const n = [];
  let r = e.length;
  for (; r--; )
    n[r] = t(e[r]);
  return n;
}
function eO(e, t) {
  const n = e.split("@");
  let r = "";
  n.length > 1 && (r = n[0] + "@", e = n[1]), e = e.replace(eZ, ".");
  const i = e.split("."), a = rZ(i, t).join(".");
  return r + a;
}
function tO(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const a = e.charCodeAt(n++);
      (a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
const nZ = (e) => String.fromCodePoint(...e), iZ = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : bo;
}, h7 = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, rO = function(e, t, n) {
  let r = 0;
  for (e = n ? xo(e / JK) : e >> 1, e += xo(e / t); e > hm * If >> 1; r += bo)
    e = xo(e / hm);
  return xo(r + (hm + 1) * e / (e + YK));
}, nO = function(e) {
  const t = [], n = e.length;
  let r = 0, i = QE, a = JE, o = e.lastIndexOf(XE);
  o < 0 && (o = 0);
  for (let c = 0; c < o; ++c)
    e.charCodeAt(c) >= 128 && ys("not-basic"), t.push(e.charCodeAt(c));
  for (let c = o > 0 ? o + 1 : 0; c < n; ) {
    const u = r;
    for (let l = 1, d = bo; ; d += bo) {
      c >= n && ys("invalid-input");
      const f = iZ(e.charCodeAt(c++));
      f >= bo && ys("invalid-input"), f > xo((ic - r) / l) && ys("overflow"), r += f * l;
      const p = d <= a ? cg : d >= a + If ? If : d - a;
      if (f < p)
        break;
      const g = bo - p;
      l > xo(ic / g) && ys("overflow"), l *= g;
    }
    const s = t.length + 1;
    a = rO(r - u, s, u == 0), xo(r / s) > ic - i && ys("overflow"), i += xo(r / s), r %= s, t.splice(r++, 0, i);
  }
  return String.fromCodePoint(...t);
}, iO = function(e) {
  const t = [];
  e = tO(e);
  const n = e.length;
  let r = QE, i = 0, a = JE;
  for (const u of e)
    u < 128 && t.push(mm(u));
  const o = t.length;
  let c = o;
  for (o && t.push(XE); c < n; ) {
    let u = ic;
    for (const l of e)
      l >= r && l < u && (u = l);
    const s = c + 1;
    u - r > xo((ic - i) / s) && ys("overflow"), i += (u - r) * s, r = u;
    for (const l of e)
      if (l < r && ++i > ic && ys("overflow"), l === r) {
        let d = i;
        for (let f = bo; ; f += bo) {
          const p = f <= a ? cg : f >= a + If ? If : f - a;
          if (d < p)
            break;
          const g = d - p, b = bo - p;
          t.push(
            mm(h7(p + g % b, 0))
          ), d = xo(g / b);
        }
        t.push(mm(h7(d, 0))), a = rO(i, s, c === o), i = 0, ++c;
      }
    ++i, ++r;
  }
  return t.join("");
}, aZ = function(e) {
  return eO(e, function(t) {
    return QK.test(t) ? nO(t.slice(4).toLowerCase()) : t;
  });
}, oZ = function(e) {
  return eO(e, function(t) {
    return XK.test(t) ? "xn--" + iO(t) : t;
  });
}, aO = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: tO,
    encode: nZ
  },
  decode: nO,
  encode: iO,
  toASCII: oZ,
  toUnicode: aZ
}, sZ = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, uZ = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, cZ = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, lZ = {
  default: sZ,
  zero: uZ,
  commonmark: cZ
}, fZ = /^(vbscript|javascript|file|data):/, pZ = /^data:image\/(gif|png|jpeg|webp);/;
function dZ(e) {
  const t = e.trim().toLowerCase();
  return fZ.test(t) ? pZ.test(t) : !0;
}
const oO = ["http:", "https:", "mailto:"];
function hZ(e) {
  const t = ng(e, !0);
  if (t.hostname && (!t.protocol || oO.indexOf(t.protocol) >= 0))
    try {
      t.hostname = aO.toASCII(t.hostname);
    } catch {
    }
  return Jf(rg(t));
}
function mZ(e) {
  const t = ng(e, !0);
  if (t.hostname && (!t.protocol || oO.indexOf(t.protocol) >= 0))
    try {
      t.hostname = aO.toUnicode(t.hostname);
    } catch {
    }
  return mc(rg(t), mc.defaultChars + "%");
}
function Da(e, t) {
  if (!(this instanceof Da))
    return new Da(e, t);
  t || ag(e) || (t = e || {}, e = "default"), this.inline = new Xf(), this.block = new e1(), this.core = new sg(), this.renderer = new Tc(), this.linkify = new ha(), this.validateLink = dZ, this.normalizeLink = hZ, this.normalizeLinkText = mZ, this.utils = vW, this.helpers = Q0({}, _W), this.options = {}, this.configure(e), t && this.set(t);
}
Da.prototype.set = function(e) {
  return Q0(this.options, e), this;
};
Da.prototype.configure = function(e) {
  const t = this;
  if (ag(e)) {
    const n = e;
    if (e = lZ[n], !e)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(n) {
    e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules), e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2);
  }), this;
};
Da.prototype.enable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.enable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
  const r = e.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
  return this;
};
Da.prototype.disable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.disable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
  const r = e.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
  return this;
};
Da.prototype.use = function(e) {
  const t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
Da.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(e, this, t);
  return this.core.process(n), n.tokens;
};
Da.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
Da.prototype.parseInline = function(e, t) {
  const n = new this.core.State(e, this, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
Da.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
var Wa = {}, Ka = {}, gm = {}, Za = {}, Ed = {}, m7;
function gZ() {
  return m7 || (m7 = 1, Object.defineProperty(Ed, "__esModule", { value: !0 }), Ed.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), Ed;
}
var Od = {}, g7;
function vZ() {
  return g7 || (g7 = 1, Object.defineProperty(Od, "__esModule", { value: !0 }), Od.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), Od;
}
var vm = {}, v7;
function y7() {
  return v7 || (v7 = 1, (function(e) {
    var t;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
    var n = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(a) {
      var o = "";
      return a > 65535 && (a -= 65536, o += String.fromCharCode(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), o += String.fromCharCode(a), o;
    };
    function r(a) {
      var o;
      return a >= 55296 && a <= 57343 || a > 1114111 ? 65533 : (o = n.get(a)) !== null && o !== void 0 ? o : a;
    }
    e.replaceCodePoint = r;
    function i(a) {
      return (0, e.fromCodePoint)(r(a));
    }
    e.default = i;
  })(vm)), vm;
}
var b7;
function C0() {
  return b7 || (b7 = 1, (function(e) {
    var t = Za && Za.__createBinding || (Object.create ? (function(re, X, de, Ce) {
      Ce === void 0 && (Ce = de);
      var J = Object.getOwnPropertyDescriptor(X, de);
      (!J || ("get" in J ? !X.__esModule : J.writable || J.configurable)) && (J = { enumerable: !0, get: function() {
        return X[de];
      } }), Object.defineProperty(re, Ce, J);
    }) : (function(re, X, de, Ce) {
      Ce === void 0 && (Ce = de), re[Ce] = X[de];
    })), n = Za && Za.__setModuleDefault || (Object.create ? (function(re, X) {
      Object.defineProperty(re, "default", { enumerable: !0, value: X });
    }) : function(re, X) {
      re.default = X;
    }), r = Za && Za.__importStar || function(re) {
      if (re && re.__esModule) return re;
      var X = {};
      if (re != null) for (var de in re) de !== "default" && Object.prototype.hasOwnProperty.call(re, de) && t(X, re, de);
      return n(X, re), X;
    }, i = Za && Za.__importDefault || function(re) {
      return re && re.__esModule ? re : { default: re };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
    var a = i(/* @__PURE__ */ gZ());
    e.htmlDecodeTree = a.default;
    var o = i(/* @__PURE__ */ vZ());
    e.xmlDecodeTree = o.default;
    var c = r(/* @__PURE__ */ y7());
    e.decodeCodePoint = c.default;
    var u = /* @__PURE__ */ y7();
    Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
      return u.replaceCodePoint;
    } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
      return u.fromCodePoint;
    } });
    var s;
    (function(re) {
      re[re.NUM = 35] = "NUM", re[re.SEMI = 59] = "SEMI", re[re.EQUALS = 61] = "EQUALS", re[re.ZERO = 48] = "ZERO", re[re.NINE = 57] = "NINE", re[re.LOWER_A = 97] = "LOWER_A", re[re.LOWER_F = 102] = "LOWER_F", re[re.LOWER_X = 120] = "LOWER_X", re[re.LOWER_Z = 122] = "LOWER_Z", re[re.UPPER_A = 65] = "UPPER_A", re[re.UPPER_F = 70] = "UPPER_F", re[re.UPPER_Z = 90] = "UPPER_Z";
    })(s || (s = {}));
    var l = 32, d;
    (function(re) {
      re[re.VALUE_LENGTH = 49152] = "VALUE_LENGTH", re[re.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", re[re.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(d = e.BinTrieFlags || (e.BinTrieFlags = {}));
    function f(re) {
      return re >= s.ZERO && re <= s.NINE;
    }
    function p(re) {
      return re >= s.UPPER_A && re <= s.UPPER_F || re >= s.LOWER_A && re <= s.LOWER_F;
    }
    function g(re) {
      return re >= s.UPPER_A && re <= s.UPPER_Z || re >= s.LOWER_A && re <= s.LOWER_Z || f(re);
    }
    function b(re) {
      return re === s.EQUALS || g(re);
    }
    var w;
    (function(re) {
      re[re.EntityStart = 0] = "EntityStart", re[re.NumericStart = 1] = "NumericStart", re[re.NumericDecimal = 2] = "NumericDecimal", re[re.NumericHex = 3] = "NumericHex", re[re.NamedEntity = 4] = "NamedEntity";
    })(w || (w = {}));
    var y;
    (function(re) {
      re[re.Legacy = 0] = "Legacy", re[re.Strict = 1] = "Strict", re[re.Attribute = 2] = "Attribute";
    })(y = e.DecodingMode || (e.DecodingMode = {}));
    var v = (
      /** @class */
      (function() {
        function re(X, de, Ce) {
          this.decodeTree = X, this.emitCodePoint = de, this.errors = Ce, this.state = w.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = y.Strict;
        }
        return re.prototype.startEntity = function(X) {
          this.decodeMode = X, this.state = w.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, re.prototype.write = function(X, de) {
          switch (this.state) {
            case w.EntityStart:
              return X.charCodeAt(de) === s.NUM ? (this.state = w.NumericStart, this.consumed += 1, this.stateNumericStart(X, de + 1)) : (this.state = w.NamedEntity, this.stateNamedEntity(X, de));
            case w.NumericStart:
              return this.stateNumericStart(X, de);
            case w.NumericDecimal:
              return this.stateNumericDecimal(X, de);
            case w.NumericHex:
              return this.stateNumericHex(X, de);
            case w.NamedEntity:
              return this.stateNamedEntity(X, de);
          }
        }, re.prototype.stateNumericStart = function(X, de) {
          return de >= X.length ? -1 : (X.charCodeAt(de) | l) === s.LOWER_X ? (this.state = w.NumericHex, this.consumed += 1, this.stateNumericHex(X, de + 1)) : (this.state = w.NumericDecimal, this.stateNumericDecimal(X, de));
        }, re.prototype.addToNumericResult = function(X, de, Ce, J) {
          if (de !== Ce) {
            var ne = Ce - de;
            this.result = this.result * Math.pow(J, ne) + parseInt(X.substr(de, ne), J), this.consumed += ne;
          }
        }, re.prototype.stateNumericHex = function(X, de) {
          for (var Ce = de; de < X.length; ) {
            var J = X.charCodeAt(de);
            if (f(J) || p(J))
              de += 1;
            else
              return this.addToNumericResult(X, Ce, de, 16), this.emitNumericEntity(J, 3);
          }
          return this.addToNumericResult(X, Ce, de, 16), -1;
        }, re.prototype.stateNumericDecimal = function(X, de) {
          for (var Ce = de; de < X.length; ) {
            var J = X.charCodeAt(de);
            if (f(J))
              de += 1;
            else
              return this.addToNumericResult(X, Ce, de, 10), this.emitNumericEntity(J, 2);
          }
          return this.addToNumericResult(X, Ce, de, 10), -1;
        }, re.prototype.emitNumericEntity = function(X, de) {
          var Ce;
          if (this.consumed <= de)
            return (Ce = this.errors) === null || Ce === void 0 || Ce.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (X === s.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === y.Strict)
            return 0;
          return this.emitCodePoint((0, c.replaceCodePoint)(this.result), this.consumed), this.errors && (X !== s.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, re.prototype.stateNamedEntity = function(X, de) {
          for (var Ce = this.decodeTree, J = Ce[this.treeIndex], ne = (J & d.VALUE_LENGTH) >> 14; de < X.length; de++, this.excess++) {
            var De = X.charCodeAt(de);
            if (this.treeIndex = E(Ce, J, this.treeIndex + Math.max(1, ne), De), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === y.Attribute && // We shouldn't have consumed any characters after the entity,
              (ne === 0 || // And there should be no invalid characters.
              b(De)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (J = Ce[this.treeIndex], ne = (J & d.VALUE_LENGTH) >> 14, ne !== 0) {
              if (De === s.SEMI)
                return this.emitNamedEntityData(this.treeIndex, ne, this.consumed + this.excess);
              this.decodeMode !== y.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, re.prototype.emitNotTerminatedNamedEntity = function() {
          var X, de = this, Ce = de.result, J = de.decodeTree, ne = (J[Ce] & d.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(Ce, ne, this.consumed), (X = this.errors) === null || X === void 0 || X.missingSemicolonAfterCharacterReference(), this.consumed;
        }, re.prototype.emitNamedEntityData = function(X, de, Ce) {
          var J = this.decodeTree;
          return this.emitCodePoint(de === 1 ? J[X] & ~d.VALUE_LENGTH : J[X + 1], Ce), de === 3 && this.emitCodePoint(J[X + 2], Ce), Ce;
        }, re.prototype.end = function() {
          var X;
          switch (this.state) {
            case w.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== y.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case w.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case w.NumericHex:
              return this.emitNumericEntity(0, 3);
            case w.NumericStart:
              return (X = this.errors) === null || X === void 0 || X.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case w.EntityStart:
              return 0;
          }
        }, re;
      })()
    );
    e.EntityDecoder = v;
    function _(re) {
      var X = "", de = new v(re, function(Ce) {
        return X += (0, c.fromCodePoint)(Ce);
      });
      return function(J, ne) {
        for (var De = 0, je = 0; (je = J.indexOf("&", je)) >= 0; ) {
          X += J.slice(De, je), de.startEntity(ne);
          var Me = de.write(
            J,
            // Skip the "&"
            je + 1
          );
          if (Me < 0) {
            De = je + de.end();
            break;
          }
          De = je + Me, je = Me === 0 ? De + 1 : De;
        }
        var qe = X + J.slice(De);
        return X = "", qe;
      };
    }
    function E(re, X, de, Ce) {
      var J = (X & d.BRANCH_LENGTH) >> 7, ne = X & d.JUMP_TABLE;
      if (J === 0)
        return ne !== 0 && Ce === ne ? de : -1;
      if (ne) {
        var De = Ce - ne;
        return De < 0 || De >= J ? -1 : re[de + De] - 1;
      }
      for (var je = de, Me = je + J - 1; je <= Me; ) {
        var qe = je + Me >>> 1, Ve = re[qe];
        if (Ve < Ce)
          je = qe + 1;
        else if (Ve > Ce)
          Me = qe - 1;
        else
          return re[qe + J];
      }
      return -1;
    }
    e.determineBranch = E;
    var O = _(a.default), M = _(o.default);
    function L(re, X) {
      return X === void 0 && (X = y.Legacy), O(re, X);
    }
    e.decodeHTML = L;
    function Z(re) {
      return O(re, y.Attribute);
    }
    e.decodeHTMLAttribute = Z;
    function Q(re) {
      return O(re, y.Strict);
    }
    e.decodeHTMLStrict = Q;
    function ae(re) {
      return M(re, y.Strict);
    }
    e.decodeXML = ae;
  })(Za)), Za;
}
var x7;
function sO() {
  return x7 || (x7 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.QuoteType = void 0;
    var t = /* @__PURE__ */ C0(), n;
    (function(f) {
      f[f.Tab = 9] = "Tab", f[f.NewLine = 10] = "NewLine", f[f.FormFeed = 12] = "FormFeed", f[f.CarriageReturn = 13] = "CarriageReturn", f[f.Space = 32] = "Space", f[f.ExclamationMark = 33] = "ExclamationMark", f[f.Number = 35] = "Number", f[f.Amp = 38] = "Amp", f[f.SingleQuote = 39] = "SingleQuote", f[f.DoubleQuote = 34] = "DoubleQuote", f[f.Dash = 45] = "Dash", f[f.Slash = 47] = "Slash", f[f.Zero = 48] = "Zero", f[f.Nine = 57] = "Nine", f[f.Semi = 59] = "Semi", f[f.Lt = 60] = "Lt", f[f.Eq = 61] = "Eq", f[f.Gt = 62] = "Gt", f[f.Questionmark = 63] = "Questionmark", f[f.UpperA = 65] = "UpperA", f[f.LowerA = 97] = "LowerA", f[f.UpperF = 70] = "UpperF", f[f.LowerF = 102] = "LowerF", f[f.UpperZ = 90] = "UpperZ", f[f.LowerZ = 122] = "LowerZ", f[f.LowerX = 120] = "LowerX", f[f.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(n || (n = {}));
    var r;
    (function(f) {
      f[f.Text = 1] = "Text", f[f.BeforeTagName = 2] = "BeforeTagName", f[f.InTagName = 3] = "InTagName", f[f.InSelfClosingTag = 4] = "InSelfClosingTag", f[f.BeforeClosingTagName = 5] = "BeforeClosingTagName", f[f.InClosingTagName = 6] = "InClosingTagName", f[f.AfterClosingTagName = 7] = "AfterClosingTagName", f[f.BeforeAttributeName = 8] = "BeforeAttributeName", f[f.InAttributeName = 9] = "InAttributeName", f[f.AfterAttributeName = 10] = "AfterAttributeName", f[f.BeforeAttributeValue = 11] = "BeforeAttributeValue", f[f.InAttributeValueDq = 12] = "InAttributeValueDq", f[f.InAttributeValueSq = 13] = "InAttributeValueSq", f[f.InAttributeValueNq = 14] = "InAttributeValueNq", f[f.BeforeDeclaration = 15] = "BeforeDeclaration", f[f.InDeclaration = 16] = "InDeclaration", f[f.InProcessingInstruction = 17] = "InProcessingInstruction", f[f.BeforeComment = 18] = "BeforeComment", f[f.CDATASequence = 19] = "CDATASequence", f[f.InSpecialComment = 20] = "InSpecialComment", f[f.InCommentLike = 21] = "InCommentLike", f[f.BeforeSpecialS = 22] = "BeforeSpecialS", f[f.SpecialStartSequence = 23] = "SpecialStartSequence", f[f.InSpecialTag = 24] = "InSpecialTag", f[f.BeforeEntity = 25] = "BeforeEntity", f[f.BeforeNumericEntity = 26] = "BeforeNumericEntity", f[f.InNamedEntity = 27] = "InNamedEntity", f[f.InNumericEntity = 28] = "InNumericEntity", f[f.InHexEntity = 29] = "InHexEntity";
    })(r || (r = {}));
    function i(f) {
      return f === n.Space || f === n.NewLine || f === n.Tab || f === n.FormFeed || f === n.CarriageReturn;
    }
    function a(f) {
      return f === n.Slash || f === n.Gt || i(f);
    }
    function o(f) {
      return f >= n.Zero && f <= n.Nine;
    }
    function c(f) {
      return f >= n.LowerA && f <= n.LowerZ || f >= n.UpperA && f <= n.UpperZ;
    }
    function u(f) {
      return f >= n.UpperA && f <= n.UpperF || f >= n.LowerA && f <= n.LowerF;
    }
    var s;
    (function(f) {
      f[f.NoValue = 0] = "NoValue", f[f.Unquoted = 1] = "Unquoted", f[f.Single = 2] = "Single", f[f.Double = 3] = "Double";
    })(s = e.QuoteType || (e.QuoteType = {}));
    var l = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, d = (
      /** @class */
      (function() {
        function f(p, g) {
          var b = p.xmlMode, w = b === void 0 ? !1 : b, y = p.decodeEntities, v = y === void 0 ? !0 : y;
          this.cbs = g, this.state = r.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = r.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = w, this.decodeEntities = v, this.entityTrie = w ? t.xmlDecodeTree : t.htmlDecodeTree;
        }
        return f.prototype.reset = function() {
          this.state = r.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = r.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, f.prototype.write = function(p) {
          this.offset += this.buffer.length, this.buffer = p, this.parse();
        }, f.prototype.end = function() {
          this.running && this.finish();
        }, f.prototype.pause = function() {
          this.running = !1;
        }, f.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, f.prototype.getIndex = function() {
          return this.index;
        }, f.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, f.prototype.stateText = function(p) {
          p === n.Lt || !this.decodeEntities && this.fastForwardTo(n.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = r.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && p === n.Amp && (this.state = r.BeforeEntity);
        }, f.prototype.stateSpecialStartSequence = function(p) {
          var g = this.sequenceIndex === this.currentSequence.length, b = g ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            a(p)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (p | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!b)
            this.isSpecial = !1;
          else if (!g) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = r.InTagName, this.stateInTagName(p);
        }, f.prototype.stateInSpecialTag = function(p) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (p === n.Gt || i(p)) {
              var g = this.index - this.currentSequence.length;
              if (this.sectionStart < g) {
                var b = this.index;
                this.index = g, this.cbs.ontext(this.sectionStart, g), this.index = b;
              }
              this.isSpecial = !1, this.sectionStart = g + 2, this.stateInClosingTagName(p);
              return;
            }
            this.sequenceIndex = 0;
          }
          (p | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === l.TitleEnd ? this.decodeEntities && p === n.Amp && (this.state = r.BeforeEntity) : this.fastForwardTo(n.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(p === n.Lt);
        }, f.prototype.stateCDATASequence = function(p) {
          p === l.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === l.Cdata.length && (this.state = r.InCommentLike, this.currentSequence = l.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = r.InDeclaration, this.stateInDeclaration(p));
        }, f.prototype.fastForwardTo = function(p) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === p)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, f.prototype.stateInCommentLike = function(p) {
          p === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === l.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = r.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : p !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, f.prototype.isTagStartChar = function(p) {
          return this.xmlMode ? !a(p) : c(p);
        }, f.prototype.startSpecial = function(p, g) {
          this.isSpecial = !0, this.currentSequence = p, this.sequenceIndex = g, this.state = r.SpecialStartSequence;
        }, f.prototype.stateBeforeTagName = function(p) {
          if (p === n.ExclamationMark)
            this.state = r.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (p === n.Questionmark)
            this.state = r.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(p)) {
            var g = p | 32;
            this.sectionStart = this.index, !this.xmlMode && g === l.TitleEnd[2] ? this.startSpecial(l.TitleEnd, 3) : this.state = !this.xmlMode && g === l.ScriptEnd[2] ? r.BeforeSpecialS : r.InTagName;
          } else p === n.Slash ? this.state = r.BeforeClosingTagName : (this.state = r.Text, this.stateText(p));
        }, f.prototype.stateInTagName = function(p) {
          a(p) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p));
        }, f.prototype.stateBeforeClosingTagName = function(p) {
          i(p) || (p === n.Gt ? this.state = r.Text : (this.state = this.isTagStartChar(p) ? r.InClosingTagName : r.InSpecialComment, this.sectionStart = this.index));
        }, f.prototype.stateInClosingTagName = function(p) {
          (p === n.Gt || i(p)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.AfterClosingTagName, this.stateAfterClosingTagName(p));
        }, f.prototype.stateAfterClosingTagName = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.state = r.Text, this.baseState = r.Text, this.sectionStart = this.index + 1);
        }, f.prototype.stateBeforeAttributeName = function(p) {
          p === n.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = r.InSpecialTag, this.sequenceIndex = 0) : this.state = r.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : p === n.Slash ? this.state = r.InSelfClosingTag : i(p) || (this.state = r.InAttributeName, this.sectionStart = this.index);
        }, f.prototype.stateInSelfClosingTag = function(p) {
          p === n.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = r.Text, this.baseState = r.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(p) || (this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p));
        }, f.prototype.stateInAttributeName = function(p) {
          (p === n.Eq || a(p)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.AfterAttributeName, this.stateAfterAttributeName(p));
        }, f.prototype.stateAfterAttributeName = function(p) {
          p === n.Eq ? this.state = r.BeforeAttributeValue : p === n.Slash || p === n.Gt ? (this.cbs.onattribend(s.NoValue, this.index), this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p)) : i(p) || (this.cbs.onattribend(s.NoValue, this.index), this.state = r.InAttributeName, this.sectionStart = this.index);
        }, f.prototype.stateBeforeAttributeValue = function(p) {
          p === n.DoubleQuote ? (this.state = r.InAttributeValueDq, this.sectionStart = this.index + 1) : p === n.SingleQuote ? (this.state = r.InAttributeValueSq, this.sectionStart = this.index + 1) : i(p) || (this.sectionStart = this.index, this.state = r.InAttributeValueNq, this.stateInAttributeValueNoQuotes(p));
        }, f.prototype.handleInAttributeValue = function(p, g) {
          p === g || !this.decodeEntities && this.fastForwardTo(g) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(g === n.DoubleQuote ? s.Double : s.Single, this.index), this.state = r.BeforeAttributeName) : this.decodeEntities && p === n.Amp && (this.baseState = this.state, this.state = r.BeforeEntity);
        }, f.prototype.stateInAttributeValueDoubleQuotes = function(p) {
          this.handleInAttributeValue(p, n.DoubleQuote);
        }, f.prototype.stateInAttributeValueSingleQuotes = function(p) {
          this.handleInAttributeValue(p, n.SingleQuote);
        }, f.prototype.stateInAttributeValueNoQuotes = function(p) {
          i(p) || p === n.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(s.Unquoted, this.index), this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p)) : this.decodeEntities && p === n.Amp && (this.baseState = this.state, this.state = r.BeforeEntity);
        }, f.prototype.stateBeforeDeclaration = function(p) {
          p === n.OpeningSquareBracket ? (this.state = r.CDATASequence, this.sequenceIndex = 0) : this.state = p === n.Dash ? r.BeforeComment : r.InDeclaration;
        }, f.prototype.stateInDeclaration = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = r.Text, this.sectionStart = this.index + 1);
        }, f.prototype.stateInProcessingInstruction = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = r.Text, this.sectionStart = this.index + 1);
        }, f.prototype.stateBeforeComment = function(p) {
          p === n.Dash ? (this.state = r.InCommentLike, this.currentSequence = l.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = r.InDeclaration;
        }, f.prototype.stateInSpecialComment = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = r.Text, this.sectionStart = this.index + 1);
        }, f.prototype.stateBeforeSpecialS = function(p) {
          var g = p | 32;
          g === l.ScriptEnd[3] ? this.startSpecial(l.ScriptEnd, 4) : g === l.StyleEnd[3] ? this.startSpecial(l.StyleEnd, 4) : (this.state = r.InTagName, this.stateInTagName(p));
        }, f.prototype.stateBeforeEntity = function(p) {
          this.entityExcess = 1, this.entityResult = 0, p === n.Number ? this.state = r.BeforeNumericEntity : p === n.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = r.InNamedEntity, this.stateInNamedEntity(p));
        }, f.prototype.stateInNamedEntity = function(p) {
          if (this.entityExcess += 1, this.trieIndex = (0, t.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, p), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var g = this.trieCurrent & t.BinTrieFlags.VALUE_LENGTH;
          if (g) {
            var b = (g >> 14) - 1;
            if (!this.allowLegacyEntity() && p !== n.Semi)
              this.trieIndex += b;
            else {
              var w = this.index - this.entityExcess + 1;
              w > this.sectionStart && this.emitPartial(this.sectionStart, w), this.entityResult = this.trieIndex, this.trieIndex += b, this.entityExcess = 0, this.sectionStart = this.index + 1, b === 0 && this.emitNamedEntity();
            }
          }
        }, f.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var p = (this.entityTrie[this.entityResult] & t.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (p) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~t.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, f.prototype.stateBeforeNumericEntity = function(p) {
          (p | 32) === n.LowerX ? (this.entityExcess++, this.state = r.InHexEntity) : (this.state = r.InNumericEntity, this.stateInNumericEntity(p));
        }, f.prototype.emitNumericEntity = function(p) {
          var g = this.index - this.entityExcess - 1, b = g + 2 + +(this.state === r.InHexEntity);
          b !== this.index && (g > this.sectionStart && this.emitPartial(this.sectionStart, g), this.sectionStart = this.index + Number(p), this.emitCodePoint((0, t.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, f.prototype.stateInNumericEntity = function(p) {
          p === n.Semi ? this.emitNumericEntity(!0) : o(p) ? (this.entityResult = this.entityResult * 10 + (p - n.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, f.prototype.stateInHexEntity = function(p) {
          p === n.Semi ? this.emitNumericEntity(!0) : o(p) ? (this.entityResult = this.entityResult * 16 + (p - n.Zero), this.entityExcess++) : u(p) ? (this.entityResult = this.entityResult * 16 + ((p | 32) - n.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, f.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === r.Text || this.baseState === r.InSpecialTag);
        }, f.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === r.Text || this.state === r.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === r.InAttributeValueDq || this.state === r.InAttributeValueSq || this.state === r.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, f.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, f.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var p = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case r.Text: {
                this.stateText(p);
                break;
              }
              case r.SpecialStartSequence: {
                this.stateSpecialStartSequence(p);
                break;
              }
              case r.InSpecialTag: {
                this.stateInSpecialTag(p);
                break;
              }
              case r.CDATASequence: {
                this.stateCDATASequence(p);
                break;
              }
              case r.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(p);
                break;
              }
              case r.InAttributeName: {
                this.stateInAttributeName(p);
                break;
              }
              case r.InCommentLike: {
                this.stateInCommentLike(p);
                break;
              }
              case r.InSpecialComment: {
                this.stateInSpecialComment(p);
                break;
              }
              case r.BeforeAttributeName: {
                this.stateBeforeAttributeName(p);
                break;
              }
              case r.InTagName: {
                this.stateInTagName(p);
                break;
              }
              case r.InClosingTagName: {
                this.stateInClosingTagName(p);
                break;
              }
              case r.BeforeTagName: {
                this.stateBeforeTagName(p);
                break;
              }
              case r.AfterAttributeName: {
                this.stateAfterAttributeName(p);
                break;
              }
              case r.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(p);
                break;
              }
              case r.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(p);
                break;
              }
              case r.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(p);
                break;
              }
              case r.AfterClosingTagName: {
                this.stateAfterClosingTagName(p);
                break;
              }
              case r.BeforeSpecialS: {
                this.stateBeforeSpecialS(p);
                break;
              }
              case r.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(p);
                break;
              }
              case r.InSelfClosingTag: {
                this.stateInSelfClosingTag(p);
                break;
              }
              case r.InDeclaration: {
                this.stateInDeclaration(p);
                break;
              }
              case r.BeforeDeclaration: {
                this.stateBeforeDeclaration(p);
                break;
              }
              case r.BeforeComment: {
                this.stateBeforeComment(p);
                break;
              }
              case r.InProcessingInstruction: {
                this.stateInProcessingInstruction(p);
                break;
              }
              case r.InNamedEntity: {
                this.stateInNamedEntity(p);
                break;
              }
              case r.BeforeEntity: {
                this.stateBeforeEntity(p);
                break;
              }
              case r.InHexEntity: {
                this.stateInHexEntity(p);
                break;
              }
              case r.InNumericEntity: {
                this.stateInNumericEntity(p);
                break;
              }
              default:
                this.stateBeforeNumericEntity(p);
            }
            this.index++;
          }
          this.cleanup();
        }, f.prototype.finish = function() {
          this.state === r.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, f.prototype.handleTrailingData = function() {
          var p = this.buffer.length + this.offset;
          this.state === r.InCommentLike ? this.currentSequence === l.CdataEnd ? this.cbs.oncdata(this.sectionStart, p, 0) : this.cbs.oncomment(this.sectionStart, p, 0) : this.state === r.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === r.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === r.InTagName || this.state === r.BeforeAttributeName || this.state === r.BeforeAttributeValue || this.state === r.AfterAttributeName || this.state === r.InAttributeName || this.state === r.InAttributeValueSq || this.state === r.InAttributeValueDq || this.state === r.InAttributeValueNq || this.state === r.InClosingTagName || this.cbs.ontext(this.sectionStart, p);
        }, f.prototype.emitPartial = function(p, g) {
          this.baseState !== r.Text && this.baseState !== r.InSpecialTag ? this.cbs.onattribdata(p, g) : this.cbs.ontext(p, g);
        }, f.prototype.emitCodePoint = function(p) {
          this.baseState !== r.Text && this.baseState !== r.InSpecialTag ? this.cbs.onattribentity(p) : this.cbs.ontextentity(p);
        }, f;
      })()
    );
    e.default = d;
  })(gm)), gm;
}
var _7;
function w7() {
  if (_7) return Ka;
  _7 = 1;
  var e = Ka && Ka.__createBinding || (Object.create ? (function(w, y, v, _) {
    _ === void 0 && (_ = v);
    var E = Object.getOwnPropertyDescriptor(y, v);
    (!E || ("get" in E ? !y.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return y[v];
    } }), Object.defineProperty(w, _, E);
  }) : (function(w, y, v, _) {
    _ === void 0 && (_ = v), w[_] = y[v];
  })), t = Ka && Ka.__setModuleDefault || (Object.create ? (function(w, y) {
    Object.defineProperty(w, "default", { enumerable: !0, value: y });
  }) : function(w, y) {
    w.default = y;
  }), n = Ka && Ka.__importStar || function(w) {
    if (w && w.__esModule) return w;
    var y = {};
    if (w != null) for (var v in w) v !== "default" && Object.prototype.hasOwnProperty.call(w, v) && e(y, w, v);
    return t(y, w), y;
  };
  Object.defineProperty(Ka, "__esModule", { value: !0 }), Ka.Parser = void 0;
  var r = n(/* @__PURE__ */ sO()), i = /* @__PURE__ */ C0(), a = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), o = /* @__PURE__ */ new Set(["p"]), c = /* @__PURE__ */ new Set(["thead", "tbody"]), u = /* @__PURE__ */ new Set(["dd", "dt"]), s = /* @__PURE__ */ new Set(["rt", "rp"]), l = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", o],
    ["h1", o],
    ["h2", o],
    ["h3", o],
    ["h4", o],
    ["h5", o],
    ["h6", o],
    ["select", a],
    ["input", a],
    ["output", a],
    ["button", a],
    ["datalist", a],
    ["textarea", a],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", u],
    ["dt", u],
    ["address", o],
    ["article", o],
    ["aside", o],
    ["blockquote", o],
    ["details", o],
    ["div", o],
    ["dl", o],
    ["fieldset", o],
    ["figcaption", o],
    ["figure", o],
    ["footer", o],
    ["form", o],
    ["header", o],
    ["hr", o],
    ["main", o],
    ["nav", o],
    ["ol", o],
    ["pre", o],
    ["section", o],
    ["table", o],
    ["ul", o],
    ["rt", s],
    ["rp", s],
    ["tbody", c],
    ["tfoot", c]
  ]), d = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), f = /* @__PURE__ */ new Set(["math", "svg"]), p = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), g = /\s|\//, b = (
    /** @class */
    (function() {
      function w(y, v) {
        v === void 0 && (v = {});
        var _, E, O, M, L;
        this.options = v, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = y ?? {}, this.lowerCaseTagNames = (_ = v.lowerCaseTags) !== null && _ !== void 0 ? _ : !v.xmlMode, this.lowerCaseAttributeNames = (E = v.lowerCaseAttributeNames) !== null && E !== void 0 ? E : !v.xmlMode, this.tokenizer = new ((O = v.Tokenizer) !== null && O !== void 0 ? O : r.default)(this.options, this), (L = (M = this.cbs).onparserinit) === null || L === void 0 || L.call(M, this);
      }
      return w.prototype.ontext = function(y, v) {
        var _, E, O = this.getSlice(y, v);
        this.endIndex = v - 1, (E = (_ = this.cbs).ontext) === null || E === void 0 || E.call(_, O), this.startIndex = v;
      }, w.prototype.ontextentity = function(y) {
        var v, _, E = this.tokenizer.getSectionStart();
        this.endIndex = E - 1, (_ = (v = this.cbs).ontext) === null || _ === void 0 || _.call(v, (0, i.fromCodePoint)(y)), this.startIndex = E;
      }, w.prototype.isVoidElement = function(y) {
        return !this.options.xmlMode && d.has(y);
      }, w.prototype.onopentagname = function(y, v) {
        this.endIndex = v;
        var _ = this.getSlice(y, v);
        this.lowerCaseTagNames && (_ = _.toLowerCase()), this.emitOpenTag(_);
      }, w.prototype.emitOpenTag = function(y) {
        var v, _, E, O;
        this.openTagStart = this.startIndex, this.tagname = y;
        var M = !this.options.xmlMode && l.get(y);
        if (M)
          for (; this.stack.length > 0 && M.has(this.stack[this.stack.length - 1]); ) {
            var L = this.stack.pop();
            (_ = (v = this.cbs).onclosetag) === null || _ === void 0 || _.call(v, L, !0);
          }
        this.isVoidElement(y) || (this.stack.push(y), f.has(y) ? this.foreignContext.push(!0) : p.has(y) && this.foreignContext.push(!1)), (O = (E = this.cbs).onopentagname) === null || O === void 0 || O.call(E, y), this.cbs.onopentag && (this.attribs = {});
      }, w.prototype.endOpenTag = function(y) {
        var v, _;
        this.startIndex = this.openTagStart, this.attribs && ((_ = (v = this.cbs).onopentag) === null || _ === void 0 || _.call(v, this.tagname, this.attribs, y), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, w.prototype.onopentagend = function(y) {
        this.endIndex = y, this.endOpenTag(!1), this.startIndex = y + 1;
      }, w.prototype.onclosetag = function(y, v) {
        var _, E, O, M, L, Z;
        this.endIndex = v;
        var Q = this.getSlice(y, v);
        if (this.lowerCaseTagNames && (Q = Q.toLowerCase()), (f.has(Q) || p.has(Q)) && this.foreignContext.pop(), this.isVoidElement(Q))
          !this.options.xmlMode && Q === "br" && ((E = (_ = this.cbs).onopentagname) === null || E === void 0 || E.call(_, "br"), (M = (O = this.cbs).onopentag) === null || M === void 0 || M.call(O, "br", {}, !0), (Z = (L = this.cbs).onclosetag) === null || Z === void 0 || Z.call(L, "br", !1));
        else {
          var ae = this.stack.lastIndexOf(Q);
          if (ae !== -1)
            if (this.cbs.onclosetag)
              for (var re = this.stack.length - ae; re--; )
                this.cbs.onclosetag(this.stack.pop(), re !== 0);
            else
              this.stack.length = ae;
          else !this.options.xmlMode && Q === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = v + 1;
      }, w.prototype.onselfclosingtag = function(y) {
        this.endIndex = y, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = y + 1) : this.onopentagend(y);
      }, w.prototype.closeCurrentTag = function(y) {
        var v, _, E = this.tagname;
        this.endOpenTag(y), this.stack[this.stack.length - 1] === E && ((_ = (v = this.cbs).onclosetag) === null || _ === void 0 || _.call(v, E, !y), this.stack.pop());
      }, w.prototype.onattribname = function(y, v) {
        this.startIndex = y;
        var _ = this.getSlice(y, v);
        this.attribname = this.lowerCaseAttributeNames ? _.toLowerCase() : _;
      }, w.prototype.onattribdata = function(y, v) {
        this.attribvalue += this.getSlice(y, v);
      }, w.prototype.onattribentity = function(y) {
        this.attribvalue += (0, i.fromCodePoint)(y);
      }, w.prototype.onattribend = function(y, v) {
        var _, E;
        this.endIndex = v, (E = (_ = this.cbs).onattribute) === null || E === void 0 || E.call(_, this.attribname, this.attribvalue, y === r.QuoteType.Double ? '"' : y === r.QuoteType.Single ? "'" : y === r.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, w.prototype.getInstructionName = function(y) {
        var v = y.search(g), _ = v < 0 ? y : y.substr(0, v);
        return this.lowerCaseTagNames && (_ = _.toLowerCase()), _;
      }, w.prototype.ondeclaration = function(y, v) {
        this.endIndex = v;
        var _ = this.getSlice(y, v);
        if (this.cbs.onprocessinginstruction) {
          var E = this.getInstructionName(_);
          this.cbs.onprocessinginstruction("!".concat(E), "!".concat(_));
        }
        this.startIndex = v + 1;
      }, w.prototype.onprocessinginstruction = function(y, v) {
        this.endIndex = v;
        var _ = this.getSlice(y, v);
        if (this.cbs.onprocessinginstruction) {
          var E = this.getInstructionName(_);
          this.cbs.onprocessinginstruction("?".concat(E), "?".concat(_));
        }
        this.startIndex = v + 1;
      }, w.prototype.oncomment = function(y, v, _) {
        var E, O, M, L;
        this.endIndex = v, (O = (E = this.cbs).oncomment) === null || O === void 0 || O.call(E, this.getSlice(y, v - _)), (L = (M = this.cbs).oncommentend) === null || L === void 0 || L.call(M), this.startIndex = v + 1;
      }, w.prototype.oncdata = function(y, v, _) {
        var E, O, M, L, Z, Q, ae, re, X, de;
        this.endIndex = v;
        var Ce = this.getSlice(y, v - _);
        this.options.xmlMode || this.options.recognizeCDATA ? ((O = (E = this.cbs).oncdatastart) === null || O === void 0 || O.call(E), (L = (M = this.cbs).ontext) === null || L === void 0 || L.call(M, Ce), (Q = (Z = this.cbs).oncdataend) === null || Q === void 0 || Q.call(Z)) : ((re = (ae = this.cbs).oncomment) === null || re === void 0 || re.call(ae, "[CDATA[".concat(Ce, "]]")), (de = (X = this.cbs).oncommentend) === null || de === void 0 || de.call(X)), this.startIndex = v + 1;
      }, w.prototype.onend = function() {
        var y, v;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var _ = this.stack.length; _ > 0; this.cbs.onclosetag(this.stack[--_], !0))
            ;
        }
        (v = (y = this.cbs).onend) === null || v === void 0 || v.call(y);
      }, w.prototype.reset = function() {
        var y, v, _, E;
        (v = (y = this.cbs).onreset) === null || v === void 0 || v.call(y), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (E = (_ = this.cbs).onparserinit) === null || E === void 0 || E.call(_, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, w.prototype.parseComplete = function(y) {
        this.reset(), this.end(y);
      }, w.prototype.getSlice = function(y, v) {
        for (; y - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var _ = this.buffers[0].slice(y - this.bufferOffset, v - this.bufferOffset); v - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), _ += this.buffers[0].slice(0, v - this.bufferOffset);
        return _;
      }, w.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, w.prototype.write = function(y) {
        var v, _;
        if (this.ended) {
          (_ = (v = this.cbs).onerror) === null || _ === void 0 || _.call(v, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(y), this.tokenizer.running && (this.tokenizer.write(y), this.writeIndex++);
      }, w.prototype.end = function(y) {
        var v, _;
        if (this.ended) {
          (_ = (v = this.cbs).onerror) === null || _ === void 0 || _.call(v, new Error(".end() after done!"));
          return;
        }
        y && this.write(y), this.ended = !0, this.tokenizer.end();
      }, w.prototype.pause = function() {
        this.tokenizer.pause();
      }, w.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, w.prototype.parseChunk = function(y) {
        this.write(y);
      }, w.prototype.done = function(y) {
        this.end(y);
      }, w;
    })()
  );
  return Ka.Parser = b, Ka;
}
var Vs = {}, ym = {}, S7;
function ep() {
  return S7 || (S7 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
    var t;
    (function(r) {
      r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
    })(t = e.ElementType || (e.ElementType = {}));
    function n(r) {
      return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
    }
    e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
  })(ym)), ym;
}
var kn = {}, C7;
function k7() {
  if (C7) return kn;
  C7 = 1;
  var e = kn && kn.__extends || /* @__PURE__ */ (function() {
    var O = function(M, L) {
      return O = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Z, Q) {
        Z.__proto__ = Q;
      } || function(Z, Q) {
        for (var ae in Q) Object.prototype.hasOwnProperty.call(Q, ae) && (Z[ae] = Q[ae]);
      }, O(M, L);
    };
    return function(M, L) {
      if (typeof L != "function" && L !== null)
        throw new TypeError("Class extends value " + String(L) + " is not a constructor or null");
      O(M, L);
      function Z() {
        this.constructor = M;
      }
      M.prototype = L === null ? Object.create(L) : (Z.prototype = L.prototype, new Z());
    };
  })(), t = kn && kn.__assign || function() {
    return t = Object.assign || function(O) {
      for (var M, L = 1, Z = arguments.length; L < Z; L++) {
        M = arguments[L];
        for (var Q in M) Object.prototype.hasOwnProperty.call(M, Q) && (O[Q] = M[Q]);
      }
      return O;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(kn, "__esModule", { value: !0 }), kn.cloneNode = kn.hasChildren = kn.isDocument = kn.isDirective = kn.isComment = kn.isText = kn.isCDATA = kn.isTag = kn.Element = kn.Document = kn.CDATA = kn.NodeWithChildren = kn.ProcessingInstruction = kn.Comment = kn.Text = kn.DataNode = kn.Node = void 0;
  var n = /* @__PURE__ */ ep(), r = (
    /** @class */
    (function() {
      function O() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(O.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(M) {
          this.parent = M;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(O.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(M) {
          this.prev = M;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(O.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(M) {
          this.next = M;
        },
        enumerable: !1,
        configurable: !0
      }), O.prototype.cloneNode = function(M) {
        return M === void 0 && (M = !1), _(this, M);
      }, O;
    })()
  );
  kn.Node = r;
  var i = (
    /** @class */
    (function(O) {
      e(M, O);
      function M(L) {
        var Z = O.call(this) || this;
        return Z.data = L, Z;
      }
      return Object.defineProperty(M.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(L) {
          this.data = L;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(r)
  );
  kn.DataNode = i;
  var a = (
    /** @class */
    (function(O) {
      e(M, O);
      function M() {
        var L = O !== null && O.apply(this, arguments) || this;
        return L.type = n.ElementType.Text, L;
      }
      return Object.defineProperty(M.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(i)
  );
  kn.Text = a;
  var o = (
    /** @class */
    (function(O) {
      e(M, O);
      function M() {
        var L = O !== null && O.apply(this, arguments) || this;
        return L.type = n.ElementType.Comment, L;
      }
      return Object.defineProperty(M.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(i)
  );
  kn.Comment = o;
  var c = (
    /** @class */
    (function(O) {
      e(M, O);
      function M(L, Z) {
        var Q = O.call(this, Z) || this;
        return Q.name = L, Q.type = n.ElementType.Directive, Q;
      }
      return Object.defineProperty(M.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(i)
  );
  kn.ProcessingInstruction = c;
  var u = (
    /** @class */
    (function(O) {
      e(M, O);
      function M(L) {
        var Z = O.call(this) || this;
        return Z.children = L, Z;
      }
      return Object.defineProperty(M.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var L;
          return (L = this.children[0]) !== null && L !== void 0 ? L : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(M.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(M.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(L) {
          this.children = L;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(r)
  );
  kn.NodeWithChildren = u;
  var s = (
    /** @class */
    (function(O) {
      e(M, O);
      function M() {
        var L = O !== null && O.apply(this, arguments) || this;
        return L.type = n.ElementType.CDATA, L;
      }
      return Object.defineProperty(M.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(u)
  );
  kn.CDATA = s;
  var l = (
    /** @class */
    (function(O) {
      e(M, O);
      function M() {
        var L = O !== null && O.apply(this, arguments) || this;
        return L.type = n.ElementType.Root, L;
      }
      return Object.defineProperty(M.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(u)
  );
  kn.Document = l;
  var d = (
    /** @class */
    (function(O) {
      e(M, O);
      function M(L, Z, Q, ae) {
        Q === void 0 && (Q = []), ae === void 0 && (ae = L === "script" ? n.ElementType.Script : L === "style" ? n.ElementType.Style : n.ElementType.Tag);
        var re = O.call(this, Q) || this;
        return re.name = L, re.attribs = Z, re.type = ae, re;
      }
      return Object.defineProperty(M.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(M.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(L) {
          this.name = L;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(M.prototype, "attributes", {
        get: function() {
          var L = this;
          return Object.keys(this.attribs).map(function(Z) {
            var Q, ae;
            return {
              name: Z,
              value: L.attribs[Z],
              namespace: (Q = L["x-attribsNamespace"]) === null || Q === void 0 ? void 0 : Q[Z],
              prefix: (ae = L["x-attribsPrefix"]) === null || ae === void 0 ? void 0 : ae[Z]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), M;
    })(u)
  );
  kn.Element = d;
  function f(O) {
    return (0, n.isTag)(O);
  }
  kn.isTag = f;
  function p(O) {
    return O.type === n.ElementType.CDATA;
  }
  kn.isCDATA = p;
  function g(O) {
    return O.type === n.ElementType.Text;
  }
  kn.isText = g;
  function b(O) {
    return O.type === n.ElementType.Comment;
  }
  kn.isComment = b;
  function w(O) {
    return O.type === n.ElementType.Directive;
  }
  kn.isDirective = w;
  function y(O) {
    return O.type === n.ElementType.Root;
  }
  kn.isDocument = y;
  function v(O) {
    return Object.prototype.hasOwnProperty.call(O, "children");
  }
  kn.hasChildren = v;
  function _(O, M) {
    M === void 0 && (M = !1);
    var L;
    if (g(O))
      L = new a(O.data);
    else if (b(O))
      L = new o(O.data);
    else if (f(O)) {
      var Z = M ? E(O.children) : [], Q = new d(O.name, t({}, O.attribs), Z);
      Z.forEach(function(de) {
        return de.parent = Q;
      }), O.namespace != null && (Q.namespace = O.namespace), O["x-attribsNamespace"] && (Q["x-attribsNamespace"] = t({}, O["x-attribsNamespace"])), O["x-attribsPrefix"] && (Q["x-attribsPrefix"] = t({}, O["x-attribsPrefix"])), L = Q;
    } else if (p(O)) {
      var Z = M ? E(O.children) : [], ae = new s(Z);
      Z.forEach(function(Ce) {
        return Ce.parent = ae;
      }), L = ae;
    } else if (y(O)) {
      var Z = M ? E(O.children) : [], re = new l(Z);
      Z.forEach(function(Ce) {
        return Ce.parent = re;
      }), O["x-mode"] && (re["x-mode"] = O["x-mode"]), L = re;
    } else if (w(O)) {
      var X = new c(O.name, O.data);
      O["x-name"] != null && (X["x-name"] = O["x-name"], X["x-publicId"] = O["x-publicId"], X["x-systemId"] = O["x-systemId"]), L = X;
    } else
      throw new Error("Not implemented yet: ".concat(O.type));
    return L.startIndex = O.startIndex, L.endIndex = O.endIndex, O.sourceCodeLocation != null && (L.sourceCodeLocation = O.sourceCodeLocation), L;
  }
  kn.cloneNode = _;
  function E(O) {
    for (var M = O.map(function(Z) {
      return _(Z, !0);
    }), L = 1; L < M.length; L++)
      M[L].prev = M[L - 1], M[L - 1].next = M[L];
    return M;
  }
  return kn;
}
var A7;
function Os() {
  return A7 || (A7 = 1, (function(e) {
    var t = Vs && Vs.__createBinding || (Object.create ? (function(c, u, s, l) {
      l === void 0 && (l = s);
      var d = Object.getOwnPropertyDescriptor(u, s);
      (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return u[s];
      } }), Object.defineProperty(c, l, d);
    }) : (function(c, u, s, l) {
      l === void 0 && (l = s), c[l] = u[s];
    })), n = Vs && Vs.__exportStar || function(c, u) {
      for (var s in c) s !== "default" && !Object.prototype.hasOwnProperty.call(u, s) && t(u, c, s);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
    var r = /* @__PURE__ */ ep(), i = /* @__PURE__ */ k7();
    n(/* @__PURE__ */ k7(), e);
    var a = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, o = (
      /** @class */
      (function() {
        function c(u, s, l) {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof s == "function" && (l = s, s = a), typeof u == "object" && (s = u, u = void 0), this.callback = u ?? null, this.options = s ?? a, this.elementCB = l ?? null;
        }
        return c.prototype.onparserinit = function(u) {
          this.parser = u;
        }, c.prototype.onreset = function() {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, c.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, c.prototype.onerror = function(u) {
          this.handleCallback(u);
        }, c.prototype.onclosetag = function() {
          this.lastNode = null;
          var u = this.tagStack.pop();
          this.options.withEndIndices && (u.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(u);
        }, c.prototype.onopentag = function(u, s) {
          var l = this.options.xmlMode ? r.ElementType.Tag : void 0, d = new i.Element(u, s, void 0, l);
          this.addNode(d), this.tagStack.push(d);
        }, c.prototype.ontext = function(u) {
          var s = this.lastNode;
          if (s && s.type === r.ElementType.Text)
            s.data += u, this.options.withEndIndices && (s.endIndex = this.parser.endIndex);
          else {
            var l = new i.Text(u);
            this.addNode(l), this.lastNode = l;
          }
        }, c.prototype.oncomment = function(u) {
          if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
            this.lastNode.data += u;
            return;
          }
          var s = new i.Comment(u);
          this.addNode(s), this.lastNode = s;
        }, c.prototype.oncommentend = function() {
          this.lastNode = null;
        }, c.prototype.oncdatastart = function() {
          var u = new i.Text(""), s = new i.CDATA([u]);
          this.addNode(s), u.parent = s, this.lastNode = u;
        }, c.prototype.oncdataend = function() {
          this.lastNode = null;
        }, c.prototype.onprocessinginstruction = function(u, s) {
          var l = new i.ProcessingInstruction(u, s);
          this.addNode(l);
        }, c.prototype.handleCallback = function(u) {
          if (typeof this.callback == "function")
            this.callback(u, this.dom);
          else if (u)
            throw u;
        }, c.prototype.addNode = function(u) {
          var s = this.tagStack[this.tagStack.length - 1], l = s.children[s.children.length - 1];
          this.options.withStartIndices && (u.startIndex = this.parser.startIndex), this.options.withEndIndices && (u.endIndex = this.parser.endIndex), s.children.push(u), l && (u.prev = l, l.next = u), u.parent = s, this.lastNode = null;
        }, c;
      })()
    );
    e.DomHandler = o, e.default = o;
  })(Vs)), Vs;
}
var Gs = {}, Bi = {}, Xi = {}, bm = {}, Fo = {}, Td = {}, E7;
function yZ() {
  if (E7) return Td;
  E7 = 1, Object.defineProperty(Td, "__esModule", { value: !0 });
  function e(t) {
    for (var n = 1; n < t.length; n++)
      t[n][0] += t[n - 1][0] + 1;
    return t;
  }
  return Td.default = new Map(/* @__PURE__ */ e([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ e([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ e([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ e([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), Td;
}
var xm = {}, O7;
function n2() {
  return O7 || (O7 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var t = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    e.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(i, a) {
      return i.codePointAt(a);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(i, a) {
        return (i.charCodeAt(a) & 64512) === 55296 ? (i.charCodeAt(a) - 55296) * 1024 + i.charCodeAt(a + 1) - 56320 + 65536 : i.charCodeAt(a);
      }
    );
    function n(i) {
      for (var a = "", o = 0, c; (c = e.xmlReplacer.exec(i)) !== null; ) {
        var u = c.index, s = i.charCodeAt(u), l = t.get(s);
        l !== void 0 ? (a += i.substring(o, u) + l, o = u + 1) : (a += "".concat(i.substring(o, u), "&#x").concat((0, e.getCodePoint)(i, u).toString(16), ";"), o = e.xmlReplacer.lastIndex += +((s & 64512) === 55296));
      }
      return a + i.substr(o);
    }
    e.encodeXML = n, e.escape = n;
    function r(i, a) {
      return function(c) {
        for (var u, s = 0, l = ""; u = i.exec(c); )
          s !== u.index && (l += c.substring(s, u.index)), l += a.get(u[0].charCodeAt(0)), s = u.index + 1;
        return l + c.substring(s);
      };
    }
    e.escapeUTF8 = r(/[&<>'"]/g, t), e.escapeAttribute = r(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), e.escapeText = r(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  })(xm)), xm;
}
var T7;
function P7() {
  if (T7) return Fo;
  T7 = 1;
  var e = Fo && Fo.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(Fo, "__esModule", { value: !0 }), Fo.encodeNonAsciiHTML = Fo.encodeHTML = void 0;
  var t = e(/* @__PURE__ */ yZ()), n = /* @__PURE__ */ n2(), r = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function i(c) {
    return o(r, c);
  }
  Fo.encodeHTML = i;
  function a(c) {
    return o(n.xmlReplacer, c);
  }
  Fo.encodeNonAsciiHTML = a;
  function o(c, u) {
    for (var s = "", l = 0, d; (d = c.exec(u)) !== null; ) {
      var f = d.index;
      s += u.substring(l, f);
      var p = u.charCodeAt(f), g = t.default.get(p);
      if (typeof g == "object") {
        if (f + 1 < u.length) {
          var b = u.charCodeAt(f + 1), w = typeof g.n == "number" ? g.n === b ? g.o : void 0 : g.n.get(b);
          if (w !== void 0) {
            s += w, l = c.lastIndex += 1;
            continue;
          }
        }
        g = g.v;
      }
      if (g !== void 0)
        s += g, l = f + 1;
      else {
        var y = (0, n.getCodePoint)(u, f);
        s += "&#x".concat(y.toString(16), ";"), l = c.lastIndex += +(y !== p);
      }
    }
    return s + u.substr(l);
  }
  return Fo;
}
var R7;
function bZ() {
  return R7 || (R7 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
    var t = /* @__PURE__ */ C0(), n = /* @__PURE__ */ P7(), r = /* @__PURE__ */ n2(), i;
    (function(f) {
      f[f.XML = 0] = "XML", f[f.HTML = 1] = "HTML";
    })(i = e.EntityLevel || (e.EntityLevel = {}));
    var a;
    (function(f) {
      f[f.UTF8 = 0] = "UTF8", f[f.ASCII = 1] = "ASCII", f[f.Extensive = 2] = "Extensive", f[f.Attribute = 3] = "Attribute", f[f.Text = 4] = "Text";
    })(a = e.EncodingMode || (e.EncodingMode = {}));
    function o(f, p) {
      p === void 0 && (p = i.XML);
      var g = typeof p == "number" ? p : p.level;
      if (g === i.HTML) {
        var b = typeof p == "object" ? p.mode : void 0;
        return (0, t.decodeHTML)(f, b);
      }
      return (0, t.decodeXML)(f);
    }
    e.decode = o;
    function c(f, p) {
      var g;
      p === void 0 && (p = i.XML);
      var b = typeof p == "number" ? { level: p } : p;
      return (g = b.mode) !== null && g !== void 0 || (b.mode = t.DecodingMode.Strict), o(f, b);
    }
    e.decodeStrict = c;
    function u(f, p) {
      p === void 0 && (p = i.XML);
      var g = typeof p == "number" ? { level: p } : p;
      return g.mode === a.UTF8 ? (0, r.escapeUTF8)(f) : g.mode === a.Attribute ? (0, r.escapeAttribute)(f) : g.mode === a.Text ? (0, r.escapeText)(f) : g.level === i.HTML ? g.mode === a.ASCII ? (0, n.encodeNonAsciiHTML)(f) : (0, n.encodeHTML)(f) : (0, r.encodeXML)(f);
    }
    e.encode = u;
    var s = /* @__PURE__ */ n2();
    Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
      return s.encodeXML;
    } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
      return s.escape;
    } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
      return s.escapeUTF8;
    } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
      return s.escapeAttribute;
    } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
      return s.escapeText;
    } });
    var l = /* @__PURE__ */ P7();
    Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
      return l.encodeHTML;
    } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return l.encodeNonAsciiHTML;
    } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
      return l.encodeHTML;
    } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
      return l.encodeHTML;
    } });
    var d = /* @__PURE__ */ C0();
    Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
      return d.EntityDecoder;
    } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
      return d.DecodingMode;
    } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
      return d.decodeXML;
    } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
      return d.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return d.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return d.decodeHTMLAttribute;
    } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
      return d.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
      return d.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return d.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return d.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
      return d.decodeXML;
    } });
  })(bm)), bm;
}
var Ws = {}, I7;
function xZ() {
  return I7 || (I7 = 1, Object.defineProperty(Ws, "__esModule", { value: !0 }), Ws.attributeNames = Ws.elementNames = void 0, Ws.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  })), Ws.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  }))), Ws;
}
var j7;
function _Z() {
  if (j7) return Xi;
  j7 = 1;
  var e = Xi && Xi.__assign || function() {
    return e = Object.assign || function(E) {
      for (var O, M = 1, L = arguments.length; M < L; M++) {
        O = arguments[M];
        for (var Z in O) Object.prototype.hasOwnProperty.call(O, Z) && (E[Z] = O[Z]);
      }
      return E;
    }, e.apply(this, arguments);
  }, t = Xi && Xi.__createBinding || (Object.create ? (function(E, O, M, L) {
    L === void 0 && (L = M);
    var Z = Object.getOwnPropertyDescriptor(O, M);
    (!Z || ("get" in Z ? !O.__esModule : Z.writable || Z.configurable)) && (Z = { enumerable: !0, get: function() {
      return O[M];
    } }), Object.defineProperty(E, L, Z);
  }) : (function(E, O, M, L) {
    L === void 0 && (L = M), E[L] = O[M];
  })), n = Xi && Xi.__setModuleDefault || (Object.create ? (function(E, O) {
    Object.defineProperty(E, "default", { enumerable: !0, value: O });
  }) : function(E, O) {
    E.default = O;
  }), r = Xi && Xi.__importStar || function(E) {
    if (E && E.__esModule) return E;
    var O = {};
    if (E != null) for (var M in E) M !== "default" && Object.prototype.hasOwnProperty.call(E, M) && t(O, E, M);
    return n(O, E), O;
  };
  Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.render = void 0;
  var i = r(/* @__PURE__ */ ep()), a = /* @__PURE__ */ bZ(), o = /* @__PURE__ */ xZ(), c = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function u(E) {
    return E.replace(/"/g, "&quot;");
  }
  function s(E, O) {
    var M;
    if (E) {
      var L = ((M = O.encodeEntities) !== null && M !== void 0 ? M : O.decodeEntities) === !1 ? u : O.xmlMode || O.encodeEntities !== "utf8" ? a.encodeXML : a.escapeAttribute;
      return Object.keys(E).map(function(Z) {
        var Q, ae, re = (Q = E[Z]) !== null && Q !== void 0 ? Q : "";
        return O.xmlMode === "foreign" && (Z = (ae = o.attributeNames.get(Z)) !== null && ae !== void 0 ? ae : Z), !O.emptyAttrs && !O.xmlMode && re === "" ? Z : "".concat(Z, '="').concat(L(re), '"');
      }).join(" ");
    }
  }
  var l = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function d(E, O) {
    O === void 0 && (O = {});
    for (var M = ("length" in E) ? E : [E], L = "", Z = 0; Z < M.length; Z++)
      L += f(M[Z], O);
    return L;
  }
  Xi.render = d, Xi.default = d;
  function f(E, O) {
    switch (E.type) {
      case i.Root:
        return d(E.children, O);
      // @ts-expect-error We don't use `Doctype` yet
      case i.Doctype:
      case i.Directive:
        return w(E);
      case i.Comment:
        return _(E);
      case i.CDATA:
        return v(E);
      case i.Script:
      case i.Style:
      case i.Tag:
        return b(E, O);
      case i.Text:
        return y(E, O);
    }
  }
  var p = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), g = /* @__PURE__ */ new Set(["svg", "math"]);
  function b(E, O) {
    var M;
    O.xmlMode === "foreign" && (E.name = (M = o.elementNames.get(E.name)) !== null && M !== void 0 ? M : E.name, E.parent && p.has(E.parent.name) && (O = e(e({}, O), { xmlMode: !1 }))), !O.xmlMode && g.has(E.name) && (O = e(e({}, O), { xmlMode: "foreign" }));
    var L = "<".concat(E.name), Z = s(E.attribs, O);
    return Z && (L += " ".concat(Z)), E.children.length === 0 && (O.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      O.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      O.selfClosingTags && l.has(E.name)
    )) ? (O.xmlMode || (L += " "), L += "/>") : (L += ">", E.children.length > 0 && (L += d(E.children, O)), (O.xmlMode || !l.has(E.name)) && (L += "</".concat(E.name, ">"))), L;
  }
  function w(E) {
    return "<".concat(E.data, ">");
  }
  function y(E, O) {
    var M, L = E.data || "";
    return ((M = O.encodeEntities) !== null && M !== void 0 ? M : O.decodeEntities) !== !1 && !(!O.xmlMode && E.parent && c.has(E.parent.name)) && (L = O.xmlMode || O.encodeEntities !== "utf8" ? (0, a.encodeXML)(L) : (0, a.escapeText)(L)), L;
  }
  function v(E) {
    return "<![CDATA[".concat(E.children[0].data, "]]>");
  }
  function _(E) {
    return "<!--".concat(E.data, "-->");
  }
  return Xi;
}
var q7;
function uO() {
  if (q7) return Bi;
  q7 = 1;
  var e = Bi && Bi.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(Bi, "__esModule", { value: !0 }), Bi.innerText = Bi.textContent = Bi.getText = Bi.getInnerHTML = Bi.getOuterHTML = void 0;
  var t = /* @__PURE__ */ Os(), n = e(/* @__PURE__ */ _Z()), r = /* @__PURE__ */ ep();
  function i(s, l) {
    return (0, n.default)(s, l);
  }
  Bi.getOuterHTML = i;
  function a(s, l) {
    return (0, t.hasChildren)(s) ? s.children.map(function(d) {
      return i(d, l);
    }).join("") : "";
  }
  Bi.getInnerHTML = a;
  function o(s) {
    return Array.isArray(s) ? s.map(o).join("") : (0, t.isTag)(s) ? s.name === "br" ? `
` : o(s.children) : (0, t.isCDATA)(s) ? o(s.children) : (0, t.isText)(s) ? s.data : "";
  }
  Bi.getText = o;
  function c(s) {
    return Array.isArray(s) ? s.map(c).join("") : (0, t.hasChildren)(s) && !(0, t.isComment)(s) ? c(s.children) : (0, t.isText)(s) ? s.data : "";
  }
  Bi.textContent = c;
  function u(s) {
    return Array.isArray(s) ? s.map(u).join("") : (0, t.hasChildren)(s) && (s.type === r.ElementType.Tag || (0, t.isCDATA)(s)) ? u(s.children) : (0, t.isText)(s) ? s.data : "";
  }
  return Bi.innerText = u, Bi;
}
var li = {}, D7;
function wZ() {
  if (D7) return li;
  D7 = 1, Object.defineProperty(li, "__esModule", { value: !0 }), li.prevElementSibling = li.nextElementSibling = li.getName = li.hasAttrib = li.getAttributeValue = li.getSiblings = li.getParent = li.getChildren = void 0;
  var e = /* @__PURE__ */ Os();
  function t(s) {
    return (0, e.hasChildren)(s) ? s.children : [];
  }
  li.getChildren = t;
  function n(s) {
    return s.parent || null;
  }
  li.getParent = n;
  function r(s) {
    var l, d, f = n(s);
    if (f != null)
      return t(f);
    for (var p = [s], g = s.prev, b = s.next; g != null; )
      p.unshift(g), l = g, g = l.prev;
    for (; b != null; )
      p.push(b), d = b, b = d.next;
    return p;
  }
  li.getSiblings = r;
  function i(s, l) {
    var d;
    return (d = s.attribs) === null || d === void 0 ? void 0 : d[l];
  }
  li.getAttributeValue = i;
  function a(s, l) {
    return s.attribs != null && Object.prototype.hasOwnProperty.call(s.attribs, l) && s.attribs[l] != null;
  }
  li.hasAttrib = a;
  function o(s) {
    return s.name;
  }
  li.getName = o;
  function c(s) {
    for (var l, d = s.next; d !== null && !(0, e.isTag)(d); )
      l = d, d = l.next;
    return d;
  }
  li.nextElementSibling = c;
  function u(s) {
    for (var l, d = s.prev; d !== null && !(0, e.isTag)(d); )
      l = d, d = l.prev;
    return d;
  }
  return li.prevElementSibling = u, li;
}
var Ui = {}, $7;
function SZ() {
  if ($7) return Ui;
  $7 = 1, Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.prepend = Ui.prependChild = Ui.append = Ui.appendChild = Ui.replaceElement = Ui.removeElement = void 0;
  function e(o) {
    if (o.prev && (o.prev.next = o.next), o.next && (o.next.prev = o.prev), o.parent) {
      var c = o.parent.children, u = c.lastIndexOf(o);
      u >= 0 && c.splice(u, 1);
    }
    o.next = null, o.prev = null, o.parent = null;
  }
  Ui.removeElement = e;
  function t(o, c) {
    var u = c.prev = o.prev;
    u && (u.next = c);
    var s = c.next = o.next;
    s && (s.prev = c);
    var l = c.parent = o.parent;
    if (l) {
      var d = l.children;
      d[d.lastIndexOf(o)] = c, o.parent = null;
    }
  }
  Ui.replaceElement = t;
  function n(o, c) {
    if (e(c), c.next = null, c.parent = o, o.children.push(c) > 1) {
      var u = o.children[o.children.length - 2];
      u.next = c, c.prev = u;
    } else
      c.prev = null;
  }
  Ui.appendChild = n;
  function r(o, c) {
    e(c);
    var u = o.parent, s = o.next;
    if (c.next = s, c.prev = o, o.next = c, c.parent = u, s) {
      if (s.prev = c, u) {
        var l = u.children;
        l.splice(l.lastIndexOf(s), 0, c);
      }
    } else u && u.children.push(c);
  }
  Ui.append = r;
  function i(o, c) {
    if (e(c), c.parent = o, c.prev = null, o.children.unshift(c) !== 1) {
      var u = o.children[1];
      u.prev = c, c.next = u;
    } else
      c.next = null;
  }
  Ui.prependChild = i;
  function a(o, c) {
    e(c);
    var u = o.parent;
    if (u) {
      var s = u.children;
      s.splice(s.indexOf(o), 0, c);
    }
    o.prev && (o.prev.next = c), c.parent = u, c.prev = o.prev, c.next = o, o.prev = c;
  }
  return Ui.prepend = a, Ui;
}
var Hi = {}, L7;
function cO() {
  if (L7) return Hi;
  L7 = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.findAll = Hi.existsOne = Hi.findOne = Hi.findOneChild = Hi.find = Hi.filter = void 0;
  var e = /* @__PURE__ */ Os();
  function t(c, u, s, l) {
    return s === void 0 && (s = !0), l === void 0 && (l = 1 / 0), n(c, Array.isArray(u) ? u : [u], s, l);
  }
  Hi.filter = t;
  function n(c, u, s, l) {
    for (var d = [], f = [u], p = [0]; ; ) {
      if (p[0] >= f[0].length) {
        if (p.length === 1)
          return d;
        f.shift(), p.shift();
        continue;
      }
      var g = f[0][p[0]++];
      if (c(g) && (d.push(g), --l <= 0))
        return d;
      s && (0, e.hasChildren)(g) && g.children.length > 0 && (p.unshift(0), f.unshift(g.children));
    }
  }
  Hi.find = n;
  function r(c, u) {
    return u.find(c);
  }
  Hi.findOneChild = r;
  function i(c, u, s) {
    s === void 0 && (s = !0);
    for (var l = null, d = 0; d < u.length && !l; d++) {
      var f = u[d];
      if ((0, e.isTag)(f))
        c(f) ? l = f : s && f.children.length > 0 && (l = i(c, f.children, !0));
      else continue;
    }
    return l;
  }
  Hi.findOne = i;
  function a(c, u) {
    return u.some(function(s) {
      return (0, e.isTag)(s) && (c(s) || a(c, s.children));
    });
  }
  Hi.existsOne = a;
  function o(c, u) {
    for (var s = [], l = [u], d = [0]; ; ) {
      if (d[0] >= l[0].length) {
        if (l.length === 1)
          return s;
        l.shift(), d.shift();
        continue;
      }
      var f = l[0][d[0]++];
      (0, e.isTag)(f) && (c(f) && s.push(f), f.children.length > 0 && (d.unshift(0), l.unshift(f.children)));
    }
  }
  return Hi.findAll = o, Hi;
}
var la = {}, N7;
function lO() {
  if (N7) return la;
  N7 = 1, Object.defineProperty(la, "__esModule", { value: !0 }), la.getElementsByTagType = la.getElementsByTagName = la.getElementById = la.getElements = la.testElement = void 0;
  var e = /* @__PURE__ */ Os(), t = /* @__PURE__ */ cO(), n = {
    tag_name: function(d) {
      return typeof d == "function" ? function(f) {
        return (0, e.isTag)(f) && d(f.name);
      } : d === "*" ? e.isTag : function(f) {
        return (0, e.isTag)(f) && f.name === d;
      };
    },
    tag_type: function(d) {
      return typeof d == "function" ? function(f) {
        return d(f.type);
      } : function(f) {
        return f.type === d;
      };
    },
    tag_contains: function(d) {
      return typeof d == "function" ? function(f) {
        return (0, e.isText)(f) && d(f.data);
      } : function(f) {
        return (0, e.isText)(f) && f.data === d;
      };
    }
  };
  function r(d, f) {
    return typeof f == "function" ? function(p) {
      return (0, e.isTag)(p) && f(p.attribs[d]);
    } : function(p) {
      return (0, e.isTag)(p) && p.attribs[d] === f;
    };
  }
  function i(d, f) {
    return function(p) {
      return d(p) || f(p);
    };
  }
  function a(d) {
    var f = Object.keys(d).map(function(p) {
      var g = d[p];
      return Object.prototype.hasOwnProperty.call(n, p) ? n[p](g) : r(p, g);
    });
    return f.length === 0 ? null : f.reduce(i);
  }
  function o(d, f) {
    var p = a(d);
    return p ? p(f) : !0;
  }
  la.testElement = o;
  function c(d, f, p, g) {
    g === void 0 && (g = 1 / 0);
    var b = a(d);
    return b ? (0, t.filter)(b, f, p, g) : [];
  }
  la.getElements = c;
  function u(d, f, p) {
    return p === void 0 && (p = !0), Array.isArray(f) || (f = [f]), (0, t.findOne)(r("id", d), f, p);
  }
  la.getElementById = u;
  function s(d, f, p, g) {
    return p === void 0 && (p = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(n.tag_name(d), f, p, g);
  }
  la.getElementsByTagName = s;
  function l(d, f, p, g) {
    return p === void 0 && (p = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(n.tag_type(d), f, p, g);
  }
  return la.getElementsByTagType = l, la;
}
var _m = {}, F7;
function CZ() {
  return F7 || (F7 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.uniqueSort = e.compareDocumentPosition = e.DocumentPosition = e.removeSubsets = void 0;
    var t = /* @__PURE__ */ Os();
    function n(o) {
      for (var c = o.length; --c >= 0; ) {
        var u = o[c];
        if (c > 0 && o.lastIndexOf(u, c - 1) >= 0) {
          o.splice(c, 1);
          continue;
        }
        for (var s = u.parent; s; s = s.parent)
          if (o.includes(s)) {
            o.splice(c, 1);
            break;
          }
      }
      return o;
    }
    e.removeSubsets = n;
    var r;
    (function(o) {
      o[o.DISCONNECTED = 1] = "DISCONNECTED", o[o.PRECEDING = 2] = "PRECEDING", o[o.FOLLOWING = 4] = "FOLLOWING", o[o.CONTAINS = 8] = "CONTAINS", o[o.CONTAINED_BY = 16] = "CONTAINED_BY";
    })(r = e.DocumentPosition || (e.DocumentPosition = {}));
    function i(o, c) {
      var u = [], s = [];
      if (o === c)
        return 0;
      for (var l = (0, t.hasChildren)(o) ? o : o.parent; l; )
        u.unshift(l), l = l.parent;
      for (l = (0, t.hasChildren)(c) ? c : c.parent; l; )
        s.unshift(l), l = l.parent;
      for (var d = Math.min(u.length, s.length), f = 0; f < d && u[f] === s[f]; )
        f++;
      if (f === 0)
        return r.DISCONNECTED;
      var p = u[f - 1], g = p.children, b = u[f], w = s[f];
      return g.indexOf(b) > g.indexOf(w) ? p === c ? r.FOLLOWING | r.CONTAINED_BY : r.FOLLOWING : p === o ? r.PRECEDING | r.CONTAINS : r.PRECEDING;
    }
    e.compareDocumentPosition = i;
    function a(o) {
      return o = o.filter(function(c, u, s) {
        return !s.includes(c, u + 1);
      }), o.sort(function(c, u) {
        var s = i(c, u);
        return s & r.PRECEDING ? -1 : s & r.FOLLOWING ? 1 : 0;
      }), o;
    }
    e.uniqueSort = a;
  })(_m)), _m;
}
var bl = {}, M7;
function kZ() {
  if (M7) return bl;
  M7 = 1, Object.defineProperty(bl, "__esModule", { value: !0 }), bl.getFeed = void 0;
  var e = /* @__PURE__ */ uO(), t = /* @__PURE__ */ lO();
  function n(f) {
    var p = u(d, f);
    return p ? p.name === "feed" ? r(p) : i(p) : null;
  }
  bl.getFeed = n;
  function r(f) {
    var p, g = f.children, b = {
      type: "atom",
      items: (0, t.getElementsByTagName)("entry", g).map(function(v) {
        var _, E = v.children, O = { media: c(E) };
        l(O, "id", "id", E), l(O, "title", "title", E);
        var M = (_ = u("link", E)) === null || _ === void 0 ? void 0 : _.attribs.href;
        M && (O.link = M);
        var L = s("summary", E) || s("content", E);
        L && (O.description = L);
        var Z = s("updated", E);
        return Z && (O.pubDate = new Date(Z)), O;
      })
    };
    l(b, "id", "id", g), l(b, "title", "title", g);
    var w = (p = u("link", g)) === null || p === void 0 ? void 0 : p.attribs.href;
    w && (b.link = w), l(b, "description", "subtitle", g);
    var y = s("updated", g);
    return y && (b.updated = new Date(y)), l(b, "author", "email", g, !0), b;
  }
  function i(f) {
    var p, g, b = (g = (p = u("channel", f.children)) === null || p === void 0 ? void 0 : p.children) !== null && g !== void 0 ? g : [], w = {
      type: f.name.substr(0, 3),
      id: "",
      items: (0, t.getElementsByTagName)("item", f.children).map(function(v) {
        var _ = v.children, E = { media: c(_) };
        l(E, "id", "guid", _), l(E, "title", "title", _), l(E, "link", "link", _), l(E, "description", "description", _);
        var O = s("pubDate", _) || s("dc:date", _);
        return O && (E.pubDate = new Date(O)), E;
      })
    };
    l(w, "title", "title", b), l(w, "link", "link", b), l(w, "description", "description", b);
    var y = s("lastBuildDate", b);
    return y && (w.updated = new Date(y)), l(w, "author", "managingEditor", b, !0), w;
  }
  var a = ["url", "type", "lang"], o = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function c(f) {
    return (0, t.getElementsByTagName)("media:content", f).map(function(p) {
      for (var g = p.attribs, b = {
        medium: g.medium,
        isDefault: !!g.isDefault
      }, w = 0, y = a; w < y.length; w++) {
        var v = y[w];
        g[v] && (b[v] = g[v]);
      }
      for (var _ = 0, E = o; _ < E.length; _++) {
        var v = E[_];
        g[v] && (b[v] = parseInt(g[v], 10));
      }
      return g.expression && (b.expression = g.expression), b;
    });
  }
  function u(f, p) {
    return (0, t.getElementsByTagName)(f, p, !0, 1)[0];
  }
  function s(f, p, g) {
    return g === void 0 && (g = !1), (0, e.textContent)((0, t.getElementsByTagName)(f, p, g, 1)).trim();
  }
  function l(f, p, g, b, w) {
    w === void 0 && (w = !1);
    var y = s(g, b, w);
    y && (f[p] = y);
  }
  function d(f) {
    return f === "rss" || f === "feed" || f === "rdf:RDF";
  }
  return bl;
}
var B7;
function wm() {
  return B7 || (B7 = 1, (function(e) {
    var t = Gs && Gs.__createBinding || (Object.create ? (function(i, a, o, c) {
      c === void 0 && (c = o);
      var u = Object.getOwnPropertyDescriptor(a, o);
      (!u || ("get" in u ? !a.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return a[o];
      } }), Object.defineProperty(i, c, u);
    }) : (function(i, a, o, c) {
      c === void 0 && (c = o), i[c] = a[o];
    })), n = Gs && Gs.__exportStar || function(i, a) {
      for (var o in i) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && t(a, i, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, n(/* @__PURE__ */ uO(), e), n(/* @__PURE__ */ wZ(), e), n(/* @__PURE__ */ SZ(), e), n(/* @__PURE__ */ cO(), e), n(/* @__PURE__ */ lO(), e), n(/* @__PURE__ */ CZ(), e), n(/* @__PURE__ */ kZ(), e);
    var r = /* @__PURE__ */ Os();
    Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
      return r.isTag;
    } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
      return r.isCDATA;
    } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
      return r.isText;
    } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
      return r.isComment;
    } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
      return r.isDocument;
    } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
      return r.hasChildren;
    } });
  })(Gs)), Gs;
}
var U7;
function AZ() {
  return U7 || (U7 = 1, (function(e) {
    var t = Wa && Wa.__createBinding || (Object.create ? (function(y, v, _, E) {
      E === void 0 && (E = _);
      var O = Object.getOwnPropertyDescriptor(v, _);
      (!O || ("get" in O ? !v.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
        return v[_];
      } }), Object.defineProperty(y, E, O);
    }) : (function(y, v, _, E) {
      E === void 0 && (E = _), y[E] = v[_];
    })), n = Wa && Wa.__setModuleDefault || (Object.create ? (function(y, v) {
      Object.defineProperty(y, "default", { enumerable: !0, value: v });
    }) : function(y, v) {
      y.default = v;
    }), r = Wa && Wa.__importStar || function(y) {
      if (y && y.__esModule) return y;
      var v = {};
      if (y != null) for (var _ in y) _ !== "default" && Object.prototype.hasOwnProperty.call(y, _) && t(v, y, _);
      return n(v, y), v;
    }, i = Wa && Wa.__importDefault || function(y) {
      return y && y.__esModule ? y : { default: y };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.Tokenizer = e.createDomStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
    var a = /* @__PURE__ */ w7(), o = /* @__PURE__ */ w7();
    Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
      return o.Parser;
    } });
    var c = /* @__PURE__ */ Os(), u = /* @__PURE__ */ Os();
    Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
      return u.DomHandler;
    } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
      return u.DomHandler;
    } });
    function s(y, v) {
      var _ = new c.DomHandler(void 0, v);
      return new a.Parser(_, v).end(y), _.root;
    }
    e.parseDocument = s;
    function l(y, v) {
      return s(y, v).children;
    }
    e.parseDOM = l;
    function d(y, v, _) {
      var E = new c.DomHandler(y, v, _);
      return new a.Parser(E, v);
    }
    e.createDomStream = d;
    var f = /* @__PURE__ */ sO();
    Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
      return i(f).default;
    } }), e.ElementType = r(/* @__PURE__ */ ep());
    var p = /* @__PURE__ */ wm(), g = /* @__PURE__ */ wm();
    Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
      return g.getFeed;
    } });
    var b = { xmlMode: !0 };
    function w(y, v) {
      return v === void 0 && (v = b), (0, p.getFeed)(l(y, v));
    }
    e.parseFeed = w, e.DomUtils = r(/* @__PURE__ */ wm());
  })(Wa)), Wa;
}
var Sm, H7;
function EZ() {
  return H7 || (H7 = 1, Sm = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), Sm;
}
var Pd = {}, z7;
function OZ() {
  if (z7) return Pd;
  z7 = 1, Object.defineProperty(Pd, "__esModule", { value: !0 });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function e(n) {
    return Object.prototype.toString.call(n) === "[object Object]";
  }
  function t(n) {
    var r, i;
    return e(n) === !1 ? !1 : (r = n.constructor, r === void 0 ? !0 : (i = r.prototype, !(e(i) === !1 || i.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return Pd.isPlainObject = t, Pd;
}
var Cm, V7;
function TZ() {
  if (V7) return Cm;
  V7 = 1;
  var e = function(v) {
    return t(v) && !n(v);
  };
  function t(y) {
    return !!y && typeof y == "object";
  }
  function n(y) {
    var v = Object.prototype.toString.call(y);
    return v === "[object RegExp]" || v === "[object Date]" || a(y);
  }
  var r = typeof Symbol == "function" && Symbol.for, i = r ? Symbol.for("react.element") : 60103;
  function a(y) {
    return y.$$typeof === i;
  }
  function o(y) {
    return Array.isArray(y) ? [] : {};
  }
  function c(y, v) {
    return v.clone !== !1 && v.isMergeableObject(y) ? b(o(y), y, v) : y;
  }
  function u(y, v, _) {
    return y.concat(v).map(function(E) {
      return c(E, _);
    });
  }
  function s(y, v) {
    if (!v.customMerge)
      return b;
    var _ = v.customMerge(y);
    return typeof _ == "function" ? _ : b;
  }
  function l(y) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(y).filter(function(v) {
      return Object.propertyIsEnumerable.call(y, v);
    }) : [];
  }
  function d(y) {
    return Object.keys(y).concat(l(y));
  }
  function f(y, v) {
    try {
      return v in y;
    } catch {
      return !1;
    }
  }
  function p(y, v) {
    return f(y, v) && !(Object.hasOwnProperty.call(y, v) && Object.propertyIsEnumerable.call(y, v));
  }
  function g(y, v, _) {
    var E = {};
    return _.isMergeableObject(y) && d(y).forEach(function(O) {
      E[O] = c(y[O], _);
    }), d(v).forEach(function(O) {
      p(y, O) || (f(y, O) && _.isMergeableObject(v[O]) ? E[O] = s(O, _)(y[O], v[O], _) : E[O] = c(v[O], _));
    }), E;
  }
  function b(y, v, _) {
    _ = _ || {}, _.arrayMerge = _.arrayMerge || u, _.isMergeableObject = _.isMergeableObject || e, _.cloneUnlessOtherwiseSpecified = c;
    var E = Array.isArray(v), O = Array.isArray(y), M = E === O;
    return M ? E ? _.arrayMerge(y, v, _) : g(y, v, _) : c(v, _);
  }
  b.all = function(v, _) {
    if (!Array.isArray(v))
      throw new Error("first argument should be an array");
    return v.reduce(function(E, O) {
      return b(E, O, _);
    }, {});
  };
  var w = b;
  return Cm = w, Cm;
}
var Ud = { exports: {} }, PZ = Ud.exports, G7;
function RZ() {
  return G7 || (G7 = 1, (function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.parseSrcset = n();
    })(PZ, function() {
      return function(t) {
        function n(E) {
          return E === " " || // space
          E === "	" || // horizontal tab
          E === `
` || // new line
          E === "\f" || // form feed
          E === "\r";
        }
        function r(E) {
          var O, M = E.exec(t.substring(w));
          if (M)
            return O = M[0], w += O.length, O;
        }
        for (var i = t.length, a = /^[ \t\n\r\u000c]+/, o = /^[, \t\n\r\u000c]+/, c = /^[^ \t\n\r\u000c]+/, u = /[,]+$/, s = /^\d+$/, l = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, d, f, p, g, b, w = 0, y = []; ; ) {
          if (r(o), w >= i)
            return y;
          d = r(c), f = [], d.slice(-1) === "," ? (d = d.replace(u, ""), _()) : v();
        }
        function v() {
          for (r(a), p = "", g = "in descriptor"; ; ) {
            if (b = t.charAt(w), g === "in descriptor")
              if (n(b))
                p && (f.push(p), p = "", g = "after descriptor");
              else if (b === ",") {
                w += 1, p && f.push(p), _();
                return;
              } else if (b === "(")
                p = p + b, g = "in parens";
              else if (b === "") {
                p && f.push(p), _();
                return;
              } else
                p = p + b;
            else if (g === "in parens")
              if (b === ")")
                p = p + b, g = "in descriptor";
              else if (b === "") {
                f.push(p), _();
                return;
              } else
                p = p + b;
            else if (g === "after descriptor" && !n(b))
              if (b === "") {
                _();
                return;
              } else
                g = "in descriptor", w -= 1;
            w += 1;
          }
        }
        function _() {
          var E = !1, O, M, L, Z, Q = {}, ae, re, X, de, Ce;
          for (Z = 0; Z < f.length; Z++)
            ae = f[Z], re = ae[ae.length - 1], X = ae.substring(0, ae.length - 1), de = parseInt(X, 10), Ce = parseFloat(X), s.test(X) && re === "w" ? ((O || M) && (E = !0), de === 0 ? E = !0 : O = de) : l.test(X) && re === "x" ? ((O || M || L) && (E = !0), Ce < 0 ? E = !0 : M = Ce) : s.test(X) && re === "h" ? ((L || M) && (E = !0), de === 0 ? E = !0 : L = de) : E = !0;
          E ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + ae + "'.") : (Q.url = d, O && (Q.w = O), M && (Q.d = M), L && (Q.h = L), y.push(Q));
        }
      };
    });
  })(Ud)), Ud.exports;
}
var Rd = { exports: {} }, W7;
function IZ() {
  if (W7) return Rd.exports;
  W7 = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return Rd.exports = t(), Rd.exports.createColors = t, Rd.exports;
}
var km, K7;
function lg() {
  if (K7) return km;
  K7 = 1;
  let e = /* @__PURE__ */ IZ(), t = ni;
  class n extends Error {
    constructor(i, a, o, c, u, s) {
      super(i), this.name = "CssSyntaxError", this.reason = i, u && (this.file = u), c && (this.source = c), s && (this.plugin = s), typeof a < "u" && typeof o < "u" && (typeof a == "number" ? (this.line = a, this.column = o) : (this.line = a.line, this.column = a.column, this.endLine = o.line, this.endColumn = o.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, n);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(i) {
      if (!this.source) return "";
      let a = this.source;
      i == null && (i = e.isColorSupported);
      let o = (p) => p, c = (p) => p, u = (p) => p;
      if (i) {
        let { bold: p, gray: g, red: b } = e.createColors(!0);
        c = (w) => p(b(w)), o = (w) => g(w), t && (u = (w) => t(w));
      }
      let s = a.split(/\r?\n/), l = Math.max(this.line - 3, 0), d = Math.min(this.line + 2, s.length), f = String(d).length;
      return s.slice(l, d).map((p, g) => {
        let b = l + 1 + g, w = " " + (" " + b).slice(-f) + " | ";
        if (b === this.line) {
          if (p.length > 160) {
            let v = 20, _ = Math.max(0, this.column - v), E = Math.max(
              this.column + v,
              this.endColumn + v
            ), O = p.slice(_, E), M = o(w.replace(/\d/g, " ")) + p.slice(0, Math.min(this.column - 1, v - 1)).replace(/[^\t]/g, " ");
            return c(">") + o(w) + u(O) + `
 ` + M + c("^");
          }
          let y = o(w.replace(/\d/g, " ")) + p.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return c(">") + o(w) + u(p) + `
 ` + y + c("^");
        }
        return " " + o(w) + u(p);
      }).join(`
`);
    }
    toString() {
      let i = this.showSourceCode();
      return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
    }
  }
  return km = n, n.default = n, km;
}
var Am, Z7;
function fO() {
  if (Z7) return Am;
  Z7 = 1;
  const e = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function t(r) {
    return r[0].toUpperCase() + r.slice(1);
  }
  class n {
    constructor(i) {
      this.builder = i;
    }
    atrule(i, a) {
      let o = "@" + i.name, c = i.params ? this.rawValue(i, "params") : "";
      if (typeof i.raws.afterName < "u" ? o += i.raws.afterName : c && (o += " "), i.nodes)
        this.block(i, o + c);
      else {
        let u = (i.raws.between || "") + (a ? ";" : "");
        this.builder(o + c + u, i);
      }
    }
    beforeAfter(i, a) {
      let o;
      i.type === "decl" ? o = this.raw(i, null, "beforeDecl") : i.type === "comment" ? o = this.raw(i, null, "beforeComment") : a === "before" ? o = this.raw(i, null, "beforeRule") : o = this.raw(i, null, "beforeClose");
      let c = i.parent, u = 0;
      for (; c && c.type !== "root"; )
        u += 1, c = c.parent;
      if (o.includes(`
`)) {
        let s = this.raw(i, null, "indent");
        if (s.length)
          for (let l = 0; l < u; l++) o += s;
      }
      return o;
    }
    block(i, a) {
      let o = this.raw(i, "between", "beforeOpen");
      this.builder(a + o + "{", i, "start");
      let c;
      i.nodes && i.nodes.length ? (this.body(i), c = this.raw(i, "after")) : c = this.raw(i, "after", "emptyBody"), c && this.builder(c), this.builder("}", i, "end");
    }
    body(i) {
      let a = i.nodes.length - 1;
      for (; a > 0 && i.nodes[a].type === "comment"; )
        a -= 1;
      let o = this.raw(i, "semicolon");
      for (let c = 0; c < i.nodes.length; c++) {
        let u = i.nodes[c], s = this.raw(u, "before");
        s && this.builder(s), this.stringify(u, a !== c || o);
      }
    }
    comment(i) {
      let a = this.raw(i, "left", "commentLeft"), o = this.raw(i, "right", "commentRight");
      this.builder("/*" + a + i.text + o + "*/", i);
    }
    decl(i, a) {
      let o = this.raw(i, "between", "colon"), c = i.prop + o + this.rawValue(i, "value");
      i.important && (c += i.raws.important || " !important"), a && (c += ";"), this.builder(c, i);
    }
    document(i) {
      this.body(i);
    }
    raw(i, a, o) {
      let c;
      if (o || (o = a), a && (c = i.raws[a], typeof c < "u"))
        return c;
      let u = i.parent;
      if (o === "before" && (!u || u.type === "root" && u.first === i || u && u.type === "document"))
        return "";
      if (!u) return e[o];
      let s = i.root();
      if (s.rawCache || (s.rawCache = {}), typeof s.rawCache[o] < "u")
        return s.rawCache[o];
      if (o === "before" || o === "after")
        return this.beforeAfter(i, o);
      {
        let l = "raw" + t(o);
        this[l] ? c = this[l](s, i) : s.walk((d) => {
          if (c = d.raws[a], typeof c < "u") return !1;
        });
      }
      return typeof c > "u" && (c = e[o]), s.rawCache[o] = c, c;
    }
    rawBeforeClose(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && o.nodes.length > 0 && typeof o.raws.after < "u")
          return a = o.raws.after, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeComment(i, a) {
      let o;
      return i.walkComments((c) => {
        if (typeof c.raws.before < "u")
          return o = c.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
      }), typeof o > "u" ? o = this.raw(a, null, "beforeDecl") : o && (o = o.replace(/\S/g, "")), o;
    }
    rawBeforeDecl(i, a) {
      let o;
      return i.walkDecls((c) => {
        if (typeof c.raws.before < "u")
          return o = c.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
      }), typeof o > "u" ? o = this.raw(a, null, "beforeRule") : o && (o = o.replace(/\S/g, "")), o;
    }
    rawBeforeOpen(i) {
      let a;
      return i.walk((o) => {
        if (o.type !== "decl" && (a = o.raws.between, typeof a < "u"))
          return !1;
      }), a;
    }
    rawBeforeRule(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && (o.parent !== i || i.first !== o) && typeof o.raws.before < "u")
          return a = o.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), a && (a = a.replace(/\S/g, "")), a;
    }
    rawColon(i) {
      let a;
      return i.walkDecls((o) => {
        if (typeof o.raws.between < "u")
          return a = o.raws.between.replace(/[^\s:]/g, ""), !1;
      }), a;
    }
    rawEmptyBody(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && o.nodes.length === 0 && (a = o.raws.after, typeof a < "u"))
          return !1;
      }), a;
    }
    rawIndent(i) {
      if (i.raws.indent) return i.raws.indent;
      let a;
      return i.walk((o) => {
        let c = o.parent;
        if (c && c !== i && c.parent && c.parent === i && typeof o.raws.before < "u") {
          let u = o.raws.before.split(`
`);
          return a = u[u.length - 1], a = a.replace(/\S/g, ""), !1;
        }
      }), a;
    }
    rawSemicolon(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && o.nodes.length && o.last.type === "decl" && (a = o.raws.semicolon, typeof a < "u"))
          return !1;
      }), a;
    }
    rawValue(i, a) {
      let o = i[a], c = i.raws[a];
      return c && c.value === o ? c.raw : o;
    }
    root(i) {
      this.body(i), i.raws.after && this.builder(i.raws.after);
    }
    rule(i) {
      this.block(i, this.rawValue(i, "selector")), i.raws.ownSemicolon && this.builder(i.raws.ownSemicolon, i, "end");
    }
    stringify(i, a) {
      if (!this[i.type])
        throw new Error(
          "Unknown AST node type " + i.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[i.type](i, a);
    }
  }
  return Am = n, n.default = n, Am;
}
var Em, Y7;
function r1() {
  if (Y7) return Em;
  Y7 = 1;
  let e = fO();
  function t(n, r) {
    new e(r).stringify(n);
  }
  return Em = t, t.default = t, Em;
}
var Id = {}, J7;
function fg() {
  return J7 || (J7 = 1, Id.isClean = Symbol("isClean"), Id.my = Symbol("my")), Id;
}
var Om, Q7;
function n1() {
  if (Q7) return Om;
  Q7 = 1;
  let e = lg(), t = fO(), n = r1(), { isClean: r, my: i } = fg();
  function a(u, s) {
    let l = new u.constructor();
    for (let d in u) {
      if (!Object.prototype.hasOwnProperty.call(u, d) || d === "proxyCache") continue;
      let f = u[d], p = typeof f;
      d === "parent" && p === "object" ? s && (l[d] = s) : d === "source" ? l[d] = f : Array.isArray(f) ? l[d] = f.map((g) => a(g, l)) : (p === "object" && f !== null && (f = a(f)), l[d] = f);
    }
    return l;
  }
  function o(u, s) {
    if (s && typeof s.offset < "u")
      return s.offset;
    let l = 1, d = 1, f = 0;
    for (let p = 0; p < u.length; p++) {
      if (d === s.line && l === s.column) {
        f = p;
        break;
      }
      u[p] === `
` ? (l = 1, d += 1) : l += 1;
    }
    return f;
  }
  class c {
    get proxyOf() {
      return this;
    }
    constructor(s = {}) {
      this.raws = {}, this[r] = !1, this[i] = !0;
      for (let l in s)
        if (l === "nodes") {
          this.nodes = [];
          for (let d of s[l])
            typeof d.clone == "function" ? this.append(d.clone()) : this.append(d);
        } else
          this[l] = s[l];
    }
    addToError(s) {
      if (s.postcssNode = this, s.stack && this.source && /\n\s{4}at /.test(s.stack)) {
        let l = this.source;
        s.stack = s.stack.replace(
          /\n\s{4}at /,
          `$&${l.input.from}:${l.start.line}:${l.start.column}$&`
        );
      }
      return s;
    }
    after(s) {
      return this.parent.insertAfter(this, s), this;
    }
    assign(s = {}) {
      for (let l in s)
        this[l] = s[l];
      return this;
    }
    before(s) {
      return this.parent.insertBefore(this, s), this;
    }
    cleanRaws(s) {
      delete this.raws.before, delete this.raws.after, s || delete this.raws.between;
    }
    clone(s = {}) {
      let l = a(this);
      for (let d in s)
        l[d] = s[d];
      return l;
    }
    cloneAfter(s = {}) {
      let l = this.clone(s);
      return this.parent.insertAfter(this, l), l;
    }
    cloneBefore(s = {}) {
      let l = this.clone(s);
      return this.parent.insertBefore(this, l), l;
    }
    error(s, l = {}) {
      if (this.source) {
        let { end: d, start: f } = this.rangeBy(l);
        return this.source.input.error(
          s,
          { column: f.column, line: f.line },
          { column: d.column, line: d.line },
          l
        );
      }
      return new e(s);
    }
    getProxyProcessor() {
      return {
        get(s, l) {
          return l === "proxyOf" ? s : l === "root" ? () => s.root().toProxy() : s[l];
        },
        set(s, l, d) {
          return s[l] === d || (s[l] = d, (l === "prop" || l === "value" || l === "name" || l === "params" || l === "important" || /* c8 ignore next */
          l === "text") && s.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[r] = !0;
    }
    markDirty() {
      if (this[r]) {
        this[r] = !1;
        let s = this;
        for (; s = s.parent; )
          s[r] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let s = this.parent.index(this);
      return this.parent.nodes[s + 1];
    }
    positionBy(s = {}) {
      let l = this.source.start;
      if (s.index)
        l = this.positionInside(s.index);
      else if (s.word) {
        let d = "document" in this.source.input ? this.source.input.document : this.source.input.css, p = d.slice(
          o(d, this.source.start),
          o(d, this.source.end)
        ).indexOf(s.word);
        p !== -1 && (l = this.positionInside(p));
      }
      return l;
    }
    positionInside(s) {
      let l = this.source.start.column, d = this.source.start.line, f = "document" in this.source.input ? this.source.input.document : this.source.input.css, p = o(f, this.source.start), g = p + s;
      for (let b = p; b < g; b++)
        f[b] === `
` ? (l = 1, d += 1) : l += 1;
      return { column: l, line: d, offset: g };
    }
    prev() {
      if (!this.parent) return;
      let s = this.parent.index(this);
      return this.parent.nodes[s - 1];
    }
    rangeBy(s = {}) {
      let l = "document" in this.source.input ? this.source.input.document : this.source.input.css, d = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: o(l, this.source.start)
      }, f = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          o(l, this.source.end) + 1
        )
      } : {
        column: d.column + 1,
        line: d.line,
        offset: d.offset + 1
      };
      if (s.word) {
        let g = l.slice(
          o(l, this.source.start),
          o(l, this.source.end)
        ).indexOf(s.word);
        g !== -1 && (d = this.positionInside(g), f = this.positionInside(g + s.word.length));
      } else
        s.start ? d = {
          column: s.start.column,
          line: s.start.line,
          offset: o(l, s.start)
        } : s.index && (d = this.positionInside(s.index)), s.end ? f = {
          column: s.end.column,
          line: s.end.line,
          offset: o(l, s.end)
        } : typeof s.endIndex == "number" ? f = this.positionInside(s.endIndex) : s.index && (f = this.positionInside(s.index + 1));
      return (f.line < d.line || f.line === d.line && f.column <= d.column) && (f = {
        column: d.column + 1,
        line: d.line,
        offset: d.offset + 1
      }), { end: f, start: d };
    }
    raw(s, l) {
      return new t().raw(this, s, l);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...s) {
      if (this.parent) {
        let l = this, d = !1;
        for (let f of s)
          f === this ? d = !0 : d ? (this.parent.insertAfter(l, f), l = f) : this.parent.insertBefore(l, f);
        d || this.remove();
      }
      return this;
    }
    root() {
      let s = this;
      for (; s.parent && s.parent.type !== "document"; )
        s = s.parent;
      return s;
    }
    toJSON(s, l) {
      let d = {}, f = l == null;
      l = l || /* @__PURE__ */ new Map();
      let p = 0;
      for (let g in this) {
        if (!Object.prototype.hasOwnProperty.call(this, g) || g === "parent" || g === "proxyCache") continue;
        let b = this[g];
        if (Array.isArray(b))
          d[g] = b.map((w) => typeof w == "object" && w.toJSON ? w.toJSON(null, l) : w);
        else if (typeof b == "object" && b.toJSON)
          d[g] = b.toJSON(null, l);
        else if (g === "source") {
          if (b == null) continue;
          let w = l.get(b.input);
          w == null && (w = p, l.set(b.input, p), p++), d[g] = {
            end: b.end,
            inputId: w,
            start: b.start
          };
        } else
          d[g] = b;
      }
      return f && (d.inputs = [...l.keys()].map((g) => g.toJSON())), d;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(s = n) {
      s.stringify && (s = s.stringify);
      let l = "";
      return s(this, (d) => {
        l += d;
      }), l;
    }
    warn(s, l, d = {}) {
      let f = { node: this };
      for (let p in d) f[p] = d[p];
      return s.warn(l, f);
    }
  }
  return Om = c, c.default = c, Om;
}
var Tm, X7;
function i1() {
  if (X7) return Tm;
  X7 = 1;
  let e = n1();
  class t extends e {
    constructor(r) {
      super(r), this.type = "comment";
    }
  }
  return Tm = t, t.default = t, Tm;
}
var Pm, e9;
function a1() {
  if (e9) return Pm;
  e9 = 1;
  let e = n1();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(r) {
      r && typeof r.value < "u" && typeof r.value != "string" && (r = { ...r, value: String(r.value) }), super(r), this.type = "decl";
    }
  }
  return Pm = t, t.default = t, Pm;
}
var Rm, t9;
function Pu() {
  if (t9) return Rm;
  t9 = 1;
  let e = i1(), t = a1(), n = n1(), { isClean: r, my: i } = fg(), a, o, c, u;
  function s(f) {
    return f.map((p) => (p.nodes && (p.nodes = s(p.nodes)), delete p.source, p));
  }
  function l(f) {
    if (f[r] = !1, f.proxyOf.nodes)
      for (let p of f.proxyOf.nodes)
        l(p);
  }
  class d extends n {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...p) {
      for (let g of p) {
        let b = this.normalize(g, this.last);
        for (let w of b) this.proxyOf.nodes.push(w);
      }
      return this.markDirty(), this;
    }
    cleanRaws(p) {
      if (super.cleanRaws(p), this.nodes)
        for (let g of this.nodes) g.cleanRaws(p);
    }
    each(p) {
      if (!this.proxyOf.nodes) return;
      let g = this.getIterator(), b, w;
      for (; this.indexes[g] < this.proxyOf.nodes.length && (b = this.indexes[g], w = p(this.proxyOf.nodes[b], b), w !== !1); )
        this.indexes[g] += 1;
      return delete this.indexes[g], w;
    }
    every(p) {
      return this.nodes.every(p);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let p = this.lastEach;
      return this.indexes[p] = 0, p;
    }
    getProxyProcessor() {
      return {
        get(p, g) {
          return g === "proxyOf" ? p : p[g] ? g === "each" || typeof g == "string" && g.startsWith("walk") ? (...b) => p[g](
            ...b.map((w) => typeof w == "function" ? (y, v) => w(y.toProxy(), v) : w)
          ) : g === "every" || g === "some" ? (b) => p[g](
            (w, ...y) => b(w.toProxy(), ...y)
          ) : g === "root" ? () => p.root().toProxy() : g === "nodes" ? p.nodes.map((b) => b.toProxy()) : g === "first" || g === "last" ? p[g].toProxy() : p[g] : p[g];
        },
        set(p, g, b) {
          return p[g] === b || (p[g] = b, (g === "name" || g === "params" || g === "selector") && p.markDirty()), !0;
        }
      };
    }
    index(p) {
      return typeof p == "number" ? p : (p.proxyOf && (p = p.proxyOf), this.proxyOf.nodes.indexOf(p));
    }
    insertAfter(p, g) {
      let b = this.index(p), w = this.normalize(g, this.proxyOf.nodes[b]).reverse();
      b = this.index(p);
      for (let v of w) this.proxyOf.nodes.splice(b + 1, 0, v);
      let y;
      for (let v in this.indexes)
        y = this.indexes[v], b < y && (this.indexes[v] = y + w.length);
      return this.markDirty(), this;
    }
    insertBefore(p, g) {
      let b = this.index(p), w = b === 0 ? "prepend" : !1, y = this.normalize(
        g,
        this.proxyOf.nodes[b],
        w
      ).reverse();
      b = this.index(p);
      for (let _ of y) this.proxyOf.nodes.splice(b, 0, _);
      let v;
      for (let _ in this.indexes)
        v = this.indexes[_], b <= v && (this.indexes[_] = v + y.length);
      return this.markDirty(), this;
    }
    normalize(p, g) {
      if (typeof p == "string")
        p = s(o(p).nodes);
      else if (typeof p > "u")
        p = [];
      else if (Array.isArray(p)) {
        p = p.slice(0);
        for (let w of p)
          w.parent && w.parent.removeChild(w, "ignore");
      } else if (p.type === "root" && this.type !== "document") {
        p = p.nodes.slice(0);
        for (let w of p)
          w.parent && w.parent.removeChild(w, "ignore");
      } else if (p.type)
        p = [p];
      else if (p.prop) {
        if (typeof p.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof p.value != "string" && (p.value = String(p.value)), p = [new t(p)];
      } else if (p.selector || p.selectors)
        p = [new u(p)];
      else if (p.name)
        p = [new a(p)];
      else if (p.text)
        p = [new e(p)];
      else
        throw new Error("Unknown node type in node creation");
      return p.map((w) => (w[i] || d.rebuild(w), w = w.proxyOf, w.parent && w.parent.removeChild(w), w[r] && l(w), w.raws || (w.raws = {}), typeof w.raws.before > "u" && g && typeof g.raws.before < "u" && (w.raws.before = g.raws.before.replace(/\S/g, "")), w.parent = this.proxyOf, w));
    }
    prepend(...p) {
      p = p.reverse();
      for (let g of p) {
        let b = this.normalize(g, this.first, "prepend").reverse();
        for (let w of b) this.proxyOf.nodes.unshift(w);
        for (let w in this.indexes)
          this.indexes[w] = this.indexes[w] + b.length;
      }
      return this.markDirty(), this;
    }
    push(p) {
      return p.parent = this, this.proxyOf.nodes.push(p), this;
    }
    removeAll() {
      for (let p of this.proxyOf.nodes) p.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(p) {
      p = this.index(p), this.proxyOf.nodes[p].parent = void 0, this.proxyOf.nodes.splice(p, 1);
      let g;
      for (let b in this.indexes)
        g = this.indexes[b], g >= p && (this.indexes[b] = g - 1);
      return this.markDirty(), this;
    }
    replaceValues(p, g, b) {
      return b || (b = g, g = {}), this.walkDecls((w) => {
        g.props && !g.props.includes(w.prop) || g.fast && !w.value.includes(g.fast) || (w.value = w.value.replace(p, b));
      }), this.markDirty(), this;
    }
    some(p) {
      return this.nodes.some(p);
    }
    walk(p) {
      return this.each((g, b) => {
        let w;
        try {
          w = p(g, b);
        } catch (y) {
          throw g.addToError(y);
        }
        return w !== !1 && g.walk && (w = g.walk(p)), w;
      });
    }
    walkAtRules(p, g) {
      return g ? p instanceof RegExp ? this.walk((b, w) => {
        if (b.type === "atrule" && p.test(b.name))
          return g(b, w);
      }) : this.walk((b, w) => {
        if (b.type === "atrule" && b.name === p)
          return g(b, w);
      }) : (g = p, this.walk((b, w) => {
        if (b.type === "atrule")
          return g(b, w);
      }));
    }
    walkComments(p) {
      return this.walk((g, b) => {
        if (g.type === "comment")
          return p(g, b);
      });
    }
    walkDecls(p, g) {
      return g ? p instanceof RegExp ? this.walk((b, w) => {
        if (b.type === "decl" && p.test(b.prop))
          return g(b, w);
      }) : this.walk((b, w) => {
        if (b.type === "decl" && b.prop === p)
          return g(b, w);
      }) : (g = p, this.walk((b, w) => {
        if (b.type === "decl")
          return g(b, w);
      }));
    }
    walkRules(p, g) {
      return g ? p instanceof RegExp ? this.walk((b, w) => {
        if (b.type === "rule" && p.test(b.selector))
          return g(b, w);
      }) : this.walk((b, w) => {
        if (b.type === "rule" && b.selector === p)
          return g(b, w);
      }) : (g = p, this.walk((b, w) => {
        if (b.type === "rule")
          return g(b, w);
      }));
    }
  }
  return d.registerParse = (f) => {
    o = f;
  }, d.registerRule = (f) => {
    u = f;
  }, d.registerAtRule = (f) => {
    a = f;
  }, d.registerRoot = (f) => {
    c = f;
  }, Rm = d, d.default = d, d.rebuild = (f) => {
    f.type === "atrule" ? Object.setPrototypeOf(f, a.prototype) : f.type === "rule" ? Object.setPrototypeOf(f, u.prototype) : f.type === "decl" ? Object.setPrototypeOf(f, t.prototype) : f.type === "comment" ? Object.setPrototypeOf(f, e.prototype) : f.type === "root" && Object.setPrototypeOf(f, c.prototype), f[i] = !0, f.nodes && f.nodes.forEach((p) => {
      d.rebuild(p);
    });
  }, Rm;
}
var Im, r9;
function pg() {
  if (r9) return Im;
  r9 = 1;
  let e = Pu();
  class t extends e {
    constructor(r) {
      super(r), this.type = "atrule";
    }
    append(...r) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...r);
    }
    prepend(...r) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...r);
    }
  }
  return Im = t, t.default = t, e.registerAtRule(t), Im;
}
var jm, n9;
function dg() {
  if (n9) return jm;
  n9 = 1;
  let e = Pu(), t, n;
  class r extends e {
    constructor(a) {
      super({ type: "document", ...a }), this.nodes || (this.nodes = []);
    }
    toResult(a = {}) {
      return new t(new n(), this, a).stringify();
    }
  }
  return r.registerLazyResult = (i) => {
    t = i;
  }, r.registerProcessor = (i) => {
    n = i;
  }, jm = r, r.default = r, jm;
}
var qm, i9;
function jZ() {
  if (i9) return qm;
  i9 = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return qm = { nanoid: (r = 21) => {
    let i = "", a = r | 0;
    for (; a--; )
      i += e[Math.random() * 64 | 0];
    return i;
  }, customAlphabet: (r, i = 21) => (a = i) => {
    let o = "", c = a | 0;
    for (; c--; )
      o += r[Math.random() * r.length | 0];
    return o;
  } }, qm;
}
var Dm, a9;
function pO() {
  if (a9) return Dm;
  a9 = 1;
  let { existsSync: e, readFileSync: t } = ni, { dirname: n, join: r } = As(), { SourceMapConsumer: i, SourceMapGenerator: a } = ni;
  function o(u) {
    return qn ? qn.from(u, "base64").toString() : window.atob(u);
  }
  class c {
    constructor(s, l) {
      if (l.map === !1) return;
      this.loadAnnotation(s), this.inline = this.startWith(this.annotation, "data:");
      let d = l.map ? l.map.prev : void 0, f = this.loadMap(l.from, d);
      !this.mapFile && l.from && (this.mapFile = l.from), this.mapFile && (this.root = n(this.mapFile)), f && (this.text = f);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new i(this.text)), this.consumerCache;
    }
    decodeInline(s) {
      let l = /^data:application\/json;charset=utf-?8;base64,/, d = /^data:application\/json;base64,/, f = /^data:application\/json;charset=utf-?8,/, p = /^data:application\/json,/, g = s.match(f) || s.match(p);
      if (g)
        return decodeURIComponent(s.substr(g[0].length));
      let b = s.match(l) || s.match(d);
      if (b)
        return o(s.substr(b[0].length));
      let w = s.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + w);
    }
    getAnnotationURL(s) {
      return s.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(s) {
      return typeof s != "object" ? !1 : typeof s.mappings == "string" || typeof s._mappings == "string" || Array.isArray(s.sections);
    }
    loadAnnotation(s) {
      let l = s.match(/\/\*\s*# sourceMappingURL=/g);
      if (!l) return;
      let d = s.lastIndexOf(l.pop()), f = s.indexOf("*/", d);
      d > -1 && f > -1 && (this.annotation = this.getAnnotationURL(s.substring(d, f)));
    }
    loadFile(s) {
      if (this.root = n(s), e(s))
        return this.mapFile = s, t(s, "utf-8").toString().trim();
    }
    loadMap(s, l) {
      if (l === !1) return !1;
      if (l) {
        if (typeof l == "string")
          return l;
        if (typeof l == "function") {
          let d = l(s);
          if (d) {
            let f = this.loadFile(d);
            if (!f)
              throw new Error(
                "Unable to load previous source map: " + d.toString()
              );
            return f;
          }
        } else {
          if (l instanceof i)
            return a.fromSourceMap(l).toString();
          if (l instanceof a)
            return l.toString();
          if (this.isMap(l))
            return JSON.stringify(l);
          throw new Error(
            "Unsupported previous source map format: " + l.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let d = this.annotation;
          return s && (d = r(n(s), d)), this.loadFile(d);
        }
      }
    }
    startWith(s, l) {
      return s ? s.substr(0, l.length) === l : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Dm = c, c.default = c, Dm;
}
var $m, o9;
function o1() {
  if (o9) return $m;
  o9 = 1;
  let { nanoid: e } = /* @__PURE__ */ jZ(), { isAbsolute: t, resolve: n } = As(), { SourceMapConsumer: r, SourceMapGenerator: i } = ni, { fileURLToPath: a, pathToFileURL: o } = ni, c = lg(), u = pO(), s = ni, l = Symbol("lineToIndexCache"), d = !!(r && i), f = !!(n && t);
  function p(b) {
    if (b[l]) return b[l];
    let w = b.css.split(`
`), y = new Array(w.length), v = 0;
    for (let _ = 0, E = w.length; _ < E; _++)
      y[_] = v, v += w[_].length + 1;
    return b[l] = y, y;
  }
  class g {
    get from() {
      return this.file || this.id;
    }
    constructor(w, y = {}) {
      if (w === null || typeof w > "u" || typeof w == "object" && !w.toString)
        throw new Error(`PostCSS received ${w} instead of CSS string`);
      if (this.css = w.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, y.document && (this.document = y.document.toString()), y.from && (!f || /^\w+:\/\//.test(y.from) || t(y.from) ? this.file = y.from : this.file = n(y.from)), f && d) {
        let v = new u(this.css, y);
        if (v.text) {
          this.map = v;
          let _ = v.consumer().file;
          !this.file && _ && (this.file = this.mapResolve(_));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(w, y, v, _ = {}) {
      let E, O, M, L, Z;
      if (y && typeof y == "object") {
        let ae = y, re = v;
        if (typeof ae.offset == "number") {
          L = ae.offset;
          let X = this.fromOffset(L);
          y = X.line, v = X.col;
        } else
          y = ae.line, v = ae.column, L = this.fromLineAndColumn(y, v);
        if (typeof re.offset == "number") {
          M = re.offset;
          let X = this.fromOffset(M);
          O = X.line, E = X.col;
        } else
          O = re.line, E = re.column, M = this.fromLineAndColumn(re.line, re.column);
      } else if (v)
        L = this.fromLineAndColumn(y, v);
      else {
        L = y;
        let ae = this.fromOffset(L);
        y = ae.line, v = ae.col;
      }
      let Q = this.origin(y, v, O, E);
      return Q ? Z = new c(
        w,
        Q.endLine === void 0 ? Q.line : { column: Q.column, line: Q.line },
        Q.endLine === void 0 ? Q.column : { column: Q.endColumn, line: Q.endLine },
        Q.source,
        Q.file,
        _.plugin
      ) : Z = new c(
        w,
        O === void 0 ? y : { column: v, line: y },
        O === void 0 ? v : { column: E, line: O },
        this.css,
        this.file,
        _.plugin
      ), Z.input = { column: v, endColumn: E, endLine: O, endOffset: M, line: y, offset: L, source: this.css }, this.file && (o && (Z.input.url = o(this.file).toString()), Z.input.file = this.file), Z;
    }
    fromLineAndColumn(w, y) {
      return p(this)[w - 1] + y - 1;
    }
    fromOffset(w) {
      let y = p(this), v = y[y.length - 1], _ = 0;
      if (w >= v)
        _ = y.length - 1;
      else {
        let E = y.length - 2, O;
        for (; _ < E; )
          if (O = _ + (E - _ >> 1), w < y[O])
            E = O - 1;
          else if (w >= y[O + 1])
            _ = O + 1;
          else {
            _ = O;
            break;
          }
      }
      return {
        col: w - y[_] + 1,
        line: _ + 1
      };
    }
    mapResolve(w) {
      return /^\w+:\/\//.test(w) ? w : n(this.map.consumer().sourceRoot || this.map.root || ".", w);
    }
    origin(w, y, v, _) {
      if (!this.map) return !1;
      let E = this.map.consumer(), O = E.originalPositionFor({ column: y, line: w });
      if (!O.source) return !1;
      let M;
      typeof v == "number" && (M = E.originalPositionFor({ column: _, line: v }));
      let L;
      t(O.source) ? L = o(O.source) : L = new URL(
        O.source,
        this.map.consumer().sourceRoot || o(this.map.mapFile)
      );
      let Z = {
        column: O.column,
        endColumn: M && M.column,
        endLine: M && M.line,
        line: O.line,
        url: L.toString()
      };
      if (L.protocol === "file:")
        if (a)
          Z.file = a(L);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let Q = E.sourceContentFor(O.source);
      return Q && (Z.source = Q), Z;
    }
    toJSON() {
      let w = {};
      for (let y of ["hasBOM", "css", "file", "id"])
        this[y] != null && (w[y] = this[y]);
      return this.map && (w.map = { ...this.map }, w.map.consumerCache && (w.map.consumerCache = void 0)), w;
    }
  }
  return $m = g, g.default = g, s && s.registerInput && s.registerInput(g), $m;
}
var Lm, s9;
function tp() {
  if (s9) return Lm;
  s9 = 1;
  let e = Pu(), t, n;
  class r extends e {
    constructor(a) {
      super(a), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(a, o, c) {
      let u = super.normalize(a);
      if (o) {
        if (c === "prepend")
          this.nodes.length > 1 ? o.raws.before = this.nodes[1].raws.before : delete o.raws.before;
        else if (this.first !== o)
          for (let s of u)
            s.raws.before = o.raws.before;
      }
      return u;
    }
    removeChild(a, o) {
      let c = this.index(a);
      return !o && c === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[c].raws.before), super.removeChild(a);
    }
    toResult(a = {}) {
      return new t(new n(), this, a).stringify();
    }
  }
  return r.registerLazyResult = (i) => {
    t = i;
  }, r.registerProcessor = (i) => {
    n = i;
  }, Lm = r, r.default = r, e.registerRoot(r), Lm;
}
var Nm, u9;
function dO() {
  if (u9) return Nm;
  u9 = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let n = [" ", `
`, "	"];
      return e.split(t, n);
    },
    split(t, n, r) {
      let i = [], a = "", o = !1, c = 0, u = !1, s = "", l = !1;
      for (let d of t)
        l ? l = !1 : d === "\\" ? l = !0 : u ? d === s && (u = !1) : d === '"' || d === "'" ? (u = !0, s = d) : d === "(" ? c += 1 : d === ")" ? c > 0 && (c -= 1) : c === 0 && n.includes(d) && (o = !0), o ? (a !== "" && i.push(a.trim()), a = "", o = !1) : a += d;
      return (r || a !== "") && i.push(a.trim()), i;
    }
  };
  return Nm = e, e.default = e, Nm;
}
var Fm, c9;
function hg() {
  if (c9) return Fm;
  c9 = 1;
  let e = Pu(), t = dO();
  class n extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(i) {
      let a = this.selector ? this.selector.match(/,\s*/) : null, o = a ? a[0] : "," + this.raw("between", "beforeOpen");
      this.selector = i.join(o);
    }
    constructor(i) {
      super(i), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return Fm = n, n.default = n, e.registerRule(n), Fm;
}
var Mm, l9;
function qZ() {
  if (l9) return Mm;
  l9 = 1;
  let e = pg(), t = i1(), n = a1(), r = o1(), i = pO(), a = tp(), o = hg();
  function c(u, s) {
    if (Array.isArray(u)) return u.map((f) => c(f));
    let { inputs: l, ...d } = u;
    if (l) {
      s = [];
      for (let f of l) {
        let p = { ...f, __proto__: r.prototype };
        p.map && (p.map = {
          ...p.map,
          __proto__: i.prototype
        }), s.push(p);
      }
    }
    if (d.nodes && (d.nodes = u.nodes.map((f) => c(f, s))), d.source) {
      let { inputId: f, ...p } = d.source;
      d.source = p, f != null && (d.source.input = s[f]);
    }
    if (d.type === "root")
      return new a(d);
    if (d.type === "decl")
      return new n(d);
    if (d.type === "rule")
      return new o(d);
    if (d.type === "comment")
      return new t(d);
    if (d.type === "atrule")
      return new e(d);
    throw new Error("Unknown node type: " + u.type);
  }
  return Mm = c, c.default = c, Mm;
}
var Bm, f9;
function hO() {
  if (f9) return Bm;
  f9 = 1;
  let { dirname: e, relative: t, resolve: n, sep: r } = As(), { SourceMapConsumer: i, SourceMapGenerator: a } = ni, { pathToFileURL: o } = ni, c = o1(), u = !!(i && a), s = !!(e && n && t && r);
  class l {
    constructor(f, p, g, b) {
      this.stringify = f, this.mapOpts = g.map || {}, this.root = p, this.opts = g, this.css = b, this.originalCSS = b, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let f;
      this.isInline() ? f = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? f = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? f = this.mapOpts.annotation(this.opts.to, this.root) : f = this.outputFile() + ".map";
      let p = `
`;
      this.css.includes(`\r
`) && (p = `\r
`), this.css += p + "/*# sourceMappingURL=" + f + " */";
    }
    applyPrevMaps() {
      for (let f of this.previous()) {
        let p = this.toUrl(this.path(f.file)), g = f.root || e(f.file), b;
        this.mapOpts.sourcesContent === !1 ? (b = new i(f.text), b.sourcesContent && (b.sourcesContent = null)) : b = f.consumer(), this.map.applySourceMap(b, p, this.toUrl(this.path(g)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let f;
          for (let p = this.root.nodes.length - 1; p >= 0; p--)
            f = this.root.nodes[p], f.type === "comment" && f.text.startsWith("# sourceMappingURL=") && this.root.removeChild(p);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), s && u && this.isMap())
        return this.generateMap();
      {
        let f = "";
        return this.stringify(this.root, (p) => {
          f += p;
        }), [f];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let f = this.previous()[0].consumer();
        f.file = this.outputFile(), this.map = a.fromSourceMap(f, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new a({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new a({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let f = 1, p = 1, g = "<no source>", b = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, w, y;
      this.stringify(this.root, (v, _, E) => {
        if (this.css += v, _ && E !== "end" && (b.generated.line = f, b.generated.column = p - 1, _.source && _.source.start ? (b.source = this.sourcePath(_), b.original.line = _.source.start.line, b.original.column = _.source.start.column - 1, this.map.addMapping(b)) : (b.source = g, b.original.line = 1, b.original.column = 0, this.map.addMapping(b))), y = v.match(/\n/g), y ? (f += y.length, w = v.lastIndexOf(`
`), p = v.length - w) : p += v.length, _ && E !== "start") {
          let O = _.parent || { raws: {} };
          (!(_.type === "decl" || _.type === "atrule" && !_.nodes) || _ !== O.last || O.raws.semicolon) && (_.source && _.source.end ? (b.source = this.sourcePath(_), b.original.line = _.source.end.line, b.original.column = _.source.end.column - 1, b.generated.line = f, b.generated.column = p - 2, this.map.addMapping(b)) : (b.source = g, b.original.line = 1, b.original.column = 0, b.generated.line = f, b.generated.column = p - 1, this.map.addMapping(b)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((f) => f.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let f = this.mapOpts.annotation;
      return typeof f < "u" && f !== !0 ? !1 : this.previous().length ? this.previous().some((p) => p.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((f) => f.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(f) {
      if (this.mapOpts.absolute || f.charCodeAt(0) === 60 || /^\w+:\/\//.test(f)) return f;
      let p = this.memoizedPaths.get(f);
      if (p) return p;
      let g = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (g = e(n(g, this.mapOpts.annotation)));
      let b = t(g, f);
      return this.memoizedPaths.set(f, b), b;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((f) => {
            if (f.source && f.source.input.map) {
              let p = f.source.input.map;
              this.previousMaps.includes(p) || this.previousMaps.push(p);
            }
          });
        else {
          let f = new c(this.originalCSS, this.opts);
          f.map && this.previousMaps.push(f.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let f = {};
      if (this.root)
        this.root.walk((p) => {
          if (p.source) {
            let g = p.source.input.from;
            if (g && !f[g]) {
              f[g] = !0;
              let b = this.usesFileUrls ? this.toFileUrl(g) : this.toUrl(this.path(g));
              this.map.setSourceContent(b, p.source.input.css);
            }
          }
        });
      else if (this.css) {
        let p = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(p, this.css);
      }
    }
    sourcePath(f) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(f.source.input.from) : this.toUrl(this.path(f.source.input.from));
    }
    toBase64(f) {
      return qn ? qn.from(f).toString("base64") : window.btoa(unescape(encodeURIComponent(f)));
    }
    toFileUrl(f) {
      let p = this.memoizedFileURLs.get(f);
      if (p) return p;
      if (o) {
        let g = o(f).toString();
        return this.memoizedFileURLs.set(f, g), g;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(f) {
      let p = this.memoizedURLs.get(f);
      if (p) return p;
      r === "\\" && (f = f.replace(/\\/g, "/"));
      let g = encodeURI(f).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(f, g), g;
    }
  }
  return Bm = l, Bm;
}
var Um, p9;
function DZ() {
  if (p9) return Um;
  p9 = 1;
  const e = 39, t = 34, n = 92, r = 47, i = 10, a = 32, o = 12, c = 9, u = 13, s = 91, l = 93, d = 40, f = 41, p = 123, g = 125, b = 59, w = 42, y = 58, v = 64, _ = /[\t\n\f\r "#'()/;[\\\]{}]/g, E = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, O = /.[\r\n"'(/\\]/, M = /[\da-f]/i;
  return Um = function(Z, Q = {}) {
    let ae = Z.css.valueOf(), re = Q.ignoreErrors, X, de, Ce, J, ne, De, je, Me, qe, Ve, xe = ae.length, ve = 0, Ae = [], Ue = [];
    function qt() {
      return ve;
    }
    function Ze(Fe) {
      throw Z.error("Unclosed " + Fe, ve);
    }
    function At() {
      return Ue.length === 0 && ve >= xe;
    }
    function He(Fe) {
      if (Ue.length) return Ue.pop();
      if (ve >= xe) return;
      let Xe = Fe ? Fe.ignoreUnclosed : !1;
      switch (X = ae.charCodeAt(ve), X) {
        case i:
        case a:
        case c:
        case u:
        case o: {
          J = ve;
          do
            J += 1, X = ae.charCodeAt(J);
          while (X === a || X === i || X === c || X === u || X === o);
          De = ["space", ae.slice(ve, J)], ve = J - 1;
          break;
        }
        case s:
        case l:
        case p:
        case g:
        case y:
        case b:
        case f: {
          let ze = String.fromCharCode(X);
          De = [ze, ze, ve];
          break;
        }
        case d: {
          if (Ve = Ae.length ? Ae.pop()[1] : "", qe = ae.charCodeAt(ve + 1), Ve === "url" && qe !== e && qe !== t && qe !== a && qe !== i && qe !== c && qe !== o && qe !== u) {
            J = ve;
            do {
              if (je = !1, J = ae.indexOf(")", J + 1), J === -1)
                if (re || Xe) {
                  J = ve;
                  break;
                } else
                  Ze("bracket");
              for (Me = J; ae.charCodeAt(Me - 1) === n; )
                Me -= 1, je = !je;
            } while (je);
            De = ["brackets", ae.slice(ve, J + 1), ve, J], ve = J;
          } else
            J = ae.indexOf(")", ve + 1), de = ae.slice(ve, J + 1), J === -1 || O.test(de) ? De = ["(", "(", ve] : (De = ["brackets", de, ve, J], ve = J);
          break;
        }
        case e:
        case t: {
          ne = X === e ? "'" : '"', J = ve;
          do {
            if (je = !1, J = ae.indexOf(ne, J + 1), J === -1)
              if (re || Xe) {
                J = ve + 1;
                break;
              } else
                Ze("string");
            for (Me = J; ae.charCodeAt(Me - 1) === n; )
              Me -= 1, je = !je;
          } while (je);
          De = ["string", ae.slice(ve, J + 1), ve, J], ve = J;
          break;
        }
        case v: {
          _.lastIndex = ve + 1, _.test(ae), _.lastIndex === 0 ? J = ae.length - 1 : J = _.lastIndex - 2, De = ["at-word", ae.slice(ve, J + 1), ve, J], ve = J;
          break;
        }
        case n: {
          for (J = ve, Ce = !0; ae.charCodeAt(J + 1) === n; )
            J += 1, Ce = !Ce;
          if (X = ae.charCodeAt(J + 1), Ce && X !== r && X !== a && X !== i && X !== c && X !== u && X !== o && (J += 1, M.test(ae.charAt(J)))) {
            for (; M.test(ae.charAt(J + 1)); )
              J += 1;
            ae.charCodeAt(J + 1) === a && (J += 1);
          }
          De = ["word", ae.slice(ve, J + 1), ve, J], ve = J;
          break;
        }
        default: {
          X === r && ae.charCodeAt(ve + 1) === w ? (J = ae.indexOf("*/", ve + 2) + 1, J === 0 && (re || Xe ? J = ae.length : Ze("comment")), De = ["comment", ae.slice(ve, J + 1), ve, J], ve = J) : (E.lastIndex = ve + 1, E.test(ae), E.lastIndex === 0 ? J = ae.length - 1 : J = E.lastIndex - 2, De = ["word", ae.slice(ve, J + 1), ve, J], Ae.push(De), ve = J);
          break;
        }
      }
      return ve++, De;
    }
    function Dt(Fe) {
      Ue.push(Fe);
    }
    return {
      back: Dt,
      endOfFile: At,
      nextToken: He,
      position: qt
    };
  }, Um;
}
var Hm, d9;
function $Z() {
  if (d9) return Hm;
  d9 = 1;
  let e = pg(), t = i1(), n = a1(), r = tp(), i = hg(), a = DZ();
  const o = {
    empty: !0,
    space: !0
  };
  function c(s) {
    for (let l = s.length - 1; l >= 0; l--) {
      let d = s[l], f = d[3] || d[2];
      if (f) return f;
    }
  }
  class u {
    constructor(l) {
      this.input = l, this.root = new r(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: l, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(l) {
      let d = new e();
      d.name = l[1].slice(1), d.name === "" && this.unnamedAtrule(d, l), this.init(d, l[2]);
      let f, p, g, b = !1, w = !1, y = [], v = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (l = this.tokenizer.nextToken(), f = l[0], f === "(" || f === "[" ? v.push(f === "(" ? ")" : "]") : f === "{" && v.length > 0 ? v.push("}") : f === v[v.length - 1] && v.pop(), v.length === 0)
          if (f === ";") {
            d.source.end = this.getPosition(l[2]), d.source.end.offset++, this.semicolon = !0;
            break;
          } else if (f === "{") {
            w = !0;
            break;
          } else if (f === "}") {
            if (y.length > 0) {
              for (g = y.length - 1, p = y[g]; p && p[0] === "space"; )
                p = y[--g];
              p && (d.source.end = this.getPosition(p[3] || p[2]), d.source.end.offset++);
            }
            this.end(l);
            break;
          } else
            y.push(l);
        else
          y.push(l);
        if (this.tokenizer.endOfFile()) {
          b = !0;
          break;
        }
      }
      d.raws.between = this.spacesAndCommentsFromEnd(y), y.length ? (d.raws.afterName = this.spacesAndCommentsFromStart(y), this.raw(d, "params", y), b && (l = y[y.length - 1], d.source.end = this.getPosition(l[3] || l[2]), d.source.end.offset++, this.spaces = d.raws.between, d.raws.between = "")) : (d.raws.afterName = "", d.params = ""), w && (d.nodes = [], this.current = d);
    }
    checkMissedSemicolon(l) {
      let d = this.colon(l);
      if (d === !1) return;
      let f = 0, p;
      for (let g = d - 1; g >= 0 && (p = l[g], !(p[0] !== "space" && (f += 1, f === 2))); g--)
        ;
      throw this.input.error(
        "Missed semicolon",
        p[0] === "word" ? p[3] + 1 : p[2]
      );
    }
    colon(l) {
      let d = 0, f, p, g;
      for (let [b, w] of l.entries()) {
        if (p = w, g = p[0], g === "(" && (d += 1), g === ")" && (d -= 1), d === 0 && g === ":")
          if (!f)
            this.doubleColon(p);
          else {
            if (f[0] === "word" && f[1] === "progid")
              continue;
            return b;
          }
        f = p;
      }
      return !1;
    }
    comment(l) {
      let d = new t();
      this.init(d, l[2]), d.source.end = this.getPosition(l[3] || l[2]), d.source.end.offset++;
      let f = l[1].slice(2, -2);
      if (/^\s*$/.test(f))
        d.text = "", d.raws.left = f, d.raws.right = "";
      else {
        let p = f.match(/^(\s*)([^]*\S)(\s*)$/);
        d.text = p[2], d.raws.left = p[1], d.raws.right = p[3];
      }
    }
    createTokenizer() {
      this.tokenizer = a(this.input);
    }
    decl(l, d) {
      let f = new n();
      this.init(f, l[0][2]);
      let p = l[l.length - 1];
      for (p[0] === ";" && (this.semicolon = !0, l.pop()), f.source.end = this.getPosition(
        p[3] || p[2] || c(l)
      ), f.source.end.offset++; l[0][0] !== "word"; )
        l.length === 1 && this.unknownWord(l), f.raws.before += l.shift()[1];
      for (f.source.start = this.getPosition(l[0][2]), f.prop = ""; l.length; ) {
        let v = l[0][0];
        if (v === ":" || v === "space" || v === "comment")
          break;
        f.prop += l.shift()[1];
      }
      f.raws.between = "";
      let g;
      for (; l.length; )
        if (g = l.shift(), g[0] === ":") {
          f.raws.between += g[1];
          break;
        } else
          g[0] === "word" && /\w/.test(g[1]) && this.unknownWord([g]), f.raws.between += g[1];
      (f.prop[0] === "_" || f.prop[0] === "*") && (f.raws.before += f.prop[0], f.prop = f.prop.slice(1));
      let b = [], w;
      for (; l.length && (w = l[0][0], !(w !== "space" && w !== "comment")); )
        b.push(l.shift());
      this.precheckMissedSemicolon(l);
      for (let v = l.length - 1; v >= 0; v--) {
        if (g = l[v], g[1].toLowerCase() === "!important") {
          f.important = !0;
          let _ = this.stringFrom(l, v);
          _ = this.spacesFromEnd(l) + _, _ !== " !important" && (f.raws.important = _);
          break;
        } else if (g[1].toLowerCase() === "important") {
          let _ = l.slice(0), E = "";
          for (let O = v; O > 0; O--) {
            let M = _[O][0];
            if (E.trim().startsWith("!") && M !== "space")
              break;
            E = _.pop()[1] + E;
          }
          E.trim().startsWith("!") && (f.important = !0, f.raws.important = E, l = _);
        }
        if (g[0] !== "space" && g[0] !== "comment")
          break;
      }
      l.some((v) => v[0] !== "space" && v[0] !== "comment") && (f.raws.between += b.map((v) => v[1]).join(""), b = []), this.raw(f, "value", b.concat(l), d), f.value.includes(":") && !d && this.checkMissedSemicolon(l);
    }
    doubleColon(l) {
      throw this.input.error(
        "Double colon",
        { offset: l[2] },
        { offset: l[2] + l[1].length }
      );
    }
    emptyRule(l) {
      let d = new i();
      this.init(d, l[2]), d.selector = "", d.raws.between = "", this.current = d;
    }
    end(l) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(l[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(l);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(l) {
      if (this.spaces += l[1], this.current.nodes) {
        let d = this.current.nodes[this.current.nodes.length - 1];
        d && d.type === "rule" && !d.raws.ownSemicolon && (d.raws.ownSemicolon = this.spaces, this.spaces = "", d.source.end = this.getPosition(l[2]), d.source.end.offset += d.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(l) {
      let d = this.input.fromOffset(l);
      return {
        column: d.col,
        line: d.line,
        offset: l
      };
    }
    init(l, d) {
      this.current.push(l), l.source = {
        input: this.input,
        start: this.getPosition(d)
      }, l.raws.before = this.spaces, this.spaces = "", l.type !== "comment" && (this.semicolon = !1);
    }
    other(l) {
      let d = !1, f = null, p = !1, g = null, b = [], w = l[1].startsWith("--"), y = [], v = l;
      for (; v; ) {
        if (f = v[0], y.push(v), f === "(" || f === "[")
          g || (g = v), b.push(f === "(" ? ")" : "]");
        else if (w && p && f === "{")
          g || (g = v), b.push("}");
        else if (b.length === 0)
          if (f === ";")
            if (p) {
              this.decl(y, w);
              return;
            } else
              break;
          else if (f === "{") {
            this.rule(y);
            return;
          } else if (f === "}") {
            this.tokenizer.back(y.pop()), d = !0;
            break;
          } else f === ":" && (p = !0);
        else f === b[b.length - 1] && (b.pop(), b.length === 0 && (g = null));
        v = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (d = !0), b.length > 0 && this.unclosedBracket(g), d && p) {
        if (!w)
          for (; y.length && (v = y[y.length - 1][0], !(v !== "space" && v !== "comment")); )
            this.tokenizer.back(y.pop());
        this.decl(y, w);
      } else
        this.unknownWord(y);
    }
    parse() {
      let l;
      for (; !this.tokenizer.endOfFile(); )
        switch (l = this.tokenizer.nextToken(), l[0]) {
          case "space":
            this.spaces += l[1];
            break;
          case ";":
            this.freeSemicolon(l);
            break;
          case "}":
            this.end(l);
            break;
          case "comment":
            this.comment(l);
            break;
          case "at-word":
            this.atrule(l);
            break;
          case "{":
            this.emptyRule(l);
            break;
          default:
            this.other(l);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(l, d, f, p) {
      let g, b, w = f.length, y = "", v = !0, _, E;
      for (let O = 0; O < w; O += 1)
        g = f[O], b = g[0], b === "space" && O === w - 1 && !p ? v = !1 : b === "comment" ? (E = f[O - 1] ? f[O - 1][0] : "empty", _ = f[O + 1] ? f[O + 1][0] : "empty", !o[E] && !o[_] ? y.slice(-1) === "," ? v = !1 : y += g[1] : v = !1) : y += g[1];
      if (!v) {
        let O = f.reduce((M, L) => M + L[1], "");
        l.raws[d] = { raw: O, value: y };
      }
      l[d] = y;
    }
    rule(l) {
      l.pop();
      let d = new i();
      this.init(d, l[0][2]), d.raws.between = this.spacesAndCommentsFromEnd(l), this.raw(d, "selector", l), this.current = d;
    }
    spacesAndCommentsFromEnd(l) {
      let d, f = "";
      for (; l.length && (d = l[l.length - 1][0], !(d !== "space" && d !== "comment")); )
        f = l.pop()[1] + f;
      return f;
    }
    // Errors
    spacesAndCommentsFromStart(l) {
      let d, f = "";
      for (; l.length && (d = l[0][0], !(d !== "space" && d !== "comment")); )
        f += l.shift()[1];
      return f;
    }
    spacesFromEnd(l) {
      let d, f = "";
      for (; l.length && (d = l[l.length - 1][0], d === "space"); )
        f = l.pop()[1] + f;
      return f;
    }
    stringFrom(l, d) {
      let f = "";
      for (let p = d; p < l.length; p++)
        f += l[p][1];
      return l.splice(d, l.length - d), f;
    }
    unclosedBlock() {
      let l = this.current.source.start;
      throw this.input.error("Unclosed block", l.line, l.column);
    }
    unclosedBracket(l) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: l[2] },
        { offset: l[2] + 1 }
      );
    }
    unexpectedClose(l) {
      throw this.input.error(
        "Unexpected }",
        { offset: l[2] },
        { offset: l[2] + 1 }
      );
    }
    unknownWord(l) {
      throw this.input.error(
        "Unknown word " + l[0][1],
        { offset: l[0][2] },
        { offset: l[0][2] + l[0][1].length }
      );
    }
    unnamedAtrule(l, d) {
      throw this.input.error(
        "At-rule without name",
        { offset: d[2] },
        { offset: d[2] + d[1].length }
      );
    }
  }
  return Hm = u, Hm;
}
var zm, h9;
function mg() {
  if (h9) return zm;
  h9 = 1;
  let e = Pu(), t = o1(), n = $Z();
  function r(i, a) {
    let o = new t(i, a), c = new n(o);
    try {
      c.parse();
    } catch (u) {
      throw gn.env.NODE_ENV !== "production" && u.name === "CssSyntaxError" && a && a.from && (/\.scss$/i.test(a.from) ? u.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(a.from) ? u.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(a.from) && (u.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), u;
    }
    return c.root;
  }
  return zm = r, r.default = r, e.registerParse(r), zm;
}
var Vm, m9;
function mO() {
  if (m9) return Vm;
  m9 = 1;
  class e {
    constructor(n, r = {}) {
      if (this.type = "warning", this.text = n, r.node && r.node.source) {
        let i = r.node.rangeBy(r);
        this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
      }
      for (let i in r) this[i] = r[i];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Vm = e, e.default = e, Vm;
}
var Gm, g9;
function gg() {
  if (g9) return Gm;
  g9 = 1;
  let e = mO();
  class t {
    get content() {
      return this.css;
    }
    constructor(r, i, a) {
      this.processor = r, this.messages = [], this.root = i, this.opts = a, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(r, i = {}) {
      i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
      let a = new e(r, i);
      return this.messages.push(a), a;
    }
    warnings() {
      return this.messages.filter((r) => r.type === "warning");
    }
  }
  return Gm = t, t.default = t, Gm;
}
var Wm, v9;
function gO() {
  if (v9) return Wm;
  v9 = 1;
  let e = {};
  return Wm = function(n) {
    e[n] || (e[n] = !0, typeof console < "u" && console.warn && console.warn(n));
  }, Wm;
}
var Km, y9;
function vO() {
  if (y9) return Km;
  y9 = 1;
  let e = Pu(), t = dg(), n = hO(), r = mg(), i = gg(), a = tp(), o = r1(), { isClean: c, my: u } = fg(), s = gO();
  const l = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, d = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, f = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, p = 0;
  function g(E) {
    return typeof E == "object" && typeof E.then == "function";
  }
  function b(E) {
    let O = !1, M = l[E.type];
    return E.type === "decl" ? O = E.prop.toLowerCase() : E.type === "atrule" && (O = E.name.toLowerCase()), O && E.append ? [
      M,
      M + "-" + O,
      p,
      M + "Exit",
      M + "Exit-" + O
    ] : O ? [M, M + "-" + O, M + "Exit", M + "Exit-" + O] : E.append ? [M, p, M + "Exit"] : [M, M + "Exit"];
  }
  function w(E) {
    let O;
    return E.type === "document" ? O = ["Document", p, "DocumentExit"] : E.type === "root" ? O = ["Root", p, "RootExit"] : O = b(E), {
      eventIndex: 0,
      events: O,
      iterator: 0,
      node: E,
      visitorIndex: 0,
      visitors: []
    };
  }
  function y(E) {
    return E[c] = !1, E.nodes && E.nodes.forEach((O) => y(O)), E;
  }
  let v = {};
  class _ {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(O, M, L) {
      this.stringified = !1, this.processed = !1;
      let Z;
      if (typeof M == "object" && M !== null && (M.type === "root" || M.type === "document"))
        Z = y(M);
      else if (M instanceof _ || M instanceof i)
        Z = y(M.root), M.map && (typeof L.map > "u" && (L.map = {}), L.map.inline || (L.map.inline = !1), L.map.prev = M.map);
      else {
        let Q = r;
        L.syntax && (Q = L.syntax.parse), L.parser && (Q = L.parser), Q.parse && (Q = Q.parse);
        try {
          Z = Q(M, L);
        } catch (ae) {
          this.processed = !0, this.error = ae;
        }
        Z && !Z[u] && e.rebuild(Z);
      }
      this.result = new i(O, Z, L), this.helpers = { ...v, postcss: v, result: this.result }, this.plugins = this.processor.plugins.map((Q) => typeof Q == "object" && Q.prepare ? { ...Q, ...Q.prepare(this.result) } : Q);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(O) {
      return this.async().catch(O);
    }
    finally(O) {
      return this.async().then(O, O);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(O, M) {
      let L = this.result.lastPlugin;
      try {
        if (M && M.addToError(O), this.error = O, O.name === "CssSyntaxError" && !O.plugin)
          O.plugin = L.postcssPlugin, O.setMessage();
        else if (L.postcssVersion && gn.env.NODE_ENV !== "production") {
          let Z = L.postcssPlugin, Q = L.postcssVersion, ae = this.result.processor.version, re = Q.split("."), X = ae.split(".");
          (re[0] !== X[0] || parseInt(re[1]) > parseInt(X[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + ae + ", but " + Z + " uses " + Q + ". Perhaps this is the source of the error below."
          );
        }
      } catch (Z) {
        console && console.error && console.error(Z);
      }
      return O;
    }
    prepareVisitors() {
      this.listeners = {};
      let O = (M, L, Z) => {
        this.listeners[L] || (this.listeners[L] = []), this.listeners[L].push([M, Z]);
      };
      for (let M of this.plugins)
        if (typeof M == "object")
          for (let L in M) {
            if (!d[L] && /^[A-Z]/.test(L))
              throw new Error(
                `Unknown event ${L} in ${M.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!f[L])
              if (typeof M[L] == "object")
                for (let Z in M[L])
                  Z === "*" ? O(M, L, M[L][Z]) : O(
                    M,
                    L + "-" + Z.toLowerCase(),
                    M[L][Z]
                  );
              else typeof M[L] == "function" && O(M, L, M[L]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let O = 0; O < this.plugins.length; O++) {
        let M = this.plugins[O], L = this.runOnRoot(M);
        if (g(L))
          try {
            await L;
          } catch (Z) {
            throw this.handleError(Z);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let O = this.result.root;
        for (; !O[c]; ) {
          O[c] = !0;
          let M = [w(O)];
          for (; M.length > 0; ) {
            let L = this.visitTick(M);
            if (g(L))
              try {
                await L;
              } catch (Z) {
                let Q = M[M.length - 1].node;
                throw this.handleError(Z, Q);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [M, L] of this.listeners.OnceExit) {
            this.result.lastPlugin = M;
            try {
              if (O.type === "document") {
                let Z = O.nodes.map(
                  (Q) => L(Q, this.helpers)
                );
                await Promise.all(Z);
              } else
                await L(O, this.helpers);
            } catch (Z) {
              throw this.handleError(Z);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(O) {
      this.result.lastPlugin = O;
      try {
        if (typeof O == "object" && O.Once) {
          if (this.result.root.type === "document") {
            let M = this.result.root.nodes.map(
              (L) => O.Once(L, this.helpers)
            );
            return g(M[0]) ? Promise.all(M) : M;
          }
          return O.Once(this.result.root, this.helpers);
        } else if (typeof O == "function")
          return O(this.result.root, this.result);
      } catch (M) {
        throw this.handleError(M);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let O = this.result.opts, M = o;
      O.syntax && (M = O.syntax.stringify), O.stringifier && (M = O.stringifier), M.stringify && (M = M.stringify);
      let Z = new n(M, this.result.root, this.result.opts).generate();
      return this.result.css = Z[0], this.result.map = Z[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let O of this.plugins) {
        let M = this.runOnRoot(O);
        if (g(M))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let O = this.result.root;
        for (; !O[c]; )
          O[c] = !0, this.walkSync(O);
        if (this.listeners.OnceExit)
          if (O.type === "document")
            for (let M of O.nodes)
              this.visitSync(this.listeners.OnceExit, M);
          else
            this.visitSync(this.listeners.OnceExit, O);
      }
      return this.result;
    }
    then(O, M) {
      return gn.env.NODE_ENV !== "production" && ("from" in this.opts || s(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(O, M);
    }
    toString() {
      return this.css;
    }
    visitSync(O, M) {
      for (let [L, Z] of O) {
        this.result.lastPlugin = L;
        let Q;
        try {
          Q = Z(M, this.helpers);
        } catch (ae) {
          throw this.handleError(ae, M.proxyOf);
        }
        if (M.type !== "root" && M.type !== "document" && !M.parent)
          return !0;
        if (g(Q))
          throw this.getAsyncError();
      }
    }
    visitTick(O) {
      let M = O[O.length - 1], { node: L, visitors: Z } = M;
      if (L.type !== "root" && L.type !== "document" && !L.parent) {
        O.pop();
        return;
      }
      if (Z.length > 0 && M.visitorIndex < Z.length) {
        let [ae, re] = Z[M.visitorIndex];
        M.visitorIndex += 1, M.visitorIndex === Z.length && (M.visitors = [], M.visitorIndex = 0), this.result.lastPlugin = ae;
        try {
          return re(L.toProxy(), this.helpers);
        } catch (X) {
          throw this.handleError(X, L);
        }
      }
      if (M.iterator !== 0) {
        let ae = M.iterator, re;
        for (; re = L.nodes[L.indexes[ae]]; )
          if (L.indexes[ae] += 1, !re[c]) {
            re[c] = !0, O.push(w(re));
            return;
          }
        M.iterator = 0, delete L.indexes[ae];
      }
      let Q = M.events;
      for (; M.eventIndex < Q.length; ) {
        let ae = Q[M.eventIndex];
        if (M.eventIndex += 1, ae === p) {
          L.nodes && L.nodes.length && (L[c] = !0, M.iterator = L.getIterator());
          return;
        } else if (this.listeners[ae]) {
          M.visitors = this.listeners[ae];
          return;
        }
      }
      O.pop();
    }
    walkSync(O) {
      O[c] = !0;
      let M = b(O);
      for (let L of M)
        if (L === p)
          O.nodes && O.each((Z) => {
            Z[c] || this.walkSync(Z);
          });
        else {
          let Z = this.listeners[L];
          if (Z && this.visitSync(Z, O.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return _.registerPostcss = (E) => {
    v = E;
  }, Km = _, _.default = _, a.registerLazyResult(_), t.registerLazyResult(_), Km;
}
var Zm, b9;
function LZ() {
  if (b9) return Zm;
  b9 = 1;
  let e = hO(), t = mg();
  const n = gg();
  let r = r1(), i = gO();
  class a {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let c, u = t;
      try {
        c = u(this._css, this._opts);
      } catch (s) {
        this.error = s;
      }
      if (this.error)
        throw this.error;
      return this._root = c, c;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(c, u, s) {
      u = u.toString(), this.stringified = !1, this._processor = c, this._css = u, this._opts = s, this._map = void 0;
      let l, d = r;
      this.result = new n(this._processor, l, this._opts), this.result.css = u;
      let f = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return f.root;
        }
      });
      let p = new e(d, l, this._opts, u);
      if (p.isMap()) {
        let [g, b] = p.generate();
        g && (this.result.css = g), b && (this.result.map = b);
      } else
        p.clearAnnotation(), this.result.css = p.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(c) {
      return this.async().catch(c);
    }
    finally(c) {
      return this.async().then(c, c);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(c, u) {
      return gn.env.NODE_ENV !== "production" && ("from" in this._opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(c, u);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return Zm = a, a.default = a, Zm;
}
var Ym, x9;
function NZ() {
  if (x9) return Ym;
  x9 = 1;
  let e = dg(), t = vO(), n = LZ(), r = tp();
  class i {
    constructor(o = []) {
      this.version = "8.5.6", this.plugins = this.normalize(o);
    }
    normalize(o) {
      let c = [];
      for (let u of o)
        if (u.postcss === !0 ? u = u() : u.postcss && (u = u.postcss), typeof u == "object" && Array.isArray(u.plugins))
          c = c.concat(u.plugins);
        else if (typeof u == "object" && u.postcssPlugin)
          c.push(u);
        else if (typeof u == "function")
          c.push(u);
        else if (typeof u == "object" && (u.parse || u.stringify)) {
          if (gn.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(u + " is not a PostCSS plugin");
      return c;
    }
    process(o, c = {}) {
      return !this.plugins.length && !c.parser && !c.stringifier && !c.syntax ? new n(this, o, c) : new t(this, o, c);
    }
    use(o) {
      return this.plugins = this.plugins.concat(this.normalize([o])), this;
    }
  }
  return Ym = i, i.default = i, r.registerProcessor(i), e.registerProcessor(i), Ym;
}
var Jm, _9;
function FZ() {
  if (_9) return Jm;
  _9 = 1;
  let e = pg(), t = i1(), n = Pu(), r = lg(), i = a1(), a = dg(), o = qZ(), c = o1(), u = vO(), s = dO(), l = n1(), d = mg(), f = NZ(), p = gg(), g = tp(), b = hg(), w = r1(), y = mO();
  function v(..._) {
    return _.length === 1 && Array.isArray(_[0]) && (_ = _[0]), new f(_);
  }
  return v.plugin = function(E, O) {
    let M = !1;
    function L(...Q) {
      console && console.warn && !M && (M = !0, console.warn(
        E + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), gn.env.LANG && gn.env.LANG.startsWith("cn") && console.warn(
        E + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let ae = O(...Q);
      return ae.postcssPlugin = E, ae.postcssVersion = new f().version, ae;
    }
    let Z;
    return Object.defineProperty(L, "postcss", {
      get() {
        return Z || (Z = L()), Z;
      }
    }), L.process = function(Q, ae, re) {
      return v([L(re)]).process(Q, ae);
    }, L;
  }, v.stringify = w, v.parse = d, v.fromJSON = o, v.list = s, v.comment = (_) => new t(_), v.atRule = (_) => new e(_), v.decl = (_) => new i(_), v.rule = (_) => new b(_), v.root = (_) => new g(_), v.document = (_) => new a(_), v.CssSyntaxError = r, v.Declaration = i, v.Container = n, v.Processor = f, v.Document = a, v.Comment = t, v.Warning = y, v.AtRule = e, v.Result = p, v.Input = c, v.Rule = b, v.Root = g, v.Node = l, u.registerPostcss(v), Jm = v, v.default = v, Jm;
}
var Qm, w9;
function MZ() {
  if (w9) return Qm;
  w9 = 1;
  const e = /* @__PURE__ */ AZ(), t = EZ(), { isPlainObject: n } = OZ(), r = TZ(), i = RZ(), { parse: a } = FZ(), o = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], c = ["script", "style"];
  function u(w, y) {
    w && Object.keys(w).forEach(function(v) {
      y(w[v], v);
    });
  }
  function s(w, y) {
    return {}.hasOwnProperty.call(w, y);
  }
  function l(w, y) {
    const v = [];
    return u(w, function(_) {
      y(_) && v.push(_);
    }), v;
  }
  function d(w) {
    for (const y in w)
      if (s(w, y))
        return !1;
    return !0;
  }
  function f(w) {
    return w.map(function(y) {
      if (!y.url)
        throw new Error("URL missing");
      return y.url + (y.w ? ` ${y.w}w` : "") + (y.h ? ` ${y.h}h` : "") + (y.d ? ` ${y.d}x` : "");
    }).join(", ");
  }
  Qm = g;
  const p = /^[^\0\t\n\f\r /<=>]+$/;
  function g(w, y, v) {
    if (w == null)
      return "";
    typeof w == "number" && (w = w.toString());
    let _ = "", E = "";
    function O(Fe, Xe) {
      const ze = this;
      this.tag = Fe, this.attribs = Xe || {}, this.tagPosition = _.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (ne.length) {
          const Rt = ne[ne.length - 1];
          Rt.text += ze.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        ne.length && o.includes(this.tag) && ne[ne.length - 1].mediaChildren.push(this.tag);
      };
    }
    y = Object.assign({}, g.defaults, y), y.parser = Object.assign({}, b, y.parser);
    const M = function(Fe) {
      return y.allowedTags === !1 || (y.allowedTags || []).indexOf(Fe) > -1;
    };
    c.forEach(function(Fe) {
      M(Fe) && !y.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${Fe}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const L = y.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let Z, Q;
    y.allowedAttributes && (Z = {}, Q = {}, u(y.allowedAttributes, function(Fe, Xe) {
      Z[Xe] = [];
      const ze = [];
      Fe.forEach(function(Rt) {
        typeof Rt == "string" && Rt.indexOf("*") >= 0 ? ze.push(t(Rt).replace(/\\\*/g, ".*")) : Z[Xe].push(Rt);
      }), ze.length && (Q[Xe] = new RegExp("^(" + ze.join("|") + ")$"));
    }));
    const ae = {}, re = {}, X = {};
    u(y.allowedClasses, function(Fe, Xe) {
      if (Z && (s(Z, Xe) || (Z[Xe] = []), Z[Xe].push("class")), ae[Xe] = Fe, Array.isArray(Fe)) {
        const ze = [];
        ae[Xe] = [], X[Xe] = [], Fe.forEach(function(Rt) {
          typeof Rt == "string" && Rt.indexOf("*") >= 0 ? ze.push(t(Rt).replace(/\\\*/g, ".*")) : Rt instanceof RegExp ? X[Xe].push(Rt) : ae[Xe].push(Rt);
        }), ze.length && (re[Xe] = new RegExp("^(" + ze.join("|") + ")$"));
      }
    });
    const de = {};
    let Ce;
    u(y.transformTags, function(Fe, Xe) {
      let ze;
      typeof Fe == "function" ? ze = Fe : typeof Fe == "string" && (ze = g.simpleTransform(Fe)), Xe === "*" ? Ce = ze : de[Xe] = ze;
    });
    let J, ne, De, je, Me, qe, Ve = !1;
    ve();
    const xe = new e.Parser({
      onopentag: function(Fe, Xe) {
        if (y.onOpenTag && y.onOpenTag(Fe, Xe), y.enforceHtmlBoundary && Fe === "html" && ve(), Me) {
          qe++;
          return;
        }
        const ze = new O(Fe, Xe);
        ne.push(ze);
        let Rt = !1;
        const Yt = !!ze.text;
        let ye;
        if (s(de, Fe) && (ye = de[Fe](Fe, Xe), ze.attribs = Xe = ye.attribs, ye.text !== void 0 && (ze.innerText = ye.text), Fe !== ye.tagName && (ze.name = Fe = ye.tagName, je[J] = ye.tagName)), Ce && (ye = Ce(Fe, Xe), ze.attribs = Xe = ye.attribs, Fe !== ye.tagName && (ze.name = Fe = ye.tagName, je[J] = ye.tagName)), (!M(Fe) || y.disallowedTagsMode === "recursiveEscape" && !d(De) || y.nestingLimit != null && J >= y.nestingLimit) && (Rt = !0, De[J] = !0, (y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") && L.indexOf(Fe) !== -1 && (Me = !0, qe = 1)), J++, Rt) {
          if (y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") {
            if (ze.innerText && !Yt) {
              const ie = Ae(ze.innerText);
              y.textFilter ? _ += y.textFilter(ie, Fe) : _ += ie, Ve = !0;
            }
            return;
          }
          E = _, _ = "";
        }
        _ += "<" + Fe, Fe === "script" && (y.allowedScriptHostnames || y.allowedScriptDomains) && (ze.innerText = ""), Rt && (y.disallowedTagsMode === "escape" || y.disallowedTagsMode === "recursiveEscape") && y.preserveEscapedAttributes ? u(Xe, function(ie, Te) {
          _ += " " + Te + '="' + Ae(ie || "", !0) + '"';
        }) : (!Z || s(Z, Fe) || Z["*"]) && u(Xe, function(ie, Te) {
          if (!p.test(Te)) {
            delete ze.attribs[Te];
            return;
          }
          if (ie === "" && !y.allowedEmptyAttributes.includes(Te) && (y.nonBooleanAttributes.includes(Te) || y.nonBooleanAttributes.includes("*"))) {
            delete ze.attribs[Te];
            return;
          }
          let $ = !1;
          if (!Z || s(Z, Fe) && Z[Fe].indexOf(Te) !== -1 || Z["*"] && Z["*"].indexOf(Te) !== -1 || s(Q, Fe) && Q[Fe].test(Te) || Q["*"] && Q["*"].test(Te))
            $ = !0;
          else if (Z && Z[Fe]) {
            for (const _e of Z[Fe])
              if (n(_e) && _e.name && _e.name === Te) {
                $ = !0;
                let Le = "";
                if (_e.multiple === !0) {
                  const et = ie.split(" ");
                  for (const Ge of et)
                    _e.values.indexOf(Ge) !== -1 && (Le === "" ? Le = Ge : Le += " " + Ge);
                } else _e.values.indexOf(ie) >= 0 && (Le = ie);
                ie = Le;
              }
          }
          if ($) {
            if (y.allowedSchemesAppliedToAttributes.indexOf(Te) !== -1 && Ue(Fe, ie)) {
              delete ze.attribs[Te];
              return;
            }
            if (Fe === "script" && Te === "src") {
              let _e = !0;
              try {
                const Le = qt(ie);
                if (y.allowedScriptHostnames || y.allowedScriptDomains) {
                  const et = (y.allowedScriptHostnames || []).find(function($t) {
                    return $t === Le.url.hostname;
                  }), Ge = (y.allowedScriptDomains || []).find(function($t) {
                    return Le.url.hostname === $t || Le.url.hostname.endsWith(`.${$t}`);
                  });
                  _e = et || Ge;
                }
              } catch {
                _e = !1;
              }
              if (!_e) {
                delete ze.attribs[Te];
                return;
              }
            }
            if (Fe === "iframe" && Te === "src") {
              let _e = !0;
              try {
                const Le = qt(ie);
                if (Le.isRelativeUrl)
                  _e = s(y, "allowIframeRelativeUrls") ? y.allowIframeRelativeUrls : !y.allowedIframeHostnames && !y.allowedIframeDomains;
                else if (y.allowedIframeHostnames || y.allowedIframeDomains) {
                  const et = (y.allowedIframeHostnames || []).find(function($t) {
                    return $t === Le.url.hostname;
                  }), Ge = (y.allowedIframeDomains || []).find(function($t) {
                    return Le.url.hostname === $t || Le.url.hostname.endsWith(`.${$t}`);
                  });
                  _e = et || Ge;
                }
              } catch {
                _e = !1;
              }
              if (!_e) {
                delete ze.attribs[Te];
                return;
              }
            }
            if (Te === "srcset")
              try {
                let _e = i(ie);
                if (_e.forEach(function(Le) {
                  Ue("srcset", Le.url) && (Le.evil = !0);
                }), _e = l(_e, function(Le) {
                  return !Le.evil;
                }), _e.length)
                  ie = f(l(_e, function(Le) {
                    return !Le.evil;
                  })), ze.attribs[Te] = ie;
                else {
                  delete ze.attribs[Te];
                  return;
                }
              } catch {
                delete ze.attribs[Te];
                return;
              }
            if (Te === "class") {
              const _e = ae[Fe], Le = ae["*"], et = re[Fe], Ge = X[Fe], $t = X["*"], Be = re["*"], P = [
                et,
                Be
              ].concat(Ge, $t).filter(function(N) {
                return N;
              });
              if (_e && Le ? ie = Dt(ie, r(_e, Le), P) : ie = Dt(ie, _e || Le, P), !ie.length) {
                delete ze.attribs[Te];
                return;
              }
            }
            if (Te === "style") {
              if (y.parseStyleAttributes)
                try {
                  const _e = a(Fe + " {" + ie + "}", { map: !1 }), Le = Ze(_e, y.allowedStyles);
                  if (ie = At(Le), ie.length === 0) {
                    delete ze.attribs[Te];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + Fe + " {" + ie + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete ze.attribs[Te];
                  return;
                }
              else if (y.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            _ += " " + Te, ie && ie.length ? _ += '="' + Ae(ie, !0) + '"' : y.allowedEmptyAttributes.includes(Te) && (_ += '=""');
          } else
            delete ze.attribs[Te];
        }), y.selfClosing.indexOf(Fe) !== -1 ? _ += " />" : (_ += ">", ze.innerText && !Yt && !y.textFilter && (_ += Ae(ze.innerText), Ve = !0)), Rt && (_ = E + Ae(_), E = ""), ze.openingTagLength = _.length - ze.tagPosition;
      },
      ontext: function(Fe) {
        if (Me)
          return;
        const Xe = ne[ne.length - 1];
        let ze;
        if (Xe && (ze = Xe.tag, Fe = Xe.innerText !== void 0 ? Xe.innerText : Fe), y.disallowedTagsMode === "completelyDiscard" && !M(ze))
          Fe = "";
        else if ((y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") && (ze === "script" || ze === "style"))
          _ += Fe;
        else if (!Ve) {
          const Rt = Ae(Fe, !1);
          y.textFilter ? _ += y.textFilter(Rt, ze) : _ += Rt;
        }
        if (ne.length) {
          const Rt = ne[ne.length - 1];
          Rt.text += Fe;
        }
      },
      onclosetag: function(Fe, Xe) {
        if (y.onCloseTag && y.onCloseTag(Fe, Xe), Me)
          if (qe--, !qe)
            Me = !1;
          else
            return;
        const ze = ne.pop();
        if (!ze)
          return;
        if (ze.tag !== Fe) {
          ne.push(ze);
          return;
        }
        Me = y.enforceHtmlBoundary ? Fe === "html" : !1, J--;
        const Rt = De[J];
        if (Rt) {
          if (delete De[J], y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") {
            ze.updateParentNodeText();
            return;
          }
          E = _, _ = "";
        }
        if (je[J] && (Fe = je[J], delete je[J]), y.exclusiveFilter) {
          const Yt = y.exclusiveFilter(ze);
          if (Yt === "excludeTag") {
            Rt && (_ = E, E = ""), _ = _.substring(0, ze.tagPosition) + _.substring(ze.tagPosition + ze.openingTagLength);
            return;
          } else if (Yt) {
            _ = _.substring(0, ze.tagPosition);
            return;
          }
        }
        if (ze.updateParentNodeMediaChildren(), ze.updateParentNodeText(), // Already output />
        y.selfClosing.indexOf(Fe) !== -1 || // Escaped tag, closing tag is implied
        Xe && !M(Fe) && ["escape", "recursiveEscape"].indexOf(y.disallowedTagsMode) >= 0) {
          Rt && (_ = E, E = "");
          return;
        }
        _ += "</" + Fe + ">", Rt && (_ = E + Ae(_), E = ""), Ve = !1;
      }
    }, y.parser);
    return xe.write(w), xe.end(), _;
    function ve() {
      _ = "", J = 0, ne = [], De = {}, je = {}, Me = !1, qe = 0;
    }
    function Ae(Fe, Xe) {
      return typeof Fe != "string" && (Fe = Fe + ""), y.parser.decodeEntities && (Fe = Fe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Xe && (Fe = Fe.replace(/"/g, "&quot;"))), Fe = Fe.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Xe && (Fe = Fe.replace(/"/g, "&quot;")), Fe;
    }
    function Ue(Fe, Xe) {
      for (Xe = Xe.replace(/[\x00-\x20]+/g, ""); ; ) {
        const Yt = Xe.indexOf("<!--");
        if (Yt === -1)
          break;
        const ye = Xe.indexOf("-->", Yt + 4);
        if (ye === -1)
          break;
        Xe = Xe.substring(0, Yt) + Xe.substring(ye + 3);
      }
      const ze = Xe.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!ze)
        return Xe.match(/^[/\\]{2}/) ? !y.allowProtocolRelative : !1;
      const Rt = ze[1].toLowerCase();
      return s(y.allowedSchemesByTag, Fe) ? y.allowedSchemesByTag[Fe].indexOf(Rt) === -1 : !y.allowedSchemes || y.allowedSchemes.indexOf(Rt) === -1;
    }
    function qt(Fe) {
      if (Fe = Fe.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), Fe.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let Xe = "relative://relative-site";
      for (let Yt = 0; Yt < 100; Yt++)
        Xe += `/${Yt}`;
      const ze = new URL(Fe, Xe);
      return {
        isRelativeUrl: ze && ze.hostname === "relative-site" && ze.protocol === "relative:",
        url: ze
      };
    }
    function Ze(Fe, Xe) {
      if (!Xe)
        return Fe;
      const ze = Fe.nodes[0];
      let Rt;
      return Xe[ze.selector] && Xe["*"] ? Rt = r(
        Xe[ze.selector],
        Xe["*"]
      ) : Rt = Xe[ze.selector] || Xe["*"], Rt && (Fe.nodes[0].nodes = ze.nodes.reduce(He(Rt), [])), Fe;
    }
    function At(Fe) {
      return Fe.nodes[0].nodes.reduce(function(Xe, ze) {
        return Xe.push(
          `${ze.prop}:${ze.value}${ze.important ? " !important" : ""}`
        ), Xe;
      }, []).join(";");
    }
    function He(Fe) {
      return function(Xe, ze) {
        return s(Fe, ze.prop) && Fe[ze.prop].some(function(Yt) {
          return Yt.test(ze.value);
        }) && Xe.push(ze), Xe;
      };
    }
    function Dt(Fe, Xe, ze) {
      return Xe ? (Fe = Fe.split(/\s+/), Fe.filter(function(Rt) {
        return Xe.indexOf(Rt) !== -1 || ze.some(function(Yt) {
          return Yt.test(Rt);
        });
      }).join(" ")) : Fe;
    }
  }
  const b = {
    decodeEntities: !0
  };
  return g.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, g.simpleTransform = function(w, y, v) {
    return v = v === void 0 ? !0 : v, y = y || {}, function(_, E) {
      let O;
      if (v)
        for (O in y)
          E[O] = y[O];
      else
        E = y;
      return {
        tagName: w,
        attribs: E
      };
    };
  }, Qm;
}
var BZ = /* @__PURE__ */ MZ();
const S9 = /* @__PURE__ */ h2(BZ);
let Xm;
function yO() {
  function e() {
    Xm || (Xm = Da({
      html: !0,
      // enabled to allow raw HTML in source
      xhtmlOut: !0,
      // Use '/' to close single tags (<br />)
      linkify: !0,
      // Convert URL-like text to links
      breaks: !0,
      // Convert '\n' in paragraphs into <br>
      typographer: !0
      // Enable some language-neutral replacement + quotes beautification
    }));
  }
  function t(n) {
    if (!String(n || "").trim())
      return "";
    e();
    try {
      const r = Xm?.render(n) || n;
      return S9(r, {
        allowedTags: S9.defaults.allowedTags.concat(["img", "details", "summary"])
      });
    } catch {
      return n;
    }
  }
  return {
    mdRender: t
  };
}
const UZ = Br(""), HZ = Br({}), zZ = Br({}), VZ = Br({});
function GZ() {
  return {
    /**
     * state for storing the active security scheme group key.
     * e.g. "bearerAuth-xApiKeyAuth"
     * gets initialized in HttpOperation
     */
    activeSecurityScheme: UZ,
    /**
     * state for storing input values for security scheme, we try to keep those flat as they are fixed for specific security themes (eg, basic has username and password)
     * e.g.
     * ```
     * {
     *   "keyAuth1-username": "sample-username",
     *   "keyAuth1-password": "sample-password",
     *   "keyAuth2-token": "sample-token",
     * }
     * ```
     * Key is the security scheme key, value is the input value.
     */
    authInputs: HZ,
    /**
     * state for storing list of auth header objects for each security scheme.
     * e.g.
     * ```
     * {
     *   "keyAAuthGroup1": [
     *     {
     *       "name": "Authorization",
     *       "value": "sample-api-key"
     *     },
     *     {
     *       "name": "X-API-Key",
     *       "value": "sample-x-api-key"
     *     }
     *   "keyAAuthGroup2": [
     *     {
     *       "name": "Authorization",
     *       "value": "Basic encoded-value"
     *     },
     *   ]
     * }
     * ```
     * The key is the security scheme group key, value is list of auth header objects.
     *
     * Auth header object: key is security scheme name, value is the token value.
     */
    authHeadersMap: zZ,
    /**
     * state for storing auth query string for each security scheme.
     * e.g.
     * ```
     * {
     *   "apiKeyAuth-xApiKeyAuth": "apikey=sample-api-key&x-api-key=sample-x-api-key"
     * }
     * ```
     * The key is the security scheme group key, value is the unified query param string.
     */
    authQueryMap: VZ
  };
}
const qi = {
  useSchemaParser: MU,
  useShiki: GV,
  useCurrentCallback: EG,
  useCurrentResponse: DE,
  useContentTypes: qE,
  useServerList: OG,
  useTryItState: PG,
  useMarkdown: yO,
  useAuth: GZ
}, pn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, WZ = {};
function KZ(e, t) {
  return ke(), Qe("div", null, " !!!!Unknown!!!! ");
}
const ZZ = /* @__PURE__ */ pn(WZ, [["render", KZ]]), YZ = /* @__PURE__ */ ir({
  __name: "MethodBadge",
  props: {
    method: {
      type: String,
      default: ""
    },
    /**
    * Size variations
    * One of ['small', 'large' ]
    */
    size: {
      type: String,
      default: "small",
      validator: (e) => PA.includes(e)
    },
    /**
     * Invert the badge colors
     * Styles for both inverted and non-inverted appearances are defined in mixins/_badges.scss
     */
    inverted: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("span", {
      class: Un(["method-badge", [e.method, e.size, { inverted: e.inverted }]]),
      "data-testid": "method-badge"
    }, cn(e.method), 3));
  }
}), s1 = /* @__PURE__ */ pn(YZ, [["__scopeId", "data-v-97b136aa"]]), JZ = ["data-spec-renderer-toc-active"], QZ = ["href", "title"], XZ = /* @__PURE__ */ ir({
  __name: "NodeItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    activePath: {
      type: String,
      default: "/"
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = e, r = Xa("base-path", Br("")), i = Xa("navigation-type", Br("path")), a = t, o = Ye(() => !n.item.title?.trim()?.includes(" ")), c = Ye(() => n.activePath === n.item.id), u = Ye(() => n.item.deprecated ? `${n.item.title} (deprecated)` : n.item.title), s = (l) => {
      a("item-selected", l);
    };
    return (l, d) => (ke(), Qe("li", {
      class: "node-item",
      "data-spec-renderer-toc-active": c.value ? !0 : void 0,
      "data-testid": "node-item"
    }, [
      Ft("a", {
        class: Un({ "single-word": o.value, active: c.value }),
        "data-testid": "node-item-title-link",
        href: `${jt(r)}${jt(i) === "hash" ? "#" : ""}${e.item.id}`,
        title: u.value,
        onClick: d[0] || (d[0] = $f((f) => s(e.item.id), ["prevent"]))
      }, [
        Ft("span", {
          class: Un(["node-item-title", { "deprecated-node-item": e.item.deprecated }]),
          "data-testid": "node-item-title"
        }, cn(e.item.title), 3),
        e.item.type === jt(Ii).HttpOperation || e.item.type === jt(Ii).HttpWebhook ? (ke(), Mt(s1, {
          key: 0,
          class: "http-operation-badge",
          "data-testid": "http-operation-badge",
          inverted: c.value,
          method: e.item.meta
        }, null, 8, ["inverted", "method"])) : Bt("", !0)
      ], 10, QZ)
    ], 8, JZ));
  }
}), eY = /* @__PURE__ */ pn(XZ, [["__scopeId", "data-v-bfb5d53f"]]), hn = "24px", tY = ["aria-hidden"], C9 = `<g clip-path="url(#clip0_2_1231)">
<path d="M22.2686 17.9663C22.4355 17.677 22.5388 17.3513 22.5388 17.0582V6.89627C22.5388 6.60414 22.4357 6.27808 22.2686 5.98877L11.8961 11.9775L22.2686 17.9663Z" fill="#00599C"/>
<path d="M12.8175 23.7349L21.6174 18.6548C21.8709 18.5084 22.1015 18.2556 22.2686 17.9663L11.8961 11.9775L1.52246 17.9663C1.68934 18.2556 1.92015 18.5082 2.17365 18.6548L10.9736 23.7349C11.4804 24.0278 12.3105 24.0278 12.8171 23.7349H12.8175Z" fill="#004482"/>
<path d="M22.2686 5.98898C22.1015 5.69911 21.8709 5.44636 21.6174 5.30067L12.8173 0.219797C12.3104 -0.0732656 11.4806 -0.0732656 10.9738 0.219797L2.17382 5.30067C1.66682 5.5928 1.25244 6.3113 1.25244 6.8963V17.058C1.25244 17.3509 1.35557 17.6768 1.52263 17.9661L11.8959 11.9775L22.2686 5.98898Z" fill="#659AD2"/>
<path d="M11.896 4.88154C7.98342 4.88154 4.80042 8.06472 4.80042 11.9773C4.80042 15.8898 7.98342 19.073 11.896 19.073C14.4207 19.073 16.7755 17.7142 18.0404 15.5274L14.97 13.7503C14.3363 14.8453 13.1588 15.525 11.896 15.525C9.93979 15.525 8.3481 13.9335 8.3481 11.9771C8.3481 10.0207 9.93998 8.42922 11.896 8.42922C13.1579 8.42922 14.3367 9.10966 14.9691 10.2039L18.0404 8.42697C16.7747 6.23997 14.4207 4.88154 11.896 4.88154ZM17.415 10.7943V11.5832H16.6262V12.3712H17.415V13.16H18.2031V12.3712H18.9912V11.5832H18.2031V10.7943H17.415ZM20.3712 10.7943V11.5832H19.5829V12.3712H20.3712V13.16H21.16V12.3712H21.948V11.5832H21.16V10.7943H20.3712Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2_1231">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, rY = /* @__PURE__ */ ir({
  __name: "LanguageCPlusPlusIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? C9 : i(C9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-c-plus-plus-icon",
      "data-testid": "kui-icon-wrapper-language-c-plus-plus-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-c-plus-plus-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, tY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), nY = ["aria-hidden"], k9 = `<path d="M21.6375 5.75623L12.5813 0.543726C12.4313 0.449976 12.225 0.412476 12 0.412476C11.775 0.412476 11.5688 0.468726 11.4188 0.543726L2.41875 5.77498C2.1 5.96248 1.875 6.43123 1.875 6.78748V17.2312C1.875 17.4375 1.9125 17.6812 2.0625 17.8875L22.0875 6.26248C21.975 6.03748 21.8063 5.86873 21.6375 5.75623Z" fill="#9B4F96"/>
<path d="M2.00623 17.8688C2.09998 18.0188 2.23123 18.15 2.36248 18.225L11.4 23.4563C11.55 23.55 11.7562 23.5875 11.9812 23.5875C12.2062 23.5875 12.4125 23.5313 12.5625 23.4563L21.5625 18.225C21.8812 18.0375 22.1062 17.5688 22.1062 17.2125V6.76877C22.1062 6.60002 22.0875 6.41252 21.9937 6.24377L2.00623 17.8688Z" fill="#68217A"/>
<path d="M15.9937 14.2687C15.2063 15.6562 13.7062 16.5938 12 16.5938C9.46875 16.5938 7.40625 14.5312 7.40625 12C7.40625 9.46875 9.46875 7.40625 12 7.40625C13.7062 7.40625 15.2063 8.34375 15.9937 9.75L18.4312 8.34375C17.1562 6.1125 14.7562 4.59375 12 4.59375C7.9125 4.59375 4.59375 7.9125 4.59375 12C4.59375 16.0875 7.9125 19.4062 12 19.4062C14.7375 19.4062 17.1375 17.9062 18.4125 15.6937L15.9937 14.2687ZM18.1875 12.4125L18.3562 11.6063H17.5687V10.725H18.525L18.75 9.5625H19.6687L19.4437 10.7062H20.1562L20.3812 9.5625H21.2812L21.0562 10.7062H21.5062V11.5875H20.8875L20.7187 12.3937H21.5062V13.275H20.55L20.325 14.4H19.4062L19.6312 13.275H18.9187L18.6937 14.4H17.7937L18.0187 13.275H17.5687V12.3937H18.1875V12.4125ZM19.0875 12.4125H19.8L19.9687 11.6063H19.2562L19.0875 12.4125Z" fill="white"/>`, iY = /* @__PURE__ */ ir({
  __name: "LanguageCSharpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? k9 : i(k9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-c-sharp-icon",
      "data-testid": "kui-icon-wrapper-language-c-sharp-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-c-sharp-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, nY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), aY = ["aria-hidden"], A9 = `<path d="M21.6375 5.75623L12.5813 0.543726C12.4313 0.449976 12.225 0.412476 12 0.412476C11.775 0.412476 11.5688 0.468726 11.4188 0.543726L2.41875 5.77498C2.1 5.96248 1.875 6.43123 1.875 6.78748V17.2312C1.875 17.4375 1.9125 17.6812 2.0625 17.8875L22.0875 6.26248C21.975 6.03748 21.8063 5.86873 21.6375 5.75623Z" fill="#659AD3"/>
<path d="M2.00623 17.8688C2.09998 18.0188 2.23123 18.15 2.36248 18.225L11.4 23.4563C11.55 23.55 11.7562 23.5875 11.9812 23.5875C12.2062 23.5875 12.4125 23.5313 12.5625 23.4563L21.5625 18.225C21.8812 18.0375 22.1062 17.5688 22.1062 17.2125V6.76877C22.1062 6.60002 22.0875 6.41252 21.9937 6.24377L2.00623 17.8688Z" fill="#03599C"/>
<path d="M15.9938 14.2687C15.2063 15.6562 13.7063 16.5938 12 16.5938C9.46875 16.5938 7.40625 14.5312 7.40625 12C7.40625 9.46875 9.46875 7.40625 12 7.40625C13.7063 7.40625 15.2063 8.34375 15.9938 9.75L18.4313 8.34375C17.1563 6.1125 14.7563 4.59375 12 4.59375C7.9125 4.59375 4.59375 7.9125 4.59375 12C4.59375 16.0875 7.9125 19.4062 12 19.4062C14.7375 19.4062 17.1375 17.9062 18.4125 15.6937L15.9938 14.2687Z" fill="white"/>`, oY = /* @__PURE__ */ ir({
  __name: "LanguageCIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? A9 : i(A9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-c-icon",
      "data-testid": "kui-icon-wrapper-language-c-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-c-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, aY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), sY = ["aria-hidden"], E9 = `<mask id="mask0_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask0_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.9563 12.8813C3.9938 13.5375 4.65005 13.2375 4.95005 13.0313C5.2313 12.825 5.32505 12.9938 5.3438 12.6C5.36255 12.3375 5.3813 12.0938 5.3813 11.8313C4.95005 11.7938 4.4813 11.8875 4.12505 12.15C3.9563 12.2813 3.60005 12.7125 3.9563 12.8813Z" fill="#F6D2A2"/>
</g>
<mask id="mask1_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask1_2_1240)">
<path d="M4.31255 13.35C4.1813 13.35 3.93755 13.2938 3.90005 12.9188C3.78755 12.8438 3.75005 12.75 3.75005 12.6938C3.7313 12.4688 3.97505 12.2063 4.1063 12.1125C4.4063 11.8875 4.80005 11.775 5.21255 11.775H5.4563V11.8313C5.47505 12.0375 5.4563 12.2438 5.43755 12.4313C5.43755 12.4875 5.43755 12.5438 5.4188 12.6C5.40005 12.8813 5.3438 12.9188 5.21255 12.975C5.1563 12.9938 5.10005 13.0125 5.0063 13.0875C4.91255 13.1438 4.5938 13.35 4.31255 13.35ZM5.21255 11.8875C4.8188 11.8875 4.46255 12 4.1813 12.2063C4.05005 12.3 3.86255 12.525 3.8813 12.675C3.8813 12.7313 3.9188 12.7875 3.9938 12.825L4.0313 12.8438V12.8813C4.05005 13.1813 4.20005 13.2188 4.31255 13.2188C4.50005 13.2188 4.76255 13.0875 4.9313 12.975C5.0438 12.9 5.1188 12.8813 5.17505 12.8625C5.2688 12.825 5.28755 12.825 5.3063 12.6C5.3063 12.5438 5.3063 12.4875 5.32505 12.4313C5.3438 12.2625 5.3438 12.075 5.3438 11.9063C5.28755 11.8875 5.25005 11.8875 5.21255 11.8875Z" fill="black"/>
</g>
<mask id="mask2_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask2_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.9563 12.8812C4.05005 12.8437 4.16255 12.825 4.2188 12.7312L3.9563 12.8812Z" fill="#C6B198"/>
</g>
<mask id="mask3_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask3_2_1240)">
<path d="M3.95631 12.9375C3.93756 12.9375 3.90006 12.9188 3.90006 12.9C3.88131 12.8625 3.90006 12.825 3.93756 12.825C3.95631 12.825 3.97506 12.8063 3.97506 12.8063C4.05006 12.7688 4.12506 12.75 4.16256 12.6938C4.18131 12.675 4.21881 12.6563 4.25631 12.675C4.27506 12.6938 4.29381 12.7313 4.27506 12.7688C4.20006 12.8625 4.10631 12.9 4.03131 12.9188L3.99381 12.9375H3.95631Z" fill="black"/>
</g>
<mask id="mask4_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask4_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.49371 4.94997C2.94371 4.23747 4.83746 0.993718 6.88121 2.32497L5.49371 4.94997Z" fill="#6AD7E5"/>
</g>
<mask id="mask5_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask5_2_1240)">
<path d="M5.53122 5.02495L5.47497 5.0062C4.16247 4.6312 4.18122 3.6937 4.21872 3.41245C4.31247 2.69995 4.98747 1.94995 5.88747 1.94995C6.24372 1.94995 6.58122 2.06245 6.91872 2.28745L6.97497 2.32495L5.53122 5.02495ZM5.88747 2.0812C5.04372 2.0812 4.42497 2.77495 4.33122 3.4312C4.23747 4.1062 4.64997 4.6312 5.45622 4.87495L6.78747 2.3437C6.50622 2.17495 6.20622 2.0812 5.88747 2.0812Z" fill="black"/>
</g>
<mask id="mask6_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask6_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.8 2.08131C18.8063 0.675056 20.6438 3.86256 18.3 4.66881L16.8 2.08131Z" fill="#6AD7E5"/>
</g>
<mask id="mask7_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask7_2_1240)">
<path d="M18.2812 4.74377L16.725 2.06252L16.7812 2.02502C17.1375 1.78127 17.4937 1.65002 17.85 1.65002C18.7125 1.65002 19.3312 2.36252 19.4625 3.05627C19.5187 3.33752 19.575 4.29377 18.3375 4.70627L18.2812 4.74377ZM16.8937 2.11877L18.3375 4.61252C19.0687 4.35002 19.4437 3.78752 19.3312 3.11252C19.2187 2.47502 18.6375 1.81877 17.85 1.81877C17.5312 1.80002 17.2125 1.89377 16.8937 2.11877Z" fill="black"/>
</g>
<mask id="mask8_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask8_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 21.0563C17.7563 21.375 18.6937 22.3313 17.925 22.8C17.1937 23.475 16.7812 22.05 16.125 21.8625C16.4062 21.4875 16.7625 21.1313 17.25 21.0563Z" fill="#F6D2A2"/>
</g>
<mask id="mask9_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask9_2_1240)">
<path d="M17.5313 23.0438C17.2313 23.0438 16.9688 22.7438 16.7438 22.4625C16.5376 22.2375 16.3313 21.9938 16.1063 21.9188L16.0126 21.9L16.0688 21.825C16.2938 21.5063 16.6688 21.0938 17.2313 21H17.2501L17.2688 21.0187C17.5876 21.225 18.2813 21.8062 18.2626 22.35C18.2626 22.5562 18.1501 22.725 17.9438 22.8563C17.8126 22.9875 17.6813 23.0438 17.5313 23.0438ZM16.2188 21.825C16.4438 21.9188 16.6313 22.1625 16.8188 22.3688C17.0438 22.65 17.2688 22.8937 17.5126 22.8937C17.6251 22.8937 17.7376 22.8375 17.8501 22.725H17.8688C18.0376 22.6125 18.1313 22.4813 18.1313 22.3125C18.1313 21.8813 17.5876 21.3375 17.2126 21.0938C16.8751 21.1875 16.5376 21.4125 16.2188 21.825ZM17.9251 22.8563C17.9063 22.8563 17.8876 22.8375 17.8688 22.8187C17.8313 22.7437 17.7938 22.65 17.7751 22.575C17.7188 22.425 17.6626 22.275 17.5501 22.1625C17.5313 22.1437 17.5313 22.1062 17.5501 22.0687C17.5688 22.05 17.6063 22.05 17.6438 22.0687C17.7751 22.2 17.8501 22.3687 17.9063 22.5375L18.0001 22.7625C18.0188 22.8 18.0001 22.8375 17.9813 22.8563H17.9251Z" fill="black"/>
</g>
<mask id="mask10_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask10_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.10007 22.1437C7.50007 22.2375 7.16257 22.7812 6.65632 23.0625C6.18757 23.3437 6.00007 22.9687 5.96257 22.8937C5.88757 22.8562 5.88757 22.9312 5.77507 22.8187C5.34382 22.125 6.22507 21.6187 6.69382 21.2812C7.35007 21.1312 7.76257 21.6937 8.10007 22.1437Z" fill="#F6D2A2"/>
</g>
<mask id="mask11_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask11_2_1240)">
<path d="M6.33748 23.2125C6.09373 23.2125 5.96248 23.0063 5.92498 22.9313H5.90623C5.84998 22.9313 5.81248 22.9125 5.73748 22.8375V22.8187C5.32498 22.1625 6.03748 21.6562 6.50623 21.3187L6.67498 21.2062H6.71248C6.78748 21.1875 6.84373 21.1875 6.91873 21.1875C7.48123 21.1875 7.83748 21.675 8.13748 22.0687L8.23123 22.2L8.11873 22.2188C7.76248 22.275 7.49998 22.5 7.23748 22.725C7.06873 22.875 6.89998 23.0063 6.71248 23.1188C6.56248 23.175 6.44998 23.2125 6.33748 23.2125ZM5.92498 22.8187C5.94373 22.8187 5.96248 22.8188 5.99998 22.8375H6.01873L6.03748 22.8563C6.07498 22.9125 6.16873 23.0812 6.35623 23.0812C6.44998 23.0812 6.54373 23.0437 6.63748 22.9875C6.82498 22.8937 6.99373 22.7437 7.14373 22.6125C7.38748 22.4062 7.64998 22.1813 7.98748 22.0875C7.70623 21.7125 7.36873 21.3 6.89998 21.3C6.84373 21.3 6.78748 21.3 6.73123 21.3187L6.58123 21.4313C6.09373 21.7688 5.49373 22.2 5.84998 22.7625C5.86873 22.8 5.88748 22.8187 5.92498 22.8187ZM5.96248 22.95C5.92498 22.95 5.88748 22.9125 5.90623 22.875C5.92498 22.6875 6.01873 22.5562 6.11248 22.4062C6.16873 22.3312 6.20623 22.2563 6.24373 22.1813C6.26248 22.1438 6.29998 22.1437 6.31873 22.1437C6.35623 22.1625 6.35623 22.2 6.35623 22.2188C6.31873 22.3125 6.26248 22.3875 6.20623 22.4625C6.11248 22.5938 6.03748 22.7063 6.01873 22.8563C6.01873 22.9313 5.99998 22.95 5.96248 22.95Z" fill="black"/>
</g>
<mask id="mask12_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask12_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.6063 4.06881C5.2688 3.90006 5.02505 3.65631 5.2313 3.26256C5.4188 2.90631 5.77505 2.94381 6.11255 3.11256L5.6063 4.06881ZM17.7751 3.73131C18.1125 3.56256 18.3563 3.31881 18.1501 2.92506C17.9626 2.56881 17.6063 2.60631 17.2688 2.77506L17.7751 3.73131Z" fill="black"/>
</g>
<mask id="mask13_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask13_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0812 12.7875C20.0437 13.4438 19.3875 13.1438 19.0875 12.9375C18.8063 12.7313 18.7125 12.9 18.6937 12.5063C18.675 12.2438 18.6562 12 18.6562 11.7375C19.0875 11.7 19.5562 11.7938 19.9125 12.0563C20.1 12.2063 20.4375 12.6188 20.0812 12.7875Z" fill="#F6D2A2"/>
</g>
<mask id="mask14_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask14_2_1240)">
<path d="M19.7438 13.2563C19.4626 13.2563 19.1438 13.05 19.0501 12.9938C18.9563 12.9375 18.9001 12.9 18.8438 12.8813C18.6938 12.825 18.6563 12.7875 18.6376 12.5063C18.6376 12.45 18.6376 12.3938 18.6188 12.3375C18.6001 12.15 18.5813 11.9438 18.6001 11.7375V11.6813H18.8438C19.2563 11.6813 19.6501 11.7938 19.9501 12.0188C20.0813 12.1125 20.3251 12.375 20.3063 12.6C20.3063 12.675 20.2688 12.7688 20.1563 12.825C20.1188 13.2 19.8751 13.2563 19.7438 13.2563ZM18.7126 11.8125C18.7126 11.9813 18.7126 12.1688 18.7313 12.3375C18.7313 12.3938 18.7313 12.45 18.7501 12.5063C18.7688 12.7313 18.7876 12.7313 18.8813 12.7688C18.9376 12.7875 19.0126 12.825 19.1251 12.8813C19.2938 12.9938 19.5563 13.125 19.7438 13.125C19.8563 13.125 20.0063 13.0875 20.0251 12.7875V12.75L20.0626 12.7313C20.1376 12.6938 20.1751 12.6563 20.1751 12.5813C20.1938 12.4313 20.0063 12.2063 19.8751 12.1125C19.5938 11.9063 19.2188 11.7938 18.8438 11.7938C18.8063 11.8125 18.7688 11.8125 18.7126 11.8125Z" fill="black"/>
</g>
<mask id="mask15_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask15_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0812 12.7875C19.9875 12.75 19.875 12.7312 19.8187 12.6375L20.0812 12.7875Z" fill="#C6B198"/>
</g>
<mask id="mask16_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask16_2_1240)">
<path d="M20.0812 12.8625H20.0625L20.025 12.8437C19.9312 12.8062 19.8375 12.7875 19.7812 12.6937C19.7625 12.675 19.7625 12.6187 19.8 12.6C19.8187 12.5812 19.875 12.5812 19.8937 12.6187C19.9312 12.675 20.0062 12.6937 20.0812 12.7312C20.1 12.7312 20.1187 12.75 20.1187 12.75C20.1562 12.7687 20.175 12.8062 20.1562 12.825C20.1375 12.8437 20.1 12.8625 20.0812 12.8625Z" fill="black"/>
</g>
<mask id="mask17_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask17_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.775 0.75C14.325 0.75 16.7063 1.10625 17.9625 3.5625C19.0875 6.3 18.675 9.2625 18.8625 12.1688C19.0125 14.6625 19.3313 17.5313 18.1875 19.8375C16.9688 22.2563 13.9313 22.875 11.4375 22.7813C9.46879 22.7063 7.10629 22.0688 5.98129 20.2688C4.68754 18.1688 5.28754 15.0375 5.38129 12.6938C5.49379 9.91875 4.63129 7.125 5.55004 4.425C6.46879 1.59375 9.01879 0.95625 11.775 0.75Z" fill="#6AD7E5"/>
</g>
<mask id="mask18_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask18_2_1240)">
<path d="M11.8688 22.8563H11.4C10.6313 22.8375 9.46876 22.7063 8.32501 22.2375C7.21876 21.7875 6.41251 21.15 5.88751 20.3063C4.83751 18.6 5.02501 16.2563 5.19376 14.175C5.23126 13.65 5.26876 13.1625 5.28751 12.6938C5.32501 11.7188 5.25001 10.7063 5.15626 9.75004C5.00626 7.98754 4.85626 6.16879 5.43751 4.40629C5.88751 3.09379 6.69376 2.15629 7.91251 1.55629C8.86876 1.08754 10.05 0.825043 11.7375 0.693793C14.25 0.675043 16.7438 1.03129 18 3.52504C18.825 5.53129 18.825 7.68754 18.8438 9.76879C18.8438 10.5563 18.8438 11.3625 18.9 12.15C18.9188 12.3938 18.9375 12.6375 18.9375 12.8813C19.0875 15.1688 19.2563 17.7563 18.2063 19.8563C17.6813 20.925 16.7625 21.7125 15.5063 22.2188C14.4938 22.6313 13.2188 22.8563 11.8688 22.8563ZM11.775 0.806293C9.13126 1.01254 6.54376 1.59379 5.58751 4.44379C5.00626 6.18754 5.15626 7.98754 5.30626 9.73129C5.38126 10.7063 5.47501 11.7 5.43751 12.6938C5.41876 13.1625 5.38126 13.65 5.34376 14.175C5.17501 16.2375 4.98751 18.5625 6.01876 20.2313C6.45001 20.925 7.83751 22.575 11.4188 22.7063H11.8875C16.0313 22.7063 17.5688 20.8688 18.1313 19.7813C19.1625 17.7188 18.9938 15.1313 18.8625 12.8625C18.8438 12.6188 18.825 12.375 18.825 12.1313C18.7875 11.3438 18.7688 10.5375 18.7688 9.75004C18.75 7.68754 18.75 5.53129 17.9438 3.54379C17.3813 2.43754 16.5375 1.68754 15.375 1.25629C14.175 0.862543 12.825 0.806293 11.775 0.806293Z" fill="black"/>
</g>
<mask id="mask19_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask19_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.2251 4.16253C12.6751 6.82503 17.0251 6.11253 16.4063 3.43128C15.8438 1.03128 12.0751 1.70628 12.2251 4.16253Z" fill="white"/>
</g>
<mask id="mask20_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask20_2_1240)">
<path d="M14.2876 5.9063C13.4438 5.9063 12.3751 5.4563 12.1501 4.1813C12.1126 3.5813 12.3001 3.03755 12.6938 2.62505C13.1251 2.1563 13.7813 1.8938 14.4563 1.8938C15.2438 1.8938 16.1813 2.3063 16.4438 3.45005C16.5938 4.08755 16.4813 4.65005 16.1251 5.10005C15.7313 5.58755 15.0376 5.9063 14.2876 5.9063ZM12.2813 4.16255C12.3751 4.68755 12.6188 5.10005 13.0126 5.40005C13.3501 5.66255 13.8188 5.7938 14.2876 5.7938C14.9813 5.7938 15.6563 5.4938 16.0313 5.02505C16.3688 4.61255 16.4626 4.0688 16.3313 3.4688C16.0876 2.40005 15.2063 2.02505 14.4563 2.02505C13.8188 2.02505 13.2001 2.28755 12.7876 2.7188C12.4313 3.0938 12.2438 3.60005 12.2813 4.16255Z" fill="black"/>
</g>
<mask id="mask21_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask21_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.03123 4.5938C7.63123 6.90005 11.325 6.3188 11.1937 3.9938C11.025 1.2188 6.44998 1.7438 7.03123 4.5938Z" fill="white"/>
</g>
<mask id="mask22_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask22_2_1240)">
<path d="M9 6.13123C8.19375 6.13123 7.25625 5.73748 6.95625 4.61248C6.825 3.95623 6.95625 3.35623 7.33125 2.90623C7.74375 2.39998 8.41875 2.09998 9.15 2.09998C10.125 2.09998 11.1563 2.68123 11.2313 3.99373C11.2688 4.53748 11.1 5.02498 10.725 5.41873C10.3313 5.84998 9.675 6.13123 9 6.13123ZM9.15 2.23123C8.45625 2.23123 7.81875 2.51248 7.425 2.98123C7.06875 3.41248 6.95625 3.95623 7.0875 4.57498C7.35 5.62498 8.25 5.99998 9 5.99998C9.6375 5.99998 10.2563 5.75623 10.65 5.32498C10.9875 4.96873 11.1563 4.49998 11.1188 3.99373C11.0813 3.18748 10.5375 2.23123 9.15 2.23123Z" fill="black"/>
</g>
<mask id="mask23_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask23_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 7.34995C12.75 7.68745 12.825 8.0812 12.7688 8.4562C12.675 8.62495 12.5063 8.6437 12.3563 8.69995C12.15 8.66245 11.9813 8.5312 11.8875 8.3437C11.8313 7.9312 11.9063 7.5187 11.925 7.1062L12.75 7.34995Z" fill="white"/>
</g>
<mask id="mask24_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask24_2_1240)">
<path d="M12.3562 8.77505C12.1125 8.73755 11.925 8.58755 11.8312 8.3813C11.7937 8.0813 11.8125 7.80005 11.8312 7.5188C11.85 7.38755 11.85 7.2563 11.85 7.12505V7.05005L12.8062 7.35005V7.38755C12.8062 7.50005 12.825 7.61255 12.825 7.7438C12.8437 7.98755 12.8625 8.25005 12.825 8.4938V8.51255C12.75 8.66255 12.6187 8.70005 12.4875 8.7563C12.45 8.73755 12.4125 8.7563 12.3562 8.77505ZM11.9437 8.32505C12.0187 8.4938 12.1687 8.6063 12.3375 8.6438C12.375 8.62505 12.4125 8.62505 12.4312 8.6063C12.5437 8.5688 12.6375 8.5313 12.6937 8.43755C12.7312 8.21255 12.7125 7.9688 12.6937 7.72505C12.6937 7.61255 12.675 7.50005 12.675 7.4063L11.9625 7.1813C11.9625 7.2938 11.9437 7.4063 11.9437 7.50005C11.925 7.80005 11.9062 8.06255 11.9437 8.32505Z" fill="black"/>
</g>
<mask id="mask25_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask25_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.68123 4.2187C8.68123 4.5937 8.39998 4.8937 8.06248 4.8937C7.72498 4.8937 7.44373 4.5937 7.44373 4.2187C7.44373 3.8437 7.72498 3.5437 8.06248 3.5437C8.39998 3.5437 8.68123 3.8437 8.68123 4.2187Z" fill="black"/>
</g>
<mask id="mask26_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask26_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47505 4.3687C8.47505 4.46245 8.40005 4.53745 8.32505 4.53745C8.25005 4.53745 8.17505 4.46245 8.17505 4.3687C8.17505 4.27495 8.25005 4.19995 8.32505 4.19995C8.4188 4.19995 8.47505 4.27495 8.47505 4.3687Z" fill="white"/>
</g>
<mask id="mask27_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask27_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9125 4.05C13.9125 4.425 13.6313 4.725 13.2938 4.725C12.9563 4.725 12.675 4.425 12.675 4.05C12.675 3.675 12.9563 3.375 13.2938 3.375C13.6313 3.375 13.9125 3.675 13.9125 4.05Z" fill="black"/>
</g>
<mask id="mask28_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask28_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.725 4.2C13.725 4.29375 13.6687 4.36875 13.575 4.36875C13.5 4.36875 13.425 4.29375 13.425 4.2C13.425 4.10625 13.4812 4.03125 13.575 4.03125C13.65 4.03125 13.725 4.10625 13.725 4.2ZM10.95 7.3125C10.6687 7.96875 11.1 9.3 11.85 8.325C11.7937 7.9125 11.8687 7.5 11.8875 7.0875L10.95 7.3125Z" fill="white"/>
</g>
<mask id="mask29_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask29_2_1240)">
<path d="M11.3437 8.73752C11.2125 8.73752 11.0812 8.66252 10.9875 8.51252C10.7812 8.21252 10.7437 7.65002 10.8937 7.29377L10.9125 7.25627L11.9437 6.99377V7.06877L11.925 7.48127C11.9062 7.76252 11.8875 8.02502 11.925 8.30627V8.32502L11.9062 8.34377C11.7187 8.60627 11.5312 8.73752 11.3437 8.73752ZM11.0062 7.36877C10.8937 7.68752 10.9312 8.19377 11.1 8.43752C11.175 8.55002 11.25 8.60627 11.3437 8.60627C11.475 8.60627 11.625 8.49377 11.775 8.30627C11.7375 8.02502 11.7562 7.74377 11.7937 7.48127L11.8125 7.16252L11.0062 7.36877Z" fill="black"/>
</g>
<mask id="mask30_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask30_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0438 6.03752C10.5375 6.07502 10.125 6.69377 10.3875 7.16252C10.7438 7.80002 11.5125 7.10627 12 7.16252C12.5625 7.18127 13.0125 7.76252 13.4625 7.27502C13.9688 6.73127 13.2375 6.20627 12.6938 5.96252L11.0438 6.03752Z" fill="#F6D2A2"/>
</g>
<mask id="mask31_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask31_2_1240)">
<path d="M13.0688 7.5375C12.9 7.5375 12.7313 7.4625 12.5625 7.3875C12.3938 7.3125 12.2063 7.2375 12 7.2375H11.9438C11.7938 7.2375 11.625 7.29375 11.4375 7.36875C11.2313 7.44375 11.025 7.5 10.8375 7.5C10.6125 7.5 10.4438 7.40625 10.3313 7.2C10.2 6.975 10.2188 6.7125 10.35 6.46875C10.5 6.1875 10.7625 6.01875 11.0438 5.98125L12.7125 5.90625H12.7313C13.1438 6.075 13.6125 6.39375 13.7063 6.76875C13.7438 6.95625 13.6875 7.14375 13.5375 7.3125C13.3875 7.48125 13.2375 7.5375 13.0688 7.5375ZM12.0188 7.125C12.225 7.125 12.4313 7.21875 12.6188 7.29375C12.7875 7.36875 12.9375 7.425 13.0875 7.425C13.2188 7.425 13.3313 7.36875 13.4438 7.25625C13.575 7.125 13.6125 6.975 13.5938 6.825C13.5188 6.50625 13.0688 6.20625 12.7125 6.05625L11.0813 6.13125C10.8375 6.15 10.6125 6.31875 10.4813 6.54375C10.3688 6.75 10.3688 6.975 10.4625 7.1625C10.5563 7.33125 10.6688 7.40625 10.8563 7.40625C11.025 7.40625 11.2125 7.33125 11.4 7.275C11.6063 7.2 11.775 7.14375 11.9625 7.14375C11.9625 7.10625 11.9813 7.10625 12.0188 7.125Z" fill="#231F20"/>
</g>
<mask id="mask32_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask32_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9876 6.01876C10.9501 5.13751 12.6376 5.02501 12.8251 5.75626C13.0313 6.50626 11.0626 6.67501 10.9876 6.01876Z" fill="black"/>
</g>`, uY = /* @__PURE__ */ ir({
  __name: "LanguageGoIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? E9 : i(E9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-go-icon",
      "data-testid": "kui-icon-wrapper-language-go-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-go-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, sY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), cY = ["aria-hidden"], O9 = `<path d="M8.92824 18.3975C8.92824 18.3975 8.03443 18.9176 9.56518 19.0931C11.4199 19.305 12.3677 19.2746 14.4111 18.8884C14.4111 18.8884 14.9494 19.225 15.6998 19.5167C11.1175 21.4798 5.32956 19.4029 8.92824 18.3975ZM8.36799 15.8353C8.36799 15.8353 7.36524 16.5776 8.89731 16.7363C10.8786 16.9408 12.4429 16.9575 15.1512 16.4363C15.1512 16.4363 15.5249 16.816 16.1134 17.0233C10.5743 18.6433 4.40481 17.1508 8.36799 15.8353Z" fill="#0074BD"/>
<path d="M13.0879 11.4883C14.2175 12.7886 12.7916 13.9577 12.7916 13.9577C12.7916 13.9577 15.6583 12.4781 14.342 10.6245C13.1122 8.89669 12.1695 8.0385 17.2736 5.07825C17.2736 5.07843 9.26154 7.07887 13.0879 11.4883Z" fill="#EA2D2E"/>
<path d="M19.1481 20.2929C19.1481 20.2929 19.8098 20.8386 18.4191 21.2602C15.775 22.0612 7.4117 22.3027 5.08895 21.2923C4.25439 20.9289 5.82002 20.4251 6.31258 20.3188C6.82614 20.2076 7.11939 20.2279 7.11939 20.2279C6.1907 19.5741 1.11695 21.5122 4.54258 22.0682C13.884 23.5824 21.5708 21.3862 19.1481 20.2929ZM9.35852 13.1801C9.35852 13.1801 5.10489 14.1906 7.85233 14.5579C9.01258 14.7131 11.3245 14.6775 13.4794 14.4967C15.24 14.3488 17.0068 14.0329 17.0068 14.0329C17.0068 14.0329 16.3866 14.2989 15.9373 14.6053C11.617 15.7417 3.27283 15.2124 5.67527 14.0507C7.70627 13.0684 9.35852 13.1801 9.35852 13.1801ZM16.9892 17.4452C21.3806 15.1639 19.35 12.9714 17.9327 13.2667C17.5862 13.3389 17.4308 13.4017 17.4308 13.4017C17.4308 13.4017 17.5598 13.1994 17.8058 13.1124C20.6095 12.1271 22.7653 16.0192 16.9015 17.5609C16.9015 17.5605 16.9688 17.4996 16.9892 17.4452Z" fill="#0074BD"/>
<path d="M14.342 0.297607C14.342 0.297607 16.7735 2.73061 12.0352 6.47067C8.23535 9.47179 11.1688 11.1825 12.0339 13.138C9.81559 11.1368 8.18847 9.37486 9.27991 7.73517C10.8827 5.32879 15.3228 4.16161 14.342 0.297607Z" fill="#EA2D2E"/>
<path d="M9.79014 23.629C14.0044 23.8984 20.4776 23.479 20.6308 21.4847C20.6308 21.4847 20.3363 22.2407 17.1476 22.8406C13.5503 23.5178 9.11251 23.4389 6.48132 23.0044C6.48132 23.0046 7.02039 23.4509 9.79014 23.629Z" fill="#0074BD"/>`, lY = /* @__PURE__ */ ir({
  __name: "LanguageJavaIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? O9 : i(O9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-java-icon",
      "data-testid": "kui-icon-wrapper-language-java-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-java-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, cY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), fY = ["aria-hidden"], T9 = `<g clip-path="url(#clip0_2_1379)">
<path d="M0.264038 0.264038H23.736V23.7362H0.264038V0.264038Z" fill="#F0DB4F"/>
<path d="M21.815 18.138C21.6431 17.0672 20.9449 16.1678 18.8765 15.3291C18.158 14.9989 17.357 14.7625 17.1184 14.218C17.0336 13.9011 17.0224 13.7226 17.076 13.5308C17.2299 12.9083 17.973 12.7142 18.5619 12.8927C18.9412 13.0199 19.3003 13.3122 19.5169 13.7785C20.5297 13.1226 20.5277 13.1269 21.2349 12.6762C20.976 12.2747 20.8378 12.0895 20.6683 11.9177C20.0591 11.2373 19.229 10.8869 17.9015 10.9137L17.21 11.0031C16.5474 11.1705 15.9159 11.5184 15.5456 11.9847C14.4345 13.2454 14.7514 15.4519 16.1034 16.36C17.4354 17.3597 19.3922 17.5872 19.6421 18.522C19.8853 19.6665 18.801 20.037 17.7232 19.9054C16.929 19.7402 16.4872 19.3365 16.0097 18.6025C15.1307 19.1112 15.1307 19.1112 14.2269 19.6309C14.4412 20.0995 14.6664 20.3115 15.0257 20.7175C16.7259 22.4421 20.9807 22.3574 21.7438 19.747C21.7747 19.6574 21.9802 19.0596 21.815 18.138ZM13.0241 11.0519H10.8287L10.8197 16.7278C10.8197 17.935 10.8821 19.0416 10.6858 19.3808C10.3646 20.0479 9.53229 19.9652 9.15298 19.8358C8.76692 19.6461 8.57061 19.3763 8.34317 18.9949C8.28073 18.8854 8.23386 18.8007 8.21811 18.7941L6.43311 19.8872C6.72992 20.4964 7.16717 21.0252 7.72723 21.3687C8.56386 21.8708 9.68829 22.0247 10.8643 21.7547C11.6297 21.5318 12.29 21.07 12.6358 20.367C13.1357 19.4455 13.0284 18.33 13.0239 17.0963C13.0352 15.0835 13.0241 13.071 13.0241 11.0519Z" fill="#323330"/>
</g>
<defs>
<clipPath id="clip0_2_1379">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, pY = /* @__PURE__ */ ir({
  __name: "LanguageJavascriptIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? T9 : i(T9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-javascript-icon",
      "data-testid": "kui-icon-wrapper-language-javascript-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-javascript-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, fY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), dY = ["aria-hidden"], P9 = `<g clip-path="url(#clip0_2_1382)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9803 17.6818C17.124 24.6939 22.158 15.7247 22.1505 10.3308C22.1419 3.95359 15.6784 0.389404 11.9762 0.389404C6.03413 0.389404 0.375 5.30041 0.375 12.0197C0.375 19.4882 6.86175 23.625 11.9762 23.625C10.8189 23.4583 6.96206 22.632 6.91012 13.7486C6.87525 7.74034 8.87006 5.33997 11.9677 6.39597C12.0371 6.42165 15.3846 7.74222 15.3846 12.056C15.3846 16.3513 11.9803 17.6818 11.9803 17.6818Z" fill="url(#paint0_linear_2_1382)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9743 6.39109C8.57549 5.21959 4.41187 8.02084 4.41187 13.6318C4.41187 22.7934 11.2011 23.625 12.024 23.625C17.9659 23.625 23.625 18.714 23.625 11.9947C23.625 4.52621 17.1382 0.389399 12.0238 0.389399C13.4404 0.193274 19.6586 1.9224 19.6586 10.4214C19.6586 15.9637 15.0154 18.981 11.9955 17.6919C11.9261 17.6662 8.57868 16.3456 8.57868 12.0318C8.57868 7.73621 11.9743 6.3909 11.9743 6.39109Z" fill="url(#paint1_linear_2_1382)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2_1382" x1="3.60969" y1="4.02333" x2="19.9869" y2="20.4052" gradientUnits="userSpaceOnUse">
<stop/>
<stop offset="1" stop-color="white"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1382" x1="20.7296" y1="19.6609" x2="4.35237" y2="3.28052" gradientUnits="userSpaceOnUse">
<stop/>
<stop offset="1" stop-color="white"/>
</linearGradient>
<clipPath id="clip0_2_1382">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, hY = /* @__PURE__ */ ir({
  __name: "LanguageJsonIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? P9 : i(P9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-json-icon",
      "data-testid": "kui-icon-wrapper-language-json-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-json-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, dY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), mY = ["aria-hidden"], R9 = `<g clip-path="url(#clip0_2_1385)">
<path d="M12.5547 0.154743C12.3824 0.0560657 12.1874 0.00415039 11.9889 0.00415039C11.7904 0.00415039 11.5953 0.0560657 11.4231 0.154743L2.08186 5.58006C1.72654 5.78106 1.52686 6.16037 1.52686 6.56256V17.4353C1.52686 17.8371 1.74867 18.2166 2.08148 18.4178L11.4227 23.8429C11.595 23.9416 11.7901 23.9936 11.9886 23.9936C12.1871 23.9936 12.3822 23.9416 12.5545 23.8429L21.8957 18.4176C22.2509 18.2166 22.4504 17.8371 22.4504 17.4351V6.56256C22.4504 6.16056 22.2285 5.78124 21.8957 5.58006L12.5547 0.154743Z" fill="url(#paint0_linear_2_1385)"/>
<path d="M21.9182 5.57997L12.5327 0.154653C12.4406 0.107813 12.3439 0.0704341 12.2442 0.0430908L1.72693 18.1496C1.81392 18.2565 1.91909 18.3473 2.03762 18.4177L11.4233 23.8428C11.6896 23.999 12.0001 24.0438 12.2886 23.9544L22.1624 5.78097C22.0975 5.69608 22.014 5.62729 21.9182 5.57997Z" fill="url(#paint1_linear_2_1385)"/>
<path d="M21.9184 18.4172C22.1847 18.261 22.3843 17.9931 22.473 17.7029L12.1999 0.0202985C11.9337 -0.0243265 11.6451 -0.00201398 11.4012 0.154361L2.08203 5.55736L12.1332 23.9989C12.2663 23.9764 12.4219 23.9318 12.555 23.8649L21.9184 18.4172Z" fill="url(#paint2_linear_2_1385)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2_1385" x1="15.793" y1="4.19491" x2="7.26197" y2="21.49" gradientUnits="userSpaceOnUse">
<stop stop-color="#3F873F"/>
<stop offset="0.33" stop-color="#3F8B3D"/>
<stop offset="0.637" stop-color="#3E9638"/>
<stop offset="0.934" stop-color="#3DA92E"/>
<stop offset="1" stop-color="#3DAE2B"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1385" x1="10.5695" y1="13.2686" x2="34.3718" y2="-4.20975" gradientUnits="userSpaceOnUse">
<stop offset="0.138" stop-color="#3F873F"/>
<stop offset="0.402" stop-color="#52A044"/>
<stop offset="0.713" stop-color="#64B749"/>
<stop offset="0.908" stop-color="#6ABF4B"/>
</linearGradient>
<linearGradient id="paint2_linear_2_1385" x1="1.18497" y1="11.9952" x2="22.8" y2="11.9952" gradientUnits="userSpaceOnUse">
<stop offset="0.092" stop-color="#6ABF4B"/>
<stop offset="0.287" stop-color="#64B749"/>
<stop offset="0.598" stop-color="#52A044"/>
<stop offset="0.862" stop-color="#3F873F"/>
</linearGradient>
<clipPath id="clip0_2_1385">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, gY = /* @__PURE__ */ ir({
  __name: "LanguageNodejsIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? R9 : i(R9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-nodejs-icon",
      "data-testid": "kui-icon-wrapper-language-nodejs-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-nodejs-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, mY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), vY = ["aria-hidden"], I9 = `<path d="M0 11.9999C0 15.4861 5.37262 18.3125 12 18.3125C18.6274 18.3125 24 15.4861 24 11.9999C24 8.51375 18.6272 5.68738 12 5.68738C5.37262 5.68738 0 8.51375 0 11.9999Z" fill="url(#paint0_radial_2_1389)"/>
<path d="M12 17.8438C18.3684 17.8438 23.5312 15.2272 23.5312 11.9999C23.5312 8.77232 18.3684 6.15613 12 6.15613C5.63156 6.15613 0.46875 8.77232 0.46875 11.9999C0.46875 15.2272 5.63156 17.8438 12 17.8438Z" fill="#777BB3"/>
<path d="M6.51973 12.7245C7.04341 12.7245 7.43416 12.6279 7.68148 12.4376C7.92635 12.249 8.09529 11.9225 8.18398 11.4673C8.26648 11.0417 8.23498 10.7447 8.09023 10.5842C7.94248 10.4203 7.62279 10.3372 7.14016 10.3372H6.30316L5.83948 12.7245H6.51973ZM3.78241 15.665C3.76321 15.665 3.74425 15.6607 3.7269 15.6525C3.70954 15.6443 3.69422 15.6323 3.68203 15.6175C3.66984 15.6027 3.66109 15.5853 3.6564 15.5667C3.65172 15.5481 3.65121 15.5286 3.65491 15.5098L4.88435 9.18392C4.89016 9.15435 4.90604 9.12771 4.92929 9.10853C4.95254 9.08935 4.98171 9.07882 5.01185 9.07874H7.66198C8.49485 9.07874 9.11473 9.30486 9.50454 9.75092C9.89604 10.199 10.0172 10.826 9.86398 11.6137C9.80154 11.9345 9.69429 12.2325 9.54523 12.4995C9.39006 12.7741 9.19207 13.0222 8.95873 13.2345C8.67166 13.503 8.34673 13.698 7.99366 13.8125C7.64641 13.9258 7.20016 13.9832 6.66804 13.9832H5.59479L5.28841 15.5597C5.28263 15.5893 5.26671 15.6161 5.24338 15.6353C5.22005 15.6545 5.19077 15.665 5.16054 15.665H3.78241Z" fill="black"/>
<path d="M6.41067 10.4674H7.14024C7.7228 10.4674 7.92511 10.5953 7.99392 10.6716C8.10774 10.798 8.12949 11.0648 8.05599 11.4426C7.97367 11.8658 7.82105 12.166 7.60224 12.3344C7.37836 12.5069 7.01386 12.5942 6.5198 12.5942H5.99742L6.41086 10.4676L6.41067 10.4674ZM7.66205 8.94867H5.01211C4.95168 8.94868 4.89313 8.96968 4.84648 9.00809C4.79983 9.0465 4.76797 9.09993 4.75636 9.15924L3.52692 15.4853C3.51966 15.523 3.52081 15.5618 3.53029 15.599C3.53977 15.6362 3.55735 15.6708 3.58176 15.7004C3.60617 15.73 3.63682 15.7539 3.67152 15.7703C3.70622 15.7867 3.74411 15.7952 3.78249 15.7952H5.16061C5.22104 15.7952 5.27956 15.7741 5.32618 15.7357C5.3728 15.6972 5.40461 15.6438 5.41617 15.5845L5.70211 14.1134H6.66792C7.21392 14.1134 7.67367 14.0537 8.03424 13.9364C8.40492 13.816 8.74599 13.6118 9.04786 13.3294C9.29092 13.108 9.49719 12.8494 9.65892 12.5631C9.81474 12.2843 9.92686 11.973 9.99174 11.6385C10.153 10.8092 10.0219 10.1453 9.60249 9.6653C9.18699 9.18961 8.53411 8.94849 7.66205 8.94849V8.94867ZM5.68149 12.8545H6.5198C7.07536 12.8545 7.48917 12.75 7.76105 12.5404C8.03311 12.3312 8.2163 11.9817 8.31192 11.4921C8.40286 11.0219 8.36142 10.6902 8.18724 10.4969C8.01267 10.3037 7.66393 10.207 7.14024 10.207H6.19599L5.68149 12.8545ZM7.66224 9.20855C8.45949 9.20855 9.04092 9.41799 9.40655 9.8363C9.77217 10.2548 9.88205 10.8389 9.73655 11.5887C9.67617 11.8977 9.57474 12.18 9.43186 12.4358C9.28861 12.6919 9.10186 12.9259 8.87105 13.1384C8.5958 13.3958 8.29036 13.5794 7.9538 13.6887C7.61742 13.7982 7.1888 13.8527 6.66811 13.8527H5.48761L5.1608 15.5346H3.78267L5.0123 9.20855H7.66224Z" fill="white"/>
<path d="M13.0235 13.9832C13.0043 13.9832 12.9853 13.979 12.9679 13.9708C12.9505 13.9626 12.9352 13.9507 12.923 13.9358C12.9107 13.921 12.9019 13.9037 12.8972 13.885C12.8925 13.8664 12.892 13.847 12.8956 13.8281L13.4394 11.0291C13.4913 10.7629 13.4786 10.572 13.4038 10.491C13.3578 10.4417 13.2202 10.359 12.8131 10.359H11.8276L11.144 13.878C11.1381 13.9076 11.1222 13.9343 11.0988 13.9534C11.0754 13.9726 11.0462 13.983 11.0159 13.983H9.64908C9.62987 13.983 9.61091 13.9788 9.59353 13.9706C9.57615 13.9624 9.5608 13.9505 9.54856 13.9357C9.53633 13.9209 9.52751 13.9036 9.52275 13.885C9.51799 13.8664 9.51739 13.847 9.52101 13.8281L10.7506 7.50204C10.7565 7.4724 10.7724 7.44571 10.7957 7.42652C10.819 7.40734 10.8483 7.39685 10.8785 7.39685H12.2454C12.2646 7.39684 12.2836 7.40107 12.3009 7.40924C12.3183 7.41741 12.3337 7.42932 12.3459 7.44412C12.3581 7.45892 12.367 7.47624 12.3717 7.49484C12.3765 7.51344 12.3771 7.53287 12.3734 7.55173L12.0768 9.07873H13.1368C13.9443 9.07873 14.4918 9.22085 14.8108 9.51391C15.1357 9.8126 15.2373 10.2902 15.1123 10.9339L14.5402 13.878C14.5343 13.9076 14.5184 13.9342 14.4951 13.9534C14.4717 13.9725 14.4425 13.983 14.4123 13.983H13.0235V13.9832Z" fill="black"/>
<path d="M12.2457 7.2666H10.8786C10.8181 7.26662 10.7596 7.28765 10.7129 7.32609C10.6663 7.36454 10.6344 7.41801 10.6229 7.47735L9.39342 13.8032C9.38612 13.8409 9.38725 13.8798 9.39671 13.917C9.40618 13.9542 9.42375 13.9888 9.44817 14.0185C9.47258 14.0481 9.50324 14.072 9.53796 14.0884C9.57267 14.1048 9.61058 14.1133 9.64898 14.1134H11.016C11.0765 14.1133 11.1351 14.0923 11.1817 14.0539C11.2284 14.0154 11.2602 13.9619 11.2718 13.9026L11.935 10.4892H12.8129C13.2194 10.4892 13.3049 10.576 13.308 10.5799C13.3328 10.6062 13.3652 10.729 13.3116 11.0044L12.7679 13.8032C12.7606 13.8409 12.7617 13.8798 12.7712 13.917C12.7806 13.9542 12.7982 13.9889 12.8227 14.0185C12.8471 14.0482 12.8778 14.072 12.9125 14.0884C12.9473 14.1048 12.9852 14.1133 13.0236 14.1134H14.4126C14.473 14.1133 14.5316 14.0922 14.5782 14.0538C14.6248 14.0154 14.6566 13.9619 14.6682 13.9026L15.2402 10.9589C15.3743 10.2677 15.2595 9.74948 14.899 9.41816C14.5547 9.10204 13.9784 8.94848 13.1369 8.94848H12.235L12.5014 7.57691C12.5087 7.53919 12.5076 7.50031 12.4982 7.46306C12.4887 7.42582 12.4711 7.39112 12.4467 7.36147C12.4223 7.33181 12.3916 7.30793 12.3568 7.29153C12.322 7.27513 12.2841 7.26662 12.2457 7.2666ZM12.2457 7.52723L11.9189 9.20873H13.1369C13.9032 9.20873 14.4319 9.3426 14.7225 9.60998C15.0137 9.87735 15.1007 10.3103 14.9847 10.9094L14.4124 13.8529H13.0236L13.5675 11.0539C13.6294 10.7355 13.6065 10.5184 13.4991 10.4025C13.3917 10.2869 13.1629 10.2289 12.8132 10.2289H11.7203L11.016 13.8527H9.64879L10.8784 7.52666H12.2457V7.52723Z" fill="white"/>
<path d="M17.2755 12.7245C17.7992 12.7245 18.1901 12.6279 18.4376 12.4376C18.6821 12.249 18.8513 11.9225 18.94 11.4673C19.0225 11.0417 18.9911 10.7447 18.8462 10.5842C18.6985 10.4203 18.3788 10.3372 17.8961 10.3372H17.0593L16.5953 12.7245H17.2755ZM14.5388 15.665C14.5195 15.6651 14.5005 15.6608 14.4831 15.6526C14.4657 15.6445 14.4504 15.6325 14.4381 15.6177C14.4259 15.6028 14.4171 15.5854 14.4124 15.5668C14.4077 15.5481 14.4072 15.5287 14.4109 15.5098L15.6403 9.18392C15.6462 9.15429 15.6621 9.1276 15.6854 9.10841C15.7087 9.08922 15.738 9.07873 15.7682 9.07874H18.4181C19.251 9.07874 19.8709 9.30486 20.2605 9.75092C20.6522 10.199 20.7731 10.826 20.62 11.6137C20.5614 11.924 20.4539 12.223 20.3014 12.4995C20.1462 12.7741 19.9482 13.0222 19.7149 13.2345C19.428 13.503 19.1027 13.698 18.7498 13.8125C18.4026 13.9258 17.9563 13.9832 17.424 13.9832H16.351L16.0448 15.5597C16.039 15.5894 16.023 15.6161 15.9997 15.6354C15.9763 15.6546 15.947 15.6651 15.9167 15.665H14.5388Z" fill="black"/>
<path d="M17.1665 10.4674H17.8961C18.4787 10.4674 18.681 10.5953 18.7496 10.6716C18.864 10.798 18.8853 11.0648 18.812 11.4426C18.7295 11.8658 18.5769 12.166 18.3581 12.3344C18.134 12.5069 17.7695 12.5942 17.2757 12.5942H16.7533L17.1665 10.4674ZM18.4179 8.94867H15.768C15.7076 8.94872 15.6491 8.96975 15.6025 9.00815C15.5558 9.04656 15.524 9.09996 15.5124 9.15924L14.2828 15.4853C14.2755 15.523 14.2767 15.5618 14.2862 15.599C14.2957 15.6362 14.3132 15.6709 14.3377 15.7005C14.3621 15.7301 14.3928 15.7539 14.4275 15.7703C14.4622 15.7867 14.5001 15.7952 14.5385 15.7952H15.9167C15.9771 15.7952 16.0356 15.7741 16.0822 15.7357C16.1288 15.6972 16.1607 15.6438 16.1722 15.5845L16.4582 14.1134H17.4238C17.9696 14.1134 18.4295 14.0537 18.7899 13.9364C19.1608 13.816 19.5018 13.6118 19.8039 13.3292C20.0469 13.1079 20.2531 12.8493 20.4148 12.5631C20.5708 12.2843 20.6825 11.973 20.7476 11.6385C20.9088 10.8092 20.778 10.1453 20.3583 9.6653C19.9428 9.18961 19.2902 8.94849 18.4177 8.94849L18.4179 8.94867ZM16.4373 12.8545H17.2755C17.8312 12.8545 18.2448 12.75 18.5171 12.5404C18.789 12.3312 18.9723 11.9817 19.0676 11.4921C19.1589 11.0219 19.1175 10.6902 18.9429 10.4969C18.7685 10.3037 18.4196 10.207 17.8961 10.207H16.952L16.4373 12.8545ZM18.4179 9.20855C19.215 9.20855 19.7968 9.41799 20.1622 9.8363C20.5278 10.2548 20.6379 10.8389 20.492 11.5887C20.432 11.8977 20.3304 12.18 20.1875 12.4358C20.0445 12.6919 19.8575 12.9259 19.6265 13.1384C19.3515 13.3958 19.0458 13.5794 18.7093 13.6887C18.3731 13.7982 17.9447 13.8527 17.4238 13.8527H16.2435L15.9163 15.5346H14.5382L15.7678 9.20855H18.4179Z" fill="white"/>
<defs>
<radialGradient id="paint0_radial_2_1389" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.20487 7.90663) scale(15.7578)">
<stop stop-color="#AEB2D5"/>
<stop offset="0.3" stop-color="#AEB2D5"/>
<stop offset="0.75" stop-color="#484C89"/>
<stop offset="1" stop-color="#484C89"/>
</radialGradient>
</defs>`, yY = /* @__PURE__ */ ir({
  __name: "LanguagePhpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? I9 : i(I9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-php-icon",
      "data-testid": "kui-icon-wrapper-language-php-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-php-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, vY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), bY = ["aria-hidden"], j9 = `<path d="M11.8858 2.29654C11.0942 2.30029 10.3386 2.3676 9.67335 2.48535C7.71398 2.83147 7.35848 3.55597 7.35848 4.89229V6.65685H11.9884V7.24504H5.62073C4.27523 7.24504 3.09698 8.05372 2.72835 9.59272C2.3031 11.3562 2.28435 12.4568 2.72835 14.2982C3.05741 15.669 3.84341 16.6455 5.1891 16.6455H6.78116V14.5302C6.78116 13.0018 8.10323 11.6539 9.67354 11.6539H14.2982C15.5856 11.6539 16.6131 10.5938 16.6131 9.30116V4.89247C16.6131 3.63754 15.5545 2.69497 14.2982 2.48554C13.5025 2.35316 12.6773 2.29297 11.8858 2.29654ZM9.38198 3.71572C9.8601 3.71572 10.2509 4.11266 10.2509 4.60091C10.2509 5.0871 9.86029 5.48029 9.38198 5.48029C8.90198 5.48029 8.51329 5.0871 8.51329 4.60091C8.5131 4.11266 8.90198 3.71572 9.38198 3.71572Z" fill="url(#paint0_linear_2_1403)"/>
<path d="M17.1903 7.24506V9.30119C17.1903 10.8949 15.8388 12.2365 14.298 12.2365H9.67327C8.40652 12.2365 7.3584 13.3208 7.3584 14.5894V18.9985C7.3584 20.2531 8.44927 20.9912 9.67327 21.3511C11.1388 21.7817 12.5443 21.8597 14.298 21.3511C15.4635 21.0134 16.6128 20.3342 16.6128 18.9985V17.2337H11.9883V16.6454H18.9281C20.2736 16.6454 20.7753 15.7069 21.2433 14.2981C21.7267 12.8477 21.7059 11.4529 21.2433 9.59256C20.9107 8.25287 20.2756 7.24487 18.9281 7.24487L17.1903 7.24506ZM14.5891 18.4101C15.0693 18.4101 15.458 18.8033 15.458 19.2899C15.458 19.7777 15.0691 20.1747 14.5891 20.1747C14.111 20.1747 13.7205 19.7777 13.7205 19.2899C13.7205 18.8033 14.111 18.4101 14.5891 18.4101Z" fill="url(#paint1_linear_2_1403)"/>
<path opacity="0.444" d="M18.2455 22.4244C18.2455 23.0887 15.4675 23.6274 12.0409 23.6274C8.61418 23.6274 5.83618 23.0887 5.83618 22.4244C5.83618 21.7599 8.61399 21.2212 12.0409 21.2212C15.4675 21.2212 18.2455 21.7597 18.2455 22.4244Z" fill="url(#paint2_radial_2_1403)"/>
<defs>
<linearGradient id="paint0_linear_2_1403" x1="1.9382" y1="2.84828" x2="12.617" y2="11.9551" gradientUnits="userSpaceOnUse">
<stop stop-color="#5A9FD4"/>
<stop offset="1" stop-color="#306998"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1403" x1="16.6347" y1="17.6161" x2="12.8051" y2="12.2457" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFD43B"/>
<stop offset="1" stop-color="#FFE873"/>
</linearGradient>
<radialGradient id="paint2_radial_2_1403" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.0159 22.3899) rotate(-90) scale(1.20343 5.2901)">
<stop stop-color="#B8B8B8" stop-opacity="0.498"/>
<stop offset="1" stop-color="#7F7F7F" stop-opacity="0"/>
</radialGradient>
</defs>`, xY = /* @__PURE__ */ ir({
  __name: "LanguagePythonIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? j9 : i(j9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-python-icon",
      "data-testid": "kui-icon-wrapper-language-python-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-python-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, bY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), _Y = ["aria-hidden"], q9 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M12 18.8213C5.37262 18.8213 0 15.2232 0 10.7845C0 6.34599 5.37262 2.74768 12 2.74768C18.6274 2.74768 24 6.34581 24 10.7845C24 15.223 18.6274 18.8213 12 18.8213ZM13.8368 5.88999C8.79937 5.88999 4.71562 8.34981 4.71562 11.3843C4.71562 14.4186 8.79937 16.8786 13.8368 16.8786C18.8741 16.8786 22.5917 15.1967 22.5917 11.3843C22.5917 7.57299 18.8741 5.88999 13.8368 5.88999Z" fill="url(#paint0_linear_2_1407)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.2754 15.1936C18.2754 15.1936 19.0018 15.4128 19.4237 15.6264C19.5699 15.7005 19.8234 15.8482 20.0061 16.0425C20.1133 16.156 20.203 16.2849 20.2723 16.425L23.1347 21.2512L18.5083 21.2531L16.3451 17.1907C16.3451 17.1907 15.9021 16.4295 15.6294 16.2088C15.402 16.0246 15.3051 15.9592 15.0802 15.9592H13.9811L13.9819 21.2503L9.88818 21.252V7.73621H18.1089C18.1089 7.73621 21.8533 7.80371 21.8533 11.366C21.8533 14.9283 18.2754 15.1936 18.2754 15.1936ZM16.4947 10.668L14.0164 10.6663L14.0152 12.9646L16.4947 12.9637C16.4947 12.9637 17.643 12.9601 17.643 11.7946C17.643 10.6059 16.4947 10.668 16.4947 10.668Z" fill="url(#paint1_linear_2_1407)"/>
<defs>
<linearGradient id="paint0_linear_2_1407" x1="0.000135372" y1="2.74591" x2="14.8636" y2="24.9385" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCED0"/>
<stop offset="1" stop-color="#84838B"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1407" x1="9.88818" y1="7.73612" x2="23.4023" y2="20.9796" gradientUnits="userSpaceOnUse">
<stop stop-color="#276DC3"/>
<stop offset="1" stop-color="#165CAA"/>
</linearGradient>
</defs>`, wY = /* @__PURE__ */ ir({
  __name: "LanguageRIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? q9 : i(q9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-r-icon",
      "data-testid": "kui-icon-wrapper-language-r-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-r-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, _Y))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), SY = ["aria-hidden"], D9 = `<g clip-path="url(#clip0_2_1410)">
<path d="M18.2021 15.6026L5.31372 23.2558L22.0018 22.1233L23.2871 5.29614L18.2021 15.6026Z" fill="url(#paint0_linear_2_1410)"/>
<path d="M22.029 22.1118L20.5948 12.212L16.6879 17.3709L22.029 22.1118Z" fill="url(#paint1_linear_2_1410)"/>
<path d="M22.0485 22.1119L11.5403 21.2871L5.36963 23.2343L22.0485 22.1119Z" fill="url(#paint2_linear_2_1410)"/>
<path d="M5.38448 23.2365L8.00966 14.6365L2.23279 15.8717L5.38448 23.2365Z" fill="url(#paint3_linear_2_1410)"/>
<path d="M16.6868 17.3995L14.2714 7.93823L7.35901 14.4179L16.6868 17.3995Z" fill="url(#paint4_linear_2_1410)"/>
<path d="M22.7391 8.07137L16.2049 2.73474L14.3854 8.61718L22.7391 8.07137Z" fill="url(#paint5_linear_2_1410)"/>
<path d="M19.6833 0.831967L15.8401 2.95578L13.4158 0.803467L19.6833 0.831967Z" fill="url(#paint6_linear_2_1410)"/>
<path d="M0.712891 18.7564L2.32277 15.8203L1.02039 12.3225L0.712891 18.7564Z" fill="url(#paint7_linear_2_1410)"/>
<path d="M0.93396 12.212L2.24402 15.9285L7.93746 14.6512L14.4375 8.61033L16.2718 2.78377L13.3838 0.744141L8.47315 2.58202C6.9259 4.02108 3.92384 6.86827 3.81565 6.92189C3.70821 6.97645 1.83283 10.521 0.93396 12.212Z" fill="white"/>
<path d="M5.53484 5.53519C8.88771 2.21081 13.2105 0.246377 14.8695 1.92019C16.5276 3.59381 14.7694 7.66144 11.4161 10.9849C8.0629 14.3083 3.79371 16.3809 2.13621 14.7071C0.477024 13.0346 2.18159 8.85881 5.53484 5.53519Z" fill="url(#paint8_linear_2_1410)"/>
<path d="M5.3844 23.233L7.98877 14.6057L16.6391 17.3845C13.5116 20.3173 10.0329 22.7966 5.3844 23.233Z" fill="url(#paint9_linear_2_1410)"/>
<path d="M14.4491 8.59326L16.6698 17.3891C19.2825 14.6422 21.6272 11.6889 22.7754 8.03601L14.4491 8.59326Z" fill="url(#paint10_linear_2_1410)"/>
<path d="M22.7528 8.08073C23.6415 5.39855 23.8465 1.55104 19.6558 0.83667L16.2173 2.73604L22.7528 8.08073Z" fill="url(#paint11_linear_2_1410)"/>
<path d="M0.712891 18.7177C0.835891 23.1442 4.02958 23.21 5.39008 23.249L2.24777 15.9103L0.712891 18.7177Z" fill="#9E1209"/>
<path d="M14.4615 8.60695C16.4693 9.84089 20.5152 12.3191 20.5971 12.3646C20.7246 12.4365 22.3416 9.63802 22.7085 8.05664L14.4615 8.60695Z" fill="url(#paint12_radial_2_1410)"/>
<path d="M7.98547 14.6057L11.4673 21.3235C13.5261 20.2069 15.1384 18.8464 16.615 17.3891L7.98547 14.6057Z" fill="url(#paint13_radial_2_1410)"/>
<path d="M2.23391 15.9196L1.7406 21.7941C2.67135 23.0656 3.95198 23.1762 5.2956 23.077C4.3236 20.6582 2.38223 15.8215 2.23391 15.9196Z" fill="url(#paint14_linear_2_1410)"/>
<path d="M16.197 2.7506L23.1141 3.72128C22.7449 2.15697 21.6113 1.14747 19.6791 0.831909L16.197 2.7506Z" fill="url(#paint15_linear_2_1410)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2_1410" x1="20.5462" y1="25.3031" x2="15.7841" y2="16.8953" gradientUnits="userSpaceOnUse">
<stop stop-color="#FB7655"/>
<stop offset="0.41" stop-color="#E42B1E"/>
<stop offset="0.99" stop-color="#990000"/>
<stop offset="1" stop-color="#990000"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1410" x1="22.9183" y1="18.24" x2="16.7809" y2="14.1215" gradientUnits="userSpaceOnUse">
<stop stop-color="#871101"/>
<stop offset="0.99" stop-color="#911209"/>
<stop offset="1" stop-color="#911209"/>
</linearGradient>
<linearGradient id="paint2_linear_2_1410" x1="18.0079" y1="25.5582" x2="11.8706" y2="21.4397" gradientUnits="userSpaceOnUse">
<stop stop-color="#871101"/>
<stop offset="0.99" stop-color="#911209"/>
<stop offset="1" stop-color="#911209"/>
</linearGradient>
<linearGradient id="paint3_linear_2_1410" x1="5.12198" y1="15.2584" x2="6.07335" y2="21.4418" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.23" stop-color="#E57252"/>
<stop offset="0.46" stop-color="#DE3B20"/>
<stop offset="0.99" stop-color="#A60003"/>
<stop offset="1" stop-color="#A60003"/>
</linearGradient>
<linearGradient id="paint4_linear_2_1410" x1="11.6661" y1="9.48511" x2="12.0167" y2="15.7956" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.23" stop-color="#E4714E"/>
<stop offset="0.56" stop-color="#BE1A0D"/>
<stop offset="0.99" stop-color="#A80D00"/>
<stop offset="1" stop-color="#A80D00"/>
</linearGradient>
<linearGradient id="paint5_linear_2_1410" x1="17.4733" y1="3.65199" x2="18.5229" y2="8.17487" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.18" stop-color="#E46342"/>
<stop offset="0.4" stop-color="#C82410"/>
<stop offset="0.99" stop-color="#A80D00"/>
<stop offset="1" stop-color="#A80D00"/>
</linearGradient>
<linearGradient id="paint6_linear_2_1410" x1="14.2687" y1="2.05915" x2="18.791" y2="-0.201908" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.54" stop-color="#C81F11"/>
<stop offset="0.99" stop-color="#BF0905"/>
<stop offset="1" stop-color="#BF0905"/>
</linearGradient>
<linearGradient id="paint7_linear_2_1410" x1="1.15764" y1="13.6823" x2="1.53002" y2="17.4088" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.31" stop-color="#DE4024"/>
<stop offset="0.99" stop-color="#BF190B"/>
<stop offset="1" stop-color="#BF190B"/>
</linearGradient>
<linearGradient id="paint8_linear_2_1410" x1="-1.40135" y1="18.4161" x2="16.096" y2="0.42394" gradientUnits="userSpaceOnUse">
<stop stop-color="#BD0012"/>
<stop offset="0.07" stop-color="white"/>
<stop offset="0.17" stop-color="white"/>
<stop offset="0.27" stop-color="#C82F1C"/>
<stop offset="0.33" stop-color="#820C01"/>
<stop offset="0.46" stop-color="#A31601"/>
<stop offset="0.72" stop-color="#B31301"/>
<stop offset="0.99" stop-color="#E82609"/>
<stop offset="1" stop-color="#E82609"/>
</linearGradient>
<linearGradient id="paint9_linear_2_1410" x1="12.0013" y1="20.2309" x2="6.73084" y2="18.9302" gradientUnits="userSpaceOnUse">
<stop stop-color="#8C0C01"/>
<stop offset="0.54" stop-color="#990C00"/>
<stop offset="0.99" stop-color="#A80D0E"/>
<stop offset="1" stop-color="#A80D0E"/>
</linearGradient>
<linearGradient id="paint10_linear_2_1410" x1="21.0534" y1="13.9055" x2="16.3713" y2="9.70926" gradientUnits="userSpaceOnUse">
<stop stop-color="#7E110B"/>
<stop offset="0.99" stop-color="#9E0C00"/>
<stop offset="1" stop-color="#9E0C00"/>
</linearGradient>
<linearGradient id="paint11_linear_2_1410" x1="22.7736" y1="6.20611" x2="20.4415" y2="3.71273" gradientUnits="userSpaceOnUse">
<stop stop-color="#79130D"/>
<stop offset="0.99" stop-color="#9E120B"/>
<stop offset="1" stop-color="#9E120B"/>
</linearGradient>
<radialGradient id="paint12_radial_2_1410" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.1006 9.78952) scale(5.73769)">
<stop stop-color="#A80D00"/>
<stop offset="0.99" stop-color="#7E0E08"/>
<stop offset="1" stop-color="#7E0E08"/>
</radialGradient>
<radialGradient id="paint13_radial_2_1410" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.15472 17.3503) scale(7.62731)">
<stop stop-color="#A30C00"/>
<stop offset="0.99" stop-color="#800E08"/>
<stop offset="1" stop-color="#800E08"/>
</radialGradient>
<linearGradient id="paint14_linear_2_1410" x1="3.75173" y1="23.2285" x2="1.85122" y2="16.7802" gradientUnits="userSpaceOnUse">
<stop stop-color="#8B2114"/>
<stop offset="0.43" stop-color="#9E100A"/>
<stop offset="0.99" stop-color="#B3100C"/>
<stop offset="1" stop-color="#B3100C"/>
</linearGradient>
<linearGradient id="paint15_linear_2_1410" x1="18.3323" y1="1.86072" x2="22.593" y2="3.74153" gradientUnits="userSpaceOnUse">
<stop stop-color="#B31000"/>
<stop offset="0.44" stop-color="#910F08"/>
<stop offset="0.99" stop-color="#791C12"/>
<stop offset="1" stop-color="#791C12"/>
</linearGradient>
<clipPath id="clip0_2_1410">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, CY = /* @__PURE__ */ ir({
  __name: "LanguageRubyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? D9 : i(D9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-ruby-icon",
      "data-testid": "kui-icon-wrapper-language-ruby-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-ruby-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, SY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), kY = ["aria-hidden"], $9 = `<path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M1.35001 20.7188C1.03126 20.7188 0.768764 20.5875 0.581264 20.3625C0.393764 20.1375 0.337514 19.8188 0.412514 19.5L3.90001 4.40625C4.05001 3.76875 4.65001 3.28125 5.28751 3.28125H22.65C22.9688 3.28125 23.2313 3.4125 23.4188 3.6375C23.6063 3.8625 23.6625 4.18125 23.5875 4.5L20.1 19.5938C19.95 20.2313 19.35 20.7188 18.7125 20.7188H1.35001Z" fill="url(#paint0_linear_2_1398)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5562 3.46875H5.34373C4.79998 3.46875 4.27498 3.9 4.14373 4.44375L0.693734 19.5563C0.562484 20.1 0.899984 20.5312 1.44373 20.5312H18.6562C19.2 20.5312 19.725 20.1 19.8562 19.5563L23.3062 4.4625C23.4375 3.91875 23.1 3.46875 22.5562 3.46875Z" fill="url(#paint1_linear_2_1398)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0374 16.5563H16.2187C16.7062 16.5563 17.0999 16.9688 17.0999 17.475C17.0999 17.9813 16.7062 18.3938 16.2187 18.3938H12.0374C11.5499 18.3938 11.1562 17.9813 11.1562 17.475C11.1562 16.9688 11.5499 16.5563 12.0374 16.5563ZM14.7562 12.4688C14.6812 12.6188 14.5312 12.7688 14.2687 12.9563L6.48744 18.5438C6.05619 18.8438 5.45619 18.7313 5.11869 18.2813C4.79994 17.8313 4.87494 17.2125 5.28744 16.9125L12.2999 11.8313V11.7188L7.89369 7.0313C7.53744 6.6563 7.57494 6.03755 7.96869 5.6438C8.38119 5.2688 8.99994 5.2688 9.35619 5.6438L14.6437 11.2688C14.9624 11.625 14.9812 12.1125 14.7562 12.4688Z" fill="#2C5591"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5499 12.2813C14.4749 12.4313 14.3249 12.5813 14.0624 12.7688L6.29994 18.3563C5.86869 18.6563 5.26869 18.5438 4.93119 18.0938C4.61244 17.6438 4.68744 17.025 5.09994 16.725L12.1124 11.6438V11.5313L7.70619 6.8438C7.34994 6.4688 7.38744 5.85005 7.78119 5.4563C8.19369 5.0813 8.81244 5.0813 9.16869 5.4563L14.4562 11.0813C14.7749 11.4188 14.7937 11.9063 14.5499 12.2813ZM11.9062 16.4625H16.0874C16.5749 16.4625 16.9687 16.8563 16.9687 17.325C16.9687 17.8125 16.5749 18.1875 16.0874 18.1875H11.9062C11.4187 18.1875 11.0249 17.7938 11.0249 17.325C11.0249 16.8375 11.4187 16.4625 11.9062 16.4625Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear_2_1398" x1="18.0574" y1="17.4105" x2="4.77264" y2="5.54419" gradientUnits="userSpaceOnUse">
<stop stop-color="#A9C8FF"/>
<stop offset="1" stop-color="#C7E6FF"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1398" x1="4.75048" y1="5.56312" x2="17.7317" y2="17.0912" gradientUnits="userSpaceOnUse">
<stop stop-color="#2D4664"/>
<stop offset="0.169" stop-color="#29405B"/>
<stop offset="0.445" stop-color="#1E2F43"/>
<stop offset="0.79" stop-color="#0C131B"/>
<stop offset="1"/>
</linearGradient>
</defs>`, AY = /* @__PURE__ */ ir({
  __name: "LanguageShellIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? $9 : i($9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-shell-icon",
      "data-testid": "kui-icon-wrapper-language-shell-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-shell-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, kY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), EY = ["aria-hidden"], L9 = `<g clip-path="url(#clip0_2_1429)">
<path d="M23.6868 6.38629C23.6867 5.8932 23.6371 5.40136 23.5387 4.91817C23.4403 4.42353 23.2731 3.94512 23.0418 3.49692C22.8002 3.06279 22.4999 2.66404 22.1493 2.31192C21.7878 1.95818 21.3679 1.66956 20.9081 1.45879C20.4543 1.22999 19.969 1.07011 19.4681 0.984419C18.9712 0.888794 18.4256 0.888794 17.9287 0.841919H5.67185C5.28951 0.848145 4.90802 0.880092 4.52997 0.937544C4.15481 0.98171 3.78757 1.07762 3.43873 1.22254C3.33935 1.26942 3.19123 1.31817 3.09185 1.36504C2.7618 1.54196 2.44808 1.74776 2.15435 1.98004C2.05498 2.07567 1.9556 2.12254 1.85623 2.21629C1.4908 2.55523 1.18859 2.95649 0.963726 3.40129C0.718162 3.8432 0.550107 4.3239 0.466851 4.82254C0.392961 5.30913 0.343524 5.79912 0.318726 6.29067V17.6138C0.31888 18.1069 0.368503 18.5987 0.466851 19.0819C0.565247 19.5766 0.732499 20.055 0.963726 20.5032C1.20537 20.9373 1.5057 21.336 1.85623 21.6882C2.21775 22.0419 2.63768 22.3305 3.09748 22.5413C3.55123 22.7701 4.03657 22.93 4.53748 23.0157C5.03435 23.1113 5.57998 23.1113 6.07685 23.1582H17.9306C18.447 23.1578 18.9623 23.1101 19.47 23.0157C19.9709 22.93 20.4562 22.7701 20.91 22.5413C21.3599 22.3136 21.7774 22.0267 22.1512 21.6882C22.5167 21.3492 22.8189 20.948 23.0437 20.5032C23.2893 20.0613 23.4573 19.5806 23.5406 19.0819C23.6145 18.5953 23.6639 18.1053 23.6887 17.6138V6.38629H23.6868Z" fill="#F05138"/>
<path d="M15.9375 18.0938C13.8543 19.2431 10.9912 19.3613 8.10935 18.1819C5.86238 17.2702 3.9412 15.7044 2.59497 13.6875C3.22061 14.1664 3.90412 14.5646 4.62935 14.8725C7.60497 16.2038 10.5787 16.1119 12.6731 14.8725C9.69184 12.6863 7.1606 9.84377 5.27435 7.52252C4.90212 7.13023 4.56986 6.70187 4.28247 6.24377C6.56247 8.23314 10.1887 10.7438 11.4787 11.4544C9.63686 9.56718 7.94428 7.53984 6.41622 5.39064C8.9563 7.85905 11.7514 10.0507 14.7543 11.9288C14.8875 12 14.9906 12.06 15.0731 12.1163C15.1611 11.9014 15.2369 11.6816 15.3 11.4581C15.9956 9.04127 15.2006 6.29439 13.4643 4.02002C17.4843 6.33939 19.875 10.6969 18.8737 14.3456C18.8475 14.445 18.8193 14.5331 18.7893 14.6363L18.825 14.6775C20.8106 17.0456 20.265 19.5525 20.0156 19.0838C18.9375 17.0625 16.9443 17.6869 15.9375 18.0938Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_2_1429">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, OY = /* @__PURE__ */ ir({
  __name: "LanguageSwiftIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? L9 : i(L9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-swift-icon",
      "data-testid": "kui-icon-wrapper-language-swift-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-swift-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, EY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), TY = ["aria-hidden"], N9 = `<g clip-path="url(#clip0_55_22054)">
<path d="M12 23.3899C18.2905 23.3899 23.3899 18.2905 23.3899 12.0001C23.3899 5.70963 18.2905 0.610229 12 0.610229C5.70963 0.610229 0.610229 5.70963 0.610229 12.0001C0.610229 18.2905 5.70963 23.3899 12 23.3899Z" fill="white"/>
<path d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6275 5.37258 24 12 24C18.6275 24 24 18.6275 24 12C24 5.37258 18.6275 0 12 0ZM12 1.22034C17.9534 1.22034 22.7797 6.04656 22.7797 12C22.7797 17.9534 17.9534 22.7797 12 22.7797C6.04656 22.7797 1.22034 17.9534 1.22034 12C1.22034 6.04656 6.04656 1.22034 12 1.22034Z" fill="#4000BF"/>
<path d="M12.1355 3.45764C16.8534 3.45764 20.6779 7.28219 20.6779 12C20.6779 16.7178 16.8534 20.5424 12.1355 20.5424C7.41769 20.5424 3.59314 16.7178 3.59314 12C3.59314 10.847 3.82157 9.74739 4.23566 8.74381C4.84027 9.56716 5.8153 10.1017 6.91517 10.1017C8.74992 10.1017 10.2372 8.61436 10.2372 6.77968C10.2372 5.6798 9.70272 4.70477 8.8793 4.10017C9.88287 3.68608 10.9825 3.45764 12.1355 3.45764Z" fill="url(#paint0_linear_55_22054)"/>
</g>
<defs>
<linearGradient id="paint0_linear_55_22054" x1="857.829" y1="1711.93" x2="857.829" y2="3.45764" gradientUnits="userSpaceOnUse">
<stop stop-color="#7400E1"/>
<stop offset="1" stop-color="#4000BF"/>
</linearGradient>
<clipPath id="clip0_55_22054">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, F9 = /* @__PURE__ */ ir({
  __name: "InsomniaIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? N9 : i(N9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon insomnia-icon",
      "data-testid": "kui-icon-wrapper-insomnia-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-insomnia-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, TY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), PY = ["aria-hidden"], M9 = '<path d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z" fill="currentColor"/>', bO = /* @__PURE__ */ ir({
  __name: "AddIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? M9 : i(M9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon add-icon",
      "data-testid": "kui-icon-wrapper-add-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-add-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, PY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), RY = ["aria-hidden"], B9 = '<path d="M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z" fill="currentColor"/>', IY = /* @__PURE__ */ ir({
  __name: "ArrowLeftIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? B9 : i(B9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-left-icon",
      "data-testid": "kui-icon-wrapper-arrow-left-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-left-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, RY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), jY = ["aria-hidden"], U9 = '<path d="M12 20L10.575 18.6L16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20Z" fill="currentColor"/>', qY = /* @__PURE__ */ ir({
  __name: "ArrowRightIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? U9 : i(U9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-right-icon",
      "data-testid": "kui-icon-wrapper-arrow-right-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-right-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, jY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), DY = ["aria-hidden"], H9 = '<path d="M9.7 18.025L4 12.325L5.425 10.9L9.7 15.175L18.875 6L20.3 7.425L9.7 18.025Z" fill="currentColor"/>', $Y = /* @__PURE__ */ ir({
  __name: "CheckIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? H9 : i(H9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-icon",
      "data-testid": "kui-icon-wrapper-check-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, DY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), LY = ["aria-hidden"], z9 = '<path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="currentColor"/>', xO = /* @__PURE__ */ ir({
  __name: "ChevronDownIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? z9 : i(z9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-down-icon",
      "data-testid": "kui-icon-wrapper-chevron-down-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-down-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, LY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), NY = ["aria-hidden"], V9 = '<path d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z" fill="currentColor"/>', u1 = /* @__PURE__ */ ir({
  __name: "ChevronRightIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? V9 : i(V9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-right-icon",
      "data-testid": "kui-icon-wrapper-chevron-right-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-right-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, NY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), FY = ["aria-hidden"], G9 = '<path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="currentColor"/>', MY = /* @__PURE__ */ ir({
  __name: "CloseIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? G9 : i(G9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon close-icon",
      "data-testid": "kui-icon-wrapper-close-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-close-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, FY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), BY = ["aria-hidden"], W9 = '<path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16Z" fill="currentColor"/>', UY = /* @__PURE__ */ ir({
  __name: "CopyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? W9 : i(W9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon copy-icon",
      "data-testid": "kui-icon-wrapper-copy-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-copy-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, BY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), HY = ["aria-hidden"], K9 = '<path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z" fill="currentColor"/>', zY = /* @__PURE__ */ ir({
  __name: "ExternalLinkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? K9 : i(K9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon external-link-icon",
      "data-testid": "kui-icon-wrapper-external-link-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-external-link-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, HY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), VY = ["aria-hidden"], Z9 = '<path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', _O = /* @__PURE__ */ ir({
  __name: "InfoIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Z9 : i(Z9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon info-icon",
      "data-testid": "kui-icon-wrapper-info-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-info-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, VY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), GY = ["aria-hidden"], Y9 = '<path d="M7 17C5.61667 17 4.4375 16.5125 3.4625 15.5375C2.4875 14.5625 2 13.3833 2 12C2 10.6167 2.4875 9.4375 3.4625 8.4625C4.4375 7.4875 5.61667 7 7 7H10C10.2833 7 10.5208 7.09583 10.7125 7.2875C10.9042 7.47917 11 7.71667 11 8C11 8.28333 10.9042 8.52083 10.7125 8.7125C10.5208 8.90417 10.2833 9 10 9H7C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15H10C10.2833 15 10.5208 15.0958 10.7125 15.2875C10.9042 15.4792 11 15.7167 11 16C11 16.2833 10.9042 16.5208 10.7125 16.7125C10.5208 16.9042 10.2833 17 10 17H7ZM9 13C8.71667 13 8.47917 12.9042 8.2875 12.7125C8.09583 12.5208 8 12.2833 8 12C8 11.7167 8.09583 11.4792 8.2875 11.2875C8.47917 11.0958 8.71667 11 9 11H15C15.2833 11 15.5208 11.0958 15.7125 11.2875C15.9042 11.4792 16 11.7167 16 12C16 12.2833 15.9042 12.5208 15.7125 12.7125C15.5208 12.9042 15.2833 13 15 13H9ZM14 17C13.7167 17 13.4792 16.9042 13.2875 16.7125C13.0958 16.5208 13 16.2833 13 16C13 15.7167 13.0958 15.4792 13.2875 15.2875C13.4792 15.0958 13.7167 15 14 15H17C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8C13 7.71667 13.0958 7.47917 13.2875 7.2875C13.4792 7.09583 13.7167 7 14 7H17C18.3833 7 19.5625 7.4875 20.5375 8.4625C21.5125 9.4375 22 10.6167 22 12C22 13.3833 21.5125 14.5625 20.5375 15.5375C19.5625 16.5125 18.3833 17 17 17H14Z" fill="currentColor"/>', WY = /* @__PURE__ */ ir({
  __name: "LinkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Y9 : i(Y9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon link-icon",
      "data-testid": "kui-icon-wrapper-link-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-link-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, GY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), KY = ["aria-hidden"], J9 = '<path d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z" fill="currentColor"/>', wO = /* @__PURE__ */ ir({
  __name: "LockIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? J9 : i(J9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon lock-icon",
      "data-testid": "kui-icon-wrapper-lock-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-lock-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, KY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ZY = ["aria-hidden"], Q9 = '<path d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z" fill="currentColor"/>', YY = /* @__PURE__ */ ir({
  __name: "MenuIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Q9 : i(Q9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon menu-icon",
      "data-testid": "kui-icon-wrapper-menu-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-menu-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, ZY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), JY = ["aria-hidden"], X9 = '<path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z" fill="currentColor"/>', i2 = /* @__PURE__ */ ir({
  __name: "NetworkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? X9 : i(X9)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon network-icon",
      "data-testid": "kui-icon-wrapper-network-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-network-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, JY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), QY = ["aria-hidden"], e_ = `<style>@keyframes kong-icon-spin { from {transform: rotate(0deg);} to {transform: rotate(360deg);} }</style>
<path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.7167 20.0958 11.4792 20.2875 11.2875C20.4792 11.0958 20.7167 11 21 11C21.2833 11 21.5208 11.0958 21.7125 11.2875C21.9042 11.4792 22 11.7167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22Z" fill="currentColor" style="transform-origin: 50% 50%; animation: kong-icon-spin 1.5s linear infinite;"/>`, XY = /* @__PURE__ */ ir({
  __name: "ProgressIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: hn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return hn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, l = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, f) => {
        const p = `${l}-${f}`;
        return s[f] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => s[f] ? `#${s[f]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? e_ : i(e_)}`;
    return (u, s) => (ke(), Mt(Sn(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon progress-icon",
      "data-testid": "kui-icon-wrapper-progress-icon",
      style: Ln(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: Xt(() => [
        (ke(), Qe("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-progress-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, QY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), {
  parseSpecDocument: moe,
  parsedDocument: goe,
  tableOfContents: voe,
  parseOpenApiSpecDocument: yoe,
  parseAsyncApiSpecDocument: boe,
  downloadSpecFile: xoe
} = qi.useSchemaParser();
function t_(e) {
  return e ? e.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-") : "";
}
const ea = (e) => [!0, !1, "true", "false"].includes(e), xi = (e) => [!0, "true"].includes(e), r_ = (e, t) => {
  const n = e.children.find((i) => i.uri === t);
  if (n)
    return n;
  const r = e.children.filter((i) => i.tags.length > 1);
  for (const i of r)
    for (const a of i.tags)
      if (i.uri.split("/").toSpliced(2, 0, Xd(a).toLowerCase()).join("/") === t)
        return i;
  return null;
}, SO = (e) => typeof e == "number" ? e : Number.parseInt(e), CO = (e) => {
  if (typeof e == "number")
    return Number.isFinite(e);
  if (typeof e == "string") {
    const t = Number.parseInt(e);
    return !Number.isNaN(t) && Number.isFinite(t);
  }
  return !1;
}, eJ = ["aria-expanded"], tJ = /* @__PURE__ */ ir({
  __name: "GroupItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    /**
     * Whether this is the root group item (otherwise it's a child of another group item)
     */
    root: {
      type: Boolean,
      default: !0
    },
    activePath: {
      type: String,
      default: "/"
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = `spec-renderer-toc-group-${t_(n.item.title)}-${t_(n.item.items[0].title)}`, a = (s) => {
      r("item-selected", s);
    }, o = Br(n.item.hideTitle || n.item.initiallyExpanded), c = ja("collapseTrigger"), u = (s) => {
      c.value === s.target && (o.value = !o.value);
    };
    return On(() => n.item.initiallyExpanded, (s) => {
      o.value = s;
    }), (s, l) => (ke(), Qe("li", {
      class: Un(["group-item", { root: e.root }]),
      "data-testid": "group-item"
    }, [
      e.item.hideTitle ? Bt("", !0) : (ke(), Qe("button", {
        key: 0,
        ref: "collapseTrigger",
        "aria-controls": i,
        "aria-expanded": o.value,
        "data-testid": "group-item-button",
        type: "button",
        onClick: u
      }, [
        bn(cn(e.item.title) + " ", 1),
        Sr(jt(u1), {
          class: Un(["chevron-icon", { expanded: o.value }])
        }, null, 8, ["class"])
      ], 8, eJ)),
      Sr(zd, { name: "spec-renderer-fade" }, {
        default: Xt(() => [
          zi(Ft("ul", {
            id: i,
            "data-testid": "group-item-list"
          }, [
            (ke(!0), Qe(Mn, null, ii(e.item.items, (d, f) => (ke(), Mt(Sn(jt(kO)(d)), {
              key: f + " " + d.title + d,
              "active-path": e.activePath,
              item: d,
              root: jt(vg)(d) ? !1 : void 0,
              onItemSelected: a
            }, null, 40, ["active-path", "item", "root"]))), 128))
          ], 512), [
            [yf, o.value]
          ])
        ]),
        _: 1
      })
    ], 2));
  }
}), rJ = /* @__PURE__ */ pn(tJ, [["__scopeId", "data-v-bd241921"]]), nJ = /* @__PURE__ */ ir({
  __name: "NodeGroupItem",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("li", null, " node-group-item "));
  }
}), iJ = /* @__PURE__ */ ir({
  __name: "ExternalLinkItem",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("li", null, " node-group-item "));
  }
});
function vg(e) {
  return Object.keys(e).length >= 2 && "title" in e && "items" in e;
}
function aJ(e) {
  return "title" in e && "items" in e && "slug" in e && "id" in e && "meta" in e && "type" in e;
}
function oJ(e) {
  return "title" in e && "slug" in e && "id" in e && "meta" in e && "type" in e;
}
function sJ(e) {
  return Object.keys(e).length === 2 && "title" in e && "url" in e;
}
const kO = (e) => aJ(e) ? nJ : vg(e) ? rJ : oJ(e) ? eY : sJ(e) ? iJ : ZZ;
function rp(e) {
  return dC() ? (hC(e), !0) : !1;
}
// @__NO_SIDE_EFFECTS__
function n_() {
  const e = /* @__PURE__ */ new Set(), t = (a) => {
    e.delete(a);
  };
  return {
    on: (a) => {
      e.add(a);
      const o = () => t(a);
      return rp(o), {
        off: o
      };
    },
    off: t,
    trigger: (...a) => Promise.all(Array.from(e).map((o) => o(...a))),
    clear: () => {
      e.clear();
    }
  };
}
const e3 = /* @__PURE__ */ new WeakMap(), uJ = /* @__NO_SIDE_EFFECTS__ */ (...e) => {
  var t;
  const n = e[0], r = (t = l2()) == null ? void 0 : t.proxy;
  if (r == null && !mC())
    throw new Error("injectLocal must be called in setup");
  return r && e3.has(r) && n in e3.get(r) ? e3.get(r)[n] : Xa(...e);
}, c1 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const cJ = (e) => e != null, lJ = Object.prototype.toString, fJ = (e) => lJ.call(e) === "[object Object]", wu = () => {
}, pJ = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
function AO(e, t) {
  function n(...r) {
    return new Promise((i, a) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(i).catch(a);
    });
  }
  return n;
}
function dJ(e, t = {}) {
  let n, r, i = wu;
  const a = (u) => {
    clearTimeout(u), i(), i = wu;
  };
  let o;
  return (u) => {
    const s = Dn(e), l = Dn(t.maxWait);
    return n && a(n), s <= 0 || l !== void 0 && l <= 0 ? (r && (a(r), r = void 0), Promise.resolve(u())) : new Promise((d, f) => {
      i = t.rejectOnCancel ? f : d, o = u, l && !r && (r = setTimeout(() => {
        n && a(n), r = void 0, d(o());
      }, l)), n = setTimeout(() => {
        r && a(r), r = void 0, d(u());
      }, s);
    });
  };
}
function hJ(...e) {
  let t = 0, n, r = !0, i = wu, a, o, c, u, s;
  !Vd(e[0]) && typeof e[0] == "object" ? { delay: o, trailing: c = !0, leading: u = !0, rejectOnCancel: s = !1 } = e[0] : [o, c = !0, u = !0, s = !1] = e;
  const l = () => {
    n && (clearTimeout(n), n = void 0, i(), i = wu);
  };
  return (f) => {
    const p = Dn(o), g = Date.now() - t, b = () => a = f();
    return l(), p <= 0 ? (t = Date.now(), b()) : (g > p && (u || !r) ? (t = Date.now(), b()) : c && (a = new Promise((w, y) => {
      i = s ? y : w, n = setTimeout(() => {
        t = Date.now(), r = !0, w(b()), l();
      }, Math.max(0, p - g));
    })), !u && !n && (n = setTimeout(() => r = !0, p)), r = !1, a);
  };
}
function i_(e, t = !1, n = "Timeout") {
  return new Promise((r, i) => {
    setTimeout(t ? () => i(n) : r, e);
  });
}
function mJ(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const r = t;
    t = void 0, r && await r;
  }, n;
}
function a_(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function vf(e) {
  return Array.isArray(e) ? e : [e];
}
function gJ(e) {
  return l2();
}
// @__NO_SIDE_EFFECTS__
function yg(e, t = 200, n = {}) {
  return AO(
    dJ(t, n),
    e
  );
}
// @__NO_SIDE_EFFECTS__
function vJ(e, t = 200, n = !1, r = !0, i = !1) {
  return AO(
    hJ(t, n, r, i),
    e
  );
}
function bg(e, t = !0, n) {
  gJ() ? P0(e, n) : t ? e() : sc(e);
}
function a2(e, t = !1) {
  function n(d, { flush: f = "sync", deep: p = !1, timeout: g, throwOnTimeout: b } = {}) {
    let w = null;
    const v = [new Promise((_) => {
      w = On(
        e,
        (E) => {
          d(E) !== t && (w ? w() : sc(() => w?.()), _(E));
        },
        {
          flush: f,
          deep: p,
          immediate: !0
        }
      );
    })];
    return g != null && v.push(
      i_(g, b).then(() => Dn(e)).finally(() => w?.())
    ), Promise.race(v);
  }
  function r(d, f) {
    if (!Vd(d))
      return n((E) => E === d, f);
    const { flush: p = "sync", deep: g = !1, timeout: b, throwOnTimeout: w } = f ?? {};
    let y = null;
    const _ = [new Promise((E) => {
      y = On(
        [e, d],
        ([O, M]) => {
          t !== (O === M) && (y ? y() : sc(() => y?.()), E(O));
        },
        {
          flush: p,
          deep: g,
          immediate: !0
        }
      );
    })];
    return b != null && _.push(
      i_(b, w).then(() => Dn(e)).finally(() => (y?.(), Dn(e)))
    ), Promise.race(_);
  }
  function i(d) {
    return n((f) => !!f, d);
  }
  function a(d) {
    return r(null, d);
  }
  function o(d) {
    return r(void 0, d);
  }
  function c(d) {
    return n(Number.isNaN, d);
  }
  function u(d, f) {
    return n((p) => {
      const g = Array.from(p);
      return g.includes(d) || g.includes(Dn(d));
    }, f);
  }
  function s(d) {
    return l(1, d);
  }
  function l(d = 1, f) {
    let p = -1;
    return n(() => (p += 1, p >= d), f);
  }
  return Array.isArray(Dn(e)) ? {
    toMatch: n,
    toContains: u,
    changed: s,
    changedTimes: l,
    get not() {
      return a2(e, !t);
    }
  } : {
    toMatch: n,
    toBe: r,
    toBeTruthy: i,
    toBeNull: a,
    toBeNaN: c,
    toBeUndefined: o,
    changed: s,
    changedTimes: l,
    get not() {
      return a2(e, !t);
    }
  };
}
function yJ(e) {
  return a2(e);
}
function EO(e, t, n = {}) {
  const {
    immediate: r = !0,
    immediateCallback: i = !1
  } = n, a = pi(!1);
  let o;
  function c() {
    o && (clearTimeout(o), o = void 0);
  }
  function u() {
    a.value = !1, c();
  }
  function s(...l) {
    i && e(), c(), a.value = !0, o = setTimeout(() => {
      a.value = !1, o = void 0, e(...l);
    }, Dn(t));
  }
  return r && (a.value = !0, c1 && s()), rp(u), {
    isPending: lu(a),
    start: s,
    stop: u
  };
}
function bJ(e, t, n) {
  return On(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function xJ(e, t, n) {
  const r = On(
    e,
    (i, a, o) => {
      i && (n?.once && sc(() => r()), t(i, a, o));
    },
    {
      ...n,
      once: !1
    }
  );
  return r;
}
const os = c1 ? window : void 0, _J = c1 ? window.document : void 0, OO = c1 ? window.navigator : void 0;
function _o(e) {
  var t;
  const n = Dn(e);
  return (t = n?.$el) != null ? t : n;
}
function Di(...e) {
  const t = [], n = () => {
    t.forEach((c) => c()), t.length = 0;
  }, r = (c, u, s, l) => (c.addEventListener(u, s, l), () => c.removeEventListener(u, s, l)), i = Ye(() => {
    const c = vf(Dn(e[0])).filter((u) => u != null);
    return c.every((u) => typeof u != "string") ? c : void 0;
  }), a = bJ(
    () => {
      var c, u;
      return [
        (u = (c = i.value) == null ? void 0 : c.map((s) => _o(s))) != null ? u : [os].filter((s) => s != null),
        vf(Dn(i.value ? e[1] : e[0])),
        vf(jt(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Dn(i.value ? e[3] : e[2])
      ];
    },
    ([c, u, s, l]) => {
      if (n(), !c?.length || !u?.length || !s?.length)
        return;
      const d = fJ(l) ? { ...l } : l;
      t.push(
        ...c.flatMap(
          (f) => u.flatMap(
            (p) => s.map((g) => r(f, p, g, d))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    a(), n();
  };
  return rp(n), o;
}
// @__NO_SIDE_EFFECTS__
function wJ() {
  const e = pi(!1), t = l2();
  return t && P0(() => {
    e.value = !0;
  }, t), e;
}
// @__NO_SIDE_EFFECTS__
function np(e) {
  const t = /* @__PURE__ */ wJ();
  return Ye(() => (t.value, !!e()));
}
function SJ(e, t, n = {}) {
  const { window: r = os, ...i } = n;
  let a;
  const o = /* @__PURE__ */ np(() => r && "MutationObserver" in r), c = () => {
    a && (a.disconnect(), a = void 0);
  }, u = Ye(() => {
    const f = Dn(e), p = vf(f).map(_o).filter(cJ);
    return new Set(p);
  }), s = On(
    u,
    (f) => {
      c(), o.value && f.size && (a = new MutationObserver(t), f.forEach((p) => a.observe(p, i)));
    },
    { immediate: !0, flush: "post" }
  ), l = () => a?.takeRecords(), d = () => {
    s(), c();
  };
  return rp(d), {
    isSupported: o,
    stop: d,
    takeRecords: l
  };
}
const CJ = Symbol("vueuse-ssr-width");
// @__NO_SIDE_EFFECTS__
function kJ() {
  const e = mC() ? /* @__PURE__ */ uJ(CJ, null) : null;
  return typeof e == "number" ? e : void 0;
}
function AJ(e, t = {}) {
  const { window: n = os, ssrWidth: r = /* @__PURE__ */ kJ() } = t, i = /* @__PURE__ */ np(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = pi(typeof r == "number"), o = pi(), c = pi(!1), u = (s) => {
    c.value = s.matches;
  };
  return gC(() => {
    if (a.value) {
      a.value = !i.value;
      const s = Dn(e).split(",");
      c.value = s.some((l) => {
        const d = l.includes("not all"), f = l.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), p = l.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let g = !!(f || p);
        return f && g && (g = r >= a_(f[1])), p && g && (g = r <= a_(p[1])), d ? !g : g;
      });
      return;
    }
    i.value && (o.value = n.matchMedia(Dn(e)), c.value = o.value.matches);
  }), Di(o, "change", u, { passive: !0 }), Ye(() => c.value);
}
// @__NO_SIDE_EFFECTS__
function o_(e, t = {}) {
  const {
    controls: n = !1,
    navigator: r = OO
  } = t, i = /* @__PURE__ */ np(() => r && "permissions" in r), a = pi(), o = typeof e == "string" ? { name: e } : e, c = pi(), u = () => {
    var l, d;
    c.value = (d = (l = a.value) == null ? void 0 : l.state) != null ? d : "prompt";
  };
  Di(a, "change", u, { passive: !0 });
  const s = mJ(async () => {
    if (i.value) {
      if (!a.value)
        try {
          a.value = await r.permissions.query(o);
        } catch {
          a.value = void 0;
        } finally {
          u();
        }
      if (n)
        return LD(a.value);
    }
  });
  return s(), n ? {
    state: c,
    isSupported: i,
    query: s
  } : c;
}
function EJ(e = {}) {
  const {
    navigator: t = OO,
    read: n = !1,
    source: r,
    copiedDuring: i = 1500,
    legacy: a = !1
  } = e, o = /* @__PURE__ */ np(() => t && "clipboard" in t), c = /* @__PURE__ */ o_("clipboard-read"), u = /* @__PURE__ */ o_("clipboard-write"), s = Ye(() => o.value || a), l = pi(""), d = pi(!1), f = EO(() => d.value = !1, i, { immediate: !1 });
  async function p() {
    let v = !(o.value && y(c.value));
    if (!v)
      try {
        l.value = await t.clipboard.readText();
      } catch {
        v = !0;
      }
    v && (l.value = w());
  }
  s.value && n && Di(["copy", "cut"], p, { passive: !0 });
  async function g(v = Dn(r)) {
    if (s.value && v != null) {
      let _ = !(o.value && y(u.value));
      if (!_)
        try {
          await t.clipboard.writeText(v);
        } catch {
          _ = !0;
        }
      _ && b(v), l.value = v, d.value = !0, f.start();
    }
  }
  function b(v) {
    const _ = document.createElement("textarea");
    _.value = v ?? "", _.style.position = "absolute", _.style.opacity = "0", document.body.appendChild(_), _.select(), document.execCommand("copy"), _.remove();
  }
  function w() {
    var v, _, E;
    return (E = (_ = (v = document?.getSelection) == null ? void 0 : v.call(document)) == null ? void 0 : _.toString()) != null ? E : "";
  }
  function y(v) {
    return v === "granted" || v === "prompt";
  }
  return {
    isSupported: s,
    text: l,
    copied: d,
    copy: g
  };
}
function OJ(e, t, n = {}) {
  const { window: r = os, ...i } = n;
  let a;
  const o = /* @__PURE__ */ np(() => r && "ResizeObserver" in r), c = () => {
    a && (a.disconnect(), a = void 0);
  }, u = Ye(() => {
    const d = Dn(e);
    return Array.isArray(d) ? d.map((f) => _o(f)) : [_o(d)];
  }), s = On(
    u,
    (d) => {
      if (c(), o.value && r) {
        a = new ResizeObserver(t);
        for (const f of d)
          f && a.observe(f, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    c(), s();
  };
  return rp(l), {
    isSupported: o,
    stop: l
  };
}
function TJ(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = os, box: i = "content-box" } = n, a = Ye(() => {
    var d, f;
    return (f = (d = _o(e)) == null ? void 0 : d.namespaceURI) == null ? void 0 : f.includes("svg");
  }), o = pi(t.width), c = pi(t.height), { stop: u } = OJ(
    e,
    ([d]) => {
      const f = i === "border-box" ? d.borderBoxSize : i === "content-box" ? d.contentBoxSize : d.devicePixelContentBoxSize;
      if (r && a.value) {
        const p = _o(e);
        if (p) {
          const g = p.getBoundingClientRect();
          o.value = g.width, c.value = g.height;
        }
      } else if (f) {
        const p = vf(f);
        o.value = p.reduce((g, { inlineSize: b }) => g + b, 0), c.value = p.reduce((g, { blockSize: b }) => g + b, 0);
      } else
        o.value = d.contentRect.width, c.value = d.contentRect.height;
    },
    n
  );
  bg(() => {
    const d = _o(e);
    d && (o.value = "offsetWidth" in d ? d.offsetWidth : t.width, c.value = "offsetHeight" in d ? d.offsetHeight : t.height);
  });
  const s = On(
    () => _o(e),
    (d) => {
      o.value = d ? t.width : 0, c.value = d ? t.height : 0;
    }
  );
  function l() {
    u(), s();
  }
  return {
    width: o,
    height: c,
    stop: l
  };
}
const PJ = {
  multiple: !0,
  accept: "*",
  reset: !1,
  directory: !1
};
function RJ(e) {
  if (!e)
    return null;
  if (e instanceof FileList)
    return e;
  const t = new DataTransfer();
  for (const n of e)
    t.items.add(n);
  return t.files;
}
function IJ(e = {}) {
  const {
    document: t = _J
  } = e, n = Br(RJ(e.initialFiles)), { on: r, trigger: i } = /* @__PURE__ */ n_(), { on: a, trigger: o } = /* @__PURE__ */ n_(), c = Ye(() => {
    var d;
    const f = (d = _o(e.input)) != null ? d : t ? t.createElement("input") : void 0;
    return f && (f.type = "file", f.onchange = (p) => {
      const g = p.target;
      n.value = g.files, i(n.value);
    }, f.oncancel = () => {
      o();
    }), f;
  }), u = () => {
    n.value = null, c.value && c.value.value && (c.value.value = "", i(null));
  }, s = (d) => {
    const f = c.value;
    f && (f.multiple = Dn(d.multiple), f.accept = Dn(d.accept), f.webkitdirectory = Dn(d.directory), pJ(d, "capture") && (f.capture = Dn(d.capture)));
  }, l = (d) => {
    const f = c.value;
    if (!f)
      return;
    const p = {
      ...PJ,
      ...e,
      ...d
    };
    s(p), Dn(p.reset) && u(), f.click();
  };
  return gC(() => {
    s(e);
  }), {
    files: pC(n),
    open: l,
    reset: u,
    onCancel: a,
    onChange: r
  };
}
const s_ = 1;
function xg(e, t = {}) {
  const {
    throttle: n = 0,
    idle: r = 200,
    onStop: i = wu,
    onScroll: a = wu,
    offset: o = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    observe: c = {
      mutation: !1
    },
    eventListenerOptions: u = {
      capture: !1,
      passive: !0
    },
    behavior: s = "auto",
    window: l = os,
    onError: d = (Q) => {
      console.error(Q);
    }
  } = t, f = typeof c == "boolean" ? {
    mutation: c
  } : c, p = pi(0), g = pi(0), b = Ye({
    get() {
      return p.value;
    },
    set(Q) {
      y(Q, void 0);
    }
  }), w = Ye({
    get() {
      return g.value;
    },
    set(Q) {
      y(void 0, Q);
    }
  });
  function y(Q, ae) {
    var re, X, de, Ce;
    if (!l)
      return;
    const J = Dn(e);
    if (!J)
      return;
    (de = J instanceof Document ? l.document.body : J) == null || de.scrollTo({
      top: (re = Dn(ae)) != null ? re : w.value,
      left: (X = Dn(Q)) != null ? X : b.value,
      behavior: Dn(s)
    });
    const ne = ((Ce = J?.document) == null ? void 0 : Ce.documentElement) || J?.documentElement || J;
    b != null && (p.value = ne.scrollLeft), w != null && (g.value = ne.scrollTop);
  }
  const v = pi(!1), _ = Gd({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), E = Gd({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), O = (Q) => {
    v.value && (v.value = !1, E.left = !1, E.right = !1, E.top = !1, E.bottom = !1, i(Q));
  }, M = /* @__PURE__ */ yg(O, n + r), L = (Q) => {
    var ae;
    if (!l)
      return;
    const re = ((ae = Q?.document) == null ? void 0 : ae.documentElement) || Q?.documentElement || _o(Q), { display: X, flexDirection: de, direction: Ce } = getComputedStyle(re), J = Ce === "rtl" ? -1 : 1, ne = re.scrollLeft;
    E.left = ne < p.value, E.right = ne > p.value;
    const De = Math.abs(ne * J) <= (o.left || 0), je = Math.abs(ne * J) + re.clientWidth >= re.scrollWidth - (o.right || 0) - s_;
    X === "flex" && de === "row-reverse" ? (_.left = je, _.right = De) : (_.left = De, _.right = je), p.value = ne;
    let Me = re.scrollTop;
    Q === l.document && !Me && (Me = l.document.body.scrollTop), E.top = Me < g.value, E.bottom = Me > g.value;
    const qe = Math.abs(Me) <= (o.top || 0), Ve = Math.abs(Me) + re.clientHeight >= re.scrollHeight - (o.bottom || 0) - s_;
    X === "flex" && de === "column-reverse" ? (_.top = Ve, _.bottom = qe) : (_.top = qe, _.bottom = Ve), g.value = Me;
  }, Z = (Q) => {
    var ae;
    if (!l)
      return;
    const re = (ae = Q.target.documentElement) != null ? ae : Q.target;
    L(re), v.value = !0, M(Q), a(Q);
  };
  return Di(
    e,
    "scroll",
    n ? /* @__PURE__ */ vJ(Z, n, !0, !1) : Z,
    u
  ), bg(() => {
    try {
      const Q = Dn(e);
      if (!Q)
        return;
      L(Q);
    } catch (Q) {
      d(Q);
    }
  }), f?.mutation && e != null && e !== l && e !== document && SJ(
    e,
    () => {
      const Q = Dn(e);
      Q && L(Q);
    },
    {
      attributes: !0,
      childList: !0,
      subtree: !0
    }
  ), Di(
    e,
    "scrollend",
    O,
    u
  ), {
    x: b,
    y: w,
    isScrolling: v,
    arrivedState: _,
    directions: E,
    measure() {
      const Q = Dn(e);
      l && Q && L(Q);
    }
  };
}
const jJ = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function qJ(e = {}) {
  const {
    reactive: t = !1,
    target: n = os,
    aliasMap: r = jJ,
    passive: i = !0,
    onEventFired: a = wu
  } = e, o = Gd(/* @__PURE__ */ new Set()), c = {
    toJSON() {
      return {};
    },
    current: o
  }, u = t ? Gd(c) : c, s = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
  function f(w, y) {
    w in u && (t ? u[w] = y : u[w].value = y);
  }
  function p() {
    o.clear();
    for (const w of d)
      f(w, !1);
  }
  function g(w, y) {
    var v, _;
    const E = (v = w.key) == null ? void 0 : v.toLowerCase(), M = [(_ = w.code) == null ? void 0 : _.toLowerCase(), E].filter(Boolean);
    E && (y ? o.add(E) : o.delete(E));
    for (const L of M)
      d.add(L), f(L, y);
    if (E === "shift" && !y) {
      const L = Array.from(l), Z = L.indexOf("shift");
      L.forEach((Q, ae) => {
        ae >= Z && (o.delete(Q), f(Q, !1));
      }), l.clear();
    } else typeof w.getModifierState == "function" && w.getModifierState("Shift") && y && [...o, ...M].forEach((L) => l.add(L));
    E === "meta" && !y ? (s.forEach((L) => {
      o.delete(L), f(L, !1);
    }), s.clear()) : typeof w.getModifierState == "function" && w.getModifierState("Meta") && y && [...o, ...M].forEach((L) => s.add(L));
  }
  Di(n, "keydown", (w) => (g(w, !0), a(w)), { passive: i }), Di(n, "keyup", (w) => (g(w, !1), a(w)), { passive: i }), Di("blur", p, { passive: i }), Di("focus", p, { passive: i });
  const b = new Proxy(
    u,
    {
      get(w, y, v) {
        if (typeof y != "string")
          return Reflect.get(w, y, v);
        if (y = y.toLowerCase(), y in r && (y = r[y]), !(y in u))
          if (/[+_-]/.test(y)) {
            const E = y.split(/[+_-]/g).map((O) => O.trim());
            u[y] = Ye(() => E.map((O) => Dn(b[O])).every(Boolean));
          } else
            u[y] = pi(!1);
        const _ = Reflect.get(w, y, v);
        return t ? Dn(_) : _;
      }
    }
  );
  return b;
}
function DJ(e = {}) {
  const { window: t = os, ...n } = e;
  return xg(t, n);
}
// @__NO_SIDE_EFFECTS__
function $J(e = {}) {
  const {
    window: t = os,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: a = !0,
    type: o = "inner"
  } = e, c = pi(n), u = pi(r), s = () => {
    if (t)
      if (o === "outer")
        c.value = t.outerWidth, u.value = t.outerHeight;
      else if (o === "visual" && t.visualViewport) {
        const { width: d, height: f, scale: p } = t.visualViewport;
        c.value = Math.round(d * p), u.value = Math.round(f * p);
      } else a ? (c.value = t.innerWidth, u.value = t.innerHeight) : (c.value = t.document.documentElement.clientWidth, u.value = t.document.documentElement.clientHeight);
  };
  s(), bg(s);
  const l = { passive: !0 };
  if (Di("resize", s, l), t && o === "visual" && t.visualViewport && Di(t.visualViewport, "resize", s, l), i) {
    const d = AJ("(orientation: portrait)");
    On(d, () => s());
  }
  return { width: c, height: u };
}
const LJ = "#232633", NJ = "#f9fafb", TO = "#6c7489", u_ = "#0044f4", PO = "16px", c_ = "20px", FJ = {
  ref: "tocNav",
  class: "table-of-contents",
  "data-testid": "table-of-contents"
}, MJ = {
  key: 0,
  class: "powered-by"
}, BJ = {
  class: "powered-by-button secondary",
  href: "https://api-documentation.dev/",
  target: "_blank"
}, UJ = /* @__PURE__ */ ir({
  __name: "SpecRendererToc",
  props: {
    tableOfContents: {
      type: [Object, String],
      required: !0
    },
    /**
     * Path of the page where spec-renderer is loaded on.
     * his is needed to compute path to individual specification details
     */
    basePath: {
      type: String,
      default: ""
    },
    /**
     * Selected path of the spec section (ui)
     */
    currentPath: {
      type: String,
      default: "/"
    },
    /**
     * this is designed scrolling container for TOC, by default it's '',meaning tocNavRef scrollable.
     * If toc is part of some external list and that list is scrollable - we need a selector for that scollable container
     */
    tocScrollingContainer: {
      type: String,
      default: ""
    },
    /**
     * Allow component itself to control URL in browser URL.
     * When false it becomes the responsibility of consuming app
     */
    controlAddressBar: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    },
    /**
        Defines how links are specified in toc
          path - id becomes part of the URL path.
          hash - uses the hash portion of the URL to keep the UI in sync with the URL.
    */
    navigationType: {
      type: String,
      default: "path"
    },
    /** Show the "Powered by Kong" content in the SpecRendererTOC. Defaults to `false`. */
    showPoweredBy: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = e;
    Pa("base-path", Ye(() => n.basePath)), Pa("current-path", Ye(() => n.currentPath)), Pa("navigation-type", Ye(() => n.navigationType));
    const r = t, i = ja("tocNav"), a = Br(null), { y: o } = xg(a), c = Ye(() => {
      if (!n.tableOfContents)
        return;
      let s = n.tableOfContents;
      if (typeof n.tableOfContents == "string")
        try {
          s = o0(s);
        } catch {
          console.error("@kong/spec-renderer: error parsing provided toc");
          return;
        }
      const l = (d, f) => {
        if (Array.isArray(d.items))
          for (let p = 0; p < d.items.length; p++)
            d.items[p].id === f && (d.initiallyExpanded = !0), l(d.items[p], f);
      };
      return l({ initiallyExpanded: !1, items: s }, n.currentPath), s;
    });
    On(() => ({ path: n.currentPath, navRef: i.value }), async (s) => {
      if (await sc(), !s.navRef || !document || (a.value || (a.value = n.tocScrollingContainer === "" ? s.navRef : document.querySelector(n.tocScrollingContainer)), !a.value))
        return;
      const l = a.value.querySelector('li[data-spec-renderer-toc-active="true"]') || null;
      if (l) {
        if (l.offsetTop < o.value) {
          l.scrollIntoView({ behavior: "instant", block: "start" });
          return;
        }
        if (o.value + a.value.offsetHeight < l.offsetTop + 2 * l.offsetHeight) {
          l.scrollIntoView({ behavior: "instant", block: "end" });
          return;
        }
      }
    }, { immediate: !0 });
    const u = (s) => {
      if (xi(n.controlAddressBar)) {
        const l = n.navigationType === "path" ? n.basePath + s : n.basePath + "#" + s;
        window.history.pushState({}, "", l);
      }
      r("item-selected", s);
    };
    return (s, l) => (ke(), Qe("nav", FJ, [
      Ft("ul", null, [
        (ke(!0), Qe(Mn, null, ii(c.value, (d, f) => (ke(), Mt(Sn(jt(kO)(d)), {
          key: f + "_" + d.title,
          "active-path": e.currentPath,
          item: d,
          onItemSelected: u
        }, null, 40, ["active-path", "item"]))), 128))
      ]),
      e.showPoweredBy ? (ke(), Qe("div", MJ, [
        Ft("a", BJ, [
          l[0] || (l[0] = bn(" API documentation editor ", -1)),
          Sr(jt(zY), {
            decorative: "",
            size: jt(PO)
          }, null, 8, ["size"])
        ]),
        l[1] || (l[1] = Ft("a", {
          href: "https://konghq.com",
          target: "_blank"
        }, "Powered by Kong", -1))
      ])) : Bt("", !0)
    ], 512));
  }
}), k0 = /* @__PURE__ */ pn(UJ, [["__scopeId", "data-v-3ec2cee5"]]), HJ = { class: "overview-panel" }, zJ = { class: "overview-panel-header" }, VJ = {
  key: 0,
  class: "default-header"
}, GJ = { class: "default-header-title" }, WJ = { class: "overview-panel-content" }, KJ = /* @__PURE__ */ ir({
  __name: "OverviewPanel",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", HJ, [
      Ft("div", zJ, [
        Bn(t.$slots, "header", {}, () => [
          e.title ? (ke(), Qe("div", VJ, [
            Bn(t.$slots, "header-icon", {}, void 0, !0),
            Ft("span", GJ, cn(e.title), 1)
          ])) : Bt("", !0)
        ], !0)
      ]),
      Ft("div", WJ, [
        Bn(t.$slots, "content", {}, void 0, !0)
      ])
    ]));
  }
}), _g = /* @__PURE__ */ pn(KJ, [["__scopeId", "data-v-2f0878ae"]]), ZJ = /* @__PURE__ */ ir({
  __name: "MarkdownRenderer",
  props: {
    markdown: {
      type: String,
      required: !0
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e) {
    const { mdRender: t } = yO(), n = e, r = Ye(() => t(n.markdown)), i = () => vC(n.tag, {
      innerHTML: r.value
    }), a = Xa("markdown-styles", Br(!0));
    return (o, c) => (ke(), Qe("div", {
      class: Un({ "default-markdown": jt(a) })
    }, [
      (ke(), Mt(Sn(i())))
    ], 2));
  }
}), ss = /* @__PURE__ */ pn(ZJ, [["__scopeId", "data-v-c7c683c6"]]), o2 = Math.min, ac = Math.max, A0 = Math.round, jd = Math.floor, So = (e) => ({
  x: e,
  y: e
}), YJ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, JJ = {
  start: "end",
  end: "start"
};
function wg(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vc(e) {
  return e.split("-")[0];
}
function l1(e) {
  return e.split("-")[1];
}
function QJ(e) {
  return e === "x" ? "y" : "x";
}
function RO(e) {
  return e === "y" ? "height" : "width";
}
const XJ = /* @__PURE__ */ new Set(["top", "bottom"]);
function yu(e) {
  return XJ.has(vc(e)) ? "y" : "x";
}
function IO(e) {
  return QJ(yu(e));
}
function eQ(e, t, n) {
  n === void 0 && (n = !1);
  const r = l1(e), i = IO(e), a = RO(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = E0(o)), [o, E0(o)];
}
function tQ(e) {
  const t = E0(e);
  return [s2(e), t, s2(t)];
}
function s2(e) {
  return e.replace(/start|end/g, (t) => JJ[t]);
}
const l_ = ["left", "right"], f_ = ["right", "left"], rQ = ["top", "bottom"], nQ = ["bottom", "top"];
function iQ(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? f_ : l_ : t ? l_ : f_;
    case "left":
    case "right":
      return t ? rQ : nQ;
    default:
      return [];
  }
}
function aQ(e, t, n, r) {
  const i = l1(e);
  let a = iQ(vc(e), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(s2)))), a;
}
function E0(e) {
  return e.replace(/left|right|bottom|top/g, (t) => YJ[t]);
}
function oQ(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function sQ(e) {
  return typeof e != "number" ? oQ(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function O0(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function p_(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = yu(t), o = IO(t), c = RO(o), u = vc(t), s = a === "y", l = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[c] / 2 - i[c] / 2;
  let p;
  switch (u) {
    case "top":
      p = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (l1(t)) {
    case "start":
      p[o] -= f * (n && s ? -1 : 1);
      break;
    case "end":
      p[o] += f * (n && s ? -1 : 1);
      break;
  }
  return p;
}
const uQ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, c = a.filter(Boolean), u = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let s = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: d
  } = p_(s, r, u), f = r, p = {}, g = 0;
  for (let b = 0; b < c.length; b++) {
    const {
      name: w,
      fn: y
    } = c[b], {
      x: v,
      y: _,
      data: E,
      reset: O
    } = await y({
      x: l,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: p,
      rects: s,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = v ?? l, d = _ ?? d, p = {
      ...p,
      [w]: {
        ...p[w],
        ...E
      }
    }, O && g <= 50 && (g++, typeof O == "object" && (O.placement && (f = O.placement), O.rects && (s = O.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : O.rects), {
      x: l,
      y: d
    } = p_(s, f, u)), b = -1);
  }
  return {
    x: l,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: p
  };
};
async function cQ(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: c,
    strategy: u
  } = e, {
    boundary: s = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = wg(t, e), g = sQ(p), w = c[f ? d === "floating" ? "reference" : "floating" : d], y = O0(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(w))) == null || n ? w : w.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(c.floating)),
    boundary: s,
    rootBoundary: l,
    strategy: u
  })), v = d === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, _ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c.floating)), E = await (a.isElement == null ? void 0 : a.isElement(_)) ? await (a.getScale == null ? void 0 : a.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = O0(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: v,
    offsetParent: _,
    strategy: u
  }) : v);
  return {
    top: (y.top - O.top + g.top) / E.y,
    bottom: (O.bottom - y.bottom + g.bottom) / E.y,
    left: (y.left - O.left + g.left) / E.x,
    right: (O.right - y.right + g.right) / E.x
  };
}
const lQ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: c,
        platform: u,
        elements: s
      } = t, {
        mainAxis: l = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: b = !0,
        ...w
      } = wg(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = vc(i), v = yu(c), _ = vc(c) === c, E = await (u.isRTL == null ? void 0 : u.isRTL(s.floating)), O = f || (_ || !b ? [E0(c)] : tQ(c)), M = g !== "none";
      !f && M && O.push(...aQ(c, b, g, E));
      const L = [c, ...O], Z = await cQ(t, w), Q = [];
      let ae = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (l && Q.push(Z[y]), d) {
        const Ce = eQ(i, o, E);
        Q.push(Z[Ce[0]], Z[Ce[1]]);
      }
      if (ae = [...ae, {
        placement: i,
        overflows: Q
      }], !Q.every((Ce) => Ce <= 0)) {
        var re, X;
        const Ce = (((re = a.flip) == null ? void 0 : re.index) || 0) + 1, J = L[Ce];
        if (J && (!(d === "alignment" ? v !== yu(J) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        ae.every((je) => yu(je.placement) === v ? je.overflows[0] > 0 : !0)))
          return {
            data: {
              index: Ce,
              overflows: ae
            },
            reset: {
              placement: J
            }
          };
        let ne = (X = ae.filter((De) => De.overflows[0] <= 0).sort((De, je) => De.overflows[1] - je.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!ne)
          switch (p) {
            case "bestFit": {
              var de;
              const De = (de = ae.filter((je) => {
                if (M) {
                  const Me = yu(je.placement);
                  return Me === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Me === "y";
                }
                return !0;
              }).map((je) => [je.placement, je.overflows.filter((Me) => Me > 0).reduce((Me, qe) => Me + qe, 0)]).sort((je, Me) => je[1] - Me[1])[0]) == null ? void 0 : de[0];
              De && (ne = De);
              break;
            }
            case "initialPlacement":
              ne = c;
              break;
          }
        if (i !== ne)
          return {
            reset: {
              placement: ne
            }
          };
      }
      return {};
    }
  };
}, fQ = /* @__PURE__ */ new Set(["left", "top"]);
async function pQ(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = vc(n), c = l1(n), u = yu(n) === "y", s = fQ.has(o) ? -1 : 1, l = a && u ? -1 : 1, d = wg(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return c && typeof g == "number" && (p = c === "end" ? g * -1 : g), u ? {
    x: p * l,
    y: f * s
  } : {
    x: f * s,
    y: p * l
  };
}
const dQ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: c
      } = t, u = await pQ(t, e);
      return o === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: i + u.x,
        y: a + u.y,
        data: {
          ...u,
          placement: o
        }
      };
    }
  };
};
function f1() {
  return typeof window < "u";
}
function Ru(e) {
  return Sg(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function da(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Eo(e) {
  var t;
  return (t = (Sg(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Sg(e) {
  return f1() ? e instanceof Node || e instanceof da(e).Node : !1;
}
function to(e) {
  return f1() ? e instanceof Element || e instanceof da(e).Element : !1;
}
function Co(e) {
  return f1() ? e instanceof HTMLElement || e instanceof da(e).HTMLElement : !1;
}
function d_(e) {
  return !f1() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof da(e).ShadowRoot;
}
const hQ = /* @__PURE__ */ new Set(["inline", "contents"]);
function ip(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ro(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !hQ.has(i);
}
const mQ = /* @__PURE__ */ new Set(["table", "td", "th"]);
function gQ(e) {
  return mQ.has(Ru(e));
}
const vQ = [":popover-open", ":modal"];
function p1(e) {
  return vQ.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const yQ = ["transform", "translate", "scale", "rotate", "perspective"], bQ = ["transform", "translate", "scale", "rotate", "perspective", "filter"], xQ = ["paint", "layout", "strict", "content"];
function Cg(e) {
  const t = kg(), n = to(e) ? ro(e) : e;
  return yQ.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || bQ.some((r) => (n.willChange || "").includes(r)) || xQ.some((r) => (n.contain || "").includes(r));
}
function _Q(e) {
  let t = Ts(e);
  for (; Co(t) && !yc(t); ) {
    if (Cg(t))
      return t;
    if (p1(t))
      return null;
    t = Ts(t);
  }
  return null;
}
function kg() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const wQ = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function yc(e) {
  return wQ.has(Ru(e));
}
function ro(e) {
  return da(e).getComputedStyle(e);
}
function d1(e) {
  return to(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ts(e) {
  if (Ru(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    d_(e) && e.host || // Fallback.
    Eo(e)
  );
  return d_(t) ? t.host : t;
}
function jO(e) {
  const t = Ts(e);
  return yc(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Co(t) && ip(t) ? t : jO(t);
}
function jf(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = jO(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = da(i);
  if (a) {
    const c = u2(o);
    return t.concat(o, o.visualViewport || [], ip(i) ? i : [], c && n ? jf(c) : []);
  }
  return t.concat(i, jf(i, [], n));
}
function u2(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function qO(e) {
  const t = ro(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Co(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, c = A0(n) !== a || A0(r) !== o;
  return c && (n = a, r = o), {
    width: n,
    height: r,
    $: c
  };
}
function Ag(e) {
  return to(e) ? e : e.contextElement;
}
function oc(e) {
  const t = Ag(e);
  if (!Co(t))
    return So(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = qO(t);
  let o = (a ? A0(n.width) : n.width) / r, c = (a ? A0(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: o,
    y: c
  };
}
const SQ = /* @__PURE__ */ So(0);
function DO(e) {
  const t = da(e);
  return !kg() || !t.visualViewport ? SQ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function CQ(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== da(e) ? !1 : t;
}
function Su(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Ag(e);
  let o = So(1);
  t && (r ? to(r) && (o = oc(r)) : o = oc(e));
  const c = CQ(a, n, r) ? DO(a) : So(0);
  let u = (i.left + c.x) / o.x, s = (i.top + c.y) / o.y, l = i.width / o.x, d = i.height / o.y;
  if (a) {
    const f = da(a), p = r && to(r) ? da(r) : r;
    let g = f, b = u2(g);
    for (; b && r && p !== g; ) {
      const w = oc(b), y = b.getBoundingClientRect(), v = ro(b), _ = y.left + (b.clientLeft + parseFloat(v.paddingLeft)) * w.x, E = y.top + (b.clientTop + parseFloat(v.paddingTop)) * w.y;
      u *= w.x, s *= w.y, l *= w.x, d *= w.y, u += _, s += E, g = da(b), b = u2(g);
    }
  }
  return O0({
    width: l,
    height: d,
    x: u,
    y: s
  });
}
function h1(e, t) {
  const n = d1(e).scrollLeft;
  return t ? t.left + n : Su(Eo(e)).left + n;
}
function $O(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - h1(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function kQ(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", o = Eo(r), c = t ? p1(t.floating) : !1;
  if (r === o || c && a)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = So(1);
  const l = So(0), d = Co(r);
  if ((d || !d && !a) && ((Ru(r) !== "body" || ip(o)) && (u = d1(r)), Co(r))) {
    const p = Su(r);
    s = oc(r), l.x = p.x + r.clientLeft, l.y = p.y + r.clientTop;
  }
  const f = o && !d && !a ? $O(o, u) : So(0);
  return {
    width: n.width * s.x,
    height: n.height * s.y,
    x: n.x * s.x - u.scrollLeft * s.x + l.x + f.x,
    y: n.y * s.y - u.scrollTop * s.y + l.y + f.y
  };
}
function AQ(e) {
  return Array.from(e.getClientRects());
}
function EQ(e) {
  const t = Eo(e), n = d1(e), r = e.ownerDocument.body, i = ac(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = ac(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + h1(e);
  const c = -n.scrollTop;
  return ro(r).direction === "rtl" && (o += ac(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: c
  };
}
const h_ = 25;
function OQ(e, t) {
  const n = da(e), r = Eo(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, c = 0, u = 0;
  if (i) {
    a = i.width, o = i.height;
    const l = kg();
    (!l || l && t === "fixed") && (c = i.offsetLeft, u = i.offsetTop);
  }
  const s = h1(r);
  if (s <= 0) {
    const l = r.ownerDocument, d = l.body, f = getComputedStyle(d), p = l.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, g = Math.abs(r.clientWidth - d.clientWidth - p);
    g <= h_ && (a -= g);
  } else s <= h_ && (a += s);
  return {
    width: a,
    height: o,
    x: c,
    y: u
  };
}
const TQ = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function PQ(e, t) {
  const n = Su(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Co(e) ? oc(e) : So(1), o = e.clientWidth * a.x, c = e.clientHeight * a.y, u = i * a.x, s = r * a.y;
  return {
    width: o,
    height: c,
    x: u,
    y: s
  };
}
function m_(e, t, n) {
  let r;
  if (t === "viewport")
    r = OQ(e, n);
  else if (t === "document")
    r = EQ(Eo(e));
  else if (to(t))
    r = PQ(t, n);
  else {
    const i = DO(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return O0(r);
}
function LO(e, t) {
  const n = Ts(e);
  return n === t || !to(n) || yc(n) ? !1 : ro(n).position === "fixed" || LO(n, t);
}
function RQ(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = jf(e, [], !1).filter((c) => to(c) && Ru(c) !== "body"), i = null;
  const a = ro(e).position === "fixed";
  let o = a ? Ts(e) : e;
  for (; to(o) && !yc(o); ) {
    const c = ro(o), u = Cg(o);
    !u && c.position === "fixed" && (i = null), (a ? !u && !i : !u && c.position === "static" && !!i && TQ.has(i.position) || ip(o) && !u && LO(e, o)) ? r = r.filter((l) => l !== o) : i = c, o = Ts(o);
  }
  return t.set(e, r), r;
}
function IQ(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? p1(t) ? [] : RQ(t, this._c) : [].concat(n), r], c = o[0], u = o.reduce((s, l) => {
    const d = m_(t, l, i);
    return s.top = ac(d.top, s.top), s.right = o2(d.right, s.right), s.bottom = o2(d.bottom, s.bottom), s.left = ac(d.left, s.left), s;
  }, m_(t, c, i));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function jQ(e) {
  const {
    width: t,
    height: n
  } = qO(e);
  return {
    width: t,
    height: n
  };
}
function qQ(e, t, n) {
  const r = Co(t), i = Eo(t), a = n === "fixed", o = Su(e, !0, a, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = So(0);
  function s() {
    u.x = h1(i);
  }
  if (r || !r && !a)
    if ((Ru(t) !== "body" || ip(i)) && (c = d1(t)), r) {
      const p = Su(t, !0, a, t);
      u.x = p.x + t.clientLeft, u.y = p.y + t.clientTop;
    } else i && s();
  a && !r && i && s();
  const l = i && !r && !a ? $O(i, c) : So(0), d = o.left + c.scrollLeft - u.x - l.x, f = o.top + c.scrollTop - u.y - l.y;
  return {
    x: d,
    y: f,
    width: o.width,
    height: o.height
  };
}
function t3(e) {
  return ro(e).position === "static";
}
function g_(e, t) {
  if (!Co(e) || ro(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Eo(e) === n && (n = n.ownerDocument.body), n;
}
function NO(e, t) {
  const n = da(e);
  if (p1(e))
    return n;
  if (!Co(e)) {
    let i = Ts(e);
    for (; i && !yc(i); ) {
      if (to(i) && !t3(i))
        return i;
      i = Ts(i);
    }
    return n;
  }
  let r = g_(e, t);
  for (; r && gQ(r) && t3(r); )
    r = g_(r, t);
  return r && yc(r) && t3(r) && !Cg(r) ? n : r || _Q(e) || n;
}
const DQ = async function(e) {
  const t = this.getOffsetParent || NO, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: qQ(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function $Q(e) {
  return ro(e).direction === "rtl";
}
const LQ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kQ,
  getDocumentElement: Eo,
  getClippingRect: IQ,
  getOffsetParent: NO,
  getElementRects: DQ,
  getClientRects: AQ,
  getDimensions: jQ,
  getScale: oc,
  isElement: to,
  isRTL: $Q
};
function FO(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function NQ(e, t) {
  let n = null, r;
  const i = Eo(e);
  function a() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function o(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), a();
    const s = e.getBoundingClientRect(), {
      left: l,
      top: d,
      width: f,
      height: p
    } = s;
    if (c || t(), !f || !p)
      return;
    const g = jd(d), b = jd(i.clientWidth - (l + f)), w = jd(i.clientHeight - (d + p)), y = jd(l), _ = {
      rootMargin: -g + "px " + -b + "px " + -w + "px " + -y + "px",
      threshold: ac(0, o2(1, u)) || 1
    };
    let E = !0;
    function O(M) {
      const L = M[0].intersectionRatio;
      if (L !== u) {
        if (!E)
          return o();
        L ? o(!1, L) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !FO(s, e.getBoundingClientRect()) && o(), E = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ..._,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, _);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function FQ(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, s = Ag(e), l = i || a ? [...s ? jf(s) : [], ...jf(t)] : [];
  l.forEach((y) => {
    i && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const d = s && c ? NQ(s, n) : null;
  let f = -1, p = null;
  o && (p = new ResizeObserver((y) => {
    let [v] = y;
    v && v.target === s && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var _;
      (_ = p) == null || _.observe(t);
    })), n();
  }), s && !u && p.observe(s), p.observe(t));
  let g, b = u ? Su(e) : null;
  u && w();
  function w() {
    const y = Su(e);
    b && !FO(b, y) && n(), b = y, g = requestAnimationFrame(w);
  }
  return n(), () => {
    var y;
    l.forEach((v) => {
      i && v.removeEventListener("scroll", n), a && v.removeEventListener("resize", n);
    }), d?.(), (y = p) == null || y.disconnect(), p = null, u && cancelAnimationFrame(g);
  };
}
const MQ = dQ, BQ = lQ, UQ = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: LQ,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return uQ(e, t, {
    ...i,
    platform: a
  });
};
function HQ(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function v_(e) {
  if (HQ(e)) {
    const t = e.$el;
    return Sg(t) && Ru(t) === "#comment" ? null : t;
  }
  return e;
}
function xl(e) {
  return typeof e == "function" ? e() : jt(e);
}
function MO(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function y_(e, t) {
  const n = MO(e);
  return Math.round(t * n) / n;
}
function zQ(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, i = Ye(() => {
    var L;
    return (L = xl(n.open)) != null ? L : !0;
  }), a = Ye(() => xl(n.middleware)), o = Ye(() => {
    var L;
    return (L = xl(n.placement)) != null ? L : "bottom";
  }), c = Ye(() => {
    var L;
    return (L = xl(n.strategy)) != null ? L : "absolute";
  }), u = Ye(() => {
    var L;
    return (L = xl(n.transform)) != null ? L : !0;
  }), s = Ye(() => v_(e.value)), l = Ye(() => v_(t.value)), d = Br(0), f = Br(0), p = Br(c.value), g = Br(o.value), b = pi({}), w = Br(!1), y = Ye(() => {
    const L = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!l.value)
      return L;
    const Z = y_(l.value, d.value), Q = y_(l.value, f.value);
    return u.value ? {
      ...L,
      transform: "translate(" + Z + "px, " + Q + "px)",
      ...MO(l.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: Z + "px",
      top: Q + "px"
    };
  });
  let v;
  function _() {
    if (s.value == null || l.value == null)
      return;
    const L = i.value;
    UQ(s.value, l.value, {
      middleware: a.value,
      placement: o.value,
      strategy: c.value
    }).then((Z) => {
      d.value = Z.x, f.value = Z.y, p.value = Z.strategy, g.value = Z.placement, b.value = Z.middlewareData, w.value = L !== !1;
    });
  }
  function E() {
    typeof v == "function" && (v(), v = void 0);
  }
  function O() {
    if (E(), r === void 0) {
      _();
      return;
    }
    if (s.value != null && l.value != null) {
      v = r(s.value, l.value, _);
      return;
    }
  }
  function M() {
    i.value || (w.value = !1);
  }
  return On([a, o, c, i], _, {
    flush: "sync"
  }), On([s, l], O, {
    flush: "sync"
  }), On(i, M, {
    flush: "sync"
  }), dC() && hC(E), {
    x: lu(d),
    y: lu(f),
    strategy: lu(p),
    placement: lu(g),
    middlewareData: lu(b),
    isPositioned: lu(w),
    floatingStyles: y,
    update: _
  };
}
const VQ = {
  ref: "triggerWrapper",
  class: "popover-trigger-wrapper"
}, GQ = ["aria-activedescendant", "aria-labelledby", "role", "x-placement"], WQ = /* @__PURE__ */ ir({
  inheritAttrs: !1,
  __name: "HeadlessPopover",
  props: {
    placement: {
      type: String,
      validator: (e) => L2.includes(e),
      default: "bottom-start"
    },
    popoverOffset: {
      type: Number,
      default: 6
    },
    role: {
      type: String,
      default: "listbox"
    },
    openOnMouseover: {
      type: Boolean,
      default: !1
    },
    closeOnPopoverClick: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: "auto"
    },
    width: {
      type: String,
      default: "auto"
    },
    maxHeight: {
      type: String,
      default: "auto"
    },
    popoverClasses: {
      type: String,
      default: ""
    }
  },
  emits: ["open", "close"],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = n, a = R0(), o = Ye(() => {
      const _ = { ...a };
      return delete _.id, delete _["aria-activedescendant"], delete _["aria-labelledby"], _;
    }), c = ja("popoverWrapper"), u = ja("triggerWrapper"), s = Br(null), l = Br(!1), d = Ye(() => u.value && u.value?.children[0] ? u.value?.children[0] : null), f = Br(null), p = () => {
      l.value ? b() : g();
    }, g = async () => {
      r.disabled || (f.value && clearTimeout(f.value), l.value = !0);
    }, b = () => {
      window && (f.value = window.setTimeout(() => {
        l.value = !1;
      }, r.openOnMouseover ? 300 : 0));
    }, w = (_) => {
      const E = _.composedPath().length ? _.composedPath()[0] : _.target;
      d.value?.contains(E) && !s.value?.contains(E) ? p() : (s.value?.contains(E) && !u.value?.contains(E) && r.closeOnPopoverClick || l.value && !c.value?.contains(E)) && b();
    }, y = Ye(() => ({
      maxWidth: r.maxWidth,
      width: r.width,
      maxHeight: r.maxHeight
    })), { floatingStyles: v } = zQ(d, s, {
      placement: r.placement,
      middleware: [MQ(r.popoverOffset), BQ()],
      transform: !1,
      whileElementsMounted: FQ
    });
    return t({
      hidePopover: b
    }), P0(() => {
      document && (Di(document, "click", w), d.value && r.openOnMouseover && (Di(d.value, ["mouseenter", "focus"], g), Di(d.value, ["mouseleave", "blur"], b)), s.value && r.openOnMouseover && (Di(s.value, ["mouseenter", "focusin"], g), Di(s.value, ["mouseleave", "focusout"], b)));
    }), On(l, (_) => {
      i(_ ? "open" : "close");
    }), (_, E) => (ke(), Qe("div", $i({
      ref: "popoverWrapper",
      class: "popover",
      "data-testid": "popover"
    }, o.value), [
      Ft("div", VQ, [
        Bn(_.$slots, "default", {}, void 0, !0)
      ], 512),
      Sr(zd, { name: "spec-renderer-fade" }, {
        default: Xt(() => [
          l.value ? (ke(), Qe("div", $i({
            key: 0,
            ref_key: "popoverRef",
            ref: s,
            "aria-activedescendant": jt(a)["aria-activedescendant"] ? String(jt(a)["aria-activedescendant"]) : void 0,
            "aria-labelledby": jt(a)["aria-labelledby"] ? String(jt(a)["aria-labelledby"]) : void 0,
            class: ["popover-container", [`popover-${e.placement}`, e.popoverClasses]],
            "data-testid": "popover-container",
            role: e.role,
            style: jt(v),
            "x-placement": e.placement
          }, jt(a).id ? { id: String(jt(a).id) } : {}), [
            Ft("div", {
              class: "popover-content",
              style: Ln(y.value)
            }, [
              Bn(_.$slots, "content", {}, void 0, !0)
            ], 4)
          ], 16, GQ)) : Bt("", !0)
        ]),
        _: 3
      })
    ], 16));
  }
}), BO = /* @__PURE__ */ pn(WQ, [["__scopeId", "data-v-467abaad"]]), KQ = ["aria-label", "disabled"], ZQ = { key: 0 }, YQ = { class: "select-items-container" }, JQ = ["id", "aria-selected", "data-testid"], QQ = ["data-testid", "onClick"], XQ = /* @__PURE__ */ ir({
  inheritAttrs: !1,
  __name: "SelectDropdown",
  props: /* @__PURE__ */ eo({
    triggerButton: {
      type: String,
      default: "Select"
    },
    items: {
      type: Object,
      required: !0
    },
    placement: {
      type: String,
      validator: (e) => L2.includes(e),
      default: "bottom-start"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    popoverOffset: {
      type: Number,
      default: 10
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ eo(["change"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = t, i = R0(), a = Ye(() => {
      const l = { ...i };
      return delete l.id, l;
    }), o = bc(e, "modelValue"), c = ja("selectPopover"), u = (l) => {
      o.value = l, c.value?.hidePopover();
    }, s = Ye(() => n.items.find((l) => l.value === o.value));
    return On(o, (l) => {
      const d = n.items.find((f) => f.value === l);
      d && r("change", d);
    }), (l, d) => (ke(), Mt(BO, $i({
      ref: "selectPopover",
      "aria-activedescendant": s.value ? `${s.value.key ? s.value.key : s.value.value}-item` : void 0,
      "aria-labelledby": jt(i).id ? String(jt(i).id) : void 0,
      class: "select-dropdown",
      "close-on-popover-click": "",
      "data-testid": "select-dropdown",
      disabled: e.disabled,
      placement: e.placement,
      "popover-offset": e.popoverOffset,
      width: "300px"
    }, a.value), {
      content: Xt(() => [
        Ft("div", YQ, [
          Ft("ul", null, [
            (ke(!0), Qe(Mn, null, ii(e.items, (f) => (ke(), Qe("li", {
              id: `${f.key ? f.key : f.value}-item`,
              key: `${f.key ? f.key : f.value}-item`,
              "aria-selected": f.value === o.value ? "true" : "false",
              class: Un(["select-item", { selected: f.value === o.value }]),
              "data-testid": f.key ? `${f.key}-item` : "select-item",
              role: "option"
            }, [
              Bn(l.$slots, `${f.key}-item`, { item: f }, () => [
                Ft("button", {
                  "data-testid": f.key ? `${f.key}-item-trigger` : "select-item-trigger",
                  onClick: $f((p) => u(f.value), ["stop"])
                }, [
                  Bn(l.$slots, `${f.key}-item-content`, { item: f }, () => [
                    Ft("span", null, cn(f.label), 1)
                  ])
                ], 8, QQ)
              ])
            ], 10, JQ))), 128))
          ])
        ])
      ]),
      default: Xt(() => [
        Ft("button", $i({
          "aria-label": s.value?.label || e.triggerButton ? void 0 : "Select one option",
          class: "trigger-button",
          "data-select-dropdown-trigger": "true",
          "data-testid": "trigger-button",
          disabled: e.disabled ? !0 : void 0,
          type: "button"
        }, jt(i).id ? { id: String(jt(i).id) } : {}), [
          Bn(l.$slots, "trigger-content", {}, () => [
            Bn(l.$slots, `${s.value?.key}-item-content`, { item: s.value }, () => [
              s.value?.label || e.triggerButton ? (ke(), Qe("span", ZQ, cn(s.value?.label || e.triggerButton), 1)) : Bt("", !0)
            ])
          ]),
          Sr(jt(xO), {
            class: "select-chevron-icon",
            decorative: ""
          })
        ], 16, KQ)
      ]),
      _: 3
    }, 16, ["aria-activedescendant", "aria-labelledby", "disabled", "placement", "popover-offset"]));
  }
}), ma = /* @__PURE__ */ pn(XQ, [["__scopeId", "data-v-d5647298"]]), eX = {
  key: 0,
  class: "variables-container"
}, tX = { class: "variable-label" }, rX = ["data-testid", "value", "onChange"], nX = /* @__PURE__ */ ir({
  __name: "ServerVariables",
  props: {
    server: {
      type: Object,
      required: !0
    }
  },
  emits: ["set-server-variable"],
  setup(e, { emit: t }) {
    const n = (a) => (a || []).map((o) => ({ label: o, value: o })), r = t, i = (a, o, c) => {
      r("set-server-variable", a, o, c);
    };
    return (a, o) => e.server.variables ? (ke(), Qe("div", eX, [
      o[1] || (o[1] = Ft("span", { class: "variables-label" }, "Variables", -1)),
      (ke(!0), Qe(Mn, null, ii(e.server.variables, (c, u) => (ke(), Qe("div", {
        key: `${e.server.id}-${u}`,
        class: "variable-container"
      }, [
        Ft("span", tX, cn(u), 1),
        o[0] || (o[0] = bn(": ", -1)),
        c.enum ? (ke(), Mt(ma, {
          key: 0,
          "data-testid": `${e.server.id}-${u}-select`,
          items: n(c.enum),
          "model-value": c.extensions?.value || c.default,
          onChange: (s) => i(e.server.id, u, s.value)
        }, null, 8, ["data-testid", "items", "model-value", "onChange"])) : (ke(), Qe("input", {
          key: 1,
          "data-testid": `${e.server.id}-${u}-input`,
          type: "text",
          value: c.extensions?.value || c.default,
          onChange: (s) => i(e.server.id, u, s.target.value)
        }, null, 40, rX))
      ]))), 128))
    ])) : Bt("", !0);
  }
}), iX = /* @__PURE__ */ pn(nX, [["__scopeId", "data-v-44f63717"]]), aX = {
  class: "overview-server-list",
  "data-testid": "overview-server-list"
}, oX = ["data-testid"], sX = { class: "server-item-header" }, uX = {
  key: 0,
  class: "overview-server-list-add-custom-url-input"
}, cX = /* @__PURE__ */ ir({
  __name: "ServerList",
  props: {
    serverList: {
      type: Array,
      required: !0
    },
    allowCustomServerUrl: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["add-custom-url", "set-server-variable"],
  setup(e, { emit: t }) {
    const n = t, r = (u, s, l) => {
      n("set-server-variable", u, s, l);
    }, i = Br(!1), a = Br(""), o = () => {
      a.value.length && (n("add-custom-url", a.value), c());
    }, c = () => {
      i.value = !1, a.value = "";
    };
    return (u, s) => (ke(), Mt(_g, { title: "API Base URL" }, {
      "header-icon": Xt(() => [
        Sr(jt(i2), { size: 20 })
      ]),
      content: Xt(() => [
        Ft("ul", aX, [
          (ke(!0), Qe(Mn, null, ii(e.serverList, (l, d) => (ke(), Qe("li", {
            key: l.id,
            class: "overview-server-list-item",
            "data-testid": `overview-server-list-item-${l.id}`
          }, [
            Ft("div", sX, [
              Ft("span", null, "Server " + cn(d + 1) + ":", 1),
              Ft("span", null, cn(l.origUrl || l.url), 1)
            ]),
            l.variables ? (ke(), Mt(iX, {
              key: 0,
              server: l,
              onSetServerVariable: r
            }, null, 8, ["server"])) : Bt("", !0),
            l.description ? (ke(), Mt(ss, {
              key: 1,
              markdown: l.description
            }, null, 8, ["markdown"])) : Bt("", !0)
          ], 8, oX))), 128)),
          e.allowCustomServerUrl ? (ke(), Qe(Mn, { key: 0 }, [
            i.value ? (ke(), Qe("div", uX, [
              zi(Ft("input", {
                "onUpdate:modelValue": s[0] || (s[0] = (l) => a.value = l),
                placeholder: "Enter custom URL",
                type: "text"
              }, null, 512), [
                [
                  xs,
                  a.value,
                  void 0,
                  { trim: !0 }
                ]
              ]),
              Ft("button", {
                class: "secondary",
                onClick: o
              }, " Save URL "),
              Ft("button", {
                class: "tertiary",
                onClick: c
              }, " Cancel ")
            ])) : (ke(), Qe("button", {
              key: 1,
              class: "secondary",
              onClick: s[1] || (s[1] = (l) => i.value = !0)
            }, [
              Sr(jt(bO), { decorative: "" }),
              s[2] || (s[2] = bn(" Add custom URL ", -1))
            ]))
          ], 64)) : Bt("", !0)
        ])
      ]),
      _: 1
    }));
  }
}), lX = /* @__PURE__ */ pn(cX, [["__scopeId", "data-v-bb408243"]]), fX = { class: "overview-collapsible-panel" }, pX = { class: "overview-collapsible-panel-header-title" }, dX = { class: "overview-collapsible-panel-content" }, hX = /* @__PURE__ */ ir({
  __name: "OverviewCollapsiblePanel",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = Br(!1);
    return (n, r) => (ke(), Qe("details", fX, [
      Ft("summary", {
        class: "overview-collapsible-panel-header",
        onClick: r[0] || (r[0] = (i) => t.value = !t.value)
      }, [
        Sr(jt(u1), {
          class: Un(["chevron-icon", { expanded: t.value }])
        }, null, 8, ["class"]),
        Ft("span", pX, cn(e.title), 1)
      ]),
      Ft("div", dX, [
        Bn(n.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), mX = /* @__PURE__ */ pn(hX, [["__scopeId", "data-v-86ef2979"]]), gX = (e) => ta(e) && "authorizationUrl" in e && !("tokenUrl" in e), b_ = (e) => ta(e) && "authorizationUrl" in e && "tokenUrl" in e, vX = (e) => ta(e) && !("authorizationUrl" in e) && "tokenUrl" in e, yX = {
  implicit: "Implicit",
  authorizationCode: "Authorization Code",
  clientCredentials: "Client Credentials",
  password: "Password"
};
function bX(e) {
  switch (e.type) {
    case "apiKey":
    case "httpApiKey":
      return xX(e.in, e.name);
    case "http":
      switch (e.scheme) {
        case "basic":
          return _X();
        case "bearer":
          return wX();
        case "digest":
          return SX();
      }
      break;
    case "oauth2":
      return CX(e);
  }
  return "";
}
function xX(e, t) {
  return `An API key is a token that you provide when making API calls. Include the token in a ${e} parameter called \`${t}\`.

  Example: ${e === "query" ? `\`?${t}=123\`` : `\`${t}: 123\``}`;
}
function _X() {
  return "Basic authentication is a simple authentication scheme built into the HTTP protocol.\n  To use it, send your HTTP requests with an Authorization header that contains the word Basic\n  followed by a space and a base64-encoded string `username:password`.\n\n  Example: `Authorization: Basic ZGVtbzpwQDU1dzByZA==`";
}
function wX() {
  return "Provide your bearer token in the Authorization header when making requests to protected resources.\n\n  Example: `Authorization: Bearer 123`";
}
function SX() {
  return 'Provide your encrypted digest scheme data in the Authorization header when making requests to protected resources.\n\n  Example: `Authorization: Digest username=guest, realm="test", nonce="2", uri="/uri", response="123"`';
}
function CX(e) {
  return UC(e.flows).map((n) => kX(yX[n], e.flows[n])).join(`

`);
}
function kX(e, t) {
  let n = `**${e} OAuth Flow**`;
  n += gX(t) || b_(t) ? `

Authorize URL: ${t.authorizationUrl}` : "", n += b_(t) || vX(t) ? `

Token URL: ${t.tokenUrl}` : "", n += t.refreshUrl ? `

Refresh URL: ${t.refreshUrl}` : "";
  const r = DF(t.scopes);
  return r.length && (n += `

Scopes:
${r.map(([i, a]) => `- \`${i}\` - ${a}`).join(`
`)}`), n;
}
const AX = {
  class: "security-list",
  "data-testid": "overview-security-list"
}, EX = /* @__PURE__ */ ir({
  __name: "SecurityList",
  props: {
    securitySchemeList: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const t = (n) => n.description ?? bX(n);
    return (n, r) => (ke(), Mt(_g, { title: "Security" }, {
      "header-icon": Xt(() => [
        Sr(jt(wO), { size: 20 })
      ]),
      content: Xt(() => [
        Ft("div", AX, [
          (ke(!0), Qe(Mn, null, ii(e.securitySchemeList, (i) => (ke(), Mt(mX, {
            key: i.id,
            "data-testid": `overview-security-scheme-${i.id}`,
            title: `${i.key} (${i.type})`
          }, {
            default: Xt(() => [
              Sr(ss, {
                markdown: t(i)
              }, null, 8, ["markdown"])
            ]),
            _: 2
          }, 1032, ["data-testid", "title"]))), 128))
        ])
      ]),
      _: 1
    }));
  }
}), OX = /* @__PURE__ */ pn(EX, [["__scopeId", "data-v-2e7dbd10"]]), TX = {
  class: "overview-additional-info",
  "data-testid": "overview-additional-info"
}, PX = {
  key: 0,
  class: "overview-additional-info-contact",
  "data-testid": "overview-additional-info-contact"
}, RX = ["href"], IX = ["href"], jX = ["href"], qX = /* @__PURE__ */ ir({
  __name: "AdditionalInfo",
  props: {
    contact: {
      type: Object,
      default: () => ({})
    },
    license: {
      type: Object,
      default: () => ({})
    },
    externalDocs: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return (t, n) => (ke(), Mt(_g, { title: "Additional Information" }, {
      "header-icon": Xt(() => [
        Sr(jt(_O), { size: 20 })
      ]),
      content: Xt(() => [
        Ft("div", TX, [
          e.contact?.url || e.contact?.email ? (ke(), Qe("div", PX, [
            n[0] || (n[0] = bn(" Contact ", -1)),
            e.contact?.url ? (ke(), Qe("a", {
              key: 0,
              href: e.contact.url,
              rel: "noopener noreferrer",
              target: "_blank"
            }, cn(e.contact.name), 9, RX)) : Bt("", !0),
            e.contact?.email ? (ke(), Qe("a", {
              key: 1,
              href: `mailto:${e.contact.email}`,
              rel: "noopener noreferrer",
              target: "_blank"
            }, " (" + cn(e.contact.email) + ") ", 9, IX)) : Bt("", !0)
          ])) : Bt("", !0),
          e.license?.name ? (ke(), Mt(Sn(e.license?.url ? "a" : "p"), {
            key: 1,
            class: "overview-additional-info-license",
            "data-testid": "overview-additional-info-license",
            href: e.license.url,
            rel: "noopener noreferrer",
            target: "_blank"
          }, {
            default: Xt(() => [
              bn(cn(e.license.name) + " License ", 1)
            ]),
            _: 1
          }, 8, ["href"])) : Bt("", !0),
          e.externalDocs?.url ? (ke(), Qe("a", {
            key: 2,
            class: "overview-additional-info-external-docs",
            href: e.externalDocs.url,
            rel: "noopener noreferrer",
            target: "_blank"
          }, cn(e.externalDocs.description || e.externalDocs.url), 9, jX)) : Bt("", !0)
        ])
      ]),
      _: 1
    }));
  }
}), DX = /* @__PURE__ */ pn(qX, [["__scopeId", "data-v-a6791fb4"]]), $X = /* @__PURE__ */ ir({
  __name: "LabelBadge",
  props: {
    label: {
      type: String,
      default: ""
    },
    /**
     * Type variations
     * One of ['neutral', 'primary' ]
     */
    type: {
      type: String,
      required: !0,
      validator: (e) => DU.includes(e)
    },
    /**
    * Size variations
    * One of ['small', 'large' ]
    */
    size: {
      type: String,
      default: "large",
      validator: (e) => PA.includes(e)
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("span", {
      class: Un(["label-badge", [e.type, e.size]]),
      "data-testid": "label-badge"
    }, cn(e.label), 3));
  }
}), qf = /* @__PURE__ */ pn($X, [["__scopeId", "data-v-9753a96d"]]), LX = {
  class: "spec-renderer-page-header",
  "data-testid": "spec-renderer-page-header"
}, NX = { class: "page-header-title" }, FX = { "data-testid": "spec-renderer-page-header-title" }, MX = {
  key: 2,
  class: "page-header-actions"
}, BX = /* @__PURE__ */ ir({
  __name: "PageHeader",
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    deprecated: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", LX, [
      Ft("div", NX, [
        Ft("h2", FX, cn(e.title), 1),
        e.type ? (ke(), Mt(qf, {
          key: 0,
          "data-testid": "data-type-badge",
          label: e.type,
          type: "neutral"
        }, null, 8, ["label"])) : Bt("", !0),
        e.deprecated ? (ke(), Mt(qf, {
          key: 1,
          "data-testid": "deprecated-badge",
          label: "DEPRECATED",
          type: "neutral"
        })) : Bt("", !0),
        t.$slots.actions ? (ke(), Qe("div", MX, [
          Bn(t.$slots, "actions", {}, void 0, !0)
        ])) : Bt("", !0)
      ]),
      e.description ? (ke(), Mt(ss, {
        key: 0,
        "data-testid": "spec-renderer-page-header-description",
        markdown: e.description
      }, null, 8, ["markdown"])) : Bt("", !0),
      Bn(t.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Iu = /* @__PURE__ */ pn(BX, [["__scopeId", "data-v-01936b02"]]), UX = { class: "overview-page" }, HX = { class: "overview-page-versions" }, zX = { class: "overview-page-content" }, VX = /* @__PURE__ */ ir({
  __name: "HttpService",
  props: {
    data: {
      type: Object,
      required: !0
    },
    specVersion: {
      type: String,
      required: !0
    },
    allowCustomServerUrl: {
      type: Boolean,
      default: !1
    },
    hideDownloadButton: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { serverList: n, addServerUrl: r, setServerVariable: i } = qi.useServerList(), { downloadSpecFile: a } = qi.useSchemaParser(), o = Ye(() => t.data.externalDocs?.url || t.data.contact?.url || t.data.contact?.email || t.data.license?.name), c = (u, s, l) => {
      i(u, s, l);
    };
    return (u, s) => (ke(), Qe("div", UX, [
      Sr(Iu, {
        class: "overview-page-header",
        title: e.data.name
      }, yC({
        default: Xt(() => [
          Ft("div", HX, [
            Sr(qf, {
              label: e.data.version,
              type: "primary"
            }, null, 8, ["label"]),
            Sr(qf, {
              label: e.specVersion,
              type: "neutral"
            }, null, 8, ["label"])
          ])
        ]),
        _: 2
      }, [
        e.hideDownloadButton ? void 0 : {
          name: "actions",
          fn: Xt(() => [
            Ft("button", {
              class: "download-spec-btn",
              onClick: s[0] || (s[0] = //@ts-ignore
              (...l) => jt(a) && jt(a)(...l))
            }, " Download ")
          ]),
          key: "0"
        }
      ]), 1032, ["title"]),
      Ft("section", zX, [
        e.data.description ? (ke(), Mt(ss, {
          key: 0,
          markdown: e.data.description
        }, null, 8, ["markdown"])) : Bt("", !0),
        jt(n).length || e.allowCustomServerUrl ? (ke(), Mt(lX, {
          key: 1,
          "allow-custom-server-url": e.allowCustomServerUrl,
          "server-list": jt(n),
          onAddCustomUrl: jt(r),
          onSetServerVariable: c
        }, null, 8, ["allow-custom-server-url", "server-list", "onAddCustomUrl"])) : Bt("", !0),
        Array.isArray(e.data.securitySchemes) && e.data.securitySchemes.length ? (ke(), Mt(OX, {
          key: 2,
          "security-scheme-list": e.data.securitySchemes
        }, null, 8, ["security-scheme-list"])) : Bt("", !0),
        o.value ? (ke(), Mt(DX, {
          key: 3,
          contact: e.data.contact,
          "external-docs": e.data.externalDocs,
          license: e.data.license
        }, null, 8, ["contact", "external-docs", "license"])) : Bt("", !0)
      ])
    ]));
  }
}), GX = /* @__PURE__ */ pn(VX, [["__scopeId", "data-v-947feebe"]]);
function UO(e) {
  const t = Ye(
    () => e.value?.oneOf?.length ? "One Of" : e.value?.anyOf?.length ? "Any Of" : ""
  ), n = Ye(
    () => (e.value?.oneOf || e.value?.anyOf || []).filter(
      rs
    ).map(Oc)
  ), r = Ye(() => n.value.map((o, c) => {
    const u = SG(c, o.title);
    return {
      key: u,
      value: c.toString(),
      label: u + `${o.deprecated ? " (deprecated)" : ""}`
    };
  })), i = Br(0), a = Ye(() => n.value[i.value] ?? e.value);
  return {
    inheritanceTypeLabel: t,
    variantSelectItemList: r,
    selectedVariantIndex: i,
    selectedSchemaModel: a
  };
}
const WX = { class: "variant-label" }, KX = /* @__PURE__ */ ir({
  __name: "VariantLabel",
  props: {
    label: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("code", WX, cn(e.label), 1));
  }
}), HO = /* @__PURE__ */ pn(KX, [["__scopeId", "data-v-224a855a"]]), ZX = ["data-testid"], YX = /* @__PURE__ */ ir({
  __name: "ModelNode",
  props: {
    schema: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    /**
     * Hides the example field from the model node
     * in case example is already shown on the page
     */
    hideExampleField: {
      type: Boolean,
      default: !1
    },
    /**
     * used for links to individual properties of a Schema Model
     */
    basePathId: {
      type: String,
      default: ""
    },
    /**
     * The depth at which the current property is at
     */
    depth: {
      type: Number,
      default: 1
    }
  },
  emits: ["selected-model-changed"],
  setup(e, { emit: t }) {
    const n = e, r = Ye(() => Oc(n.schema)), { variantSelectItemList: i, selectedSchemaModel: a, selectedVariantIndex: o, inheritanceTypeLabel: c } = UO(r);
    function u(d) {
      o.value = Number(d.value);
    }
    const s = t;
    On(a, (d) => {
      s("selected-model-changed", d);
    }, {
      immediate: !0
    });
    const l = Ye(() => `model-node-${n.title.replaceAll(" ", "-")}`);
    return (d, f) => (ke(), Qe("div", {
      class: "model-node-container",
      "data-testid": l.value
    }, [
      jt(i).length ? (ke(), Qe(Mn, { key: 0 }, [
        Ft("div", null, [
          jt(c) ? (ke(), Mt(HO, {
            key: 0,
            label: jt(c)
          }, null, 8, ["label"])) : Bt("", !0),
          Sr(ma, {
            id: `${l.value}-variant-select-dropdown`,
            class: "model-node-variant-select",
            items: jt(i),
            "model-value": jt(o).toString(),
            onChange: u
          }, null, 8, ["id", "items", "model-value"])
        ]),
        jt(a)?.oneOf || jt(a)?.anyOf ? (ke(), Mt(c2, {
          key: 0,
          "base-path-id": e.basePathId,
          depth: e.depth,
          property: jt(a),
          "property-name": jt(a).title || jt(i)[jt(o)].label,
          "required-fields": jt(a)?.required
        }, null, 8, ["base-path-id", "depth", "property", "property-name", "required-fields"])) : Bt("", !0)
      ], 64)) : Bt("", !0),
      (ke(!0), Qe(Mn, null, ii(jt(a)?.properties, (p, g, b) => (ke(), Qe(Mn, { key: g }, [
        jt(rs)(p) ? (ke(), Mt(c2, {
          key: 0,
          "base-path-id": e.basePathId,
          class: Un({ "model-node-property": b !== 0 }),
          "data-testid": `model-property-${g}`,
          depth: e.depth,
          property: p,
          "property-name": g.toString(),
          "required-fields": jt(a)?.required
        }, null, 8, ["base-path-id", "class", "data-testid", "depth", "property", "property-name", "required-fields"])) : Bt("", !0)
      ], 64))), 128))
    ], 8, ZX));
  }
}), ap = /* @__PURE__ */ pn(YX, [["__scopeId", "data-v-7e77caeb"]]), JX = /* @__PURE__ */ ir({
  __name: "PropertyDescription",
  props: {
    description: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.description ? (ke(), Mt(ss, {
      key: 0,
      class: "property-field-description",
      "data-testid": "property-field-description",
      markdown: e.description
    }, null, 8, ["markdown"])) : Bt("", !0);
  }
}), QX = /* @__PURE__ */ pn(JX, [["__scopeId", "data-v-16e5f22c"]]), XX = {
  class: "property-field-example",
  "data-testid": "property-field-example"
}, eee = { class: "property-field-example-value" }, tee = /* @__PURE__ */ ir({
  __name: "PropertyExample",
  props: {
    example: {
      // allow any type since typeof example is unknown
      type: null,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("p", XX, [
      n[0] || (n[0] = Ft("span", { class: "field-title" }, "Example:", -1)),
      Ft("span", eee, cn(jt(IA)(e.example)), 1)
    ]));
  }
}), ree = /* @__PURE__ */ pn(tee, [["__scopeId", "data-v-05b820a3"]]), nee = {
  key: 0,
  class: "property-title",
  "data-testid": "property-field-title"
}, iee = { class: "property-title-name" }, aee = { class: "property-type" }, oee = {
  key: 0,
  "data-testid": "property-field-type"
}, see = {
  key: 1,
  "data-testid": "property-field-item-type"
}, uee = {
  key: 2,
  "data-testid": "property-field-format"
}, cee = {
  key: 3,
  class: "required-property",
  "data-testid": "property-field-required"
}, lee = {
  key: 4,
  class: "readonly-property",
  "data-testid": "property-field-read-only"
}, fee = {
  key: 5,
  "data-testid": "property-field-unique-items"
}, pee = ["href"], dee = /* @__PURE__ */ ir({
  __name: "PropertyInfo",
  props: {
    title: {
      type: String,
      default: ""
    },
    propertyType: {
      type: [Array, String],
      default: ""
    },
    format: {
      type: String,
      default: ""
    },
    propertyItemType: {
      type: [Array, String],
      default: ""
    },
    uniqueItems: {
      type: Boolean,
      default: !1
    },
    deprecated: {
      type: Boolean,
      default: !1
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    variantsList: {
      type: Array,
      default: () => []
    },
    inheritanceTypeLabel: {
      type: String,
      default: ""
    },
    propertyPath: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["variant-changed"],
  setup(e, { emit: t }) {
    const n = e, r = Br("0"), i = t, a = Ye(() => Array.isArray(n.propertyType) ? n.propertyType.join(" | ") : n.propertyType ?? "");
    function o(c) {
      i("variant-changed", Number(c.value));
    }
    return (c, u) => (ke(), Qe("div", {
      class: Un(["property-info", { "deprecated-property": e.deprecated }]),
      "data-testid": "property-field-info"
    }, [
      e.title || e.inheritanceTypeLabel || e.variantsList.length ? (ke(), Qe("span", nee, [
        Ft("span", iee, cn(e.title), 1),
        e.inheritanceTypeLabel ? (ke(), Mt(HO, {
          key: 0,
          class: "property-title-variant-label",
          label: e.inheritanceTypeLabel
        }, null, 8, ["label"])) : Bt("", !0),
        e.variantsList.length ? (ke(), Mt(ma, {
          key: 1,
          id: `${e.title}-variant-select-dropdown`,
          modelValue: r.value,
          "onUpdate:modelValue": u[0] || (u[0] = (s) => r.value = s),
          class: "property-title-variant-select",
          items: e.variantsList,
          onChange: o
        }, null, 8, ["id", "modelValue", "items"])) : Bt("", !0)
      ])) : Bt("", !0),
      Ft("span", aee, [
        a.value ? (ke(), Qe("span", oee, cn(a.value), 1)) : Bt("", !0),
        e.propertyItemType ? (ke(), Qe("span", see, cn(`[${e.propertyItemType}]`), 1)) : Bt("", !0),
        e.format ? (ke(), Qe("span", uee, cn(`(${e.format})`), 1)) : Bt("", !0),
        e.requiredFields?.includes(e.title) ? (ke(), Qe("span", cee, "required")) : Bt("", !0),
        e.readOnly ? (ke(), Qe("span", lee, "read-only")) : Bt("", !0),
        e.uniqueItems ? (ke(), Qe("span", fee, "unique-items")) : Bt("", !0),
        e.deprecated ? (ke(), Mt(qf, {
          key: 6,
          "data-testid": "property-field-deprecated",
          label: "DEPRECATED",
          size: "small",
          type: "neutral"
        })) : Bt("", !0)
      ]),
      e.propertyPath ? (ke(), Qe("a", {
        key: 1,
        class: "property-info-permalink",
        href: `#${e.propertyPath}`
      }, [
        Sr(jt(WY))
      ], 8, pee)) : Bt("", !0)
    ], 2));
  }
}), hee = /* @__PURE__ */ pn(dee, [["__scopeId", "data-v-fc996712"]]), mee = {
  class: "property-field-enum",
  "data-testid": "property-field-enum"
}, gee = { class: "enum-field-list" }, vee = ["data-testid"], yee = /* @__PURE__ */ ir({
  __name: "PropertyEnum",
  props: {
    enumValueList: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("p", mee, [
      n[0] || (n[0] = Ft("span", { class: "field-title" }, "Allowed values:", -1)),
      Ft("span", gee, [
        (ke(!0), Qe(Mn, null, ii(e.enumValueList, (r) => (ke(), Qe(Mn, null, [
          r ? (ke(), Qe("span", {
            key: r?.toString(),
            class: "property-field-enum-value",
            "data-testid": `property-field-enum-value-${r}`
          }, cn(r), 9, vee)) : Bt("", !0)
        ], 64))), 256))
      ])
    ]));
  }
}), bee = /* @__PURE__ */ pn(yee, [["__scopeId", "data-v-71bc6b4e"]]), xee = {
  class: "property-field-pattern",
  "data-testid": "property-field-pattern"
}, _ee = { class: "property-field-pattern-value" }, wee = /* @__PURE__ */ ir({
  __name: "PropertyPattern",
  props: {
    pattern: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("p", xee, [
      n[0] || (n[0] = Ft("span", { class: "field-title" }, "Match pattern:", -1)),
      Ft("span", _ee, cn(e.pattern), 1)
    ]));
  }
}), See = /* @__PURE__ */ pn(wee, [["__scopeId", "data-v-106ddaac"]]), Cee = {
  class: "property-field-range",
  "data-testid": "property-field-range"
}, kee = /* @__PURE__ */ ir({
  __name: "PropertyRange",
  props: {
    maximum: {
      type: Number,
      default: null
    },
    minimum: {
      type: Number,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    minLength: {
      type: Number,
      default: null
    },
    exclusiveMaximum: {
      type: [Boolean, Number],
      default: null
    },
    exclusiveMinimum: {
      type: [Boolean, Number],
      default: null
    },
    multipleOf: {
      type: Number,
      default: null
    },
    maxItems: {
      type: Number,
      default: null
    },
    minItems: {
      type: Number,
      default: null
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      const r = [];
      return Number.isFinite(t.minimum) && r.push({
        key: "range-min",
        value: typeof t.exclusiveMinimum == "boolean" && t.exclusiveMinimum ? `> ${t.minimum}` : `>= ${t.minimum}`
      }), Number.isFinite(t.maximum) && r.push({
        key: "range-max",
        value: typeof t.exclusiveMaximum == "boolean" && t.exclusiveMaximum ? `< ${t.maximum}` : `<= ${t.maximum}`
      }), Number.isFinite(t.minLength) && r.push({
        key: "range-min-length",
        value: `>= ${t.minLength} characters`
      }), Number.isFinite(t.maxLength) && r.push({
        key: "range-max-length",
        value: `<= ${t.maxLength} characters`
      }), Number.isFinite(t.exclusiveMinimum) && r.push({
        key: "range-exclusive-min",
        value: `> ${t.exclusiveMinimum}`
      }), Number.isFinite(t.exclusiveMaximum) && r.push({
        key: "range-exclusive-max",
        value: `< ${t.exclusiveMaximum}`
      }), Number.isFinite(t.multipleOf) && r.push({ key: "range-multiple-of", value: `x ${t.multipleOf}` }), Number.isFinite(t.minItems) && r.push({ key: "range-min-items", value: `>= ${t.minItems} items` }), Number.isFinite(t.maxItems) && r.push({ key: "range-max-items", value: `<= ${t.maxItems} items` }), r;
    });
    return (r, i) => (ke(), Qe("p", Cee, [
      (ke(!0), Qe(Mn, null, ii(n.value, (a) => (ke(), Qe("span", {
        key: a.key,
        class: "property-field-range-value"
      }, cn(a.value), 1))), 128))
    ]));
  }
}), Aee = /* @__PURE__ */ pn(kee, [["__scopeId", "data-v-c0174553"]]), Eee = {
  class: "property-field-default",
  "data-testid": "property-field-default"
}, Oee = { class: "property-field-default-value" }, Tee = /* @__PURE__ */ ir({
  __name: "PropertyDefault",
  props: {
    defaultValue: {
      // allow any type since typeof default value is unknown
      type: null,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("p", Eee, [
      n[0] || (n[0] = Ft("span", { class: "field-title" }, "Default:", -1)),
      Ft("span", Oee, cn(jt(IA)(e.defaultValue)), 1)
    ]));
  }
}), Pee = /* @__PURE__ */ pn(Tee, [["__scopeId", "data-v-b5e94329"]]), Ree = {
  class: "property-field-additional-properties",
  "data-testid": "property-field-additional-properties"
}, Iee = {
  key: 0,
  class: "footprint"
}, jee = {
  key: 1,
  class: "footprint"
}, qee = /* @__PURE__ */ ir({
  __name: "AdditionalProperties",
  props: {
    additionalProperties: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", Ree, [
      e.additionalProperties === !0 ? (ke(), Qe("div", Iee, " * Additional properties are allowed. ")) : Bt("", !0),
      e.additionalProperties === !1 ? (ke(), Qe("div", jee, n[0] || (n[0] = [
        bn(" * Additional properties are ", -1),
        Ft("b", null, "NOT", -1),
        bn(" allowed. ", -1)
      ]))) : Bt("", !0)
    ]));
  }
}), Dee = /* @__PURE__ */ pn(qee, [["__scopeId", "data-v-c16e0515"]]), $ee = { class: "property-field-list" }, Lee = /* @__PURE__ */ ir({
  __name: "PropertyFieldList",
  props: {
    property: {
      type: Object,
      required: !0
    },
    propertyName: {
      type: String,
      default: ""
    },
    hiddenFieldList: {
      type: Array,
      default: () => []
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    variantSelectItemList: {
      type: Array,
      default: () => []
    },
    inheritanceTypeLabel: {
      type: String,
      default: ""
    },
    propertyPath: {
      type: String,
      default: ""
    }
  },
  emits: ["variant-changed"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = (o) => {
      if (n.hiddenFieldList.includes(o))
        return !1;
      const c = n.property?.["x-stoplight"]?.explicitProperties;
      return Array.isArray(c) && c.length ? c.includes(o) : !0;
    }, a = Ye(() => {
      const o = [];
      if (!rs(n.property)) return [];
      !n.hiddenFieldList.includes("info") && (n.property.title || n.propertyName || n.property.type) && o.push({
        component: hee,
        props: {
          title: n.propertyName || n.property.title,
          propertyType: n.property.type,
          uniqueItems: n.property.uniqueItems,
          requiredFields: n.requiredFields,
          variantsList: n.variantSelectItemList,
          inheritanceTypeLabel: n.inheritanceTypeLabel,
          deprecated: n.property.deprecated,
          propertyPath: n.propertyPath,
          propertyItemType: n.property.itemType,
          format: n.property.format,
          readOnly: n.property.readOnly
        },
        eventHandlers: {
          "variant-changed": (s) => {
            r("variant-changed", s);
          }
        },
        key: "property-info"
      }), i("description") && n.property.description && o.push({
        component: QX,
        props: {
          description: n.property.description
        },
        eventHandlers: {},
        key: "property-description"
      }), i("enum") && n.property.enum && o.push({
        component: bee,
        props: {
          enumValueList: n.property.enum
        },
        eventHandlers: {},
        key: "property-enum"
      }), i("pattern") && n.property.pattern && o.push({
        component: See,
        props: {
          pattern: n.property.pattern
        },
        eventHandlers: {},
        key: "property-pattern"
      }), i("default") && n.property.default !== void 0 && o.push({
        component: Pee,
        props: {
          defaultValue: n.property.default
        },
        eventHandlers: {},
        key: "property-default"
      });
      const c = {};
      return qU.forEach((s) => {
        i(s) && (c[s] = n.property[s]);
      }), !n.hiddenFieldList.includes("range") && Object.values(c).some((s) => s !== void 0) && o.push({
        component: Aee,
        props: c,
        eventHandlers: {},
        key: "property-range"
      }), (n.property.example && i("example") || n.property.examples && i("examples")) && o.push({
        component: ree,
        props: {
          example: n.property.examples || n.property.example
        },
        eventHandlers: {},
        key: "property-example"
      }), i("additionalProperties") && typeof n.property.additionalProperties == "boolean" && o.push({
        component: Dee,
        props: {
          additionalProperties: n.property.additionalProperties
        },
        eventHandlers: {},
        key: "property-additional-properties"
      }), o;
    });
    return (o, c) => (ke(), Qe("div", $ee, [
      (ke(!0), Qe(Mn, null, ii(a.value, (u) => (ke(), Mt(Sn(u.component), $i({
        key: u.key
      }, { ref_for: !0 }, u.props, ND(u.eventHandlers)), null, 16))), 128))
    ]));
  }
}), op = /* @__PURE__ */ pn(Lee, [["__scopeId", "data-v-4aaaf217"]]), Nee = ["id", "data-testid"], Fee = {
  key: 0,
  class: "selected-variant-container"
}, Mee = {
  key: 1,
  ref: "nestedFields"
}, Bee = /* @__PURE__ */ ir({
  __name: "ModelProperty",
  props: {
    property: {
      type: Object,
      required: !0
    },
    propertyName: {
      type: String,
      required: !0
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    /**
     * used for links to individual properties of a Schema Model
     */
    basePathId: {
      type: String,
      default: ""
    },
    /**
     * The depth at which the current property is at
     */
    depth: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    const t = e, n = Xa("max-expanded-depth", Br(hc)), r = Br(t.depth < n.value), i = ja("modelProperty"), a = ja("nestedFields"), o = Ye(() => `model-property-${u0(t.propertyName)}`), c = Ye(() => t.basePathId ? u0(`${t.basePathId}-${t.propertyName}`) : void 0), u = Ye(() => Oc(t.property)), {
      variantSelectItemList: s,
      selectedSchemaModel: l,
      selectedVariantIndex: d,
      inheritanceTypeLabel: f
    } = UO(u), p = Ye(() => l.value?.properties ? !!Object.keys(l.value?.properties).length : !1);
    P0(() => {
      if (r.value && g(), s0() || !c.value)
        return;
      const b = `#${c.value}`, w = window.location.hash;
      w.length && (w === b ? i.value?.scrollIntoView({ behavior: "smooth" }) : w.startsWith(b) && (r.value = !0, g()));
    });
    const g = () => {
      a.value && (a.value.open = !0);
    };
    return (b, w) => {
      const y = FD("ModelProperty", !0);
      return ke(), Qe("div", {
        id: c.value,
        ref: "modelProperty",
        class: "model-property",
        "data-testid": o.value
      }, [
        Sr(op, {
          "inheritance-type-label": jt(f),
          property: u.value,
          "property-name": e.propertyName,
          "property-path": c.value,
          "required-fields": e.requiredFields,
          "variant-select-item-list": jt(s),
          onVariantChanged: w[0] || (w[0] = (v) => d.value = v)
        }, null, 8, ["inheritance-type-label", "property", "property-name", "property-path", "required-fields", "variant-select-item-list"]),
        jt(s).length ? (ke(), Qe("div", Fee, [
          Sr(y, {
            "base-path-id": c.value,
            depth: e.depth,
            property: jt(l),
            "property-name": jt(l).title || jt(s)[jt(d)].label,
            "required-fields": jt(l).required
          }, null, 8, ["base-path-id", "depth", "property", "property-name", "required-fields"])
        ])) : p.value ? (ke(), Qe("details", Mee, [
          Ft("summary", {
            class: "nested-fields-summary",
            onClick: w[1] || (w[1] = () => r.value = !r.value)
          }, [
            Sr(jt(bO), {
              class: Un(["add-circle-icon", { expanded: r.value }]),
              size: "16px"
            }, null, 8, ["class"]),
            Ft("span", null, cn(r.value ? "Hide" : "Show") + " Child Parameters", 1)
          ]),
          r.value ? (ke(), Mt(ap, {
            key: 0,
            "base-path-id": c.value,
            class: "nested-model-node",
            depth: e.depth + 1,
            schema: jt(l),
            title: e.propertyName
          }, null, 8, ["base-path-id", "depth", "schema", "title"])) : Bt("", !0)
        ], 512)) : Bt("", !0)
      ], 8, Nee);
    };
  }
}), c2 = /* @__PURE__ */ pn(Bee, [["__scopeId", "data-v-d02191e5"]]), Uee = { key: 0 }, Hee = {
  key: 0,
  class: "endpoint-collapsible-section-content"
}, zee = /* @__PURE__ */ ir({
  __name: "CollapsibleSection",
  props: {
    borderVisible: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = Br(!0), n = (r) => {
      r.target.dataset.selectDropdownTrigger || (t.value = !t.value);
    };
    return (r, i) => (ke(), Qe("details", {
      class: Un(["endpoint-collapsible-section", { "border-visible": e.borderVisible }]),
      open: ""
    }, [
      Ft("summary", {
        class: "endpoint-collapsible-section-header",
        onClick: n
      }, [
        Bn(r.$slots, "title", {}, () => [
          e.title ? (ke(), Qe("h3", Uee, cn(e.title), 1)) : Bt("", !0)
        ]),
        Sr(jt(u1), {
          class: Un(["chevron-icon", { expanded: t.value }]),
          size: jt(PO)
        }, null, 8, ["class", "size"])
      ]),
      r.$slots.default ? (ke(), Qe("div", Hee, [
        Bn(r.$slots, "default")
      ])) : Bt("", !0)
    ], 2));
  }
}), Pc = /* @__PURE__ */ pn(zee, [["__scopeId", "data-v-10dc6efb"]]), Vee = { class: "request-param-list-items" }, Gee = /* @__PURE__ */ ir({
  __name: "RequestParamList",
  props: {
    paramList: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = (r, i) => {
      if (!r.schema) return null;
      const a = i;
      return r.description && !a?.description && (a.description = r.description), a;
    }, n = (r) => r.schema?.required ? r.schema?.required : r.required ? [r.name] : [];
    return (r, i) => (ke(), Mt(Pc, {
      class: "request-param-list",
      title: e.title
    }, {
      default: Xt(() => [
        Ft("div", Vee, [
          (ke(!0), Qe(Mn, null, ii(e.paramList, (a) => (ke(), Qe(Mn, {
            key: a.id
          }, [
            a.schema ? (ke(), Mt(c2, {
              key: 0,
              property: { ...a.schema, ...t(a, a.schema) },
              "property-name": a.name,
              "required-fields": n(a)
            }, null, 8, ["property", "property-name", "required-fields"])) : Bt("", !0)
          ], 64))), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]));
  }
}), Hd = /* @__PURE__ */ pn(Gee, [["__scopeId", "data-v-bebb6706"]]), Wee = { "data-testid": "endpoint-http-request" }, zO = /* @__PURE__ */ ir({
  __name: "HttpRequest",
  props: {
    query: {
      type: Array,
      default: () => []
    },
    path: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    titlePrefix: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      const r = [], { query: i, path: a, headers: o } = MD(t), c = t.titlePrefix + " ";
      return i.value?.length && r.push({
        component: Hd,
        componentProps: {
          paramList: i.value,
          title: `${c}Query Parameters`,
          "data-testid": "endpoint-query-param-list"
        },
        key: "query"
      }), a.value?.length && r.push({
        component: Hd,
        componentProps: {
          paramList: a.value,
          title: `${c}Path Parameters`,
          "data-testid": "endpoint-path-param-list"
        },
        key: "path"
      }), o.value?.length && r.push({
        component: Hd,
        componentProps: {
          paramList: o.value,
          title: `${c}Headers`,
          "data-testid": "endpoint-header-param-list"
        },
        key: "headers"
      }), r;
    });
    return (r, i) => (ke(), Qe("section", Wee, [
      (ke(!0), Qe(Mn, null, ii(n.value, ({ component: a, componentProps: o, key: c }) => (ke(), Qe(Mn, { key: c }, [
        o ? (ke(), Mt(Sn(a), $i({
          key: 0,
          ref_for: !0
        }, o), null, 16)) : Bt("", !0)
      ], 64))), 128)),
      Bn(r.$slots, "default")
    ]));
  }
}), Kee = { class: "content-list-item-schema" }, x_ = /* @__PURE__ */ ir({
  __name: "ContentListItemSchema",
  props: {
    schema: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = Ye(() => {
      const n = ["example", "examples"];
      return e.schema.properties && Object.keys(e.schema.properties)?.length && n.push("info"), n;
    });
    return (n, r) => (ke(), Qe("div", Kee, [
      Sr(op, {
        "hidden-field-list": t.value,
        property: e.schema,
        "required-fields": e.schema.required
      }, null, 8, ["hidden-field-list", "property", "required-fields"]),
      Sr(ap, {
        schema: e.schema,
        title: e.schema.title
      }, null, 8, ["schema", "title"])
    ]));
  }
}), Zee = {
  class: "body-content-list",
  "data-testid": "endpoint-body-content-list"
}, Yee = { class: "content-list-schema-title" }, Jee = /* @__PURE__ */ ir({
  __name: "BodyContentList",
  props: {
    description: {
      type: String,
      default: ""
    },
    contents: {
      type: Array,
      required: !0
    },
    hideReadonly: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e;
    function n(r) {
      const i = Oc(r);
      return t.hideReadonly ? J2(i, RE) : i;
    }
    return (r, i) => (ke(), Qe("div", Zee, [
      e.description ? (ke(), Mt(ss, {
        key: 0,
        class: "body-content-list-description",
        markdown: e.description
      }, null, 8, ["markdown"])) : Bt("", !0),
      (ke(!0), Qe(Mn, null, ii(e.contents, (a) => (ke(), Qe(Mn, {
        key: a.id
      }, [
        a.schema?.title ? (ke(), Mt(Pc, {
          key: 0,
          "border-visible": !1
        }, yC({
          default: Xt(() => [
            Sr(x_, {
              schema: n(a.schema)
            }, null, 8, ["schema"])
          ]),
          _: 2
        }, [
          a.schema.title ? {
            name: "title",
            fn: Xt(() => [
              Ft("h4", Yee, cn(a.schema.title), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1024)) : a.schema ? (ke(), Mt(x_, {
          key: 1,
          schema: n(a.schema)
        }, null, 8, ["schema"])) : Bt("", !0)
      ], 64))), 128))
    ]));
  }
}), Qee = /* @__PURE__ */ pn(Jee, [["__scopeId", "data-v-c9891b53"]]), Xee = {
  class: "endpoint-http-response",
  "data-testid": "endpoint-http-response"
}, ete = { class: "http-response-header" }, tte = /* @__PURE__ */ ir({
  __name: "HttpOperationBody",
  props: {
    description: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Response"
    },
    contentList: {
      type: Array,
      default: () => []
    },
    hideReadonly: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("section", Xee, [
      Sr(Pc, null, {
        title: Xt(() => [
          Ft("div", ete, [
            Ft("h3", null, cn(e.title), 1),
            Bn(t.$slots, "default", {}, void 0, !0)
          ])
        ]),
        default: Xt(() => [
          Sr(Qee, {
            contents: e.contentList,
            description: e.description,
            "hide-readonly": e.hideReadonly
          }, null, 8, ["contents", "description", "hide-readonly"])
        ]),
        _: 3
      })
    ]));
  }
}), r3 = /* @__PURE__ */ pn(tte, [["__scopeId", "data-v-6b51395c"]]), rte = ["title"], nte = /* @__PURE__ */ ir({
  __name: "CopyButton",
  props: {
    content: {
      required: !0,
      type: String
    },
    iconsSize: {
      type: String,
      default: "16px"
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  },
  setup(e) {
    const t = e, { copy: n, copied: r } = EJ({ source: t.content, legacy: !0 });
    async function i() {
      await n(t.content);
    }
    return (a, o) => (ke(), Qe("button", {
      class: "copy-button",
      title: jt(r) ? "Copied!" : "Copy",
      onClick: $f(i, ["stop"])
    }, [
      (ke(), Mt(Sn(jt(r) ? jt($Y) : jt(UY)), {
        color: jt(r) ? "green" : e.iconColor,
        size: e.iconsSize
      }, null, 8, ["color", "size"]))
    ], 8, rte));
  }
}), m1 = /* @__PURE__ */ pn(nte, [["__scopeId", "data-v-bf351e12"]]), ite = {
  class: "server-endpoint",
  "data-testid": "server-endpoint"
}, ate = { class: "current-endpoint" }, ote = { class: "endpoint-body" }, ste = {
  key: 0,
  class: "endpoint-path",
  "data-testid": "endpoint-path"
}, ute = ["data-testid"], cte = {
  key: 0,
  class: "endpoint-body"
}, lte = {
  class: "endpoint-path",
  "data-testid": "endpoint-path"
}, fte = /* @__PURE__ */ ir({
  __name: "ServerEndpoint",
  props: {
    method: {
      type: String,
      required: !0
    },
    serverUrlList: {
      type: Array,
      required: !0
    },
    selectedServerUrl: {
      type: String,
      required: !0
    },
    path: {
      type: String,
      default: ""
    }
  },
  emits: ["selected-server-changed"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = Ye(() => `${n.method}-${n.serverUrlList[0]}${n.path}`), a = (c) => {
      r("selected-server-changed", c);
    }, o = Ye(() => n.serverUrlList.map((c) => ({ label: c, value: c, key: c })));
    return (c, u) => (ke(), Qe("div", ite, [
      Ft("div", ate, [
        Sr(s1, {
          method: e.method,
          size: "large"
        }, null, 8, ["method"]),
        e.serverUrlList.length > 1 ? (ke(), Mt(ma, {
          key: 0,
          id: "server-select-dropdown",
          class: "server-select-dropdown",
          "data-testid": `server-dropdown-${i.value}`,
          items: o.value,
          "model-value": e.selectedServerUrl,
          "onUpdate:modelValue": a
        }, {
          "trigger-content": Xt(() => [
            Ft("span", ote, cn(e.selectedServerUrl), 1),
            e.path ? (ke(), Qe("span", ste, cn(e.path), 1)) : Bt("", !0)
          ]),
          _: 1
        }, 8, ["data-testid", "items", "model-value"])) : (ke(), Qe("div", {
          key: 1,
          class: "server-url-with-path",
          "data-testid": `server-url-${i.value}`
        }, [
          e.selectedServerUrl ? (ke(), Qe("span", cte, cn(e.selectedServerUrl), 1)) : Bt("", !0),
          Ft("span", lte, cn(e.path), 1)
        ], 8, ute))
      ]),
      Sr(m1, {
        content: e.selectedServerUrl + e.path
      }, null, 8, ["content"])
    ]));
  }
}), Eg = /* @__PURE__ */ pn(fte, [["__scopeId", "data-v-b8aaf937"]]), pte = {
  class: "endpoint-http-callbacks",
  "data-testid": "endpoint-http-callbacks"
}, dte = { class: "http-callbacks-header" }, hte = { class: "callback-collapsible-section-content" }, mte = /* @__PURE__ */ ir({
  __name: "HttpCallbacks",
  props: {
    callback: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("section", pte, [
      Sr(Pc, { "border-visible": !1 }, {
        title: Xt(() => [
          Ft("div", dte, [
            n[0] || (n[0] = Ft("h3", null, "Callbacks", -1)),
            Bn(t.$slots, "default", {}, void 0, !0)
          ])
        ]),
        default: Xt(() => [
          Ft("div", hte, [
            Sr(Eg, {
              class: "callback-path-url",
              method: e.callback.method,
              "selected-server-url": e.callback.path,
              "server-url-list": [e.callback.path]
            }, null, 8, ["method", "selected-server-url", "server-url-list"]),
            e.callback.request ? (ke(), Mt(zO, $i({ key: 0 }, e.callback.request, { "title-prefix": "Callback" }), null, 16)) : Bt("", !0),
            Bn(t.$slots, "callback-response", {}, void 0, !0)
          ])
        ]),
        _: 3
      })
    ]));
  }
}), gte = /* @__PURE__ */ pn(mte, [["__scopeId", "data-v-2cf20e98"]]), vte = ["data-testid", "disabled"], yte = ["data-testid", "onClick"], bte = ["data-testid", "onClick"], xte = /* @__PURE__ */ ir({
  __name: "TryItDropdown",
  props: {
    data: {
      type: Object,
      required: !0
    },
    isLoading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["tryit-api-call"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = [
      {
        label: "in Browser",
        value: "browser",
        key: "browser"
      },
      {
        label: "in Insomnia",
        value: "insomnia",
        key: "insomnia"
      }
    ], a = Xa("hide-insomnia-tryit", Br(!1)), o = Xa("spec-url", Br("")), c = Ye(() => !(a.value || !o.value)), u = Ye(() => n.isLoading ? XY : c.value ? s.value === "browser" ? i2 : F9 : null), { selectedTryItMethodKey: s } = qi.useTryItState(), l = (f) => {
      (!f || !f.target.dataset.selectDropdownTrigger) && (s.value === "browser" ? r("tryit-api-call") : window.open(
        `https://insomnia.rest/run?uri=${encodeURIComponent(o.value)}`,
        "_blank"
      ));
    }, d = (f) => {
      s.value = f.key || "browser", l();
    };
    return (f, p) => (ke(), Qe("div", {
      class: Un(["tryit-wrapper", e.data.method])
    }, [
      Ft("button", {
        class: Un(["call-button", { "no-dropdown": !c.value }]),
        "data-testid": `tryit-call-button-${e.data.id}`,
        disabled: e.isLoading,
        onClick: l
      }, [
        u.value ? (ke(), Mt(Sn(u.value), {
          key: 0,
          class: "tryit-method-icon"
        })) : Bt("", !0),
        p[0] || (p[0] = bn(" Try It! ", -1))
      ], 10, vte),
      c.value ? (ke(), Mt(ma, {
        key: 0,
        id: `tryit-dropdown-${e.data.id}`,
        class: "tryit-dropdown",
        "data-testid": `tryit-dropdown-${e.data.id}`,
        disabled: e.isLoading,
        items: i,
        placement: "bottom-end",
        "trigger-button": ""
      }, {
        "browser-item": Xt(({ item: g }) => [
          Ft("button", {
            "data-testid": `tryit-send-request-${e.data.id}`,
            onClick: (b) => d(g)
          }, [
            Sr(jt(i2)),
            bn(" " + cn(g.label), 1)
          ], 8, yte)
        ]),
        "insomnia-item": Xt(({ item: g }) => [
          Ft("button", {
            "data-testid": `tryit-insomnia-${e.data.id}`,
            onClick: (b) => d(g)
          }, [
            Sr(jt(F9)),
            bn(" " + cn(g.label), 1)
          ], 8, bte)
        ]),
        _: 1
      }, 8, ["id", "data-testid", "disabled"])) : Bt("", !0)
    ], 2));
  }
}), _te = /* @__PURE__ */ pn(xte, [["__scopeId", "data-v-826732a5"]]), wte = { class: "collapsable-panel" }, Ste = { class: "btn-container" }, Cte = ["aria-expanded"], kte = { class: "panel-body" }, Ate = /* @__PURE__ */ ir({
  __name: "CollapsablePanel",
  props: {
    collapsible: {
      type: Boolean,
      default: !0
    },
    contentToCopy: {
      type: String,
      default: ""
    },
    startCollapsed: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, n = Br(t.collapsible && t.startCollapsed), r = (i) => {
      t.collapsible && !i.target.dataset.selectDropdownTrigger && (n.value = !n.value);
    };
    return (i, a) => (ke(), Qe("div", wte, [
      Ft("div", {
        class: Un(["panel-header", { collapsed: n.value, collapsible: e.collapsible }]),
        onClick: r
      }, [
        Bn(i.$slots, "header", {}, void 0, !0),
        Ft("div", Ste, [
          e.contentToCopy && !n.value ? (ke(), Mt(m1, {
            key: 0,
            content: e.contentToCopy
          }, null, 8, ["content"])) : Bt("", !0),
          e.collapsible ? (ke(), Qe("button", {
            key: 1,
            "aria-expanded": !n.value,
            "aria-label": "Toggle content",
            class: "collapse-trigger-btn",
            type: "button"
          }, [
            n.value ? (ke(), Mt(jt(u1), {
              key: 0,
              class: "chevron-icon"
            })) : (ke(), Mt(jt(xO), {
              key: 1,
              class: "chevron-icon"
            }))
          ], 8, Cte)) : Bt("", !0)
        ])
      ], 2),
      zi(Ft("div", kte, [
        Bn(i.$slots, "default", {}, void 0, !0)
      ], 512), [
        [yf, !n.value]
      ])
    ]));
  }
}), g1 = /* @__PURE__ */ pn(Ate, [["__scopeId", "data-v-6fd8039c"]]), Ete = /* @__PURE__ */ ir({
  __name: "InputLabel",
  props: {
    required: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("label", {
      class: Un({ required: e.required })
    }, [
      Bn(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), wo = /* @__PURE__ */ pn(Ete, [["__scopeId", "data-v-7de4374b"]]), Ote = /* @__PURE__ */ ir({
  __name: "TooltipPopover",
  props: {
    text: {
      type: String,
      default: "Tooltip content"
    },
    placement: {
      type: String,
      validator: (e) => L2.includes(e),
      default: "top-start"
    }
  },
  setup(e) {
    return (t, n) => (ke(), Mt(BO, {
      class: "tooltip-popover",
      "max-width": "300px",
      "open-on-mouseover": "",
      placement: e.placement,
      role: "tooltip"
    }, {
      content: Xt(() => [
        Bn(t.$slots, "content", {}, () => [
          bn(cn(e.text), 1)
        ], !0)
      ]),
      default: Xt(() => [
        Bn(t.$slots, "default", {}, () => [
          Sr(jt(_O), {
            class: "tooltip-trigger-info-icon",
            color: `var(--kui-color-text-neutral, ${jt(TO)})`,
            tabindex: "0"
          }, null, 8, ["color"])
        ], !0)
      ]),
      _: 3
    }, 8, ["placement"]));
  }
}), bu = /* @__PURE__ */ pn(Ote, [["__scopeId", "data-v-0d81e24a"]]), Tte = { class: "param-wrapper" }, Pte = ["id", "aria-describedby"], Rte = { class: "param-wrapper" }, Ite = ["id", "aria-describedby"], jte = {
  key: 0,
  class: "param-wrapper"
}, qte = { class: "button-wrapper" }, Dte = ["aria-label"], $te = ["aria-label"], Lte = ["id", "onUpdate:modelValue", "aria-describedby"], Nte = ["for"], Fte = { class: "key-span" }, Mte = /* @__PURE__ */ ir({
  __name: "TryItAuth2",
  props: {
    schemeKey: {
      type: String,
      required: !0
    },
    dataId: {
      type: String,
      required: !0
    },
    scheme: {
      type: Object,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const n = e, { authInputs: r, authHeadersMap: i } = qi.useAuth(), a = () => {
      r.value[`${n.schemeKey}-token`] = "";
    }, o = (l) => {
      Object.entries(n.scheme.flows.clientCredentials?.scopes || {}).forEach(([d]) => {
        r.value[`${n.schemeKey}-scope-${d}`] = l ? "true" : "false";
      });
    };
    t({
      auth2ClientCredentialsAuth: async () => {
        const l = r.value[`${n.schemeKey}-clientId`] || "", d = r.value[`${n.schemeKey}-clientSecret`] || "", f = btoa(`${l}:${d}`), p = [];
        if (r.value[`${n.schemeKey}-token`])
          return;
        Object.keys(r.value).filter((b) => b.startsWith(`${n.schemeKey}-scope-`)).forEach((b) => {
          r.value[b].toString() === "true" && p.push(b.replace(`${n.schemeKey}-scope-`, ""));
        });
        const g = await fetch(n.scheme.flows.clientCredentials?.tokenUrl || "", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Basic ${f}`
          },
          body: new URLSearchParams({
            grant_type: "client_credentials",
            ...p.length ? { scope: p.join(" ") } : {}
          })
        });
        if (g.ok) {
          let b = await g.json();
          r.value[`${n.schemeKey}-token`] = `${b.token_type || "Bearer"} ${b.access_token}`, await u(), EO(async () => {
            r.value[`${n.schemeKey}-token`] = "", await u();
          }, (b.expires_in || 60) * 1e3);
        }
        return g;
      }
    });
    const u = async () => {
      const l = r.value[`${n.schemeKey}-clientId`] || "", d = r.value[`${n.schemeKey}-clientSecret`] || "";
      (!l || !d) && (r.value[`${n.schemeKey}-token`] = ""), i.value[n.schemeKey] = [{
        name: "Authorization",
        value: r.value[`${n.schemeKey}-token`] || "Bearer"
      }];
    }, s = /* @__PURE__ */ yg(() => {
      u();
    }, 100);
    return On(() => ({
      clientId: r.value[`${n.schemeKey}-clientId`],
      clientSecret: r.value[`${n.schemeKey}-clientSecret`]
    }), () => {
      s();
    }, { immediate: !0 }), (l, d) => (ke(), Qe("div", null, [
      Ft("div", Tte, [
        Sr(wo, {
          class: "param-label",
          for: `auth-input-oauth2-clientCredentials-clientId-${e.dataId}`
        }, {
          default: Xt(() => [
            d[4] || (d[4] = bn(" Client ID ", -1)),
            e.scheme.description ? (ke(), Mt(bu, {
              key: 0,
              id: `auth-tooltip-oauth2-clientCredentials-clientId-${e.dataId}`,
              text: e.scheme.description
            }, null, 8, ["id", "text"])) : Bt("", !0)
          ]),
          _: 1,
          __: [4]
        }, 8, ["for"]),
        zi(Ft("input", {
          id: `auth-input-oauth2-clientCredentials-clientId-${e.dataId}`,
          "onUpdate:modelValue": d[0] || (d[0] = (f) => jt(r)[`${e.schemeKey}-clientId`] = f),
          "aria-describedby": `auth-input-oauth2-clientCredentials-clientId-${e.dataId}`,
          autocomplete: "off",
          placeholder: "Enter Client ID",
          type: "text"
        }, null, 8, Pte), [
          [xs, jt(r)[`${e.schemeKey}-clientId`]]
        ])
      ]),
      Ft("div", Rte, [
        Sr(wo, {
          class: "param-label",
          for: `auth-input-oauth2-clientCredentials-secret-${e.dataId}`
        }, {
          default: Xt(() => [
            d[5] || (d[5] = bn(" Client Secret ", -1)),
            e.scheme.description ? (ke(), Mt(bu, {
              key: 0,
              id: `auth-tooltip-oauth2-clientCredentials-secret-${e.dataId}`,
              text: e.scheme.description
            }, null, 8, ["id", "text"])) : Bt("", !0)
          ]),
          _: 1,
          __: [5]
        }, 8, ["for"]),
        zi(Ft("input", {
          id: `auth-input-oauth2-clientCredentials-secret-${e.dataId}`,
          "onUpdate:modelValue": d[1] || (d[1] = (f) => jt(r)[`${e.schemeKey}-clientSecret`] = f),
          "aria-describedby": `auth-input-oauth2-clientCredentials-secret-${e.dataId}`,
          autocomplete: "off",
          placeholder: "Enter Client Secret",
          type: "password"
        }, null, 8, Ite), [
          [xs, jt(r)[`${e.schemeKey}-clientSecret`]]
        ])
      ]),
      e.scheme.flows.clientCredentials?.scopes && Object.keys(e.scheme.flows.clientCredentials.scopes).length ? (ke(), Qe("div", jte, [
        Ft("div", qte, [
          Sr(wo, {
            class: "param-label",
            for: `auth-input-oauth2-clientCredentials-secret-${e.dataId}`
          }, {
            default: Xt(() => d[6] || (d[6] = [
              bn(" Scopes ", -1)
            ])),
            _: 1,
            __: [6]
          }, 8, ["for"]),
          Ft("div", null, [
            Ft("button", {
              "aria-label": `Select all scopes for ${e.schemeKey}`,
              type: "button",
              onClick: d[2] || (d[2] = (f) => o(!0))
            }, " Select all ", 8, Dte),
            Ft("button", {
              "aria-label": `Deselect all scopes for ${e.schemeKey}`,
              type: "button",
              onClick: d[3] || (d[3] = (f) => o(!1))
            }, " Deselect all ", 8, $te)
          ])
        ]),
        (ke(!0), Qe(Mn, null, ii(e.scheme.flows.clientCredentials.scopes, (f, p) => (ke(), Qe("div", {
          key: f,
          class: "scope-wrapper"
        }, [
          zi(Ft("input", {
            id: `auth-input-oauth2-clientCredentials-scope-${p}-${e.dataId}`,
            "onUpdate:modelValue": (g) => jt(r)[`${e.schemeKey}-scope-${p}`] = g,
            "aria-describedby": `auth-input-oauth2-clientCredentials-scope-${p}-${e.dataId}`,
            autocomplete: "off",
            type: "checkbox",
            onChange: a
          }, null, 40, Lte), [
            [BD, jt(r)[`${e.schemeKey}-scope-${p}`]]
          ]),
          Ft("label", {
            for: `auth-input-oauth2-clientCredentials-scope-${p}-${e.dataId}`
          }, [
            Ft("span", Fte, cn(p), 1),
            bn(" - " + cn(f), 1)
          ], 8, Nte)
        ]))), 128))
      ])) : Bt("", !0)
    ]));
  }
}), Bte = /* @__PURE__ */ pn(Mte, [["__scopeId", "data-v-cb37bb2b"]]), Ute = { key: 0 }, Hte = { class: "param-wrapper" }, zte = ["id", "onUpdate:modelValue", "aria-describedby"], Vte = { class: "param-wrapper" }, Gte = ["id", "onUpdate:modelValue", "aria-describedby"], Wte = { key: 1 }, Kte = { class: "param-wrapper" }, Zte = ["id", "onUpdate:modelValue", "aria-describedby"], Yte = { key: 3 }, Jte = { class: "param-wrapper" }, Qte = ["id", "onUpdate:modelValue", "aria-describedby"], Xte = /* @__PURE__ */ ir({
  __name: "TryItAuth",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  emits: ["security-scheme-changed"],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = ja("auth2ComponentTemplate");
    t({
      auth2ClientCredentialsAuth: async () => i.value?.[0]?.auth2ClientCredentialsAuth ? await i.value[0].auth2ClientCredentialsAuth() : { ok: !0 }
    });
    const o = n, { activeSecurityScheme: c, authHeadersMap: u, authQueryMap: s, authInputs: l } = qi.useAuth(), d = Xa("security-scheme-group-list", Ye(() => [])), f = Ye(() => d.value.map((y) => ({
      label: y.title,
      value: y.key,
      key: y.key
    }))), p = Br(r.data.security?.[0]?.[0]?.key || ""), g = Br({}), b = /* @__PURE__ */ yg(() => {
      const y = (v, _, E, O) => {
        O === "query" ? s.value[v] = `${_}=${E}` : u.value[v] = [{ name: _, value: E }];
      };
      for (const [v, _] of Object.entries(g.value)) {
        const E = _.in;
        if (_.type === "oauth2" && _.flows.clientCredentials)
          return;
        if (_.type === "http" && _.scheme === "basic") {
          const O = l.value[`${v}-username`] || "", M = l.value[`${v}-password`] || "", L = btoa(`${O}:${M}`);
          y(v, "Authorization", `Basic ${L}`, E);
        } else if (_.type === "http" && _.scheme === "bearer") {
          const O = l.value[`${v}-token`] || "";
          y(v, "Authorization", `Bearer ${O}`, E);
        } else {
          const O = l.value[`${v}-token`] || "";
          y(v, _.name || "Authorization", O, E);
        }
      }
    }, 100), w = (y, v) => y.name || y.bearerFormat || v || "Access Token";
    return On(l, () => {
      b();
    }, { immediate: !0, deep: !0 }), On(p, (y) => {
      c.value = y, o("security-scheme-changed", y), b();
    }), On(() => ({ key: c.value, list: d.value }), () => {
      const y = {};
      if ((d.value.find((_) => _.key === c.value)?.schemeList ?? []).forEach((_) => {
        y[_.key] = _;
      }), Object.keys(y).length > 0) {
        g.value = y, p.value = c.value;
        return;
      }
      Object.keys(g.value).length == 0 && ((d.value.find((E) => E.key === p.value)?.schemeList ?? []).forEach((E) => {
        y[E.key] = E;
      }), g.value = y);
    }, { immediate: !0 }), (y, v) => jt(d)?.length && e.data.path ? (ke(), Mt(g1, {
      key: 0,
      class: "try-it-auth",
      "data-testid": `tryit-auth-${e.data.id}`
    }, {
      header: Xt(() => [
        Sr(jt(wO), {
          color: jt(TO),
          size: 20
        }, null, 8, ["color"]),
        v[1] || (v[1] = Ft("h3", null, " Authentication ", -1)),
        f.value.length > 1 ? (ke(), Mt(ma, {
          key: 0,
          id: `tryit-scheme-selector-${e.data.id}`,
          modelValue: p.value,
          "onUpdate:modelValue": v[0] || (v[0] = (_) => p.value = _),
          class: "scheme-selector",
          items: f.value,
          placement: "bottom-end"
        }, null, 8, ["id", "modelValue", "items"])) : Bt("", !0)
      ]),
      default: Xt(() => [
        (ke(!0), Qe(Mn, null, ii(g.value, (_, E) => (ke(), Qe("div", {
          key: _.id,
          class: "wide"
        }, [
          _.type === "http" && _.scheme === "basic" ? (ke(), Qe("div", Ute, [
            Ft("div", Hte, [
              Sr(wo, {
                class: "param-label",
                for: `auth-token-input-basic-username-${e.data.id}`
              }, {
                default: Xt(() => [
                  v[2] || (v[2] = bn(" Username ", -1)),
                  _.description ? (ke(), Mt(bu, {
                    key: 0,
                    id: `auth-token-tooltip-basic-username-${e.data.id}`,
                    text: _.description
                  }, null, 8, ["id", "text"])) : Bt("", !0)
                ]),
                _: 2,
                __: [2]
              }, 1032, ["for"]),
              zi(Ft("input", {
                id: `auth-token-input-basic-username-${e.data.id}`,
                "onUpdate:modelValue": (O) => jt(l)[`${E}-username`] = O,
                "aria-describedby": `auth-token-tooltip-basic-username-${e.data.id}`,
                autocomplete: "off",
                placeholder: "Enter Username",
                type: "text"
              }, null, 8, zte), [
                [xs, jt(l)[`${E}-username`]]
              ])
            ]),
            Ft("div", Vte, [
              Sr(wo, {
                class: "param-label",
                for: `auth-token-input-basic-password-${e.data.id}`
              }, {
                default: Xt(() => [
                  v[3] || (v[3] = bn(" Password ", -1)),
                  _.description ? (ke(), Mt(bu, {
                    key: 0,
                    id: `auth-token-tooltip-basic-password-${e.data.id}`,
                    text: _.description
                  }, null, 8, ["id", "text"])) : Bt("", !0)
                ]),
                _: 2,
                __: [3]
              }, 1032, ["for"]),
              zi(Ft("input", {
                id: `auth-token-input-basic-password-${e.data.id}`,
                "onUpdate:modelValue": (O) => jt(l)[`${E}-password`] = O,
                "aria-describedby": `auth-token-tooltip-basic-password-${e.data.id}`,
                autocomplete: "off",
                placeholder: "Enter Password",
                type: "password"
              }, null, 8, Gte), [
                [xs, jt(l)[`${E}-password`]]
              ])
            ])
          ])) : _.type === "http" && _.scheme === "bearer" ? (ke(), Qe("div", Wte, [
            Ft("div", Kte, [
              Sr(wo, {
                class: "param-label",
                for: `auth-token-input-bearer-token-${e.data.id}`
              }, {
                default: Xt(() => [
                  v[4] || (v[4] = bn(" JWT token ", -1)),
                  _.description ? (ke(), Mt(bu, {
                    key: 0,
                    id: `auth-token-tooltip-bearer-token-${e.data.id}`,
                    text: _.description
                  }, null, 8, ["id", "text"])) : Bt("", !0)
                ]),
                _: 2,
                __: [4]
              }, 1032, ["for"]),
              zi(Ft("input", {
                id: `auth-token-input-bearer-token-${e.data.id}`,
                "onUpdate:modelValue": (O) => jt(l)[`${E}-token`] = O,
                "aria-describedby": `auth-token-tooltip-bearer-token-${e.data.id}`,
                autocomplete: "off",
                placeholder: "Enter JWT token",
                type: "password"
              }, null, 8, Zte), [
                [xs, jt(l)[`${E}-token`]]
              ])
            ])
          ])) : _.type === "oauth2" && _.flows.clientCredentials ? (ke(), Mt(Bte, {
            key: 2,
            ref_for: !0,
            ref: "auth2ComponentTemplate",
            "data-id": e.data.id,
            scheme: _,
            "scheme-key": E
          }, null, 8, ["data-id", "scheme", "scheme-key"])) : (ke(), Qe("div", Yte, [
            Ft("div", Jte, [
              Sr(wo, {
                class: "param-label",
                for: `auth-token-input-${w(_)}-${e.data.id}`
              }, {
                default: Xt(() => [
                  bn(cn(w(_)) + " ", 1),
                  _.description ? (ke(), Mt(bu, {
                    key: 0,
                    id: `auth-token-tooltip-${w(_)}-${e.data.id}`,
                    text: _.description
                  }, null, 8, ["id", "text"])) : Bt("", !0)
                ]),
                _: 2
              }, 1032, ["for"]),
              zi(Ft("input", {
                id: `auth-token-input-${w(_)}-${e.data.id}`,
                "onUpdate:modelValue": (O) => jt(l)[`${E}-token`] = O,
                "aria-describedby": `auth-token-tooltip-${w(_)}-${e.data.id}`,
                autocomplete: "off",
                placeholder: "App credential",
                type: "password"
              }, null, 8, Qte), [
                [xs, jt(l)[`${E}-token`]]
              ])
            ])
          ]))
        ]))), 128))
      ]),
      _: 1
    }, 8, ["data-testid"])) : Bt("", !0);
  }
}), ere = /* @__PURE__ */ pn(Xte, [["__scopeId", "data-v-47c0bbd8"]]), tre = /* @__PURE__ */ ir({
  __name: "CodeBlock",
  props: {
    code: {
      type: String,
      required: !0
    },
    lang: {
      type: String,
      default: ""
    },
    isError: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { highlighter: n } = qi.useShiki(), r = (o) => Xu.find((c) => c.httpSnippetLanguage === o)?.highlightLanguage, i = Ye(() => {
      if (t.isError)
        return `<div class='error'>${t.code}</div>`;
      if (n.value && t.lang) {
        const o = r(t.lang);
        return n.value.codeToHtml(t.code, {
          lang: o,
          themes: {
            light: "catppuccin-latte",
            dark: "catppuccin-mocha"
          },
          colorReplacements: {
            "catppuccin-latte": {
              // Always use the neutral weakest token, fallback to **light** background
              "#eff1f5": `var(--kui-color-background-neutral-weakest, ${NJ})`
            },
            "catppuccin-mocha": {
              // Always use the neutral weakest token, fallback to **dark** background
              "#1e1e2e": `var(--kui-color-background-neutral-weakest, ${LJ})`
            }
          }
        });
      }
      return "";
    }), a = () => vC("div", { class: "code-block", innerHTML: i.value });
    return (o, c) => (ke(), Qe("div", null, [
      Sr(a)
    ]));
  }
}), Df = /* @__PURE__ */ pn(tre, [["__scopeId", "data-v-89d77d09"]]), rre = /* @__PURE__ */ ir({
  __name: "EditableCodeBlock",
  props: {
    code: {
      type: String,
      required: !0
    },
    lang: {
      type: String,
      default: ""
    }
  },
  emits: ["request-body-changed"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = Br(!1), a = (g, b) => {
      let w = g;
      if (i.value = !1, b === "json")
        try {
          w = JSON.stringify(JSON.parse(g), null, ns);
        } catch {
          i.value = !0;
        }
      return w;
    }, o = ja("editableInput"), c = Br(a(n.code, n.lang)), u = Br(n.code), s = Br(0), l = (g, b) => {
      if (typeof window > "u" || !o.value || !o.value.childNodes[0])
        return;
      const w = window.getSelection(), y = document.createRange();
      let v = 0, _ = g;
      for (let E = 0; E < o.value.childNodes.length; E++) {
        const O = (o.value.childNodes[E]?.textContent || "").length;
        if (_ - O <= 0)
          break;
        v++, _ -= O, o.value.childNodes[E]?.nodeName === "BR" && _--;
      }
      o.value.childNodes[v] && (_ = o.value.childNodes[v].textContent?.length || 0, y.setStart(o.value.childNodes[v], _), y.collapse(!0), w?.removeAllRanges(), w?.addRange(y), o.value.focus());
    }, d = () => {
      if (typeof window > "u" || !o.value)
        return 0;
      const g = window.getSelection();
      if (!g)
        return 0;
      const b = o.value.innerText.split(""), w = g.rangeCount > 0 ? g?.getRangeAt(0) : null;
      if (w) {
        const y = w?.cloneRange();
        y?.selectNodeContents(o.value), y?.setEnd(w.endContainer, w?.endOffset);
        let v = y.toString();
        const _ = v.split("");
        let E = v.length, O = 0;
        for (let M = 0; M < _.length; M++)
          _[M] !== `
` && b[O] === `
` && (O++, E++), O++;
        return g.anchorOffset === 0 && b[O] === `
` && E++, E;
      }
      return 0;
    }, f = (g) => {
      let b = g.target.innerText;
      if (g.inputType === "insertParagraph") {
        if (s.value = d(), s.value > 1 && u.value) {
          const y = u.value.split(`
`);
          let v = "", _ = 0, E = 0;
          do
            _ += y[E].length + 1, _ >= s.value && (v = y[E]), E++;
          while (v === "" && E <= y.length - 1);
          if (v) {
            let O = v.replace(/[^\s].*/, "").length;
            (v.endsWith("{") || v.endsWith("[")) && (O += ns), O > 0 && (b = b.substring(0, s.value) + Array(O + 1).join(" ") + b.substring(s.value), o.value && (o.value.innerText = b), u.value = b, l(s.value));
          }
        }
        u.value = b;
        return;
      }
      if (g.inputType === "deleteContentBackward") {
        u.value = b;
        return;
      }
      i.value = !1;
      let w = a(b, n.lang);
      u.value = w, s.value = d(), r("request-body-changed", w);
    }, p = (g) => {
      i.value = !1;
      const b = g.target.innerText;
      let w = a(b, n.lang);
      c.value = w, o.value && (o.value.innerText = c.value), u.value = w, r("request-body-changed", w);
    };
    return On(
      () => ({ code: n.code, lang: n.lang, editableInput: o.value }),
      ({ code: g, lang: b, editableInput: w }) => {
        g !== w?.innerText && (c.value = a(g, b), u.value = c.value, w && (w.innerText = c.value, s.value !== 0 && l(s.value)));
      }
    ), (g, b) => (ke(), Qe("div", {
      class: Un(["editable-code-wrapper", { "error-wrapper": i.value }])
    }, [
      Sr(Df, {
        code: u.value || "",
        lang: e.lang
      }, null, 8, ["code", "lang"]),
      b[0] || (qy(-1, !0), (b[0] = Ft("div", {
        ref: "editableInput",
        class: "editable-code",
        contenteditable: "plaintext-only",
        spellcheck: "false",
        onFocusout: p,
        onInput: f
      }, [
        bn(cn(c.value), 1)
      ], 544)).cacheIndex = 0, qy(1), b[0])
    ], 2));
  }
}), nre = /* @__PURE__ */ pn(rre, [["__scopeId", "data-v-b0bbe692"]]), ire = { class: "switch-control-wrapper" }, are = /* @__PURE__ */ ir({
  inheritAttrs: !1,
  __name: "ToggleSwitch",
  props: /* @__PURE__ */ eo({
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ eo(["change", "input"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = t, i = R0(), a = Ye(() => {
      const f = { ...i };
      return delete f.id, f;
    }), o = Ye(() => ({
      disabled: n.disabled,
      checked: u.value,
      ...!!i.id && { id: String(i.id) }
    })), c = Ye(() => ({
      "aria-checked": u.value,
      tabindex: n.disabled ? -1 : 0,
      ...!!i.id && { "aria-labelledby": String(i.id) }
    })), u = bc(e, "modelValue"), s = ja("switchInput"), l = (f) => {
      n.disabled || (f.type === "click" || f.type === "keyup" && f.code === "Space") && s.value?.click();
    }, d = (f) => {
      u.value !== f.target.checked && (u.value = f.target.checked, r("change", f.target.checked), r("input", f.target.checked));
    };
    return (f, p) => (ke(), Qe("div", $i({
      class: ["toggle-switch", { disabled: e.disabled }]
    }, a.value), [
      Ft("input", $i({
        ref: "switchInput",
        hidden: "",
        tabindex: "-1",
        type: "checkbox"
      }, o.value, { onInput: d }), null, 16),
      Ft("div", ire, [
        Ft("span", $i({
          class: ["switch-control", { checked: u.value, disabled: e.disabled }],
          "data-testid": "switch-control",
          role: "checkbox"
        }, c.value, {
          onClick: l,
          onKeydown: p[0] || (p[0] = Dy($f(() => {
          }, ["prevent"]), ["space"])),
          onKeyup: Dy(l, ["space"])
        }), p[1] || (p[1] = [
          Ft("span", { class: "switch-control-enabled-bar" }, null, -1)
        ]), 16)
      ]),
      e.label || f.$slots.label ? (ke(), Mt(wo, I0($i({ key: 0 }, jt(i).id ? { for: String(jt(i).id) } : {})), {
        default: Xt(() => [
          bn(cn(e.label), 1)
        ]),
        _: 1
      }, 16)) : Bt("", !0)
    ], 16));
  }
}), ore = /* @__PURE__ */ pn(are, [["__scopeId", "data-v-6ae991ef"]]), sre = {
  key: 0,
  class: "wide required-only-wrapper"
}, ure = /* @__PURE__ */ ir({
  __name: "RequiredToggle",
  props: /* @__PURE__ */ eo({
    data: {
      type: Object,
      required: !0
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = bc(e, "modelValue"), r = Ye(() => {
      if (!t.data.request?.body?.contents?.length || !t.data.request.body.contents[0] || t.data?.request?.body?.contents && t.data.request.body.contents.length && Array.isArray(t.data.request.body.contents[0].examples) && t.data.request.body.contents[0].examples.length)
        return !1;
      const i = (a, o, c) => {
        if (c > vE || !a || Object.keys(a).length < 1)
          return !1;
        if (a.required && a.required.length > 0)
          return !0;
        let u = !1;
        return Object.keys(a.properties || {}).forEach((s) => {
          const l = a.properties[s];
          l.anyOf && Array.isArray(l.anyOf) && l.anyOf.length ? u = i(l.anyOf[0] || {}, s, c) : l.type === "object" || l.allOf ? u = i(l || {}, s, ++c) : u = i(a.properties[s], s, c);
        }), u;
      };
      return i(t.data.request.body.contents[0].schema, "", 0);
    });
    return On(r, (i) => {
      i === !1 && (n.value = !1);
    }, { immediate: !0 }), (i, a) => r.value ? (ke(), Qe("div", sre, [
      Sr(wo, {
        for: `required-toggle-switch-${e.data.id}`
      }, {
        default: Xt(() => a[1] || (a[1] = [
          bn(" Show only required parameters ", -1)
        ])),
        _: 1,
        __: [1]
      }, 8, ["for"]),
      Sr(ore, {
        id: `required-toggle-switch-${e.data.id}`,
        modelValue: n.value,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => n.value = o)
      }, null, 8, ["id", "modelValue"])
    ])) : Bt("", !0);
  }
}), VO = /* @__PURE__ */ pn(ure, [["__scopeId", "data-v-a8313dc3"]]), cre = {
  key: 0,
  class: "wide"
}, lre = {
  key: 0,
  class: "required-label"
}, fre = ["id", "onUpdate:modelValue", "aria-describedby", "data-testid"], pre = {
  key: 1,
  class: "wide body-param"
}, dre = { key: 2 }, hre = {
  key: 0,
  class: "choose-file-text"
}, mre = {
  key: 1,
  class: "choose-file-text"
}, gre = /* @__PURE__ */ ir({
  __name: "TryItParams",
  props: /* @__PURE__ */ eo({
    data: {
      type: Object,
      required: !0
    },
    paramType: {
      type: String,
      required: !0
    },
    /* coming as a property when request sample is picked in RequestSample */
    requestBody: {
      type: Object,
      default: () => ({ text: "" })
    },
    /** list of headers to exclude from TryIt */
    excludeHeaderList: {
      type: Array,
      default: () => []
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ eo(["request-path-changed", "request-query-changed", "request-headers-changed", "request-body-changed"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = bc(e, "modelValue"), i = t, a = {
      path: "Path Parameters",
      query: "Query Parameters",
      body: "Body",
      headers: "Headers"
    }, { files: o, open: c, onChange: u } = IJ({
      accept: n.requestBody?.acceptedExt,
      directory: !1,
      reset: !0,
      multiple: !1
    });
    u((p) => {
      i("request-body-changed", { isBinary: !0, content: p });
    });
    const s = Ye(() => {
      if (n.paramType === "query")
        return n.data.request?.query?.reduce((p, g) => (p[g.name] = g, p), {});
      if (n.paramType === "path")
        return n.data.request?.path?.reduce((p, g) => (p[g.name] = g, p), {});
      if (n.paramType === "headers")
        return n.data.request?.headers?.reduce((p, g) => (n.excludeHeaderList.includes(g.name) || (p[g.name] = g), p), {});
      if (n.paramType === "body") {
        if (n.requestBody.isBinary)
          return { body: {} };
        if (n.requestBody.content)
          return { body: { example: n.requestBody.content } };
      }
      return {};
    }), l = Br({}), d = Ye(() => n.paramType !== "body" ? "" : l.value.body);
    On(s, (p) => {
      if (p) {
        const g = Q2(p);
        Object.keys(p).forEach((b) => {
          l.value[b] = Object.keys(l.value).includes(b) ? l.value[b] : g[b];
        });
      }
    }, { immediate: !0 });
    const f = (p) => {
      p && i("request-body-changed", { isBinary: !1, content: p });
    };
    return On(l, (p) => {
      if (n.paramType === "path") {
        i("request-path-changed", X2(n.data, p));
        return;
      }
      n.paramType === "query" && i("request-query-changed", eg(n.data, p)), n.paramType === "headers" && i("request-headers-changed", tg({ data: n.data, fieldValues: p, excludeHeaderList: n.excludeHeaderList }));
    }, { deep: !0 }), (p, g) => zi((ke(), Mt(g1, {
      class: "try-it-params",
      "content-to-copy": d.value,
      "data-testid": `tryit-params-${e.paramType}-${e.data.id}`,
      "start-collapsed": e.paramType !== "body"
    }, {
      header: Xt(() => [
        Ft("h3", null, cn(a[n.paramType]), 1)
      ]),
      default: Xt(() => [
        e.paramType !== "body" && s.value && Object.keys(s.value).length ? (ke(), Qe("div", cre, [
          (ke(!0), Qe(Mn, null, ii(Object.keys(s.value), (b) => (ke(), Qe("div", {
            key: `${s.value[b].name}${e.paramType}`,
            class: "param-wrapper"
          }, [
            Sr(wo, {
              class: "param-label",
              for: `request-${e.paramType}-input-${s.value[b].name || b}-${e.data.id}`
            }, {
              default: Xt(() => [
                s.value[b].required ? (ke(), Qe("div", lre, " * ")) : Bt("", !0),
                bn(" " + cn(s.value[b].name || b) + " ", 1),
                s.value[b].description ? (ke(), Mt(bu, {
                  key: 1,
                  id: `request-${e.paramType}-tooltip-${s.value[b].name || b}-${e.data.id}`
                }, {
                  content: Xt(() => [
                    Sr(ss, {
                      markdown: s.value[b].description
                    }, null, 8, ["markdown"])
                  ]),
                  _: 2
                }, 1032, ["id"])) : Bt("", !0)
              ]),
              _: 2
            }, 1032, ["for"]),
            zi(Ft("input", {
              id: `request-${e.paramType}-input-${s.value[b].name || b}-${e.data.id}`,
              "onUpdate:modelValue": (w) => l.value[b] = w,
              "aria-describedby": `request-${e.paramType}-tooltip-${s.value[b].name || b}-${e.data.id}`,
              autocomplete: "off",
              "data-testid": `tryit-${e.paramType}-param-${b}-${e.data.id}`,
              type: "text"
            }, null, 8, fre), [
              [xs, l.value[b]]
            ])
          ]))), 128))
        ])) : Bt("", !0),
        e.paramType === "body" && s.value && Object.keys(s.value).length ? (ke(), Qe("div", pre, [
          e.requestBody.isBinary ? Bt("", !0) : (ke(), Mt(VO, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": g[0] || (g[0] = (b) => r.value = b),
            class: "required-fields-toggle",
            data: e.data
          }, null, 8, ["modelValue", "data"])),
          e.requestBody.isBinary ? (ke(), Qe("div", dre, [
            Ft("button", {
              class: "choose-file-btn",
              type: "button",
              onClick: g[1] || (g[1] = (b) => jt(c)())
            }, " Choose file "),
            jt(o) ? Bt("", !0) : (ke(), Qe("span", hre, "No file selected")),
            jt(o) && jt(o).length > 0 ? (ke(), Qe("span", mre, cn(jt(o)[0].name), 1)) : Bt("", !0)
          ])) : (ke(), Mt(nre, {
            key: 1,
            class: "body-param-code-block",
            code: l.value.body,
            lang: "json",
            onRequestBodyChanged: f
          }, null, 8, ["code"]))
        ])) : Bt("", !0)
      ]),
      _: 1
    }, 8, ["content-to-copy", "data-testid", "start-collapsed"])), [
      [yf, s.value && Object.keys(s.value).length]
    ]);
  }
}), qd = /* @__PURE__ */ pn(gre, [["__scopeId", "data-v-03b1ae22"]]), vre = { class: "h-wrapper" }, yre = { key: 0 }, bre = {
  key: 0,
  class: "wide"
}, xre = {
  key: 1,
  class: "wide"
}, _re = { class: "error-panel" }, wre = {
  key: 0,
  class: "cors-error"
}, Sre = {
  key: 2,
  class: "wide"
}, Cre = /* @__PURE__ */ ir({
  __name: "TryItResponse",
  props: {
    dataId: {
      type: String,
      required: !0
    },
    response: {
      type: Object,
      default: () => {
      }
    },
    responseError: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    const t = e, n = Ye(() => t.responseError?.message || ""), r = Ye(() => {
      const l = {};
      if (t.response)
        for (const d of t.response.headers.entries())
          l[d[0]] = d[1];
      return Object.keys(l).length ? JSON.stringify(l, null, ns) : "";
    }), i = Br(""), a = Ye(() => {
      const l = [];
      return i.value && l.push({ value: "body", label: "Result" }), r.value && l.push({ value: "headers", label: "Headers" }), n.value && l.push({ value: "error", label: "Error" }), l;
    }), o = Ye(() => t.response.headers.get("content-type")?.includes("image") ?? !1), c = Ye(() => o.value ? {
      component: "img",
      props: {
        src: i.value,
        alt: "response image",
        width: "300px"
      }
    } : {
      component: Df,
      props: {
        code: i.value,
        lang: s.value,
        class: "response-body"
      }
    }), u = Br();
    On(a, (l) => {
      l.length && (u.value = l[0].value);
    }, { immediate: !0 });
    const s = Br("");
    return On(() => t.response, async (l) => {
      if (l)
        if (l.headers.get("content-type")?.includes("/json"))
          i.value = JSON.stringify(await l.json(), null, ns), s.value = "json";
        else if (o.value) {
          const d = await l.blob();
          i.value = URL.createObjectURL(d);
        } else
          i.value = await l.text(), s.value = "text";
      else
        i.value = "", s.value = "";
    }, { immediate: !0 }), (l, d) => (ke(), Mt(g1, {
      collapsible: !1,
      "data-testid": `tryit-response-${e.dataId}`
    }, {
      header: Xt(() => [
        Ft("div", vre, [
          Ft("h3", null, [
            e.response?.status ? Bt("", !0) : (ke(), Qe("span", yre, " Response ")),
            e.response?.status ? (ke(), Qe("span", {
              key: 1,
              class: Un(`response-status ${e.response?.ok}`)
            }, cn(e.response?.status), 3)) : Bt("", !0)
          ])
        ]),
        Sr(ma, {
          id: `response-option-select-${e.dataId}`,
          modelValue: u.value,
          "onUpdate:modelValue": d[0] || (d[0] = (f) => u.value = f),
          class: "res-option-selector",
          items: a.value,
          placement: "bottom-end"
        }, null, 8, ["id", "modelValue", "items"])
      ]),
      default: Xt(() => [
        i.value && u.value === "body" ? (ke(), Qe("div", bre, [
          (ke(), Mt(Sn(c.value.component), I0(UD(c.value.props)), null, 16))
        ])) : Bt("", !0),
        n.value && u.value === "error" ? (ke(), Qe("div", xre, [
          Ft("div", _re, [
            bn(cn(n.value) + " ", 1),
            e.response ? Bt("", !0) : (ke(), Qe("div", wre, " Make sure CORS is enabled for the server. "))
          ])
        ])) : Bt("", !0),
        r.value && u.value === "headers" ? (ke(), Qe("div", Sre, [
          Sr(Df, {
            code: r.value,
            lang: "json"
          }, null, 8, ["code"])
        ])) : Bt("", !0)
      ]),
      _: 1
    }, 8, ["data-testid"]));
  }
}), kre = /* @__PURE__ */ pn(Cre, [["__scopeId", "data-v-f1097a03"]]), Are = ["data-testid"], Ere = { class: "method-path" }, Ore = { class: "path" }, Tre = {
  key: 0,
  class: "tryit-body"
}, Pre = /* @__PURE__ */ ir({
  __name: "TryIt",
  props: /* @__PURE__ */ eo({
    data: {
      type: Object,
      required: !0
    },
    serverUrl: {
      type: String,
      required: !0
    },
    requestBody: {
      type: Object,
      default: () => ({ text: "" })
    },
    /* headers generated by auth token changes in TryItAuth */
    authHeaders: {
      type: Array,
      default: () => []
    },
    /* query portion generated by auth token changes in TryItAuth */
    authQuery: {
      type: String,
      default: ""
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ eo(["request-path-changed", "request-query-changed", "request-headers-changed", "request-body-changed", "security-scheme-changed"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = ja("auth2ComponentTemplate"), i = bc(e, "modelValue"), a = t, o = (Q) => {
      a("security-scheme-changed", Q);
    }, c = Ye(() => n.authHeaders.map(({ name: Q }) => Q) ?? []), u = Br(), s = Br(), l = Br(n.serverUrl), d = Br(""), f = Br(""), p = Br([]), g = Br({ isBinary: !1, content: "" }), b = Br(!1), w = Ye(
      () => (!n.data.servers || !n.data.servers.some((Q) => Q.variables)) && (!n.data.request?.query || !n.data.request?.query.length) && (!n.data.request?.path || !n.data.request?.path.length) && (!n.data.request?.headers || !n.data.request?.headers.length) && !n.data.security?.length && !g.value && !u.value && !s.value
    ), y = (Q) => {
      d.value = Q, a("request-path-changed", Q);
    }, v = (Q) => {
      f.value = Q, a("request-query-changed", Q);
    }, _ = (Q) => {
      p.value = Q, a("request-headers-changed", Q);
    }, E = (Q) => {
      g.value = Q, a("request-body-changed", Q);
    }, O = Xa("hide-tryit", Br(!1)), M = (Q) => new Promise((ae, re) => {
      const X = new FileReader();
      X.onload = (de) => {
        ae(de.target?.result);
      }, X.onerror = (de) => {
        re(de);
      }, X.readAsArrayBuffer(Q);
    }), L = async (Q = !1) => {
      const ae = n.data.method.toUpperCase() === "GET";
      if (r.value && r.value.auth2ClientCredentialsAuth)
        try {
          const re = await r.value.auth2ClientCredentialsAuth();
          if (re && !re.ok)
            throw u.value = re, new Error(`Error: ${re.status} ${re.statusText}`);
        } catch (re) {
          s.value = re, b.value = !1;
          return;
        }
      try {
        b.value = !0;
        const re = new URL(`${l.value}${d.value}`.replaceAll("{", "").replaceAll("}", ""));
        let X = f.value;
        re.search = X;
        const de = [
          ...IE(n.data),
          ...p.value,
          ...n.authHeaders || []
        ].reduce((De, je) => (De[Q === !1 && ae ? je.name.toLowerCase() : je.name] = je.value, De), {});
        let { body: Ce } = jE(de, g.value), J = null;
        try {
          if (g.value.isBinary && g.value.content && g.value.content?.length > 0) {
            const De = g.value.content[0];
            J = new Uint8Array(await M(De));
          }
        } catch (De) {
          s.value = De, b.value = !1;
          return;
        }
        Q === !1 && ae && de["content-type"] && delete de["content-type"], n.authQuery && (X += (f.value ? "&" : "?") + n.authQuery);
        const ne = await fetch(re.href, {
          method: String(n.data.method).toUpperCase(),
          headers: de,
          ...Ce || J ? { body: Ce || J } : null
        });
        u.value = ne;
      } catch (re) {
        if (!Q && ae) {
          L(!0);
          return;
        }
        s.value = re;
      } finally {
        b.value = !1;
      }
    }, Z = Ye(() => {
      const Q = Array.isArray(n.data.servers) && n.data.servers.length > 0;
      return !O.value && (!!n.serverUrl || Q);
    });
    return On(() => n.serverUrl, () => {
      l.value = n.serverUrl;
    }), On(() => n.requestBody, (Q) => {
      g.value = Q;
    }, { immediate: !0 }), On(() => n.data.id, () => {
      d.value = X2(n.data), f.value = eg(n.data), p.value = tg({ data: n.data, excludeHeaderList: c.value }), u.value = void 0, s.value = void 0;
    }, { immediate: !0 }), (Q, ae) => Z.value ? (ke(), Qe("div", {
      key: 0,
      class: "tryit-wrapper",
      "data-testid": `tryit-wrapper-${e.data.id}`
    }, [
      Ft("div", {
        class: Un(["tryit-header", { "no-body": w.value }])
      }, [
        Ft("div", Ere, [
          Sr(s1, {
            method: e.data.method,
            size: "small"
          }, null, 8, ["method"]),
          Ft("span", Ore, cn(e.data.path), 1)
        ]),
        e.data.path ? (ke(), Mt(_te, {
          key: 0,
          class: "tryit-button-dropdown",
          data: e.data,
          "is-loading": b.value,
          onTryitApiCall: L
        }, null, 8, ["data", "is-loading"])) : Bt("", !0)
      ], 2),
      w.value ? Bt("", !0) : (ke(), Qe("div", Tre, [
        Sr(ere, {
          ref: "auth2ComponentTemplate",
          data: e.data,
          onSecuritySchemeChanged: o
        }, null, 8, ["data"]),
        Sr(qd, {
          data: e.data,
          "param-type": "path",
          onRequestPathChanged: y
        }, null, 8, ["data"]),
        Sr(qd, {
          data: e.data,
          "param-type": "query",
          onRequestQueryChanged: v
        }, null, 8, ["data"]),
        Sr(qd, {
          data: e.data,
          "exclude-header-list": c.value,
          "param-type": "headers",
          onRequestHeadersChanged: _
        }, null, 8, ["data", "exclude-header-list"]),
        Sr(qd, {
          modelValue: i.value,
          "onUpdate:modelValue": ae[0] || (ae[0] = (re) => i.value = re),
          data: e.data,
          "param-type": "body",
          "request-body": g.value,
          onRequestBodyChanged: E
        }, null, 8, ["modelValue", "data", "request-body"]),
        u.value || s.value ? (ke(), Mt(kre, {
          key: 0,
          "data-id": e.data.id,
          response: u.value,
          "response-error": s.value
        }, null, 8, ["data-id", "response", "response-error"])) : Bt("", !0)
      ]))
    ], 8, Are)) : Bt("", !0);
  }
}), Rre = /* @__PURE__ */ pn(Pre, [["__scopeId", "data-v-e7b379b9"]]);
var _l = {}, Mo = {}, __;
function Pn() {
  if (__) return Mo;
  __ = 1;
  var e = Mo && Mo.__read || function(a, o) {
    var c = typeof Symbol == "function" && a[Symbol.iterator];
    if (!c) return a;
    var u = c.call(a), s, l = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(s = u.next()).done; ) l.push(s.value);
    } catch (f) {
      d = { error: f };
    } finally {
      try {
        s && !s.done && (c = u.return) && c.call(u);
      } finally {
        if (d) throw d.error;
      }
    }
    return l;
  }, t = Mo && Mo.__spreadArray || function(a, o, c) {
    if (c || arguments.length === 2) for (var u = 0, s = o.length, l; u < s; u++)
      (l || !(u in o)) && (l || (l = Array.prototype.slice.call(o, 0, u)), l[u] = o[u]);
    return a.concat(l || Array.prototype.slice.call(o));
  };
  Mo.__esModule = !0, Mo.CodeBuilder = void 0;
  var n = "", r = `
`, i = (
    /** @class */
    /* @__PURE__ */ (function() {
      function a(o) {
        var c = o === void 0 ? {} : o, u = c.indent, s = c.join, l = this;
        this.postProcessors = [], this.code = [], this.indentationCharacter = n, this.lineJoin = r, this.indentLine = function(d, f) {
          f === void 0 && (f = 0);
          var p = l.indentationCharacter.repeat(f);
          return "".concat(p).concat(d);
        }, this.unshift = function(d, f) {
          var p = l.indentLine(d, f);
          l.code.unshift(p);
        }, this.push = function(d, f) {
          var p = l.indentLine(d, f);
          l.code.push(p);
        }, this.pushToLast = function(d) {
          l.code || l.push(d);
          var f = "".concat(l.code[l.code.length - 1]).concat(d);
          l.code[l.code.length - 1] = f;
        }, this.blank = function() {
          l.code.push("");
        }, this.join = function() {
          var d = l.code.join(l.lineJoin), f = l.postProcessors.reduce(function(p, g) {
            return g(p);
          }, d);
          return f;
        }, this.addPostProcessor = function(d) {
          l.postProcessors = t(t([], e(l.postProcessors), !1), [d], !1);
        }, this.indentationCharacter = u || n, this.lineJoin = s ?? r;
      }
      return a;
    })()
  );
  return Mo.CodeBuilder = i, Mo;
}
var fa = {}, w_;
function ei() {
  if (w_) return fa;
  w_ = 1;
  var e = fa && fa.__read || function(a, o) {
    var c = typeof Symbol == "function" && a[Symbol.iterator];
    if (!c) return a;
    var u = c.call(a), s, l = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(s = u.next()).done; ) l.push(s.value);
    } catch (f) {
      d = { error: f };
    } finally {
      try {
        s && !s.done && (c = u.return) && c.call(u);
      } finally {
        if (d) throw d.error;
      }
    }
    return l;
  }, t = fa && fa.__spreadArray || function(a, o, c) {
    if (c || arguments.length === 2) for (var u = 0, s = o.length, l; u < s; u++)
      (l || !(u in o)) && (l || (l = Array.prototype.slice.call(o, 0, u)), l[u] = o[u]);
    return a.concat(l || Array.prototype.slice.call(o));
  };
  fa.__esModule = !0, fa.escapeForDoubleQuotes = fa.escapeForSingleQuotes = fa.escapeString = void 0;
  function n(a, o) {
    o === void 0 && (o = {});
    var c = o.delimiter, u = c === void 0 ? '"' : c, s = o.escapeChar, l = s === void 0 ? "\\" : s, d = o.escapeNewlines, f = d === void 0 ? !0 : d, p = a.toString();
    return t([], e(p), !1).map(function(g) {
      return g === "\b" ? "".concat(l, "b") : g === "	" ? "".concat(l, "t") : g === `
` ? f ? "".concat(l, "n") : g : g === "\f" ? "".concat(l, "f") : g === "\r" ? f ? "".concat(l, "r") : g : g === l ? l + l : g === u ? l + u : g < " " || g > "~" ? JSON.stringify(g).slice(1, -1) : g;
    }).join("");
  }
  fa.escapeString = n;
  var r = function(a) {
    return n(a, { delimiter: "'" });
  };
  fa.escapeForSingleQuotes = r;
  var i = function(a) {
    return n(a, { delimiter: '"' });
  };
  return fa.escapeForDoubleQuotes = i, fa;
}
var n3 = {}, S_;
function Wi() {
  return S_ || (S_ = 1, (function(e) {
    e.__esModule = !0, e.isMimeTypeJSON = e.hasHeader = e.getHeader = e.getHeaderName = void 0;
    var t = function(o, c) {
      return Object.keys(o).find(function(u) {
        return u.toLowerCase() === c.toLowerCase();
      });
    };
    e.getHeaderName = t;
    var n = function(o, c) {
      var u = (0, e.getHeaderName)(o, c);
      if (u)
        return o[u];
    };
    e.getHeader = n;
    var r = function(o, c) {
      return !!(0, e.getHeaderName)(o, c);
    };
    e.hasHeader = r;
    var i = [
      "application/json",
      "application/x-json",
      "text/json",
      "text/x-json",
      "+json"
    ], a = function(o) {
      return i.some(function(c) {
        return o.includes(c);
      });
    };
    e.isMimeTypeJSON = a;
  })(n3)), n3;
}
var Bo = {}, i3 = {}, wl = {}, Sl = {}, C_;
function Ire() {
  if (C_) return Sl;
  C_ = 1, Sl.__esModule = !0, Sl.libcurl = void 0;
  var e = Pn(), t = ei();
  return Sl.libcurl = {
    info: {
      key: "libcurl",
      title: "Libcurl",
      link: "http://curl.haxx.se/libcurl",
      description: "Simple REST and HTTP API Client for C"
    },
    convert: function(n) {
      var r = n.method, i = n.fullUrl, a = n.headersObj, o = n.allHeaders, c = n.postData, u = new e.CodeBuilder(), s = u.push, l = u.blank, d = u.join;
      s("CURL *hnd = curl_easy_init();"), l(), s('curl_easy_setopt(hnd, CURLOPT_CUSTOMREQUEST, "'.concat(r.toUpperCase(), '");')), s('curl_easy_setopt(hnd, CURLOPT_URL, "'.concat(i, '");'));
      var f = Object.keys(a);
      return f.length && (l(), s("struct curl_slist *headers = NULL;"), f.forEach(function(p) {
        s('headers = curl_slist_append(headers, "'.concat(p, ": ").concat((0, t.escapeForDoubleQuotes)(a[p]), '");'));
      }), s("curl_easy_setopt(hnd, CURLOPT_HTTPHEADER, headers);")), o.cookie && (l(), s('curl_easy_setopt(hnd, CURLOPT_COOKIE, "'.concat(o.cookie, '");'))), c.text && (l(), s("curl_easy_setopt(hnd, CURLOPT_POSTFIELDS, ".concat(JSON.stringify(c.text), ");"))), l(), s("CURLcode ret = curl_easy_perform(hnd);"), d();
    }
  }, Sl;
}
var k_;
function jre() {
  if (k_) return wl;
  k_ = 1, wl.__esModule = !0, wl.c = void 0;
  var e = Ire();
  return wl.c = {
    info: {
      key: "c",
      title: "C",
      extname: ".c",
      default: "libcurl"
    },
    clientsById: {
      libcurl: e.libcurl
    }
  }, wl;
}
var Cl = {}, kl = {}, A_;
function qre() {
  if (A_) return kl;
  A_ = 1, kl.__esModule = !0, kl.clj_http = void 0;
  var e = Pn(), t = Wi(), n = (
    /** @class */
    /* @__PURE__ */ (function() {
      function s(l) {
        var d = this;
        this.name = "", this.toString = function() {
          return ":".concat(d.name);
        }, this.name = l;
      }
      return s;
    })()
  ), r = (
    /** @class */
    /* @__PURE__ */ (function() {
      function s(l) {
        var d = this;
        this.path = "", this.toString = function() {
          return '(clojure.java.io/file "'.concat(d.path, '")');
        }, this.path = l;
      }
      return s;
    })()
  ), i = function(s) {
    return s === void 0 ? null : s === null ? "null" : s.constructor.name.toLowerCase();
  }, a = function(s) {
    return i(s) === "object" ? Object.keys(s).length === 0 : !1;
  }, o = function(s) {
    return Object.keys(s).filter(function(l) {
      return a(s[l]);
    }).forEach(function(l) {
      delete s[l];
    }), s;
  }, c = function(s, l) {
    var d = " ".repeat(s);
    return l.replace(/\n/g, `
`.concat(d));
  }, u = function(s) {
    switch (i(s)) {
      case "string":
        return '"'.concat(s.replace(/"/g, '\\"'), '"');
      case "file":
        return s.toString();
      case "keyword":
        return s.toString();
      case "null":
        return "nil";
      case "regexp":
        return '#"'.concat(s.source, '"');
      case "object": {
        var l = Object.keys(s).reduce(function(f, p) {
          var g = c(p.length + 2, u(s[p]));
          return "".concat(f, ":").concat(p, " ").concat(g, `
 `);
        }, "").trim();
        return "{".concat(c(1, l), "}");
      }
      case "array": {
        var d = s.reduce(function(f, p) {
          return "".concat(f, " ").concat(u(p));
        }, "").trim();
        return "[".concat(c(1, d), "]");
      }
      default:
        return s.toString();
    }
  };
  return kl.clj_http = {
    info: {
      key: "clj_http",
      title: "clj-http",
      link: "https://github.com/dakrone/clj-http",
      description: "An idiomatic clojure http client wrapping the apache client."
    },
    convert: function(s, l) {
      var d = s.queryObj, f = s.method, p = s.postData, g = s.url, b = s.allHeaders, w = new e.CodeBuilder({ indent: l?.indent }), y = w.push, v = w.join, _ = ["get", "post", "put", "delete", "patch", "head", "options"];
      if (f = f.toLowerCase(), !_.includes(f))
        return y("Method not supported"), v();
      var E = {
        headers: b,
        "query-params": d
      };
      switch (p.mimeType) {
        case "application/json":
          {
            E["content-type"] = new n("json"), E["form-params"] = p.jsonObj;
            var O = (0, t.getHeaderName)(E.headers, "content-type");
            O && delete E.headers[O];
          }
          break;
        case "application/x-www-form-urlencoded":
          {
            E["form-params"] = p.paramsObj;
            var O = (0, t.getHeaderName)(E.headers, "content-type");
            O && delete E.headers[O];
          }
          break;
        case "text/plain":
          {
            E.body = p.text;
            var O = (0, t.getHeaderName)(E.headers, "content-type");
            O && delete E.headers[O];
          }
          break;
        case "multipart/form-data": {
          if (p.params) {
            E.multipart = p.params.map(function(Q) {
              return Q.fileName && !Q.value ? {
                name: Q.name,
                content: new r(Q.fileName)
              } : {
                name: Q.name,
                content: Q.value
              };
            });
            var O = (0, t.getHeaderName)(E.headers, "content-type");
            O && delete E.headers[O];
          }
          break;
        }
      }
      switch ((0, t.getHeader)(E.headers, "accept")) {
        case "application/json":
          {
            E.accept = new n("json");
            var O = (0, t.getHeaderName)(E.headers, "accept");
            O && delete E.headers[O];
          }
          break;
      }
      if (y(`(require '[clj-http.client :as client])
`), a(o(E)))
        y("(client/".concat(f, ' "').concat(g, '")'));
      else {
        var M = 11 + f.length + g.length, L = c(M, u(o(E)));
        y("(client/".concat(f, ' "').concat(g, '" ').concat(L, ")"));
      }
      return v();
    }
  }, kl;
}
var E_;
function Dre() {
  if (E_) return Cl;
  E_ = 1, Cl.__esModule = !0, Cl.clojure = void 0;
  var e = qre();
  return Cl.clojure = {
    info: {
      key: "clojure",
      title: "Clojure",
      extname: ".clj",
      default: "clj_http"
    },
    clientsById: {
      clj_http: e.clj_http
    }
  }, Cl;
}
var Al = {}, El = {}, O_;
function $re() {
  if (O_) return El;
  O_ = 1, El.__esModule = !0, El.native = void 0;
  var e = Pn(), t = ei();
  return El.native = {
    info: {
      key: "native",
      title: "http::client",
      link: "https://crystal-lang.org/api/master/HTTP/Client.html",
      description: "Crystal HTTP client"
    },
    convert: function(n, r) {
      var i = n.method, a = n.fullUrl, o = n.postData, c = n.allHeaders;
      r === void 0 && (r = {});
      var u = r.insecureSkipVerify, s = u === void 0 ? !1 : u, l = new e.CodeBuilder(), d = l.push, f = l.blank, p = l.join;
      d('require "http/client"'), f(), d('url = "'.concat(a, '"'));
      var g = Object.keys(c);
      g.length && (d("headers = HTTP::Headers{"), g.forEach(function(E) {
        d('  "'.concat(E, '" => "').concat((0, t.escapeForDoubleQuotes)(c[E]), '"'));
      }), d("}")), o.text && d("reqBody = ".concat(JSON.stringify(o.text))), f();
      var b = i.toUpperCase(), w = ["GET", "POST", "HEAD", "DELETE", "PATCH", "PUT", "OPTIONS"], y = g.length ? ", headers: headers" : "", v = o.text ? ", body: reqBody" : "", _ = s ? ", tls: OpenSSL::SSL::Context::Client.insecure" : "";
      return w.includes(b) ? d("response = HTTP::Client.".concat(b.toLowerCase(), " url").concat(y).concat(v).concat(_)) : d('response = HTTP::Client.exec "'.concat(b, '", url').concat(y).concat(v).concat(_)), d("puts response.body"), p();
    }
  }, El;
}
var T_;
function Lre() {
  if (T_) return Al;
  T_ = 1, Al.__esModule = !0, Al.crystal = void 0;
  var e = $re();
  return Al.crystal = {
    info: {
      key: "crystal",
      title: "Crystal",
      extname: ".cr",
      default: "native"
    },
    clientsById: {
      native: e.native
    }
  }, Al;
}
var Ol = {}, Ks = {}, P_;
function Nre() {
  if (P_) return Ks;
  P_ = 1;
  var e = Ks && Ks.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  };
  Ks.__esModule = !0, Ks.httpclient = void 0;
  var t = Pn(), n = ei(), r = Wi(), i = function(a) {
    var o = (0, r.getHeader)(a, "accept-encoding");
    if (!o)
      return [];
    var c = {
      gzip: "DecompressionMethods.GZip",
      deflate: "DecompressionMethods.Deflate"
    }, u = [];
    return typeof o == "string" && (o = [o]), o.forEach(function(s) {
      s.split(",").forEach(function(l) {
        var d = /\s*([^;\s]+)/.exec(l);
        if (d) {
          var f = c[d[1]];
          f && u.push(f);
        }
      });
    }), u;
  };
  return Ks.httpclient = {
    info: {
      key: "httpclient",
      title: "HttpClient",
      link: "https://docs.microsoft.com/en-us/dotnet/api/system.net.http.httpclient",
      description: ".NET Standard HTTP Client"
    },
    convert: function(a, o) {
      var c, u, s = a.allHeaders, l = a.postData, d = a.method, f = a.fullUrl, p = e({ indent: "    " }, o), g = new t.CodeBuilder({ indent: p.indent }), b = g.push, w = g.join;
      b("using System.Net.Http.Headers;");
      var y = "", v = !!s.cookie, _ = i(s);
      (v || _.length) && (y = "clientHandler", b("var clientHandler = new HttpClientHandler"), b("{"), v && b("UseCookies = false,", 1), _.length && b("AutomaticDecompression = ".concat(_.join(" | "), ","), 1), b("};")), b("var client = new HttpClient(".concat(y, ");")), b("var request = new HttpRequestMessage"), b("{");
      var E = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS", "TRACE"];
      d = d.toUpperCase(), d && E.includes(d) ? d = "HttpMethod.".concat(d[0]).concat(d.substring(1).toLowerCase()) : d = 'new HttpMethod("'.concat(d, '")'), b("Method = ".concat(d, ","), 1), b('RequestUri = new Uri("'.concat(f, '"),'), 1);
      var O = Object.keys(s).filter(function(L) {
        switch (L.toLowerCase()) {
          case "content-type":
          case "content-length":
          case "accept-encoding":
            return !1;
          default:
            return !0;
        }
      });
      if (O.length && (b("Headers =", 1), b("{", 1), O.forEach(function(L) {
        b('{ "'.concat(L, '", "').concat((0, n.escapeForDoubleQuotes)(s[L]), '" },'), 2);
      }), b("},", 1)), l.text) {
        var M = l.mimeType;
        switch (M) {
          case "application/x-www-form-urlencoded":
            b("Content = new FormUrlEncodedContent(new Dictionary<string, string>", 1), b("{", 1), (c = l.params) === null || c === void 0 || c.forEach(function(L) {
              b('{ "'.concat(L.name, '", "').concat(L.value, '" },'), 2);
            }), b("}),", 1);
            break;
          case "multipart/form-data":
            b("Content = new MultipartFormDataContent", 1), b("{", 1), (u = l.params) === null || u === void 0 || u.forEach(function(L) {
              b("new StringContent(".concat(JSON.stringify(L.value || ""), ")"), 2), b("{", 2), b("Headers =", 3), b("{", 3), L.contentType && b('ContentType = new MediaTypeHeaderValue("'.concat(L.contentType, '"),'), 4), b('ContentDisposition = new ContentDispositionHeaderValue("form-data")', 4), b("{", 4), b('Name = "'.concat(L.name, '",'), 5), L.fileName && b('FileName = "'.concat(L.fileName, '",'), 5), b("}", 4), b("}", 3), b("},", 2);
            }), b("},", 1);
            break;
          default:
            b("Content = new StringContent(".concat(JSON.stringify(l.text || ""), ")"), 1), b("{", 1), b("Headers =", 2), b("{", 2), b('ContentType = new MediaTypeHeaderValue("'.concat(M, '")'), 3), b("}", 2), b("}", 1);
            break;
        }
      }
      return b("};"), b("using (var response = await client.SendAsync(request))"), b("{"), b("response.EnsureSuccessStatusCode();", 1), b("var body = await response.Content.ReadAsStringAsync();", 1), b("Console.WriteLine(body);", 1), b("}"), w();
    }
  }, Ks;
}
var Tl = {}, R_;
function Fre() {
  if (R_) return Tl;
  R_ = 1, Tl.__esModule = !0, Tl.restsharp = void 0;
  var e = Pn(), t = ei(), n = Wi();
  return Tl.restsharp = {
    info: {
      key: "restsharp",
      title: "RestSharp",
      link: "http://restsharp.org/",
      description: "Simple REST and HTTP API Client for .NET"
    },
    convert: function(r) {
      var i = r.allHeaders, a = r.method, o = r.fullUrl, c = r.headersObj, u = r.cookies, s = r.postData, l = new e.CodeBuilder(), d = l.push, f = l.join, p = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS"].includes(a.toUpperCase());
      if (!p)
        return "Method not supported";
      function g(y) {
        return y.replace(/\w+/g, function(v) {
          return v.charAt(0).toUpperCase() + v.slice(1).toLowerCase();
        });
      }
      if (d('var client = new RestClient("'.concat(o, '");')), d('var request = new RestRequest("", Method.'.concat(g(a), ");")), Object.keys(c).forEach(function(y) {
        d('request.AddHeader("'.concat(y, '", "').concat((0, t.escapeForDoubleQuotes)(c[y]), '");'));
      }), u.forEach(function(y) {
        var v = y.name, _ = y.value;
        d('request.AddCookie("'.concat(v, '", "').concat(_, '");'));
      }), s.text) {
        var b = (0, n.getHeader)(i, "content-type"), w = JSON.stringify(s.text);
        d('request.AddParameter("'.concat(b, '", ').concat(w, ", ParameterType.RequestBody);"));
      }
      return d("var response = client.Execute(request);"), f();
    }
  }, Tl;
}
var I_;
function Mre() {
  if (I_) return Ol;
  I_ = 1, Ol.__esModule = !0, Ol.csharp = void 0;
  var e = Nre(), t = Fre();
  return Ol.csharp = {
    info: {
      key: "csharp",
      title: "C#",
      extname: ".cs",
      default: "restsharp"
    },
    clientsById: {
      httpclient: e.httpclient,
      restsharp: t.restsharp
    }
  }, Ol;
}
var Pl = {}, Rl = {}, j_;
function Bre() {
  if (j_) return Rl;
  j_ = 1, Rl.__esModule = !0, Rl.native = void 0;
  var e = Pn(), t = ei();
  return Rl.native = {
    info: {
      key: "native",
      title: "NewRequest",
      link: "http://golang.org/pkg/net/http/#NewRequest",
      description: "Golang HTTP client request"
    },
    convert: function(n, r) {
      var i = n.postData, a = n.method, o = n.allHeaders, c = n.fullUrl;
      r === void 0 && (r = {});
      var u = new e.CodeBuilder({ indent: "	" }), s = u.blank, l = u.push, d = u.join, f = r.showBoilerplate, p = f === void 0 ? !0 : f, g = r.checkErrors, b = g === void 0 ? !1 : g, w = r.printBody, y = w === void 0 ? !0 : w, v = r.timeout, _ = v === void 0 ? -1 : v, E = r.insecureSkipVerify, O = E === void 0 ? !1 : E, M = b ? "err" : "_", L = p ? 1 : 0, Z = function() {
        b && (l("if err != nil {", L), l("panic(err)", L + 1), l("}", L));
      };
      p && (l("package main"), s(), l("import ("), l('"fmt"', L), _ > 0 && l('"time"', L), O && l('"crypto/tls"', L), i.text && l('"strings"', L), l('"net/http"', L), y && l('"io"', L), l(")"), s(), l("func main() {"), s()), O && (l("insecureTransport := http.DefaultTransport.(*http.Transport).Clone()", L), l("insecureTransport.TLSClientConfig = &tls.Config{InsecureSkipVerify: true}", L));
      var Q = _ > 0, ae = Q || O, re = ae ? "client" : "http.DefaultClient";
      return ae && (l("client := http.Client{", L), Q && l("Timeout: time.Duration(".concat(_, " * time.Second),"), L + 1), O && l("Transport: insecureTransport,", L + 1), l("}", L), s()), l('url := "'.concat(c, '"'), L), s(), i.text ? (l("payload := strings.NewReader(".concat(JSON.stringify(i.text), ")"), L), s(), l("req, ".concat(M, ' := http.NewRequest("').concat(a, '", url, payload)'), L), s()) : (l("req, ".concat(M, ' := http.NewRequest("').concat(a, '", url, nil)'), L), s()), Z(), Object.keys(o).length && (Object.keys(o).forEach(function(X) {
        l('req.Header.Add("'.concat(X, '", "').concat((0, t.escapeForDoubleQuotes)(o[X]), '")'), L);
      }), s()), l("res, ".concat(M, " := ").concat(re, ".Do(req)"), L), Z(), y && (s(), l("defer res.Body.Close()", L), l("body, ".concat(M, " := io.ReadAll(res.Body)"), L), Z()), s(), l("fmt.Println(res)", L), y && l("fmt.Println(string(body))", L), p && (s(), l("}")), d();
    }
  }, Rl;
}
var q_;
function Ure() {
  if (q_) return Pl;
  q_ = 1, Pl.__esModule = !0, Pl.go = void 0;
  var e = Bre();
  return Pl.go = {
    info: {
      key: "go",
      title: "Go",
      extname: ".go",
      default: "native"
    },
    clientsById: {
      native: e.native
    }
  }, Pl;
}
var Il = {}, Zs = {}, D_;
function Hre() {
  if (D_) return Zs;
  D_ = 1;
  var e = Zs && Zs.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Zs.__esModule = !0, Zs.http11 = void 0;
  var t = Pn(), n = `\r
`;
  return Zs.http11 = {
    info: {
      key: "http1.1",
      title: "HTTP/1.1",
      link: "https://tools.ietf.org/html/rfc7230",
      description: "HTTP/1.1 request string in accordance with RFC 7230"
    },
    convert: function(r, i) {
      var a = r.method, o = r.fullUrl, c = r.uriObj, u = r.httpVersion, s = r.allHeaders, l = r.postData, d = e({ absoluteURI: !1, autoContentLength: !0, autoHost: !0 }, i), f = new t.CodeBuilder({ indent: "", join: n }), p = f.blank, g = f.push, b = f.join, w = d.absoluteURI ? o : c.path;
      g("".concat(a, " ").concat(w, " ").concat(u));
      var y = Object.keys(s);
      if (y.forEach(function(O) {
        var M = O.toLowerCase().replace(/(^|-)(\w)/g, function(L) {
          return L.toUpperCase();
        });
        g("".concat(M, ": ").concat(s[O]));
      }), d.autoHost && !y.includes("host") && g("Host: ".concat(c.host)), d.autoContentLength && l.text && !y.includes("content-length")) {
        var v = qn.byteLength(l.text, "ascii").toString();
        g("Content-Length: ".concat(v));
      }
      p();
      var _ = b(), E = l.text || "";
      return "".concat(_).concat(n).concat(E);
    }
  }, Zs;
}
var $_;
function zre() {
  if ($_) return Il;
  $_ = 1, Il.__esModule = !0, Il.http = void 0;
  var e = Hre();
  return Il.http = {
    info: {
      key: "http",
      title: "HTTP",
      extname: null,
      default: "1.1"
    },
    clientsById: {
      "http1.1": e.http11
    }
  }, Il;
}
var jl = {}, Ys = {}, L_;
function Vre() {
  if (L_) return Ys;
  L_ = 1;
  var e = Ys && Ys.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Ys.__esModule = !0, Ys.asynchttp = void 0;
  var t = Pn(), n = ei();
  return Ys.asynchttp = {
    info: {
      key: "asynchttp",
      title: "AsyncHttp",
      link: "https://github.com/AsyncHttpClient/async-http-client",
      description: "Asynchronous Http and WebSocket Client library for Java"
    },
    convert: function(r, i) {
      var a = r.method, o = r.allHeaders, c = r.postData, u = r.fullUrl, s = e({ indent: "  " }, i), l = new t.CodeBuilder({ indent: s.indent }), d = l.blank, f = l.push, p = l.join;
      return f("AsyncHttpClient client = new DefaultAsyncHttpClient();"), f('client.prepare("'.concat(a.toUpperCase(), '", "').concat(u, '")')), Object.keys(o).forEach(function(g) {
        f('.setHeader("'.concat(g, '", "').concat((0, n.escapeForDoubleQuotes)(o[g]), '")'), 1);
      }), c.text && f(".setBody(".concat(JSON.stringify(c.text), ")"), 1), f(".execute()", 1), f(".toCompletableFuture()", 1), f(".thenAccept(System.out::println)", 1), f(".join();", 1), d(), f("client.close();"), p();
    }
  }, Ys;
}
var Js = {}, N_;
function Gre() {
  if (N_) return Js;
  N_ = 1;
  var e = Js && Js.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Js.__esModule = !0, Js.nethttp = void 0;
  var t = Pn(), n = ei();
  return Js.nethttp = {
    info: {
      key: "nethttp",
      title: "java.net.http",
      link: "https://openjdk.java.net/groups/net/httpclient/intro.html",
      description: "Java Standardized HTTP Client API"
    },
    convert: function(r, i) {
      var a = r.allHeaders, o = r.fullUrl, c = r.method, u = r.postData, s = e({ indent: "  " }, i), l = new t.CodeBuilder({ indent: s.indent }), d = l.push, f = l.join;
      return d("HttpRequest request = HttpRequest.newBuilder()"), d('.uri(URI.create("'.concat(o, '"))'), 2), Object.keys(a).forEach(function(p) {
        d('.header("'.concat(p, '", "').concat((0, n.escapeForDoubleQuotes)(a[p]), '")'), 2);
      }), u.text ? d('.method("'.concat(c.toUpperCase(), '", HttpRequest.BodyPublishers.ofString(').concat(JSON.stringify(u.text), "))"), 2) : d('.method("'.concat(c.toUpperCase(), '", HttpRequest.BodyPublishers.noBody())'), 2), d(".build();", 2), d("HttpResponse<String> response = HttpClient.newHttpClient().send(request, HttpResponse.BodyHandlers.ofString());"), d("System.out.println(response.body());"), f();
    }
  }, Js;
}
var Qs = {}, F_;
function Wre() {
  if (F_) return Qs;
  F_ = 1;
  var e = Qs && Qs.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Qs.__esModule = !0, Qs.okhttp = void 0;
  var t = Pn(), n = ei();
  return Qs.okhttp = {
    info: {
      key: "okhttp",
      title: "OkHttp",
      link: "http://square.github.io/okhttp/",
      description: "An HTTP Request Client Library"
    },
    convert: function(r, i) {
      var a = r.postData, o = r.method, c = r.fullUrl, u = r.allHeaders, s = e({ indent: "  " }, i), l = new t.CodeBuilder({ indent: s.indent }), d = l.push, f = l.blank, p = l.join, g = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD"], b = ["POST", "PUT", "DELETE", "PATCH"];
      return d("OkHttpClient client = new OkHttpClient();"), f(), a.text && (a.boundary ? d('MediaType mediaType = MediaType.parse("'.concat(a.mimeType, "; boundary=").concat(a.boundary, '");')) : d('MediaType mediaType = MediaType.parse("'.concat(a.mimeType, '");')), d("RequestBody body = RequestBody.create(mediaType, ".concat(JSON.stringify(a.text), ");"))), d("Request request = new Request.Builder()"), d('.url("'.concat(c, '")'), 1), g.includes(o.toUpperCase()) ? b.includes(o.toUpperCase()) ? a.text ? d(".".concat(o.toLowerCase(), "(body)"), 1) : d(".".concat(o.toLowerCase(), "(null)"), 1) : d(".".concat(o.toLowerCase(), "()"), 1) : a.text ? d('.method("'.concat(o.toUpperCase(), '", body)'), 1) : d('.method("'.concat(o.toUpperCase(), '", null)'), 1), Object.keys(u).forEach(function(w) {
        d('.addHeader("'.concat(w, '", "').concat((0, n.escapeForDoubleQuotes)(u[w]), '")'), 1);
      }), d(".build();", 1), f(), d("Response response = client.newCall(request).execute();"), p();
    }
  }, Qs;
}
var Xs = {}, M_;
function Kre() {
  if (M_) return Xs;
  M_ = 1;
  var e = Xs && Xs.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Xs.__esModule = !0, Xs.unirest = void 0;
  var t = Pn(), n = ei();
  return Xs.unirest = {
    info: {
      key: "unirest",
      title: "Unirest",
      link: "http://unirest.io/java.html",
      description: "Lightweight HTTP Request Client Library"
    },
    convert: function(r, i) {
      var a = r.method, o = r.allHeaders, c = r.postData, u = r.fullUrl, s = e({ indent: "  " }, i), l = new t.CodeBuilder({ indent: s.indent }), d = l.join, f = l.push, p = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS"];
      return p.includes(a.toUpperCase()) ? f("HttpResponse<String> response = Unirest.".concat(a.toLowerCase(), '("').concat(u, '")')) : f('HttpResponse<String> response = Unirest.customMethod("'.concat(a.toUpperCase(), '","').concat(u, '")')), Object.keys(o).forEach(function(g) {
        f('.header("'.concat(g, '", "').concat((0, n.escapeForDoubleQuotes)(o[g]), '")'), 1);
      }), c.text && f(".body(".concat(JSON.stringify(c.text), ")"), 1), f(".asString();", 1), d();
    }
  }, Xs;
}
var B_;
function Zre() {
  if (B_) return jl;
  B_ = 1, jl.__esModule = !0, jl.java = void 0;
  var e = Vre(), t = Gre(), n = Wre(), r = Kre();
  return jl.java = {
    info: {
      key: "java",
      title: "Java",
      extname: ".java",
      default: "unirest"
    },
    clientsById: {
      asynchttp: e.asynchttp,
      nethttp: t.nethttp,
      okhttp: n.okhttp,
      unirest: r.unirest
    }
  }, jl;
}
var ql = {}, Uo = {}, a3, U_;
function Yre() {
  return U_ || (U_ = 1, a3 = function(e) {
    return Object.prototype.toString.call(e) === "[object RegExp]";
  }), a3;
}
var o3, H_;
function Jre() {
  return H_ || (H_ = 1, o3 = function(e) {
    var t = typeof e;
    return e !== null && (t === "object" || t === "function");
  }), o3;
}
var Dd = {}, z_;
function Qre() {
  return z_ || (z_ = 1, Object.defineProperty(Dd, "__esModule", { value: !0 }), Dd.default = (e) => Object.getOwnPropertySymbols(e).filter((t) => Object.prototype.propertyIsEnumerable.call(e, t))), Dd;
}
var s3, V_;
function us() {
  if (V_) return s3;
  V_ = 1;
  const e = Yre(), t = Jre(), n = Qre().default;
  return s3 = (r, i, a) => {
    const o = [];
    return (function c(u, s, l) {
      s = s || {}, s.indent = s.indent || "	", l = l || "";
      let d;
      s.inlineCharacterLimit === void 0 ? d = {
        newLine: `
`,
        newLineOrSpace: `
`,
        pad: l,
        indent: l + s.indent
      } : d = {
        newLine: "@@__STRINGIFY_OBJECT_NEW_LINE__@@",
        newLineOrSpace: "@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@",
        pad: "@@__STRINGIFY_OBJECT_PAD__@@",
        indent: "@@__STRINGIFY_OBJECT_INDENT__@@"
      };
      const f = (p) => {
        if (s.inlineCharacterLimit === void 0)
          return p;
        const g = p.replace(new RegExp(d.newLine, "g"), "").replace(new RegExp(d.newLineOrSpace, "g"), " ").replace(new RegExp(d.pad + "|" + d.indent, "g"), "");
        return g.length <= s.inlineCharacterLimit ? g : p.replace(new RegExp(d.newLine + "|" + d.newLineOrSpace, "g"), `
`).replace(new RegExp(d.pad, "g"), l).replace(new RegExp(d.indent, "g"), l + s.indent);
      };
      if (o.indexOf(u) !== -1)
        return '"[Circular]"';
      if (u == null || typeof u == "number" || typeof u == "boolean" || typeof u == "function" || typeof u == "symbol" || e(u))
        return String(u);
      if (u instanceof Date)
        return `new Date('${u.toISOString()}')`;
      if (Array.isArray(u)) {
        if (u.length === 0)
          return "[]";
        o.push(u);
        const p = "[" + d.newLine + u.map((g, b) => {
          const w = u.length - 1 === b ? d.newLine : "," + d.newLineOrSpace;
          let y = c(g, s, l + s.indent);
          return s.transform && (y = s.transform(u, b, y)), d.indent + y + w;
        }).join("") + d.pad + "]";
        return o.pop(), f(p);
      }
      if (t(u)) {
        let p = Object.keys(u).concat(n(u));
        if (s.filter && (p = p.filter((b) => s.filter(u, b))), p.length === 0)
          return "{}";
        o.push(u);
        const g = "{" + d.newLine + p.map((b, w) => {
          const y = p.length - 1 === w ? d.newLine : "," + d.newLineOrSpace, v = typeof b == "symbol", _ = !v && /^[a-z$_][a-z$_0-9]*$/i.test(b), E = v || _ ? b : c(b, s);
          let O = c(u[b], s, l + s.indent);
          return s.transform && (O = s.transform(u, b, O)), d.indent + String(E) + ": " + O + y;
        }).join("") + d.pad + "}";
        return o.pop(), f(g);
      }
      return u = String(u).replace(/[\r\n]/g, (p) => p === `
` ? "\\n" : "\\r"), s.singleQuotes === !1 ? (u = u.replace(/"/g, '\\"'), `"${u}"`) : (u = u.replace(/\\?'/g, "\\'"), `'${u}'`);
    })(r, i, a);
  }, s3;
}
var G_;
function Xre() {
  if (G_) return Uo;
  G_ = 1;
  var e = Uo && Uo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Uo && Uo.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Uo.__esModule = !0, Uo.axios = void 0;
  var n = t(us()), r = Pn();
  return Uo.axios = {
    info: {
      key: "axios",
      title: "Axios",
      link: "https://github.com/axios/axios",
      description: "Promise based HTTP client for the browser and node.js"
    },
    convert: function(i, a) {
      var o = i.allHeaders, c = i.method, u = i.url, s = i.queryObj, l = i.postData, d = e({ indent: "  " }, a), f = new r.CodeBuilder({ indent: d.indent }), p = f.blank, g = f.push, b = f.join, w = f.addPostProcessor;
      g("import axios from 'axios';"), p();
      var y = {
        method: c,
        url: u
      };
      switch (Object.keys(s).length && (y.params = s), Object.keys(o).length && (y.headers = o), l.mimeType) {
        case "application/x-www-form-urlencoded":
          l.params && (g("const encodedParams = new URLSearchParams();"), l.params.forEach(function(_) {
            g("encodedParams.set('".concat(_.name, "', '").concat(_.value, "');"));
          }), p(), y.data = "encodedParams,", w(function(_) {
            return _.replace(/'encodedParams,'/, "encodedParams,");
          }));
          break;
        case "application/json":
          l.jsonObj && (y.data = l.jsonObj);
          break;
        case "multipart/form-data":
          if (!l.params)
            break;
          g("const form = new FormData();"), l.params.forEach(function(_) {
            g("form.append('".concat(_.name, "', '").concat(_.value || _.fileName || "", "');"));
          }), p(), y.data = "[form]";
          break;
        default:
          l.text && (y.data = l.text);
      }
      var v = (0, n.default)(y, {
        indent: "  ",
        inlineCharacterLimit: 80
      }).replace('"[form]"', "form");
      return g("const options = ".concat(v, ";")), p(), g("try {"), g("const { data } = await axios.request(options);", 1), g("console.log(data);", 1), g("} catch (error) {"), g("console.error(error);", 1), g("}"), b();
    }
  }, Uo;
}
var Ho = {}, W_;
function ene() {
  if (W_) return Ho;
  W_ = 1;
  var e = Ho && Ho.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  }, t = Ho && Ho.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Ho.__esModule = !0, Ho.fetch = void 0;
  var n = t(us()), r = Pn(), i = Wi();
  return Ho.fetch = {
    info: {
      key: "fetch",
      title: "fetch",
      link: "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch",
      description: "Perform asynchronous HTTP requests with the Fetch API"
    },
    convert: function(a, o) {
      var c = a.method, u = a.allHeaders, s = a.postData, l = a.fullUrl, d = e({ indent: "  ", credentials: null }, o), f = new r.CodeBuilder({ indent: d.indent }), p = f.blank, g = f.join, b = f.push, w = {
        method: c
      };
      switch (Object.keys(u).length && (w.headers = u), d.credentials !== null && (w.credentials = d.credentials), b("const url = '".concat(l, "';")), s.mimeType) {
        case "application/x-www-form-urlencoded":
          w.body = s.paramsObj ? s.paramsObj : s.text;
          break;
        case "application/json":
          w.body = JSON.stringify(s.jsonObj);
          break;
        case "multipart/form-data":
          if (!s.params)
            break;
          var y = (0, i.getHeaderName)(u, "content-type");
          y && delete u[y], b("const form = new FormData();"), s.params.forEach(function(v) {
            b("form.append('".concat(v.name, "', '").concat(v.value || v.fileName || "", "');"));
          }), p();
          break;
        default:
          s.text && (w.body = s.text);
      }
      return w.headers && !Object.keys(w.headers).length && delete w.headers, b("const options = ".concat((0, n.default)(w, {
        indent: d.indent,
        inlineCharacterLimit: 80,
        transform: function(v, _, E) {
          return _ === "body" && s.mimeType === "application/x-www-form-urlencoded" ? "new URLSearchParams(".concat(E, ")") : E;
        }
      }), ";")), p(), s.params && s.mimeType === "multipart/form-data" && (b("options.body = form;"), p()), b("try {"), b("const response = await fetch(url, options);", 1), b("const data = await response.json();", 1), b("console.log(data);", 1), b("} catch (error) {"), b("console.error(error);", 1), b("}"), g();
    }
  }, Ho;
}
var zo = {}, K_;
function tne() {
  if (K_) return zo;
  K_ = 1;
  var e = zo && zo.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  }, t = zo && zo.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  zo.__esModule = !0, zo.jquery = void 0;
  var n = t(us()), r = Pn(), i = Wi();
  return zo.jquery = {
    info: {
      key: "jquery",
      title: "jQuery",
      link: "http://api.jquery.com/jquery.ajax/",
      description: "Perform an asynchronous HTTP (Ajax) requests with jQuery"
    },
    convert: function(a, o) {
      var c, u = a.fullUrl, s = a.method, l = a.allHeaders, d = a.postData, f = e({ indent: "  " }, o), p = new r.CodeBuilder({ indent: f.indent }), g = p.blank, b = p.push, w = p.join, y = {
        async: !0,
        crossDomain: !0,
        url: u,
        method: s,
        headers: l
      };
      switch (d.mimeType) {
        case "application/x-www-form-urlencoded":
          y.data = d.paramsObj ? d.paramsObj : d.text;
          break;
        case "application/json":
          y.processData = !1, y.data = d.text;
          break;
        case "multipart/form-data":
          if (!d.params)
            break;
          if (b("const form = new FormData();"), d.params.forEach(function(E) {
            b("form.append('".concat(E.name, "', '").concat(E.value || E.fileName || "", "');"));
          }), y.processData = !1, y.contentType = !1, y.mimeType = "multipart/form-data", y.data = "[form]", (0, i.hasHeader)(l, "content-type") && !((c = (0, i.getHeader)(l, "content-type")) === null || c === void 0) && c.includes("boundary")) {
            var v = (0, i.getHeaderName)(l, "content-type");
            v && delete y.headers[v];
          }
          g();
          break;
        default:
          d.text && (y.data = d.text);
      }
      var _ = (0, n.default)(y, { indent: f.indent }).replace("'[form]'", "form");
      return b("const settings = ".concat(_, ";")), g(), b("$.ajax(settings).done(function (response) {"), b("console.log(response);", 1), b("});"), w();
    }
  }, zo;
}
var Vo = {}, Z_;
function rne() {
  if (Z_) return Vo;
  Z_ = 1;
  var e = Vo && Vo.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var l in c) Object.prototype.hasOwnProperty.call(c, l) && (o[l] = c[l]);
      }
      return o;
    }, e.apply(this, arguments);
  }, t = Vo && Vo.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Vo.__esModule = !0, Vo.xhr = void 0;
  var n = t(us()), r = Pn(), i = ei(), a = Wi();
  return Vo.xhr = {
    info: {
      key: "xhr",
      title: "XMLHttpRequest",
      link: "https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest",
      description: "W3C Standard API that provides scripted client functionality"
    },
    convert: function(o, c) {
      var u, s = o.postData, l = o.allHeaders, d = o.method, f = o.fullUrl, p = e({ indent: "  ", cors: !0 }, c), g = new r.CodeBuilder({ indent: p.indent }), b = g.blank, w = g.push, y = g.join;
      switch (s.mimeType) {
        case "application/json":
          w("const data = JSON.stringify(".concat((0, n.default)(s.jsonObj, {
            indent: p.indent
          }), ");")), b();
          break;
        case "multipart/form-data":
          if (!s.params)
            break;
          if (w("const data = new FormData();"), s.params.forEach(function(_) {
            w("data.append('".concat(_.name, "', '").concat(_.value || _.fileName || "", "');"));
          }), (0, a.hasHeader)(l, "content-type") && !((u = (0, a.getHeader)(l, "content-type")) === null || u === void 0) && u.includes("boundary")) {
            var v = (0, a.getHeaderName)(l, "content-type");
            v && delete l[v];
          }
          b();
          break;
        default:
          w("const data = ".concat(s.text ? "'".concat(s.text, "'") : "null", ";")), b();
      }
      return w("const xhr = new XMLHttpRequest();"), p.cors && w("xhr.withCredentials = true;"), b(), w("xhr.addEventListener('readystatechange', function () {"), w("if (this.readyState === this.DONE) {", 1), w("console.log(this.responseText);", 2), w("}", 1), w("});"), b(), w("xhr.open('".concat(d, "', '").concat(f, "');")), Object.keys(l).forEach(function(_) {
        w("xhr.setRequestHeader('".concat(_, "', '").concat((0, i.escapeForSingleQuotes)(l[_]), "');"));
      }), b(), w("xhr.send(data);"), y();
    }
  }, Vo;
}
var Y_;
function nne() {
  if (Y_) return ql;
  Y_ = 1, ql.__esModule = !0, ql.javascript = void 0;
  var e = Xre(), t = ene(), n = tne(), r = rne();
  return ql.javascript = {
    info: {
      key: "javascript",
      title: "JavaScript",
      extname: ".js",
      default: "xhr"
    },
    clientsById: {
      xhr: r.xhr,
      axios: e.axios,
      fetch: t.fetch,
      jquery: n.jquery
    }
  }, ql;
}
var Dl = {}, eu = {}, J_;
function ine() {
  if (J_) return eu;
  J_ = 1;
  var e = eu && eu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  eu.__esModule = !0, eu.okhttp = void 0;
  var t = Pn(), n = ei();
  return eu.okhttp = {
    info: {
      key: "okhttp",
      title: "OkHttp",
      link: "http://square.github.io/okhttp/",
      description: "An HTTP Request Client Library"
    },
    convert: function(r, i) {
      var a = r.postData, o = r.fullUrl, c = r.method, u = r.allHeaders, s = e({ indent: "  " }, i), l = new t.CodeBuilder({ indent: s.indent }), d = l.blank, f = l.join, p = l.push, g = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD"], b = ["POST", "PUT", "DELETE", "PATCH"];
      return p("val client = OkHttpClient()"), d(), a.text && (a.boundary ? p('val mediaType = MediaType.parse("'.concat(a.mimeType, "; boundary=").concat(a.boundary, '")')) : p('val mediaType = MediaType.parse("'.concat(a.mimeType, '")')), p("val body = RequestBody.create(mediaType, ".concat(JSON.stringify(a.text), ")"))), p("val request = Request.Builder()"), p('.url("'.concat(o, '")'), 1), g.includes(c.toUpperCase()) ? b.includes(c.toUpperCase()) ? a.text ? p(".".concat(c.toLowerCase(), "(body)"), 1) : p(".".concat(c.toLowerCase(), "(null)"), 1) : p(".".concat(c.toLowerCase(), "()"), 1) : a.text ? p('.method("'.concat(c.toUpperCase(), '", body)'), 1) : p('.method("'.concat(c.toUpperCase(), '", null)'), 1), Object.keys(u).forEach(function(w) {
        p('.addHeader("'.concat(w, '", "').concat((0, n.escapeForDoubleQuotes)(u[w]), '")'), 1);
      }), p(".build()", 1), d(), p("val response = client.newCall(request).execute()"), f();
    }
  }, eu;
}
var Q_;
function ane() {
  if (Q_) return Dl;
  Q_ = 1, Dl.__esModule = !0, Dl.kotlin = void 0;
  var e = ine();
  return Dl.kotlin = {
    info: {
      key: "kotlin",
      title: "Kotlin",
      extname: ".kt",
      default: "okhttp"
    },
    clientsById: {
      okhttp: e.okhttp
    }
  }, Dl;
}
var $l = {}, Go = {}, X_;
function one() {
  if (X_) return Go;
  X_ = 1;
  var e = Go && Go.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Go && Go.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Go.__esModule = !0, Go.axios = void 0;
  var n = t(us()), r = Pn();
  return Go.axios = {
    info: {
      key: "axios",
      title: "Axios",
      link: "https://github.com/axios/axios",
      description: "Promise based HTTP client for the browser and node.js"
    },
    convert: function(i, a) {
      var o = i.method, c = i.url, u = i.queryObj, s = i.allHeaders, l = i.postData, d = e({ indent: "  " }, a), f = new r.CodeBuilder({ indent: d.indent }), p = f.blank, g = f.join, b = f.push, w = f.addPostProcessor;
      b("const axios = require('axios').default;");
      var y = {
        method: o,
        url: c
      };
      switch (Object.keys(u).length && (y.params = u), Object.keys(s).length && (y.headers = s), l.mimeType) {
        case "application/x-www-form-urlencoded":
          l.params && (b("const { URLSearchParams } = require('url');"), p(), b("const encodedParams = new URLSearchParams();"), l.params.forEach(function(_) {
            b("encodedParams.set('".concat(_.name, "', '").concat(_.value, "');"));
          }), p(), y.data = "encodedParams,", w(function(_) {
            return _.replace(/'encodedParams,'/, "encodedParams,");
          }));
          break;
        case "application/json":
          p(), l.jsonObj && (y.data = l.jsonObj);
          break;
        default:
          p(), l.text && (y.data = l.text);
      }
      var v = (0, n.default)(y, { indent: "  ", inlineCharacterLimit: 80 });
      return b("const options = ".concat(v, ";")), p(), b("try {"), b("const { data } = await axios.request(options);", 1), b("console.log(data);", 1), b("} catch (error) {"), b("console.error(error);", 1), b("}"), g();
    }
  }, Go;
}
var Wo = {}, ew;
function sne() {
  if (ew) return Wo;
  ew = 1;
  var e = Wo && Wo.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  }, t = Wo && Wo.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Wo.__esModule = !0, Wo.fetch = void 0;
  var n = t(us()), r = Pn(), i = Wi();
  return Wo.fetch = {
    info: {
      key: "fetch",
      title: "Fetch",
      link: "https://github.com/bitinn/node-fetch",
      description: "Simplified HTTP node-fetch client"
    },
    convert: function(a, o) {
      var c, u = a.method, s = a.fullUrl, l = a.postData, d = a.headersObj, f = a.cookies, p = e({ indent: "  " }, o), g = !1, b = new r.CodeBuilder({ indent: p.indent }), w = b.blank, y = b.push, v = b.join, _ = b.unshift;
      y("const fetch = require('node-fetch');"), w();
      var E = {
        method: u
      };
      switch (Object.keys(d).length && (E.headers = d), l.mimeType) {
        case "application/x-www-form-urlencoded":
          _("const { URLSearchParams } = require('url');"), y("const encodedParams = new URLSearchParams();"), (c = l.params) === null || c === void 0 || c.forEach(function(Z) {
            y("encodedParams.set('".concat(Z.name, "', '").concat(Z.value, "');"));
          }), w(), E.body = "encodedParams";
          break;
        case "application/json":
          l.jsonObj && (E.body = JSON.stringify(l.jsonObj));
          break;
        case "multipart/form-data":
          if (!l.params)
            break;
          var O = (0, i.getHeaderName)(d, "content-type");
          O && delete d[O], _("const FormData = require('form-data');"), y("const formData = new FormData();"), l.params.forEach(function(Z) {
            if (!Z.fileName && !Z.fileName && !Z.contentType) {
              y("formData.append('".concat(Z.name, "', '").concat(Z.value, "');"));
              return;
            }
            Z.fileName && (g = !0, y("formData.append('".concat(Z.name, "', fs.createReadStream('").concat(Z.fileName, "'));")));
          }), w();
          break;
        default:
          l.text && (E.body = l.text);
      }
      if (f.length) {
        var M = f.map(function(Z) {
          return "".concat(encodeURIComponent(Z.name), "=").concat(encodeURIComponent(Z.value));
        }).join("; ");
        E.headers || (E.headers = {}), E.headers.cookie = M;
      }
      y("const url = '".concat(s, "';")), E.headers && !Object.keys(E.headers).length && delete E.headers;
      var L = (0, n.default)(E, { indent: "  ", inlineCharacterLimit: 80 });
      return y("const options = ".concat(L, ";")), g && _("const fs = require('fs');"), l.params && l.mimeType === "multipart/form-data" && y("options.body = formData;"), w(), y("try {"), y("const response = await fetch(url, options);", 1), y("const data = await response.json();", 1), y("console.log(data);", 1), y("} catch (error) {"), y("console.error(error);", 1), y("}"), v().replace(/'encodedParams'/, "encodedParams").replace(/"fs\.createReadStream\(\\"(.+)\\"\)"/, 'fs.createReadStream("$1")');
    }
  }, Wo;
}
var Ko = {}, tw;
function une() {
  if (tw) return Ko;
  tw = 1;
  var e = Ko && Ko.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Ko && Ko.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Ko.__esModule = !0, Ko.native = void 0;
  var n = t(us()), r = Pn();
  return Ko.native = {
    info: {
      key: "native",
      title: "HTTP",
      link: "http://nodejs.org/api/http.html#http_http_request_options_callback",
      description: "Node.js native HTTP interface"
    },
    convert: function(i, a) {
      var o = i.uriObj, c = i.method, u = i.allHeaders, s = i.postData;
      a === void 0 && (a = {});
      var l = a.indent, d = l === void 0 ? "  " : l, f = a.insecureSkipVerify, p = f === void 0 ? !1 : f, g = new r.CodeBuilder({ indent: d }), b = g.blank, w = g.join, y = g.push, v = g.unshift, _ = e({ method: c, hostname: o.hostname, port: o.port, path: o.path, headers: u }, p ? { rejectUnauthorized: !1 } : {});
      switch (y("const http = require('".concat(o.protocol.replace(":", ""), "');")), b(), y("const options = ".concat((0, n.default)(_, { indent: d }), ";")), b(), y("const req = http.request(options, function (res) {"), y("const chunks = [];", 1), b(), y("res.on('data', function (chunk) {", 1), y("chunks.push(chunk);", 2), y("});", 1), b(), y("res.on('end', function () {", 1), y("const body = Buffer.concat(chunks);", 2), y("console.log(body.toString());", 2), y("});", 1), y("});"), b(), s.mimeType) {
        case "application/x-www-form-urlencoded":
          s.paramsObj && (v("const qs = require('querystring');"), y("req.write(qs.stringify(".concat((0, n.default)(s.paramsObj, {
            indent: "  ",
            inlineCharacterLimit: 80
          }), "));")));
          break;
        case "application/json":
          s.jsonObj && y("req.write(JSON.stringify(".concat((0, n.default)(s.jsonObj, {
            indent: "  ",
            inlineCharacterLimit: 80
          }), "));"));
          break;
        default:
          s.text && y("req.write(".concat((0, n.default)(s.text, { indent: d }), ");"));
      }
      return y("req.end();"), w();
    }
  }, Ko;
}
var Zo = {}, rw;
function cne() {
  if (rw) return Zo;
  rw = 1;
  var e = Zo && Zo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Zo && Zo.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Zo.__esModule = !0, Zo.request = void 0;
  var n = t(us()), r = Pn();
  return Zo.request = {
    info: {
      key: "request",
      title: "Request",
      link: "https://github.com/request/request",
      description: "Simplified HTTP request client"
    },
    convert: function(i, a) {
      var o = i.method, c = i.url, u = i.queryObj, s = i.postData, l = i.headersObj, d = i.cookies, f = e({ indent: "  " }, a), p = !1, g = new r.CodeBuilder({ indent: f.indent }), b = g.push, w = g.blank, y = g.join, v = g.unshift;
      b("const request = require('request');"), w();
      var _ = {
        method: o,
        url: c
      };
      switch (Object.keys(u).length && (_.qs = u), Object.keys(l).length && (_.headers = l), s.mimeType) {
        case "application/x-www-form-urlencoded":
          _.form = s.paramsObj;
          break;
        case "application/json":
          s.jsonObj && (_.body = s.jsonObj, _.json = !0);
          break;
        case "multipart/form-data":
          if (!s.params)
            break;
          _.formData = {}, s.params.forEach(function(E) {
            if (!E.fileName && !E.fileName && !E.contentType) {
              _.formData[E.name] = E.value;
              return;
            }
            var O = {};
            E.fileName ? (p = !0, O = {
              value: "fs.createReadStream(".concat(E.fileName, ")"),
              options: {
                filename: E.fileName,
                contentType: E.contentType ? E.contentType : null
              }
            }) : E.value && (O.value = E.value), _.formData[E.name] = O;
          });
          break;
        default:
          s.text && (_.body = s.text);
      }
      return d.length && (_.jar = "JAR", b("const jar = request.jar();"), d.forEach(function(E) {
        b("jar.setCookie(request.cookie('".concat(encodeURIComponent(E.name), "=").concat(encodeURIComponent(E.value), "'), '").concat(c, "');"));
      }), w()), p && v("const fs = require('fs');"), b("const options = ".concat((0, n.default)(_, { indent: "  ", inlineCharacterLimit: 80 }), ";")), w(), b("request(options, function (error, response, body) {"), b("if (error) throw new Error(error);", 1), w(), b("console.log(body);", 1), b("});"), y().replace("'JAR'", "jar").replace(/'fs\.createReadStream\((.*)\)'/, "fs.createReadStream('$1')");
    }
  }, Zo;
}
var Yo = {}, nw;
function lne() {
  if (nw) return Yo;
  nw = 1;
  var e = Yo && Yo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Yo && Yo.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Yo.__esModule = !0, Yo.unirest = void 0;
  var n = t(us()), r = Pn();
  return Yo.unirest = {
    info: {
      key: "unirest",
      title: "Unirest",
      link: "http://unirest.io/nodejs.html",
      description: "Lightweight HTTP Request Client Library"
    },
    convert: function(i, a) {
      var o = i.method, c = i.url, u = i.cookies, s = i.queryObj, l = i.postData, d = i.headersObj, f = e({ indent: "  " }, a), p = !1, g = new r.CodeBuilder({
        indent: f.indent
      }), b = g.addPostProcessor, w = g.blank, y = g.join, v = g.push, _ = g.unshift;
      switch (v("const unirest = require('unirest');"), w(), v("const req = unirest('".concat(o, "', '").concat(c, "');")), w(), u.length && (v("const CookieJar = unirest.jar();"), u.forEach(function(O) {
        v("CookieJar.add('".concat(encodeURIComponent(O.name), "=").concat(encodeURIComponent(O.value), "', '").concat(c, "');"));
      }), v("req.jar(CookieJar);"), w()), Object.keys(s).length && (v("req.query(".concat((0, n.default)(s, { indent: f.indent }), ");")), w()), Object.keys(d).length && (v("req.headers(".concat((0, n.default)(d, { indent: f.indent }), ");")), w()), l.mimeType) {
        case "application/x-www-form-urlencoded":
          l.paramsObj && (v("req.form(".concat((0, n.default)(l.paramsObj, { indent: f.indent }), ");")), w());
          break;
        case "application/json":
          l.jsonObj && (v("req.type('json');"), v("req.send(".concat((0, n.default)(l.jsonObj, { indent: f.indent }), ");")), w());
          break;
        case "multipart/form-data": {
          if (!l.params)
            break;
          var E = [];
          l.params.forEach(function(O) {
            var M = {};
            O.fileName && !O.value ? (p = !0, M.body = "fs.createReadStream('".concat(O.fileName, "')"), b(function(L) {
              return L.replace(/'fs\.createReadStream\(\\'(.+)\\'\)'/, "fs.createReadStream('$1')");
            })) : O.value && (M.body = O.value), M.body && (O.contentType && (M["content-type"] = O.contentType), E.push(M));
          }), v("req.multipart(".concat((0, n.default)(E, { indent: f.indent }), ");")), w();
          break;
        }
        default:
          l.text && (v("req.send(".concat((0, n.default)(l.text, { indent: f.indent }), ");")), w());
      }
      return p && _("const fs = require('fs');"), v("req.end(function (res) {"), v("if (res.error) throw new Error(res.error);", 1), w(), v("console.log(res.body);", 1), v("});"), y();
    }
  }, Yo;
}
var iw;
function fne() {
  if (iw) return $l;
  iw = 1, $l.__esModule = !0, $l.node = void 0;
  var e = one(), t = sne(), n = une(), r = cne(), i = lne();
  return $l.node = {
    info: {
      key: "node",
      title: "Node.js",
      extname: ".js",
      default: "native"
    },
    clientsById: {
      native: n.native,
      request: r.request,
      unirest: i.unirest,
      axios: e.axios,
      fetch: t.fetch
    }
  }, $l;
}
var Ll = {}, Jo = {}, u3 = {}, aw;
function pne() {
  return aw || (aw = 1, (function(e) {
    e.__esModule = !0, e.literalRepresentation = e.nsDeclaration = void 0;
    var t = function(r, i, a, o) {
      var c = "".concat(r, " *").concat(i, " = "), u = (0, e.literalRepresentation)(a, o ? c.length : void 0);
      return "".concat(c).concat(u, ";");
    };
    e.nsDeclaration = t;
    var n = function(r, i) {
      var a = i === void 0 ? ", " : `,
   `.concat(" ".repeat(i));
      switch (Object.prototype.toString.call(r)) {
        case "[object Number]":
          return "@".concat(r);
        case "[object Array]": {
          var o = r.map(function(s) {
            return (0, e.literalRepresentation)(s);
          });
          return "@[ ".concat(o.join(a), " ]");
        }
        case "[object Object]": {
          var c = [];
          for (var u in r)
            c.push('@"'.concat(u, '": ').concat((0, e.literalRepresentation)(r[u])));
          return "@{ ".concat(c.join(a), " }");
        }
        case "[object Boolean]":
          return r ? "@YES" : "@NO";
        default:
          return r == null ? "" : '@"'.concat(r.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = n;
  })(u3)), u3;
}
var ow;
function dne() {
  if (ow) return Jo;
  ow = 1;
  var e = Jo && Jo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Jo && Jo.__read || function(i, a) {
    var o = typeof Symbol == "function" && i[Symbol.iterator];
    if (!o) return i;
    var c = o.call(i), u, s = [], l;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) s.push(u.value);
    } catch (d) {
      l = { error: d };
    } finally {
      try {
        u && !u.done && (o = c.return) && o.call(c);
      } finally {
        if (l) throw l.error;
      }
    }
    return s;
  };
  Jo.__esModule = !0, Jo.nsurlsession = void 0;
  var n = Pn(), r = pne();
  return Jo.nsurlsession = {
    info: {
      key: "nsurlsession",
      title: "NSURLSession",
      link: "https://developer.apple.com/library/mac/documentation/Foundation/Reference/NSURLSession_class/index.html",
      description: "Foundation's NSURLSession request"
    },
    convert: function(i, a) {
      var o, c = i.allHeaders, u = i.postData, s = i.method, l = i.fullUrl, d = e({ indent: "    ", pretty: !0, timeout: 10 }, a), f = new n.CodeBuilder({ indent: d.indent }), p = f.push, g = f.join, b = f.blank, w = {
        hasHeaders: !1,
        hasBody: !1
      };
      if (p("#import <Foundation/Foundation.h>"), Object.keys(c).length && (w.hasHeaders = !0, b(), p((0, r.nsDeclaration)("NSDictionary", "headers", c, d.pretty))), u.text || u.jsonObj || u.params)
        switch (w.hasBody = !0, u.mimeType) {
          case "application/x-www-form-urlencoded":
            if (!((o = u.params) === null || o === void 0) && o.length) {
              b();
              var y = t(u.params), v = y[0], _ = y.slice(1);
              p('NSMutableData *postData = [[NSMutableData alloc] initWithData:[@"'.concat(v.name, "=").concat(v.value, '" dataUsingEncoding:NSUTF8StringEncoding]];')), _.forEach(function(E) {
                var O = E.name, M = E.value;
                p('[postData appendData:[@"&'.concat(O, "=").concat(M, '" dataUsingEncoding:NSUTF8StringEncoding]];'));
              });
            } else
              w.hasBody = !1;
            break;
          case "application/json":
            u.jsonObj && (p((0, r.nsDeclaration)("NSDictionary", "parameters", u.jsonObj, d.pretty)), b(), p("NSData *postData = [NSJSONSerialization dataWithJSONObject:parameters options:0 error:nil];"));
            break;
          case "multipart/form-data":
            p((0, r.nsDeclaration)("NSArray", "parameters", u.params || [], d.pretty)), p('NSString *boundary = @"'.concat(u.boundary, '";')), b(), p("NSError *error;"), p("NSMutableString *body = [NSMutableString string];"), p("for (NSDictionary *param in parameters) {"), p('[body appendFormat:@"--%@\\r\\n", boundary];', 1), p('if (param[@"fileName"]) {', 1), p('[body appendFormat:@"Content-Disposition:form-data; name=\\"%@\\"; filename=\\"%@\\"\\r\\n", param[@"name"], param[@"fileName"]];', 2), p('[body appendFormat:@"Content-Type: %@\\r\\n\\r\\n", param[@"contentType"]];', 2), p('[body appendFormat:@"%@", [NSString stringWithContentsOfFile:param[@"fileName"] encoding:NSUTF8StringEncoding error:&error]];', 2), p("if (error) {", 2), p('NSLog(@"%@", error);', 3), p("}", 2), p("} else {", 1), p('[body appendFormat:@"Content-Disposition:form-data; name=\\"%@\\"\\r\\n\\r\\n", param[@"name"]];', 2), p('[body appendFormat:@"%@", param[@"value"]];', 2), p("}", 1), p("}"), p('[body appendFormat:@"\\r\\n--%@--\\r\\n", boundary];'), p("NSData *postData = [body dataUsingEncoding:NSUTF8StringEncoding];");
            break;
          default:
            b(), p('NSData *postData = [[NSData alloc] initWithData:[@"'.concat(u.text, '" dataUsingEncoding:NSUTF8StringEncoding]];'));
        }
      return b(), p('NSMutableURLRequest *request = [NSMutableURLRequest requestWithURL:[NSURL URLWithString:@"'.concat(l, '"]')), p("                                                       cachePolicy:NSURLRequestUseProtocolCachePolicy"), p("                                                   timeoutInterval:".concat(d.timeout.toFixed(1), "];")), p('[request setHTTPMethod:@"'.concat(s, '"];')), w.hasHeaders && p("[request setAllHTTPHeaderFields:headers];"), w.hasBody && p("[request setHTTPBody:postData];"), b(), p("NSURLSession *session = [NSURLSession sharedSession];"), p("NSURLSessionDataTask *dataTask = [session dataTaskWithRequest:request"), p("                                            completionHandler:^(NSData *data, NSURLResponse *response, NSError *error) {"), p("                                            if (error) {", 1), p('                                            NSLog(@"%@", error);', 2), p("                                            } else {", 1), p("                                            NSHTTPURLResponse *httpResponse = (NSHTTPURLResponse *) response;", 2), p('                                            NSLog(@"%@", httpResponse);', 2), p("                                            }", 1), p("                                            }];"), p("[dataTask resume];"), g();
    }
  }, Jo;
}
var sw;
function hne() {
  if (sw) return Ll;
  sw = 1, Ll.__esModule = !0, Ll.objc = void 0;
  var e = dne();
  return Ll.objc = {
    info: {
      key: "objc",
      title: "Objective-C",
      extname: ".m",
      default: "nsurlsession"
    },
    clientsById: {
      nsurlsession: e.nsurlsession
    }
  }, Ll;
}
var Nl = {}, tu = {}, uw;
function mne() {
  if (uw) return tu;
  uw = 1;
  var e = tu && tu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  tu.__esModule = !0, tu.cohttp = void 0;
  var t = Pn(), n = ei();
  return tu.cohttp = {
    info: {
      key: "cohttp",
      title: "CoHTTP",
      link: "https://github.com/mirage/ocaml-cohttp",
      description: "Cohttp is a very lightweight HTTP server using Lwt or Async for OCaml"
    },
    convert: function(r, i) {
      var a = r.fullUrl, o = r.allHeaders, c = r.postData, u = r.method, s = e({ indent: "  " }, i), l = ["get", "post", "head", "delete", "patch", "put", "options"], d = new t.CodeBuilder({ indent: s.indent }), f = d.push, p = d.blank, g = d.join;
      f("open Cohttp_lwt_unix"), f("open Cohttp"), f("open Lwt"), p(), f('let uri = Uri.of_string "'.concat(a, '" in'));
      var b = Object.keys(o);
      b.length === 1 ? f('let headers = Header.add (Header.init ()) "'.concat(b[0], '" "').concat((0, n.escapeForDoubleQuotes)(o[b[0]]), '" in')) : b.length > 1 && (f("let headers = Header.add_list (Header.init ()) ["), b.forEach(function(_) {
        f('("'.concat(_, '", "').concat((0, n.escapeForDoubleQuotes)(o[_]), '");'), 1);
      }), f("] in")), c.text && f("let body = Cohttp_lwt_body.of_string ".concat(JSON.stringify(c.text), " in")), p();
      var w = b.length ? "~headers " : "", y = c.text ? "~body " : "", v = l.includes(u.toLowerCase()) ? "`".concat(u.toUpperCase()) : '(Code.method_of_string "'.concat(u, '")');
      return f("Client.call ".concat(w).concat(y).concat(v, " uri")), f(">>= fun (res, body_stream) ->"), f("(* Do stuff with the result *)", 1), g();
    }
  }, tu;
}
var cw;
function gne() {
  if (cw) return Nl;
  cw = 1, Nl.__esModule = !0, Nl.ocaml = void 0;
  var e = mne();
  return Nl.ocaml = {
    info: {
      key: "ocaml",
      title: "OCaml",
      extname: ".ml",
      default: "cohttp"
    },
    clientsById: {
      cohttp: e.cohttp
    }
  }, Nl;
}
var Fl = {}, Ml = {}, c3 = {}, lw;
function v1() {
  return lw || (lw = 1, (function(e) {
    e.__esModule = !0, e.supportedMethods = e.convertType = void 0;
    var t = ei(), n = function(r, i, a) {
      switch (a = a || "", i = i || "", Object.prototype.toString.call(r)) {
        case "[object Null]":
          return "null";
        case "[object Undefined]":
          return "null";
        case "[object String]":
          return "'".concat((0, t.escapeString)(r, { delimiter: "'", escapeNewlines: !1 }), "'");
        case "[object Number]":
          return r.toString();
        case "[object Array]": {
          var o = r.map(function(s) {
            return (0, e.convertType)(s, "".concat(i).concat(i), i);
          }).join(`,
`.concat(i));
          return `[
`.concat(i).concat(o, `
`).concat(a, "]");
        }
        case "[object Object]": {
          var c = [];
          for (var u in r)
            Object.prototype.hasOwnProperty.call(r, u) && c.push("".concat((0, e.convertType)(u, i), " => ").concat((0, e.convertType)(r[u], "".concat(i).concat(i), i)));
          return `[
`.concat(i).concat(c.join(`,
`.concat(i)), `
`).concat(a, "]");
        }
        default:
          return "null";
      }
    };
    e.convertType = n, e.supportedMethods = [
      "ACL",
      "BASELINE_CONTROL",
      "CHECKIN",
      "CHECKOUT",
      "CONNECT",
      "COPY",
      "DELETE",
      "GET",
      "HEAD",
      "LABEL",
      "LOCK",
      "MERGE",
      "MKACTIVITY",
      "MKCOL",
      "MKWORKSPACE",
      "MOVE",
      "OPTIONS",
      "POST",
      "PROPFIND",
      "PROPPATCH",
      "PUT",
      "REPORT",
      "TRACE",
      "UNCHECKOUT",
      "UNLOCK",
      "UPDATE",
      "VERSION_CONTROL"
    ];
  })(c3)), c3;
}
var fw;
function vne() {
  if (fw) return Ml;
  fw = 1, Ml.__esModule = !0, Ml.curl = void 0;
  var e = Pn(), t = ei(), n = v1();
  return Ml.curl = {
    info: {
      key: "curl",
      title: "cURL",
      link: "http://php.net/manual/en/book.curl.php",
      description: "PHP with ext-curl"
    },
    convert: function(r, i) {
      var a = r.uriObj, o = r.postData, c = r.fullUrl, u = r.method, s = r.httpVersion, l = r.cookies, d = r.headersObj;
      i === void 0 && (i = {});
      var f = i.closingTag, p = f === void 0 ? !1 : f, g = i.indent, b = g === void 0 ? "  " : g, w = i.maxRedirects, y = w === void 0 ? 10 : w, v = i.namedErrors, _ = v === void 0 ? !1 : v, E = i.noTags, O = E === void 0 ? !1 : E, M = i.shortTags, L = M === void 0 ? !1 : M, Z = i.timeout, Q = Z === void 0 ? 30 : Z, ae = new e.CodeBuilder({ indent: b }), re = ae.push, X = ae.blank, de = ae.join;
      O || (re(L ? "<?" : "<?php"), X()), re("$curl = curl_init();"), X();
      var Ce = [
        {
          escape: !0,
          name: "CURLOPT_PORT",
          value: a.port
        },
        {
          escape: !0,
          name: "CURLOPT_URL",
          value: c
        },
        {
          escape: !1,
          name: "CURLOPT_RETURNTRANSFER",
          value: "true"
        },
        {
          escape: !0,
          name: "CURLOPT_ENCODING",
          value: ""
        },
        {
          escape: !1,
          name: "CURLOPT_MAXREDIRS",
          value: y
        },
        {
          escape: !1,
          name: "CURLOPT_TIMEOUT",
          value: Q
        },
        {
          escape: !1,
          name: "CURLOPT_HTTP_VERSION",
          value: s === "HTTP/1.0" ? "CURL_HTTP_VERSION_1_0" : "CURL_HTTP_VERSION_1_1"
        },
        {
          escape: !0,
          name: "CURLOPT_CUSTOMREQUEST",
          value: u
        },
        {
          escape: !o.jsonObj,
          name: "CURLOPT_POSTFIELDS",
          value: o ? o.jsonObj ? "json_encode(".concat((0, n.convertType)(o.jsonObj, b.repeat(2), b), ")") : o.text : void 0
        }
      ];
      re("curl_setopt_array($curl, [");
      var J = new e.CodeBuilder({ indent: b, join: `
`.concat(b) });
      Ce.forEach(function(je) {
        var Me = je.value, qe = je.name, Ve = je.escape;
        Me != null && J.push("".concat(qe, " => ").concat(Ve ? JSON.stringify(Me) : Me, ","));
      });
      var ne = l.map(function(je) {
        return "".concat(encodeURIComponent(je.name), "=").concat(encodeURIComponent(je.value));
      });
      ne.length && J.push('CURLOPT_COOKIE => "'.concat(ne.join("; "), '",'));
      var De = Object.keys(d).sort().map(function(je) {
        return '"'.concat(je, ": ").concat((0, t.escapeForDoubleQuotes)(d[je]), '"');
      });
      return De.length && (J.push("CURLOPT_HTTPHEADER => ["), J.push(De.join(`,
`.concat(b).concat(b)), 1), J.push("],")), re(J.join(), 1), re("]);"), X(), re("$response = curl_exec($curl);"), re("$err = curl_error($curl);"), X(), re("curl_close($curl);"), X(), re("if ($err) {"), re(_ ? 'echo array_flip(get_defined_constants(true)["curl"])[$err];' : 'echo "cURL Error #:" . $err;', 1), re("} else {"), re("echo $response;", 1), re("}"), !O && p && (X(), re("?>")), de();
    }
  }, Ml;
}
var ru = {}, pw;
function yne() {
  if (pw) return ru;
  pw = 1;
  var e = ru && ru.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  };
  ru.__esModule = !0, ru.guzzle = void 0;
  var t = Pn(), n = ei(), r = Wi(), i = v1();
  return ru.guzzle = {
    info: {
      key: "guzzle",
      title: "Guzzle",
      link: "http://docs.guzzlephp.org/en/stable/",
      description: "PHP with Guzzle"
    },
    convert: function(a, o) {
      var c, u = a.postData, s = a.fullUrl, l = a.method, d = a.cookies, f = a.headersObj, p = e({ closingTag: !1, indent: "  ", noTags: !1, shortTags: !1 }, o), g = new t.CodeBuilder({ indent: p.indent }), b = g.push, w = g.blank, y = g.join, v = new t.CodeBuilder({ indent: p.indent }), _ = v.code, E = v.push, O = v.join;
      switch (p.noTags || (b(p.shortTags ? "<?" : "<?php"), w()), u.mimeType) {
        case "application/x-www-form-urlencoded":
          E("'form_params' => ".concat((0, i.convertType)(u.paramsObj, p.indent + p.indent, p.indent), ","), 1);
          break;
        case "multipart/form-data": {
          var M = [];
          if (u.params && u.params.forEach(function(ae) {
            if (ae.fileName) {
              var re = {
                name: ae.name,
                filename: ae.fileName,
                contents: ae.value
              };
              ae.contentType && (re.headers = { "Content-Type": ae.contentType }), M.push(re);
            } else ae.value && M.push({
              name: ae.name,
              contents: ae.value
            });
          }), M.length && (E("'multipart' => ".concat((0, i.convertType)(M, p.indent + p.indent, p.indent)), 1), (0, r.hasHeader)(f, "content-type") && !((c = (0, r.getHeader)(f, "content-type")) === null || c === void 0) && c.indexOf("boundary"))) {
            var L = (0, r.getHeaderName)(f, "content-type");
            L && delete f[L];
          }
          break;
        }
        default:
          u.text && E("'body' => ".concat((0, i.convertType)(u.text), ","), 1);
      }
      var Z = Object.keys(f).sort().map(function(ae) {
        return "".concat(p.indent).concat(p.indent, "'").concat(ae, "' => '").concat((0, n.escapeForSingleQuotes)(f[ae]), "',");
      }), Q = d.map(function(ae) {
        return "".concat(encodeURIComponent(ae.name), "=").concat(encodeURIComponent(ae.value));
      }).join("; ");
      return Q.length && Z.push("".concat(p.indent).concat(p.indent, "'cookie' => '").concat((0, n.escapeForSingleQuotes)(Q), "',")), Z.length && (E("'headers' => [", 1), E(Z.join(`
`)), E("],", 1)), b("$client = new \\GuzzleHttp\\Client();"), w(), _.length ? (b("$response = $client->request('".concat(l, "', '").concat(s, "', [")), b(O()), b("]);")) : b("$response = $client->request('".concat(l, "', '").concat(s, "');")), w(), b("echo $response->getBody();"), !p.noTags && p.closingTag && (w(), b("?>")), y();
    }
  }, ru;
}
var Bl = {}, dw;
function bne() {
  if (dw) return Bl;
  dw = 1, Bl.__esModule = !0, Bl.http1 = void 0;
  var e = Pn(), t = v1();
  return Bl.http1 = {
    info: {
      key: "http1",
      title: "HTTP v1",
      link: "http://php.net/manual/en/book.http.php",
      description: "PHP with pecl/http v1"
    },
    convert: function(n, r) {
      var i = n.method, a = n.url, o = n.postData, c = n.queryObj, u = n.headersObj, s = n.cookiesObj;
      r === void 0 && (r = {});
      var l = r.closingTag, d = l === void 0 ? !1 : l, f = r.indent, p = f === void 0 ? "  " : f, g = r.noTags, b = g === void 0 ? !1 : g, w = r.shortTags, y = w === void 0 ? !1 : w, v = new e.CodeBuilder({ indent: p }), _ = v.push, E = v.blank, O = v.join;
      switch (b || (_(y ? "<?" : "<?php"), E()), t.supportedMethods.includes(i.toUpperCase()) || _("HttpRequest::methodRegister('".concat(i, "');")), _("$request = new HttpRequest();"), _("$request->setUrl(".concat((0, t.convertType)(a), ");")), t.supportedMethods.includes(i.toUpperCase()) ? _("$request->setMethod(HTTP_METH_".concat(i.toUpperCase(), ");")) : _("$request->setMethod(HttpRequest::HTTP_METH_".concat(i.toUpperCase(), ");")), E(), Object.keys(c).length && (_("$request->setQueryData(".concat((0, t.convertType)(c, p), ");")), E()), Object.keys(u).length && (_("$request->setHeaders(".concat((0, t.convertType)(u, p), ");")), E()), Object.keys(s).length && (_("$request->setCookies(".concat((0, t.convertType)(s, p), ");")), E()), o.mimeType) {
        case "application/x-www-form-urlencoded":
          _("$request->setContentType(".concat((0, t.convertType)(o.mimeType), ");")), _("$request->setPostFields(".concat((0, t.convertType)(o.paramsObj, p), ");")), E();
          break;
        case "application/json":
          _("$request->setContentType(".concat((0, t.convertType)(o.mimeType), ");")), _("$request->setBody(json_encode(".concat((0, t.convertType)(o.jsonObj, p), "));")), E();
          break;
        default:
          o.text && (_("$request->setBody(".concat((0, t.convertType)(o.text), ");")), E());
      }
      return _("try {"), _("$response = $request->send();", 1), E(), _("echo $response->getBody();", 1), _("} catch (HttpException $ex) {"), _("echo $ex;", 1), _("}"), !b && d && (E(), _("?>")), O();
    }
  }, Bl;
}
var Ul = {}, hw;
function xne() {
  if (hw) return Ul;
  hw = 1, Ul.__esModule = !0, Ul.http2 = void 0;
  var e = Pn(), t = Wi(), n = v1();
  return Ul.http2 = {
    info: {
      key: "http2",
      title: "HTTP v2",
      link: "http://devel-m6w6.rhcloud.com/mdref/http",
      description: "PHP with pecl/http v2"
    },
    convert: function(r, i) {
      var a, o = r.postData, c = r.headersObj, u = r.method, s = r.queryObj, l = r.cookiesObj, d = r.url;
      i === void 0 && (i = {});
      var f = i.closingTag, p = f === void 0 ? !1 : f, g = i.indent, b = g === void 0 ? "  " : g, w = i.noTags, y = w === void 0 ? !1 : w, v = i.shortTags, _ = v === void 0 ? !1 : v, E = new e.CodeBuilder({ indent: b }), O = E.push, M = E.blank, L = E.join, Z = !1;
      switch (y || (O(_ ? "<?" : "<?php"), M()), O("$client = new http\\Client;"), O("$request = new http\\Client\\Request;"), M(), o.mimeType) {
        case "application/x-www-form-urlencoded":
          O("$body = new http\\Message\\Body;"), O("$body->append(new http\\QueryString(".concat((0, n.convertType)(o.paramsObj, b), "));")), M(), Z = !0;
          break;
        case "multipart/form-data": {
          if (!o.params)
            break;
          var Q = [], ae = {};
          o.params.forEach(function(Ce) {
            var J = Ce.name, ne = Ce.fileName, De = Ce.value, je = Ce.contentType;
            if (ne) {
              Q.push({
                name: J,
                type: je,
                file: ne,
                data: De
              });
              return;
            }
            De && (ae[J] = De);
          });
          var re = Object.keys(ae).length ? (0, n.convertType)(ae, b) : "null", X = Q.length ? (0, n.convertType)(Q, b) : "null";
          if (O("$body = new http\\Message\\Body;"), O("$body->addForm(".concat(re, ", ").concat(X, ");")), (0, t.hasHeader)(c, "content-type") && !((a = (0, t.getHeader)(c, "content-type")) === null || a === void 0) && a.indexOf("boundary")) {
            var de = (0, t.getHeaderName)(c, "content-type");
            de && delete c[de];
          }
          M(), Z = !0;
          break;
        }
        case "application/json":
          O("$body = new http\\Message\\Body;"), O("$body->append(json_encode(".concat((0, n.convertType)(o.jsonObj, b), "));")), Z = !0;
          break;
        default:
          o.text && (O("$body = new http\\Message\\Body;"), O("$body->append(".concat((0, n.convertType)(o.text), ");")), M(), Z = !0);
      }
      return O("$request->setRequestUrl(".concat((0, n.convertType)(d), ");")), O("$request->setRequestMethod(".concat((0, n.convertType)(u), ");")), Z && (O("$request->setBody($body);"), M()), Object.keys(s).length && (O("$request->setQuery(new http\\QueryString(".concat((0, n.convertType)(s, b), "));")), M()), Object.keys(c).length && (O("$request->setHeaders(".concat((0, n.convertType)(c, b), ");")), M()), Object.keys(l).length && (M(), O("$client->setCookies(".concat((0, n.convertType)(l, b), ");")), M()), O("$client->enqueue($request)->send();"), O("$response = $client->getResponse();"), M(), O("echo $response->getBody();"), !y && p && (M(), O("?>")), L();
    }
  }, Ul;
}
var mw;
function _ne() {
  if (mw) return Fl;
  mw = 1, Fl.__esModule = !0, Fl.php = void 0;
  var e = vne(), t = yne(), n = bne(), r = xne();
  return Fl.php = {
    info: {
      key: "php",
      title: "PHP",
      extname: ".php",
      default: "curl"
    },
    clientsById: {
      curl: e.curl,
      guzzle: t.guzzle,
      http1: n.http1,
      http2: r.http2
    }
  }, Fl;
}
var Hl = {}, zl = {}, Vl = {}, gw;
function GO() {
  if (gw) return Vl;
  gw = 1, Vl.__esModule = !0, Vl.generatePowershellConvert = void 0;
  var e = Pn(), t = ei(), n = Wi(), r = function(i) {
    var a = function(o) {
      var c = o.method, u = o.headersObj, s = o.cookies, l = o.uriObj, d = o.fullUrl, f = o.postData, p = o.allHeaders, g = new e.CodeBuilder(), b = g.push, w = g.join, y = [
        "DEFAULT",
        "DELETE",
        "GET",
        "HEAD",
        "MERGE",
        "OPTIONS",
        "PATCH",
        "POST",
        "PUT",
        "TRACE"
      ], v = y.includes(c.toUpperCase()) ? "-Method" : "-CustomMethod", _ = [], E = Object.keys(u);
      return E.length && (b("$headers=@{}"), E.forEach(function(O) {
        O !== "connection" && b('$headers.Add("'.concat(O, '", "').concat((0, t.escapeString)(u[O], { escapeChar: "`" }), '")'));
      }), _.push("-Headers $headers")), s.length && (b("$session = New-Object Microsoft.PowerShell.Commands.WebRequestSession"), s.forEach(function(O) {
        b("$cookie = New-Object System.Net.Cookie"), b("$cookie.Name = '".concat(O.name, "'")), b("$cookie.Value = '".concat(O.value, "'")), b("$cookie.Domain = '".concat(l.host, "'")), b("$session.Cookies.Add($cookie)");
      }), _.push("-WebSession $session")), f.text && (_.push("-ContentType '".concat((0, t.escapeString)((0, n.getHeader)(p, "content-type"), {
        delimiter: "'",
        escapeChar: "`"
      }), "'")), _.push("-Body '".concat(f.text, "'"))), b("$response = ".concat(i, " -Uri '").concat(d, "' ").concat(v, " ").concat(c, " ").concat(_.join(" "))), w();
    };
    return a;
  };
  return Vl.generatePowershellConvert = r, Vl;
}
var vw;
function wne() {
  if (vw) return zl;
  vw = 1, zl.__esModule = !0, zl.restmethod = void 0;
  var e = GO();
  return zl.restmethod = {
    info: {
      key: "restmethod",
      title: "Invoke-RestMethod",
      link: "https://docs.microsoft.com/en-us/powershell/module/Microsoft.PowerShell.Utility/Invoke-RestMethod",
      description: "Powershell Invoke-RestMethod client"
    },
    convert: (0, e.generatePowershellConvert)("Invoke-RestMethod")
  }, zl;
}
var Gl = {}, yw;
function Sne() {
  if (yw) return Gl;
  yw = 1, Gl.__esModule = !0, Gl.webrequest = void 0;
  var e = GO();
  return Gl.webrequest = {
    info: {
      key: "webrequest",
      title: "Invoke-WebRequest",
      link: "https://docs.microsoft.com/en-us/powershell/module/Microsoft.PowerShell.Utility/Invoke-WebRequest",
      description: "Powershell Invoke-WebRequest client"
    },
    convert: (0, e.generatePowershellConvert)("Invoke-WebRequest")
  }, Gl;
}
var bw;
function Cne() {
  if (bw) return Hl;
  bw = 1, Hl.__esModule = !0, Hl.powershell = void 0;
  var e = wne(), t = Sne();
  return Hl.powershell = {
    info: {
      key: "powershell",
      title: "Powershell",
      extname: ".ps1",
      default: "webrequest"
    },
    clientsById: {
      webrequest: t.webrequest,
      restmethod: e.restmethod
    }
  }, Hl;
}
var Wl = {}, Kl = {}, xw;
function kne() {
  if (xw) return Kl;
  xw = 1, Kl.__esModule = !0, Kl.python3 = void 0;
  var e = Pn(), t = ei();
  return Kl.python3 = {
    info: {
      key: "python3",
      title: "http.client",
      link: "https://docs.python.org/3/library/http.client.html",
      description: "Python3 HTTP Client"
    },
    convert: function(n, r) {
      var i = n.uriObj, a = i.path, o = i.protocol, c = i.host, u = n.postData, s = n.allHeaders, l = n.method;
      r === void 0 && (r = {});
      var d = r.insecureSkipVerify, f = d === void 0 ? !1 : d, p = new e.CodeBuilder(), g = p.push, b = p.blank, w = p.join;
      if (g("import http.client"), f && g("import ssl"), b(), o === "https:") {
        var y = f ? ", context = ssl._create_unverified_context()" : "";
        g('conn = http.client.HTTPSConnection("'.concat(c, '"').concat(y, ")")), b();
      } else
        g('conn = http.client.HTTPConnection("'.concat(c, '")')), b();
      var v = JSON.stringify(u.text);
      v && (g("payload = ".concat(v)), b());
      var _ = s, E = Object.keys(_).length;
      if (E === 1)
        for (var O in _)
          g("headers = { '".concat(O, `': "`).concat((0, t.escapeForDoubleQuotes)(_[O]), '" }')), b();
      else if (E > 1) {
        var M = 1;
        g("headers = {");
        for (var O in _)
          M++ !== E ? g("    '".concat(O, `': "`).concat((0, t.escapeForDoubleQuotes)(_[O]), '",')) : g("    '".concat(O, `': "`).concat((0, t.escapeForDoubleQuotes)(_[O]), '"'));
        g("}"), b();
      }
      return g(v && E ? 'conn.request("'.concat(l, '", "').concat(a, '", payload, headers)') : v && !E ? 'conn.request("'.concat(l, '", "').concat(a, '", payload)') : !v && E ? 'conn.request("'.concat(l, '", "').concat(a, '", headers=headers)') : 'conn.request("'.concat(l, '", "').concat(a, '")')), b(), g("res = conn.getresponse()"), g("data = res.read()"), b(), g('print(data.decode("utf-8"))'), w();
    }
  }, Kl;
}
var nu = {}, l3 = {}, _w;
function Ane() {
  return _w || (_w = 1, (function(e) {
    e.__esModule = !0, e.literalRepresentation = void 0;
    function t(r, i, a, o, c) {
      var u = o.repeat(c), s = o.repeat(c - 1), l = a ? `,
`.concat(u) : ", ", d = r === "object" ? "{" : "[", f = r === "object" ? "}" : "]";
      return a ? "".concat(d, `
`).concat(u).concat(i.join(l), `
`).concat(s).concat(f) : r === "object" && i.length > 0 ? "".concat(d, " ").concat(i.join(l), " ").concat(f) : "".concat(d).concat(i.join(l)).concat(f);
    }
    var n = function(r, i, a) {
      switch (a = a === void 0 ? 1 : a + 1, Object.prototype.toString.call(r)) {
        case "[object Number]":
          return r;
        case "[object Array]": {
          var o = !1, c = r.map(function(l) {
            return Object.prototype.toString.call(l) === "[object Object]" && (o = Object.keys(l).length > 1), (0, e.literalRepresentation)(l, i, a);
          });
          return t("array", c, o, i.indent, a);
        }
        case "[object Object]": {
          var u = [];
          for (var s in r)
            u.push('"'.concat(s, '": ').concat((0, e.literalRepresentation)(r[s], i, a)));
          return t("object", u, i.pretty && u.length > 1, i.indent, a);
        }
        case "[object Null]":
          return "None";
        case "[object Boolean]":
          return r ? "True" : "False";
        default:
          return r == null ? "" : '"'.concat(r.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = n;
  })(l3)), l3;
}
var ww;
function Ene() {
  if (ww) return nu;
  ww = 1;
  var e = nu && nu.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var l in c) Object.prototype.hasOwnProperty.call(c, l) && (o[l] = c[l]);
      }
      return o;
    }, e.apply(this, arguments);
  };
  nu.__esModule = !0, nu.requests = void 0;
  var t = Pn(), n = ei(), r = Wi(), i = Ane(), a = ["HEAD", "GET", "POST", "PUT", "PATCH", "DELETE", "OPTIONS"];
  return nu.requests = {
    info: {
      key: "requests",
      title: "Requests",
      link: "http://docs.python-requests.org/en/latest/api/#requests.request",
      description: "Requests HTTP library"
    },
    convert: function(o, c) {
      var u = o.queryObj, s = o.url, l = o.postData, d = o.allHeaders, f = o.method, p = e({ indent: "    ", pretty: !0 }, c), g = new t.CodeBuilder({ indent: p.indent }), b = g.push, w = g.blank, y = g.join;
      b("import requests"), w(), b('url = "'.concat(s, '"')), w();
      var v;
      Object.keys(u).length && (v = "querystring = ".concat(JSON.stringify(u)), b(v), w());
      var _ = d, E = {}, O = {}, M = !1, L = !1, Z = !1;
      switch (l.mimeType) {
        case "application/json":
          l.jsonObj && (b("payload = ".concat((0, i.literalRepresentation)(l.jsonObj, p))), Z = !0, L = !0);
          break;
        case "multipart/form-data":
          if (!l.params)
            break;
          if (E = {}, l.params.forEach(function(ne) {
            ne.fileName ? (O[ne.name] = "open('".concat(ne.fileName, "', 'rb')"), M = !0) : (E[ne.name] = ne.value, L = !0);
          }), M) {
            b("files = ".concat((0, i.literalRepresentation)(O, p))), L && b("payload = ".concat((0, i.literalRepresentation)(E, p)));
            var Q = (0, r.getHeaderName)(_, "content-type");
            Q && delete _[Q];
          } else {
            var ae = JSON.stringify(l.text);
            ae && (b("payload = ".concat(ae)), L = !0);
          }
          break;
        default: {
          if (l.mimeType === "application/x-www-form-urlencoded" && l.paramsObj) {
            b("payload = ".concat((0, i.literalRepresentation)(l.paramsObj, p))), L = !0;
            break;
          }
          var re = JSON.stringify(l.text);
          re && (b("payload = ".concat(re)), L = !0);
        }
      }
      var X = Object.keys(_).length;
      if (X === 0 && (L || M))
        w();
      else if (X === 1)
        for (var de in _)
          b('headers = {"'.concat(de, '": "').concat((0, n.escapeForDoubleQuotes)(_[de]), '"}')), w();
      else if (X > 1) {
        var Ce = 1;
        b("headers = {");
        for (var de in _)
          b(Ce !== X ? '"'.concat(de, '": "').concat((0, n.escapeForDoubleQuotes)(_[de]), '",') : '"'.concat(de, '": "').concat((0, n.escapeForDoubleQuotes)(_[de]), '"'), 1), Ce += 1;
        b("}"), w();
      }
      var J = a.includes(f) ? "response = requests.".concat(f.toLowerCase(), "(url") : 'response = requests.request("'.concat(f, '", url');
      return L && (Z ? J += ", json=payload" : J += ", data=payload"), M && (J += ", files=files"), X > 0 && (J += ", headers=headers"), v && (J += ", params=querystring"), J += ")", b(J), w(), b("print(response.json())"), y();
    }
  }, nu;
}
var Sw;
function One() {
  if (Sw) return Wl;
  Sw = 1, Wl.__esModule = !0, Wl.python = void 0;
  var e = kne(), t = Ene();
  return Wl.python = {
    info: {
      key: "python",
      title: "Python",
      extname: ".py",
      default: "python3"
    },
    clientsById: {
      python3: e.python3,
      requests: t.requests
    }
  }, Wl;
}
var Zl = {}, iu = {}, Cw;
function Tne() {
  if (Cw) return iu;
  Cw = 1;
  var e = iu && iu.__read || function(i, a) {
    var o = typeof Symbol == "function" && i[Symbol.iterator];
    if (!o) return i;
    var c = o.call(i), u, s = [], l;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) s.push(u.value);
    } catch (d) {
      l = { error: d };
    } finally {
      try {
        u && !u.done && (o = c.return) && o.call(c);
      } finally {
        if (l) throw l.error;
      }
    }
    return s;
  };
  iu.__esModule = !0, iu.httr = void 0;
  var t = Pn(), n = ei(), r = Wi();
  return iu.httr = {
    info: {
      key: "httr",
      title: "httr",
      link: "https://cran.r-project.org/web/packages/httr/vignettes/quickstart.html",
      description: "httr: Tools for Working with URLs and HTTP"
    },
    convert: function(i, a) {
      var o, c = i.url, u = i.queryObj, s = i.queryString, l = i.postData, d = i.allHeaders, f = i.method;
      a === void 0 && (a = {});
      var p = new t.CodeBuilder({
        indent: (o = a.indent) !== null && o !== void 0 ? o : "  "
      }), g = p.push, b = p.blank, w = p.join;
      g("library(httr)"), b(), g('url <- "'.concat(c, '"')), b();
      var y = u;
      delete u.key;
      var v = Object.entries(y), _ = v.length;
      if (_ === 1) {
        var E = v[0];
        g("queryString <- list(".concat(E[0], ' = "').concat(E[1], '")')), b();
      } else _ > 1 && (g("queryString <- list("), v.forEach(function(J, ne) {
        var De = e(J, 2), je = De[0], Me = De[1], qe = ne !== _ - 1, Ve = qe ? "," : "";
        g("".concat(je, ' = "').concat(Me, '"').concat(Ve), 1);
      }), g(")"), b());
      var O = JSON.stringify(l.text);
      if (O && (g("payload <- ".concat(O)), b()), l.text || l.jsonObj || l.params)
        switch (l.mimeType) {
          case "application/x-www-form-urlencoded":
            g('encode <- "form"'), b();
            break;
          case "application/json":
            g('encode <- "json"'), b();
            break;
          case "multipart/form-data":
            g('encode <- "multipart"'), b();
            break;
          default:
            g('encode <- "raw"'), b();
            break;
        }
      var M = (0, r.getHeader)(d, "cookie"), L = (0, r.getHeader)(d, "accept"), Z = M ? "set_cookies(`".concat(String(M).replace(/;/g, '", `').replace(/` /g, "`").replace(/[=]/g, '` = "'), '")') : void 0, Q = L ? 'accept("'.concat((0, n.escapeForDoubleQuotes)(L), '")') : void 0, ae = 'content_type("'.concat((0, n.escapeForDoubleQuotes)(l.mimeType), '")'), re = Object.entries(d).filter(function(J) {
        var ne = e(J, 1), De = ne[0];
        return !["cookie", "accept", "content-type"].includes(De.toLowerCase());
      }).map(function(J) {
        var ne = e(J, 2), De = ne[0], je = ne[1];
        return "'".concat(De, "' = '").concat((0, n.escapeForSingleQuotes)(je), "'");
      }).join(", "), X = re ? "add_headers(".concat(re, ")") : void 0, de = 'response <- VERB("'.concat(f, '", url');
      O && (de += ", body = payload"), s.length && (de += ", query = queryString");
      var Ce = [X, ae, Q, Z].filter(function(J) {
        return !!J;
      }).join(", ");
      return Ce && (de += ", ".concat(Ce)), (l.text || l.jsonObj || l.params) && (de += ", encode = encode"), de += ")", g(de), b(), g('content(response, "text")'), w();
    }
  }, iu;
}
var kw;
function Pne() {
  if (kw) return Zl;
  kw = 1, Zl.__esModule = !0, Zl.r = void 0;
  var e = Tne();
  return Zl.r = {
    info: {
      key: "r",
      title: "R",
      extname: ".r",
      default: "httr"
    },
    clientsById: {
      httr: e.httr
    }
  }, Zl;
}
var Yl = {}, Jl = {}, Aw;
function Rne() {
  if (Aw) return Jl;
  Aw = 1, Jl.__esModule = !0, Jl.faraday = void 0;
  var e = Pn(), t = ei();
  return Jl.faraday = {
    info: {
      key: "faraday",
      title: "faraday",
      link: "https://github.com/lostisland/faraday",
      description: "Faraday HTTP client"
    },
    convert: function(n) {
      var r = n.uriObj, i = n.queryObj, a = n.method, o = n.postData, c = n.allHeaders, u = new e.CodeBuilder(), s = u.push, l = u.blank, d = u.join, f = a.toUpperCase(), p = [
        "GET",
        "POST",
        "HEAD",
        "DELETE",
        "PATCH",
        "PUT",
        "OPTIONS",
        "COPY",
        "LOCK",
        "UNLOCK",
        "MOVE",
        "TRACE"
      ];
      if (!p.includes(f))
        return s("# Faraday cannot currently run ".concat(f, " requests. Please use another client.")), d();
      s("require 'faraday'"), l(), o.mimeType === "application/x-www-form-urlencoded" && o.params && (s("data = {"), o.params.forEach(function(b) {
        s("  :".concat(b.name, " => ").concat(JSON.stringify(b.value), ","));
      }), s("}"), l()), s("conn = Faraday.new("), s("  url: '".concat(r.protocol, "//").concat(r.host, "',")), (c["content-type"] || c["Content-Type"]) && s("  headers: {'Content-Type' => '".concat(c["content-type"] || c["Content-Type"], "'}")), s(")"), l(), s("response = conn.".concat(f.toLowerCase(), "('").concat(r.pathname, "') do |req|"));
      var g = Object.keys(c);
      switch (g.length && g.forEach(function(b) {
        b.toLowerCase() !== "content-type" && s("  req.headers['".concat(b, "'] = '").concat((0, t.escapeForSingleQuotes)(c[b]), "'"));
      }), Object.keys(i).forEach(function(b) {
        var w = i[b];
        Array.isArray(w) ? s("  req.params['".concat(b, "'] = ").concat(JSON.stringify(w))) : s("  req.params['".concat(b, "'] = '").concat(w, "'"));
      }), o.mimeType) {
        case "application/x-www-form-urlencoded":
          o.params && s("  req.body = URI.encode_www_form(data)");
          break;
        case "application/json":
          o.jsonObj && s("  req.body = ".concat(JSON.stringify(o.text)));
          break;
        default:
          o.text && s("  req.body = ".concat(JSON.stringify(o.text)));
      }
      return s("end"), l(), s("puts response.status"), s("puts response.body"), d();
    }
  }, Jl;
}
var Ql = {}, Ew;
function Ine() {
  if (Ew) return Ql;
  Ew = 1, Ql.__esModule = !0, Ql.native = void 0;
  var e = Pn(), t = ei();
  return Ql.native = {
    info: {
      key: "native",
      title: "net::http",
      link: "http://ruby-doc.org/stdlib-2.2.1/libdoc/net/http/rdoc/Net/HTTP.html",
      description: "Ruby HTTP client"
    },
    convert: function(n, r) {
      var i = n.uriObj, a = n.method, o = n.fullUrl, c = n.postData, u = n.allHeaders;
      r === void 0 && (r = {});
      var s = r.insecureSkipVerify, l = s === void 0 ? !1 : s, d = new e.CodeBuilder(), f = d.push, p = d.blank, g = d.join;
      f("require 'uri'"), f("require 'net/http'"), p();
      var b = a.toUpperCase(), w = [
        "GET",
        "POST",
        "HEAD",
        "DELETE",
        "PATCH",
        "PUT",
        "OPTIONS",
        "COPY",
        "LOCK",
        "UNLOCK",
        "MOVE",
        "TRACE"
      ], y = b.charAt(0) + b.substring(1).toLowerCase();
      w.includes(b) || (f("class Net::HTTP::".concat(y, " < Net::HTTPRequest")), f("  METHOD = '".concat(b.toUpperCase(), "'")), f("  REQUEST_HAS_BODY = '".concat(c.text ? "true" : "false", "'")), f("  RESPONSE_HAS_BODY = true"), f("end"), p()), f('url = URI("'.concat(o, '")')), p(), f("http = Net::HTTP.new(url.host, url.port)"), i.protocol === "https:" && (f("http.use_ssl = true"), l && f("http.verify_mode = OpenSSL::SSL::VERIFY_NONE")), p(), f("request = Net::HTTP::".concat(y, ".new(url)"));
      var v = Object.keys(u);
      return v.length && v.forEach(function(_) {
        f('request["'.concat(_, `"] = '`).concat((0, t.escapeForSingleQuotes)(u[_]), "'"));
      }), c.text && f("request.body = ".concat(JSON.stringify(c.text))), p(), f("response = http.request(request)"), f("puts response.read_body"), g();
    }
  }, Ql;
}
var Ow;
function jne() {
  if (Ow) return Yl;
  Ow = 1, Yl.__esModule = !0, Yl.ruby = void 0;
  var e = Rne(), t = Ine();
  return Yl.ruby = {
    info: {
      key: "ruby",
      title: "Ruby",
      extname: ".rb",
      default: "native"
    },
    clientsById: {
      native: t.native,
      faraday: e.faraday
    }
  }, Yl;
}
var Xl = {}, Ya = {}, f3 = {}, Tw;
function qne() {
  return Tw || (Tw = 1, (function(e) {
    e.__esModule = !0, e.literalRepresentation = void 0;
    function t(r, i, a, o, c) {
      var u = o.repeat(c), s = o.repeat(c - 1), l = a ? `,
`.concat(u) : ", ", d = r === "object" ? "json!({" : "(", f = r === "object" ? "})" : ")";
      return a ? "".concat(d, `
`).concat(u).concat(i.join(l), `
`).concat(s).concat(f) : "".concat(d).concat(i.join(l)).concat(f);
    }
    var n = function(r, i, a) {
      switch (a = a === void 0 ? 1 : a + 1, Object.prototype.toString.call(r)) {
        case "[object Number]":
          return r;
        case "[object Array]": {
          var o = !1, c = r.map(function(l) {
            return Object.prototype.toString.call(l) === "[object Object]" && (o = Object.keys(l).length > 1), (0, e.literalRepresentation)(l, i, a);
          });
          return t("array", c, o, i.indent, a);
        }
        case "[object Object]": {
          var u = [];
          for (var s in r)
            u.push('"'.concat(s, '": ').concat((0, e.literalRepresentation)(r[s], i, a)));
          return t("object", u, i.pretty && u.length > 1, i.indent, a);
        }
        case "[object Null]":
          return "json!(null)";
        case "[object Boolean]":
          return r ? "true" : "false";
        default:
          return r == null ? "" : '"'.concat(r.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = n;
  })(f3)), f3;
}
var Pw;
function Dne() {
  if (Pw) return Ya;
  Pw = 1;
  var e = Ya && Ya.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var l in c) Object.prototype.hasOwnProperty.call(c, l) && (o[l] = c[l]);
      }
      return o;
    }, e.apply(this, arguments);
  }, t = Ya && Ya.__values || function(o) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = c && o[c], s = 0;
    if (u) return u.call(o);
    if (o && typeof o.length == "number") return {
      next: function() {
        return o && s >= o.length && (o = void 0), { value: o && o[s++], done: !o };
      }
    };
    throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, n = Ya && Ya.__read || function(o, c) {
    var u = typeof Symbol == "function" && o[Symbol.iterator];
    if (!u) return o;
    var s = u.call(o), l, d = [], f;
    try {
      for (; (c === void 0 || c-- > 0) && !(l = s.next()).done; ) d.push(l.value);
    } catch (p) {
      f = { error: p };
    } finally {
      try {
        l && !l.done && (u = s.return) && u.call(s);
      } finally {
        if (f) throw f.error;
      }
    }
    return d;
  };
  Ya.__esModule = !0, Ya.reqwest = void 0;
  var r = Pn(), i = qne();
  Ya.reqwest = {
    info: {
      key: "reqwest",
      title: "reqwest",
      link: "https://docs.rs/reqwest/latest/reqwest/",
      description: "reqwest HTTP library"
    },
    convert: function(o, c) {
      var u, s, l, d, f, p, g, b, w, y, v = o.queryObj, _ = o.url, E = o.postData, O = o.allHeaders, M = o.method, L = e({ indent: "    ", pretty: !0 }, c), Z = 0, Q = new r.CodeBuilder({ indent: L.indent }), ae = Q.push, re = Q.blank, X = Q.join, de = Q.pushToLast, Ce = Q.unshift;
      ae("use reqwest;", Z), re(), ae("#[tokio::main]", Z), ae("pub async fn main() {", Z), Z += 1, ae('let url = "'.concat(_, '";'), Z), re();
      var J = !1;
      if (Object.keys(v).length) {
        J = !0, ae("let querystring = [", Z), Z += 1;
        try {
          for (var ne = t(Object.entries(v)), De = ne.next(); !De.done; De = ne.next()) {
            var je = n(De.value, 2), Me = je[0], qe = je[1];
            ae('("'.concat(Me, '", "').concat(qe, '"),'), Z);
          }
        } catch (Le) {
          u = { error: Le };
        } finally {
          try {
            De && !De.done && (s = ne.return) && s.call(ne);
          } finally {
            if (u) throw u.error;
          }
        }
        Z -= 1, ae("];", Z), re();
      }
      var Ve = {}, xe = {}, ve = !1, Ae = !1, Ue = !1, qt = !1, Ze = !1;
      switch (E.mimeType) {
        case "application/json":
          E.jsonObj && ae("let payload = ".concat((0, i.literalRepresentation)(E.jsonObj, L, Z), ";"), Z), qt = !0;
          break;
        case "multipart/form-data":
          if (Ze = !0, !E.params) {
            ae("let form = reqwest::multipart::Form::new()", Z), ae('.text("", "");', Z + 1);
            break;
          }
          if (Ve = {}, E.params.forEach(function(Le) {
            Le.fileName ? (xe[Le.name] = Le.fileName, ve = !0) : Ve[Le.name] = Le.value;
          }), ve) {
            try {
              for (var At = t(a), He = At.next(); !He.done; He = At.next()) {
                var Dt = He.value;
                ae(Dt, Z);
              }
            } catch (Le) {
              l = { error: Le };
            } finally {
              try {
                He && !He.done && (d = At.return) && d.call(At);
              } finally {
                if (l) throw l.error;
              }
            }
            re();
          }
          ae("let form = reqwest::multipart::Form::new()", Z);
          try {
            for (var Fe = t(Object.entries(xe)), Xe = Fe.next(); !Xe.done; Xe = Fe.next()) {
              var ze = n(Xe.value, 2), Rt = ze[0], Yt = ze[1];
              ae('.part("'.concat(Rt, '", file_to_part("').concat(Yt, '").await)'), Z + 1);
            }
          } catch (Le) {
            f = { error: Le };
          } finally {
            try {
              Xe && !Xe.done && (p = Fe.return) && p.call(Fe);
            } finally {
              if (f) throw f.error;
            }
          }
          try {
            for (var ye = t(Object.entries(Ve)), W = ye.next(); !W.done; W = ye.next()) {
              var Y = n(W.value, 2), Rt = Y[0], qe = Y[1];
              ae('.text("'.concat(Rt, '", "').concat(qe, '")'), Z + 1);
            }
          } catch (Le) {
            g = { error: Le };
          } finally {
            try {
              W && !W.done && (b = ye.return) && b.call(ye);
            } finally {
              if (g) throw g.error;
            }
          }
          de(";");
          break;
        default: {
          if (E.mimeType === "application/x-www-form-urlencoded" && E.paramsObj) {
            ae("let payload = ".concat((0, i.literalRepresentation)(E.paramsObj, L, Z), ";"), Z), Ae = !0;
            break;
          }
          if (E.text) {
            ae("let payload = ".concat((0, i.literalRepresentation)(E.text, L, Z), ";"), Z), Ue = !0;
            break;
          }
        }
      }
      (Ae || qt || Ue) && (Ce("use serde_json::json;"), re());
      var ie = !1;
      if (Object.keys(O).length) {
        ie = !0, ae("let mut headers = reqwest::header::HeaderMap::new();", Z);
        try {
          for (var Te = t(Object.entries(O)), $ = Te.next(); !$.done; $ = Te.next()) {
            var _e = n($.value, 2), Me = _e[0], qe = _e[1];
            Me.toLowerCase() === "content-type" && Ze || ae('headers.insert("'.concat(Me, '", ').concat((0, i.literalRepresentation)(qe, L), ".parse().unwrap());"), Z);
          }
        } catch (Le) {
          w = { error: Le };
        } finally {
          try {
            $ && !$.done && (y = Te.return) && y.call(Te);
          } finally {
            if (w) throw w.error;
          }
        }
        re();
      }
      switch (ae("let client = reqwest::Client::new();", Z), M) {
        case "POST":
          ae("let response = client.post(url)", Z);
          break;
        case "GET":
          ae("let response = client.get(url)", Z);
          break;
        default: {
          ae('let response = client.request(reqwest::Method::from_str("'.concat(M, '").unwrap(), url)'), Z), Ce("use std::str::FromStr;");
          break;
        }
      }
      return J && ae(".query(&querystring)", Z + 1), Ze && ae(".multipart(form)", Z + 1), ie && ae(".headers(headers)", Z + 1), qt && ae(".json(&payload)", Z + 1), Ae && ae(".form(&payload)", Z + 1), Ue && ae(".body(payload)", Z + 1), ae(".send()", Z + 1), ae(".await;", Z + 1), re(), ae("let results = response.unwrap()", Z), ae(".json::<serde_json::Value>()", Z + 1), ae(".await", Z + 1), ae(".unwrap();", Z + 1), re(), ae("dbg!(results);", Z), ae(`}
`), X();
    }
  };
  var a = [
    "async fn file_to_part(file_name: &'static str) -> reqwest::multipart::Part {",
    "    let file = tokio::fs::File::open(file_name).await.unwrap();",
    "    let stream = tokio_util::codec::FramedRead::new(file, tokio_util::codec::BytesCodec::new());",
    "    let body = reqwest::Body::wrap_stream(stream);",
    "    reqwest::multipart::Part::stream(body)",
    "        .file_name(file_name)",
    '        .mime_str("text/plain").unwrap()',
    "}"
  ];
  return Ya;
}
var Rw;
function $ne() {
  if (Rw) return Xl;
  Rw = 1, Xl.__esModule = !0, Xl.rust = void 0;
  var e = Dne();
  return Xl.rust = {
    info: {
      key: "rust",
      title: "Rust",
      extname: ".rs",
      default: "reqwest"
    },
    clientsById: {
      reqwest: e.reqwest
    }
  }, Xl;
}
var ef = {}, au = {}, ou = {}, Iw;
function Og() {
  if (Iw) return ou;
  Iw = 1, ou.__esModule = !0, ou.escape = ou.quote = void 0;
  var e = function(n) {
    n === void 0 && (n = "");
    var r = /^[a-z0-9-_/.@%^=:]+$/i, i = r.test(n);
    return i ? n : "'".concat(n.replace(/'/g, "'\\''"), "'");
  };
  ou.quote = e;
  var t = function(n) {
    return n.replace(/\r/g, "\\r").replace(/\n/g, "\\n");
  };
  return ou.escape = t, ou;
}
var jw;
function Lne() {
  if (jw) return au;
  jw = 1;
  var e = au && au.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var l in c) Object.prototype.hasOwnProperty.call(c, l) && (o[l] = c[l]);
      }
      return o;
    }, e.apply(this, arguments);
  };
  au.__esModule = !0, au.curl = void 0;
  var t = Pn(), n = Wi(), r = Og(), i = {
    "http1.0": "0",
    "url ": "",
    cookie: "b",
    data: "d",
    form: "F",
    globoff: "g",
    header: "H",
    insecure: "k",
    request: "X"
  }, a = function(o) {
    return function(c) {
      if (o) {
        var u = i[c];
        return u ? "-".concat(u) : "";
      }
      return "--".concat(c);
    };
  };
  return au.curl = {
    info: {
      key: "curl",
      title: "cURL",
      link: "http://curl.haxx.se/",
      description: "cURL is a command line tool and library for transferring data with URL syntax"
    },
    convert: function(o, c) {
      var u, s = o.fullUrl, l = o.method, d = o.httpVersion, f = o.headersObj, p = o.allHeaders, g = o.postData;
      c === void 0 && (c = {});
      var b = c.binary, w = b === void 0 ? !1 : b, y = c.globOff, v = y === void 0 ? !1 : y, _ = c.indent, E = _ === void 0 ? "  " : _, O = c.insecureSkipVerify, M = O === void 0 ? !1 : O, L = c.prettifyJson, Z = L === void 0 ? !1 : L, Q = c.short, ae = Q === void 0 ? !1 : Q, re = new t.CodeBuilder(e(e({}, typeof E == "string" ? { indent: E } : {}), { join: E !== !1 ? ` \\
`.concat(E) : " " })), X = re.push, de = re.join, Ce = a(ae), J = (0, r.quote)(s);
      if (X("curl ".concat(Ce("request"), " ").concat(l)), v && (J = unescape(J), X(Ce("globoff"))), X("".concat(Ce("url ")).concat(J)), M && X(Ce("insecure")), d === "HTTP/1.0" && X(Ce("http1.0")), (0, n.getHeader)(p, "accept-encoding") && X("--compressed"), g.mimeType === "multipart/form-data") {
        var ne = (0, n.getHeaderName)(f, "content-type");
        if (ne) {
          var De = f[ne];
          if (ne && De) {
            var je = De.replace(/; boundary.+?(?=(;|$))/, "");
            f[ne] = je, p[ne] = je;
          }
        }
      }
      switch (Object.keys(f).sort().forEach(function(Ae) {
        var Ue = "".concat(Ae, ": ").concat(f[Ae]);
        X("".concat(Ce("header"), " ").concat((0, r.quote)(Ue)));
      }), p.cookie && X("".concat(Ce("cookie"), " ").concat((0, r.quote)(p.cookie))), g.mimeType) {
        case "multipart/form-data":
          (u = g.params) === null || u === void 0 || u.forEach(function(Ae) {
            var Ue = "";
            Ae.fileName ? Ue = "".concat(Ae.name, "=@").concat(Ae.fileName) : Ue = "".concat(Ae.name, "=").concat(Ae.value), X("".concat(Ce("form"), " ").concat((0, r.quote)(Ue)));
          });
          break;
        case "application/x-www-form-urlencoded":
          g.params ? g.params.forEach(function(Ae) {
            var Ue = Ae.name, qt = encodeURIComponent(Ae.name), Ze = qt !== Ue, At = Ze ? qt : Ue, He = w ? "--data-binary" : "--data".concat(Ze ? "-urlencode" : "");
            X("".concat(He, " ").concat((0, r.quote)("".concat(At, "=").concat(Ae.value))));
          }) : X("".concat(w ? "--data-binary" : Ce("data"), " ").concat((0, r.quote)(g.text)));
          break;
        default: {
          if (!g.text)
            break;
          var Me = w ? "--data-binary" : Ce("data"), qe = !1;
          if ((0, n.isMimeTypeJSON)(g.mimeType)) {
            var Ve = g.text.length > 2;
            if (Ve && Z)
              try {
                var xe = JSON.parse(g.text);
                qe = !0;
                var ve = JSON.stringify(xe, void 0, E);
                g.text.indexOf("'") > 0 ? X("".concat(Me, ` @- <<EOF
`).concat(ve, `
EOF`)) : X("".concat(Me, ` '
`).concat(ve, `
'`));
              } catch {
              }
          }
          qe || X("".concat(Me, " ").concat((0, r.quote)(g.text)));
        }
      }
      return de();
    }
  }, au;
}
var su = {}, qw;
function Nne() {
  if (qw) return su;
  qw = 1;
  var e = su && su.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  su.__esModule = !0, su.httpie = void 0;
  var t = Pn(), n = Og();
  return su.httpie = {
    info: {
      key: "httpie",
      title: "HTTPie",
      link: "http://httpie.org/",
      description: "a CLI, cURL-like tool for humans"
    },
    convert: function(r, i) {
      var a = r.allHeaders, o = r.postData, c = r.queryObj, u = r.fullUrl, s = r.method, l = r.url, d = e({ body: !1, cert: !1, headers: !1, indent: "  ", pretty: !1, print: !1, queryParams: !1, short: !1, style: !1, timeout: !1, verbose: !1, verify: !1 }, i), f = new t.CodeBuilder({
        indent: d.indent,
        // @ts-expect-error SEEMS LEGIT
        join: d.indent !== !1 ? ` \\
`.concat(d.indent) : " "
      }), p = f.push, g = f.join, b = f.unshift, w = !1, y = [];
      d.headers && y.push(d.short ? "-h" : "--headers"), d.body && y.push(d.short ? "-b" : "--body"), d.verbose && y.push(d.short ? "-v" : "--verbose"), d.print && y.push("".concat(d.short ? "-p" : "--print", "=").concat(d.print)), d.verify && y.push("--verify=".concat(d.verify)), d.cert && y.push("--cert=".concat(d.cert)), d.pretty && y.push("--pretty=".concat(d.pretty)), d.style && y.push("--style=".concat(d.style)), d.timeout && y.push("--timeout=".concat(d.timeout)), d.queryParams && Object.keys(c).forEach(function(E) {
        var O = c[E];
        Array.isArray(O) ? O.forEach(function(M) {
          p("".concat(E, "==").concat((0, n.quote)(M)));
        }) : p("".concat(E, "==").concat((0, n.quote)(O)));
      }), Object.keys(a).sort().forEach(function(E) {
        p("".concat(E, ":").concat((0, n.quote)(a[E])));
      }), o.mimeType === "application/x-www-form-urlencoded" ? o.params && o.params.length && (y.push(d.short ? "-f" : "--form"), o.params.forEach(function(E) {
        p("".concat(E.name, "=").concat((0, n.quote)(E.value)));
      })) : w = !0;
      var v = y.length ? "".concat(y.join(" "), " ") : "";
      if (l = (0, n.quote)(d.queryParams ? l : u), b("http ".concat(v).concat(s, " ").concat(l)), w && o.text) {
        var _ = (0, n.quote)(o.text);
        b("echo ".concat(_, " | "));
      }
      return g();
    }
  }, su;
}
var uu = {}, Dw;
function Fne() {
  if (Dw) return uu;
  Dw = 1;
  var e = uu && uu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  uu.__esModule = !0, uu.wget = void 0;
  var t = Pn(), n = Og();
  return uu.wget = {
    info: {
      key: "wget",
      title: "Wget",
      link: "https://www.gnu.org/software/wget/",
      description: "a free software package for retrieving files using HTTP, HTTPS"
    },
    convert: function(r, i) {
      var a = r.method, o = r.postData, c = r.allHeaders, u = r.fullUrl, s = e({ indent: "  ", short: !1, verbose: !1 }, i), l = new t.CodeBuilder({
        indent: s.indent,
        // @ts-expect-error SEEMS LEGIT
        join: s.indent !== !1 ? ` \\
`.concat(s.indent) : " "
      }), d = l.push, f = l.join;
      return s.verbose ? d("wget ".concat(s.short ? "-v" : "--verbose")) : d("wget ".concat(s.short ? "-q" : "--quiet")), d("--method ".concat((0, n.quote)(a))), Object.keys(c).forEach(function(p) {
        var g = "".concat(p, ": ").concat(c[p]);
        d("--header ".concat((0, n.quote)(g)));
      }), o.text && d("--body-data ".concat((0, n.escape)((0, n.quote)(o.text)))), d(s.short ? "-O" : "--output-document"), d("- ".concat((0, n.quote)(u))), f();
    }
  }, uu;
}
var $w;
function Mne() {
  if ($w) return ef;
  $w = 1, ef.__esModule = !0, ef.shell = void 0;
  var e = Lne(), t = Nne(), n = Fne();
  return ef.shell = {
    info: {
      key: "shell",
      title: "Shell",
      extname: ".sh",
      default: "curl"
    },
    clientsById: {
      curl: e.curl,
      httpie: t.httpie,
      wget: n.wget
    }
  }, ef;
}
var tf = {}, Qo = {}, p3 = {}, Lw;
function Bne() {
  return Lw || (Lw = 1, (function(e) {
    e.__esModule = !0, e.literalRepresentation = e.literalDeclaration = void 0;
    var t = function(a, o) {
      return o.repeat(a);
    }, n = function(a, o, c, u) {
      var s = t(u, c), l = t(u - 1, c), d = o ? `,
`.concat(s) : ", ";
      return o ? `[
`.concat(s).concat(a.join(d), `
`).concat(l, "]") : "[".concat(a.join(d), "]");
    }, r = function(a, o, c) {
      return "let ".concat(a, " = ").concat((0, e.literalRepresentation)(o, c));
    };
    e.literalDeclaration = r;
    var i = function(a, o, c) {
      switch (c = c === void 0 ? 1 : c + 1, Object.prototype.toString.call(a)) {
        case "[object Number]":
          return a;
        case "[object Array]": {
          var u = !1, s = a.map(function(f) {
            return Object.prototype.toString.call(f) === "[object Object]" && (u = Object.keys(f).length > 1), (0, e.literalRepresentation)(f, o, c);
          });
          return n(s, u, o.indent, c);
        }
        case "[object Object]": {
          var l = [];
          for (var d in a)
            l.push('"'.concat(d, '": ').concat((0, e.literalRepresentation)(a[d], o, c)));
          return n(
            l,
            // @ts-expect-error needs better types
            o.pretty && l.length > 1,
            // @ts-expect-error needs better types
            o.indent,
            c
          );
        }
        case "[object Boolean]":
          return a.toString();
        default:
          return a == null ? "" : '"'.concat(a.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = i;
  })(p3)), p3;
}
var Nw;
function Une() {
  if (Nw) return Qo;
  Nw = 1;
  var e = Qo && Qo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Qo && Qo.__read || function(i, a) {
    var o = typeof Symbol == "function" && i[Symbol.iterator];
    if (!o) return i;
    var c = o.call(i), u, s = [], l;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) s.push(u.value);
    } catch (d) {
      l = { error: d };
    } finally {
      try {
        u && !u.done && (o = c.return) && o.call(c);
      } finally {
        if (l) throw l.error;
      }
    }
    return s;
  };
  Qo.__esModule = !0, Qo.nsurlsession = void 0;
  var n = Pn(), r = Bne();
  return Qo.nsurlsession = {
    info: {
      key: "nsurlsession",
      title: "NSURLSession",
      link: "https://developer.apple.com/library/mac/documentation/Foundation/Reference/NSURLSession_class/index.html",
      description: "Foundation's NSURLSession request"
    },
    convert: function(i, a) {
      var o, c = i.allHeaders, u = i.postData, s = i.fullUrl, l = i.method, d = e({ indent: "  ", pretty: !0, timeout: "10" }, a), f = new n.CodeBuilder({ indent: d.indent }), p = f.push, g = f.blank, b = f.join, w = {
        hasHeaders: !1,
        hasBody: !1
      };
      if (p("import Foundation"), Object.keys(c).length && (w.hasHeaders = !0, g(), p((0, r.literalDeclaration)("headers", c, d))), u.text || u.jsonObj || u.params)
        switch (w.hasBody = !0, u.mimeType) {
          case "application/x-www-form-urlencoded":
            if (g(), !((o = u.params) === null || o === void 0) && o.length) {
              var y = t(u.params), v = y[0], _ = y.slice(1);
              p('let postData = NSMutableData(data: "'.concat(v.name, "=").concat(v.value, '".data(using: String.Encoding.utf8)!)')), _.forEach(function(E) {
                var O = E.name, M = E.value;
                p('postData.append("&'.concat(O, "=").concat(M, '".data(using: String.Encoding.utf8)!)'));
              });
            } else
              w.hasBody = !1;
            break;
          case "application/json":
            u.jsonObj && (p("".concat((0, r.literalDeclaration)("parameters", u.jsonObj, d), " as [String : Any]")), g(), p("let postData = JSONSerialization.data(withJSONObject: parameters, options: [])"));
            break;
          case "multipart/form-data":
            p((0, r.literalDeclaration)("parameters", u.params, d)), g(), p('let boundary = "'.concat(u.boundary, '"')), g(), p('var body = ""'), p("var error: NSError? = nil"), p("for param in parameters {"), p('let paramName = param["name"]!', 1), p('body += "--\\(boundary)\\r\\n"', 1), p('body += "Content-Disposition:form-data; name=\\"\\(paramName)\\""', 1), p('if let filename = param["fileName"] {', 1), p('let contentType = param["content-type"]!', 2), p("let fileContent = String(contentsOfFile: filename, encoding: String.Encoding.utf8)", 2), p("if (error != nil) {", 2), p("print(error as Any)", 3), p("}", 2), p('body += "; filename=\\"\\(filename)\\"\\r\\n"', 2), p('body += "Content-Type: \\(contentType)\\r\\n\\r\\n"', 2), p("body += fileContent", 2), p('} else if let paramValue = param["value"] {', 1), p('body += "\\r\\n\\r\\n\\(paramValue)"', 2), p("}", 1), p("}");
            break;
          default:
            g(), p('let postData = NSData(data: "'.concat(u.text, '".data(using: String.Encoding.utf8)!)'));
        }
      return g(), p('let request = NSMutableURLRequest(url: NSURL(string: "'.concat(s, '")! as URL,')), p("                                        cachePolicy: .useProtocolCachePolicy,"), p(
        // @ts-expect-error needs better types
        "                                    timeoutInterval: ".concat(parseInt(d.timeout, 10).toFixed(1), ")")
      ), p('request.httpMethod = "'.concat(l, '"')), w.hasHeaders && p("request.allHTTPHeaderFields = headers"), w.hasBody && p("request.httpBody = postData as Data"), g(), p("let session = URLSession.shared"), p("let dataTask = session.dataTask(with: request as URLRequest, completionHandler: { (data, response, error) -> Void in"), p("if (error != nil) {", 1), p("print(error as Any)", 2), p("} else {", 1), p("let httpResponse = response as? HTTPURLResponse", 2), p("print(httpResponse)", 2), p("}", 1), p("})"), g(), p("dataTask.resume()"), b();
    }
  }, Qo;
}
var Fw;
function Hne() {
  if (Fw) return tf;
  Fw = 1, tf.__esModule = !0, tf.swift = void 0;
  var e = Une();
  return tf.swift = {
    info: {
      key: "swift",
      title: "Swift",
      extname: ".swift",
      default: "nsurlsession"
    },
    clientsById: {
      nsurlsession: e.nsurlsession
    }
  }, tf;
}
var Mw;
function T0() {
  return Mw || (Mw = 1, (function(e) {
    e.__esModule = !0, e.addTargetClient = e.isClient = e.addTarget = e.isTarget = e.targets = void 0;
    var t = jre(), n = Dre(), r = Lre(), i = Mre(), a = Ure(), o = zre(), c = Zre(), u = nne(), s = ane(), l = fne(), d = hne(), f = gne(), p = _ne(), g = Cne(), b = One(), w = Pne(), y = jne(), v = $ne(), _ = Mne(), E = Hne();
    e.targets = {
      c: t.c,
      clojure: n.clojure,
      crystal: r.crystal,
      csharp: i.csharp,
      go: a.go,
      http: o.http,
      java: c.java,
      javascript: u.javascript,
      kotlin: s.kotlin,
      node: l.node,
      objc: d.objc,
      ocaml: f.ocaml,
      php: p.php,
      powershell: g.powershell,
      python: b.python,
      r: w.r,
      ruby: y.ruby,
      rust: v.rust,
      shell: _.shell,
      swift: E.swift
    };
    var O = function(Q) {
      if (typeof Q != "object" || Q === null || Array.isArray(Q)) {
        var ae = Q === null ? "null" : Array.isArray(Q) ? "array" : typeof Q;
        throw new Error('you tried to add a target which is not an object, got type: "'.concat(ae, '"'));
      }
      if (!Object.prototype.hasOwnProperty.call(Q, "info"))
        throw new Error("targets must contain an `info` object");
      if (!Object.prototype.hasOwnProperty.call(Q.info, "key"))
        throw new Error("targets must have an `info` object with the property `key`");
      if (!Q.info.key)
        throw new Error("target key must be a unique string");
      if (Object.prototype.hasOwnProperty.call(e.targets, Q.info.key))
        throw new Error("a target already exists with this key, `".concat(Q.info.key, "`"));
      if (!Object.prototype.hasOwnProperty.call(Q.info, "title"))
        throw new Error("targets must have an `info` object with the property `title`");
      if (!Q.info.title)
        throw new Error("target title must be a non-zero-length string");
      if (!Object.prototype.hasOwnProperty.call(Q.info, "extname"))
        throw new Error("targets must have an `info` object with the property `extname`");
      if (!Object.prototype.hasOwnProperty.call(Q, "clientsById") || !Q.clientsById || Object.keys(Q.clientsById).length === 0)
        throw new Error("No clients provided in target ".concat(Q.info.key, ".  You must provide the property `clientsById` containg your clients."));
      if (!Object.prototype.hasOwnProperty.call(Q.info, "default"))
        throw new Error("targets must have an `info` object with the property `default`");
      if (!Object.prototype.hasOwnProperty.call(Q.clientsById, Q.info.default))
        throw new Error("target ".concat(Q.info.key, " is configured with a default client ").concat(Q.info.default, ", but no such client was found in the property `clientsById` (found ").concat(JSON.stringify(Object.keys(Q.clientsById)), ")"));
      return Object.values(Q.clientsById).forEach(e.isClient), !0;
    };
    e.isTarget = O;
    var M = function(Q) {
      (0, e.isTarget)(Q) && (e.targets[Q.info.key] = Q);
    };
    e.addTarget = M;
    var L = function(Q) {
      if (!Q)
        throw new Error("clients must be objects");
      if (!Object.prototype.hasOwnProperty.call(Q, "info"))
        throw new Error("targets client must contain an `info` object");
      if (!Object.prototype.hasOwnProperty.call(Q.info, "key"))
        throw new Error("targets client must have an `info` object with property `key`");
      if (!Q.info.key)
        throw new Error("client.info.key must contain an identifier unique to this target");
      if (!Object.prototype.hasOwnProperty.call(Q.info, "title"))
        throw new Error("targets client must have an `info` object with property `title`");
      if (!Object.prototype.hasOwnProperty.call(Q.info, "description"))
        throw new Error("targets client must have an `info` object with property `description`");
      if (!Object.prototype.hasOwnProperty.call(Q.info, "link"))
        throw new Error("targets client must have an `info` object with property `link`");
      if (!Object.prototype.hasOwnProperty.call(Q, "convert") || typeof Q.convert != "function")
        throw new Error("targets client must have a `convert` property containing a conversion function");
      return !0;
    };
    e.isClient = L;
    var Z = function(Q, ae) {
      if ((0, e.isClient)(ae)) {
        if (!Object.prototype.hasOwnProperty.call(e.targets, Q))
          throw new Error("Sorry, but no ".concat(Q, " target exists to add clients to"));
        if (Object.prototype.hasOwnProperty.call(e.targets[Q], ae.info.key))
          throw new Error("the target ".concat(Q, " already has a client with the key ").concat(ae.info.key, ", please use a different key"));
        e.targets[Q].clientsById[ae.info.key] = ae;
      }
    };
    e.addTargetClient = Z;
  })(i3)), i3;
}
var Bw;
function WO() {
  if (Bw) return Bo;
  Bw = 1;
  var e = Bo && Bo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  };
  Bo.__esModule = !0, Bo.extname = Bo.availableTargets = void 0;
  var t = T0(), n = function() {
    return Object.keys(t.targets).map(function(i) {
      return e(e({}, t.targets[i].info), { clients: Object.keys(t.targets[i].clientsById).map(function(a) {
        return t.targets[i].clientsById[a].info;
      }) });
    });
  };
  Bo.availableTargets = n;
  var r = function(i) {
    var a;
    return ((a = t.targets[i]) === null || a === void 0 ? void 0 : a.info.extname) || "";
  };
  return Bo.extname = r, Bo;
}
var Ja = {}, d3 = {}, h3 = { exports: {} }, Uw;
function y1() {
  return Uw || (Uw = 1, (function(e, t) {
    var n = ni;
    e.exports = r, r.through = r;
    function r(i, a, o) {
      i = i || function(g) {
        this.queue(g);
      }, a = a || function() {
        this.queue(null);
      };
      var c = !1, u = !1, s = [], l = !1, d = new n();
      d.readable = d.writable = !0, d.paused = !1, d.autoDestroy = !(o && o.autoDestroy === !1), d.write = function(g) {
        return i.call(this, g), !d.paused;
      };
      function f() {
        for (; s.length && !d.paused; ) {
          var g = s.shift();
          if (g === null)
            return d.emit("end");
          d.emit("data", g);
        }
      }
      d.queue = d.push = function(g) {
        return l || (g === null && (l = !0), s.push(g), f()), d;
      }, d.on("end", function() {
        d.readable = !1, !d.writable && d.autoDestroy && gn.nextTick(function() {
          d.destroy();
        });
      });
      function p() {
        d.writable = !1, a.call(d), !d.readable && d.autoDestroy && d.destroy();
      }
      return d.end = function(g) {
        if (!c)
          return c = !0, arguments.length && d.write(g), p(), d;
      }, d.destroy = function() {
        if (!u)
          return u = !0, c = !0, s.length = 0, d.writable = d.readable = !1, d.emit("close"), d;
      }, d.pause = function() {
        if (!d.paused)
          return d.paused = !0, d;
      }, d.resume = function() {
        return d.paused && (d.paused = !1, d.emit("resume")), f(), d.paused || d.emit("drain"), d;
      }, d;
    }
  })(h3)), h3.exports;
}
var m3, Hw;
function zne() {
  if (Hw) return m3;
  Hw = 1;
  var e = ni;
  return m3 = function t(n) {
    if (Array.isArray(n)) {
      var r = 0, i = n.length;
      return t(function(u) {
        return r < i ? this.emit("data", n[r++]) : this.emit("end"), !0;
      });
    }
    var a = new e(), o = 0;
    a.ended = !1, a.started = !1, a.readable = !0, a.writable = !1, a.paused = !1, a.ended = !1, a.pause = function() {
      a.started = !0, a.paused = !0;
    };
    function c() {
      if (a.started = !0, !a.ended)
        for (; !a.ended && !a.paused && n.call(a, o++, function() {
          !a.ended && !a.paused && gn.nextTick(c);
        }); )
          ;
    }
    return a.resume = function() {
      a.started = !0, a.paused = !1, c();
    }, a.on("end", function() {
      a.ended = !0, a.readable = !1, gn.nextTick(a.destroy);
    }), a.destroy = function() {
      a.ended = !0, a.emit("close");
    }, gn.nextTick(function() {
      a.started || a.resume();
    }), a;
  }, m3;
}
var g3, zw;
function KO() {
  if (zw) return g3;
  zw = 1;
  var e = ni, t = ["write", "end", "destroy"], n = ["resume", "pause"], r = ["data", "close"], i = Array.prototype.slice;
  g3 = o;
  function a(c, u) {
    if (c.forEach)
      return c.forEach(u);
    for (var s = 0; s < c.length; s++)
      u(c[s], s);
  }
  function o(c, u) {
    var s = new e(), l = !1;
    return a(t, d), a(n, f), a(r, p), u.on("end", g), c.on("drain", function() {
      s.emit("drain");
    }), c.on("error", b), u.on("error", b), s.writable = c.writable, s.readable = u.readable, s;
    function d(w) {
      s[w] = y;
      function y() {
        return c[w].apply(c, arguments);
      }
    }
    function f(w) {
      s[w] = y;
      function y() {
        s.emit(w);
        var v = u[w];
        if (v)
          return v.apply(u, arguments);
        u.emit(w);
      }
    }
    function p(w) {
      u.on(w, y);
      function y() {
        var v = i.call(arguments);
        v.unshift(w), s.emit.apply(s, v);
      }
    }
    function g() {
      if (!l) {
        l = !0;
        var w = i.call(arguments);
        w.unshift("end"), s.emit.apply(s, w);
      }
    }
    function b(w) {
      s.emit("error", w);
    }
  }
  return g3;
}
var v3, Vw;
function Vne() {
  if (Vw) return v3;
  Vw = 1;
  var e = ni.Stream;
  return v3 = function(t, n) {
    var r = new e(), i = 0, a = 0, o = !1, c = !1, u = !1, s = 0, l = !1;
    n = n || {};
    var d = n.failures ? "failure" : "error", f = {};
    r.writable = !0, r.readable = !0;
    function p(y, v) {
      var _ = s + 1;
      if (v === _ ? (y !== void 0 && r.emit.apply(r, ["data", y]), s++, _++) : f[v] = y, f.hasOwnProperty(_)) {
        var E = f[_];
        return delete f[_], p(E, _);
      }
      a++, i === a && (c && (c = !1, r.emit("drain")), o && w());
    }
    function g(y, v, _) {
      u || (l = !0, (!y || n.failures) && p(v, _), y && r.emit.apply(r, [d, y]), l = !1);
    }
    function b(y, v, _) {
      return t.call(null, y, function(E, O) {
        _(E, O, v);
      });
    }
    r.write = function(y) {
      if (o) throw new Error("map stream is not writable");
      l = !1, i++;
      try {
        var v = b(y, i, g);
        return c = v === !1, !c;
      } catch (_) {
        if (l)
          throw _;
        return g(_), !c;
      }
    };
    function w(y) {
      if (o = !0, r.writable = !1, y !== void 0)
        return p(y, i);
      i == a && (r.readable = !1, r.emit("end"), r.destroy());
    }
    return r.end = function(y) {
      o || w(y);
    }, r.destroy = function() {
      o = u = !0, r.writable = r.readable = c = !1, gn.nextTick(function() {
        r.emit("close");
      });
    }, r.pause = function() {
      c = !0;
    }, r.resume = function() {
      c = !1;
    }, r;
  }, v3;
}
var y3, Gw;
function Gne() {
  return Gw || (Gw = 1, y3 = y1()), y3;
}
var b3 = {}, $d = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Ww;
function Wne() {
  return Ww || (Ww = 1, (function(e, t) {
    var n = P2(), r = n.Buffer;
    function i(o, c) {
      for (var u in o)
        c[u] = o[u];
    }
    r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = a);
    function a(o, c, u) {
      return r(o, c, u);
    }
    a.prototype = Object.create(r.prototype), i(r, a), a.from = function(o, c, u) {
      if (typeof o == "number")
        throw new TypeError("Argument must not be a number");
      return r(o, c, u);
    }, a.alloc = function(o, c, u) {
      if (typeof o != "number")
        throw new TypeError("Argument must be a number");
      var s = r(o);
      return c !== void 0 ? typeof u == "string" ? s.fill(c, u) : s.fill(c) : s.fill(0), s;
    }, a.allocUnsafe = function(o) {
      if (typeof o != "number")
        throw new TypeError("Argument must be a number");
      return r(o);
    }, a.allocUnsafeSlow = function(o) {
      if (typeof o != "number")
        throw new TypeError("Argument must be a number");
      return n.SlowBuffer(o);
    };
  })($d, $d.exports)), $d.exports;
}
var Kw;
function Kne() {
  if (Kw) return b3;
  Kw = 1;
  var e = Wne().Buffer, t = e.isEncoding || function(y) {
    switch (y = "" + y, y && y.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function n(y) {
    if (!y) return "utf8";
    for (var v; ; )
      switch (y) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return y;
        default:
          if (v) return;
          y = ("" + y).toLowerCase(), v = !0;
      }
  }
  function r(y) {
    var v = n(y);
    if (typeof v != "string" && (e.isEncoding === t || !t(y))) throw new Error("Unknown encoding: " + y);
    return v || y;
  }
  b3.StringDecoder = i;
  function i(y) {
    this.encoding = r(y);
    var v;
    switch (this.encoding) {
      case "utf16le":
        this.text = d, this.end = f, v = 4;
        break;
      case "utf8":
        this.fillLast = u, v = 4;
        break;
      case "base64":
        this.text = p, this.end = g, v = 3;
        break;
      default:
        this.write = b, this.end = w;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(v);
  }
  i.prototype.write = function(y) {
    if (y.length === 0) return "";
    var v, _;
    if (this.lastNeed) {
      if (v = this.fillLast(y), v === void 0) return "";
      _ = this.lastNeed, this.lastNeed = 0;
    } else
      _ = 0;
    return _ < y.length ? v ? v + this.text(y, _) : this.text(y, _) : v || "";
  }, i.prototype.end = l, i.prototype.text = s, i.prototype.fillLast = function(y) {
    if (this.lastNeed <= y.length)
      return y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, y.length), this.lastNeed -= y.length;
  };
  function a(y) {
    return y <= 127 ? 0 : y >> 5 === 6 ? 2 : y >> 4 === 14 ? 3 : y >> 3 === 30 ? 4 : y >> 6 === 2 ? -1 : -2;
  }
  function o(y, v, _) {
    var E = v.length - 1;
    if (E < _) return 0;
    var O = a(v[E]);
    return O >= 0 ? (O > 0 && (y.lastNeed = O - 1), O) : --E < _ || O === -2 ? 0 : (O = a(v[E]), O >= 0 ? (O > 0 && (y.lastNeed = O - 2), O) : --E < _ || O === -2 ? 0 : (O = a(v[E]), O >= 0 ? (O > 0 && (O === 2 ? O = 0 : y.lastNeed = O - 3), O) : 0));
  }
  function c(y, v, _) {
    if ((v[0] & 192) !== 128)
      return y.lastNeed = 0, "�";
    if (y.lastNeed > 1 && v.length > 1) {
      if ((v[1] & 192) !== 128)
        return y.lastNeed = 1, "�";
      if (y.lastNeed > 2 && v.length > 2 && (v[2] & 192) !== 128)
        return y.lastNeed = 2, "�";
    }
  }
  function u(y) {
    var v = this.lastTotal - this.lastNeed, _ = c(this, y);
    if (_ !== void 0) return _;
    if (this.lastNeed <= y.length)
      return y.copy(this.lastChar, v, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    y.copy(this.lastChar, v, 0, y.length), this.lastNeed -= y.length;
  }
  function s(y, v) {
    var _ = o(this, y, v);
    if (!this.lastNeed) return y.toString("utf8", v);
    this.lastTotal = _;
    var E = y.length - (_ - this.lastNeed);
    return y.copy(this.lastChar, 0, E), y.toString("utf8", v, E);
  }
  function l(y) {
    var v = y && y.length ? this.write(y) : "";
    return this.lastNeed ? v + "�" : v;
  }
  function d(y, v) {
    if ((y.length - v) % 2 === 0) {
      var _ = y.toString("utf16le", v);
      if (_) {
        var E = _.charCodeAt(_.length - 1);
        if (E >= 55296 && E <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1], _.slice(0, -1);
      }
      return _;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = y[y.length - 1], y.toString("utf16le", v, y.length - 1);
  }
  function f(y) {
    var v = y && y.length ? this.write(y) : "";
    if (this.lastNeed) {
      var _ = this.lastTotal - this.lastNeed;
      return v + this.lastChar.toString("utf16le", 0, _);
    }
    return v;
  }
  function p(y, v) {
    var _ = (y.length - v) % 3;
    return _ === 0 ? y.toString("base64", v) : (this.lastNeed = 3 - _, this.lastTotal = 3, _ === 1 ? this.lastChar[0] = y[y.length - 1] : (this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1]), y.toString("base64", v, y.length - _));
  }
  function g(y) {
    var v = y && y.length ? this.write(y) : "";
    return this.lastNeed ? v + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : v;
  }
  function b(y) {
    return y.toString(this.encoding);
  }
  function w(y) {
    return y && y.length ? this.write(y) : "";
  }
  return b3;
}
var x3, Zw;
function Zne() {
  if (Zw) return x3;
  Zw = 1;
  var e = y1(), t = Kne().StringDecoder;
  x3 = n;
  function n(r, i, a) {
    var o = new t(), c = "", u = a && a.maxLength, s = !(a && a.trailing === !1);
    typeof r == "function" && (i = r, r = null), r || (r = /\r?\n/);
    function l(f, p) {
      if (i) {
        try {
          p = i(p);
        } catch (g) {
          return f.emit("error", g);
        }
        typeof p < "u" && f.queue(p);
      } else
        f.queue(p);
    }
    function d(f, p) {
      var g = ((c ?? "") + p).split(r);
      if (c = g.pop(), u && c.length > u)
        return f.emit("error", new Error("maximum buffer reached"));
      for (var b = 0; b < g.length; b++) {
        var w = g[b];
        l(f, w);
      }
    }
    return e(
      function(f) {
        d(this, o.write(f));
      },
      function() {
        o.end && d(this, o.end()), s && c != null && l(this, c), this.queue(null);
      }
    );
  }
  return x3;
}
var _3, Yw;
function Yne() {
  if (Yw) return _3;
  Yw = 1;
  var e = KO(), t = y1();
  return _3 = function() {
    var n;
    if (arguments.length == 1 && Array.isArray(arguments[0]) ? n = arguments[0] : n = [].slice.call(arguments), n.length == 0)
      return t();
    if (n.length == 1)
      return n[0];
    var r = n[0], i = n[n.length - 1], a = e(r, i);
    function o(s) {
      s.length < 2 || (s[0].pipe(s[1]), o(s.slice(1)));
    }
    o(n);
    function c() {
      var s = [].slice.call(arguments);
      s.unshift("error"), a.emit.apply(a, s);
    }
    for (var u = 1; u < n.length - 1; u++)
      n[u].on("error", c);
    return a;
  }, _3;
}
var Jw;
function Jne() {
  return Jw || (Jw = 1, (function(e) {
    var t = ni.Stream, n = e, r = y1(), i = zne(), a = KO(), o = Vne(), c = Gne(), u = Zne(), s = Yne(), l = Qa.setImmediate || gn.nextTick;
    n.Stream = t, n.through = r, n.from = i, n.duplex = a, n.map = o, n.pause = c, n.split = u, n.pipeline = n.connect = n.pipe = s, n.concat = //actually this should be called concat
    n.merge = function() {
      var d = [].slice.call(arguments);
      d.length === 1 && d[0] instanceof Array && (d = d[0]);
      var f = new t();
      f.setMaxListeners(0);
      var p = 0;
      return f.writable = f.readable = !0, d.length ? d.forEach(function(g) {
        g.pipe(f, { end: !1 });
        var b = !1;
        g.on("end", function() {
          b || (b = !0, p++, p == d.length && f.emit("end"));
        });
      }) : gn.nextTick(function() {
        f.emit("end");
      }), f.write = function(g) {
        this.emit("data", g);
      }, f.destroy = function() {
        d.forEach(function(g) {
          g.destroy && g.destroy();
        });
      }, f;
    }, n.collect = n.writeArray = function(d) {
      if (typeof d != "function")
        throw new Error("function writeArray (done): done must be function");
      var f = new t(), p = [], g = !1;
      return f.write = function(b) {
        p.push(b);
      }, f.end = function() {
        g = !0, d(null, p);
      }, f.writable = !0, f.readable = !1, f.destroy = function() {
        f.writable = f.readable = !1, !g && d(new Error("destroyed before end"), p);
      }, f;
    }, n.readArray = function(d) {
      var f = new t(), p = 0, g = !1, b = !1;
      if (f.readable = !0, f.writable = !1, !Array.isArray(d))
        throw new Error("event-stream.read expects an array");
      return f.resume = function() {
        if (!b) {
          g = !1;
          for (var w = d.length; p < w && !g && !b; )
            f.emit("data", d[p++]);
          p == w && !b && (b = !0, f.readable = !1, f.emit("end"));
        }
      }, gn.nextTick(f.resume), f.pause = function() {
        g = !0;
      }, f.destroy = function() {
        b = !0, f.emit("close");
      }, f;
    }, n.readable = function(d, f) {
      var p = new t(), g = 0, b = !1, w = !1, y = !1;
      if (p.readable = !0, p.writable = !1, typeof d != "function")
        throw new Error("event-stream.readable expects async function");
      p.on("end", function() {
        w = !0;
      });
      function v(_, E) {
        _ ? (p.emit("error", _), f || p.emit("end")) : arguments.length > 1 && p.emit("data", E), l(function() {
          if (!(w || b || y))
            try {
              y = !0, d.call(p, g++, function() {
                y = !1, v.apply(null, arguments);
              });
            } catch (O) {
              p.emit("error", O);
            }
        });
      }
      return p.resume = function() {
        b = !1, v();
      }, gn.nextTick(v), p.pause = function() {
        b = !0;
      }, p.destroy = function() {
        p.emit("end"), p.emit("close"), w = !0;
      }, p;
    }, n.mapSync = function(d) {
      return n.through(function(p) {
        var g;
        try {
          g = d(p);
        } catch (b) {
          return this.emit("error", b);
        }
        g !== void 0 && this.emit("data", g);
      });
    }, n.filterSync = function(d) {
      return n.through(function(f) {
        var p = this;
        d(f) && p.queue(f);
      });
    }, n.flatmapSync = function(d) {
      return n.through(function(f) {
        var p = this;
        f.forEach(function(g) {
          p.queue(d(g));
        });
      });
    }, n.log = function(d) {
      return n.through(function(f) {
        [].slice.call(arguments), d ? console.error(d, f) : console.error(f), this.emit("data", f);
      });
    }, n.child = function(d) {
      return n.duplex(d.stdin, d.stdout);
    }, n.parse = function(d) {
      var f = !!(d && d.error);
      return n.through(function(p) {
        var g;
        try {
          p && (g = JSON.parse(p.toString()));
        } catch (b) {
          return f ? this.emit("error", b) : console.error(b, "attempting to parse:", p);
        }
        g !== void 0 && this.emit("data", g);
      });
    }, n.stringify = function() {
      var d = P2().Buffer;
      return n.mapSync(function(f) {
        return JSON.stringify(d.isBuffer(f) ? f.toString() : f) + `
`;
      });
    }, n.replace = function(d, f) {
      return n.pipeline(n.split(d), n.join(f));
    }, n.join = function(d) {
      if (typeof d == "function")
        return n.wait(d);
      var f = !0;
      return n.through(function(p) {
        return f || this.emit("data", d), f = !1, this.emit("data", p), !0;
      });
    }, n.wait = function(d) {
      var f = [];
      return n.through(
        function(p) {
          f.push(p);
        },
        function() {
          var p = qn.isBuffer(f[0]) ? qn.concat(f) : f.join("");
          this.emit("data", p), this.emit("end"), d && d(null, p);
        }
      );
    }, n.pipeable = function() {
      throw new Error("[EVENT-STREAM] es.pipeable is deprecated");
    };
  })(d3)), d3;
}
var w3 = {}, S3 = {}, C3, Qw;
function ZO() {
  return Qw || (Qw = 1, C3 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), r = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[n] = i;
    for (n in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(t);
    if (a.length !== 1 || a[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var o = Object.getOwnPropertyDescriptor(t, n);
      if (o.value !== i || o.enumerable !== !0)
        return !1;
    }
    return !0;
  }), C3;
}
var k3, Xw;
function Tg() {
  if (Xw) return k3;
  Xw = 1;
  var e = ZO();
  return k3 = function() {
    return e() && !!Symbol.toStringTag;
  }, k3;
}
var A3, eS;
function Qne() {
  return eS || (eS = 1, A3 = Error), A3;
}
var E3, tS;
function Xne() {
  return tS || (tS = 1, E3 = EvalError), E3;
}
var O3, rS;
function eie() {
  return rS || (rS = 1, O3 = RangeError), O3;
}
var T3, nS;
function tie() {
  return nS || (nS = 1, T3 = ReferenceError), T3;
}
var P3, iS;
function YO() {
  return iS || (iS = 1, P3 = SyntaxError), P3;
}
var R3, aS;
function sp() {
  return aS || (aS = 1, R3 = TypeError), R3;
}
var I3, oS;
function rie() {
  return oS || (oS = 1, I3 = URIError), I3;
}
var j3, sS;
function nie() {
  if (sS) return j3;
  sS = 1;
  var e = typeof Symbol < "u" && Symbol, t = ZO();
  return j3 = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, j3;
}
var q3, uS;
function iie() {
  if (uS) return q3;
  uS = 1;
  var e = {
    __proto__: null,
    foo: {}
  }, t = Object;
  return q3 = function() {
    return { __proto__: e }.foo === e.foo && !(e instanceof t);
  }, q3;
}
var D3, cS;
function aie() {
  if (cS) return D3;
  cS = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, r = "[object Function]", i = function(u, s) {
    for (var l = [], d = 0; d < u.length; d += 1)
      l[d] = u[d];
    for (var f = 0; f < s.length; f += 1)
      l[f + u.length] = s[f];
    return l;
  }, a = function(u, s) {
    for (var l = [], d = s, f = 0; d < u.length; d += 1, f += 1)
      l[f] = u[d];
    return l;
  }, o = function(c, u) {
    for (var s = "", l = 0; l < c.length; l += 1)
      s += c[l], l + 1 < c.length && (s += u);
    return s;
  };
  return D3 = function(u) {
    var s = this;
    if (typeof s != "function" || t.apply(s) !== r)
      throw new TypeError(e + s);
    for (var l = a(arguments, 1), d, f = function() {
      if (this instanceof d) {
        var y = s.apply(
          this,
          i(l, arguments)
        );
        return Object(y) === y ? y : this;
      }
      return s.apply(
        u,
        i(l, arguments)
      );
    }, p = n(0, s.length - l.length), g = [], b = 0; b < p; b++)
      g[b] = "$" + b;
    if (d = Function("binder", "return function (" + o(g, ",") + "){ return binder.apply(this,arguments); }")(f), s.prototype) {
      var w = function() {
      };
      w.prototype = s.prototype, d.prototype = new w(), w.prototype = null;
    }
    return d;
  }, D3;
}
var $3, lS;
function Pg() {
  if (lS) return $3;
  lS = 1;
  var e = aie();
  return $3 = Function.prototype.bind || e, $3;
}
var L3, fS;
function oie() {
  if (fS) return L3;
  fS = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = Pg();
  return L3 = n.call(e, t), L3;
}
var N3, pS;
function Rc() {
  if (pS) return N3;
  pS = 1;
  var e, t = /* @__PURE__ */ Qne(), n = /* @__PURE__ */ Xne(), r = /* @__PURE__ */ eie(), i = /* @__PURE__ */ tie(), a = /* @__PURE__ */ YO(), o = /* @__PURE__ */ sp(), c = /* @__PURE__ */ rie(), u = Function, s = function(De) {
    try {
      return u('"use strict"; return (' + De + ").constructor;")();
    } catch {
    }
  }, l = Object.getOwnPropertyDescriptor;
  if (l)
    try {
      l({}, "");
    } catch {
      l = null;
    }
  var d = function() {
    throw new o();
  }, f = l ? (function() {
    try {
      return arguments.callee, d;
    } catch {
      try {
        return l(arguments, "callee").get;
      } catch {
        return d;
      }
    }
  })() : d, p = nie()(), g = /* @__PURE__ */ iie()(), b = Object.getPrototypeOf || (g ? function(De) {
    return De.__proto__;
  } : null), w = {}, y = typeof Uint8Array > "u" || !b ? e : b(Uint8Array), v = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": p && b ? b([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": w,
    "%AsyncGenerator%": w,
    "%AsyncGeneratorFunction%": w,
    "%AsyncIteratorPrototype%": w,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": u,
    "%GeneratorFunction%": w,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": p && b ? b(b([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !p || !b ? e : b((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": r,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !p || !b ? e : b((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": p && b ? b(""[Symbol.iterator]()) : e,
    "%Symbol%": p ? Symbol : e,
    "%SyntaxError%": a,
    "%ThrowTypeError%": f,
    "%TypedArray%": y,
    "%TypeError%": o,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": c,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  if (b)
    try {
      null.error;
    } catch (De) {
      var _ = b(b(De));
      v["%Error.prototype%"] = _;
    }
  var E = function De(je) {
    var Me;
    if (je === "%AsyncFunction%")
      Me = s("async function () {}");
    else if (je === "%GeneratorFunction%")
      Me = s("function* () {}");
    else if (je === "%AsyncGeneratorFunction%")
      Me = s("async function* () {}");
    else if (je === "%AsyncGenerator%") {
      var qe = De("%AsyncGeneratorFunction%");
      qe && (Me = qe.prototype);
    } else if (je === "%AsyncIteratorPrototype%") {
      var Ve = De("%AsyncGenerator%");
      Ve && b && (Me = b(Ve.prototype));
    }
    return v[je] = Me, Me;
  }, O = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, M = Pg(), L = /* @__PURE__ */ oie(), Z = M.call(Function.call, Array.prototype.concat), Q = M.call(Function.apply, Array.prototype.splice), ae = M.call(Function.call, String.prototype.replace), re = M.call(Function.call, String.prototype.slice), X = M.call(Function.call, RegExp.prototype.exec), de = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Ce = /\\(\\)?/g, J = function(je) {
    var Me = re(je, 0, 1), qe = re(je, -1);
    if (Me === "%" && qe !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (qe === "%" && Me !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var Ve = [];
    return ae(je, de, function(xe, ve, Ae, Ue) {
      Ve[Ve.length] = Ae ? ae(Ue, Ce, "$1") : ve || xe;
    }), Ve;
  }, ne = function(je, Me) {
    var qe = je, Ve;
    if (L(O, qe) && (Ve = O[qe], qe = "%" + Ve[0] + "%"), L(v, qe)) {
      var xe = v[qe];
      if (xe === w && (xe = E(qe)), typeof xe > "u" && !Me)
        throw new o("intrinsic " + je + " exists, but is not available. Please file an issue!");
      return {
        alias: Ve,
        name: qe,
        value: xe
      };
    }
    throw new a("intrinsic " + je + " does not exist!");
  };
  return N3 = function(je, Me) {
    if (typeof je != "string" || je.length === 0)
      throw new o("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Me != "boolean")
      throw new o('"allowMissing" argument must be a boolean');
    if (X(/^%?[^%]*%?$/, je) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var qe = J(je), Ve = qe.length > 0 ? qe[0] : "", xe = ne("%" + Ve + "%", Me), ve = xe.name, Ae = xe.value, Ue = !1, qt = xe.alias;
    qt && (Ve = qt[0], Q(qe, Z([0, 1], qt)));
    for (var Ze = 1, At = !0; Ze < qe.length; Ze += 1) {
      var He = qe[Ze], Dt = re(He, 0, 1), Fe = re(He, -1);
      if ((Dt === '"' || Dt === "'" || Dt === "`" || Fe === '"' || Fe === "'" || Fe === "`") && Dt !== Fe)
        throw new a("property names with quotes must have matching quotes");
      if ((He === "constructor" || !At) && (Ue = !0), Ve += "." + He, ve = "%" + Ve + "%", L(v, ve))
        Ae = v[ve];
      else if (Ae != null) {
        if (!(He in Ae)) {
          if (!Me)
            throw new o("base intrinsic for " + je + " exists, but the property is not available.");
          return;
        }
        if (l && Ze + 1 >= qe.length) {
          var Xe = l(Ae, He);
          At = !!Xe, At && "get" in Xe && !("originalValue" in Xe.get) ? Ae = Xe.get : Ae = Ae[He];
        } else
          At = L(Ae, He), Ae = Ae[He];
        At && !Ue && (v[ve] = Ae);
      }
    }
    return Ae;
  }, N3;
}
var F3 = { exports: {} }, M3, dS;
function Rg() {
  if (dS) return M3;
  dS = 1;
  var e = /* @__PURE__ */ Rc(), t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return M3 = t, M3;
}
var B3, hS;
function Ig() {
  if (hS) return B3;
  hS = 1;
  var e = /* @__PURE__ */ Rc(), t = e("%Object.getOwnPropertyDescriptor%", !0);
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return B3 = t, B3;
}
var U3, mS;
function sie() {
  if (mS) return U3;
  mS = 1;
  var e = /* @__PURE__ */ Rg(), t = /* @__PURE__ */ YO(), n = /* @__PURE__ */ sp(), r = /* @__PURE__ */ Ig();
  return U3 = function(a, o, c) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof o != "string" && typeof o != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var u = arguments.length > 3 ? arguments[3] : null, s = arguments.length > 4 ? arguments[4] : null, l = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, f = !!r && r(a, o);
    if (e)
      e(a, o, {
        configurable: l === null && f ? f.configurable : !l,
        enumerable: u === null && f ? f.enumerable : !u,
        value: c,
        writable: s === null && f ? f.writable : !s
      });
    else if (d || !u && !s && !l)
      a[o] = c;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, U3;
}
var H3, gS;
function uie() {
  if (gS) return H3;
  gS = 1;
  var e = /* @__PURE__ */ Rg(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, H3 = t, H3;
}
var z3, vS;
function cie() {
  if (vS) return z3;
  vS = 1;
  var e = /* @__PURE__ */ Rc(), t = /* @__PURE__ */ sie(), n = /* @__PURE__ */ uie()(), r = /* @__PURE__ */ Ig(), i = /* @__PURE__ */ sp(), a = e("%Math.floor%");
  return z3 = function(c, u) {
    if (typeof c != "function")
      throw new i("`fn` is not a function");
    if (typeof u != "number" || u < 0 || u > 4294967295 || a(u) !== u)
      throw new i("`length` must be a positive 32-bit integer");
    var s = arguments.length > 2 && !!arguments[2], l = !0, d = !0;
    if ("length" in c && r) {
      var f = r(c, "length");
      f && !f.configurable && (l = !1), f && !f.writable && (d = !1);
    }
    return (l || d || !s) && (n ? t(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      u,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      u
    )), c;
  }, z3;
}
var yS;
function JO() {
  return yS || (yS = 1, (function(e) {
    var t = Pg(), n = /* @__PURE__ */ Rc(), r = /* @__PURE__ */ cie(), i = /* @__PURE__ */ sp(), a = n("%Function.prototype.apply%"), o = n("%Function.prototype.call%"), c = n("%Reflect.apply%", !0) || t.call(o, a), u = /* @__PURE__ */ Rg(), s = n("%Math.max%");
    e.exports = function(f) {
      if (typeof f != "function")
        throw new i("a function is required");
      var p = c(t, o, arguments);
      return r(
        p,
        1 + s(0, f.length - (arguments.length - 1)),
        !0
      );
    };
    var l = function() {
      return c(t, a, arguments);
    };
    u ? u(e.exports, "apply", { value: l }) : e.exports.apply = l;
  })(F3)), F3.exports;
}
var V3, bS;
function jg() {
  if (bS) return V3;
  bS = 1;
  var e = /* @__PURE__ */ Rc(), t = JO(), n = t(e("String.prototype.indexOf"));
  return V3 = function(i, a) {
    var o = e(i, !!a);
    return typeof o == "function" && n(i, ".prototype.") > -1 ? t(o) : o;
  }, V3;
}
var G3, xS;
function lie() {
  if (xS) return G3;
  xS = 1;
  var e = Tg()(), t = jg(), n = t("Object.prototype.toString"), r = function(c) {
    return e && c && typeof c == "object" && Symbol.toStringTag in c ? !1 : n(c) === "[object Arguments]";
  }, i = function(c) {
    return r(c) ? !0 : c !== null && typeof c == "object" && typeof c.length == "number" && c.length >= 0 && n(c) !== "[object Array]" && n(c.callee) === "[object Function]";
  }, a = (function() {
    return r(arguments);
  })();
  return r.isLegacyArguments = i, G3 = a ? r : i, G3;
}
var W3, _S;
function fie() {
  if (_S) return W3;
  _S = 1;
  var e = Object.prototype.toString, t = Function.prototype.toString, n = /^\s*(?:function)?\*/, r = Tg()(), i = Object.getPrototypeOf, a = function() {
    if (!r)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, o;
  return W3 = function(u) {
    if (typeof u != "function")
      return !1;
    if (n.test(t.call(u)))
      return !0;
    if (!r) {
      var s = e.call(u);
      return s === "[object GeneratorFunction]";
    }
    if (!i)
      return !1;
    if (typeof o > "u") {
      var l = a();
      o = l ? i(l) : !1;
    }
    return i(u) === o;
  }, W3;
}
var K3, wS;
function pie() {
  if (wS) return K3;
  wS = 1;
  var e = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, r;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, t(function() {
        throw 42;
      }, null, n);
    } catch (v) {
      v !== r && (t = null);
    }
  else
    t = null;
  var i = /^\s*class\b/, a = function(_) {
    try {
      var E = e.call(_);
      return i.test(E);
    } catch {
      return !1;
    }
  }, o = function(_) {
    try {
      return a(_) ? !1 : (e.call(_), !0);
    } catch {
      return !1;
    }
  }, c = Object.prototype.toString, u = "[object Object]", s = "[object Function]", l = "[object GeneratorFunction]", d = "[object HTMLAllCollection]", f = "[object HTML document.all class]", p = "[object HTMLCollection]", g = typeof Symbol == "function" && !!Symbol.toStringTag, b = !(0 in [,]), w = function() {
    return !1;
  };
  if (typeof document == "object") {
    var y = document.all;
    c.call(y) === c.call(document.all) && (w = function(_) {
      if ((b || !_) && (typeof _ > "u" || typeof _ == "object"))
        try {
          var E = c.call(_);
          return (E === d || E === f || E === p || E === u) && _("") == null;
        } catch {
        }
      return !1;
    });
  }
  return K3 = t ? function(_) {
    if (w(_))
      return !0;
    if (!_ || typeof _ != "function" && typeof _ != "object")
      return !1;
    try {
      t(_, null, n);
    } catch (E) {
      if (E !== r)
        return !1;
    }
    return !a(_) && o(_);
  } : function(_) {
    if (w(_))
      return !0;
    if (!_ || typeof _ != "function" && typeof _ != "object")
      return !1;
    if (g)
      return o(_);
    if (a(_))
      return !1;
    var E = c.call(_);
    return E !== s && E !== l && !/^\[object HTML/.test(E) ? !1 : o(_);
  }, K3;
}
var Z3, SS;
function die() {
  if (SS) return Z3;
  SS = 1;
  var e = pie(), t = Object.prototype.toString, n = Object.prototype.hasOwnProperty, r = function(u, s, l) {
    for (var d = 0, f = u.length; d < f; d++)
      n.call(u, d) && (l == null ? s(u[d], d, u) : s.call(l, u[d], d, u));
  }, i = function(u, s, l) {
    for (var d = 0, f = u.length; d < f; d++)
      l == null ? s(u.charAt(d), d, u) : s.call(l, u.charAt(d), d, u);
  }, a = function(u, s, l) {
    for (var d in u)
      n.call(u, d) && (l == null ? s(u[d], d, u) : s.call(l, u[d], d, u));
  }, o = function(u, s, l) {
    if (!e(s))
      throw new TypeError("iterator must be a function");
    var d;
    arguments.length >= 3 && (d = l), t.call(u) === "[object Array]" ? r(u, s, d) : typeof u == "string" ? i(u, s, d) : a(u, s, d);
  };
  return Z3 = o, Z3;
}
var Y3, CS;
function hie() {
  return CS || (CS = 1, Y3 = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), Y3;
}
var J3, kS;
function mie() {
  if (kS) return J3;
  kS = 1;
  var e = /* @__PURE__ */ hie(), t = typeof globalThis > "u" ? Qa : globalThis;
  return J3 = function() {
    for (var r = [], i = 0; i < e.length; i++)
      typeof t[e[i]] == "function" && (r[r.length] = e[i]);
    return r;
  }, J3;
}
var Q3, AS;
function QO() {
  if (AS) return Q3;
  AS = 1;
  var e = die(), t = /* @__PURE__ */ mie(), n = JO(), r = jg(), i = /* @__PURE__ */ Ig(), a = r("Object.prototype.toString"), o = Tg()(), c = typeof globalThis > "u" ? Qa : globalThis, u = t(), s = r("String.prototype.slice"), l = Object.getPrototypeOf, d = r("Array.prototype.indexOf", !0) || function(w, y) {
    for (var v = 0; v < w.length; v += 1)
      if (w[v] === y)
        return v;
    return -1;
  }, f = { __proto__: null };
  o && i && l ? e(u, function(b) {
    var w = new c[b]();
    if (Symbol.toStringTag in w) {
      var y = l(w), v = i(y, Symbol.toStringTag);
      if (!v) {
        var _ = l(y);
        v = i(_, Symbol.toStringTag);
      }
      f["$" + b] = n(v.get);
    }
  }) : e(u, function(b) {
    var w = new c[b](), y = w.slice || w.set;
    y && (f["$" + b] = n(y));
  });
  var p = function(w) {
    var y = !1;
    return e(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      f,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(v, _) {
        if (!y)
          try {
            "$" + v(w) === _ && (y = s(_, 1));
          } catch {
          }
      }
    ), y;
  }, g = function(w) {
    var y = !1;
    return e(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      f,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(v, _) {
        if (!y)
          try {
            v(w), y = s(_, 1);
          } catch {
          }
      }
    ), y;
  };
  return Q3 = function(w) {
    if (!w || typeof w != "object")
      return !1;
    if (!o) {
      var y = s(a(w), 8, -1);
      return d(u, y) > -1 ? y : y !== "Object" ? !1 : g(w);
    }
    return i ? p(w) : null;
  }, Q3;
}
var X3, ES;
function gie() {
  if (ES) return X3;
  ES = 1;
  var e = /* @__PURE__ */ QO();
  return X3 = function(n) {
    return !!e(n);
  }, X3;
}
var OS;
function vie() {
  return OS || (OS = 1, (function(e) {
    var t = lie(), n = fie(), r = /* @__PURE__ */ QO(), i = /* @__PURE__ */ gie();
    function a(ie) {
      return ie.call.bind(ie);
    }
    var o = typeof BigInt < "u", c = typeof Symbol < "u", u = a(Object.prototype.toString), s = a(Number.prototype.valueOf), l = a(String.prototype.valueOf), d = a(Boolean.prototype.valueOf);
    if (o)
      var f = a(BigInt.prototype.valueOf);
    if (c)
      var p = a(Symbol.prototype.valueOf);
    function g(ie, Te) {
      if (typeof ie != "object")
        return !1;
      try {
        return Te(ie), !0;
      } catch {
        return !1;
      }
    }
    e.isArgumentsObject = t, e.isGeneratorFunction = n, e.isTypedArray = i;
    function b(ie) {
      return typeof Promise < "u" && ie instanceof Promise || ie !== null && typeof ie == "object" && typeof ie.then == "function" && typeof ie.catch == "function";
    }
    e.isPromise = b;
    function w(ie) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ie) : i(ie) || ve(ie);
    }
    e.isArrayBufferView = w;
    function y(ie) {
      return r(ie) === "Uint8Array";
    }
    e.isUint8Array = y;
    function v(ie) {
      return r(ie) === "Uint8ClampedArray";
    }
    e.isUint8ClampedArray = v;
    function _(ie) {
      return r(ie) === "Uint16Array";
    }
    e.isUint16Array = _;
    function E(ie) {
      return r(ie) === "Uint32Array";
    }
    e.isUint32Array = E;
    function O(ie) {
      return r(ie) === "Int8Array";
    }
    e.isInt8Array = O;
    function M(ie) {
      return r(ie) === "Int16Array";
    }
    e.isInt16Array = M;
    function L(ie) {
      return r(ie) === "Int32Array";
    }
    e.isInt32Array = L;
    function Z(ie) {
      return r(ie) === "Float32Array";
    }
    e.isFloat32Array = Z;
    function Q(ie) {
      return r(ie) === "Float64Array";
    }
    e.isFloat64Array = Q;
    function ae(ie) {
      return r(ie) === "BigInt64Array";
    }
    e.isBigInt64Array = ae;
    function re(ie) {
      return r(ie) === "BigUint64Array";
    }
    e.isBigUint64Array = re;
    function X(ie) {
      return u(ie) === "[object Map]";
    }
    X.working = typeof Map < "u" && X(/* @__PURE__ */ new Map());
    function de(ie) {
      return typeof Map > "u" ? !1 : X.working ? X(ie) : ie instanceof Map;
    }
    e.isMap = de;
    function Ce(ie) {
      return u(ie) === "[object Set]";
    }
    Ce.working = typeof Set < "u" && Ce(/* @__PURE__ */ new Set());
    function J(ie) {
      return typeof Set > "u" ? !1 : Ce.working ? Ce(ie) : ie instanceof Set;
    }
    e.isSet = J;
    function ne(ie) {
      return u(ie) === "[object WeakMap]";
    }
    ne.working = typeof WeakMap < "u" && ne(/* @__PURE__ */ new WeakMap());
    function De(ie) {
      return typeof WeakMap > "u" ? !1 : ne.working ? ne(ie) : ie instanceof WeakMap;
    }
    e.isWeakMap = De;
    function je(ie) {
      return u(ie) === "[object WeakSet]";
    }
    je.working = typeof WeakSet < "u" && je(/* @__PURE__ */ new WeakSet());
    function Me(ie) {
      return je(ie);
    }
    e.isWeakSet = Me;
    function qe(ie) {
      return u(ie) === "[object ArrayBuffer]";
    }
    qe.working = typeof ArrayBuffer < "u" && qe(new ArrayBuffer());
    function Ve(ie) {
      return typeof ArrayBuffer > "u" ? !1 : qe.working ? qe(ie) : ie instanceof ArrayBuffer;
    }
    e.isArrayBuffer = Ve;
    function xe(ie) {
      return u(ie) === "[object DataView]";
    }
    xe.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && xe(new DataView(new ArrayBuffer(1), 0, 1));
    function ve(ie) {
      return typeof DataView > "u" ? !1 : xe.working ? xe(ie) : ie instanceof DataView;
    }
    e.isDataView = ve;
    var Ae = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function Ue(ie) {
      return u(ie) === "[object SharedArrayBuffer]";
    }
    function qt(ie) {
      return typeof Ae > "u" ? !1 : (typeof Ue.working > "u" && (Ue.working = Ue(new Ae())), Ue.working ? Ue(ie) : ie instanceof Ae);
    }
    e.isSharedArrayBuffer = qt;
    function Ze(ie) {
      return u(ie) === "[object AsyncFunction]";
    }
    e.isAsyncFunction = Ze;
    function At(ie) {
      return u(ie) === "[object Map Iterator]";
    }
    e.isMapIterator = At;
    function He(ie) {
      return u(ie) === "[object Set Iterator]";
    }
    e.isSetIterator = He;
    function Dt(ie) {
      return u(ie) === "[object Generator]";
    }
    e.isGeneratorObject = Dt;
    function Fe(ie) {
      return u(ie) === "[object WebAssembly.Module]";
    }
    e.isWebAssemblyCompiledModule = Fe;
    function Xe(ie) {
      return g(ie, s);
    }
    e.isNumberObject = Xe;
    function ze(ie) {
      return g(ie, l);
    }
    e.isStringObject = ze;
    function Rt(ie) {
      return g(ie, d);
    }
    e.isBooleanObject = Rt;
    function Yt(ie) {
      return o && g(ie, f);
    }
    e.isBigIntObject = Yt;
    function ye(ie) {
      return c && g(ie, p);
    }
    e.isSymbolObject = ye;
    function W(ie) {
      return Xe(ie) || ze(ie) || Rt(ie) || Yt(ie) || ye(ie);
    }
    e.isBoxedPrimitive = W;
    function Y(ie) {
      return typeof Uint8Array < "u" && (Ve(ie) || qt(ie));
    }
    e.isAnyArrayBuffer = Y, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ie) {
      Object.defineProperty(e, ie, {
        enumerable: !1,
        value: function() {
          throw new Error(ie + " is not supported in userland");
        }
      });
    });
  })(S3)), S3;
}
var e6, TS;
function yie() {
  return TS || (TS = 1, e6 = function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }), e6;
}
var Ld = { exports: {} }, PS;
function bie() {
  return PS || (PS = 1, typeof Object.create == "function" ? Ld.exports = function(t, n) {
    n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : Ld.exports = function(t, n) {
    if (n) {
      t.super_ = n;
      var r = function() {
      };
      r.prototype = n.prototype, t.prototype = new r(), t.prototype.constructor = t;
    }
  }), Ld.exports;
}
var RS;
function qg() {
  return RS || (RS = 1, (function(e) {
    var t = Object.getOwnPropertyDescriptors || function(ve) {
      for (var Ae = Object.keys(ve), Ue = {}, qt = 0; qt < Ae.length; qt++)
        Ue[Ae[qt]] = Object.getOwnPropertyDescriptor(ve, Ae[qt]);
      return Ue;
    }, n = /%[sdj%]/g;
    e.format = function(xe) {
      if (!O(xe)) {
        for (var ve = [], Ae = 0; Ae < arguments.length; Ae++)
          ve.push(o(arguments[Ae]));
        return ve.join(" ");
      }
      for (var Ae = 1, Ue = arguments, qt = Ue.length, Ze = String(xe).replace(n, function(He) {
        if (He === "%%") return "%";
        if (Ae >= qt) return He;
        switch (He) {
          case "%s":
            return String(Ue[Ae++]);
          case "%d":
            return Number(Ue[Ae++]);
          case "%j":
            try {
              return JSON.stringify(Ue[Ae++]);
            } catch {
              return "[Circular]";
            }
          default:
            return He;
        }
      }), At = Ue[Ae]; Ae < qt; At = Ue[++Ae])
        v(At) || !Q(At) ? Ze += " " + At : Ze += " " + o(At);
      return Ze;
    }, e.deprecate = function(xe, ve) {
      if (typeof gn < "u" && gn.noDeprecation === !0)
        return xe;
      if (typeof gn > "u")
        return function() {
          return e.deprecate(xe, ve).apply(this, arguments);
        };
      var Ae = !1;
      function Ue() {
        if (!Ae) {
          if (gn.throwDeprecation)
            throw new Error(ve);
          gn.traceDeprecation ? console.trace(ve) : console.error(ve), Ae = !0;
        }
        return xe.apply(this, arguments);
      }
      return Ue;
    };
    var r = {}, i = /^$/;
    if (gn.env.NODE_DEBUG) {
      var a = gn.env.NODE_DEBUG;
      a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + a + "$", "i");
    }
    e.debuglog = function(xe) {
      if (xe = xe.toUpperCase(), !r[xe])
        if (i.test(xe)) {
          var ve = gn.pid;
          r[xe] = function() {
            var Ae = e.format.apply(e, arguments);
            console.error("%s %d: %s", xe, ve, Ae);
          };
        } else
          r[xe] = function() {
          };
      return r[xe];
    };
    function o(xe, ve) {
      var Ae = {
        seen: [],
        stylize: u
      };
      return arguments.length >= 3 && (Ae.depth = arguments[2]), arguments.length >= 4 && (Ae.colors = arguments[3]), y(ve) ? Ae.showHidden = ve : ve && e._extend(Ae, ve), L(Ae.showHidden) && (Ae.showHidden = !1), L(Ae.depth) && (Ae.depth = 2), L(Ae.colors) && (Ae.colors = !1), L(Ae.customInspect) && (Ae.customInspect = !0), Ae.colors && (Ae.stylize = c), l(Ae, xe, Ae.depth);
    }
    e.inspect = o, o.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, o.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function c(xe, ve) {
      var Ae = o.styles[ve];
      return Ae ? "\x1B[" + o.colors[Ae][0] + "m" + xe + "\x1B[" + o.colors[Ae][1] + "m" : xe;
    }
    function u(xe, ve) {
      return xe;
    }
    function s(xe) {
      var ve = {};
      return xe.forEach(function(Ae, Ue) {
        ve[Ae] = !0;
      }), ve;
    }
    function l(xe, ve, Ae) {
      if (xe.customInspect && ve && X(ve.inspect) && // Filter out the util module, it's inspect function is special
      ve.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
      !(ve.constructor && ve.constructor.prototype === ve)) {
        var Ue = ve.inspect(Ae, xe);
        return O(Ue) || (Ue = l(xe, Ue, Ae)), Ue;
      }
      var qt = d(xe, ve);
      if (qt)
        return qt;
      var Ze = Object.keys(ve), At = s(Ze);
      if (xe.showHidden && (Ze = Object.getOwnPropertyNames(ve)), re(ve) && (Ze.indexOf("message") >= 0 || Ze.indexOf("description") >= 0))
        return f(ve);
      if (Ze.length === 0) {
        if (X(ve)) {
          var He = ve.name ? ": " + ve.name : "";
          return xe.stylize("[Function" + He + "]", "special");
        }
        if (Z(ve))
          return xe.stylize(RegExp.prototype.toString.call(ve), "regexp");
        if (ae(ve))
          return xe.stylize(Date.prototype.toString.call(ve), "date");
        if (re(ve))
          return f(ve);
      }
      var Dt = "", Fe = !1, Xe = ["{", "}"];
      if (w(ve) && (Fe = !0, Xe = ["[", "]"]), X(ve)) {
        var ze = ve.name ? ": " + ve.name : "";
        Dt = " [Function" + ze + "]";
      }
      if (Z(ve) && (Dt = " " + RegExp.prototype.toString.call(ve)), ae(ve) && (Dt = " " + Date.prototype.toUTCString.call(ve)), re(ve) && (Dt = " " + f(ve)), Ze.length === 0 && (!Fe || ve.length == 0))
        return Xe[0] + Dt + Xe[1];
      if (Ae < 0)
        return Z(ve) ? xe.stylize(RegExp.prototype.toString.call(ve), "regexp") : xe.stylize("[Object]", "special");
      xe.seen.push(ve);
      var Rt;
      return Fe ? Rt = p(xe, ve, Ae, At, Ze) : Rt = Ze.map(function(Yt) {
        return g(xe, ve, Ae, At, Yt, Fe);
      }), xe.seen.pop(), b(Rt, Dt, Xe);
    }
    function d(xe, ve) {
      if (L(ve))
        return xe.stylize("undefined", "undefined");
      if (O(ve)) {
        var Ae = "'" + JSON.stringify(ve).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return xe.stylize(Ae, "string");
      }
      if (E(ve))
        return xe.stylize("" + ve, "number");
      if (y(ve))
        return xe.stylize("" + ve, "boolean");
      if (v(ve))
        return xe.stylize("null", "null");
    }
    function f(xe) {
      return "[" + Error.prototype.toString.call(xe) + "]";
    }
    function p(xe, ve, Ae, Ue, qt) {
      for (var Ze = [], At = 0, He = ve.length; At < He; ++At)
        je(ve, String(At)) ? Ze.push(g(
          xe,
          ve,
          Ae,
          Ue,
          String(At),
          !0
        )) : Ze.push("");
      return qt.forEach(function(Dt) {
        Dt.match(/^\d+$/) || Ze.push(g(
          xe,
          ve,
          Ae,
          Ue,
          Dt,
          !0
        ));
      }), Ze;
    }
    function g(xe, ve, Ae, Ue, qt, Ze) {
      var At, He, Dt;
      if (Dt = Object.getOwnPropertyDescriptor(ve, qt) || { value: ve[qt] }, Dt.get ? Dt.set ? He = xe.stylize("[Getter/Setter]", "special") : He = xe.stylize("[Getter]", "special") : Dt.set && (He = xe.stylize("[Setter]", "special")), je(Ue, qt) || (At = "[" + qt + "]"), He || (xe.seen.indexOf(Dt.value) < 0 ? (v(Ae) ? He = l(xe, Dt.value, null) : He = l(xe, Dt.value, Ae - 1), He.indexOf(`
`) > -1 && (Ze ? He = He.split(`
`).map(function(Fe) {
        return "  " + Fe;
      }).join(`
`).slice(2) : He = `
` + He.split(`
`).map(function(Fe) {
        return "   " + Fe;
      }).join(`
`))) : He = xe.stylize("[Circular]", "special")), L(At)) {
        if (Ze && qt.match(/^\d+$/))
          return He;
        At = JSON.stringify("" + qt), At.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (At = At.slice(1, -1), At = xe.stylize(At, "name")) : (At = At.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), At = xe.stylize(At, "string"));
      }
      return At + ": " + He;
    }
    function b(xe, ve, Ae) {
      var Ue = xe.reduce(function(qt, Ze) {
        return Ze.indexOf(`
`) >= 0, qt + Ze.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return Ue > 60 ? Ae[0] + (ve === "" ? "" : ve + `
 `) + " " + xe.join(`,
  `) + " " + Ae[1] : Ae[0] + ve + " " + xe.join(", ") + " " + Ae[1];
    }
    e.types = vie();
    function w(xe) {
      return Array.isArray(xe);
    }
    e.isArray = w;
    function y(xe) {
      return typeof xe == "boolean";
    }
    e.isBoolean = y;
    function v(xe) {
      return xe === null;
    }
    e.isNull = v;
    function _(xe) {
      return xe == null;
    }
    e.isNullOrUndefined = _;
    function E(xe) {
      return typeof xe == "number";
    }
    e.isNumber = E;
    function O(xe) {
      return typeof xe == "string";
    }
    e.isString = O;
    function M(xe) {
      return typeof xe == "symbol";
    }
    e.isSymbol = M;
    function L(xe) {
      return xe === void 0;
    }
    e.isUndefined = L;
    function Z(xe) {
      return Q(xe) && Ce(xe) === "[object RegExp]";
    }
    e.isRegExp = Z, e.types.isRegExp = Z;
    function Q(xe) {
      return typeof xe == "object" && xe !== null;
    }
    e.isObject = Q;
    function ae(xe) {
      return Q(xe) && Ce(xe) === "[object Date]";
    }
    e.isDate = ae, e.types.isDate = ae;
    function re(xe) {
      return Q(xe) && (Ce(xe) === "[object Error]" || xe instanceof Error);
    }
    e.isError = re, e.types.isNativeError = re;
    function X(xe) {
      return typeof xe == "function";
    }
    e.isFunction = X;
    function de(xe) {
      return xe === null || typeof xe == "boolean" || typeof xe == "number" || typeof xe == "string" || typeof xe == "symbol" || // ES6 symbol
      typeof xe > "u";
    }
    e.isPrimitive = de, e.isBuffer = yie();
    function Ce(xe) {
      return Object.prototype.toString.call(xe);
    }
    function J(xe) {
      return xe < 10 ? "0" + xe.toString(10) : xe.toString(10);
    }
    var ne = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function De() {
      var xe = /* @__PURE__ */ new Date(), ve = [
        J(xe.getHours()),
        J(xe.getMinutes()),
        J(xe.getSeconds())
      ].join(":");
      return [xe.getDate(), ne[xe.getMonth()], ve].join(" ");
    }
    e.log = function() {
      console.log("%s - %s", De(), e.format.apply(e, arguments));
    }, e.inherits = bie(), e._extend = function(xe, ve) {
      if (!ve || !Q(ve)) return xe;
      for (var Ae = Object.keys(ve), Ue = Ae.length; Ue--; )
        xe[Ae[Ue]] = ve[Ae[Ue]];
      return xe;
    };
    function je(xe, ve) {
      return Object.prototype.hasOwnProperty.call(xe, ve);
    }
    var Me = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    e.promisify = function(ve) {
      if (typeof ve != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (Me && ve[Me]) {
        var Ae = ve[Me];
        if (typeof Ae != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(Ae, Me, {
          value: Ae,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), Ae;
      }
      function Ae() {
        for (var Ue, qt, Ze = new Promise(function(Dt, Fe) {
          Ue = Dt, qt = Fe;
        }), At = [], He = 0; He < arguments.length; He++)
          At.push(arguments[He]);
        At.push(function(Dt, Fe) {
          Dt ? qt(Dt) : Ue(Fe);
        });
        try {
          ve.apply(this, At);
        } catch (Dt) {
          qt(Dt);
        }
        return Ze;
      }
      return Object.setPrototypeOf(Ae, Object.getPrototypeOf(ve)), Me && Object.defineProperty(Ae, Me, {
        value: Ae,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        Ae,
        t(ve)
      );
    }, e.promisify.custom = Me;
    function qe(xe, ve) {
      if (!xe) {
        var Ae = new Error("Promise was rejected with a falsy value");
        Ae.reason = xe, xe = Ae;
      }
      return ve(xe);
    }
    function Ve(xe) {
      if (typeof xe != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function ve() {
        for (var Ae = [], Ue = 0; Ue < arguments.length; Ue++)
          Ae.push(arguments[Ue]);
        var qt = Ae.pop();
        if (typeof qt != "function")
          throw new TypeError("The last argument must be of type Function");
        var Ze = this, At = function() {
          return qt.apply(Ze, arguments);
        };
        xe.apply(this, Ae).then(
          function(He) {
            gn.nextTick(At.bind(null, null, He));
          },
          function(He) {
            gn.nextTick(qe.bind(null, He, At));
          }
        );
      }
      return Object.setPrototypeOf(ve, Object.getPrototypeOf(xe)), Object.defineProperties(
        ve,
        t(xe)
      ), ve;
    }
    e.callbackify = Ve;
  })(w3)), w3;
}
var t6, IS;
function xie() {
  if (IS) return t6;
  IS = 1;
  var e = ni.Stream, t = qg();
  t6 = n;
  function n() {
    this.source = null, this.dataSize = 0, this.maxDataSize = 1024 * 1024, this.pauseStream = !0, this._maxDataSizeExceeded = !1, this._released = !1, this._bufferedEvents = [];
  }
  return t.inherits(n, e), n.create = function(r, i) {
    var a = new this();
    i = i || {};
    for (var o in i)
      a[o] = i[o];
    a.source = r;
    var c = r.emit;
    return r.emit = function() {
      return a._handleEmit(arguments), c.apply(r, arguments);
    }, r.on("error", function() {
    }), a.pauseStream && r.pause(), a;
  }, Object.defineProperty(n.prototype, "readable", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.source.readable;
    }
  }), n.prototype.setEncoding = function() {
    return this.source.setEncoding.apply(this.source, arguments);
  }, n.prototype.resume = function() {
    this._released || this.release(), this.source.resume();
  }, n.prototype.pause = function() {
    this.source.pause();
  }, n.prototype.release = function() {
    this._released = !0, this._bufferedEvents.forEach((function(r) {
      this.emit.apply(this, r);
    }).bind(this)), this._bufferedEvents = [];
  }, n.prototype.pipe = function() {
    var r = e.prototype.pipe.apply(this, arguments);
    return this.resume(), r;
  }, n.prototype._handleEmit = function(r) {
    if (this._released) {
      this.emit.apply(this, r);
      return;
    }
    r[0] === "data" && (this.dataSize += r[1].length, this._checkIfMaxDataSizeExceeded()), this._bufferedEvents.push(r);
  }, n.prototype._checkIfMaxDataSizeExceeded = function() {
    if (!this._maxDataSizeExceeded && !(this.dataSize <= this.maxDataSize)) {
      this._maxDataSizeExceeded = !0;
      var r = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
      this.emit("error", new Error(r));
    }
  }, t6;
}
var r6, jS;
function _ie() {
  if (jS) return r6;
  jS = 1;
  var e = qg(), t = ni.Stream, n = xie();
  r6 = r;
  function r() {
    this.writable = !1, this.readable = !0, this.dataSize = 0, this.maxDataSize = 2 * 1024 * 1024, this.pauseStreams = !0, this._released = !1, this._streams = [], this._currentStream = null, this._insideLoop = !1, this._pendingNext = !1;
  }
  return e.inherits(r, t), r.create = function(i) {
    var a = new this();
    i = i || {};
    for (var o in i)
      a[o] = i[o];
    return a;
  }, r.isStreamLike = function(i) {
    return typeof i != "function" && typeof i != "string" && typeof i != "boolean" && typeof i != "number" && !qn.isBuffer(i);
  }, r.prototype.append = function(i) {
    var a = r.isStreamLike(i);
    if (a) {
      if (!(i instanceof n)) {
        var o = n.create(i, {
          maxDataSize: 1 / 0,
          pauseStream: this.pauseStreams
        });
        i.on("data", this._checkDataSize.bind(this)), i = o;
      }
      this._handleErrors(i), this.pauseStreams && i.pause();
    }
    return this._streams.push(i), this;
  }, r.prototype.pipe = function(i, a) {
    return t.prototype.pipe.call(this, i, a), this.resume(), i;
  }, r.prototype._getNext = function() {
    if (this._currentStream = null, this._insideLoop) {
      this._pendingNext = !0;
      return;
    }
    this._insideLoop = !0;
    try {
      do
        this._pendingNext = !1, this._realGetNext();
      while (this._pendingNext);
    } finally {
      this._insideLoop = !1;
    }
  }, r.prototype._realGetNext = function() {
    var i = this._streams.shift();
    if (typeof i > "u") {
      this.end();
      return;
    }
    if (typeof i != "function") {
      this._pipeNext(i);
      return;
    }
    var a = i;
    a((function(o) {
      var c = r.isStreamLike(o);
      c && (o.on("data", this._checkDataSize.bind(this)), this._handleErrors(o)), this._pipeNext(o);
    }).bind(this));
  }, r.prototype._pipeNext = function(i) {
    this._currentStream = i;
    var a = r.isStreamLike(i);
    if (a) {
      i.on("end", this._getNext.bind(this)), i.pipe(this, { end: !1 });
      return;
    }
    var o = i;
    this.write(o), this._getNext();
  }, r.prototype._handleErrors = function(i) {
    var a = this;
    i.on("error", function(o) {
      a._emitError(o);
    });
  }, r.prototype.write = function(i) {
    this.emit("data", i);
  }, r.prototype.pause = function() {
    this.pauseStreams && (this.pauseStreams && this._currentStream && typeof this._currentStream.pause == "function" && this._currentStream.pause(), this.emit("pause"));
  }, r.prototype.resume = function() {
    this._released || (this._released = !0, this.writable = !0, this._getNext()), this.pauseStreams && this._currentStream && typeof this._currentStream.resume == "function" && this._currentStream.resume(), this.emit("resume");
  }, r.prototype.end = function() {
    this._reset(), this.emit("end");
  }, r.prototype.destroy = function() {
    this._reset(), this.emit("close");
  }, r.prototype._reset = function() {
    this.writable = !1, this._streams = [], this._currentStream = null;
  }, r.prototype._checkDataSize = function() {
    if (this._updateDataSize(), !(this.dataSize <= this.maxDataSize)) {
      var i = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
      this._emitError(new Error(i));
    }
  }, r.prototype._updateDataSize = function() {
    this.dataSize = 0;
    var i = this;
    this._streams.forEach(function(a) {
      a.dataSize && (i.dataSize += a.dataSize);
    }), this._currentStream && this._currentStream.dataSize && (this.dataSize += this._currentStream.dataSize);
  }, r.prototype._emitError = function(i) {
    this._reset(), this.emit("error", i);
  }, r6;
}
var cu = {}, uf = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
var wie = uf.exports, qS;
function Sie() {
  return qS || (qS = 1, (function(e, t) {
    (function(n) {
      var r = t && !t.nodeType && t, i = e && !e.nodeType && e, a = typeof Qa == "object" && Qa;
      (a.global === a || a.window === a || a.self === a) && (n = a);
      var o, c = 2147483647, u = 36, s = 1, l = 26, d = 38, f = 700, p = 72, g = 128, b = "-", w = /^xn--/, y = /[^\x20-\x7E]/, v = /[\x2E\u3002\uFF0E\uFF61]/g, _ = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, E = u - s, O = Math.floor, M = String.fromCharCode, L;
      function Z(qe) {
        throw new RangeError(_[qe]);
      }
      function Q(qe, Ve) {
        for (var xe = qe.length, ve = []; xe--; )
          ve[xe] = Ve(qe[xe]);
        return ve;
      }
      function ae(qe, Ve) {
        var xe = qe.split("@"), ve = "";
        xe.length > 1 && (ve = xe[0] + "@", qe = xe[1]), qe = qe.replace(v, ".");
        var Ae = qe.split("."), Ue = Q(Ae, Ve).join(".");
        return ve + Ue;
      }
      function re(qe) {
        for (var Ve = [], xe = 0, ve = qe.length, Ae, Ue; xe < ve; )
          Ae = qe.charCodeAt(xe++), Ae >= 55296 && Ae <= 56319 && xe < ve ? (Ue = qe.charCodeAt(xe++), (Ue & 64512) == 56320 ? Ve.push(((Ae & 1023) << 10) + (Ue & 1023) + 65536) : (Ve.push(Ae), xe--)) : Ve.push(Ae);
        return Ve;
      }
      function X(qe) {
        return Q(qe, function(Ve) {
          var xe = "";
          return Ve > 65535 && (Ve -= 65536, xe += M(Ve >>> 10 & 1023 | 55296), Ve = 56320 | Ve & 1023), xe += M(Ve), xe;
        }).join("");
      }
      function de(qe) {
        return qe - 48 < 10 ? qe - 22 : qe - 65 < 26 ? qe - 65 : qe - 97 < 26 ? qe - 97 : u;
      }
      function Ce(qe, Ve) {
        return qe + 22 + 75 * (qe < 26) - ((Ve != 0) << 5);
      }
      function J(qe, Ve, xe) {
        var ve = 0;
        for (qe = xe ? O(qe / f) : qe >> 1, qe += O(qe / Ve); qe > E * l >> 1; ve += u)
          qe = O(qe / E);
        return O(ve + (E + 1) * qe / (qe + d));
      }
      function ne(qe) {
        var Ve = [], xe = qe.length, ve, Ae = 0, Ue = g, qt = p, Ze, At, He, Dt, Fe, Xe, ze, Rt, Yt;
        for (Ze = qe.lastIndexOf(b), Ze < 0 && (Ze = 0), At = 0; At < Ze; ++At)
          qe.charCodeAt(At) >= 128 && Z("not-basic"), Ve.push(qe.charCodeAt(At));
        for (He = Ze > 0 ? Ze + 1 : 0; He < xe; ) {
          for (Dt = Ae, Fe = 1, Xe = u; He >= xe && Z("invalid-input"), ze = de(qe.charCodeAt(He++)), (ze >= u || ze > O((c - Ae) / Fe)) && Z("overflow"), Ae += ze * Fe, Rt = Xe <= qt ? s : Xe >= qt + l ? l : Xe - qt, !(ze < Rt); Xe += u)
            Yt = u - Rt, Fe > O(c / Yt) && Z("overflow"), Fe *= Yt;
          ve = Ve.length + 1, qt = J(Ae - Dt, ve, Dt == 0), O(Ae / ve) > c - Ue && Z("overflow"), Ue += O(Ae / ve), Ae %= ve, Ve.splice(Ae++, 0, Ue);
        }
        return X(Ve);
      }
      function De(qe) {
        var Ve, xe, ve, Ae, Ue, qt, Ze, At, He, Dt, Fe, Xe = [], ze, Rt, Yt, ye;
        for (qe = re(qe), ze = qe.length, Ve = g, xe = 0, Ue = p, qt = 0; qt < ze; ++qt)
          Fe = qe[qt], Fe < 128 && Xe.push(M(Fe));
        for (ve = Ae = Xe.length, Ae && Xe.push(b); ve < ze; ) {
          for (Ze = c, qt = 0; qt < ze; ++qt)
            Fe = qe[qt], Fe >= Ve && Fe < Ze && (Ze = Fe);
          for (Rt = ve + 1, Ze - Ve > O((c - xe) / Rt) && Z("overflow"), xe += (Ze - Ve) * Rt, Ve = Ze, qt = 0; qt < ze; ++qt)
            if (Fe = qe[qt], Fe < Ve && ++xe > c && Z("overflow"), Fe == Ve) {
              for (At = xe, He = u; Dt = He <= Ue ? s : He >= Ue + l ? l : He - Ue, !(At < Dt); He += u)
                ye = At - Dt, Yt = u - Dt, Xe.push(
                  M(Ce(Dt + ye % Yt, 0))
                ), At = O(ye / Yt);
              Xe.push(M(Ce(At, 0))), Ue = J(xe, Rt, ve == Ae), xe = 0, ++ve;
            }
          ++xe, ++Ve;
        }
        return Xe.join("");
      }
      function je(qe) {
        return ae(qe, function(Ve) {
          return w.test(Ve) ? ne(Ve.slice(4).toLowerCase()) : Ve;
        });
      }
      function Me(qe) {
        return ae(qe, function(Ve) {
          return y.test(Ve) ? "xn--" + De(Ve) : Ve;
        });
      }
      if (o = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: re,
          encode: X
        },
        decode: ne,
        encode: De,
        toASCII: Me,
        toUnicode: je
      }, r && i)
        if (e.exports == r)
          i.exports = o;
        else
          for (L in o)
            o.hasOwnProperty(L) && (r[L] = o[L]);
      else
        n.punycode = o;
    })(wie);
  })(uf, uf.exports)), uf.exports;
}
var n6, DS;
function Cie() {
  if (DS) return n6;
  DS = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = e && t && typeof t.get == "function" ? t.get : null, r = e && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, a = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = i && a && typeof a.get == "function" ? a.get : null, c = i && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype, s = u ? WeakMap.prototype.has : null, l = typeof WeakSet == "function" && WeakSet.prototype, d = l ? WeakSet.prototype.has : null, f = typeof WeakRef == "function" && WeakRef.prototype, p = f ? WeakRef.prototype.deref : null, g = Boolean.prototype.valueOf, b = Object.prototype.toString, w = Function.prototype.toString, y = String.prototype.match, v = String.prototype.slice, _ = String.prototype.replace, E = String.prototype.toUpperCase, O = String.prototype.toLowerCase, M = RegExp.prototype.test, L = Array.prototype.concat, Z = Array.prototype.join, Q = Array.prototype.slice, ae = Math.floor, re = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, X = Object.getOwnPropertySymbols, de = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Ce = typeof Symbol == "function" && typeof Symbol.iterator == "object", J = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Ce || !0) ? Symbol.toStringTag : null, ne = Object.prototype.propertyIsEnumerable, De = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(S) {
    return S.__proto__;
  } : null);
  function je(S, h) {
    if (S === 1 / 0 || S === -1 / 0 || S !== S || S && S > -1e3 && S < 1e3 || M.call(/e/, h))
      return h;
    var k = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof S == "number") {
      var R = S < 0 ? -ae(-S) : ae(S);
      if (R !== S) {
        var j = String(R), A = v.call(h, j.length + 1);
        return _.call(j, k, "$&_") + "." + _.call(_.call(A, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return _.call(h, k, "$&_");
  }
  var Me = ni, qe = Me.custom, Ve = Fe(qe) ? qe : null;
  n6 = function S(h, k, R, j) {
    var A = k || {};
    if (Rt(A, "quoteStyle") && A.quoteStyle !== "single" && A.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Rt(A, "maxStringLength") && (typeof A.maxStringLength == "number" ? A.maxStringLength < 0 && A.maxStringLength !== 1 / 0 : A.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var I = Rt(A, "customInspect") ? A.customInspect : !0;
    if (typeof I != "boolean" && I !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Rt(A, "indent") && A.indent !== null && A.indent !== "	" && !(parseInt(A.indent, 10) === A.indent && A.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Rt(A, "numericSeparator") && typeof A.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var z = A.numericSeparator;
    if (typeof h > "u")
      return "undefined";
    if (h === null)
      return "null";
    if (typeof h == "boolean")
      return h ? "true" : "false";
    if (typeof h == "string")
      return et(h, A);
    if (typeof h == "number") {
      if (h === 0)
        return 1 / 0 / h > 0 ? "0" : "-0";
      var H = String(h);
      return z ? je(h, H) : H;
    }
    if (typeof h == "bigint") {
      var K = String(h) + "n";
      return z ? je(h, K) : K;
    }
    var U = typeof A.depth > "u" ? 5 : A.depth;
    if (typeof R > "u" && (R = 0), R >= U && U > 0 && typeof h == "object")
      return Ae(h) ? "[Array]" : "[Object]";
    var D = F(A, R);
    if (typeof j > "u")
      j = [];
    else if (W(j, h) >= 0)
      return "[Circular]";
    function B(Re, Pe, $e) {
      if (Pe && (j = Q.call(j), j.push(Pe)), $e) {
        var We = {
          depth: A.depth
        };
        return Rt(A, "quoteStyle") && (We.quoteStyle = A.quoteStyle), S(Re, We, R + 1, j);
      }
      return S(Re, A, R + 1, j);
    }
    if (typeof h == "function" && !qt(h)) {
      var ee = ye(h), V = C(h, B);
      return "[Function" + (ee ? ": " + ee : " (anonymous)") + "]" + (V.length > 0 ? " { " + Z.call(V, ", ") + " }" : "");
    }
    if (Fe(h)) {
      var te = Ce ? _.call(String(h), /^(Symbol\(.*\))_[^)]*$/, "$1") : de.call(h);
      return typeof h == "object" && !Ce ? $t(te) : te;
    }
    if (Le(h)) {
      for (var ue = "<" + O.call(String(h.nodeName)), ge = h.attributes || [], pe = 0; pe < ge.length; pe++)
        ue += " " + ge[pe].name + "=" + xe(ve(ge[pe].value), "double", A);
      return ue += ">", h.childNodes && h.childNodes.length && (ue += "..."), ue += "</" + O.call(String(h.nodeName)) + ">", ue;
    }
    if (Ae(h)) {
      if (h.length === 0)
        return "[]";
      var se = C(h, B);
      return D && !N(se) ? "[" + T(se, D) + "]" : "[ " + Z.call(se, ", ") + " ]";
    }
    if (Ze(h)) {
      var ce = C(h, B);
      return !("cause" in Error.prototype) && "cause" in h && !ne.call(h, "cause") ? "{ [" + String(h) + "] " + Z.call(L.call("[cause]: " + B(h.cause), ce), ", ") + " }" : ce.length === 0 ? "[" + String(h) + "]" : "{ [" + String(h) + "] " + Z.call(ce, ", ") + " }";
    }
    if (typeof h == "object" && I) {
      if (Ve && typeof h[Ve] == "function" && Me)
        return Me(h, { depth: U - R });
      if (I !== "symbol" && typeof h.inspect == "function")
        return h.inspect();
    }
    if (Y(h)) {
      var Oe = [];
      return r && r.call(h, function(Re, Pe) {
        Oe.push(B(Pe, h, !0) + " => " + B(Re, h));
      }), P("Map", n.call(h), Oe, D);
    }
    if ($(h)) {
      var fe = [];
      return c && c.call(h, function(Re) {
        fe.push(B(Re, h));
      }), P("Set", o.call(h), fe, D);
    }
    if (ie(h))
      return Be("WeakMap");
    if (_e(h))
      return Be("WeakSet");
    if (Te(h))
      return Be("WeakRef");
    if (He(h))
      return $t(B(Number(h)));
    if (Xe(h))
      return $t(B(re.call(h)));
    if (Dt(h))
      return $t(g.call(h));
    if (At(h))
      return $t(B(String(h)));
    if (typeof window < "u" && h === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && h === globalThis || typeof Qa < "u" && h === Qa)
      return "{ [object globalThis] }";
    if (!Ue(h) && !qt(h)) {
      var be = C(h, B), me = De ? De(h) === Object.prototype : h instanceof Object || h.constructor === Object, Ie = h instanceof Object ? "" : "null prototype", le = !me && J && Object(h) === h && J in h ? v.call(Yt(h), 8, -1) : Ie ? "Object" : "", he = me || typeof h.constructor != "function" ? "" : h.constructor.name ? h.constructor.name + " " : "", we = he + (le || Ie ? "[" + Z.call(L.call([], le || [], Ie || []), ": ") + "] " : "");
      return be.length === 0 ? we + "{}" : D ? we + "{" + T(be, D) + "}" : we + "{ " + Z.call(be, ", ") + " }";
    }
    return String(h);
  };
  function xe(S, h, k) {
    var R = (k.quoteStyle || h) === "double" ? '"' : "'";
    return R + S + R;
  }
  function ve(S) {
    return _.call(String(S), /"/g, "&quot;");
  }
  function Ae(S) {
    return Yt(S) === "[object Array]" && (!J || !(typeof S == "object" && J in S));
  }
  function Ue(S) {
    return Yt(S) === "[object Date]" && (!J || !(typeof S == "object" && J in S));
  }
  function qt(S) {
    return Yt(S) === "[object RegExp]" && (!J || !(typeof S == "object" && J in S));
  }
  function Ze(S) {
    return Yt(S) === "[object Error]" && (!J || !(typeof S == "object" && J in S));
  }
  function At(S) {
    return Yt(S) === "[object String]" && (!J || !(typeof S == "object" && J in S));
  }
  function He(S) {
    return Yt(S) === "[object Number]" && (!J || !(typeof S == "object" && J in S));
  }
  function Dt(S) {
    return Yt(S) === "[object Boolean]" && (!J || !(typeof S == "object" && J in S));
  }
  function Fe(S) {
    if (Ce)
      return S && typeof S == "object" && S instanceof Symbol;
    if (typeof S == "symbol")
      return !0;
    if (!S || typeof S != "object" || !de)
      return !1;
    try {
      return de.call(S), !0;
    } catch {
    }
    return !1;
  }
  function Xe(S) {
    if (!S || typeof S != "object" || !re)
      return !1;
    try {
      return re.call(S), !0;
    } catch {
    }
    return !1;
  }
  var ze = Object.prototype.hasOwnProperty || function(S) {
    return S in this;
  };
  function Rt(S, h) {
    return ze.call(S, h);
  }
  function Yt(S) {
    return b.call(S);
  }
  function ye(S) {
    if (S.name)
      return S.name;
    var h = y.call(w.call(S), /^function\s*([\w$]+)/);
    return h ? h[1] : null;
  }
  function W(S, h) {
    if (S.indexOf)
      return S.indexOf(h);
    for (var k = 0, R = S.length; k < R; k++)
      if (S[k] === h)
        return k;
    return -1;
  }
  function Y(S) {
    if (!n || !S || typeof S != "object")
      return !1;
    try {
      n.call(S);
      try {
        o.call(S);
      } catch {
        return !0;
      }
      return S instanceof Map;
    } catch {
    }
    return !1;
  }
  function ie(S) {
    if (!s || !S || typeof S != "object")
      return !1;
    try {
      s.call(S, s);
      try {
        d.call(S, d);
      } catch {
        return !0;
      }
      return S instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Te(S) {
    if (!p || !S || typeof S != "object")
      return !1;
    try {
      return p.call(S), !0;
    } catch {
    }
    return !1;
  }
  function $(S) {
    if (!o || !S || typeof S != "object")
      return !1;
    try {
      o.call(S);
      try {
        n.call(S);
      } catch {
        return !0;
      }
      return S instanceof Set;
    } catch {
    }
    return !1;
  }
  function _e(S) {
    if (!d || !S || typeof S != "object")
      return !1;
    try {
      d.call(S, d);
      try {
        s.call(S, s);
      } catch {
        return !0;
      }
      return S instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Le(S) {
    return !S || typeof S != "object" ? !1 : typeof HTMLElement < "u" && S instanceof HTMLElement ? !0 : typeof S.nodeName == "string" && typeof S.getAttribute == "function";
  }
  function et(S, h) {
    if (S.length > h.maxStringLength) {
      var k = S.length - h.maxStringLength, R = "... " + k + " more character" + (k > 1 ? "s" : "");
      return et(v.call(S, 0, h.maxStringLength), h) + R;
    }
    var j = _.call(_.call(S, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Ge);
    return xe(j, "single", h);
  }
  function Ge(S) {
    var h = S.charCodeAt(0), k = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[h];
    return k ? "\\" + k : "\\x" + (h < 16 ? "0" : "") + E.call(h.toString(16));
  }
  function $t(S) {
    return "Object(" + S + ")";
  }
  function Be(S) {
    return S + " { ? }";
  }
  function P(S, h, k, R) {
    var j = R ? T(k, R) : Z.call(k, ", ");
    return S + " (" + h + ") {" + j + "}";
  }
  function N(S) {
    for (var h = 0; h < S.length; h++)
      if (W(S[h], `
`) >= 0)
        return !1;
    return !0;
  }
  function F(S, h) {
    var k;
    if (S.indent === "	")
      k = "	";
    else if (typeof S.indent == "number" && S.indent > 0)
      k = Z.call(Array(S.indent + 1), " ");
    else
      return null;
    return {
      base: k,
      prev: Z.call(Array(h + 1), k)
    };
  }
  function T(S, h) {
    if (S.length === 0)
      return "";
    var k = `
` + h.prev + h.base;
    return k + Z.call(S, "," + k) + `
` + h.prev;
  }
  function C(S, h) {
    var k = Ae(S), R = [];
    if (k) {
      R.length = S.length;
      for (var j = 0; j < S.length; j++)
        R[j] = Rt(S, j) ? h(S[j], S) : "";
    }
    var A = typeof X == "function" ? X(S) : [], I;
    if (Ce) {
      I = {};
      for (var z = 0; z < A.length; z++)
        I["$" + A[z]] = A[z];
    }
    for (var H in S)
      Rt(S, H) && (k && String(Number(H)) === H && H < S.length || Ce && I["$" + H] instanceof Symbol || (M.call(/[^\w$]/, H) ? R.push(h(H, S) + ": " + h(S[H], S)) : R.push(H + ": " + h(S[H], S))));
    if (typeof X == "function")
      for (var K = 0; K < A.length; K++)
        ne.call(S, A[K]) && R.push("[" + h(A[K]) + "]: " + h(S[A[K]], S));
    return R;
  }
  return n6;
}
var i6, $S;
function kie() {
  if ($S) return i6;
  $S = 1;
  var e = /* @__PURE__ */ Rc(), t = jg(), n = /* @__PURE__ */ Cie(), r = /* @__PURE__ */ sp(), i = e("%WeakMap%", !0), a = e("%Map%", !0), o = t("WeakMap.prototype.get", !0), c = t("WeakMap.prototype.set", !0), u = t("WeakMap.prototype.has", !0), s = t("Map.prototype.get", !0), l = t("Map.prototype.set", !0), d = t("Map.prototype.has", !0), f = function(w, y) {
    for (var v = w, _; (_ = v.next) !== null; v = _)
      if (_.key === y)
        return v.next = _.next, _.next = /** @type {NonNullable<typeof list.next>} */
        w.next, w.next = _, _;
  }, p = function(w, y) {
    var v = f(w, y);
    return v && v.value;
  }, g = function(w, y, v) {
    var _ = f(w, y);
    _ ? _.value = v : w.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: y,
      next: w.next,
      value: v
    };
  }, b = function(w, y) {
    return !!f(w, y);
  };
  return i6 = function() {
    var y, v, _, E = {
      assert: function(O) {
        if (!E.has(O))
          throw new r("Side channel does not contain " + n(O));
      },
      get: function(O) {
        if (i && O && (typeof O == "object" || typeof O == "function")) {
          if (y)
            return o(y, O);
        } else if (a) {
          if (v)
            return s(v, O);
        } else if (_)
          return p(_, O);
      },
      has: function(O) {
        if (i && O && (typeof O == "object" || typeof O == "function")) {
          if (y)
            return u(y, O);
        } else if (a) {
          if (v)
            return d(v, O);
        } else if (_)
          return b(_, O);
        return !1;
      },
      set: function(O, M) {
        i && O && (typeof O == "object" || typeof O == "function") ? (y || (y = new i()), c(y, O, M)) : a ? (v || (v = new a()), l(v, O, M)) : (_ || (_ = { key: {}, next: null }), g(_, O, M));
      }
    };
    return E;
  }, i6;
}
var a6, LS;
function Dg() {
  if (LS) return a6;
  LS = 1;
  var e = String.prototype.replace, t = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return a6 = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(r) {
        return e.call(r, t, "+");
      },
      RFC3986: function(r) {
        return String(r);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, a6;
}
var o6, NS;
function XO() {
  if (NS) return o6;
  NS = 1;
  var e = /* @__PURE__ */ Dg(), t = Object.prototype.hasOwnProperty, n = Array.isArray, r = (function() {
    for (var w = [], y = 0; y < 256; ++y)
      w.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return w;
  })(), i = function(y) {
    for (; y.length > 1; ) {
      var v = y.pop(), _ = v.obj[v.prop];
      if (n(_)) {
        for (var E = [], O = 0; O < _.length; ++O)
          typeof _[O] < "u" && E.push(_[O]);
        v.obj[v.prop] = E;
      }
    }
  }, a = function(y, v) {
    for (var _ = v && v.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, E = 0; E < y.length; ++E)
      typeof y[E] < "u" && (_[E] = y[E]);
    return _;
  }, o = function w(y, v, _) {
    if (!v)
      return y;
    if (typeof v != "object") {
      if (n(y))
        y.push(v);
      else if (y && typeof y == "object")
        (_ && (_.plainObjects || _.allowPrototypes) || !t.call(Object.prototype, v)) && (y[v] = !0);
      else
        return [y, v];
      return y;
    }
    if (!y || typeof y != "object")
      return [y].concat(v);
    var E = y;
    return n(y) && !n(v) && (E = a(y, _)), n(y) && n(v) ? (v.forEach(function(O, M) {
      if (t.call(y, M)) {
        var L = y[M];
        L && typeof L == "object" && O && typeof O == "object" ? y[M] = w(L, O, _) : y.push(O);
      } else
        y[M] = O;
    }), y) : Object.keys(v).reduce(function(O, M) {
      var L = v[M];
      return t.call(O, M) ? O[M] = w(O[M], L, _) : O[M] = L, O;
    }, E);
  }, c = function(y, v) {
    return Object.keys(v).reduce(function(_, E) {
      return _[E] = v[E], _;
    }, y);
  }, u = function(w, y, v) {
    var _ = w.replace(/\+/g, " ");
    if (v === "iso-8859-1")
      return _.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(_);
    } catch {
      return _;
    }
  }, s = 1024, l = function(y, v, _, E, O) {
    if (y.length === 0)
      return y;
    var M = y;
    if (typeof y == "symbol" ? M = Symbol.prototype.toString.call(y) : typeof y != "string" && (M = String(y)), _ === "iso-8859-1")
      return escape(M).replace(/%u[0-9a-f]{4}/gi, function(de) {
        return "%26%23" + parseInt(de.slice(2), 16) + "%3B";
      });
    for (var L = "", Z = 0; Z < M.length; Z += s) {
      for (var Q = M.length >= s ? M.slice(Z, Z + s) : M, ae = [], re = 0; re < Q.length; ++re) {
        var X = Q.charCodeAt(re);
        if (X === 45 || X === 46 || X === 95 || X === 126 || X >= 48 && X <= 57 || X >= 65 && X <= 90 || X >= 97 && X <= 122 || O === e.RFC1738 && (X === 40 || X === 41)) {
          ae[ae.length] = Q.charAt(re);
          continue;
        }
        if (X < 128) {
          ae[ae.length] = r[X];
          continue;
        }
        if (X < 2048) {
          ae[ae.length] = r[192 | X >> 6] + r[128 | X & 63];
          continue;
        }
        if (X < 55296 || X >= 57344) {
          ae[ae.length] = r[224 | X >> 12] + r[128 | X >> 6 & 63] + r[128 | X & 63];
          continue;
        }
        re += 1, X = 65536 + ((X & 1023) << 10 | Q.charCodeAt(re) & 1023), ae[ae.length] = r[240 | X >> 18] + r[128 | X >> 12 & 63] + r[128 | X >> 6 & 63] + r[128 | X & 63];
      }
      L += ae.join("");
    }
    return L;
  }, d = function(y) {
    for (var v = [{ obj: { o: y }, prop: "o" }], _ = [], E = 0; E < v.length; ++E)
      for (var O = v[E], M = O.obj[O.prop], L = Object.keys(M), Z = 0; Z < L.length; ++Z) {
        var Q = L[Z], ae = M[Q];
        typeof ae == "object" && ae !== null && _.indexOf(ae) === -1 && (v.push({ obj: M, prop: Q }), _.push(ae));
      }
    return i(v), y;
  }, f = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, p = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, g = function(y, v) {
    return [].concat(y, v);
  }, b = function(y, v) {
    if (n(y)) {
      for (var _ = [], E = 0; E < y.length; E += 1)
        _.push(v(y[E]));
      return _;
    }
    return v(y);
  };
  return o6 = {
    arrayToObject: a,
    assign: c,
    combine: g,
    compact: d,
    decode: u,
    encode: l,
    isBuffer: p,
    isRegExp: f,
    maybeMap: b,
    merge: o
  }, o6;
}
var s6, FS;
function Aie() {
  if (FS) return s6;
  FS = 1;
  var e = kie(), t = /* @__PURE__ */ XO(), n = /* @__PURE__ */ Dg(), r = Object.prototype.hasOwnProperty, i = {
    brackets: function(w) {
      return w + "[]";
    },
    comma: "comma",
    indices: function(w, y) {
      return w + "[" + y + "]";
    },
    repeat: function(w) {
      return w;
    }
  }, a = Array.isArray, o = Array.prototype.push, c = function(b, w) {
    o.apply(b, a(w) ? w : [w]);
  }, u = Date.prototype.toISOString, s = n.default, l = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    format: s,
    formatter: n.formatters[s],
    // deprecated
    indices: !1,
    serializeDate: function(w) {
      return u.call(w);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, d = function(w) {
    return typeof w == "string" || typeof w == "number" || typeof w == "boolean" || typeof w == "symbol" || typeof w == "bigint";
  }, f = {}, p = function b(w, y, v, _, E, O, M, L, Z, Q, ae, re, X, de, Ce, J, ne, De) {
    for (var je = w, Me = De, qe = 0, Ve = !1; (Me = Me.get(f)) !== void 0 && !Ve; ) {
      var xe = Me.get(w);
      if (qe += 1, typeof xe < "u") {
        if (xe === qe)
          throw new RangeError("Cyclic object value");
        Ve = !0;
      }
      typeof Me.get(f) > "u" && (qe = 0);
    }
    if (typeof Q == "function" ? je = Q(y, je) : je instanceof Date ? je = X(je) : v === "comma" && a(je) && (je = t.maybeMap(je, function(Yt) {
      return Yt instanceof Date ? X(Yt) : Yt;
    })), je === null) {
      if (O)
        return Z && !J ? Z(y, l.encoder, ne, "key", de) : y;
      je = "";
    }
    if (d(je) || t.isBuffer(je)) {
      if (Z) {
        var ve = J ? y : Z(y, l.encoder, ne, "key", de);
        return [Ce(ve) + "=" + Ce(Z(je, l.encoder, ne, "value", de))];
      }
      return [Ce(y) + "=" + Ce(String(je))];
    }
    var Ae = [];
    if (typeof je > "u")
      return Ae;
    var Ue;
    if (v === "comma" && a(je))
      J && Z && (je = t.maybeMap(je, Z)), Ue = [{ value: je.length > 0 ? je.join(",") || null : void 0 }];
    else if (a(Q))
      Ue = Q;
    else {
      var qt = Object.keys(je);
      Ue = ae ? qt.sort(ae) : qt;
    }
    var Ze = L ? y.replace(/\./g, "%2E") : y, At = _ && a(je) && je.length === 1 ? Ze + "[]" : Ze;
    if (E && a(je) && je.length === 0)
      return At + "[]";
    for (var He = 0; He < Ue.length; ++He) {
      var Dt = Ue[He], Fe = typeof Dt == "object" && typeof Dt.value < "u" ? Dt.value : je[Dt];
      if (!(M && Fe === null)) {
        var Xe = re && L ? Dt.replace(/\./g, "%2E") : Dt, ze = a(je) ? typeof v == "function" ? v(At, Xe) : At : At + (re ? "." + Xe : "[" + Xe + "]");
        De.set(w, qe);
        var Rt = e();
        Rt.set(f, De), c(Ae, b(
          Fe,
          ze,
          v,
          _,
          E,
          O,
          M,
          L,
          v === "comma" && J && a(je) ? null : Z,
          Q,
          ae,
          re,
          X,
          de,
          Ce,
          J,
          ne,
          Rt
        ));
      }
    }
    return Ae;
  }, g = function(w) {
    if (!w)
      return l;
    if (typeof w.allowEmptyArrays < "u" && typeof w.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof w.encodeDotInKeys < "u" && typeof w.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (w.encoder !== null && typeof w.encoder < "u" && typeof w.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var y = w.charset || l.charset;
    if (typeof w.charset < "u" && w.charset !== "utf-8" && w.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var v = n.default;
    if (typeof w.format < "u") {
      if (!r.call(n.formatters, w.format))
        throw new TypeError("Unknown format option provided.");
      v = w.format;
    }
    var _ = n.formatters[v], E = l.filter;
    (typeof w.filter == "function" || a(w.filter)) && (E = w.filter);
    var O;
    if (w.arrayFormat in i ? O = w.arrayFormat : "indices" in w ? O = w.indices ? "indices" : "repeat" : O = l.arrayFormat, "commaRoundTrip" in w && typeof w.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var M = typeof w.allowDots > "u" ? w.encodeDotInKeys === !0 ? !0 : l.allowDots : !!w.allowDots;
    return {
      addQueryPrefix: typeof w.addQueryPrefix == "boolean" ? w.addQueryPrefix : l.addQueryPrefix,
      allowDots: M,
      allowEmptyArrays: typeof w.allowEmptyArrays == "boolean" ? !!w.allowEmptyArrays : l.allowEmptyArrays,
      arrayFormat: O,
      charset: y,
      charsetSentinel: typeof w.charsetSentinel == "boolean" ? w.charsetSentinel : l.charsetSentinel,
      commaRoundTrip: w.commaRoundTrip,
      delimiter: typeof w.delimiter > "u" ? l.delimiter : w.delimiter,
      encode: typeof w.encode == "boolean" ? w.encode : l.encode,
      encodeDotInKeys: typeof w.encodeDotInKeys == "boolean" ? w.encodeDotInKeys : l.encodeDotInKeys,
      encoder: typeof w.encoder == "function" ? w.encoder : l.encoder,
      encodeValuesOnly: typeof w.encodeValuesOnly == "boolean" ? w.encodeValuesOnly : l.encodeValuesOnly,
      filter: E,
      format: v,
      formatter: _,
      serializeDate: typeof w.serializeDate == "function" ? w.serializeDate : l.serializeDate,
      skipNulls: typeof w.skipNulls == "boolean" ? w.skipNulls : l.skipNulls,
      sort: typeof w.sort == "function" ? w.sort : null,
      strictNullHandling: typeof w.strictNullHandling == "boolean" ? w.strictNullHandling : l.strictNullHandling
    };
  };
  return s6 = function(b, w) {
    var y = b, v = g(w), _, E;
    typeof v.filter == "function" ? (E = v.filter, y = E("", y)) : a(v.filter) && (E = v.filter, _ = E);
    var O = [];
    if (typeof y != "object" || y === null)
      return "";
    var M = i[v.arrayFormat], L = M === "comma" && v.commaRoundTrip;
    _ || (_ = Object.keys(y)), v.sort && _.sort(v.sort);
    for (var Z = e(), Q = 0; Q < _.length; ++Q) {
      var ae = _[Q];
      v.skipNulls && y[ae] === null || c(O, p(
        y[ae],
        ae,
        M,
        L,
        v.allowEmptyArrays,
        v.strictNullHandling,
        v.skipNulls,
        v.encodeDotInKeys,
        v.encode ? v.encoder : null,
        v.filter,
        v.sort,
        v.allowDots,
        v.serializeDate,
        v.format,
        v.formatter,
        v.encodeValuesOnly,
        v.charset,
        Z
      ));
    }
    var re = O.join(v.delimiter), X = v.addQueryPrefix === !0 ? "?" : "";
    return v.charsetSentinel && (v.charset === "iso-8859-1" ? X += "utf8=%26%2310003%3B&" : X += "utf8=%E2%9C%93&"), re.length > 0 ? X + re : "";
  }, s6;
}
var u6, MS;
function Eie() {
  if (MS) return u6;
  MS = 1;
  var e = /* @__PURE__ */ XO(), t = Object.prototype.hasOwnProperty, n = Array.isArray, r = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1
  }, i = function(f) {
    return f.replace(/&#(\d+);/g, function(p, g) {
      return String.fromCharCode(parseInt(g, 10));
    });
  }, a = function(f, p) {
    return f && typeof f == "string" && p.comma && f.indexOf(",") > -1 ? f.split(",") : f;
  }, o = "utf8=%26%2310003%3B", c = "utf8=%E2%9C%93", u = function(p, g) {
    var b = { __proto__: null }, w = g.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    w = w.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var y = g.parameterLimit === 1 / 0 ? void 0 : g.parameterLimit, v = w.split(g.delimiter, y), _ = -1, E, O = g.charset;
    if (g.charsetSentinel)
      for (E = 0; E < v.length; ++E)
        v[E].indexOf("utf8=") === 0 && (v[E] === c ? O = "utf-8" : v[E] === o && (O = "iso-8859-1"), _ = E, E = v.length);
    for (E = 0; E < v.length; ++E)
      if (E !== _) {
        var M = v[E], L = M.indexOf("]="), Z = L === -1 ? M.indexOf("=") : L + 1, Q, ae;
        Z === -1 ? (Q = g.decoder(M, r.decoder, O, "key"), ae = g.strictNullHandling ? null : "") : (Q = g.decoder(M.slice(0, Z), r.decoder, O, "key"), ae = e.maybeMap(
          a(M.slice(Z + 1), g),
          function(X) {
            return g.decoder(X, r.decoder, O, "value");
          }
        )), ae && g.interpretNumericEntities && O === "iso-8859-1" && (ae = i(ae)), M.indexOf("[]=") > -1 && (ae = n(ae) ? [ae] : ae);
        var re = t.call(b, Q);
        re && g.duplicates === "combine" ? b[Q] = e.combine(b[Q], ae) : (!re || g.duplicates === "last") && (b[Q] = ae);
      }
    return b;
  }, s = function(f, p, g, b) {
    for (var w = b ? p : a(p, g), y = f.length - 1; y >= 0; --y) {
      var v, _ = f[y];
      if (_ === "[]" && g.parseArrays)
        v = g.allowEmptyArrays && (w === "" || g.strictNullHandling && w === null) ? [] : [].concat(w);
      else {
        v = g.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var E = _.charAt(0) === "[" && _.charAt(_.length - 1) === "]" ? _.slice(1, -1) : _, O = g.decodeDotInKeys ? E.replace(/%2E/g, ".") : E, M = parseInt(O, 10);
        !g.parseArrays && O === "" ? v = { 0: w } : !isNaN(M) && _ !== O && String(M) === O && M >= 0 && g.parseArrays && M <= g.arrayLimit ? (v = [], v[M] = w) : O !== "__proto__" && (v[O] = w);
      }
      w = v;
    }
    return w;
  }, l = function(p, g, b, w) {
    if (p) {
      var y = b.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p, v = /(\[[^[\]]*])/, _ = /(\[[^[\]]*])/g, E = b.depth > 0 && v.exec(y), O = E ? y.slice(0, E.index) : y, M = [];
      if (O) {
        if (!b.plainObjects && t.call(Object.prototype, O) && !b.allowPrototypes)
          return;
        M.push(O);
      }
      for (var L = 0; b.depth > 0 && (E = _.exec(y)) !== null && L < b.depth; ) {
        if (L += 1, !b.plainObjects && t.call(Object.prototype, E[1].slice(1, -1)) && !b.allowPrototypes)
          return;
        M.push(E[1]);
      }
      if (E) {
        if (b.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + b.depth + " and strictDepth is true");
        M.push("[" + y.slice(E.index) + "]");
      }
      return s(M, g, b, w);
    }
  }, d = function(p) {
    if (!p)
      return r;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var g = typeof p.charset > "u" ? r.charset : p.charset, b = typeof p.duplicates > "u" ? r.duplicates : p.duplicates;
    if (b !== "combine" && b !== "first" && b !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var w = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : r.allowDots : !!p.allowDots;
    return {
      allowDots: w,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : r.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : r.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : r.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : r.arrayLimit,
      charset: g,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : r.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : r.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : r.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : r.decoder,
      delimiter: typeof p.delimiter == "string" || e.isRegExp(p.delimiter) ? p.delimiter : r.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : r.depth,
      duplicates: b,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : r.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : r.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : r.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : r.strictDepth,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : r.strictNullHandling
    };
  };
  return u6 = function(f, p) {
    var g = d(p);
    if (f === "" || f === null || typeof f > "u")
      return g.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var b = typeof f == "string" ? u(f, g) : f, w = g.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, y = Object.keys(b), v = 0; v < y.length; ++v) {
      var _ = y[v], E = l(_, b[_], g, typeof f == "string");
      w = e.merge(w, E, g);
    }
    return g.allowSparse === !0 ? w : e.compact(w);
  }, u6;
}
var c6, BS;
function Oie() {
  if (BS) return c6;
  BS = 1;
  var e = /* @__PURE__ */ Aie(), t = /* @__PURE__ */ Eie(), n = /* @__PURE__ */ Dg();
  return c6 = {
    formats: n,
    parse: t,
    stringify: e
  }, c6;
}
var US;
function eT() {
  if (US) return cu;
  US = 1;
  var e = Sie();
  function t() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  var n = /^([a-z0-9.+-]+:)/i, r = /:[0-9]*$/, i = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, a = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
  ], o = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
  ].concat(a), c = ["'"].concat(o), u = [
    "%",
    "/",
    "?",
    ";",
    "#"
  ].concat(c), s = [
    "/",
    "?",
    "#"
  ], l = 255, d = /^[+a-z0-9A-Z_-]{0,63}$/, f = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, p = {
    javascript: !0,
    "javascript:": !0
  }, g = {
    javascript: !0,
    "javascript:": !0
  }, b = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  }, w = /* @__PURE__ */ Oie();
  function y(O, M, L) {
    if (O && typeof O == "object" && O instanceof t)
      return O;
    var Z = new t();
    return Z.parse(O, M, L), Z;
  }
  t.prototype.parse = function(O, M, L) {
    if (typeof O != "string")
      throw new TypeError("Parameter 'url' must be a string, not " + typeof O);
    var Z = O.indexOf("?"), Q = Z !== -1 && Z < O.indexOf("#") ? "?" : "#", ae = O.split(Q), re = /\\/g;
    ae[0] = ae[0].replace(re, "/"), O = ae.join(Q);
    var X = O;
    if (X = X.trim(), !L && O.split("#").length === 1) {
      var de = i.exec(X);
      if (de)
        return this.path = X, this.href = X, this.pathname = de[1], de[2] ? (this.search = de[2], M ? this.query = w.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : M && (this.search = "", this.query = {}), this;
    }
    var Ce = n.exec(X);
    if (Ce) {
      Ce = Ce[0];
      var J = Ce.toLowerCase();
      this.protocol = J, X = X.substr(Ce.length);
    }
    if (L || Ce || X.match(/^\/\/[^@/]+@[^@/]+/)) {
      var ne = X.substr(0, 2) === "//";
      ne && !(Ce && g[Ce]) && (X = X.substr(2), this.slashes = !0);
    }
    if (!g[Ce] && (ne || Ce && !b[Ce])) {
      for (var De = -1, je = 0; je < s.length; je++) {
        var Me = X.indexOf(s[je]);
        Me !== -1 && (De === -1 || Me < De) && (De = Me);
      }
      var qe, Ve;
      De === -1 ? Ve = X.lastIndexOf("@") : Ve = X.lastIndexOf("@", De), Ve !== -1 && (qe = X.slice(0, Ve), X = X.slice(Ve + 1), this.auth = decodeURIComponent(qe)), De = -1;
      for (var je = 0; je < u.length; je++) {
        var Me = X.indexOf(u[je]);
        Me !== -1 && (De === -1 || Me < De) && (De = Me);
      }
      De === -1 && (De = X.length), this.host = X.slice(0, De), X = X.slice(De), this.parseHost(), this.hostname = this.hostname || "";
      var xe = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!xe)
        for (var ve = this.hostname.split(/\./), je = 0, Ae = ve.length; je < Ae; je++) {
          var Ue = ve[je];
          if (Ue && !Ue.match(d)) {
            for (var qt = "", Ze = 0, At = Ue.length; Ze < At; Ze++)
              Ue.charCodeAt(Ze) > 127 ? qt += "x" : qt += Ue[Ze];
            if (!qt.match(d)) {
              var He = ve.slice(0, je), Dt = ve.slice(je + 1), Fe = Ue.match(f);
              Fe && (He.push(Fe[1]), Dt.unshift(Fe[2])), Dt.length && (X = "/" + Dt.join(".") + X), this.hostname = He.join(".");
              break;
            }
          }
        }
      this.hostname.length > l ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), xe || (this.hostname = e.toASCII(this.hostname));
      var Xe = this.port ? ":" + this.port : "", ze = this.hostname || "";
      this.host = ze + Xe, this.href += this.host, xe && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), X[0] !== "/" && (X = "/" + X));
    }
    if (!p[J])
      for (var je = 0, Ae = c.length; je < Ae; je++) {
        var Rt = c[je];
        if (X.indexOf(Rt) !== -1) {
          var Yt = encodeURIComponent(Rt);
          Yt === Rt && (Yt = escape(Rt)), X = X.split(Rt).join(Yt);
        }
      }
    var ye = X.indexOf("#");
    ye !== -1 && (this.hash = X.substr(ye), X = X.slice(0, ye));
    var W = X.indexOf("?");
    if (W !== -1 ? (this.search = X.substr(W), this.query = X.substr(W + 1), M && (this.query = w.parse(this.query)), X = X.slice(0, W)) : M && (this.search = "", this.query = {}), X && (this.pathname = X), b[J] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var Xe = this.pathname || "", Y = this.search || "";
      this.path = Xe + Y;
    }
    return this.href = this.format(), this;
  };
  function v(O) {
    return typeof O == "string" && (O = y(O)), O instanceof t ? O.format() : t.prototype.format.call(O);
  }
  t.prototype.format = function() {
    var O = this.auth || "";
    O && (O = encodeURIComponent(O), O = O.replace(/%3A/i, ":"), O += "@");
    var M = this.protocol || "", L = this.pathname || "", Z = this.hash || "", Q = !1, ae = "";
    this.host ? Q = O + this.host : this.hostname && (Q = O + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (Q += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (ae = w.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var re = this.search || ae && "?" + ae || "";
    return M && M.substr(-1) !== ":" && (M += ":"), this.slashes || (!M || b[M]) && Q !== !1 ? (Q = "//" + (Q || ""), L && L.charAt(0) !== "/" && (L = "/" + L)) : Q || (Q = ""), Z && Z.charAt(0) !== "#" && (Z = "#" + Z), re && re.charAt(0) !== "?" && (re = "?" + re), L = L.replace(/[?#]/g, function(X) {
      return encodeURIComponent(X);
    }), re = re.replace("#", "%23"), M + Q + L + re + Z;
  };
  function _(O, M) {
    return y(O, !1, !0).resolve(M);
  }
  t.prototype.resolve = function(O) {
    return this.resolveObject(y(O, !1, !0)).format();
  };
  function E(O, M) {
    return O ? y(O, !1, !0).resolveObject(M) : M;
  }
  return t.prototype.resolveObject = function(O) {
    if (typeof O == "string") {
      var M = new t();
      M.parse(O, !1, !0), O = M;
    }
    for (var L = new t(), Z = Object.keys(this), Q = 0; Q < Z.length; Q++) {
      var ae = Z[Q];
      L[ae] = this[ae];
    }
    if (L.hash = O.hash, O.href === "")
      return L.href = L.format(), L;
    if (O.slashes && !O.protocol) {
      for (var re = Object.keys(O), X = 0; X < re.length; X++) {
        var de = re[X];
        de !== "protocol" && (L[de] = O[de]);
      }
      return b[L.protocol] && L.hostname && !L.pathname && (L.pathname = "/", L.path = L.pathname), L.href = L.format(), L;
    }
    if (O.protocol && O.protocol !== L.protocol) {
      if (!b[O.protocol]) {
        for (var Ce = Object.keys(O), J = 0; J < Ce.length; J++) {
          var ne = Ce[J];
          L[ne] = O[ne];
        }
        return L.href = L.format(), L;
      }
      if (L.protocol = O.protocol, !O.host && !g[O.protocol]) {
        for (var Ae = (O.pathname || "").split("/"); Ae.length && !(O.host = Ae.shift()); )
          ;
        O.host || (O.host = ""), O.hostname || (O.hostname = ""), Ae[0] !== "" && Ae.unshift(""), Ae.length < 2 && Ae.unshift(""), L.pathname = Ae.join("/");
      } else
        L.pathname = O.pathname;
      if (L.search = O.search, L.query = O.query, L.host = O.host || "", L.auth = O.auth, L.hostname = O.hostname || O.host, L.port = O.port, L.pathname || L.search) {
        var De = L.pathname || "", je = L.search || "";
        L.path = De + je;
      }
      return L.slashes = L.slashes || O.slashes, L.href = L.format(), L;
    }
    var Me = L.pathname && L.pathname.charAt(0) === "/", qe = O.host || O.pathname && O.pathname.charAt(0) === "/", Ve = qe || Me || L.host && O.pathname, xe = Ve, ve = L.pathname && L.pathname.split("/") || [], Ae = O.pathname && O.pathname.split("/") || [], Ue = L.protocol && !b[L.protocol];
    if (Ue && (L.hostname = "", L.port = null, L.host && (ve[0] === "" ? ve[0] = L.host : ve.unshift(L.host)), L.host = "", O.protocol && (O.hostname = null, O.port = null, O.host && (Ae[0] === "" ? Ae[0] = O.host : Ae.unshift(O.host)), O.host = null), Ve = Ve && (Ae[0] === "" || ve[0] === "")), qe)
      L.host = O.host || O.host === "" ? O.host : L.host, L.hostname = O.hostname || O.hostname === "" ? O.hostname : L.hostname, L.search = O.search, L.query = O.query, ve = Ae;
    else if (Ae.length)
      ve || (ve = []), ve.pop(), ve = ve.concat(Ae), L.search = O.search, L.query = O.query;
    else if (O.search != null) {
      if (Ue) {
        L.host = ve.shift(), L.hostname = L.host;
        var qt = L.host && L.host.indexOf("@") > 0 ? L.host.split("@") : !1;
        qt && (L.auth = qt.shift(), L.hostname = qt.shift(), L.host = L.hostname);
      }
      return L.search = O.search, L.query = O.query, (L.pathname !== null || L.search !== null) && (L.path = (L.pathname ? L.pathname : "") + (L.search ? L.search : "")), L.href = L.format(), L;
    }
    if (!ve.length)
      return L.pathname = null, L.search ? L.path = "/" + L.search : L.path = null, L.href = L.format(), L;
    for (var Ze = ve.slice(-1)[0], At = (L.host || O.host || ve.length > 1) && (Ze === "." || Ze === "..") || Ze === "", He = 0, Dt = ve.length; Dt >= 0; Dt--)
      Ze = ve[Dt], Ze === "." ? ve.splice(Dt, 1) : Ze === ".." ? (ve.splice(Dt, 1), He++) : He && (ve.splice(Dt, 1), He--);
    if (!Ve && !xe)
      for (; He--; He)
        ve.unshift("..");
    Ve && ve[0] !== "" && (!ve[0] || ve[0].charAt(0) !== "/") && ve.unshift(""), At && ve.join("/").substr(-1) !== "/" && ve.push("");
    var Fe = ve[0] === "" || ve[0] && ve[0].charAt(0) === "/";
    if (Ue) {
      L.hostname = Fe ? "" : ve.length ? ve.shift() : "", L.host = L.hostname;
      var qt = L.host && L.host.indexOf("@") > 0 ? L.host.split("@") : !1;
      qt && (L.auth = qt.shift(), L.hostname = qt.shift(), L.host = L.hostname);
    }
    return Ve = Ve || L.host && ve.length, Ve && !Fe && ve.unshift(""), ve.length > 0 ? L.pathname = ve.join("/") : (L.pathname = null, L.path = null), (L.pathname !== null || L.search !== null) && (L.path = (L.pathname ? L.pathname : "") + (L.search ? L.search : "")), L.auth = O.auth || L.auth, L.slashes = L.slashes || O.slashes, L.href = L.format(), L;
  }, t.prototype.parseHost = function() {
    var O = this.host, M = r.exec(O);
    M && (M = M[0], M !== ":" && (this.port = M.substr(1)), O = O.substr(0, O.length - M.length)), O && (this.hostname = O);
  }, cu.parse = y, cu.resolve = _, cu.resolveObject = E, cu.format = v, cu.Url = t, cu;
}
var l6 = {};
const Tie = {
  "application/1d-interleaved-parityfec": { source: "iana" },
  "application/3gpdash-qoe-report+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/3gpp-ims+xml": { source: "iana", compressible: !0 },
  "application/3gpphal+json": { source: "iana", compressible: !0 },
  "application/3gpphalforms+json": { source: "iana", compressible: !0 },
  "application/a2l": { source: "iana" },
  "application/ace+cbor": { source: "iana" },
  "application/activemessage": { source: "iana" },
  "application/activity+json": { source: "iana", compressible: !0 },
  "application/alto-costmap+json": { source: "iana", compressible: !0 },
  "application/alto-costmapfilter+json": { source: "iana", compressible: !0 },
  "application/alto-directory+json": { source: "iana", compressible: !0 },
  "application/alto-endpointcost+json": { source: "iana", compressible: !0 },
  "application/alto-endpointcostparams+json": { source: "iana", compressible: !0 },
  "application/alto-endpointprop+json": { source: "iana", compressible: !0 },
  "application/alto-endpointpropparams+json": { source: "iana", compressible: !0 },
  "application/alto-error+json": { source: "iana", compressible: !0 },
  "application/alto-networkmap+json": { source: "iana", compressible: !0 },
  "application/alto-networkmapfilter+json": { source: "iana", compressible: !0 },
  "application/alto-updatestreamcontrol+json": { source: "iana", compressible: !0 },
  "application/alto-updatestreamparams+json": { source: "iana", compressible: !0 },
  "application/aml": { source: "iana" },
  "application/andrew-inset": { source: "iana", extensions: ["ez"] },
  "application/applefile": { source: "iana" },
  "application/applixware": { source: "apache", extensions: ["aw"] },
  "application/at+jwt": { source: "iana" },
  "application/atf": { source: "iana" },
  "application/atfx": { source: "iana" },
  "application/atom+xml": { source: "iana", compressible: !0, extensions: ["atom"] },
  "application/atomcat+xml": { source: "iana", compressible: !0, extensions: ["atomcat"] },
  "application/atomdeleted+xml": { source: "iana", compressible: !0, extensions: ["atomdeleted"] },
  "application/atomicmail": { source: "iana" },
  "application/atomsvc+xml": { source: "iana", compressible: !0, extensions: ["atomsvc"] },
  "application/atsc-dwd+xml": { source: "iana", compressible: !0, extensions: ["dwd"] },
  "application/atsc-dynamic-event-message": { source: "iana" },
  "application/atsc-held+xml": { source: "iana", compressible: !0, extensions: ["held"] },
  "application/atsc-rdt+json": { source: "iana", compressible: !0 },
  "application/atsc-rsat+xml": { source: "iana", compressible: !0, extensions: ["rsat"] },
  "application/atxml": { source: "iana" },
  "application/auth-policy+xml": { source: "iana", compressible: !0 },
  "application/bacnet-xdd+zip": { source: "iana", compressible: !1 },
  "application/batch-smtp": { source: "iana" },
  "application/bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/beep+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/calendar+json": { source: "iana", compressible: !0 },
  "application/calendar+xml": { source: "iana", compressible: !0, extensions: ["xcs"] },
  "application/call-completion": { source: "iana" },
  "application/cals-1840": { source: "iana" },
  "application/captive+json": { source: "iana", compressible: !0 },
  "application/cbor": { source: "iana" },
  "application/cbor-seq": { source: "iana" },
  "application/cccex": { source: "iana" },
  "application/ccmp+xml": { source: "iana", compressible: !0 },
  "application/ccxml+xml": { source: "iana", compressible: !0, extensions: ["ccxml"] },
  "application/cdfx+xml": { source: "iana", compressible: !0, extensions: ["cdfx"] },
  "application/cdmi-capability": { source: "iana", extensions: ["cdmia"] },
  "application/cdmi-container": { source: "iana", extensions: ["cdmic"] },
  "application/cdmi-domain": { source: "iana", extensions: ["cdmid"] },
  "application/cdmi-object": { source: "iana", extensions: ["cdmio"] },
  "application/cdmi-queue": { source: "iana", extensions: ["cdmiq"] },
  "application/cdni": { source: "iana" },
  "application/cea": { source: "iana" },
  "application/cea-2018+xml": { source: "iana", compressible: !0 },
  "application/cellml+xml": { source: "iana", compressible: !0 },
  "application/cfw": { source: "iana" },
  "application/city+json": { source: "iana", compressible: !0 },
  "application/clr": { source: "iana" },
  "application/clue+xml": { source: "iana", compressible: !0 },
  "application/clue_info+xml": { source: "iana", compressible: !0 },
  "application/cms": { source: "iana" },
  "application/cnrp+xml": { source: "iana", compressible: !0 },
  "application/coap-group+json": { source: "iana", compressible: !0 },
  "application/coap-payload": { source: "iana" },
  "application/commonground": { source: "iana" },
  "application/conference-info+xml": { source: "iana", compressible: !0 },
  "application/cose": { source: "iana" },
  "application/cose-key": { source: "iana" },
  "application/cose-key-set": { source: "iana" },
  "application/cpl+xml": { source: "iana", compressible: !0, extensions: ["cpl"] },
  "application/csrattrs": { source: "iana" },
  "application/csta+xml": { source: "iana", compressible: !0 },
  "application/cstadata+xml": { source: "iana", compressible: !0 },
  "application/csvm+json": { source: "iana", compressible: !0 },
  "application/cu-seeme": { source: "apache", extensions: ["cu"] },
  "application/cwt": { source: "iana" },
  "application/cybercash": { source: "iana" },
  "application/dart": { compressible: !0 },
  "application/dash+xml": { source: "iana", compressible: !0, extensions: ["mpd"] },
  "application/dash-patch+xml": { source: "iana", compressible: !0, extensions: ["mpp"] },
  "application/dashdelta": { source: "iana" },
  "application/davmount+xml": { source: "iana", compressible: !0, extensions: ["davmount"] },
  "application/dca-rft": { source: "iana" },
  "application/dcd": { source: "iana" },
  "application/dec-dx": { source: "iana" },
  "application/dialog-info+xml": { source: "iana", compressible: !0 },
  "application/dicom": { source: "iana" },
  "application/dicom+json": { source: "iana", compressible: !0 },
  "application/dicom+xml": { source: "iana", compressible: !0 },
  "application/dii": { source: "iana" },
  "application/dit": { source: "iana" },
  "application/dns": { source: "iana" },
  "application/dns+json": { source: "iana", compressible: !0 },
  "application/dns-message": { source: "iana" },
  "application/docbook+xml": { source: "apache", compressible: !0, extensions: ["dbk"] },
  "application/dots+cbor": { source: "iana" },
  "application/dskpp+xml": { source: "iana", compressible: !0 },
  "application/dssc+der": { source: "iana", extensions: ["dssc"] },
  "application/dssc+xml": { source: "iana", compressible: !0, extensions: ["xdssc"] },
  "application/dvcs": { source: "iana" },
  "application/ecmascript": { source: "iana", compressible: !0, extensions: ["es", "ecma"] },
  "application/edi-consent": { source: "iana" },
  "application/edi-x12": { source: "iana", compressible: !1 },
  "application/edifact": { source: "iana", compressible: !1 },
  "application/efi": { source: "iana" },
  "application/elm+json": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/elm+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.cap+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/emergencycalldata.comment+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.control+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.deviceinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.ecall.msd": { source: "iana" },
  "application/emergencycalldata.providerinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.serviceinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.subscriberinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.veds+xml": { source: "iana", compressible: !0 },
  "application/emma+xml": { source: "iana", compressible: !0, extensions: ["emma"] },
  "application/emotionml+xml": { source: "iana", compressible: !0, extensions: ["emotionml"] },
  "application/encaprtp": { source: "iana" },
  "application/epp+xml": { source: "iana", compressible: !0 },
  "application/epub+zip": { source: "iana", compressible: !1, extensions: ["epub"] },
  "application/eshop": { source: "iana" },
  "application/exi": { source: "iana", extensions: ["exi"] },
  "application/expect-ct-report+json": { source: "iana", compressible: !0 },
  "application/express": { source: "iana", extensions: ["exp"] },
  "application/fastinfoset": { source: "iana" },
  "application/fastsoap": { source: "iana" },
  "application/fdt+xml": { source: "iana", compressible: !0, extensions: ["fdt"] },
  "application/fhir+json": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/fhir+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/fido.trusted-apps+json": { compressible: !0 },
  "application/fits": { source: "iana" },
  "application/flexfec": { source: "iana" },
  "application/font-sfnt": { source: "iana" },
  "application/font-tdpfr": { source: "iana", extensions: ["pfr"] },
  "application/font-woff": { source: "iana", compressible: !1 },
  "application/framework-attributes+xml": { source: "iana", compressible: !0 },
  "application/geo+json": { source: "iana", compressible: !0, extensions: ["geojson"] },
  "application/geo+json-seq": { source: "iana" },
  "application/geopackage+sqlite3": { source: "iana" },
  "application/geoxacml+xml": { source: "iana", compressible: !0 },
  "application/gltf-buffer": { source: "iana" },
  "application/gml+xml": { source: "iana", compressible: !0, extensions: ["gml"] },
  "application/gpx+xml": { source: "apache", compressible: !0, extensions: ["gpx"] },
  "application/gxf": { source: "apache", extensions: ["gxf"] },
  "application/gzip": { source: "iana", compressible: !1, extensions: ["gz"] },
  "application/h224": { source: "iana" },
  "application/held+xml": { source: "iana", compressible: !0 },
  "application/hjson": { extensions: ["hjson"] },
  "application/http": { source: "iana" },
  "application/hyperstudio": { source: "iana", extensions: ["stk"] },
  "application/ibe-key-request+xml": { source: "iana", compressible: !0 },
  "application/ibe-pkg-reply+xml": { source: "iana", compressible: !0 },
  "application/ibe-pp-data": { source: "iana" },
  "application/iges": { source: "iana" },
  "application/im-iscomposing+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/index": { source: "iana" },
  "application/index.cmd": { source: "iana" },
  "application/index.obj": { source: "iana" },
  "application/index.response": { source: "iana" },
  "application/index.vnd": { source: "iana" },
  "application/inkml+xml": { source: "iana", compressible: !0, extensions: ["ink", "inkml"] },
  "application/iotp": { source: "iana" },
  "application/ipfix": { source: "iana", extensions: ["ipfix"] },
  "application/ipp": { source: "iana" },
  "application/isup": { source: "iana" },
  "application/its+xml": { source: "iana", compressible: !0, extensions: ["its"] },
  "application/java-archive": { source: "apache", compressible: !1, extensions: ["jar", "war", "ear"] },
  "application/java-serialized-object": { source: "apache", compressible: !1, extensions: ["ser"] },
  "application/java-vm": { source: "apache", compressible: !1, extensions: ["class"] },
  "application/javascript": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["js", "mjs"] },
  "application/jf2feed+json": { source: "iana", compressible: !0 },
  "application/jose": { source: "iana" },
  "application/jose+json": { source: "iana", compressible: !0 },
  "application/jrd+json": { source: "iana", compressible: !0 },
  "application/jscalendar+json": { source: "iana", compressible: !0 },
  "application/json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["json", "map"] },
  "application/json-patch+json": { source: "iana", compressible: !0 },
  "application/json-seq": { source: "iana" },
  "application/json5": { extensions: ["json5"] },
  "application/jsonml+json": { source: "apache", compressible: !0, extensions: ["jsonml"] },
  "application/jwk+json": { source: "iana", compressible: !0 },
  "application/jwk-set+json": { source: "iana", compressible: !0 },
  "application/jwt": { source: "iana" },
  "application/kpml-request+xml": { source: "iana", compressible: !0 },
  "application/kpml-response+xml": { source: "iana", compressible: !0 },
  "application/ld+json": { source: "iana", compressible: !0, extensions: ["jsonld"] },
  "application/lgr+xml": { source: "iana", compressible: !0, extensions: ["lgr"] },
  "application/link-format": { source: "iana" },
  "application/load-control+xml": { source: "iana", compressible: !0 },
  "application/lost+xml": { source: "iana", compressible: !0, extensions: ["lostxml"] },
  "application/lostsync+xml": { source: "iana", compressible: !0 },
  "application/lpf+zip": { source: "iana", compressible: !1 },
  "application/lxf": { source: "iana" },
  "application/mac-binhex40": { source: "iana", extensions: ["hqx"] },
  "application/mac-compactpro": { source: "apache", extensions: ["cpt"] },
  "application/macwriteii": { source: "iana" },
  "application/mads+xml": { source: "iana", compressible: !0, extensions: ["mads"] },
  "application/manifest+json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["webmanifest"] },
  "application/marc": { source: "iana", extensions: ["mrc"] },
  "application/marcxml+xml": { source: "iana", compressible: !0, extensions: ["mrcx"] },
  "application/mathematica": { source: "iana", extensions: ["ma", "nb", "mb"] },
  "application/mathml+xml": { source: "iana", compressible: !0, extensions: ["mathml"] },
  "application/mathml-content+xml": { source: "iana", compressible: !0 },
  "application/mathml-presentation+xml": { source: "iana", compressible: !0 },
  "application/mbms-associated-procedure-description+xml": { source: "iana", compressible: !0 },
  "application/mbms-deregister+xml": { source: "iana", compressible: !0 },
  "application/mbms-envelope+xml": { source: "iana", compressible: !0 },
  "application/mbms-msk+xml": { source: "iana", compressible: !0 },
  "application/mbms-msk-response+xml": { source: "iana", compressible: !0 },
  "application/mbms-protection-description+xml": { source: "iana", compressible: !0 },
  "application/mbms-reception-report+xml": { source: "iana", compressible: !0 },
  "application/mbms-register+xml": { source: "iana", compressible: !0 },
  "application/mbms-register-response+xml": { source: "iana", compressible: !0 },
  "application/mbms-schedule+xml": { source: "iana", compressible: !0 },
  "application/mbms-user-service-description+xml": { source: "iana", compressible: !0 },
  "application/mbox": { source: "iana", extensions: ["mbox"] },
  "application/media-policy-dataset+xml": { source: "iana", compressible: !0, extensions: ["mpf"] },
  "application/media_control+xml": { source: "iana", compressible: !0 },
  "application/mediaservercontrol+xml": { source: "iana", compressible: !0, extensions: ["mscml"] },
  "application/merge-patch+json": { source: "iana", compressible: !0 },
  "application/metalink+xml": { source: "apache", compressible: !0, extensions: ["metalink"] },
  "application/metalink4+xml": { source: "iana", compressible: !0, extensions: ["meta4"] },
  "application/mets+xml": { source: "iana", compressible: !0, extensions: ["mets"] },
  "application/mf4": { source: "iana" },
  "application/mikey": { source: "iana" },
  "application/mipc": { source: "iana" },
  "application/missing-blocks+cbor-seq": { source: "iana" },
  "application/mmt-aei+xml": { source: "iana", compressible: !0, extensions: ["maei"] },
  "application/mmt-usd+xml": { source: "iana", compressible: !0, extensions: ["musd"] },
  "application/mods+xml": { source: "iana", compressible: !0, extensions: ["mods"] },
  "application/moss-keys": { source: "iana" },
  "application/moss-signature": { source: "iana" },
  "application/mosskey-data": { source: "iana" },
  "application/mosskey-request": { source: "iana" },
  "application/mp21": { source: "iana", extensions: ["m21", "mp21"] },
  "application/mp4": { source: "iana", extensions: ["mp4s", "m4p"] },
  "application/mpeg4-generic": { source: "iana" },
  "application/mpeg4-iod": { source: "iana" },
  "application/mpeg4-iod-xmt": { source: "iana" },
  "application/mrb-consumer+xml": { source: "iana", compressible: !0 },
  "application/mrb-publish+xml": { source: "iana", compressible: !0 },
  "application/msc-ivr+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/msc-mixer+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/msword": { source: "iana", compressible: !1, extensions: ["doc", "dot"] },
  "application/mud+json": { source: "iana", compressible: !0 },
  "application/multipart-core": { source: "iana" },
  "application/mxf": { source: "iana", extensions: ["mxf"] },
  "application/n-quads": { source: "iana", extensions: ["nq"] },
  "application/n-triples": { source: "iana", extensions: ["nt"] },
  "application/nasdata": { source: "iana" },
  "application/news-checkgroups": { source: "iana", charset: "US-ASCII" },
  "application/news-groupinfo": { source: "iana", charset: "US-ASCII" },
  "application/news-transmission": { source: "iana" },
  "application/nlsml+xml": { source: "iana", compressible: !0 },
  "application/node": { source: "iana", extensions: ["cjs"] },
  "application/nss": { source: "iana" },
  "application/oauth-authz-req+jwt": { source: "iana" },
  "application/oblivious-dns-message": { source: "iana" },
  "application/ocsp-request": { source: "iana" },
  "application/ocsp-response": { source: "iana" },
  "application/octet-stream": { source: "iana", compressible: !1, extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] },
  "application/oda": { source: "iana", extensions: ["oda"] },
  "application/odm+xml": { source: "iana", compressible: !0 },
  "application/odx": { source: "iana" },
  "application/oebps-package+xml": { source: "iana", compressible: !0, extensions: ["opf"] },
  "application/ogg": { source: "iana", compressible: !1, extensions: ["ogx"] },
  "application/omdoc+xml": { source: "apache", compressible: !0, extensions: ["omdoc"] },
  "application/onenote": { source: "apache", extensions: ["onetoc", "onetoc2", "onetmp", "onepkg"] },
  "application/opc-nodeset+xml": { source: "iana", compressible: !0 },
  "application/oscore": { source: "iana" },
  "application/oxps": { source: "iana", extensions: ["oxps"] },
  "application/p21": { source: "iana" },
  "application/p21+zip": { source: "iana", compressible: !1 },
  "application/p2p-overlay+xml": { source: "iana", compressible: !0, extensions: ["relo"] },
  "application/parityfec": { source: "iana" },
  "application/passport": { source: "iana" },
  "application/patch-ops-error+xml": { source: "iana", compressible: !0, extensions: ["xer"] },
  "application/pdf": { source: "iana", compressible: !1, extensions: ["pdf"] },
  "application/pdx": { source: "iana" },
  "application/pem-certificate-chain": { source: "iana" },
  "application/pgp-encrypted": { source: "iana", compressible: !1, extensions: ["pgp"] },
  "application/pgp-keys": { source: "iana", extensions: ["asc"] },
  "application/pgp-signature": { source: "iana", extensions: ["asc", "sig"] },
  "application/pics-rules": { source: "apache", extensions: ["prf"] },
  "application/pidf+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/pidf-diff+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/pkcs10": { source: "iana", extensions: ["p10"] },
  "application/pkcs12": { source: "iana" },
  "application/pkcs7-mime": { source: "iana", extensions: ["p7m", "p7c"] },
  "application/pkcs7-signature": { source: "iana", extensions: ["p7s"] },
  "application/pkcs8": { source: "iana", extensions: ["p8"] },
  "application/pkcs8-encrypted": { source: "iana" },
  "application/pkix-attr-cert": { source: "iana", extensions: ["ac"] },
  "application/pkix-cert": { source: "iana", extensions: ["cer"] },
  "application/pkix-crl": { source: "iana", extensions: ["crl"] },
  "application/pkix-pkipath": { source: "iana", extensions: ["pkipath"] },
  "application/pkixcmp": { source: "iana", extensions: ["pki"] },
  "application/pls+xml": { source: "iana", compressible: !0, extensions: ["pls"] },
  "application/poc-settings+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/postscript": { source: "iana", compressible: !0, extensions: ["ai", "eps", "ps"] },
  "application/ppsp-tracker+json": { source: "iana", compressible: !0 },
  "application/problem+json": { source: "iana", compressible: !0 },
  "application/problem+xml": { source: "iana", compressible: !0 },
  "application/provenance+xml": { source: "iana", compressible: !0, extensions: ["provx"] },
  "application/prs.alvestrand.titrax-sheet": { source: "iana" },
  "application/prs.cww": { source: "iana", extensions: ["cww"] },
  "application/prs.cyn": { source: "iana", charset: "7-BIT" },
  "application/prs.hpub+zip": { source: "iana", compressible: !1 },
  "application/prs.nprend": { source: "iana" },
  "application/prs.plucker": { source: "iana" },
  "application/prs.rdf-xml-crypt": { source: "iana" },
  "application/prs.xsf+xml": { source: "iana", compressible: !0 },
  "application/pskc+xml": { source: "iana", compressible: !0, extensions: ["pskcxml"] },
  "application/pvd+json": { source: "iana", compressible: !0 },
  "application/qsig": { source: "iana" },
  "application/raml+yaml": { compressible: !0, extensions: ["raml"] },
  "application/raptorfec": { source: "iana" },
  "application/rdap+json": { source: "iana", compressible: !0 },
  "application/rdf+xml": { source: "iana", compressible: !0, extensions: ["rdf", "owl"] },
  "application/reginfo+xml": { source: "iana", compressible: !0, extensions: ["rif"] },
  "application/relax-ng-compact-syntax": { source: "iana", extensions: ["rnc"] },
  "application/remote-printing": { source: "iana" },
  "application/reputon+json": { source: "iana", compressible: !0 },
  "application/resource-lists+xml": { source: "iana", compressible: !0, extensions: ["rl"] },
  "application/resource-lists-diff+xml": { source: "iana", compressible: !0, extensions: ["rld"] },
  "application/rfc+xml": { source: "iana", compressible: !0 },
  "application/riscos": { source: "iana" },
  "application/rlmi+xml": { source: "iana", compressible: !0 },
  "application/rls-services+xml": { source: "iana", compressible: !0, extensions: ["rs"] },
  "application/route-apd+xml": { source: "iana", compressible: !0, extensions: ["rapd"] },
  "application/route-s-tsid+xml": { source: "iana", compressible: !0, extensions: ["sls"] },
  "application/route-usd+xml": { source: "iana", compressible: !0, extensions: ["rusd"] },
  "application/rpki-ghostbusters": { source: "iana", extensions: ["gbr"] },
  "application/rpki-manifest": { source: "iana", extensions: ["mft"] },
  "application/rpki-publication": { source: "iana" },
  "application/rpki-roa": { source: "iana", extensions: ["roa"] },
  "application/rpki-updown": { source: "iana" },
  "application/rsd+xml": { source: "apache", compressible: !0, extensions: ["rsd"] },
  "application/rss+xml": { source: "apache", compressible: !0, extensions: ["rss"] },
  "application/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "application/rtploopback": { source: "iana" },
  "application/rtx": { source: "iana" },
  "application/samlassertion+xml": { source: "iana", compressible: !0 },
  "application/samlmetadata+xml": { source: "iana", compressible: !0 },
  "application/sarif+json": { source: "iana", compressible: !0 },
  "application/sarif-external-properties+json": { source: "iana", compressible: !0 },
  "application/sbe": { source: "iana" },
  "application/sbml+xml": { source: "iana", compressible: !0, extensions: ["sbml"] },
  "application/scaip+xml": { source: "iana", compressible: !0 },
  "application/scim+json": { source: "iana", compressible: !0 },
  "application/scvp-cv-request": { source: "iana", extensions: ["scq"] },
  "application/scvp-cv-response": { source: "iana", extensions: ["scs"] },
  "application/scvp-vp-request": { source: "iana", extensions: ["spq"] },
  "application/scvp-vp-response": { source: "iana", extensions: ["spp"] },
  "application/sdp": { source: "iana", extensions: ["sdp"] },
  "application/secevent+jwt": { source: "iana" },
  "application/senml+cbor": { source: "iana" },
  "application/senml+json": { source: "iana", compressible: !0 },
  "application/senml+xml": { source: "iana", compressible: !0, extensions: ["senmlx"] },
  "application/senml-etch+cbor": { source: "iana" },
  "application/senml-etch+json": { source: "iana", compressible: !0 },
  "application/senml-exi": { source: "iana" },
  "application/sensml+cbor": { source: "iana" },
  "application/sensml+json": { source: "iana", compressible: !0 },
  "application/sensml+xml": { source: "iana", compressible: !0, extensions: ["sensmlx"] },
  "application/sensml-exi": { source: "iana" },
  "application/sep+xml": { source: "iana", compressible: !0 },
  "application/sep-exi": { source: "iana" },
  "application/session-info": { source: "iana" },
  "application/set-payment": { source: "iana" },
  "application/set-payment-initiation": { source: "iana", extensions: ["setpay"] },
  "application/set-registration": { source: "iana" },
  "application/set-registration-initiation": { source: "iana", extensions: ["setreg"] },
  "application/sgml": { source: "iana" },
  "application/sgml-open-catalog": { source: "iana" },
  "application/shf+xml": { source: "iana", compressible: !0, extensions: ["shf"] },
  "application/sieve": { source: "iana", extensions: ["siv", "sieve"] },
  "application/simple-filter+xml": { source: "iana", compressible: !0 },
  "application/simple-message-summary": { source: "iana" },
  "application/simplesymbolcontainer": { source: "iana" },
  "application/sipc": { source: "iana" },
  "application/slate": { source: "iana" },
  "application/smil": { source: "iana" },
  "application/smil+xml": { source: "iana", compressible: !0, extensions: ["smi", "smil"] },
  "application/smpte336m": { source: "iana" },
  "application/soap+fastinfoset": { source: "iana" },
  "application/soap+xml": { source: "iana", compressible: !0 },
  "application/sparql-query": { source: "iana", extensions: ["rq"] },
  "application/sparql-results+xml": { source: "iana", compressible: !0, extensions: ["srx"] },
  "application/spdx+json": { source: "iana", compressible: !0 },
  "application/spirits-event+xml": { source: "iana", compressible: !0 },
  "application/sql": { source: "iana" },
  "application/srgs": { source: "iana", extensions: ["gram"] },
  "application/srgs+xml": { source: "iana", compressible: !0, extensions: ["grxml"] },
  "application/sru+xml": { source: "iana", compressible: !0, extensions: ["sru"] },
  "application/ssdl+xml": { source: "apache", compressible: !0, extensions: ["ssdl"] },
  "application/ssml+xml": { source: "iana", compressible: !0, extensions: ["ssml"] },
  "application/stix+json": { source: "iana", compressible: !0 },
  "application/swid+xml": { source: "iana", compressible: !0, extensions: ["swidtag"] },
  "application/tamp-apex-update": { source: "iana" },
  "application/tamp-apex-update-confirm": { source: "iana" },
  "application/tamp-community-update": { source: "iana" },
  "application/tamp-community-update-confirm": { source: "iana" },
  "application/tamp-error": { source: "iana" },
  "application/tamp-sequence-adjust": { source: "iana" },
  "application/tamp-sequence-adjust-confirm": { source: "iana" },
  "application/tamp-status-query": { source: "iana" },
  "application/tamp-status-response": { source: "iana" },
  "application/tamp-update": { source: "iana" },
  "application/tamp-update-confirm": { source: "iana" },
  "application/tar": { compressible: !0 },
  "application/taxii+json": { source: "iana", compressible: !0 },
  "application/td+json": { source: "iana", compressible: !0 },
  "application/tei+xml": { source: "iana", compressible: !0, extensions: ["tei", "teicorpus"] },
  "application/tetra_isi": { source: "iana" },
  "application/thraud+xml": { source: "iana", compressible: !0, extensions: ["tfi"] },
  "application/timestamp-query": { source: "iana" },
  "application/timestamp-reply": { source: "iana" },
  "application/timestamped-data": { source: "iana", extensions: ["tsd"] },
  "application/tlsrpt+gzip": { source: "iana" },
  "application/tlsrpt+json": { source: "iana", compressible: !0 },
  "application/tnauthlist": { source: "iana" },
  "application/token-introspection+jwt": { source: "iana" },
  "application/toml": { compressible: !0, extensions: ["toml"] },
  "application/trickle-ice-sdpfrag": { source: "iana" },
  "application/trig": { source: "iana", extensions: ["trig"] },
  "application/ttml+xml": { source: "iana", compressible: !0, extensions: ["ttml"] },
  "application/tve-trigger": { source: "iana" },
  "application/tzif": { source: "iana" },
  "application/tzif-leap": { source: "iana" },
  "application/ubjson": { compressible: !1, extensions: ["ubj"] },
  "application/ulpfec": { source: "iana" },
  "application/urc-grpsheet+xml": { source: "iana", compressible: !0 },
  "application/urc-ressheet+xml": { source: "iana", compressible: !0, extensions: ["rsheet"] },
  "application/urc-targetdesc+xml": { source: "iana", compressible: !0, extensions: ["td"] },
  "application/urc-uisocketdesc+xml": { source: "iana", compressible: !0 },
  "application/vcard+json": { source: "iana", compressible: !0 },
  "application/vcard+xml": { source: "iana", compressible: !0 },
  "application/vemmi": { source: "iana" },
  "application/vividence.scriptfile": { source: "apache" },
  "application/vnd.1000minds.decision-model+xml": { source: "iana", compressible: !0, extensions: ["1km"] },
  "application/vnd.3gpp-prose+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp-prose-pc3ch+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp-v2x-local-service-information": { source: "iana" },
  "application/vnd.3gpp.5gnas": { source: "iana" },
  "application/vnd.3gpp.access-transfer-events+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.bsf+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.gmop+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.gtpc": { source: "iana" },
  "application/vnd.3gpp.interworking-data": { source: "iana" },
  "application/vnd.3gpp.lpp": { source: "iana" },
  "application/vnd.3gpp.mc-signalling-ear": { source: "iana" },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-payload": { source: "iana" },
  "application/vnd.3gpp.mcdata-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-signalling": { source: "iana" },
  "application/vnd.3gpp.mcdata-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-floor-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-location-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-signed+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-affiliation-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-location-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mid-call+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.ngap": { source: "iana" },
  "application/vnd.3gpp.pfcp": { source: "iana" },
  "application/vnd.3gpp.pic-bw-large": { source: "iana", extensions: ["plb"] },
  "application/vnd.3gpp.pic-bw-small": { source: "iana", extensions: ["psb"] },
  "application/vnd.3gpp.pic-bw-var": { source: "iana", extensions: ["pvb"] },
  "application/vnd.3gpp.s1ap": { source: "iana" },
  "application/vnd.3gpp.sms": { source: "iana" },
  "application/vnd.3gpp.sms+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.srvcc-ext+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.srvcc-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.state-and-event-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.ussd+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp2.bcmcsinfo+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp2.sms": { source: "iana" },
  "application/vnd.3gpp2.tcap": { source: "iana", extensions: ["tcap"] },
  "application/vnd.3lightssoftware.imagescal": { source: "iana" },
  "application/vnd.3m.post-it-notes": { source: "iana", extensions: ["pwn"] },
  "application/vnd.accpac.simply.aso": { source: "iana", extensions: ["aso"] },
  "application/vnd.accpac.simply.imp": { source: "iana", extensions: ["imp"] },
  "application/vnd.acucobol": { source: "iana", extensions: ["acu"] },
  "application/vnd.acucorp": { source: "iana", extensions: ["atc", "acutc"] },
  "application/vnd.adobe.air-application-installer-package+zip": { source: "apache", compressible: !1, extensions: ["air"] },
  "application/vnd.adobe.flash.movie": { source: "iana" },
  "application/vnd.adobe.formscentral.fcdt": { source: "iana", extensions: ["fcdt"] },
  "application/vnd.adobe.fxp": { source: "iana", extensions: ["fxp", "fxpl"] },
  "application/vnd.adobe.partial-upload": { source: "iana" },
  "application/vnd.adobe.xdp+xml": { source: "iana", compressible: !0, extensions: ["xdp"] },
  "application/vnd.adobe.xfdf": { source: "iana", extensions: ["xfdf"] },
  "application/vnd.aether.imp": { source: "iana" },
  "application/vnd.afpc.afplinedata": { source: "iana" },
  "application/vnd.afpc.afplinedata-pagedef": { source: "iana" },
  "application/vnd.afpc.cmoca-cmresource": { source: "iana" },
  "application/vnd.afpc.foca-charset": { source: "iana" },
  "application/vnd.afpc.foca-codedfont": { source: "iana" },
  "application/vnd.afpc.foca-codepage": { source: "iana" },
  "application/vnd.afpc.modca": { source: "iana" },
  "application/vnd.afpc.modca-cmtable": { source: "iana" },
  "application/vnd.afpc.modca-formdef": { source: "iana" },
  "application/vnd.afpc.modca-mediummap": { source: "iana" },
  "application/vnd.afpc.modca-objectcontainer": { source: "iana" },
  "application/vnd.afpc.modca-overlay": { source: "iana" },
  "application/vnd.afpc.modca-pagesegment": { source: "iana" },
  "application/vnd.age": { source: "iana", extensions: ["age"] },
  "application/vnd.ah-barcode": { source: "iana" },
  "application/vnd.ahead.space": { source: "iana", extensions: ["ahead"] },
  "application/vnd.airzip.filesecure.azf": { source: "iana", extensions: ["azf"] },
  "application/vnd.airzip.filesecure.azs": { source: "iana", extensions: ["azs"] },
  "application/vnd.amadeus+json": { source: "iana", compressible: !0 },
  "application/vnd.amazon.ebook": { source: "apache", extensions: ["azw"] },
  "application/vnd.amazon.mobi8-ebook": { source: "iana" },
  "application/vnd.americandynamics.acc": { source: "iana", extensions: ["acc"] },
  "application/vnd.amiga.ami": { source: "iana", extensions: ["ami"] },
  "application/vnd.amundsen.maze+xml": { source: "iana", compressible: !0 },
  "application/vnd.android.ota": { source: "iana" },
  "application/vnd.android.package-archive": { source: "apache", compressible: !1, extensions: ["apk"] },
  "application/vnd.anki": { source: "iana" },
  "application/vnd.anser-web-certificate-issue-initiation": { source: "iana", extensions: ["cii"] },
  "application/vnd.anser-web-funds-transfer-initiation": { source: "apache", extensions: ["fti"] },
  "application/vnd.antix.game-component": { source: "iana", extensions: ["atx"] },
  "application/vnd.apache.arrow.file": { source: "iana" },
  "application/vnd.apache.arrow.stream": { source: "iana" },
  "application/vnd.apache.thrift.binary": { source: "iana" },
  "application/vnd.apache.thrift.compact": { source: "iana" },
  "application/vnd.apache.thrift.json": { source: "iana" },
  "application/vnd.api+json": { source: "iana", compressible: !0 },
  "application/vnd.aplextor.warrp+json": { source: "iana", compressible: !0 },
  "application/vnd.apothekende.reservation+json": { source: "iana", compressible: !0 },
  "application/vnd.apple.installer+xml": { source: "iana", compressible: !0, extensions: ["mpkg"] },
  "application/vnd.apple.keynote": { source: "iana", extensions: ["key"] },
  "application/vnd.apple.mpegurl": { source: "iana", extensions: ["m3u8"] },
  "application/vnd.apple.numbers": { source: "iana", extensions: ["numbers"] },
  "application/vnd.apple.pages": { source: "iana", extensions: ["pages"] },
  "application/vnd.apple.pkpass": { compressible: !1, extensions: ["pkpass"] },
  "application/vnd.arastra.swi": { source: "iana" },
  "application/vnd.aristanetworks.swi": { source: "iana", extensions: ["swi"] },
  "application/vnd.artisan+json": { source: "iana", compressible: !0 },
  "application/vnd.artsquare": { source: "iana" },
  "application/vnd.astraea-software.iota": { source: "iana", extensions: ["iota"] },
  "application/vnd.audiograph": { source: "iana", extensions: ["aep"] },
  "application/vnd.autopackage": { source: "iana" },
  "application/vnd.avalon+json": { source: "iana", compressible: !0 },
  "application/vnd.avistar+xml": { source: "iana", compressible: !0 },
  "application/vnd.balsamiq.bmml+xml": { source: "iana", compressible: !0, extensions: ["bmml"] },
  "application/vnd.balsamiq.bmpr": { source: "iana" },
  "application/vnd.banana-accounting": { source: "iana" },
  "application/vnd.bbf.usp.error": { source: "iana" },
  "application/vnd.bbf.usp.msg": { source: "iana" },
  "application/vnd.bbf.usp.msg+json": { source: "iana", compressible: !0 },
  "application/vnd.bekitzur-stech+json": { source: "iana", compressible: !0 },
  "application/vnd.bint.med-content": { source: "iana" },
  "application/vnd.biopax.rdf+xml": { source: "iana", compressible: !0 },
  "application/vnd.blink-idb-value-wrapper": { source: "iana" },
  "application/vnd.blueice.multipass": { source: "iana", extensions: ["mpm"] },
  "application/vnd.bluetooth.ep.oob": { source: "iana" },
  "application/vnd.bluetooth.le.oob": { source: "iana" },
  "application/vnd.bmi": { source: "iana", extensions: ["bmi"] },
  "application/vnd.bpf": { source: "iana" },
  "application/vnd.bpf3": { source: "iana" },
  "application/vnd.businessobjects": { source: "iana", extensions: ["rep"] },
  "application/vnd.byu.uapi+json": { source: "iana", compressible: !0 },
  "application/vnd.cab-jscript": { source: "iana" },
  "application/vnd.canon-cpdl": { source: "iana" },
  "application/vnd.canon-lips": { source: "iana" },
  "application/vnd.capasystems-pg+json": { source: "iana", compressible: !0 },
  "application/vnd.cendio.thinlinc.clientconf": { source: "iana" },
  "application/vnd.century-systems.tcp_stream": { source: "iana" },
  "application/vnd.chemdraw+xml": { source: "iana", compressible: !0, extensions: ["cdxml"] },
  "application/vnd.chess-pgn": { source: "iana" },
  "application/vnd.chipnuts.karaoke-mmd": { source: "iana", extensions: ["mmd"] },
  "application/vnd.ciedi": { source: "iana" },
  "application/vnd.cinderella": { source: "iana", extensions: ["cdy"] },
  "application/vnd.cirpack.isdn-ext": { source: "iana" },
  "application/vnd.citationstyles.style+xml": { source: "iana", compressible: !0, extensions: ["csl"] },
  "application/vnd.claymore": { source: "iana", extensions: ["cla"] },
  "application/vnd.cloanto.rp9": { source: "iana", extensions: ["rp9"] },
  "application/vnd.clonk.c4group": { source: "iana", extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"] },
  "application/vnd.cluetrust.cartomobile-config": { source: "iana", extensions: ["c11amc"] },
  "application/vnd.cluetrust.cartomobile-config-pkg": { source: "iana", extensions: ["c11amz"] },
  "application/vnd.coffeescript": { source: "iana" },
  "application/vnd.collabio.xodocuments.document": { source: "iana" },
  "application/vnd.collabio.xodocuments.document-template": { source: "iana" },
  "application/vnd.collabio.xodocuments.presentation": { source: "iana" },
  "application/vnd.collabio.xodocuments.presentation-template": { source: "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet": { source: "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet-template": { source: "iana" },
  "application/vnd.collection+json": { source: "iana", compressible: !0 },
  "application/vnd.collection.doc+json": { source: "iana", compressible: !0 },
  "application/vnd.collection.next+json": { source: "iana", compressible: !0 },
  "application/vnd.comicbook+zip": { source: "iana", compressible: !1 },
  "application/vnd.comicbook-rar": { source: "iana" },
  "application/vnd.commerce-battelle": { source: "iana" },
  "application/vnd.commonspace": { source: "iana", extensions: ["csp"] },
  "application/vnd.contact.cmsg": { source: "iana", extensions: ["cdbcmsg"] },
  "application/vnd.coreos.ignition+json": { source: "iana", compressible: !0 },
  "application/vnd.cosmocaller": { source: "iana", extensions: ["cmc"] },
  "application/vnd.crick.clicker": { source: "iana", extensions: ["clkx"] },
  "application/vnd.crick.clicker.keyboard": { source: "iana", extensions: ["clkk"] },
  "application/vnd.crick.clicker.palette": { source: "iana", extensions: ["clkp"] },
  "application/vnd.crick.clicker.template": { source: "iana", extensions: ["clkt"] },
  "application/vnd.crick.clicker.wordbank": { source: "iana", extensions: ["clkw"] },
  "application/vnd.criticaltools.wbs+xml": { source: "iana", compressible: !0, extensions: ["wbs"] },
  "application/vnd.cryptii.pipe+json": { source: "iana", compressible: !0 },
  "application/vnd.crypto-shade-file": { source: "iana" },
  "application/vnd.cryptomator.encrypted": { source: "iana" },
  "application/vnd.cryptomator.vault": { source: "iana" },
  "application/vnd.ctc-posml": { source: "iana", extensions: ["pml"] },
  "application/vnd.ctct.ws+xml": { source: "iana", compressible: !0 },
  "application/vnd.cups-pdf": { source: "iana" },
  "application/vnd.cups-postscript": { source: "iana" },
  "application/vnd.cups-ppd": { source: "iana", extensions: ["ppd"] },
  "application/vnd.cups-raster": { source: "iana" },
  "application/vnd.cups-raw": { source: "iana" },
  "application/vnd.curl": { source: "iana" },
  "application/vnd.curl.car": { source: "apache", extensions: ["car"] },
  "application/vnd.curl.pcurl": { source: "apache", extensions: ["pcurl"] },
  "application/vnd.cyan.dean.root+xml": { source: "iana", compressible: !0 },
  "application/vnd.cybank": { source: "iana" },
  "application/vnd.cyclonedx+json": { source: "iana", compressible: !0 },
  "application/vnd.cyclonedx+xml": { source: "iana", compressible: !0 },
  "application/vnd.d2l.coursepackage1p0+zip": { source: "iana", compressible: !1 },
  "application/vnd.d3m-dataset": { source: "iana" },
  "application/vnd.d3m-problem": { source: "iana" },
  "application/vnd.dart": { source: "iana", compressible: !0, extensions: ["dart"] },
  "application/vnd.data-vision.rdz": { source: "iana", extensions: ["rdz"] },
  "application/vnd.datapackage+json": { source: "iana", compressible: !0 },
  "application/vnd.dataresource+json": { source: "iana", compressible: !0 },
  "application/vnd.dbf": { source: "iana", extensions: ["dbf"] },
  "application/vnd.debian.binary-package": { source: "iana" },
  "application/vnd.dece.data": { source: "iana", extensions: ["uvf", "uvvf", "uvd", "uvvd"] },
  "application/vnd.dece.ttml+xml": { source: "iana", compressible: !0, extensions: ["uvt", "uvvt"] },
  "application/vnd.dece.unspecified": { source: "iana", extensions: ["uvx", "uvvx"] },
  "application/vnd.dece.zip": { source: "iana", extensions: ["uvz", "uvvz"] },
  "application/vnd.denovo.fcselayout-link": { source: "iana", extensions: ["fe_launch"] },
  "application/vnd.desmume.movie": { source: "iana" },
  "application/vnd.dir-bi.plate-dl-nosuffix": { source: "iana" },
  "application/vnd.dm.delegation+xml": { source: "iana", compressible: !0 },
  "application/vnd.dna": { source: "iana", extensions: ["dna"] },
  "application/vnd.document+json": { source: "iana", compressible: !0 },
  "application/vnd.dolby.mlp": { source: "apache", extensions: ["mlp"] },
  "application/vnd.dolby.mobile.1": { source: "iana" },
  "application/vnd.dolby.mobile.2": { source: "iana" },
  "application/vnd.doremir.scorecloud-binary-document": { source: "iana" },
  "application/vnd.dpgraph": { source: "iana", extensions: ["dpg"] },
  "application/vnd.dreamfactory": { source: "iana", extensions: ["dfac"] },
  "application/vnd.drive+json": { source: "iana", compressible: !0 },
  "application/vnd.ds-keypoint": { source: "apache", extensions: ["kpxx"] },
  "application/vnd.dtg.local": { source: "iana" },
  "application/vnd.dtg.local.flash": { source: "iana" },
  "application/vnd.dtg.local.html": { source: "iana" },
  "application/vnd.dvb.ait": { source: "iana", extensions: ["ait"] },
  "application/vnd.dvb.dvbisl+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.dvbj": { source: "iana" },
  "application/vnd.dvb.esgcontainer": { source: "iana" },
  "application/vnd.dvb.ipdcdftnotifaccess": { source: "iana" },
  "application/vnd.dvb.ipdcesgaccess": { source: "iana" },
  "application/vnd.dvb.ipdcesgaccess2": { source: "iana" },
  "application/vnd.dvb.ipdcesgpdd": { source: "iana" },
  "application/vnd.dvb.ipdcroaming": { source: "iana" },
  "application/vnd.dvb.iptv.alfec-base": { source: "iana" },
  "application/vnd.dvb.iptv.alfec-enhancement": { source: "iana" },
  "application/vnd.dvb.notif-aggregate-root+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-container+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-generic+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-msglist+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-registration-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-registration-response+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-init+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.pfr": { source: "iana" },
  "application/vnd.dvb.service": { source: "iana", extensions: ["svc"] },
  "application/vnd.dxr": { source: "iana" },
  "application/vnd.dynageo": { source: "iana", extensions: ["geo"] },
  "application/vnd.dzr": { source: "iana" },
  "application/vnd.easykaraoke.cdgdownload": { source: "iana" },
  "application/vnd.ecdis-update": { source: "iana" },
  "application/vnd.ecip.rlp": { source: "iana" },
  "application/vnd.eclipse.ditto+json": { source: "iana", compressible: !0 },
  "application/vnd.ecowin.chart": { source: "iana", extensions: ["mag"] },
  "application/vnd.ecowin.filerequest": { source: "iana" },
  "application/vnd.ecowin.fileupdate": { source: "iana" },
  "application/vnd.ecowin.series": { source: "iana" },
  "application/vnd.ecowin.seriesrequest": { source: "iana" },
  "application/vnd.ecowin.seriesupdate": { source: "iana" },
  "application/vnd.efi.img": { source: "iana" },
  "application/vnd.efi.iso": { source: "iana" },
  "application/vnd.emclient.accessrequest+xml": { source: "iana", compressible: !0 },
  "application/vnd.enliven": { source: "iana", extensions: ["nml"] },
  "application/vnd.enphase.envoy": { source: "iana" },
  "application/vnd.eprints.data+xml": { source: "iana", compressible: !0 },
  "application/vnd.epson.esf": { source: "iana", extensions: ["esf"] },
  "application/vnd.epson.msf": { source: "iana", extensions: ["msf"] },
  "application/vnd.epson.quickanime": { source: "iana", extensions: ["qam"] },
  "application/vnd.epson.salt": { source: "iana", extensions: ["slt"] },
  "application/vnd.epson.ssf": { source: "iana", extensions: ["ssf"] },
  "application/vnd.ericsson.quickcall": { source: "iana" },
  "application/vnd.espass-espass+zip": { source: "iana", compressible: !1 },
  "application/vnd.eszigno3+xml": { source: "iana", compressible: !0, extensions: ["es3", "et3"] },
  "application/vnd.etsi.aoc+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.asic-e+zip": { source: "iana", compressible: !1 },
  "application/vnd.etsi.asic-s+zip": { source: "iana", compressible: !1 },
  "application/vnd.etsi.cug+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvcommand+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvdiscovery+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-bc+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-cod+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-npvr+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvservice+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsync+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvueprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.mcid+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.mheg5": { source: "iana" },
  "application/vnd.etsi.overload-control-policy-dataset+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.pstn+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.sci+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.simservs+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.timestamp-token": { source: "iana" },
  "application/vnd.etsi.tsl+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.tsl.der": { source: "iana" },
  "application/vnd.eu.kasparian.car+json": { source: "iana", compressible: !0 },
  "application/vnd.eudora.data": { source: "iana" },
  "application/vnd.evolv.ecig.profile": { source: "iana" },
  "application/vnd.evolv.ecig.settings": { source: "iana" },
  "application/vnd.evolv.ecig.theme": { source: "iana" },
  "application/vnd.exstream-empower+zip": { source: "iana", compressible: !1 },
  "application/vnd.exstream-package": { source: "iana" },
  "application/vnd.ezpix-album": { source: "iana", extensions: ["ez2"] },
  "application/vnd.ezpix-package": { source: "iana", extensions: ["ez3"] },
  "application/vnd.f-secure.mobile": { source: "iana" },
  "application/vnd.familysearch.gedcom+zip": { source: "iana", compressible: !1 },
  "application/vnd.fastcopy-disk-image": { source: "iana" },
  "application/vnd.fdf": { source: "iana", extensions: ["fdf"] },
  "application/vnd.fdsn.mseed": { source: "iana", extensions: ["mseed"] },
  "application/vnd.fdsn.seed": { source: "iana", extensions: ["seed", "dataless"] },
  "application/vnd.ffsns": { source: "iana" },
  "application/vnd.ficlab.flb+zip": { source: "iana", compressible: !1 },
  "application/vnd.filmit.zfc": { source: "iana" },
  "application/vnd.fints": { source: "iana" },
  "application/vnd.firemonkeys.cloudcell": { source: "iana" },
  "application/vnd.flographit": { source: "iana", extensions: ["gph"] },
  "application/vnd.fluxtime.clip": { source: "iana", extensions: ["ftc"] },
  "application/vnd.font-fontforge-sfd": { source: "iana" },
  "application/vnd.framemaker": { source: "iana", extensions: ["fm", "frame", "maker", "book"] },
  "application/vnd.frogans.fnc": { source: "iana", extensions: ["fnc"] },
  "application/vnd.frogans.ltf": { source: "iana", extensions: ["ltf"] },
  "application/vnd.fsc.weblaunch": { source: "iana", extensions: ["fsc"] },
  "application/vnd.fujifilm.fb.docuworks": { source: "iana" },
  "application/vnd.fujifilm.fb.docuworks.binder": { source: "iana" },
  "application/vnd.fujifilm.fb.docuworks.container": { source: "iana" },
  "application/vnd.fujifilm.fb.jfi+xml": { source: "iana", compressible: !0 },
  "application/vnd.fujitsu.oasys": { source: "iana", extensions: ["oas"] },
  "application/vnd.fujitsu.oasys2": { source: "iana", extensions: ["oa2"] },
  "application/vnd.fujitsu.oasys3": { source: "iana", extensions: ["oa3"] },
  "application/vnd.fujitsu.oasysgp": { source: "iana", extensions: ["fg5"] },
  "application/vnd.fujitsu.oasysprs": { source: "iana", extensions: ["bh2"] },
  "application/vnd.fujixerox.art-ex": { source: "iana" },
  "application/vnd.fujixerox.art4": { source: "iana" },
  "application/vnd.fujixerox.ddd": { source: "iana", extensions: ["ddd"] },
  "application/vnd.fujixerox.docuworks": { source: "iana", extensions: ["xdw"] },
  "application/vnd.fujixerox.docuworks.binder": { source: "iana", extensions: ["xbd"] },
  "application/vnd.fujixerox.docuworks.container": { source: "iana" },
  "application/vnd.fujixerox.hbpl": { source: "iana" },
  "application/vnd.fut-misnet": { source: "iana" },
  "application/vnd.futoin+cbor": { source: "iana" },
  "application/vnd.futoin+json": { source: "iana", compressible: !0 },
  "application/vnd.fuzzysheet": { source: "iana", extensions: ["fzs"] },
  "application/vnd.genomatix.tuxedo": { source: "iana", extensions: ["txd"] },
  "application/vnd.gentics.grd+json": { source: "iana", compressible: !0 },
  "application/vnd.geo+json": { source: "iana", compressible: !0 },
  "application/vnd.geocube+xml": { source: "iana", compressible: !0 },
  "application/vnd.geogebra.file": { source: "iana", extensions: ["ggb"] },
  "application/vnd.geogebra.slides": { source: "iana" },
  "application/vnd.geogebra.tool": { source: "iana", extensions: ["ggt"] },
  "application/vnd.geometry-explorer": { source: "iana", extensions: ["gex", "gre"] },
  "application/vnd.geonext": { source: "iana", extensions: ["gxt"] },
  "application/vnd.geoplan": { source: "iana", extensions: ["g2w"] },
  "application/vnd.geospace": { source: "iana", extensions: ["g3w"] },
  "application/vnd.gerber": { source: "iana" },
  "application/vnd.globalplatform.card-content-mgt": { source: "iana" },
  "application/vnd.globalplatform.card-content-mgt-response": { source: "iana" },
  "application/vnd.gmx": { source: "iana", extensions: ["gmx"] },
  "application/vnd.google-apps.document": { compressible: !1, extensions: ["gdoc"] },
  "application/vnd.google-apps.presentation": { compressible: !1, extensions: ["gslides"] },
  "application/vnd.google-apps.spreadsheet": { compressible: !1, extensions: ["gsheet"] },
  "application/vnd.google-earth.kml+xml": { source: "iana", compressible: !0, extensions: ["kml"] },
  "application/vnd.google-earth.kmz": { source: "iana", compressible: !1, extensions: ["kmz"] },
  "application/vnd.gov.sk.e-form+xml": { source: "iana", compressible: !0 },
  "application/vnd.gov.sk.e-form+zip": { source: "iana", compressible: !1 },
  "application/vnd.gov.sk.xmldatacontainer+xml": { source: "iana", compressible: !0 },
  "application/vnd.grafeq": { source: "iana", extensions: ["gqf", "gqs"] },
  "application/vnd.gridmp": { source: "iana" },
  "application/vnd.groove-account": { source: "iana", extensions: ["gac"] },
  "application/vnd.groove-help": { source: "iana", extensions: ["ghf"] },
  "application/vnd.groove-identity-message": { source: "iana", extensions: ["gim"] },
  "application/vnd.groove-injector": { source: "iana", extensions: ["grv"] },
  "application/vnd.groove-tool-message": { source: "iana", extensions: ["gtm"] },
  "application/vnd.groove-tool-template": { source: "iana", extensions: ["tpl"] },
  "application/vnd.groove-vcard": { source: "iana", extensions: ["vcg"] },
  "application/vnd.hal+json": { source: "iana", compressible: !0 },
  "application/vnd.hal+xml": { source: "iana", compressible: !0, extensions: ["hal"] },
  "application/vnd.handheld-entertainment+xml": { source: "iana", compressible: !0, extensions: ["zmm"] },
  "application/vnd.hbci": { source: "iana", extensions: ["hbci"] },
  "application/vnd.hc+json": { source: "iana", compressible: !0 },
  "application/vnd.hcl-bireports": { source: "iana" },
  "application/vnd.hdt": { source: "iana" },
  "application/vnd.heroku+json": { source: "iana", compressible: !0 },
  "application/vnd.hhe.lesson-player": { source: "iana", extensions: ["les"] },
  "application/vnd.hl7cda+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.hl7v2+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.hp-hpgl": { source: "iana", extensions: ["hpgl"] },
  "application/vnd.hp-hpid": { source: "iana", extensions: ["hpid"] },
  "application/vnd.hp-hps": { source: "iana", extensions: ["hps"] },
  "application/vnd.hp-jlyt": { source: "iana", extensions: ["jlt"] },
  "application/vnd.hp-pcl": { source: "iana", extensions: ["pcl"] },
  "application/vnd.hp-pclxl": { source: "iana", extensions: ["pclxl"] },
  "application/vnd.httphone": { source: "iana" },
  "application/vnd.hydrostatix.sof-data": { source: "iana", extensions: ["sfd-hdstx"] },
  "application/vnd.hyper+json": { source: "iana", compressible: !0 },
  "application/vnd.hyper-item+json": { source: "iana", compressible: !0 },
  "application/vnd.hyperdrive+json": { source: "iana", compressible: !0 },
  "application/vnd.hzn-3d-crossword": { source: "iana" },
  "application/vnd.ibm.afplinedata": { source: "iana" },
  "application/vnd.ibm.electronic-media": { source: "iana" },
  "application/vnd.ibm.minipay": { source: "iana", extensions: ["mpy"] },
  "application/vnd.ibm.modcap": { source: "iana", extensions: ["afp", "listafp", "list3820"] },
  "application/vnd.ibm.rights-management": { source: "iana", extensions: ["irm"] },
  "application/vnd.ibm.secure-container": { source: "iana", extensions: ["sc"] },
  "application/vnd.iccprofile": { source: "iana", extensions: ["icc", "icm"] },
  "application/vnd.ieee.1905": { source: "iana" },
  "application/vnd.igloader": { source: "iana", extensions: ["igl"] },
  "application/vnd.imagemeter.folder+zip": { source: "iana", compressible: !1 },
  "application/vnd.imagemeter.image+zip": { source: "iana", compressible: !1 },
  "application/vnd.immervision-ivp": { source: "iana", extensions: ["ivp"] },
  "application/vnd.immervision-ivu": { source: "iana", extensions: ["ivu"] },
  "application/vnd.ims.imsccv1p1": { source: "iana" },
  "application/vnd.ims.imsccv1p2": { source: "iana" },
  "application/vnd.ims.imsccv1p3": { source: "iana" },
  "application/vnd.ims.lis.v2.result+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolproxy+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolproxy.id+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolsettings+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": { source: "iana", compressible: !0 },
  "application/vnd.informedcontrol.rms+xml": { source: "iana", compressible: !0 },
  "application/vnd.informix-visionary": { source: "iana" },
  "application/vnd.infotech.project": { source: "iana" },
  "application/vnd.infotech.project+xml": { source: "iana", compressible: !0 },
  "application/vnd.innopath.wamp.notification": { source: "iana" },
  "application/vnd.insors.igm": { source: "iana", extensions: ["igm"] },
  "application/vnd.intercon.formnet": { source: "iana", extensions: ["xpw", "xpx"] },
  "application/vnd.intergeo": { source: "iana", extensions: ["i2g"] },
  "application/vnd.intertrust.digibox": { source: "iana" },
  "application/vnd.intertrust.nncp": { source: "iana" },
  "application/vnd.intu.qbo": { source: "iana", extensions: ["qbo"] },
  "application/vnd.intu.qfx": { source: "iana", extensions: ["qfx"] },
  "application/vnd.iptc.g2.catalogitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.conceptitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.knowledgeitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.newsitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.newsmessage+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.packageitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.planningitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.ipunplugged.rcprofile": { source: "iana", extensions: ["rcprofile"] },
  "application/vnd.irepository.package+xml": { source: "iana", compressible: !0, extensions: ["irp"] },
  "application/vnd.is-xpr": { source: "iana", extensions: ["xpr"] },
  "application/vnd.isac.fcs": { source: "iana", extensions: ["fcs"] },
  "application/vnd.iso11783-10+zip": { source: "iana", compressible: !1 },
  "application/vnd.jam": { source: "iana", extensions: ["jam"] },
  "application/vnd.japannet-directory-service": { source: "iana" },
  "application/vnd.japannet-jpnstore-wakeup": { source: "iana" },
  "application/vnd.japannet-payment-wakeup": { source: "iana" },
  "application/vnd.japannet-registration": { source: "iana" },
  "application/vnd.japannet-registration-wakeup": { source: "iana" },
  "application/vnd.japannet-setstore-wakeup": { source: "iana" },
  "application/vnd.japannet-verification": { source: "iana" },
  "application/vnd.japannet-verification-wakeup": { source: "iana" },
  "application/vnd.jcp.javame.midlet-rms": { source: "iana", extensions: ["rms"] },
  "application/vnd.jisp": { source: "iana", extensions: ["jisp"] },
  "application/vnd.joost.joda-archive": { source: "iana", extensions: ["joda"] },
  "application/vnd.jsk.isdn-ngn": { source: "iana" },
  "application/vnd.kahootz": { source: "iana", extensions: ["ktz", "ktr"] },
  "application/vnd.kde.karbon": { source: "iana", extensions: ["karbon"] },
  "application/vnd.kde.kchart": { source: "iana", extensions: ["chrt"] },
  "application/vnd.kde.kformula": { source: "iana", extensions: ["kfo"] },
  "application/vnd.kde.kivio": { source: "iana", extensions: ["flw"] },
  "application/vnd.kde.kontour": { source: "iana", extensions: ["kon"] },
  "application/vnd.kde.kpresenter": { source: "iana", extensions: ["kpr", "kpt"] },
  "application/vnd.kde.kspread": { source: "iana", extensions: ["ksp"] },
  "application/vnd.kde.kword": { source: "iana", extensions: ["kwd", "kwt"] },
  "application/vnd.kenameaapp": { source: "iana", extensions: ["htke"] },
  "application/vnd.kidspiration": { source: "iana", extensions: ["kia"] },
  "application/vnd.kinar": { source: "iana", extensions: ["kne", "knp"] },
  "application/vnd.koan": { source: "iana", extensions: ["skp", "skd", "skt", "skm"] },
  "application/vnd.kodak-descriptor": { source: "iana", extensions: ["sse"] },
  "application/vnd.las": { source: "iana" },
  "application/vnd.las.las+json": { source: "iana", compressible: !0 },
  "application/vnd.las.las+xml": { source: "iana", compressible: !0, extensions: ["lasxml"] },
  "application/vnd.laszip": { source: "iana" },
  "application/vnd.leap+json": { source: "iana", compressible: !0 },
  "application/vnd.liberty-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.llamagraphics.life-balance.desktop": { source: "iana", extensions: ["lbd"] },
  "application/vnd.llamagraphics.life-balance.exchange+xml": { source: "iana", compressible: !0, extensions: ["lbe"] },
  "application/vnd.logipipe.circuit+zip": { source: "iana", compressible: !1 },
  "application/vnd.loom": { source: "iana" },
  "application/vnd.lotus-1-2-3": { source: "iana", extensions: ["123"] },
  "application/vnd.lotus-approach": { source: "iana", extensions: ["apr"] },
  "application/vnd.lotus-freelance": { source: "iana", extensions: ["pre"] },
  "application/vnd.lotus-notes": { source: "iana", extensions: ["nsf"] },
  "application/vnd.lotus-organizer": { source: "iana", extensions: ["org"] },
  "application/vnd.lotus-screencam": { source: "iana", extensions: ["scm"] },
  "application/vnd.lotus-wordpro": { source: "iana", extensions: ["lwp"] },
  "application/vnd.macports.portpkg": { source: "iana", extensions: ["portpkg"] },
  "application/vnd.mapbox-vector-tile": { source: "iana", extensions: ["mvt"] },
  "application/vnd.marlin.drm.actiontoken+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.conftoken+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.license+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.mdcf": { source: "iana" },
  "application/vnd.mason+json": { source: "iana", compressible: !0 },
  "application/vnd.maxar.archive.3tz+zip": { source: "iana", compressible: !1 },
  "application/vnd.maxmind.maxmind-db": { source: "iana" },
  "application/vnd.mcd": { source: "iana", extensions: ["mcd"] },
  "application/vnd.medcalcdata": { source: "iana", extensions: ["mc1"] },
  "application/vnd.mediastation.cdkey": { source: "iana", extensions: ["cdkey"] },
  "application/vnd.meridian-slingshot": { source: "iana" },
  "application/vnd.mfer": { source: "iana", extensions: ["mwf"] },
  "application/vnd.mfmp": { source: "iana", extensions: ["mfm"] },
  "application/vnd.micro+json": { source: "iana", compressible: !0 },
  "application/vnd.micrografx.flo": { source: "iana", extensions: ["flo"] },
  "application/vnd.micrografx.igx": { source: "iana", extensions: ["igx"] },
  "application/vnd.microsoft.portable-executable": { source: "iana" },
  "application/vnd.microsoft.windows.thumbnail-cache": { source: "iana" },
  "application/vnd.miele+json": { source: "iana", compressible: !0 },
  "application/vnd.mif": { source: "iana", extensions: ["mif"] },
  "application/vnd.minisoft-hp3000-save": { source: "iana" },
  "application/vnd.mitsubishi.misty-guard.trustweb": { source: "iana" },
  "application/vnd.mobius.daf": { source: "iana", extensions: ["daf"] },
  "application/vnd.mobius.dis": { source: "iana", extensions: ["dis"] },
  "application/vnd.mobius.mbk": { source: "iana", extensions: ["mbk"] },
  "application/vnd.mobius.mqy": { source: "iana", extensions: ["mqy"] },
  "application/vnd.mobius.msl": { source: "iana", extensions: ["msl"] },
  "application/vnd.mobius.plc": { source: "iana", extensions: ["plc"] },
  "application/vnd.mobius.txf": { source: "iana", extensions: ["txf"] },
  "application/vnd.mophun.application": { source: "iana", extensions: ["mpn"] },
  "application/vnd.mophun.certificate": { source: "iana", extensions: ["mpc"] },
  "application/vnd.motorola.flexsuite": { source: "iana" },
  "application/vnd.motorola.flexsuite.adsi": { source: "iana" },
  "application/vnd.motorola.flexsuite.fis": { source: "iana" },
  "application/vnd.motorola.flexsuite.gotap": { source: "iana" },
  "application/vnd.motorola.flexsuite.kmr": { source: "iana" },
  "application/vnd.motorola.flexsuite.ttc": { source: "iana" },
  "application/vnd.motorola.flexsuite.wem": { source: "iana" },
  "application/vnd.motorola.iprm": { source: "iana" },
  "application/vnd.mozilla.xul+xml": { source: "iana", compressible: !0, extensions: ["xul"] },
  "application/vnd.ms-3mfdocument": { source: "iana" },
  "application/vnd.ms-artgalry": { source: "iana", extensions: ["cil"] },
  "application/vnd.ms-asf": { source: "iana" },
  "application/vnd.ms-cab-compressed": { source: "iana", extensions: ["cab"] },
  "application/vnd.ms-color.iccprofile": { source: "apache" },
  "application/vnd.ms-excel": { source: "iana", compressible: !1, extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] },
  "application/vnd.ms-excel.addin.macroenabled.12": { source: "iana", extensions: ["xlam"] },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": { source: "iana", extensions: ["xlsb"] },
  "application/vnd.ms-excel.sheet.macroenabled.12": { source: "iana", extensions: ["xlsm"] },
  "application/vnd.ms-excel.template.macroenabled.12": { source: "iana", extensions: ["xltm"] },
  "application/vnd.ms-fontobject": { source: "iana", compressible: !0, extensions: ["eot"] },
  "application/vnd.ms-htmlhelp": { source: "iana", extensions: ["chm"] },
  "application/vnd.ms-ims": { source: "iana", extensions: ["ims"] },
  "application/vnd.ms-lrm": { source: "iana", extensions: ["lrm"] },
  "application/vnd.ms-office.activex+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-officetheme": { source: "iana", extensions: ["thmx"] },
  "application/vnd.ms-opentype": { source: "apache", compressible: !0 },
  "application/vnd.ms-outlook": { compressible: !1, extensions: ["msg"] },
  "application/vnd.ms-package.obfuscated-opentype": { source: "apache" },
  "application/vnd.ms-pki.seccat": { source: "apache", extensions: ["cat"] },
  "application/vnd.ms-pki.stl": { source: "apache", extensions: ["stl"] },
  "application/vnd.ms-playready.initiator+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-powerpoint": { source: "iana", compressible: !1, extensions: ["ppt", "pps", "pot"] },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": { source: "iana", extensions: ["ppam"] },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": { source: "iana", extensions: ["pptm"] },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": { source: "iana", extensions: ["sldm"] },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": { source: "iana", extensions: ["ppsm"] },
  "application/vnd.ms-powerpoint.template.macroenabled.12": { source: "iana", extensions: ["potm"] },
  "application/vnd.ms-printdevicecapabilities+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-printing.printticket+xml": { source: "apache", compressible: !0 },
  "application/vnd.ms-printschematicket+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-project": { source: "iana", extensions: ["mpp", "mpt"] },
  "application/vnd.ms-tnef": { source: "iana" },
  "application/vnd.ms-windows.devicepairing": { source: "iana" },
  "application/vnd.ms-windows.nwprinting.oob": { source: "iana" },
  "application/vnd.ms-windows.printerpairing": { source: "iana" },
  "application/vnd.ms-windows.wsd.oob": { source: "iana" },
  "application/vnd.ms-wmdrm.lic-chlg-req": { source: "iana" },
  "application/vnd.ms-wmdrm.lic-resp": { source: "iana" },
  "application/vnd.ms-wmdrm.meter-chlg-req": { source: "iana" },
  "application/vnd.ms-wmdrm.meter-resp": { source: "iana" },
  "application/vnd.ms-word.document.macroenabled.12": { source: "iana", extensions: ["docm"] },
  "application/vnd.ms-word.template.macroenabled.12": { source: "iana", extensions: ["dotm"] },
  "application/vnd.ms-works": { source: "iana", extensions: ["wps", "wks", "wcm", "wdb"] },
  "application/vnd.ms-wpl": { source: "iana", extensions: ["wpl"] },
  "application/vnd.ms-xpsdocument": { source: "iana", compressible: !1, extensions: ["xps"] },
  "application/vnd.msa-disk-image": { source: "iana" },
  "application/vnd.mseq": { source: "iana", extensions: ["mseq"] },
  "application/vnd.msign": { source: "iana" },
  "application/vnd.multiad.creator": { source: "iana" },
  "application/vnd.multiad.creator.cif": { source: "iana" },
  "application/vnd.music-niff": { source: "iana" },
  "application/vnd.musician": { source: "iana", extensions: ["mus"] },
  "application/vnd.muvee.style": { source: "iana", extensions: ["msty"] },
  "application/vnd.mynfc": { source: "iana", extensions: ["taglet"] },
  "application/vnd.nacamar.ybrid+json": { source: "iana", compressible: !0 },
  "application/vnd.ncd.control": { source: "iana" },
  "application/vnd.ncd.reference": { source: "iana" },
  "application/vnd.nearst.inv+json": { source: "iana", compressible: !0 },
  "application/vnd.nebumind.line": { source: "iana" },
  "application/vnd.nervana": { source: "iana" },
  "application/vnd.netfpx": { source: "iana" },
  "application/vnd.neurolanguage.nlu": { source: "iana", extensions: ["nlu"] },
  "application/vnd.nimn": { source: "iana" },
  "application/vnd.nintendo.nitro.rom": { source: "iana" },
  "application/vnd.nintendo.snes.rom": { source: "iana" },
  "application/vnd.nitf": { source: "iana", extensions: ["ntf", "nitf"] },
  "application/vnd.noblenet-directory": { source: "iana", extensions: ["nnd"] },
  "application/vnd.noblenet-sealer": { source: "iana", extensions: ["nns"] },
  "application/vnd.noblenet-web": { source: "iana", extensions: ["nnw"] },
  "application/vnd.nokia.catalogs": { source: "iana" },
  "application/vnd.nokia.conml+wbxml": { source: "iana" },
  "application/vnd.nokia.conml+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.iptv.config+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.isds-radio-presets": { source: "iana" },
  "application/vnd.nokia.landmark+wbxml": { source: "iana" },
  "application/vnd.nokia.landmark+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.landmarkcollection+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.n-gage.ac+xml": { source: "iana", compressible: !0, extensions: ["ac"] },
  "application/vnd.nokia.n-gage.data": { source: "iana", extensions: ["ngdat"] },
  "application/vnd.nokia.n-gage.symbian.install": { source: "iana", extensions: ["n-gage"] },
  "application/vnd.nokia.ncd": { source: "iana" },
  "application/vnd.nokia.pcd+wbxml": { source: "iana" },
  "application/vnd.nokia.pcd+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.radio-preset": { source: "iana", extensions: ["rpst"] },
  "application/vnd.nokia.radio-presets": { source: "iana", extensions: ["rpss"] },
  "application/vnd.novadigm.edm": { source: "iana", extensions: ["edm"] },
  "application/vnd.novadigm.edx": { source: "iana", extensions: ["edx"] },
  "application/vnd.novadigm.ext": { source: "iana", extensions: ["ext"] },
  "application/vnd.ntt-local.content-share": { source: "iana" },
  "application/vnd.ntt-local.file-transfer": { source: "iana" },
  "application/vnd.ntt-local.ogw_remote-access": { source: "iana" },
  "application/vnd.ntt-local.sip-ta_remote": { source: "iana" },
  "application/vnd.ntt-local.sip-ta_tcp_stream": { source: "iana" },
  "application/vnd.oasis.opendocument.chart": { source: "iana", extensions: ["odc"] },
  "application/vnd.oasis.opendocument.chart-template": { source: "iana", extensions: ["otc"] },
  "application/vnd.oasis.opendocument.database": { source: "iana", extensions: ["odb"] },
  "application/vnd.oasis.opendocument.formula": { source: "iana", extensions: ["odf"] },
  "application/vnd.oasis.opendocument.formula-template": { source: "iana", extensions: ["odft"] },
  "application/vnd.oasis.opendocument.graphics": { source: "iana", compressible: !1, extensions: ["odg"] },
  "application/vnd.oasis.opendocument.graphics-template": { source: "iana", extensions: ["otg"] },
  "application/vnd.oasis.opendocument.image": { source: "iana", extensions: ["odi"] },
  "application/vnd.oasis.opendocument.image-template": { source: "iana", extensions: ["oti"] },
  "application/vnd.oasis.opendocument.presentation": { source: "iana", compressible: !1, extensions: ["odp"] },
  "application/vnd.oasis.opendocument.presentation-template": { source: "iana", extensions: ["otp"] },
  "application/vnd.oasis.opendocument.spreadsheet": { source: "iana", compressible: !1, extensions: ["ods"] },
  "application/vnd.oasis.opendocument.spreadsheet-template": { source: "iana", extensions: ["ots"] },
  "application/vnd.oasis.opendocument.text": { source: "iana", compressible: !1, extensions: ["odt"] },
  "application/vnd.oasis.opendocument.text-master": { source: "iana", extensions: ["odm"] },
  "application/vnd.oasis.opendocument.text-template": { source: "iana", extensions: ["ott"] },
  "application/vnd.oasis.opendocument.text-web": { source: "iana", extensions: ["oth"] },
  "application/vnd.obn": { source: "iana" },
  "application/vnd.ocf+cbor": { source: "iana" },
  "application/vnd.oci.image.manifest.v1+json": { source: "iana", compressible: !0 },
  "application/vnd.oftn.l10n+json": { source: "iana", compressible: !0 },
  "application/vnd.oipf.contentaccessdownload+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.contentaccessstreaming+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.cspg-hexbinary": { source: "iana" },
  "application/vnd.oipf.dae.svg+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.dae.xhtml+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.mippvcontrolmessage+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.pae.gem": { source: "iana" },
  "application/vnd.oipf.spdiscovery+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.spdlist+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.ueprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.userprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.olpc-sugar": { source: "iana", extensions: ["xo"] },
  "application/vnd.oma-scws-config": { source: "iana" },
  "application/vnd.oma-scws-http-request": { source: "iana" },
  "application/vnd.oma-scws-http-response": { source: "iana" },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.drm-trigger+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.imd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.ltkm": { source: "iana" },
  "application/vnd.oma.bcast.notification+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.provisioningtrigger": { source: "iana" },
  "application/vnd.oma.bcast.sgboot": { source: "iana" },
  "application/vnd.oma.bcast.sgdd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.sgdu": { source: "iana" },
  "application/vnd.oma.bcast.simple-symbol-container": { source: "iana" },
  "application/vnd.oma.bcast.smartcard-trigger+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.sprov+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.stkm": { source: "iana" },
  "application/vnd.oma.cab-address-book+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-feature-handler+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-pcc+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-subs-invite+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-user-prefs+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.dcd": { source: "iana" },
  "application/vnd.oma.dcdc": { source: "iana" },
  "application/vnd.oma.dd2+xml": { source: "iana", compressible: !0, extensions: ["dd2"] },
  "application/vnd.oma.drm.risd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.group-usage-list+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.lwm2m+cbor": { source: "iana" },
  "application/vnd.oma.lwm2m+json": { source: "iana", compressible: !0 },
  "application/vnd.oma.lwm2m+tlv": { source: "iana" },
  "application/vnd.oma.pal+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.detailed-progress-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.final-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.groups+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.invocation-descriptor+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.optimized-progress-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.push": { source: "iana" },
  "application/vnd.oma.scidm.messages+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.xcap-directory+xml": { source: "iana", compressible: !0 },
  "application/vnd.omads-email+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omads-file+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omads-folder+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omaloc-supl-init": { source: "iana" },
  "application/vnd.onepager": { source: "iana" },
  "application/vnd.onepagertamp": { source: "iana" },
  "application/vnd.onepagertamx": { source: "iana" },
  "application/vnd.onepagertat": { source: "iana" },
  "application/vnd.onepagertatp": { source: "iana" },
  "application/vnd.onepagertatx": { source: "iana" },
  "application/vnd.openblox.game+xml": { source: "iana", compressible: !0, extensions: ["obgx"] },
  "application/vnd.openblox.game-binary": { source: "iana" },
  "application/vnd.openeye.oeb": { source: "iana" },
  "application/vnd.openofficeorg.extension": { source: "apache", extensions: ["oxt"] },
  "application/vnd.openstreetmap.data+xml": { source: "iana", compressible: !0, extensions: ["osm"] },
  "application/vnd.opentimestamps.ots": { source: "iana" },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawing+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { source: "iana", compressible: !1, extensions: ["pptx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": { source: "iana", extensions: ["sldx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { source: "iana", extensions: ["ppsx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { source: "iana", extensions: ["potx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { source: "iana", compressible: !1, extensions: ["xlsx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": { source: "iana", extensions: ["xltx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.theme+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.vmldrawing": { source: "iana" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { source: "iana", compressible: !1, extensions: ["docx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { source: "iana", extensions: ["dotx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.core-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.relationships+xml": { source: "iana", compressible: !0 },
  "application/vnd.oracle.resource+json": { source: "iana", compressible: !0 },
  "application/vnd.orange.indata": { source: "iana" },
  "application/vnd.osa.netdeploy": { source: "iana" },
  "application/vnd.osgeo.mapguide.package": { source: "iana", extensions: ["mgp"] },
  "application/vnd.osgi.bundle": { source: "iana" },
  "application/vnd.osgi.dp": { source: "iana", extensions: ["dp"] },
  "application/vnd.osgi.subsystem": { source: "iana", extensions: ["esa"] },
  "application/vnd.otps.ct-kip+xml": { source: "iana", compressible: !0 },
  "application/vnd.oxli.countgraph": { source: "iana" },
  "application/vnd.pagerduty+json": { source: "iana", compressible: !0 },
  "application/vnd.palm": { source: "iana", extensions: ["pdb", "pqa", "oprc"] },
  "application/vnd.panoply": { source: "iana" },
  "application/vnd.paos.xml": { source: "iana" },
  "application/vnd.patentdive": { source: "iana" },
  "application/vnd.patientecommsdoc": { source: "iana" },
  "application/vnd.pawaafile": { source: "iana", extensions: ["paw"] },
  "application/vnd.pcos": { source: "iana" },
  "application/vnd.pg.format": { source: "iana", extensions: ["str"] },
  "application/vnd.pg.osasli": { source: "iana", extensions: ["ei6"] },
  "application/vnd.piaccess.application-licence": { source: "iana" },
  "application/vnd.picsel": { source: "iana", extensions: ["efif"] },
  "application/vnd.pmi.widget": { source: "iana", extensions: ["wg"] },
  "application/vnd.poc.group-advertisement+xml": { source: "iana", compressible: !0 },
  "application/vnd.pocketlearn": { source: "iana", extensions: ["plf"] },
  "application/vnd.powerbuilder6": { source: "iana", extensions: ["pbd"] },
  "application/vnd.powerbuilder6-s": { source: "iana" },
  "application/vnd.powerbuilder7": { source: "iana" },
  "application/vnd.powerbuilder7-s": { source: "iana" },
  "application/vnd.powerbuilder75": { source: "iana" },
  "application/vnd.powerbuilder75-s": { source: "iana" },
  "application/vnd.preminet": { source: "iana" },
  "application/vnd.previewsystems.box": { source: "iana", extensions: ["box"] },
  "application/vnd.proteus.magazine": { source: "iana", extensions: ["mgz"] },
  "application/vnd.psfs": { source: "iana" },
  "application/vnd.publishare-delta-tree": { source: "iana", extensions: ["qps"] },
  "application/vnd.pvi.ptid1": { source: "iana", extensions: ["ptid"] },
  "application/vnd.pwg-multiplexed": { source: "iana" },
  "application/vnd.pwg-xhtml-print+xml": { source: "iana", compressible: !0 },
  "application/vnd.qualcomm.brew-app-res": { source: "iana" },
  "application/vnd.quarantainenet": { source: "iana" },
  "application/vnd.quark.quarkxpress": { source: "iana", extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"] },
  "application/vnd.quobject-quoxdocument": { source: "iana" },
  "application/vnd.radisys.moml+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-conf+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-conn+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-dialog+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-stream+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-conf+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-base+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-group+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-speech+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-transform+xml": { source: "iana", compressible: !0 },
  "application/vnd.rainstor.data": { source: "iana" },
  "application/vnd.rapid": { source: "iana" },
  "application/vnd.rar": { source: "iana", extensions: ["rar"] },
  "application/vnd.realvnc.bed": { source: "iana", extensions: ["bed"] },
  "application/vnd.recordare.musicxml": { source: "iana", extensions: ["mxl"] },
  "application/vnd.recordare.musicxml+xml": { source: "iana", compressible: !0, extensions: ["musicxml"] },
  "application/vnd.renlearn.rlprint": { source: "iana" },
  "application/vnd.resilient.logic": { source: "iana" },
  "application/vnd.restful+json": { source: "iana", compressible: !0 },
  "application/vnd.rig.cryptonote": { source: "iana", extensions: ["cryptonote"] },
  "application/vnd.rim.cod": { source: "apache", extensions: ["cod"] },
  "application/vnd.rn-realmedia": { source: "apache", extensions: ["rm"] },
  "application/vnd.rn-realmedia-vbr": { source: "apache", extensions: ["rmvb"] },
  "application/vnd.route66.link66+xml": { source: "iana", compressible: !0, extensions: ["link66"] },
  "application/vnd.rs-274x": { source: "iana" },
  "application/vnd.ruckus.download": { source: "iana" },
  "application/vnd.s3sms": { source: "iana" },
  "application/vnd.sailingtracker.track": { source: "iana", extensions: ["st"] },
  "application/vnd.sar": { source: "iana" },
  "application/vnd.sbm.cid": { source: "iana" },
  "application/vnd.sbm.mid2": { source: "iana" },
  "application/vnd.scribus": { source: "iana" },
  "application/vnd.sealed.3df": { source: "iana" },
  "application/vnd.sealed.csf": { source: "iana" },
  "application/vnd.sealed.doc": { source: "iana" },
  "application/vnd.sealed.eml": { source: "iana" },
  "application/vnd.sealed.mht": { source: "iana" },
  "application/vnd.sealed.net": { source: "iana" },
  "application/vnd.sealed.ppt": { source: "iana" },
  "application/vnd.sealed.tiff": { source: "iana" },
  "application/vnd.sealed.xls": { source: "iana" },
  "application/vnd.sealedmedia.softseal.html": { source: "iana" },
  "application/vnd.sealedmedia.softseal.pdf": { source: "iana" },
  "application/vnd.seemail": { source: "iana", extensions: ["see"] },
  "application/vnd.seis+json": { source: "iana", compressible: !0 },
  "application/vnd.sema": { source: "iana", extensions: ["sema"] },
  "application/vnd.semd": { source: "iana", extensions: ["semd"] },
  "application/vnd.semf": { source: "iana", extensions: ["semf"] },
  "application/vnd.shade-save-file": { source: "iana" },
  "application/vnd.shana.informed.formdata": { source: "iana", extensions: ["ifm"] },
  "application/vnd.shana.informed.formtemplate": { source: "iana", extensions: ["itp"] },
  "application/vnd.shana.informed.interchange": { source: "iana", extensions: ["iif"] },
  "application/vnd.shana.informed.package": { source: "iana", extensions: ["ipk"] },
  "application/vnd.shootproof+json": { source: "iana", compressible: !0 },
  "application/vnd.shopkick+json": { source: "iana", compressible: !0 },
  "application/vnd.shp": { source: "iana" },
  "application/vnd.shx": { source: "iana" },
  "application/vnd.sigrok.session": { source: "iana" },
  "application/vnd.simtech-mindmapper": { source: "iana", extensions: ["twd", "twds"] },
  "application/vnd.siren+json": { source: "iana", compressible: !0 },
  "application/vnd.smaf": { source: "iana", extensions: ["mmf"] },
  "application/vnd.smart.notebook": { source: "iana" },
  "application/vnd.smart.teacher": { source: "iana", extensions: ["teacher"] },
  "application/vnd.snesdev-page-table": { source: "iana" },
  "application/vnd.software602.filler.form+xml": { source: "iana", compressible: !0, extensions: ["fo"] },
  "application/vnd.software602.filler.form-xml-zip": { source: "iana" },
  "application/vnd.solent.sdkm+xml": { source: "iana", compressible: !0, extensions: ["sdkm", "sdkd"] },
  "application/vnd.spotfire.dxp": { source: "iana", extensions: ["dxp"] },
  "application/vnd.spotfire.sfs": { source: "iana", extensions: ["sfs"] },
  "application/vnd.sqlite3": { source: "iana" },
  "application/vnd.sss-cod": { source: "iana" },
  "application/vnd.sss-dtf": { source: "iana" },
  "application/vnd.sss-ntf": { source: "iana" },
  "application/vnd.stardivision.calc": { source: "apache", extensions: ["sdc"] },
  "application/vnd.stardivision.draw": { source: "apache", extensions: ["sda"] },
  "application/vnd.stardivision.impress": { source: "apache", extensions: ["sdd"] },
  "application/vnd.stardivision.math": { source: "apache", extensions: ["smf"] },
  "application/vnd.stardivision.writer": { source: "apache", extensions: ["sdw", "vor"] },
  "application/vnd.stardivision.writer-global": { source: "apache", extensions: ["sgl"] },
  "application/vnd.stepmania.package": { source: "iana", extensions: ["smzip"] },
  "application/vnd.stepmania.stepchart": { source: "iana", extensions: ["sm"] },
  "application/vnd.street-stream": { source: "iana" },
  "application/vnd.sun.wadl+xml": { source: "iana", compressible: !0, extensions: ["wadl"] },
  "application/vnd.sun.xml.calc": { source: "apache", extensions: ["sxc"] },
  "application/vnd.sun.xml.calc.template": { source: "apache", extensions: ["stc"] },
  "application/vnd.sun.xml.draw": { source: "apache", extensions: ["sxd"] },
  "application/vnd.sun.xml.draw.template": { source: "apache", extensions: ["std"] },
  "application/vnd.sun.xml.impress": { source: "apache", extensions: ["sxi"] },
  "application/vnd.sun.xml.impress.template": { source: "apache", extensions: ["sti"] },
  "application/vnd.sun.xml.math": { source: "apache", extensions: ["sxm"] },
  "application/vnd.sun.xml.writer": { source: "apache", extensions: ["sxw"] },
  "application/vnd.sun.xml.writer.global": { source: "apache", extensions: ["sxg"] },
  "application/vnd.sun.xml.writer.template": { source: "apache", extensions: ["stw"] },
  "application/vnd.sus-calendar": { source: "iana", extensions: ["sus", "susp"] },
  "application/vnd.svd": { source: "iana", extensions: ["svd"] },
  "application/vnd.swiftview-ics": { source: "iana" },
  "application/vnd.sycle+xml": { source: "iana", compressible: !0 },
  "application/vnd.syft+json": { source: "iana", compressible: !0 },
  "application/vnd.symbian.install": { source: "apache", extensions: ["sis", "sisx"] },
  "application/vnd.syncml+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xsm"] },
  "application/vnd.syncml.dm+wbxml": { source: "iana", charset: "UTF-8", extensions: ["bdm"] },
  "application/vnd.syncml.dm+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xdm"] },
  "application/vnd.syncml.dm.notification": { source: "iana" },
  "application/vnd.syncml.dmddf+wbxml": { source: "iana" },
  "application/vnd.syncml.dmddf+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["ddf"] },
  "application/vnd.syncml.dmtnds+wbxml": { source: "iana" },
  "application/vnd.syncml.dmtnds+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.syncml.ds.notification": { source: "iana" },
  "application/vnd.tableschema+json": { source: "iana", compressible: !0 },
  "application/vnd.tao.intent-module-archive": { source: "iana", extensions: ["tao"] },
  "application/vnd.tcpdump.pcap": { source: "iana", extensions: ["pcap", "cap", "dmp"] },
  "application/vnd.think-cell.ppttc+json": { source: "iana", compressible: !0 },
  "application/vnd.tmd.mediaflex.api+xml": { source: "iana", compressible: !0 },
  "application/vnd.tml": { source: "iana" },
  "application/vnd.tmobile-livetv": { source: "iana", extensions: ["tmo"] },
  "application/vnd.tri.onesource": { source: "iana" },
  "application/vnd.trid.tpt": { source: "iana", extensions: ["tpt"] },
  "application/vnd.triscape.mxs": { source: "iana", extensions: ["mxs"] },
  "application/vnd.trueapp": { source: "iana", extensions: ["tra"] },
  "application/vnd.truedoc": { source: "iana" },
  "application/vnd.ubisoft.webplayer": { source: "iana" },
  "application/vnd.ufdl": { source: "iana", extensions: ["ufd", "ufdl"] },
  "application/vnd.uiq.theme": { source: "iana", extensions: ["utz"] },
  "application/vnd.umajin": { source: "iana", extensions: ["umj"] },
  "application/vnd.unity": { source: "iana", extensions: ["unityweb"] },
  "application/vnd.uoml+xml": { source: "iana", compressible: !0, extensions: ["uoml"] },
  "application/vnd.uplanet.alert": { source: "iana" },
  "application/vnd.uplanet.alert-wbxml": { source: "iana" },
  "application/vnd.uplanet.bearer-choice": { source: "iana" },
  "application/vnd.uplanet.bearer-choice-wbxml": { source: "iana" },
  "application/vnd.uplanet.cacheop": { source: "iana" },
  "application/vnd.uplanet.cacheop-wbxml": { source: "iana" },
  "application/vnd.uplanet.channel": { source: "iana" },
  "application/vnd.uplanet.channel-wbxml": { source: "iana" },
  "application/vnd.uplanet.list": { source: "iana" },
  "application/vnd.uplanet.list-wbxml": { source: "iana" },
  "application/vnd.uplanet.listcmd": { source: "iana" },
  "application/vnd.uplanet.listcmd-wbxml": { source: "iana" },
  "application/vnd.uplanet.signal": { source: "iana" },
  "application/vnd.uri-map": { source: "iana" },
  "application/vnd.valve.source.material": { source: "iana" },
  "application/vnd.vcx": { source: "iana", extensions: ["vcx"] },
  "application/vnd.vd-study": { source: "iana" },
  "application/vnd.vectorworks": { source: "iana" },
  "application/vnd.vel+json": { source: "iana", compressible: !0 },
  "application/vnd.verimatrix.vcas": { source: "iana" },
  "application/vnd.veritone.aion+json": { source: "iana", compressible: !0 },
  "application/vnd.veryant.thin": { source: "iana" },
  "application/vnd.ves.encrypted": { source: "iana" },
  "application/vnd.vidsoft.vidconference": { source: "iana" },
  "application/vnd.visio": { source: "iana", extensions: ["vsd", "vst", "vss", "vsw"] },
  "application/vnd.visionary": { source: "iana", extensions: ["vis"] },
  "application/vnd.vividence.scriptfile": { source: "iana" },
  "application/vnd.vsf": { source: "iana", extensions: ["vsf"] },
  "application/vnd.wap.sic": { source: "iana" },
  "application/vnd.wap.slc": { source: "iana" },
  "application/vnd.wap.wbxml": { source: "iana", charset: "UTF-8", extensions: ["wbxml"] },
  "application/vnd.wap.wmlc": { source: "iana", extensions: ["wmlc"] },
  "application/vnd.wap.wmlscriptc": { source: "iana", extensions: ["wmlsc"] },
  "application/vnd.webturbo": { source: "iana", extensions: ["wtb"] },
  "application/vnd.wfa.dpp": { source: "iana" },
  "application/vnd.wfa.p2p": { source: "iana" },
  "application/vnd.wfa.wsc": { source: "iana" },
  "application/vnd.windows.devicepairing": { source: "iana" },
  "application/vnd.wmc": { source: "iana" },
  "application/vnd.wmf.bootstrap": { source: "iana" },
  "application/vnd.wolfram.mathematica": { source: "iana" },
  "application/vnd.wolfram.mathematica.package": { source: "iana" },
  "application/vnd.wolfram.player": { source: "iana", extensions: ["nbp"] },
  "application/vnd.wordperfect": { source: "iana", extensions: ["wpd"] },
  "application/vnd.wqd": { source: "iana", extensions: ["wqd"] },
  "application/vnd.wrq-hp3000-labelled": { source: "iana" },
  "application/vnd.wt.stf": { source: "iana", extensions: ["stf"] },
  "application/vnd.wv.csp+wbxml": { source: "iana" },
  "application/vnd.wv.csp+xml": { source: "iana", compressible: !0 },
  "application/vnd.wv.ssp+xml": { source: "iana", compressible: !0 },
  "application/vnd.xacml+json": { source: "iana", compressible: !0 },
  "application/vnd.xara": { source: "iana", extensions: ["xar"] },
  "application/vnd.xfdl": { source: "iana", extensions: ["xfdl"] },
  "application/vnd.xfdl.webform": { source: "iana" },
  "application/vnd.xmi+xml": { source: "iana", compressible: !0 },
  "application/vnd.xmpie.cpkg": { source: "iana" },
  "application/vnd.xmpie.dpkg": { source: "iana" },
  "application/vnd.xmpie.plan": { source: "iana" },
  "application/vnd.xmpie.ppkg": { source: "iana" },
  "application/vnd.xmpie.xlim": { source: "iana" },
  "application/vnd.yamaha.hv-dic": { source: "iana", extensions: ["hvd"] },
  "application/vnd.yamaha.hv-script": { source: "iana", extensions: ["hvs"] },
  "application/vnd.yamaha.hv-voice": { source: "iana", extensions: ["hvp"] },
  "application/vnd.yamaha.openscoreformat": { source: "iana", extensions: ["osf"] },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": { source: "iana", compressible: !0, extensions: ["osfpvg"] },
  "application/vnd.yamaha.remote-setup": { source: "iana" },
  "application/vnd.yamaha.smaf-audio": { source: "iana", extensions: ["saf"] },
  "application/vnd.yamaha.smaf-phrase": { source: "iana", extensions: ["spf"] },
  "application/vnd.yamaha.through-ngn": { source: "iana" },
  "application/vnd.yamaha.tunnel-udpencap": { source: "iana" },
  "application/vnd.yaoweme": { source: "iana" },
  "application/vnd.yellowriver-custom-menu": { source: "iana", extensions: ["cmp"] },
  "application/vnd.youtube.yt": { source: "iana" },
  "application/vnd.zul": { source: "iana", extensions: ["zir", "zirz"] },
  "application/vnd.zzazz.deck+xml": { source: "iana", compressible: !0, extensions: ["zaz"] },
  "application/voicexml+xml": { source: "iana", compressible: !0, extensions: ["vxml"] },
  "application/voucher-cms+json": { source: "iana", compressible: !0 },
  "application/vq-rtcpxr": { source: "iana" },
  "application/wasm": { source: "iana", compressible: !0, extensions: ["wasm"] },
  "application/watcherinfo+xml": { source: "iana", compressible: !0, extensions: ["wif"] },
  "application/webpush-options+json": { source: "iana", compressible: !0 },
  "application/whoispp-query": { source: "iana" },
  "application/whoispp-response": { source: "iana" },
  "application/widget": { source: "iana", extensions: ["wgt"] },
  "application/winhlp": { source: "apache", extensions: ["hlp"] },
  "application/wita": { source: "iana" },
  "application/wordperfect5.1": { source: "iana" },
  "application/wsdl+xml": { source: "iana", compressible: !0, extensions: ["wsdl"] },
  "application/wspolicy+xml": { source: "iana", compressible: !0, extensions: ["wspolicy"] },
  "application/x-7z-compressed": { source: "apache", compressible: !1, extensions: ["7z"] },
  "application/x-abiword": { source: "apache", extensions: ["abw"] },
  "application/x-ace-compressed": { source: "apache", extensions: ["ace"] },
  "application/x-amf": { source: "apache" },
  "application/x-apple-diskimage": { source: "apache", extensions: ["dmg"] },
  "application/x-arj": { compressible: !1, extensions: ["arj"] },
  "application/x-authorware-bin": { source: "apache", extensions: ["aab", "x32", "u32", "vox"] },
  "application/x-authorware-map": { source: "apache", extensions: ["aam"] },
  "application/x-authorware-seg": { source: "apache", extensions: ["aas"] },
  "application/x-bcpio": { source: "apache", extensions: ["bcpio"] },
  "application/x-bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/x-bittorrent": { source: "apache", extensions: ["torrent"] },
  "application/x-blorb": { source: "apache", extensions: ["blb", "blorb"] },
  "application/x-bzip": { source: "apache", compressible: !1, extensions: ["bz"] },
  "application/x-bzip2": { source: "apache", compressible: !1, extensions: ["bz2", "boz"] },
  "application/x-cbr": { source: "apache", extensions: ["cbr", "cba", "cbt", "cbz", "cb7"] },
  "application/x-cdlink": { source: "apache", extensions: ["vcd"] },
  "application/x-cfs-compressed": { source: "apache", extensions: ["cfs"] },
  "application/x-chat": { source: "apache", extensions: ["chat"] },
  "application/x-chess-pgn": { source: "apache", extensions: ["pgn"] },
  "application/x-chrome-extension": { extensions: ["crx"] },
  "application/x-cocoa": { source: "nginx", extensions: ["cco"] },
  "application/x-compress": { source: "apache" },
  "application/x-conference": { source: "apache", extensions: ["nsc"] },
  "application/x-cpio": { source: "apache", extensions: ["cpio"] },
  "application/x-csh": { source: "apache", extensions: ["csh"] },
  "application/x-deb": { compressible: !1 },
  "application/x-debian-package": { source: "apache", extensions: ["deb", "udeb"] },
  "application/x-dgc-compressed": { source: "apache", extensions: ["dgc"] },
  "application/x-director": { source: "apache", extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"] },
  "application/x-doom": { source: "apache", extensions: ["wad"] },
  "application/x-dtbncx+xml": { source: "apache", compressible: !0, extensions: ["ncx"] },
  "application/x-dtbook+xml": { source: "apache", compressible: !0, extensions: ["dtb"] },
  "application/x-dtbresource+xml": { source: "apache", compressible: !0, extensions: ["res"] },
  "application/x-dvi": { source: "apache", compressible: !1, extensions: ["dvi"] },
  "application/x-envoy": { source: "apache", extensions: ["evy"] },
  "application/x-eva": { source: "apache", extensions: ["eva"] },
  "application/x-font-bdf": { source: "apache", extensions: ["bdf"] },
  "application/x-font-dos": { source: "apache" },
  "application/x-font-framemaker": { source: "apache" },
  "application/x-font-ghostscript": { source: "apache", extensions: ["gsf"] },
  "application/x-font-libgrx": { source: "apache" },
  "application/x-font-linux-psf": { source: "apache", extensions: ["psf"] },
  "application/x-font-pcf": { source: "apache", extensions: ["pcf"] },
  "application/x-font-snf": { source: "apache", extensions: ["snf"] },
  "application/x-font-speedo": { source: "apache" },
  "application/x-font-sunos-news": { source: "apache" },
  "application/x-font-type1": { source: "apache", extensions: ["pfa", "pfb", "pfm", "afm"] },
  "application/x-font-vfont": { source: "apache" },
  "application/x-freearc": { source: "apache", extensions: ["arc"] },
  "application/x-futuresplash": { source: "apache", extensions: ["spl"] },
  "application/x-gca-compressed": { source: "apache", extensions: ["gca"] },
  "application/x-glulx": { source: "apache", extensions: ["ulx"] },
  "application/x-gnumeric": { source: "apache", extensions: ["gnumeric"] },
  "application/x-gramps-xml": { source: "apache", extensions: ["gramps"] },
  "application/x-gtar": { source: "apache", extensions: ["gtar"] },
  "application/x-gzip": { source: "apache" },
  "application/x-hdf": { source: "apache", extensions: ["hdf"] },
  "application/x-httpd-php": { compressible: !0, extensions: ["php"] },
  "application/x-install-instructions": { source: "apache", extensions: ["install"] },
  "application/x-iso9660-image": { source: "apache", extensions: ["iso"] },
  "application/x-iwork-keynote-sffkey": { extensions: ["key"] },
  "application/x-iwork-numbers-sffnumbers": { extensions: ["numbers"] },
  "application/x-iwork-pages-sffpages": { extensions: ["pages"] },
  "application/x-java-archive-diff": { source: "nginx", extensions: ["jardiff"] },
  "application/x-java-jnlp-file": { source: "apache", compressible: !1, extensions: ["jnlp"] },
  "application/x-javascript": { compressible: !0 },
  "application/x-keepass2": { extensions: ["kdbx"] },
  "application/x-latex": { source: "apache", compressible: !1, extensions: ["latex"] },
  "application/x-lua-bytecode": { extensions: ["luac"] },
  "application/x-lzh-compressed": { source: "apache", extensions: ["lzh", "lha"] },
  "application/x-makeself": { source: "nginx", extensions: ["run"] },
  "application/x-mie": { source: "apache", extensions: ["mie"] },
  "application/x-mobipocket-ebook": { source: "apache", extensions: ["prc", "mobi"] },
  "application/x-mpegurl": { compressible: !1 },
  "application/x-ms-application": { source: "apache", extensions: ["application"] },
  "application/x-ms-shortcut": { source: "apache", extensions: ["lnk"] },
  "application/x-ms-wmd": { source: "apache", extensions: ["wmd"] },
  "application/x-ms-wmz": { source: "apache", extensions: ["wmz"] },
  "application/x-ms-xbap": { source: "apache", extensions: ["xbap"] },
  "application/x-msaccess": { source: "apache", extensions: ["mdb"] },
  "application/x-msbinder": { source: "apache", extensions: ["obd"] },
  "application/x-mscardfile": { source: "apache", extensions: ["crd"] },
  "application/x-msclip": { source: "apache", extensions: ["clp"] },
  "application/x-msdos-program": { extensions: ["exe"] },
  "application/x-msdownload": { source: "apache", extensions: ["exe", "dll", "com", "bat", "msi"] },
  "application/x-msmediaview": { source: "apache", extensions: ["mvb", "m13", "m14"] },
  "application/x-msmetafile": { source: "apache", extensions: ["wmf", "wmz", "emf", "emz"] },
  "application/x-msmoney": { source: "apache", extensions: ["mny"] },
  "application/x-mspublisher": { source: "apache", extensions: ["pub"] },
  "application/x-msschedule": { source: "apache", extensions: ["scd"] },
  "application/x-msterminal": { source: "apache", extensions: ["trm"] },
  "application/x-mswrite": { source: "apache", extensions: ["wri"] },
  "application/x-netcdf": { source: "apache", extensions: ["nc", "cdf"] },
  "application/x-ns-proxy-autoconfig": { compressible: !0, extensions: ["pac"] },
  "application/x-nzb": { source: "apache", extensions: ["nzb"] },
  "application/x-perl": { source: "nginx", extensions: ["pl", "pm"] },
  "application/x-pilot": { source: "nginx", extensions: ["prc", "pdb"] },
  "application/x-pkcs12": { source: "apache", compressible: !1, extensions: ["p12", "pfx"] },
  "application/x-pkcs7-certificates": { source: "apache", extensions: ["p7b", "spc"] },
  "application/x-pkcs7-certreqresp": { source: "apache", extensions: ["p7r"] },
  "application/x-pki-message": { source: "iana" },
  "application/x-rar-compressed": { source: "apache", compressible: !1, extensions: ["rar"] },
  "application/x-redhat-package-manager": { source: "nginx", extensions: ["rpm"] },
  "application/x-research-info-systems": { source: "apache", extensions: ["ris"] },
  "application/x-sea": { source: "nginx", extensions: ["sea"] },
  "application/x-sh": { source: "apache", compressible: !0, extensions: ["sh"] },
  "application/x-shar": { source: "apache", extensions: ["shar"] },
  "application/x-shockwave-flash": { source: "apache", compressible: !1, extensions: ["swf"] },
  "application/x-silverlight-app": { source: "apache", extensions: ["xap"] },
  "application/x-sql": { source: "apache", extensions: ["sql"] },
  "application/x-stuffit": { source: "apache", compressible: !1, extensions: ["sit"] },
  "application/x-stuffitx": { source: "apache", extensions: ["sitx"] },
  "application/x-subrip": { source: "apache", extensions: ["srt"] },
  "application/x-sv4cpio": { source: "apache", extensions: ["sv4cpio"] },
  "application/x-sv4crc": { source: "apache", extensions: ["sv4crc"] },
  "application/x-t3vm-image": { source: "apache", extensions: ["t3"] },
  "application/x-tads": { source: "apache", extensions: ["gam"] },
  "application/x-tar": { source: "apache", compressible: !0, extensions: ["tar"] },
  "application/x-tcl": { source: "apache", extensions: ["tcl", "tk"] },
  "application/x-tex": { source: "apache", extensions: ["tex"] },
  "application/x-tex-tfm": { source: "apache", extensions: ["tfm"] },
  "application/x-texinfo": { source: "apache", extensions: ["texinfo", "texi"] },
  "application/x-tgif": { source: "apache", extensions: ["obj"] },
  "application/x-ustar": { source: "apache", extensions: ["ustar"] },
  "application/x-virtualbox-hdd": { compressible: !0, extensions: ["hdd"] },
  "application/x-virtualbox-ova": { compressible: !0, extensions: ["ova"] },
  "application/x-virtualbox-ovf": { compressible: !0, extensions: ["ovf"] },
  "application/x-virtualbox-vbox": { compressible: !0, extensions: ["vbox"] },
  "application/x-virtualbox-vbox-extpack": { compressible: !1, extensions: ["vbox-extpack"] },
  "application/x-virtualbox-vdi": { compressible: !0, extensions: ["vdi"] },
  "application/x-virtualbox-vhd": { compressible: !0, extensions: ["vhd"] },
  "application/x-virtualbox-vmdk": { compressible: !0, extensions: ["vmdk"] },
  "application/x-wais-source": { source: "apache", extensions: ["src"] },
  "application/x-web-app-manifest+json": { compressible: !0, extensions: ["webapp"] },
  "application/x-www-form-urlencoded": { source: "iana", compressible: !0 },
  "application/x-x509-ca-cert": { source: "iana", extensions: ["der", "crt", "pem"] },
  "application/x-x509-ca-ra-cert": { source: "iana" },
  "application/x-x509-next-ca-cert": { source: "iana" },
  "application/x-xfig": { source: "apache", extensions: ["fig"] },
  "application/x-xliff+xml": { source: "apache", compressible: !0, extensions: ["xlf"] },
  "application/x-xpinstall": { source: "apache", compressible: !1, extensions: ["xpi"] },
  "application/x-xz": { source: "apache", extensions: ["xz"] },
  "application/x-zmachine": { source: "apache", extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"] },
  "application/x400-bp": { source: "iana" },
  "application/xacml+xml": { source: "iana", compressible: !0 },
  "application/xaml+xml": { source: "apache", compressible: !0, extensions: ["xaml"] },
  "application/xcap-att+xml": { source: "iana", compressible: !0, extensions: ["xav"] },
  "application/xcap-caps+xml": { source: "iana", compressible: !0, extensions: ["xca"] },
  "application/xcap-diff+xml": { source: "iana", compressible: !0, extensions: ["xdf"] },
  "application/xcap-el+xml": { source: "iana", compressible: !0, extensions: ["xel"] },
  "application/xcap-error+xml": { source: "iana", compressible: !0 },
  "application/xcap-ns+xml": { source: "iana", compressible: !0, extensions: ["xns"] },
  "application/xcon-conference-info+xml": { source: "iana", compressible: !0 },
  "application/xcon-conference-info-diff+xml": { source: "iana", compressible: !0 },
  "application/xenc+xml": { source: "iana", compressible: !0, extensions: ["xenc"] },
  "application/xhtml+xml": { source: "iana", compressible: !0, extensions: ["xhtml", "xht"] },
  "application/xhtml-voice+xml": { source: "apache", compressible: !0 },
  "application/xliff+xml": { source: "iana", compressible: !0, extensions: ["xlf"] },
  "application/xml": { source: "iana", compressible: !0, extensions: ["xml", "xsl", "xsd", "rng"] },
  "application/xml-dtd": { source: "iana", compressible: !0, extensions: ["dtd"] },
  "application/xml-external-parsed-entity": { source: "iana" },
  "application/xml-patch+xml": { source: "iana", compressible: !0 },
  "application/xmpp+xml": { source: "iana", compressible: !0 },
  "application/xop+xml": { source: "iana", compressible: !0, extensions: ["xop"] },
  "application/xproc+xml": { source: "apache", compressible: !0, extensions: ["xpl"] },
  "application/xslt+xml": { source: "iana", compressible: !0, extensions: ["xsl", "xslt"] },
  "application/xspf+xml": { source: "apache", compressible: !0, extensions: ["xspf"] },
  "application/xv+xml": { source: "iana", compressible: !0, extensions: ["mxml", "xhvml", "xvml", "xvm"] },
  "application/yang": { source: "iana", extensions: ["yang"] },
  "application/yang-data+json": { source: "iana", compressible: !0 },
  "application/yang-data+xml": { source: "iana", compressible: !0 },
  "application/yang-patch+json": { source: "iana", compressible: !0 },
  "application/yang-patch+xml": { source: "iana", compressible: !0 },
  "application/yin+xml": { source: "iana", compressible: !0, extensions: ["yin"] },
  "application/zip": { source: "iana", compressible: !1, extensions: ["zip"] },
  "application/zlib": { source: "iana" },
  "application/zstd": { source: "iana" },
  "audio/1d-interleaved-parityfec": { source: "iana" },
  "audio/32kadpcm": { source: "iana" },
  "audio/3gpp": { source: "iana", compressible: !1, extensions: ["3gpp"] },
  "audio/3gpp2": { source: "iana" },
  "audio/aac": { source: "iana" },
  "audio/ac3": { source: "iana" },
  "audio/adpcm": { source: "apache", extensions: ["adp"] },
  "audio/amr": { source: "iana", extensions: ["amr"] },
  "audio/amr-wb": { source: "iana" },
  "audio/amr-wb+": { source: "iana" },
  "audio/aptx": { source: "iana" },
  "audio/asc": { source: "iana" },
  "audio/atrac-advanced-lossless": { source: "iana" },
  "audio/atrac-x": { source: "iana" },
  "audio/atrac3": { source: "iana" },
  "audio/basic": { source: "iana", compressible: !1, extensions: ["au", "snd"] },
  "audio/bv16": { source: "iana" },
  "audio/bv32": { source: "iana" },
  "audio/clearmode": { source: "iana" },
  "audio/cn": { source: "iana" },
  "audio/dat12": { source: "iana" },
  "audio/dls": { source: "iana" },
  "audio/dsr-es201108": { source: "iana" },
  "audio/dsr-es202050": { source: "iana" },
  "audio/dsr-es202211": { source: "iana" },
  "audio/dsr-es202212": { source: "iana" },
  "audio/dv": { source: "iana" },
  "audio/dvi4": { source: "iana" },
  "audio/eac3": { source: "iana" },
  "audio/encaprtp": { source: "iana" },
  "audio/evrc": { source: "iana" },
  "audio/evrc-qcp": { source: "iana" },
  "audio/evrc0": { source: "iana" },
  "audio/evrc1": { source: "iana" },
  "audio/evrcb": { source: "iana" },
  "audio/evrcb0": { source: "iana" },
  "audio/evrcb1": { source: "iana" },
  "audio/evrcnw": { source: "iana" },
  "audio/evrcnw0": { source: "iana" },
  "audio/evrcnw1": { source: "iana" },
  "audio/evrcwb": { source: "iana" },
  "audio/evrcwb0": { source: "iana" },
  "audio/evrcwb1": { source: "iana" },
  "audio/evs": { source: "iana" },
  "audio/flexfec": { source: "iana" },
  "audio/fwdred": { source: "iana" },
  "audio/g711-0": { source: "iana" },
  "audio/g719": { source: "iana" },
  "audio/g722": { source: "iana" },
  "audio/g7221": { source: "iana" },
  "audio/g723": { source: "iana" },
  "audio/g726-16": { source: "iana" },
  "audio/g726-24": { source: "iana" },
  "audio/g726-32": { source: "iana" },
  "audio/g726-40": { source: "iana" },
  "audio/g728": { source: "iana" },
  "audio/g729": { source: "iana" },
  "audio/g7291": { source: "iana" },
  "audio/g729d": { source: "iana" },
  "audio/g729e": { source: "iana" },
  "audio/gsm": { source: "iana" },
  "audio/gsm-efr": { source: "iana" },
  "audio/gsm-hr-08": { source: "iana" },
  "audio/ilbc": { source: "iana" },
  "audio/ip-mr_v2.5": { source: "iana" },
  "audio/isac": { source: "apache" },
  "audio/l16": { source: "iana" },
  "audio/l20": { source: "iana" },
  "audio/l24": { source: "iana", compressible: !1 },
  "audio/l8": { source: "iana" },
  "audio/lpc": { source: "iana" },
  "audio/melp": { source: "iana" },
  "audio/melp1200": { source: "iana" },
  "audio/melp2400": { source: "iana" },
  "audio/melp600": { source: "iana" },
  "audio/mhas": { source: "iana" },
  "audio/midi": { source: "apache", extensions: ["mid", "midi", "kar", "rmi"] },
  "audio/mobile-xmf": { source: "iana", extensions: ["mxmf"] },
  "audio/mp3": { compressible: !1, extensions: ["mp3"] },
  "audio/mp4": { source: "iana", compressible: !1, extensions: ["m4a", "mp4a"] },
  "audio/mp4a-latm": { source: "iana" },
  "audio/mpa": { source: "iana" },
  "audio/mpa-robust": { source: "iana" },
  "audio/mpeg": { source: "iana", compressible: !1, extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] },
  "audio/mpeg4-generic": { source: "iana" },
  "audio/musepack": { source: "apache" },
  "audio/ogg": { source: "iana", compressible: !1, extensions: ["oga", "ogg", "spx", "opus"] },
  "audio/opus": { source: "iana" },
  "audio/parityfec": { source: "iana" },
  "audio/pcma": { source: "iana" },
  "audio/pcma-wb": { source: "iana" },
  "audio/pcmu": { source: "iana" },
  "audio/pcmu-wb": { source: "iana" },
  "audio/prs.sid": { source: "iana" },
  "audio/qcelp": { source: "iana" },
  "audio/raptorfec": { source: "iana" },
  "audio/red": { source: "iana" },
  "audio/rtp-enc-aescm128": { source: "iana" },
  "audio/rtp-midi": { source: "iana" },
  "audio/rtploopback": { source: "iana" },
  "audio/rtx": { source: "iana" },
  "audio/s3m": { source: "apache", extensions: ["s3m"] },
  "audio/scip": { source: "iana" },
  "audio/silk": { source: "apache", extensions: ["sil"] },
  "audio/smv": { source: "iana" },
  "audio/smv-qcp": { source: "iana" },
  "audio/smv0": { source: "iana" },
  "audio/sofa": { source: "iana" },
  "audio/sp-midi": { source: "iana" },
  "audio/speex": { source: "iana" },
  "audio/t140c": { source: "iana" },
  "audio/t38": { source: "iana" },
  "audio/telephone-event": { source: "iana" },
  "audio/tetra_acelp": { source: "iana" },
  "audio/tetra_acelp_bb": { source: "iana" },
  "audio/tone": { source: "iana" },
  "audio/tsvcis": { source: "iana" },
  "audio/uemclip": { source: "iana" },
  "audio/ulpfec": { source: "iana" },
  "audio/usac": { source: "iana" },
  "audio/vdvi": { source: "iana" },
  "audio/vmr-wb": { source: "iana" },
  "audio/vnd.3gpp.iufp": { source: "iana" },
  "audio/vnd.4sb": { source: "iana" },
  "audio/vnd.audiokoz": { source: "iana" },
  "audio/vnd.celp": { source: "iana" },
  "audio/vnd.cisco.nse": { source: "iana" },
  "audio/vnd.cmles.radio-events": { source: "iana" },
  "audio/vnd.cns.anp1": { source: "iana" },
  "audio/vnd.cns.inf1": { source: "iana" },
  "audio/vnd.dece.audio": { source: "iana", extensions: ["uva", "uvva"] },
  "audio/vnd.digital-winds": { source: "iana", extensions: ["eol"] },
  "audio/vnd.dlna.adts": { source: "iana" },
  "audio/vnd.dolby.heaac.1": { source: "iana" },
  "audio/vnd.dolby.heaac.2": { source: "iana" },
  "audio/vnd.dolby.mlp": { source: "iana" },
  "audio/vnd.dolby.mps": { source: "iana" },
  "audio/vnd.dolby.pl2": { source: "iana" },
  "audio/vnd.dolby.pl2x": { source: "iana" },
  "audio/vnd.dolby.pl2z": { source: "iana" },
  "audio/vnd.dolby.pulse.1": { source: "iana" },
  "audio/vnd.dra": { source: "iana", extensions: ["dra"] },
  "audio/vnd.dts": { source: "iana", extensions: ["dts"] },
  "audio/vnd.dts.hd": { source: "iana", extensions: ["dtshd"] },
  "audio/vnd.dts.uhd": { source: "iana" },
  "audio/vnd.dvb.file": { source: "iana" },
  "audio/vnd.everad.plj": { source: "iana" },
  "audio/vnd.hns.audio": { source: "iana" },
  "audio/vnd.lucent.voice": { source: "iana", extensions: ["lvp"] },
  "audio/vnd.ms-playready.media.pya": { source: "iana", extensions: ["pya"] },
  "audio/vnd.nokia.mobile-xmf": { source: "iana" },
  "audio/vnd.nortel.vbk": { source: "iana" },
  "audio/vnd.nuera.ecelp4800": { source: "iana", extensions: ["ecelp4800"] },
  "audio/vnd.nuera.ecelp7470": { source: "iana", extensions: ["ecelp7470"] },
  "audio/vnd.nuera.ecelp9600": { source: "iana", extensions: ["ecelp9600"] },
  "audio/vnd.octel.sbc": { source: "iana" },
  "audio/vnd.presonus.multitrack": { source: "iana" },
  "audio/vnd.qcelp": { source: "iana" },
  "audio/vnd.rhetorex.32kadpcm": { source: "iana" },
  "audio/vnd.rip": { source: "iana", extensions: ["rip"] },
  "audio/vnd.rn-realaudio": { compressible: !1 },
  "audio/vnd.sealedmedia.softseal.mpeg": { source: "iana" },
  "audio/vnd.vmx.cvsd": { source: "iana" },
  "audio/vnd.wave": { compressible: !1 },
  "audio/vorbis": { source: "iana", compressible: !1 },
  "audio/vorbis-config": { source: "iana" },
  "audio/wav": { compressible: !1, extensions: ["wav"] },
  "audio/wave": { compressible: !1, extensions: ["wav"] },
  "audio/webm": { source: "apache", compressible: !1, extensions: ["weba"] },
  "audio/x-aac": { source: "apache", compressible: !1, extensions: ["aac"] },
  "audio/x-aiff": { source: "apache", extensions: ["aif", "aiff", "aifc"] },
  "audio/x-caf": { source: "apache", compressible: !1, extensions: ["caf"] },
  "audio/x-flac": { source: "apache", extensions: ["flac"] },
  "audio/x-m4a": { source: "nginx", extensions: ["m4a"] },
  "audio/x-matroska": { source: "apache", extensions: ["mka"] },
  "audio/x-mpegurl": { source: "apache", extensions: ["m3u"] },
  "audio/x-ms-wax": { source: "apache", extensions: ["wax"] },
  "audio/x-ms-wma": { source: "apache", extensions: ["wma"] },
  "audio/x-pn-realaudio": { source: "apache", extensions: ["ram", "ra"] },
  "audio/x-pn-realaudio-plugin": { source: "apache", extensions: ["rmp"] },
  "audio/x-realaudio": { source: "nginx", extensions: ["ra"] },
  "audio/x-tta": { source: "apache" },
  "audio/x-wav": { source: "apache", extensions: ["wav"] },
  "audio/xm": { source: "apache", extensions: ["xm"] },
  "chemical/x-cdx": { source: "apache", extensions: ["cdx"] },
  "chemical/x-cif": { source: "apache", extensions: ["cif"] },
  "chemical/x-cmdf": { source: "apache", extensions: ["cmdf"] },
  "chemical/x-cml": { source: "apache", extensions: ["cml"] },
  "chemical/x-csml": { source: "apache", extensions: ["csml"] },
  "chemical/x-pdb": { source: "apache" },
  "chemical/x-xyz": { source: "apache", extensions: ["xyz"] },
  "font/collection": { source: "iana", extensions: ["ttc"] },
  "font/otf": { source: "iana", compressible: !0, extensions: ["otf"] },
  "font/sfnt": { source: "iana" },
  "font/ttf": { source: "iana", compressible: !0, extensions: ["ttf"] },
  "font/woff": { source: "iana", extensions: ["woff"] },
  "font/woff2": { source: "iana", extensions: ["woff2"] },
  "image/aces": { source: "iana", extensions: ["exr"] },
  "image/apng": { compressible: !1, extensions: ["apng"] },
  "image/avci": { source: "iana", extensions: ["avci"] },
  "image/avcs": { source: "iana", extensions: ["avcs"] },
  "image/avif": { source: "iana", compressible: !1, extensions: ["avif"] },
  "image/bmp": { source: "iana", compressible: !0, extensions: ["bmp"] },
  "image/cgm": { source: "iana", extensions: ["cgm"] },
  "image/dicom-rle": { source: "iana", extensions: ["drle"] },
  "image/emf": { source: "iana", extensions: ["emf"] },
  "image/fits": { source: "iana", extensions: ["fits"] },
  "image/g3fax": { source: "iana", extensions: ["g3"] },
  "image/gif": { source: "iana", compressible: !1, extensions: ["gif"] },
  "image/heic": { source: "iana", extensions: ["heic"] },
  "image/heic-sequence": { source: "iana", extensions: ["heics"] },
  "image/heif": { source: "iana", extensions: ["heif"] },
  "image/heif-sequence": { source: "iana", extensions: ["heifs"] },
  "image/hej2k": { source: "iana", extensions: ["hej2"] },
  "image/hsj2": { source: "iana", extensions: ["hsj2"] },
  "image/ief": { source: "iana", extensions: ["ief"] },
  "image/jls": { source: "iana", extensions: ["jls"] },
  "image/jp2": { source: "iana", compressible: !1, extensions: ["jp2", "jpg2"] },
  "image/jpeg": { source: "iana", compressible: !1, extensions: ["jpeg", "jpg", "jpe"] },
  "image/jph": { source: "iana", extensions: ["jph"] },
  "image/jphc": { source: "iana", extensions: ["jhc"] },
  "image/jpm": { source: "iana", compressible: !1, extensions: ["jpm"] },
  "image/jpx": { source: "iana", compressible: !1, extensions: ["jpx", "jpf"] },
  "image/jxr": { source: "iana", extensions: ["jxr"] },
  "image/jxra": { source: "iana", extensions: ["jxra"] },
  "image/jxrs": { source: "iana", extensions: ["jxrs"] },
  "image/jxs": { source: "iana", extensions: ["jxs"] },
  "image/jxsc": { source: "iana", extensions: ["jxsc"] },
  "image/jxsi": { source: "iana", extensions: ["jxsi"] },
  "image/jxss": { source: "iana", extensions: ["jxss"] },
  "image/ktx": { source: "iana", extensions: ["ktx"] },
  "image/ktx2": { source: "iana", extensions: ["ktx2"] },
  "image/naplps": { source: "iana" },
  "image/pjpeg": { compressible: !1 },
  "image/png": { source: "iana", compressible: !1, extensions: ["png"] },
  "image/prs.btif": { source: "iana", extensions: ["btif"] },
  "image/prs.pti": { source: "iana", extensions: ["pti"] },
  "image/pwg-raster": { source: "iana" },
  "image/sgi": { source: "apache", extensions: ["sgi"] },
  "image/svg+xml": { source: "iana", compressible: !0, extensions: ["svg", "svgz"] },
  "image/t38": { source: "iana", extensions: ["t38"] },
  "image/tiff": { source: "iana", compressible: !1, extensions: ["tif", "tiff"] },
  "image/tiff-fx": { source: "iana", extensions: ["tfx"] },
  "image/vnd.adobe.photoshop": { source: "iana", compressible: !0, extensions: ["psd"] },
  "image/vnd.airzip.accelerator.azv": { source: "iana", extensions: ["azv"] },
  "image/vnd.cns.inf2": { source: "iana" },
  "image/vnd.dece.graphic": { source: "iana", extensions: ["uvi", "uvvi", "uvg", "uvvg"] },
  "image/vnd.djvu": { source: "iana", extensions: ["djvu", "djv"] },
  "image/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "image/vnd.dwg": { source: "iana", extensions: ["dwg"] },
  "image/vnd.dxf": { source: "iana", extensions: ["dxf"] },
  "image/vnd.fastbidsheet": { source: "iana", extensions: ["fbs"] },
  "image/vnd.fpx": { source: "iana", extensions: ["fpx"] },
  "image/vnd.fst": { source: "iana", extensions: ["fst"] },
  "image/vnd.fujixerox.edmics-mmr": { source: "iana", extensions: ["mmr"] },
  "image/vnd.fujixerox.edmics-rlc": { source: "iana", extensions: ["rlc"] },
  "image/vnd.globalgraphics.pgb": { source: "iana" },
  "image/vnd.microsoft.icon": { source: "iana", compressible: !0, extensions: ["ico"] },
  "image/vnd.mix": { source: "iana" },
  "image/vnd.mozilla.apng": { source: "iana" },
  "image/vnd.ms-dds": { compressible: !0, extensions: ["dds"] },
  "image/vnd.ms-modi": { source: "iana", extensions: ["mdi"] },
  "image/vnd.ms-photo": { source: "apache", extensions: ["wdp"] },
  "image/vnd.net-fpx": { source: "iana", extensions: ["npx"] },
  "image/vnd.pco.b16": { source: "iana", extensions: ["b16"] },
  "image/vnd.radiance": { source: "iana" },
  "image/vnd.sealed.png": { source: "iana" },
  "image/vnd.sealedmedia.softseal.gif": { source: "iana" },
  "image/vnd.sealedmedia.softseal.jpg": { source: "iana" },
  "image/vnd.svf": { source: "iana" },
  "image/vnd.tencent.tap": { source: "iana", extensions: ["tap"] },
  "image/vnd.valve.source.texture": { source: "iana", extensions: ["vtf"] },
  "image/vnd.wap.wbmp": { source: "iana", extensions: ["wbmp"] },
  "image/vnd.xiff": { source: "iana", extensions: ["xif"] },
  "image/vnd.zbrush.pcx": { source: "iana", extensions: ["pcx"] },
  "image/webp": { source: "apache", extensions: ["webp"] },
  "image/wmf": { source: "iana", extensions: ["wmf"] },
  "image/x-3ds": { source: "apache", extensions: ["3ds"] },
  "image/x-cmu-raster": { source: "apache", extensions: ["ras"] },
  "image/x-cmx": { source: "apache", extensions: ["cmx"] },
  "image/x-freehand": { source: "apache", extensions: ["fh", "fhc", "fh4", "fh5", "fh7"] },
  "image/x-icon": { source: "apache", compressible: !0, extensions: ["ico"] },
  "image/x-jng": { source: "nginx", extensions: ["jng"] },
  "image/x-mrsid-image": { source: "apache", extensions: ["sid"] },
  "image/x-ms-bmp": { source: "nginx", compressible: !0, extensions: ["bmp"] },
  "image/x-pcx": { source: "apache", extensions: ["pcx"] },
  "image/x-pict": { source: "apache", extensions: ["pic", "pct"] },
  "image/x-portable-anymap": { source: "apache", extensions: ["pnm"] },
  "image/x-portable-bitmap": { source: "apache", extensions: ["pbm"] },
  "image/x-portable-graymap": { source: "apache", extensions: ["pgm"] },
  "image/x-portable-pixmap": { source: "apache", extensions: ["ppm"] },
  "image/x-rgb": { source: "apache", extensions: ["rgb"] },
  "image/x-tga": { source: "apache", extensions: ["tga"] },
  "image/x-xbitmap": { source: "apache", extensions: ["xbm"] },
  "image/x-xcf": { compressible: !1 },
  "image/x-xpixmap": { source: "apache", extensions: ["xpm"] },
  "image/x-xwindowdump": { source: "apache", extensions: ["xwd"] },
  "message/cpim": { source: "iana" },
  "message/delivery-status": { source: "iana" },
  "message/disposition-notification": { source: "iana", extensions: ["disposition-notification"] },
  "message/external-body": { source: "iana" },
  "message/feedback-report": { source: "iana" },
  "message/global": { source: "iana", extensions: ["u8msg"] },
  "message/global-delivery-status": { source: "iana", extensions: ["u8dsn"] },
  "message/global-disposition-notification": { source: "iana", extensions: ["u8mdn"] },
  "message/global-headers": { source: "iana", extensions: ["u8hdr"] },
  "message/http": { source: "iana", compressible: !1 },
  "message/imdn+xml": { source: "iana", compressible: !0 },
  "message/news": { source: "iana" },
  "message/partial": { source: "iana", compressible: !1 },
  "message/rfc822": { source: "iana", compressible: !0, extensions: ["eml", "mime"] },
  "message/s-http": { source: "iana" },
  "message/sip": { source: "iana" },
  "message/sipfrag": { source: "iana" },
  "message/tracking-status": { source: "iana" },
  "message/vnd.si.simp": { source: "iana" },
  "message/vnd.wfa.wsc": { source: "iana", extensions: ["wsc"] },
  "model/3mf": { source: "iana", extensions: ["3mf"] },
  "model/e57": { source: "iana" },
  "model/gltf+json": { source: "iana", compressible: !0, extensions: ["gltf"] },
  "model/gltf-binary": { source: "iana", compressible: !0, extensions: ["glb"] },
  "model/iges": { source: "iana", compressible: !1, extensions: ["igs", "iges"] },
  "model/mesh": { source: "iana", compressible: !1, extensions: ["msh", "mesh", "silo"] },
  "model/mtl": { source: "iana", extensions: ["mtl"] },
  "model/obj": { source: "iana", extensions: ["obj"] },
  "model/step": { source: "iana" },
  "model/step+xml": { source: "iana", compressible: !0, extensions: ["stpx"] },
  "model/step+zip": { source: "iana", compressible: !1, extensions: ["stpz"] },
  "model/step-xml+zip": { source: "iana", compressible: !1, extensions: ["stpxz"] },
  "model/stl": { source: "iana", extensions: ["stl"] },
  "model/vnd.collada+xml": { source: "iana", compressible: !0, extensions: ["dae"] },
  "model/vnd.dwf": { source: "iana", extensions: ["dwf"] },
  "model/vnd.flatland.3dml": { source: "iana" },
  "model/vnd.gdl": { source: "iana", extensions: ["gdl"] },
  "model/vnd.gs-gdl": { source: "apache" },
  "model/vnd.gs.gdl": { source: "iana" },
  "model/vnd.gtw": { source: "iana", extensions: ["gtw"] },
  "model/vnd.moml+xml": { source: "iana", compressible: !0 },
  "model/vnd.mts": { source: "iana", extensions: ["mts"] },
  "model/vnd.opengex": { source: "iana", extensions: ["ogex"] },
  "model/vnd.parasolid.transmit.binary": { source: "iana", extensions: ["x_b"] },
  "model/vnd.parasolid.transmit.text": { source: "iana", extensions: ["x_t"] },
  "model/vnd.pytha.pyox": { source: "iana" },
  "model/vnd.rosette.annotated-data-model": { source: "iana" },
  "model/vnd.sap.vds": { source: "iana", extensions: ["vds"] },
  "model/vnd.usdz+zip": { source: "iana", compressible: !1, extensions: ["usdz"] },
  "model/vnd.valve.source.compiled-map": { source: "iana", extensions: ["bsp"] },
  "model/vnd.vtu": { source: "iana", extensions: ["vtu"] },
  "model/vrml": { source: "iana", compressible: !1, extensions: ["wrl", "vrml"] },
  "model/x3d+binary": { source: "apache", compressible: !1, extensions: ["x3db", "x3dbz"] },
  "model/x3d+fastinfoset": { source: "iana", extensions: ["x3db"] },
  "model/x3d+vrml": { source: "apache", compressible: !1, extensions: ["x3dv", "x3dvz"] },
  "model/x3d+xml": { source: "iana", compressible: !0, extensions: ["x3d", "x3dz"] },
  "model/x3d-vrml": { source: "iana", extensions: ["x3dv"] },
  "multipart/alternative": { source: "iana", compressible: !1 },
  "multipart/appledouble": { source: "iana" },
  "multipart/byteranges": { source: "iana" },
  "multipart/digest": { source: "iana" },
  "multipart/encrypted": { source: "iana", compressible: !1 },
  "multipart/form-data": { source: "iana", compressible: !1 },
  "multipart/header-set": { source: "iana" },
  "multipart/mixed": { source: "iana" },
  "multipart/multilingual": { source: "iana" },
  "multipart/parallel": { source: "iana" },
  "multipart/related": { source: "iana", compressible: !1 },
  "multipart/report": { source: "iana" },
  "multipart/signed": { source: "iana", compressible: !1 },
  "multipart/vnd.bint.med-plus": { source: "iana" },
  "multipart/voice-message": { source: "iana" },
  "multipart/x-mixed-replace": { source: "iana" },
  "text/1d-interleaved-parityfec": { source: "iana" },
  "text/cache-manifest": { source: "iana", compressible: !0, extensions: ["appcache", "manifest"] },
  "text/calendar": { source: "iana", extensions: ["ics", "ifb"] },
  "text/calender": { compressible: !0 },
  "text/cmd": { compressible: !0 },
  "text/coffeescript": { extensions: ["coffee", "litcoffee"] },
  "text/cql": { source: "iana" },
  "text/cql-expression": { source: "iana" },
  "text/cql-identifier": { source: "iana" },
  "text/css": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["css"] },
  "text/csv": { source: "iana", compressible: !0, extensions: ["csv"] },
  "text/csv-schema": { source: "iana" },
  "text/directory": { source: "iana" },
  "text/dns": { source: "iana" },
  "text/ecmascript": { source: "iana" },
  "text/encaprtp": { source: "iana" },
  "text/enriched": { source: "iana" },
  "text/fhirpath": { source: "iana" },
  "text/flexfec": { source: "iana" },
  "text/fwdred": { source: "iana" },
  "text/gff3": { source: "iana" },
  "text/grammar-ref-list": { source: "iana" },
  "text/html": { source: "iana", compressible: !0, extensions: ["html", "htm", "shtml"] },
  "text/jade": { extensions: ["jade"] },
  "text/javascript": { source: "iana", compressible: !0 },
  "text/jcr-cnd": { source: "iana" },
  "text/jsx": { compressible: !0, extensions: ["jsx"] },
  "text/less": { compressible: !0, extensions: ["less"] },
  "text/markdown": { source: "iana", compressible: !0, extensions: ["markdown", "md"] },
  "text/mathml": { source: "nginx", extensions: ["mml"] },
  "text/mdx": { compressible: !0, extensions: ["mdx"] },
  "text/mizar": { source: "iana" },
  "text/n3": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["n3"] },
  "text/parameters": { source: "iana", charset: "UTF-8" },
  "text/parityfec": { source: "iana" },
  "text/plain": { source: "iana", compressible: !0, extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"] },
  "text/provenance-notation": { source: "iana", charset: "UTF-8" },
  "text/prs.fallenstein.rst": { source: "iana" },
  "text/prs.lines.tag": { source: "iana", extensions: ["dsc"] },
  "text/prs.prop.logic": { source: "iana" },
  "text/raptorfec": { source: "iana" },
  "text/red": { source: "iana" },
  "text/rfc822-headers": { source: "iana" },
  "text/richtext": { source: "iana", compressible: !0, extensions: ["rtx"] },
  "text/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "text/rtp-enc-aescm128": { source: "iana" },
  "text/rtploopback": { source: "iana" },
  "text/rtx": { source: "iana" },
  "text/sgml": { source: "iana", extensions: ["sgml", "sgm"] },
  "text/shaclc": { source: "iana" },
  "text/shex": { source: "iana", extensions: ["shex"] },
  "text/slim": { extensions: ["slim", "slm"] },
  "text/spdx": { source: "iana", extensions: ["spdx"] },
  "text/strings": { source: "iana" },
  "text/stylus": { extensions: ["stylus", "styl"] },
  "text/t140": { source: "iana" },
  "text/tab-separated-values": { source: "iana", compressible: !0, extensions: ["tsv"] },
  "text/troff": { source: "iana", extensions: ["t", "tr", "roff", "man", "me", "ms"] },
  "text/turtle": { source: "iana", charset: "UTF-8", extensions: ["ttl"] },
  "text/ulpfec": { source: "iana" },
  "text/uri-list": { source: "iana", compressible: !0, extensions: ["uri", "uris", "urls"] },
  "text/vcard": { source: "iana", compressible: !0, extensions: ["vcard"] },
  "text/vnd.a": { source: "iana" },
  "text/vnd.abc": { source: "iana" },
  "text/vnd.ascii-art": { source: "iana" },
  "text/vnd.curl": { source: "iana", extensions: ["curl"] },
  "text/vnd.curl.dcurl": { source: "apache", extensions: ["dcurl"] },
  "text/vnd.curl.mcurl": { source: "apache", extensions: ["mcurl"] },
  "text/vnd.curl.scurl": { source: "apache", extensions: ["scurl"] },
  "text/vnd.debian.copyright": { source: "iana", charset: "UTF-8" },
  "text/vnd.dmclientscript": { source: "iana" },
  "text/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "text/vnd.esmertec.theme-descriptor": { source: "iana", charset: "UTF-8" },
  "text/vnd.familysearch.gedcom": { source: "iana", extensions: ["ged"] },
  "text/vnd.ficlab.flt": { source: "iana" },
  "text/vnd.fly": { source: "iana", extensions: ["fly"] },
  "text/vnd.fmi.flexstor": { source: "iana", extensions: ["flx"] },
  "text/vnd.gml": { source: "iana" },
  "text/vnd.graphviz": { source: "iana", extensions: ["gv"] },
  "text/vnd.hans": { source: "iana" },
  "text/vnd.hgl": { source: "iana" },
  "text/vnd.in3d.3dml": { source: "iana", extensions: ["3dml"] },
  "text/vnd.in3d.spot": { source: "iana", extensions: ["spot"] },
  "text/vnd.iptc.newsml": { source: "iana" },
  "text/vnd.iptc.nitf": { source: "iana" },
  "text/vnd.latex-z": { source: "iana" },
  "text/vnd.motorola.reflex": { source: "iana" },
  "text/vnd.ms-mediapackage": { source: "iana" },
  "text/vnd.net2phone.commcenter.command": { source: "iana" },
  "text/vnd.radisys.msml-basic-layout": { source: "iana" },
  "text/vnd.senx.warpscript": { source: "iana" },
  "text/vnd.si.uricatalogue": { source: "iana" },
  "text/vnd.sosi": { source: "iana" },
  "text/vnd.sun.j2me.app-descriptor": { source: "iana", charset: "UTF-8", extensions: ["jad"] },
  "text/vnd.trolltech.linguist": { source: "iana", charset: "UTF-8" },
  "text/vnd.wap.si": { source: "iana" },
  "text/vnd.wap.sl": { source: "iana" },
  "text/vnd.wap.wml": { source: "iana", extensions: ["wml"] },
  "text/vnd.wap.wmlscript": { source: "iana", extensions: ["wmls"] },
  "text/vtt": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["vtt"] },
  "text/x-asm": { source: "apache", extensions: ["s", "asm"] },
  "text/x-c": { source: "apache", extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"] },
  "text/x-component": { source: "nginx", extensions: ["htc"] },
  "text/x-fortran": { source: "apache", extensions: ["f", "for", "f77", "f90"] },
  "text/x-gwt-rpc": { compressible: !0 },
  "text/x-handlebars-template": { extensions: ["hbs"] },
  "text/x-java-source": { source: "apache", extensions: ["java"] },
  "text/x-jquery-tmpl": { compressible: !0 },
  "text/x-lua": { extensions: ["lua"] },
  "text/x-markdown": { compressible: !0, extensions: ["mkd"] },
  "text/x-nfo": { source: "apache", extensions: ["nfo"] },
  "text/x-opml": { source: "apache", extensions: ["opml"] },
  "text/x-org": { compressible: !0, extensions: ["org"] },
  "text/x-pascal": { source: "apache", extensions: ["p", "pas"] },
  "text/x-processing": { compressible: !0, extensions: ["pde"] },
  "text/x-sass": { extensions: ["sass"] },
  "text/x-scss": { extensions: ["scss"] },
  "text/x-setext": { source: "apache", extensions: ["etx"] },
  "text/x-sfv": { source: "apache", extensions: ["sfv"] },
  "text/x-suse-ymp": { compressible: !0, extensions: ["ymp"] },
  "text/x-uuencode": { source: "apache", extensions: ["uu"] },
  "text/x-vcalendar": { source: "apache", extensions: ["vcs"] },
  "text/x-vcard": { source: "apache", extensions: ["vcf"] },
  "text/xml": { source: "iana", compressible: !0, extensions: ["xml"] },
  "text/xml-external-parsed-entity": { source: "iana" },
  "text/yaml": { compressible: !0, extensions: ["yaml", "yml"] },
  "video/1d-interleaved-parityfec": { source: "iana" },
  "video/3gpp": { source: "iana", extensions: ["3gp", "3gpp"] },
  "video/3gpp-tt": { source: "iana" },
  "video/3gpp2": { source: "iana", extensions: ["3g2"] },
  "video/av1": { source: "iana" },
  "video/bmpeg": { source: "iana" },
  "video/bt656": { source: "iana" },
  "video/celb": { source: "iana" },
  "video/dv": { source: "iana" },
  "video/encaprtp": { source: "iana" },
  "video/ffv1": { source: "iana" },
  "video/flexfec": { source: "iana" },
  "video/h261": { source: "iana", extensions: ["h261"] },
  "video/h263": { source: "iana", extensions: ["h263"] },
  "video/h263-1998": { source: "iana" },
  "video/h263-2000": { source: "iana" },
  "video/h264": { source: "iana", extensions: ["h264"] },
  "video/h264-rcdo": { source: "iana" },
  "video/h264-svc": { source: "iana" },
  "video/h265": { source: "iana" },
  "video/iso.segment": { source: "iana", extensions: ["m4s"] },
  "video/jpeg": { source: "iana", extensions: ["jpgv"] },
  "video/jpeg2000": { source: "iana" },
  "video/jpm": { source: "apache", extensions: ["jpm", "jpgm"] },
  "video/jxsv": { source: "iana" },
  "video/mj2": { source: "iana", extensions: ["mj2", "mjp2"] },
  "video/mp1s": { source: "iana" },
  "video/mp2p": { source: "iana" },
  "video/mp2t": { source: "iana", extensions: ["ts"] },
  "video/mp4": { source: "iana", compressible: !1, extensions: ["mp4", "mp4v", "mpg4"] },
  "video/mp4v-es": { source: "iana" },
  "video/mpeg": { source: "iana", compressible: !1, extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"] },
  "video/mpeg4-generic": { source: "iana" },
  "video/mpv": { source: "iana" },
  "video/nv": { source: "iana" },
  "video/ogg": { source: "iana", compressible: !1, extensions: ["ogv"] },
  "video/parityfec": { source: "iana" },
  "video/pointer": { source: "iana" },
  "video/quicktime": { source: "iana", compressible: !1, extensions: ["qt", "mov"] },
  "video/raptorfec": { source: "iana" },
  "video/raw": { source: "iana" },
  "video/rtp-enc-aescm128": { source: "iana" },
  "video/rtploopback": { source: "iana" },
  "video/rtx": { source: "iana" },
  "video/scip": { source: "iana" },
  "video/smpte291": { source: "iana" },
  "video/smpte292m": { source: "iana" },
  "video/ulpfec": { source: "iana" },
  "video/vc1": { source: "iana" },
  "video/vc2": { source: "iana" },
  "video/vnd.cctv": { source: "iana" },
  "video/vnd.dece.hd": { source: "iana", extensions: ["uvh", "uvvh"] },
  "video/vnd.dece.mobile": { source: "iana", extensions: ["uvm", "uvvm"] },
  "video/vnd.dece.mp4": { source: "iana" },
  "video/vnd.dece.pd": { source: "iana", extensions: ["uvp", "uvvp"] },
  "video/vnd.dece.sd": { source: "iana", extensions: ["uvs", "uvvs"] },
  "video/vnd.dece.video": { source: "iana", extensions: ["uvv", "uvvv"] },
  "video/vnd.directv.mpeg": { source: "iana" },
  "video/vnd.directv.mpeg-tts": { source: "iana" },
  "video/vnd.dlna.mpeg-tts": { source: "iana" },
  "video/vnd.dvb.file": { source: "iana", extensions: ["dvb"] },
  "video/vnd.fvt": { source: "iana", extensions: ["fvt"] },
  "video/vnd.hns.video": { source: "iana" },
  "video/vnd.iptvforum.1dparityfec-1010": { source: "iana" },
  "video/vnd.iptvforum.1dparityfec-2005": { source: "iana" },
  "video/vnd.iptvforum.2dparityfec-1010": { source: "iana" },
  "video/vnd.iptvforum.2dparityfec-2005": { source: "iana" },
  "video/vnd.iptvforum.ttsavc": { source: "iana" },
  "video/vnd.iptvforum.ttsmpeg2": { source: "iana" },
  "video/vnd.motorola.video": { source: "iana" },
  "video/vnd.motorola.videop": { source: "iana" },
  "video/vnd.mpegurl": { source: "iana", extensions: ["mxu", "m4u"] },
  "video/vnd.ms-playready.media.pyv": { source: "iana", extensions: ["pyv"] },
  "video/vnd.nokia.interleaved-multimedia": { source: "iana" },
  "video/vnd.nokia.mp4vr": { source: "iana" },
  "video/vnd.nokia.videovoip": { source: "iana" },
  "video/vnd.objectvideo": { source: "iana" },
  "video/vnd.radgamettools.bink": { source: "iana" },
  "video/vnd.radgamettools.smacker": { source: "iana" },
  "video/vnd.sealed.mpeg1": { source: "iana" },
  "video/vnd.sealed.mpeg4": { source: "iana" },
  "video/vnd.sealed.swf": { source: "iana" },
  "video/vnd.sealedmedia.softseal.mov": { source: "iana" },
  "video/vnd.uvvu.mp4": { source: "iana", extensions: ["uvu", "uvvu"] },
  "video/vnd.vivo": { source: "iana", extensions: ["viv"] },
  "video/vnd.youtube.yt": { source: "iana" },
  "video/vp8": { source: "iana" },
  "video/vp9": { source: "iana" },
  "video/webm": { source: "apache", compressible: !1, extensions: ["webm"] },
  "video/x-f4v": { source: "apache", extensions: ["f4v"] },
  "video/x-fli": { source: "apache", extensions: ["fli"] },
  "video/x-flv": { source: "apache", compressible: !1, extensions: ["flv"] },
  "video/x-m4v": { source: "apache", extensions: ["m4v"] },
  "video/x-matroska": { source: "apache", compressible: !1, extensions: ["mkv", "mk3d", "mks"] },
  "video/x-mng": { source: "apache", extensions: ["mng"] },
  "video/x-ms-asf": { source: "apache", extensions: ["asf", "asx"] },
  "video/x-ms-vob": { source: "apache", extensions: ["vob"] },
  "video/x-ms-wm": { source: "apache", extensions: ["wm"] },
  "video/x-ms-wmv": { source: "apache", compressible: !1, extensions: ["wmv"] },
  "video/x-ms-wmx": { source: "apache", extensions: ["wmx"] },
  "video/x-ms-wvx": { source: "apache", extensions: ["wvx"] },
  "video/x-msvideo": { source: "apache", extensions: ["avi"] },
  "video/x-sgi-movie": { source: "apache", extensions: ["movie"] },
  "video/x-smv": { source: "apache", extensions: ["smv"] },
  "x-conference/x-cooltalk": { source: "apache", extensions: ["ice"] },
  "x-shader/x-fragment": { compressible: !0 },
  "x-shader/x-vertex": { compressible: !0 }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
var f6, HS;
function Pie() {
  return HS || (HS = 1, f6 = Tie), f6;
}
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var zS;
function Rie() {
  return zS || (zS = 1, (function(e) {
    var t = Pie(), n = As().extname, r = /^\s*([^;\s]*)(?:;|\s|$)/, i = /^text\//i;
    e.charset = a, e.charsets = { lookup: a }, e.contentType = o, e.extension = c, e.extensions = /* @__PURE__ */ Object.create(null), e.lookup = u, e.types = /* @__PURE__ */ Object.create(null), s(e.extensions, e.types);
    function a(l) {
      if (!l || typeof l != "string")
        return !1;
      var d = r.exec(l), f = d && t[d[1].toLowerCase()];
      return f && f.charset ? f.charset : d && i.test(d[1]) ? "UTF-8" : !1;
    }
    function o(l) {
      if (!l || typeof l != "string")
        return !1;
      var d = l.indexOf("/") === -1 ? e.lookup(l) : l;
      if (!d)
        return !1;
      if (d.indexOf("charset") === -1) {
        var f = e.charset(d);
        f && (d += "; charset=" + f.toLowerCase());
      }
      return d;
    }
    function c(l) {
      if (!l || typeof l != "string")
        return !1;
      var d = r.exec(l), f = d && e.extensions[d[1].toLowerCase()];
      return !f || !f.length ? !1 : f[0];
    }
    function u(l) {
      if (!l || typeof l != "string")
        return !1;
      var d = n("x." + l).toLowerCase().substr(1);
      return d && e.types[d] || !1;
    }
    function s(l, d) {
      var f = ["nginx", "apache", void 0, "iana"];
      Object.keys(t).forEach(function(g) {
        var b = t[g], w = b.extensions;
        if (!(!w || !w.length)) {
          l[g] = w;
          for (var y = 0; y < w.length; y++) {
            var v = w[y];
            if (d[v]) {
              var _ = f.indexOf(t[d[v]].source), E = f.indexOf(b.source);
              if (d[v] !== "application/octet-stream" && (_ > E || _ === E && d[v].substr(0, 12) === "application/"))
                continue;
            }
            d[v] = g;
          }
        }
      });
    }
  })(l6)), l6;
}
var p6, VS;
function Iie() {
  if (VS) return p6;
  VS = 1, p6 = e;
  function e(t) {
    var n = typeof setImmediate == "function" ? setImmediate : typeof gn == "object" && typeof gn.nextTick == "function" ? gn.nextTick : null;
    n ? n(t) : setTimeout(t, 0);
  }
  return p6;
}
var d6, GS;
function tT() {
  if (GS) return d6;
  GS = 1;
  var e = Iie();
  d6 = t;
  function t(n) {
    var r = !1;
    return e(function() {
      r = !0;
    }), function(a, o) {
      r ? n(a, o) : e(function() {
        n(a, o);
      });
    };
  }
  return d6;
}
var h6, WS;
function rT() {
  if (WS) return h6;
  WS = 1, h6 = e;
  function e(n) {
    Object.keys(n.jobs).forEach(t.bind(n)), n.jobs = {};
  }
  function t(n) {
    typeof this.jobs[n] == "function" && this.jobs[n]();
  }
  return h6;
}
var m6, KS;
function nT() {
  if (KS) return m6;
  KS = 1;
  var e = tT(), t = rT();
  m6 = n;
  function n(i, a, o, c) {
    var u = o.keyedList ? o.keyedList[o.index] : o.index;
    o.jobs[u] = r(a, u, i[u], function(s, l) {
      u in o.jobs && (delete o.jobs[u], s ? t(o) : o.results[u] = l, c(s, o.results));
    });
  }
  function r(i, a, o, c) {
    var u;
    return i.length == 2 ? u = i(o, e(c)) : u = i(o, a, e(c)), u;
  }
  return m6;
}
var g6, ZS;
function iT() {
  if (ZS) return g6;
  ZS = 1, g6 = e;
  function e(t, n) {
    var r = !Array.isArray(t), i = {
      index: 0,
      keyedList: r || n ? Object.keys(t) : null,
      jobs: {},
      results: r ? {} : [],
      size: r ? Object.keys(t).length : t.length
    };
    return n && i.keyedList.sort(r ? n : function(a, o) {
      return n(t[a], t[o]);
    }), i;
  }
  return g6;
}
var v6, YS;
function aT() {
  if (YS) return v6;
  YS = 1;
  var e = rT(), t = tT();
  v6 = n;
  function n(r) {
    Object.keys(this.jobs).length && (this.index = this.size, e(this), t(r)(null, this.results));
  }
  return v6;
}
var y6, JS;
function jie() {
  if (JS) return y6;
  JS = 1;
  var e = nT(), t = iT(), n = aT();
  y6 = r;
  function r(i, a, o) {
    for (var c = t(i); c.index < (c.keyedList || i).length; )
      e(i, a, c, function(u, s) {
        if (u) {
          o(u, s);
          return;
        }
        if (Object.keys(c.jobs).length === 0) {
          o(null, c.results);
          return;
        }
      }), c.index++;
    return n.bind(c, o);
  }
  return y6;
}
var rf = { exports: {} }, QS;
function oT() {
  if (QS) return rf.exports;
  QS = 1;
  var e = nT(), t = iT(), n = aT();
  rf.exports = r, rf.exports.ascending = i, rf.exports.descending = a;
  function r(o, c, u, s) {
    var l = t(o, u);
    return e(o, c, l, function d(f, p) {
      if (f) {
        s(f, p);
        return;
      }
      if (l.index++, l.index < (l.keyedList || o).length) {
        e(o, c, l, d);
        return;
      }
      s(null, l.results);
    }), n.bind(l, s);
  }
  function i(o, c) {
    return o < c ? -1 : o > c ? 1 : 0;
  }
  function a(o, c) {
    return -1 * i(o, c);
  }
  return rf.exports;
}
var b6, XS;
function qie() {
  if (XS) return b6;
  XS = 1;
  var e = oT();
  b6 = t;
  function t(n, r, i) {
    return e(n, r, null, i);
  }
  return b6;
}
var x6, eC;
function Die() {
  return eC || (eC = 1, x6 = {
    parallel: jie(),
    serial: qie(),
    serialOrdered: oT()
  }), x6;
}
var _6, tC;
function $ie() {
  return tC || (tC = 1, _6 = function(e, t) {
    return Object.keys(t).forEach(function(n) {
      e[n] = e[n] || t[n];
    }), e;
  }), _6;
}
var w6, rC;
function Lie() {
  if (rC) return w6;
  rC = 1;
  var e = _ie(), t = qg(), n = As(), r = ni, i = ni, a = eT().parse, o = ni, c = ni.Stream, u = Rie(), s = Die(), l = $ie();
  w6 = d, t.inherits(d, e);
  function d(f) {
    if (!(this instanceof d))
      return new d(f);
    this._overheadLength = 0, this._valueLength = 0, this._valuesToMeasure = [], e.call(this), f = f || {};
    for (var p in f)
      this[p] = f[p];
  }
  return d.LINE_BREAK = `\r
`, d.DEFAULT_CONTENT_TYPE = "application/octet-stream", d.prototype.append = function(f, p, g) {
    g = g || {}, typeof g == "string" && (g = { filename: g });
    var b = e.prototype.append.bind(this);
    if (typeof p == "number" && (p = "" + p), t.isArray(p)) {
      this._error(new Error("Arrays are not supported."));
      return;
    }
    var w = this._multiPartHeader(f, p, g), y = this._multiPartFooter();
    b(w), b(p), b(y), this._trackLength(w, p, g);
  }, d.prototype._trackLength = function(f, p, g) {
    var b = 0;
    g.knownLength != null ? b += +g.knownLength : qn.isBuffer(p) ? b = p.length : typeof p == "string" && (b = qn.byteLength(p)), this._valueLength += b, this._overheadLength += qn.byteLength(f) + d.LINE_BREAK.length, !(!p || !p.path && !(p.readable && p.hasOwnProperty("httpVersion")) && !(p instanceof c)) && (g.knownLength || this._valuesToMeasure.push(p));
  }, d.prototype._lengthRetriever = function(f, p) {
    f.hasOwnProperty("fd") ? f.end != null && f.end != 1 / 0 && f.start != null ? p(null, f.end + 1 - (f.start ? f.start : 0)) : o.stat(f.path, function(g, b) {
      var w;
      if (g) {
        p(g);
        return;
      }
      w = b.size - (f.start ? f.start : 0), p(null, w);
    }) : f.hasOwnProperty("httpVersion") ? p(null, +f.headers["content-length"]) : f.hasOwnProperty("httpModule") ? (f.on("response", function(g) {
      f.pause(), p(null, +g.headers["content-length"]);
    }), f.resume()) : p("Unknown stream");
  }, d.prototype._multiPartHeader = function(f, p, g) {
    if (typeof g.header == "string")
      return g.header;
    var b = this._getContentDisposition(p, g), w = this._getContentType(p, g), y = "", v = {
      // add custom disposition as third element or keep it two elements if not
      "Content-Disposition": ["form-data", 'name="' + f + '"'].concat(b || []),
      // if no content type. allow it to be empty array
      "Content-Type": [].concat(w || [])
    };
    typeof g.header == "object" && l(v, g.header);
    var _;
    for (var E in v)
      v.hasOwnProperty(E) && (_ = v[E], _ != null && (Array.isArray(_) || (_ = [_]), _.length && (y += E + ": " + _.join("; ") + d.LINE_BREAK)));
    return "--" + this.getBoundary() + d.LINE_BREAK + y + d.LINE_BREAK;
  }, d.prototype._getContentDisposition = function(f, p) {
    var g, b;
    return typeof p.filepath == "string" ? g = n.normalize(p.filepath).replace(/\\/g, "/") : p.filename || f.name || f.path ? g = n.basename(p.filename || f.name || f.path) : f.readable && f.hasOwnProperty("httpVersion") && (g = n.basename(f.client._httpMessage.path || "")), g && (b = 'filename="' + g + '"'), b;
  }, d.prototype._getContentType = function(f, p) {
    var g = p.contentType;
    return !g && f.name && (g = u.lookup(f.name)), !g && f.path && (g = u.lookup(f.path)), !g && f.readable && f.hasOwnProperty("httpVersion") && (g = f.headers["content-type"]), !g && (p.filepath || p.filename) && (g = u.lookup(p.filepath || p.filename)), !g && typeof f == "object" && (g = d.DEFAULT_CONTENT_TYPE), g;
  }, d.prototype._multiPartFooter = function() {
    return (function(f) {
      var p = d.LINE_BREAK, g = this._streams.length === 0;
      g && (p += this._lastBoundary()), f(p);
    }).bind(this);
  }, d.prototype._lastBoundary = function() {
    return "--" + this.getBoundary() + "--" + d.LINE_BREAK;
  }, d.prototype.getHeaders = function(f) {
    var p, g = {
      "content-type": "multipart/form-data; boundary=" + this.getBoundary()
    };
    for (p in f)
      f.hasOwnProperty(p) && (g[p.toLowerCase()] = f[p]);
    return g;
  }, d.prototype.setBoundary = function(f) {
    this._boundary = f;
  }, d.prototype.getBoundary = function() {
    return this._boundary || this._generateBoundary(), this._boundary;
  }, d.prototype.getBuffer = function() {
    for (var f = new qn.alloc(0), p = this.getBoundary(), g = 0, b = this._streams.length; g < b; g++)
      typeof this._streams[g] != "function" && (qn.isBuffer(this._streams[g]) ? f = qn.concat([f, this._streams[g]]) : f = qn.concat([f, qn.from(this._streams[g])]), (typeof this._streams[g] != "string" || this._streams[g].substring(2, p.length + 2) !== p) && (f = qn.concat([f, qn.from(d.LINE_BREAK)])));
    return qn.concat([f, qn.from(this._lastBoundary())]);
  }, d.prototype._generateBoundary = function() {
    for (var f = "--------------------------", p = 0; p < 24; p++)
      f += Math.floor(Math.random() * 10).toString(16);
    this._boundary = f;
  }, d.prototype.getLengthSync = function() {
    var f = this._overheadLength + this._valueLength;
    return this._streams.length && (f += this._lastBoundary().length), this.hasKnownLength() || this._error(new Error("Cannot calculate proper length in synchronous way.")), f;
  }, d.prototype.hasKnownLength = function() {
    var f = !0;
    return this._valuesToMeasure.length && (f = !1), f;
  }, d.prototype.getLength = function(f) {
    var p = this._overheadLength + this._valueLength;
    if (this._streams.length && (p += this._lastBoundary().length), !this._valuesToMeasure.length) {
      gn.nextTick(f.bind(this, null, p));
      return;
    }
    s.parallel(this._valuesToMeasure, this._lengthRetriever, function(g, b) {
      if (g) {
        f(g);
        return;
      }
      b.forEach(function(w) {
        p += w;
      }), f(null, p);
    });
  }, d.prototype.submit = function(f, p) {
    var g, b, w = { method: "post" };
    return typeof f == "string" ? (f = a(f), b = l({
      port: f.port,
      path: f.pathname,
      host: f.hostname,
      protocol: f.protocol
    }, w)) : (b = l(f, w), b.port || (b.port = b.protocol == "https:" ? 443 : 80)), b.headers = this.getHeaders(f.headers), b.protocol == "https:" ? g = i.request(b) : g = r.request(b), this.getLength((function(y, v) {
      if (y && y !== "Unknown stream") {
        this._error(y);
        return;
      }
      if (v && g.setHeader("Content-Length", v), this.pipe(g), p) {
        var _, E = function(O, M) {
          return g.removeListener("error", E), g.removeListener("response", _), p.call(this, O, M);
        };
        _ = E.bind(this, null), g.on("error", E), g.on("response", _);
      }
    }).bind(this)), g;
  }, d.prototype._error = function(f) {
    this.error || (this.error = f, this.pause(), this.emit("error", f));
  }, d.prototype.toString = function() {
    return "[object FormData]";
  }, w6;
}
var S6 = { exports: {} }, nC;
function Nie() {
  return nC || (nC = 1, (function(e) {
    var t = Object.create, n = Object.defineProperty, r = Object.defineProperties, i = Object.getOwnPropertyDescriptor, a = Object.getOwnPropertyDescriptors, o = Object.getOwnPropertyNames, c = Object.getOwnPropertySymbols, u = Object.getPrototypeOf, s = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable, d = Math.pow, f = (J, ne, De) => ne in J ? n(J, ne, { enumerable: !0, configurable: !0, writable: !0, value: De }) : J[ne] = De, p = (J, ne) => {
      for (var De in ne || (ne = {}))
        s.call(ne, De) && f(J, De, ne[De]);
      if (c)
        for (var De of c(ne))
          l.call(ne, De) && f(J, De, ne[De]);
      return J;
    }, g = (J, ne) => r(J, a(ne)), b = (J, ne) => function() {
      return ne || (0, J[o(J)[0]])((ne = { exports: {} }).exports, ne), ne.exports;
    }, w = (J, ne) => {
      for (var De in ne)
        n(J, De, { get: ne[De], enumerable: !0 });
    }, y = (J, ne, De, je) => {
      if (ne && typeof ne == "object" || typeof ne == "function")
        for (let Me of o(ne))
          !s.call(J, Me) && Me !== De && n(J, Me, { get: () => ne[Me], enumerable: !(je = i(ne, Me)) || je.enumerable });
      return J;
    }, v = (J, ne, De) => (De = J != null ? t(u(J)) : {}, y(
      !J || !J.__esModule ? n(De, "default", { value: J, enumerable: !0 }) : De,
      J
    )), _ = (J) => y(n({}, "__esModule", { value: !0 }), J), E = b({
      "node_modules/ajv-formats/dist/formats.js"(J) {
        Object.defineProperty(J, "__esModule", { value: !0 }), J.formatNames = J.fastFormats = J.fullFormats = void 0;
        function ne(Te, $) {
          return { validate: Te, compare: $ };
        }
        J.fullFormats = {
          date: ne(qe, Ve),
          time: ne(ve, Ae),
          "date-time": ne(qt, Ze),
          duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
          uri: Dt,
          "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
          "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
          url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
          email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
          hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
          ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
          ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
          regex: ie,
          uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
          "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
          "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
          "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
          byte: Xe,
          int32: { type: "number", validate: Yt },
          int64: { type: "number", validate: ye },
          float: { type: "number", validate: W },
          double: { type: "number", validate: W },
          password: !0,
          binary: !0
        }, J.fastFormats = g(p({}, J.fullFormats), {
          date: ne(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, Ve),
          time: ne(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, Ae),
          "date-time": ne(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, Ze),
          uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
          "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
          email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
        }), J.formatNames = Object.keys(J.fullFormats);
        function De(Te) {
          return Te % 4 === 0 && (Te % 100 !== 0 || Te % 400 === 0);
        }
        var je = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, Me = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function qe(Te) {
          const $ = je.exec(Te);
          if (!$)
            return !1;
          const _e = +$[1], Le = +$[2], et = +$[3];
          return Le >= 1 && Le <= 12 && et >= 1 && et <= (Le === 2 && De(_e) ? 29 : Me[Le]);
        }
        function Ve(Te, $) {
          if (Te && $)
            return Te > $ ? 1 : Te < $ ? -1 : 0;
        }
        var xe = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
        function ve(Te, $) {
          const _e = xe.exec(Te);
          if (!_e)
            return !1;
          const Le = +_e[1], et = +_e[2], Ge = +_e[3], $t = _e[5];
          return (Le <= 23 && et <= 59 && Ge <= 59 || Le === 23 && et === 59 && Ge === 60) && (!$ || $t !== "");
        }
        function Ae(Te, $) {
          if (!(Te && $))
            return;
          const _e = xe.exec(Te), Le = xe.exec($);
          if (_e && Le)
            return Te = _e[1] + _e[2] + _e[3] + (_e[4] || ""), $ = Le[1] + Le[2] + Le[3] + (Le[4] || ""), Te > $ ? 1 : Te < $ ? -1 : 0;
        }
        var Ue = /t|\s/i;
        function qt(Te) {
          const $ = Te.split(Ue);
          return $.length === 2 && qe($[0]) && ve($[1], !0);
        }
        function Ze(Te, $) {
          if (!(Te && $))
            return;
          const [_e, Le] = Te.split(Ue), [et, Ge] = $.split(Ue), $t = Ve(_e, et);
          if ($t !== void 0)
            return $t || Ae(Le, Ge);
        }
        var At = /\/|:/, He = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
        function Dt(Te) {
          return At.test(Te) && He.test(Te);
        }
        var Fe = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
        function Xe(Te) {
          return Fe.lastIndex = 0, Fe.test(Te);
        }
        var ze = -d(2, 31), Rt = d(2, 31) - 1;
        function Yt(Te) {
          return Number.isInteger(Te) && Te <= Rt && Te >= ze;
        }
        function ye(Te) {
          return Number.isInteger(Te);
        }
        function W() {
          return !0;
        }
        var Y = /[^\\]\\Z/;
        function ie(Te) {
          if (Y.test(Te))
            return !1;
          try {
            return new RegExp(Te), !0;
          } catch {
            return !1;
          }
        }
      }
    }), O = b({
      "src/validate.js"(J) {
        J["afterRequest.json"] = je;
        var ne = { $id: "afterRequest.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["lastAccess", "eTag", "hitCount"], properties: { expires: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, lastAccess: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, eTag: { type: "string" }, hitCount: { type: "integer" }, comment: { type: "string" } } }, De = new RegExp("^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", "u");
        function je(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.lastAccess === void 0 && (ee = "lastAccess") || A.eTag === void 0 && (ee = "eTag") || A.hitCount === void 0 && (ee = "hitCount"))
              return je.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: ne.required, parentSchema: ne, data: A }], !1;
            if (A.expires !== void 0) {
              let V = A.expires;
              const te = D;
              if (typeof V == "string") {
                if (!De.test(V))
                  return je.errors = [{ instancePath: I + "/expires", schemaPath: "#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: ne.properties.expires, data: V }], !1;
              } else
                return je.errors = [{ instancePath: I + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.expires.type, parentSchema: ne.properties.expires, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.lastAccess !== void 0) {
                let V = A.lastAccess;
                const te = D;
                if (typeof V == "string") {
                  if (!De.test(V))
                    return je.errors = [{ instancePath: I + "/lastAccess", schemaPath: "#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: ne.properties.lastAccess, data: V }], !1;
                } else
                  return je.errors = [{ instancePath: I + "/lastAccess", schemaPath: "#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.lastAccess.type, parentSchema: ne.properties.lastAccess, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B) {
                if (A.eTag !== void 0) {
                  let V = A.eTag;
                  const te = D;
                  if (typeof V != "string")
                    return je.errors = [{ instancePath: I + "/eTag", schemaPath: "#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.eTag.type, parentSchema: ne.properties.eTag, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.hitCount !== void 0) {
                    let V = A.hitCount;
                    const te = D;
                    if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                      return je.errors = [{ instancePath: I + "/hitCount", schemaPath: "#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: ne.properties.hitCount.type, parentSchema: ne.properties.hitCount, data: V }], !1;
                    var B = te === D;
                  } else
                    var B = !0;
                  if (B)
                    if (A.comment !== void 0) {
                      let V = A.comment;
                      const te = D;
                      if (typeof V != "string")
                        return je.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.comment.type, parentSchema: ne.properties.comment, data: V }], !1;
                      var B = te === D;
                    } else
                      var B = !0;
                }
              }
            }
          } else
            return je.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: ne.type, parentSchema: ne, data: A }], !1;
          return je.errors = U, D === 0;
        }
        J["beforeRequest.json"] = qe;
        var Me = { $id: "beforeRequest.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["lastAccess", "eTag", "hitCount"], properties: { expires: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, lastAccess: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, eTag: { type: "string" }, hitCount: { type: "integer" }, comment: { type: "string" } } };
        function qe(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.lastAccess === void 0 && (ee = "lastAccess") || A.eTag === void 0 && (ee = "eTag") || A.hitCount === void 0 && (ee = "hitCount"))
              return qe.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: Me.required, parentSchema: Me, data: A }], !1;
            if (A.expires !== void 0) {
              let V = A.expires;
              const te = D;
              if (typeof V == "string") {
                if (!De.test(V))
                  return qe.errors = [{ instancePath: I + "/expires", schemaPath: "#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Me.properties.expires, data: V }], !1;
              } else
                return qe.errors = [{ instancePath: I + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.expires.type, parentSchema: Me.properties.expires, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.lastAccess !== void 0) {
                let V = A.lastAccess;
                const te = D;
                if (typeof V == "string") {
                  if (!De.test(V))
                    return qe.errors = [{ instancePath: I + "/lastAccess", schemaPath: "#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Me.properties.lastAccess, data: V }], !1;
                } else
                  return qe.errors = [{ instancePath: I + "/lastAccess", schemaPath: "#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.lastAccess.type, parentSchema: Me.properties.lastAccess, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B) {
                if (A.eTag !== void 0) {
                  let V = A.eTag;
                  const te = D;
                  if (typeof V != "string")
                    return qe.errors = [{ instancePath: I + "/eTag", schemaPath: "#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.eTag.type, parentSchema: Me.properties.eTag, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.hitCount !== void 0) {
                    let V = A.hitCount;
                    const te = D;
                    if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                      return qe.errors = [{ instancePath: I + "/hitCount", schemaPath: "#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Me.properties.hitCount.type, parentSchema: Me.properties.hitCount, data: V }], !1;
                    var B = te === D;
                  } else
                    var B = !0;
                  if (B)
                    if (A.comment !== void 0) {
                      let V = A.comment;
                      const te = D;
                      if (typeof V != "string")
                        return qe.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.comment.type, parentSchema: Me.properties.comment, data: V }], !1;
                      var B = te === D;
                    } else
                      var B = !0;
                }
              }
            }
          } else
            return qe.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Me.type, parentSchema: Me, data: A }], !1;
          return qe.errors = U, D === 0;
        }
        J["browser.json"] = xe;
        var Ve = { $id: "browser.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "version"], properties: { name: { type: "string" }, version: { type: "string" }, comment: { type: "string" } } };
        function xe(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.name === void 0 && (ee = "name") || A.version === void 0 && (ee = "version"))
              return xe.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: Ve.required, parentSchema: Ve, data: A }], !1;
            if (A.name !== void 0) {
              let V = A.name;
              const te = D;
              if (typeof V != "string")
                return xe.errors = [{ instancePath: I + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ve.properties.name.type, parentSchema: Ve.properties.name, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.version !== void 0) {
                let V = A.version;
                const te = D;
                if (typeof V != "string")
                  return xe.errors = [{ instancePath: I + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ve.properties.version.type, parentSchema: Ve.properties.version, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B)
                if (A.comment !== void 0) {
                  let V = A.comment;
                  const te = D;
                  if (typeof V != "string")
                    return xe.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ve.properties.comment.type, parentSchema: Ve.properties.comment, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
            }
          } else
            return xe.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ve.type, parentSchema: Ve, data: A }], !1;
          return xe.errors = U, D === 0;
        }
        J["cache.json"] = Ae;
        var ve = { properties: { beforeRequest: { oneOf: [{ type: "null" }, { $ref: "beforeRequest.json#" }] }, afterRequest: { oneOf: [{ type: "null" }, { $ref: "afterRequest.json#" }] }, comment: { type: "string" } } };
        function Ae(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            if (A.beforeRequest !== void 0) {
              let ge = A.beforeRequest;
              const pe = D, se = D;
              let ce = !1, Oe = null;
              const fe = D;
              if (ge !== null) {
                const Ie = { instancePath: I + "/beforeRequest", schemaPath: "#/properties/beforeRequest/oneOf/0/type", keyword: "type", params: { type: "null" }, message: "must be null", schema: ve.properties.beforeRequest.oneOf[0].type, parentSchema: ve.properties.beforeRequest.oneOf[0], data: ge };
                U === null ? U = [Ie] : U.push(Ie), D++;
              }
              var ee = fe === D;
              ee && (ce = !0, Oe = 0);
              const be = D;
              if (D === D)
                if (ge && typeof ge == "object" && !Array.isArray(ge)) {
                  let Ie;
                  if (ge.lastAccess === void 0 && (Ie = "lastAccess") || ge.eTag === void 0 && (Ie = "eTag") || ge.hitCount === void 0 && (Ie = "hitCount")) {
                    const le = { instancePath: I + "/beforeRequest", schemaPath: "beforeRequest.json#/required", keyword: "required", params: { missingProperty: Ie }, message: "must have required property '" + Ie + "'", schema: Me.required, parentSchema: Me, data: ge };
                    U === null ? U = [le] : U.push(le), D++;
                  } else {
                    if (ge.expires !== void 0) {
                      let le = ge.expires;
                      const he = D;
                      if (D === he)
                        if (typeof le == "string") {
                          if (!De.test(le)) {
                            const we = { instancePath: I + "/beforeRequest/expires", schemaPath: "beforeRequest.json#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Me.properties.expires, data: le };
                            U === null ? U = [we] : U.push(we), D++;
                          }
                        } else {
                          const we = { instancePath: I + "/beforeRequest/expires", schemaPath: "beforeRequest.json#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.expires.type, parentSchema: Me.properties.expires, data: le };
                          U === null ? U = [we] : U.push(we), D++;
                        }
                      var B = he === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (ge.lastAccess !== void 0) {
                        let le = ge.lastAccess;
                        const he = D;
                        if (D === he)
                          if (typeof le == "string") {
                            if (!De.test(le)) {
                              const Re = { instancePath: I + "/beforeRequest/lastAccess", schemaPath: "beforeRequest.json#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Me.properties.lastAccess, data: le };
                              U === null ? U = [Re] : U.push(Re), D++;
                            }
                          } else {
                            const Re = { instancePath: I + "/beforeRequest/lastAccess", schemaPath: "beforeRequest.json#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.lastAccess.type, parentSchema: Me.properties.lastAccess, data: le };
                            U === null ? U = [Re] : U.push(Re), D++;
                          }
                        var B = he === D;
                      } else
                        var B = !0;
                      if (B) {
                        if (ge.eTag !== void 0) {
                          let le = ge.eTag;
                          const he = D;
                          if (typeof le != "string") {
                            const Re = { instancePath: I + "/beforeRequest/eTag", schemaPath: "beforeRequest.json#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.eTag.type, parentSchema: Me.properties.eTag, data: le };
                            U === null ? U = [Re] : U.push(Re), D++;
                          }
                          var B = he === D;
                        } else
                          var B = !0;
                        if (B) {
                          if (ge.hitCount !== void 0) {
                            let le = ge.hitCount;
                            const he = D;
                            if (!(typeof le == "number" && !(le % 1) && !isNaN(le))) {
                              const Re = { instancePath: I + "/beforeRequest/hitCount", schemaPath: "beforeRequest.json#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Me.properties.hitCount.type, parentSchema: Me.properties.hitCount, data: le };
                              U === null ? U = [Re] : U.push(Re), D++;
                            }
                            var B = he === D;
                          } else
                            var B = !0;
                          if (B)
                            if (ge.comment !== void 0) {
                              let le = ge.comment;
                              const he = D;
                              if (typeof le != "string") {
                                const Re = { instancePath: I + "/beforeRequest/comment", schemaPath: "beforeRequest.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.comment.type, parentSchema: Me.properties.comment, data: le };
                                U === null ? U = [Re] : U.push(Re), D++;
                              }
                              var B = he === D;
                            } else
                              var B = !0;
                        }
                      }
                    }
                  }
                } else {
                  const Ie = { instancePath: I + "/beforeRequest", schemaPath: "beforeRequest.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Me.type, parentSchema: Me, data: ge };
                  U === null ? U = [Ie] : U.push(Ie), D++;
                }
              var ee = be === D;
              if (ee && ce ? (ce = !1, Oe = [Oe, 1]) : ee && (ce = !0, Oe = 1), ce)
                D = se, U !== null && (se ? U.length = se : U = null);
              else {
                const Ie = { instancePath: I + "/beforeRequest", schemaPath: "#/properties/beforeRequest/oneOf", keyword: "oneOf", params: { passingSchemas: Oe }, message: "must match exactly one schema in oneOf", schema: ve.properties.beforeRequest.oneOf, parentSchema: ve.properties.beforeRequest, data: ge };
                return U === null ? U = [Ie] : U.push(Ie), D++, Ae.errors = U, !1;
              }
              var V = pe === D;
            } else
              var V = !0;
            if (V) {
              if (A.afterRequest !== void 0) {
                let ge = A.afterRequest;
                const pe = D, se = D;
                let ce = !1, Oe = null;
                const fe = D;
                if (ge !== null) {
                  const le = { instancePath: I + "/afterRequest", schemaPath: "#/properties/afterRequest/oneOf/0/type", keyword: "type", params: { type: "null" }, message: "must be null", schema: ve.properties.afterRequest.oneOf[0].type, parentSchema: ve.properties.afterRequest.oneOf[0], data: ge };
                  U === null ? U = [le] : U.push(le), D++;
                }
                var ue = fe === D;
                ue && (ce = !0, Oe = 0);
                const be = D;
                if (D === D)
                  if (ge && typeof ge == "object" && !Array.isArray(ge)) {
                    let le;
                    if (ge.lastAccess === void 0 && (le = "lastAccess") || ge.eTag === void 0 && (le = "eTag") || ge.hitCount === void 0 && (le = "hitCount")) {
                      const he = { instancePath: I + "/afterRequest", schemaPath: "afterRequest.json#/required", keyword: "required", params: { missingProperty: le }, message: "must have required property '" + le + "'", schema: ne.required, parentSchema: ne, data: ge };
                      U === null ? U = [he] : U.push(he), D++;
                    } else {
                      if (ge.expires !== void 0) {
                        let he = ge.expires;
                        const we = D;
                        if (D === we)
                          if (typeof he == "string") {
                            if (!De.test(he)) {
                              const Re = { instancePath: I + "/afterRequest/expires", schemaPath: "afterRequest.json#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: ne.properties.expires, data: he };
                              U === null ? U = [Re] : U.push(Re), D++;
                            }
                          } else {
                            const Re = { instancePath: I + "/afterRequest/expires", schemaPath: "afterRequest.json#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.expires.type, parentSchema: ne.properties.expires, data: he };
                            U === null ? U = [Re] : U.push(Re), D++;
                          }
                        var te = we === D;
                      } else
                        var te = !0;
                      if (te) {
                        if (ge.lastAccess !== void 0) {
                          let he = ge.lastAccess;
                          const we = D;
                          if (D === we)
                            if (typeof he == "string") {
                              if (!De.test(he)) {
                                const Pe = { instancePath: I + "/afterRequest/lastAccess", schemaPath: "afterRequest.json#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: ne.properties.lastAccess, data: he };
                                U === null ? U = [Pe] : U.push(Pe), D++;
                              }
                            } else {
                              const Pe = { instancePath: I + "/afterRequest/lastAccess", schemaPath: "afterRequest.json#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.lastAccess.type, parentSchema: ne.properties.lastAccess, data: he };
                              U === null ? U = [Pe] : U.push(Pe), D++;
                            }
                          var te = we === D;
                        } else
                          var te = !0;
                        if (te) {
                          if (ge.eTag !== void 0) {
                            let he = ge.eTag;
                            const we = D;
                            if (typeof he != "string") {
                              const Pe = { instancePath: I + "/afterRequest/eTag", schemaPath: "afterRequest.json#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.eTag.type, parentSchema: ne.properties.eTag, data: he };
                              U === null ? U = [Pe] : U.push(Pe), D++;
                            }
                            var te = we === D;
                          } else
                            var te = !0;
                          if (te) {
                            if (ge.hitCount !== void 0) {
                              let he = ge.hitCount;
                              const we = D;
                              if (!(typeof he == "number" && !(he % 1) && !isNaN(he))) {
                                const Pe = { instancePath: I + "/afterRequest/hitCount", schemaPath: "afterRequest.json#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: ne.properties.hitCount.type, parentSchema: ne.properties.hitCount, data: he };
                                U === null ? U = [Pe] : U.push(Pe), D++;
                              }
                              var te = we === D;
                            } else
                              var te = !0;
                            if (te)
                              if (ge.comment !== void 0) {
                                let he = ge.comment;
                                const we = D;
                                if (typeof he != "string") {
                                  const Pe = { instancePath: I + "/afterRequest/comment", schemaPath: "afterRequest.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ne.properties.comment.type, parentSchema: ne.properties.comment, data: he };
                                  U === null ? U = [Pe] : U.push(Pe), D++;
                                }
                                var te = we === D;
                              } else
                                var te = !0;
                          }
                        }
                      }
                    }
                  } else {
                    const le = { instancePath: I + "/afterRequest", schemaPath: "afterRequest.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: ne.type, parentSchema: ne, data: ge };
                    U === null ? U = [le] : U.push(le), D++;
                  }
                var ue = be === D;
                if (ue && ce ? (ce = !1, Oe = [Oe, 1]) : ue && (ce = !0, Oe = 1), ce)
                  D = se, U !== null && (se ? U.length = se : U = null);
                else {
                  const le = { instancePath: I + "/afterRequest", schemaPath: "#/properties/afterRequest/oneOf", keyword: "oneOf", params: { passingSchemas: Oe }, message: "must match exactly one schema in oneOf", schema: ve.properties.afterRequest.oneOf, parentSchema: ve.properties.afterRequest, data: ge };
                  return U === null ? U = [le] : U.push(le), D++, Ae.errors = U, !1;
                }
                var V = pe === D;
              } else
                var V = !0;
              if (V)
                if (A.comment !== void 0) {
                  let ge = A.comment;
                  const pe = D;
                  if (typeof ge != "string")
                    return Ae.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ve.properties.comment.type, parentSchema: ve.properties.comment, data: ge }], !1;
                  var V = pe === D;
                } else
                  var V = !0;
            }
          }
          return Ae.errors = U, D === 0;
        }
        J["content.json"] = qt;
        var Ue = { $id: "content.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["size", "mimeType"], properties: { size: { type: "integer" }, compression: { type: "integer" }, mimeType: { type: "string" }, text: { type: "string" }, encoding: { type: "string" }, comment: { type: "string" } } };
        function qt(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.size === void 0 && (ee = "size") || A.mimeType === void 0 && (ee = "mimeType"))
              return qt.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: Ue.required, parentSchema: Ue, data: A }], !1;
            if (A.size !== void 0) {
              let V = A.size;
              const te = D;
              if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                return qt.errors = [{ instancePath: I + "/size", schemaPath: "#/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ue.properties.size.type, parentSchema: Ue.properties.size, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.compression !== void 0) {
                let V = A.compression;
                const te = D;
                if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                  return qt.errors = [{ instancePath: I + "/compression", schemaPath: "#/properties/compression/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ue.properties.compression.type, parentSchema: Ue.properties.compression, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B) {
                if (A.mimeType !== void 0) {
                  let V = A.mimeType;
                  const te = D;
                  if (typeof V != "string")
                    return qt.errors = [{ instancePath: I + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.mimeType.type, parentSchema: Ue.properties.mimeType, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.text !== void 0) {
                    let V = A.text;
                    const te = D;
                    if (typeof V != "string")
                      return qt.errors = [{ instancePath: I + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.text.type, parentSchema: Ue.properties.text, data: V }], !1;
                    var B = te === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.encoding !== void 0) {
                      let V = A.encoding;
                      const te = D;
                      if (typeof V != "string")
                        return qt.errors = [{ instancePath: I + "/encoding", schemaPath: "#/properties/encoding/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.encoding.type, parentSchema: Ue.properties.encoding, data: V }], !1;
                      var B = te === D;
                    } else
                      var B = !0;
                    if (B)
                      if (A.comment !== void 0) {
                        let V = A.comment;
                        const te = D;
                        if (typeof V != "string")
                          return qt.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.comment.type, parentSchema: Ue.properties.comment, data: V }], !1;
                        var B = te === D;
                      } else
                        var B = !0;
                  }
                }
              }
            }
          } else
            return qt.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ue.type, parentSchema: Ue, data: A }], !1;
          return qt.errors = U, D === 0;
        }
        J["cookie.json"] = He;
        var Ze = { $id: "cookie.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "value"], properties: { name: { type: "string" }, value: { type: "string" }, path: { type: "string" }, domain: { type: "string" }, expires: { type: ["string", "null"], format: "date-time" }, httpOnly: { type: "boolean" }, secure: { type: "boolean" }, comment: { type: "string" } } }, At = E().fullFormats["date-time"];
        function He(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.name === void 0 && (ee = "name") || A.value === void 0 && (ee = "value"))
              return He.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: Ze.required, parentSchema: Ze, data: A }], !1;
            if (A.name !== void 0) {
              let V = A.name;
              const te = D;
              if (typeof V != "string")
                return He.errors = [{ instancePath: I + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.name.type, parentSchema: Ze.properties.name, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.value !== void 0) {
                let V = A.value;
                const te = D;
                if (typeof V != "string")
                  return He.errors = [{ instancePath: I + "/value", schemaPath: "#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.value.type, parentSchema: Ze.properties.value, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B) {
                if (A.path !== void 0) {
                  let V = A.path;
                  const te = D;
                  if (typeof V != "string")
                    return He.errors = [{ instancePath: I + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.path.type, parentSchema: Ze.properties.path, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.domain !== void 0) {
                    let V = A.domain;
                    const te = D;
                    if (typeof V != "string")
                      return He.errors = [{ instancePath: I + "/domain", schemaPath: "#/properties/domain/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.domain.type, parentSchema: Ze.properties.domain, data: V }], !1;
                    var B = te === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.expires !== void 0) {
                      let V = A.expires;
                      const te = D;
                      if (typeof V != "string" && V !== null)
                        return He.errors = [{ instancePath: I + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: Ze.properties.expires.type }, message: "must be string,null", schema: Ze.properties.expires.type, parentSchema: Ze.properties.expires, data: V }], !1;
                      if (typeof V == "string" && !At.validate(V))
                        return He.errors = [{ instancePath: I + "/expires", schemaPath: "#/properties/expires/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Ze.properties.expires, data: V }], !1;
                      var B = te === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (A.httpOnly !== void 0) {
                        let V = A.httpOnly;
                        const te = D;
                        if (typeof V != "boolean")
                          return He.errors = [{ instancePath: I + "/httpOnly", schemaPath: "#/properties/httpOnly/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Ze.properties.httpOnly.type, parentSchema: Ze.properties.httpOnly, data: V }], !1;
                        var B = te === D;
                      } else
                        var B = !0;
                      if (B) {
                        if (A.secure !== void 0) {
                          let V = A.secure;
                          const te = D;
                          if (typeof V != "boolean")
                            return He.errors = [{ instancePath: I + "/secure", schemaPath: "#/properties/secure/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Ze.properties.secure.type, parentSchema: Ze.properties.secure, data: V }], !1;
                          var B = te === D;
                        } else
                          var B = !0;
                        if (B)
                          if (A.comment !== void 0) {
                            let V = A.comment;
                            const te = D;
                            if (typeof V != "string")
                              return He.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.comment.type, parentSchema: Ze.properties.comment, data: V }], !1;
                            var B = te === D;
                          } else
                            var B = !0;
                      }
                    }
                  }
                }
              }
            }
          } else
            return He.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ze.type, parentSchema: Ze, data: A }], !1;
          return He.errors = U, D === 0;
        }
        J["creator.json"] = Fe;
        var Dt = { $id: "creator.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "version"], properties: { name: { type: "string" }, version: { type: "string" }, comment: { type: "string" } } };
        function Fe(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.name === void 0 && (ee = "name") || A.version === void 0 && (ee = "version"))
              return Fe.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: Dt.required, parentSchema: Dt, data: A }], !1;
            if (A.name !== void 0) {
              let V = A.name;
              const te = D;
              if (typeof V != "string")
                return Fe.errors = [{ instancePath: I + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Dt.properties.name.type, parentSchema: Dt.properties.name, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.version !== void 0) {
                let V = A.version;
                const te = D;
                if (typeof V != "string")
                  return Fe.errors = [{ instancePath: I + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Dt.properties.version.type, parentSchema: Dt.properties.version, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B)
                if (A.comment !== void 0) {
                  let V = A.comment;
                  const te = D;
                  if (typeof V != "string")
                    return Fe.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Dt.properties.comment.type, parentSchema: Dt.properties.comment, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
            }
          } else
            return Fe.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Dt.type, parentSchema: Dt, data: A }], !1;
          return Fe.errors = U, D === 0;
        }
        J["entry.json"] = Ge;
        var Xe = { $id: "entry.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["startedDateTime", "time", "request", "response", "cache", "timings"], properties: { pageref: { type: "string" }, startedDateTime: { type: "string", format: "date-time", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, time: { type: "number", min: 0 }, request: { $ref: "request.json#" }, response: { $ref: "response.json#" }, cache: { $ref: "cache.json#" }, timings: { $ref: "timings.json#" }, serverIPAddress: { type: "string", oneOf: [{ format: "ipv4" }, { format: "ipv6" }] }, connection: { type: "string" }, comment: { type: "string" } } }, ze = { $id: "timings.json#", $schema: "http://json-schema.org/draft-06/schema#", required: ["send", "wait", "receive"], properties: { dns: { type: "number", min: -1 }, connect: { type: "number", min: -1 }, blocked: { type: "number", min: -1 }, send: { type: "number", min: -1 }, wait: { type: "number", min: -1 }, receive: { type: "number", min: -1 }, ssl: { type: "number", min: -1 }, comment: { type: "string" } } }, Rt = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, Yt = /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i, ye = new RegExp("^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))", "u"), W = { $id: "request.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["method", "url", "httpVersion", "cookies", "headers", "queryString", "headersSize", "bodySize"], properties: { method: { type: "string" }, url: { type: "string", format: "uri" }, httpVersion: { type: "string" }, cookies: { type: "array", items: { $ref: "cookie.json#" } }, headers: { type: "array", items: { $ref: "header.json#" } }, queryString: { type: "array", items: { $ref: "query.json#" } }, postData: { $ref: "postData.json#" }, headersSize: { type: "integer" }, bodySize: { type: "integer" }, comment: { type: "string" } } }, Y = { $id: "header.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "value"], properties: { name: { type: "string" }, value: { type: "string" }, comment: { type: "string" } } }, ie = { $id: "query.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "value"], properties: { name: { type: "string" }, value: { type: "string" }, comment: { type: "string" } } }, Te = { $id: "postData.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["mimeType"], properties: { mimeType: { type: "string" }, text: { type: "string" }, params: { type: "array", required: ["name"], properties: { name: { type: "string" }, value: { type: "string" }, fileName: { type: "string" }, contentType: { type: "string" }, comment: { type: "string" } } }, comment: { type: "string" } } }, $ = E().fullFormats.uri;
        function _e(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let Oe;
            if (A.method === void 0 && (Oe = "method") || A.url === void 0 && (Oe = "url") || A.httpVersion === void 0 && (Oe = "httpVersion") || A.cookies === void 0 && (Oe = "cookies") || A.headers === void 0 && (Oe = "headers") || A.queryString === void 0 && (Oe = "queryString") || A.headersSize === void 0 && (Oe = "headersSize") || A.bodySize === void 0 && (Oe = "bodySize"))
              return _e.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: Oe }, message: "must have required property '" + Oe + "'", schema: W.required, parentSchema: W, data: A }], !1;
            if (A.method !== void 0) {
              let fe = A.method;
              const be = D;
              if (typeof fe != "string")
                return _e.errors = [{ instancePath: I + "/method", schemaPath: "#/properties/method/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: W.properties.method.type, parentSchema: W.properties.method, data: fe }], !1;
              var B = be === D;
            } else
              var B = !0;
            if (B) {
              if (A.url !== void 0) {
                let fe = A.url;
                const be = D;
                if (typeof fe == "string") {
                  if (!$(fe))
                    return _e.errors = [{ instancePath: I + "/url", schemaPath: "#/properties/url/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"', schema: "uri", parentSchema: W.properties.url, data: fe }], !1;
                } else
                  return _e.errors = [{ instancePath: I + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: W.properties.url.type, parentSchema: W.properties.url, data: fe }], !1;
                var B = be === D;
              } else
                var B = !0;
              if (B) {
                if (A.httpVersion !== void 0) {
                  let fe = A.httpVersion;
                  const be = D;
                  if (typeof fe != "string")
                    return _e.errors = [{ instancePath: I + "/httpVersion", schemaPath: "#/properties/httpVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: W.properties.httpVersion.type, parentSchema: W.properties.httpVersion, data: fe }], !1;
                  var B = be === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.cookies !== void 0) {
                    let fe = A.cookies;
                    const be = D;
                    if (Array.isArray(fe)) {
                      var ee = !0;
                      const Ie = fe.length;
                      for (let le = 0; le < Ie; le++) {
                        let he = fe[le];
                        const we = D;
                        if (he && typeof he == "object" && !Array.isArray(he)) {
                          let Pe;
                          if (he.name === void 0 && (Pe = "name") || he.value === void 0 && (Pe = "value"))
                            return _e.errors = [{ instancePath: I + "/cookies/" + le, schemaPath: "cookie.json#/required", keyword: "required", params: { missingProperty: Pe }, message: "must have required property '" + Pe + "'", schema: Ze.required, parentSchema: Ze, data: he }], !1;
                          if (he.name !== void 0) {
                            let $e = he.name;
                            const We = D;
                            if (typeof $e != "string")
                              return _e.errors = [{ instancePath: I + "/cookies/" + le + "/name", schemaPath: "cookie.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.name.type, parentSchema: Ze.properties.name, data: $e }], !1;
                            var V = We === D;
                          } else
                            var V = !0;
                          if (V) {
                            if (he.value !== void 0) {
                              let $e = he.value;
                              const We = D;
                              if (typeof $e != "string")
                                return _e.errors = [{ instancePath: I + "/cookies/" + le + "/value", schemaPath: "cookie.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.value.type, parentSchema: Ze.properties.value, data: $e }], !1;
                              var V = We === D;
                            } else
                              var V = !0;
                            if (V) {
                              if (he.path !== void 0) {
                                let $e = he.path;
                                const We = D;
                                if (typeof $e != "string")
                                  return _e.errors = [{ instancePath: I + "/cookies/" + le + "/path", schemaPath: "cookie.json#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.path.type, parentSchema: Ze.properties.path, data: $e }], !1;
                                var V = We === D;
                              } else
                                var V = !0;
                              if (V) {
                                if (he.domain !== void 0) {
                                  let $e = he.domain;
                                  const We = D;
                                  if (typeof $e != "string")
                                    return _e.errors = [{ instancePath: I + "/cookies/" + le + "/domain", schemaPath: "cookie.json#/properties/domain/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.domain.type, parentSchema: Ze.properties.domain, data: $e }], !1;
                                  var V = We === D;
                                } else
                                  var V = !0;
                                if (V) {
                                  if (he.expires !== void 0) {
                                    let $e = he.expires;
                                    const We = D;
                                    if (typeof $e != "string" && $e !== null)
                                      return _e.errors = [{ instancePath: I + "/cookies/" + le + "/expires", schemaPath: "cookie.json#/properties/expires/type", keyword: "type", params: { type: Ze.properties.expires.type }, message: "must be string,null", schema: Ze.properties.expires.type, parentSchema: Ze.properties.expires, data: $e }], !1;
                                    if (typeof $e == "string" && !At.validate($e))
                                      return _e.errors = [{ instancePath: I + "/cookies/" + le + "/expires", schemaPath: "cookie.json#/properties/expires/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Ze.properties.expires, data: $e }], !1;
                                    var V = We === D;
                                  } else
                                    var V = !0;
                                  if (V) {
                                    if (he.httpOnly !== void 0) {
                                      let $e = he.httpOnly;
                                      const We = D;
                                      if (typeof $e != "boolean")
                                        return _e.errors = [{ instancePath: I + "/cookies/" + le + "/httpOnly", schemaPath: "cookie.json#/properties/httpOnly/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Ze.properties.httpOnly.type, parentSchema: Ze.properties.httpOnly, data: $e }], !1;
                                      var V = We === D;
                                    } else
                                      var V = !0;
                                    if (V) {
                                      if (he.secure !== void 0) {
                                        let $e = he.secure;
                                        const We = D;
                                        if (typeof $e != "boolean")
                                          return _e.errors = [{ instancePath: I + "/cookies/" + le + "/secure", schemaPath: "cookie.json#/properties/secure/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Ze.properties.secure.type, parentSchema: Ze.properties.secure, data: $e }], !1;
                                        var V = We === D;
                                      } else
                                        var V = !0;
                                      if (V)
                                        if (he.comment !== void 0) {
                                          let $e = he.comment;
                                          const We = D;
                                          if (typeof $e != "string")
                                            return _e.errors = [{ instancePath: I + "/cookies/" + le + "/comment", schemaPath: "cookie.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.comment.type, parentSchema: Ze.properties.comment, data: $e }], !1;
                                          var V = We === D;
                                        } else
                                          var V = !0;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else
                          return _e.errors = [{ instancePath: I + "/cookies/" + le, schemaPath: "cookie.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ze.type, parentSchema: Ze, data: he }], !1;
                        var ee = we === D;
                        if (!ee)
                          break;
                      }
                    } else
                      return _e.errors = [{ instancePath: I + "/cookies", schemaPath: "#/properties/cookies/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: W.properties.cookies.type, parentSchema: W.properties.cookies, data: fe }], !1;
                    var B = be === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.headers !== void 0) {
                      let fe = A.headers;
                      const be = D;
                      if (Array.isArray(fe)) {
                        var te = !0;
                        const Ie = fe.length;
                        for (let le = 0; le < Ie; le++) {
                          let he = fe[le];
                          const we = D;
                          if (he && typeof he == "object" && !Array.isArray(he)) {
                            let Pe;
                            if (he.name === void 0 && (Pe = "name") || he.value === void 0 && (Pe = "value"))
                              return _e.errors = [{ instancePath: I + "/headers/" + le, schemaPath: "header.json#/required", keyword: "required", params: { missingProperty: Pe }, message: "must have required property '" + Pe + "'", schema: Y.required, parentSchema: Y, data: he }], !1;
                            if (he.name !== void 0) {
                              let $e = he.name;
                              const We = D;
                              if (typeof $e != "string")
                                return _e.errors = [{ instancePath: I + "/headers/" + le + "/name", schemaPath: "header.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.name.type, parentSchema: Y.properties.name, data: $e }], !1;
                              var ue = We === D;
                            } else
                              var ue = !0;
                            if (ue) {
                              if (he.value !== void 0) {
                                let $e = he.value;
                                const We = D;
                                if (typeof $e != "string")
                                  return _e.errors = [{ instancePath: I + "/headers/" + le + "/value", schemaPath: "header.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.value.type, parentSchema: Y.properties.value, data: $e }], !1;
                                var ue = We === D;
                              } else
                                var ue = !0;
                              if (ue)
                                if (he.comment !== void 0) {
                                  let $e = he.comment;
                                  const We = D;
                                  if (typeof $e != "string")
                                    return _e.errors = [{ instancePath: I + "/headers/" + le + "/comment", schemaPath: "header.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.comment.type, parentSchema: Y.properties.comment, data: $e }], !1;
                                  var ue = We === D;
                                } else
                                  var ue = !0;
                            }
                          } else
                            return _e.errors = [{ instancePath: I + "/headers/" + le, schemaPath: "header.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Y.type, parentSchema: Y, data: he }], !1;
                          var te = we === D;
                          if (!te)
                            break;
                        }
                      } else
                        return _e.errors = [{ instancePath: I + "/headers", schemaPath: "#/properties/headers/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: W.properties.headers.type, parentSchema: W.properties.headers, data: fe }], !1;
                      var B = be === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (A.queryString !== void 0) {
                        let fe = A.queryString;
                        const be = D;
                        if (Array.isArray(fe)) {
                          var ge = !0;
                          const Ie = fe.length;
                          for (let le = 0; le < Ie; le++) {
                            let he = fe[le];
                            const we = D;
                            if (he && typeof he == "object" && !Array.isArray(he)) {
                              let Pe;
                              if (he.name === void 0 && (Pe = "name") || he.value === void 0 && (Pe = "value"))
                                return _e.errors = [{ instancePath: I + "/queryString/" + le, schemaPath: "query.json#/required", keyword: "required", params: { missingProperty: Pe }, message: "must have required property '" + Pe + "'", schema: ie.required, parentSchema: ie, data: he }], !1;
                              if (he.name !== void 0) {
                                let $e = he.name;
                                const We = D;
                                if (typeof $e != "string")
                                  return _e.errors = [{ instancePath: I + "/queryString/" + le + "/name", schemaPath: "query.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ie.properties.name.type, parentSchema: ie.properties.name, data: $e }], !1;
                                var pe = We === D;
                              } else
                                var pe = !0;
                              if (pe) {
                                if (he.value !== void 0) {
                                  let $e = he.value;
                                  const We = D;
                                  if (typeof $e != "string")
                                    return _e.errors = [{ instancePath: I + "/queryString/" + le + "/value", schemaPath: "query.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ie.properties.value.type, parentSchema: ie.properties.value, data: $e }], !1;
                                  var pe = We === D;
                                } else
                                  var pe = !0;
                                if (pe)
                                  if (he.comment !== void 0) {
                                    let $e = he.comment;
                                    const We = D;
                                    if (typeof $e != "string")
                                      return _e.errors = [{ instancePath: I + "/queryString/" + le + "/comment", schemaPath: "query.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ie.properties.comment.type, parentSchema: ie.properties.comment, data: $e }], !1;
                                    var pe = We === D;
                                  } else
                                    var pe = !0;
                              }
                            } else
                              return _e.errors = [{ instancePath: I + "/queryString/" + le, schemaPath: "query.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: ie.type, parentSchema: ie, data: he }], !1;
                            var ge = we === D;
                            if (!ge)
                              break;
                          }
                        } else
                          return _e.errors = [{ instancePath: I + "/queryString", schemaPath: "#/properties/queryString/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: W.properties.queryString.type, parentSchema: W.properties.queryString, data: fe }], !1;
                        var B = be === D;
                      } else
                        var B = !0;
                      if (B) {
                        if (A.postData !== void 0) {
                          let fe = A.postData;
                          const be = D;
                          if (fe && typeof fe == "object" && !Array.isArray(fe)) {
                            let Ie;
                            if (fe.mimeType === void 0 && (Ie = "mimeType"))
                              return _e.errors = [{ instancePath: I + "/postData", schemaPath: "postData.json#/required", keyword: "required", params: { missingProperty: Ie }, message: "must have required property '" + Ie + "'", schema: Te.required, parentSchema: Te, data: fe }], !1;
                            if (fe.mimeType !== void 0) {
                              let le = fe.mimeType;
                              const he = D;
                              if (typeof le != "string")
                                return _e.errors = [{ instancePath: I + "/postData/mimeType", schemaPath: "postData.json#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.mimeType.type, parentSchema: Te.properties.mimeType, data: le }], !1;
                              var se = he === D;
                            } else
                              var se = !0;
                            if (se) {
                              if (fe.text !== void 0) {
                                let le = fe.text;
                                const he = D;
                                if (typeof le != "string")
                                  return _e.errors = [{ instancePath: I + "/postData/text", schemaPath: "postData.json#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.text.type, parentSchema: Te.properties.text, data: le }], !1;
                                var se = he === D;
                              } else
                                var se = !0;
                              if (se) {
                                if (fe.params !== void 0) {
                                  let le = fe.params;
                                  const he = D;
                                  if (!Array.isArray(le))
                                    return _e.errors = [{ instancePath: I + "/postData/params", schemaPath: "postData.json#/properties/params/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Te.properties.params.type, parentSchema: Te.properties.params, data: le }], !1;
                                  if (le && typeof le == "object" && !Array.isArray(le)) {
                                    let Re;
                                    if (le.name === void 0 && (Re = "name"))
                                      return _e.errors = [{ instancePath: I + "/postData/params", schemaPath: "postData.json#/properties/params/required", keyword: "required", params: { missingProperty: Re }, message: "must have required property '" + Re + "'", schema: Te.properties.params.required, parentSchema: Te.properties.params, data: le }], !1;
                                    if (le.name !== void 0) {
                                      let Pe = le.name;
                                      const $e = D;
                                      if (typeof Pe != "string")
                                        return _e.errors = [{ instancePath: I + "/postData/params/name", schemaPath: "postData.json#/properties/params/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.name.type, parentSchema: Te.properties.params.properties.name, data: Pe }], !1;
                                      var ce = $e === D;
                                    } else
                                      var ce = !0;
                                    if (ce) {
                                      if (le.value !== void 0) {
                                        let Pe = le.value;
                                        const $e = D;
                                        if (typeof Pe != "string")
                                          return _e.errors = [{ instancePath: I + "/postData/params/value", schemaPath: "postData.json#/properties/params/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.value.type, parentSchema: Te.properties.params.properties.value, data: Pe }], !1;
                                        var ce = $e === D;
                                      } else
                                        var ce = !0;
                                      if (ce) {
                                        if (le.fileName !== void 0) {
                                          let Pe = le.fileName;
                                          const $e = D;
                                          if (typeof Pe != "string")
                                            return _e.errors = [{ instancePath: I + "/postData/params/fileName", schemaPath: "postData.json#/properties/params/properties/fileName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.fileName.type, parentSchema: Te.properties.params.properties.fileName, data: Pe }], !1;
                                          var ce = $e === D;
                                        } else
                                          var ce = !0;
                                        if (ce) {
                                          if (le.contentType !== void 0) {
                                            let Pe = le.contentType;
                                            const $e = D;
                                            if (typeof Pe != "string")
                                              return _e.errors = [{ instancePath: I + "/postData/params/contentType", schemaPath: "postData.json#/properties/params/properties/contentType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.contentType.type, parentSchema: Te.properties.params.properties.contentType, data: Pe }], !1;
                                            var ce = $e === D;
                                          } else
                                            var ce = !0;
                                          if (ce)
                                            if (le.comment !== void 0) {
                                              let Pe = le.comment;
                                              const $e = D;
                                              if (typeof Pe != "string")
                                                return _e.errors = [{ instancePath: I + "/postData/params/comment", schemaPath: "postData.json#/properties/params/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.comment.type, parentSchema: Te.properties.params.properties.comment, data: Pe }], !1;
                                              var ce = $e === D;
                                            } else
                                              var ce = !0;
                                        }
                                      }
                                    }
                                  }
                                  var se = he === D;
                                } else
                                  var se = !0;
                                if (se)
                                  if (fe.comment !== void 0) {
                                    let le = fe.comment;
                                    const he = D;
                                    if (typeof le != "string")
                                      return _e.errors = [{ instancePath: I + "/postData/comment", schemaPath: "postData.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.comment.type, parentSchema: Te.properties.comment, data: le }], !1;
                                    var se = he === D;
                                  } else
                                    var se = !0;
                              }
                            }
                          } else
                            return _e.errors = [{ instancePath: I + "/postData", schemaPath: "postData.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Te.type, parentSchema: Te, data: fe }], !1;
                          var B = be === D;
                        } else
                          var B = !0;
                        if (B) {
                          if (A.headersSize !== void 0) {
                            let fe = A.headersSize;
                            const be = D;
                            if (!(typeof fe == "number" && !(fe % 1) && !isNaN(fe)))
                              return _e.errors = [{ instancePath: I + "/headersSize", schemaPath: "#/properties/headersSize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: W.properties.headersSize.type, parentSchema: W.properties.headersSize, data: fe }], !1;
                            var B = be === D;
                          } else
                            var B = !0;
                          if (B) {
                            if (A.bodySize !== void 0) {
                              let fe = A.bodySize;
                              const be = D;
                              if (!(typeof fe == "number" && !(fe % 1) && !isNaN(fe)))
                                return _e.errors = [{ instancePath: I + "/bodySize", schemaPath: "#/properties/bodySize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: W.properties.bodySize.type, parentSchema: W.properties.bodySize, data: fe }], !1;
                              var B = be === D;
                            } else
                              var B = !0;
                            if (B)
                              if (A.comment !== void 0) {
                                let fe = A.comment;
                                const be = D;
                                if (typeof fe != "string")
                                  return _e.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: W.properties.comment.type, parentSchema: W.properties.comment, data: fe }], !1;
                                var B = be === D;
                              } else
                                var B = !0;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else
            return _e.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: W.type, parentSchema: W, data: A }], !1;
          return _e.errors = U, D === 0;
        }
        var Le = { $id: "response.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["status", "statusText", "httpVersion", "cookies", "headers", "content", "redirectURL", "headersSize", "bodySize"], properties: { status: { type: "integer" }, statusText: { type: "string" }, httpVersion: { type: "string" }, cookies: { type: "array", items: { $ref: "cookie.json#" } }, headers: { type: "array", items: { $ref: "header.json#" } }, content: { $ref: "content.json#" }, redirectURL: { type: "string" }, headersSize: { type: "integer" }, bodySize: { type: "integer" }, comment: { type: "string" } } };
        function et(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let pe;
            if (A.status === void 0 && (pe = "status") || A.statusText === void 0 && (pe = "statusText") || A.httpVersion === void 0 && (pe = "httpVersion") || A.cookies === void 0 && (pe = "cookies") || A.headers === void 0 && (pe = "headers") || A.content === void 0 && (pe = "content") || A.redirectURL === void 0 && (pe = "redirectURL") || A.headersSize === void 0 && (pe = "headersSize") || A.bodySize === void 0 && (pe = "bodySize"))
              return et.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: pe }, message: "must have required property '" + pe + "'", schema: Le.required, parentSchema: Le, data: A }], !1;
            if (A.status !== void 0) {
              let se = A.status;
              const ce = D;
              if (!(typeof se == "number" && !(se % 1) && !isNaN(se)))
                return et.errors = [{ instancePath: I + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Le.properties.status.type, parentSchema: Le.properties.status, data: se }], !1;
              var B = ce === D;
            } else
              var B = !0;
            if (B) {
              if (A.statusText !== void 0) {
                let se = A.statusText;
                const ce = D;
                if (typeof se != "string")
                  return et.errors = [{ instancePath: I + "/statusText", schemaPath: "#/properties/statusText/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.statusText.type, parentSchema: Le.properties.statusText, data: se }], !1;
                var B = ce === D;
              } else
                var B = !0;
              if (B) {
                if (A.httpVersion !== void 0) {
                  let se = A.httpVersion;
                  const ce = D;
                  if (typeof se != "string")
                    return et.errors = [{ instancePath: I + "/httpVersion", schemaPath: "#/properties/httpVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.httpVersion.type, parentSchema: Le.properties.httpVersion, data: se }], !1;
                  var B = ce === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.cookies !== void 0) {
                    let se = A.cookies;
                    const ce = D;
                    if (Array.isArray(se)) {
                      var ee = !0;
                      const fe = se.length;
                      for (let be = 0; be < fe; be++) {
                        let me = se[be];
                        const Ie = D;
                        if (me && typeof me == "object" && !Array.isArray(me)) {
                          let he;
                          if (me.name === void 0 && (he = "name") || me.value === void 0 && (he = "value"))
                            return et.errors = [{ instancePath: I + "/cookies/" + be, schemaPath: "cookie.json#/required", keyword: "required", params: { missingProperty: he }, message: "must have required property '" + he + "'", schema: Ze.required, parentSchema: Ze, data: me }], !1;
                          if (me.name !== void 0) {
                            let we = me.name;
                            const Re = D;
                            if (typeof we != "string")
                              return et.errors = [{ instancePath: I + "/cookies/" + be + "/name", schemaPath: "cookie.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.name.type, parentSchema: Ze.properties.name, data: we }], !1;
                            var V = Re === D;
                          } else
                            var V = !0;
                          if (V) {
                            if (me.value !== void 0) {
                              let we = me.value;
                              const Re = D;
                              if (typeof we != "string")
                                return et.errors = [{ instancePath: I + "/cookies/" + be + "/value", schemaPath: "cookie.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.value.type, parentSchema: Ze.properties.value, data: we }], !1;
                              var V = Re === D;
                            } else
                              var V = !0;
                            if (V) {
                              if (me.path !== void 0) {
                                let we = me.path;
                                const Re = D;
                                if (typeof we != "string")
                                  return et.errors = [{ instancePath: I + "/cookies/" + be + "/path", schemaPath: "cookie.json#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.path.type, parentSchema: Ze.properties.path, data: we }], !1;
                                var V = Re === D;
                              } else
                                var V = !0;
                              if (V) {
                                if (me.domain !== void 0) {
                                  let we = me.domain;
                                  const Re = D;
                                  if (typeof we != "string")
                                    return et.errors = [{ instancePath: I + "/cookies/" + be + "/domain", schemaPath: "cookie.json#/properties/domain/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.domain.type, parentSchema: Ze.properties.domain, data: we }], !1;
                                  var V = Re === D;
                                } else
                                  var V = !0;
                                if (V) {
                                  if (me.expires !== void 0) {
                                    let we = me.expires;
                                    const Re = D;
                                    if (typeof we != "string" && we !== null)
                                      return et.errors = [{ instancePath: I + "/cookies/" + be + "/expires", schemaPath: "cookie.json#/properties/expires/type", keyword: "type", params: { type: Ze.properties.expires.type }, message: "must be string,null", schema: Ze.properties.expires.type, parentSchema: Ze.properties.expires, data: we }], !1;
                                    if (typeof we == "string" && !At.validate(we))
                                      return et.errors = [{ instancePath: I + "/cookies/" + be + "/expires", schemaPath: "cookie.json#/properties/expires/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Ze.properties.expires, data: we }], !1;
                                    var V = Re === D;
                                  } else
                                    var V = !0;
                                  if (V) {
                                    if (me.httpOnly !== void 0) {
                                      let we = me.httpOnly;
                                      const Re = D;
                                      if (typeof we != "boolean")
                                        return et.errors = [{ instancePath: I + "/cookies/" + be + "/httpOnly", schemaPath: "cookie.json#/properties/httpOnly/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Ze.properties.httpOnly.type, parentSchema: Ze.properties.httpOnly, data: we }], !1;
                                      var V = Re === D;
                                    } else
                                      var V = !0;
                                    if (V) {
                                      if (me.secure !== void 0) {
                                        let we = me.secure;
                                        const Re = D;
                                        if (typeof we != "boolean")
                                          return et.errors = [{ instancePath: I + "/cookies/" + be + "/secure", schemaPath: "cookie.json#/properties/secure/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Ze.properties.secure.type, parentSchema: Ze.properties.secure, data: we }], !1;
                                        var V = Re === D;
                                      } else
                                        var V = !0;
                                      if (V)
                                        if (me.comment !== void 0) {
                                          let we = me.comment;
                                          const Re = D;
                                          if (typeof we != "string")
                                            return et.errors = [{ instancePath: I + "/cookies/" + be + "/comment", schemaPath: "cookie.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.comment.type, parentSchema: Ze.properties.comment, data: we }], !1;
                                          var V = Re === D;
                                        } else
                                          var V = !0;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else
                          return et.errors = [{ instancePath: I + "/cookies/" + be, schemaPath: "cookie.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ze.type, parentSchema: Ze, data: me }], !1;
                        var ee = Ie === D;
                        if (!ee)
                          break;
                      }
                    } else
                      return et.errors = [{ instancePath: I + "/cookies", schemaPath: "#/properties/cookies/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Le.properties.cookies.type, parentSchema: Le.properties.cookies, data: se }], !1;
                    var B = ce === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.headers !== void 0) {
                      let se = A.headers;
                      const ce = D;
                      if (Array.isArray(se)) {
                        var te = !0;
                        const fe = se.length;
                        for (let be = 0; be < fe; be++) {
                          let me = se[be];
                          const Ie = D;
                          if (me && typeof me == "object" && !Array.isArray(me)) {
                            let he;
                            if (me.name === void 0 && (he = "name") || me.value === void 0 && (he = "value"))
                              return et.errors = [{ instancePath: I + "/headers/" + be, schemaPath: "header.json#/required", keyword: "required", params: { missingProperty: he }, message: "must have required property '" + he + "'", schema: Y.required, parentSchema: Y, data: me }], !1;
                            if (me.name !== void 0) {
                              let we = me.name;
                              const Re = D;
                              if (typeof we != "string")
                                return et.errors = [{ instancePath: I + "/headers/" + be + "/name", schemaPath: "header.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.name.type, parentSchema: Y.properties.name, data: we }], !1;
                              var ue = Re === D;
                            } else
                              var ue = !0;
                            if (ue) {
                              if (me.value !== void 0) {
                                let we = me.value;
                                const Re = D;
                                if (typeof we != "string")
                                  return et.errors = [{ instancePath: I + "/headers/" + be + "/value", schemaPath: "header.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.value.type, parentSchema: Y.properties.value, data: we }], !1;
                                var ue = Re === D;
                              } else
                                var ue = !0;
                              if (ue)
                                if (me.comment !== void 0) {
                                  let we = me.comment;
                                  const Re = D;
                                  if (typeof we != "string")
                                    return et.errors = [{ instancePath: I + "/headers/" + be + "/comment", schemaPath: "header.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.comment.type, parentSchema: Y.properties.comment, data: we }], !1;
                                  var ue = Re === D;
                                } else
                                  var ue = !0;
                            }
                          } else
                            return et.errors = [{ instancePath: I + "/headers/" + be, schemaPath: "header.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Y.type, parentSchema: Y, data: me }], !1;
                          var te = Ie === D;
                          if (!te)
                            break;
                        }
                      } else
                        return et.errors = [{ instancePath: I + "/headers", schemaPath: "#/properties/headers/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Le.properties.headers.type, parentSchema: Le.properties.headers, data: se }], !1;
                      var B = ce === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (A.content !== void 0) {
                        let se = A.content;
                        const ce = D;
                        if (se && typeof se == "object" && !Array.isArray(se)) {
                          let fe;
                          if (se.size === void 0 && (fe = "size") || se.mimeType === void 0 && (fe = "mimeType"))
                            return et.errors = [{ instancePath: I + "/content", schemaPath: "content.json#/required", keyword: "required", params: { missingProperty: fe }, message: "must have required property '" + fe + "'", schema: Ue.required, parentSchema: Ue, data: se }], !1;
                          if (se.size !== void 0) {
                            let be = se.size;
                            const me = D;
                            if (!(typeof be == "number" && !(be % 1) && !isNaN(be)))
                              return et.errors = [{ instancePath: I + "/content/size", schemaPath: "content.json#/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ue.properties.size.type, parentSchema: Ue.properties.size, data: be }], !1;
                            var ge = me === D;
                          } else
                            var ge = !0;
                          if (ge) {
                            if (se.compression !== void 0) {
                              let be = se.compression;
                              const me = D;
                              if (!(typeof be == "number" && !(be % 1) && !isNaN(be)))
                                return et.errors = [{ instancePath: I + "/content/compression", schemaPath: "content.json#/properties/compression/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ue.properties.compression.type, parentSchema: Ue.properties.compression, data: be }], !1;
                              var ge = me === D;
                            } else
                              var ge = !0;
                            if (ge) {
                              if (se.mimeType !== void 0) {
                                let be = se.mimeType;
                                const me = D;
                                if (typeof be != "string")
                                  return et.errors = [{ instancePath: I + "/content/mimeType", schemaPath: "content.json#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.mimeType.type, parentSchema: Ue.properties.mimeType, data: be }], !1;
                                var ge = me === D;
                              } else
                                var ge = !0;
                              if (ge) {
                                if (se.text !== void 0) {
                                  let be = se.text;
                                  const me = D;
                                  if (typeof be != "string")
                                    return et.errors = [{ instancePath: I + "/content/text", schemaPath: "content.json#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.text.type, parentSchema: Ue.properties.text, data: be }], !1;
                                  var ge = me === D;
                                } else
                                  var ge = !0;
                                if (ge) {
                                  if (se.encoding !== void 0) {
                                    let be = se.encoding;
                                    const me = D;
                                    if (typeof be != "string")
                                      return et.errors = [{ instancePath: I + "/content/encoding", schemaPath: "content.json#/properties/encoding/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.encoding.type, parentSchema: Ue.properties.encoding, data: be }], !1;
                                    var ge = me === D;
                                  } else
                                    var ge = !0;
                                  if (ge)
                                    if (se.comment !== void 0) {
                                      let be = se.comment;
                                      const me = D;
                                      if (typeof be != "string")
                                        return et.errors = [{ instancePath: I + "/content/comment", schemaPath: "content.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.comment.type, parentSchema: Ue.properties.comment, data: be }], !1;
                                      var ge = me === D;
                                    } else
                                      var ge = !0;
                                }
                              }
                            }
                          }
                        } else
                          return et.errors = [{ instancePath: I + "/content", schemaPath: "content.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ue.type, parentSchema: Ue, data: se }], !1;
                        var B = ce === D;
                      } else
                        var B = !0;
                      if (B) {
                        if (A.redirectURL !== void 0) {
                          let se = A.redirectURL;
                          const ce = D;
                          if (typeof se != "string")
                            return et.errors = [{ instancePath: I + "/redirectURL", schemaPath: "#/properties/redirectURL/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.redirectURL.type, parentSchema: Le.properties.redirectURL, data: se }], !1;
                          var B = ce === D;
                        } else
                          var B = !0;
                        if (B) {
                          if (A.headersSize !== void 0) {
                            let se = A.headersSize;
                            const ce = D;
                            if (!(typeof se == "number" && !(se % 1) && !isNaN(se)))
                              return et.errors = [{ instancePath: I + "/headersSize", schemaPath: "#/properties/headersSize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Le.properties.headersSize.type, parentSchema: Le.properties.headersSize, data: se }], !1;
                            var B = ce === D;
                          } else
                            var B = !0;
                          if (B) {
                            if (A.bodySize !== void 0) {
                              let se = A.bodySize;
                              const ce = D;
                              if (!(typeof se == "number" && !(se % 1) && !isNaN(se)))
                                return et.errors = [{ instancePath: I + "/bodySize", schemaPath: "#/properties/bodySize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Le.properties.bodySize.type, parentSchema: Le.properties.bodySize, data: se }], !1;
                              var B = ce === D;
                            } else
                              var B = !0;
                            if (B)
                              if (A.comment !== void 0) {
                                let se = A.comment;
                                const ce = D;
                                if (typeof se != "string")
                                  return et.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.comment.type, parentSchema: Le.properties.comment, data: se }], !1;
                                var B = ce === D;
                              } else
                                var B = !0;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else
            return et.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Le.type, parentSchema: Le, data: A }], !1;
          return et.errors = U, D === 0;
        }
        function Ge(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (D === 0)
            if (A && typeof A == "object" && !Array.isArray(A)) {
              let te;
              if (A.startedDateTime === void 0 && (te = "startedDateTime") || A.time === void 0 && (te = "time") || A.request === void 0 && (te = "request") || A.response === void 0 && (te = "response") || A.cache === void 0 && (te = "cache") || A.timings === void 0 && (te = "timings"))
                return Ge.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: te }, message: "must have required property '" + te + "'", schema: Xe.required, parentSchema: Xe, data: A }], !1;
              if (A.pageref !== void 0) {
                let ue = A.pageref;
                const ge = D;
                if (typeof ue != "string")
                  return Ge.errors = [{ instancePath: I + "/pageref", schemaPath: "#/properties/pageref/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Xe.properties.pageref.type, parentSchema: Xe.properties.pageref, data: ue }], !1;
                var B = ge === D;
              } else
                var B = !0;
              if (B) {
                if (A.startedDateTime !== void 0) {
                  let ue = A.startedDateTime;
                  const ge = D;
                  if (D === ge && D === ge)
                    if (typeof ue == "string")
                      if (ye.test(ue)) {
                        if (!At.validate(ue))
                          return Ge.errors = [{ instancePath: I + "/startedDateTime", schemaPath: "#/properties/startedDateTime/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Xe.properties.startedDateTime, data: ue }], !1;
                      } else
                        return Ge.errors = [{ instancePath: I + "/startedDateTime", schemaPath: "#/properties/startedDateTime/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))", parentSchema: Xe.properties.startedDateTime, data: ue }], !1;
                    else
                      return Ge.errors = [{ instancePath: I + "/startedDateTime", schemaPath: "#/properties/startedDateTime/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Xe.properties.startedDateTime.type, parentSchema: Xe.properties.startedDateTime, data: ue }], !1;
                  var B = ge === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.time !== void 0) {
                    let ue = A.time;
                    const ge = D;
                    if (typeof ue != "number")
                      return Ge.errors = [{ instancePath: I + "/time", schemaPath: "#/properties/time/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Xe.properties.time.type, parentSchema: Xe.properties.time, data: ue }], !1;
                    var B = ge === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.request !== void 0) {
                      let ue = A.request;
                      const ge = D;
                      _e(ue, { instancePath: I + "/request", parentData: A, parentDataProperty: "request", rootData: K }) || (U = U === null ? _e.errors : U.concat(_e.errors), D = U.length);
                      var B = ge === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (A.response !== void 0) {
                        let ue = A.response;
                        const ge = D;
                        et(ue, { instancePath: I + "/response", parentData: A, parentDataProperty: "response", rootData: K }) || (U = U === null ? et.errors : U.concat(et.errors), D = U.length);
                        var B = ge === D;
                      } else
                        var B = !0;
                      if (B) {
                        if (A.cache !== void 0) {
                          let ue = A.cache;
                          const ge = D;
                          Ae(ue, { instancePath: I + "/cache", parentData: A, parentDataProperty: "cache", rootData: K }) || (U = U === null ? Ae.errors : U.concat(Ae.errors), D = U.length);
                          var B = ge === D;
                        } else
                          var B = !0;
                        if (B) {
                          if (A.timings !== void 0) {
                            let ue = A.timings;
                            const ge = D;
                            if (ue && typeof ue == "object" && !Array.isArray(ue)) {
                              let se;
                              if (ue.send === void 0 && (se = "send") || ue.wait === void 0 && (se = "wait") || ue.receive === void 0 && (se = "receive"))
                                return Ge.errors = [{ instancePath: I + "/timings", schemaPath: "timings.json#/required", keyword: "required", params: { missingProperty: se }, message: "must have required property '" + se + "'", schema: ze.required, parentSchema: ze, data: ue }], !1;
                              if (ue.dns !== void 0) {
                                let ce = ue.dns;
                                const Oe = D;
                                if (typeof ce != "number")
                                  return Ge.errors = [{ instancePath: I + "/timings/dns", schemaPath: "timings.json#/properties/dns/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.dns.type, parentSchema: ze.properties.dns, data: ce }], !1;
                                var ee = Oe === D;
                              } else
                                var ee = !0;
                              if (ee) {
                                if (ue.connect !== void 0) {
                                  let ce = ue.connect;
                                  const Oe = D;
                                  if (typeof ce != "number")
                                    return Ge.errors = [{ instancePath: I + "/timings/connect", schemaPath: "timings.json#/properties/connect/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.connect.type, parentSchema: ze.properties.connect, data: ce }], !1;
                                  var ee = Oe === D;
                                } else
                                  var ee = !0;
                                if (ee) {
                                  if (ue.blocked !== void 0) {
                                    let ce = ue.blocked;
                                    const Oe = D;
                                    if (typeof ce != "number")
                                      return Ge.errors = [{ instancePath: I + "/timings/blocked", schemaPath: "timings.json#/properties/blocked/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.blocked.type, parentSchema: ze.properties.blocked, data: ce }], !1;
                                    var ee = Oe === D;
                                  } else
                                    var ee = !0;
                                  if (ee) {
                                    if (ue.send !== void 0) {
                                      let ce = ue.send;
                                      const Oe = D;
                                      if (typeof ce != "number")
                                        return Ge.errors = [{ instancePath: I + "/timings/send", schemaPath: "timings.json#/properties/send/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.send.type, parentSchema: ze.properties.send, data: ce }], !1;
                                      var ee = Oe === D;
                                    } else
                                      var ee = !0;
                                    if (ee) {
                                      if (ue.wait !== void 0) {
                                        let ce = ue.wait;
                                        const Oe = D;
                                        if (typeof ce != "number")
                                          return Ge.errors = [{ instancePath: I + "/timings/wait", schemaPath: "timings.json#/properties/wait/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.wait.type, parentSchema: ze.properties.wait, data: ce }], !1;
                                        var ee = Oe === D;
                                      } else
                                        var ee = !0;
                                      if (ee) {
                                        if (ue.receive !== void 0) {
                                          let ce = ue.receive;
                                          const Oe = D;
                                          if (typeof ce != "number")
                                            return Ge.errors = [{ instancePath: I + "/timings/receive", schemaPath: "timings.json#/properties/receive/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.receive.type, parentSchema: ze.properties.receive, data: ce }], !1;
                                          var ee = Oe === D;
                                        } else
                                          var ee = !0;
                                        if (ee) {
                                          if (ue.ssl !== void 0) {
                                            let ce = ue.ssl;
                                            const Oe = D;
                                            if (typeof ce != "number")
                                              return Ge.errors = [{ instancePath: I + "/timings/ssl", schemaPath: "timings.json#/properties/ssl/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.ssl.type, parentSchema: ze.properties.ssl, data: ce }], !1;
                                            var ee = Oe === D;
                                          } else
                                            var ee = !0;
                                          if (ee)
                                            if (ue.comment !== void 0) {
                                              let ce = ue.comment;
                                              const Oe = D;
                                              if (typeof ce != "string")
                                                return Ge.errors = [{ instancePath: I + "/timings/comment", schemaPath: "timings.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ze.properties.comment.type, parentSchema: ze.properties.comment, data: ce }], !1;
                                              var ee = Oe === D;
                                            } else
                                              var ee = !0;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            var B = ge === D;
                          } else
                            var B = !0;
                          if (B) {
                            if (A.serverIPAddress !== void 0) {
                              let ue = A.serverIPAddress;
                              const ge = D;
                              if (typeof ue != "string")
                                return Ge.errors = [{ instancePath: I + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Xe.properties.serverIPAddress.type, parentSchema: Xe.properties.serverIPAddress, data: ue }], !1;
                              const pe = D;
                              let se = !1, ce = null;
                              const Oe = D;
                              if (D === Oe && typeof ue == "string" && !Rt.test(ue)) {
                                const me = { instancePath: I + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/oneOf/0/format", keyword: "format", params: { format: "ipv4" }, message: 'must match format "ipv4"', schema: "ipv4", parentSchema: Xe.properties.serverIPAddress.oneOf[0], data: ue };
                                U === null ? U = [me] : U.push(me), D++;
                              }
                              var V = Oe === D;
                              V && (se = !0, ce = 0);
                              const fe = D;
                              if (D === fe && typeof ue == "string" && !Yt.test(ue)) {
                                const me = { instancePath: I + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/oneOf/1/format", keyword: "format", params: { format: "ipv6" }, message: 'must match format "ipv6"', schema: "ipv6", parentSchema: Xe.properties.serverIPAddress.oneOf[1], data: ue };
                                U === null ? U = [me] : U.push(me), D++;
                              }
                              var V = fe === D;
                              if (V && se ? (se = !1, ce = [ce, 1]) : V && (se = !0, ce = 1), se)
                                D = pe, U !== null && (pe ? U.length = pe : U = null);
                              else {
                                const me = { instancePath: I + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/oneOf", keyword: "oneOf", params: { passingSchemas: ce }, message: "must match exactly one schema in oneOf", schema: Xe.properties.serverIPAddress.oneOf, parentSchema: Xe.properties.serverIPAddress, data: ue };
                                return U === null ? U = [me] : U.push(me), D++, Ge.errors = U, !1;
                              }
                              var B = ge === D;
                            } else
                              var B = !0;
                            if (B) {
                              if (A.connection !== void 0) {
                                let ue = A.connection;
                                const ge = D;
                                if (typeof ue != "string")
                                  return Ge.errors = [{ instancePath: I + "/connection", schemaPath: "#/properties/connection/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Xe.properties.connection.type, parentSchema: Xe.properties.connection, data: ue }], !1;
                                var B = ge === D;
                              } else
                                var B = !0;
                              if (B)
                                if (A.comment !== void 0) {
                                  let ue = A.comment;
                                  const ge = D;
                                  if (typeof ue != "string")
                                    return Ge.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Xe.properties.comment.type, parentSchema: Xe.properties.comment, data: ue }], !1;
                                  var B = ge === D;
                                } else
                                  var B = !0;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else
              return Ge.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Xe.type, parentSchema: Xe, data: A }], !1;
          return Ge.errors = U, D === 0;
        }
        J["har.json"] = C;
        var $t = { $id: "har.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["log"], properties: { log: { $ref: "log.json#" } } }, Be = { $id: "log.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["version", "creator", "entries"], properties: { version: { type: "string" }, creator: { $ref: "creator.json#" }, browser: { $ref: "browser.json#" }, pages: { type: "array", items: { $ref: "page.json#" } }, entries: { type: "array", items: { $ref: "entry.json#" } }, comment: { type: "string" } } }, P = { $id: "page.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["startedDateTime", "id", "title", "pageTimings"], properties: { startedDateTime: { type: "string", format: "date-time", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, id: { type: "string", unique: !0 }, title: { type: "string" }, pageTimings: { $ref: "pageTimings.json#" }, comment: { type: "string" } } }, N = { $id: "pageTimings.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", properties: { onContentLoad: { type: "number", min: -1 }, onLoad: { type: "number", min: -1 }, comment: { type: "string" } } };
        function F(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let V;
            if (A.startedDateTime === void 0 && (V = "startedDateTime") || A.id === void 0 && (V = "id") || A.title === void 0 && (V = "title") || A.pageTimings === void 0 && (V = "pageTimings"))
              return F.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: V }, message: "must have required property '" + V + "'", schema: P.required, parentSchema: P, data: A }], !1;
            if (A.startedDateTime !== void 0) {
              let te = A.startedDateTime;
              const ue = D;
              if (typeof te == "string")
                if (ye.test(te)) {
                  if (!At.validate(te))
                    return F.errors = [{ instancePath: I + "/startedDateTime", schemaPath: "#/properties/startedDateTime/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: P.properties.startedDateTime, data: te }], !1;
                } else
                  return F.errors = [{ instancePath: I + "/startedDateTime", schemaPath: "#/properties/startedDateTime/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))", parentSchema: P.properties.startedDateTime, data: te }], !1;
              else
                return F.errors = [{ instancePath: I + "/startedDateTime", schemaPath: "#/properties/startedDateTime/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.startedDateTime.type, parentSchema: P.properties.startedDateTime, data: te }], !1;
              var B = ue === D;
            } else
              var B = !0;
            if (B) {
              if (A.id !== void 0) {
                let te = A.id;
                const ue = D;
                if (typeof te != "string")
                  return F.errors = [{ instancePath: I + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.id.type, parentSchema: P.properties.id, data: te }], !1;
                var B = ue === D;
              } else
                var B = !0;
              if (B) {
                if (A.title !== void 0) {
                  let te = A.title;
                  const ue = D;
                  if (typeof te != "string")
                    return F.errors = [{ instancePath: I + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.title.type, parentSchema: P.properties.title, data: te }], !1;
                  var B = ue === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.pageTimings !== void 0) {
                    let te = A.pageTimings;
                    const ue = D;
                    if (te && typeof te == "object" && !Array.isArray(te)) {
                      if (te.onContentLoad !== void 0) {
                        let pe = te.onContentLoad;
                        const se = D;
                        if (typeof pe != "number")
                          return F.errors = [{ instancePath: I + "/pageTimings/onContentLoad", schemaPath: "pageTimings.json#/properties/onContentLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: N.properties.onContentLoad.type, parentSchema: N.properties.onContentLoad, data: pe }], !1;
                        var ee = se === D;
                      } else
                        var ee = !0;
                      if (ee) {
                        if (te.onLoad !== void 0) {
                          let pe = te.onLoad;
                          const se = D;
                          if (typeof pe != "number")
                            return F.errors = [{ instancePath: I + "/pageTimings/onLoad", schemaPath: "pageTimings.json#/properties/onLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: N.properties.onLoad.type, parentSchema: N.properties.onLoad, data: pe }], !1;
                          var ee = se === D;
                        } else
                          var ee = !0;
                        if (ee)
                          if (te.comment !== void 0) {
                            let pe = te.comment;
                            const se = D;
                            if (typeof pe != "string")
                              return F.errors = [{ instancePath: I + "/pageTimings/comment", schemaPath: "pageTimings.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: N.properties.comment.type, parentSchema: N.properties.comment, data: pe }], !1;
                            var ee = se === D;
                          } else
                            var ee = !0;
                      }
                    } else
                      return F.errors = [{ instancePath: I + "/pageTimings", schemaPath: "pageTimings.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: N.type, parentSchema: N, data: te }], !1;
                    var B = ue === D;
                  } else
                    var B = !0;
                  if (B)
                    if (A.comment !== void 0) {
                      let te = A.comment;
                      const ue = D;
                      if (typeof te != "string")
                        return F.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.comment.type, parentSchema: P.properties.comment, data: te }], !1;
                      var B = ue === D;
                    } else
                      var B = !0;
                }
              }
            }
          } else
            return F.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: P.type, parentSchema: P, data: A }], !1;
          return F.errors = U, D === 0;
        }
        function T(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (D === 0)
            if (A && typeof A == "object" && !Array.isArray(A)) {
              let ge;
              if (A.version === void 0 && (ge = "version") || A.creator === void 0 && (ge = "creator") || A.entries === void 0 && (ge = "entries"))
                return T.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ge }, message: "must have required property '" + ge + "'", schema: Be.required, parentSchema: Be, data: A }], !1;
              if (A.version !== void 0) {
                let pe = A.version;
                const se = D;
                if (typeof pe != "string")
                  return T.errors = [{ instancePath: I + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Be.properties.version.type, parentSchema: Be.properties.version, data: pe }], !1;
                var B = se === D;
              } else
                var B = !0;
              if (B) {
                if (A.creator !== void 0) {
                  let pe = A.creator;
                  const se = D;
                  if (D === D)
                    if (pe && typeof pe == "object" && !Array.isArray(pe)) {
                      let fe;
                      if (pe.name === void 0 && (fe = "name") || pe.version === void 0 && (fe = "version"))
                        return T.errors = [{ instancePath: I + "/creator", schemaPath: "creator.json#/required", keyword: "required", params: { missingProperty: fe }, message: "must have required property '" + fe + "'", schema: Dt.required, parentSchema: Dt, data: pe }], !1;
                      if (pe.name !== void 0) {
                        let be = pe.name;
                        const me = D;
                        if (typeof be != "string")
                          return T.errors = [{ instancePath: I + "/creator/name", schemaPath: "creator.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Dt.properties.name.type, parentSchema: Dt.properties.name, data: be }], !1;
                        var ee = me === D;
                      } else
                        var ee = !0;
                      if (ee) {
                        if (pe.version !== void 0) {
                          let be = pe.version;
                          const me = D;
                          if (typeof be != "string")
                            return T.errors = [{ instancePath: I + "/creator/version", schemaPath: "creator.json#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Dt.properties.version.type, parentSchema: Dt.properties.version, data: be }], !1;
                          var ee = me === D;
                        } else
                          var ee = !0;
                        if (ee)
                          if (pe.comment !== void 0) {
                            let be = pe.comment;
                            const me = D;
                            if (typeof be != "string")
                              return T.errors = [{ instancePath: I + "/creator/comment", schemaPath: "creator.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Dt.properties.comment.type, parentSchema: Dt.properties.comment, data: be }], !1;
                            var ee = me === D;
                          } else
                            var ee = !0;
                      }
                    } else
                      return T.errors = [{ instancePath: I + "/creator", schemaPath: "creator.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Dt.type, parentSchema: Dt, data: pe }], !1;
                  var B = se === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.browser !== void 0) {
                    let pe = A.browser;
                    const se = D;
                    if (D === D)
                      if (pe && typeof pe == "object" && !Array.isArray(pe)) {
                        let fe;
                        if (pe.name === void 0 && (fe = "name") || pe.version === void 0 && (fe = "version"))
                          return T.errors = [{ instancePath: I + "/browser", schemaPath: "browser.json#/required", keyword: "required", params: { missingProperty: fe }, message: "must have required property '" + fe + "'", schema: Ve.required, parentSchema: Ve, data: pe }], !1;
                        if (pe.name !== void 0) {
                          let be = pe.name;
                          const me = D;
                          if (typeof be != "string")
                            return T.errors = [{ instancePath: I + "/browser/name", schemaPath: "browser.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ve.properties.name.type, parentSchema: Ve.properties.name, data: be }], !1;
                          var V = me === D;
                        } else
                          var V = !0;
                        if (V) {
                          if (pe.version !== void 0) {
                            let be = pe.version;
                            const me = D;
                            if (typeof be != "string")
                              return T.errors = [{ instancePath: I + "/browser/version", schemaPath: "browser.json#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ve.properties.version.type, parentSchema: Ve.properties.version, data: be }], !1;
                            var V = me === D;
                          } else
                            var V = !0;
                          if (V)
                            if (pe.comment !== void 0) {
                              let be = pe.comment;
                              const me = D;
                              if (typeof be != "string")
                                return T.errors = [{ instancePath: I + "/browser/comment", schemaPath: "browser.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ve.properties.comment.type, parentSchema: Ve.properties.comment, data: be }], !1;
                              var V = me === D;
                            } else
                              var V = !0;
                        }
                      } else
                        return T.errors = [{ instancePath: I + "/browser", schemaPath: "browser.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ve.type, parentSchema: Ve, data: pe }], !1;
                    var B = se === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.pages !== void 0) {
                      let pe = A.pages;
                      const se = D;
                      if (D === se)
                        if (Array.isArray(pe)) {
                          var te = !0;
                          const Oe = pe.length;
                          for (let fe = 0; fe < Oe; fe++) {
                            let be = pe[fe];
                            const me = D;
                            F(be, { instancePath: I + "/pages/" + fe, parentData: pe, parentDataProperty: fe, rootData: K }) || (U = U === null ? F.errors : U.concat(F.errors), D = U.length);
                            var te = me === D;
                            if (!te)
                              break;
                          }
                        } else
                          return T.errors = [{ instancePath: I + "/pages", schemaPath: "#/properties/pages/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Be.properties.pages.type, parentSchema: Be.properties.pages, data: pe }], !1;
                      var B = se === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (A.entries !== void 0) {
                        let pe = A.entries;
                        const se = D;
                        if (D === se)
                          if (Array.isArray(pe)) {
                            var ue = !0;
                            const Oe = pe.length;
                            for (let fe = 0; fe < Oe; fe++) {
                              let be = pe[fe];
                              const me = D;
                              Ge(be, { instancePath: I + "/entries/" + fe, parentData: pe, parentDataProperty: fe, rootData: K }) || (U = U === null ? Ge.errors : U.concat(Ge.errors), D = U.length);
                              var ue = me === D;
                              if (!ue)
                                break;
                            }
                          } else
                            return T.errors = [{ instancePath: I + "/entries", schemaPath: "#/properties/entries/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Be.properties.entries.type, parentSchema: Be.properties.entries, data: pe }], !1;
                        var B = se === D;
                      } else
                        var B = !0;
                      if (B)
                        if (A.comment !== void 0) {
                          let pe = A.comment;
                          const se = D;
                          if (typeof pe != "string")
                            return T.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Be.properties.comment.type, parentSchema: Be.properties.comment, data: pe }], !1;
                          var B = se === D;
                        } else
                          var B = !0;
                    }
                  }
                }
              }
            } else
              return T.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Be.type, parentSchema: Be, data: A }], !1;
          return T.errors = U, D === 0;
        }
        function C(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (D === 0)
            if (A && typeof A == "object" && !Array.isArray(A)) {
              let B;
              if (A.log === void 0 && (B = "log"))
                return C.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: B }, message: "must have required property '" + B + "'", schema: $t.required, parentSchema: $t, data: A }], !1;
              if (A.log !== void 0) {
                let ee = A.log;
                T(ee, { instancePath: I + "/log", parentData: A, parentDataProperty: "log", rootData: K }) || (U = U === null ? T.errors : U.concat(T.errors), D = U.length);
              }
            } else
              return C.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: $t.type, parentSchema: $t, data: A }], !1;
          return C.errors = U, D === 0;
        }
        J["header.json"] = S;
        function S(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.name === void 0 && (ee = "name") || A.value === void 0 && (ee = "value"))
              return S.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: Y.required, parentSchema: Y, data: A }], !1;
            if (A.name !== void 0) {
              let V = A.name;
              const te = D;
              if (typeof V != "string")
                return S.errors = [{ instancePath: I + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.name.type, parentSchema: Y.properties.name, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.value !== void 0) {
                let V = A.value;
                const te = D;
                if (typeof V != "string")
                  return S.errors = [{ instancePath: I + "/value", schemaPath: "#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.value.type, parentSchema: Y.properties.value, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B)
                if (A.comment !== void 0) {
                  let V = A.comment;
                  const te = D;
                  if (typeof V != "string")
                    return S.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.comment.type, parentSchema: Y.properties.comment, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
            }
          } else
            return S.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Y.type, parentSchema: Y, data: A }], !1;
          return S.errors = U, D === 0;
        }
        J["log.json"] = T, J["page.json"] = F, J["pageTimings.json"] = h;
        function h(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            if (A.onContentLoad !== void 0) {
              let ee = A.onContentLoad;
              const V = D;
              if (typeof ee != "number")
                return h.errors = [{ instancePath: I + "/onContentLoad", schemaPath: "#/properties/onContentLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: N.properties.onContentLoad.type, parentSchema: N.properties.onContentLoad, data: ee }], !1;
              var B = V === D;
            } else
              var B = !0;
            if (B) {
              if (A.onLoad !== void 0) {
                let ee = A.onLoad;
                const V = D;
                if (typeof ee != "number")
                  return h.errors = [{ instancePath: I + "/onLoad", schemaPath: "#/properties/onLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: N.properties.onLoad.type, parentSchema: N.properties.onLoad, data: ee }], !1;
                var B = V === D;
              } else
                var B = !0;
              if (B)
                if (A.comment !== void 0) {
                  let ee = A.comment;
                  const V = D;
                  if (typeof ee != "string")
                    return h.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: N.properties.comment.type, parentSchema: N.properties.comment, data: ee }], !1;
                  var B = V === D;
                } else
                  var B = !0;
            }
          } else
            return h.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: N.type, parentSchema: N, data: A }], !1;
          return h.errors = U, D === 0;
        }
        J["postData.json"] = k;
        function k(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let V;
            if (A.mimeType === void 0 && (V = "mimeType"))
              return k.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: V }, message: "must have required property '" + V + "'", schema: Te.required, parentSchema: Te, data: A }], !1;
            if (A.mimeType !== void 0) {
              let te = A.mimeType;
              const ue = D;
              if (typeof te != "string")
                return k.errors = [{ instancePath: I + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.mimeType.type, parentSchema: Te.properties.mimeType, data: te }], !1;
              var B = ue === D;
            } else
              var B = !0;
            if (B) {
              if (A.text !== void 0) {
                let te = A.text;
                const ue = D;
                if (typeof te != "string")
                  return k.errors = [{ instancePath: I + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.text.type, parentSchema: Te.properties.text, data: te }], !1;
                var B = ue === D;
              } else
                var B = !0;
              if (B) {
                if (A.params !== void 0) {
                  let te = A.params;
                  const ue = D;
                  if (!Array.isArray(te))
                    return k.errors = [{ instancePath: I + "/params", schemaPath: "#/properties/params/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Te.properties.params.type, parentSchema: Te.properties.params, data: te }], !1;
                  if (te && typeof te == "object" && !Array.isArray(te)) {
                    let pe;
                    if (te.name === void 0 && (pe = "name"))
                      return k.errors = [{ instancePath: I + "/params", schemaPath: "#/properties/params/required", keyword: "required", params: { missingProperty: pe }, message: "must have required property '" + pe + "'", schema: Te.properties.params.required, parentSchema: Te.properties.params, data: te }], !1;
                    if (te.name !== void 0) {
                      let se = te.name;
                      const ce = D;
                      if (typeof se != "string")
                        return k.errors = [{ instancePath: I + "/params/name", schemaPath: "#/properties/params/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.name.type, parentSchema: Te.properties.params.properties.name, data: se }], !1;
                      var ee = ce === D;
                    } else
                      var ee = !0;
                    if (ee) {
                      if (te.value !== void 0) {
                        let se = te.value;
                        const ce = D;
                        if (typeof se != "string")
                          return k.errors = [{ instancePath: I + "/params/value", schemaPath: "#/properties/params/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.value.type, parentSchema: Te.properties.params.properties.value, data: se }], !1;
                        var ee = ce === D;
                      } else
                        var ee = !0;
                      if (ee) {
                        if (te.fileName !== void 0) {
                          let se = te.fileName;
                          const ce = D;
                          if (typeof se != "string")
                            return k.errors = [{ instancePath: I + "/params/fileName", schemaPath: "#/properties/params/properties/fileName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.fileName.type, parentSchema: Te.properties.params.properties.fileName, data: se }], !1;
                          var ee = ce === D;
                        } else
                          var ee = !0;
                        if (ee) {
                          if (te.contentType !== void 0) {
                            let se = te.contentType;
                            const ce = D;
                            if (typeof se != "string")
                              return k.errors = [{ instancePath: I + "/params/contentType", schemaPath: "#/properties/params/properties/contentType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.contentType.type, parentSchema: Te.properties.params.properties.contentType, data: se }], !1;
                            var ee = ce === D;
                          } else
                            var ee = !0;
                          if (ee)
                            if (te.comment !== void 0) {
                              let se = te.comment;
                              const ce = D;
                              if (typeof se != "string")
                                return k.errors = [{ instancePath: I + "/params/comment", schemaPath: "#/properties/params/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.params.properties.comment.type, parentSchema: Te.properties.params.properties.comment, data: se }], !1;
                              var ee = ce === D;
                            } else
                              var ee = !0;
                        }
                      }
                    }
                  }
                  var B = ue === D;
                } else
                  var B = !0;
                if (B)
                  if (A.comment !== void 0) {
                    let te = A.comment;
                    const ue = D;
                    if (typeof te != "string")
                      return k.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Te.properties.comment.type, parentSchema: Te.properties.comment, data: te }], !1;
                    var B = ue === D;
                  } else
                    var B = !0;
              }
            }
          } else
            return k.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Te.type, parentSchema: Te, data: A }], !1;
          return k.errors = U, D === 0;
        }
        J["query.json"] = R;
        function R(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.name === void 0 && (ee = "name") || A.value === void 0 && (ee = "value"))
              return R.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: ie.required, parentSchema: ie, data: A }], !1;
            if (A.name !== void 0) {
              let V = A.name;
              const te = D;
              if (typeof V != "string")
                return R.errors = [{ instancePath: I + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ie.properties.name.type, parentSchema: ie.properties.name, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.value !== void 0) {
                let V = A.value;
                const te = D;
                if (typeof V != "string")
                  return R.errors = [{ instancePath: I + "/value", schemaPath: "#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ie.properties.value.type, parentSchema: ie.properties.value, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B)
                if (A.comment !== void 0) {
                  let V = A.comment;
                  const te = D;
                  if (typeof V != "string")
                    return R.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ie.properties.comment.type, parentSchema: ie.properties.comment, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
            }
          } else
            return R.errors = [{ instancePath: I, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: ie.type, parentSchema: ie, data: A }], !1;
          return R.errors = U, D === 0;
        }
        J["request.json"] = _e, J["response.json"] = et, J["timings.json"] = j;
        function j(A, { instancePath: I = "", parentData: z, parentDataProperty: H, rootData: K = A } = {}) {
          let U = null, D = 0;
          if (A && typeof A == "object" && !Array.isArray(A)) {
            let ee;
            if (A.send === void 0 && (ee = "send") || A.wait === void 0 && (ee = "wait") || A.receive === void 0 && (ee = "receive"))
              return j.errors = [{ instancePath: I, schemaPath: "#/required", keyword: "required", params: { missingProperty: ee }, message: "must have required property '" + ee + "'", schema: ze.required, parentSchema: ze, data: A }], !1;
            if (A.dns !== void 0) {
              let V = A.dns;
              const te = D;
              if (typeof V != "number")
                return j.errors = [{ instancePath: I + "/dns", schemaPath: "#/properties/dns/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.dns.type, parentSchema: ze.properties.dns, data: V }], !1;
              var B = te === D;
            } else
              var B = !0;
            if (B) {
              if (A.connect !== void 0) {
                let V = A.connect;
                const te = D;
                if (typeof V != "number")
                  return j.errors = [{ instancePath: I + "/connect", schemaPath: "#/properties/connect/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.connect.type, parentSchema: ze.properties.connect, data: V }], !1;
                var B = te === D;
              } else
                var B = !0;
              if (B) {
                if (A.blocked !== void 0) {
                  let V = A.blocked;
                  const te = D;
                  if (typeof V != "number")
                    return j.errors = [{ instancePath: I + "/blocked", schemaPath: "#/properties/blocked/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.blocked.type, parentSchema: ze.properties.blocked, data: V }], !1;
                  var B = te === D;
                } else
                  var B = !0;
                if (B) {
                  if (A.send !== void 0) {
                    let V = A.send;
                    const te = D;
                    if (typeof V != "number")
                      return j.errors = [{ instancePath: I + "/send", schemaPath: "#/properties/send/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.send.type, parentSchema: ze.properties.send, data: V }], !1;
                    var B = te === D;
                  } else
                    var B = !0;
                  if (B) {
                    if (A.wait !== void 0) {
                      let V = A.wait;
                      const te = D;
                      if (typeof V != "number")
                        return j.errors = [{ instancePath: I + "/wait", schemaPath: "#/properties/wait/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.wait.type, parentSchema: ze.properties.wait, data: V }], !1;
                      var B = te === D;
                    } else
                      var B = !0;
                    if (B) {
                      if (A.receive !== void 0) {
                        let V = A.receive;
                        const te = D;
                        if (typeof V != "number")
                          return j.errors = [{ instancePath: I + "/receive", schemaPath: "#/properties/receive/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.receive.type, parentSchema: ze.properties.receive, data: V }], !1;
                        var B = te === D;
                      } else
                        var B = !0;
                      if (B) {
                        if (A.ssl !== void 0) {
                          let V = A.ssl;
                          const te = D;
                          if (typeof V != "number")
                            return j.errors = [{ instancePath: I + "/ssl", schemaPath: "#/properties/ssl/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: ze.properties.ssl.type, parentSchema: ze.properties.ssl, data: V }], !1;
                          var B = te === D;
                        } else
                          var B = !0;
                        if (B)
                          if (A.comment !== void 0) {
                            let V = A.comment;
                            const te = D;
                            if (typeof V != "string")
                              return j.errors = [{ instancePath: I + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ze.properties.comment.type, parentSchema: ze.properties.comment, data: V }], !1;
                            var B = te === D;
                          } else
                            var B = !0;
                      }
                    }
                  }
                }
              }
            }
          }
          return j.errors = U, D === 0;
        }
      }
    }), M = {};
    w(M, {
      HARError: () => Z,
      default: () => Ce,
      validate: () => ae,
      validateHar: () => de,
      validateRequest: () => re,
      validateResponse: () => X
    }), e.exports = _(M);
    var L = v(O()), Z = class extends Error {
      constructor(J) {
        super(), this.name = "HARError", this.message = "Validation Failed", this.errors = [], this.errors = J, Error.captureStackTrace(this, this.constructor);
      }
    }, Q = {
      request: L["request.json"],
      afterRequest: L["afterRequest.json"],
      beforeRequest: L["beforeRequest.json"],
      browser: L["browser.json"],
      cache: L["cache.json"],
      content: L["content.json"],
      cookie: L["cookie.json"],
      creator: L["creator.json"],
      entry: L["entry.json"],
      har: L["har.json"],
      header: L["header.json"],
      log: L["log.json"],
      page: L["page.json"],
      pageTimings: L["pageTimings.json"],
      postData: L["postData.json"],
      query: L["query.json"],
      response: L["response.json"],
      timings: L["timings.json"]
    }, ae = (J, ne) => {
      const De = Q[J], je = De(ne);
      if (!je)
        throw new Z(De.errors);
      return je;
    }, re = (J) => ae("request", J), X = (J) => ae("response", J), de = (J) => ae("har", J), Ce = re;
  })(S6)), S6.exports;
}
var Qu = {}, C6, iC;
function Fie() {
  if (iC) return C6;
  iC = 1;
  function e(n, r) {
    return Object.prototype.hasOwnProperty.call(n, r);
  }
  C6 = function(n, r, i, a) {
    r = r || "&", i = i || "=";
    var o = {};
    if (typeof n != "string" || n.length === 0)
      return o;
    var c = /\+/g;
    n = n.split(r);
    var u = 1e3;
    a && typeof a.maxKeys == "number" && (u = a.maxKeys);
    var s = n.length;
    u > 0 && s > u && (s = u);
    for (var l = 0; l < s; ++l) {
      var d = n[l].replace(c, "%20"), f = d.indexOf(i), p, g, b, w;
      f >= 0 ? (p = d.substr(0, f), g = d.substr(f + 1)) : (p = d, g = ""), b = decodeURIComponent(p), w = decodeURIComponent(g), e(o, b) ? t(o[b]) ? o[b].push(w) : o[b] = [o[b], w] : o[b] = w;
    }
    return o;
  };
  var t = Array.isArray || function(n) {
    return Object.prototype.toString.call(n) === "[object Array]";
  };
  return C6;
}
var k6, aC;
function Mie() {
  if (aC) return k6;
  aC = 1;
  var e = function(i) {
    switch (typeof i) {
      case "string":
        return i;
      case "boolean":
        return i ? "true" : "false";
      case "number":
        return isFinite(i) ? i : "";
      default:
        return "";
    }
  };
  k6 = function(i, a, o, c) {
    return a = a || "&", o = o || "=", i === null && (i = void 0), typeof i == "object" ? n(r(i), function(u) {
      var s = encodeURIComponent(e(u)) + o;
      return t(i[u]) ? n(i[u], function(l) {
        return s + encodeURIComponent(e(l));
      }).join(a) : s + encodeURIComponent(e(i[u]));
    }).join(a) : c ? encodeURIComponent(e(c)) + o + encodeURIComponent(e(i)) : "";
  };
  var t = Array.isArray || function(i) {
    return Object.prototype.toString.call(i) === "[object Array]";
  };
  function n(i, a) {
    if (i.map) return i.map(a);
    for (var o = [], c = 0; c < i.length; c++)
      o.push(a(i[c], c));
    return o;
  }
  var r = Object.keys || function(i) {
    var a = [];
    for (var o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  };
  return k6;
}
var oC;
function Bie() {
  return oC || (oC = 1, Qu.decode = Qu.parse = Fie(), Qu.encode = Qu.stringify = Mie()), Qu;
}
var Ss = Bie();
function sT(e) {
  return encodeURIComponent(e);
}
function uT(e) {
  return decodeURIComponent(e);
}
var Uie = {
  decode: Ss.decode,
  encode: Ss.encode,
  parse: Ss.parse,
  stringify: Ss.stringify,
  escape: sT,
  unescape: uT
};
const Hie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Ss.decode,
  default: Uie,
  encode: Ss.encode,
  escape: sT,
  parse: Ss.parse,
  stringify: Ss.stringify,
  unescape: uT
}, Symbol.toStringTag, { value: "Module" })), zie = /* @__PURE__ */ q0(Hie);
var Xo = {}, sC;
function Vie() {
  return sC || (sC = 1, (function(e) {
    /**
     * @license https://raw.githubusercontent.com/node-fetch/node-fetch/master/LICENSE.md
     *
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 - 2020 Node Fetch Team
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     *
     * Extracted from https://github.com/node-fetch/node-fetch/blob/64c5c296a0250b852010746c76144cb9e14698d9/src/utils/form-data.js
     */
    var t = Xo && Xo.__generator || function(d, f) {
      var p = { label: 0, sent: function() {
        if (w[0] & 1) throw w[1];
        return w[1];
      }, trys: [], ops: [] }, g, b, w, y;
      return y = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
        return this;
      }), y;
      function v(E) {
        return function(O) {
          return _([E, O]);
        };
      }
      function _(E) {
        if (g) throw new TypeError("Generator is already executing.");
        for (; p; ) try {
          if (g = 1, b && (w = E[0] & 2 ? b.return : E[0] ? b.throw || ((w = b.return) && w.call(b), 0) : b.next) && !(w = w.call(b, E[1])).done) return w;
          switch (b = 0, w && (E = [E[0] & 2, w.value]), E[0]) {
            case 0:
            case 1:
              w = E;
              break;
            case 4:
              return p.label++, { value: E[1], done: !1 };
            case 5:
              p.label++, b = E[1], E = [0];
              continue;
            case 7:
              E = p.ops.pop(), p.trys.pop();
              continue;
            default:
              if (w = p.trys, !(w = w.length > 0 && w[w.length - 1]) && (E[0] === 6 || E[0] === 2)) {
                p = 0;
                continue;
              }
              if (E[0] === 3 && (!w || E[1] > w[0] && E[1] < w[3])) {
                p.label = E[1];
                break;
              }
              if (E[0] === 6 && p.label < w[1]) {
                p.label = w[1], w = E;
                break;
              }
              if (w && p.label < w[2]) {
                p.label = w[2], p.ops.push(E);
                break;
              }
              w[2] && p.ops.pop(), p.trys.pop();
              continue;
          }
          E = f.call(d, p);
        } catch (O) {
          E = [6, O], b = 0;
        } finally {
          g = w = 0;
        }
        if (E[0] & 5) throw E[1];
        return { value: E[0] ? E[1] : void 0, done: !0 };
      }
    }, n = Xo && Xo.__values || function(d) {
      var f = typeof Symbol == "function" && Symbol.iterator, p = f && d[f], g = 0;
      if (p) return p.call(d);
      if (d && typeof d.length == "number") return {
        next: function() {
          return d && g >= d.length && (d = void 0), { value: d && d[g++], done: !d };
        }
      };
      throw new TypeError(f ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, r = Xo && Xo.__read || function(d, f) {
      var p = typeof Symbol == "function" && d[Symbol.iterator];
      if (!p) return d;
      var g = p.call(d), b, w = [], y;
      try {
        for (; (f === void 0 || f-- > 0) && !(b = g.next()).done; ) w.push(b.value);
      } catch (v) {
        y = { error: v };
      } finally {
        try {
          b && !b.done && (p = g.return) && p.call(g);
        } finally {
          if (y) throw y.error;
        }
      }
      return w;
    };
    e.__esModule = !0, e.formDataIterator = e.isBlob = void 0;
    var i = `\r
`, a = "-".repeat(2), o = Symbol.toStringTag, c = function(d) {
      return typeof d == "object" && typeof d.arrayBuffer == "function" && typeof d.type == "string" && typeof d.stream == "function" && typeof d.constructor == "function" && /^(Blob|File)$/.test(d[o]);
    };
    e.isBlob = c;
    var u = function(d) {
      return "".concat(a).concat(d).concat(a).concat(i.repeat(2));
    }, s = function(d, f, p) {
      var g = "";
      return g += "".concat(a).concat(d).concat(i), g += 'Content-Disposition: form-data; name="'.concat(f, '"'), (0, e.isBlob)(p) && (g += '; filename="'.concat(p.name, '"').concat(i), g += "Content-Type: ".concat(p.type || "application/octet-stream")), "".concat(g).concat(i.repeat(2));
    }, l = function(d, f) {
      var p, g, b, w, y, v, _, E;
      return t(this, function(O) {
        switch (O.label) {
          case 0:
            O.trys.push([0, 10, 11, 12]), p = n(d), g = p.next(), O.label = 1;
          case 1:
            return g.done ? [3, 9] : (b = r(g.value, 2), w = b[0], y = b[1], [4, s(f, w, y)]);
          case 2:
            return O.sent(), (0, e.isBlob)(y) ? [5, n(y.stream())] : [3, 4];
          case 3:
            return O.sent(), [3, 6];
          case 4:
            return [4, y];
          case 5:
            O.sent(), O.label = 6;
          case 6:
            return [4, i];
          case 7:
            O.sent(), O.label = 8;
          case 8:
            return g = p.next(), [3, 1];
          case 9:
            return [3, 12];
          case 10:
            return v = O.sent(), _ = { error: v }, [3, 12];
          case 11:
            try {
              g && !g.done && (E = p.return) && E.call(p);
            } finally {
              if (_) throw _.error;
            }
            return [
              7
              /*endfinally*/
            ];
          case 12:
            return [4, u(f)];
          case 13:
            return O.sent(), [
              2
              /*return*/
            ];
        }
      });
    };
    e.formDataIterator = l;
  })(Xo)), Xo;
}
var nf = {}, uC;
function Gie() {
  if (uC) return nf;
  uC = 1, nf.__esModule = !0, nf.reducer = void 0;
  var e = function(t, n) {
    var r = t[n.name];
    return r === void 0 ? (t[n.name] = n.value, t) : Array.isArray(r) ? (r.push(n.value), t) : (t[n.name] = [r, n.value], t);
  };
  return nf.reducer = e, nf;
}
var cC;
function Wie() {
  return cC || (cC = 1, (function(e) {
    var t = Ja && Ja.__assign || function() {
      return t = Object.assign || function(_) {
        for (var E, O = 1, M = arguments.length; O < M; O++) {
          E = arguments[O];
          for (var L in E) Object.prototype.hasOwnProperty.call(E, L) && (_[L] = E[L]);
        }
        return _;
      }, t.apply(this, arguments);
    }, n = Ja && Ja.__createBinding || (Object.create ? (function(_, E, O, M) {
      M === void 0 && (M = O);
      var L = Object.getOwnPropertyDescriptor(E, O);
      (!L || ("get" in L ? !E.__esModule : L.writable || L.configurable)) && (L = { enumerable: !0, get: function() {
        return E[O];
      } }), Object.defineProperty(_, M, L);
    }) : (function(_, E, O, M) {
      M === void 0 && (M = O), _[M] = E[O];
    })), r = Ja && Ja.__values || function(_) {
      var E = typeof Symbol == "function" && Symbol.iterator, O = E && _[E], M = 0;
      if (O) return O.call(_);
      if (_ && typeof _.length == "number") return {
        next: function() {
          return _ && M >= _.length && (_ = void 0), { value: _ && _[M++], done: !_ };
        }
      };
      throw new TypeError(E ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, i = Ja && Ja.__importDefault || function(_) {
      return _ && _.__esModule ? _ : { default: _ };
    };
    e.__esModule = !0, e.HTTPSnippet = e.isHarEntry = e.addTargetClient = e.addTarget = e.extname = e.availableTargets = void 0;
    var a = Jne(), o = i(Lie()), c = /* @__PURE__ */ Nie(), u = zie, s = eT(), l = Vie(), d = Wi(), f = Gie(), p = T0(), g = WO();
    n(e, g, "availableTargets"), n(e, g, "extname");
    var b = T0();
    n(e, b, "addTarget"), n(e, b, "addTargetClient");
    var w = (
      // @ts-expect-error — we're only using window.FormData if it exists
      typeof window < "u" && window.FormData ? window.FormData : o.default
    ), y = function(_) {
      return typeof _ == "object" && "log" in _ && typeof _.log == "object" && "entries" in _.log && Array.isArray(_.log.entries);
    };
    e.isHarEntry = y;
    var v = (
      /** @class */
      /* @__PURE__ */ (function() {
        function _(E) {
          var O = this;
          this.requests = [], this.prepare = function(L) {
            var Z, Q, ae, re, X, de = t(t({}, L), { fullUrl: "", uriObj: {}, queryObj: {}, headersObj: {}, cookiesObj: {}, allHeaders: {} });
            if (de.queryString && de.queryString.length && (de.queryObj = de.queryString.reduce(f.reducer, {})), de.headers && de.headers.length) {
              var Ce = /^HTTP\/2/;
              de.headersObj = de.headers.reduce(function(He, Dt) {
                var Fe, Xe = Dt.name, ze = Dt.value, Rt = Ce.exec(de.httpVersion) ? Xe.toLocaleLowerCase() : Xe;
                return t(t({}, He), (Fe = {}, Fe[Rt] = ze, Fe));
              }, {});
            }
            de.cookies && de.cookies.length && (de.cookiesObj = de.cookies.reduceRight(function(He, Dt) {
              var Fe, Xe = Dt.name, ze = Dt.value;
              return t(t({}, He), (Fe = {}, Fe[Xe] = ze, Fe));
            }, {}));
            var J = (ae = de.cookies) === null || ae === void 0 ? void 0 : ae.map(function(He) {
              var Dt = He.name, Fe = He.value;
              return "".concat(encodeURIComponent(Dt), "=").concat(encodeURIComponent(Fe));
            });
            switch (J?.length && (de.allHeaders.cookie = J.join("; ")), de?.postData.mimeType) {
              case "multipart/mixed":
              case "multipart/related":
              case "multipart/form-data":
              case "multipart/alternative":
                if (de.postData.text = "", de.postData.mimeType = "multipart/form-data", !((re = de.postData) === null || re === void 0) && re.params) {
                  var ne = new w(), De = typeof ne[Symbol.iterator] == "function", je = "---011000010111000001101001";
                  if (De || (ne._boundary = je), (X = de.postData) === null || X === void 0 || X.params.forEach(function(He) {
                    var Dt = He.name, Fe = He.value || "", Xe = He.fileName || null;
                    De ? (0, l.isBlob)(Fe) ? ne.append(Dt, Fe, Xe) : ne.append(Dt, Fe) : ne.append(Dt, Fe, {
                      filename: Xe,
                      contentType: He.contentType || null
                    });
                  }), De)
                    try {
                      for (var Me = r((0, l.formDataIterator)(ne, je)), qe = Me.next(); !qe.done; qe = Me.next()) {
                        var Ve = qe.value;
                        de.postData.text += Ve;
                      }
                    } catch (He) {
                      Z = { error: He };
                    } finally {
                      try {
                        qe && !qe.done && (Q = Me.return) && Q.call(Me);
                      } finally {
                        if (Z) throw Z.error;
                      }
                    }
                  else
                    ne.pipe(
                      // @ts-expect-error TODO
                      (0, a.map)(function(He) {
                        de.postData.text += He;
                      })
                    );
                  de.postData.boundary = je;
                  var xe = (0, d.getHeaderName)(de.headersObj, "content-type") || "content-type";
                  de.headersObj[xe] = "multipart/form-data; boundary=".concat(je);
                }
                break;
              case "application/x-www-form-urlencoded":
                de.postData.params ? (de.postData.paramsObj = de.postData.params.reduce(f.reducer, {}), de.postData.text = (0, u.stringify)(de.postData.paramsObj)) : de.postData.text = "";
                break;
              case "text/json":
              case "text/x-json":
              case "application/json":
              case "application/x-json":
                if (de.postData.mimeType = "application/json", de.postData.text)
                  try {
                    de.postData.jsonObj = JSON.parse(de.postData.text);
                  } catch {
                    de.postData.mimeType = "text/plain";
                  }
                break;
            }
            var ve = t(t({}, de.allHeaders), de.headersObj), Ae = (0, s.parse)(de.url, !0, !0);
            de.queryObj = t(t({}, de.queryObj), Ae.query);
            var Ue = (0, u.stringify)(de.queryObj), qt = t(t({}, Ae), { query: de.queryObj, search: Ue, path: Ue ? "".concat(Ae.pathname, "?").concat(Ue) : Ae.pathname }), Ze = (0, s.format)(t(t({}, Ae), { query: null, search: null })), At = (0, s.format)(t(t({}, Ae), qt));
            return t(t({}, de), { allHeaders: ve, fullUrl: At, url: Ze, uriObj: qt });
          }, this.convert = function(L, Z, Q) {
            !Q && Z && (Q = Z);
            var ae = p.targets[L];
            if (!ae)
              return !1;
            var re = ae.clientsById[Z || ae.info.default].convert, X = O.requests.map(function(de) {
              return re(de, Q);
            });
            return X.length === 1 ? X[0] : X;
          };
          var M = [];
          this.requests = [], (0, e.isHarEntry)(E) ? M = E.log.entries : M = [
            {
              request: E
            }
          ], M.forEach(function(L) {
            var Z, Q = L.request, ae = t(t({ bodySize: 0, headersSize: 0, headers: [], cookies: [], httpVersion: "HTTP/1.1", queryString: [] }, Q), { postData: Q?.postData || {
              mimeType: ((Z = Q.postData) === null || Z === void 0 ? void 0 : Z.mimeType) || "application/octet-stream"
            } });
            (0, c.validateRequest)(ae) && O.requests.push(O.prepare(ae));
          });
        }
        return _;
      })()
    );
    e.HTTPSnippet = v;
  })(Ja)), Ja;
}
var lC;
function Kie() {
  return lC || (lC = 1, (function(e) {
    var t = _l && _l.__createBinding || (Object.create ? (function(u, s, l, d) {
      d === void 0 && (d = l);
      var f = Object.getOwnPropertyDescriptor(s, l);
      (!f || ("get" in f ? !s.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return s[l];
      } }), Object.defineProperty(u, d, f);
    }) : (function(u, s, l, d) {
      d === void 0 && (d = l), u[d] = s[l];
    }));
    e.__esModule = !0, e.targets = e.isTarget = e.isClient = e.addTargetClient = e.addTarget = e.isHarEntry = e.HTTPSnippet = e.extname = e.availableTargets = e.getHeaderName = e.getHeader = e.escapeString = e.CodeBuilder = void 0;
    var n = Pn();
    t(e, n, "CodeBuilder");
    var r = ei();
    t(e, r, "escapeString");
    var i = Wi();
    t(e, i, "getHeader"), t(e, i, "getHeaderName");
    var a = WO();
    t(e, a, "availableTargets"), t(e, a, "extname");
    var o = Wie();
    t(e, o, "HTTPSnippet"), t(e, o, "isHarEntry");
    var c = T0();
    t(e, c, "addTarget"), t(e, c, "addTargetClient"), t(e, c, "isClient"), t(e, c, "isTarget"), t(e, c, "targets");
  })(_l)), _l;
}
var Zie = Kie();
const vs = /* @__PURE__ */ ir({
  __name: "LanguageIcon",
  props: {
    lang: {
      type: String,
      required: !0,
      validator: (e) => Object.values(NU).includes(e)
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      switch (t.lang) {
        case "python":
          return xY;
        case "node":
          return gY;
        case "java":
          return lY;
        case "javascript":
          return pY;
        case "go":
          return uY;
        case "ruby":
          return CY;
        case "swift":
          return OY;
        case "csharp":
          return iY;
        case "c++":
          return rY;
        case "php":
          return yY;
        case "c":
          return oY;
        case "r":
          return wY;
        case "json":
          return hY;
        default:
          return AY;
      }
    });
    return (r, i) => (ke(), Mt(Sn(n.value)));
  }
}), Yie = ["data-testid"], Jie = { class: "select-wrapper" }, Qie = ["value"], Xie = { class: "wide" }, eae = /* @__PURE__ */ ir({
  __name: "RequestSample",
  props: /* @__PURE__ */ eo({
    data: {
      type: Object,
      required: !0
    },
    /**
     * server url selected by user on endpoints detail page
     */
    serverUrl: {
      type: String,
      required: !0
    },
    /* value is coming from TryIt path parameter change */
    requestPath: {
      type: String,
      required: !0
    },
    /* headers generated by auth token changes un TryItAuth */
    authHeaders: {
      type: Array,
      default: () => []
    },
    customHeaders: {
      type: Array,
      default: () => []
    },
    /* query portion generated by auth token changes un TryItAuth */
    authQuery: {
      type: String,
      default: ""
    },
    /* value is coming from TryIt query parameter change */
    requestQuery: {
      type: String,
      default: ""
    },
    /* value is coming from TryIt body parameter change */
    requestBody: {
      type: Object,
      default: () => ({ content: "" })
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ eo(["request-body-sample-idx-changed"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = bc(e, "modelValue"), i = Xa("hide-tryit", Br(!1)), a = t, o = Ye(() => i.value ? n.requestBody && i.value ? Xu : Xu.filter((v) => v.httpSnippetLanguage !== "json") : Xu.filter((v) => v.httpSnippetLanguage !== "json")), c = Ye(() => o.value.map((v) => ({
      label: v.label,
      value: v.httpSnippetLanguage,
      key: v.httpSnippetLanguage
    }))), u = Br(), s = Br(), l = Br(!1), d = Ye(() => u.value ? Xu.find((v) => v.httpSnippetLanguage === u.value)?.libraries || [] : []), f = (v) => Array.isArray(v) && v.length ? v[0].key : null, p = Br(n.data?.request?.body?.contents && n.data.request.body.contents.length ? f(n.data.request.body.contents[0].examples) : null), g = Ye(() => n.data?.request?.body?.contents && n.data.request.body.contents.length && Array.isArray(n.data.request.body.contents[0].examples) && n.data.request.body.contents[0].examples.length ? n.data.request.body.contents[0].examples : []), b = Ye(() => g.value.map((v) => ({
      label: v.key,
      value: v.key,
      key: v.key
    })));
    On(g, (v) => {
      p.value = f(v);
    });
    const w = Br(), y = Br();
    return On(p, (v) => {
      a("request-body-sample-idx-changed", g.value.findIndex((_) => _.key === v));
    }), On(() => ({
      method: n.data.method,
      lang: u.value,
      lib: s.value,
      serverUrl: n.serverUrl,
      authHeaders: n.authHeaders,
      customHeaders: n.customHeaders,
      requestPath: n.requestPath,
      requestQuery: n.requestQuery,
      authQuery: n.authQuery,
      requestBody: n.requestBody
    }), (v, _) => {
      v.method !== _?.method && o.value?.[0] && (u.value = o.value[0].httpSnippetLanguage, v.lang = u.value), v.lang !== _?.lang && (s.value = d.value?.length ? d.value[0].httpSnippetLibrary : void 0);
      let E = !1;
      if (!w.value || v.serverUrl !== _?.serverUrl || v.requestPath !== _?.requestPath || v.requestQuery !== _?.requestQuery || v.authQuery !== _?.authQuery || v.requestBody !== _?.requestBody || v.authHeaders !== _?.authHeaders || v.customHeaders !== _?.customHeaders) {
        let O;
        const M = (v.serverUrl + v.requestPath).replaceAll("{", "").replaceAll("}", "");
        try {
          O = new URL(M), l.value = !1;
        } catch {
          let L = "";
          M.includes("//:") || (L = "missing protocol"), y.value = `Invalid URL value '${M}'${L ? "<br/> - " + L : ""}`, l.value = !0;
          return;
        }
        try {
          let L = v.requestQuery;
          v.authQuery && (L += (v.requestQuery ? "&" : "?") + v.authQuery);
          const Z = [
            ...IE(n.data),
            ...v.customHeaders,
            ...v.authHeaders
          ], { body: Q } = jE(Z.reduce((de, Ce) => (de[Ce.name] = Ce.value, de), {}), v.requestBody);
          O.search = L;
          const ae = Object.fromEntries(O.searchParams), re = Object.keys(ae).map((de) => ({ name: de, value: ae[de] })), X = {
            method: v.method.toUpperCase(),
            // server.origin is set to null when protocol is invalid, we we have to use server.href here
            // but as queryString is passed separately we want to strip it out from url
            url: O.href.replace(/\?.*/, ""),
            queryString: re,
            headers: Z
          };
          !v.requestBody.isBinary && Q && (X.postData = {
            // HTTPsnippet is not doing nice trying to handle with body params based on mimeType, so we going to send pre-formatted body, and
            // make HTTPsnippet to use as is by forcing mimeType as `text/plain`
            mimeType: "text/plain",
            text: Q
          }), v.requestBody.isBinary && v.requestBody.content && v.requestBody.content?.length > 0 && (X.postData = {
            mimeType: "application/pdf",
            text: `@${v.requestBody.content[0].name}`
          }), w.value = new Zie.HTTPSnippet(X), E = !0;
        } catch (L) {
          console.error("@kong/spec-renderer: error in HTTPSnippet", L, M), l.value = !0;
        }
      }
      if (l.value)
        y.value = "Error initializing code snippet";
      else if (!y.value || E || v.lang !== _?.lang || v.lib !== _?.lib) {
        if (v.lang === "json")
          return y.value = v.requestBody, Xu.filter((O) => O.httpSnippetLanguage !== "json");
        w.value && (y.value = w.value.convert(v.lang, v.lib, { binary: v.requestBody?.isBinary }) || "");
      }
    }, { immediate: !0, deep: !0 }), (v, _) => (ke(), Qe("div", {
      class: "request-sample-wrapper",
      "data-testid": `request-sample-${e.data.id}`
    }, [
      Sr(g1, {
        collapsible: !1,
        "content-to-copy": y.value
      }, {
        header: Xt(() => [
          Ft("div", Jie, [
            Sr(ma, {
              id: `language-select-${e.data.id}`,
              modelValue: u.value,
              "onUpdate:modelValue": _[0] || (_[0] = (E) => u.value = E),
              class: "language-selector",
              items: c.value
            }, {
              "shell-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "bash" }),
                bn(" " + cn(E.label), 1)
              ]),
              "python-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "python" }),
                bn(" " + cn(E.label), 1)
              ]),
              "node-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "node" }),
                bn(" " + cn(E.label), 1)
              ]),
              "javascript-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "javascript" }),
                bn(" " + cn(E.label), 1)
              ]),
              "go-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "go" }),
                bn(" " + cn(E.label), 1)
              ]),
              "java-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "java" }),
                bn(" " + cn(E.label), 1)
              ]),
              "csharp-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "csharp" }),
                bn(" " + cn(E.label), 1)
              ]),
              "ruby-item-content": Xt(({ item: E }) => [
                Sr(vs, { lang: "ruby" }),
                bn(" " + cn(E.label), 1)
              ]),
              _: 1
            }, 8, ["id", "modelValue", "items"]),
            _[4] || (_[4] = bn("   ", -1)),
            d.value.length ? zi((ke(), Qe("select", {
              key: 0,
              "onUpdate:modelValue": _[1] || (_[1] = (E) => s.value = E)
            }, [
              (ke(!0), Qe(Mn, null, ii(d.value, (E) => (ke(), Qe("option", {
                key: E.httpSnippetLibrary,
                value: E.httpSnippetLibrary
              }, cn(E.label), 9, Qie))), 128))
            ], 512)), [
              [HD, s.value]
            ]) : Bt("", !0),
            b.value && b.value.length && p.value ? (ke(), Mt(ma, {
              key: 1,
              id: `request-sample-select-${e.data.id}`,
              modelValue: p.value,
              "onUpdate:modelValue": _[2] || (_[2] = (E) => p.value = E),
              class: "request-sample-selector",
              items: b.value,
              placement: "bottom-end"
            }, null, 8, ["id", "modelValue", "items"])) : Bt("", !0)
          ])
        ]),
        default: Xt(() => [
          jt(i) ? (ke(), Mt(VO, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": _[3] || (_[3] = (E) => r.value = E),
            data: e.data
          }, null, 8, ["modelValue", "data"])) : Bt("", !0),
          Ft("div", Xie, [
            y.value && u.value ? (ke(), Mt(Df, {
              key: 0,
              code: y.value,
              "is-error": l.value,
              lang: u.value
            }, null, 8, ["code", "is-error", "lang"])) : Bt("", !0)
          ])
        ]),
        _: 1
      }, 8, ["content-to-copy"])
    ], 8, Yie));
  }
}), tae = /* @__PURE__ */ pn(eae, [["__scopeId", "data-v-cb356e76"]]), rae = { class: "schema-example" }, nae = { class: "schema-example-header" }, iae = /* @__PURE__ */ ir({
  __name: "SchemaExample",
  props: {
    schemaExampleJson: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: "Example"
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", rae, [
      Ft("div", nae, [
        Bn(t.$slots, "default", {}, () => [
          Ft("span", null, cn(e.title), 1),
          Sr(m1, { content: e.schemaExampleJson }, null, 8, ["content"])
        ], !0)
      ]),
      Sr(Df, {
        code: e.schemaExampleJson,
        lang: "json"
      }, null, 8, ["code"])
    ]));
  }
}), up = /* @__PURE__ */ pn(iae, [["__scopeId", "data-v-777fb096"]]), aae = { class: "response-sample-header-right" }, oae = /* @__PURE__ */ ir({
  __name: "ResponseSample",
  props: {
    contentList: {
      type: Array,
      required: !0
    },
    responseCode: {
      type: String,
      required: !0
    },
    contentType: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = Br("0"), r = Ye(() => t.contentList.length ? gf(
      t.contentList,
      {},
      parseInt(n.value) || 0
    ) : t.description), i = Ye(() => t.contentList[0]?.examples ? t.contentList[0].examples.map((a, o) => ({
      label: a.key,
      value: o.toString(),
      key: a.key
    })) : []);
    return (a, o) => (ke(), Mt(up, {
      class: "response-sample",
      "data-testid": "response-sample",
      "schema-example-json": r.value
    }, {
      default: Xt(() => [
        Bn(a.$slots, "default", {}, void 0, !0),
        Ft("div", aae, [
          i.value && i.value.length > 1 ? (ke(), Mt(ma, {
            key: 0,
            id: "response-sample-select",
            modelValue: n.value,
            "onUpdate:modelValue": o[0] || (o[0] = (c) => n.value = c),
            class: "response-sample-selector",
            "data-testid": "response-sample-selector",
            items: i.value,
            placement: "bottom-end"
          }, null, 8, ["modelValue", "items"])) : Bt("", !0),
          Sr(m1, { content: r.value }, null, 8, ["content"])
        ])
      ]),
      _: 3
    }, 8, ["schema-example-json"]));
  }
}), fC = /* @__PURE__ */ pn(oae, [["__scopeId", "data-v-851a4113"]]), sae = { class: "callback-sample" }, uae = { class: "callback-sample-header" }, cae = { class: "callback-sample-content" }, lae = /* @__PURE__ */ ir({
  __name: "CallbackSample",
  props: {
    callbackKey: {
      type: String,
      required: !0
    },
    requestSample: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", sae, [
      Ft("div", uae, [
        Bn(t.$slots, "header", {}, void 0, !0)
      ]),
      Ft("div", cae, [
        e.requestSample ? (ke(), Mt(up, {
          key: 0,
          class: "callback-request-sample",
          "schema-example-json": e.requestSample,
          title: "Callback Body"
        }, null, 8, ["schema-example-json"])) : Bt("", !0),
        Bn(t.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), fae = /* @__PURE__ */ pn(lae, [["__scopeId", "data-v-a1f5d7c3"]]), pae = /* @__PURE__ */ ir({
  __name: "ResponseCodeDot",
  props: {
    responseCode: {
      type: String,
      required: !0,
      validator: (e) => $U.includes(e)
    },
    /**
    * Size variations
    * One of ['small', 'large' ]
    */
    size: {
      type: String,
      default: "small",
      validator: (e) => LU.includes(e)
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("span", {
      class: Un(["response-code-dot", [`response-code-${e.responseCode}`, e.size]])
    }, null, 2));
  }
}), A6 = /* @__PURE__ */ pn(pae, [["__scopeId", "data-v-b50c106f"]]), dae = { class: "response-type-select" }, hae = {
  key: 1,
  class: "response-type-select-label"
}, mae = /* @__PURE__ */ ir({
  __name: "ResponseTypeSelect",
  props: {
    componentList: {
      type: Array,
      required: !0
    }
  },
  emits: ["update-response-code", "update-content-type"],
  setup(e, { emit: t }) {
    const n = t;
    function r(i, a) {
      a === pc.ResponseCodeSelectMenu ? n("update-response-code", i.value) : a === pc.ContentTypeSelectMenu && n("update-content-type", i.value);
    }
    return (i, a) => (ke(), Qe("div", dae, [
      (ke(!0), Qe(Mn, null, ii(e.componentList, (o) => (ke(), Qe(Mn, {
        key: o.name
      }, [
        o.optionList.length > 1 ? (ke(), Mt(ma, {
          key: 0,
          items: o.optionList,
          "model-value": o.value,
          onChange: (c) => r(c, o.name)
        }, {
          "2xx-item-content": Xt(({ item: c }) => [
            c?.key ? (ke(), Mt(A6, {
              key: 0,
              "response-code": "2xx"
            })) : Bt("", !0),
            bn(" " + cn(c?.label), 1)
          ]),
          "4xx-item-content": Xt(({ item: c }) => [
            c?.key ? (ke(), Mt(A6, {
              key: 0,
              "response-code": "4xx"
            })) : Bt("", !0),
            bn(" " + cn(c?.label), 1)
          ]),
          _: 2
        }, 1032, ["items", "model-value", "onChange"])) : (ke(), Qe("span", hae, [
          o.name === "response-code-select-menu" ? (ke(), Mt(A6, {
            key: 0,
            "response-code": o.value === "200" ? "2xx" : "4xx"
          }, null, 8, ["response-code"])) : Bt("", !0),
          bn(" " + cn(o.value), 1)
        ]))
      ], 64))), 128))
    ]));
  }
}), af = /* @__PURE__ */ pn(mae, [["__scopeId", "data-v-72c6ece3"]]), gae = ["data-testid"], vae = { class: "http-operation-container" }, yae = ["data-testid"], bae = ["data-testid"], xae = { class: "calback-response-sample-header" }, _ae = /* @__PURE__ */ ir({
  __name: "HttpOperation",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      const ze = [];
      for (const Rt of t.data.security ?? [])
        if (Rt.length) {
          let Yt = "", ye = "";
          Rt.forEach((W) => {
            Yt = Yt.length ? Yt + ` & ${W.key}` : W.key, ye = ye.length ? ye + `-${W.key.replace(" ", "-")}` : W.key.replace(" ", "-");
          }), ze.push({
            title: Yt,
            key: ye,
            schemeList: Rt
          });
        }
      return ze;
    });
    Pa("security-scheme-group-list", n);
    const r = Xa("hide-tryit", Br(!1)), i = Br(!0), a = Br(!0), o = Ye(() => ({
      ...t.data,
      name: "name" in t.data ? t.data.name : t.data.summary || t.data.iid || t.data.path,
      path: "path" in t.data ? t.data.path : ""
    })), c = Ye(() => "name" in t.data), u = Ye(() => r.value ? a.value : i.value), {
      serverUrlList: s,
      selectedServerUrl: l
    } = qi.useServerList(), d = Br(""), f = Br(""), p = Br([]), g = Br({ isBinary: !1, content: "" }), b = Br(t.data.security?.[0]?.[0]?.key || ""), { activeSecurityScheme: w, authHeadersMap: y, authQueryMap: v } = qi.useAuth(), _ = Ye(() => y.value[b.value] ?? []), E = Ye(() => v.value[b.value] ?? ""), O = (ze) => {
      b.value = ze;
    }, {
      activeContentType: M,
      activeResponseContentList: L,
      contentSelectComponentList: Z
    } = qi.useContentTypes(o.value.request?.body?.contents ?? []), Q = Ye(() => t.data.responses ?? []), {
      activeResponseDescription: ae,
      activeResponseCode: re,
      activeContentType: X,
      activeResponseContentList: de,
      responseSelectComponentList: Ce
    } = qi.useCurrentResponse(Q), J = Ye(() => t.data.callbacks ?? []), {
      activeCallbackKey: ne,
      callbackKeyList: De,
      activeCallback: je,
      activeCallbackRequestSample: Me,
      activeCallbackResponseDescription: qe,
      activeCallbackResponseCode: Ve,
      activeCallbackContentType: xe,
      activeCallbackResponseContentList: ve,
      activeCallbackResponseSelectComponentList: Ae
    } = qi.useCurrentCallback(J), Ue = (ze) => {
      d.value = ze;
    }, qt = (ze) => {
      f.value = ze;
    }, Ze = (ze) => {
      p.value = ze;
    }, At = (ze) => {
      g.value = ze;
    }, He = (ze) => {
      g.value = { isBinary: !1, content: L.value.length ? gf(
        L.value,
        { excludeReadonly: !0, excludeNotRequired: u.value },
        ze
      ) : "" };
    };
    function Dt(ze) {
      l.value = ze;
    }
    const Fe = Ye(() => L.value?.length > 0 && (L.value[0].schema?.format == "binary" || L.value[0].schema?.contentMediaType === "application/octet-stream"));
    function Xe(ze) {
      M.value = ze, Fe.value ? g.value = { isBinary: !0, content: [] } : g.value = { isBinary: !1, content: L.value.length ? gf(
        L.value,
        { excludeReadonly: !0, excludeNotRequired: u.value },
        0
      ) : "" };
    }
    return On(() => ({ id: t.data.id, excludeNotRequired: u.value }), (ze) => {
      !w.value && n.value.length && (w.value = n.value[0].key), d.value = X2(o.value), f.value = eg(o.value), p.value = tg({ data: o.value });
      let Rt = "*";
      L.value?.length > 0 && L.value[0].mediaType && (p.value.push({ name: "Content-Type", value: L.value[0].mediaType }), Rt = `.${L.value[0].mediaType.split("/").reverse()[0]}`), Fe.value ? g.value = { isBinary: !0, content: [], acceptedExt: Rt } : g.value = {
        isBinary: !1,
        content: L.value ? gf(
          L.value,
          { excludeReadonly: !0, excludeNotRequired: ze.excludeNotRequired },
          0
        ) : ""
      };
    }, { immediate: !0 }), (ze, Rt) => (ke(), Qe("div", {
      class: "http-operation",
      "data-testid": `http-operation-${o.value.id}`
    }, [
      o.value.name ? (ke(), Mt(Iu, {
        key: 0,
        class: "http-operation-header",
        deprecated: o.value.deprecated,
        description: o.value.description,
        title: o.value.name,
        type: c.value ? "WEBHOOK" : ""
      }, {
        default: Xt(() => [
          jt(s).length || o.value.path ? (ke(), Mt(Eg, {
            key: 0,
            class: "http-operation-server-endpoint",
            "data-testid": `server-endpoint-${o.value.id}`,
            method: o.value.method,
            path: o.value.path,
            "selected-server-url": jt(l),
            "server-url-list": jt(s),
            onSelectedServerChanged: Dt
          }, null, 8, ["data-testid", "method", "path", "selected-server-url", "server-url-list"])) : Bt("", !0)
        ]),
        _: 1
      }, 8, ["deprecated", "description", "title", "type"])) : Bt("", !0),
      Ft("section", vae, [
        Ft("div", {
          class: "left",
          "data-testid": `http-operation-left-${o.value.id}`
        }, [
          o.value.request ? (ke(), Mt(zO, I0($i({ key: 0 }, o.value.request)), {
            default: Xt(() => [
              jt(L).length ? (ke(), Mt(r3, {
                key: 0,
                class: "http-operation-request-body",
                "content-list": jt(L),
                description: o.value.request.body?.description,
                "hide-readonly": "",
                title: "Body"
              }, {
                default: Xt(() => [
                  Sr(af, {
                    "component-list": jt(Z),
                    onUpdateContentType: Xe
                  }, null, 8, ["component-list"])
                ]),
                _: 1
              }, 8, ["content-list", "description"])) : Bt("", !0)
            ]),
            _: 1
          }, 16)) : Bt("", !0),
          Sr(r3, {
            class: "http-operation-response",
            "content-list": jt(de),
            description: jt(ae),
            title: "Response"
          }, {
            default: Xt(() => [
              Sr(af, {
                "component-list": jt(Ce),
                onUpdateContentType: Rt[0] || (Rt[0] = (Yt) => X.value = Yt),
                onUpdateResponseCode: Rt[1] || (Rt[1] = (Yt) => re.value = Yt)
              }, null, 8, ["component-list"])
            ]),
            _: 1
          }, 8, ["content-list", "description"]),
          J.value.length ? (ke(), Mt(gte, {
            key: 1,
            callback: jt(je),
            class: "http-operation-callbacks"
          }, {
            "callback-response": Xt(() => [
              Sr(r3, {
                "content-list": jt(ve),
                description: jt(qe),
                title: "Callback Response"
              }, {
                default: Xt(() => [
                  Sr(af, {
                    "component-list": jt(Ae),
                    onUpdateContentType: Rt[3] || (Rt[3] = (Yt) => xe.value = Yt),
                    onUpdateResponseCode: Rt[4] || (Rt[4] = (Yt) => Ve.value = Yt)
                  }, null, 8, ["component-list"])
                ]),
                _: 1
              }, 8, ["content-list", "description"])
            ]),
            default: Xt(() => [
              Sr(ma, {
                id: `http-callback-select-dropdown-${o.value.id}`,
                modelValue: jt(ne),
                "onUpdate:modelValue": Rt[2] || (Rt[2] = (Yt) => Vd(ne) ? ne.value = Yt : null),
                class: "http-callback-select-dropdown",
                items: jt(De)
              }, null, 8, ["id", "modelValue", "items"])
            ]),
            _: 1
          }, 8, ["callback"])) : Bt("", !0)
        ], 8, yae),
        Ft("div", {
          class: "right",
          "data-testid": `http-operation-right-${o.value.id}`
        }, [
          Sr(Rre, {
            modelValue: i.value,
            "onUpdate:modelValue": Rt[5] || (Rt[5] = (Yt) => i.value = Yt),
            "auth-headers": _.value,
            "auth-query": E.value,
            data: o.value,
            "request-body": g.value,
            "server-url": jt(l),
            onRequestBodyChanged: At,
            onRequestHeadersChanged: Ze,
            onRequestPathChanged: Ue,
            onRequestQueryChanged: qt,
            onSecuritySchemeChanged: O
          }, null, 8, ["modelValue", "auth-headers", "auth-query", "data", "request-body", "server-url"]),
          jt(l) && d.value ? (ke(), Mt(tae, {
            key: 0,
            modelValue: a.value,
            "onUpdate:modelValue": Rt[6] || (Rt[6] = (Yt) => a.value = Yt),
            "auth-headers": _.value,
            "auth-query": E.value,
            "custom-headers": p.value,
            data: o.value,
            "request-body": g.value,
            "request-path": d.value,
            "request-query": f.value,
            "server-url": jt(l),
            onRequestBodySampleIdxChanged: He
          }, null, 8, ["modelValue", "auth-headers", "auth-query", "custom-headers", "data", "request-body", "request-path", "request-query", "server-url"])) : Bt("", !0),
          Sr(fC, {
            "content-list": jt(de),
            "content-type": jt(X),
            description: jt(ae),
            "response-code": jt(re) || ""
          }, {
            default: Xt(() => [
              Sr(af, {
                "component-list": jt(Ce),
                onUpdateContentType: Rt[7] || (Rt[7] = (Yt) => X.value = Yt),
                onUpdateResponseCode: Rt[8] || (Rt[8] = (Yt) => re.value = Yt)
              }, null, 8, ["component-list"])
            ]),
            _: 1
          }, 8, ["content-list", "content-type", "description", "response-code"]),
          jt(je) && jt(Me) ? (ke(), Mt(fae, {
            key: 1,
            "callback-key": jt(je).key,
            class: "http-operation-callback-sample",
            "request-sample": jt(Me)
          }, {
            header: Xt(() => [
              Sr(ma, {
                id: `http-callback-sample-select-dropdown-${o.value.id}`,
                modelValue: jt(ne),
                "onUpdate:modelValue": Rt[9] || (Rt[9] = (Yt) => Vd(ne) ? ne.value = Yt : null),
                class: "http-callback-select-dropdown",
                items: jt(De)
              }, null, 8, ["id", "modelValue", "items"]),
              Rt[12] || (Rt[12] = bn(" callback sample ", -1))
            ]),
            default: Xt(() => [
              Sr(fC, {
                "content-list": jt(ve),
                "content-type": jt(xe),
                description: jt(qe),
                "response-code": jt(Ve) || ""
              }, {
                default: Xt(() => [
                  Ft("div", xae, [
                    Rt[13] || (Rt[13] = Ft("span", null, "Callback Response", -1)),
                    Sr(af, {
                      "component-list": jt(Ae),
                      onUpdateContentType: Rt[10] || (Rt[10] = (Yt) => xe.value = Yt),
                      onUpdateResponseCode: Rt[11] || (Rt[11] = (Yt) => Ve.value = Yt)
                    }, null, 8, ["component-list"])
                  ])
                ]),
                _: 1
              }, 8, ["content-list", "content-type", "description", "response-code"])
            ]),
            _: 1
          }, 8, ["callback-key", "request-sample"])) : Bt("", !0)
        ], 8, bae)
      ])
    ], 8, gae));
  }
}), wae = /* @__PURE__ */ pn(_ae, [["__scopeId", "data-v-257019a8"]]), Sae = /* @__PURE__ */ ir({
  __name: "HttpOperationTag",
  props: {
    name: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (ke(), Mt(Iu, {
      id: `tag-${jt(u0)(e.name)}`,
      class: "http-operation-header",
      description: e.description,
      title: e.name
    }, null, 8, ["id", "description", "title"]));
  }
}), Cae = ["data-testid"], kae = {
  key: 0,
  class: "message-prop"
}, Aae = {
  key: 1,
  class: "message-prop"
}, Eae = { class: "http-model-content" }, Oae = /* @__PURE__ */ ir({
  __name: "AsyncMessage",
  props: {
    data: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => `http-async-message-${t.title.replaceAll(" ", "-")}`), r = Ye(() => t.data.payload ?? {}), i = Br(r.value), a = Ye(() => {
      const c = J0({
        objData: i.value,
        filteringOptions: { excludeReadonly: !1, excludeNotRequired: !1 }
      });
      return c && Object.keys(c).length ? JSON.stringify(c, null, ns) : "";
    }), o = Ye(
      () => a.value ? ["info", "description", "example"] : ["info", "description"]
    );
    return (c, u) => (ke(), Qe("div", {
      class: "async-message",
      "data-testid": n.value
    }, [
      Sr(Iu, {
        class: "http-model-header",
        description: e.data.summary,
        title: e.title,
        type: e.data.type?.toString()
      }, null, 8, ["description", "title", "type"]),
      e.data.messageId ? (ke(), Qe("div", kae, [
        u[1] || (u[1] = bn(" Message Id: ", -1)),
        Ft("b", null, cn(e.data.messageId), 1)
      ])) : Bt("", !0),
      e.data.correlationId ? (ke(), Qe("div", Aae, [
        u[2] || (u[2] = bn(" Correlation Id: ", -1)),
        Ft("b", null, cn(e.data.correlationId), 1)
      ])) : Bt("", !0),
      e.data.description ? (ke(), Mt(ss, {
        key: 2,
        class: "message-description",
        "data-testid": "spec-renderer-async-message-description",
        markdown: e.data.description
      }, null, 8, ["markdown"])) : Bt("", !0),
      Ft("div", Eae, [
        Ft("div", null, [
          Sr(op, {
            "hidden-field-list": o.value,
            property: i.value,
            "property-name": e.title,
            "required-fields": i.value?.required
          }, null, 8, ["hidden-field-list", "property", "property-name", "required-fields"]),
          Sr(Pc, { title: "Payload" }, {
            default: Xt(() => [
              Sr(ap, {
                schema: r.value,
                title: e.title,
                onSelectedModelChanged: u[0] || (u[0] = (s) => i.value = s)
              }, null, 8, ["schema", "title"])
            ]),
            _: 1
          })
        ]),
        a.value ? (ke(), Mt(up, {
          key: 0,
          "schema-example-json": a.value
        }, null, 8, ["schema-example-json"])) : Bt("", !0)
      ])
    ], 8, Cae));
  }
}), cT = /* @__PURE__ */ pn(Oae, [["__scopeId", "data-v-5c4ae32c"]]), Tae = ["data-testid"], Pae = {
  key: 1,
  class: "operation-prop"
}, Rae = { class: "async-operation-container" }, Iae = { key: 3 }, jae = { class: "accepted-collapsible-section-content" }, qae = /* @__PURE__ */ ir({
  __name: "AsyncOperation",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => t.data.operation.channels().all()[0]), r = Ye(() => (t.data.operation.channels().all() || []).map((c) => c.address()).filter((c) => !!c)), i = Ye(() => ({
      id: t.data.operation.id() || "",
      name: t.data.operation.id() || "",
      summary: t.data.operation.summary(),
      description: t.data.operation.description(),
      method: t.data.method,
      messages: t.data.operation.messages().all()
    })), a = Ye(() => {
      const c = [];
      return t.data.operation.messages().all().forEach((u) => {
        c.push(RA(u).data);
      }), c;
    }), o = Ye(() => {
      const c = [];
      return n.value.parameters().all().forEach((u) => {
        c.push({
          id: u.id(),
          name: u.id(),
          ...u.hasSchema() ? { schema: es(u.schema()) } : null
        });
      }), c;
    });
    return (c, u) => (ke(), Qe("div", {
      class: "async-operation",
      "data-testid": `async-operation-${i.value.id}`
    }, [
      i.value.name ? (ke(), Mt(Iu, {
        key: 0,
        class: "async-operation-header",
        deprecated: i.value.deprecated,
        description: i.value.summary,
        title: i.value.name
      }, {
        default: Xt(() => [
          r.value.length ? (ke(), Mt(Eg, {
            key: 0,
            class: "async-operation-server-endpoint",
            "data-testid": `server-endpoint-${i.value.id}`,
            method: i.value.method,
            "selected-server-url": r.value[0] ?? "",
            "server-url-list": r.value
          }, null, 8, ["data-testid", "method", "selected-server-url", "server-url-list"])) : Bt("", !0)
        ]),
        _: 1
      }, 8, ["deprecated", "description", "title"])) : Bt("", !0),
      i.value.id ? (ke(), Qe("div", Pae, [
        u[0] || (u[0] = bn(" Operation Id: ", -1)),
        Ft("b", null, cn(i.value.id), 1)
      ])) : Bt("", !0),
      i.value.description ? (ke(), Mt(ss, {
        key: 2,
        class: "operation-description",
        "data-testid": "spec-renderer-async-message-description",
        markdown: i.value.description
      }, null, 8, ["markdown"])) : Bt("", !0),
      Ft("section", Rae, [
        o.value ? (ke(), Mt(Hd, {
          key: 0,
          "param-list": o.value,
          title: "Parameters"
        }, null, 8, ["param-list"])) : Bt("", !0)
      ]),
      a.value.length ? (ke(), Qe("div", Iae, [
        (ke(!0), Qe(Mn, null, ii(a.value, (s) => (ke(), Mt(Pc, {
          key: s.messageId,
          "border-visible": !1
        }, {
          title: Xt(() => [
            Ft("h3", null, cn(`Message accepted: ${s.messageId}`), 1)
          ]),
          default: Xt(() => [
            Ft("div", jae, [
              Sr(cT, {
                data: s,
                title: ""
              }, null, 8, ["data"])
            ])
          ]),
          _: 2
        }, 1024))), 128))
      ])) : Bt("", !0)
    ], 8, Tae));
  }
}), Dae = /* @__PURE__ */ pn(qae, [["__scopeId", "data-v-f91bffb5"]]), $ae = ["data-testid"], Lae = { class: "http-model-content" }, Nae = /* @__PURE__ */ ir({
  __name: "HttpModel",
  props: {
    data: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => `http-model-${t.title.replaceAll(" ", "-")}`), r = Br(t.data), i = Ye(() => {
      const o = J0({
        objData: r.value,
        filteringOptions: { excludeReadonly: !1, excludeNotRequired: !1 }
      });
      return o && Object.keys(o).length ? JSON.stringify(o, null, ns) : "";
    }), a = Ye(
      () => i.value ? ["info", "description", "example"] : ["info", "description"]
    );
    return (o, c) => (ke(), Qe("div", {
      class: "http-model",
      "data-testid": n.value
    }, [
      Sr(Iu, {
        class: "http-model-header",
        description: r.value.description,
        title: e.title,
        type: r.value.type?.toString()
      }, null, 8, ["description", "title", "type"]),
      Ft("div", Lae, [
        Ft("div", null, [
          Sr(op, {
            "hidden-field-list": a.value,
            property: r.value,
            "property-name": e.title,
            "required-fields": r.value?.required
          }, null, 8, ["hidden-field-list", "property", "property-name", "required-fields"]),
          Sr(ap, {
            schema: e.data,
            title: e.title,
            onSelectedModelChanged: c[0] || (c[0] = (u) => r.value = u)
          }, null, 8, ["schema", "title"])
        ]),
        i.value ? (ke(), Mt(up, {
          key: 0,
          "schema-example-json": i.value
        }, null, 8, ["schema-example-json"])) : Bt("", !0)
      ])
    ], 8, $ae));
  }
}), Fae = /* @__PURE__ */ pn(Nae, [["__scopeId", "data-v-73845938"]]), Mae = /* @__PURE__ */ ir({
  __name: "ArticleNode",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", null, [
      n[0] || (n[0] = bn(" Article ", -1)),
      n[1] || (n[1] = Ft("br", null, null, -1)),
      bn(" " + cn(e.data), 1)
    ]));
  }
}), Bae = /* @__PURE__ */ ir({
  __name: "UnknownNode",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (ke(), Qe("div", null, [
      n[0] || (n[0] = bn(" !!!!Unknown Node!!!! ", -1)),
      n[1] || (n[1] = Ft("br", null, null, -1)),
      bn(" " + cn(e.data), 1)
    ]));
  }
}), Uae = ["data-testid", "href", "onClick"], Hae = { class: "navigation-title" }, zae = /* @__PURE__ */ ir({
  __name: "DocumentNavigation",
  props: {
    neighborComponentList: {
      type: Array,
      required: !0
    },
    basePath: {
      type: String,
      required: !0
    },
    navigationType: {
      type: String,
      required: !0
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = t, r = (i) => {
      n("item-selected", i);
    };
    return (i, a) => (ke(), Qe("div", {
      class: Un(["document-navigation", { "single-item": e.neighborComponentList.length === 1 }])
    }, [
      (ke(!0), Qe(Mn, null, ii(e.neighborComponentList, (o) => (ke(), Qe("a", {
        key: o.type,
        class: Un(["document-navigation-link", o.type]),
        "data-testid": `document-navigation-link-${o.type}`,
        href: `${e.basePath}${e.navigationType === "hash" ? "#" : ""}${o.uri}`,
        onClick: $f((c) => r(o.uri), ["prevent"])
      }, [
        o.type === "previous" ? (ke(), Mt(jt(IY), {
          key: 0,
          color: jt(u_),
          decorative: "",
          size: jt(c_)
        }, null, 8, ["color", "size"])) : (ke(), Mt(jt(qY), {
          key: 1,
          color: jt(u_),
          decorative: "",
          size: jt(c_)
        }, null, 8, ["color", "size"])),
        Ft("span", Hae, [
          bn(cn(o.name) + " ", 1),
          o.method ? (ke(), Mt(s1, {
            key: 0,
            method: o.method,
            size: "small"
          }, null, 8, ["method"])) : Bt("", !0)
        ])
      ], 10, Uae))), 128))
    ], 2));
  }
}), Vae = /* @__PURE__ */ pn(zae, [["__scopeId", "data-v-b373e2c4"]]), Gae = ["id"], Wae = { key: 0 }, Kae = {
  key: 1,
  class: "placeholder"
}, Zae = {
  key: 2,
  class: "placeholder"
}, Yae = /* @__PURE__ */ ir({
  __name: "SpecDocument",
  props: {
    document: {
      type: [Object, String],
      required: !0
    },
    /**
     * table of contents. when passed to the document we will use it to define the order of scrollable sections (nList)
     */
    tableOfContents: {
      type: [Object, String],
      default: null
    },
    /**
     * URL to fetch spec document from
     */
    specUrl: {
      type: String,
      default: ""
    },
    currentPath: {
      type: String,
      required: !0
    },
    basePath: {
      type: String,
      default: ""
    },
    /**
     * Do not show TryIt section
     */
    hideTryIt: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    },
    /**
     * Do not show  Insomnia option in TryIt
     */
    hideInsomniaTryIt: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    },
    /**
     * Allow scrolling trough operations/schemas
     */
    allowContentScrolling: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    },
    /**
     * scrolling container that holds SpecDocument, use window by default
     */
    documentScrollingContainer: {
      type: String,
      default: ""
    },
    /**
     * Allow component itself to control URL in browser URL.
     * When false it becomes the responsibility of consuming app
     */
    controlAddressBar: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    },
    /**
        Defines how links are specified in toc
          path - id becomes part of the URL path.
          hash - uses the hash portion of the URL to keep the UI in sync with the URL.
    */
    navigationType: {
      type: String,
      default: "path"
    },
    /**
     * Use default markdown styling
     */
    markdownStyles: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    },
    /**
     * Allow user to add custom server url which will be added to the list of available servers
     */
    allowCustomServerUrl: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    },
    /**
     * Hide navigation buttons at the bottom of the document.
     * Only relevant when not in content scrolling mode.
     */
    hideNavigationButtons: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    },
    /**
     * Hide the spec download button.
     */
    hideDownloadButton: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    },
    /**
     * The max depth until which nested properties should remain expanded by default.
     */
    maxExpandedDepth: {
      type: [Number, String],
      validator: CO,
      default: hc
    }
  },
  emits: ["path-not-found", "content-scrolled", "item-selected"],
  setup(e, { emit: t }) {
    const n = e, { highlighter: r, createHighlighter: i } = qi.useShiki(), { initialize: a } = qi.useServerList(), o = qJ();
    xJ(o["meta+f"], () => {
      g.value = !0;
    }, { once: !0 });
    const c = Br(null);
    Pa("spec-url", Ye(() => n.specUrl)), Pa("base-path", Ye(() => n.basePath)), Pa("hide-tryit", Ye(() => xi(n.hideTryIt))), Pa("hide-insomnia-tryit", Ye(() => xi(n.hideInsomniaTryIt))), Pa("markdown-styles", Ye(() => xi(n.markdownStyles))), Pa("max-expanded-depth", Ye(() => SO(n.maxExpandedDepth) || hc));
    const u = t, s = Br([]), l = Br(), d = Br(!1), f = Br(), p = ja("wrapper"), g = Br(!1), b = Ye(() => {
      if (typeof n.document == "string")
        try {
          return o0(n.document);
        } catch {
          return console.error("@kong/spec-renderer: error parsing provided document"), {};
        }
      return n.document;
    }), w = (xe) => {
      if (!xe) return null;
      const ve = {
        data: xe.data
      };
      switch (xe.type) {
        case Ii.Article:
          return { component: Mae, props: ve, doc: xe };
        case Ii.HttpOperation:
        case Ii.HttpWebhook:
          return { component: wae, props: ve, doc: xe };
        case Ii.HttpOperationTag:
          return { component: Sae, props: { ...xe.data }, doc: xe };
        case Ii.AsyncOperation:
          return { component: Dae, props: ve, doc: xe };
        case Ii.HttpService:
          return {
            component: GX,
            props: {
              ...ve,
              specVersion: xe.specVersion,
              allowCustomServerUrl: xi(n.allowCustomServerUrl),
              hideDownloadButton: xi(n.hideDownloadButton)
            },
            doc: xe
          };
        case Ii.Model:
          return { component: Fae, props: { ...ve, title: xe.name }, doc: xe };
        case Ii.AsyncMessage:
          return { component: cT, props: { ...ve, title: xe.name }, doc: xe };
        default:
          return { component: Bae, props: ve, doc: xe };
      }
    }, y = (xe) => {
      const ve = b.value?.data?.tags?.find((Ae) => Ae.name === xe);
      return ve ? { name: ve.name, description: ve?.description } : void 0;
    }, v = Ye(() => s0() || !n.documentScrollingContainer ? null : document.querySelector(n.documentScrollingContainer)), { y: _, isScrolling: E } = DJ(), { y: O, isScrolling: M } = xg(v.value), L = /* @__PURE__ */ $J(), Z = TJ(v.value), Q = Ye(() => v.value ? O.value : _.value), ae = Ye(() => v.value ? M.value : E.value), re = Ye(() => v.value ? Z : L), X = Ye(() => {
      let xe = [];
      if (xe.push(b.value), n.tableOfContents === null)
        xe.push(...b.value.children.filter((Ae) => (Ae.tags || []).length === 0 && Ae.type !== "model")), b.value.tags?.forEach((Ae) => {
          xe.push(...b.value.children.filter((Ue) => (Ue.tags || []).includes(Ae)));
        }), xe.push(...b.value.children.filter((Ae) => !Ae.tags || Ae.tags.length === 0 ? !1 : !!Ae.tags.find((Ue) => !b.value.tags.includes(Ue)))), xe.push(...b.value.children.filter((Ae) => (Ae.tags || []).length === 0 && Ae.type === "model"));
      else {
        let Ae = n.tableOfContents;
        if (typeof n.tableOfContents == "string")
          try {
            Ae = o0(Ae);
          } catch {
            console.error("@kong/spec-renderer: error parsing provided toc");
          }
        const Ue = (qt) => {
          if (Array.isArray(qt.items))
            for (let Ze = 0; Ze < qt.items.length; Ze++) {
              const At = qt.items[Ze];
              if (At.id !== "/") {
                if (vg(At) && "itemsType" in At) {
                  const He = y(At.title);
                  He && He?.name && xe.push({ type: Ii.HttpOperationTag, data: He, name: At.title });
                }
                if (qt.items[Ze].items)
                  Ue(qt.items[Ze]);
                else {
                  const He = r_(b.value, At.id);
                  He && xe.push({ ...He, uri: At.id });
                }
              }
            }
        };
        Ue({ items: Ae });
      }
      const ve = [];
      for (let Ae = 0; Ae < xe.length; Ae++) {
        const Ue = w(xe[Ae]);
        Ue && ve.push(Ue);
      }
      return ve;
    }), de = Ye(() => X.value.findIndex((xe) => xe.doc.uri === n.currentPath)), Ce = Ye(() => X.value[de.value]), J = Ye(() => xi(n.allowContentScrolling) && b.value.children.length < Vx), ne = Ye(() => xi(n.hideNavigationButtons) && b.value.children.length < Vx), De = Ye(() => {
      const xe = [];
      if (ne.value || J.value)
        return xe;
      for (const ve of [-1, 1]) {
        const Ae = X.value[de.value + Number(ve)];
        Ae && xe.push({
          name: Ae.doc.name,
          uri: Ae.doc.uri,
          type: ve === -1 ? "previous" : "next",
          ...Ae.doc.type === "http_operation" && Ae.doc.data.method ? { method: Ae.doc.data.method } : {}
        });
      }
      return xe;
    }), je = Br(0), Me = (xe) => {
      if (xi(n.controlAddressBar)) {
        const ve = n.navigationType === "path" ? n.basePath + xe : n.basePath + "#" + xe;
        window.history.pushState({}, "", ve), je.value = 0;
      }
      u("item-selected", xe);
    }, qe = (xe) => {
      const ve = Array(X.value.length).fill("false", 0);
      xe.sort();
      for (let Ae = 0; Ae < ve.length; Ae++)
        ve[Ae] = s.value[Ae], xe.includes(Ae) ? ve[Ae] = "true" : ve[Ae] !== "true" && Ae - xe[xe.length - 1] <= zx && xe[0] - Ae <= zx && (ve[Ae] = "forced");
      s.value = ve;
    };
    On(() => ({
      nodesList: X.value,
      yPosition: Q.value,
      isScrolling: ae.value,
      wrapperRef: p.value,
      wHeight: re.value.height.value,
      wWidth: re.value.width.value
    }), (xe, ve) => {
      if (!J.value || !d.value || !xe.nodesList || !xe.wrapperRef || ((ve?.wHeight !== xe.wHeight || ve?.wWidth != xe.wWidth) && (l.value = void 0), xe.isScrolling && l.value != null && Math.abs(xe.yPosition - l.value) < WV))
        return;
      const Ae = [], Ue = [];
      if (Array.from(xe.wrapperRef.children).forEach((At, He) => {
        const Dt = At;
        if (Dt.offsetTop - xe.yPosition > xe.wHeight || Dt.offsetTop + Dt.offsetHeight < xe.yPosition)
          return;
        const Fe = xe.yPosition - Dt.offsetTop, Xe = Dt.offsetTop + Dt.offsetHeight - (xe.yPosition + xe.wHeight), Rt = (Dt.offsetHeight - (Fe < 0 ? 0 : Fe) - (Xe < 0 ? 0 : Xe)) * 100 / Dt.offsetHeight;
        Ae.push({ idx: He, cEl: Dt, vHp: Rt | 0 }), Ue.push(He);
      }), Ae.sort((At, He) => At.vHp === He.vHp ? 0 : At.vHp > He.vHp ? -1 : 1), Ae.length === 0) {
        l.value = xe.yPosition;
        return;
      }
      const qt = Ae[0].idx;
      qe(Ue);
      const Ze = X.value[qt].doc.uri;
      if (Ze && Ze !== f.value && !xe.isScrolling) {
        if (u("content-scrolled", Ze), n.controlAddressBar) {
          const At = n.navigationType === "path" ? n.basePath + Ze : n.basePath + "#" + Ze;
          window.history[je.value++ > 0 ? "replaceState" : "pushState"]({}, "", At);
        }
        f.value = Ze;
      }
      l.value = xe.yPosition;
    }, { immediate: !0 });
    const Ve = (xe, ve, Ae) => {
      let Ue = 0;
      const qt = setInterval(() => {
        const Ze = document.querySelector(xe);
        Ze && Ze.offsetTop > 0 && (clearInterval(qt), Ae(Ze)), Ue++, Ue >= ve && (clearInterval(qt), Ae(Ze));
      }, 100);
    };
    return On(() => ({
      pathname: n.currentPath,
      document: b.value
    }), async (xe, ve) => {
      const { pathname: Ae, document: Ue } = xe, { document: qt } = ve || {}, Ze = !Ae || Ae === "/";
      if (c.value = Ze ? Ue : r_(Ue, Ae), !c.value) {
        u("path-not-found", Ae);
        return;
      }
      if (qt !== Ue && (l.value = 0, g.value = !1, a(c.value?.data?.servers || Ue.data.servers || [])), !J.value) {
        r.value || await i();
        return;
      }
      if (Ae === ve?.pathname && ve?.pathname || Ae === f.value)
        return;
      d.value = !1;
      const At = X.value.findIndex((He) => He.doc.uri === Ae);
      if (qe([At]), !s0() && (await sc(), document)) {
        p.value || await yJ(p).not.toBeNull({ timeout: 1e4 });
        const He = `[id="${At}-nodecontainer"]`, Dt = p.value?.querySelector(He);
        Dt && (At === 0 ? v.value ? v.value.scrollTo(0, 0) : window.scrollTo(0, 0) : !v.value || O.value > 0 ? setTimeout(() => Dt.scrollIntoView({ behavior: "instant" }), 50) : Ve(He, 10, (Fe) => {
          Fe.scrollIntoView({ behavior: "instant" });
        }), f.value = Ae), setTimeout(async () => {
          d.value = !0;
        }, 500);
      }
    }, { immediate: !0 }), bC(async () => {
      await i();
    }), (xe, ve) => J.value ? c.value ? (ke(), Qe("div", {
      key: 1,
      ref: "wrapper",
      class: Un(["nodes-wrapper", { "reset-margin": e.markdownStyles }])
    }, [
      (ke(!0), Qe(Mn, null, ii(X.value, (Ae, Ue) => (ke(), Qe("div", {
        id: `${Ue}-nodecontainer`,
        key: `${Ae.doc.uri}-${Ue}`,
        class: "spec-renderer-document"
      }, [
        Ae.component ? (ke(), Qe("div", Wae, [
          ["true", "forced"].includes(s.value[Ue]) ? (ke(), Mt(Sn(Ae.component), $i({
            key: 0,
            ref_for: !0
          }, Ae.props), null, 16)) : g.value ? (ke(), Qe("div", Kae, cn(jt(Fd)(Ae.doc)), 1)) : (ke(), Qe("div", Zae))
        ])) : Bt("", !0)
      ], 8, Gae))), 128))
    ], 2)) : Bt("", !0) : (ke(), Qe("div", {
      key: 0,
      class: Un(["spec-renderer-document", { "reset-margin": e.markdownStyles }])
    }, [
      Ce.value?.component ? (ke(), Mt(Sn(Ce.value.component), I0($i({ key: 0 }, Ce.value.props)), null, 16)) : Bt("", !0),
      De.value.length ? (ke(), Mt(Vae, {
        key: 1,
        "base-path": e.basePath,
        "navigation-type": e.navigationType,
        "neighbor-component-list": De.value,
        onItemSelected: Me
      }, null, 8, ["base-path", "navigation-type", "neighbor-component-list"])) : Bt("", !0)
    ], 2));
  }
}), $g = /* @__PURE__ */ pn(Yae, [["__scopeId", "data-v-b735e7a3"]]), Jae = {
  class: "slideout-container",
  "data-testid": "slideout-container"
}, Qae = { class: "slideout-header" }, Xae = {
  key: 0,
  class: "slideout-title"
}, eoe = { class: "slideout-content" }, toe = /* @__PURE__ */ ir({
  inheritAttrs: !1,
  __name: "SlideOut",
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    /**
     * Max width of SlideOut container.
     */
    maxWidth: {
      type: String,
      required: !1,
      default: "500px"
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    zD((u) => ({
      "5806ad3b": r.maxWidth
    }));
    const n = R0(), r = e, i = t, a = (u) => {
      r.visible && u.keyCode === 27 && i("close");
    }, o = (u) => {
      typeof document < "u" && (u ? document?.addEventListener("keydown", a) : document?.removeEventListener("keydown", a));
    }, c = (u) => {
      typeof document < "u" && (u ? document.scrollingElement?.classList.add("spec-renderer-no-scroll") : document.scrollingElement?.classList.remove("spec-renderer-no-scroll"));
    };
    return On(() => r.visible, async (u) => {
      u ? (o(!0), c(!0)) : (o(!1), c(!1));
    }, { immediate: !0 }), VD(() => {
      o(!1), c(!1);
    }), (u, s) => (ke(), Mt(GD, { to: "body" }, [
      Ft("div", $i(jt(n), { class: "slideout" }), [
        Sr(zd, { name: "spec-renderer-fade" }, {
          default: Xt(() => [
            zi(Ft("div", {
              class: "slideout-backdrop",
              onClick: s[0] || (s[0] = (l) => i("close"))
            }, null, 512), [
              [yf, e.visible]
            ])
          ]),
          _: 1
        }),
        Sr(zd, { name: "spec-renderer-slide-in" }, {
          default: Xt(() => [
            zi(Ft("div", Jae, [
              Ft("div", Qae, [
                e.title ? (ke(), Qe("span", Xae, cn(e.title), 1)) : Bt("", !0),
                Ft("button", {
                  "aria-label": "Close",
                  class: "slideout-close-icon",
                  "data-testid": "slideout-close-icon",
                  type: "button",
                  onClick: s[1] || (s[1] = (l) => u.$emit("close"))
                }, [
                  Sr(jt(MY), {
                    class: "close-icon",
                    decorative: ""
                  })
                ])
              ]),
              Ft("div", eoe, [
                Bn(u.$slots, "default", {}, void 0, !0)
              ])
            ], 512), [
              [yf, e.visible]
            ])
          ]),
          _: 3
        })
      ], 16)
    ]));
  }
}), roe = /* @__PURE__ */ pn(toe, [["__scopeId", "data-v-d64fd5e5"]]), noe = { class: "spec-renderer-wrapper" }, ioe = { class: "spec-renderer-content" }, aoe = {
  key: 1,
  class: "spec-renderer-small-screen-header"
}, ooe = { class: "doc" }, soe = /* @__PURE__ */ ir({
  __name: "SpecRenderer",
  props: {
    spec: {},
    basePath: { default: "" },
    currentPath: { default: "/" },
    specUrl: { default: "" },
    controlAddressBar: { type: [Boolean, String], default: !0 },
    navigationType: { default: "path" },
    hideSchemas: { type: [Boolean, String], default: !1 },
    hideInternal: { type: [Boolean, String], default: !1 },
    hideDeprecated: { type: [Boolean, String], default: !1 },
    hideTryIt: { type: [Boolean, String], default: !1 },
    hideInsomniaTryIt: { type: [Boolean, String], default: !1 },
    traceParsing: { type: [Boolean, String], default: !1 },
    withCredentials: { type: [Boolean, String], default: !1 },
    allowContentScrolling: { type: [Boolean, String], default: !0 },
    documentScrollingContainer: { default: "" },
    markdownStyles: { type: [Boolean, String], default: !0 },
    allowCustomServerUrl: { type: [Boolean, String], default: !0 },
    hideNavigationButtons: { type: [Boolean, String], default: !0 },
    hideDownloadButton: { type: [Boolean, String], default: !1 },
    showPoweredBy: { type: [Boolean, String], default: !1 },
    maxExpandedDepth: { default: () => hc }
  },
  emits: ["path-not-found"],
  setup(e, { emit: t }) {
    const { parseSpecDocument: n, parsedDocument: r, tableOfContents: i } = qi.useSchemaParser(), a = Br(e.currentPath), o = Br(e.currentPath), c = (g) => {
      a.value = g, o.value === g ? s.value += 1 : o.value = g, l.value = !1;
    }, u = t, s = Br(0), l = Br(!1), d = (g) => {
      u("path-not-found", g);
    }, f = async () => {
      l.value = !0;
    }, p = (g) => {
      a.value = g;
    };
    return On(() => ({
      specUrl: e.specUrl,
      spec: e.spec,
      hideSchemas: e.hideSchemas,
      hideInternal: e.hideInternal,
      hideDeprecated: e.hideDeprecated
    }), async (g, b) => {
      b && (g.spec !== b?.spec || g.specUrl !== b?.specUrl) && (o.value = "/", a.value = "/"), await n(g.spec, {
        hideSchemas: xi(g.hideSchemas),
        hideInternal: xi(g.hideInternal),
        hideDeprecated: xi(g.hideDeprecated),
        traceParsing: xi(e.traceParsing),
        ...g.specUrl ? { specUrl: g.specUrl } : null,
        withCredentials: xi(e.withCredentials),
        currentPath: a.value
      }), e.traceParsing && (console.log("parsedDocument:", r.value), console.log("tableOfContents:", i.value));
    }, { immediate: !0 }), (g, b) => (ke(), Qe("div", noe, [
      Ft("div", ioe, [
        jt(i) ? (ke(), Mt(roe, {
          key: 0,
          class: "slideout-toc",
          title: jt(r)?.name || "Table of Contents",
          visible: l.value,
          onClose: b[0] || (b[0] = (w) => l.value = !1)
        }, {
          default: Xt(() => [
            l.value ? (ke(), Mt(k0, {
              key: 0,
              "base-path": g.basePath,
              class: "spec-renderer-toc",
              "control-address-bar": g.controlAddressBar,
              "current-path": a.value,
              "navigation-type": g.navigationType,
              "show-powered-by": g.showPoweredBy,
              "table-of-contents": jt(i),
              onItemSelected: c
            }, null, 8, ["base-path", "control-address-bar", "current-path", "navigation-type", "show-powered-by", "table-of-contents"])) : Bt("", !0)
          ]),
          _: 1
        }, 8, ["title", "visible"])) : Bt("", !0),
        Ft("aside", null, [
          jt(i) && !l.value ? (ke(), Mt(k0, {
            key: 0,
            "base-path": g.basePath,
            class: "spec-renderer-toc",
            "control-address-bar": g.controlAddressBar,
            "current-path": a.value,
            "navigation-type": g.navigationType,
            "show-powered-by": g.showPoweredBy,
            "table-of-contents": jt(i),
            onItemSelected: c
          }, null, 8, ["base-path", "control-address-bar", "current-path", "navigation-type", "show-powered-by", "table-of-contents"])) : Bt("", !0)
        ]),
        jt(i) ? (ke(), Qe("div", aoe, [
          Ft("button", {
            class: "slideout-toc-trigger-button",
            type: "button",
            onClick: f
          }, [
            Sr(jt(YY), { class: "menu-icon" }),
            b[1] || (b[1] = bn(" Menu ", -1))
          ])
        ])) : Bt("", !0),
        Ft("div", ooe, [
          jt(r) && g.currentPath ? (ke(), Mt($g, {
            key: s.value,
            "allow-content-scrolling": g.allowContentScrolling,
            "allow-custom-server-url": g.allowCustomServerUrl,
            "base-path": g.basePath,
            "control-address-bar": g.controlAddressBar,
            "current-path": o.value,
            document: jt(r),
            "document-scrolling-container": g.documentScrollingContainer,
            "hide-download-button": g.hideDownloadButton,
            "hide-insomnia-try-it": g.hideInsomniaTryIt,
            "hide-navigation-buttons": g.hideNavigationButtons,
            "hide-try-it": g.hideTryIt,
            "markdown-styles": g.markdownStyles,
            "max-expanded-depth": g.maxExpandedDepth,
            "navigation-type": g.navigationType,
            "spec-url": g.specUrl,
            "table-of-contents": jt(i),
            onContentScrolled: p,
            onItemSelected: c,
            onPathNotFound: d
          }, null, 8, ["allow-content-scrolling", "allow-custom-server-url", "base-path", "control-address-bar", "current-path", "document", "document-scrolling-container", "hide-download-button", "hide-insomnia-try-it", "hide-navigation-buttons", "hide-try-it", "markdown-styles", "max-expanded-depth", "navigation-type", "spec-url", "table-of-contents"])) : Bt("", !0)
        ])
      ])
    ]));
  }
}), lT = /* @__PURE__ */ pn(soe, [["__scopeId", "data-v-09435208"]]), uoe = /* @__PURE__ */ ir({
  __name: "SchemaRenderer",
  props: {
    /**
     * JSON schema to render
     */
    schema: {
      type: [Object, String],
      required: !0
    },
    /**
     * Fallback title to display for schema
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * show/hide the title and description header
     */
    headerVisible: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    },
    /**
     * show/hide example section
     */
    exampleVisible: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    },
    /**
     * enable links to individual properties of a Schema Model
     */
    enablePropertyLinks: {
      type: [Boolean, String],
      validator: ea,
      default: !1
    },
    /**
     * The max depth until which nested properties should remain expanded by default.
     */
    maxExpandedDepth: {
      type: [Number, String],
      validator: CO,
      default: hc
    },
    /**
     * Use default markdown styling
     */
    markdownStyles: {
      type: [Boolean, String],
      validator: ea,
      default: !0
    }
  },
  setup(e) {
    const t = e;
    Pa("max-expanded-depth", Ye(() => SO(t.maxExpandedDepth) || hc)), Pa("markdown-styles", Ye(() => xi(t.markdownStyles)));
    const n = Ye(() => {
      if (typeof t.schema == "string")
        try {
          return o0(t.schema);
        } catch {
          return console.error("@kong/spec-renderer: error parsing provided JSON Schema"), {};
        }
      return t.schema;
    }), r = Ye(() => xi(t.headerVisible)), i = Ye(() => xi(t.exampleVisible)), a = Ye(() => ({
      schema: n.value,
      title: t.title,
      ...xi(t.enablePropertyLinks) ? { basePathId: `schema-${l.value}` } : null
    })), o = Br(n.value), { createHighlighter: c } = qi.useShiki();
    bC(async () => {
      await c();
    });
    const u = Ye(() => {
      if (!i.value)
        return null;
      const f = J0({
        objData: o.value,
        filteringOptions: { excludeReadonly: !1, excludeNotRequired: !1 }
      });
      return f && Object.keys(f).length ? JSON.stringify(f, null, ns) : "";
    }), s = Ye(
      () => u.value || !i.value ? ["info", "description", "example"] : ["info", "description"]
    ), l = Ye(() => n.value.title || t.title), d = Ye(() => n.value.type?.toString());
    return (f, p) => (ke(), Qe("div", {
      class: Un(["schema-renderer", { "reset-margin": e.markdownStyles }])
    }, [
      r.value && l.value ? (ke(), Mt(Iu, {
        key: 0,
        class: "schema-renderer-header",
        description: n.value.description,
        title: l.value,
        type: d.value
      }, null, 8, ["description", "title", "type"])) : Bt("", !0),
      Ft("div", {
        class: Un(["schema-renderer-content", { "model-example-visible": i.value }])
      }, [
        Ft("div", null, [
          Sr(op, {
            "hidden-field-list": s.value,
            property: o.value,
            "required-fields": o.value?.required
          }, null, 8, ["hidden-field-list", "property", "required-fields"]),
          Sr(ap, $i(a.value, {
            onSelectedModelChanged: p[0] || (p[0] = (g) => o.value = g)
          }), null, 16)
        ]),
        u.value ? (ke(), Mt(up, {
          key: 0,
          "schema-example-json": u.value
        }, null, 8, ["schema-example-json"])) : Bt("", !0)
      ], 2)
    ], 2));
  }
}), fT = /* @__PURE__ */ pn(uoe, [["__scopeId", "data-v-9ee7d477"]]), _oe = {
  install: (e) => {
    e.component("KongSpecRenderer", lT), e.component("KongSpecRendererToc", k0), e.component("KongSpecRendererDocument", $g), e.component("KongSchemaRenderer", fT);
  }
};
function coe() {
  if (!customElements.get("kong-spec-renderer")) {
    const e = Gp(lT);
    customElements.define("kong-spec-renderer", e);
  }
  if (!customElements.get("kong-spec-renderer-toc")) {
    const e = Gp(k0);
    customElements.define("kong-spec-renderer-toc", e);
  }
  if (!customElements.get("kong-spec-renderer-document")) {
    const e = Gp($g);
    customElements.define("kong-spec-renderer-document", e);
  }
  if (!customElements.get("kong-schema-renderer")) {
    const e = Gp(fT);
    customElements.define("kong-schema-renderer", e);
  }
}
typeof window < "u" && (window.registerKongSpecRenderer = coe);
export {
  lT as S,
  $g as a,
  k0 as b,
  fT as c,
  moe as d,
  yoe as e,
  boe as f,
  h2 as g,
  xoe as h,
  _oe as i,
  goe as j,
  r_ as k,
  gn as p,
  coe as r,
  Xd as s,
  voe as t
};
//# sourceMappingURL=index-nT3qzvAW.js.map
